
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.6";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.6" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.6";

});



parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("1kxNS", function(module, exports) {
module.exports = import("drKOm").then(()=>parcelRequire('eRhfF'));

});

parcelRegister("17RAS", function(module, exports) {
module.exports = import("lEKa2").then(()=>parcelRequire('cJzQy'));

});

parcelRegister("9cAOC", function(module, exports) {
module.exports = import("1KS8m").then(()=>parcelRequire('jJyBW'));

});

parcelRegister("ig1zj", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("fHOh0")
]).then(()=>parcelRequire('l8ejG'));

});

parcelRegister("izwJa", function(module, exports) {
module.exports = Promise.all([
    import("v1FIS"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("fHOh0"),
    import("aundz")
]).then(()=>parcelRequire('4jZ4M'));

});

parcelRegister("5ICjr", function(module, exports) {
module.exports = import("kYtEm").then(()=>parcelRequire('WxZnK'));

});

parcelRegister("cnA9B", function(module, exports) {
module.exports = import("gZWQu").then(()=>parcelRequire('8IvJk'));

});

parcelRegister("hWRf7", function(module, exports) {
module.exports = Promise.all([
    import("5hHZF"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("cULS6")
]).then(()=>parcelRequire('ixgg7'));

});

parcelRegister("hNE8N", function(module, exports) {
module.exports = import("ha6Zy").then(()=>parcelRequire('iuRXE'));

});

parcelRegister("iu44M", function(module, exports) {
module.exports = import("7U6TM").then(()=>parcelRequire('c8jPH'));

});

parcelRegister("9bosY", function(module, exports) {
module.exports = import("6vHzh").then(()=>parcelRequire('9M2zB'));

});

parcelRegister("lS6VR", function(module, exports) {
module.exports = import("3ujGm").then(()=>parcelRequire('4ICj0'));

});

parcelRegister("i3E6M", function(module, exports) {
module.exports = Promise.all([
    import("hhpHF"),
    import("8RLI5"),
    import("fTIsd"),
    import("5hHZF"),
    import("1OCeY"),
    import("grigy"),
    import("azMpU")
]).then(()=>parcelRequire('jkG0R'));

});

parcelRegister("btvxz", function(module, exports) {
module.exports = import("9YKCA").then(()=>parcelRequire('gAGr9'));

});

parcelRegister("cw4kp", function(module, exports) {
module.exports = import("cOmPi").then(()=>parcelRequire('hkZcq'));

});

parcelRegister("azW6p", function(module, exports) {
module.exports = import("iRair").then(()=>parcelRequire('lsGTL'));

});

parcelRegister("4mam3", function(module, exports) {
module.exports = import("47Hqj").then(()=>parcelRequire('hCY3V'));

});

parcelRegister("7eQZD", function(module, exports) {
module.exports = import("69eU3").then(()=>parcelRequire('1dLN4'));

});

parcelRegister("hCWPF", function(module, exports) {
module.exports = import("3EPD7").then(()=>parcelRequire('gxt0W'));

});

parcelRegister("7TqMi", function(module, exports) {
module.exports = import("2d8Oh").then(()=>parcelRequire('ecY9p'));

});

parcelRegister("hE34J", function(module, exports) {
module.exports = import("7kXPv").then(()=>parcelRequire('60X9L'));

});

parcelRegister("beNf0", function(module, exports) {
module.exports = Promise.all([
    import("fXdFq"),
    import("dON9q"),
    import("5hHZF"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("4rAhe")
]).then(()=>parcelRequire('8Pntn'));

});

parcelRegister("kHo6B", function(module, exports) {
module.exports = Promise.all([
    import("dKwSE"),
    import("6NHtf")
]).then(()=>parcelRequire('6RHff'));

});

parcelRegister("aKj1q", function(module, exports) {
module.exports = import("1X7pE").then(()=>parcelRequire('cCgm8'));

});

parcelRegister("lzpRT", function(module, exports) {
module.exports = import("2b8RM").then(()=>parcelRequire('9CHRp'));

});

parcelRegister("jzDwI", function(module, exports) {
module.exports = import("5x512").then(()=>parcelRequire('7DNbY'));

});

parcelRegister("30ZNd", function(module, exports) {
module.exports = Promise.all([
    import("1gwX4"),
    import("kMtpP")
]).then(()=>parcelRequire('imsBH'));

});

parcelRegister("2tMCN", function(module, exports) {
module.exports = import("9qCCo").then(()=>parcelRequire('65wfT'));

});

parcelRegister("gtVuc", function(module, exports) {
module.exports = import("81JOb").then(()=>parcelRequire('a1oYv'));

});

parcelRegister("eUGnc", function(module, exports) {
module.exports = import("dluKe").then(()=>parcelRequire('k8LKW'));

});

parcelRegister("dyVBz", function(module, exports) {
module.exports = Promise.all([
    import("dBMJ8"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("8Df9W")
]).then(()=>parcelRequire('96GeJ'));

});

parcelRegister("4l5Qy", function(module, exports) {
module.exports = import("emRFe").then(()=>parcelRequire('1hGqG'));

});

parcelRegister("j8xYK", function(module, exports) {
module.exports = import("cvFeB").then(()=>parcelRequire('5kLQ4'));

});

parcelRegister("h41Lj", function(module, exports) {
module.exports = Promise.all([
    import("grigy"),
    import("8iugp")
]).then(()=>parcelRequire('5ZYjH'));

});

parcelRegister("bEnnP", function(module, exports) {
module.exports = import("dinB3").then(()=>parcelRequire('9Wgs5'));

});

parcelRegister("9S5d7", function(module, exports) {
module.exports = import("bItWa").then(()=>parcelRequire('g4twr'));

});

parcelRegister("2cOfd", function(module, exports) {
module.exports = Promise.all([
    import("2vHmd"),
    import("czClN"),
    import("1X7pE"),
    import("fXdFq"),
    import("2espm")
]).then(()=>parcelRequire('4anrv'));

});

parcelRegister("dCiDK", function(module, exports) {
module.exports = Promise.all([
    import("lzfgR"),
    import("1X7pE"),
    import("fXdFq"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("8cxy2")
]).then(()=>parcelRequire('gKJeM'));

});

parcelRegister("kF8sz", function(module, exports) {
module.exports = import("kNulB").then(()=>parcelRequire('aLS8T'));

});

parcelRegister("7IOMu", function(module, exports) {
module.exports = import("1OCeY").then(()=>parcelRequire('freJM'));

});

parcelRegister("lIwSa", function(module, exports) {
module.exports = import("5Kcsv").then(()=>parcelRequire('lmJD0'));

});

parcelRegister("kjjFK", function(module, exports) {
module.exports = import("6xLYo").then(()=>parcelRequire('jvQIZ'));

});

parcelRegister("73vIF", function(module, exports) {
module.exports = import("gqIOU").then(()=>parcelRequire('1s1qI'));

});

parcelRegister("fscaG", function(module, exports) {
module.exports = import("6Y5Ol").then(()=>parcelRequire('4yQO9'));

});

parcelRegister("gf49Y", function(module, exports) {
module.exports = import("6TeTN").then(()=>parcelRequire('6N11R'));

});

parcelRegister("ls28k", function(module, exports) {
module.exports = import("9qxit").then(()=>parcelRequire('86ekN'));

});

parcelRegister("9zt8E", function(module, exports) {
module.exports = import("aOg5u").then(()=>parcelRequire('d7k7T'));

});

parcelRegister("d9ttx", function(module, exports) {
module.exports = import("4ATA2").then(()=>parcelRequire('3mX02'));

});

parcelRegister("9FVmB", function(module, exports) {
module.exports = import("3dKJu").then(()=>parcelRequire('hyxDq'));

});

parcelRegister("caf89", function(module, exports) {
module.exports = import("5VZf8").then(()=>parcelRequire('3VXL7'));

});

parcelRegister("aXQ0q", function(module, exports) {
module.exports = import("4iR8O").then(()=>parcelRequire('gAANa'));

});

parcelRegister("6Ui8X", function(module, exports) {
module.exports = Promise.all([
    import("dON9q"),
    import("fTIsd"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("lbM03")
]).then(()=>parcelRequire('8v1b5'));

});

parcelRegister("ekYxJ", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("jlktw")
]).then(()=>parcelRequire('3flzr'));

});

parcelRegister("ePH0I", function(module, exports) {
module.exports = Promise.all([
    import("2vHmd"),
    import("1X7pE"),
    import("kChIP")
]).then(()=>parcelRequire('76S88'));

});

parcelRegister("g46lE", function(module, exports) {
module.exports = import("jEzNL").then(()=>parcelRequire('3QvJN'));

});

parcelRegister("kozFG", function(module, exports) {
module.exports = Promise.all([
    import("NeEg4"),
    import("7bB1J"),
    import("8xkod"),
    import("jwFxG"),
    import("dweJY"),
    import("lzfgR"),
    import("6OcAH"),
    import("2vHmd"),
    import("czClN"),
    import("2espm"),
    import("1X7pE"),
    import("fXdFq"),
    import("hhpHF"),
    import("fTIsd"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("4a3VC")
]).then(()=>parcelRequire('6t2hZ'));

});

parcelRegister("e5AY1", function(module, exports) {
module.exports = Promise.all([
    import("9nx65"),
    import("auEaS")
]).then(()=>parcelRequire('akUSB'));

});

parcelRegister("iJ2Y2", function(module, exports) {
module.exports = import("8AprB").then(()=>parcelRequire('7b8EV'));

});

parcelRegister("3QNQm", function(module, exports) {
module.exports = import("hhbKj").then(()=>parcelRequire('e1SPC'));

});

parcelRegister("jy5Gc", function(module, exports) {
module.exports = import("kB2me").then(()=>parcelRequire('6rgbU'));

});

parcelRegister("7y8d1", function(module, exports) {
module.exports = Promise.all([
    import("8fhR9"),
    import("aDaKt")
]).then(()=>parcelRequire('5C4lx'));

});

parcelRegister("fZxB7", function(module, exports) {
module.exports = import("8fhR9").then(()=>parcelRequire('7s8sT'));

});

parcelRegister("8wJiH", function(module, exports) {
module.exports = Promise.all([
    import("9nx65"),
    import("kz5zI")
]).then(()=>parcelRequire('gaL9r'));

});

parcelRegister("d5GRw", function(module, exports) {
module.exports = Promise.all([
    import("lv3WB"),
    import("ao6XK"),
    import("liw50")
]).then(()=>parcelRequire('89Ant'));

});

parcelRegister("cPOzu", function(module, exports) {
module.exports = import("lv3WB").then(()=>parcelRequire('kJ4Nv'));

});

parcelRegister("kKoub", function(module, exports) {
module.exports = import("ao6XK").then(()=>parcelRequire('8Cg8K'));

});

parcelRegister("99ODJ", function(module, exports) {
module.exports = import("81MA3").then(()=>parcelRequire('4pmdG'));

});

parcelRegister("hQ8Ix", function(module, exports) {
module.exports = import("ir3ZX").then(()=>parcelRequire('6eVkc'));

});

parcelRegister("bxkxY", function(module, exports) {
module.exports = Promise.all([
    import("4ATA2"),
    import("6H0mW")
]).then(()=>parcelRequire('jF7FR'));

});

parcelRegister("dFNCn", function(module, exports) {
module.exports = Promise.all([
    import("lzfgR"),
    import("5xq8q")
]).then(()=>parcelRequire('7M2fN'));

});

parcelRegister("6wb2d", function(module, exports) {
module.exports = import("2STLs").then(()=>parcelRequire('e6dzi'));

});

parcelRegister("e67bp", function(module, exports) {
module.exports = Promise.all([
    import("fTIsd"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("8Rz6p")
]).then(()=>parcelRequire('c3dog'));

});

parcelRegister("bOfya", function(module, exports) {
module.exports = Promise.all([
    import("fTIsd"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("1MjEm")
]).then(()=>parcelRequire('aLNn4'));

});

parcelRegister("lxjm8", function(module, exports) {
module.exports = Promise.all([
    import("1X7pE"),
    import("2vHmd")
]).then(()=>parcelRequire('4QVJO'));

});

parcelRegister("kI08N", function(module, exports) {
module.exports = import("hehBI").then(()=>parcelRequire('a6zkF'));

});

parcelRegister("1Zlit", function(module, exports) {
module.exports = import("2QkAK").then(()=>parcelRequire('cGplh'));

});

parcelRegister("6f0iC", function(module, exports) {
module.exports = import("4C9df").then(()=>parcelRequire('cR9KR'));

});

parcelRegister("fkgiI", function(module, exports) {
module.exports = Promise.all([
    import("8xkod"),
    import("hhpHF"),
    import("fTIsd"),
    import("grigy"),
    import("jwFxG")
]).then(()=>parcelRequire('jFtj2'));

});

parcelRegister("h6zvN", function(module, exports) {
module.exports = import("58l3o").then(()=>parcelRequire('8YEdP'));

});

parcelRegister("5dqT9", function(module, exports) {
module.exports = Promise.all([
    import("fXdFq"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("37RYM")
]).then(()=>parcelRequire('2vgAH'));

});

parcelRegister("7DI29", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("dweJY")
]).then(()=>parcelRequire('agSfY'));

});

parcelRegister("fl9hx", function(module, exports) {
module.exports = Promise.all([
    import("NeEg4"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("gNrY9")
]).then(()=>parcelRequire('1LzgR'));

});

parcelRegister("hPFjJ", function(module, exports) {
module.exports = import("lJTjC").then(()=>parcelRequire('bKJEi'));

});

parcelRegister("fV5mD", function(module, exports) {
module.exports = import("3kftT").then(()=>parcelRequire('4vkqZ'));

});

parcelRegister("gJihM", function(module, exports) {
module.exports = import("5MNei").then(()=>parcelRequire('2lG1M'));

});

parcelRegister("h3NBU", function(module, exports) {
module.exports = import("l1vlz").then(()=>parcelRequire('cQEfa'));

});

parcelRegister("ggfVM", function(module, exports) {
module.exports = import("cBuaj").then(()=>parcelRequire('ax3AV'));

});

parcelRegister("2kpqY", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm")
]).then(()=>parcelRequire('hpPR3'));

});

parcelRegister("gC6J4", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("dON9q")
]).then(()=>parcelRequire('fpisx'));

});

parcelRegister("1Vo2U", function(module, exports) {
module.exports = Promise.all([
    import("8xkod"),
    import("jwFxG"),
    import("lzfgR"),
    import("hhpHF"),
    import("fTIsd"),
    import("5hHZF"),
    import("dBMJ8"),
    import("fEQCi"),
    import("grigy"),
    import("1P8t5")
]).then(()=>parcelRequire('4P0id'));

});

parcelRegister("6sM9I", function(module, exports) {
module.exports = Promise.all([
    import("8xkod"),
    import("jwFxG"),
    import("5Kcsv"),
    import("hhpHF"),
    import("fTIsd"),
    import("dBMJ8"),
    import("fEQCi"),
    import("grigy"),
    import("dEJk1")
]).then(()=>parcelRequire('ejgLs'));

});

parcelRegister("c53kG", function(module, exports) {
module.exports = Promise.all([
    import("3kftT"),
    import("adje5")
]).then(()=>parcelRequire('5M42h'));

});

parcelRegister("cf1v6", function(module, exports) {
module.exports = import("ffVxH").then(()=>parcelRequire('1I8OZ'));

});

parcelRegister("yIzc6", function(module, exports) {
module.exports = import("aLU1Z").then(()=>parcelRequire('6tDMn'));

});

parcelRegister("hJQHe", function(module, exports) {
module.exports = import("12PBy").then(()=>parcelRequire('ilbOK'));

});

parcelRegister("gyF7G", function(module, exports) {
module.exports = import("dBMJ8").then(()=>parcelRequire('4tM0R'));

});

parcelRegister("7wwms", function(module, exports) {
module.exports = import("grigy").then(()=>parcelRequire('jy6lz'));

});

parcelRegister("jXlSw", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("e7vKH")
]).then(()=>parcelRequire('dgjUD'));

});

parcelRegister("99JXb", function(module, exports) {
module.exports = Promise.all([
    import("grigy"),
    import("g5akM")
]).then(()=>parcelRequire('6qgbN'));

});

parcelRegister("cx3iL", function(module, exports) {
module.exports = import("5hHZF").then(()=>parcelRequire('1V0q4'));

});

parcelRegister("iqiTU", function(module, exports) {
module.exports = import("ktq5f").then(()=>parcelRequire('e872T'));

});

parcelRegister("8bJe4", function(module, exports) {
module.exports = import("6Rldr").then(()=>parcelRequire('4JiZe'));

});

parcelRegister("ausat", function(module, exports) {
module.exports = import("97OKd").then(()=>parcelRequire('adged'));

});

parcelRegister("5fmdv", function(module, exports) {
module.exports = import("1krop").then(()=>parcelRequire('iImk4'));

});

parcelRegister("7WnHE", function(module, exports) {
module.exports = import("b3NUb").then(()=>parcelRequire('7oLai'));

});

parcelRegister("frtMl", function(module, exports) {
module.exports = import("8xkod").then(()=>parcelRequire('2YI8O'));

});

parcelRegister("knvWN", function(module, exports) {
module.exports = Promise.all([
    import("fKuka"),
    import("2vHmd"),
    import("czClN"),
    import("2espm"),
    import("1gwX4"),
    import("1X7pE"),
    import("fXdFq"),
    import("grigy"),
    import("gvy97")
]).then(()=>parcelRequire('gib5V'));

});

parcelRegister("fwr6Z", function(module, exports) {
module.exports = Promise.all([
    import("jxWAK"),
    import("NeEg4"),
    import("7bB1J"),
    import("8xkod"),
    import("jwFxG"),
    import("dweJY"),
    import("lzfgR"),
    import("6OcAH"),
    import("2vHmd"),
    import("czClN"),
    import("2espm"),
    import("1gwX4"),
    import("1X7pE"),
    import("fXdFq"),
    import("hhpHF"),
    import("fTIsd"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("9YmWN")
]).then(()=>parcelRequire('ih6vZ'));

});

parcelRegister("9RpKq", function(module, exports) {
module.exports = import("jnMRP").then(()=>parcelRequire('5h7Hb'));

});

parcelRegister("aMstF", function(module, exports) {
module.exports = import("9ZfBt").then(()=>parcelRequire('jtFBV'));

});

parcelRegister("7H6al", function(module, exports) {
module.exports = import("6356H").then(()=>parcelRequire('5qzyl'));

});

parcelRegister("9DmQd", function(module, exports) {
module.exports = Promise.all([
    import("1r5GA"),
    import("fKuka"),
    import("acfyj")
]).then(()=>parcelRequire('cfXvg'));

});

parcelRegister("e19Ts", function(module, exports) {
module.exports = import("MZgrB").then(()=>parcelRequire('jptZ6'));

});

parcelRegister("8Oblf", function(module, exports) {
module.exports = import("1Bzin").then(()=>parcelRequire('k6HFw'));

});

parcelRegister("1YFd5", function(module, exports) {
module.exports = Promise.all([
    import("5hHZF"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("d22Xn")
]).then(()=>parcelRequire('iKQMa'));

});

parcelRegister("ha7Re", function(module, exports) {
module.exports = import("7Gebr").then(()=>parcelRequire('gMlZ2'));

});

parcelRegister("78xhL", function(module, exports) {
module.exports = import("gGWei").then(()=>parcelRequire('8t94R'));

});

parcelRegister("16bns", function(module, exports) {
module.exports = import("j3dTP").then(()=>parcelRequire('2c76y'));

});

parcelRegister("6cdSN", function(module, exports) {
module.exports = Promise.all([
    import("1X7pE"),
    import("7bB1J")
]).then(()=>parcelRequire('50gWi'));

});

parcelRegister("kuOb2", function(module, exports) {
module.exports = import("2OLyj").then(()=>parcelRequire('lwrLa'));

});

parcelRegister("lLpGm", function(module, exports) {
module.exports = import("9Cw0c").then(()=>parcelRequire('fOyGR'));

});

parcelRegister("cPE41", function(module, exports) {
module.exports = import("9nx65").then(()=>parcelRequire('7Z2Py'));

});

parcelRegister("aSG3t", function(module, exports) {
module.exports = Promise.all([
    import("1Bzin"),
    import("fTIsd"),
    import("v1FIS"),
    import("1OCeY"),
    import("32pnj")
]).then(()=>parcelRequire('emzWn'));

});

parcelRegister("gRwBK", function(module, exports) {
module.exports = import("6qWg9").then(()=>parcelRequire('iGu0d'));

});

parcelRegister("fMV6c", function(module, exports) {
module.exports = Promise.all([
    import("9nx65"),
    import("NeEg4"),
    import("dON9q"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("dIcqQ")
]).then(()=>parcelRequire('aJDI6'));

});

parcelRegister("6wL6F", function(module, exports) {
module.exports = import("5HHDu").then(()=>parcelRequire('3Oy3E'));

});

parcelRegister("ioHKy", function(module, exports) {
module.exports = import("kf71B").then(()=>parcelRequire('fP8W3'));

});

parcelRegister("grQxT", function(module, exports) {
module.exports = import("g7py3").then(()=>parcelRequire('hWTCj'));

});

parcelRegister("9lk1O", function(module, exports) {
module.exports = import("ii8eF").then(()=>parcelRequire('izYMe'));

});

parcelRegister("9oAYk", function(module, exports) {
module.exports = import("2lNOi").then(()=>parcelRequire('ibpqz'));

});

parcelRegister("860P7", function(module, exports) {
module.exports = import("llRlc").then(()=>parcelRequire('aNNaP'));

});

parcelRegister("ewUDn", function(module, exports) {
module.exports = import("3VPON").then(()=>parcelRequire('5U5kQ'));

});

parcelRegister("9mZIr", function(module, exports) {
module.exports = Promise.all([
    import("8QVmy"),
    import("8AeSe")
]).then(()=>parcelRequire('7qCqC'));

});

parcelRegister("lxsW4", function(module, exports) {
module.exports = import("8QVmy").then(()=>parcelRequire('d9IjG'));

});

parcelRegister("cxK1U", function(module, exports) {
module.exports = Promise.all([
    import("7bB1J"),
    import("1X7pE"),
    import("4nMBK")
]).then(()=>parcelRequire('b08db'));

});

parcelRegister("541Oj", function(module, exports) {
module.exports = Promise.all([
    import("9nx65"),
    import("2vHmd"),
    import("1X7pE"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("fcP47")
]).then(()=>parcelRequire('csnz5'));

});

parcelRegister("71NUC", function(module, exports) {
module.exports = import("bnrY2").then(()=>parcelRequire('7BWIS'));

});

parcelRegister("iR2Df", function(module, exports) {
module.exports = import("5xK8R").then(()=>parcelRequire('9wsVL'));

});

parcelRegister("4LJlw", function(module, exports) {
module.exports = import("zNfAN").then(()=>parcelRequire('imHOT'));

});

parcelRegister("hdjqq", function(module, exports) {
module.exports = import("idHSe").then(()=>parcelRequire('hpM8m'));

});

parcelRegister("5QNu4", function(module, exports) {
module.exports = import("9q3Px").then(()=>parcelRequire('3las8'));

});

parcelRegister("cVrM5", function(module, exports) {
module.exports = import("2QRLa").then(()=>parcelRequire('f2ddM'));

});

parcelRegister("W9f2E", function(module, exports) {
module.exports = import("6bsvQ").then(()=>parcelRequire('1iY5q'));

});

parcelRegister("hoyiK", function(module, exports) {
module.exports = import("crbBl").then(()=>parcelRequire('b60MU'));

});

parcelRegister("jMFMh", function(module, exports) {
module.exports = Promise.all([
    import("fXdFq"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("jxWAK")
]).then(()=>parcelRequire('9BKjR'));

});

parcelRegister("dEuPA", function(module, exports) {
module.exports = Promise.all([
    import("fXdFq"),
    import("5hHZF"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("jhVZE")
]).then(()=>parcelRequire('j6KuL'));

});

parcelRegister("57dKa", function(module, exports) {
module.exports = import("dGIUq").then(()=>parcelRequire('4F6s3'));

});

parcelRegister("buzt7", function(module, exports) {
module.exports = import("9vJPP").then(()=>parcelRequire('em6uI'));

});

parcelRegister("9pnvI", function(module, exports) {
module.exports = import("hLYgv").then(()=>parcelRequire('kw1Mw'));

});

parcelRegister("6EF8x", function(module, exports) {
module.exports = import("aJXcZ").then(()=>parcelRequire('drquL'));

});

parcelRegister("i0cSS", function(module, exports) {
module.exports = import("8RLI5").then(()=>parcelRequire('equE1'));

});

parcelRegister("9CXjy", function(module, exports) {
module.exports = import("45MLD").then(()=>parcelRequire('cFoIJ'));

});

parcelRegister("1pL9D", function(module, exports) {
module.exports = import("2mjVT").then(()=>parcelRequire('hnMe9'));

});

parcelRegister("kDAsT", function(module, exports) {
module.exports = import("2mcbx").then(()=>parcelRequire('1HxqU'));

});

parcelRegister("5HDED", function(module, exports) {
module.exports = import("5ISMZ").then(()=>parcelRequire('3U6rp'));

});

parcelRegister("arD2g", function(module, exports) {
module.exports = import("daVYY").then(()=>parcelRequire('9zuYK'));

});

parcelRegister("iHpqd", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("jUrdz")
]).then(()=>parcelRequire('f0J2n'));

});

parcelRegister("32hw9", function(module, exports) {
module.exports = import("9rgnR").then(()=>parcelRequire('85fOW'));

});

parcelRegister("8QiAU", function(module, exports) {
module.exports = import("797xI").then(()=>parcelRequire('4tV9c'));

});

parcelRegister("4cUhM", function(module, exports) {
module.exports = import("1gwX4").then(()=>parcelRequire('abL8p'));

});

parcelRegister("4IwaY", function(module, exports) {
module.exports = Promise.all([
    import("grigy"),
    import("3cv6n")
]).then(()=>parcelRequire('ebRuV'));

});

parcelRegister("1s7pq", function(module, exports) {
module.exports = import("kGstb").then(()=>parcelRequire('4EMv8'));

});

parcelRegister("jszie", function(module, exports) {
module.exports = import("7AQph").then(()=>parcelRequire('3y4MK'));

});

parcelRegister("cD4mp", function(module, exports) {
module.exports = import("fKuka").then(()=>parcelRequire('59J0X'));

});

parcelRegister("7I3sy", function(module, exports) {
module.exports = import("cH8yR").then(()=>parcelRequire('5brm7'));

});

parcelRegister("50iyw", function(module, exports) {
module.exports = import("4RA5B").then(()=>parcelRequire('dlo9K'));

});

parcelRegister("beq76", function(module, exports) {
module.exports = Promise.all([
    import("kNulB"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("g0I3e")
]).then(()=>parcelRequire('hLmaC'));

});

parcelRegister("gGFZa", function(module, exports) {
module.exports = import("c2S62").then(()=>parcelRequire('8yeKB'));

});

parcelRegister("gPLW0", function(module, exports) {
module.exports = import("czClN").then(()=>parcelRequire('fqAXQ'));

});

parcelRegister("cwXmW", function(module, exports) {
module.exports = import("8NPg9").then(()=>parcelRequire('6f1N1'));

});

parcelRegister("9hPYF", function(module, exports) {
module.exports = import("c0riU").then(()=>parcelRequire('lNjEc'));

});

parcelRegister("2OabP", function(module, exports) {
module.exports = import("isPiO").then(()=>parcelRequire('bE0OI'));

});

parcelRegister("39n2K", function(module, exports) {
module.exports = import("jFwkb").then(()=>parcelRequire('2lsi1'));

});

parcelRegister("k4NYq", function(module, exports) {
module.exports = Promise.all([
    import("NeEg4"),
    import("7bB1J"),
    import("8xkod"),
    import("jwFxG"),
    import("dweJY"),
    import("lzfgR"),
    import("6OcAH"),
    import("2vHmd"),
    import("czClN"),
    import("2espm"),
    import("dluKe"),
    import("1gwX4"),
    import("1X7pE"),
    import("fXdFq"),
    import("dON9q"),
    import("hhpHF"),
    import("fTIsd"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("c4i62")
]).then(()=>parcelRequire('eag0R'));

});

parcelRegister("hDqWD", function(module, exports) {
module.exports = Promise.all([
    import("NeEg4"),
    import("7bB1J"),
    import("8xkod"),
    import("jwFxG"),
    import("dweJY"),
    import("lzfgR"),
    import("2vHmd"),
    import("czClN"),
    import("2espm"),
    import("1X7pE"),
    import("fXdFq"),
    import("hhpHF"),
    import("fTIsd"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("6OcAH")
]).then(()=>parcelRequire('28Ate'));

});

parcelRegister("dvdJW", function(module, exports) {
module.exports = import("cY93X").then(()=>parcelRequire('dfHdZ'));

});

parcelRegister("6K078", function(module, exports) {
module.exports = Promise.all([
    import("fXdFq"),
    import("8bcB6")
]).then(()=>parcelRequire('jEcSg'));

});

parcelRegister("5g5IS", function(module, exports) {
module.exports = import("2nY7u").then(()=>parcelRequire('HqHtR'));

});

parcelRegister("2p3AB", function(module, exports) {
module.exports = import("9rq0O").then(()=>parcelRequire('dzltQ'));

});

parcelRegister("d6X7F", function(module, exports) {
module.exports = import("ilGPR").then(()=>parcelRequire('kftcF'));

});

parcelRegister("i4LQ8", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("v1FIS")
]).then(()=>parcelRequire('44eWM'));

});

parcelRegister("aPuRP", function(module, exports) {
module.exports = import("dKwSE").then(()=>parcelRequire('9gxHJ'));

});

parcelRegister("21taf", function(module, exports) {
module.exports = Promise.all([
    import("cBuaj"),
    import("E133w")
]).then(()=>parcelRequire('6Gb4A'));

});

parcelRegister("bk3Tm", function(module, exports) {
module.exports = import("lzfgR").then(()=>parcelRequire('2Ah2f'));

});

parcelRegister("6IgB5", function(module, exports) {
module.exports = Promise.all([
    import("lzfgR"),
    import("80PIo")
]).then(()=>parcelRequire('5BOMW'));

});

parcelRegister("ei3ke", function(module, exports) {
module.exports = import("jt9sD").then(()=>parcelRequire('bofAc'));

});

parcelRegister("azSDu", function(module, exports) {
module.exports = import("5iouX").then(()=>parcelRequire('dLfA0'));

});

parcelRegister("fnQ8C", function(module, exports) {
module.exports = Promise.all([
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("ihyHw")
]).then(()=>parcelRequire('iUTKc'));

});

parcelRegister("9N6lA", function(module, exports) {
module.exports = Promise.all([
    import("1cpVR"),
    import("kyPxH")
]).then(()=>parcelRequire('8cwBi'));

});

parcelRegister("di01K", function(module, exports) {
module.exports = import("5yJif").then(()=>parcelRequire('7F99B'));

});

parcelRegister("2cNsB", function(module, exports) {
module.exports = import("fXdFq").then(()=>parcelRequire('33SN4'));

});

parcelRegister("2CNnu", function(module, exports) {
module.exports = import("3VzHQ").then(()=>parcelRequire('Dj2jM'));

});

parcelRegister("2gtB2", function(module, exports) {
module.exports = Promise.all([
    import("fXdFq"),
    import("lCFQN")
]).then(()=>parcelRequire('4tV9b'));

});

parcelRegister("dgovY", function(module, exports) {
module.exports = import("89DIG").then(()=>parcelRequire('d4pG7'));

});

parcelRegister("93oAw", function(module, exports) {
module.exports = Promise.all([
    import("grigy"),
    import("RPZj8")
]).then(()=>parcelRequire('ggeCp'));

});

parcelRegister("iv3g3", function(module, exports) {
module.exports = Promise.all([
    import("8RLI5"),
    import("fTIsd"),
    import("1OCeY"),
    import("grigy"),
    import("f0Sf2")
]).then(()=>parcelRequire('9o8L9'));

});

parcelRegister("bkG1D", function(module, exports) {
module.exports = import("5qQCQ").then(()=>parcelRequire('5m57X'));

});

parcelRegister("c2799", function(module, exports) {
module.exports = import("5mSfh").then(()=>parcelRequire('idljD'));

});

parcelRegister("5b8pP", function(module, exports) {
module.exports = import("gZqWT").then(()=>parcelRequire('7wtCU'));

});

parcelRegister("enqpG", function(module, exports) {
module.exports = import("82klF").then(()=>parcelRequire('fAYRi'));

});

parcelRegister("hpGL1", function(module, exports) {
module.exports = import("194NA").then(()=>parcelRequire('gd1yy'));

});

parcelRegister("16g7s", function(module, exports) {
module.exports = import("b8JBa").then(()=>parcelRequire('lOPpQ'));

});

parcelRegister("d76ck", function(module, exports) {
module.exports = Promise.all([
    import("4C9df"),
    import("1OCeY"),
    import("grigy"),
    import("8FgsM")
]).then(()=>parcelRequire('b9QfQ'));

});

parcelRegister("lqHgs", function(module, exports) {
module.exports = import("dEv2O").then(()=>parcelRequire('65ci6'));

});

parcelRegister("5vrnu", function(module, exports) {
module.exports = Promise.all([
    import("fKuka"),
    import("1r5GA")
]).then(()=>parcelRequire('1qoqD'));

});

parcelRegister("8YvjL", function(module, exports) {
module.exports = import("3jnlp").then(()=>parcelRequire('cEYqS'));

});

parcelRegister("eeNQB", function(module, exports) {
module.exports = Promise.all([
    import("2vHmd"),
    import("1X7pE"),
    import("fXdFq"),
    import("fTIsd"),
    import("dBMJ8"),
    import("fEQCi"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("dYyVW")
]).then(()=>parcelRequire('6tNBL'));

});

parcelRegister("fLLfn", function(module, exports) {
module.exports = import("2fjJ5").then(()=>parcelRequire('fJweG'));

});

parcelRegister("h6i1u", function(module, exports) {
module.exports = import("hhpHF").then(()=>parcelRequire('xhiOg'));

});

parcelRegister("7NEJZ", function(module, exports) {
module.exports = import("1cpVR").then(()=>parcelRequire('eSSTZ'));

});

parcelRegister("hPu5O", function(module, exports) {
module.exports = Promise.all([
    import("jhVZE"),
    import("NeEg4"),
    import("7bB1J"),
    import("8xkod"),
    import("jwFxG"),
    import("dweJY"),
    import("lzfgR"),
    import("6OcAH"),
    import("2vHmd"),
    import("czClN"),
    import("2espm"),
    import("1gwX4"),
    import("1X7pE"),
    import("fXdFq"),
    import("hhpHF"),
    import("fTIsd"),
    import("5hHZF"),
    import("dBMJ8"),
    import("fEQCi"),
    import("v1FIS"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("jnCN5")
]).then(()=>parcelRequire('2AmoQ'));

});

parcelRegister("hGPOo", function(module, exports) {
module.exports = import("fTIsd").then(()=>parcelRequire('bUaEk'));

});

parcelRegister("8dmba", function(module, exports) {
module.exports = import("aaV31").then(()=>parcelRequire('6PFWO'));

});

parcelRegister("i3k1R", function(module, exports) {
module.exports = import("2mk5M").then(()=>parcelRequire('7SWf8'));

});

parcelRegister("eG73g", function(module, exports) {
module.exports = import("ehJXT").then(()=>parcelRequire('k8FmD'));

});

parcelRegister("1K9Lk", function(module, exports) {
module.exports = import("hxDX3").then(()=>parcelRequire('hGWX0'));

});

parcelRegister("cYAbL", function(module, exports) {
module.exports = import("aCIgC").then(()=>parcelRequire('1xBHy'));

});

parcelRegister("8PjQ5", function(module, exports) {
module.exports = import("gPRMS").then(()=>parcelRequire('avJmR'));

});

parcelRegister("3OXZt", function(module, exports) {
module.exports = import("3EHqS").then(()=>parcelRequire('iCL0w'));

});

parcelRegister("4TJPD", function(module, exports) {
module.exports = import("c6nS0").then(()=>parcelRequire('aIm7z'));

});

parcelRegister("8zsoI", function(module, exports) {
module.exports = Promise.all([
    import("dON9q"),
    import("fTIsd"),
    import("5hHZF"),
    import("1OCeY"),
    import("grigy"),
    import("iPHwm"),
    import("azxzF")
]).then(()=>parcelRequire('cL0n7'));

});

parcelRegister("aCWTI", function(module, exports) {
module.exports = Promise.all([
    import("grigy"),
    import("bnZkN")
]).then(()=>parcelRequire('62rUS'));

});

parcelRegister("60eUy", function(module, exports) {
module.exports = Promise.all([
    import("89DIG"),
    import("1Bzin"),
    import("8RLI5"),
    import("v1FIS"),
    import("1OCeY"),
    import("grigy"),
    import("bIpWk")
]).then(()=>parcelRequire('asCGs'));

});

parcelRegister("kRLoY", function(module, exports) {
module.exports = import("iQY8z").then(()=>parcelRequire('g6rFQ'));

});

parcelRegister("7adgQ", function(module, exports) {
module.exports = import("hpc4H").then(()=>parcelRequire('glnWN'));

});

parcelRegister("f1mbI", function(module, exports) {
module.exports = import("6CVJG").then(()=>parcelRequire('ay5D8'));

});

parcelRegister("czaSJ", function(module, exports) {
module.exports = import("1DE6s").then(()=>parcelRequire('biVJC'));

});

parcelRegister("fzHxO", function(module, exports) {
module.exports = import("j98CJ").then(()=>parcelRequire('dxSXq'));

});

parcelRegister("gN3GG", function(module, exports) {
module.exports = import("hCmxd").then(()=>parcelRequire('dJ6w5'));

});

parcelRegister("dBGU0", function(module, exports) {
module.exports = import("6iSM5").then(()=>parcelRequire('97Mrb'));

});

parcelRegister("4CzwD", function(module, exports) {
module.exports = Promise.all([
    import("dBMJ8"),
    import("fEQCi")
]).then(()=>parcelRequire('cSHkm'));

});

parcelRegister("70Cvu", function(module, exports) {
module.exports = Promise.all([
    import("dBMJ8"),
    import("fEQCi"),
    import("bGQPv")
]).then(()=>parcelRequire('eGOVp'));

});

parcelRegister("5aDGl", function(module, exports) {
module.exports = import("NeEg4").then(()=>parcelRequire('3llWN'));

});

parcelRegister("6l3M9", function(module, exports) {
module.exports = import("5OTbw").then(()=>parcelRequire('9zKT7'));

});

parcelRegister("8B2If", function(module, exports) {
module.exports = import("jaBpS").then(()=>parcelRequire('e48Ig'));

});

parcelRegister("h1DC1", function(module, exports) {
module.exports = import("2pNHA").then(()=>parcelRequire('eQ9KK'));

});

parcelRegister("537yu", function(module, exports) {
module.exports = import("03wHd").then(()=>parcelRequire('b5rcW'));

});

parcelRegister("5vbnl", function(module, exports) {
module.exports = import("9Pk9h").then(()=>parcelRequire('1kwmW'));

});

parcelRegister("4chEh", function(module, exports) {
module.exports = import("j0jAV").then(()=>parcelRequire('3Ssdl'));

});

parcelRegister("bnODD", function(module, exports) {
module.exports = import("cjLFC").then(()=>parcelRequire('kCDBK'));

});

parcelRegister("kMS5v", function(module, exports) {
module.exports = import("6oqPy").then(()=>parcelRequire('hTJB0'));

});

parcelRegister("2zv84", function(module, exports) {
module.exports = import("3mh8i").then(()=>parcelRequire('4E0Xu'));

});

parcelRegister("aT3DP", function(module, exports) {
module.exports = import("9eKLJ").then(()=>parcelRequire('kQvn7'));

});

parcelRegister("kG3mz", function(module, exports) {
module.exports = import("jAX1J").then(()=>parcelRequire('2UQHQ'));

});

parcelRegister("dBxMr", function(module, exports) {
module.exports = import("6lc09").then(()=>parcelRequire('bZgAm'));

});

parcelRegister("9BOQz", function(module, exports) {
module.exports = import("lBuNw").then(()=>parcelRequire('9DEL7'));

});

parcelRegister("cV2T5", function(module, exports) {
module.exports = import("77MHq").then(()=>parcelRequire('lvan5'));

});

parcelRegister("cifvz", function(module, exports) {
module.exports = import("9K8zr").then(()=>parcelRequire('aK3aN'));

});

parcelRegister("4opac", function(module, exports) {
module.exports = import("6Ubmj").then(()=>parcelRequire('8tu3R'));

});

parcelRegister("8l7q7", function(module, exports) {
module.exports = import("cioYn").then(()=>parcelRequire('31OBo'));

});

parcelRegister("3EHZ7", function(module, exports) {
module.exports = import("eeOCr").then(()=>parcelRequire('cWe64'));

});

parcelRegister("f29qU", function(module, exports) {
module.exports = import("9GzKv").then(()=>parcelRequire('acDie'));

});

parcelRegister("40rDn", function(module, exports) {
module.exports = import("l5ZoV").then(()=>parcelRequire('4ebZZ'));

});

parcelRegister("ahqjs", function(module, exports) {
module.exports = import("6Yf4u").then(()=>parcelRequire('auUEg'));

});

parcelRegister("a61sh", function(module, exports) {
module.exports = import("f6w5y").then(()=>parcelRequire('3hW9D'));

});

parcelRegister("cAmHn", function(module, exports) {
module.exports = import("hbFOk").then(()=>parcelRequire('87NAM'));

});

parcelRegister("1TfLI", function(module, exports) {
module.exports = import("4vi9a").then(()=>parcelRequire('3JQmE'));

});

parcelRegister("6JPFE", function(module, exports) {
module.exports = import("2bEcS").then(()=>parcelRequire('5RjL7'));

});

parcelRegister("5S23W", function(module, exports) {
module.exports = import("5MexX").then(()=>parcelRequire('2EzwO'));

});

parcelRegister("4I4vw", function(module, exports) {
module.exports = import("gyfTX").then(()=>parcelRequire('3Wzxn'));

});

parcelRegister("53oQ4", function(module, exports) {
module.exports = import("dizOn").then(()=>parcelRequire('hb0NN'));

});

parcelRegister("9FCXG", function(module, exports) {
module.exports = import("cL4ub").then(()=>parcelRequire('9DxFt'));

});

parcelRegister("j98nV", function(module, exports) {
module.exports = import("4qvzK").then(()=>parcelRequire('2V5zg'));

});

parcelRegister("5B5TG", function(module, exports) {
module.exports = import("gfInW").then(()=>parcelRequire('lJaDK'));

});

parcelRegister("51JxB", function(module, exports) {
module.exports = import("a7HmX").then(()=>parcelRequire('9dvZc'));

});

parcelRegister("2qUDj", function(module, exports) {
module.exports = import("lNPMC").then(()=>parcelRequire('hGE2a'));

});

parcelRegister("24UOY", function(module, exports) {
module.exports = import("lvgni").then(()=>parcelRequire('jUPlB'));

});

parcelRegister("4B9BJ", function(module, exports) {
module.exports = import("6Kbf2").then(()=>parcelRequire('fOHaU'));

});

parcelRegister("8cwCq", function(module, exports) {
module.exports = import("ac9Dy").then(()=>parcelRequire('iYXGX'));

});

parcelRegister("iqE7T", function(module, exports) {
module.exports = import("bijwA").then(()=>parcelRequire('5s3bQ'));

});

parcelRegister("6rCTW", function(module, exports) {
module.exports = import("hWLKE").then(()=>parcelRequire('3FyZW'));

});

parcelRegister("3oofz", function(module, exports) {
module.exports = import("4n2J9").then(()=>parcelRequire('5ZK8n'));

});

parcelRegister("eJEBc", function(module, exports) {
module.exports = import("cpzGD").then(()=>parcelRequire('5PWmG'));

});

parcelRegister("2FjmX", function(module, exports) {
module.exports = import("8KsqG").then(()=>parcelRequire('gUCAk'));

});

parcelRegister("4CfuP", function(module, exports) {
module.exports = import("bay2B").then(()=>parcelRequire('40dLD'));

});

parcelRegister("44DNi", function(module, exports) {
module.exports = import("3mv2J").then(()=>parcelRequire('47PmU'));

});

parcelRegister("rHwQW", function(module, exports) {
module.exports = import("lVHjh").then(()=>parcelRequire('1zIs6'));

});

parcelRegister("57sT0", function(module, exports) {
module.exports = import("32U4c").then(()=>parcelRequire('2GF4S'));

});

parcelRegister("kzpSl", function(module, exports) {
module.exports = import("cAllz").then(()=>parcelRequire('9OvbG'));

});

parcelRegister("iRZPM", function(module, exports) {
module.exports = import("9Yf9y").then(()=>parcelRequire('jMhsp'));

});

parcelRegister("g4TUv", function(module, exports) {
module.exports = import("4VXQ8").then(()=>parcelRequire('dS3yx'));

});

parcelRegister("2y7eV", function(module, exports) {
module.exports = import("a3Kyq").then(()=>parcelRequire('d8SHU'));

});

parcelRegister("j2naT", function(module, exports) {
module.exports = import("5pf6I").then(()=>parcelRequire('1Adn0'));

});

parcelRegister("aI7gx", function(module, exports) {
module.exports = import("lSG5f").then(()=>parcelRequire('gPun9'));

});

parcelRegister("5F93B", function(module, exports) {
module.exports = import("6qMwc").then(()=>parcelRequire('i0Y5a'));

});

parcelRegister("9W8gU", function(module, exports) {
module.exports = import("pRNEx").then(()=>parcelRequire('lQomA'));

});

parcelRegister("cyHaQ", function(module, exports) {
module.exports = import("iBbwX").then(()=>parcelRequire('grfIz'));

});

parcelRegister("xJH6B", function(module, exports) {
module.exports = import("Q7gig").then(()=>parcelRequire('18u3q'));

});

parcelRegister("2BN6c", function(module, exports) {
module.exports = import("9gT0L").then(()=>parcelRequire('k1Cax'));

});

parcelRegister("jklKV", function(module, exports) {
module.exports = import("evTK6").then(()=>parcelRequire('2YddO'));

});

parcelRegister("ijVNE", function(module, exports) {
module.exports = import("awRyO").then(()=>parcelRequire('5P2GY'));

});

parcelRegister("48BGn", function(module, exports) {
module.exports = import("jC4Qx").then(()=>parcelRequire('icgrU'));

});

parcelRegister("kvV5t", function(module, exports) {
module.exports = import("13SYp").then(()=>parcelRequire('kjFEQ'));

});

parcelRegister("2gk3g", function(module, exports) {
module.exports = import("dznFL").then(()=>parcelRequire('bEcMs'));

});

parcelRegister("5DH0m", function(module, exports) {
module.exports = import("7CjfG").then(()=>parcelRequire('hYMcI'));

});

parcelRegister("9JdxH", function(module, exports) {
module.exports = import("bFTbh").then(()=>parcelRequire('hgCUg'));

});

parcelRegister("65y68", function(module, exports) {
module.exports = import("aDZl3").then(()=>parcelRequire('dcMbh'));

});

parcelRegister("lSxTn", function(module, exports) {
module.exports = import("bgwEH").then(()=>parcelRequire('kqL8m'));

});

parcelRegister("ibOgu", function(module, exports) {
module.exports = import("9FYdD").then(()=>parcelRequire('99VFl'));

});

parcelRegister("fokKh", function(module, exports) {
module.exports = import("cViQp").then(()=>parcelRequire('iGyYD'));

});

parcelRegister("amcJb", function(module, exports) {
module.exports = import("8b4PO").then(()=>parcelRequire('8xla1'));

});

parcelRegister("3mqtg", function(module, exports) {
module.exports = import("FPTVz").then(()=>parcelRequire('f34Am'));

});

parcelRegister("9VI5I", function(module, exports) {
module.exports = import("ehvPf").then(()=>parcelRequire('8JjSK'));

});

parcelRegister("jNeD4", function(module, exports) {
module.exports = import("9Z5c9").then(()=>parcelRequire('6NJ1p'));

});

parcelRegister("Lg2z3", function(module, exports) {
module.exports = import("5POY8").then(()=>parcelRequire('dfkuc'));

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


/**
 * react-router v7.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $d88e17cec3da5cb4$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-4N6VE7H7.mjs"
});
var $d88e17cec3da5cb4$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $d88e17cec3da5cb4$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $d88e17cec3da5cb4$var$__typeError("Cannot " + msg);
var $d88e17cec3da5cb4$var$__privateGet = (obj, member, getter)=>($d88e17cec3da5cb4$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $d88e17cec3da5cb4$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $d88e17cec3da5cb4$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $d88e17cec3da5cb4$var$__privateSet = (obj, member, value, setter)=>($d88e17cec3da5cb4$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/history.ts
var $d88e17cec3da5cb4$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($d88e17cec3da5cb4$export$e19cd5f9376f8cee || {});
var $d88e17cec3da5cb4$var$PopStateEventType = "popstate";
function $d88e17cec3da5cb4$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $d88e17cec3da5cb4$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $d88e17cec3da5cb4$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $d88e17cec3da5cb4$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $d88e17cec3da5cb4$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $d88e17cec3da5cb4$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $d88e17cec3da5cb4$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $d88e17cec3da5cb4$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $d88e17cec3da5cb4$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $d88e17cec3da5cb4$export$fe53371bee54353d(to);
    }
    return $d88e17cec3da5cb4$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $d88e17cec3da5cb4$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d88e17cec3da5cb4$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d88e17cec3da5cb4$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d88e17cec3da5cb4$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d88e17cec3da5cb4$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $d88e17cec3da5cb4$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d88e17cec3da5cb4$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d88e17cec3da5cb4$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $d88e17cec3da5cb4$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $d88e17cec3da5cb4$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $d88e17cec3da5cb4$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d88e17cec3da5cb4$var$createKey(),
        mask: mask
    };
    return location;
}
function $d88e17cec3da5cb4$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $d88e17cec3da5cb4$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d88e17cec3da5cb4$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $d88e17cec3da5cb4$var$isLocation(to) ? to : $d88e17cec3da5cb4$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d88e17cec3da5cb4$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $d88e17cec3da5cb4$var$isLocation(to) ? to : $d88e17cec3da5cb4$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d88e17cec3da5cb4$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $d88e17cec3da5cb4$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($d88e17cec3da5cb4$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($d88e17cec3da5cb4$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $d88e17cec3da5cb4$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $d88e17cec3da5cb4$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $d88e17cec3da5cb4$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $d88e17cec3da5cb4$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $d88e17cec3da5cb4$var$_map;
var $d88e17cec3da5cb4$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $d88e17cec3da5cb4$var$__privateAdd(this, $d88e17cec3da5cb4$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_map).has(context)) return $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_map).set(context, value);
    }
};
$d88e17cec3da5cb4$var$_map = new WeakMap();
var $d88e17cec3da5cb4$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d88e17cec3da5cb4$var$isUnsupportedLazyRouteObjectKey(key) {
    return $d88e17cec3da5cb4$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $d88e17cec3da5cb4$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $d88e17cec3da5cb4$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $d88e17cec3da5cb4$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $d88e17cec3da5cb4$var$isIndexRoute(route) {
    return route.index === true;
}
function $d88e17cec3da5cb4$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d88e17cec3da5cb4$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $d88e17cec3da5cb4$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($d88e17cec3da5cb4$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $d88e17cec3da5cb4$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $d88e17cec3da5cb4$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $d88e17cec3da5cb4$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $d88e17cec3da5cb4$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $d88e17cec3da5cb4$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $d88e17cec3da5cb4$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $d88e17cec3da5cb4$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d88e17cec3da5cb4$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $d88e17cec3da5cb4$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $d88e17cec3da5cb4$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d88e17cec3da5cb4$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $d88e17cec3da5cb4$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $d88e17cec3da5cb4$var$flattenAndRankRoutes(routes) {
    let branches = $d88e17cec3da5cb4$var$flattenRoutes(routes);
    $d88e17cec3da5cb4$var$rankRouteBranches(branches);
    return branches;
}
function $d88e17cec3da5cb4$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $d88e17cec3da5cb4$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d88e17cec3da5cb4$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $d88e17cec3da5cb4$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $d88e17cec3da5cb4$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d88e17cec3da5cb4$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $d88e17cec3da5cb4$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $d88e17cec3da5cb4$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d88e17cec3da5cb4$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d88e17cec3da5cb4$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $d88e17cec3da5cb4$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $d88e17cec3da5cb4$var$paramRe = /^:[\w-]+$/;
var $d88e17cec3da5cb4$var$dynamicSegmentValue = 3;
var $d88e17cec3da5cb4$var$indexRouteValue = 2;
var $d88e17cec3da5cb4$var$emptySegmentValue = 1;
var $d88e17cec3da5cb4$var$staticSegmentValue = 10;
var $d88e17cec3da5cb4$var$splatPenalty = -2;
var $d88e17cec3da5cb4$var$isSplat = (s)=>s === "*";
function $d88e17cec3da5cb4$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d88e17cec3da5cb4$var$isSplat)) initialScore += $d88e17cec3da5cb4$var$splatPenalty;
    if (index) initialScore += $d88e17cec3da5cb4$var$indexRouteValue;
    return segments.filter((s)=>!$d88e17cec3da5cb4$var$isSplat(s)).reduce((score, segment)=>score + ($d88e17cec3da5cb4$var$paramRe.test(segment) ? $d88e17cec3da5cb4$var$dynamicSegmentValue : segment === "" ? $d88e17cec3da5cb4$var$emptySegmentValue : $d88e17cec3da5cb4$var$staticSegmentValue), initialScore);
}
function $d88e17cec3da5cb4$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d88e17cec3da5cb4$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d88e17cec3da5cb4$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $d88e17cec3da5cb4$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d88e17cec3da5cb4$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d88e17cec3da5cb4$var$normalizePathname($d88e17cec3da5cb4$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d88e17cec3da5cb4$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $d88e17cec3da5cb4$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d88e17cec3da5cb4$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $d88e17cec3da5cb4$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $d88e17cec3da5cb4$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d88e17cec3da5cb4$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d88e17cec3da5cb4$var$compilePath(path, caseSensitive = false, end = true) {
    $d88e17cec3da5cb4$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $d88e17cec3da5cb4$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d88e17cec3da5cb4$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $d88e17cec3da5cb4$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $d88e17cec3da5cb4$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $d88e17cec3da5cb4$var$joinPaths([
        basename,
        pathname
    ]);
}
var $d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $d88e17cec3da5cb4$var$isAbsoluteUrl = (url)=>$d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX.test(url);
function $d88e17cec3da5cb4$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $d88e17cec3da5cb4$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $d88e17cec3da5cb4$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $d88e17cec3da5cb4$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $d88e17cec3da5cb4$var$normalizeSearch(search),
        hash: $d88e17cec3da5cb4$var$normalizeHash(hash)
    };
}
function $d88e17cec3da5cb4$var$resolvePathname(relativePath, fromPathname) {
    let segments = $d88e17cec3da5cb4$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d88e17cec3da5cb4$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $d88e17cec3da5cb4$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $d88e17cec3da5cb4$var$getResolveToMatches(matches) {
    let pathMatches = $d88e17cec3da5cb4$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $d88e17cec3da5cb4$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $d88e17cec3da5cb4$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $d88e17cec3da5cb4$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $d88e17cec3da5cb4$var$getInvalidPathError("?", "pathname", "search", to));
        $d88e17cec3da5cb4$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $d88e17cec3da5cb4$var$getInvalidPathError("#", "pathname", "hash", to));
        $d88e17cec3da5cb4$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $d88e17cec3da5cb4$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d88e17cec3da5cb4$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $d88e17cec3da5cb4$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $d88e17cec3da5cb4$var$joinPaths = (paths)=>$d88e17cec3da5cb4$var$removeDoubleSlashes(paths.join("/"));
var $d88e17cec3da5cb4$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $d88e17cec3da5cb4$var$normalizePathname = (pathname)=>$d88e17cec3da5cb4$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $d88e17cec3da5cb4$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $d88e17cec3da5cb4$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $d88e17cec3da5cb4$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $d88e17cec3da5cb4$export$4051a07651545597(data2, init) {
    return new $d88e17cec3da5cb4$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $d88e17cec3da5cb4$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $d88e17cec3da5cb4$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d88e17cec3da5cb4$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $d88e17cec3da5cb4$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $d88e17cec3da5cb4$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $d88e17cec3da5cb4$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $d88e17cec3da5cb4$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $d88e17cec3da5cb4$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $d88e17cec3da5cb4$var$joinPaths(parts) || "/";
}
var $d88e17cec3da5cb4$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $d88e17cec3da5cb4$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($d88e17cec3da5cb4$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $d88e17cec3da5cb4$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $d88e17cec3da5cb4$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $d88e17cec3da5cb4$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $d88e17cec3da5cb4$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $d88e17cec3da5cb4$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $d88e17cec3da5cb4$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$d88e17cec3da5cb4$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $d88e17cec3da5cb4$var$wrapImpl(aggregated[key], original, (...args)=>$d88e17cec3da5cb4$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$d88e17cec3da5cb4$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$d88e17cec3da5cb4$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $d88e17cec3da5cb4$var$wrapImpl(aggregated.middleware, original, (...args)=>$d88e17cec3da5cb4$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$d88e17cec3da5cb4$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $d88e17cec3da5cb4$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$d88e17cec3da5cb4$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $d88e17cec3da5cb4$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $d88e17cec3da5cb4$export$fe53371bee54353d(to) : ".",
                ...$d88e17cec3da5cb4$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$d88e17cec3da5cb4$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$d88e17cec3da5cb4$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $d88e17cec3da5cb4$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$d88e17cec3da5cb4$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$d88e17cec3da5cb4$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $d88e17cec3da5cb4$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $d88e17cec3da5cb4$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $d88e17cec3da5cb4$var$getReadonlyRequest(request),
            context: context != null ? $d88e17cec3da5cb4$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $d88e17cec3da5cb4$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $d88e17cec3da5cb4$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $d88e17cec3da5cb4$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $d88e17cec3da5cb4$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $d88e17cec3da5cb4$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $d88e17cec3da5cb4$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $d88e17cec3da5cb4$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $d88e17cec3da5cb4$var$getReadonlyContext(context)
    };
}
function $d88e17cec3da5cb4$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $d88e17cec3da5cb4$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $d88e17cec3da5cb4$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $d88e17cec3da5cb4$var$getReadonlyContext(context) {
    if ($d88e17cec3da5cb4$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $d88e17cec3da5cb4$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $d88e17cec3da5cb4$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $d88e17cec3da5cb4$var$objectProtoNames;
}
// lib/router/router.ts
var $d88e17cec3da5cb4$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $d88e17cec3da5cb4$var$validMutationMethods = new Set($d88e17cec3da5cb4$var$validMutationMethodsArr);
var $d88e17cec3da5cb4$var$validRequestMethodsArr = [
    "GET",
    ...$d88e17cec3da5cb4$var$validMutationMethodsArr
];
var $d88e17cec3da5cb4$var$validRequestMethods = new Set($d88e17cec3da5cb4$var$validRequestMethodsArr);
var $d88e17cec3da5cb4$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $d88e17cec3da5cb4$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $d88e17cec3da5cb4$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $d88e17cec3da5cb4$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $d88e17cec3da5cb4$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $d88e17cec3da5cb4$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $d88e17cec3da5cb4$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $d88e17cec3da5cb4$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $d88e17cec3da5cb4$var$_routes, $d88e17cec3da5cb4$var$_branches, $d88e17cec3da5cb4$var$_hmrRoutes, $d88e17cec3da5cb4$var$_hmrBranches;
var $d88e17cec3da5cb4$var$DataRoutes = class {
    constructor(routes){
        $d88e17cec3da5cb4$var$__privateAdd(this, $d88e17cec3da5cb4$var$_routes);
        $d88e17cec3da5cb4$var$__privateAdd(this, $d88e17cec3da5cb4$var$_branches);
        $d88e17cec3da5cb4$var$__privateAdd(this, $d88e17cec3da5cb4$var$_hmrRoutes);
        $d88e17cec3da5cb4$var$__privateAdd(this, $d88e17cec3da5cb4$var$_hmrBranches);
        $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_routes, routes);
        $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_branches, $d88e17cec3da5cb4$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_hmrRoutes) ?? $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_hmrBranches) ?? $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_branches);
    }
    get hasHMRRoutes() {
        return $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_routes, routes);
        $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_branches, $d88e17cec3da5cb4$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_hmrRoutes, routes);
        $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_hmrBranches, $d88e17cec3da5cb4$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_hmrRoutes)) {
            $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_routes, $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_hmrRoutes));
            $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_branches, $d88e17cec3da5cb4$var$__privateGet(this, $d88e17cec3da5cb4$var$_hmrBranches));
            $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_hmrRoutes, void 0);
            $d88e17cec3da5cb4$var$__privateSet(this, $d88e17cec3da5cb4$var$_hmrBranches, void 0);
        }
    }
};
$d88e17cec3da5cb4$var$_routes = new WeakMap();
$d88e17cec3da5cb4$var$_branches = new WeakMap();
$d88e17cec3da5cb4$var$_hmrRoutes = new WeakMap();
$d88e17cec3da5cb4$var$_hmrBranches = new WeakMap();
function $d88e17cec3da5cb4$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $d88e17cec3da5cb4$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $d88e17cec3da5cb4$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$d88e17cec3da5cb4$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $d88e17cec3da5cb4$var$DataRoutes($d88e17cec3da5cb4$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $d88e17cec3da5cb4$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $d88e17cec3da5cb4$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d88e17cec3da5cb4$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$d88e17cec3da5cb4$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $d88e17cec3da5cb4$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $d88e17cec3da5cb4$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $d88e17cec3da5cb4$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d88e17cec3da5cb4$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $d88e17cec3da5cb4$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d88e17cec3da5cb4$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d88e17cec3da5cb4$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $d88e17cec3da5cb4$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d88e17cec3da5cb4$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d88e17cec3da5cb4$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $d88e17cec3da5cb4$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $d88e17cec3da5cb4$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $d88e17cec3da5cb4$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $d88e17cec3da5cb4$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $d88e17cec3da5cb4$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $d88e17cec3da5cb4$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d88e17cec3da5cb4$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $d88e17cec3da5cb4$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $d88e17cec3da5cb4$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $d88e17cec3da5cb4$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d88e17cec3da5cb4$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $d88e17cec3da5cb4$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $d88e17cec3da5cb4$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $d88e17cec3da5cb4$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $d88e17cec3da5cb4$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($d88e17cec3da5cb4$var$isErrorResult(result) && $d88e17cec3da5cb4$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $d88e17cec3da5cb4$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $d88e17cec3da5cb4$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$d88e17cec3da5cb4$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $d88e17cec3da5cb4$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $d88e17cec3da5cb4$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $d88e17cec3da5cb4$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $d88e17cec3da5cb4$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $d88e17cec3da5cb4$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d88e17cec3da5cb4$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $d88e17cec3da5cb4$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($d88e17cec3da5cb4$var$isErrorResult(result)) {
            let boundaryMatch = $d88e17cec3da5cb4$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $d88e17cec3da5cb4$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $d88e17cec3da5cb4$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $d88e17cec3da5cb4$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $d88e17cec3da5cb4$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $d88e17cec3da5cb4$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$d88e17cec3da5cb4$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $d88e17cec3da5cb4$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $d88e17cec3da5cb4$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $d88e17cec3da5cb4$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $d88e17cec3da5cb4$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $d88e17cec3da5cb4$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $d88e17cec3da5cb4$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $d88e17cec3da5cb4$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d88e17cec3da5cb4$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $d88e17cec3da5cb4$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d88e17cec3da5cb4$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d88e17cec3da5cb4$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d88e17cec3da5cb4$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d88e17cec3da5cb4$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $d88e17cec3da5cb4$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $d88e17cec3da5cb4$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($d88e17cec3da5cb4$var$isRedirectResult(actionResult) || $d88e17cec3da5cb4$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d88e17cec3da5cb4$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($d88e17cec3da5cb4$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $d88e17cec3da5cb4$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d88e17cec3da5cb4$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($d88e17cec3da5cb4$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d88e17cec3da5cb4$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $d88e17cec3da5cb4$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $d88e17cec3da5cb4$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $d88e17cec3da5cb4$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $d88e17cec3da5cb4$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $d88e17cec3da5cb4$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $d88e17cec3da5cb4$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $d88e17cec3da5cb4$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $d88e17cec3da5cb4$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $d88e17cec3da5cb4$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $d88e17cec3da5cb4$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d88e17cec3da5cb4$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $d88e17cec3da5cb4$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d88e17cec3da5cb4$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d88e17cec3da5cb4$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d88e17cec3da5cb4$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $d88e17cec3da5cb4$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $d88e17cec3da5cb4$var$getDoneFetcher(void 0));
            return;
        }
        if ($d88e17cec3da5cb4$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $d88e17cec3da5cb4$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($d88e17cec3da5cb4$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $d88e17cec3da5cb4$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $d88e17cec3da5cb4$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $d88e17cec3da5cb4$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $d88e17cec3da5cb4$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($d88e17cec3da5cb4$var$isAbsoluteUrl(location)) {
                const url = $d88e17cec3da5cb4$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d88e17cec3da5cb4$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d88e17cec3da5cb4$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($d88e17cec3da5cb4$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $d88e17cec3da5cb4$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $d88e17cec3da5cb4$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $d88e17cec3da5cb4$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$d88e17cec3da5cb4$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($d88e17cec3da5cb4$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $d88e17cec3da5cb4$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $d88e17cec3da5cb4$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $d88e17cec3da5cb4$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $d88e17cec3da5cb4$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $d88e17cec3da5cb4$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $d88e17cec3da5cb4$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $d88e17cec3da5cb4$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $d88e17cec3da5cb4$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $d88e17cec3da5cb4$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $d88e17cec3da5cb4$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d88e17cec3da5cb4$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d88e17cec3da5cb4$export$386d57f03f0b2883;
        $d88e17cec3da5cb4$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $d88e17cec3da5cb4$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $d88e17cec3da5cb4$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $d88e17cec3da5cb4$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $d88e17cec3da5cb4$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$d88e17cec3da5cb4$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $d88e17cec3da5cb4$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($d88e17cec3da5cb4$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $d88e17cec3da5cb4$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $d88e17cec3da5cb4$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $d88e17cec3da5cb4$export$3336b097a6fbc59a(routes, opts) {
    $d88e17cec3da5cb4$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $d88e17cec3da5cb4$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$d88e17cec3da5cb4$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $d88e17cec3da5cb4$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $d88e17cec3da5cb4$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $d88e17cec3da5cb4$var$defaultNormalizePath;
        let method = request.method;
        let location = $d88e17cec3da5cb4$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $d88e17cec3da5cb4$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $d88e17cec3da5cb4$export$b8d3e69d4b3eff04();
        if (!$d88e17cec3da5cb4$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d88e17cec3da5cb4$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d88e17cec3da5cb4$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $d88e17cec3da5cb4$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d88e17cec3da5cb4$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $d88e17cec3da5cb4$export$f5708dca728d7177(requestContext instanceof $d88e17cec3da5cb4$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $d88e17cec3da5cb4$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $d88e17cec3da5cb4$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $d88e17cec3da5cb4$var$createDataFunctionUrl(request, location),
                    pattern: $d88e17cec3da5cb4$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($d88e17cec3da5cb4$export$6e80290866a84dd4(error)) return error;
                    if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $d88e17cec3da5cb4$export$f2680fa305b734ca(error.status, error.statusText, await $d88e17cec3da5cb4$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(error)) error = $d88e17cec3da5cb4$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $d88e17cec3da5cb4$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $d88e17cec3da5cb4$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $d88e17cec3da5cb4$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $d88e17cec3da5cb4$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $d88e17cec3da5cb4$var$defaultNormalizePath;
        let method = request.method;
        let location = $d88e17cec3da5cb4$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $d88e17cec3da5cb4$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $d88e17cec3da5cb4$export$b8d3e69d4b3eff04();
        if (!$d88e17cec3da5cb4$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d88e17cec3da5cb4$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d88e17cec3da5cb4$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d88e17cec3da5cb4$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d88e17cec3da5cb4$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $d88e17cec3da5cb4$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $d88e17cec3da5cb4$export$f5708dca728d7177(requestContext instanceof $d88e17cec3da5cb4$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $d88e17cec3da5cb4$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $d88e17cec3da5cb4$var$runServerMiddlewarePipeline({
                request: request,
                url: $d88e17cec3da5cb4$var$createDataFunctionUrl(request, location),
                pattern: $d88e17cec3da5cb4$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($d88e17cec3da5cb4$var$dataWithResponseInitToResponse(error));
                if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $d88e17cec3da5cb4$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d88e17cec3da5cb4$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $d88e17cec3da5cb4$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($d88e17cec3da5cb4$var$isDataStrategyResult(e) && $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($d88e17cec3da5cb4$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d88e17cec3da5cb4$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $d88e17cec3da5cb4$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($d88e17cec3da5cb4$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($d88e17cec3da5cb4$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($d88e17cec3da5cb4$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d88e17cec3da5cb4$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $d88e17cec3da5cb4$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($d88e17cec3da5cb4$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d88e17cec3da5cb4$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $d88e17cec3da5cb4$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $d88e17cec3da5cb4$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $d88e17cec3da5cb4$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $d88e17cec3da5cb4$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $d88e17cec3da5cb4$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $d88e17cec3da5cb4$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $d88e17cec3da5cb4$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $d88e17cec3da5cb4$var$callDataStrategyImpl(dataStrategy || $d88e17cec3da5cb4$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($d88e17cec3da5cb4$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $d88e17cec3da5cb4$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(result.result)) throw $d88e17cec3da5cb4$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $d88e17cec3da5cb4$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $d88e17cec3da5cb4$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $d88e17cec3da5cb4$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $d88e17cec3da5cb4$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $d88e17cec3da5cb4$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $d88e17cec3da5cb4$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $d88e17cec3da5cb4$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $d88e17cec3da5cb4$var$resolveTo(to ? to : ".", $d88e17cec3da5cb4$var$getResolveToMatches(contextualMatches), $d88e17cec3da5cb4$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $d88e17cec3da5cb4$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $d88e17cec3da5cb4$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $d88e17cec3da5cb4$export$fe53371bee54353d(path);
}
function $d88e17cec3da5cb4$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$d88e17cec3da5cb4$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d88e17cec3da5cb4$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d88e17cec3da5cb4$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d88e17cec3da5cb4$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $d88e17cec3da5cb4$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$d88e17cec3da5cb4$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$d88e17cec3da5cb4$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d88e17cec3da5cb4$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d88e17cec3da5cb4$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d88e17cec3da5cb4$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d88e17cec3da5cb4$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d88e17cec3da5cb4$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($d88e17cec3da5cb4$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $d88e17cec3da5cb4$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $d88e17cec3da5cb4$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $d88e17cec3da5cb4$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $d88e17cec3da5cb4$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $d88e17cec3da5cb4$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$d88e17cec3da5cb4$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $d88e17cec3da5cb4$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($d88e17cec3da5cb4$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $d88e17cec3da5cb4$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($d88e17cec3da5cb4$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $d88e17cec3da5cb4$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $d88e17cec3da5cb4$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $d88e17cec3da5cb4$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $d88e17cec3da5cb4$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $d88e17cec3da5cb4$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($d88e17cec3da5cb4$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $d88e17cec3da5cb4$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $d88e17cec3da5cb4$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$d88e17cec3da5cb4$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $d88e17cec3da5cb4$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $d88e17cec3da5cb4$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d88e17cec3da5cb4$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $d88e17cec3da5cb4$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $d88e17cec3da5cb4$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$d88e17cec3da5cb4$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $d88e17cec3da5cb4$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $d88e17cec3da5cb4$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $d88e17cec3da5cb4$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$d88e17cec3da5cb4$var$isSameRoute(aChild, bChild))) ?? false;
}
var $d88e17cec3da5cb4$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $d88e17cec3da5cb4$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $d88e17cec3da5cb4$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $d88e17cec3da5cb4$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $d88e17cec3da5cb4$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $d88e17cec3da5cb4$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $d88e17cec3da5cb4$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $d88e17cec3da5cb4$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $d88e17cec3da5cb4$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $d88e17cec3da5cb4$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $d88e17cec3da5cb4$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $d88e17cec3da5cb4$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $d88e17cec3da5cb4$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $d88e17cec3da5cb4$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $d88e17cec3da5cb4$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $d88e17cec3da5cb4$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $d88e17cec3da5cb4$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $d88e17cec3da5cb4$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $d88e17cec3da5cb4$var$isNonNullable(value) {
    return value !== void 0;
}
function $d88e17cec3da5cb4$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $d88e17cec3da5cb4$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($d88e17cec3da5cb4$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $d88e17cec3da5cb4$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $d88e17cec3da5cb4$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $d88e17cec3da5cb4$var$defaultDataStrategy(args);
    return $d88e17cec3da5cb4$var$runClientMiddlewarePipeline(args, ()=>$d88e17cec3da5cb4$var$defaultDataStrategy(args));
}
function $d88e17cec3da5cb4$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $d88e17cec3da5cb4$var$runMiddlewarePipeline(args, handler, processResult, $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(result) ? $d88e17cec3da5cb4$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $d88e17cec3da5cb4$var$runClientMiddlewarePipeline(args, handler) {
    return $d88e17cec3da5cb4$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($d88e17cec3da5cb4$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $d88e17cec3da5cb4$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $d88e17cec3da5cb4$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $d88e17cec3da5cb4$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $d88e17cec3da5cb4$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $d88e17cec3da5cb4$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $d88e17cec3da5cb4$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $d88e17cec3da5cb4$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $d88e17cec3da5cb4$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $d88e17cec3da5cb4$var$loadLazyRoute(match.route, $d88e17cec3da5cb4$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $d88e17cec3da5cb4$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $d88e17cec3da5cb4$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $d88e17cec3da5cb4$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $d88e17cec3da5cb4$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $d88e17cec3da5cb4$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$d88e17cec3da5cb4$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($d88e17cec3da5cb4$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $d88e17cec3da5cb4$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $d88e17cec3da5cb4$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $d88e17cec3da5cb4$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $d88e17cec3da5cb4$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $d88e17cec3da5cb4$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $d88e17cec3da5cb4$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $d88e17cec3da5cb4$var$createDataFunctionUrl(request, path),
        pattern: $d88e17cec3da5cb4$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $d88e17cec3da5cb4$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $d88e17cec3da5cb4$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $d88e17cec3da5cb4$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $d88e17cec3da5cb4$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d88e17cec3da5cb4$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d88e17cec3da5cb4$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $d88e17cec3da5cb4$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $d88e17cec3da5cb4$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $d88e17cec3da5cb4$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $d88e17cec3da5cb4$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $d88e17cec3da5cb4$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $d88e17cec3da5cb4$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $d88e17cec3da5cb4$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $d88e17cec3da5cb4$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $d88e17cec3da5cb4$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$d88e17cec3da5cb4$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $d88e17cec3da5cb4$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $d88e17cec3da5cb4$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $d88e17cec3da5cb4$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($d88e17cec3da5cb4$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($d88e17cec3da5cb4$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $d88e17cec3da5cb4$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $d88e17cec3da5cb4$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($d88e17cec3da5cb4$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $d88e17cec3da5cb4$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d88e17cec3da5cb4$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d88e17cec3da5cb4$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $d88e17cec3da5cb4$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d88e17cec3da5cb4$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $d88e17cec3da5cb4$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d88e17cec3da5cb4$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d88e17cec3da5cb4$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $d88e17cec3da5cb4$export$f5708dca728d7177(!$d88e17cec3da5cb4$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d88e17cec3da5cb4$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $d88e17cec3da5cb4$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $d88e17cec3da5cb4$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $d88e17cec3da5cb4$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d88e17cec3da5cb4$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $d88e17cec3da5cb4$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $d88e17cec3da5cb4$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($d88e17cec3da5cb4$var$isErrorResult(result)) {
            let boundaryMatch = $d88e17cec3da5cb4$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($d88e17cec3da5cb4$var$isRedirectResult(result)) $d88e17cec3da5cb4$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $d88e17cec3da5cb4$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d88e17cec3da5cb4$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $d88e17cec3da5cb4$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $d88e17cec3da5cb4$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d88e17cec3da5cb4$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $d88e17cec3da5cb4$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d88e17cec3da5cb4$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d88e17cec3da5cb4$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $d88e17cec3da5cb4$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $d88e17cec3da5cb4$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($d88e17cec3da5cb4$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $d88e17cec3da5cb4$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(path) : path;
    return $d88e17cec3da5cb4$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $d88e17cec3da5cb4$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $d88e17cec3da5cb4$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $d88e17cec3da5cb4$var$dataWithResponseInitToErrorResponse(data2) {
    return new $d88e17cec3da5cb4$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $d88e17cec3da5cb4$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $d88e17cec3da5cb4$var$isDataStrategyResult(value));
}
function $d88e17cec3da5cb4$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $d88e17cec3da5cb4$var$isRedirectDataStrategyResult(result) {
    return $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result.result) && $d88e17cec3da5cb4$var$redirectStatusCodes.has(result.result.status);
}
function $d88e17cec3da5cb4$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $d88e17cec3da5cb4$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d88e17cec3da5cb4$export$794b2760043cf8cd(statusCode) {
    return $d88e17cec3da5cb4$var$redirectStatusCodes.has(statusCode);
}
function $d88e17cec3da5cb4$export$6e80290866a84dd4(result) {
    return $d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result) && $d88e17cec3da5cb4$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $d88e17cec3da5cb4$var$isValidMethod(method) {
    return $d88e17cec3da5cb4$var$validRequestMethods.has(method.toUpperCase());
}
function $d88e17cec3da5cb4$export$cbae47800eb95bc3(method) {
    return $d88e17cec3da5cb4$var$validMutationMethods.has(method.toUpperCase());
}
function $d88e17cec3da5cb4$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d88e17cec3da5cb4$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d88e17cec3da5cb4$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $d88e17cec3da5cb4$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d88e17cec3da5cb4$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $d88e17cec3da5cb4$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $d88e17cec3da5cb4$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d88e17cec3da5cb4$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $d88e17cec3da5cb4$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $d88e17cec3da5cb4$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $d88e17cec3da5cb4$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d88e17cec3da5cb4$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $d88e17cec3da5cb4$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d88e17cec3da5cb4$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d88e17cec3da5cb4$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $d88e17cec3da5cb4$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $d88e17cec3da5cb4$export$2eeee58951ff3c1c = $acw62.createContext(null);
$d88e17cec3da5cb4$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $d88e17cec3da5cb4$export$315e3ffb01f217 = $acw62.createContext(null);
$d88e17cec3da5cb4$export$315e3ffb01f217.displayName = "DataRouterState";
var $d88e17cec3da5cb4$export$717f757c655223f1 = $acw62.createContext(false);
function $d88e17cec3da5cb4$var$useIsRSCRouterContext() {
    return $acw62.useContext($d88e17cec3da5cb4$export$717f757c655223f1);
}
var $d88e17cec3da5cb4$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$d88e17cec3da5cb4$export$3681f408decb40d1.displayName = "ViewTransition";
var $d88e17cec3da5cb4$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$d88e17cec3da5cb4$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $d88e17cec3da5cb4$var$AwaitContext = $acw62.createContext(null);
$d88e17cec3da5cb4$var$AwaitContext.displayName = "Await";
var $d88e17cec3da5cb4$export$2666c20e15407622 = (props)=>$acw62.createElement($d88e17cec3da5cb4$var$AwaitContext.Provider, props);
var $d88e17cec3da5cb4$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$d88e17cec3da5cb4$export$3044ab7fdabeaee6.displayName = "Navigation";
var $d88e17cec3da5cb4$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$d88e17cec3da5cb4$export$e6a44b110a0c44d3.displayName = "Location";
var $d88e17cec3da5cb4$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$d88e17cec3da5cb4$export$aac280ed165a4397.displayName = "Route";
var $d88e17cec3da5cb4$var$RouteErrorContext = $acw62.createContext(null);
$d88e17cec3da5cb4$var$RouteErrorContext.displayName = "RouteError";
var $d88e17cec3da5cb4$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $d88e17cec3da5cb4$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $d88e17cec3da5cb4$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $d88e17cec3da5cb4$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $d88e17cec3da5cb4$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$d88e17cec3da5cb4$var$ERROR_DIGEST_BASE}:${$d88e17cec3da5cb4$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $d88e17cec3da5cb4$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$d88e17cec3da5cb4$var$ERROR_DIGEST_BASE}:${$d88e17cec3da5cb4$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $d88e17cec3da5cb4$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $d88e17cec3da5cb4$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $d88e17cec3da5cb4$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $d88e17cec3da5cb4$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $d88e17cec3da5cb4$export$9c954a9d03d32f4a() {
    return $acw62.useContext($d88e17cec3da5cb4$export$e6a44b110a0c44d3) != null;
}
function $d88e17cec3da5cb4$export$45d76561a5302f2b() {
    $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($d88e17cec3da5cb4$export$e6a44b110a0c44d3).location;
}
function $d88e17cec3da5cb4$export$1b3f31771c5d07c() {
    return $acw62.useContext($d88e17cec3da5cb4$export$e6a44b110a0c44d3).navigationType;
}
function $d88e17cec3da5cb4$export$6c330e8992e8a295(pattern) {
    $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$d88e17cec3da5cb4$export$81336c211d5ff295(pattern, $d88e17cec3da5cb4$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $d88e17cec3da5cb4$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $d88e17cec3da5cb4$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $d88e17cec3da5cb4$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    return isDataRoute ? $d88e17cec3da5cb4$var$useNavigateStable() : $d88e17cec3da5cb4$var$useNavigateUnstable();
}
function $d88e17cec3da5cb4$var$useNavigateUnstable() {
    $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($d88e17cec3da5cb4$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    let { pathname: locationPathname } = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($d88e17cec3da5cb4$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $d88e17cec3da5cb4$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $d88e17cec3da5cb4$var$warning(activeRef.current, $d88e17cec3da5cb4$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $d88e17cec3da5cb4$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d88e17cec3da5cb4$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $d88e17cec3da5cb4$var$OutletContext = $acw62.createContext(null);
function $d88e17cec3da5cb4$export$4138103a3ae699cc() {
    return $acw62.useContext($d88e17cec3da5cb4$var$OutletContext);
}
function $d88e17cec3da5cb4$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $d88e17cec3da5cb4$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $d88e17cec3da5cb4$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    let { pathname: locationPathname } = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($d88e17cec3da5cb4$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$d88e17cec3da5cb4$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $d88e17cec3da5cb4$export$5d3fca4a98652595(routes, locationArg) {
    return $d88e17cec3da5cb4$var$useRoutesImpl(routes, locationArg);
}
function $d88e17cec3da5cb4$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($d88e17cec3da5cb4$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $d88e17cec3da5cb4$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $d88e17cec3da5cb4$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $d88e17cec3da5cb4$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $d88e17cec3da5cb4$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($d88e17cec3da5cb4$export$945fecf35a8ef089) {
        $d88e17cec3da5cb4$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $d88e17cec3da5cb4$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $d88e17cec3da5cb4$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $d88e17cec3da5cb4$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $d88e17cec3da5cb4$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d88e17cec3da5cb4$var$DefaultErrorComponent() {
    let error = $d88e17cec3da5cb4$export$ed527bf60f6e05f2();
    let message = $d88e17cec3da5cb4$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($d88e17cec3da5cb4$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $d88e17cec3da5cb4$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$DefaultErrorComponent, null);
var $d88e17cec3da5cb4$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $d88e17cec3da5cb4$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$d88e17cec3da5cb4$var$RenderErrorBoundary.contextType = $d88e17cec3da5cb4$export$717f757c655223f1;
var $d88e17cec3da5cb4$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $d88e17cec3da5cb4$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $d88e17cec3da5cb4$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $d88e17cec3da5cb4$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $d88e17cec3da5cb4$var$parseToInfo(redirect2.location, basename);
            if ($d88e17cec3da5cb4$var$isBrowser && !$d88e17cec3da5cb4$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $d88e17cec3da5cb4$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $d88e17cec3da5cb4$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($d88e17cec3da5cb4$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $d88e17cec3da5cb4$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $d88e17cec3da5cb4$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $d88e17cec3da5cb4$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $d88e17cec3da5cb4$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d88e17cec3da5cb4$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $d88e17cec3da5cb4$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $d88e17cec3da5cb4$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($d88e17cec3da5cb4$export$2eeee58951ff3c1c);
    $d88e17cec3da5cb4$export$f5708dca728d7177(ctx, $d88e17cec3da5cb4$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $d88e17cec3da5cb4$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($d88e17cec3da5cb4$export$315e3ffb01f217);
    $d88e17cec3da5cb4$export$f5708dca728d7177(state, $d88e17cec3da5cb4$var$getDataRouterConsoleError(hookName));
    return state;
}
function $d88e17cec3da5cb4$var$useRouteContext(hookName) {
    let route = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    $d88e17cec3da5cb4$export$f5708dca728d7177(route, $d88e17cec3da5cb4$var$getDataRouterConsoleError(hookName));
    return route;
}
function $d88e17cec3da5cb4$var$useCurrentRouteId(hookName) {
    let route = $d88e17cec3da5cb4$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $d88e17cec3da5cb4$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $d88e17cec3da5cb4$var$useRouteId() {
    return $d88e17cec3da5cb4$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $d88e17cec3da5cb4$export$d0fd4b7106de2769() {
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $d88e17cec3da5cb4$export$600dc272ed516c15() {
    let dataRouterContext = $d88e17cec3da5cb4$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $d88e17cec3da5cb4$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d88e17cec3da5cb4$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$d88e17cec3da5cb4$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $d88e17cec3da5cb4$export$1448a5050d252c4d() {
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $d88e17cec3da5cb4$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $d88e17cec3da5cb4$export$fd5d37484eab868d(routeId) {
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $d88e17cec3da5cb4$export$fdc00f3f26066d5e() {
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $d88e17cec3da5cb4$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $d88e17cec3da5cb4$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($d88e17cec3da5cb4$var$RouteErrorContext);
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $d88e17cec3da5cb4$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $d88e17cec3da5cb4$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($d88e17cec3da5cb4$var$AwaitContext);
    return value?._data;
}
function $d88e17cec3da5cb4$export$17f53340677d5831() {
    let value = $acw62.useContext($d88e17cec3da5cb4$var$AwaitContext);
    return value?._error;
}
var $d88e17cec3da5cb4$var$blockerId = 0;
function $d88e17cec3da5cb4$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d88e17cec3da5cb4$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $d88e17cec3da5cb4$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $d88e17cec3da5cb4$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $d88e17cec3da5cb4$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$d88e17cec3da5cb4$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $d88e17cec3da5cb4$export$386d57f03f0b2883;
}
function $d88e17cec3da5cb4$var$useNavigateStable() {
    let { router: router } = $d88e17cec3da5cb4$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $d88e17cec3da5cb4$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $d88e17cec3da5cb4$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $d88e17cec3da5cb4$var$warning(activeRef.current, $d88e17cec3da5cb4$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $d88e17cec3da5cb4$var$alreadyWarned = {};
function $d88e17cec3da5cb4$var$warningOnce(key, cond, message) {
    if (!cond && !$d88e17cec3da5cb4$var$alreadyWarned[key]) {
        $d88e17cec3da5cb4$var$alreadyWarned[key] = true;
        $d88e17cec3da5cb4$var$warning(false, message);
    }
}
function $d88e17cec3da5cb4$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $d88e17cec3da5cb4$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $d88e17cec3da5cb4$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $d88e17cec3da5cb4$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $d88e17cec3da5cb4$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $d88e17cec3da5cb4$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$d88e17cec3da5cb4$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$d88e17cec3da5cb4$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $d88e17cec3da5cb4$var$alreadyWarned2 = {};
function $d88e17cec3da5cb4$export$5b28268982f175ba(condition, message) {
    if (!condition && !$d88e17cec3da5cb4$var$alreadyWarned2[message]) {
        $d88e17cec3da5cb4$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $d88e17cec3da5cb4$var$USE_OPTIMISTIC = "useOptimistic";
var $d88e17cec3da5cb4$var$useOptimisticImpl = $acw62[$d88e17cec3da5cb4$var$USE_OPTIMISTIC];
var $d88e17cec3da5cb4$var$stableUseOptimisticSetter = ()=>void 0;
function $d88e17cec3da5cb4$var$useOptimisticSafe(val) {
    if ($d88e17cec3da5cb4$var$useOptimisticImpl) return $d88e17cec3da5cb4$var$useOptimisticImpl(val);
    else return [
        val,
        $d88e17cec3da5cb4$var$stableUseOptimisticSetter
    ];
}
function $d88e17cec3da5cb4$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($d88e17cec3da5cb4$export$945fecf35a8ef089) {
            if (route.element) $d88e17cec3da5cb4$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($d88e17cec3da5cb4$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $d88e17cec3da5cb4$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($d88e17cec3da5cb4$export$945fecf35a8ef089) {
            if (route.errorElement) $d88e17cec3da5cb4$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $d88e17cec3da5cb4$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $d88e17cec3da5cb4$export$f30f7e456d254e83(routes, opts) {
    return $d88e17cec3da5cb4$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $d88e17cec3da5cb4$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $d88e17cec3da5cb4$export$e2fd2c03906469db,
        mapRouteProperties: $d88e17cec3da5cb4$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $d88e17cec3da5cb4$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $d88e17cec3da5cb4$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $d88e17cec3da5cb4$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $d88e17cec3da5cb4$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $d88e17cec3da5cb4$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $d88e17cec3da5cb4$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $d88e17cec3da5cb4$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$d88e17cec3da5cb4$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d88e17cec3da5cb4$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$d88e17cec3da5cb4$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $d88e17cec3da5cb4$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $d88e17cec3da5cb4$var$MemoizedDataRoutes = $acw62.memo($d88e17cec3da5cb4$var$DataRoutes2);
function $d88e17cec3da5cb4$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $d88e17cec3da5cb4$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $d88e17cec3da5cb4$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $d88e17cec3da5cb4$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $d88e17cec3da5cb4$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $d88e17cec3da5cb4$export$f5708dca728d7177($d88e17cec3da5cb4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    $d88e17cec3da5cb4$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    let { pathname: locationPathname } = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let navigate = $d88e17cec3da5cb4$export$9770f232ac06a008();
    let path = $d88e17cec3da5cb4$var$resolveTo(to, $d88e17cec3da5cb4$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $d88e17cec3da5cb4$export$910ae8079b2c2852(props) {
    return $d88e17cec3da5cb4$export$a3be3530d8e40d0b(props.context);
}
function $d88e17cec3da5cb4$export$e7b0ac011bb776c6(props) {
    $d88e17cec3da5cb4$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $d88e17cec3da5cb4$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $d88e17cec3da5cb4$export$f5708dca728d7177(!$d88e17cec3da5cb4$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $d88e17cec3da5cb4$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $d88e17cec3da5cb4$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $d88e17cec3da5cb4$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $d88e17cec3da5cb4$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $d88e17cec3da5cb4$export$5d3fca4a98652595($d88e17cec3da5cb4$export$16da398f5434bdec(children), location);
}
function $d88e17cec3da5cb4$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($d88e17cec3da5cb4$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($d88e17cec3da5cb4$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $d88e17cec3da5cb4$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$ResolveAwait, null, children));
}
var $d88e17cec3da5cb4$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $d88e17cec3da5cb4$var$ResolveAwait({ children: children }) {
    let data2 = $d88e17cec3da5cb4$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $d88e17cec3da5cb4$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $d88e17cec3da5cb4$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $d88e17cec3da5cb4$export$f5708dca728d7177(element.type === $d88e17cec3da5cb4$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $d88e17cec3da5cb4$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d88e17cec3da5cb4$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $d88e17cec3da5cb4$export$9b5b6d122dea0c88 = $d88e17cec3da5cb4$export$16da398f5434bdec;
function $d88e17cec3da5cb4$export$daf73786167a7f72(matches) {
    return $d88e17cec3da5cb4$var$_renderMatches(matches);
}
function $d88e17cec3da5cb4$var$useRouteComponentProps() {
    return {
        params: $d88e17cec3da5cb4$export$99eaa27ddbbb95ef(),
        loaderData: $d88e17cec3da5cb4$export$1448a5050d252c4d(),
        actionData: $d88e17cec3da5cb4$export$fdc00f3f26066d5e(),
        matches: $d88e17cec3da5cb4$export$2378eb7f5ff86053()
    };
}
function $d88e17cec3da5cb4$export$6c4f3826290c37af({ children: children }) {
    const props = $d88e17cec3da5cb4$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $d88e17cec3da5cb4$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $d88e17cec3da5cb4$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $d88e17cec3da5cb4$var$useHydrateFallbackProps() {
    return {
        params: $d88e17cec3da5cb4$export$99eaa27ddbbb95ef(),
        loaderData: $d88e17cec3da5cb4$export$1448a5050d252c4d(),
        actionData: $d88e17cec3da5cb4$export$fdc00f3f26066d5e()
    };
}
function $d88e17cec3da5cb4$export$f8cff34f39c1932a({ children: children }) {
    const props = $d88e17cec3da5cb4$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $d88e17cec3da5cb4$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $d88e17cec3da5cb4$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $d88e17cec3da5cb4$var$useErrorBoundaryProps() {
    return {
        params: $d88e17cec3da5cb4$export$99eaa27ddbbb95ef(),
        loaderData: $d88e17cec3da5cb4$export$1448a5050d252c4d(),
        actionData: $d88e17cec3da5cb4$export$fdc00f3f26066d5e(),
        error: $d88e17cec3da5cb4$export$ed527bf60f6e05f2()
    };
}
function $d88e17cec3da5cb4$export$e5afde5c4b6d747b({ children: children }) {
    const props = $d88e17cec3da5cb4$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $d88e17cec3da5cb4$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $d88e17cec3da5cb4$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $d88e17cec3da5cb4$var$defaultMethod = "get";
var $d88e17cec3da5cb4$var$defaultEncType = "application/x-www-form-urlencoded";
function $d88e17cec3da5cb4$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $d88e17cec3da5cb4$var$isButtonElement(object) {
    return $d88e17cec3da5cb4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d88e17cec3da5cb4$var$isFormElement(object) {
    return $d88e17cec3da5cb4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d88e17cec3da5cb4$var$isInputElement(object) {
    return $d88e17cec3da5cb4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d88e17cec3da5cb4$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d88e17cec3da5cb4$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d88e17cec3da5cb4$var$isModifiedEvent(event);
}
function $d88e17cec3da5cb4$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d88e17cec3da5cb4$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d88e17cec3da5cb4$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $d88e17cec3da5cb4$var$_formDataSupportsSubmitter = null;
function $d88e17cec3da5cb4$var$isFormDataSubmitterSupported() {
    if ($d88e17cec3da5cb4$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d88e17cec3da5cb4$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d88e17cec3da5cb4$var$_formDataSupportsSubmitter = true;
    }
    return $d88e17cec3da5cb4$var$_formDataSupportsSubmitter;
}
var $d88e17cec3da5cb4$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d88e17cec3da5cb4$var$getFormEncType(encType) {
    if (encType != null && !$d88e17cec3da5cb4$var$supportedFormEncTypes.has(encType)) {
        $d88e17cec3da5cb4$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$d88e17cec3da5cb4$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $d88e17cec3da5cb4$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d88e17cec3da5cb4$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $d88e17cec3da5cb4$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $d88e17cec3da5cb4$var$defaultMethod;
        encType = $d88e17cec3da5cb4$var$getFormEncType(target.getAttribute("enctype")) || $d88e17cec3da5cb4$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d88e17cec3da5cb4$var$isButtonElement(target) || $d88e17cec3da5cb4$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $d88e17cec3da5cb4$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d88e17cec3da5cb4$var$defaultMethod;
        encType = $d88e17cec3da5cb4$var$getFormEncType(target.getAttribute("formenctype")) || $d88e17cec3da5cb4$var$getFormEncType(form.getAttribute("enctype")) || $d88e17cec3da5cb4$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$d88e17cec3da5cb4$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d88e17cec3da5cb4$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $d88e17cec3da5cb4$var$defaultMethod;
        action = null;
        encType = $d88e17cec3da5cb4$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $d88e17cec3da5cb4$var$HOLE = -1;
var $d88e17cec3da5cb4$var$NAN = -2;
var $d88e17cec3da5cb4$var$NEGATIVE_INFINITY = -3;
var $d88e17cec3da5cb4$var$NEGATIVE_ZERO = -4;
var $d88e17cec3da5cb4$var$NULL = -5;
var $d88e17cec3da5cb4$var$POSITIVE_INFINITY = -6;
var $d88e17cec3da5cb4$var$UNDEFINED = -7;
var $d88e17cec3da5cb4$var$TYPE_BIGINT = "B";
var $d88e17cec3da5cb4$var$TYPE_DATE = "D";
var $d88e17cec3da5cb4$var$TYPE_ERROR = "E";
var $d88e17cec3da5cb4$var$TYPE_MAP = "M";
var $d88e17cec3da5cb4$var$TYPE_NULL_OBJECT = "N";
var $d88e17cec3da5cb4$var$TYPE_PROMISE = "P";
var $d88e17cec3da5cb4$var$TYPE_REGEXP = "R";
var $d88e17cec3da5cb4$var$TYPE_SET = "S";
var $d88e17cec3da5cb4$var$TYPE_SYMBOL = "Y";
var $d88e17cec3da5cb4$var$TYPE_URL = "U";
var $d88e17cec3da5cb4$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $d88e17cec3da5cb4$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $d88e17cec3da5cb4$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $d88e17cec3da5cb4$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $d88e17cec3da5cb4$var$TIME_LIMIT_MS = 1;
var $d88e17cec3da5cb4$var$getNow = ()=>Date.now();
var $d88e17cec3da5cb4$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $d88e17cec3da5cb4$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $d88e17cec3da5cb4$var$UNDEFINED;
    if (input === null) return $d88e17cec3da5cb4$var$NULL;
    if (Number.isNaN(input)) return $d88e17cec3da5cb4$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $d88e17cec3da5cb4$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $d88e17cec3da5cb4$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $d88e17cec3da5cb4$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $d88e17cec3da5cb4$var$stringify.call(this, stack);
    return index;
}
async function $d88e17cec3da5cb4$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $d88e17cec3da5cb4$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $d88e17cec3da5cb4$var$UNDEFINED;
        if (value === null) return $d88e17cec3da5cb4$var$NULL;
        if (Number.isNaN(value)) return $d88e17cec3da5cb4$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $d88e17cec3da5cb4$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $d88e17cec3da5cb4$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $d88e17cec3da5cb4$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $d88e17cec3da5cb4$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $d88e17cec3da5cb4$var$TIME_LIMIT_MS) {
            await $d88e17cec3da5cb4$var$yieldToMain();
            lastYieldTime = $d88e17cec3da5cb4$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$d88e17cec3da5cb4$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$d88e17cec3da5cb4$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$d88e17cec3da5cb4$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $d88e17cec3da5cb4$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$d88e17cec3da5cb4$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$d88e17cec3da5cb4$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$d88e17cec3da5cb4$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$d88e17cec3da5cb4$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$d88e17cec3da5cb4$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$d88e17cec3da5cb4$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$d88e17cec3da5cb4$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$d88e17cec3da5cb4$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$d88e17cec3da5cb4$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$d88e17cec3da5cb4$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($d88e17cec3da5cb4$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $d88e17cec3da5cb4$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $d88e17cec3da5cb4$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $d88e17cec3da5cb4$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $d88e17cec3da5cb4$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $d88e17cec3da5cb4$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $d88e17cec3da5cb4$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $d88e17cec3da5cb4$var$hydrate.call(this, startIndex);
}
function $d88e17cec3da5cb4$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $d88e17cec3da5cb4$var$UNDEFINED:
                set(void 0);
                continue;
            case $d88e17cec3da5cb4$var$NULL:
                set(null);
                continue;
            case $d88e17cec3da5cb4$var$NAN:
                set(NaN);
                continue;
            case $d88e17cec3da5cb4$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $d88e17cec3da5cb4$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $d88e17cec3da5cb4$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $d88e17cec3da5cb4$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $d88e17cec3da5cb4$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $d88e17cec3da5cb4$var$globalObj && $d88e17cec3da5cb4$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $d88e17cec3da5cb4$var$globalObj && typeof $d88e17cec3da5cb4$var$globalObj[errorType] === "function" ? new $d88e17cec3da5cb4$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $d88e17cec3da5cb4$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $d88e17cec3da5cb4$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $d88e17cec3da5cb4$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $d88e17cec3da5cb4$var$Deferred2();
    const reader = readable.pipeThrough($d88e17cec3da5cb4$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $d88e17cec3da5cb4$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $d88e17cec3da5cb4$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $d88e17cec3da5cb4$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $d88e17cec3da5cb4$var$unflatten.call(this, line)
    };
}
async function $d88e17cec3da5cb4$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $d88e17cec3da5cb4$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $d88e17cec3da5cb4$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $d88e17cec3da5cb4$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $d88e17cec3da5cb4$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $d88e17cec3da5cb4$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $d88e17cec3da5cb4$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $d88e17cec3da5cb4$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$d88e17cec3da5cb4$var$TYPE_PROMISE}${deferredId}:[["${$d88e17cec3da5cb4$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$d88e17cec3da5cb4$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$d88e17cec3da5cb4$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $d88e17cec3da5cb4$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$d88e17cec3da5cb4$var$TYPE_ERROR}${deferredId}:[["${$d88e17cec3da5cb4$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$d88e17cec3da5cb4$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$d88e17cec3da5cb4$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $d88e17cec3da5cb4$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $d88e17cec3da5cb4$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $d88e17cec3da5cb4$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $d88e17cec3da5cb4$export$4cf11838cdc2a8a8(html) {
    return html.replace($d88e17cec3da5cb4$var$ESCAPE_REGEX, (match)=>$d88e17cec3da5cb4$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $d88e17cec3da5cb4$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $d88e17cec3da5cb4$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $d88e17cec3da5cb4$var$SingleFetchNoResultError = class extends Error {
};
var $d88e17cec3da5cb4$export$ae9272e641ead836 = 202;
var $d88e17cec3da5cb4$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $d88e17cec3da5cb4$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$d88e17cec3da5cb4$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $d88e17cec3da5cb4$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $d88e17cec3da5cb4$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $d88e17cec3da5cb4$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $d88e17cec3da5cb4$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $d88e17cec3da5cb4$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $d88e17cec3da5cb4$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $d88e17cec3da5cb4$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $d88e17cec3da5cb4$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $d88e17cec3da5cb4$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $d88e17cec3da5cb4$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $d88e17cec3da5cb4$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $d88e17cec3da5cb4$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($d88e17cec3da5cb4$export$3f1eb41d9a6a6a27(result.result) || $d88e17cec3da5cb4$export$972111febbeef05b(result.result) || $d88e17cec3da5cb4$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $d88e17cec3da5cb4$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $d88e17cec3da5cb4$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $d88e17cec3da5cb4$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $d88e17cec3da5cb4$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$d88e17cec3da5cb4$var$createDeferred2());
    let singleFetchDfd = $d88e17cec3da5cb4$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $d88e17cec3da5cb4$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $d88e17cec3da5cb4$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $d88e17cec3da5cb4$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $d88e17cec3da5cb4$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $d88e17cec3da5cb4$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $d88e17cec3da5cb4$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $d88e17cec3da5cb4$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $d88e17cec3da5cb4$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $d88e17cec3da5cb4$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $d88e17cec3da5cb4$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $d88e17cec3da5cb4$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$d88e17cec3da5cb4$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$d88e17cec3da5cb4$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $d88e17cec3da5cb4$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $d88e17cec3da5cb4$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $d88e17cec3da5cb4$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $d88e17cec3da5cb4$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $d88e17cec3da5cb4$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $d88e17cec3da5cb4$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($d88e17cec3da5cb4$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $d88e17cec3da5cb4$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $d88e17cec3da5cb4$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($d88e17cec3da5cb4$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$d88e17cec3da5cb4$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $d88e17cec3da5cb4$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $d88e17cec3da5cb4$export$4023ad4ecd4126a2(body, global) {
    return $d88e17cec3da5cb4$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $d88e17cec3da5cb4$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $d88e17cec3da5cb4$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$d88e17cec3da5cb4$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $d88e17cec3da5cb4$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $d88e17cec3da5cb4$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $d88e17cec3da5cb4$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $d88e17cec3da5cb4$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $d88e17cec3da5cb4$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $d88e17cec3da5cb4$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $d88e17cec3da5cb4$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $d88e17cec3da5cb4$var$getModuleLinkHrefs(matches, manifest);
    return $d88e17cec3da5cb4$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $d88e17cec3da5cb4$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $d88e17cec3da5cb4$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $d88e17cec3da5cb4$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($d88e17cec3da5cb4$var$prefetchStyleLink));
}
async function $d88e17cec3da5cb4$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$d88e17cec3da5cb4$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$d88e17cec3da5cb4$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$d88e17cec3da5cb4$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($d88e17cec3da5cb4$var$prefetchStyleLink));
}
async function $d88e17cec3da5cb4$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $d88e17cec3da5cb4$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $d88e17cec3da5cb4$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $d88e17cec3da5cb4$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $d88e17cec3da5cb4$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $d88e17cec3da5cb4$var$dedupeLinkDescriptors(links.flat(1).filter($d88e17cec3da5cb4$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $d88e17cec3da5cb4$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $d88e17cec3da5cb4$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $d88e17cec3da5cb4$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $d88e17cec3da5cb4$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $d88e17cec3da5cb4$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $d88e17cec3da5cb4$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$d88e17cec3da5cb4$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($d88e17cec3da5cb4$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $d88e17cec3da5cb4$var$_isPreloadSupported;
function $d88e17cec3da5cb4$var$isPreloadSupported() {
    if ($d88e17cec3da5cb4$var$_isPreloadSupported !== void 0) return $d88e17cec3da5cb4$var$_isPreloadSupported;
    let el = document.createElement("link");
    $d88e17cec3da5cb4$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $d88e17cec3da5cb4$var$_isPreloadSupported;
}
function $d88e17cec3da5cb4$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $d88e17cec3da5cb4$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $d88e17cec3da5cb4$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $d88e17cec3da5cb4$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $d88e17cec3da5cb4$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $d88e17cec3da5cb4$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RemixRootDefaultErrorBoundary, {
            error: $d88e17cec3da5cb4$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $d88e17cec3da5cb4$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $d88e17cec3da5cb4$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $d88e17cec3da5cb4$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$d88e17cec3da5cb4$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $d88e17cec3da5cb4$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $d88e17cec3da5cb4$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $d88e17cec3da5cb4$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $d88e17cec3da5cb4$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $d88e17cec3da5cb4$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $d88e17cec3da5cb4$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $d88e17cec3da5cb4$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $d88e17cec3da5cb4$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $d88e17cec3da5cb4$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $d88e17cec3da5cb4$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $d88e17cec3da5cb4$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $d88e17cec3da5cb4$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $d88e17cec3da5cb4$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$d88e17cec3da5cb4$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $d88e17cec3da5cb4$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $d88e17cec3da5cb4$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $d88e17cec3da5cb4$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $d88e17cec3da5cb4$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $d88e17cec3da5cb4$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $d88e17cec3da5cb4$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $d88e17cec3da5cb4$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $d88e17cec3da5cb4$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $d88e17cec3da5cb4$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $d88e17cec3da5cb4$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $d88e17cec3da5cb4$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $d88e17cec3da5cb4$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $d88e17cec3da5cb4$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $d88e17cec3da5cb4$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $d88e17cec3da5cb4$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $d88e17cec3da5cb4$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $d88e17cec3da5cb4$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $d88e17cec3da5cb4$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $d88e17cec3da5cb4$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $d88e17cec3da5cb4$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $d88e17cec3da5cb4$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $d88e17cec3da5cb4$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $d88e17cec3da5cb4$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $d88e17cec3da5cb4$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $d88e17cec3da5cb4$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $d88e17cec3da5cb4$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $d88e17cec3da5cb4$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $d88e17cec3da5cb4$var$nextPaths = /* @__PURE__ */ new Set();
var $d88e17cec3da5cb4$var$discoveredPathsMaxSize = 1e3;
var $d88e17cec3da5cb4$var$discoveredPaths = /* @__PURE__ */ new Set();
var $d88e17cec3da5cb4$export$b5915cf27fa06b9f = 7680;
function $d88e17cec3da5cb4$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $d88e17cec3da5cb4$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $d88e17cec3da5cb4$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $d88e17cec3da5cb4$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$d88e17cec3da5cb4$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($d88e17cec3da5cb4$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $d88e17cec3da5cb4$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $d88e17cec3da5cb4$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $d88e17cec3da5cb4$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$d88e17cec3da5cb4$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$d88e17cec3da5cb4$var$discoveredPaths.has(pathname)) $d88e17cec3da5cb4$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($d88e17cec3da5cb4$var$nextPaths.keys()).filter((path)=>{
                if ($d88e17cec3da5cb4$var$discoveredPaths.has(path)) {
                    $d88e17cec3da5cb4$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $d88e17cec3da5cb4$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $d88e17cec3da5cb4$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $d88e17cec3da5cb4$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $d88e17cec3da5cb4$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $d88e17cec3da5cb4$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $d88e17cec3da5cb4$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($d88e17cec3da5cb4$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $d88e17cec3da5cb4$export$b5915cf27fa06b9f) {
        $d88e17cec3da5cb4$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($d88e17cec3da5cb4$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($d88e17cec3da5cb4$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($d88e17cec3da5cb4$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$d88e17cec3da5cb4$var$addToFifoQueue(p, $d88e17cec3da5cb4$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $d88e17cec3da5cb4$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $d88e17cec3da5cb4$var$addToFifoQueue(path, queue) {
    if (queue.size >= $d88e17cec3da5cb4$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $d88e17cec3da5cb4$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $d88e17cec3da5cb4$var$useDataRouterContext2() {
    let context = $acw62.useContext($d88e17cec3da5cb4$export$2eeee58951ff3c1c);
    $d88e17cec3da5cb4$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $d88e17cec3da5cb4$var$useDataRouterStateContext() {
    let context = $acw62.useContext($d88e17cec3da5cb4$export$315e3ffb01f217);
    $d88e17cec3da5cb4$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $d88e17cec3da5cb4$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$d88e17cec3da5cb4$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $d88e17cec3da5cb4$var$useFrameworkContext() {
    let context = $acw62.useContext($d88e17cec3da5cb4$export$208d6a3bc3aa62bd);
    $d88e17cec3da5cb4$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $d88e17cec3da5cb4$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($d88e17cec3da5cb4$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $d88e17cec3da5cb4$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $d88e17cec3da5cb4$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $d88e17cec3da5cb4$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $d88e17cec3da5cb4$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $d88e17cec3da5cb4$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $d88e17cec3da5cb4$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $d88e17cec3da5cb4$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$d88e17cec3da5cb4$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $d88e17cec3da5cb4$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $d88e17cec3da5cb4$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $d88e17cec3da5cb4$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $d88e17cec3da5cb4$var$useDataRouterStateContext();
    let matches = $d88e17cec3da5cb4$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$d88e17cec3da5cb4$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$d88e17cec3da5cb4$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$d88e17cec3da5cb4$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$d88e17cec3da5cb4$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $d88e17cec3da5cb4$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $d88e17cec3da5cb4$var$useIsRSCRouterContext();
    let { router: router } = $d88e17cec3da5cb4$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$d88e17cec3da5cb4$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $d88e17cec3da5cb4$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $d88e17cec3da5cb4$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $d88e17cec3da5cb4$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $d88e17cec3da5cb4$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let { future: future } = $d88e17cec3da5cb4$var$useFrameworkContext();
    let { basename: basename } = $d88e17cec3da5cb4$var$useDataRouterContext2();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $d88e17cec3da5cb4$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $d88e17cec3da5cb4$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $d88e17cec3da5cb4$var$useFrameworkContext();
    let { basename: basename } = $d88e17cec3da5cb4$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $d88e17cec3da5cb4$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$d88e17cec3da5cb4$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$d88e17cec3da5cb4$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $d88e17cec3da5cb4$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$d88e17cec3da5cb4$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $d88e17cec3da5cb4$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $d88e17cec3da5cb4$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $d88e17cec3da5cb4$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $d88e17cec3da5cb4$var$useDataRouterStateContext();
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let _matches = $d88e17cec3da5cb4$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$d88e17cec3da5cb4$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $d88e17cec3da5cb4$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $d88e17cec3da5cb4$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $d88e17cec3da5cb4$var$isHydrated = false;
function $d88e17cec3da5cb4$export$3be068dde909e563() {
    $d88e17cec3da5cb4$var$isHydrated = true;
}
function $d88e17cec3da5cb4$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $d88e17cec3da5cb4$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $d88e17cec3da5cb4$var$useDataRouterContext2();
    let { matches: routerMatches } = $d88e17cec3da5cb4$var$useDataRouterStateContext();
    let isRSCRouterContext = $d88e17cec3da5cb4$var$useIsRSCRouterContext();
    let enableFogOfWar = $d88e17cec3da5cb4$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $d88e17cec3da5cb4$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $d88e17cec3da5cb4$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $d88e17cec3da5cb4$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($d88e17cec3da5cb4$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $d88e17cec3da5cb4$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($d88e17cec3da5cb4$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $d88e17cec3da5cb4$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $d88e17cec3da5cb4$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $d88e17cec3da5cb4$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $d88e17cec3da5cb4$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $d88e17cec3da5cb4$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($d88e17cec3da5cb4$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $d88e17cec3da5cb4$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $d88e17cec3da5cb4$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $d88e17cec3da5cb4$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$ff0bf87698939488, null) : null)));
}
var $d88e17cec3da5cb4$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($d88e17cec3da5cb4$var$isBrowser2) window.__reactRouterVersion = "7.15.1";
} catch (e) {}
function $d88e17cec3da5cb4$export$1f3f55432a00e06d(routes, opts) {
    return $d88e17cec3da5cb4$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $d88e17cec3da5cb4$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $d88e17cec3da5cb4$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $d88e17cec3da5cb4$export$9269a41d8c4635e,
        hydrationRouteProperties: $d88e17cec3da5cb4$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $d88e17cec3da5cb4$export$1ba7ed8a3a7b3765(routes, opts) {
    return $d88e17cec3da5cb4$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $d88e17cec3da5cb4$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $d88e17cec3da5cb4$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $d88e17cec3da5cb4$export$9269a41d8c4635e,
        hydrationRouteProperties: $d88e17cec3da5cb4$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $d88e17cec3da5cb4$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $d88e17cec3da5cb4$var$deserializeErrors(state.errors)
    };
    return state;
}
function $d88e17cec3da5cb4$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $d88e17cec3da5cb4$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $d88e17cec3da5cb4$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $d88e17cec3da5cb4$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $d88e17cec3da5cb4$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $d88e17cec3da5cb4$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $d88e17cec3da5cb4$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$d88e17cec3da5cb4$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $d88e17cec3da5cb4$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $d88e17cec3da5cb4$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $d88e17cec3da5cb4$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $d88e17cec3da5cb4$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $d88e17cec3da5cb4$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $d88e17cec3da5cb4$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $d88e17cec3da5cb4$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $d88e17cec3da5cb4$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$d88e17cec3da5cb4$export$a6c7ac8248d6e38a.displayName = "Link";
var $d88e17cec3da5cb4$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $d88e17cec3da5cb4$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($d88e17cec3da5cb4$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d88e17cec3da5cb4$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $d88e17cec3da5cb4$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$d88e17cec3da5cb4$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $d88e17cec3da5cb4$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $d88e17cec3da5cb4$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let submit = $d88e17cec3da5cb4$export$47c85c6e3a081d3();
    let formAction = $d88e17cec3da5cb4$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$d88e17cec3da5cb4$export$a7fed597f4b8afd8.displayName = "Form";
function $d88e17cec3da5cb4$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($d88e17cec3da5cb4$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let matches = $d88e17cec3da5cb4$export$2378eb7f5ff86053();
    $d88e17cec3da5cb4$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $d88e17cec3da5cb4$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$d88e17cec3da5cb4$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $d88e17cec3da5cb4$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$d88e17cec3da5cb4$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$d88e17cec3da5cb4$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $d88e17cec3da5cb4$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $d88e17cec3da5cb4$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($d88e17cec3da5cb4$export$2eeee58951ff3c1c);
    $d88e17cec3da5cb4$export$f5708dca728d7177(ctx, $d88e17cec3da5cb4$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $d88e17cec3da5cb4$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($d88e17cec3da5cb4$export$315e3ffb01f217);
    $d88e17cec3da5cb4$export$f5708dca728d7177(state, $d88e17cec3da5cb4$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $d88e17cec3da5cb4$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $d88e17cec3da5cb4$export$9770f232ac06a008();
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let path = $d88e17cec3da5cb4$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($d88e17cec3da5cb4$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $d88e17cec3da5cb4$export$fe53371bee54353d(location) === $d88e17cec3da5cb4$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $d88e17cec3da5cb4$export$f1a78c17382fe22a(defaultInit) {
    $d88e17cec3da5cb4$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($d88e17cec3da5cb4$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d88e17cec3da5cb4$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $d88e17cec3da5cb4$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d88e17cec3da5cb4$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $d88e17cec3da5cb4$var$fetcherId = 0;
var $d88e17cec3da5cb4$var$getUniqueFetcherId = ()=>`__${String(++$d88e17cec3da5cb4$var$fetcherId)}__`;
function $d88e17cec3da5cb4$export$47c85c6e3a081d3() {
    let { router: router } = $d88e17cec3da5cb4$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let currentRouteId = $d88e17cec3da5cb4$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d88e17cec3da5cb4$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d88e17cec3da5cb4$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $d88e17cec3da5cb4$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    $d88e17cec3da5cb4$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$d88e17cec3da5cb4$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $d88e17cec3da5cb4$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $d88e17cec3da5cb4$export$fe53371bee54353d(path);
}
function $d88e17cec3da5cb4$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $d88e17cec3da5cb4$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $d88e17cec3da5cb4$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($d88e17cec3da5cb4$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($d88e17cec3da5cb4$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $d88e17cec3da5cb4$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $d88e17cec3da5cb4$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $d88e17cec3da5cb4$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $d88e17cec3da5cb4$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $d88e17cec3da5cb4$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $d88e17cec3da5cb4$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $d88e17cec3da5cb4$export$fa996778a3a31087() {
    let state = $d88e17cec3da5cb4$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $acw62.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $d88e17cec3da5cb4$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $d88e17cec3da5cb4$var$savedScrollPositions = {};
function $d88e17cec3da5cb4$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $d88e17cec3da5cb4$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $d88e17cec3da5cb4$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $d88e17cec3da5cb4$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d88e17cec3da5cb4$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($d88e17cec3da5cb4$export$3044ab7fdabeaee6);
    let location = $d88e17cec3da5cb4$export$45d76561a5302f2b();
    let matches = $d88e17cec3da5cb4$export$2378eb7f5ff86053();
    let navigation = $d88e17cec3da5cb4$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $d88e17cec3da5cb4$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $d88e17cec3da5cb4$var$getScrollRestorationKey(location, matches, basename, getKey);
            $d88e17cec3da5cb4$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d88e17cec3da5cb4$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d88e17cec3da5cb4$var$savedScrollPositions));
        } catch (error) {
            $d88e17cec3da5cb4$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d88e17cec3da5cb4$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d88e17cec3da5cb4$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($d88e17cec3da5cb4$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$d88e17cec3da5cb4$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $d88e17cec3da5cb4$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $d88e17cec3da5cb4$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $d88e17cec3da5cb4$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $d88e17cec3da5cb4$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $d88e17cec3da5cb4$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $d88e17cec3da5cb4$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($d88e17cec3da5cb4$export$3681f408decb40d1);
    $d88e17cec3da5cb4$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $d88e17cec3da5cb4$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $d88e17cec3da5cb4$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $d88e17cec3da5cb4$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $d88e17cec3da5cb4$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $d88e17cec3da5cb4$export$81336c211d5ff295(path.pathname, nextPath) != null || $d88e17cec3da5cb4$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $d88e17cec3da5cb4$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $d88e17cec3da5cb4$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $d88e17cec3da5cb4$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $d88e17cec3da5cb4$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $d88e17cec3da5cb4$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $d88e17cec3da5cb4$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $d88e17cec3da5cb4$var$serializeErrors(context.errors)
        };
        let json = $d88e17cec3da5cb4$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($d88e17cec3da5cb4$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $d88e17cec3da5cb4$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($d88e17cec3da5cb4$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $d88e17cec3da5cb4$var$getStatelessNavigator() {
    return {
        createHref: $d88e17cec3da5cb4$var$createHref,
        encodeLocation: $d88e17cec3da5cb4$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $d88e17cec3da5cb4$export$69163f0b72ec60d9(routes, opts) {
    return $d88e17cec3da5cb4$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $d88e17cec3da5cb4$export$9269a41d8c4635e
    });
}
function $d88e17cec3da5cb4$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $d88e17cec3da5cb4$export$87cb1a9238dc3fba(routes, $d88e17cec3da5cb4$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $d88e17cec3da5cb4$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $d88e17cec3da5cb4$var$createHref,
        encodeLocation: $d88e17cec3da5cb4$var$encodeLocation,
        getFetcher () {
            return $d88e17cec3da5cb4$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $d88e17cec3da5cb4$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $d88e17cec3da5cb4$var$createHref(to) {
    return typeof to === "string" ? to : $d88e17cec3da5cb4$export$fe53371bee54353d(to);
}
function $d88e17cec3da5cb4$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $d88e17cec3da5cb4$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $d88e17cec3da5cb4$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $d773e80e0af5ed8a$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $484aedf5a2e0ad16$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$defaultContext);
const $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$SSRContext);
    let counter = $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useCounter(cur === $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $d8a6de909e063b29$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$defaultContext && $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$canUseDOM;
    let counter = $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($d8a6de909e063b29$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $d8a6de909e063b29$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function' ? $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $d8a6de909e063b29$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore']($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$subscribe, $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$getSnapshot, $d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($d8a6de909e063b29$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $929ec773c0d051c0$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    // Keep an up to date copy of value in a ref so we can access the current value in the generator.
    // This allows us to maintain a stable queue function.
    let currValue = (0, $acw62.useRef)(value);
    let effect = (0, $acw62.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $acw62.useRef)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (currValue.current === newValue.value) nextRef.current();
        else setValue(newValue.value);
    });
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        currValue.current = value;
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (0, $acw62.useCallback)((fn)=>{
        effect.current = fn(currValue.current);
        nextRef.current();
    }, [
        nextRef
    ]);
    return [
        value,
        queue
    ];
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $3af2a5641bd71461$var$$390e54f620492c70$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $3af2a5641bd71461$export$d41a04c74483c6ef = new Map();
// This allows us to clean up the idsUpdaterMap when the id is no longer used.
// Map is a strong reference, so unused ids wouldn't be cleaned up otherwise.
// This can happen in suspended components where mount/unmount is not called.
let $3af2a5641bd71461$var$$390e54f620492c70$var$registry;
if (typeof FinalizationRegistry !== 'undefined') $3af2a5641bd71461$var$$390e54f620492c70$var$registry = new FinalizationRegistry((heldValue)=>{
    $3af2a5641bd71461$export$d41a04c74483c6ef.delete(heldValue);
});
function $3af2a5641bd71461$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $d8a6de909e063b29$export$619500959fc48b26)(value);
    let cleanupRef = (0, $acw62.useRef)(null);
    if ($3af2a5641bd71461$var$$390e54f620492c70$var$registry) $3af2a5641bd71461$var$$390e54f620492c70$var$registry.register(cleanupRef, res);
    if ($3af2a5641bd71461$var$$390e54f620492c70$var$canUseDOM) {
        const cacheIdRef = $3af2a5641bd71461$export$d41a04c74483c6ef.get(res);
        if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
        else $3af2a5641bd71461$export$d41a04c74483c6ef.set(res, [
            nextId
        ]);
    }
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            // In Suspense, the cleanup function may be not called
            // when it is though, also remove it from the finalization registry.
            if ($3af2a5641bd71461$var$$390e54f620492c70$var$registry) $3af2a5641bd71461$var$$390e54f620492c70$var$registry.unregister(cleanupRef);
            $3af2a5641bd71461$export$d41a04c74483c6ef.delete(r);
        };
    }, [
        res
    ]);
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) setValue(newId);
        return ()=>{
            if (newId) nextId.current = null;
        };
    });
    return res;
}
function $3af2a5641bd71461$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdsA = $3af2a5641bd71461$export$d41a04c74483c6ef.get(idA);
    if (setIdsA) {
        setIdsA.forEach((ref)=>ref.current = idB);
        return idB;
    }
    let setIdsB = $3af2a5641bd71461$export$d41a04c74483c6ef.get(idB);
    if (setIdsB) {
        setIdsB.forEach((ref)=>ref.current = idA);
        return idA;
    }
    return idB;
}
function $3af2a5641bd71461$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $3af2a5641bd71461$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $929ec773c0d051c0$export$14d238f342723f25)(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $eed06c8362986bd2$export$c9058316764c140e(...refs) {
    if (refs.length === 1 && refs[0]) return refs[0];
    return (value)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $eed06c8362986bd2$var$$4064df0d6f9620e1$var$setRef(ref, value);
            hasCleanup ||= typeof cleanup == 'function';
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            cleanups.forEach((cleanup, i)=>{
                if (typeof cleanup === 'function') cleanup();
                else $eed06c8362986bd2$var$$4064df0d6f9620e1$var$setRef(refs[i], null);
            });
        };
    };
}
function $eed06c8362986bd2$var$$4064df0d6f9620e1$var$setRef(ref, value) {
    if (typeof ref === 'function') return ref(value);
    else if (ref != null) ref.current = value;
}


function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $195af97314dd822a$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(a, b);
            else if (key === 'id' && a && b) result.id = (0, $3af2a5641bd71461$export$cd8c9cb68f842629)(a, b);
            else if (key === 'ref' && a && b) result.ref = (0, $eed06c8362986bd2$export$c9058316764c140e)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0231fe790c02c958$export$4338b53315abf666(ref) {
    const objRef = (0, $acw62.useRef)(null);
    const cleanupRef = (0, $acw62.useRef)(undefined);
    const refEffect = (0, $acw62.useCallback)((instance)=>{
        if (typeof ref === 'function') {
            const refCallback = ref;
            const refCleanup = refCallback(instance);
            return ()=>{
                if (typeof refCleanup === 'function') refCleanup();
                else refCallback(null);
            };
        } else if (ref) {
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        }
    }, [
        ref
    ]);
    return (0, $acw62.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (cleanupRef.current) {
                    cleanupRef.current();
                    cleanupRef.current = undefined;
                }
                if (value != null) cleanupRef.current = refEffect(value);
            }
        }), [
        refEffect
    ]);
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $78f7e4721048d8d5$export$c62b8e45d58ddad9 = Symbol('default');
function $78f7e4721048d8d5$export$2881499e37b75b9a({ values: values, children: children }) {
    for (let [Context, value] of values)children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: value
    }, children);
    return children;
}
function $78f7e4721048d8d5$export$4d86445c2cf5e3(props) {
    let { className: className, style: style, children: children, defaultClassName: defaultClassName, defaultChildren: defaultChildren, defaultStyle: defaultStyle, values: values, render: render } = props;
    return (0, $acw62.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === 'function') computedClassName = className({
            ...values,
            defaultClassName: defaultClassName
        });
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style({
            ...values,
            defaultStyle: defaultStyle || {}
        });
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children({
            ...values,
            defaultChildren: defaultChildren
        });
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName ?? defaultClassName,
            style: computedStyle || defaultStyle ? {
                ...defaultStyle,
                ...computedStyle
            } : undefined,
            children: computedChildren ?? defaultChildren,
            'data-rac': '',
            render: render ? (props)=>render(props, values) : undefined
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values,
        render
    ]);
}
function $78f7e4721048d8d5$export$c245e6201fed2f75(value, wrap) {
    return (renderProps)=>wrap(typeof value === 'function' ? value(renderProps) : value, renderProps);
}
function $78f7e4721048d8d5$export$fabf2dc03a41866e(context, slot) {
    let ctx = (0, $acw62.useContext)(context);
    if (slot === null) return null;
    if (ctx && typeof ctx === 'object' && 'slots' in ctx && ctx.slots) {
        let slotKey = slot || $78f7e4721048d8d5$export$c62b8e45d58ddad9;
        if (!ctx.slots[slotKey]) {
            let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p)=>`"${p}"`));
            let errorMessage = slot ? `Invalid slot "${slot}".` : 'A slot prop is required.';
            throw new Error(`${errorMessage} Valid slot names are ${availableSlots}.`);
        }
        return ctx.slots[slotKey];
    }
    // @ts-ignore
    return ctx;
}
function $78f7e4721048d8d5$export$29f1550f4b0d4415(props, ref, context) {
    let ctx = $78f7e4721048d8d5$export$fabf2dc03a41866e(context, props.slot) || {};
    let { ref: contextRef, ...contextProps } = ctx;
    let mergedRef = (0, $0231fe790c02c958$export$4338b53315abf666)((0, $acw62.useMemo)(()=>(0, $eed06c8362986bd2$export$c9058316764c140e)(ref, contextRef), [
        ref,
        contextRef
    ]));
    let mergedProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(contextProps, props);
    // mergeProps does not merge `style`. Adding this there might be a breaking change.
    if ('style' in contextProps && contextProps.style && 'style' in props && props.style) {
        if (typeof contextProps.style === 'function' || typeof props.style === 'function') mergedProps.style = (renderProps)=>{
            let contextStyle = typeof contextProps.style === 'function' ? contextProps.style(renderProps) : contextProps.style;
            let defaultStyle = {
                ...renderProps.defaultStyle,
                ...contextStyle
            };
            let style = typeof props.style === 'function' ? props.style({
                ...renderProps,
                defaultStyle: defaultStyle
            }) : props.style;
            return {
                ...defaultStyle,
                ...style
            };
        };
        else mergedProps.style = {
            ...contextProps.style,
            ...props.style
        };
    }
    return [
        mergedProps,
        mergedRef
    ];
}
function $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8(initialState = true) {
    // Initial state is typically based on the parent having an aria-label or aria-labelledby.
    // If it does, this value should be false so that we don't update the state and cause a rerender when we go through the layoutEffect
    let [hasSlot, setHasSlot] = (0, $acw62.useState)(initialState);
    let hasRun = (0, $acw62.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    let ref = (0, $acw62.useCallback)((el)=>{
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function $78f7e4721048d8d5$export$ef03459518577ad4(props) {
    const prefix = /^(data-.*)$/;
    let filteredProps = {};
    for(const prop in props)if (!prefix.test(prop)) filteredProps[prop] = props[prop];
    return filteredProps;
}
function $78f7e4721048d8d5$var$$7230ffa83bc0c2cf$var$DOMElement(ElementType, props, forwardedRef) {
    let { render: render, ...otherProps } = props;
    let elementRef = (0, $acw62.useRef)(null);
    let ref = (0, $acw62.useMemo)(()=>(0, $eed06c8362986bd2$export$c9058316764c140e)(forwardedRef, elementRef), [
        forwardedRef,
        elementRef
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{}, [
        ElementType,
        render
    ]);
    let domProps = {
        ...otherProps,
        ref: ref
    };
    if (render) return render(domProps, undefined);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, domProps);
}
const $78f7e4721048d8d5$var$$7230ffa83bc0c2cf$var$domComponentCache = {};
const $78f7e4721048d8d5$export$df3a06d6289f983e = new Proxy({}, {
    get (target, elementType) {
        if (typeof elementType !== 'string') return undefined;
        let res = $78f7e4721048d8d5$var$$7230ffa83bc0c2cf$var$domComponentCache[elementType];
        if (!res) {
            res = (0, $acw62.forwardRef)($78f7e4721048d8d5$var$$7230ffa83bc0c2cf$var$DOMElement.bind(null, elementType));
            $78f7e4721048d8d5$var$$7230ffa83bc0c2cf$var$domComponentCache[elementType] = res;
        }
        return res;
    }
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React doesn't understand the <template> element, which doesn't have children like a normal element.
// It will throw an error during hydration when it expects the firstChild to contain content rendered
// on the server, when in reality, the browser will have placed this inside the `content` document fragment.
// This monkey patches the firstChild property for our special hidden template elements to work around this error.
// does the same for appendChild/removeChild/insertBefore as per the issue below
// See https://github.com/facebook/react/issues/19932
if (typeof HTMLTemplateElement !== 'undefined') {
    Object.defineProperty(HTMLTemplateElement.prototype, 'firstChild', {
        configurable: true,
        enumerable: true,
        get: function() {
            return this.content.firstChild;
        }
    });
    Object.defineProperty(HTMLTemplateElement.prototype, 'appendChild', {
        configurable: true,
        enumerable: true,
        value: function(node) {
            return this.content.appendChild(node);
        }
    });
    Object.defineProperty(HTMLTemplateElement.prototype, 'removeChild', {
        configurable: true,
        enumerable: true,
        value: function(node) {
            return this.content.removeChild(node);
        }
    });
    Object.defineProperty(HTMLTemplateElement.prototype, 'insertBefore', {
        configurable: true,
        enumerable: true,
        value: function(node, child) {
            return this.content.insertBefore(node, child);
        }
    });
}
const $ffa0afb9817175b6$export$94b6d0abf7d33e8c = (0, $acw62.createContext)(false);
function $ffa0afb9817175b6$export$8dc98ba7eadeaa56(props) {
    let isHidden = (0, $acw62.useContext)($ffa0afb9817175b6$export$94b6d0abf7d33e8c);
    if (isHidden) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    let children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ffa0afb9817175b6$export$94b6d0abf7d33e8c.Provider, {
        value: true
    }, props.children);
    // In SSR, portals are not supported by React. Instead, always render into a <template>
    // element, which the browser will never display to the user. In addition, the
    // content is not part of the accessible DOM tree, so it won't affect ids or other accessibility attributes.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("template", null, children);
}
function $ffa0afb9817175b6$export$86427a43e3e48ebb(fn) {
    let Wrapper = (props, ref)=>{
        let isHidden = (0, $acw62.useContext)($ffa0afb9817175b6$export$94b6d0abf7d33e8c);
        if (isHidden) return null;
        return fn(props, ref);
    };
    // @ts-ignore - for react dev tools
    Wrapper.displayName = fn.displayName || fn.name;
    return (0, $acw62.forwardRef)(Wrapper);
}
function $ffa0afb9817175b6$export$b5d7cc18bb8d2b59() {
    return (0, $acw62.useContext)($ffa0afb9817175b6$export$94b6d0abf7d33e8c);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $aaf42248096e4ba7$export$75b6ee27786ba447 = (0, $acw62.createContext)({});
const $aaf42248096e4ba7$export$b04be29aa201d4f5 = (0, $ffa0afb9817175b6$export$86427a43e3e48ebb)(function Label(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $aaf42248096e4ba7$export$75b6ee27786ba447);
    let { elementType: elementType = 'label', ...labelProps } = props;
    let ElementType = (0, $78f7e4721048d8d5$export$df3a06d6289f983e)[elementType];
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        className: "react-aria-Label",
        ...labelProps,
        ref: ref
    });
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$DOMPropNames = new Set([
    'id'
]);
const $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
// See LinkDOMProps in dom.d.ts.
const $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$linkPropNames = new Set([
    'href',
    'hrefLang',
    'target',
    'rel',
    'download',
    'ping',
    'referrerPolicy'
]);
const $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$globalAttrs = new Set([
    'dir',
    'lang',
    'hidden',
    'inert',
    'translate'
]);
const $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$globalEvents = new Set([
    'onClick',
    'onAuxClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onScroll',
    'onWheel',
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration',
    'onTransitionCancel',
    'onTransitionEnd',
    'onTransitionRun',
    'onTransitionStart'
]);
const $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$propRe = /^(data-.*)$/;
function $c5a0f9cfef525171$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, global: global, events: events = global, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$DOMPropNames.has(prop) || labelable && $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$labelablePropNames.has(prop) || isLink && $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$linkPropNames.has(prop) || global && $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$globalAttrs.has(prop) || events && ($c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$globalEvents.has(prop) || prop.endsWith('Capture') && $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$globalEvents.has(prop.slice(0, -7))) || propNames?.has(prop) || $c5a0f9cfef525171$var$$8e9d2fae0ecb9001$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d00c1960ddd60c91$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, 'aria-label': label, 'aria-labelledby': labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $3af2a5641bd71461$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f5e6258447762a7e$export$8467354a121f1b9f(props) {
    let { id: id, label: label, 'aria-labelledby': ariaLabelledby, 'aria-label': ariaLabel, labelElementType: labelElementType = 'label' } = props;
    id = (0, $3af2a5641bd71461$export$f680877a34711e37)(id);
    let labelId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else !ariaLabelledby && ariaLabel;
    let fieldProps = (0, $d00c1960ddd60c91$export$d6875122194c7b44)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $a59d57ae38d5ccaa$var$$d805ff57cab8bee2$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
const $a59d57ae38d5ccaa$var$$d805ff57cab8bee2$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $a59d57ae38d5ccaa$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === 'rtl';
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $a59d57ae38d5ccaa$var$$d805ff57cab8bee2$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split('-')[0];
    return $a59d57ae38d5ccaa$var$$d805ff57cab8bee2$var$RTL_LANGS.has(lang);
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $3d8ab49f2e80d1ad$export$f09106e7c6677ec5() {
    let locale = typeof window !== 'undefined' && window[$3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$localeSymbol] || typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: (0, $a59d57ae38d5ccaa$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
    };
}
let $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$currentLocale = $3d8ab49f2e80d1ad$export$f09106e7c6677ec5();
let $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$listeners = new Set();
function $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$updateLocale() {
    $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$currentLocale = $3d8ab49f2e80d1ad$export$f09106e7c6677ec5();
    for (let listener of $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$listeners)listener($3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$currentLocale);
}
function $3d8ab49f2e80d1ad$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $d8a6de909e063b29$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $acw62.useState)($3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$currentLocale);
    (0, $acw62.useEffect)(()=>{
        if ($3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$listeners.size === 0) window.addEventListener('languagechange', $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$updateLocale);
        $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$listeners.add(setDefaultLocale);
        return ()=>{
            $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$listeners.delete(setDefaultLocale);
            if ($3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$listeners.size === 0) window.removeEventListener('languagechange', $3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) {
        let locale = typeof window !== 'undefined' && window[$3d8ab49f2e80d1ad$var$$520a025cdb0d710d$var$localeSymbol];
        return {
            locale: locale || 'en-US',
            direction: 'ltr'
        };
    }
    return defaultLocale;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * Internal component that handles the case when locale is provided.
 */ function $e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithLocale(props) {
    let { locale: locale, children: children } = props;
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            locale: locale,
            direction: (0, $a59d57ae38d5ccaa$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
        }), [
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nContext.Provider, {
        value: value
    }, children);
}
/**
 * Internal component that handles the case when no locale is provided.
 */ function $e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithDefaultLocale(props) {
    let { children: children } = props;
    let defaultLocale = (0, $3d8ab49f2e80d1ad$export$188ec29ebc2bdc3a)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nContext.Provider, {
        value: defaultLocale
    }, children);
}
function $e9bafae0aa65a2d3$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    // Conditionally render different components to avoid calling useDefaultLocale.
    // This is necessary because useDefaultLocale triggers a re-render.
    if (locale) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithLocale, {
        locale: locale,
        children: children
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithDefaultLocale, {
        children: children
    });
}
function $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $3d8ab49f2e80d1ad$export$188ec29ebc2bdc3a)();
    let context = (0, $acw62.useContext)($e9bafae0aa65a2d3$var$$2eb8e6d23f3d0cb0$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $baa35843f774415a$var$$1dfb119a85e764e5$var$formatterCache = new Map();
let $baa35843f774415a$var$$1dfb119a85e764e5$var$supportsSignDisplay = false;
try {
    $baa35843f774415a$var$$1dfb119a85e764e5$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
        signDisplay: 'exceptZero'
    }).resolvedOptions().signDisplay === 'exceptZero';
// eslint-disable-next-line no-empty
} catch  {}
let $baa35843f774415a$var$$1dfb119a85e764e5$var$supportsUnit = false;
try {
    $baa35843f774415a$var$$1dfb119a85e764e5$var$supportsUnit = new Intl.NumberFormat('de-DE', {
        style: 'unit',
        unit: 'degree'
    }).resolvedOptions().style === 'unit';
// eslint-disable-next-line no-empty
} catch  {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $baa35843f774415a$var$$1dfb119a85e764e5$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            'ja-JP': " \u5EA6",
            'zh-TW': "\u5EA6",
            'sl-SI': " \xb0"
        }
    }
};
class $baa35843f774415a$export$cc77c4ff7e8673c5 {
    constructor(locale, options = {}){
        this.numberFormatter = $baa35843f774415a$var$$1dfb119a85e764e5$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = '';
        if (!$baa35843f774415a$var$$1dfb119a85e764e5$var$supportsSignDisplay && this.options.signDisplay != null) res = $baa35843f774415a$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === 'unit' && !$baa35843f774415a$var$$1dfb119a85e764e5$var$supportsUnit) {
            let { unit: unit, unitDisplay: unitDisplay = 'short', locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = $baa35843f774415a$var$$1dfb119a85e764e5$var$UNITS[unit]?.[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        if (typeof this.numberFormatter.formatRange === 'function') return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        if (typeof this.numberFormatter.formatRangeToParts === 'function') return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$baa35843f774415a$var$$1dfb119a85e764e5$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$baa35843f774415a$var$$1dfb119a85e764e5$var$supportsUnit && this.options.style === 'unit') options = {
            ...options,
            style: 'unit',
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
}
function $baa35843f774415a$var$$1dfb119a85e764e5$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes('-nu-')) {
        if (!locale.includes('-u-')) locale += '-u-';
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === 'unit' && !$baa35843f774415a$var$$1dfb119a85e764e5$var$supportsUnit) {
        let { unit: unit, unitDisplay: unitDisplay = 'short' } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!$baa35843f774415a$var$$1dfb119a85e764e5$var$UNITS[unit]?.[unitDisplay]) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: 'decimal'
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($baa35843f774415a$var$$1dfb119a85e764e5$var$formatterCache.has(cacheKey)) return $baa35843f774415a$var$$1dfb119a85e764e5$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $baa35843f774415a$var$$1dfb119a85e764e5$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $baa35843f774415a$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === 'auto') return numberFormat.format(num);
    else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === 'exceptZero') {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
            if ([
                ...minus
            ].length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
            let positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4878a8fda89cfc79$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    return (0, $acw62.useMemo)(()=>new (0, $baa35843f774415a$export$cc77c4ff7e8673c5)(locale, options), [
        locale,
        options
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $0aebee02c692839a$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $0aebee02c692839a$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let precision = 0;
    let stepString = step.toString();
    // Handle negative exponents in exponential notation (e.g., "1e-7" → precision 8)
    let eIndex = stepString.toLowerCase().indexOf('e-');
    if (eIndex > 0) precision = Math.abs(Math.floor(Math.log10(Math.abs(step)))) + eIndex;
    else {
        let pointIndex = stepString.indexOf('.');
        if (pointIndex >= 0) precision = stepString.length - pointIndex;
    }
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $0aebee02c692839a$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $0aebee02c692839a$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($0aebee02c692839a$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($0aebee02c692839a$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $0aebee02c692839a$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $0aebee02c692839a$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6375b6c06748f80c$export$ed5abd763a836edc(props) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, valueLabel: valueLabel, isIndeterminate: isIndeterminate, formatOptions: formatOptions = {
        style: 'percent'
    } } = props;
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $f5e6258447762a7e$export$8467354a121f1b9f)({
        ...props,
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    value = (0, $0aebee02c692839a$export$7d15b64cf5a3a4c4)(value, minValue, maxValue);
    let percentage = (value - minValue) / (maxValue - minValue);
    let formatter = (0, $4878a8fda89cfc79$export$b7a616150fdb9f44)(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        let valueToFormat = formatOptions.style === 'percent' ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            ...fieldProps,
            'aria-valuenow': isIndeterminate ? undefined : value,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-valuetext': isIndeterminate ? undefined : valueLabel,
            role: 'progressbar'
        }),
        labelProps: labelProps
    };
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $74f2e87e59c34f9e$export$e9f3bf65a26ce129 = (0, $acw62.createContext)(null);
const $74f2e87e59c34f9e$export$c17561cb55d4db30 = (0, $acw62.forwardRef)(function ProgressBar(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $74f2e87e59c34f9e$export$e9f3bf65a26ce129);
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, isIndeterminate: isIndeterminate = false } = props;
    value = (0, $0aebee02c692839a$export$7d15b64cf5a3a4c4)(value, minValue, maxValue);
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { progressBarProps: progressBarProps, labelProps: labelProps } = (0, $6375b6c06748f80c$export$ed5abd763a836edc)({
        ...props,
        label: label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = isIndeterminate ? undefined : (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-ProgressBar',
        values: {
            percentage: percentage,
            valueText: progressBarProps['aria-valuetext'],
            isIndeterminate: isIndeterminate
        }
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, progressBarProps),
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aaf42248096e4ba7$export$75b6ee27786ba447).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: 'span'
        }
    }, renderProps.children));
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer = null;
function $1c9c0beddd9981ff$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer) {
        $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer = new $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$LiveAnnouncer();
        // wait for the live announcer regions to be added to the dom, then announce
        // otherwise Safari won't announce the message if it's added too quickly
        // found most times less than 100ms were not consistent when announcing with Safari
        // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
        // https://github.com/reactwg/react-18/discussions/102
        // if we're in a test environment, announce without waiting
        // @ts-ignore
        if (!(typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined')) setTimeout(()=>{
            if ($1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer?.isAttached()) $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer?.announce(message, assertiveness, timeout);
        }, 100);
        else $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer.announce(message, assertiveness, timeout);
    } else $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $1c9c0beddd9981ff$export$d10ae4f68404609a(assertiveness) {
    if ($1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer) $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer.clear(assertiveness);
}
function $1c9c0beddd9981ff$export$d8686216b8b81b2f() {
    if ($1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer) {
        $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer.destroy();
        $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$LiveAnnouncer {
    constructor(){
        this.node = null;
        this.assertiveLog = null;
        this.politeLog = null;
        if (typeof document !== 'undefined') {
            this.node = document.createElement('div');
            this.node.dataset.liveAnnouncer = 'true';
            // copied from VisuallyHidden
            Object.assign(this.node.style, {
                border: 0,
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap'
            });
            this.assertiveLog = this.createLog('assertive');
            this.node.appendChild(this.assertiveLog);
            this.politeLog = this.createLog('polite');
            this.node.appendChild(this.politeLog);
            document.body.prepend(this.node);
        }
    }
    isAttached() {
        return this.node?.isConnected;
    }
    createLog(ariaLive) {
        let node = document.createElement('div');
        node.setAttribute('role', 'log');
        node.setAttribute('aria-live', ariaLive);
        node.setAttribute('aria-relevant', 'additions');
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = 'assertive', timeout = $1c9c0beddd9981ff$var$$a46cf152bb926da5$var$LIVEREGION_TIMEOUT_DELAY) {
        if (!this.node) return;
        let node = document.createElement('div');
        if (typeof message === 'object') {
            // To read an aria-labelledby, the element must have an appropriate role, such as img.
            node.setAttribute('role', 'img');
            node.setAttribute('aria-labelledby', message['aria-labelledby']);
        } else node.textContent = message;
        if (assertiveness === 'assertive') this.assertiveLog?.appendChild(node);
        else this.politeLog?.appendChild(node);
        if (message !== '') setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if ((!assertiveness || assertiveness === 'assertive') && this.assertiveLog) this.assertiveLog.innerHTML = '';
        if ((!assertiveness || assertiveness === 'polite') && this.politeLog) this.politeLog.innerHTML = '';
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1f6f9bb93c82bcb3$export$de79e2c695e052f3(element) {
    if ($1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$getScrollableElements(element);
        element.focus();
        $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$restoreScrollPosition(scrollableElements);
    }
}
let $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScrollCached = null;
function $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScroll() {
    if ($1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScrollCached == null) {
        $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch  {
        // Ignore
        }
    }
    return $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$supportsPreventScrollCached;
}
function $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $1f6f9bb93c82bcb3$var$$1969ac565cfec8d0$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}


const $c8e82650210ecd78$export$b204af158042fbac = (el)=>{
    return el?.ownerDocument ?? document;
};
const $c8e82650210ecd78$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $c8e82650210ecd78$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/**
 * Type guard that checks if a value is a Node. Verifies the presence and type of the nodeType property.
 */ function $c8e82650210ecd78$var$$d447af545b77c9f1$var$isNode(value) {
    return value !== null && typeof value === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
function $c8e82650210ecd78$export$af51f0f06c0f328a(node) {
    return $c8e82650210ecd78$var$$d447af545b77c9f1$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'host' in node;
}


/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $b1f0b06c417727c2$var$$6a20a7989e6c817a$var$_tableNestedRows = false;
let $b1f0b06c417727c2$var$$6a20a7989e6c817a$var$_shadowDOM = false;
function $b1f0b06c417727c2$export$d9d8a0f82de49530() {
    $b1f0b06c417727c2$var$$6a20a7989e6c817a$var$_tableNestedRows = true;
}
function $b1f0b06c417727c2$export$1b00cb14a96194e6() {
    return $b1f0b06c417727c2$var$$6a20a7989e6c817a$var$_tableNestedRows;
}
function $b1f0b06c417727c2$export$12b151d9882e9985() {
    $b1f0b06c417727c2$var$$6a20a7989e6c817a$var$_shadowDOM = true;
}
function $b1f0b06c417727c2$export$98658e8c59125e6a() {
    return $b1f0b06c417727c2$var$$6a20a7989e6c817a$var$_shadowDOM;
}


// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
/* eslint-disable rsp-rules/no-non-shadow-contains, rsp-rules/safe-event-target */ function $8fd85525b97849bf$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode !== null){
        if (currentNode === node) return true;
        if (currentNode.tagName === 'SLOT' && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $c8e82650210ecd78$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
const $8fd85525b97849bf$export$cd4e5573fbe2b576 = (doc = document)=>{
    if (!(0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) return doc.activeElement;
    let activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && activeElement.shadowRoot?.activeElement)activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $8fd85525b97849bf$export$e58f029f0fbfdb29(event) {
    if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)() && event.target instanceof Element && event.target.shadowRoot) {
        if ('composedPath' in event) return event.composedPath()[0] ?? null;
        else if ('composedPath' in event.nativeEvent) return event.nativeEvent.composedPath()[0] ?? null;
    }
    return event.target;
}
function $8fd85525b97849bf$export$b4f377a2b6254582(node) {
    if (!node) return false;
    // Get the active element within the node's parent shadow root (or the document). Can return null.
    let root = node.getRootNode();
    let ownerWindow = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(node);
    if (!(root instanceof ownerWindow.Document || root instanceof ownerWindow.ShadowRoot)) return false;
    let activeElement = root.activeElement;
    // Check if the active element is within this node. These nodes are within the same shadow root.
    return activeElement != null && node.contains(activeElement);
}








/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $592f2da4382028a0$var$$ae77152785188400$var$supportsCheckVisibility = typeof Element !== 'undefined' && 'checkVisibility' in Element.prototype;
function $592f2da4382028a0$var$$ae77152785188400$var$isStyleVisible(element) {
    const windowObject = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $592f2da4382028a0$var$$ae77152785188400$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $592f2da4382028a0$export$e989c0fffaa6b27a(element, childElement) {
    if ($592f2da4382028a0$var$$ae77152785188400$var$supportsCheckVisibility) return element.checkVisibility({
        visibilityProperty: true
    }) && !element.closest('[data-react-aria-prevent-focus]');
    return element.nodeName !== '#comment' && $592f2da4382028a0$var$$ae77152785188400$var$isStyleVisible(element) && $592f2da4382028a0$var$$ae77152785188400$var$isAttributeVisible(element, childElement) && (!element.parentElement || $592f2da4382028a0$export$e989c0fffaa6b27a(element.parentElement, element));
}


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])',
    'permission'
];
const $aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$FOCUSABLE_ELEMENT_SELECTOR = $aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$TABBABLE_ELEMENT_SELECTOR = $aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $aa0a68d418bbb48e$export$4c063cf1350e6fed(element, options) {
    return element.matches($aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$FOCUSABLE_ELEMENT_SELECTOR) && !$aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$isInert(element) && (options?.skipVisibilityCheck || (0, $592f2da4382028a0$export$e989c0fffaa6b27a)(element));
}
function $aa0a68d418bbb48e$export$bebd5a1431fec25d(element) {
    return element.matches($aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$TABBABLE_ELEMENT_SELECTOR) && (0, $592f2da4382028a0$export$e989c0fffaa6b27a)(element) && !$aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$isInert(element);
}
function $aa0a68d418bbb48e$var$$3b8b240c1bf84ab9$var$isInert(element) {
    let node = element;
    while(node != null){
        if (node instanceof node.ownerDocument.defaultView.HTMLElement && node.inert) return true;
        node = node.parentElement;
    }
    return false;
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7249d88549c99f1a$export$525bc4921d56d4a(nativeEvent) {
    let event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = ()=>event.defaultPrevented;
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = ()=>event.cancelBubble;
    event.persist = ()=>{};
    return event;
}
function $7249d88549c99f1a$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $7249d88549c99f1a$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (eventTarget instanceof HTMLButtonElement || eventTarget instanceof HTMLInputElement || eventTarget instanceof HTMLTextAreaElement || eventTarget instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = eventTarget;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    let event = $7249d88549c99f1a$export$525bc4921d56d4a(e);
                    onBlur?.(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    stateRef.current.observer?.disconnect();
                    let relatedTargetEl = target === (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)() ? null : (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        onBlur
    ]);
}
let $7249d88549c99f1a$export$fda7da73ab5d4c48 = false;
function $7249d88549c99f1a$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $aa0a68d418bbb48e$export$4c063cf1350e6fed)(target, {
        skipVisibilityCheck: true
    }))target = target.parentElement;
    let window = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(target);
    let activeElement = window.document.activeElement;
    if (!activeElement || activeElement === target) return;
    $7249d88549c99f1a$export$fda7da73ab5d4c48 = true;
    let isRefocusing = false;
    let onBlur = (e)=>{
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === activeElement || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusOut = (e)=>{
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === activeElement || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    let onFocus = (e)=>{
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === target || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusIn = (e)=>{
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === target || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    window.addEventListener('blur', onBlur, true);
    window.addEventListener('focusout', onFocusOut, true);
    window.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('focus', onFocus, true);
    let cleanup = ()=>{
        cancelAnimationFrame(raf);
        window.removeEventListener('blur', onBlur, true);
        window.removeEventListener('focusout', onFocusOut, true);
        window.removeEventListener('focusin', onFocusIn, true);
        window.removeEventListener('focus', onFocus, true);
        $7249d88549c99f1a$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    let raf = requestAnimationFrame(cleanup);
    return cleanup;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testUserAgent(re) {
    if (typeof window === 'undefined' || window.navigator == null) return false;
    let brands = window.navigator['userAgentData']?.brands;
    return Array.isArray(brands) && brands.some((brand)=>re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $dd0d4fc527b0735d$export$9ac100e40613ea10 = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testPlatform(/^Mac/i);
});
const $dd0d4fc527b0735d$export$186c6964ca17d99 = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testPlatform(/^iPhone/i);
});
const $dd0d4fc527b0735d$export$7bef049ce92e4224 = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $dd0d4fc527b0735d$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $dd0d4fc527b0735d$export$fedb369cb70207f1 = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$export$186c6964ca17d99() || $dd0d4fc527b0735d$export$7bef049ce92e4224();
});
const $dd0d4fc527b0735d$export$e1865c3bedcd822b = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$export$9ac100e40613ea10() || $dd0d4fc527b0735d$export$fedb369cb70207f1();
});
const $dd0d4fc527b0735d$export$78551043582a6a98 = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testUserAgent(/AppleWebKit/i) && !$dd0d4fc527b0735d$export$6446a186d09e379e();
});
const $dd0d4fc527b0735d$export$6446a186d09e379e = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testUserAgent(/Chrome/i);
});
const $dd0d4fc527b0735d$export$a11b0059900ceec8 = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testUserAgent(/Android/i);
});
const $dd0d4fc527b0735d$export$b7d78993b74f766d = $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$cached(function() {
    return $dd0d4fc527b0735d$var$$2add3ce32c6007eb$var$testUserAgent(/Firefox/i);
});



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $acee182969117c6e$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.pointerType === '' && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $dd0d4fc527b0735d$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $acee182969117c6e$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $dd0d4fc527b0735d$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$RouterContext = (0, $acw62.createContext)({
    isNative: true,
    open: $dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$openSyntheticLink,
    useHref: (href)=>href
});
function $dc5a334d7ad7481f$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $acw62.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$getSyntheticLink(target, (link)=>{
                    if ($dc5a334d7ad7481f$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $dc5a334d7ad7481f$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $dc5a334d7ad7481f$export$9a302a45f65d0572() {
    return (0, $acw62.useContext)($dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$RouterContext);
}
function $dc5a334d7ad7481f$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $dc5a334d7ad7481f$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $dd0d4fc527b0735d$export$b7d78993b74f766d)() && window.event?.type?.startsWith('key') && target.target === '_blank') {
        if ((0, $dd0d4fc527b0735d$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $dd0d4fc527b0735d$export$78551043582a6a98)() && (0, $dd0d4fc527b0735d$export$9ac100e40613ea10)() && !(0, $dd0d4fc527b0735d$export$7bef049ce92e4224)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        detail: 1,
        bubbles: true,
        cancelable: true
    });
    $dc5a334d7ad7481f$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $dc5a334d7ad7481f$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$dc5a334d7ad7481f$export$95185d699e05d4d7.isOpening = false;
function $dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        let link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$openSyntheticLink(target, modifiers) {
    $dc5a334d7ad7481f$var$$caaf0dd3060ed57c$var$getSyntheticLink(target, (link)=>$dc5a334d7ad7481f$export$95185d699e05d4d7(link, modifiers));
}
function $dc5a334d7ad7481f$export$bdc77b0c0a3a85d6(props) {
    let router = $dc5a334d7ad7481f$export$9a302a45f65d0572();
    const href = router.useHref(props.href ?? '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $dc5a334d7ad7481f$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $dc5a334d7ad7481f$export$7e924b3091a3bd18(props) {
    let router = $dc5a334d7ad7481f$export$9a302a45f65d0572();
    const href = router.useHref(props?.href ?? '');
    return {
        href: props?.href ? href : undefined,
        target: props?.target,
        rel: props?.rel,
        download: props?.download,
        ping: props?.ping,
        referrerPolicy: props?.referrerPolicy
    };
}
function $dc5a334d7ad7481f$export$13aea1a3cb5e3f1f(e, router, href, routerOptions) {
    // If a custom router is provided, prevent default and forward if this link should client navigate.
    if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
    !e.isDefaultPrevented() && $dc5a334d7ad7481f$export$efa8c9099e530235(e.currentTarget, e) && href) {
        e.preventDefault();
        router.open(e.currentTarget, e, href, routerOptions);
    }
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality = null;
let $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType = 'keyboard';
const $627d69440c27e5e4$export$901e90a13c50a14e = new Set();
let $627d69440c27e5e4$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = false;
let $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $627d69440c27e5e4$var$$8f5a2122b0992be3$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$triggerChangeHandlers(modality, e) {
    for (let handler of $627d69440c27e5e4$export$901e90a13c50a14e)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $dd0d4fc527b0735d$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleKeyboardEvent(e) {
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
    if (!(0, $dc5a334d7ad7481f$export$95185d699e05d4d7).isOpening && $627d69440c27e5e4$var$$8f5a2122b0992be3$var$isValidKey(e)) {
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality = 'keyboard';
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType = 'keyboard';
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$triggerChangeHandlers('keyboard', e);
    }
}
function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent(e) {
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality = 'pointer';
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType = 'pointerType' in e ? e.pointerType : 'mouse';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$triggerChangeHandlers('pointer', e);
    }
}
function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleClickEvent(e) {
    if (!(0, $dc5a334d7ad7481f$export$95185d699e05d4d7).isOpening && (0, $acee182969117c6e$export$60278871457622de)(e)) {
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality = 'virtual';
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType = 'virtual';
    }
}
function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    let ownerWindow = (0, $c8e82650210ecd78$export$f21a1ffae260145a)((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e));
    let ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e));
    if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === ownerWindow || (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === ownerDocument || (0, $7249d88549c99f1a$export$fda7da73ab5d4c48) || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus && !$627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently) {
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality = 'virtual';
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType = 'virtual';
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$triggerChangeHandlers('virtual', e);
    }
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = false;
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = false;
}
function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleWindowBlur() {
    if (0, $7249d88549c99f1a$export$fda7da73ab5d4c48) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = false;
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents(element) {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const windowObject = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(element);
    const documentObject = (0, $c8e82650210ecd78$export$b204af158042fbac)(element);
    if ($627d69440c27e5e4$export$d90243b58daecda7.get(windowObject)) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $627d69440c27e5e4$var$$8f5a2122b0992be3$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $627d69440c27e5e4$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $627d69440c27e5e4$var$$8f5a2122b0992be3$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(element);
    const documentObject = (0, $c8e82650210ecd78$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$627d69440c27e5e4$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $627d69440c27e5e4$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $627d69440c27e5e4$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
    }
    $627d69440c27e5e4$export$d90243b58daecda7.delete(windowObject);
};
function $627d69440c27e5e4$export$2f1888112f558a7d(element) {
    const documentObject = (0, $c8e82650210ecd78$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $627d69440c27e5e4$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $627d69440c27e5e4$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$627d69440c27e5e4$var$$8f5a2122b0992be3$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $627d69440c27e5e4$export$2f1888112f558a7d();
function $627d69440c27e5e4$export$b9b3dfddab17db27() {
    return $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality !== 'pointer';
}
function $627d69440c27e5e4$export$630ff653c5ada6a9() {
    return $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality;
}
function $627d69440c27e5e4$export$8397ddfc504fdb9a(modality) {
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality = modality;
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType = modality === 'pointer' ? 'mouse' : modality;
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$triggerChangeHandlers(modality, null);
}
function $627d69440c27e5e4$export$887a228355cf7d95() {
    return $627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentPointerType;
}
function $627d69440c27e5e4$export$98e20ec92f614cfe() {
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($627d69440c27e5e4$var$$8f5a2122b0992be3$var$currentModality);
        };
        $627d69440c27e5e4$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $627d69440c27e5e4$export$901e90a13c50a14e.delete(handler);
        };
    }, []);
    return (0, $d8a6de909e063b29$export$535bd6ca7f90a273)() ? null : modality;
}
const $627d69440c27e5e4$var$$8f5a2122b0992be3$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $627d69440c27e5e4$var$$8f5a2122b0992be3$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    let eventTarget = e ? (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) : undefined;
    let document1 = (0, $c8e82650210ecd78$export$b204af158042fbac)(eventTarget);
    let ownerWindow = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(eventTarget);
    const IHTMLInputElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof ownerWindow !== 'undefined' ? ownerWindow.KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(document1);
    isTextInput = isTextInput || activeElement instanceof IHTMLInputElement && !$627d69440c27e5e4$var$$8f5a2122b0992be3$var$nonTextInputTypes.has(activeElement.type) || activeElement instanceof IHTMLTextAreaElement || activeElement instanceof IHTMLElement && activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$627d69440c27e5e4$var$$8f5a2122b0992be3$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $627d69440c27e5e4$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $627d69440c27e5e4$export$b9b3dfddab17db27());
    $627d69440c27e5e4$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $627d69440c27e5e4$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $627d69440c27e5e4$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        if (opts?.enabled === false) return;
        let handler = (modality, e)=>{
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$627d69440c27e5e4$var$$8f5a2122b0992be3$var$isKeyboardFocusEvent(!!opts?.isTextInput, modality, e)) return;
            fn($627d69440c27e5e4$export$b9b3dfddab17db27());
        };
        $627d69440c27e5e4$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $627d69440c27e5e4$export$901e90a13c50a14e.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionCallbacks = new Set();
function $9d388cfeecad3612$var$$081cb5757e08788e$var$setupGlobalEvents() {
    if (typeof window === 'undefined') return;
    function isTransitionEvent(event) {
        return 'propertyName' in event;
    }
    let onTransitionStart = (e)=>{
        let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (!isTransitionEvent(e) || !eventTarget) return;
        // Add the transitioning property to the list for this element.
        let transitions = $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.get(eventTarget);
        if (!transitions) {
            transitions = new Set();
            $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.set(eventTarget, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            eventTarget.addEventListener('transitioncancel', onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (!isTransitionEvent(e) || !eventTarget) return;
        // Remove property from list of transitioning properties.
        let properties = $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.get(eventTarget);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            eventTarget.removeEventListener('transitioncancel', onTransitionEnd);
            $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.delete(eventTarget);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.size === 0) {
            for (let cb of $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionCallbacks)cb();
            $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $9d388cfeecad3612$var$$081cb5757e08788e$var$setupGlobalEvents();
    else document.addEventListener('DOMContentLoaded', $9d388cfeecad3612$var$$081cb5757e08788e$var$setupGlobalEvents);
}
/**
 * Cleans up any elements that are no longer in the document.
 * This is necessary because we can't rely on transitionend events to fire
 * for elements that are removed from the document while transitioning.
 */ function $9d388cfeecad3612$var$$081cb5757e08788e$var$cleanupDetachedElements() {
    for (const [eventTarget] of $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement)// the explicit instanceof check, since it may be different in different contexts.
    if ('isConnected' in eventTarget && !eventTarget.isConnected) $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.delete(eventTarget);
}
function $9d388cfeecad3612$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        $9d388cfeecad3612$var$$081cb5757e08788e$var$cleanupDetachedElements();
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($9d388cfeecad3612$var$$081cb5757e08788e$var$transitionsByElement.size === 0) fn();
        else $9d388cfeecad3612$var$$081cb5757e08788e$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea661b83393f500e$export$80f3e147d781571c(element) {
    if (!element.isConnected) return;
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(element);
    if ((0, $627d69440c27e5e4$export$630ff653c5ada6a9)() === 'virtual') {
        let lastFocusedElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument);
        (0, $9d388cfeecad3612$export$24490316f764c430)(()=>{
            const activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument);
            // If focus did not move or focus was lost to the body, and the element is still in the document, focus it.
            if ((activeElement === lastFocusedElement || activeElement === ownerDocument.body) && element.isConnected) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(element);
        });
    } else (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(element);
}










var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $66d841e13fef000a$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $7249d88549c99f1a$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(eventTarget);
        const activeElement = ownerDocument ? (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument) : (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
        if (eventTarget === e.currentTarget && eventTarget === activeElement) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3ceac55835d57be0$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                shouldStopPropagation = true;
            },
            continuePropagation () {
                shouldStopPropagation = false;
            },
            isPropagationStopped () {
                return shouldStopPropagation;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $beb56bc06b54112c$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $3ceac55835d57be0$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $3ceac55835d57be0$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $15604418d42e607a$export$4debdb1a3f0fa79e(context, ref) {
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2d50ad364d7cf854$export$f9762fab77588ecb = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $2d50ad364d7cf854$var$$d1116acdf220c2da$var$useFocusableContext(ref) {
    let context = (0, $acw62.useContext)($2d50ad364d7cf854$export$f9762fab77588ecb) || {};
    (0, $15604418d42e607a$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
const $2d50ad364d7cf854$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $0231fe790c02c958$export$4338b53315abf666)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2d50ad364d7cf854$export$f9762fab77588ecb.Provider, {
        value: context
    }, children);
});
function $2d50ad364d7cf854$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $66d841e13fef000a$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $beb56bc06b54112c$export$8f71654801c2f7cd)(props);
    let interactions = (0, $195af97314dd822a$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $2d50ad364d7cf854$var$$d1116acdf220c2da$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $ea661b83393f500e$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    // Always set a tabIndex so that Safari allows focusing native buttons and inputs.
    let tabIndex = props.excludeFromTabOrder ? -1 : 0;
    if (props.isDisabled) tabIndex = undefined;
    return {
        focusableProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: tabIndex
        }, interactionProps)
    };
}
const $2d50ad364d7cf854$export$35a3bebf7ef2d934 = (0, $acw62.forwardRef)(({ children: children, ...props }, ref)=>{
    ref = (0, $0231fe790c02c958$export$4338b53315abf666)(ref);
    let { focusableProps: focusableProps } = $2d50ad364d7cf854$export$4c014de7c8940b4c(props, ref);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
    (0, $acw62.useEffect)(()=>{
        return;
    }, [
        ref,
        props.isDisabled
    ]);
    // @ts-ignore
    let childRef = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version, 10) < 19 ? child.ref : child.props.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(focusableProps, child.props),
        // @ts-ignore
        ref: (0, $eed06c8362986bd2$export$c9058316764c140e)(childRef, ref)
    });
});







/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $cf25a153d3568de7$var$$cbf007e418543821$var$state = 'default';
let $cf25a153d3568de7$var$$cbf007e418543821$var$savedUserSelect = '';
let $cf25a153d3568de7$var$$cbf007e418543821$var$modifiedElementMap = new WeakMap();
function $cf25a153d3568de7$export$16a4697467175487(target) {
    if ((0, $dd0d4fc527b0735d$export$fedb369cb70207f1)()) {
        if ($cf25a153d3568de7$var$$cbf007e418543821$var$state === 'default') {
            const documentObject = (0, $c8e82650210ecd78$export$b204af158042fbac)(target);
            $cf25a153d3568de7$var$$cbf007e418543821$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = 'none';
        }
        $cf25a153d3568de7$var$$cbf007e418543821$var$state = 'disabled';
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
        $cf25a153d3568de7$var$$cbf007e418543821$var$modifiedElementMap.set(target, target.style[property]);
        target.style[property] = 'none';
    }
}
function $cf25a153d3568de7$export$b0d6fa1ab32e3295(target) {
    if ((0, $dd0d4fc527b0735d$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($cf25a153d3568de7$var$$cbf007e418543821$var$state !== 'disabled') return;
        $cf25a153d3568de7$var$$cbf007e418543821$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $9d388cfeecad3612$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($cf25a153d3568de7$var$$cbf007e418543821$var$state === 'restoring') {
                    const documentObject = (0, $c8e82650210ecd78$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === 'none') documentObject.documentElement.style.webkitUserSelect = $cf25a153d3568de7$var$$cbf007e418543821$var$savedUserSelect || '';
                    $cf25a153d3568de7$var$$cbf007e418543821$var$savedUserSelect = '';
                    $cf25a153d3568de7$var$$cbf007e418543821$var$state = 'default';
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $cf25a153d3568de7$var$$cbf007e418543821$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $cf25a153d3568de7$var$$cbf007e418543821$var$modifiedElementMap.get(target);
            let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
            if (target.style[property] === 'none') target.style[property] = targetOldUserSelect;
            if (target.getAttribute('style') === '') target.removeAttribute('style');
            $cf25a153d3568de7$var$$cbf007e418543821$var$modifiedElementMap.delete(target);
        }
    }
}





/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5f528d9729e078c2$var$$2b2d34ff061957fb$var$getWebpackNonce(doc) {
    let ownerWindow = doc?.defaultView;
    return ownerWindow?.__webpack_nonce__ || globalThis['__webpack_nonce__'] || undefined;
}
let $5f528d9729e078c2$var$$2b2d34ff061957fb$var$nonceCache = new WeakMap();
function $5f528d9729e078c2$export$88b319273f3705b4() {
    $5f528d9729e078c2$var$$2b2d34ff061957fb$var$nonceCache = new WeakMap();
}
function $5f528d9729e078c2$export$2b85b721e524d74b(doc) {
    let d = doc ?? (typeof document !== 'undefined' ? document : undefined);
    if (!d) return $5f528d9729e078c2$var$$2b2d34ff061957fb$var$getWebpackNonce(d);
    if ($5f528d9729e078c2$var$$2b2d34ff061957fb$var$nonceCache.has(d)) return $5f528d9729e078c2$var$$2b2d34ff061957fb$var$nonceCache.get(d);
    let meta = d.querySelector('meta[property="csp-nonce"]');
    let nonce = meta && meta instanceof (0, $c8e82650210ecd78$export$f21a1ffae260145a)(meta).HTMLMetaElement && (meta.nonce || meta.content) || $5f528d9729e078c2$var$$2b2d34ff061957fb$var$getWebpackNonce(d) || undefined;
    if (nonce !== undefined) $5f528d9729e078c2$var$$2b2d34ff061957fb$var$nonceCache.set(d, nonce);
    return nonce;
}








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $758d9eda1e4fbc82$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    register: ()=>{}
});
$758d9eda1e4fbc82$export$5165eccb35aaadb5.displayName = 'PressResponderContext';




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Use the earliest effect type possible. useInsertionEffect runs during the mutation phase,
// before all layout effects, but is available only in React 18 and later.
const $7bf6d137e5c3909a$var$$fe16bffc7a557bf0$var$useEarlyEffect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useInsertionEffect'] ?? (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c);
function $7bf6d137e5c3909a$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    $7bf6d137e5c3909a$var$$fe16bffc7a557bf0$var$useEarlyEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f?.(...args);
    }, []);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a2eab827d897a6a9$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = options?.once ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        let fn = globalListeners.current.get(listener)?.fn || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}



parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)((0, $758d9eda1e4fbc82$export$5165eccb35aaadb5));
    if (context) {
        // Prevent mergeProps from merging ref.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let { register: register, ref: ref, ...contextProps } = context;
        props = (0, $195af97314dd822a$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $15604418d42e607a$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
class $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PressEvent {
    #shouldStopPropagation;
    constructor(type, pointerType, originalEvent, state){
        this.#shouldStopPropagation = true;
        let currentTarget = state?.target ?? originalEvent.currentTarget;
        const rect = currentTarget?.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
        this.key = originalEvent.key;
    }
    continuePropagation() {
        this.#shouldStopPropagation = false;
    }
    get shouldStopPropagation() {
        return this.#shouldStopPropagation;
    }
}
const $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$LINK_CLICKED = Symbol('linkClicked');
const $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$STYLE_ID = 'react-aria-pressable-style';
const $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PRESSABLE_ATTRIBUTE = 'data-react-aria-pressable';
function $1aae0f2f42307dd4$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onClick: onClick, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: domRef, ...domProps } = $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null,
        disposables: []
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $a2eab827d897a6a9$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $acw62.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PressEvent('pressstart', pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressStart,
        onPressChange
    ]);
    let triggerPressEnd = (0, $acw62.useCallback)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PressEvent('pressend', pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PressEvent('press', pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation &&= event.shouldStopPropagation;
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressEnd,
        onPressChange,
        onPress
    ]);
    let triggerPressEndEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(triggerPressEnd);
    let triggerPressUp = (0, $acw62.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PressEvent('pressup', pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    }, [
        isDisabled,
        onPressUp
    ]);
    let triggerPressUpEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(triggerPressUp);
    let cancel = (0, $acw62.useCallback)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $cf25a153d3568de7$export$b0d6fa1ab32e3295)(state.target);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        }
    }, [
        allowTextSelectionOnPress,
        removeAllGlobalListeners,
        triggerPressEnd
    ]);
    let cancelEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(cancel);
    let cancelOnPointerExit = (0, $acw62.useCallback)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    }, [
        shouldCancelOnPointerExit,
        cancel
    ]);
    let triggerClick = (0, $acw62.useCallback)((e)=>{
        if (isDisabled) return;
        onClick?.(e);
    }, [
        isDisabled,
        onClick
    ]);
    let triggerSyntheticClick = (0, $acw62.useCallback)((e, target)=>{
        if (isDisabled) return;
        // Some third-party libraries pass in onClick instead of onPress.
        // Create a fake mouse event and trigger onClick as well.
        // This matches the browser's native activation behavior for certain elements (e.g. button).
        // https://html.spec.whatwg.org/#activation
        // https://html.spec.whatwg.org/#fire-a-synthetic-pointer-event
        if (onClick) {
            let event = new MouseEvent('click', e);
            (0, $7249d88549c99f1a$export$c2b7abe5d61ec696)(event, target);
            onClick((0, $7249d88549c99f1a$export$525bc4921d56d4a)(event));
        }
    }, [
        isDisabled,
        onClick
    ]);
    let pressProps = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && (0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
                    if ($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$shouldPreventDefaultKeyboard((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e), e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        state.pointerType = 'keyboard';
                        shouldStopPropagation = triggerPressStart(e, 'keyboard');
                    }
                    // Focus may move before the key up event, so register the event on the document
                    // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                    // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                    let originalTarget = e.currentTarget;
                    let pressUp = (e)=>{
                        if ($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && (0, $8fd85525b97849bf$export$4282f70798064fe0)(originalTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) && state.target) triggerPressUpEvent($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(state.target, e), 'keyboard');
                    };
                    addGlobalListener((0, $c8e82650210ecd78$export$b204af158042fbac)(e.currentTarget), 'keyup', (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(pressUp, onKeyUp), true);
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $dd0d4fc527b0735d$export$9ac100e40613ea10)()) state.metaKeyEvents?.set(e.key, e.nativeEvent);
                } else if (e.key === 'Meta') state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $dc5a334d7ad7481f$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === 'virtual' || (0, $acee182969117c6e$export$60278871457622de)(e.nativeEvent))) {
                        let stopPressStart = triggerPressStart(e, 'virtual');
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressUp = triggerPressUpEvent(e, 'virtual');
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressEnd = triggerPressEndEvent(e, 'virtual');
                        triggerClick(e);
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    } else if (state.isPressed && state.pointerType !== 'keyboard') {
                        let pointerType = state.pointerType || e.nativeEvent.pointerType || 'virtual';
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressUp = triggerPressUpEvent($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(e.currentTarget, e), pointerType);
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        let stopPressEnd = triggerPressEndEvent($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(e.currentTarget, e), pointerType, true);
                        shouldStopPropagation = stopPressUp && stopPressEnd;
                        state.isOverTarget = false;
                        triggerClick(e);
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        cancelEvent(e);
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && state.target && $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidKeyboardEvent(e, state.target)) {
                if ($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$shouldPreventDefaultKeyboard((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e), e.key)) e.preventDefault();
                let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
                let wasPressed = (0, $8fd85525b97849bf$export$4282f70798064fe0)(state.target, target);
                // eslint-disable-next-line react-hooks/rules-of-hooks
                triggerPressEndEvent($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(state.target, e), 'keyboard', wasPressed);
                if (wasPressed) triggerSyntheticClick(e, state.target);
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== 'Enter' && $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isHTMLAnchorLink(state.target) && (0, $8fd85525b97849bf$export$4282f70798064fe0)(state.target, target) && !e[$1aae0f2f42307dd4$var$$d27d541f9569d26d$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$1aae0f2f42307dd4$var$$d27d541f9569d26d$var$LINK_CLICKED] = true;
                    (0, $dc5a334d7ad7481f$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                state.metaKeyEvents?.delete(e.key);
            } else if (e.key === 'Meta' && state.metaKeyEvents?.size) {
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())state.target?.dispatchEvent(new KeyboardEvent('keyup', event));
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $acee182969117c6e$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!allowTextSelectionOnPress) (0, $cf25a153d3568de7$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    // Release pointer capture so that touch interactions can leave the original target.
                    // This enables onPointerLeave and onPointerEnter to fire.
                    let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
                    if ('releasePointerCapture' in target) {
                        if ('hasPointerCapture' in target) {
                            if (target.hasPointerCapture(e.pointerId)) target.releasePointerCapture(e.pointerId);
                        } else target.releasePointerCapture(e.pointerId);
                    }
                    addGlobalListener((0, $c8e82650210ecd78$export$b204af158042fbac)(e.currentTarget), 'pointerup', onPointerUp, false);
                    addGlobalListener((0, $c8e82650210ecd78$export$b204af158042fbac)(e.currentTarget), 'pointercancel', onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
                if (e.button === 0) {
                    if (preventFocusOnPress) {
                        let dispose = (0, $7249d88549c99f1a$export$cabe61c495ee3649)(e.target);
                        if (dispose) state.disposables.push(dispose);
                    }
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) || state.pointerType === 'virtual') return;
                // Only handle left clicks. If isPressed is true, delay until onClick.
                if (e.button === 0 && !state.isPressed) triggerPressUpEvent(e, state.pointerType || e.pointerType);
            };
            pressProps.onPointerEnter = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = true;
                    triggerPressStart($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(state.target, e), state.pointerType);
                }
            };
            pressProps.onPointerLeave = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    triggerPressEndEvent($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(state.target, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) && state.pointerType != null) {
                        // Wait for onClick to fire onPress. This avoids browser issues when the DOM
                        // is mutated between onPointerUp and onClick, and is more compatible with third party libraries.
                        // https://github.com/adobe/react-spectrum/issues/1513
                        // https://issues.chromium.org/issues/40732224
                        // However, iOS and Android do not focus or fire onClick after a long press.
                        // We work around this by triggering a click ourselves after a timeout.
                        // This timeout is canceled during the click event in case the real one fires first.
                        // The timeout must be at least 32ms, because Safari on iOS delays the click event on
                        // non-form elements without certain ARIA roles (for hover emulation).
                        // https://github.com/WebKit/WebKit/blob/dccfae42bb29bd4bdef052e469f604a9387241c0/Source/WebKit/WebProcess/WebPage/ios/WebPageIOS.mm#L875-L892
                        let clicked = false;
                        let timeout = setTimeout(()=>{
                            if (state.isPressed && state.target instanceof HTMLElement) {
                                if (clicked) cancelEvent(e);
                                else {
                                    (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(state.target);
                                    state.target.click();
                                }
                            }
                        }, 80);
                        // Use a capturing listener to track if a click occurred.
                        // If stopPropagation is called it may never reach our handler.
                        addGlobalListener(e.currentTarget, 'click', ()=>clicked = true, true);
                        state.disposables.push(()=>clearTimeout(timeout));
                    } else cancelEvent(e);
                    // Ignore subsequent onPointerLeave event before onClick on touch devices.
                    state.isOverTarget = false;
                }
            };
            let onPointerCancel = (e)=>{
                // eslint-disable-next-line react-hooks/rules-of-hooks
                cancelEvent(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                cancelEvent(e);
            };
        } else var e, e1, e2, e3, e4, e5, e6, e7, e8;
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancelOnPointerExit,
        triggerPressStart,
        triggerClick,
        triggerSyntheticClick
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!domRef || false) return;
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(domRef.current);
        if (!ownerDocument || !ownerDocument.head || ownerDocument.getElementById($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$STYLE_ID)) return;
        const style = ownerDocument.createElement('style');
        style.id = $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$STYLE_ID;
        let nonce = (0, $5f528d9729e078c2$export$2b85b721e524d74b)(ownerDocument);
        if (nonce) style.nonce = nonce;
        // touchAction: 'manipulation' is supposed to be equivalent, but in
        // Safari it causes onPointerCancel not to fire on scroll.
        // https://bugs.webkit.org/show_bug.cgi?id=240917
        style.textContent = `
@layer {
  [${$1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PRESSABLE_ATTRIBUTE}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim();
        ownerDocument.head.prepend(style);
    }, [
        domRef
    ]);
    (0, $acw62.useEffect)(()=>{
        let state = ref.current;
        return ()=>{
            if (!allowTextSelectionOnPress) (0, $cf25a153d3568de7$export$b0d6fa1ab32e3295)(state.target ?? undefined);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, pressProps, {
            [$1aae0f2f42307dd4$var$$d27d541f9569d26d$var$PRESSABLE_ATTRIBUTE]: true
        })
    };
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof (0, $c8e82650210ecd78$export$f21a1ffae260145a)(element).HTMLInputElement && !$1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidInputKey(element, key) || element instanceof (0, $c8e82650210ecd78$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === 'link' || !role && $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isHTMLAnchorLink(element)) && key !== 'Enter');
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY,
        key: e.key
    };
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$getPointClientRect(point);
    return $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$areRectanglesOverlapping(rect, pointRect);
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$shouldPreventDefaultUp(target) {
    if (target instanceof HTMLInputElement) return false;
    if (target instanceof HTMLButtonElement) return target.type !== 'submit' && target.type !== 'reset';
    if ($1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isHTMLAnchorLink(target)) return false;
    return true;
}
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidInputKey(target, key);
    return $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$shouldPreventDefaultUp(target);
}
const $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $1aae0f2f42307dd4$var$$d27d541f9569d26d$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7ba2564f6a00a739$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = 'button', isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: onClick, href: href, target: target, rel: rel, type: type = 'button' } = props;
    let additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled,
        form: props.form,
        formAction: props.formAction,
        formEncType: props.formEncType,
        formMethod: props.formMethod,
        formNoValidate: props.formNoValidate,
        formTarget: props.formTarget,
        name: props.name,
        value: props.value
    };
    else additionalProps = {
        role: 'button',
        href: elementType === 'a' && !isDisabled ? href : undefined,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(focusableProps, pressProps, (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            'aria-current': props['aria-current'],
            'aria-disabled': props['aria-disabled']
        })
    };
}






var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $dcef548b0303e20e$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $a2eab827d897a6a9$export$4eaf04e54aa8eed6)();
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    let onSyntheticFocus = (0, $7249d88549c99f1a$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(eventTarget);
        const activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === eventTarget) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            let currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', (e)=>{
                let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
                if (state.current.isFocusWithin && !(0, $8fd85525b97849bf$export$4282f70798064fe0)(currentTarget, eventTarget)) {
                    let nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: eventTarget
                    });
                    (0, $7249d88549c99f1a$export$c2b7abe5d61ec696)(nativeEvent, currentTarget);
                    let event = (0, $7249d88549c99f1a$export$525bc4921d56d4a)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $acw62 = parcelRequire("acw62");
function $0cde480b945a073a$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $627d69440c27e5e4$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        state.current.isFocusVisible = (0, $627d69440c27e5e4$export$b9b3dfddab17db27)();
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $627d69440c27e5e4$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [
        isTextInput,
        isFocused
    ], {
        enabled: isFocused,
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $66d841e13fef000a$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents = false;
let $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$hoverCount = 0;
function $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$setGlobalIgnoreEmulatedMouseEvents() {
    $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents = false;
    }, 500);
}
function $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$setupGlobalTouchEvents() {
    let ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(null);
    if (typeof ownerDocument === 'undefined') return;
    if ($c3d85362ed1440ed$var$$e969f22b6713ca4a$var$hoverCount === 0) {
        if (typeof PointerEvent !== 'undefined') ownerDocument.addEventListener('pointerup', $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$handleGlobalPointerEvent);
    }
    $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$hoverCount++;
    return ()=>{
        $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$hoverCount--;
        if ($c3d85362ed1440ed$var$$e969f22b6713ca4a$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') ownerDocument.removeEventListener('pointerup', $c3d85362ed1440ed$var$$e969f22b6713ca4a$var$handleGlobalPointerEvent);
    };
}
function $c3d85362ed1440ed$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $acw62.useEffect)($c3d85362ed1440ed$var$$e969f22b6713ca4a$var$setupGlobalTouchEvents, []);
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $a2eab827d897a6a9$export$4eaf04e54aa8eed6)();
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !(0, $8fd85525b97849bf$export$4282f70798064fe0)(event.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(event))) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            // When an element that is hovered over is removed, no pointerleave event is fired by the browser,
            // even though the originally hovered target may have shrunk in size so it is no longer hovered.
            // However, a pointerover event will be fired on the new target the mouse is over.
            // In Chrome this happens immediately. In Safari and Firefox, it happens upon moving the mouse one pixel.
            addGlobalListener((0, $c8e82650210ecd78$export$b204af158042fbac)((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(event)), 'pointerover', (e)=>{
                if (state.isHovered && state.target && !(0, $8fd85525b97849bf$export$4282f70798064fe0)(state.target, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) triggerHoverEnd(e, e.pointerType);
            }, {
                capture: true
            });
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            let target = state.target;
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered || !target) return;
            state.isHovered = false;
            removeAllGlobalListeners();
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($c3d85362ed1440ed$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && (0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) triggerHoverEnd(e, e.pointerType);
            };
        } else var e, e1;
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state,
        addGlobalListener,
        removeAllGlobalListeners
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $972ba92a45901f5b$export$24d547caef80ccd1 = (0, $acw62.createContext)({});
const $972ba92a45901f5b$export$353f5b6fc5456de1 = (0, $ffa0afb9817175b6$export$86427a43e3e48ebb)(function Button(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $972ba92a45901f5b$export$24d547caef80ccd1);
    let ctx = props;
    let { isPending: isPending } = ctx;
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $7ba2564f6a00a739$export$ea18c227d4417cc3)(props, ref);
    buttonProps = $972ba92a45901f5b$var$$7705c033048f6da7$var$useDisableInteractions(buttonProps, isPending);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $0cde480b945a073a$export$4e328f61c538687f)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        ...props,
        isDisabled: props.isDisabled || isPending
    });
    let renderValues = {
        isHovered: isHovered,
        isPressed: (ctx.isPressed || isPressed) && !isPending,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: props.isDisabled || false,
        isPending: isPending ?? false
    };
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: renderValues,
        defaultClassName: 'react-aria-Button'
    });
    let buttonId = (0, $3af2a5641bd71461$export$f680877a34711e37)(buttonProps.id);
    let progressId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let ariaLabelledby = buttonProps['aria-labelledby'];
    if (isPending) {
        // aria-labelledby wins over aria-label
        // https://www.w3.org/TR/accname-1.2/#computation-steps
        if (ariaLabelledby) ariaLabelledby = `${ariaLabelledby} ${progressId}`;
        else if (buttonProps['aria-label']) ariaLabelledby = `${buttonId} ${progressId}`;
    }
    let wasPending = (0, $acw62.useRef)(isPending);
    (0, $acw62.useEffect)(()=>{
        let message = {
            'aria-labelledby': ariaLabelledby || buttonId
        };
        if (!wasPending.current && isFocused && isPending) (0, $1c9c0beddd9981ff$export$a9b970dcc4ae71a9)(message, 'assertive');
        else if (wasPending.current && isFocused && !isPending) (0, $1c9c0beddd9981ff$export$a9b970dcc4ae71a9)(message, 'assertive');
        wasPending.current = isPending;
    }, [
        isPending,
        isFocused,
        ariaLabelledby,
        buttonId
    ]);
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).button, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, buttonProps, focusProps, hoverProps),
        // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
        // We do this by changing the button's type to button.
        type: buttonProps.type === 'submit' && isPending ? 'button' : buttonProps.type,
        id: buttonId,
        ref: ref,
        "aria-labelledby": ariaLabelledby,
        slot: props.slot || undefined,
        "aria-disabled": isPending ? 'true' : buttonProps['aria-disabled'],
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": renderValues.isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-pending": isPending || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f2e87e59c34f9e$export$e9f3bf65a26ce129).Provider, {
        value: {
            id: progressId
        }
    }, renderProps.children));
});
// Events to preserve when isPending is true (for tooltips and other overlays)
const $972ba92a45901f5b$var$$7705c033048f6da7$var$PRESERVED_EVENT_PATTERN = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function $972ba92a45901f5b$var$$7705c033048f6da7$var$useDisableInteractions(props, isPending) {
    if (isPending) {
        for(const key in props)if (key.startsWith('on') && !$972ba92a45901f5b$var$$7705c033048f6da7$var$PRESERVED_EVENT_PATTERN.test(key)) props[key] = undefined;
        props.href = undefined;
        props.target = undefined;
    }
    return props;
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5cc6cedd00940323$export$d68d59712b04d9d1 {
    constructor(key){
        this.value = null;
        this.level = 0;
        this.hasChildNodes = false;
        this.rendered = null;
        this.textValue = '';
        this['aria-label'] = undefined;
        this.index = 0;
        this.parentKey = null;
        this.prevKey = null;
        this.nextKey = null;
        this.firstChildKey = null;
        this.lastChildKey = null;
        this.props = {};
        this.colSpan = null;
        this.colIndex = null;
        this.type = this.constructor.type;
        this.key = key;
    }
    get childNodes() {
        throw new Error('childNodes is not supported');
    }
    clone() {
        let node = new this.constructor(this.key);
        node.value = this.value;
        node.level = this.level;
        node.hasChildNodes = this.hasChildNodes;
        node.rendered = this.rendered;
        node.textValue = this.textValue;
        node['aria-label'] = this['aria-label'];
        node.index = this.index;
        node.parentKey = this.parentKey;
        node.prevKey = this.prevKey;
        node.nextKey = this.nextKey;
        node.firstChildKey = this.firstChildKey;
        node.lastChildKey = this.lastChildKey;
        node.props = this.props;
        node.render = this.render;
        node.colSpan = this.colSpan;
        node.colIndex = this.colIndex;
        return node;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filter(collection, newCollection, filterFn) {
        let clone = this.clone();
        newCollection.addDescendants(clone, collection);
        return clone;
    }
}
class $5cc6cedd00940323$export$b1918e978f1ee46f extends $5cc6cedd00940323$export$d68d59712b04d9d1 {
    filter(collection, newCollection, filterFn) {
        let [firstKey, lastKey] = $5cc6cedd00940323$var$$6f0c29017aeec335$var$filterChildren(collection, newCollection, this.firstChildKey, filterFn);
        let newNode = this.clone();
        newNode.firstChildKey = firstKey;
        newNode.lastChildKey = lastKey;
        return newNode;
    }
}
class $5cc6cedd00940323$export$5ae2504e948afce5 extends $5cc6cedd00940323$export$d68d59712b04d9d1 {
    static{
        this.type = 'header';
    }
}
class $5cc6cedd00940323$export$8258a0665a675899 extends $5cc6cedd00940323$export$d68d59712b04d9d1 {
    static{
        this.type = 'loader';
    }
}
class $5cc6cedd00940323$export$fd11f34e1d07f134 extends $5cc6cedd00940323$export$b1918e978f1ee46f {
    static{
        this.type = 'item';
    }
    filter(collection, newCollection, filterFn) {
        if (filterFn(this.textValue, this)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
class $5cc6cedd00940323$export$437f11dc9b403b78 extends $5cc6cedd00940323$export$b1918e978f1ee46f {
    static{
        this.type = 'section';
    }
    filter(collection, newCollection, filterFn) {
        let filteredSection = super.filter(collection, newCollection, filterFn);
        if (filteredSection) {
            if (filteredSection.lastChildKey !== null) {
                let lastChild = collection.getItem(filteredSection.lastChildKey);
                if (lastChild && lastChild.type !== 'header') return filteredSection;
            }
        }
        return null;
    }
}
class $5cc6cedd00940323$export$408d25a4e12db025 {
    get size() {
        return this.itemCount;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    *[Symbol.iterator]() {
        let node = this.firstKey != null ? this.keyMap.get(this.firstKey) : undefined;
        while(node){
            yield node;
            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : undefined;
        }
    }
    getChildren(key) {
        let keyMap = this.keyMap;
        return {
            *[Symbol.iterator] () {
                let parent = keyMap.get(key);
                let node = parent?.firstChildKey != null ? keyMap.get(parent.firstChildKey) : null;
                while(node){
                    yield node;
                    node = node.nextKey != null ? keyMap.get(node.nextKey) : undefined;
                }
            }
        };
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.prevKey != null) {
            node = this.keyMap.get(node.prevKey);
            while(node && node.type !== 'item' && node.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
            return node?.key ?? null;
        }
        return node.parentKey;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.type !== 'item' && node.firstChildKey != null) return node.firstChildKey;
        while(node){
            if (node.nextKey != null) return node.nextKey;
            if (node.parentKey != null) node = this.keyMap.get(node.parentKey);
            else return null;
        }
        return null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        let node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
        while(node?.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
        return node?.key ?? null;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at() {
        throw new Error('Not implemented');
    }
    clone() {
        // We need to clone using this.constructor so that subclasses have the right prototype.
        // TypeScript isn't happy about this yet.
        // https://github.com/microsoft/TypeScript/issues/3841
        let Constructor = this.constructor;
        let collection = new Constructor();
        collection.keyMap = new Map(this.keyMap);
        collection.firstKey = this.firstKey;
        collection.lastKey = this.lastKey;
        collection.itemCount = this.itemCount;
        return collection;
    }
    addNode(node) {
        if (this.frozen) throw new Error('Cannot add a node to a frozen collection');
        if (node.type === 'item' && this.keyMap.get(node.key) == null) this.itemCount++;
        this.keyMap.set(node.key, node);
    }
    // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
    addDescendants(node, oldCollection) {
        this.addNode(node);
        let children = oldCollection.getChildren(node.key);
        for (let child of children)this.addDescendants(child, oldCollection);
    }
    removeNode(key) {
        if (this.frozen) throw new Error('Cannot remove a node to a frozen collection');
        let node = this.keyMap.get(key);
        if (node != null && node.type === 'item') this.itemCount--;
        this.keyMap.delete(key);
    }
    commit(firstKey, lastKey, isSSR = false) {
        if (this.frozen) throw new Error('Cannot commit a frozen collection');
        this.firstKey = firstKey;
        this.lastKey = lastKey;
        this.frozen = !isSSR;
    }
    filter(filterFn) {
        let newCollection = new this.constructor();
        let [firstKey, lastKey] = $5cc6cedd00940323$var$$6f0c29017aeec335$var$filterChildren(this, newCollection, this.firstKey, filterFn);
        newCollection?.commit(firstKey, lastKey);
        return newCollection;
    }
    constructor(){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.frozen = false;
        this.itemCount = 0;
    }
}
function $5cc6cedd00940323$var$$6f0c29017aeec335$var$filterChildren(collection, newCollection, firstChildKey, filterFn) {
    // loop over the siblings for firstChildKey
    // create new nodes based on calling node.filter for each child
    // if it returns null then don't include it, otherwise update its prev/next keys
    // add them to the newCollection
    if (firstChildKey == null) return [
        null,
        null
    ];
    let firstNode = null;
    let lastNode = null;
    let currentNode = collection.getItem(firstChildKey);
    while(currentNode != null){
        let newNode = currentNode.filter(collection, newCollection, filterFn);
        if (newNode != null) {
            newNode.nextKey = null;
            if (lastNode) {
                newNode.prevKey = lastNode.key;
                lastNode.nextKey = newNode.key;
            }
            if (firstNode == null) firstNode = newNode;
            newCollection.addNode(newNode);
            lastNode = newNode;
        }
        currentNode = currentNode.nextKey ? collection.getItem(currentNode.nextKey) : null;
    }
    // TODO: this is pretty specific to dividers but doesn't feel like there is a good way to get around it since we only can know
    // to filter the last separator in a collection only after performing a filter for the rest of the contents after it
    // Its gross that it needs to live here, might be nice if somehow we could have this live in the separator code
    if (lastNode && lastNode.type === 'separator') {
        let prevKey = lastNode.prevKey;
        newCollection.removeNode(lastNode.key);
        if (prevKey) {
            lastNode = newCollection.getItem(prevKey);
            lastNode.nextKey = null;
        } else lastNode = null;
    }
    return [
        firstNode?.key ?? null,
        lastNode?.key ?? null
    ];
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b32135b427285c71$export$410b0c854570d131 {
    constructor(ownerDocument){
        this._firstChild = null;
        this._lastChild = null;
        this._previousSibling = null;
        this._nextSibling = null;
        this._parentNode = null;
        this._minInvalidChildIndex = null;
        this.ownerDocument = ownerDocument;
    }
    *[Symbol.iterator]() {
        let node = this.firstChild;
        while(node){
            yield node;
            node = node.nextSibling;
        }
    }
    get firstChild() {
        return this._firstChild;
    }
    set firstChild(firstChild) {
        this._firstChild = firstChild;
        this.ownerDocument.markDirty(this);
    }
    get lastChild() {
        return this._lastChild;
    }
    set lastChild(lastChild) {
        this._lastChild = lastChild;
        this.ownerDocument.markDirty(this);
    }
    get previousSibling() {
        return this._previousSibling;
    }
    set previousSibling(previousSibling) {
        this._previousSibling = previousSibling;
        this.ownerDocument.markDirty(this);
    }
    get nextSibling() {
        return this._nextSibling;
    }
    set nextSibling(nextSibling) {
        this._nextSibling = nextSibling;
        this.ownerDocument.markDirty(this);
    }
    get parentNode() {
        return this._parentNode;
    }
    set parentNode(parentNode) {
        this._parentNode = parentNode;
        this.ownerDocument.markDirty(this);
    }
    get isConnected() {
        return this.parentNode?.isConnected || false;
    }
    invalidateChildIndices(child) {
        if (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || child.index < this._minInvalidChildIndex.index) {
            this._minInvalidChildIndex = child;
            this.ownerDocument.markDirty(this);
        }
    }
    updateChildIndices() {
        let node = this._minInvalidChildIndex;
        while(node){
            node.index = node.previousSibling ? node.previousSibling.index + 1 : 0;
            node = node.nextSibling;
        }
        this._minInvalidChildIndex = null;
    }
    appendChild(child) {
        if (child.parentNode) child.parentNode.removeChild(child);
        if (this.firstChild == null) this.firstChild = child;
        if (this.lastChild) {
            this.lastChild.nextSibling = child;
            child.index = this.lastChild.index + 1;
            child.previousSibling = this.lastChild;
        } else {
            child.previousSibling = null;
            child.index = 0;
        }
        child.parentNode = this;
        child.nextSibling = null;
        this.lastChild = child;
        this.ownerDocument.markDirty(this);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    insertBefore(newNode, referenceNode) {
        if (referenceNode == null) return this.appendChild(newNode);
        if (newNode.parentNode) newNode.parentNode.removeChild(newNode);
        newNode.nextSibling = referenceNode;
        newNode.previousSibling = referenceNode.previousSibling;
        // Ensure that the newNode's index is less than that of the reference node so that
        // invalidateChildIndices will properly use the newNode as the _minInvalidChildIndex, thus making sure
        // we will properly update the indexes of all sibiling nodes after the newNode. The value here doesn't matter
        // since updateChildIndices should calculate the proper indexes.
        newNode.index = referenceNode.index - 1;
        if (this.firstChild === referenceNode) this.firstChild = newNode;
        else if (referenceNode.previousSibling) referenceNode.previousSibling.nextSibling = newNode;
        referenceNode.previousSibling = newNode;
        newNode.parentNode = referenceNode.parentNode;
        this.invalidateChildIndices(newNode);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    removeChild(child) {
        if (child.parentNode !== this) return;
        if (this._minInvalidChildIndex === child) this._minInvalidChildIndex = null;
        if (child.nextSibling) {
            this.invalidateChildIndices(child.nextSibling);
            child.nextSibling.previousSibling = child.previousSibling;
        }
        if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
        if (this.firstChild === child) this.firstChild = child.nextSibling;
        if (this.lastChild === child) this.lastChild = child.previousSibling;
        child.parentNode = null;
        child.nextSibling = null;
        child.previousSibling = null;
        child.index = 0;
        this.ownerDocument.markDirty(child);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    addEventListener() {}
    removeEventListener() {}
    get previousVisibleSibling() {
        let node = this.previousSibling;
        while(node && node.isHidden)node = node.previousSibling;
        return node;
    }
    get nextVisibleSibling() {
        let node = this.nextSibling;
        while(node && node.isHidden)node = node.nextSibling;
        return node;
    }
    get firstVisibleChild() {
        let node = this.firstChild;
        while(node && node.isHidden)node = node.nextSibling;
        return node;
    }
    get lastVisibleChild() {
        let node = this.lastChild;
        while(node && node.isHidden)node = node.previousSibling;
        return node;
    }
}
class $b32135b427285c71$export$dc064fe9e59310fd extends $b32135b427285c71$export$410b0c854570d131 {
    constructor(type, ownerDocument){
        super(ownerDocument), this.nodeType = 8 // COMMENT_NODE (we'd use ELEMENT_NODE but React DevTools will fail to get its dimensions)
        , this.isMutated = true, this._index = 0, this.isHidden = false;
        this.node = null;
    }
    get index() {
        return this._index;
    }
    set index(index) {
        this._index = index;
        this.ownerDocument.markDirty(this);
    }
    get level() {
        if (this.parentNode instanceof $b32135b427285c71$export$dc064fe9e59310fd) return this.parentNode.level + (this.parentNode.node?.type === 'item' ? 1 : 0);
        return 0;
    }
    /**
   * Lazily gets a mutable instance of a Node. If the node has already
   * been cloned during this update cycle, it just returns the existing one.
   */ getMutableNode() {
        if (this.node == null) return null;
        if (!this.isMutated) {
            this.node = this.node.clone();
            this.isMutated = true;
        }
        this.ownerDocument.markDirty(this);
        return this.node;
    }
    updateNode() {
        let nextSibling = this.nextVisibleSibling;
        let node = this.getMutableNode();
        if (node == null) return;
        node.index = this.index;
        node.level = this.level;
        node.parentKey = this.parentNode instanceof $b32135b427285c71$export$dc064fe9e59310fd ? this.parentNode.node?.key ?? null : null;
        node.prevKey = this.previousVisibleSibling?.node?.key ?? null;
        node.nextKey = nextSibling?.node?.key ?? null;
        node.hasChildNodes = !!this.firstChild;
        node.firstChildKey = this.firstVisibleChild?.node?.key ?? null;
        node.lastChildKey = this.lastVisibleChild?.node?.key ?? null;
        // Update the colIndex of sibling nodes if this node has a colSpan.
        if ((node.colSpan != null || node.colIndex != null) && nextSibling) {
            // This queues the next sibling for update, which means this happens recursively.
            let nextColIndex = (node.colIndex ?? node.index) + (node.colSpan ?? 1);
            if (nextSibling.node != null && nextColIndex !== nextSibling.node.colIndex) {
                let siblingNode = nextSibling.getMutableNode();
                siblingNode.colIndex = nextColIndex;
            }
        }
    }
    setProps(obj, ref, CollectionNodeClass, rendered, render) {
        let node;
        let { value: value1, textValue: textValue, id: id, ...props } = obj;
        if (this.node == null) {
            node = new CollectionNodeClass(id ?? `react-aria-${++this.ownerDocument.nodeId}`);
            this.node = node;
        } else node = this.getMutableNode();
        props.ref = ref;
        node.props = props;
        node.rendered = rendered;
        node.render = render;
        node.value = value1;
        if (obj['aria-label']) node['aria-label'] = obj['aria-label'];
        node.textValue = textValue || (typeof props.children === 'string' ? props.children : '') || obj['aria-label'] || '';
        if (id != null && id !== node.key) throw new Error('Cannot change the id of an item');
        if (props.colSpan != null) node.colSpan = props.colSpan;
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    get style() {
        // React sets display: none to hide elements during Suspense.
        // We'll handle this by setting the element to hidden and invalidating
        // its siblings/parent. Hidden elements remain in the Document, but
        // are removed from the Collection.
        let element = this;
        return {
            get display () {
                return element.isHidden ? 'none' : '';
            },
            set display (value){
                let isHidden = value === 'none';
                if (element.isHidden !== isHidden) {
                    // Mark parent node dirty if this element is currently the first or last visible child.
                    if (element.parentNode?.firstVisibleChild === element || element.parentNode?.lastVisibleChild === element) element.ownerDocument.markDirty(element.parentNode);
                    // Mark sibling visible elements dirty.
                    let prev = element.previousVisibleSibling;
                    let next = element.nextVisibleSibling;
                    if (prev) element.ownerDocument.markDirty(prev);
                    if (next) element.ownerDocument.markDirty(next);
                    // Mark self dirty.
                    element.isHidden = isHidden;
                    element.ownerDocument.markDirty(element);
                }
            }
        };
    }
    hasAttribute() {}
    setAttribute() {}
    setAttributeNS() {}
    removeAttribute() {}
}
class $b32135b427285c71$export$b34a105447964f9f extends $b32135b427285c71$export$410b0c854570d131 {
    constructor(collection){
        // @ts-ignore
        super(null), this.nodeType = 11 // DOCUMENT_FRAGMENT_NODE
        , this.ownerDocument = this, this.dirtyNodes = new Set(), this.isSSR = false, this.nodeId = 0, this.nodesByProps = new WeakMap(), this.nextCollection = null, this.subscriptions = new Set(), this.queuedRender = false, this.inSubscription = false;
        this.collection = collection;
        this.nextCollection = collection;
    }
    get isConnected() {
        return true;
    }
    createElement(type) {
        return new $b32135b427285c71$export$dc064fe9e59310fd(type, this);
    }
    getMutableCollection() {
        if (!this.nextCollection) this.nextCollection = this.collection.clone();
        return this.nextCollection;
    }
    markDirty(node) {
        this.dirtyNodes.add(node);
    }
    addNode(element) {
        if (element.isHidden || element.node == null) return;
        let collection = this.getMutableCollection();
        if (!collection.getItem(element.node.key)) for (let child of element)this.addNode(child);
        collection.addNode(element.node);
    }
    removeNode(node) {
        for (let child of node)this.removeNode(child);
        if (node.node) {
            let collection = this.getMutableCollection();
            collection.removeNode(node.node.key);
        }
    }
    /** Finalizes the collection update, updating all nodes and freezing the collection. */ getCollection() {
        // If in a subscription update, return return the existing collection.
        // React will call getCollection again during render, at which point all the updates will be complete.
        if (this.inSubscription) return this.collection;
        // Reset queuedRender to false when getCollection is called during render.
        this.queuedRender = false;
        this.updateCollection();
        return this.collection;
    }
    updateCollection() {
        // First, remove disconnected nodes and update the indices of dirty element children.
        for (let element of this.dirtyNodes)if (element instanceof $b32135b427285c71$export$dc064fe9e59310fd && (!element.isConnected || element.isHidden)) this.removeNode(element);
        else element.updateChildIndices();
        // Next, update dirty collection nodes.
        for (let element of this.dirtyNodes)if (element instanceof $b32135b427285c71$export$dc064fe9e59310fd) {
            if (element.isConnected && !element.isHidden) {
                element.updateNode();
                this.addNode(element);
            }
            if (element.node) this.dirtyNodes.delete(element);
            element.isMutated = false;
        } else this.dirtyNodes.delete(element);
        // Finally, update the collection.
        if (this.nextCollection) {
            this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR);
            if (!this.isSSR) {
                this.collection = this.nextCollection;
                this.nextCollection = null;
            }
        }
    }
    queueUpdate() {
        if (this.dirtyNodes.size === 0 || this.queuedRender) return;
        // Only trigger subscriptions once during an update, when the first item changes.
        // React's useSyncExternalStore will call getCollection immediately, to check whether the snapshot changed.
        // If so, React will queue a render to happen after the current commit to our fake DOM finishes.
        // We track whether getCollection is called in a subscription, and once it is called during render,
        // we reset queuedRender back to false.
        this.queuedRender = true;
        this.inSubscription = true;
        // Clone the collection to ensure that React queues a render. It will call getCollection again
        // during render, at which point all the updates will be complete and we can return
        // the new collection.
        if (!this.isSSR) this.collection = this.collection.clone();
        for (let fn of this.subscriptions)fn();
        this.inSubscription = false;
    }
    subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    resetAfterSSR() {
        if (this.isSSR) {
            this.isSSR = false;
            this.firstChild = null;
            this.lastChild = null;
            this.nodeId = 0;
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c655fcfa8fa3a47c$export$727c8fc270210f13(props) {
    let { children: children, items: items, idScope: idScope, addIdAndValue: addIdAndValue, dependencies: dependencies = [] } = props;
    // Invalidate the cache whenever the parent value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cache = (0, $acw62.useMemo)(()=>new WeakMap(), dependencies);
    return (0, $acw62.useMemo)(()=>{
        if (items && typeof children === 'function') {
            let res = [];
            for (let item of items){
                let rendered = cache.get(item);
                if (!rendered) {
                    rendered = children(item);
                    // @ts-ignore
                    let key = rendered.props.id ?? item.key ?? item.id;
                    if (key == null) throw new Error('Could not determine key for item');
                    if (idScope != null && rendered.props.id == null) key = idScope + ':' + key;
                    // Note: only works if wrapped Item passes through id...
                    rendered = (0, $acw62.cloneElement)(rendered, addIdAndValue ? {
                        key: key,
                        id: key,
                        value: item
                    } : {
                        key: key
                    });
                    cache.set(item, rendered);
                }
                res.push(rendered);
            }
            return res;
        } else if (typeof children !== 'function') return children;
    }, [
        children,
        items,
        cache,
        idScope,
        addIdAndValue
    ]);
}






var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$ShallowRenderContext = (0, $acw62.createContext)(false);
const $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionDocumentContext = (0, $acw62.createContext)(null);
function $18968b9ec17502c7$export$bf788dd355e3a401(props) {
    // If a document was provided above us, we're already in a hidden tree. Just render the content.
    let doc = (0, $acw62.useContext)($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionDocumentContext);
    if (doc) // even though the actual implementation since React 16 did.
    // We must return ReactElement so that TS does not complain that <CollectionBuilder>
    // is not a valid JSX element with React 16 and 17 types.
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return props.content;
    // Otherwise, render a hidden copy of the children so that we can build the collection before constructing the state.
    // This should always come before the real DOM content so we have built the collection by the time it renders during SSR.
    // This is fine. CollectionDocumentContext never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let { collection: collection, document: document } = $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useCollectionDocument(props.createCollection);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ffa0afb9817175b6$export$8dc98ba7eadeaa56), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionDocumentContext.Provider, {
        value: document
    }, props.content)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionInner, {
        render: props.children,
        collection: collection
    }));
}
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionInner({ collection: collection, render: render }) {
    return render(collection);
}
// React 16 and 17 don't support useSyncExternalStore natively, and the shim provided by React does not support getServerSnapshot.
// This wrapper uses the shim, but additionally calls getServerSnapshot during SSR (according to SSRProvider).
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSyncExternalStoreFallback(subscribe, getSnapshot, getServerSnapshot) {
    let isSSR = (0, $d8a6de909e063b29$export$535bd6ca7f90a273)();
    let isSSRRef = (0, $acw62.useRef)(isSSR);
    // This is read immediately inside the wrapper, which also runs during render.
    // We just need a ref to avoid invalidating the callback itself, which
    // would cause React to re-run the callback more than necessary.
    // eslint-disable-next-line rulesdir/pure-render
    isSSRRef.current = isSSR;
    let getSnapshotWrapper = (0, $acw62.useCallback)(()=>{
        return isSSRRef.current ? getServerSnapshot() : getSnapshot();
    }, [
        getSnapshot,
        getServerSnapshot
    ]);
    return (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshotWrapper);
}
const $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSyncExternalStore = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] : $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSyncExternalStoreFallback;
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useCollectionDocument(createCollection) {
    // The document instance is mutable, and should never change between renders.
    // useSyncExternalStore is used to subscribe to updates, which vends immutable Collection objects.
    let [document] = (0, $acw62.useState)(()=>new (0, $b32135b427285c71$export$b34a105447964f9f)(createCollection?.() || new (0, $5cc6cedd00940323$export$408d25a4e12db025)()));
    let subscribe = (0, $acw62.useCallback)((fn)=>document.subscribe(fn), [
        document
    ]);
    let getSnapshot = (0, $acw62.useCallback)(()=>{
        let collection = document.getCollection();
        if (document.isSSR) // We do this _after_ getting the collection above so that the collection still has content in it from SSR
        // during the current render, before React has finished the client render.
        document.resetAfterSSR();
        return collection;
    }, [
        document
    ]);
    let getServerSnapshot = (0, $acw62.useCallback)(()=>{
        document.isSSR = true;
        return document.getCollection();
    }, [
        document
    ]);
    let collection = $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return {
        collection: collection,
        document: document
    };
}
const $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$SSRContext = (0, $acw62.createContext)(null);
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$createCollectionNodeClass(type) {
    let NodeClass = class extends (0, $5cc6cedd00940323$export$d68d59712b04d9d1) {
        static{
            this.type = type;
        }
    };
    return NodeClass;
}
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSSRCollectionNode(CollectionNodeClass, props, ref, rendered, children, render) {
    // To prevent breaking change, if CollectionNodeClass is a string, create a CollectionNodeClass using the string as the type
    if (typeof CollectionNodeClass === 'string') CollectionNodeClass = $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$createCollectionNodeClass(CollectionNodeClass);
    // During SSR, portals are not supported, so the collection children will be wrapped in an SSRContext.
    // Since SSR occurs only once, we assume that the elements are rendered in order and never re-render.
    // Therefore we can create elements in our collection document during render so that they are in the
    // collection by the time we need to use the collection to render to the real DOM.
    // After hydration, we switch to client rendering using the portal.
    let itemRef = (0, $acw62.useCallback)((element)=>{
        element?.setProps(props, ref, CollectionNodeClass, rendered, render);
    }, [
        props,
        ref,
        rendered,
        render,
        CollectionNodeClass
    ]);
    let parentNode = (0, $acw62.useContext)($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$SSRContext);
    if (parentNode) {
        // Guard against double rendering in strict mode.
        let element = parentNode.ownerDocument.nodesByProps.get(props);
        if (!element) {
            element = parentNode.ownerDocument.createElement(CollectionNodeClass.type);
            element.setProps(props, ref, CollectionNodeClass, rendered, render);
            parentNode.appendChild(element);
            parentNode.ownerDocument.updateCollection();
            parentNode.ownerDocument.nodesByProps.set(props, element);
        }
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$SSRContext.Provider, {
            value: element
        }, children) : null;
    }
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionNodeClass.type, {
        ref: itemRef
    }, children);
}
function $18968b9ec17502c7$export$18af5c7a9e9b3664(CollectionNodeClass, render) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $acw62.forwardRef)((props, ref)=>{
        let focusableProps = (0, $acw62.useContext)((0, $2d50ad364d7cf854$export$f9762fab77588ecb));
        let isShallow = (0, $acw62.useContext)($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$ShallowRenderContext);
        if (!isShallow) {
            if (render.length >= 3) throw new Error(render.name + ' cannot be rendered outside a collection.');
            return render(props, ref);
        }
        return $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSSRCollectionNode(CollectionNodeClass, props, ref, 'children' in props ? props.children : null, null, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2d50ad364d7cf854$export$f9762fab77588ecb).Provider, {
                value: focusableProps
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                node: node
            })));
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $18968b9ec17502c7$export$e953bb1cd0f19726(CollectionNodeClass, render, useChildren = $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useCollectionChildren) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $acw62.forwardRef)((props, ref)=>{
        let children = useChildren(props);
        return $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useSSRCollectionNode(CollectionNodeClass, props, ref, null, children, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                node: node
            })) ?? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useCollectionChildren(options) {
    return (0, $c655fcfa8fa3a47c$export$727c8fc270210f13)({
        ...options,
        addIdAndValue: true
    });
}
const $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionContext = (0, $acw62.createContext)(null);
function $18968b9ec17502c7$export$fb8073518f34e6ec(props) {
    let ctx = (0, $acw62.useContext)($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionContext);
    let dependencies = (ctx?.dependencies || []).concat(props.dependencies);
    let idScope = props.idScope ?? ctx?.idScope;
    let children = $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$useCollectionChildren({
        ...props,
        idScope: idScope,
        dependencies: dependencies
    });
    let doc = (0, $acw62.useContext)($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionDocumentContext);
    if (doc) children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionRoot, null, children);
    // Propagate dependencies and idScope to child collections.
    ctx = (0, $acw62.useMemo)(()=>({
            dependencies: dependencies,
            idScope: idScope
        }), [
        idScope,
        ...dependencies
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionContext.Provider, {
        value: ctx
    }, children);
}
function $18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionRoot({ children: children }) {
    let doc = (0, $acw62.useContext)($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionDocumentContext);
    let wrappedChildren = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$CollectionDocumentContext.Provider, {
            value: null
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$ShallowRenderContext.Provider, {
            value: true
        }, children)), [
        children
    ]);
    // During SSR, we render the content directly, and append nodes to the document during render.
    // The collection children return null so that nothing is actually rendered into the HTML.
    return (0, $d8a6de909e063b29$export$535bd6ca7f90a273)() ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18968b9ec17502c7$var$$42ceafc619f9c3ba$var$SSRContext.Provider, {
        value: doc
    }, wrappedChildren) : (0, $1u0KT.createPortal)(wrappedChildren, doc);
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c9742a26b2470517$export$d40e14dec8b060a8 = (0, $acw62.createContext)(null);
const $c9742a26b2470517$export$6e2c8f0811a474ce = (0, $18968b9ec17502c7$export$e953bb1cd0f19726)('section', (props, ref, section)=>{
    let { name: name, render: render } = (0, $acw62.useContext)($c9742a26b2470517$export$d40e14dec8b060a8);
    return render(props, ref, section, 'react-aria-Section');
});
const $c9742a26b2470517$export$a164736487e3f0ae = {
    CollectionRoot ({ collection: collection, renderDropIndicator: renderDropIndicator }) {
        return $c9742a26b2470517$var$$263ab7fc0f95ccdb$var$useCollectionRender(collection, null, renderDropIndicator);
    },
    CollectionBranch ({ collection: collection, parent: parent, renderDropIndicator: renderDropIndicator }) {
        return $c9742a26b2470517$var$$263ab7fc0f95ccdb$var$useCollectionRender(collection, parent, renderDropIndicator);
    }
};
function $c9742a26b2470517$var$$263ab7fc0f95ccdb$var$useCollectionRender(collection, parent, renderDropIndicator) {
    return (0, $c655fcfa8fa3a47c$export$727c8fc270210f13)({
        items: parent ? collection.getChildren(parent.key) : collection,
        dependencies: [
            renderDropIndicator
        ],
        children (node) {
            // Return a empty fragment since we don't want to render the content twice
            // If we don't skip the content node here, we end up rendering them twice in a Tree since we also render the content node in TreeItem
            if (node.type === 'content') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
            let rendered = node.render(node);
            if (!renderDropIndicator || node.type !== 'item') return rendered;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderDropIndicator({
                type: 'item',
                key: node.key,
                dropPosition: 'before'
            }), rendered, $c9742a26b2470517$export$2dbbd341daed716d(collection, node, renderDropIndicator));
        }
    });
}
function $c9742a26b2470517$export$2dbbd341daed716d(collection, node, renderDropIndicator) {
    let key = node.key;
    let keyAfter = collection.getKeyAfter(key);
    let nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    while(nextItemInFlattenedCollection != null && nextItemInFlattenedCollection.type !== 'item'){
        keyAfter = collection.getKeyAfter(nextItemInFlattenedCollection.key);
        nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    }
    let nextItemInSameLevel = node.nextKey != null ? collection.getItem(node.nextKey) : null;
    while(nextItemInSameLevel != null && nextItemInSameLevel.type !== 'item')nextItemInSameLevel = nextItemInSameLevel.nextKey != null ? collection.getItem(nextItemInSameLevel.nextKey) : null;
    // Render one or more "after" drop indicators when the next item in the flattened collection
    // has a smaller level, is not an item, or there are no more items in the collection.
    // Otherwise, the "after" position is equivalent to the next item's "before" position.
    let afterIndicators = [];
    if (nextItemInSameLevel == null) {
        let current = node;
        while(current?.type === 'item' && (!nextItemInFlattenedCollection || current.parentKey !== nextItemInFlattenedCollection.parentKey && nextItemInFlattenedCollection.level < current.level)){
            let indicator = renderDropIndicator({
                type: 'item',
                key: current.key,
                dropPosition: 'after'
            });
            if ((0, $acw62.isValidElement)(indicator)) afterIndicators.push((0, $acw62.cloneElement)(indicator, {
                key: `${current.key}-after`
            }));
            current = current.parentKey != null ? collection.getItem(current.parentKey) : null;
        }
    }
    return afterIndicators;
}
const $c9742a26b2470517$export$4feb769f8ddf26c5 = (0, $acw62.createContext)($c9742a26b2470517$export$a164736487e3f0ae);
function $c9742a26b2470517$export$90e00781bc59d8f9(focusedKey) {
    return (0, $acw62.useMemo)(()=>focusedKey != null ? new Set([
            focusedKey
        ]) : null, [
        focusedKey
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7304b6cd94823e88$export$d188a835a7bc5783 = (0, $acw62.createContext)({});
const $7304b6cd94823e88$export$f55761759794cf55 = (0, $acw62.createContext)(null);
const $7304b6cd94823e88$export$62ed72bc21f6b8a6 = (0, $acw62.forwardRef)(function DropIndicator(props, ref) {
    let { render: render } = (0, $acw62.useContext)($7304b6cd94823e88$export$f55761759794cf55);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render(props, ref));
});
function $7304b6cd94823e88$export$971707d8a129a1f7(dragAndDropHooks, dropState) {
    let renderDropIndicator = dragAndDropHooks?.renderDropIndicator;
    let isVirtualDragging = dragAndDropHooks?.isVirtualDragging?.();
    let fn = (0, $acw62.useCallback)((target)=>{
        // Only show drop indicators when virtual dragging or this is the current drop target.
        if (isVirtualDragging || dropState?.isDropTarget(target)) return renderDropIndicator ? renderDropIndicator(target) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7304b6cd94823e88$export$62ed72bc21f6b8a6, {
            target: target
        });
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dropState?.target,
        isVirtualDragging,
        renderDropIndicator
    ]);
    return dragAndDropHooks?.useDropIndicator ? fn : undefined;
}
function $7304b6cd94823e88$export$d1e8e3fbb7461f6(selectionManager, dragAndDropHooks, dropState) {
    // Persist the focused key and the drop target key.
    let focusedKey = selectionManager.focusedKey;
    let dropTargetKey = null;
    if (dragAndDropHooks?.isVirtualDragging?.() && dropState?.target?.type === 'item') {
        dropTargetKey = dropState.target.key;
        if (dropState.target.dropPosition === 'after') {
            // Normalize to the "before" drop position since we only render those to the DOM.
            let nextKey = dropState.collection.getKeyAfter(dropTargetKey);
            let lastDescendantKey = null;
            if (nextKey != null) {
                let targetLevel = dropState.collection.getItem(dropTargetKey)?.level ?? 0;
                // Skip over any rows that are descendants of the target ("after" position should be after all children)
                while(nextKey){
                    let node = dropState.collection.getItem(nextKey);
                    // eslint-disable-next-line max-depth
                    if (!node) break;
                    // Skip over non-item nodes (e.g., loaders) since they can't be drop targets.
                    // eslint-disable-next-line max-depth
                    if (node.type !== 'item') {
                        nextKey = dropState.collection.getKeyAfter(nextKey);
                        continue;
                    }
                    // Stop once we find an item at the same level or higher
                    // eslint-disable-next-line max-depth
                    if ((node.level ?? 0) <= targetLevel) break;
                    lastDescendantKey = nextKey;
                    nextKey = dropState.collection.getKeyAfter(nextKey);
                }
            }
            // If nextKey is null (end of collection), use the last descendant
            dropTargetKey = nextKey ?? lastDescendantKey ?? dropTargetKey;
        }
    }
    return (0, $acw62.useMemo)(()=>{
        return new Set([
            focusedKey,
            dropTargetKey
        ].filter((k)=>k != null));
    }, [
        focusedKey,
        dropTargetKey
    ]);
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $95906153127427b2$export$e0e4026c12a8bdbb = (0, $acw62.createContext)({});
const $95906153127427b2$export$8b251419efc915eb = (0, $18968b9ec17502c7$export$18af5c7a9e9b3664)((0, $5cc6cedd00940323$export$5ae2504e948afce5), function Header(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $95906153127427b2$export$e0e4026c12a8bdbb);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).header, {
        className: "react-aria-Header",
        ...props,
        ref: ref
    }, props.children);
});



/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Custom event names for updating the autocomplete's aria-activedecendant.
const $ae953e6954b92065$export$447a38995de2c711 = 'react-aria-clear-focus';
const $ae953e6954b92065$export$831c820ad60f9d12 = 'react-aria-focus';




function $c842d318e9d3d067$export$76e4e37e5339496d(to) {
    let from = $c842d318e9d3d067$export$759df0d867455a91((0, $c8e82650210ecd78$export$b204af158042fbac)(to));
    if (from !== to) {
        if (from) $c842d318e9d3d067$export$6c5dc7e81d2cc29a(from, to);
        if (to) $c842d318e9d3d067$export$2b35b76d2e30e129(to, from);
    }
}
function $c842d318e9d3d067$export$6c5dc7e81d2cc29a(from, to) {
    from.dispatchEvent(new FocusEvent('blur', {
        relatedTarget: to
    }));
    from.dispatchEvent(new FocusEvent('focusout', {
        bubbles: true,
        relatedTarget: to
    }));
}
function $c842d318e9d3d067$export$2b35b76d2e30e129(to, from) {
    to.dispatchEvent(new FocusEvent('focus', {
        relatedTarget: from
    }));
    to.dispatchEvent(new FocusEvent('focusin', {
        bubbles: true,
        relatedTarget: from
    }));
}
function $c842d318e9d3d067$export$759df0d867455a91(document) {
    let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(document);
    let activeDescendant = activeElement?.getAttribute('aria-activedescendant');
    if (activeDescendant) return document.getElementById(activeDescendant) || activeElement;
    return activeElement;
}





var $af107dbe0e7155b3$export$2e2bcd8739ae039 = {};
$af107dbe0e7155b3$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`
};


var $750248cfbad47bb8$export$2e2bcd8739ae039 = {};
$750248cfbad47bb8$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};


var $777f0efe3531f380$export$2e2bcd8739ae039 = {};
$777f0efe3531f380$export$2e2bcd8739ae039 = {
    "collectionLabel": `N\xe1vrhy`
};


var $0dc5b99ad771c75d$export$2e2bcd8739ae039 = {};
$0dc5b99ad771c75d$export$2e2bcd8739ae039 = {
    "collectionLabel": `Forslag`
};


var $d9919a100b79bbbd$export$2e2bcd8739ae039 = {};
$d9919a100b79bbbd$export$2e2bcd8739ae039 = {
    "collectionLabel": `Empfehlungen`
};


var $78f6bb513a6c9153$export$2e2bcd8739ae039 = {};
$78f6bb513a6c9153$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
};


var $b38e73501202dd64$export$2e2bcd8739ae039 = {};
$b38e73501202dd64$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggestions`
};


var $bf7e3cc975bb3158$export$2e2bcd8739ae039 = {};
$bf7e3cc975bb3158$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugerencias`
};


var $df00343bbbfa9668$export$2e2bcd8739ae039 = {};
$df00343bbbfa9668$export$2e2bcd8739ae039 = {
    "collectionLabel": `Soovitused`
};


var $27c7ac5ac52218a0$export$2e2bcd8739ae039 = {};
$27c7ac5ac52218a0$export$2e2bcd8739ae039 = {
    "collectionLabel": `Ehdotukset`
};


var $2ef123a6454b0516$export$2e2bcd8739ae039 = {};
$2ef123a6454b0516$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggestions`
};


var $f44d0419994b0f4b$export$2e2bcd8739ae039 = {};
$f44d0419994b0f4b$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`
};


var $ac54dc540d2a22e0$export$2e2bcd8739ae039 = {};
$ac54dc540d2a22e0$export$2e2bcd8739ae039 = {
    "collectionLabel": `Prijedlozi`
};


var $379f07e3f1089cda$export$2e2bcd8739ae039 = {};
$379f07e3f1089cda$export$2e2bcd8739ae039 = {
    "collectionLabel": `Javaslatok`
};


var $84b564135169d8c2$export$2e2bcd8739ae039 = {};
$84b564135169d8c2$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggerimenti`
};


var $c3112dbc707cec1d$export$2e2bcd8739ae039 = {};
$c3112dbc707cec1d$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5019}\u{88DC}`
};


var $0eabcf88e3ddb23a$export$2e2bcd8739ae039 = {};
$0eabcf88e3ddb23a$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{C81C}\u{C548}`
};


var $f06c12d9f72d26c3$export$2e2bcd8739ae039 = {};
$f06c12d9f72d26c3$export$2e2bcd8739ae039 = {
    "collectionLabel": `Pasi\u{16B}lymai`
};


var $da3bfac5297d11d5$export$2e2bcd8739ae039 = {};
$da3bfac5297d11d5$export$2e2bcd8739ae039 = {
    "collectionLabel": `Ieteikumi`
};


var $d60e8b0b9e550dae$export$2e2bcd8739ae039 = {};
$d60e8b0b9e550dae$export$2e2bcd8739ae039 = {
    "collectionLabel": `Forslag`
};


var $00939a1d5c83d278$export$2e2bcd8739ae039 = {};
$00939a1d5c83d278$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggesties`
};


var $ef4c27643fd3b4a9$export$2e2bcd8739ae039 = {};
$ef4c27643fd3b4a9$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugestie`
};


var $00a5a54f4cda0dd4$export$2e2bcd8739ae039 = {};
$00a5a54f4cda0dd4$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugest\xf5es`
};


var $010ef62fe72be9a9$export$2e2bcd8739ae039 = {};
$010ef62fe72be9a9$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugest\xf5es`
};


var $745076af98d891cd$export$2e2bcd8739ae039 = {};
$745076af98d891cd$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugestii`
};


var $17b30a2bae153520$export$2e2bcd8739ae039 = {};
$17b30a2bae153520$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};


var $8b7fbb070bae004e$export$2e2bcd8739ae039 = {};
$8b7fbb070bae004e$export$2e2bcd8739ae039 = {
    "collectionLabel": `N\xe1vrhy`
};


var $02c10deac578a80c$export$2e2bcd8739ae039 = {};
$02c10deac578a80c$export$2e2bcd8739ae039 = {
    "collectionLabel": `Predlogi`
};


var $f98d850cfe75a1c0$export$2e2bcd8739ae039 = {};
$f98d850cfe75a1c0$export$2e2bcd8739ae039 = {
    "collectionLabel": `Predlozi`
};


var $eab2f006e8cd9628$export$2e2bcd8739ae039 = {};
$eab2f006e8cd9628$export$2e2bcd8739ae039 = {
    "collectionLabel": `F\xf6rslag`
};


var $302f84501d60d739$export$2e2bcd8739ae039 = {};
$302f84501d60d739$export$2e2bcd8739ae039 = {
    "collectionLabel": `\xd6neriler`
};


var $f361d694ffa83167$export$2e2bcd8739ae039 = {};
$f361d694ffa83167$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`
};


var $2f37dafae7d6ad6a$export$2e2bcd8739ae039 = {};
$2f37dafae7d6ad6a$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5EFA}\u{8BAE}`
};


var $93db4dbaa6d5f7fb$export$2e2bcd8739ae039 = {};
$93db4dbaa6d5f7fb$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5EFA}\u{8B70}`
};


var $8068350e9dca23d4$export$2e2bcd8739ae039 = {};
$8068350e9dca23d4$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $af107dbe0e7155b3$export$2e2bcd8739ae039),
    "bg-BG": (0, $750248cfbad47bb8$export$2e2bcd8739ae039),
    "cs-CZ": (0, $777f0efe3531f380$export$2e2bcd8739ae039),
    "da-DK": (0, $0dc5b99ad771c75d$export$2e2bcd8739ae039),
    "de-DE": (0, $d9919a100b79bbbd$export$2e2bcd8739ae039),
    "el-GR": (0, $78f6bb513a6c9153$export$2e2bcd8739ae039),
    "en-US": (0, $b38e73501202dd64$export$2e2bcd8739ae039),
    "es-ES": (0, $bf7e3cc975bb3158$export$2e2bcd8739ae039),
    "et-EE": (0, $df00343bbbfa9668$export$2e2bcd8739ae039),
    "fi-FI": (0, $27c7ac5ac52218a0$export$2e2bcd8739ae039),
    "fr-FR": (0, $2ef123a6454b0516$export$2e2bcd8739ae039),
    "he-IL": (0, $f44d0419994b0f4b$export$2e2bcd8739ae039),
    "hr-HR": (0, $ac54dc540d2a22e0$export$2e2bcd8739ae039),
    "hu-HU": (0, $379f07e3f1089cda$export$2e2bcd8739ae039),
    "it-IT": (0, $84b564135169d8c2$export$2e2bcd8739ae039),
    "ja-JP": (0, $c3112dbc707cec1d$export$2e2bcd8739ae039),
    "ko-KR": (0, $0eabcf88e3ddb23a$export$2e2bcd8739ae039),
    "lt-LT": (0, $f06c12d9f72d26c3$export$2e2bcd8739ae039),
    "lv-LV": (0, $da3bfac5297d11d5$export$2e2bcd8739ae039),
    "nb-NO": (0, $d60e8b0b9e550dae$export$2e2bcd8739ae039),
    "nl-NL": (0, $00939a1d5c83d278$export$2e2bcd8739ae039),
    "pl-PL": (0, $ef4c27643fd3b4a9$export$2e2bcd8739ae039),
    "pt-BR": (0, $00a5a54f4cda0dd4$export$2e2bcd8739ae039),
    "pt-PT": (0, $010ef62fe72be9a9$export$2e2bcd8739ae039),
    "ro-RO": (0, $745076af98d891cd$export$2e2bcd8739ae039),
    "ru-RU": (0, $17b30a2bae153520$export$2e2bcd8739ae039),
    "sk-SK": (0, $8b7fbb070bae004e$export$2e2bcd8739ae039),
    "sl-SI": (0, $02c10deac578a80c$export$2e2bcd8739ae039),
    "sr-SP": (0, $f98d850cfe75a1c0$export$2e2bcd8739ae039),
    "sv-SE": (0, $eab2f006e8cd9628$export$2e2bcd8739ae039),
    "tr-TR": (0, $302f84501d60d739$export$2e2bcd8739ae039),
    "uk-UA": (0, $f361d694ffa83167$export$2e2bcd8739ae039),
    "zh-CN": (0, $2f37dafae7d6ad6a$export$2e2bcd8739ae039),
    "zh-TW": (0, $93db4dbaa6d5f7fb$export$2e2bcd8739ae039)
};




/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $04f975ad47e6ea6d$export$16792effe837dba3(e) {
    if ((0, $dd0d4fc527b0735d$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}
// HTML input types that do not cause the software keyboard to appear.
const $04f975ad47e6ea6d$var$$bb39c0fc1c19b34c$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $04f975ad47e6ea6d$export$c57958e35f31ed73(target) {
    return target instanceof HTMLInputElement && !$04f975ad47e6ea6d$var$$bb39c0fc1c19b34c$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b2a7046806938274$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(handler);
    let isDisabled = handler == null;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}






/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ff90e1c6d3535329$var$$a747a10fe70a57da$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
const $ff90e1c6d3535329$var$$a747a10fe70a57da$var$stringsSymbol = Symbol.for('react-aria.i18n.strings');
let $ff90e1c6d3535329$var$$a747a10fe70a57da$var$cachedGlobalStrings = undefined;
class $ff90e1c6d3535329$export$c17fa47878dc55b6 {
    constructor(messages, defaultLocale = 'en-US'){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $ff90e1c6d3535329$var$$a747a10fe70a57da$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === 'undefined') return null;
        let locale = window[$ff90e1c6d3535329$var$$a747a10fe70a57da$var$localeSymbol];
        if ($ff90e1c6d3535329$var$$a747a10fe70a57da$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$ff90e1c6d3535329$var$$a747a10fe70a57da$var$stringsSymbol];
            if (!globalStrings) return null;
            $ff90e1c6d3535329$var$$a747a10fe70a57da$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$ff90e1c6d3535329$var$$a747a10fe70a57da$var$cachedGlobalStrings[pkg] = new $ff90e1c6d3535329$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $ff90e1c6d3535329$var$$a747a10fe70a57da$var$cachedGlobalStrings?.[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
}
function $ff90e1c6d3535329$var$$a747a10fe70a57da$var$getStringsForLocale(locale, strings, defaultLocale = 'en-US') {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $ff90e1c6d3535329$var$$a747a10fe70a57da$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + '-')) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $ff90e1c6d3535329$var$$a747a10fe70a57da$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split('-')[0];
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9669c9aa003608a2$var$$b27c684a33948c64$var$pluralRulesCache = new Map();
const $9669c9aa003608a2$var$$b27c684a33948c64$var$numberFormatCache = new Map();
class $9669c9aa003608a2$export$2f817fcdc4b89ae0 {
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === 'function' ? message(variables, this) : message;
    }
    plural(count, options, type = 'cardinal') {
        let opt = options['=' + count];
        if (opt) return typeof opt === 'function' ? opt() : opt;
        let key = this.locale + ':' + type;
        let pluralRules = $9669c9aa003608a2$var$$b27c684a33948c64$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $9669c9aa003608a2$var$$b27c684a33948c64$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
    number(value) {
        let numberFormat = $9669c9aa003608a2$var$$b27c684a33948c64$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $9669c9aa003608a2$var$$b27c684a33948c64$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fd75b5296f720c9c$var$$cf2482eff2eeeec2$var$cache = new WeakMap();
function $fd75b5296f720c9c$var$$cf2482eff2eeeec2$var$getCachedDictionary(strings) {
    let dictionary = $fd75b5296f720c9c$var$$cf2482eff2eeeec2$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $ff90e1c6d3535329$export$c17fa47878dc55b6)(strings);
        $fd75b5296f720c9c$var$$cf2482eff2eeeec2$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $fd75b5296f720c9c$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $ff90e1c6d3535329$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $fd75b5296f720c9c$var$$cf2482eff2eeeec2$var$getCachedDictionary(strings);
}
function $fd75b5296f720c9c$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let dictionary = $fd75b5296f720c9c$export$87b761675e8eaa10(strings, packageName);
    return (0, $acw62.useMemo)(()=>new (0, $9669c9aa003608a2$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}




var $acw62 = parcelRequire("acw62");
function $fd5b3ca8197b50ac$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fd5b3ca8197b50ac$export$1e40b3ca02d92d21(props, state) {
    let { inputRef: inputRef, collectionRef: collectionRef, filter: filter, disableAutoFocusFirst: disableAutoFocusFirst = false, disableVirtualFocus: disableVirtualFocus = false } = props;
    let collectionId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let timeout = (0, $acw62.useRef)(undefined);
    let delayNextActiveDescendant = (0, $acw62.useRef)(false);
    let queuedActiveDescendant = (0, $acw62.useRef)(null);
    // For mobile screen readers, we don't want virtual focus, instead opting to disable FocusScope's restoreFocus and manually
    // moving focus back to the subtriggers
    let isMobileScreenReader = (0, $627d69440c27e5e4$export$630ff653c5ada6a9)() === 'virtual' && ((0, $dd0d4fc527b0735d$export$fedb369cb70207f1)() || (0, $dd0d4fc527b0735d$export$a11b0059900ceec8)());
    let [shouldUseVirtualFocus, setShouldUseVirtualFocus] = (0, $acw62.useState)(!isMobileScreenReader && !disableVirtualFocus);
    // Tracks if a collection has been connected to the autocomplete. If false, we don't want to add various attributes to the autocomplete input
    // since it isn't attached to a filterable collection (e.g. Tabs)
    let [hasCollection, setHasCollection] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        return ()=>clearTimeout(timeout.current);
    }, []);
    let updateActiveDescendantEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        // Ensure input is focused if the user clicks on the collection directly.
        // don't trigger on touch so that mobile keyboard doesnt appear when tapping on options
        if (!e.isTrusted && shouldUseVirtualFocus && inputRef.current && (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(inputRef.current)) !== inputRef.current && (0, $627d69440c27e5e4$export$887a228355cf7d95)() !== 'touch') inputRef.current.focus();
        let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (e.isTrusted || !target || queuedActiveDescendant.current === target.id) return;
        clearTimeout(timeout.current);
        if (target !== collectionRef.current) {
            if (delayNextActiveDescendant.current) {
                queuedActiveDescendant.current = target.id;
                timeout.current = setTimeout(()=>{
                    state.setFocusedNodeId(target.id);
                }, 500);
            } else {
                queuedActiveDescendant.current = target.id;
                state.setFocusedNodeId(target.id);
            }
        } else if (queuedActiveDescendant.current && !document.getElementById(queuedActiveDescendant.current)) {
            // If we recieve a focus event refocusing the collection, either we have newly refocused the input and are waiting for the
            // wrapped collection to refocus the previously focused node if any OR
            // we are in a state where we've filtered to such a point that there aren't any matching items in the collection to focus.
            // In this case we want to clear tracked item if any and clear active descendant
            queuedActiveDescendant.current = null;
            state.setFocusedNodeId(null);
        }
        delayNextActiveDescendant.current = false;
    });
    let [collectionNode, setCollectionNode] = (0, $acw62.useState)(null);
    let callbackRef = (0, $acw62.useCallback)((node)=>{
        setCollectionNode(node);
        if (node != null) {
            // If useSelectableCollection isn't passed shouldUseVirtualFocus even when useAutocomplete provides it
            // that means the collection doesn't support it (e.g. Table). If that is the case, we need to disable it here regardless
            // of what the user's provided so that the input doesn't recieve the onKeyDown and autocomplete props.
            if (node.getAttribute('tabindex') != null) setShouldUseVirtualFocus(false);
            setHasCollection(true);
        } else setHasCollection(false);
    }, []);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (collectionNode != null) // of the letter you just typed. If we recieve another focus event then we clear the queued update
        collectionNode.addEventListener('focusin', updateActiveDescendantEvent);
        return ()=>{
            collectionNode?.removeEventListener('focusin', updateActiveDescendantEvent);
        };
    }, [
        collectionNode
    ]);
    // Make sure to memo so that React doesn't keep registering a new event listeners on every rerender of the wrapped collection
    let mergedCollectionRef = (0, $0231fe790c02c958$export$4338b53315abf666)((0, $acw62.useMemo)(()=>(0, $eed06c8362986bd2$export$c9058316764c140e)(collectionRef, callbackRef), [
        collectionRef,
        callbackRef
    ]));
    let focusFirstItem = (0, $acw62.useCallback)(()=>{
        delayNextActiveDescendant.current = true;
        collectionRef.current?.dispatchEvent(new CustomEvent((0, $ae953e6954b92065$export$831c820ad60f9d12), {
            cancelable: true,
            bubbles: true,
            detail: {
                focusStrategy: 'first'
            }
        }));
    }, [
        collectionRef
    ]);
    let clearVirtualFocus = (0, $acw62.useCallback)((clearFocusKey)=>{
        (0, $c842d318e9d3d067$export$76e4e37e5339496d)((0, $8fd85525b97849bf$export$cd4e5573fbe2b576)());
        queuedActiveDescendant.current = null;
        state.setFocusedNodeId(null);
        let clearFocusEvent = new CustomEvent((0, $ae953e6954b92065$export$447a38995de2c711), {
            cancelable: true,
            bubbles: true,
            detail: {
                clearFocusKey: clearFocusKey
            }
        });
        clearTimeout(timeout.current);
        delayNextActiveDescendant.current = false;
        collectionRef.current?.dispatchEvent(clearFocusEvent);
    }, [
        collectionRef,
        state
    ]);
    let lastInputType = (0, $acw62.useRef)('');
    (0, $b2a7046806938274$export$90fc3a17d93f704c)(inputRef, 'input', (e)=>{
        let { inputType: inputType } = e;
        lastInputType.current = inputType;
    });
    let onChange = (value)=>{
        // Tell wrapped collection to focus the first element in the list when typing forward and to clear focused key when modifying the text via
        // copy paste/backspacing/undo/redo for screen reader announcements
        if (lastInputType.current === 'insertText' && !disableAutoFocusFirst) focusFirstItem();
        else if (lastInputType.current && (lastInputType.current.includes('insert') || lastInputType.current.includes('delete') || lastInputType.current.includes('history'))) {
            clearVirtualFocus(true);
            // If onChange was triggered before the timeout actually updated the activedescendant, we need to fire
            // our own dispatchVirtualFocus so focusVisible gets reapplied on the input
            if ((0, $c842d318e9d3d067$export$759df0d867455a91)(document) === inputRef.current) (0, $c842d318e9d3d067$export$2b35b76d2e30e129)(inputRef.current, null);
        }
        state.setInputValue(value);
    };
    let keyDownTarget = (0, $acw62.useRef)(null);
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        keyDownTarget.current = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (e.nativeEvent.isComposing) return;
        let focusedNodeId = queuedActiveDescendant.current;
        if (focusedNodeId !== null && (0, $c8e82650210ecd78$export$b204af158042fbac)(inputRef.current).getElementById(focusedNodeId) == null) {
            // if the focused id doesn't exist in document, then we need to clear the tracked focused node, otherwise
            // we will be attempting to fire key events on a non-existing node instead of trying to focus the newly swapped wrapped collection.
            // This can happen if you are swapping out the Autocomplete wrapped collection component like in the docs search.
            queuedActiveDescendant.current = null;
            focusedNodeId = null;
        }
        switch(e.key){
            case 'a':
                if ((0, $04f975ad47e6ea6d$export$16792effe837dba3)(e)) return;
                break;
            case 'Escape':
                // Early return for Escape here so it doesn't leak the Escape event from the simulated collection event below and
                // close the dialog prematurely. Ideally that should be up to the discretion of the input element hence the check
                // for isPropagationStopped
                if (e.isDefaultPrevented()) return;
                break;
            case ' ':
                // Space shouldn't trigger onAction so early return.
                return;
            case 'Tab':
                // Don't propogate Tab down to the collection, otherwise we will try to focus the collection via useSelectableCollection's Tab handler (aka shift tab logic)
                // We want FocusScope to handle Tab if one exists (aka sub dialog), so special casepropogate
                if ('continuePropagation' in e) e.continuePropagation();
                return;
            case 'Home':
            case 'End':
            case 'PageDown':
            case 'PageUp':
            case 'ArrowUp':
            case 'ArrowDown':
            case 'ArrowRight':
            case 'ArrowLeft':
                {
                    if ((e.key === 'Home' || e.key === 'End') && focusedNodeId == null && e.shiftKey) return;
                    // If there is text within the input field, we'll want continue propagating events down
                    // to the wrapped collection if there is a focused node so that a user can continue moving the
                    // virtual focus. However, if the user doesn't have a focus in the collection, just move the text
                    // cursor instead. They can move focus down into the collection via down/up arrow if need be
                    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && state.inputValue.length > 0) {
                        if (focusedNodeId == null) {
                            if (!e.isPropagationStopped()) e.stopPropagation();
                            return;
                        }
                        break;
                    }
                    // Prevent these keys from moving the text cursor in the input
                    e.preventDefault();
                    // Move virtual focus into the wrapped collection
                    let focusCollection = new CustomEvent((0, $ae953e6954b92065$export$831c820ad60f9d12), {
                        cancelable: true,
                        bubbles: true
                    });
                    collectionRef.current?.dispatchEvent(focusCollection);
                    break;
                }
        }
        // Emulate the keyboard events that happen in the input field in the wrapped collection. This is for triggering things like onAction via Enter
        // or moving focus from one item to another. Stop propagation on the input event if it isn't already stopped so it doesn't leak out. For events
        // like ESC, the dispatched event below will bubble out of the collection and be stopped if handled by useSelectableCollection, otherwise will bubble
        // as expected
        if (!e.isPropagationStopped()) e.stopPropagation();
        let shouldPerformDefaultAction = true;
        if (collectionRef.current !== null) {
            if (focusedNodeId == null) shouldPerformDefaultAction = collectionRef.current?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            else {
                let item = document.getElementById(focusedNodeId);
                if (item) shouldPerformDefaultAction = item?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            }
        }
        if (shouldPerformDefaultAction) switch(e.key){
            case 'ArrowLeft':
            case 'ArrowRight':
                // Clear the activedescendant so NVDA announcements aren't interrupted but retain the focused key in the collection so the
                // user's keyboard navigation restarts from where they left off
                clearVirtualFocus();
                break;
            case 'Enter':
                // Trigger click action on item when Enter key was pressed.
                if (focusedNodeId != null) {
                    let item = document.getElementById(focusedNodeId);
                    item?.dispatchEvent(new PointerEvent('click', e.nativeEvent));
                }
                break;
        }
        else e.preventDefault();
    };
    let onKeyUpCapture = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        // Dispatch simulated key up events for things like triggering links in listbox
        // Make sure to stop the propagation of the input keyup event so that the simulated keyup/down pair
        // is detected by usePress instead of the original keyup originating from the input
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === keyDownTarget.current) {
            e.stopImmediatePropagation();
            let focusedNodeId = queuedActiveDescendant.current;
            if (focusedNodeId == null) collectionRef.current?.dispatchEvent(new KeyboardEvent(e.type, e));
            else {
                let item = document.getElementById(focusedNodeId);
                item?.dispatchEvent(new KeyboardEvent(e.type, e));
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        document.addEventListener('keyup', onKeyUpCapture, true);
        return ()=>{
            document.removeEventListener('keyup', onKeyUpCapture, true);
        };
    }, []);
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($fd5b3ca8197b50ac$var$$parcel$interopDefault((0, $8068350e9dca23d4$export$2e2bcd8739ae039)), '@react-aria/autocomplete');
    let collectionProps = (0, $d00c1960ddd60c91$export$d6875122194c7b44)({
        id: collectionId,
        'aria-label': stringFormatter.format('collectionLabel')
    });
    let filterFn = (0, $acw62.useCallback)((nodeTextValue, node)=>{
        if (filter) return filter(nodeTextValue, state.inputValue, node);
        return true;
    }, [
        state.inputValue,
        filter
    ]);
    // Be sure to clear/restore the virtual + collection focus when blurring/refocusing the field so we only show the
    // focus ring on the virtually focused collection when are actually interacting with the Autocomplete
    let onBlur = (e)=>{
        if (!e.isTrusted) return;
        let lastFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (lastFocusedNode) (0, $c842d318e9d3d067$export$6c5dc7e81d2cc29a)(lastFocusedNode, e.relatedTarget);
    };
    let onFocus = (e)=>{
        if (!e.isTrusted) return;
        let curFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (curFocusedNode) {
            let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
            queueMicrotask(()=>{
                (0, $c842d318e9d3d067$export$6c5dc7e81d2cc29a)(target, collectionRef.current);
                (0, $c842d318e9d3d067$export$2b35b76d2e30e129)(collectionRef.current, target);
            });
        }
    };
    // Clicking back into the input can happen after focus moved elsewhere in the dialog, while
    // virtual focus is still on an option. Clear virtual focus on pointer down so mouse
    // interactions restore the input state before the click's focus handling runs.
    // Touch is excluded because touch interactions should not move focus back to the input.
    let onPointerDown = (e)=>{
        if (e.button !== 0 || e.pointerType === 'touch' || queuedActiveDescendant.current == null || inputRef.current == null) return;
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === inputRef.current) clearVirtualFocus();
    };
    // Only apply the autocomplete specific behaviors if the collection component wrapped by it is actually
    // being filtered/allows filtering by the Autocomplete.
    let inputProps = {
        value: state.inputValue,
        onChange: onChange
    };
    let virtualFocusProps = {
        onKeyDown: onKeyDown,
        'aria-activedescendant': state.focusedNodeId ?? undefined,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerDown: onPointerDown
    };
    if (hasCollection) inputProps = {
        ...inputProps,
        ...shouldUseVirtualFocus && virtualFocusProps,
        enterKeyHint: 'go',
        'aria-controls': collectionId,
        // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
        'aria-autocomplete': 'list',
        // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
        autoCorrect: 'off',
        // This disable's the macOS Safari spell check auto corrections.
        spellCheck: 'false',
        autoComplete: 'off'
    };
    return {
        inputProps: inputProps,
        collectionProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(collectionProps, {
            shouldUseVirtualFocus: shouldUseVirtualFocus,
            disallowTypeAhead: shouldUseVirtualFocus
        }),
        collectionRef: mergedCollectionRef,
        filter: filter != null ? filterFn : undefined
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Use the earliest effect possible to reset the ref below.
const $6f904fcfe20ed0fd$var$$3e6197669829fe11$var$useEarlyEffect = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useInsertionEffect'] ?? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};
function $6f904fcfe20ed0fd$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    // Store the value in both state and a ref. The state value will only be used when uncontrolled.
    // The ref is used to track the most current value, which is passed to the function setState callback.
    let [stateValue, setStateValue] = (0, $acw62.useState)(value || defaultValue);
    let valueRef = (0, $acw62.useRef)(stateValue);
    let isControlledRef = (0, $acw62.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $acw62.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    // After each render, update the ref to the current value.
    // This ensures that the setState callback argument is reset.
    // Note: the effect should not have any dependencies so that controlled values always reset.
    let currentValue = isControlled ? value : stateValue;
    $6f904fcfe20ed0fd$var$$3e6197669829fe11$var$useEarlyEffect(()=>{
        valueRef.current = currentValue;
    });
    let [, forceUpdate] = (0, $acw62.useReducer)(()=>({}), {});
    let setValue = (0, $acw62.useCallback)((value, ...args)=>{
        // @ts-ignore - TS doesn't know that T cannot be a function.
        let newValue = typeof value === 'function' ? value(valueRef.current) : value;
        if (!Object.is(valueRef.current, newValue)) {
            // Update the ref so that the next setState callback has the most recent value.
            valueRef.current = newValue;
            setStateValue(newValue);
            // Always trigger a re-render, even when controlled, so that the layout effect above runs to reset the value.
            forceUpdate();
            // Trigger onChange. Note that if setState is called multiple times in a single event,
            // onChange will be called for each one instead of only once.
            onChange?.(newValue, ...args);
        }
    }, [
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9fa05bc02085342b$export$ce1595f6e1a63433(props) {
    let { onInputChange: propsOnInputChange, inputValue: propsInputValue, defaultInputValue: propsDefaultInputValue = '' } = props;
    let onInputChange = (value)=>{
        if (propsOnInputChange) propsOnInputChange(value);
    };
    let [focusedNodeId, setFocusedNodeId] = (0, $acw62.useState)(null);
    let [inputValue, setInputValue] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(propsInputValue, propsDefaultInputValue, onInputChange);
    return {
        inputValue: inputValue,
        setInputValue: setInputValue,
        focusedNodeId: focusedNodeId,
        setFocusedNodeId: setFocusedNodeId
    };
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $80b3f40af2eadde4$export$36e687af51cd0967 = (0, $acw62.createContext)(null);
const $80b3f40af2eadde4$export$68ee3368b6d68148 = (0, $acw62.createContext)(null);
const $80b3f40af2eadde4$export$b0d3ecf7112093a7 = (0, $acw62.createContext)(null);
const $80b3f40af2eadde4$export$698f465ec27e93df = (0, $acw62.createContext)(null);
function $80b3f40af2eadde4$export$2f2b9559550c7bbc(props) {
    let ctx = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)($80b3f40af2eadde4$export$36e687af51cd0967, props.slot);
    props = (0, $195af97314dd822a$export$9d1611c77c2fe928)(ctx, props);
    let { filter: filter, disableAutoFocusFirst: disableAutoFocusFirst } = props;
    let state = (0, $9fa05bc02085342b$export$ce1595f6e1a63433)(props);
    let inputRef = (0, $acw62.useRef)(null);
    let collectionRef = (0, $acw62.useRef)(null);
    let { inputProps: inputProps, collectionProps: collectionProps, collectionRef: mergedCollectionRef, filter: filterFn } = (0, $fd5b3ca8197b50ac$export$1e40b3ca02d92d21)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        filter: filter,
        disableAutoFocusFirst: disableAutoFocusFirst,
        inputRef: inputRef,
        collectionRef: collectionRef
    }, state);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $80b3f40af2eadde4$export$68ee3368b6d68148,
                state
            ],
            [
                $80b3f40af2eadde4$export$698f465ec27e93df,
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                $80b3f40af2eadde4$export$b0d3ecf7112093a7,
                {
                    ...collectionProps,
                    filter: filterFn,
                    ref: mergedCollectionRef
                }
            ]
        ]
    }, props.children);
}





var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $08cc935c33eff3e5$var$$792f28e438b9ad5f$var$SharedElementContext = (0, $acw62.createContext)(null);
function $08cc935c33eff3e5$export$758399f318e6385a(props) {
    let ref = (0, $acw62.useRef)({});
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($08cc935c33eff3e5$var$$792f28e438b9ad5f$var$SharedElementContext.Provider, {
        value: ref
    }, props.children);
}
const $08cc935c33eff3e5$export$c34620ff8881d89f = (0, $acw62.forwardRef)(function SharedElement(props, ref) {
    let { name: name, isVisible: isVisible = true, children: children, className: className, style: style, render: render, ...divProps } = props;
    let [state, setState] = (0, $acw62.useState)(isVisible ? 'visible' : 'hidden');
    let scopeRef = (0, $acw62.useContext)($08cc935c33eff3e5$var$$792f28e438b9ad5f$var$SharedElementContext);
    if (!scopeRef) throw new Error('<SharedElement> must be rendered inside a <SharedElementTransition>');
    if (isVisible && state === 'hidden') setState('visible');
    ref = (0, $0231fe790c02c958$export$4338b53315abf666)(ref);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let element = ref.current;
        let scope = scopeRef.current;
        let prevSnapshot = scope[name];
        let frame = null;
        if (element && isVisible && prevSnapshot) {
            // Element is transitioning from a previous instance.
            setState('visible');
            let animations = element.getAnimations();
            // Set properties to animate from.
            let values = prevSnapshot.style.map(([property, prevValue])=>{
                let value = element.style[property];
                if (property === 'translate') {
                    let prevRect = prevSnapshot.rect;
                    let currentItem = element.getBoundingClientRect();
                    let deltaX = prevRect.left - currentItem?.left;
                    let deltaY = prevRect.top - currentItem?.top;
                    element.style.translate = `${deltaX}px ${deltaY}px`;
                } else element.style[property] = prevValue;
                return [
                    property,
                    value
                ];
            });
            // Cancel any new animations triggered by these properties.
            for (let a of element.getAnimations())if (!animations.includes(a)) a.cancel();
            // Remove overrides after one frame to animate to the current values.
            frame = requestAnimationFrame(()=>{
                frame = null;
                for (let [property, value] of values)element.style[property] = value;
            });
            delete scope[name];
        } else if (element && isVisible && !prevSnapshot) {
            // No previous instance exists, apply the entering state.
            queueMicrotask(()=>(0, $1u0KT.flushSync)(()=>setState('entering')));
            frame = requestAnimationFrame(()=>{
                frame = null;
                setState('visible');
            });
        } else if (element && !isVisible) // If so, no new SharedElement consumed it, so enter the exiting state.
        queueMicrotask(()=>{
            if (scope[name]) {
                delete scope[name];
                (0, $1u0KT.flushSync)(()=>setState('exiting'));
                Promise.all(element.getAnimations().map((a)=>a.finished)).then(()=>setState('hidden')).catch(()=>{});
            } else setState('hidden');
        });
        return ()=>{
            if (frame != null) cancelAnimationFrame(frame);
            if (element && element.isConnected && !element.hasAttribute('data-exiting')) {
                // On unmount, store a snapshot of the rectangle and computed style for transitioning properties.
                let style = window.getComputedStyle(element);
                if (style.transitionProperty !== 'none') {
                    let transitionProperty = style.transitionProperty.split(/\s*,\s*/);
                    scope[name] = {
                        rect: element.getBoundingClientRect(),
                        style: transitionProperty.map((p)=>[
                                p,
                                style[p]
                            ])
                    };
                }
            }
        };
    }, [
        ref,
        scopeRef,
        name,
        isVisible
    ]);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        children: children,
        className: className,
        style: style,
        render: render,
        values: {
            isEntering: state === 'entering',
            isExiting: state === 'exiting'
        }
    });
    if (state === 'hidden') return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...divProps,
        ...renderProps,
        ref: ref,
        "data-entering": state === 'entering' || undefined,
        "data-exiting": state === 'exiting' || undefined
    });
});



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f978dd1340ad1a86$export$c9549807523555e0 = (0, $acw62.createContext)({
    isSelected: false
});
const $f978dd1340ad1a86$export$17f80983afe4e444 = (0, $acw62.forwardRef)(function SelectionIndicator(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $f978dd1340ad1a86$export$c9549807523555e0);
    let { isSelected: isSelected, ...otherProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08cc935c33eff3e5$export$c34620ff8881d89f), {
        ...otherProps,
        ref: ref,
        className: props.className || 'react-aria-SelectionIndicator',
        name: "SelectionIndicator",
        isVisible: isSelected
    });
});




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $58a91265a88a8484$export$52210f68a14655d0(props) {
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === 'vertical') ariaOrientation = 'vertical';
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== 'hr') return {
        separatorProps: {
            ...domProps,
            role: 'separator',
            'aria-orientation': ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3866bf926703ac65$export$6615d83f6de245ce = (0, $acw62.createContext)({});
class $3866bf926703ac65$export$7750289ca694c0b5 extends (0, $5cc6cedd00940323$export$d68d59712b04d9d1) {
    static{
        this.type = 'separator';
    }
    filter(collection, newCollection) {
        let prevItem = newCollection.getItem(this.prevKey);
        if (prevItem && prevItem.type !== 'separator') {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
const $3866bf926703ac65$export$1ff3c3f08ae963c0 = (0, $18968b9ec17502c7$export$18af5c7a9e9b3664)($3866bf926703ac65$export$7750289ca694c0b5, function Separator(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $3866bf926703ac65$export$6615d83f6de245ce);
    let { elementType: elementType, orientation: orientation, style: style, className: className, slot: slot, ...otherProps } = props;
    let Element = elementType || 'hr';
    if (Element === 'hr' && orientation === 'vertical') Element = 'div';
    let ElementType = (0, $78f7e4721048d8d5$export$df3a06d6289f983e)[Element];
    let { separatorProps: separatorProps } = (0, $58a91265a88a8484$export$52210f68a14655d0)({
        ...otherProps,
        elementType: elementType,
        orientation: orientation
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        render: props.render,
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, separatorProps),
        style: style,
        className: className ?? 'react-aria-Separator',
        ref: ref,
        slot: slot || undefined
    });
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9b7271d3af613df1$export$9afb8bc826b033ea = (0, $acw62.createContext)({});
const $9b7271d3af613df1$export$5f1af8db9871e1d6 = (0, $acw62.forwardRef)(function Text(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $9b7271d3af613df1$export$9afb8bc826b033ea);
    let { elementType: elementType = 'span', ...domProps } = props;
    let ElementType = (0, $78f7e4721048d8d5$export$df3a06d6289f983e)[elementType];
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        className: "react-aria-Text",
        ...domProps,
        ref: ref
    });
});



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $08de3e3886d23c85$export$3585ede4d035bf14 = new WeakMap();
function $08de3e3886d23c85$var$$cd088b5c0d7b27b4$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $08de3e3886d23c85$export$9145995848b05025(state, itemKey) {
    let data = $08de3e3886d23c85$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error('Unknown list');
    return `${data.id}-option-${$08de3e3886d23c85$var$$cd088b5c0d7b27b4$var$normalizeKey(itemKey)}`;
}













// https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/ShadowTreeWalker.ts
class $51f33e0a80159b58$export$63eb3ababa9c55c4 {
    constructor(doc, root, whatToShow, filter){
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = (node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                const shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    if (typeof this.filter === 'function') return this.filter(node);
                    else if (this.filter?.acceptNode) return this.filter.acceptNode(node);
                    else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter ?? null;
        this.whatToShow = whatToShow ?? NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        const shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
    get currentNode() {
        return this._currentNode;
    }
    set currentNode(node) {
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(this.root, node)) throw new Error('Cannot set currentNode to a node that is not contained by the root node.');
        const walkers = [];
        let curNode = node;
        let currentWalkerCurrentNode = node;
        this._currentNode = node;
        while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            const shadowRoot = curNode;
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            walkers.push(walker);
            walker.currentNode = currentWalkerCurrentNode;
            this._currentSetFor.add(walker);
            curNode = currentWalkerCurrentNode = shadowRoot.host;
        } else curNode = curNode.parentNode;
        const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
            acceptNode: this._acceptNode
        });
        walkers.push(walker);
        walker.currentNode = currentWalkerCurrentNode;
        this._currentSetFor.add(walker);
        this._walkerStack = walkers;
    }
    get doc() {
        return this._doc;
    }
    firstChild() {
        let currentNode = this.currentNode;
        let newNode = this.nextNode();
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(currentNode, newNode)) {
            this.currentNode = currentNode;
            return null;
        }
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    lastChild() {
        let walker = this._walkerStack[0];
        let newNode = walker.lastChild();
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    nextNode() {
        const nextNode = this._walkerStack[0].nextNode();
        if (nextNode) {
            const shadowRoot = nextNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(nextNode);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    this.currentNode = nextNode;
                    return nextNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (nextNode) this.currentNode = nextNode;
            return nextNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    previousNode() {
        const currentWalker = this._walkerStack[0];
        if (currentWalker.currentNode === currentWalker.root) {
            if (this._currentSetFor.has(currentWalker)) {
                this._currentSetFor.delete(currentWalker);
                if (this._walkerStack.length > 1) {
                    this._walkerStack.shift();
                    let newNode = this.previousNode();
                    if (newNode) this.currentNode = newNode;
                    return newNode;
                } else return null;
            }
            return null;
        }
        const previousNode = currentWalker.previousNode();
        if (previousNode) {
            const shadowRoot = previousNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(previousNode);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    if (previousNode) this.currentNode = previousNode;
                    return previousNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.lastChild();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (previousNode) this.currentNode = previousNode;
            return previousNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.previousNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    /**
     * @deprecated
     */ nextSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
     * @deprecated
     */ previousSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
     * @deprecated
     */ parentNode() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
}
function $51f33e0a80159b58$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
    if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) return new $51f33e0a80159b58$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
    return doc.createTreeWalker(root, whatToShow, filter);
}










var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT = 'react-aria-focus-scope-restore';
let $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = null;
function $5c60d71a4f66bda5$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)(null);
    let endRef = (0, $acw62.useRef)(null);
    let scopeRef = (0, $acw62.useRef)([]);
    let { parentNode: parentNode } = (0, $acw62.useContext)($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $acw62.useMemo)(()=>new $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $5c60d71a4f66bda5$export$d06fae2ee68b101e.root;
        if ($5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope && !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isAncestorScope($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope, parent.scopeRef)) {
            let activeNode = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $5c60d71a4f66bda5$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let node = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current?.nextSibling;
        let nodes = [];
        let stopPropagation = (e)=>e.stopPropagation();
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return ()=>{
            for (let node of nodes)node.removeEventListener($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT, stopPropagation);
        };
    }, [
        children
    ]);
    $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useFocusContainment(scopeRef, contain);
    $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useAutoFocus(scopeRef, autoFocus);
    (0, $acw62.useEffect)(()=>{
        const activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined));
        let scope = null;
        if ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $5c60d71a4f66bda5$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            // Scope may have been re-parented.
            let parentScope = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scopeRef)?.parent?.scopeRef ?? null;
            if ((scopeRef === $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope || $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isAncestorScope(scopeRef, $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope)) && (!parentScope || $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(parentScope))) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = parentScope;
            $5c60d71a4f66bda5$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $acw62.useMemo)(()=>$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $acw62.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $5c60d71a4f66bda5$export$10c5169755ce7bd7() {
    return (0, $acw62.useContext)($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$FocusContext)?.focusManager;
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(scope[0] ?? undefined));
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(scope[0] ?? undefined));
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) {
    let scope = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getRadiosInGroup(element) {
    if (!element.form) return Array.from((0, $c8e82650210ecd78$export$b204af158042fbac)(element).querySelectorAll(`input[type="radio"][name="${CSS.escape(element.name)}"]`)).filter((radio)=>!radio.form);
    // namedItem returns RadioNodeList (iterable) for 2+ elements, but a single Element for exactly 1.
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormControlsCollection/namedItem
    const radioList = element.form.elements.namedItem(element.name);
    let ownerWindow = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(element);
    if (radioList instanceof ownerWindow.RadioNodeList) return Array.from(radioList).filter((el)=>el instanceof ownerWindow.HTMLInputElement);
    if (radioList instanceof ownerWindow.HTMLInputElement) return [
        radioList
    ];
    return [];
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isTabbableRadio(element) {
    if (element.checked) return true;
    const radios = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getRadiosInGroup(element);
    return radios.length > 0 && !radios.some((radio)=>radio.checked);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)(undefined);
    let raf = (0, $acw62.useRef)(undefined);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument);
            let scope = scopeRef.current;
            if (!scope || !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) {
                $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nextElement, true);
                if (nextElement instanceof (0, $c8e82650210ecd78$export$f21a1ffae260145a)(nextElement).HTMLInputElement) nextElement.select();
            }
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope || $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isAncestorScope($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope, scopeRef)) && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e), scopeRef.current)) {
                $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
                focusedNode.current = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
            } else if ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) && !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e), scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope.current) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusFirstInScope($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope.current);
            } else if ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef)) focusedNode.current = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Patches infinite focus coersion loop for Android Talkback where the user isn't able to move the virtual cursor
                // if within a containing focus scope. Bug filed against Chrome: https://issuetracker.google.com/issues/384844019.
                // Note that this means focus can leave focus containing modals due to this, but it is isolated to Chrome Talkback.
                let modality = (0, $627d69440c27e5e4$export$630ff653c5ada6a9)();
                let shouldSkipFocusRestore = (modality === 'virtual' || modality === null) && (0, $dd0d4fc527b0735d$export$a11b0059900ceec8)() && (0, $dd0d4fc527b0735d$export$6446a186d09e379e)();
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument);
                if (!shouldSkipFocusRestore && activeElement && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) && !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(activeElement, scopeRef)) {
                    $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
                    let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
                    if (target && target.isConnected) {
                        focusedNode.current = target;
                        focusedNode.current?.focus();
                    } else if ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope.current) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusFirstInScope($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener('keydown', onKeyDown, false);
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope?.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        scope?.forEach((element)=>element.addEventListener('focusout', onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener('keydown', onKeyDown, false);
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope?.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
            scope?.forEach((element)=>element.removeEventListener('focusout', onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInAnyScope(element) {
    return $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(element);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>(0, $8fd85525b97849bf$export$4282f70798064fe0)(node, element));
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $5c60d71a4f66bda5$export$d06fae2ee68b101e.traverse($5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $5c60d71a4f66bda5$export$1258395f99bf9cbf(element) {
    return $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(element, $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isAncestorScope(ancestor, scope) {
    let parent = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scope)?.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $ea661b83393f500e$export$80f3e147d781571c)(element);
    } catch  {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch  {
    // ignore
    }
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
    let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
        walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    return nextNode;
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusFirstInScope(scope, tabbable = true) {
    $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getFirstInScope(scope, tabbable));
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
            const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope((0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument), $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope.current) && scopeRef.current) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
            if ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(target, scopeRef.current)) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
            else if (!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInAnyScope(target)) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = null;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope?.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope?.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldRestoreFocus(scopeRef) {
    let scope = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return scope?.scopeRef === scopeRef;
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== 'undefined' ? (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined)) : null);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope || $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isAncestorScope($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope, scopeRef)) && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope((0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument), scopeRef.current)) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope?.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope?.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(focusedElement, scopeRef) || !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldRestoreFocus(scopeRef)) return;
            let treeNode = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !nodeToRestore.isConnected || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(nextElement, scopeRef));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $c8e82650210ecd78$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        treeNode.nodeToRestore = nodeToRestoreRef.current ?? undefined;
        return ()=>{
            let treeNode = $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)(ownerDocument);
            if (restoreFocus && nodeToRestore && (activeElement && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInChildScope(activeElement, scopeRef) || activeElement === ownerDocument.body && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $5c60d71a4f66bda5$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $5c60d71a4f66bda5$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                let node = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$getFirstInScope(treeNode.scopeRef.current, true);
                                $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$restoreFocusToElement(node);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(node);
}
function $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(root, opts, scope) {
    let filter = opts?.tabbable ? (0, $aa0a68d418bbb48e$export$bebd5a1431fec25d) : (0, $aa0a68d418bbb48e$export$4c063cf1350e6fed);
    // Ensure that root is an Element or fall back appropriately
    let rootElement = root?.nodeType === Node.ELEMENT_NODE ? root : null;
    // Determine the document to use
    let doc = (0, $c8e82650210ecd78$export$b204af158042fbac)(rootElement);
    // Create a TreeWalker, ensuring the root is an Element or Document
    let walker = (0, $51f33e0a80159b58$export$4d0f8be8b12a7ef6)(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // Skip nodes inside the starting node.
            if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(opts?.from, node)) return NodeFilter.FILTER_REJECT;
            if (opts?.tabbable && node.tagName === 'INPUT' && node.getAttribute('type') === 'radio') {
                // If the radio is in a form, we can get all the other radios by name
                if (!$5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isTabbableRadio(node)) return NodeFilter.FILTER_REJECT;
                // If the radio is in the same group as the current node and none are selected, we can skip it
                if (walker.currentNode.tagName === 'INPUT' && walker.currentNode.type === 'radio' && walker.currentNode.name === node.name) return NodeFilter.FILTER_REJECT;
            }
            if (filter(node) && (!scope || $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(node, scope)) && (!opts?.accept || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts?.from) walker.currentNode = opts.from;
    return walker;
}
function $5c60d71a4f66bda5$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(root));
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(root, node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)((0, $c8e82650210ecd78$export$b204af158042fbac)(root));
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(root, node)) walker.currentNode = node;
            else {
                let next = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$last(walker);
                if (next) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(next, true);
                return next ?? null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(previousNode, true);
            return previousNode ?? null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $5c60d71a4f66bda5$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$last(walker);
            if (next) $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$focusElement(next, true);
            return next ?? null;
        }
    };
}
function $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$Tree {
    constructor(){
        this.fastMap = new Map();
        this.root = new $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent ?? null);
        if (!parentNode) return;
        let node = new $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        let newTree = new $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$Tree();
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, node.parent?.scopeRef ?? null, node.nodeToRestore);
        return newTree;
    }
}
class $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$TreeNode {
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
}
let $5c60d71a4f66bda5$export$d06fae2ee68b101e = new $5c60d71a4f66bda5$var$$535772f9d2c1f38d$var$Tree();





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1d463ab6331131e4$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $dd0d4fc527b0735d$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $1d463ab6331131e4$export$c3d8340acf92597f(collectionRef, key) {
    let selector = `[data-key="${CSS.escape(String(key))}"]`;
    let collection = collectionRef.current?.dataset.collection;
    if (collection) selector = `[data-collection="${CSS.escape(collection)}"]${selector}`;
    return collectionRef.current?.querySelector(selector);
}
const $1d463ab6331131e4$var$$22bbea12c2567021$var$collectionMap = new WeakMap();
function $1d463ab6331131e4$export$881eb0d9f3605d9d(collection) {
    let id = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    $1d463ab6331131e4$var$$22bbea12c2567021$var$collectionMap.set(collection, id);
    return id;
}
function $1d463ab6331131e4$export$6aeb1680a0ae8741(collection) {
    return $1d463ab6331131e4$var$$22bbea12c2567021$var$collectionMap.get(collection);
}





/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a8a77caa3f8e5a02$export$2bb74740c4e19def(node, checkForOverflow) {
    if (!node) return false;
    let style = window.getComputedStyle(node);
    let root = document.scrollingElement || document.documentElement;
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    // Root element has `visible` overflow by default, but is scrollable nonetheless.
    if (node === root && style.overflow !== 'hidden') isScrollable = true;
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e2432c9017bae9d1$export$94ed1c92c7beeb22(node, checkForOverflow) {
    let parentElements = [];
    let root = document.scrollingElement || document.documentElement;
    do {
        if ((0, $a8a77caa3f8e5a02$export$2bb74740c4e19def)(node, checkForOverflow)) parentElements.push(node);
        node = node.parentElement;
    }while (node && node !== root);
    return parentElements;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fea4bf42b4a1cc33$export$53a0910f038337bd(scrollView, element, opts = {}) {
    let { block: block = 'nearest', inline: inline = 'nearest' } = opts;
    if (scrollView === element) return;
    let y = scrollView.scrollTop;
    let x = scrollView.scrollLeft;
    let target = element.getBoundingClientRect();
    let view = scrollView.getBoundingClientRect();
    let itemStyle = window.getComputedStyle(element);
    let viewStyle = window.getComputedStyle(scrollView);
    let root = document.scrollingElement || document.documentElement;
    let viewTop = scrollView === root ? 0 : view.top;
    let viewBottom = scrollView === root ? scrollView.clientHeight : view.bottom;
    let viewLeft = scrollView === root ? 0 : view.left;
    let viewRight = scrollView === root ? scrollView.clientWidth : view.right;
    let scrollMarginTop = parseInt(itemStyle.scrollMarginTop, 10) || 0;
    let scrollMarginBottom = parseInt(itemStyle.scrollMarginBottom, 10) || 0;
    let scrollMarginLeft = parseInt(itemStyle.scrollMarginLeft, 10) || 0;
    let scrollMarginRight = parseInt(itemStyle.scrollMarginRight, 10) || 0;
    let scrollPaddingTop = parseInt(viewStyle.scrollPaddingTop, 10) || 0;
    let scrollPaddingBottom = parseInt(viewStyle.scrollPaddingBottom, 10) || 0;
    let scrollPaddingLeft = parseInt(viewStyle.scrollPaddingLeft, 10) || 0;
    let scrollPaddingRight = parseInt(viewStyle.scrollPaddingRight, 10) || 0;
    let borderTopWidth = parseInt(viewStyle.borderTopWidth, 10) || 0;
    let borderBottomWidth = parseInt(viewStyle.borderBottomWidth, 10) || 0;
    let borderLeftWidth = parseInt(viewStyle.borderLeftWidth, 10) || 0;
    let borderRightWidth = parseInt(viewStyle.borderRightWidth, 10) || 0;
    let scrollAreaTop = target.top - scrollMarginTop;
    let scrollAreaBottom = target.bottom + scrollMarginBottom;
    let scrollAreaLeft = target.left - scrollMarginLeft;
    let scrollAreaRight = target.right + scrollMarginRight;
    let scrollBarOffsetX = scrollView === root ? 0 : borderLeftWidth + borderRightWidth;
    let scrollBarOffsetY = scrollView === root ? 0 : borderTopWidth + borderBottomWidth;
    let scrollBarWidth = scrollView.offsetWidth - scrollView.clientWidth - scrollBarOffsetX;
    let scrollBarHeight = scrollView.offsetHeight - scrollView.clientHeight - scrollBarOffsetY;
    let scrollPortTop = viewTop + borderTopWidth + scrollPaddingTop;
    let scrollPortBottom = viewBottom - borderBottomWidth - scrollPaddingBottom - scrollBarHeight;
    let scrollPortLeft = viewLeft + borderLeftWidth + scrollPaddingLeft;
    let scrollPortRight = viewRight - borderRightWidth - scrollPaddingRight;
    // IOS always positions the scrollbar on the right ¯\_(ツ)_/¯
    if (viewStyle.direction === 'rtl' && !(0, $dd0d4fc527b0735d$export$fedb369cb70207f1)()) scrollPortLeft += scrollBarWidth;
    else scrollPortRight -= scrollBarWidth;
    let shouldScrollBlock = scrollAreaTop < scrollPortTop || scrollAreaBottom > scrollPortBottom;
    let shouldScrollInline = scrollAreaLeft < scrollPortLeft || scrollAreaRight > scrollPortRight;
    if (shouldScrollBlock && block === 'start') y += scrollAreaTop - scrollPortTop;
    else if (shouldScrollBlock && block === 'center') y += (scrollAreaTop + scrollAreaBottom) / 2 - (scrollPortTop + scrollPortBottom) / 2;
    else if (shouldScrollBlock && block === 'end') y += scrollAreaBottom - scrollPortBottom;
    else if (shouldScrollBlock && block === 'nearest') {
        let start = scrollAreaTop - scrollPortTop;
        let end = scrollAreaBottom - scrollPortBottom;
        y += Math.abs(start) <= Math.abs(end) ? start : end;
    }
    if (shouldScrollInline && inline === 'start') x += scrollAreaLeft - scrollPortLeft;
    else if (shouldScrollInline && inline === 'center') x += (scrollAreaLeft + scrollAreaRight) / 2 - (scrollPortLeft + scrollPortRight) / 2;
    else if (shouldScrollInline && inline === 'end') x += scrollAreaRight - scrollPortRight;
    else if (shouldScrollInline && inline === 'nearest') {
        let start = scrollAreaLeft - scrollPortLeft;
        let end = scrollAreaRight - scrollPortRight;
        x += Math.abs(start) <= Math.abs(end) ? start : end;
    }
    scrollView.scrollTo({
        left: x,
        top: y
    });
}
function $fea4bf42b4a1cc33$export$c826860796309d1b(targetElement, opts = {}) {
    let { containingElement: containingElement } = opts;
    if (targetElement && targetElement.isConnected) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === 'hidden';
        if (!isScrollPrevented) {
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            // use scrollIntoView({block: 'nearest'}) instead of .focus to check if the element is fully in view or not since .focus()
            // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            targetElement?.scrollIntoView?.({
                block: 'nearest'
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                containingElement?.scrollIntoView?.({
                    block: 'center',
                    inline: 'center'
                });
                targetElement.scrollIntoView?.({
                    block: 'nearest'
                });
            }
        } else {
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            let scrollParents = (0, $e2432c9017bae9d1$export$94ed1c92c7beeb22)(targetElement, true);
            for (let scrollParent of scrollParents)$fea4bf42b4a1cc33$export$53a0910f038337bd(scrollParent, targetElement);
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                scrollParents = containingElement ? (0, $e2432c9017bae9d1$export$94ed1c92c7beeb22)(containingElement, true) : [];
                for (let scrollParent of scrollParents)$fea4bf42b4a1cc33$export$53a0910f038337bd(scrollParent, containingElement, {
                    block: 'center',
                    inline: 'center'
                });
            }
        }
    }
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $618460223b684d16$var$$f5a4a9a3486154da$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $618460223b684d16$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $acw62.useRef)({
        search: '',
        timeout: undefined
    }).current;
    let onKeyDown = (e)=>{
        let character = $618460223b684d16$var$$f5a4a9a3486154da$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) || state.search.length === 0 && character === ' ') return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === ' ' && state.search.trim().length > 0) {
            e.preventDefault();
            if (!('continuePropagation' in e)) e.stopPropagation();
        }
        state.search += character;
        if (keyboardDelegate.getKeyForSearch != null) {
            // Use the delegate to find a key to focus.
            // Prioritize items after the currently focused item, falling back to searching the whole list.
            let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
            // If no key found, search from the top.
            if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
            if (key != null) {
                selectionManager.setFocusedKey(key);
                if (onTypeSelect) onTypeSelect(key);
            }
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = '';
        }, $618460223b684d16$var$$f5a4a9a3486154da$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : undefined
        }
    };
}
function $618460223b684d16$var$$f5a4a9a3486154da$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return '';
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e30f5ecbce65d2c0$export$72ef708ab07251f1(effect, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    const lastDeps = (0, $acw62.useRef)(null);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}



var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $83a47f3f24e82e5a$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, escapeKeyBehavior: escapeKeyBehavior = 'clearSelection', selectOnFocus: selectOnFocus = manager.selectionBehavior === 'replace', disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = 'action' } = options;
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let router = (0, $dc5a334d7ad7481f$export$9a302a45f65d0572)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === 'Tab') e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current || !(0, $8fd85525b97849bf$export$4282f70798064fe0)(ref.current, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === 'selection' && selectOnFocus && !(0, $1d463ab6331131e4$export$d3e3bd3e26688c04)(e)) {
                    (0, $1u0KT.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = (0, $1d463ab6331131e4$export$c3d8340acf92597f)(ref, key);
                    let itemProps = manager.getItemProps(key);
                    if (item) router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === 'override') return;
                if (e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(key);
                else if (selectOnFocus && !(0, $1d463ab6331131e4$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case 'ArrowDown':
                if (delegate.getKeyBelow) {
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow?.(manager.focusedKey) : delegate.getFirstKey?.();
                    if (nextKey == null && shouldFocusWrap) nextKey = delegate.getFirstKey?.(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowUp':
                if (delegate.getKeyAbove) {
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove?.(manager.focusedKey) : delegate.getLastKey?.();
                    if (nextKey == null && shouldFocusWrap) nextKey = delegate.getLastKey?.(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowLeft':
                if (delegate.getKeyLeftOf) {
                    let nextKey = manager.focusedKey != null ? delegate.getKeyLeftOf?.(manager.focusedKey) : delegate.getFirstKey?.();
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? delegate.getFirstKey?.(manager.focusedKey) : delegate.getLastKey?.(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey, direction === 'rtl' ? 'first' : 'last');
                    }
                }
                break;
            case 'ArrowRight':
                if (delegate.getKeyRightOf) {
                    let nextKey = manager.focusedKey != null ? delegate.getKeyRightOf?.(manager.focusedKey) : delegate.getFirstKey?.();
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? delegate.getLastKey?.(manager.focusedKey) : delegate.getFirstKey?.(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey, direction === 'rtl' ? 'last' : 'first');
                    }
                }
                break;
            case 'Home':
                if (delegate.getFirstKey) {
                    if (manager.focusedKey === null && e.shiftKey) return;
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $04f975ad47e6ea6d$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if (firstKey != null) {
                        if ((0, $04f975ad47e6ea6d$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(firstKey);
                        else if (selectOnFocus) manager.replaceSelection(firstKey);
                    }
                }
                break;
            case 'End':
                if (delegate.getLastKey) {
                    if (manager.focusedKey === null && e.shiftKey) return;
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $04f975ad47e6ea6d$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if (lastKey != null) {
                        if ((0, $04f975ad47e6ea6d$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(lastKey);
                        else if (selectOnFocus) manager.replaceSelection(lastKey);
                    }
                }
                break;
            case 'PageDown':
                if (delegate.getKeyPageBelow && manager.focusedKey != null) {
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'PageUp':
                if (delegate.getKeyPageAbove && manager.focusedKey != null) {
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'a':
                if ((0, $04f975ad47e6ea6d$export$16792effe837dba3)(e) && manager.selectionMode === 'multiple' && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case 'Escape':
                if (escapeKeyBehavior === 'clearSelection' && !disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case 'Tab':
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $5c60d71a4f66bda5$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next = undefined;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        // If the active element is NOT tabbable but is contained by an element that IS tabbable (aka the cell), the browser will actually move focus to
                        // the containing element. We need to special case this so that tab will move focus out of the grid instead of looping between
                        // focusing the containing cell and back to the non-tabbable child element
                        let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
                        if (next && (!(0, $8fd85525b97849bf$export$b4f377a2b6254582)(next) || activeElement && !(0, $aa0a68d418bbb48e$export$bebd5a1431fec25d)(activeElement))) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    /// TODO: should this happen all the time??
    let scrollPos = (0, $acw62.useRef)({
        top: 0,
        left: 0
    });
    (0, $b2a7046806938274$export$90fc3a17d93f704c)(scrollRef, 'scroll', ()=>{
        scrollPos.current = {
            top: scrollRef.current?.scrollTop ?? 0,
            left: scrollRef.current?.scrollLeft ?? 0
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus && !manager.isSelected(key)) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToKey(manager.lastSelectedKey ?? delegate.getLastKey?.());
            else navigateToKey(manager.firstSelectedKey ?? delegate.getFirstKey?.());
        } else if (scrollRef.current) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (manager.focusedKey != null && scrollRef.current) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = (0, $1d463ab6331131e4$export$c3d8340acf92597f)(ref, manager.focusedKey);
            if (element instanceof HTMLElement) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!(0, $8fd85525b97849bf$export$b4f377a2b6254582)(element) && !shouldUseVirtualFocus) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(element);
                let modality = (0, $627d69440c27e5e4$export$630ff653c5ada6a9)();
                if (modality === 'keyboard') (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget)) manager.setFocused(false);
    };
    // Ref to track whether the first item in the collection should be automatically focused. Specifically used for autocomplete when user types
    // to focus the first key AFTER the collection updates.
    // TODO: potentially expand the usage of this
    let shouldVirtualFocusFirst = (0, $acw62.useRef)(false);
    (0, $b2a7046806938274$export$90fc3a17d93f704c)(ref, (0, $ae953e6954b92065$export$831c820ad60f9d12), !shouldUseVirtualFocus ? undefined : (e)=>{
        let { detail: detail } = e;
        e.stopPropagation();
        manager.setFocused(true);
        // If the user is typing forwards, autofocus the first option in the list.
        if (detail?.focusStrategy === 'first') shouldVirtualFocusFirst.current = true;
    });
    (0, $e30f5ecbce65d2c0$export$72ef708ab07251f1)(()=>{
        if (shouldVirtualFocusFirst.current) {
            let keyToFocus = delegate.getFirstKey?.() ?? null;
            // If no focusable items exist in the list, make sure to clear any activedescendant that may still exist and move focus back to
            // the original active element (e.g. the autocomplete input)
            if (keyToFocus == null) {
                let previousActiveElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
                (0, $c842d318e9d3d067$export$76e4e37e5339496d)(ref.current);
                (0, $c842d318e9d3d067$export$2b35b76d2e30e129)(previousActiveElement, null);
                // If there wasn't a focusable key but the collection had items, then that means we aren't in an intermediate load state and all keys are disabled.
                // Reset shouldVirtualFocusFirst so that we don't erronously autofocus an item when the collection is filtered again.
                if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
            } else {
                manager.setFocusedKey(keyToFocus);
                // Only set shouldVirtualFocusFirst to false if we've successfully set the first key as the focused key
                // If there wasn't a key to focus, we might be in a temporary loading state so we'll want to still focus the first key
                // after the collection updates after load
                shouldVirtualFocusFirst.current = false;
            }
        }
    }, [
        manager.collection
    ]);
    (0, $e30f5ecbce65d2c0$export$72ef708ab07251f1)(()=>{
        // If user causes the focused key to change in any other way, clear shouldVirtualFocusFirst so we don't
        // accidentally move focus from under them. Skip this if the collection was empty because we might be in a load
        // state and will still want to focus the first item after load
        if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
    }, [
        manager.focusedKey
    ]);
    (0, $b2a7046806938274$export$90fc3a17d93f704c)(ref, (0, $ae953e6954b92065$export$447a38995de2c711), !shouldUseVirtualFocus ? undefined : (e)=>{
        e.stopPropagation();
        manager.setFocused(false);
        if (e.detail?.clearFocusKey) manager.setFocusedKey(null);
    });
    const autoFocusRef = (0, $acw62.useRef)(autoFocus);
    const didAutoFocusRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === 'first') focusedKey = delegate.getFirstKey?.() ?? null;
            if (autoFocus === 'last') focusedKey = delegate.getLastKey?.() ?? null;
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus && ref.current) (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
            // Wait until the collection has items to autofocus.
            if (manager.collection.size > 0) {
                autoFocusRef.current = false;
                didAutoFocusRef.current = true;
            }
        }
    });
    // Scroll the focused element into view when the focusedKey changes.
    let lastFocusedKey = (0, $acw62.useRef)(manager.focusedKey);
    let raf = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (manager.isFocused && manager.focusedKey != null && (manager.focusedKey !== lastFocusedKey.current || didAutoFocusRef.current) && scrollRef.current && ref.current) {
            let modality = (0, $627d69440c27e5e4$export$630ff653c5ada6a9)();
            let element = (0, $1d463ab6331131e4$export$c3d8340acf92597f)(ref, manager.focusedKey);
            if (!(element instanceof HTMLElement)) // The collection may initially be empty (e.g. virtualizer), so wait until the element exists.
            return;
            if (modality === 'keyboard' || didAutoFocusRef.current) {
                if (raf.current) cancelAnimationFrame(raf.current);
                raf.current = requestAnimationFrame(()=>{
                    if (scrollRef.current) {
                        (0, $fea4bf42b4a1cc33$export$53a0910f038337bd)(scrollRef.current, element);
                        // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                        if (modality !== 'virtual') (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(element, {
                            containingElement: ref.current
                        });
                    }
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (!shouldUseVirtualFocus && manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null && ref.current) (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        didAutoFocusRef.current = false;
    });
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    (0, $b2a7046806938274$export$90fc3a17d93f704c)(ref, 'react-aria-focus-scope-restore', (e)=>{
        e.preventDefault();
        manager.setFocused(true);
    });
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $618460223b684d16$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $195af97314dd822a$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    let tabIndex = undefined;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    let collectionId = (0, $1d463ab6331131e4$export$881eb0d9f3605d9d)(manager.collection);
    return {
        collectionProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(handlers, {
            tabIndex: tabIndex,
            'data-collection': collectionId
        })
    };
}



/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $2e262f973170f80b$export$8f5ed9ff9f511381 {
    constructor(ref){
        this.ref = ref;
    }
    getItemRect(key) {
        let container = this.ref.current;
        if (!container) return null;
        let item = key != null ? (0, $1d463ab6331131e4$export$c3d8340acf92597f)(this.ref, key) : null;
        if (!item) return null;
        let containerRect = container.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        return {
            x: itemRect.left - containerRect.left - container.clientLeft + container.scrollLeft,
            y: itemRect.top - containerRect.top - container.clientTop + container.scrollTop,
            width: itemRect.width,
            height: itemRect.height
        };
    }
    getContentSize() {
        let container = this.ref.current;
        return {
            width: container?.scrollWidth ?? 0,
            height: container?.scrollHeight ?? 0
        };
    }
    getVisibleRect() {
        let container = this.ref.current;
        return {
            x: container?.scrollLeft ?? 0,
            y: container?.scrollTop ?? 0,
            width: container?.clientWidth ?? 0,
            height: container?.clientHeight ?? 0
        };
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a3fdb18a48ed07b4$export$a05409b8bb224a5a {
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || 'all';
            this.orientation = opts.orientation || 'vertical';
            this.direction = opts.direction;
            this.layout = opts.layout || 'stack';
            this.layoutDelegate = opts.layoutDelegate || new (0, $2e262f973170f80b$export$8f5ed9ff9f511381)(opts.ref);
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = 'stack';
            this.orientation = 'vertical';
            this.disabledBehavior = 'all';
            this.layoutDelegate = new (0, $2e262f973170f80b$export$8f5ed9ff9f511381)(this.ref);
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === 'stack' && this.orientation === 'vertical') {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
    isDisabled(item) {
        return this.disabledBehavior === 'all' && (item.props?.isDisabled || this.disabledKeys.has(item.key));
    }
    findNextNonDisabled(key, getNext) {
        let nextKey = key;
        while(nextKey != null){
            let item = this.collection.getItem(nextKey);
            if (item?.type === 'item' && !this.isDisabled(item)) return nextKey;
            nextKey = getNext(nextKey);
        }
        return null;
    }
    getNextKey(key) {
        let nextKey = key;
        nextKey = this.collection.getKeyAfter(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyAfter(key));
    }
    getPreviousKey(key) {
        let nextKey = key;
        nextKey = this.collection.getKeyBefore(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyBefore(key));
    }
    findKey(key, nextKey, shouldSkip) {
        let tempKey = key;
        let itemRect = this.layoutDelegate.getItemRect(tempKey);
        if (!itemRect || tempKey == null) return null;
        // Find the item above or below in the same column.
        let prevRect = itemRect;
        do {
            tempKey = nextKey(tempKey);
            if (tempKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(tempKey);
        }while (itemRect && shouldSkip(prevRect, itemRect) && tempKey != null);
        return tempKey;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.y === itemRect.y || prevRect.x !== itemRect.x;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.x === itemRect.x || prevRect.y !== itemRect.y;
    }
    getKeyBelow(key) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        // This is a temporary solution for CardView until we refactor useSelectableCollection.
        // https://github.com/orgs/adobe/projects/19/views/32?pane=issue&itemId=77825042
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyRightOf' : 'getKeyLeftOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key));
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'rtl');
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'rtl'), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'rtl');
        return null;
    }
    getKeyLeftOf(key) {
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyLeftOf' : 'getKeyRightOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key));
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'ltr');
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'ltr'), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'ltr');
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyAfter(key));
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyBefore(key));
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        if (menu && !(0, $a8a77caa3f8e5a02$export$2bb74740c4e19def)(menu)) return this.getFirstKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.max(0, itemRect.x + itemRect.width - this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x > pageX && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y > pageY && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey ?? this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        if (menu && !(0, $a8a77caa3f8e5a02$export$2bb74740c4e19def)(menu)) return this.getLastKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.min(this.layoutDelegate.getContentSize().width, itemRect.x - itemRect.width + this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x < pageX && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y - itemRect.height + this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y < pageY && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey ?? this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getNextKey(key);
        }
        return null;
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $040b7c2ffa13ce2b$var$$673d46fce3e5717d$var$cache = new Map();
function $040b7c2ffa13ce2b$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($040b7c2ffa13ce2b$var$$673d46fce3e5717d$var$cache.has(cacheKey)) return $040b7c2ffa13ce2b$var$$673d46fce3e5717d$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $040b7c2ffa13ce2b$var$$673d46fce3e5717d$var$cache.set(cacheKey, formatter);
    return formatter;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $06a03ced0cfc365c$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, orientation: orientation } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $040b7c2ffa13ce2b$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $a3fdb18a48ed07b4$export$a05409b8bb224a5a)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator,
            layoutDelegate: layoutDelegate,
            orientation: orientation
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior,
        orientation
    ]);
    let { collectionProps: collectionProps } = (0, $83a47f3f24e82e5a$export$d6daf82dcd84e87c)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dfa5b531f0e1c61b$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || 'toggle';
    let orientation = props.orientation || 'vertical';
    let linkBehavior = props.linkBehavior || (selectionBehavior === 'replace' ? 'action' : 'override');
    if (selectionBehavior === 'toggle' && linkBehavior === 'action') // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = 'override';
    let { listProps: listProps } = (0, $06a03ced0cfc365c$export$b95089534ab7c1fd)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $3af2a5641bd71461$export$f680877a34711e37)(props.id);
    (0, $08de3e3886d23c85$export$3585ede4d035bf14).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior,
        // @ts-ignore
        UNSTABLE_itemBehavior: props['UNSTABLE_itemBehavior']
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $f5e6258447762a7e$export$8467354a121f1b9f)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, focusWithinProps, state.selectionManager.selectionMode === 'multiple' ? {
            'aria-multiselectable': 'true'
        } : {}, {
            role: 'listbox',
            'aria-orientation': orientation,
            ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(fieldProps, listProps)
        })
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b7580a4132762537$export$c3f9f39876e4bc7(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Technically, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: 'presentation',
            onMouseDown: (e)=>{
                // Prevent DOM focus from moving on mouse down when using virtual focus
                e.preventDefault();
            }
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}





















var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $e653c573b0f229ee$var$$121970af65029459$var$descriptionId = 0;
const $e653c573b0f229ee$var$$121970af65029459$var$descriptionNodes = new Map();
function $e653c573b0f229ee$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $acw62.useState)();
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (!description) return;
        let desc = $e653c573b0f229ee$var$$121970af65029459$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$e653c573b0f229ee$var$$121970af65029459$var$descriptionId++}`;
            setId(id);
            let node = document.createElement('div');
            node.id = id;
            node.style.display = 'none';
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $e653c573b0f229ee$var$$121970af65029459$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $e653c573b0f229ee$var$$121970af65029459$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        'aria-describedby': description ? id : undefined
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5ed2f5a4901645c5$var$$7b01448eaad0fe7c$var$DEFAULT_THRESHOLD = 500;
function $5ed2f5a4901645c5$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $5ed2f5a4901645c5$var$$7b01448eaad0fe7c$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $acw62.useRef)(undefined);
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $a2eab827d897a6a9$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === 'mouse' || e.pointerType === 'touch') {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: 'longpressstart'
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent('pointercancel', {
                        bubbles: true
                    }));
                    // Ensure target is focused. On touch devices, browsers typically focus on pointer up.
                    if ((0, $c8e82650210ecd78$export$b204af158042fbac)(e.target).activeElement !== e.target) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(e.target);
                    if (onLongPress) onLongPress({
                        ...e,
                        type: 'longpress'
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === 'touch') {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    let ownerWindow = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(e.target);
                    addGlobalListener(e.target, 'contextmenu', onContextMenu, {
                        once: true
                    });
                    addGlobalListener(ownerWindow, 'pointerup', ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, 'contextmenu', onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd({
                ...e,
                type: 'longpressend'
            });
        }
    });
    let descriptionProps = (0, $e653c573b0f229ee$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9ef49e4bf6a3a063$export$ecf600387e221c37(options) {
    let { id: id, selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = 'action' } = options;
    let router = (0, $dc5a334d7ad7481f$export$9a302a45f65d0572)();
    id = (0, $3af2a5641bd71461$export$f680877a34711e37)(id);
    let onSelect = (e)=>{
        if (e.pointerType === 'keyboard' && (0, $1d463ab6331131e4$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === 'none') return;
            if (manager.isLink(key)) {
                if (linkBehavior === 'selection' && ref.current) {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === 'override' || linkBehavior === 'none') return;
            }
            if (manager.selectionMode === 'single') {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === 'toggle' || e && ((0, $04f975ad47e6ea6d$export$16792effe837dba3)(e) || e.pointerType === 'touch' || e.pointerType === 'virtual')) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $acw62.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused) {
            if (!shouldUseVirtualFocus) {
                if (focus) focus();
                else if ((0, $8fd85525b97849bf$export$cd4e5573fbe2b576)() !== ref.current && ref.current) (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
            } else (0, $c842d318e9d3d067$export$76e4e37e5339496d)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    (0, $acw62.useEffect)(()=>{
        if (isDisabled && manager.focusedKey === key) manager.setFocusedKey(null);
    }, [
        manager,
        isDisabled,
        key
    ]);
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === 'override';
    let isActionOverride = onAction && options['UNSTABLE_itemBehavior'] === 'action';
    let hasLinkAction = manager.isLink(key) && linkBehavior !== 'selection' && linkBehavior !== 'none';
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride && !isActionOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === 'replace' ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === 'replace';
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $acw62.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $acw62.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $acw62.useRef)(false);
    let collectionItemProps = manager.getItemProps(key);
    let performAction = (e)=>{
        if (onAction) {
            onAction();
            ref.current?.dispatchEvent(new CustomEvent('react-aria-item-action', {
                bubbles: true
            }));
        }
        if (hasLinkAction && ref.current) router.open(ref.current, e, collectionItemProps.href, collectionItemProps.routerOptions);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {
        ref: ref
    };
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === 'keyboard' && (!hasAction || $9ef49e4bf6a3a063$var$$f6ba6936bfd098a0$var$isSelectionKey(e.key))) onSelect(e);
        };
        // If allowsDifferentPressOrigin and interacting with mouse, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== 'mouse') {
                if (e.pointerType === 'keyboard' && !$9ef49e4bf6a3a063$var$$f6ba6936bfd098a0$var$isActionKey(e.key)) return;
                performAction(e);
            } else if (e.pointerType !== 'keyboard' && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? undefined : (e)=>{
                if (e.pointerType === 'mouse' && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : (e)=>{
                if (e.pointerType !== 'keyboard' && e.pointerType !== 'mouse' && allowsSelection) onSelect(e);
            };
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === 'mouse' && !hasPrimaryAction || e.pointerType === 'keyboard' && (!allowsActions || $9ef49e4bf6a3a063$var$$f6ba6936bfd098a0$var$isSelectionKey(e.key)))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === 'touch' || e.pointerType === 'pen' || e.pointerType === 'virtual' || e.pointerType === 'keyboard' && hasAction && $9ef49e4bf6a3a063$var$$f6ba6936bfd098a0$var$isActionKey(e.key) || e.pointerType === 'mouse' && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps['data-collection'] = (0, $1d463ab6331131e4$export$6aeb1680a0ae8741)(manager.collection);
    itemProps['data-key'] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    // When using virtual focus, make sure the focused key gets updated on press.
    if (shouldUseVirtualFocus) itemPressProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(itemPressProps, {
        onPressStart (e) {
            if (e.pointerType !== 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        },
        onPress (e) {
            if (e.pointerType === 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        }
    });
    if (collectionItemProps) {
        for (let key of [
            'onPressStart',
            'onPressEnd',
            'onPressChange',
            'onPress',
            'onPressUp',
            'onClick'
        ])if (collectionItemProps[key]) itemPressProps[key] = (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(itemPressProps[key], collectionItemProps[key]);
    }
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === 'mouse') {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $5ed2f5a4901645c5$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === 'touch') {
                onSelect(e);
                manager.setSelectionBehavior('toggle');
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === 'touch' && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = linkBehavior !== 'none' && manager.isLink(key) ? (e)=>{
        if (!(0, $dc5a334d7ad7481f$export$95185d699e05d4d7).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction || shouldUseVirtualFocus && !isDisabled ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick,
            id: id
        }, shouldUseVirtualFocus ? {
            onMouseDown: (e)=>e.preventDefault()
        } : undefined),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $9ef49e4bf6a3a063$var$$f6ba6936bfd098a0$var$isActionKey(key) {
    return key === 'Enter';
}
function $9ef49e4bf6a3a063$var$$f6ba6936bfd098a0$var$isSelectionKey(key) {
    return key === ' ';
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d6e64cab34740d82$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === 'function') return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $d6e64cab34740d82$export$fbdeaa6a76694f71(iterable) {
    return $d6e64cab34740d82$export$5f3398f8733f90e2(iterable, 0);
}
function $d6e64cab34740d82$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $d6e64cab34740d82$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $d6e64cab34740d82$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$d6e64cab34740d82$var$$cd5ea4b915021f1d$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$d6e64cab34740d82$var$$cd5ea4b915021f1d$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $d6e64cab34740d82$var$$cd5ea4b915021f1d$var$getAncestors(collection, node) {
    let parents = [];
    let currNode = node;
    while(currNode?.parentKey != null){
        currNode = collection.getItem(currNode.parentKey);
        if (currNode) parents.unshift(currNode);
    }
    return parents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f221e8898c91be02$var$$2efe10d3f1f9e31e$var$cache = new WeakMap();
function $f221e8898c91be02$export$77d5aafae4e095b2(collection) {
    let count = $f221e8898c91be02$var$$2efe10d3f1f9e31e$var$cache.get(collection);
    if (count != null) return count;
    // TS isn't smart enough to know we've ensured count is a number, so use a new variable
    let counter = 0;
    let countItems = (items)=>{
        for (let item of items){
            if (item.type === 'section') countItems((0, $d6e64cab34740d82$export$1005530eda016c13)(item, collection));
            else if (item.type === 'item') counter++;
        }
    };
    countItems(collection);
    $f221e8898c91be02$var$$2efe10d3f1f9e31e$var$cache.set(collection, counter);
    return counter;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c267fc781bfbb4a6$export$497855f14858aa34(props, state, ref) {
    let { key: key } = props;
    let data = (0, $08de3e3886d23c85$export$3585ede4d035bf14).get(state);
    let isDisabled = props.isDisabled ?? state.selectionManager.isDisabled(key);
    let isSelected = props.isSelected ?? state.selectionManager.isSelected(key);
    let shouldSelectOnPressUp = props.shouldSelectOnPressUp ?? data?.shouldSelectOnPressUp;
    let shouldFocusOnHover = props.shouldFocusOnHover ?? data?.shouldFocusOnHover;
    let shouldUseVirtualFocus = props.shouldUseVirtualFocus ?? data?.shouldUseVirtualFocus;
    let isVirtualized = props.isVirtualized ?? data?.isVirtualized;
    let labelId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    let optionProps = {
        role: 'option',
        'aria-disabled': isDisabled || undefined,
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': descriptionId
    };
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item?.index);
        optionProps['aria-posinset'] = Number.isNaN(index) ? undefined : index + 1;
        optionProps['aria-setsize'] = (0, $f221e8898c91be02$export$77d5aafae4e095b2)(state.collection);
    }
    let onAction = data?.onAction ? ()=>data?.onAction?.(key) : undefined;
    let id = (0, $08de3e3886d23c85$export$9145995848b05025)(state, key);
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $9ef49e4bf6a3a063$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: onAction || item?.props?.onAction ? (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(item?.props?.onAction, onAction) : undefined,
        linkBehavior: data?.linkBehavior,
        // @ts-ignore
        UNSTABLE_itemBehavior: data?.['UNSTABLE_itemBehavior'],
        id: id
    });
    let { hoverProps: hoverProps } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $627d69440c27e5e4$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(item?.props);
    delete domProps.id;
    let linkProps = (0, $dc5a334d7ad7481f$export$7e924b3091a3bd18)(item?.props);
    return {
        optionProps: {
            ...optionProps,
            ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, itemProps, hoverProps, linkProps),
            id: id
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && state.selectionManager.isFocused && (0, $627d69440c27e5e4$export$b9b3dfddab17db27)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}







var $acw62 = parcelRequire("acw62");
function $6896282d2baa3117$export$a9d04c5684123369(value) {
    const pieces = (0, $acw62.version).split('.');
    const major = parseInt(pieces[0], 10);
    if (major >= 19) return value;
    // compatibility with React < 19
    return value ? 'true' : undefined;
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $0bc0716193623f54$export$d085fb9e920b5ca7 {
    constructor(nodes){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === 'section') for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        let size = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            // Only count sections and items when determining size so that
            // loaders and separators in RAC/S2 don't influence the emptyState determination
            if (node.type === 'section' || node.type === 'item') size++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this._size = size;
        this.lastKey = last?.key ?? null;
    }
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey ?? null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey ?? null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return node?.childNodes || [];
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $16823393b0390906$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $16823393b0390906$export$52baac22726c72bf) {
            this.anchorKey = anchorKey ?? keys.anchorKey;
            this.currentKey = currentKey ?? keys.currentKey;
        } else {
            this.anchorKey = anchorKey ?? null;
            this.currentKey = currentKey ?? null;
        }
    }
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $90734d7564eaa29c$var$$60f19cefd567a3e4$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $90734d7564eaa29c$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = 'none', disallowEmptySelection: disallowEmptySelection = false, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = 'toggle', disabledBehavior: disabledBehavior = 'all' } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $acw62.useRef)(false);
    let [, setFocused] = (0, $acw62.useState)(false);
    let focusedKeyRef = (0, $acw62.useRef)(null);
    let childFocusStrategyRef = (0, $acw62.useRef)(null);
    let [, setFocusedKey] = (0, $acw62.useState)(null);
    let selectedKeysProp = (0, $acw62.useMemo)(()=>$90734d7564eaa29c$var$$60f19cefd567a3e4$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $acw62.useMemo)(()=>$90734d7564eaa29c$var$$60f19cefd567a3e4$var$convertSelection(props.defaultSelectedKeys, new (0, $16823393b0390906$export$52baac22726c72bf)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $acw62.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === 'replace' && selectionBehavior === 'toggle' && typeof selectedKeys === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $acw62.useRef)(selectionBehaviorProp);
    (0, $acw62.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = 'first') {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$90734d7564eaa29c$var$$60f19cefd567a3e4$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $90734d7564eaa29c$var$$60f19cefd567a3e4$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === 'all' ? 'all' : new (0, $16823393b0390906$export$52baac22726c72bf)(selection);
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $387e045946fd3796$export$6c8a5aaad13c9852 {
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        this.allowsCellSelection = options?.allowsCellSelection ?? false;
        this._isSelectAll = null;
        this.layoutDelegate = options?.layoutDelegate || null;
        this.fullCollection = options?.fullCollection || null;
    }
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === 'none') return false;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return false;
        return this.state.selectedKeys === 'all' ? this.canSelectItem(mappedKey) : this.state.selectedKeys.has(mappedKey);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === 'all') return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $d6e64cab34740d82$export$8c434b3a7a4dad6)(this.collection, item, first) < 0) first = item;
        }
        return first?.key ?? null;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $d6e64cab34740d82$export$8c434b3a7a4dad6)(this.collection, item, last) > 0) last = item;
        }
        return last?.key ?? null;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            this.replaceSelection(toKey);
            return;
        }
        let mappedToKey = this.getKey(toKey);
        if (mappedToKey == null) return;
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === 'all') selection = new (0, $16823393b0390906$export$52baac22726c72bf)([
            mappedToKey
        ], mappedToKey, mappedToKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey ?? mappedToKey;
            selection = new (0, $16823393b0390906$export$52baac22726c72bf)(selectedKeys, anchorKey, mappedToKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey ?? mappedToKey))selection.delete(key);
            for (let key of this.getKeyRange(mappedToKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $d6e64cab34740d82$export$8c434b3a7a4dad6)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(from, to);
        let keys = [];
        let key = from;
        while(key != null){
            let item = this.collection.getItem(key);
            if (item && (item.type === 'item' || item.type === 'cell' && this.allowsCellSelection)) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === 'cell' && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item && item.type !== 'item' && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== 'item') return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single' && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let keys = new (0, $16823393b0390906$export$52baac22726c72bf)(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(mappedKey)) keys.delete(mappedKey);
        else if (this.canSelectItem(mappedKey)) {
            keys.add(mappedKey);
            keys.anchorKey = mappedKey;
            keys.currentKey = mappedKey;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === 'none') return;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let selection = this.canSelectItem(mappedKey) ? new (0, $16823393b0390906$export$52baac22726c72bf)([
            mappedKey
        ], mappedKey, mappedKey) : new (0, $16823393b0390906$export$52baac22726c72bf)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === 'none') return;
        let selection = new (0, $16823393b0390906$export$52baac22726c72bf)();
        for (let key of keys){
            let mappedKey = this.getKey(key);
            if (mappedKey != null) {
                selection.add(mappedKey);
                if (this.selectionMode === 'single') break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        // Use the full (unfiltered) collection when available so that materializing
        // the 'all' selection includes items that are currently filtered out (e.g. by Autocomplete).
        let collection = this.fullCollection ?? this.collection;
        let keys = [];
        let addKeys = (key)=>{
            while(key != null){
                if (this.canSelectItemIn(key, collection)) {
                    let item = collection.getItem(key);
                    if (item?.type === 'item') keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item?.hasChildNodes && (this.allowsCellSelection || item.type !== 'item')) addKeys((0, $d6e64cab34740d82$export$fbdeaa6a76694f71)((0, $d6e64cab34740d82$export$1005530eda016c13)(item, collection))?.key ?? null);
                }
                key = collection.getKeyAfter(key);
            }
        };
        addKeys(collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $16823393b0390906$export$52baac22726c72bf)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual')) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        return this.canSelectItemIn(key, this.collection);
    }
    canSelectItemIn(key, collection) {
        if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
        let item = collection.getItem(key);
        if (!item || item?.props?.isDisabled || item.type === 'cell' && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        return this.state.disabledBehavior === 'all' && (this.state.disabledKeys.has(key) || !!this.collection.getItem(key)?.props?.isDisabled);
    }
    isLink(key) {
        return !!this.collection.getItem(key)?.props?.href;
    }
    getItemProps(key) {
        return this.collection.getItem(key)?.props;
    }
    withCollection(collection) {
        return new $387e045946fd3796$export$6c8a5aaad13c9852(collection, this.state, {
            allowsCellSelection: this.allowsCellSelection,
            layoutDelegate: this.layoutDelegate || undefined,
            fullCollection: this.fullCollection ?? this.collection
        });
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $bc7bcd13cb05b1ae$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) && children.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) yield* this.iterateCollection({
            children: children.props.children,
            items: items
        });
        else if (typeof children === 'function') {
            if (!items) throw new Error('props.children was a function but props.items is missing');
            let index = 0;
            for (let item of items){
                yield* this.getFullNode({
                    value: item,
                    index: index
                }, {
                    renderer: children
                });
                index++;
            }
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                if (child) items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === 'cell' && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            let key = v.key ?? v.id;
            if (key == null) throw new Error('No key found for item');
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(partialNode.element) && partialNode.element.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) {
            let children = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(partialNode.element.props.children, (child)=>{
                children.push(child);
            });
            let index = partialNode.index ?? 0;
            for (const child of children)yield* this.getFullNode({
                element: child,
                index: index++
            }, state, parentKey, parentNode);
            return;
        }
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== 'function' && typeof type.getCollectionNode !== 'function') {
                let name = element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index ?? 0;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key ?? null;
                if (nodeKey == null) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value ?? partialNode.value ?? null;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$capitalize(node.type)}> in <${$bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$capitalize(parentNode?.type ?? 'unknown parent type')}>. Only <${$bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null || partialNode.type == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value ?? null,
            level: (parentNode?.level ?? 0) + (parentNode?.type === 'item' ? 1 : 0),
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue ?? '',
            'aria-label': partialNode['aria-label'],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes || false,
            childNodes: $bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$iterable(function*() {
                if (!partialNode.hasChildNodes || !partialNode.childNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    let nodes = builder.getFullNode({
                        ...child,
                        index: index
                    }, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $bc7bcd13cb05b1ae$var$$bda7a7e55e1ff206$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f35a370e077731b3$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $acw62.useMemo)(()=>new (0, $bc7bcd13cb05b1ae$export$bf788dd355e3a401)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $acw62.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $78bb3024d26c2ff4$export$2f645645f7bca764(props) {
    let { filter: filter, layoutDelegate: layoutDelegate } = props;
    let selectionState = (0, $90734d7564eaa29c$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $acw62.useCallback)((nodes)=>filter ? new (0, $0bc0716193623f54$export$d085fb9e920b5ca7)(filter(nodes)) : new (0, $0bc0716193623f54$export$d085fb9e920b5ca7)(nodes), [
        filter
    ]);
    let context = (0, $acw62.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $f35a370e077731b3$export$6cd28814d92fa9c9)(props, factory, context);
    let selectionManager = (0, $acw62.useMemo)(()=>new (0, $387e045946fd3796$export$6c8a5aaad13c9852)(collection, selectionState, {
            layoutDelegate: layoutDelegate
        }), [
        collection,
        selectionState,
        layoutDelegate
    ]);
    $78bb3024d26c2ff4$var$$b14b6f590b50af39$var$useFocusedKeyReset(collection, selectionManager);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
function $78bb3024d26c2ff4$export$ba9d38c0f1bf2b36(state, filterFn) {
    let collection = (0, $acw62.useMemo)(()=>filterFn ? state.collection.filter(filterFn) : state.collection, [
        state.collection,
        filterFn
    ]);
    let selectionManager = state.selectionManager.withCollection(collection);
    $78bb3024d26c2ff4$var$$b14b6f590b50af39$var$useFocusedKeyReset(collection, selectionManager);
    return {
        collection: collection,
        selectionManager: selectionManager,
        disabledKeys: state.disabledKeys
    };
}
function $78bb3024d26c2ff4$var$$b14b6f590b50af39$var$useFocusedKeyReset(collection, selectionManager) {
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (selectionManager.focusedKey != null && !collection.getItem(selectionManager.focusedKey) && cachedCollection.current) {
            // Walk forward in the old collection to find the next key that still exists in the new collection.
            let key = cachedCollection.current.getKeyAfter(selectionManager.focusedKey);
            let nextFocusedKey = null;
            while(key != null){
                let node = collection.getItem(key);
                if (node && node.type === 'item' && !selectionManager.isDisabled(key)) {
                    nextFocusedKey = key;
                    break;
                }
                key = cachedCollection.current.getKeyAfter(key);
            }
            // If no such key exists, walk backward.
            if (nextFocusedKey == null) {
                key = cachedCollection.current.getKeyBefore(selectionManager.focusedKey);
                while(key != null){
                    let node = collection.getItem(key);
                    if (node && node.type === 'item' && !selectionManager.isDisabled(key)) {
                        nextFocusedKey = key;
                        break;
                    }
                    key = cachedCollection.current.getKeyBefore(key);
                }
            }
            selectionManager.setFocusedKey(nextFocusedKey);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $05b5d708b420cd83$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $a8a77caa3f8e5a02$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $a8a77caa3f8e5a02$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fd9a00a3f50018ba$export$ccaea96c28e8b9e7(props, ref) {
    let { collection: collection, onLoadMore: onLoadMore, scrollOffset: scrollOffset = 1 } = props;
    let sentinelObserver = (0, $acw62.useRef)(null);
    let triggerLoadMore = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((entries)=>{
        // Use "isIntersecting" over an equality check of 0 since it seems like there is cases where
        // a intersection ratio of 0 can be reported when isIntersecting is actually true
        for (let entry of entries)// Up to user discretion as to how to handle these multiple onLoadMore calls
        if (entry.isIntersecting && onLoadMore) onLoadMore();
    });
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (ref.current) {
            // Tear down and set up a new IntersectionObserver when the collection changes so that we can properly trigger additional loadMores if there is room for more items
            // Need to do this tear down and set up since using a large rootMargin will mean the observer's callback isn't called even when scrolling the item into view beause its visibility hasn't actually changed
            // https://codesandbox.io/p/sandbox/magical-swanson-dhgp89?file=%2Fsrc%2FApp.js%3A21%2C21
            sentinelObserver.current = new IntersectionObserver(triggerLoadMore, {
                root: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref?.current),
                rootMargin: `0px ${100 * scrollOffset}% ${100 * scrollOffset}% ${100 * scrollOffset}%`
            });
            sentinelObserver.current.observe(ref.current);
        }
        return ()=>{
            if (sentinelObserver.current) sentinelObserver.current.disconnect();
        };
    }, [
        collection,
        ref,
        scrollOffset
    ]);
}




var $acw62 = parcelRequire("acw62");







/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cbc77d4357361516$export$7ff8f37d2d81a48d = (0, $acw62.createContext)(null);
const $cbc77d4357361516$export$7c5906fe4f1f2af2 = (0, $acw62.createContext)(null);
const $cbc77d4357361516$export$41f133550aa26f48 = (0, $acw62.forwardRef)(function ListBox(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $cbc77d4357361516$export$7ff8f37d2d81a48d);
    let state = (0, $acw62.useContext)($cbc77d4357361516$export$7c5906fe4f1f2af2);
    // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
    // Those components render two copies of their children so that the collection can be built even when the popover is closed.
    // The first copy sends a collection document via context which we render the collection portal into.
    // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
    // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.
    if (state) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$bf788dd355e3a401), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$fb8073518f34e6ec), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cbc77d4357361516$var$$928221da08ecbc62$var$StandaloneListBox, {
            props: props,
            listBoxRef: ref,
            collection: collection
        }));
});
function $cbc77d4357361516$var$$928221da08ecbc62$var$StandaloneListBox({ props: props, listBoxRef: listBoxRef, collection: collection }) {
    props = {
        ...props,
        collection: collection,
        children: null,
        items: null
    };
    let { layoutDelegate: layoutDelegate } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let state = (0, $78bb3024d26c2ff4$export$2f645645f7bca764)({
        ...props,
        layoutDelegate: layoutDelegate
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: listBoxRef
    });
}
function $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxInner({ state: inputState, props: props, listBoxRef: listBoxRef }) {
    [props, listBoxRef] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, listBoxRef, (0, $80b3f40af2eadde4$export$b0d3ecf7112093a7));
    let { dragAndDropHooks: dragAndDropHooks, layout: layout = 'stack', orientation: orientation = 'vertical', filter: filter } = props;
    let state = (0, $78bb3024d26c2ff4$export$ba9d38c0f1bf2b36)(inputState, filter);
    let { collection: collection, selectionManager: selectionManager } = state;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = selectionManager;
    let collator = (0, $040b7c2ffa13ce2b$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let keyboardDelegate = (0, $acw62.useMemo)(()=>props.keyboardDelegate || new (0, $a3fdb18a48ed07b4$export$a05409b8bb224a5a)({
            collection: collection,
            collator: collator,
            ref: listBoxRef,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layout: layout,
            orientation: orientation,
            direction: direction,
            layoutDelegate: layoutDelegate
        }), [
        collection,
        collator,
        listBoxRef,
        disabledBehavior,
        disabledKeys,
        orientation,
        direction,
        props.keyboardDelegate,
        layout,
        layoutDelegate
    ]);
    let { listBoxProps: listBoxProps } = (0, $dfa5b531f0e1c61b$export$50eacbbf140a3141)({
        ...props,
        shouldSelectOnPressUp: isListDraggable || props.shouldSelectOnPressUp,
        keyboardDelegate: keyboardDelegate,
        isVirtualized: isVirtualized
    }, state, listBoxRef);
    let dragHooksProvided = (0, $acw62.useRef)(isListDraggable);
    let dropHooksProvided = (0, $acw62.useRef)(isListDroppable);
    (0, $acw62.useEffect)(()=>{
        return;
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $acw62.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, listBoxRef);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, listBoxRef, {
            orientation: orientation,
            layout: layout,
            direction: direction
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, listBoxRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $0cde480b945a073a$export$4e328f61c538687f)();
    let isEmpty = state.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: isEmpty,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: props.layout || 'stack',
        orientation: orientation,
        state: state
    };
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ListBox',
        values: renderValues
    });
    let emptyState = null;
    if (isEmpty && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        // eslint-disable-next-line
        role: "option",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState(renderValues));
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c60d71a4f66bda5$export$20e40289641fbbb6), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, listBoxProps, focusProps, droppableCollection?.collectionProps),
        ref: listBoxRef,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": props.layout || 'stack',
        "data-orientation": orientation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $cbc77d4357361516$export$7ff8f37d2d81a48d,
                props
            ],
            [
                $cbc77d4357361516$export$7c5906fe4f1f2af2,
                state
            ],
            [
                (0, $7304b6cd94823e88$export$d188a835a7bc5783),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $3866bf926703ac65$export$6615d83f6de245ce),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $7304b6cd94823e88$export$f55761759794cf55),
                {
                    render: $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxDropIndicatorWrapper
                }
            ],
            [
                (0, $c9742a26b2470517$export$d40e14dec8b060a8),
                {
                    name: 'ListBoxSection',
                    render: $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxSectionInner
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08cc935c33eff3e5$export$758399f318e6385a), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionRoot, {
        collection: collection,
        scrollRef: listBoxRef,
        persistedKeys: (0, $7304b6cd94823e88$export$d1e8e3fbb7461f6)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $7304b6cd94823e88$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
function $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxSectionInner(props, ref, section, className = 'react-aria-ListBoxSection') {
    let state = (0, $acw62.useContext)($cbc77d4357361516$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $acw62.useContext)((0, $7304b6cd94823e88$export$d188a835a7bc5783));
    let { CollectionBranch: CollectionBranch } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let [headingRef, heading] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)();
    let { headingProps: headingProps, groupProps: groupProps } = (0, $b7580a4132762537$export$c3f9f39876e4bc7)({
        heading: heading,
        'aria-label': props['aria-label'] ?? undefined
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: className,
        values: undefined
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).section, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, groupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95906153127427b2$export$e0e4026c12a8bdbb).Provider, {
        value: {
            ...headingProps,
            ref: headingRef
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section,
        renderDropIndicator: (0, $7304b6cd94823e88$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    })));
}
const $cbc77d4357361516$export$dca12b0bb56e4fc = (0, $18968b9ec17502c7$export$e953bb1cd0f19726)((0, $5cc6cedd00940323$export$437f11dc9b403b78), $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxSectionInner);
const $cbc77d4357361516$export$a11e76429ed99b4 = (0, $18968b9ec17502c7$export$18af5c7a9e9b3664)((0, $5cc6cedd00940323$export$fd11f34e1d07f134), function ListBoxItem(props, forwardedRef, item) {
    let ref = (0, $0231fe790c02c958$export$4338b53315abf666)(forwardedRef);
    let state = (0, $acw62.useContext)($cbc77d4357361516$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $acw62.useContext)((0, $7304b6cd94823e88$export$d188a835a7bc5783));
    let { optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps, ...states } = (0, $c267fc781bfbb4a6$export$497855f14858aa34)({
        key: item.key,
        'aria-label': props?.['aria-label']
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $beb56bc06b54112c$export$8f71654801c2f7cd)(props);
    let { focusProps: focusProps } = (0, $66d841e13fef000a$export$f8168d8dd8fd66e6)(props);
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasAction: states.hasAction
    }, dragState);
    let droppableItem = null;
    if (dropState && dragAndDropHooks) droppableItem = dragAndDropHooks.useDroppableItem({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, ref);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: props.children,
        defaultClassName: 'react-aria-ListBoxItem',
        values: {
            ...states,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: droppableItem?.isDropTarget
        }
    });
    (0, $acw62.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let ElementType = props.href ? (0, $78f7e4721048d8d5$export$df3a06d6289f983e).a : (0, $78f7e4721048d8d5$export$df3a06d6289f983e).div;
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    if (props.href && optionProps.tabIndex == null) optionProps.tabIndex = -1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, optionProps, hoverProps, keyboardProps, focusProps, draggableItem?.dragProps, droppableItem?.dropProps),
        ref: ref,
        "data-allows-dragging": !!dragState || undefined,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": droppableItem?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        [(0, $78f7e4721048d8d5$export$c62b8e45d58ddad9)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $f978dd1340ad1a86$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});
function $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxDropIndicatorWrapper(props, ref) {
    ref = (0, $0231fe790c02c958$export$4338b53315abf666)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $acw62.useContext)((0, $7304b6cd94823e88$export$d188a835a7bc5783));
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref
    });
}
function $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, ...otherProps } = props;
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...dropIndicatorProps,
        ...renderProps,
        role: "option",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    });
}
const $cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxDropIndicatorForwardRef = (0, $acw62.forwardRef)($cbc77d4357361516$var$$928221da08ecbc62$var$ListBoxDropIndicator);
const $cbc77d4357361516$export$8e6d031a08cf56a1 = (0, $18968b9ec17502c7$export$18af5c7a9e9b3664)((0, $5cc6cedd00940323$export$8258a0665a675899), function ListBoxLoadingIndicator(props, ref, item) {
    let state = (0, $acw62.useContext)($cbc77d4357361516$export$7c5906fe4f1f2af2);
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $acw62.useRef)(null);
    let memoedLoadMoreProps = (0, $acw62.useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, $fd9a00a3f50018ba$export$ccaea96c28e8b9e7)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-ListBoxLoadingIndicator',
        values: undefined
    });
    let optionProps = {
        // For Android talkback
        tabIndex: -1
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $6896282d2baa3117$export$a9d04c5684123369)(true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)((0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
            global: true
        }), optionProps),
        ...renderProps,
        // aria-selected isn't needed here since this option is not selectable.
        role: "option",
        ref: ref
    }, renderProps.children));
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1f2154cf4c8e1674$export$2de4954e8ae13b9f = (0, $acw62.createContext)({
    placement: 'bottom'
});
const $1f2154cf4c8e1674$export$746d02f47f4d381 = (0, $acw62.forwardRef)(function OverlayArrow(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $1f2154cf4c8e1674$export$2de4954e8ae13b9f);
    let placement = props.placement;
    let style = {
        position: 'absolute',
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)'
    };
    if (placement != null) style[placement] = '100%';
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-OverlayArrow',
        values: {
            placement: placement
        }
    });
    // remove undefined values from renderProps.style object so that it can be
    // spread merged with the other style object
    if (renderProps.style) Object.keys(renderProps.style).forEach((key)=>renderProps.style[key] === undefined && delete renderProps.style[key]);
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...DOMProps,
        ...renderProps,
        style: {
            ...style,
            ...renderProps.style
        },
        ref: ref,
        "data-placement": placement
    });
});






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4435b3119328f4b3$export$d688439359537581 = (0, $acw62.createContext)({});
const $4435b3119328f4b3$export$a8a3e93435678ff9 = (0, $acw62.forwardRef)(function Heading(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $4435b3119328f4b3$export$d688439359537581);
    let { children: children, level: level = 3, className: className, ...domProps } = props;
    let Element = (0, $78f7e4721048d8d5$export$df3a06d6289f983e)[`h${level}`];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, {
        ...domProps,
        ref: ref,
        className: className ?? 'react-aria-Heading'
    }, children);
});









var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6510e6cf1cf107af$export$744d98a3b8a94e1c = (0, $acw62.createContext)({});
const $6510e6cf1cf107af$export$16e4d70cc375e707 = (0, $acw62.forwardRef)(function Keyboard(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $6510e6cf1cf107af$export$744d98a3b8a94e1c);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).kbd, {
        dir: "ltr",
        ...props,
        ref: ref
    });
});









/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d707d1388c03da55$export$6f49b4016bfc8d56 = new WeakMap();




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $da0a9d79e1f6e616$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    !props['aria-label'] && props['aria-labelledby'];
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $06a03ced0cfc365c$export$b95089534ab7c1fd)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: 'override'
    });
    (0, $d707d1388c03da55$export$6f49b4016bfc8d56).set(state, {
        onClose: props.onClose,
        onAction: props.onAction,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus
    });
    return {
        menuProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: 'menu',
            ...listProps,
            onKeyDown: (e)=>{
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== 'Escape' || props.shouldUseVirtualFocus) listProps.onKeyDown?.(e);
            }
        })
    };
}















var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $efb04c72874387d3$export$9d32628fc2aea7da(props, state, ref) {
    let { id: id, key: key, closeOnSelect: closeOnSelect, shouldCloseOnSelect: shouldCloseOnSelect, isVirtualized: isVirtualized, 'aria-haspopup': hasPopup, onPressStart: onPressStart, onPressUp: pressUpProp, onPress: onPress, onPressChange: pressChangeProp, onPressEnd: onPressEnd, onClick: onClickProp, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur, selectionManager: selectionManager = state.selectionManager } = props;
    let isTrigger = !!hasPopup;
    let isTriggerExpanded = isTrigger && props['aria-expanded'] === 'true';
    let isDisabled = props.isDisabled ?? selectionManager.isDisabled(key);
    let isSelected = props.isSelected ?? selectionManager.isSelected(key);
    let data = (0, $d707d1388c03da55$export$6f49b4016bfc8d56).get(state);
    let item = state.collection.getItem(key);
    let onClose = props.onClose || data.onClose;
    let router = (0, $dc5a334d7ad7481f$export$9a302a45f65d0572)();
    let performAction = ()=>{
        if (isTrigger) return;
        if (item?.props?.onAction) item.props.onAction();
        else if (props.onAction) props.onAction(key);
        if (data.onAction) {
            // Must reassign to variable otherwise `this` binding gets messed up. Something to do with WeakMap.
            let onAction = data.onAction;
            onAction(key);
        }
    };
    let role = 'menuitem';
    if (!isTrigger) {
        if (selectionManager.selectionMode === 'single') role = 'menuitemradio';
        else if (selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    }
    let labelId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    let keyboardId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    let ariaProps = {
        id: id,
        'aria-disabled': isDisabled || undefined,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            props['aria-describedby'],
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined,
        'aria-controls': props['aria-controls'],
        'aria-haspopup': hasPopup,
        'aria-expanded': props['aria-expanded']
    };
    if (selectionManager.selectionMode !== 'none' && !isTrigger) ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        let index = Number(item?.index);
        ariaProps['aria-posinset'] = Number.isNaN(index) ? undefined : index + 1;
        ariaProps['aria-setsize'] = (0, $f221e8898c91be02$export$77d5aafae4e095b2)(state.collection);
    }
    let isPressedRef = (0, $acw62.useRef)(false);
    let onPressChange = (isPressed)=>{
        pressChangeProp?.(isPressed);
        isPressedRef.current = isPressed;
    };
    let interaction = (0, $acw62.useRef)(null);
    let onPressUp = (e)=>{
        if (e.pointerType !== 'keyboard') interaction.current = {
            pointerType: e.pointerType
        };
        // If interacting with mouse, allow the user to mouse down on the trigger button,
        // drag, and release over an item (matching native behavior).
        if (e.pointerType === 'mouse') {
            if (!isPressedRef.current) e.target.click();
        }
        pressUpProp?.(e);
    };
    let onClick = (e)=>{
        onClickProp?.(e);
        performAction();
        (0, $dc5a334d7ad7481f$export$13aea1a3cb5e3f1f)(e, router, item.props.href, item?.props.routerOptions);
        let shouldClose = interaction.current?.pointerType === 'keyboard' ? interaction.current?.key === 'Enter' || selectionManager.selectionMode === 'none' || selectionManager.isLink(key) : selectionManager.selectionMode !== 'multiple' || selectionManager.isLink(key);
        shouldClose = shouldCloseOnSelect ?? closeOnSelect ?? shouldClose;
        if (onClose && !isTrigger && shouldClose) onClose();
        interaction.current = null;
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $9ef49e4bf6a3a063$export$ecf600387e221c37)({
        id: id,
        selectionManager: selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: 'none',
        shouldUseVirtualFocus: data.shouldUseVirtualFocus
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            // Hovering over an already expanded sub dialog trigger should keep focus in the dialog.
            if (!(0, $627d69440c27e5e4$export$b9b3dfddab17db27)() && !(isTriggerExpanded && hasPopup)) {
                selectionManager.setFocused(true);
                selectionManager.setFocusedKey(key);
            }
            hoverStartProp?.(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $beb56bc06b54112c$export$8f71654801c2f7cd)({
        onKeyDown: (e)=>{
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case ' ':
                    interaction.current = {
                        pointerType: 'keyboard',
                        key: ' '
                    };
                    (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e).click();
                    (0, $627d69440c27e5e4$export$8397ddfc504fdb9a)('keyboard');
                    break;
                case 'Enter':
                    interaction.current = {
                        pointerType: 'keyboard',
                        key: 'Enter'
                    };
                    // Trigger click unless this is a link. Links trigger click natively.
                    if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e).tagName !== 'A') (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e).click();
                    (0, $627d69440c27e5e4$export$8397ddfc504fdb9a)('keyboard');
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown?.(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    });
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    }, ref);
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(item?.props);
    delete domProps.id;
    let linkProps = (0, $dc5a334d7ad7481f$export$7e924b3091a3bd18)(item?.props);
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, linkProps, isTrigger ? {
                onFocus: itemProps.onFocus,
                'data-collection': itemProps['data-collection'],
                'data-key': itemProps['data-key']
            } : itemProps, pressProps, hoverProps, keyboardProps, focusableProps, data.shouldUseVirtualFocus || isTrigger ? {
                onMouseDown: (e)=>e.preventDefault()
            } : undefined, isDisabled ? undefined : {
                onClick: onClick
            }),
            // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
            tabIndex: itemProps.tabIndex != null && isTriggerExpanded && !data.shouldUseVirtualFocus ? -1 : itemProps.tabIndex
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && selectionManager.isFocused && (0, $627d69440c27e5e4$export$b9b3dfddab17db27)() && !isTriggerExpanded,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e361fc5eca3c819d$export$73f7a44322579622(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}


var $45d28fd690f859ad$export$2e2bcd8739ae039 = {};
$45d28fd690f859ad$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};


var $4319c63413d09275$export$2e2bcd8739ae039 = {};
$4319c63413d09275$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};


var $a31c71a9a5bcf4f2$export$2e2bcd8739ae039 = {};
$a31c71a9a5bcf4f2$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};


var $d04b11fab441be1c$export$2e2bcd8739ae039 = {};
$d04b11fab441be1c$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};


var $c6003c66d650437b$export$2e2bcd8739ae039 = {};
$c6003c66d650437b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};


var $942c865fcd3b1f38$export$2e2bcd8739ae039 = {};
$942c865fcd3b1f38$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};


var $7ba4d72c0e3db428$export$2e2bcd8739ae039 = {};
$7ba4d72c0e3db428$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


var $51d77b86e8212700$export$2e2bcd8739ae039 = {};
$51d77b86e8212700$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};


var $a18e264e39fd8772$export$2e2bcd8739ae039 = {};
$a18e264e39fd8772$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};


var $44e1a5c8e60465d9$export$2e2bcd8739ae039 = {};
$44e1a5c8e60465d9$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};


var $851229d11cb1635d$export$2e2bcd8739ae039 = {};
$851229d11cb1635d$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};


var $196787593e6f1f7e$export$2e2bcd8739ae039 = {};
$196787593e6f1f7e$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};


var $60880a29d40d7d10$export$2e2bcd8739ae039 = {};
$60880a29d40d7d10$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


var $ca5bbd219d332696$export$2e2bcd8739ae039 = {};
$ca5bbd219d332696$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};


var $4cbcf220942639cb$export$2e2bcd8739ae039 = {};
$4cbcf220942639cb$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premi a lungo o premi Alt + Freccia gi\xf9 per aprire il menu`
};


var $2bc001ca28135a9e$export$2e2bcd8739ae039 = {};
$2bc001ca28135a9e$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};


var $003546ac42a6b617$export$2e2bcd8739ae039 = {};
$003546ac42a6b617$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};


var $1224bb2399a7de7e$export$2e2bcd8739ae039 = {};
$1224bb2399a7de7e$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};


var $d9f1bdfe48488233$export$2e2bcd8739ae039 = {};
$d9f1bdfe48488233$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};


var $f1a03be418c275df$export$2e2bcd8739ae039 = {};
$f1a03be418c275df$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};


var $de8b61412f8ef114$export$2e2bcd8739ae039 = {};
$de8b61412f8ef114$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


var $83158ce3624fd664$export$2e2bcd8739ae039 = {};
$83158ce3624fd664$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};


var $75cdca78b918e8f9$export$2e2bcd8739ae039 = {};
$75cdca78b918e8f9$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


var $46a5362bb40ba155$export$2e2bcd8739ae039 = {};
$46a5362bb40ba155$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};


var $65b74278aafeaf23$export$2e2bcd8739ae039 = {};
$65b74278aafeaf23$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};


var $0e8718fa29bf8717$export$2e2bcd8739ae039 = {};
$0e8718fa29bf8717$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};


var $9e46a6b1b3c4e983$export$2e2bcd8739ae039 = {};
$9e46a6b1b3c4e983$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};


var $758fdbd35cb52367$export$2e2bcd8739ae039 = {};
$758fdbd35cb52367$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};


var $317291f23b117b12$export$2e2bcd8739ae039 = {};
$317291f23b117b12$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


var $940e14af2210ad09$export$2e2bcd8739ae039 = {};
$940e14af2210ad09$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};


var $045eeeda8d793465$export$2e2bcd8739ae039 = {};
$045eeeda8d793465$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};


var $17bed417f14e7909$export$2e2bcd8739ae039 = {};
$17bed417f14e7909$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};


var $eddb97e1e9c2893f$export$2e2bcd8739ae039 = {};
$eddb97e1e9c2893f$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};


var $852c289570256901$export$2e2bcd8739ae039 = {};
$852c289570256901$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};


var $20b2f5c2f0786e1d$export$2e2bcd8739ae039 = {};
$20b2f5c2f0786e1d$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $45d28fd690f859ad$export$2e2bcd8739ae039),
    "bg-BG": (0, $4319c63413d09275$export$2e2bcd8739ae039),
    "cs-CZ": (0, $a31c71a9a5bcf4f2$export$2e2bcd8739ae039),
    "da-DK": (0, $d04b11fab441be1c$export$2e2bcd8739ae039),
    "de-DE": (0, $c6003c66d650437b$export$2e2bcd8739ae039),
    "el-GR": (0, $942c865fcd3b1f38$export$2e2bcd8739ae039),
    "en-US": (0, $7ba4d72c0e3db428$export$2e2bcd8739ae039),
    "es-ES": (0, $51d77b86e8212700$export$2e2bcd8739ae039),
    "et-EE": (0, $a18e264e39fd8772$export$2e2bcd8739ae039),
    "fi-FI": (0, $44e1a5c8e60465d9$export$2e2bcd8739ae039),
    "fr-FR": (0, $851229d11cb1635d$export$2e2bcd8739ae039),
    "he-IL": (0, $196787593e6f1f7e$export$2e2bcd8739ae039),
    "hr-HR": (0, $60880a29d40d7d10$export$2e2bcd8739ae039),
    "hu-HU": (0, $ca5bbd219d332696$export$2e2bcd8739ae039),
    "it-IT": (0, $4cbcf220942639cb$export$2e2bcd8739ae039),
    "ja-JP": (0, $2bc001ca28135a9e$export$2e2bcd8739ae039),
    "ko-KR": (0, $003546ac42a6b617$export$2e2bcd8739ae039),
    "lt-LT": (0, $1224bb2399a7de7e$export$2e2bcd8739ae039),
    "lv-LV": (0, $d9f1bdfe48488233$export$2e2bcd8739ae039),
    "nb-NO": (0, $f1a03be418c275df$export$2e2bcd8739ae039),
    "nl-NL": (0, $de8b61412f8ef114$export$2e2bcd8739ae039),
    "pl-PL": (0, $83158ce3624fd664$export$2e2bcd8739ae039),
    "pt-BR": (0, $75cdca78b918e8f9$export$2e2bcd8739ae039),
    "pt-PT": (0, $46a5362bb40ba155$export$2e2bcd8739ae039),
    "ro-RO": (0, $65b74278aafeaf23$export$2e2bcd8739ae039),
    "ru-RU": (0, $0e8718fa29bf8717$export$2e2bcd8739ae039),
    "sk-SK": (0, $9e46a6b1b3c4e983$export$2e2bcd8739ae039),
    "sl-SI": (0, $758fdbd35cb52367$export$2e2bcd8739ae039),
    "sr-SP": (0, $317291f23b117b12$export$2e2bcd8739ae039),
    "sv-SE": (0, $940e14af2210ad09$export$2e2bcd8739ae039),
    "tr-TR": (0, $045eeeda8d793465$export$2e2bcd8739ae039),
    "uk-UA": (0, $17bed417f14e7909$export$2e2bcd8739ae039),
    "zh-CN": (0, $eddb97e1e9c2893f$export$2e2bcd8739ae039),
    "zh-TW": (0, $852c289570256901$export$2e2bcd8739ae039)
};







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $13046dbced2674d2$export$f6211563215e3b37 = new WeakMap();
function $13046dbced2674d2$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $acw62.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !(0, $8fd85525b97849bf$export$4282f70798064fe0)(target, triggerRef.current)) return;
            // Ignore scroll events on any input or textarea as the cursor position can cause it to scroll
            // such as in a combobox. Clicking the dropdown button places focus on the input, and if the
            // text inside the input extends beyond the 'end', then it will scroll so the cursor is visible at the end.
            if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) return;
            let onCloseHandler = onClose || $13046dbced2674d2$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $303347a1ceb2a26a$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $acw62.useEffect)(()=>{
        if (ref && ref.current) (0, $13046dbced2674d2$export$f6211563215e3b37).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    let overlayId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : undefined,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}


function $76315dc48e502eaa$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $76315dc48e502eaa$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = 'menu', isDisabled: isDisabled, trigger: trigger = 'press' } = props;
    let menuTriggerId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $303347a1ceb2a26a$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === 'longPress' && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case 'Enter':
            case ' ':
                // React puts listeners on the same root, so even if propagation was stopped, immediate propagation is still possible.
                // useTypeSelect will handle the spacebar first if it's running, so we don't want to open if it's handled it already.
                // We use isDefaultPrevented() instead of isPropagationStopped() because createEventHandler stops propagation by default.
                // And default prevented means that the event was handled by something else (typeahead), so we don't want to open the menu.
                if (trigger === 'longPress' || e.isDefaultPrevented()) return;
            // fallthrough
            case 'ArrowDown':
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('first');
                break;
            case 'ArrowUp':
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('last');
                break;
            default:
                // Allow other keys.
                if ('continuePropagation' in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($76315dc48e502eaa$var$$parcel$interopDefault((0, $20b2f5c2f0786e1d$export$2e2bcd8739ae039)), '@react-aria/menu');
    let { longPressProps: longPressProps } = (0, $5ed2f5a4901645c5$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== 'longPress',
        accessibilityDescription: stringFormatter.format('longPressMessage'),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open('first');
        }
    });
    let pressProps = {
        preventFocusOnPress: true,
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) {
                (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(e.target);
                // If opened with a screen reader, auto focus the first item.
                // Otherwise, the menu itself will be focused.
                state.open(e.pointerType === 'virtual' ? 'first' : null);
            }
        },
        onPress (e) {
            if (e.pointerType === 'touch' && !isDisabled) {
                (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(e.target);
                state.toggle();
            }
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === 'press' ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            'aria-labelledby': menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}













var $acw62 = parcelRequire("acw62");
function $93616957b81f8d1a$var$$970072cf4b13fde3$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== 'undefined';
}
function $93616957b81f8d1a$export$683480f191c0e3ea(options) {
    // Only call onResize from inside the effect, otherwise we'll void our assumption that
    // useEffectEvents are safe to pass in.
    const { ref: ref, box: box, onResize: onResize } = options;
    let onResizeEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(onResize);
    (0, $acw62.useEffect)(()=>{
        let element = ref?.current;
        if (!element) return;
        if (!$93616957b81f8d1a$var$$970072cf4b13fde3$var$hasResizeObserver()) {
            window.addEventListener('resize', onResizeEvent, false);
            return ()=>{
                window.removeEventListener('resize', onResizeEvent, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResizeEvent();
            });
            resizeObserverInstance.observe(element, {
                box: box
            });
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        ref,
        box
    ]);
}



var $acw62 = parcelRequire("acw62");
const $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS = 2;
const $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$THROTTLE_TIME = 50;
const $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$TIMEOUT_TIME = 1000;
const $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $232c7c08acb7364c$export$85ec83e04c95f50a(options) {
    let { menuRef: menuRef, submenuRef: submenuRef, isOpen: isOpen, isDisabled: isDisabled } = options;
    let prevPointerPos = (0, $acw62.useRef)(undefined);
    let submenuRect = (0, $acw62.useRef)(undefined);
    let lastProcessedTime = (0, $acw62.useRef)(0);
    let timeout = (0, $acw62.useRef)(undefined);
    let autoCloseTimeout = (0, $acw62.useRef)(undefined);
    let submenuSide = (0, $acw62.useRef)(undefined);
    let movementsTowardsSubmenuCount = (0, $acw62.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, $acw62.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: isOpen ? submenuRef : undefined,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS;
        prevPointerPos.current = undefined;
    };
    let modality = (0, $627d69440c27e5e4$export$98e20ec92f614cfe)();
    // Prevent mouse down over safe triangle. Clicking while pointer-events: none is applied
    // will cause focus to move unexpectedly since it will go to an element behind the menu.
    let onPointerDown = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        if (preventPointerEvents) e.preventDefault();
    });
    (0, $acw62.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = 'none';
        else menuRef.current.style.pointerEvents = '';
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== 'pointer' || !menu) {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? 'left' : 'right';
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === 'right' ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === 'left' ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && (0, $8fd85525b97849bf$export$4282f70798064fe0)(menu, target)) target.dispatchEvent(new PointerEvent('pointerover', {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$TIMEOUT_TIME);
        };
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerdown', onPointerDown, true);
        return ()=>{
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerdown', onPointerDown, true);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $232c7c08acb7364c$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b7140318e95e7742$export$7138b0d059a6e743(props, state, ref) {
    let { parentMenuRef: parentMenuRef, submenuRef: submenuRef, type: type = 'menu', isDisabled: isDisabled, delay: delay = 200, shouldUseVirtualFocus: shouldUseVirtualFocus } = props;
    let submenuTriggerId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let overlayId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let openTimeout = (0, $acw62.useRef)(undefined);
    let cancelOpenTimeout = (0, $acw62.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, $acw62.useCallback)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    }, [
        state,
        cancelOpenTimeout
    ]);
    let onSubmenuClose = (0, $acw62.useCallback)(()=>{
        cancelOpenTimeout();
        state.close();
    }, [
        state,
        cancelOpenTimeout
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let submenuKeyDown = (e)=>{
        // If focus is not within the menu, assume virtual focus is being used.
        // This means some other input element is also within the popover, so we shouldn't close the menu.
        if (!(0, $8fd85525b97849bf$export$b4f377a2b6254582)(e.currentTarget)) return;
        switch(e.key){
            case 'ArrowLeft':
                if (direction === 'ltr' && (0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(ref.current);
                }
                break;
            case 'ArrowRight':
                if (direction === 'rtl' && (0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(ref.current);
                }
                break;
            case 'Escape':
                // TODO: can remove this when we fix collection event leaks
                if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(submenuRef.current, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(ref.current);
                }
                break;
        }
    };
    let submenuProps = {
        id: overlayId,
        'aria-labelledby': submenuTriggerId,
        submenuLevel: state.submenuLevel,
        ...type === 'menu' && {
            onClose: state.closeAll,
            autoFocus: state.focusStrategy ?? undefined,
            onKeyDown: submenuKeyDown
        }
    };
    let submenuTriggerKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowRight':
                if (!isDisabled) {
                    if (direction === 'ltr') {
                        e.preventDefault();
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!submenuRef?.current && (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)() === ref?.current) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(submenuRef.current);
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case 'ArrowLeft':
                if (!isDisabled) {
                    if (direction === 'rtl') {
                        e.preventDefault();
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!submenuRef?.current && (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)() === ref?.current) (0, $1f6f9bb93c82bcb3$export$de79e2c695e052f3)(submenuRef.current);
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === 'virtual' || e.pointerType === 'keyboard')) onSubmenuOpen('first');
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === 'touch' || e.pointerType === 'mouse')) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    (0, $b2a7046806938274$export$90fc3a17d93f704c)(parentMenuRef, 'focusin', (e)=>{
        // If we detect focus moved to a different item in the same menu that the currently open submenu trigger is in
        // then close the submenu. This is for a case where the user hovers a root menu item when multiple submenus are open
        if (state.isOpen && (0, $8fd85525b97849bf$export$4282f70798064fe0)(parentMenuRef.current, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) && (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) !== ref.current) onSubmenuClose();
    });
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    (0, $232c7c08acb7364c$export$85ec83e04c95f50a)({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            'aria-controls': state.isOpen ? overlayId : undefined,
            'aria-haspopup': !isDisabled ? type : undefined,
            'aria-expanded': state.isOpen ? 'true' : 'false',
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2069e091702d9800$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $acw62.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $acw62.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $38c9ae03315e664f$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $2069e091702d9800$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $acw62.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        expandedKeysStack: expandedKeysStack,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    };
}


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c094b8c4fed2a408$export$cfc51cf86138bf98(props, state) {
    let { triggerKey: triggerKey } = props;
    let { expandedKeysStack: expandedKeysStack, openSubmenu: openSubmenu, closeSubmenu: closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, $acw62.useState)(expandedKeysStack?.length);
    let isOpen = (0, $acw62.useMemo)(()=>expandedKeysStack[submenuLevel] === triggerKey, [
        expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let open = (0, $acw62.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy ?? null);
        openSubmenu(triggerKey, submenuLevel);
    }, [
        openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, $acw62.useCallback)(()=>{
        setFocusStrategy(null);
        closeSubmenu(triggerKey, submenuLevel);
    }, [
        closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, $acw62.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy ?? null);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $acw62.useMemo)(()=>({
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle: toggle
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}












var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6032300fdcf46ae6$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $acw62.useRef)(false);
    let prevContext = (0, $acw62.useContext)((0, $758d9eda1e4fbc82$export$5165eccb35aaadb5));
    let context = (0, $195af97314dd822a$export$9d1611c77c2fe928)(prevContext || {}, {
        ...props,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    context.ref = (0, $0231fe790c02c958$export$4338b53315abf666)(ref || prevContext?.ref);
    (0, $15604418d42e607a$export$4debdb1a3f0fa79e)(prevContext, context.ref);
    (0, $acw62.useEffect)(()=>{
        if (!isRegistered.current) isRegistered.current = true; // only warn once in strict mode.
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $758d9eda1e4fbc82$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
});
function $6032300fdcf46ae6$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $acw62.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $758d9eda1e4fbc82$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
}



var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $e4d9482be0a1f655$export$863faf230ee2118a {
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === 'section' || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last?.key ?? null;
    }
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey ?? null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey ?? null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d7aa838cc52d6cf4$export$728d6ba534403756(props) {
    let { onExpandedChange: onExpandedChange } = props;
    let [expandedKeys, setExpandedKeys] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), onExpandedChange);
    let selectionState = (0, $90734d7564eaa29c$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $f35a370e077731b3$export$6cd28814d92fa9c9)(props, (0, $acw62.useCallback)((nodes)=>new (0, $e4d9482be0a1f655$export$863faf230ee2118a)(nodes, {
            expandedKeys: expandedKeys
        }), [
        expandedKeys
    ]), null);
    (0, $acw62.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($d7aa838cc52d6cf4$var$$6b915bde6cd300dd$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $387e045946fd3796$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $d7aa838cc52d6cf4$var$$6b915bde6cd300dd$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}






/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $38553a00537f68b8$export$c7e742effb1c51e2 = (0, $acw62.createContext)(null);
const $38553a00537f68b8$export$24aad8519b95b41b = (0, $acw62.createContext)(null);
const $38553a00537f68b8$export$795aec4671cbae19 = (0, $acw62.createContext)(null);
const $38553a00537f68b8$var$$49319ee1285aa241$var$SelectionManagerContext = (0, $acw62.createContext)(null);
function $38553a00537f68b8$export$27d2ad3c5815583e(props) {
    let state = (0, $38c9ae03315e664f$export$79fefeb1c2091ac3)(props);
    let ref = (0, $acw62.useRef)(null);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $76315dc48e502eaa$export$dc9c12ed27dd1b49)({
        ...props,
        type: 'menu'
    }, state, ref);
    // Allows menu width to match button
    let [buttonWidth, setButtonWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (ref.current) setButtonWidth(ref.current.offsetWidth + 'px');
    }, [
        ref
    ]);
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: ref,
        onResize: onResize
    });
    let scrollRef = (0, $acw62.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $38553a00537f68b8$export$c7e742effb1c51e2,
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $ce4897092af7eb66$export$d2f961adcb0afbe),
                state
            ],
            [
                $38553a00537f68b8$export$795aec4671cbae19,
                state
            ],
            [
                (0, $c079ee9c5fe80a9e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'MenuTrigger',
                    triggerRef: ref,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': buttonWidth
                    },
                    'aria-labelledby': menuProps['aria-labelledby']
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6032300fdcf46ae6$export$3351871ee4b288b8), {
        ...menuTriggerProps,
        ref: ref,
        isPressed: state.isOpen
    }, props.children));
}
const $38553a00537f68b8$var$$49319ee1285aa241$var$SubmenuTriggerContext = (0, $acw62.createContext)(null);
class $38553a00537f68b8$var$$49319ee1285aa241$var$SubmenuTriggerNode extends (0, $5cc6cedd00940323$export$d68d59712b04d9d1) {
    static{
        this.type = 'submenutrigger';
    }
    filter(collection, newCollection, filterFn) {
        let triggerNode = collection.getItem(this.firstChildKey);
        if (triggerNode && filterFn(triggerNode.textValue, this)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
const $38553a00537f68b8$export$ecabc99eeffab7ca = (0, $18968b9ec17502c7$export$e953bb1cd0f19726)($38553a00537f68b8$var$$49319ee1285aa241$var$SubmenuTriggerNode, (props, ref, item)=>{
    let { CollectionBranch: CollectionBranch } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let state = (0, $acw62.useContext)($38553a00537f68b8$export$24aad8519b95b41b);
    let rootMenuTriggerState = (0, $acw62.useContext)($38553a00537f68b8$export$795aec4671cbae19);
    let submenuTriggerState = (0, $c094b8c4fed2a408$export$cfc51cf86138bf98)({
        triggerKey: item.key
    }, rootMenuTriggerState);
    let submenuRef = (0, $acw62.useRef)(null);
    let itemRef = (0, $0231fe790c02c958$export$4338b53315abf666)(ref);
    let { parentMenuRef: parentMenuRef, shouldUseVirtualFocus: shouldUseVirtualFocus } = (0, $acw62.useContext)($38553a00537f68b8$var$$49319ee1285aa241$var$SubmenuTriggerContext);
    let { submenuTriggerProps: submenuTriggerProps, submenuProps: submenuProps, popoverProps: popoverProps } = (0, $b7140318e95e7742$export$7138b0d059a6e743)({
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        delay: props.delay,
        shouldUseVirtualFocus: shouldUseVirtualFocus
    }, submenuTriggerState, itemRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext,
                {
                    ...submenuTriggerProps,
                    onAction: undefined,
                    ref: itemRef
                }
            ],
            [
                $38553a00537f68b8$export$c7e742effb1c51e2,
                {
                    ref: submenuRef,
                    ...submenuProps
                }
            ],
            [
                (0, $ce4897092af7eb66$export$d2f961adcb0afbe),
                submenuTriggerState
            ],
            [
                (0, $c079ee9c5fe80a9e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'SubmenuTrigger',
                    triggerRef: itemRef,
                    placement: 'end top',
                    'aria-labelledby': submenuProps['aria-labelledby'],
                    ...popoverProps
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }), props.children[1]);
}, (props)=>props.children[0]);
const $38553a00537f68b8$export$d9b273488cd8ce6f = (0, $acw62.forwardRef)(function Menu(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $38553a00537f68b8$export$c7e742effb1c51e2);
    // Delay rendering the actual menu until we have the collection so that auto focus works properly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$bf788dd355e3a401), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$fb8073518f34e6ec), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($38553a00537f68b8$var$$49319ee1285aa241$var$MenuInner, {
            props: props,
            collection: collection,
            menuRef: ref
        }));
});
function $38553a00537f68b8$var$$49319ee1285aa241$var$MenuInner({ props: props, collection: collection, menuRef: ref }) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, (0, $80b3f40af2eadde4$export$b0d3ecf7112093a7));
    let { filter: filter, ...autocompleteMenuProps } = props;
    let filteredCollection = (0, $acw62.useMemo)(()=>filter ? collection.filter(filter) : collection, [
        collection,
        filter
    ]);
    let state = (0, $d7aa838cc52d6cf4$export$728d6ba534403756)({
        ...props,
        collection: filteredCollection,
        children: undefined
    });
    let triggerState = (0, $acw62.useContext)($38553a00537f68b8$export$795aec4671cbae19);
    let { isVirtualized: isVirtualized, CollectionRoot: CollectionRoot } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let { menuProps: menuProps } = (0, $da0a9d79e1f6e616$export$38eaa17faae8f579)({
        ...props,
        isVirtualized: isVirtualized,
        onClose: props.onClose || triggerState?.close
    }, state, ref);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-Menu',
        values: {
            isEmpty: state.collection.size === 0
        }
    });
    let emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menuitem",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState());
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c60d71a4f66bda5$export$20e40289641fbbb6), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, menuProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        onScroll: props.onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $38553a00537f68b8$export$24aad8519b95b41b,
                state
            ],
            [
                (0, $3866bf926703ac65$export$6615d83f6de245ce),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $c9742a26b2470517$export$d40e14dec8b060a8),
                {
                    name: 'MenuSection',
                    render: $38553a00537f68b8$var$$49319ee1285aa241$var$MenuSectionInner
                }
            ],
            [
                $38553a00537f68b8$var$$49319ee1285aa241$var$SubmenuTriggerContext,
                {
                    parentMenuRef: ref,
                    shouldUseVirtualFocus: autocompleteMenuProps?.shouldUseVirtualFocus
                }
            ],
            [
                $38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext,
                {
                    shouldCloseOnSelect: props.shouldCloseOnSelect
                }
            ],
            [
                (0, $80b3f40af2eadde4$export$b0d3ecf7112093a7),
                null
            ],
            [
                (0, $80b3f40af2eadde4$export$698f465ec27e93df),
                null
            ],
            [
                $38553a00537f68b8$var$$49319ee1285aa241$var$SelectionManagerContext,
                state.selectionManager
            ],
            /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */ /* We assume the context can never change between defined and undefined. */ /* eslint-disable-next-line react-hooks/rules-of-hooks */ [
                $38553a00537f68b8$export$795aec4671cbae19,
                triggerState ?? (0, $38c9ae03315e664f$export$79fefeb1c2091ac3)({})
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08cc935c33eff3e5$export$758399f318e6385a), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, $c9742a26b2470517$export$90e00781bc59d8f9)(state.selectionManager.focusedKey),
        scrollRef: ref
    }))), emptyState));
}
// A subclass of SelectionManager that forwards focus-related properties to the parent,
// but has its own local selection state.
class $38553a00537f68b8$var$$49319ee1285aa241$var$GroupSelectionManager extends (0, $387e045946fd3796$export$6c8a5aaad13c9852) {
    constructor(parent, state){
        super(parent.collection, state);
        this.parent = parent;
    }
    get focusedKey() {
        return this.parent.focusedKey;
    }
    get isFocused() {
        return this.parent.isFocused;
    }
    setFocusedKey(key, childFocusStrategy) {
        return this.parent.setFocusedKey(key, childFocusStrategy);
    }
    setFocused(isFocused) {
        this.parent.setFocused(isFocused);
    }
    get childFocusStrategy() {
        return this.parent.childFocusStrategy;
    }
}
function $38553a00537f68b8$var$$49319ee1285aa241$var$MenuSectionInner(props, ref, section, className = 'react-aria-MenuSection') {
    let state = (0, $acw62.useContext)($38553a00537f68b8$export$24aad8519b95b41b);
    let { CollectionBranch: CollectionBranch } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let [headingRef, heading] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)();
    let { headingProps: headingProps, groupProps: groupProps } = (0, $e361fc5eca3c819d$export$73f7a44322579622)({
        heading: heading,
        'aria-label': section.props['aria-label'] ?? undefined
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: className,
        className: section.props?.className,
        style: section.props?.style,
        values: undefined
    });
    let parent = (0, $acw62.useContext)($38553a00537f68b8$var$$49319ee1285aa241$var$SelectionManagerContext);
    let selectionState = (0, $90734d7564eaa29c$export$253fe78d46329472)(props);
    let manager = props.selectionMode != null ? new $38553a00537f68b8$var$$49319ee1285aa241$var$GroupSelectionManager(parent, selectionState) : parent;
    let closeOnSelect = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)($38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext)?.shouldCloseOnSelect;
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).section, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, groupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $95906153127427b2$export$e0e4026c12a8bdbb),
                {
                    ...headingProps,
                    ref: headingRef
                }
            ],
            [
                $38553a00537f68b8$var$$49319ee1285aa241$var$SelectionManagerContext,
                manager
            ],
            [
                $38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext,
                {
                    shouldCloseOnSelect: props.shouldCloseOnSelect ?? closeOnSelect
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section
    })));
}
const $38553a00537f68b8$export$4b1545b4f2016d26 = (0, $18968b9ec17502c7$export$e953bb1cd0f19726)((0, $5cc6cedd00940323$export$437f11dc9b403b78), $38553a00537f68b8$var$$49319ee1285aa241$var$MenuSectionInner);
const $38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext = (0, $acw62.createContext)(null);
const $38553a00537f68b8$export$2ce376c2cc3355c8 = (0, $18968b9ec17502c7$export$18af5c7a9e9b3664)((0, $5cc6cedd00940323$export$fd11f34e1d07f134), function MenuItem(props, forwardedRef, item) {
    [props, forwardedRef] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, forwardedRef, $38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext);
    let id = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)($38553a00537f68b8$var$$49319ee1285aa241$var$MenuItemContext)?.id;
    let state = (0, $acw62.useContext)($38553a00537f68b8$export$24aad8519b95b41b);
    let ref = (0, $0231fe790c02c958$export$4338b53315abf666)(forwardedRef);
    let selectionManager = (0, $acw62.useContext)($38553a00537f68b8$var$$49319ee1285aa241$var$SelectionManagerContext);
    let { isVirtualized: isVirtualized } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let { menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps, ...states } = (0, $efb04c72874387d3$export$9d32628fc2aea7da)({
        ...props,
        id: id,
        key: item.key,
        selectionManager: selectionManager,
        isVirtualized: isVirtualized
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        isDisabled: states.isDisabled
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-MenuItem',
        values: {
            ...states,
            isHovered: isHovered,
            isFocusVisible: states.isFocusVisible,
            selectionMode: selectionManager.selectionMode,
            selectionBehavior: selectionManager.selectionBehavior,
            hasSubmenu: !!props['aria-haspopup'],
            isOpen: props['aria-expanded'] === 'true'
        }
    });
    let ElementType = props.href ? (0, $78f7e4721048d8d5$export$df3a06d6289f983e).a : (0, $78f7e4721048d8d5$export$df3a06d6289f983e).div;
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, menuItemProps, hoverProps),
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": selectionManager.selectionMode === 'none' ? undefined : selectionManager.selectionMode,
        "data-has-submenu": !!props['aria-haspopup'] || undefined,
        "data-open": props['aria-expanded'] === 'true' || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        [(0, $78f7e4721048d8d5$export$c62b8e45d58ddad9)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $6510e6cf1cf107af$export$744d98a3b8a94e1c),
                keyboardShortcutProps
            ],
            [
                (0, $f978dd1340ad1a86$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});










var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a9c1eaa034597075$export$60d741e20e0aa309 = (0, $acw62.createContext)({});
function $a9c1eaa034597075$export$78efe591171d7d45(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $a9c1eaa034597075$export$9fc1347d4195ccb3();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a9c1eaa034597075$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? undefined : getContainer ?? ctxGetContainer
        }
    }, props.children);
}
function $a9c1eaa034597075$export$9fc1347d4195ccb3() {
    return (0, $acw62.useContext)($a9c1eaa034597075$export$60d741e20e0aa309) ?? {};
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e4b93c37deb87f91$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $e4b93c37deb87f91$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $d8a6de909e063b29$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $acw62.useState)(false);
    let contextValue = (0, $acw62.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $a9c1eaa034597075$export$9fc1347d4195ccb3)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c60d71a4f66bda5$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: (props.shouldContainFocus || contain) && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4b93c37deb87f91$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6032300fdcf46ae6$export$cf75428e0b9ed1ea), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(contents, portalContainer);
}
function $e4b93c37deb87f91$export$14c98a7594375490() {
    let ctx = (0, $acw62.useContext)($e4b93c37deb87f91$export$a2200b96afd16271);
    let setContain = ctx?.setContain;
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        setContain?.(true);
    }, [
        setContain
    ]);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bbe58c72b8289ca6$export$d55e7ee900f34e93(props, ref) {
    let { role: role = 'dialog' } = props;
    let titleId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    titleId = props['aria-label'] ? undefined : titleId;
    let isRefocusing = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (ref.current && !(0, $8fd85525b97849bf$export$b4f377a2b6254582)(ref.current)) {
            (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                // Check that the dialog is still focused, or focused was lost to the body.
                if ((0, $8fd85525b97849bf$export$cd4e5573fbe2b576)() === ref.current || (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)() === document.body) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $e4b93c37deb87f91$export$14c98a7594375490)();
    // Warn in dev mode if the dialog has no accessible title.
    // This catches a common mistake where useDialog and useOverlayTriggerState
    // are used in the same component, causing the title element to not be
    // in the DOM when useSlotId queries for it.
    // Check the DOM element directly since aria-labelledby may be added by
    // wrapper components (e.g. RAC Dialog uses trigger ID as a fallback).
    let hasWarned = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{});
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            'aria-labelledby': props['aria-labelledby'] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}






var $acw62 = parcelRequire("acw62");




/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ce4897092af7eb66$export$8b93a07348a7730c = (0, $acw62.createContext)(null);
const $ce4897092af7eb66$export$d2f961adcb0afbe = (0, $acw62.createContext)(null);
function $ce4897092af7eb66$export$2e1e1122cf0cba88(props) {
    // Use useMenuTriggerState instead of useOverlayTriggerState in case a menu is embedded in the dialog.
    // This is needed to handle submenus.
    let state = (0, $38c9ae03315e664f$export$79fefeb1c2091ac3)(props);
    let buttonRef = (0, $acw62.useRef)(null);
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $303347a1ceb2a26a$export$f9d5c8beee7d008d)({
        type: 'dialog'
    }, state, buttonRef);
    // Allows popover width to match trigger element
    let [buttonWidth, setButtonWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (buttonRef.current) setButtonWidth(buttonRef.current.offsetWidth + 'px');
    }, [
        buttonRef
    ]);
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: buttonRef,
        onResize: onResize
    });
    // Label dialog by the trigger as a fallback if there is no title slot.
    // This is done in RAC instead of hooks because otherwise we cannot distinguish
    // between context and props. Normally aria-labelledby overrides the title
    // but when sent by context we want the title to win.
    triggerProps.id = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    overlayProps['aria-labelledby'] = triggerProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $ce4897092af7eb66$export$d2f961adcb0afbe,
                state
            ],
            [
                (0, $38553a00537f68b8$export$795aec4671cbae19),
                state
            ],
            [
                $ce4897092af7eb66$export$8b93a07348a7730c,
                overlayProps
            ],
            [
                (0, $c079ee9c5fe80a9e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'DialogTrigger',
                    triggerRef: buttonRef,
                    'aria-labelledby': overlayProps['aria-labelledby'],
                    style: {
                        '--trigger-width': buttonWidth
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6032300fdcf46ae6$export$3351871ee4b288b8), {
        ...triggerProps,
        ref: buttonRef,
        isPressed: state.isOpen
    }, props.children));
}
const $ce4897092af7eb66$export$3ddf2d174ce01153 = (0, $acw62.forwardRef)(function Dialog(props, ref) {
    let originalAriaLabelledby = props['aria-labelledby'];
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $ce4897092af7eb66$export$8b93a07348a7730c);
    let { dialogProps: dialogProps, titleProps: titleProps } = (0, $bbe58c72b8289ca6$export$d55e7ee900f34e93)({
        ...props,
        // Only pass aria-labelledby from props, not context.
        // Context is used as a fallback below.
        'aria-labelledby': originalAriaLabelledby
    }, ref);
    let state = (0, $acw62.useContext)($ce4897092af7eb66$export$d2f961adcb0afbe);
    if (!dialogProps['aria-label'] && !dialogProps['aria-labelledby']) // If aria-labelledby exists on props, we know it came from context.
    // Use that as a fallback in case there is no title slot.
    {
        if (props['aria-labelledby']) dialogProps['aria-labelledby'] = props['aria-labelledby'];
    }
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        defaultClassName: 'react-aria-Dialog',
        className: props.className,
        style: props.style,
        children: props.children,
        values: {
            close: state?.close || (()=>{})
        }
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).section, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, dialogProps),
        render: props.render,
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $4435b3119328f4b3$export$d688439359537581),
                {
                    slots: {
                        [(0, $78f7e4721048d8d5$export$c62b8e45d58ddad9)]: {},
                        title: {
                            ...titleProps,
                            level: 2
                        }
                    }
                }
            ],
            [
                (0, $972ba92a45901f5b$export$24d547caef80ccd1),
                {
                    slots: {
                        [(0, $78f7e4721048d8d5$export$c62b8e45d58ddad9)]: {},
                        close: {
                            onPress: ()=>state?.close()
                        }
                    }
                }
            ]
        ]
    }, renderProps.children));
});






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$supportsInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$isAlwaysVisibleNode(node) {
    return node.dataset.liveAnnouncer === 'true' || node.dataset.reactAriaTopLayer !== undefined;
}
// Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$refCountMap = new WeakMap();
let $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack = [];
function $3dcf81fd889e5f42$export$1c3ebcada18427bf(targets, options) {
    let windowObj = (0, $c8e82650210ecd78$export$f21a1ffae260145a)(targets?.[0]);
    let opts = options instanceof windowObj.Element ? {
        root: options
    } : options;
    let root = opts?.root ?? document.body;
    let shouldUseInert = opts?.shouldUseInert && $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$supportsInert;
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let getHidden = (element)=>{
        return shouldUseInert && element instanceof windowObj.HTMLElement ? element.inert : element.getAttribute('aria-hidden') === 'true';
    };
    let setHidden = (element, hidden)=>{
        if (shouldUseInert && element instanceof windowObj.HTMLElement) element.inert = hidden;
        else if (hidden) element.setAttribute('aria-hidden', 'true');
        else {
            element.removeAttribute('aria-hidden');
            if (element instanceof windowObj.HTMLElement) // we are trying to make the element visible to screen readers again, so remove inert as well
            element.inert = false;
        }
    };
    let shadowRootsToWatch = new Set();
    if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) // traverse upwards until the root is reached
    for (let target of targets){
        let node = target;
        while(node && node !== root){
            let root = node.getRootNode();
            if ('shadowRoot' in root) shadowRootsToWatch.add(root.shadowRoot);
            node = root.parentNode;
        }
    }
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]'))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (hiddenNodes.has(node) || visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(node, target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = (0, $51f33e0a80159b58$export$4d0f8be8b12a7ef6)((0, $c8e82650210ecd78$export$b204af158042fbac)(root), root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        let refCount = $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$refCountMap.get(node) ?? 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (getHidden(node) && refCount === 0) return;
        if (refCount === 0) setHidden(node, true);
        hiddenNodes.add(node);
        $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.length) $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack[$3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== 'childList') continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (change.target.isConnected && ![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>(0, $8fd85525b97849bf$export$4282f70798064fe0)(node, change.target))) for (let node of change.addedNodes){
                if ((node instanceof HTMLElement || node instanceof SVGElement) && $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$isAlwaysVisibleNode(node)) visibleNodes.add(node);
                else if (node instanceof Element) walk(node);
            }
            if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) {
                // if any of the observed shadow roots were removed, stop observing them
                for (let shadowRoot of shadowRootsToWatch)if (!shadowRoot.isConnected) {
                    observer.disconnect();
                    break;
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let shadowObservers = new Set();
    if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) for (let shadowRoot of shadowRootsToWatch){
        // Disconnect single target instead of all https://github.com/whatwg/dom/issues/126
        let shadowObserver = new MutationObserver((changes)=>{
            for (let change of changes){
                if (change.type !== 'childList') continue;
                // If the parent element of the added nodes is not within one of the targets,
                // and not already inside a hidden node, hide all of the new children.
                if (change.target.isConnected && ![
                    ...visibleNodes,
                    ...hiddenNodes
                ].some((node)=>(0, $8fd85525b97849bf$export$4282f70798064fe0)(node, change.target))) for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$isAlwaysVisibleNode(node)) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
                if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) {
                    // if any of the observed shadow roots were removed, stop observing them
                    for (let shadowRoot of shadowRootsToWatch)if (!shadowRoot.isConnected) {
                        observer.disconnect();
                        break;
                    }
                }
            }
        });
        shadowObserver.observe(shadowRoot, {
            childList: true,
            subtree: true
        });
        shadowObservers.add(shadowObserver);
    }
    let observerWrapper = {
        visibleNodes: visibleNodes,
        hiddenNodes: hiddenNodes,
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        if ((0, $b1f0b06c417727c2$export$98658e8c59125e6a)()) for (let shadowObserver of shadowObservers)shadowObserver.disconnect();
        for (let node of hiddenNodes){
            let count = $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                setHidden(node, false);
                $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$refCountMap.delete(node);
            } else $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack[$3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.length - 1]) {
            $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.pop();
            if ($3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.length) $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack[$3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.length - 1].observe();
        } else $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.splice($3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.indexOf(observerWrapper), 1);
    };
}
function $3dcf81fd889e5f42$export$1020fa7f77e17884(element) {
    let observer = $3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack[$3dcf81fd889e5f42$var$$58196c8d6a1f38fc$var$observerStack.length - 1];
    if (observer && !observer.visibleNodes.has(element)) {
        observer.visibleNodes.add(element);
        return ()=>{
            observer.visibleNodes.delete(element);
        };
    }
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
const $fdfc6513a986f524$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $fdfc6513a986f524$var$$954926fb6168ae2a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
const $fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
const $fdfc6513a986f524$var$$954926fb6168ae2a$var$TOTAL_SIZE = {
    width: 'totalWidth',
    height: 'totalHeight'
};
const $fdfc6513a986f524$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE = {};
let $fdfc6513a986f524$var$$954926fb6168ae2a$var$getVisualViewport = ()=>typeof document !== 'undefined' ? window.visualViewport : null;
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getContainerDimensions(containerNode, visualViewport) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    let isPinchZoomedIn = (visualViewport?.scale ?? 1) > 1;
    // In the case where the container is `html` or `body` and the container doesn't have something like `position: relative`,
    // then position absolute will be positioned relative to the viewport, also known as the `initial containing block`.
    // That's why we use the visual viewport instead.
    if (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        width = visualViewport?.width ?? totalWidth;
        height = visualViewport?.height ?? totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if (visualViewport) {
            top = visualViewport.offsetTop;
            left = visualViewport.offsetLeft;
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getOffset(containerNode, false));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $dd0d4fc527b0735d$export$78551043582a6a98)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = visualViewport?.pageTop ?? 0;
        left = visualViewport?.pageLeft ?? 0;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    let containerScroll = containerDimensions.scroll[axis] ?? 0;
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = containerOffsetWithBoundary[axis] + boundaryDimensions.scroll[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = containerOffsetWithBoundary[axis] + boundaryDimensions.scroll[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[axis]] + boundarySize - padding;
    // transformed value of the left edge of the overlay
    let startEdgeOffset = offset - containerScroll + boundaryDimensions.scroll[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[axis]] + containerOffsetWithBoundary[axis] - boundaryDimensions[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[axis]];
    // transformed value of the right edge of the overlay
    let endEdgeOffset = offset - containerScroll + size + boundaryDimensions.scroll[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[axis]] + containerOffsetWithBoundary[axis] - boundaryDimensions[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$parsePlacement(input) {
    if ($fdfc6513a986f524$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input]) return $fdfc6513a986f524$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(' ');
    let axis = $fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[placement] || 'right';
    let crossAxis = $fdfc6513a986f524$var$$954926fb6168ae2a$var$CROSS_AXIS[axis];
    if (!$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    let size = $fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS_SIZE[axis];
    let crossSize = $fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS_SIZE[crossAxis];
    $fdfc6513a986f524$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $fdfc6513a986f524$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input];
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis] ?? 0;
    if (crossPlacement === 'center') // at this point the overlay center should match the button center
    position[crossAxis] += ((childOffset[crossSize] ?? 0) - (overlaySize[crossSize] ?? 0)) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += (childOffset[crossSize] ?? 0) - (overlaySize[crossSize] ?? 0);
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top or left overlapping arrow with button bottom or right
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom or right overlapping arrow with button top or left
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $0aebee02c692839a$export$7d15b64cf5a3a4c4)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container.
        let containerHeight = isContainerPositioned ? containerDimensions[size] : containerDimensions[$fdfc6513a986f524$var$$954926fb6168ae2a$var$TOTAL_SIZE[size]];
        position[$fdfc6513a986f524$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection, containerDimensions, isContainerDescendentOfBoundary, visualViewport) {
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top
    // with respect to the container.
    let overlayTop = (position.top != null ? position.top : containerDimensions[$fdfc6513a986f524$var$$954926fb6168ae2a$var$TOTAL_SIZE.height] - (position.bottom ?? 0) - overlayHeight) - (containerDimensions.scroll.top ?? 0);
    // calculate the dimentions of the "boundingRect" which is most restrictive top/bottom of the boundaryRect and the visual view port
    let boundaryToContainerTransformOffset = isContainerDescendentOfBoundary ? containerOffsetWithBoundary.top : 0;
    let boundingRect = {
        // This should be boundary top in container coord system vs viewport top in container coord system
        // For the viewport top, there are several cases
        // 1. pinchzoom case where we want the viewports offset top as top here
        // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
        top: Math.max(boundaryDimensions.top + boundaryToContainerTransformOffset, (visualViewport?.offsetTop ?? boundaryDimensions.top) + boundaryToContainerTransformOffset),
        bottom: Math.min(boundaryDimensions.top + boundaryDimensions.height + boundaryToContainerTransformOffset, (visualViewport?.offsetTop ?? 0) + (visualViewport?.height ?? 0))
    };
    let maxHeight = heightGrowthDirection !== 'top' ? Math.max(0, boundingRect.bottom // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - ((margins.top ?? 0) + (margins.bottom ?? 0) + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - boundingRect.top // this is the top of the boundary
     - ((margins.top ?? 0) + (margins.bottom ?? 0) + padding // save additional space for margin and padding
    ));
    return maxHeight;
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo, containerDimensions, isContainerDescendentOfBoundary) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] // trigger start
     - (containerDimensions.scroll[axis] ?? 0 // transform trigger position to be with respect to viewport 0,0
    ) - (boundaryDimensions[axis] + (isContainerDescendentOfBoundary ? containerOffsetWithBoundary[axis] : 0 // boundary start
    )) - (margins[axis] ?? 0 // margins usually for arrows or other decorations
    ) - margins[$fdfc6513a986f524$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[axis]] - padding); // padding between overlay and boundary
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + (isContainerDescendentOfBoundary ? containerOffsetWithBoundary[axis] : 0) - childOffset[axis] - childOffset[size] + (containerDimensions.scroll[axis] ?? 0) - (margins[axis] ?? 0) - margins[$fdfc6513a986f524$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $fdfc6513a986f524$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset, isContainerDescendentOfBoundary, visualViewport) {
    let placementInfo = $fdfc6513a986f524$var$$954926fb6168ae2a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $fdfc6513a986f524$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
    let normalizedOffset = offset;
    let space = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo, containerDimensions, isContainerDescendentOfBoundary);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && overlaySize[size] > space) {
        let flippedPlacementInfo = $fdfc6513a986f524$var$$954926fb6168ae2a$var$parsePlacement(`${$fdfc6513a986f524$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $fdfc6513a986f524$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
        let flippedSpace = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo, containerDimensions, isContainerDescendentOfBoundary);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = 'bottom';
    if (placementInfo.axis === 'top') {
        if (placementInfo.placement === 'top') heightGrowthDirection = 'top';
        else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossAxis === 'top') {
        if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';
        else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
    }
    let delta = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection, containerDimensions, isContainerDescendentOfBoundary, visualViewport);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $fdfc6513a986f524$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
    delta = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    // childOffset[crossAxis] + .5 * childOffset[crossSize] = absolute position with respect to the trigger's coordinate system that would place the arrow in the center of the trigger
    // position[crossAxis] - margins[AXIS[crossAxis]] = value use to transform the position to a value with respect to the overlay's coordinate system. A child element's (aka arrow) position absolute's "0"
    // is positioned after the margin of its parent (aka overlay) so we need to subtract it to get the proper coordinate transform
    let origin = childOffset[crossAxis] - position[crossAxis] - margins[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[crossAxis]];
    let preferredArrowPosition = origin + .5 * childOffset[crossSize];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    // overlaySize[crossSize] - margins = true size of the overlay
    const overlayMargin = $fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[crossAxis] === 'left' ? (margins.left ?? 0) + (margins.right ?? 0) : (margins.top ?? 0) + (margins.bottom ?? 0);
    const arrowMaxPosition = overlaySize[crossSize] - overlayMargin - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    // Same margin accomodation done here as well as for the preferredArrowPosition
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] + arrowSize / 2 - (position[crossAxis] + margins[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[crossAxis]]);
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - arrowSize / 2 - (position[crossAxis] + margins[$fdfc6513a986f524$var$$954926fb6168ae2a$var$AXIS[crossAxis]]);
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $0aebee02c692839a$export$7d15b64cf5a3a4c4)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $0aebee02c692839a$export$7d15b64cf5a3a4c4)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    // If there is an arrow, use that as the origin so that animations are smooth.
    // Otherwise use the target edge.
    ({ placement: placement, crossPlacement: crossPlacement } = placementInfo);
    if (arrowSize) origin = arrowPosition[crossAxis];
    else if (crossPlacement === 'right') origin += childOffset[crossSize];
    else if (crossPlacement === 'center') origin += childOffset[crossSize] / 2;
    let crossOrigin = placement === 'left' || placement === 'top' ? overlaySize[size] : 0;
    let triggerAnchorPoint = {
        x: placement === 'top' || placement === 'bottom' ? origin : crossOrigin,
        y: placement === 'left' || placement === 'right' ? origin : crossOrigin
    };
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placement,
        triggerAnchorPoint: triggerAnchorPoint
    };
}
function $fdfc6513a986f524$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let visualViewport = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getVisualViewport();
    let container = overlayNode instanceof HTMLElement ? $fdfc6513a986f524$var$$954926fb6168ae2a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    let childOffset = isViewportContainer ? $fdfc6513a986f524$var$$954926fb6168ae2a$var$getOffset(targetNode, false) : $fdfc6513a986f524$var$$954926fb6168ae2a$var$getPosition(targetNode, container, false);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getOffset(overlayNode, true);
    let margins = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getMargins(overlayNode);
    overlaySize.width += (margins.left ?? 0) + (margins.right ?? 0);
    overlaySize.height += (margins.top ?? 0) + (margins.bottom ?? 0);
    let scrollSize = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getScroll(scrollNode);
    // Note that due to logic inside getContainerDimensions, for cases where the boundary element is the body, we will return
    // a height/width that matches the visual viewport size rather than the body's height/width (aka for zoom it will be zoom adjusted size)
    // and a top/left that is adjusted as well (will return the top/left of the zoomed in viewport, or 0,0 for a non-zoomed body)
    // Otherwise this returns the height/width of a arbitrary boundary element, and its top/left with respect to the viewport (NOTE THIS MEANS IT DOESNT INCLUDE SCROLL)
    let boundaryDimensions = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getContainerDimensions(boundaryElement, visualViewport);
    let containerDimensions = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getContainerDimensions(container, visualViewport);
    // There are several difference cases of how to calculate the containerOffsetWithBoundary:
    // - boundaryElement is body or HTML and the container is an arbitrary element in the boundary (aka submenu with parent menu as container in v3)
    // - boundaryElement and container are both body or HTML element (aka standard popover case)
    // - boundaryElement is customized by the user. Container can also be arbitrary (either body/HTML or some other element)
    // containerOffsetWithBoundary should always return a value that is the boundary's coordinate offset with respect to the container coord system (container is 0, 0)
    let containerOffsetWithBoundary;
    if ((boundaryElement.tagName === 'BODY' || boundaryElement.tagName === 'HTML') && !isViewportContainer) {
        // Use getRect instead of getOffset because boundaryDimensions for BODY/HTML is in viewport coordinate space,
        // not document coordinate space
        let containerRect = $fdfc6513a986f524$export$4b834cebd9e5cebe(container, false);
        // the offset should be negative because if container is at viewport position x,y, then viewport top (aka 0)
        // is at position -x,y in container-relative coordinates
        containerOffsetWithBoundary = {
            top: -(containerRect.top - boundaryDimensions.top),
            left: -(containerRect.left - boundaryDimensions.left),
            width: 0,
            height: 0
        };
    } else if ((boundaryElement.tagName === 'BODY' || boundaryElement.tagName === 'HTML') && isViewportContainer) containerOffsetWithBoundary = {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    };
    else // like in ScrollingBoundaryContainerExample in Popover.stories.
    containerOffsetWithBoundary = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getPosition(boundaryElement, container, false);
    let isContainerDescendentOfBoundary = (0, $8fd85525b97849bf$export$4282f70798064fe0)(boundaryElement, container);
    return $fdfc6513a986f524$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset, isContainerDescendentOfBoundary, visualViewport);
}
function $fdfc6513a986f524$export$4b834cebd9e5cebe(node, ignoreScale) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    // Use offsetWidth and offsetHeight if this is an HTML element, so that
    // the size is not affected by scale transforms.
    if (ignoreScale && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        width = node.offsetWidth;
        height = node.offsetHeight;
    }
    return {
        top: top,
        left: left,
        width: width,
        height: height
    };
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getOffset(node, ignoreScale) {
    let { top: top, left: left, width: width, height: height } = $fdfc6513a986f524$export$4b834cebd9e5cebe(node, ignoreScale);
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getPosition(node, parent, ignoreScale) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === 'fixed') offset = $fdfc6513a986f524$export$4b834cebd9e5cebe(node, ignoreScale);
    else {
        offset = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getOffset(node, ignoreScale);
        let parentOffset = $fdfc6513a986f524$var$$954926fb6168ae2a$var$getOffset(parent, ignoreScale);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !$fdfc6513a986f524$var$$954926fb6168ae2a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$fdfc6513a986f524$var$$954926fb6168ae2a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $fdfc6513a986f524$var$$954926fb6168ae2a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' || 'backdropFilter' in style && style.backdropFilter !== 'none' || 'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $1fae08535d7d048a$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let { arrowSize: arrowSize, targetRef: targetRef, overlayRef: overlayRef, arrowRef: arrowRef, scrollRef: scrollRef = overlayRef, placement: placement = 'bottom', containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== 'undefined' ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $acw62.useState)(null);
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        arrowRef?.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $acw62.useRef)($1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.scale);
    (0, $acw62.useEffect)(()=>{
        if (isOpen) lastScale.current = $1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $acw62.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !boundaryElement) return;
        if ($1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.scale !== lastScale.current) return;
        // Determine a scroll anchor based on the focused element.
        // This stores the offset of the anchor element from the scroll container
        // so it can be restored after repositioning. This way if the overlay height
        // changes, the focused element appears to stay in the same position.
        let anchor = null;
        if (scrollRef.current && (0, $8fd85525b97849bf$export$b4f377a2b6254582)(scrollRef.current)) {
            let anchorRect = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)()?.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            // Anchor from the top if the offset is in the top half of the scrollable element,
            // otherwise anchor from the bottom.
            anchor = {
                type: 'top',
                offset: (anchorRect?.top ?? 0) - scrollRect.top
            };
            if (anchor.offset > scrollRect.height / 2) {
                anchor.type = 'bottom';
                anchor.offset = (anchorRect?.bottom ?? 0) - scrollRect.bottom;
            }
        }
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        let overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            overlay.style.top = '0px';
            overlay.style.bottom = '';
            overlay.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + 'px';
        }
        let position = (0, $fdfc6513a986f524$export$b3ceb0cbf1056d98)({
            placement: $1fae08535d7d048a$var$$b3526bc71400be8d$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current || overlayRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize ?? (arrowRef?.current ? (0, $fdfc6513a986f524$export$4b834cebd9e5cebe)(arrowRef.current, true).width : 0),
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        if (!position.position) return;
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = '';
        overlay.style.bottom = '';
        overlay.style.left = '';
        overlay.style.right = '';
        Object.keys(position.position).forEach((key)=>overlay.style[key] = position.position[key] + 'px');
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : '';
        // Restore scroll position relative to anchor element.
        let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
        if (anchor && activeElement && scrollRef.current) {
            let anchorRect = activeElement.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            let newOffset = anchorRect[anchor.type] - scrollRect[anchor.type];
            scrollRef.current.scrollTop += newOffset - anchor.offset;
        }
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $1fae08535d7d048a$var$$b3526bc71400be8d$var$useResize(updatePosition);
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: targetRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $acw62.useRef)(false);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.addEventListener('resize', onResize);
        $1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.addEventListener('scroll', onScroll);
        return ()=>{
            $1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.removeEventListener('resize', onResize);
            $1fae08535d7d048a$var$$b3526bc71400be8d$var$visualViewport?.removeEventListener('scroll', onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $acw62.useCallback)(()=>{
        if (!isResizing.current) onClose?.();
    }, [
        onClose,
        isResizing
    ]);
    (0, $13046dbced2674d2$export$18fc8428861184da)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: position ? 'absolute' : 'fixed',
                top: !position ? 0 : undefined,
                left: !position ? 0 : undefined,
                zIndex: 100000,
                ...position?.position,
                maxHeight: position?.maxHeight ?? '100vh'
            }
        },
        placement: position?.placement ?? null,
        triggerAnchorPoint: position?.triggerAnchorPoint ?? null,
        arrowProps: {
            'aria-hidden': 'true',
            role: 'presentation',
            style: {
                left: position?.arrowOffsetLeft,
                top: position?.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $1fae08535d7d048a$var$$b3526bc71400be8d$var$useResize(onResize) {
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener('resize', onResize, false);
        return ()=>{
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $1fae08535d7d048a$var$$b3526bc71400be8d$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}










var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $5ed9e550bbc221b0$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside && $5ed9e550bbc221b0$var$$e260d131964da0f9$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $c8e82650210ecd78$export$b204af158042fbac)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== 'undefined') {
            let onClick = (e)=>{
                if (state.isPointerDown && $5ed9e550bbc221b0$var$$e260d131964da0f9$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            // Use click instead of pointerup to avoid Android Chrome issue
            // https://issues.chromium.org/issues/40732224
            documentObject.addEventListener('pointerdown', onPointerDown, true);
            documentObject.addEventListener('click', onClick, true);
            return ()=>{
                documentObject.removeEventListener('pointerdown', onPointerDown, true);
                documentObject.removeEventListener('click', onClick, true);
            };
        }
    }, [
        ref,
        isDisabled
    ]);
}
function $5ed9e550bbc221b0$var$$e260d131964da0f9$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(event);
    if (target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = target.ownerDocument;
        if (!ownerDocument || !(0, $8fd85525b97849bf$export$4282f70798064fe0)(ownerDocument.documentElement, target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (target.closest('[data-react-aria-top-layer]')) return false;
    }
    if (!ref.current) return false;
    // When the event source is inside a Shadow DOM, event.target is just the shadow root.
    // Using event.composedPath instead means we can get the actual element inside the shadow root.
    // This only works if the shadow root is open, there is no way to detect if it is closed.
    // If the event composed path contains the ref, interaction is inside.
    return !event.composedPath().includes(ref.current);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays = [];
function $2a3fcbfcdf4b930b$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    let lastVisibleOverlay = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(()=>{
        if (isOpen && !$2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.includes(ref)) {
            $2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.push(ref);
            return ()=>{
                let index = $2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.indexOf(ref);
                if (index >= 0) $2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.splice(index, 1);
            };
        }
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays[$2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        const topMostOverlay = $2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays[$2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.length - 1];
        lastVisibleOverlay.current = topMostOverlay;
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
            if (topMostOverlay === ref) e.stopPropagation();
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
            if ($2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays[$2a3fcbfcdf4b930b$var$$77844860df94ba23$var$visibleOverlays.length - 1] === ref) e.stopPropagation();
            if (lastVisibleOverlay.current === ref) onHide();
        }
        lastVisibleOverlay.current = undefined;
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === 'Escape' && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $5ed9e550bbc221b0$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : undefined,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $5c60d71a4f66bda5$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose?.();
        }
    });
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {}
    };
}










/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollCount = 0;
let $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$restore;
function $a2359fdf8b4c0098$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollCount++;
        if ($a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollCount === 1) {
            if ((0, $dd0d4fc527b0735d$export$fedb369cb70207f1)()) $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$restore = $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollMobileSafari();
            else $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$restore = $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollStandard();
        }
        return ()=>{
            $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollCount--;
            if ($a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollCount === 0) $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollStandard() {
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(scrollbarWidth > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
    ('scrollbarGutter' in document.documentElement.style ? $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$setStyle(document.documentElement, 'scrollbarGutter', 'stable') : $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$setStyle(document.documentElement, 'paddingRight', `${scrollbarWidth}px`)), $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event. This is best effort: we can't prevent default when pinch
//    zooming or when an element contains text selection, which may allow scrolling in some cases.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focus moves to an input, create an off screen input and focus that temporarily. This prevents
//    Safari from scrolling the page. After a small delay, focus the real input and scroll it into view
//    ourselves, without scrolling the whole page.
function $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$preventScrollMobileSafari() {
    // Set overflow hidden so scrollIntoViewport() (useSelectableCollection) sees isScrollPrevented and
    // scrolls only scroll parents instead of calling native scrollIntoView() which moves the window.
    let restoreOverflow = $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$setStyle(document.documentElement, 'overflow', 'hidden');
    let scrollable;
    let allowTouchMove = false;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        scrollable = (0, $a8a77caa3f8e5a02$export$2bb74740c4e19def)(target) ? target : (0, $05b5d708b420cd83$export$cfa2225e87938781)(target, true);
        allowTouchMove = false;
        // If the target is selected, don't preventDefault in touchmove to allow user to adjust selection.
        let selection = target.ownerDocument.defaultView.getSelection();
        if (selection && !selection.isCollapsed && selection.containsNode(target, true)) allowTouchMove = true;
        // If this is a range input, allow touch move to allow user to adjust the slider value
        if (e.composedPath().some((el)=>el instanceof HTMLInputElement && el.type === 'range')) allowTouchMove = true;
        // If this is a focused input element with a selected range, allow user to drag the selection handles.
        if ('selectionStart' in target && 'selectionEnd' in target && target.selectionStart < target.selectionEnd && target.ownerDocument.activeElement === target) allowTouchMove = true;
    };
    // Prevent scrolling up when at the top and scrolling down when at the bottom
    // of a nested scrollable area, otherwise mobile Safari will start scrolling
    // the window instead.
    // This must be applied before the touchstart event as of iOS 26, so inject it as a <style> element.
    let style = document.createElement('style');
    let nonce = (0, $5f528d9729e078c2$export$2b85b721e524d74b)();
    if (nonce) style.nonce = nonce;
    style.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim();
    document.head.prepend(style);
    let onTouchMove = (e)=>{
        // Allow pinch-zooming.
        if (e.touches.length === 2 || allowTouchMove) return;
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onBlur = (e)=>{
        let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        let relatedTarget = e.relatedTarget;
        if (relatedTarget && (0, $04f975ad47e6ea6d$export$c57958e35f31ed73)(relatedTarget)) {
            // Focus without scrolling the whole page, and then scroll into view manually.
            relatedTarget.focus({
                preventScroll: true
            });
            $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$scrollIntoViewWhenReady(relatedTarget, (0, $04f975ad47e6ea6d$export$c57958e35f31ed73)(target));
        } else if (!relatedTarget) {
            // When tapping the Done button on the keyboard, focus moves to the body.
            // FocusScope will then restore focus back to the input. Later when tapping
            // the same input again, it is already focused, so no blur event will fire,
            // resulting in the flow above never running and Safari's native scrolling occurring.
            // Instead, move focus to the parent focusable element (e.g. the dialog).
            let focusable = target.parentElement?.closest('[tabindex]');
            focusable?.focus({
                preventScroll: true
            });
        }
    };
    // Override programmatic focus to scroll into view without scrolling the whole page.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(opts) {
        // Track whether the keyboard was already visible before.
        let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
        let wasKeyboardVisible = activeElement != null && (0, $04f975ad47e6ea6d$export$c57958e35f31ed73)(activeElement);
        // Focus the element without scrolling the page.
        focus.call(this, {
            ...opts,
            preventScroll: true
        });
        if (!opts || !opts.preventScroll) $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$scrollIntoViewWhenReady(this, wasKeyboardVisible);
    };
    let removeEvents = (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)($a2359fdf8b4c0098$var$$0644e3663365bfe5$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$addEvent(document, 'blur', onBlur, true));
    return ()=>{
        restoreOverflow();
        removeEvents();
        style.remove();
        HTMLElement.prototype.focus = focus;
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$addEvent(target, event, handler, options) {
    // internal function, so it's ok to ignore the difficult to fix type error
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return ()=>{
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$scrollIntoViewWhenReady(target, wasKeyboardVisible) {
    if (wasKeyboardVisible || !$a2359fdf8b4c0098$var$$0644e3663365bfe5$var$visualViewport) $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$scrollIntoView(target);
    else // measure the correct position to scroll to.
    $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$visualViewport.addEventListener('resize', ()=>$a2359fdf8b4c0098$var$$0644e3663365bfe5$var$scrollIntoView(target), {
        once: true
    });
}
function $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    let nextTarget = target;
    while(nextTarget && nextTarget !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $05b5d708b420cd83$export$cfa2225e87938781)(nextTarget);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
            let scrollableRect = scrollable.getBoundingClientRect();
            let targetRect = nextTarget.getBoundingClientRect();
            if (targetRect.top < scrollableRect.top || targetRect.bottom > scrollableRect.top + nextTarget.clientHeight) {
                let bottom = scrollableRect.bottom;
                if ($a2359fdf8b4c0098$var$$0644e3663365bfe5$var$visualViewport) bottom = Math.min(bottom, $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$visualViewport.offsetTop + $a2359fdf8b4c0098$var$$0644e3663365bfe5$var$visualViewport.height);
                // Center within the viewport.
                let adjustment = targetRect.top - scrollableRect.top - ((bottom - scrollableRect.top) / 2 - targetRect.height / 2);
                scrollable.scrollTo({
                    // Clamp to the valid range to prevent over-scrolling.
                    top: Math.max(0, Math.min(scrollable.scrollHeight - scrollable.clientHeight, scrollable.scrollTop + adjustment)),
                    behavior: 'smooth'
                });
            }
        }
        nextTarget = scrollable.parentElement;
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $307a350e3349b6de$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, groupRef: groupRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    let isSubmenu = otherProps['trigger'] === 'SubmenuTrigger';
    let { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $2a3fcbfcdf4b930b$export$ea8f71083e90600f)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal || isSubmenu,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, groupRef ?? popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: origin } = (0, $1fae08535d7d048a$export$d39e1813b3bdd0e1)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal && !isSubmenu ? state.close : null
    });
    (0, $a2359fdf8b4c0098$export$ee0f7cc6afcd1c18)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && popoverRef.current) {
            if (isNonModal) return (0, $3dcf81fd889e5f42$export$1020fa7f77e17884)(groupRef?.current ?? popoverRef.current);
            else return (0, $3dcf81fd889e5f42$export$1c3ebcada18427bf)([
                groupRef?.current ?? popoverRef.current
            ], {
                shouldUseInert: true
            });
        }
    }, [
        isNonModal,
        state.isOpen,
        popoverRef,
        groupRef
    ]);
    return {
        popoverProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement,
        triggerAnchorPoint: origin
    };
}


var $95b70dafd7bf21ac$export$2e2bcd8739ae039 = {};
$95b70dafd7bf21ac$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


var $5fb45d0a92cc1e98$export$2e2bcd8739ae039 = {};
$5fb45d0a92cc1e98$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


var $c51358ec8b2cdc49$export$2e2bcd8739ae039 = {};
$c51358ec8b2cdc49$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};


var $16bd49e609dd6f24$export$2e2bcd8739ae039 = {};
$16bd49e609dd6f24$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};


var $c4ce2f2b39f50ba7$export$2e2bcd8739ae039 = {};
$c4ce2f2b39f50ba7$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};


var $d3116529ea98aa84$export$2e2bcd8739ae039 = {};
$d3116529ea98aa84$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};


var $c32844beabb52c5d$export$2e2bcd8739ae039 = {};
$c32844beabb52c5d$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};


var $e900587482c88497$export$2e2bcd8739ae039 = {};
$e900587482c88497$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};


var $db8c4b7c59662c4b$export$2e2bcd8739ae039 = {};
$db8c4b7c59662c4b$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};


var $cc2e2671fb9bce0a$export$2e2bcd8739ae039 = {};
$cc2e2671fb9bce0a$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};


var $469a668d33770159$export$2e2bcd8739ae039 = {};
$469a668d33770159$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};


var $fb9fa58e858e3777$export$2e2bcd8739ae039 = {};
$fb9fa58e858e3777$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


var $7db322eaf4a03d01$export$2e2bcd8739ae039 = {};
$7db322eaf4a03d01$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};


var $9ff1517c3050b36e$export$2e2bcd8739ae039 = {};
$9ff1517c3050b36e$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};


var $6ff534e353a9b5ab$export$2e2bcd8739ae039 = {};
$6ff534e353a9b5ab$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};


var $3e44359b745af9ba$export$2e2bcd8739ae039 = {};
$3e44359b745af9ba$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


var $4c06f9a47debea41$export$2e2bcd8739ae039 = {};
$4c06f9a47debea41$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};


var $1d66229405b64078$export$2e2bcd8739ae039 = {};
$1d66229405b64078$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};


var $ae211ed34009cb74$export$2e2bcd8739ae039 = {};
$ae211ed34009cb74$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};


var $139290f5854595cb$export$2e2bcd8739ae039 = {};
$139290f5854595cb$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};


var $1d1bc0cfbb6d5c6a$export$2e2bcd8739ae039 = {};
$1d1bc0cfbb6d5c6a$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};


var $f6fae29926e4d78a$export$2e2bcd8739ae039 = {};
$f6fae29926e4d78a$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};


var $c5edcac8b317d46f$export$2e2bcd8739ae039 = {};
$c5edcac8b317d46f$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};


var $6ac4d4b4f3fe3db8$export$2e2bcd8739ae039 = {};
$6ac4d4b4f3fe3db8$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};


var $214a2fa0c6b6ffba$export$2e2bcd8739ae039 = {};
$214a2fa0c6b6ffba$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};


var $f6adb6a2b419d11d$export$2e2bcd8739ae039 = {};
$f6adb6a2b419d11d$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


var $1383906bc1bd7aaf$export$2e2bcd8739ae039 = {};
$1383906bc1bd7aaf$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};


var $874f294f94cf61f1$export$2e2bcd8739ae039 = {};
$874f294f94cf61f1$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};


var $4532563182378127$export$2e2bcd8739ae039 = {};
$4532563182378127$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};


var $a211fc3819bb134c$export$2e2bcd8739ae039 = {};
$a211fc3819bb134c$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};


var $4c8f53d9e550170b$export$2e2bcd8739ae039 = {};
$4c8f53d9e550170b$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};


var $7ff28e8ead085241$export$2e2bcd8739ae039 = {};
$7ff28e8ead085241$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


var $8bb56d5ae0f45c23$export$2e2bcd8739ae039 = {};
$8bb56d5ae0f45c23$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};


var $3436102ff58e1f4e$export$2e2bcd8739ae039 = {};
$3436102ff58e1f4e$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};


var $d70801974758e55d$export$2e2bcd8739ae039 = {};
$d70801974758e55d$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $95b70dafd7bf21ac$export$2e2bcd8739ae039),
    "bg-BG": (0, $5fb45d0a92cc1e98$export$2e2bcd8739ae039),
    "cs-CZ": (0, $c51358ec8b2cdc49$export$2e2bcd8739ae039),
    "da-DK": (0, $16bd49e609dd6f24$export$2e2bcd8739ae039),
    "de-DE": (0, $c4ce2f2b39f50ba7$export$2e2bcd8739ae039),
    "el-GR": (0, $d3116529ea98aa84$export$2e2bcd8739ae039),
    "en-US": (0, $c32844beabb52c5d$export$2e2bcd8739ae039),
    "es-ES": (0, $e900587482c88497$export$2e2bcd8739ae039),
    "et-EE": (0, $db8c4b7c59662c4b$export$2e2bcd8739ae039),
    "fi-FI": (0, $cc2e2671fb9bce0a$export$2e2bcd8739ae039),
    "fr-FR": (0, $469a668d33770159$export$2e2bcd8739ae039),
    "he-IL": (0, $fb9fa58e858e3777$export$2e2bcd8739ae039),
    "hr-HR": (0, $7db322eaf4a03d01$export$2e2bcd8739ae039),
    "hu-HU": (0, $9ff1517c3050b36e$export$2e2bcd8739ae039),
    "it-IT": (0, $6ff534e353a9b5ab$export$2e2bcd8739ae039),
    "ja-JP": (0, $3e44359b745af9ba$export$2e2bcd8739ae039),
    "ko-KR": (0, $4c06f9a47debea41$export$2e2bcd8739ae039),
    "lt-LT": (0, $1d66229405b64078$export$2e2bcd8739ae039),
    "lv-LV": (0, $ae211ed34009cb74$export$2e2bcd8739ae039),
    "nb-NO": (0, $139290f5854595cb$export$2e2bcd8739ae039),
    "nl-NL": (0, $1d1bc0cfbb6d5c6a$export$2e2bcd8739ae039),
    "pl-PL": (0, $f6fae29926e4d78a$export$2e2bcd8739ae039),
    "pt-BR": (0, $c5edcac8b317d46f$export$2e2bcd8739ae039),
    "pt-PT": (0, $6ac4d4b4f3fe3db8$export$2e2bcd8739ae039),
    "ro-RO": (0, $214a2fa0c6b6ffba$export$2e2bcd8739ae039),
    "ru-RU": (0, $f6adb6a2b419d11d$export$2e2bcd8739ae039),
    "sk-SK": (0, $1383906bc1bd7aaf$export$2e2bcd8739ae039),
    "sl-SI": (0, $874f294f94cf61f1$export$2e2bcd8739ae039),
    "sr-SP": (0, $4532563182378127$export$2e2bcd8739ae039),
    "sv-SE": (0, $a211fc3819bb134c$export$2e2bcd8739ae039),
    "tr-TR": (0, $4c8f53d9e550170b$export$2e2bcd8739ae039),
    "uk-UA": (0, $7ff28e8ead085241$export$2e2bcd8739ae039),
    "zh-CN": (0, $8bb56d5ae0f45c23$export$2e2bcd8739ae039),
    "zh-TW": (0, $3436102ff58e1f4e$export$2e2bcd8739ae039)
};







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1b36921254027e01$var$$ea3928288112382f$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap'
};
function $1b36921254027e01$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $acw62.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$1b36921254027e01$var$$ea3928288112382f$var$styles,
            ...style
        };
        else return $1b36921254027e01$var$$ea3928288112382f$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $1b36921254027e01$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = 'div', isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $1b36921254027e01$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, (0, $195af97314dd822a$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}



var $acw62 = parcelRequire("acw62");
function $f3b62664694cfaa7$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f3b62664694cfaa7$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($f3b62664694cfaa7$var$$parcel$interopDefault((0, $d70801974758e55d$export$2e2bcd8739ae039)), '@react-aria/overlays');
    let labels = (0, $d00c1960ddd60c91$export$d6875122194c7b44)(otherProps, stringFormatter.format('dismiss'));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b36921254027e01$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}









var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7443e41c6b4c1d53$export$6d3443f2c48bfc20(ref, isReady = true) {
    let [isEntering, setEntering] = (0, $acw62.useState)(true);
    let isAnimationReady = isEntering && isReady;
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (isAnimationReady && ref.current && 'getAnimations' in ref.current) {
            for (let animation of ref.current.getAnimations())if (animation instanceof CSSTransition) animation.cancel();
        }
    }, [
        ref,
        isAnimationReady
    ]);
    $7443e41c6b4c1d53$var$$fcc7165e876206c6$var$useAnimation(ref, isAnimationReady, (0, $acw62.useCallback)(()=>setEntering(false), []));
    return isAnimationReady;
}
function $7443e41c6b4c1d53$export$45fda7c47f93fd48(ref, isOpen) {
    let [exitState, setExitState] = (0, $acw62.useState)(isOpen ? 'open' : 'closed');
    switch(exitState){
        case 'open':
            // If isOpen becomes false, set the state to exiting.
            if (!isOpen) setExitState('exiting');
            break;
        case 'closed':
        case 'exiting':
            // If we are exiting and isOpen becomes true, the animation was interrupted.
            // Reset the state to open.
            if (isOpen) setExitState('open');
            break;
    }
    let isExiting = exitState === 'exiting';
    $7443e41c6b4c1d53$var$$fcc7165e876206c6$var$useAnimation(ref, isExiting, (0, $acw62.useCallback)(()=>{
        // Set the state to closed, which will cause the element to be unmounted.
        setExitState((state)=>state === 'exiting' ? 'closed' : state);
    }, []));
    return isExiting;
}
function $7443e41c6b4c1d53$var$$fcc7165e876206c6$var$useAnimation(ref, isActive, onEnd) {
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (isActive && ref.current) {
            if (!('getAnimations' in ref.current)) {
                // JSDOM
                onEnd();
                return;
            }
            let animations = ref.current.getAnimations();
            if (animations.length === 0) {
                onEnd();
                return;
            }
            let canceled = false;
            Promise.allSettled(animations.map((a)=>a.finished)).then(()=>{
                if (!canceled) (0, $1u0KT.flushSync)(()=>{
                    onEnd();
                });
            });
            return ()=>{
                canceled = true;
            };
        }
    }, [
        ref,
        isActive,
        onEnd
    ]);
}





/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c079ee9c5fe80a9e$export$9b9a0cd73afb7ca4 = (0, $acw62.createContext)(null);
// Stores a ref for the portal container for a group of popovers (e.g. submenus).
const $c079ee9c5fe80a9e$var$$542a13ca2fa5b484$var$PopoverGroupContext = (0, $acw62.createContext)(null);
const $c079ee9c5fe80a9e$export$5b6b19405a83ff9d = (0, $acw62.forwardRef)(function Popover(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $c079ee9c5fe80a9e$export$9b9a0cd73afb7ca4);
    let contextState = (0, $acw62.useContext)((0, $ce4897092af7eb66$export$d2f961adcb0afbe));
    let localState = (0, $2069e091702d9800$export$61c6a8c84e605fb6)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let isExiting = (0, $7443e41c6b4c1d53$export$45fda7c47f93fd48)(ref, state.isOpen) || props.isExiting || false;
    let isHidden = (0, $ffa0afb9817175b6$export$b5d7cc18bb8d2b59)();
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    // If we are in a hidden tree, we still need to preserve our children.
    if (isHidden) {
        let children = props.children;
        if (typeof children === 'function') children = children({
            trigger: props.trigger || null,
            placement: 'bottom',
            isEntering: false,
            isExiting: false,
            defaultChildren: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    }
    if (state && !state.isOpen && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c079ee9c5fe80a9e$var$$542a13ca2fa5b484$var$PopoverInner, {
        ...props,
        triggerRef: props.triggerRef,
        state: state,
        popoverRef: ref,
        isExiting: isExiting,
        dir: direction
    });
});
function $c079ee9c5fe80a9e$var$$542a13ca2fa5b484$var$PopoverInner({ state: state, isExiting: isExiting, UNSTABLE_portalContainer: UNSTABLE_portalContainer, clearContexts: clearContexts, ...props }) {
    // Calculate the arrow size internally (and remove props.arrowSize from PopoverProps)
    // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
    let arrowRef = (0, $acw62.useRef)(null);
    let containerRef = (0, $acw62.useRef)(null);
    let groupCtx = (0, $acw62.useContext)($c079ee9c5fe80a9e$var$$542a13ca2fa5b484$var$PopoverGroupContext);
    let isSubPopover = groupCtx && props.trigger === 'SubmenuTrigger';
    let { popoverProps: popoverProps, underlayProps: underlayProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: triggerAnchorPoint } = (0, $307a350e3349b6de$export$542a6fd13ac93354)({
        ...props,
        offset: props.offset ?? 8,
        arrowRef: arrowRef,
        // If this is a submenu/subdialog, use the root popover's container
        // to detect outside interaction and add aria-hidden.
        groupRef: isSubPopover ? groupCtx : containerRef
    }, state);
    let ref = props.popoverRef;
    let isEntering = (0, $7443e41c6b4c1d53$export$6d3443f2c48bfc20)(ref, !!placement) || props.isEntering || false;
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-Popover',
        values: {
            trigger: props.trigger || null,
            placement: placement,
            isEntering: isEntering,
            isExiting: isExiting
        }
    });
    // Automatically render Popover with role=dialog except when isNonModal is true,
    // or a dialog is already nested inside the popover.
    let shouldBeDialog = !props.isNonModal || props.trigger === 'SubmenuTrigger';
    let [isDialog, setDialog] = (0, $acw62.useState)(false);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (ref.current) setDialog(shouldBeDialog && !ref.current.querySelector('[role=dialog]'));
    }, [
        ref,
        shouldBeDialog
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDialog && (props.trigger !== 'SubmenuTrigger' || (0, $627d69440c27e5e4$export$630ff653c5ada6a9)() !== 'pointer') && ref.current && !(0, $8fd85525b97849bf$export$b4f377a2b6254582)(ref.current)) (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
    }, [
        isDialog,
        ref,
        props.trigger
    ]);
    let children = (0, $acw62.useMemo)(()=>{
        let children = renderProps.children;
        if (clearContexts) for (let Context of clearContexts)children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: null
        }, children);
        return children;
    }, [
        renderProps.children,
        clearContexts
    ]);
    let style = {
        ...popoverProps.style,
        '--trigger-anchor-point': triggerAnchorPoint ? `${triggerAnchorPoint.x}px ${triggerAnchorPoint.y}px` : undefined,
        ...renderProps.style
    };
    let overlay = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)((0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
            global: true
        }), popoverProps),
        ...renderProps,
        role: isDialog ? 'dialog' : undefined,
        tabIndex: isDialog ? -1 : undefined,
        "aria-label": props['aria-label'],
        "aria-labelledby": props['aria-labelledby'],
        ref: ref,
        slot: props.slot || undefined,
        style: style,
        dir: props.dir,
        "data-trigger": props.trigger,
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, !props.isNonModal && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f3b62664694cfaa7$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1f2154cf4c8e1674$export$2de4954e8ae13b9f).Provider, {
        value: {
            ...arrowProps,
            placement: placement,
            ref: arrowRef
        }
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f3b62664694cfaa7$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }));
    // If this is a root popover, render an extra div to act as the portal container for submenus/subdialogs.
    if (!isSubPopover) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4b93c37deb87f91$export$c6fdb837b070b4ff), {
        ...props,
        shouldContainFocus: isDialog,
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, !props.isNonModal && state.isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "underlay",
        ...underlayProps,
        style: {
            position: 'fixed',
            inset: 0
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c079ee9c5fe80a9e$var$$542a13ca2fa5b484$var$PopoverGroupContext.Provider, {
        value: containerRef
    }, overlay)));
    // Submenus/subdialogs are mounted into the root popover's container.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4b93c37deb87f91$export$c6fdb837b070b4ff), {
        ...props,
        shouldContainFocus: isDialog,
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer ?? groupCtx?.current ?? undefined
    }, overlay);
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $76bbfd363f450690$export$ff05c3ac10437e03 = (0, $acw62.createContext)(null);
const $76bbfd363f450690$export$f551688fc98f2e09 = (0, $acw62.forwardRef)(function FieldError(props, ref) {
    let validation = (0, $acw62.useContext)($76bbfd363f450690$export$ff05c3ac10437e03);
    if (!validation?.isInvalid) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($76bbfd363f450690$var$$1f3c3b1a70cec653$var$FieldErrorInner, {
        ...props,
        ref: ref
    });
});
const $76bbfd363f450690$var$$1f3c3b1a70cec653$var$FieldErrorInner = (0, $acw62.forwardRef)((props, ref)=>{
    let validation = (0, $acw62.useContext)($76bbfd363f450690$export$ff05c3ac10437e03);
    let { elementType: elementType, ...restProps } = props;
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(restProps, {
        global: true
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...restProps,
        defaultClassName: 'react-aria-FieldError',
        defaultChildren: validation.validationErrors.length === 0 ? undefined : validation.validationErrors.join(' '),
        values: validation
    });
    if (renderProps.children == null) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b7271d3af613df1$export$5f1af8db9871e1d6), {
        slot: "errorMessage",
        elementType: elementType,
        ...domProps,
        ...renderProps,
        ref: ref
    });
});




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0c6ddd323fa7af24$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$CUSTOM_VALIDITY_STATE = {
    ...$0c6ddd323fa7af24$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $0c6ddd323fa7af24$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $0c6ddd323fa7af24$export$aca958c65c314e6c,
    validationErrors: []
};
const $0c6ddd323fa7af24$export$571b5131b7e65c11 = (0, $acw62.createContext)({});
const $0c6ddd323fa7af24$export$a763b9476acd3eb = '__reactAriaFormValidationState';
function $0c6ddd323fa7af24$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$0c6ddd323fa7af24$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$0c6ddd323fa7af24$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$useFormValidationStateImpl(props);
}
function $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = 'aria' } = props;
    // backward compatibility.
    if (validationState) isInvalid ||= validationState === 'invalid';
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $acw62.useMemo)(()=>{
        if (!validate || value == null) return null;
        let validateErrors = $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$runValidate(validate, value);
        return $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$getValidationResult(validateErrors);
    }, [
        validate,
        value
    ]);
    if (builtinValidation?.validationDetails.valid) builtinValidation = undefined;
    // Get relevant server errors from the form.
    let serverErrors = (0, $acw62.useContext)($0c6ddd323fa7af24$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $acw62.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$0c6ddd323fa7af24$var$$fd2148440a13ec26$var$asArray(serverErrors[name])) : $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $acw62.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $acw62.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $acw62.useMemo)(()=>$0c6ddd323fa7af24$var$$fd2148440a13ec26$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $acw62.useRef)($0c6ddd323fa7af24$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $acw62.useState)($0c6ddd323fa7af24$export$dad6ae84456c676a);
    let lastError = (0, $acw62.useRef)($0c6ddd323fa7af24$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$0c6ddd323fa7af24$var$$fd2148440a13ec26$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $0c6ddd323fa7af24$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === 'native' ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === 'aria' && !$0c6ddd323fa7af24$var$$fd2148440a13ec26$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $0c6ddd323fa7af24$export$dad6ae84456c676a;
            if (!$0c6ddd323fa7af24$var$$fd2148440a13ec26$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === 'native') setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === 'native') setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$runValidate(validate, value) {
    if (typeof validate === 'function') {
        let e = validate(value);
        if (e && typeof e !== 'boolean') return $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$asArray(e);
    }
    return [];
}
function $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $0c6ddd323fa7af24$var$$fd2148440a13ec26$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $0c6ddd323fa7af24$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$0c6ddd323fa7af24$export$aca958c65c314e6c
    };
    for (let v of results){
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid ||= v.isInvalid;
        for(let key in validationDetails)validationDetails[key] ||= v.validationDetails[key];
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bdd138f35fdd977e$export$c24727297075ec6a = (0, $acw62.createContext)(null);
const $bdd138f35fdd977e$export$a7fed597f4b8afd8 = (0, $acw62.forwardRef)(function Form(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $bdd138f35fdd977e$export$c24727297075ec6a);
    let { validationErrors: validationErrors, validationBehavior: validationBehavior = 'native', children: children, className: className, ...domProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).form, {
        noValidate: validationBehavior !== 'native',
        ...domProps,
        ref: ref,
        className: className || 'react-aria-Form'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bdd138f35fdd977e$export$c24727297075ec6a.Provider, {
        value: {
            ...props,
            validationBehavior: validationBehavior
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0c6ddd323fa7af24$export$571b5131b7e65c11).Provider, {
        value: validationErrors ?? {}
    }, children)));
});


var $f311888bc8e0e94d$export$2e2bcd8739ae039 = {};
$f311888bc8e0e94d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{644}\u{648}\u{627}\u{646}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{62D}\u{62F}\u{62F} \u{639}\u{646}\u{635}\u{631}\u{64B}\u{627}`,
    "tableResizer": `\u{623}\u{62F}\u{627}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`
};


var $a5c483787c266cb5$export$2e2bcd8739ae039 = {};
$a5c483787c266cb5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{438} \u{43C}\u{43E}\u{441}\u{442}\u{440}\u{438}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}`,
    "tableResizer": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}`
};


var $86a12841e8b2e581$export$2e2bcd8739ae039 = {};
$86a12841e8b2e581$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorky barev`,
    "dropzoneLabel": `M\xedsto pro p\u{159}eta\u{17E}en\xed`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `Zm\u{11B}na velikosti`
};


var $52acb70396fcfe3d$export$2e2bcd8739ae039 = {};
$52acb70396fcfe3d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farvepr\xf8ver`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe6lg et element`,
    "tableResizer": `St\xf8rrelses\xe6ndring`
};


var $ee02524fe5db966c$export$2e2bcd8739ae039 = {};
$ee02524fe5db966c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farbfelder`,
    "dropzoneLabel": `Ablegebereich`,
    "selectPlaceholder": `Element w\xe4hlen`,
    "tableResizer": `Gr\xf6\xdfenanpassung`
};


var $49346a7b24ae72e6$export$2e2bcd8739ae039 = {};
$49346a7b24ae72e6$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{3A7}\u{3C1}\u{3C9}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3AC} \u{3B4}\u{3B5}\u{3AF}\u{3B3}\u{3BC}\u{3B1}\u{3C4}\u{3B1}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3BE}\u{3C4}\u{3B5} \u{3AD}\u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B5}\u{3AF}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "tableResizer": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`
};


var $948200540231f1d5$export$2e2bcd8739ae039 = {};
$948200540231f1d5$export$2e2bcd8739ae039 = {
    "selectPlaceholder": `Select an item`,
    "tableResizer": `Resizer`,
    "dropzoneLabel": `DropZone`,
    "colorSwatchPicker": `Color swatches`
};


var $d3932d71751b5618$export$2e2bcd8739ae039 = {};
$d3932d71751b5618$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Muestras de colores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Seleccionar un art\xedculo`,
    "tableResizer": `Cambiador de tama\xf1o`
};


var $60c744b0eb5093cc$export$2e2bcd8739ae039 = {};
$60c744b0eb5093cc$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rvin\xe4idised`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};


var $cc874e1a88006c60$export$2e2bcd8739ae039 = {};
$cc874e1a88006c60$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rimallit`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valitse kohde`,
    "tableResizer": `Koon muuttaja`
};


var $f3b125e717c02eeb$export$2e2bcd8739ae039 = {};
$f3b125e717c02eeb$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\xc9chantillons de couleurs`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `S\xe9lectionner un \xe9l\xe9ment`,
    "tableResizer": `Redimensionneur`
};


var $9cacb3e391b666cd$export$2e2bcd8739ae039 = {};
$9cacb3e391b666cd$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{5D3}\u{5D5}\u{5D2}\u{5DE}\u{5D9}\u{5D5}\u{5EA} \u{5E6}\u{5D1}\u{5E2}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{5D1}\u{5D7}\u{5E8} \u{5E4}\u{5E8}\u{5D9}\u{5D8}`,
    "tableResizer": `\u{5E9}\u{5D9}\u{5E0}\u{5D5}\u{5D9} \u{5D2}\u{5D5}\u{5D3}\u{5DC}`
};


var $a0ce17594440c9e1$export$2e2bcd8739ae039 = {};
$a0ce17594440c9e1$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boja`,
    "dropzoneLabel": `Zona spu\u{161}tanja`,
    "selectPlaceholder": `Odaberite stavku`,
    "tableResizer": `Promjena veli\u{10D}ine`
};


var $a9bed06a512a569a$export$2e2bcd8739ae039 = {};
$a9bed06a512a569a$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Sz\xednt\xe1rak`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe1lasszon ki egy elemet`,
    "tableResizer": `\xc1tm\xe9retez\u{151}`
};


var $3576852d4846e96d$export$2e2bcd8739ae039 = {};
$3576852d4846e96d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Campioni di colore`,
    "dropzoneLabel": `Zona di rilascio`,
    "selectPlaceholder": `Seleziona un elemento`,
    "tableResizer": `Ridimensionamento`
};


var $65c62a5a9d299b6e$export$2e2bcd8739ae039 = {};
$65c62a5a9d299b6e$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30B9}\u{30A6}\u{30A9}\u{30C3}\u{30C1}`,
    "dropzoneLabel": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BE}\u{30FC}\u{30F3}`,
    "selectPlaceholder": `\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}`,
    "tableResizer": `\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{30C4}\u{30FC}\u{30EB}`
};


var $e7ecdfd5e7511825$export$2e2bcd8739ae039 = {};
$e7ecdfd5e7511825$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{C0C9}\u{C0C1} \u{ACAC}\u{BCF8}`,
    "dropzoneLabel": `\u{B4DC}\u{B86D} \u{C601}\u{C5ED}`,
    "selectPlaceholder": `\u{D56D}\u{BAA9} \u{C120}\u{D0DD}`,
    "tableResizer": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{AE30}`
};


var $9f6f312811f455b4$export$2e2bcd8739ae039 = {};
$9f6f312811f455b4$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Spalv\u{173} pavyzd\u{17E}iai`,
    "dropzoneLabel": `\u{201E}DropZone\u{201C}`,
    "selectPlaceholder": `Pasirinkite element\u{105}`,
    "tableResizer": `Dyd\u{17E}io keitiklis`
};


var $b8be766187c85a54$export$2e2bcd8739ae039 = {};
$b8be766187c85a54$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Kr\u{101}su paraugi`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izv\u{113}l\u{113}ties vienumu`,
    "tableResizer": `Izm\u{113}ra main\u{12B}t\u{101}js`
};


var $db78b677342da0d7$export$2e2bcd8739ae039 = {};
$db78b677342da0d7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Fargekart`,
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};


var $edf890b430328563$export$2e2bcd8739ae039 = {};
$edf890b430328563$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `kleurstalen`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`
};


var $d2790b157e6374a9$export$2e2bcd8739ae039 = {};
$d2790b157e6374a9$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Pr\xf3bki kolor\xf3w`,
    "dropzoneLabel": `Strefa upuszczania`,
    "selectPlaceholder": `Wybierz element`,
    "tableResizer": `Zmiana rozmiaru`
};


var $a0e3d487f5510840$export$2e2bcd8739ae039 = {};
$a0e3d487f5510840$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


var $ccc4cb69f86c12c9$export$2e2bcd8739ae039 = {};
$ccc4cb69f86c12c9$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


var $4963f16c82e995b5$export$2e2bcd8739ae039 = {};
$4963f16c82e995b5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Specimene de culoare`,
    "dropzoneLabel": `Zon\u{103} de plasare`,
    "selectPlaceholder": `Selecta\u{21B}i un element`,
    "tableResizer": `Instrument de redimensionare`
};


var $2e826042b6d4987d$export$2e2bcd8739ae039 = {};
$2e826042b6d4987d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{44B}\u{435} \u{43E}\u{431}\u{440}\u{430}\u{437}\u{446}\u{44B}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430}`
};


var $2fe4ed9dd0d48513$export$2e2bcd8739ae039 = {};
$2fe4ed9dd0d48513$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorkovn\xedky farieb`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `N\xe1stroj na zmenu ve\u{13E}kosti`
};


var $4467ec743def48d0$export$2e2bcd8739ae039 = {};
$4467ec743def48d0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Barvne palete`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izberite element`,
    "tableResizer": `Spreminjanje velikosti`
};


var $95067f31966b41b5$export$2e2bcd8739ae039 = {};
$95067f31966b41b5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boje`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`
};


var $b8349cf0dd26aa09$export$2e2bcd8739ae039 = {};
$b8349cf0dd26aa09$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `F\xe4rgrutor`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};


var $b8c55d40f09051b5$export$2e2bcd8739ae039 = {};
$b8c55d40f09051b5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Renk \xf6rnekleri`,
    "dropzoneLabel": `B\u{131}rakma B\xf6lgesi`,
    "selectPlaceholder": `Bir \xf6\u{11F}e se\xe7in`,
    "tableResizer": `Yeniden boyutland\u{131}r\u{131}c\u{131}`
};


var $80d929572fd43d7f$export$2e2bcd8739ae039 = {};
$80d929572fd43d7f$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{417}\u{440}\u{430}\u{437}\u{43A}\u{438} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{417}\u{430}\u{441}\u{456}\u{431} \u{437}\u{43C}\u{456}\u{43D}\u{435}\u{43D}\u{43D}\u{44F} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`
};


var $a7a2e818e08cbdf3$export$2e2bcd8739ae039 = {};
$a7a2e818e08cbdf3$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{989C}\u{8272}\u{8272}\u{677F}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{533A}\u{57DF}`,
    "selectPlaceholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9879}\u{76EE}`,
    "tableResizer": `\u{5C3A}\u{5BF8}\u{8C03}\u{6574}\u{5668}`
};


var $260db04705e578b1$export$2e2bcd8739ae039 = {};
$260db04705e578b1$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{8272}\u{7968}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{5340}`,
    "selectPlaceholder": `\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "tableResizer": `\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`
};


var $4793c39cef08f039$export$2e2bcd8739ae039 = {};
$4793c39cef08f039$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $f311888bc8e0e94d$export$2e2bcd8739ae039),
    "bg-BG": (0, $a5c483787c266cb5$export$2e2bcd8739ae039),
    "cs-CZ": (0, $86a12841e8b2e581$export$2e2bcd8739ae039),
    "da-DK": (0, $52acb70396fcfe3d$export$2e2bcd8739ae039),
    "de-DE": (0, $ee02524fe5db966c$export$2e2bcd8739ae039),
    "el-GR": (0, $49346a7b24ae72e6$export$2e2bcd8739ae039),
    "en-US": (0, $948200540231f1d5$export$2e2bcd8739ae039),
    "es-ES": (0, $d3932d71751b5618$export$2e2bcd8739ae039),
    "et-EE": (0, $60c744b0eb5093cc$export$2e2bcd8739ae039),
    "fi-FI": (0, $cc874e1a88006c60$export$2e2bcd8739ae039),
    "fr-FR": (0, $f3b125e717c02eeb$export$2e2bcd8739ae039),
    "he-IL": (0, $9cacb3e391b666cd$export$2e2bcd8739ae039),
    "hr-HR": (0, $a0ce17594440c9e1$export$2e2bcd8739ae039),
    "hu-HU": (0, $a9bed06a512a569a$export$2e2bcd8739ae039),
    "it-IT": (0, $3576852d4846e96d$export$2e2bcd8739ae039),
    "ja-JP": (0, $65c62a5a9d299b6e$export$2e2bcd8739ae039),
    "ko-KR": (0, $e7ecdfd5e7511825$export$2e2bcd8739ae039),
    "lt-LT": (0, $9f6f312811f455b4$export$2e2bcd8739ae039),
    "lv-LV": (0, $b8be766187c85a54$export$2e2bcd8739ae039),
    "nb-NO": (0, $db78b677342da0d7$export$2e2bcd8739ae039),
    "nl-NL": (0, $edf890b430328563$export$2e2bcd8739ae039),
    "pl-PL": (0, $d2790b157e6374a9$export$2e2bcd8739ae039),
    "pt-BR": (0, $a0e3d487f5510840$export$2e2bcd8739ae039),
    "pt-PT": (0, $ccc4cb69f86c12c9$export$2e2bcd8739ae039),
    "ro-RO": (0, $4963f16c82e995b5$export$2e2bcd8739ae039),
    "ru-RU": (0, $2e826042b6d4987d$export$2e2bcd8739ae039),
    "sk-SK": (0, $2fe4ed9dd0d48513$export$2e2bcd8739ae039),
    "sl-SI": (0, $4467ec743def48d0$export$2e2bcd8739ae039),
    "sr-SP": (0, $95067f31966b41b5$export$2e2bcd8739ae039),
    "sv-SE": (0, $b8349cf0dd26aa09$export$2e2bcd8739ae039),
    "tr-TR": (0, $b8c55d40f09051b5$export$2e2bcd8739ae039),
    "uk-UA": (0, $80d929572fd43d7f$export$2e2bcd8739ae039),
    "zh-CN": (0, $a7a2e818e08cbdf3$export$2e2bcd8739ae039),
    "zh-TW": (0, $260db04705e578b1$export$2e2bcd8739ae039)
};


















/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ec7707e2bf6dfe59$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $f5e6258447762a7e$export$8467354a121f1b9f)(props);
    let descriptionId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2fe5180bff655840$export$703601b7e90536f8 = new WeakMap();
function $2fe5180bff655840$export$e64b2f635402ca43(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate, isDisabled: isDisabled, isRequired: isRequired, name: name, form: form, validationBehavior: validationBehavior = 'aria' } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $040b7c2ffa13ce2b$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $a3fdb18a48ed07b4$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, ref, collator), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator,
        ref
    ]);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $76315dc48e502eaa$export$dc9c12ed27dd1b49)({
        isDisabled: isDisabled,
        type: 'listbox'
    }, state, ref);
    let onKeyDown = (e)=>{
        if (state.selectionManager.selectionMode === 'multiple') return;
        switch(e.key){
            case 'ArrowLeft':
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyAbove?.(state.selectedKey) : delegate.getFirstKey?.();
                    if (key) state.setSelectedKey(key);
                    break;
                }
            case 'ArrowRight':
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyBelow?.(state.selectedKey) : delegate.getFirstKey?.();
                    if (key) state.setSelectedKey(key);
                    break;
                }
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $618460223b684d16$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $ec7707e2bf6dfe59$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    if (state.selectionManager.selectionMode === 'multiple') typeSelectProps = {};
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let triggerProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    $2fe5180bff655840$export$703601b7e90536f8.set(state, {
        isDisabled: isDisabled,
        isRequired: isRequired,
        name: name,
        form: form,
        validationBehavior: validationBehavior
    });
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current?.focus();
                    (0, $627d69440c27e5e4$export$8397ddfc504fdb9a)('keyboard');
                }
            }
        },
        triggerProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            ...triggerProps,
            isDisabled: isDisabled,
            onKeyDown: (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(triggerProps.onKeyDown, onKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            'aria-labelledby': [
                valueId,
                triggerProps['aria-labelledby'],
                triggerProps['aria-label'] && !triggerProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' '),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            linkBehavior: 'selection',
            onBlur: (e)=>{
                if ((0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            'aria-labelledby': [
                fieldProps['aria-labelledby'],
                triggerProps['aria-label'] && !fieldProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' ')
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        hiddenSelectProps: {
            isDisabled: isDisabled,
            name: name,
            label: props.label,
            state: state,
            triggerRef: ref,
            form: form
        }
    };
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a71202214a10b9ab$export$5add1d006293d136(ref, initialValue, onReset) {
    let handleReset = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        if (onReset && !e.defaultPrevented) onReset(initialValue);
    });
    (0, $acw62.useEffect)(()=>{
        let form = ref?.current?.form;
        form?.addEventListener('reset', handleReset);
        return ()=>{
            form?.removeEventListener('reset', handleReset);
        };
    }, [
        ref
    ]);
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9aec99f022b72b42$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (validationBehavior === 'native' && ref?.current && !ref.current.disabled) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(' ') || 'Invalid value.' : '';
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute('title')) ref.current.title = '';
            if (!state.realtimeValidation.isInvalid) state.updateValidation($9aec99f022b72b42$var$$860f7da480e22816$var$getNativeValidity(ref.current));
        }
    });
    let isIgnoredReset = (0, $acw62.useRef)(false);
    let onReset = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(()=>{
        if (!isIgnoredReset.current) state.resetValidation();
    });
    let onInvalid = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)((e)=>{
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref?.current?.form;
        if (!e.defaultPrevented && ref && form && $9aec99f022b72b42$var$$860f7da480e22816$var$getFirstInvalidInput(form) === ref.current) {
            if (focus) focus();
            else ref.current?.focus();
            (0, $627d69440c27e5e4$export$8397ddfc504fdb9a)('keyboard');
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(()=>{
        state.commitValidation();
    });
    (0, $acw62.useEffect)(()=>{
        let input = ref?.current;
        if (!input) return;
        let form = input.form;
        let reset = form?.reset;
        if (form) // validation errors that are returned by server actions.
        // To do this, we ignore programmatic form resets that occur outside a user event.
        // This is best-effort. There may be false positives, e.g. setTimeout.
        form.reset = ()=>{
            // React uses MessageChannel for scheduling, so ignore 'message' events.
            isIgnoredReset.current = !window.event || window.event.type === 'message' && (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(window.event) instanceof MessagePort;
            reset?.call(form);
            isIgnoredReset.current = false;
        };
        input.addEventListener('invalid', onInvalid);
        input.addEventListener('change', onChange);
        form?.addEventListener('reset', onReset);
        return ()=>{
            input.removeEventListener('invalid', onInvalid);
            input.removeEventListener('change', onChange);
            form?.removeEventListener('reset', onReset);
            if (form) form.reset = reset;
        };
    }, [
        ref,
        validationBehavior
    ]);
}
function $9aec99f022b72b42$var$$860f7da480e22816$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $9aec99f022b72b42$var$$860f7da480e22816$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $9aec99f022b72b42$var$$860f7da480e22816$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $9aec99f022b72b42$var$$860f7da480e22816$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (element.validity?.valid === false) return element;
    }
    return null;
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5858513320805a65$export$f809e80f58e251d1(props, state, triggerRef) {
    let data = (0, $2fe5180bff655840$export$703601b7e90536f8).get(state) || {};
    let { autoComplete: autoComplete, name: name = data.name, form: form = data.form, isDisabled: isDisabled = data.isDisabled } = props;
    let { validationBehavior: validationBehavior, isRequired: isRequired } = data;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $1b36921254027e01$export$a966af930f325cab)({
        style: {
            // Prevent page scrolling.
            position: 'fixed',
            top: 0,
            left: 0
        }
    });
    (0, $a71202214a10b9ab$export$5add1d006293d136)(props.selectRef, state.defaultValue, state.setValue);
    (0, $9aec99f022b72b42$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior,
        focus: ()=>triggerRef.current?.focus()
    }, state, props.selectRef);
    let setValue = state.setValue;
    let onChange = (0, $acw62.useCallback)((e)=>{
        let eventTarget = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (eventTarget.multiple) setValue(Array.from(eventTarget.selectedOptions, (option)=>option.value));
        else setValue(e.currentTarget.value);
    }, [
        setValue
    ]);
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            'aria-hidden': true,
            // @ts-ignore
            ['data-react-aria-prevent-focus']: true,
            // @ts-ignore
            ['data-a11y-ignore']: 'aria-hidden-focus'
        },
        inputProps: {
            style: {
                display: 'none'
            }
        },
        selectProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            multiple: state.selectionManager.selectionMode === 'multiple',
            required: validationBehavior === 'native' && isRequired,
            name: name,
            form: form,
            value: state.value ?? '',
            onChange: onChange,
            onInput: onChange
        }
    };
}
function $5858513320805a65$export$cbd84cdb2e668835(props) {
    let { state: state, triggerRef: triggerRef, label: label, name: name, form: form, isDisabled: isDisabled } = props;
    let selectRef = (0, $acw62.useRef)(null);
    let inputRef = (0, $acw62.useRef)(null);
    let { containerProps: containerProps, selectProps: selectProps } = $5858513320805a65$export$f809e80f58e251d1({
        ...props,
        selectRef: state.collection.size <= 300 ? selectRef : inputRef
    }, state, triggerRef);
    let values = Array.isArray(state.value) ? state.value : [
        state.value
    ];
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...containerProps,
        "data-testid": "hidden-select-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, label, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ...selectProps,
        ref: selectRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: "",
        label: '\u00A0'
    }, '\u00A0'), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item && item.type === 'item') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue);
    }), state.collection.size === 0 && name && values.map((value, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: i,
            value: value ?? ''
        })))));
    else if (name) {
        let data = (0, $2fe5180bff655840$export$703601b7e90536f8).get(state) || {};
        let { validationBehavior: validationBehavior } = data;
        // Always render at least one hidden input to ensure required form submission.
        if (values.length === 0) values = [
            null
        ];
        let res = values.map((value, i)=>{
            let inputProps = {
                type: 'hidden',
                autoComplete: selectProps.autoComplete,
                name: name,
                form: form,
                disabled: isDisabled,
                value: value ?? ''
            };
            if (validationBehavior === 'native') // so that an empty value blocks HTML form submission when the field is required.
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                key: i,
                ...inputProps,
                ref: i === 0 ? inputRef : null,
                style: {
                    display: 'none'
                },
                type: "text",
                required: i === 0 ? selectProps.required : false,
                onChange: ()=>{}
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                key: i,
                ...inputProps,
                ref: i === 0 ? inputRef : null
            });
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, res);
    }
    return null;
}







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1b74276efbe19e40$export$5159ec8b34d4ec12(props) {
    let { selectionMode: selectionMode = 'single', shouldCloseOnSelect: shouldCloseOnSelect = selectionMode === 'single' } = props;
    let triggerState = (0, $2069e091702d9800$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let defaultValue = (0, $acw62.useMemo)(()=>{
        return props.defaultValue !== undefined ? props.defaultValue : selectionMode === 'single' ? props.defaultSelectedKey ?? null : [];
    }, [
        props.defaultValue,
        props.defaultSelectedKey,
        selectionMode
    ]);
    let value = (0, $acw62.useMemo)(()=>{
        return props.value !== undefined ? props.value : selectionMode === 'single' ? props.selectedKey : undefined;
    }, [
        props.value,
        props.selectedKey,
        selectionMode
    ]);
    let [controlledValue, setControlledValue] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(value, defaultValue, props.onChange);
    // Only display the first selected item if in single selection mode but the value is an array.
    let displayValue = selectionMode === 'single' && Array.isArray(controlledValue) ? controlledValue[0] : controlledValue;
    let setValue = (value)=>{
        if (selectionMode === 'single') {
            let key = Array.isArray(value) ? value[0] ?? null : value;
            setControlledValue(key);
            if (key !== displayValue) props.onSelectionChange?.(key);
        } else {
            let keys = [];
            if (Array.isArray(value)) keys = value;
            else if (value != null) keys = [
                value
            ];
            setControlledValue(keys);
        }
    };
    let listState = (0, $78bb3024d26c2ff4$export$2f645645f7bca764)({
        ...props,
        selectionMode: selectionMode,
        disallowEmptySelection: selectionMode === 'single',
        allowDuplicateSelectionEvents: true,
        selectedKeys: (0, $acw62.useMemo)(()=>$1b74276efbe19e40$var$$29256f53a2edafe9$var$convertValue(displayValue), [
            displayValue
        ]),
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            if (selectionMode === 'single') {
                let key = keys.values().next().value ?? null;
                setValue(key);
            } else setValue([
                ...keys
            ]);
            if (shouldCloseOnSelect) triggerState.close();
            validationState.commitValidation();
        }
    });
    let selectedKey = listState.selectionManager.firstSelectedKey;
    let selectedItems = (0, $acw62.useMemo)(()=>{
        return [
            ...listState.selectionManager.selectedKeys
        ].map((key)=>listState.collection.getItem(key)).filter((item)=>item != null);
    }, [
        listState.selectionManager.selectedKeys,
        listState.collection
    ]);
    let validationState = (0, $0c6ddd323fa7af24$export$fc1a364ae1f3ff10)({
        ...props,
        value: Array.isArray(displayValue) && displayValue.length === 0 ? null : displayValue
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [initialValue] = (0, $acw62.useState)(displayValue);
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        value: displayValue,
        defaultValue: defaultValue ?? initialValue,
        setValue: setValue,
        selectedKey: selectedKey,
        setSelectedKey: setValue,
        selectedItem: selectedItems[0] ?? null,
        selectedItems: selectedItems,
        defaultSelectedKey: props.defaultSelectedKey ?? (props.selectionMode === 'single' ? initialValue : null),
        focusStrategy: focusStrategy,
        open (focusStrategy = null) {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0 || props.allowsEmptyCollection) {
                setFocusStrategy(focusStrategy);
                triggerState.open();
            }
        },
        toggle (focusStrategy = null) {
            if (listState.collection.size !== 0 || props.allowsEmptyCollection) {
                setFocusStrategy(focusStrategy);
                triggerState.toggle();
            }
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}
function $1b74276efbe19e40$var$$29256f53a2edafe9$var$convertValue(value) {
    if (value === undefined) return undefined;
    if (value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $daae3b169f4e1063$export$a2f47a3d2973640(options = {}) {
    let { locale: locale } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    return (0, $acw62.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}




function $234aa604da0871e2$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $234aa604da0871e2$export$7540cee5be7dc19b = (0, $acw62.createContext)(null);
const $234aa604da0871e2$export$ef445b55be0601bd = (0, $acw62.createContext)(null);
const $234aa604da0871e2$export$ef9b1a59e592288f = (0, $acw62.forwardRef)(function Select(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $234aa604da0871e2$export$7540cee5be7dc19b);
    let { children: children, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false } = props;
    let content = (0, $acw62.useMemo)(()=>typeof children === 'function' ? children({
            isOpen: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isRequired: isRequired,
            isFocused: false,
            isFocusVisible: false,
            defaultChildren: null
        }) : children, [
        children,
        isDisabled,
        isInvalid,
        isRequired
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$bf788dd355e3a401), {
        content: content
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($234aa604da0871e2$var$$c8bb816105474884$var$SelectInner, {
            props: props,
            collection: collection,
            selectRef: ref
        }));
});
// Contexts to clear inside the popover.
const $234aa604da0871e2$var$$c8bb816105474884$var$CLEAR_CONTEXTS = [
    (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
    (0, $972ba92a45901f5b$export$24d547caef80ccd1),
    (0, $9b7271d3af613df1$export$9afb8bc826b033ea)
];
function $234aa604da0871e2$var$$c8bb816105474884$var$SelectInner({ props: props, selectRef: ref, collection: collection }) {
    let { validationBehavior: formValidationBehavior } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)((0, $bdd138f35fdd977e$export$c24727297075ec6a)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $1b74276efbe19e40$export$5159ec8b34d4ec12)({
        ...props,
        collection: collection,
        children: undefined,
        validationBehavior: validationBehavior
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $0cde480b945a073a$export$4e328f61c538687f)({
        within: true
    });
    // Get props for child elements from useSelect
    let buttonRef = (0, $acw62.useRef)(null);
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, hiddenSelectProps: hiddenSelectProps, ...validation } = (0, $2fe5180bff655840$export$e64b2f635402ca43)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, buttonRef);
    // Make menu width match input + button
    let [buttonWidth, setButtonWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (buttonRef.current) setButtonWidth(buttonRef.current.offsetWidth + 'px');
    }, [
        buttonRef
    ]);
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: buttonRef,
        onResize: onResize
    });
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, $acw62.useMemo)(()=>({
            isOpen: state.isOpen,
            isFocused: state.isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        state.isFocused,
        isFocusVisible,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: renderPropsState,
        defaultClassName: 'react-aria-Select'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    let scrollRef = (0, $acw62.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $234aa604da0871e2$export$7540cee5be7dc19b,
                props
            ],
            [
                $234aa604da0871e2$export$ef445b55be0601bd,
                state
            ],
            [
                $234aa604da0871e2$export$f8f745c04421623f,
                valueProps
            ],
            [
                (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $972ba92a45901f5b$export$24d547caef80ccd1),
                {
                    ...triggerProps,
                    ref: buttonRef,
                    isPressed: state.isOpen,
                    autoFocus: props.autoFocus
                }
            ],
            [
                (0, $ce4897092af7eb66$export$d2f961adcb0afbe),
                state
            ],
            [
                (0, $c079ee9c5fe80a9e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'Select',
                    triggerRef: buttonRef,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': buttonWidth
                    },
                    'aria-labelledby': menuProps['aria-labelledby'],
                    clearContexts: $234aa604da0871e2$var$$c8bb816105474884$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $cbc77d4357361516$export$7ff8f37d2d81a48d),
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $cbc77d4357361516$export$7c5906fe4f1f2af2),
                state
            ],
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $76bbfd363f450690$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5858513320805a65$export$cbd84cdb2e668835), {
        ...hiddenSelectProps,
        autoComplete: props.autoComplete
    })));
}
const $234aa604da0871e2$export$f8f745c04421623f = (0, $acw62.createContext)(null);
const $234aa604da0871e2$export$e288731fd71264f0 = (0, $ffa0afb9817175b6$export$86427a43e3e48ebb)(function SelectValue(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $234aa604da0871e2$export$f8f745c04421623f);
    let state = (0, $acw62.useContext)($234aa604da0871e2$export$ef445b55be0601bd);
    let { placeholder: placeholder } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)($234aa604da0871e2$export$7540cee5be7dc19b);
    let rendered = state.selectedItems.map((item)=>{
        let rendered = item.props?.children;
        // If the selected item has a function as a child, we need to call it to render to React.JSX.
        if (typeof rendered === 'function') {
            let fn = rendered;
            rendered = fn({
                isHovered: false,
                isPressed: false,
                isSelected: false,
                isFocused: false,
                isFocusVisible: false,
                isDisabled: false,
                selectionMode: 'single',
                selectionBehavior: 'toggle'
            });
        }
        return rendered;
    });
    let formatter = (0, $daae3b169f4e1063$export$a2f47a3d2973640)();
    let textValue = (0, $acw62.useMemo)(()=>state.selectedItems.map((item)=>item?.textValue), [
        state.selectedItems
    ]);
    let selectionMode = state.selectionManager.selectionMode;
    let selectedText = (0, $acw62.useMemo)(()=>selectionMode === 'single' ? textValue[0] ?? '' : formatter.format(textValue), [
        selectionMode,
        formatter,
        textValue
    ]);
    let defaultChildren = (0, $acw62.useMemo)(()=>{
        if (selectionMode === 'single') return rendered[0];
        let parts = formatter.formatToParts(textValue);
        if (parts.length === 0) return null;
        let index = 0;
        return parts.map((part)=>{
            if (part.type === 'element') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: index
            }, rendered[index++]);
            else return part.value;
        });
    }, [
        selectionMode,
        formatter,
        textValue,
        rendered
    ]);
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($234aa604da0871e2$var$$parcel$interopDefault((0, $4793c39cef08f039$export$2e2bcd8739ae039)), 'react-aria-components');
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultChildren: defaultChildren ?? placeholder ?? stringFormatter.format('selectPlaceholder'),
        defaultClassName: 'react-aria-SelectValue',
        values: {
            selectedItem: state.selectedItems[0]?.value ?? null,
            selectedItems: (0, $acw62.useMemo)(()=>state.selectedItems.map((item)=>item.value ?? null), [
                state.selectedItems
            ]),
            selectedText: selectedText,
            isPlaceholder: state.selectedItems.length === 0,
            state: state
        }
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).span, {
        ref: ref,
        ...DOMProps,
        ...renderProps,
        "data-placeholder": state.selectedItems.length === 0 || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b7271d3af613df1$export$9afb8bc826b033ea).Provider, {
        value: undefined
    }, renderProps.children));
});




var $acw62 = parcelRequire("acw62");
function $9c65e6561322b2ec$var$_defineProperty(e, r, t) {
    return (r = $9c65e6561322b2ec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9c65e6561322b2ec$var$_extends() {
    return $9c65e6561322b2ec$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9c65e6561322b2ec$var$_extends.apply(null, arguments);
}
function $9c65e6561322b2ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c65e6561322b2ec$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c65e6561322b2ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9c65e6561322b2ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c65e6561322b2ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9c65e6561322b2ec$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9c65e6561322b2ec$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $9c65e6561322b2ec$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $9c65e6561322b2ec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9c65e6561322b2ec$var$_toPropertyKey(t) {
    var i = $9c65e6561322b2ec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
var $9c65e6561322b2ec$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "tabIndex",
    "className",
    "fill",
    "size",
    "verticalAlign",
    "id",
    "title",
    "style"
];
var $9c65e6561322b2ec$var$sizeMap = {
    small: 16,
    medium: 32,
    large: 64
};
function $9c65e6561322b2ec$var$createIconComponent(name, defaultClassName, getSVGData) {
    var svgDataByHeight = getSVGData();
    var heights = Object.keys(svgDataByHeight);
    var Icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, forwardedRef) {
        var ariaLabel = _ref['aria-label'], arialabelledby = _ref['aria-labelledby'], tabIndex = _ref.tabIndex, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill, _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, _ref$verticalAlign = _ref.verticalAlign, verticalAlign = _ref$verticalAlign === void 0 ? 'text-bottom' : _ref$verticalAlign, id = _ref.id, title = _ref.title, style = _ref.style, rest = $9c65e6561322b2ec$var$_objectWithoutProperties(_ref, $9c65e6561322b2ec$var$_excluded);
        var height = $9c65e6561322b2ec$var$sizeMap[size] || size;
        var naturalHeight = $9c65e6561322b2ec$var$closestNaturalHeight(heights, height);
        var naturalWidth = svgDataByHeight[naturalHeight].width;
        var width = height * (naturalWidth / naturalHeight);
        var path = svgDataByHeight[naturalHeight].path;
        var labelled = ariaLabel || arialabelledby;
        var role = labelled ? 'img' : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $9c65e6561322b2ec$var$_extends({
            ref: forwardedRef,
            "data-component": "Octicon"
        }, rest, {
            "aria-hidden": labelled ? undefined : 'true',
            tabIndex: tabIndex,
            focusable: tabIndex >= 0 ? 'true' : 'false',
            "aria-label": ariaLabel,
            "aria-labelledby": arialabelledby,
            className: "".concat(defaultClassName, " ").concat(className).trim(),
            role: role,
            viewBox: "0 0 ".concat(naturalWidth, " ").concat(naturalHeight),
            width: width,
            height: height,
            fill: fill,
            id: id,
            display: "inline-block",
            overflow: "visible",
            style: $9c65e6561322b2ec$var$_objectSpread2({
                verticalAlign: verticalAlign
            }, style)
        }), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title) : null, path);
    });
    Icon.displayName = name;
    return Icon;
}
function $9c65e6561322b2ec$var$closestNaturalHeight(naturalHeights, height) {
    return naturalHeights.map(function(naturalHeight) {
        return parseInt(naturalHeight, 10);
    }).reduce(function(acc, naturalHeight) {
        return naturalHeight <= height ? naturalHeight : acc;
    }, naturalHeights[0]);
}
/* THIS FILE IS GENERATED. DO NOT EDIT IT. */ var $9c65e6561322b2ec$export$12f5813a529780ed = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AccessibilityIcon", "octicon octicon-accessibility", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.923 5.302c.063.063.122.129.178.198H14A.75.75 0 0 1 14 7h-3.3l.578 5.163.362 2.997a.75.75 0 0 1-1.49.18L9.868 13H6.132l-.282 2.34a.75.75 0 0 1-1.49-.18l.362-2.997L5.3 7H2a.75.75 0 0 1 0-1.5h3.9a2.54 2.54 0 0 1 .176-.198 3 3 0 1 1 3.847 0ZM9.2 7.073h-.001a1.206 1.206 0 0 0-2.398 0L6.305 11.5h3.39ZM9.5 3a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.974 8.114a3.573 3.573 0 1 0-3.947 0c-.302.21-.57.467-.79.762H3.708a.75.75 0 1 0 0 1.5h4.885a2.93 2.93 0 0 0-.026.188l-.814 7.267-.499 4.142a.75.75 0 1 0 1.49.18l.42-3.486h5.67l.42 3.485a.75.75 0 0 0 1.49-.18l-.5-4.142-.813-7.266a3.502 3.502 0 0 0-.026-.188h4.885a.75.75 0 1 0 0-1.5h-5.527a3.466 3.466 0 0 0-.79-.762Zm.099-2.979a2.073 2.073 0 1 1-4.146 0 2.073 2.073 0 0 1 4.146 0Zm-.131 5.596.72 6.436H9.338l.72-6.436a1.954 1.954 0 0 1 3.884 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$587fb0e8d01524db = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AccessibilityInsetIcon", "octicon octicon-accessibility-inset", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM3.75 6a.75.75 0 0 0 0 1.5h2.409a1.9 1.9 0 0 0-.025.151l-.307 2.508-.323 3.011a.75.75 0 0 0 1.492.16l.25-2.33h1.509l.25 2.33a.748.748 0 0 0 1.199.552.75.75 0 0 0 .291-.712l-.32-3-.309-2.519a1.9 1.9 0 0 0-.025-.151h2.409a.75.75 0 0 0 0-1.5h-8.5ZM8 6a2 2 0 1 0 .001-3.999A2 2 0 0 0 8 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm2.5 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM12 9h6.375a.75.75 0 0 1 0 1.5h-4.028l.542 4.42.482 4.5a.75.75 0 1 1-1.492.16l-.41-3.83H10.53l-.41 3.83a.75.75 0 1 1-1.492-.16l.484-4.511.54-4.409H5.625a.75.75 0 0 1 0-1.5H12Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f8bd6b52341b4af7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AgentIcon", "octicon octicon-agent", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.5 8.9v-.052A2.956 2.956 0 0 0 11.542 5.9a.815.815 0 0 1-.751-.501l-.145-.348A3.496 3.496 0 0 0 7.421 2.9h-.206a3.754 3.754 0 0 0-3.736 4.118l.011.121a.822.822 0 0 1-.619.879A1.81 1.81 0 0 0 1.5 9.773v.14c0 1.097.89 1.987 1.987 1.987H4.5a.75.75 0 0 1 0 1.5H3.487A3.487 3.487 0 0 1 0 9.913v-.14C0 8.449.785 7.274 1.963 6.75A5.253 5.253 0 0 1 7.215 1.4h.206a4.992 4.992 0 0 1 4.586 3.024A4.455 4.455 0 0 1 16 8.848V8.9a.75.75 0 0 1-1.5 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.38 7.67 2.25 2.25a.749.749 0 0 1 0 1.061L8.38 13.23a.749.749 0 1 1-1.06-1.06l1.719-1.72L7.32 8.731A.75.75 0 0 1 8.38 7.67ZM15 13.45h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22.5 13.919v-.278a5.097 5.097 0 0 0-4.961-5.086.858.858 0 0 1-.754-.497l-.149-.327A6.414 6.414 0 0 0 10.81 4a6.133 6.133 0 0 0-6.13 6.32l.019.628a.863.863 0 0 1-.67.869A3.263 3.263 0 0 0 1.5 14.996v.108A3.397 3.397 0 0 0 4.896 18.5h1.577a.75.75 0 0 1 0 1.5H4.896A4.896 4.896 0 0 1 0 15.104v-.108a4.761 4.761 0 0 1 3.185-4.493l-.004-.137A7.633 7.633 0 0 1 10.81 2.5a7.911 7.911 0 0 1 7.176 4.58C21.36 7.377 24 10.207 24 13.641v.278a.75.75 0 0 1-1.5 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.306 11.77 3.374 3.375a.749.749 0 0 1 0 1.061l-3.375 3.375-.057.051a.751.751 0 0 1-1.004-.051.751.751 0 0 1-.051-1.004l.051-.057 2.845-2.845-2.844-2.844a.75.75 0 1 1 1.061-1.061ZM22.5 19.8H18a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$bd6b40ca17243254 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AiModelIcon", "octicon octicon-ai-model", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.628 7.25a2.25 2.25 0 1 1 0 1.5H8.622a2.25 2.25 0 0 1-2.513 1.466L5.03 12.124a2.25 2.25 0 1 1-1.262-.814l1.035-1.832A2.245 2.245 0 0 1 4.25 8c0-.566.209-1.082.553-1.478L3.768 4.69a2.25 2.25 0 1 1 1.262-.814l1.079 1.908A2.25 2.25 0 0 1 8.622 7.25ZM2.5 2.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm4 4.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6.25 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-9.5 5.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.375 8.5a3.25 3.25 0 1 1-3.163 4h-3a3.252 3.252 0 0 1-4.443 2.509L7.214 17.76a3.25 3.25 0 1 1-1.342-.674l1.672-2.957A3.238 3.238 0 0 1 6.75 12c0-.907.371-1.727.97-2.316L6.117 6.846A3.253 3.253 0 0 1 1.875 3.75a3.25 3.25 0 1 1 5.526 2.32l1.603 2.836A3.25 3.25 0 0 1 13.093 11h3.119a3.252 3.252 0 0 1 3.163-2.5ZM10 10.25a1.75 1.75 0 1 0-.001 3.499A1.75 1.75 0 0 0 10 10.25ZM5.125 2a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm12.5 9.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Zm-14.25 8.5a1.75 1.75 0 1 0 3.501-.001 1.75 1.75 0 0 0-3.501.001Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4a143c8822a09fb4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AlertIcon", "octicon octicon-alert", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752Zm3.03.751a1.002 1.002 0 0 0-1.732 0L2.168 19.499A1.002 1.002 0 0 0 3.034 21h17.932a1.002 1.002 0 0 0 .866-1.5L12.866 3.994Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$7918f1ef0d6bf70c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AlertFillIcon", "octicon octicon-alert-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.855.708c.5-.896 1.79-.896 2.29 0l4.675 8.351a1.312 1.312 0 0 1-1.146 1.954H1.33A1.313 1.313 0 0 1 .183 9.058ZM7 7V3H5v4Zm-1 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575ZM8 5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8 5Zm1 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752ZM12 8.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 8.5Zm1 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$40a6e2bdd55901c0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("AppsIcon", "octicon octicon-apps", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 3.25c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 5.75 7.5h-2.5A1.75 1.75 0 0 1 1.5 5.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 8.5 5.75Zm-7 7c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75ZM3.25 3a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5A.25.25 0 0 0 6 5.75v-2.5A.25.25 0 0 0 5.75 3Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm-7 7a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.5 2.75A2.75 2.75 0 0 0 2.75 5.5v3a2.75 2.75 0 0 0 2.75 2.75h3a2.75 2.75 0 0 0 2.75-2.75v-3A2.75 2.75 0 0 0 8.5 2.75h-3ZM4.25 5.5c0-.69.56-1.25 1.25-1.25h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-3Zm1.25 7.25a2.75 2.75 0 0 0-2.75 2.75v3a2.75 2.75 0 0 0 2.75 2.75h3a2.75 2.75 0 0 0 2.75-2.75v-3a2.75 2.75 0 0 0-2.75-2.75h-3ZM4.25 15.5c0-.69.56-1.25 1.25-1.25h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-3Zm8.5-10a2.75 2.75 0 0 1 2.75-2.75h3a2.75 2.75 0 0 1 2.75 2.75v3a2.75 2.75 0 0 1-2.75 2.75h-3a2.75 2.75 0 0 1-2.75-2.75v-3Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-3Zm0 8.5a2.75 2.75 0 0 0-2.75 2.75v3a2.75 2.75 0 0 0 2.75 2.75h3a2.75 2.75 0 0 0 2.75-2.75v-3a2.75 2.75 0 0 0-2.75-2.75h-3Zm-1.25 2.75c0-.69.56-1.25 1.25-1.25h3c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-3Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$64abfa02d870a554 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArchiveIcon", "octicon octicon-archive", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v1.5A1.75 1.75 0 0 1 14.25 6H1.75A1.75 1.75 0 0 1 0 4.25ZM1.75 7a.75.75 0 0 1 .75.75v5.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-5.5a.75.75 0 0 1 1.5 0v5.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25v-5.5A.75.75 0 0 1 1.75 7Zm0-4.5a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25ZM6.25 8h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 2h18.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 21.25 9H2.75A1.75 1.75 0 0 1 1 7.25v-3.5C1 2.784 1.784 2 2.75 2Zm18.5 1.5H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25ZM2.75 10a.75.75 0 0 1 .75.75v9.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-9.5a.75.75 0 0 1 1.5 0v9.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-9.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.75 11.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$39a586317aa80eb5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowBothIcon", "octicon octicon-arrow-both", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.72 3.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.56 7h10.88l-2.22-2.22a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l2.22-2.22H2.56l2.22 2.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-3.5-3.5a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.78 5.97a.75.75 0 0 0-1.06 0l-5.25 5.25a.75.75 0 0 0 0 1.06l5.25 5.25a.75.75 0 0 0 1.06-1.06L3.81 12.5h16.38l-3.97 3.97a.75.75 0 1 0 1.06 1.06l5.25-5.25a.75.75 0 0 0 0-1.06l-5.25-5.25a.75.75 0 1 0-1.06 1.06L20.19 11H3.81l3.97-3.97a.75.75 0 0 0 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1c939d3c9b6931b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowDownIcon", "octicon octicon-arrow-down", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.03 8.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.47 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l2.97 2.97V3.75a.75.75 0 0 1 1.5 0v7.44l2.97-2.97a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.97 13.22a.75.75 0 0 1 1.06 0L11 18.19V3.75a.75.75 0 0 1 1.5 0v14.44l4.97-4.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-6.25 6.25a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8b57ee4b0e98fb27 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowDownLeftIcon", "octicon octicon-arrow-down-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.78 4.22a.75.75 0 0 1 0 1.06l-5.26 5.26h4.2a.75.75 0 0 1 0 1.5H4.71a.75.75 0 0 1-.75-.75V5.28a.75.75 0 0 1 1.5 0v4.2l5.26-5.26a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 8.5a.75.75 0 0 1 .75.75v7.19L16.72 6.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L7.56 17.5h7.19a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$814e7401971f4e15 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowDownRightIcon", "octicon octicon-arrow-down-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.22 4.179a.75.75 0 0 1 1.06 0l5.26 5.26v-4.2a.75.75 0 0 1 1.5 0v6.01a.75.75 0 0 1-.75.75H5.28a.75.75 0 0 1 0-1.5h4.2L4.22 5.24a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.25 8.5a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h7.19L6.22 7.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L17.5 16.44V9.25a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8afed21ef5c2afa5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowLeftIcon", "octicon octicon-arrow-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.78 19.03a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L5.81 11.5h14.44a.75.75 0 0 1 0 1.5H5.81l4.97 4.97a.75.75 0 0 1 0 1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9ca09caa9c849d9c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowRightIcon", "octicon octicon-arrow-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.22 2.97a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l2.97-2.97H3.75a.75.75 0 0 1 0-1.5h7.44L8.22 4.03a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.22 19.03a.75.75 0 0 1 0-1.06L18.19 13H3.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$37616c26ca544529 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowSwitchIcon", "octicon octicon-arrow-switch", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.22 14.78a.75.75 0 0 0 1.06-1.06L4.56 12h8.69a.75.75 0 0 0 0-1.5H4.56l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3Zm5.56-6.5a.75.75 0 1 1-1.06-1.06l1.72-1.72H2.75a.75.75 0 0 1 0-1.5h8.69L9.72 2.28a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.72 21.78a.75.75 0 0 0 1.06-1.06L5.56 17.5h14.69a.75.75 0 0 0 0-1.5H5.56l3.22-3.22a.75.75 0 1 0-1.06-1.06l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5Zm8.56-9.5a.75.75 0 1 1-1.06-1.06L18.44 8H3.75a.75.75 0 0 1 0-1.5h14.69l-3.22-3.22a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f1a507b991affc46 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowUpIcon", "octicon octicon-arrow-up", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.47 7.78a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0l4.25 4.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L9 4.81v7.44a.75.75 0 0 1-1.5 0V4.81L4.53 7.78a.75.75 0 0 1-1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.655 10.405a.75.75 0 0 1-1.06 0l-4.97-4.97v14.44a.75.75 0 0 1-1.5 0V5.435l-4.97 4.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l6.25-6.25a.75.75 0 0 1 1.06 0l6.25 6.25a.75.75 0 0 1 0 1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8c53b52ced56b6d0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowUpLeftIcon", "octicon octicon-arrow-up-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.96 4.75A.75.75 0 0 1 4.71 4h6.01a.75.75 0 0 1 0 1.5h-4.2l5.26 5.26a.75.75 0 0 1-1.06 1.061l-5.26-5.26v4.2a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 15.5a.75.75 0 0 1-.75-.75v-9A.75.75 0 0 1 5.75 5h9a.75.75 0 0 1 0 1.5H7.56l10.22 10.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L6.5 7.56v7.19a.75.75 0 0 1-.75.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ca4d2b63d3464320 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ArrowUpRightIcon", "octicon octicon-arrow-up-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.53 4.75A.75.75 0 0 1 5.28 4h6.01a.75.75 0 0 1 .75.75v6.01a.75.75 0 0 1-1.5 0v-4.2l-5.26 5.261a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L9.48 5.5h-4.2a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.25 15.5a.75.75 0 0 1-.75-.75V7.56L7.28 17.78a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L16.44 6.5H9.25a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4a0107eb20c58f1c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BeakerIcon", "octicon octicon-beaker", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 5.782V2.5h-.25a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5H11v3.282l3.666 5.76C15.619 13.04 14.543 15 12.767 15H3.233c-1.776 0-2.852-1.96-1.899-3.458Zm-2.4 6.565a.75.75 0 0 0 .633 1.153h9.534a.75.75 0 0 0 .633-1.153L12.225 10.5h-8.45ZM9.5 2.5h-3V6c0 .143-.04.283-.117.403L4.73 9h6.54L9.617 6.403A.746.746 0 0 1 9.5 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 8.807V3.5h-.563a.75.75 0 0 1 0-1.5h9.125a.75.75 0 0 1 0 1.5H16v5.307l5.125 9.301c.964 1.75-.302 3.892-2.299 3.892H5.174c-1.998 0-3.263-2.142-2.3-3.892ZM4.189 18.832a1.123 1.123 0 0 0 .985 1.668h13.652a1.123 1.123 0 0 0 .985-1.668L17.7 15H6.3ZM14.5 3.5h-5V9a.75.75 0 0 1-.093.362L7.127 13.5h9.746l-2.28-4.138A.75.75 0 0 1 14.5 9Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2235404cc2cfe93c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BellIcon", "octicon octicon-bell", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16a2 2 0 0 0 1.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 0 0 8 16ZM3 5a5 5 0 0 1 10 0v2.947c0 .05.015.098.042.139l1.703 2.555A1.519 1.519 0 0 1 13.482 13H2.518a1.516 1.516 0 0 1-1.263-2.36l1.703-2.554A.255.255 0 0 0 3 7.947Zm5-3.5A3.5 3.5 0 0 0 4.5 5v2.947c0 .346-.102.683-.294.97l-1.703 2.556a.017.017 0 0 0-.003.01l.001.006c0 .002.002.004.004.006l.006.004.007.001h10.964l.007-.001.006-.004.004-.006.001-.007a.017.017 0 0 0-.003-.01l-1.703-2.554a1.745 1.745 0 0 1-.294-.97V5A3.5 3.5 0 0 0 8 1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c3.681 0 7 2.565 7 6v4.539c0 .642.189 1.269.545 1.803l2.2 3.298A1.517 1.517 0 0 1 20.482 19H15.5a3.5 3.5 0 1 1-7 0H3.519a1.518 1.518 0 0 1-1.265-2.359l2.2-3.299A3.25 3.25 0 0 0 5 11.539V7c0-3.435 3.318-6 7-6ZM6.5 7v4.539a4.75 4.75 0 0 1-.797 2.635l-2.2 3.298-.003.01.001.007.004.006.006.004.007.001h16.964l.007-.001.006-.004.004-.006.001-.006a.017.017 0 0 0-.003-.01l-2.199-3.299a4.753 4.753 0 0 1-.798-2.635V7c0-2.364-2.383-4.5-5.5-4.5S6.5 4.636 6.5 7ZM14 19h-4a2 2 0 1 0 4 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$db2f520bd369b7e6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BellFillIcon", "octicon octicon-bell-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16c.9 0 1.7-.6 1.9-1.5.1-.3-.1-.5-.4-.5h-3c-.3 0-.5.2-.4.5.2.9 1 1.5 1.9 1.5ZM3 5c0-2.8 2.2-5 5-5s5 2.2 5 5v3l1.7 2.6c.2.2.3.5.3.8 0 .8-.7 1.5-1.5 1.5h-11c-.8.1-1.5-.6-1.5-1.4 0-.3.1-.6.3-.8L3 8.1V5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 8a6 6 0 1 1 12 0v2.917c0 .703.228 1.387.65 1.95L20.7 15.6a1.5 1.5 0 0 1-1.2 2.4h-15a1.5 1.5 0 0 1-1.2-2.4l2.05-2.733a3.25 3.25 0 0 0 .65-1.95Zm6 13.5A3.502 3.502 0 0 1 8.645 19h6.71A3.502 3.502 0 0 1 12 21.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f7b8d0021b678e0e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BellSlashIcon", "octicon octicon-bell-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m4.182 4.31.016.011 10.104 7.316.013.01 1.375.996a.75.75 0 1 1-.88 1.214L13.626 13H2.518a1.516 1.516 0 0 1-1.263-2.36l1.703-2.554A.255.255 0 0 0 3 7.947V5.305L.31 3.357a.75.75 0 1 1 .88-1.214Zm7.373 7.19L4.5 6.391v1.556c0 .346-.102.683-.294.97l-1.703 2.556a.017.017 0 0 0-.003.01c0 .005.002.009.005.012l.006.004.007.001ZM8 1.5c-.997 0-1.895.416-2.534 1.086A.75.75 0 1 1 4.38 1.55 5 5 0 0 1 13 5v2.373a.75.75 0 0 1-1.5 0V5A3.5 3.5 0 0 0 8 1.5ZM8 16a2 2 0 0 1-1.985-1.75c-.017-.137.097-.25.235-.25h3.5c.138 0 .252.113.235.25A2 2 0 0 1 8 16Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.22 1.22a.75.75 0 0 1 1.06 0l20.5 20.5a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L17.94 19H15.5a3.5 3.5 0 1 1-7 0H3.518a1.516 1.516 0 0 1-1.263-2.36l2.2-3.298A3.249 3.249 0 0 0 5 11.539V7c0-.294.025-.583.073-.866L1.22 2.28a.75.75 0 0 1 0-1.06ZM6.5 7.56h-.001v3.979a4.75 4.75 0 0 1-.797 2.635l-2.2 3.298-.003.01.001.007.004.006.006.004.007.001H16.44ZM10 19a2 2 0 1 0 4 0Zm2-16.5c-1.463 0-2.8.485-3.788 1.257l-.04.032a.75.75 0 1 1-.935-1.173l.05-.04C8.548 1.59 10.212 1 12 1c3.681 0 7 2.565 7 6v4.539c0 .642.19 1.269.546 1.803l1.328 1.992a.75.75 0 1 1-1.248.832l-1.328-1.992a4.75 4.75 0 0 1-.798-2.635V7c0-2.364-2.383-4.5-5.5-4.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5c4e80a0a9240ca3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BlockedIcon", "octicon octicon-blocked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.467.22a.749.749 0 0 1 .53-.22h6.006c.199 0 .389.079.53.22l4.247 4.247c.141.14.22.331.22.53v6.006a.749.749 0 0 1-.22.53l-4.247 4.247a.749.749 0 0 1-.53.22H4.997a.749.749 0 0 1-.53-.22L.22 11.533a.749.749 0 0 1-.22-.53V4.997c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.308v5.384L5.308 14.5h5.384l3.808-3.808V5.308L10.692 1.5ZM4 7.75A.75.75 0 0 1 4.75 7h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 4 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.638 2.22a.749.749 0 0 1 .53-.22h7.664c.199 0 .389.079.53.22l5.418 5.418c.141.14.22.332.22.53v7.664a.749.749 0 0 1-.22.53l-5.418 5.418a.749.749 0 0 1-.53.22H8.168a.749.749 0 0 1-.53-.22l-5.42-5.418a.752.752 0 0 1-.219-.53V8.168c0-.199.079-.389.22-.53l5.418-5.42ZM8.48 3.5 3.5 8.48v7.04l4.98 4.98h7.04l4.98-4.98V8.48L15.52 3.5ZM7 11.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3d4d964fb74ced39 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BoldIcon", "octicon octicon-bold", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 2h4.5a3.501 3.501 0 0 1 2.852 5.53A3.499 3.499 0 0 1 9.5 14H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 7v3h4.5a1.5 1.5 0 0 0 0-3Zm3.5-2a1.5 1.5 0 0 0 0-3H5v3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7807f5bbd02c545b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookIcon", "octicon octicon-book", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75A.75.75 0 0 1 .75 1h4.253c1.227 0 2.317.59 3 1.501A3.743 3.743 0 0 1 11.006 1h4.245a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75h-4.507a2.25 2.25 0 0 0-1.591.659l-.622.621a.75.75 0 0 1-1.06 0l-.622-.621A2.25 2.25 0 0 0 5.258 13H.75a.75.75 0 0 1-.75-.75Zm7.251 10.324.004-5.073-.002-2.253A2.25 2.25 0 0 0 5.003 2.5H1.5v9h3.757a3.75 3.75 0 0 1 1.994.574ZM8.755 4.75l-.004 7.322a3.752 3.752 0 0 1 1.992-.572H14.5v-9h-3.495a2.25 2.25 0 0 0-2.25 2.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 3.75A.75.75 0 0 1 .75 3h7.497c1.566 0 2.945.8 3.751 2.014A4.495 4.495 0 0 1 15.75 3h7.5a.75.75 0 0 1 .75.75v15.063a.752.752 0 0 1-.755.75l-7.682-.052a3 3 0 0 0-2.142.878l-.89.891a.75.75 0 0 1-1.061 0l-.902-.901a2.996 2.996 0 0 0-2.121-.879H.75a.75.75 0 0 1-.75-.75Zm12.75 15.232a4.503 4.503 0 0 1 2.823-.971l6.927.047V4.5h-6.75a3 3 0 0 0-3 3ZM11.247 7.497a3 3 0 0 0-3-2.997H1.5V18h6.947c1.018 0 2.006.346 2.803.98Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5bd5f9b8e1b52f6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookLockedIcon", "octicon octicon-book-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 6a3 3 0 0 1 3 3v1.168c.591.281 1 .884 1 1.582v2.5A1.75 1.75 0 0 1 14.25 16h-4.5A1.75 1.75 0 0 1 8 14.25v-2.5c0-.698.409-1.301 1-1.582V9a3 3 0 0 1 3-3Zm0 1.5A1.5 1.5 0 0 0 10.5 9v1h3V9A1.5 1.5 0 0 0 12 7.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.003 1c1.227 0 2.317.59 3.001 1.501A3.746 3.746 0 0 1 11.005 1h4.245a.75.75 0 0 1 .75.75V5.5a.75.75 0 0 1-1.5 0v-3h-3.495c-1.21 0-2.204.956-2.255 2.153V6.5a.75.75 0 0 1-1.5 0V4.69A2.249 2.249 0 0 0 5.003 2.5H1.5v9h3.758c.612 0 1.208.15 1.74.429l.005.001a.75.75 0 0 1-.705 1.324l-.001-.001v.002A2.245 2.245 0 0 0 5.258 13H.75a.75.75 0 0 1-.75-.75V1.75A.75.75 0 0 1 .75 1h4.253Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$93cb139c864b0aec = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookmarkIcon", "octicon octicon-bookmark", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 0 1-1.227.579L8 11.722l-3.773 3.107A.751.751 0 0 1 3 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.91l3.023-2.489a.75.75 0 0 1 .954 0l3.023 2.49V2.75a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 3.75C5 2.784 5.784 2 6.75 2h10.5c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.586L12 17.21l-5.781 4.625A.75.75 0 0 1 5 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v15.94l5.031-4.026a.749.749 0 0 1 .938 0L17.5 19.69V3.75a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$d22b8bd58461a421 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookmarkFillIcon", "octicon octicon-bookmark-fill", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.69 2h10.56c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.585L12 17.21l-5.781 4.626A.75.75 0 0 1 5 21.253L4.94 3.756A1.748 1.748 0 0 1 6.69 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$77df11a9db3bfb4e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookmarkFilledIcon", "octicon octicon-bookmark-filled", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 0 1-1.227.579L8 11.722l-3.773 3.107A.75.75 0 0 1 3 14.25V2.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$27fe15307e1afa36 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookmarkSlashIcon", "octicon octicon-bookmark-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.19 1.143 4.182 3.31l.014.01 8.486 6.145.014.01 2.994 2.168a.75.75 0 1 1-.88 1.214L13 11.547v2.703a.75.75 0 0 1-1.206.596L8 11.944l-3.794 2.902A.75.75 0 0 1 3 14.25V4.305L.31 2.357a.75.75 0 1 1 .88-1.214ZM4.5 5.39v7.341l3.044-2.328a.75.75 0 0 1 .912 0l3.044 2.328V10.46ZM5.865 1h5.385c.966 0 1.75.784 1.75 1.75v3.624a.75.75 0 0 1-1.5 0V2.75a.25.25 0 0 0-.25-.25H5.865a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.565 2.018v-.001l21.75 15.75a.75.75 0 1 1-.88 1.215L19 16.495v4.764a.748.748 0 0 1-1.219.584L12 17.21l-5.781 4.634A.75.75 0 0 1 5 21.259V6.357L.685 3.232a.75.75 0 0 1 .88-1.214ZM17.5 15.408l-11-7.965v12.254l5.031-4.032a.749.749 0 0 1 .938 0l5.031 4.032ZM7.25 2a.75.75 0 0 0 0 1.5h10a.25.25 0 0 1 .25.25v6.5a.75.75 0 0 0 1.5 0v-6.5A1.75 1.75 0 0 0 17.25 2h-10Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$dc810451588d8559 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BookmarkSlashFillIcon", "octicon octicon-bookmark-slash-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.19 1.143a.75.75 0 1 0-.88 1.215L3 4.305v9.945a.75.75 0 0 0 1.206.596L8 11.944l3.794 2.902A.75.75 0 0 0 13 14.25v-2.703l1.81 1.31a.75.75 0 1 0 .88-1.214l-2.994-2.168a1.09 1.09 0 0 0-.014-.01L4.196 3.32a.712.712 0 0 0-.014-.01L1.19 1.143Zm2.934.203A.5.5 0 0 1 4.6 1h7.233C12.478 1 13 1.522 13 2.167v5.05a.5.5 0 0 1-.793.405l-7.9-5.717a.5.5 0 0 1-.183-.559Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m3.232 2.175 18.5 15.5a.75.75 0 1 1-.964 1.15L19 17.343v3.907a.75.75 0 0 1-1.218.585L12 17.21l-5.781 4.626A.75.75 0 0 1 5 21.253L4.947 5.569 2.268 3.325a.75.75 0 1 1 .964-1.15ZM7.421 2h9.829c.966 0 1.75.784 1.75 1.75v8.073a.75.75 0 0 1-1.232.575L6.94 3.325A.75.75 0 0 1 7.421 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$d6fce8bbba23f624 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BooleanOffIcon", "octicon octicon-boolean-off", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 13.25 15H2.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1h10.5ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 20.25 22H3.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 2 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.5 12a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm1.5 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$4c9edaecaffa8422 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BooleanOnIcon", "octicon octicon-boolean-on", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 13.25 15H2.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1h10.5ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 5.75a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 20.25 22H3.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 2 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.75 8.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0v-6.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6211d598766c7b98 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BriefcaseIcon", "octicon octicon-briefcase", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.75 0h2.5C10.216 0 11 .784 11 1.75V3h3.25c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-8.5C0 3.784.784 3 1.75 3H5V1.75C5 .784 5.784 0 6.75 0ZM3.5 9.5a3.49 3.49 0 0 1-2-.627v4.377c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V8.873a3.49 3.49 0 0 1-2 .627Zm-1.75-5a.25.25 0 0 0-.25.25V6a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V4.75a.25.25 0 0 0-.25-.25H1.75ZM9.5 3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.5 1.75C7.5.784 8.284 0 9.25 0h5.5c.966 0 1.75.784 1.75 1.75V4h4.75c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25V5.75C1 4.784 1.784 4 2.75 4H7.5Zm-5 10.24v8.26c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-8.26A4.235 4.235 0 0 1 18.75 13H5.25a4.235 4.235 0 0 1-2.75-1.01Zm19-3.24v-3a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v3a2.75 2.75 0 0 0 2.75 2.75h13.5a2.75 2.75 0 0 0 2.75-2.75Zm-6.5-7a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25V4h6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$18bc95dd4fe2936b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BroadcastIcon", "octicon octicon-broadcast", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 8.582v5.668a.75.75 0 0 1-1.5 0V8.582a1.75 1.75 0 1 1 1.5 0Zm3.983-7.125a.75.75 0 0 1 1.06.026A7.976 7.976 0 0 1 16 7c0 2.139-.84 4.083-2.207 5.517a.75.75 0 1 1-1.086-1.034A6.474 6.474 0 0 0 14.5 7a6.474 6.474 0 0 0-1.793-4.483.75.75 0 0 1 .026-1.06Zm-9.466 0c.3.286.312.76.026 1.06A6.474 6.474 0 0 0 1.5 7a6.47 6.47 0 0 0 1.793 4.483.75.75 0 0 1-1.086 1.034A7.973 7.973 0 0 1 0 7c0-2.139.84-4.083 2.207-5.517a.75.75 0 0 1 1.06-.026Zm8.556 2.321A4.988 4.988 0 0 1 13 7a4.988 4.988 0 0 1-1.177 3.222.75.75 0 1 1-1.146-.967A3.487 3.487 0 0 0 11.5 7c0-.86-.309-1.645-.823-2.255a.75.75 0 0 1 1.146-.967Zm-6.492.958A3.48 3.48 0 0 0 4.5 7a3.48 3.48 0 0 0 .823 2.255.75.75 0 0 1-1.146.967A4.981 4.981 0 0 1 3 7a4.982 4.982 0 0 1 1.188-3.236.75.75 0 1 1 1.143.972Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.485 2.515a.75.75 0 0 0-1.06 1.06A10.465 10.465 0 0 1 22.5 11c0 2.9-1.174 5.523-3.075 7.424a.75.75 0 0 0 1.06 1.061A11.965 11.965 0 0 0 24 11c0-3.314-1.344-6.315-3.515-8.485Zm-15.91 1.06a.75.75 0 0 0-1.06-1.06A11.965 11.965 0 0 0 0 11c0 3.313 1.344 6.314 3.515 8.485a.75.75 0 0 0 1.06-1.06A10.465 10.465 0 0 1 1.5 11c0-2.9 1.174-5.524 3.075-7.425ZM8.11 7.11a.75.75 0 0 0-1.06-1.06A6.98 6.98 0 0 0 5 11a6.98 6.98 0 0 0 2.05 4.95.75.75 0 0 0 1.06-1.061 5.48 5.48 0 0 1-1.61-3.89 5.48 5.48 0 0 1 1.61-3.888Zm8.84-1.06a.75.75 0 1 0-1.06 1.06A5.48 5.48 0 0 1 17.5 11a5.48 5.48 0 0 1-1.61 3.889.75.75 0 1 0 1.06 1.06A6.98 6.98 0 0 0 19 11a6.98 6.98 0 0 0-2.05-4.949ZM14 11a2 2 0 0 1-1.25 1.855v8.395a.75.75 0 0 1-1.5 0v-8.395A2 2 0 1 1 14 11Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$abc36f8394967e37 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BrowserIcon", "octicon octicon-browser", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25ZM14.5 6h-13v7.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm-6-3.5v2h6V2.75a.25.25 0 0 0-.25-.25ZM5 2.5v2h2v-2Zm-3.25 0a.25.25 0 0 0-.25.25V4.5h2v-2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h20.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 22.25 22H1.75A1.75 1.75 0 0 1 0 20.25ZM22.5 7h-21v13.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25Zm-10-3.5v2h10V3.75a.25.25 0 0 0-.25-.25ZM7 3.5v2h4v-2Zm-5.25 0a.25.25 0 0 0-.25.25V5.5h4v-2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$6a890007100de1ac = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("BugIcon", "octicon octicon-bug", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.72.22a.75.75 0 0 1 1.06 0l1 .999a3.488 3.488 0 0 1 2.441 0l.999-1a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.775.776c.616.63.995 1.493.995 2.444v.327c0 .1-.009.197-.025.292.408.14.764.392 1.029.722l1.968-.787a.75.75 0 0 1 .556 1.392L13 7.258V9h2.25a.75.75 0 0 1 0 1.5H13v.5c0 .409-.049.806-.141 1.186l2.17.868a.75.75 0 0 1-.557 1.392l-2.184-.873A4.997 4.997 0 0 1 8 16a4.997 4.997 0 0 1-4.288-2.427l-2.183.873a.75.75 0 0 1-.558-1.392l2.17-.868A5.036 5.036 0 0 1 3 11v-.5H.75a.75.75 0 0 1 0-1.5H3V7.258L.971 6.446a.75.75 0 0 1 .558-1.392l1.967.787c.265-.33.62-.583 1.03-.722a1.677 1.677 0 0 1-.026-.292V4.5c0-.951.38-1.814.995-2.444L4.72 1.28a.75.75 0 0 1 0-1.06Zm.53 6.28a.75.75 0 0 0-.75.75V11a3.5 3.5 0 1 0 7 0V7.25a.75.75 0 0 0-.75-.75ZM6.173 5h3.654A.172.172 0 0 0 10 4.827V4.5a2 2 0 1 0-4 0v.327c0 .096.077.173.173.173Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.72.22a.75.75 0 0 1 1.06 0l1.204 1.203A4.98 4.98 0 0 1 12 1c.717 0 1.4.151 2.016.423L15.22.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-.971.972A4.991 4.991 0 0 1 17 6v1.104a2.755 2.755 0 0 1 1.917 1.974l1.998-.999a.75.75 0 0 1 .67 1.342L19 10.714V13.5l3.25.003a.75.75 0 0 1 0 1.5L19 15.001V16c0 .568-.068 1.134-.204 1.686l.04.018 2.75 1.375a.75.75 0 1 1-.671 1.342l-2.638-1.319A6.998 6.998 0 0 1 12 23a6.998 6.998 0 0 1-6.197-3.742l-2.758 1.181a.752.752 0 0 1-1.064-.776.752.752 0 0 1 .474-.602l2.795-1.199A6.976 6.976 0 0 1 5 16v-.996H1.75a.75.75 0 0 1 0-1.5H5v-2.79L2.415 9.42a.75.75 0 0 1 .67-1.342l1.998.999A2.756 2.756 0 0 1 7 7.104V6a4.99 4.99 0 0 1 1.69-3.748l-.97-.972a.75.75 0 0 1 0-1.06ZM6.5 9.75V16a5.5 5.5 0 1 0 11 0V9.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25ZM8.5 7h7V6a3.5 3.5 0 1 0-7 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$e16b9b401b22a826 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CacheIcon", "octicon octicon-cache", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 5.724V8c0 .248.238.7 1.169 1.159.874.43 2.144.745 3.62.822a.75.75 0 1 1-.078 1.498c-1.622-.085-3.102-.432-4.204-.975a5.565 5.565 0 0 1-.507-.28V12.5c0 .133.058.318.282.551.227.237.591.483 1.101.707 1.015.447 2.47.742 4.117.742.406 0 .802-.018 1.183-.052a.751.751 0 1 1 .134 1.494C8.89 15.98 8.45 16 8 16c-1.805 0-3.475-.32-4.721-.869-.623-.274-1.173-.619-1.579-1.041-.408-.425-.7-.964-.7-1.59v-9c0-.626.292-1.165.7-1.591.406-.42.956-.766 1.579-1.04C4.525.32 6.195 0 8 0c1.806 0 3.476.32 4.721.869.623.274 1.173.619 1.579 1.041.408.425.7.964.7 1.59 0 .626-.292 1.165-.7 1.591-.406.42-.956.766-1.578 1.04C11.475 6.68 9.805 7 8 7c-1.805 0-3.475-.32-4.721-.869a6.15 6.15 0 0 1-.779-.407Zm0-2.224c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 5.205 6.353 5.5 8 5.5c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55 0-.133-.058-.318-.282-.551-.227-.237-.591-.483-1.101-.707C11.102 1.795 9.647 1.5 8 1.5c-1.646 0-3.101.295-4.118.742-.508.224-.873.471-1.1.708-.224.232-.282.417-.282.55Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.49 7.582a.375.375 0 0 0-.66-.313l-3.625 4.625a.375.375 0 0 0 .295.606h2.127l-.619 2.922a.375.375 0 0 0 .666.304l3.125-4.125A.375.375 0 0 0 15.5 11h-1.778l.769-3.418Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.505 9.117a7.723 7.723 0 0 1-1.497-.852V12c0 .524.473 1.23 1.8 1.883 1.267.625 3.085 1.071 5.18 1.182a.76.76 0 0 1-.08 1.517c-2.242-.118-4.274-.598-5.772-1.336a7.264 7.264 0 0 1-1.128-.68V18.3c0 .282.127.61.476.973.352.366.899.732 1.633 1.055 1.466.645 3.545 1.063 5.881 1.063.577 0 1.14-.025 1.683-.074a.76.76 0 0 1 .135 1.513 20.47 20.47 0 0 1-1.818.08c-2.496 0-4.792-.443-6.493-1.192-.849-.374-1.584-.838-2.117-1.393-.536-.558-.9-1.244-.9-2.025V5.7c0-.782.364-1.467.9-2.025.533-.555 1.268-1.02 2.117-1.393 1.7-.749 3.997-1.193 6.493-1.193 2.497 0 4.793.444 6.493 1.193.85.373 1.585.838 2.117 1.393.537.558.9 1.243.9 2.025 0 .781-.363 1.467-.9 2.025-.532.554-1.267 1.02-2.117 1.393-1.7.748-3.996 1.192-6.493 1.192-2.496 0-4.792-.444-6.493-1.192Zm-1.021-4.39c-.35.362-.476.69-.476.972 0 .282.127.61.476.972.352.367.899.732 1.633 1.055 1.466.646 3.545 1.064 5.881 1.064 2.337 0 4.415-.418 5.882-1.064.734-.323 1.28-.688 1.633-1.055.35-.363.476-.69.476-.972 0-.282-.127-.61-.476-.973-.353-.367-.9-.732-1.633-1.055-1.467-.645-3.545-1.063-5.882-1.063-2.336 0-4.415.418-5.88 1.063-.735.323-1.282.688-1.634 1.055Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.425 11.11a.5.5 0 0 0-.881-.418l-5.438 6.937a.5.5 0 0 0 .394.808h3.268l-.945 4.46a.5.5 0 0 0 .888.405l4.688-6.188a.5.5 0 0 0-.399-.802h-2.745l1.17-5.202Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$5fda1783bb83f57b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CalendarIcon", "octicon octicon-calendar", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 0a.75.75 0 0 1 .75.75V2h5V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V3.75C1 2.784 1.784 2 2.75 2H4V.75A.75.75 0 0 1 4.75 0ZM2.5 7.5v6.75c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V7.5Zm10.75-4H2.75a.25.25 0 0 0-.25.25V6h11V3.75a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.75 0a.75.75 0 0 1 .75.75V3h9V.75a.75.75 0 0 1 1.5 0V3h2.75c.966 0 1.75.784 1.75 1.75v16a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-16C1.5 3.784 2.284 3 3.25 3H6V.75A.75.75 0 0 1 6.75 0ZM21 9.5H3v11.25c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25Zm-17.75-5a.25.25 0 0 0-.25.25V8h18V4.75a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7dd004358974b05d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CheckIcon", "octicon octicon-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.03 5.72a.75.75 0 0 1 0 1.06l-11.5 11.5a.747.747 0 0 1-1.072-.012l-5.5-5.75a.75.75 0 1 1 1.084-1.036l4.97 5.195L19.97 5.72a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f6dd727656c97851 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CheckCircleIcon", "octicon octicon-check-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm1.5 0a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm10.28-1.72-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$3298acaca062aba2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CheckCircleFillIcon", "octicon octicon-check-circle-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm-.705 8.737L9.63 4.403 8.392 3.166 5.295 6.263l-1.7-1.702L2.356 5.8l2.938 2.938Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.78-9.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018L6.75 9.19 5.28 7.72a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l2 2a.75.75 0 0 0 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c0a1936901b0e55 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CheckboxIcon", "octicon octicon-checkbox", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.5 2.75v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25Zm9.28 3.53-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$df0d89aa19ad5bd4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CheckboxFillIcon", "octicon octicon-checkbox-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 1h10.5c.967 0 1.75.783 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.783 1.783 1 2.75 1Zm9.03 5.28a.749.749 0 1 0-1.06-1.06L6.75 9.189 5.28 7.72a.749.749 0 1 0-1.06 1.06l2 2a.749.749 0 0 0 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.25 2c.966 0 1.75.783 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.783 2.783 2 3.75 2Zm-2.97 6.22a.749.749 0 0 0-1.06 0l-5.97 5.969-2.47-2.469a.749.749 0 1 0-1.06 1.06l3 3a.749.749 0 0 0 1.06 0l6.5-6.5a.749.749 0 0 0 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ca81f537ef473f1b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ChecklistIcon", "octicon octicon-checklist", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 1.75v11.5c0 .138.112.25.25.25h3.17a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 13.25V1.75C1 .784 1.784 0 2.75 0h8.5C12.216 0 13 .784 13 1.75v7.736a.75.75 0 0 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25Zm13.274 9.537v-.001l-4.557 4.45a.75.75 0 0 1-1.055-.008l-1.943-1.95a.75.75 0 0 1 1.062-1.058l1.419 1.425 4.026-3.932a.75.75 0 1 1 1.048 1.074ZM4.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM4 7.75A.75.75 0 0 1 4.75 7h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 4 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.5 3.75a.25.25 0 0 1 .25-.25h13.5a.25.25 0 0 1 .25.25v10a.75.75 0 0 0 1.5 0v-10A1.75 1.75 0 0 0 17.25 2H3.75A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h7a.75.75 0 0 0 0-1.5h-7a.25.25 0 0 1-.25-.25V3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.25 7a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Zm-.75 4.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm16.28 4.53a.75.75 0 1 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$4857d3f3f5f8319b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ChevronDownIcon", "octicon octicon-chevron-down", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 8.825c-.2 0-.4-.1-.5-.2l-3.3-3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.7 2.7 2.7-2.7c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-3.2 3.2c-.2.2-.4.3-.6.3Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.78 5.22a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0L3.22 6.28a.749.749 0 1 1 1.06-1.06L8 8.939l3.72-3.719a.749.749 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.22 8.22a.749.749 0 0 0 0 1.06l6.25 6.25a.749.749 0 0 0 1.06 0l6.25-6.25a.749.749 0 1 0-1.06-1.06L12 13.939 6.28 8.22a.749.749 0 0 0-1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$20bc5960c3c9eebb = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ChevronLeftIcon", "octicon octicon-chevron-left", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.587 6.025c0 .2.1.4.2.5l3.3 3.3c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1l-2.7-2.7 2.7-2.7c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-3.2 3.2c-.2.2-.3.4-.3.6Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.78 12.78a.75.75 0 0 1-1.06 0L4.47 8.53a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L6.06 8l3.72 3.72a.75.75 0 0 1 0 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.28 5.22a.75.75 0 0 1 0 1.06L9.56 12l5.72 5.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b837bd7eac09a33e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ChevronRightIcon", "octicon octicon-chevron-right", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.7 10c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1L6.9 6 4.2 3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l3.3 3.2c.3.3.3.8 0 1.1L5.3 9.7c-.2.2-.4.3-.6.3Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.72 18.78a.75.75 0 0 1 0-1.06L14.44 12 8.72 6.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ChevronUpIcon", "octicon octicon-chevron-up", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 4c-.2 0-.4.1-.5.2L2.2 7.5c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0L6 5.9l2.7 2.7c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L6.6 4.3C6.4 4.1 6.2 4 6 4Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.22 10.53a.749.749 0 0 1 0-1.06l4.25-4.25a.749.749 0 0 1 1.06 0l4.25 4.25a.749.749 0 1 1-1.06 1.06L8 6.811 4.28 10.53a.749.749 0 0 1-1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.78 15.78a.749.749 0 0 1-1.06 0L12 10.061 6.28 15.78a.749.749 0 1 1-1.06-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9c1c3f5a4a271817 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CircleIcon", "octicon octicon-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$24060b1e22abbcab = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CircleSlashIcon", "octicon octicon-circle-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM3.965 13.096a6.5 6.5 0 0 0 9.131-9.131ZM1.5 8a6.474 6.474 0 0 0 1.404 4.035l9.131-9.131A6.499 6.499 0 0 0 1.5 8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM5.834 19.227A9.464 9.464 0 0 0 12 21.5a9.5 9.5 0 0 0 9.5-9.5 9.464 9.464 0 0 0-2.273-6.166ZM2.5 12a9.464 9.464 0 0 0 2.273 6.166L18.166 4.773A9.463 9.463 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8099ab97743c966c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ClockIcon", "octicon octicon-clock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7-3.25v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$4e0abfe5b1e1c658 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ClockFillIcon", "octicon octicon-clock-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.575-3.25a.825.825 0 1 0-1.65 0v3.5c0 .337.205.64.519.766l2.5 1a.825.825 0 0 0 .612-1.532l-1.981-.793Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11.575-4.75a.825.825 0 1 0-1.65 0v5.5c0 .296.159.57.416.716l3.5 2a.825.825 0 0 0 .818-1.432l-3.084-1.763Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$575cd077dbb2b254 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CloudIcon", "octicon octicon-cloud", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 7.25A5.225 5.225 0 0 1 7.25 2a5.222 5.222 0 0 1 4.767 3.029A4.472 4.472 0 0 1 16 9.5c0 2.505-1.995 4.5-4.5 4.5h-8A3.474 3.474 0 0 1 0 10.5c0-1.41.809-2.614 2.001-3.17Zm1.54.482a.75.75 0 0 1-.556.832c-.86.22-1.484.987-1.484 1.936 0 1.124.876 2 2 2h8c1.676 0 3-1.324 3-3s-1.324-3-3-3a.75.75 0 0 1-.709-.504A3.72 3.72 0 0 0 7.25 3.5C5.16 3.5 3.5 5.16 3.5 7.25c.002.146.014.292.035.436l.004.036.001.008Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.103 10.107c0-4.244 3.445-7.607 7.733-7.607 3.19 0 5.912 1.858 7.099 4.563l.01.022.001.006C21.348 7.345 24 10.095 24 13.536 24 17.148 21.076 20 17.431 20H5.017C2.23 20 0 17.83 0 15.06a4.899 4.899 0 0 1 3.112-4.581 7.696 7.696 0 0 1-.009-.372ZM10.836 4c-3.485 0-6.233 2.717-6.233 6.107 0 .284.022.602.052.756a.75.75 0 0 1-.552.869c-1.52.385-2.603 1.712-2.603 3.328 0 1.917 1.532 3.44 3.517 3.44h12.414c2.843 0 5.069-2.206 5.069-4.964 0-2.759-2.226-4.965-5.069-4.965a.75.75 0 0 1-.696-.47l-.179-.446C15.606 5.5 13.424 4 10.836 4Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c97a28c99d5bd1ee = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CloudOfflineIcon", "octicon octicon-cloud-offline", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.25 2c-.69 0-1.351.13-1.957.371a.75.75 0 1 0 .554 1.394c.43-.17.903-.265 1.403-.265a3.72 3.72 0 0 1 3.541 2.496.75.75 0 0 0 .709.504c1.676 0 3 1.324 3 3a3 3 0 0 1-.681 1.92.75.75 0 0 0 1.156.955A4.496 4.496 0 0 0 16 9.5a4.472 4.472 0 0 0-3.983-4.471A5.222 5.222 0 0 0 7.25 2ZM.72 1.72a.75.75 0 0 1 1.06 0l2.311 2.31c.03.025.056.052.08.08l8.531 8.532.035.034 2.043 2.044a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-1.8-1.799a4.54 4.54 0 0 1-.42.019h-8A3.474 3.474 0 0 1 0 10.5c0-1.41.809-2.614 2.001-3.17a5.218 5.218 0 0 1 .646-2.622L.72 2.78a.75.75 0 0 1 0-1.06ZM3.5 7.25c.004.161.018.322.041.481a.75.75 0 0 1-.557.833c-.86.22-1.484.986-1.484 1.936 0 1.124.876 2 2 2h6.94L3.771 5.832A3.788 3.788 0 0 0 3.5 7.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m2.78 2.22 19.5 19.5a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2.845-2.845a6.932 6.932 0 0 1-.944.065H5.017C2.229 20 0 17.831 0 15.059a4.899 4.899 0 0 1 3.111-4.58A7.52 7.52 0 0 1 4.36 5.922L1.72 3.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018ZM16.94 18.5 5.448 7.01a6.026 6.026 0 0 0-.794 3.853.75.75 0 0 1-.552.869c-1.52.385-2.603 1.712-2.603 3.328 0 1.917 1.532 3.44 3.517 3.44Zm-6.104-16a7.865 7.865 0 0 0-3.638.88.75.75 0 1 0 .692 1.331A6.365 6.365 0 0 1 10.836 4c2.588 0 4.77 1.5 5.72 3.655l.179.445a.75.75 0 0 0 .696.471c2.843 0 5.069 2.206 5.069 4.965a4.9 4.9 0 0 1-1.684 3.716.75.75 0 0 0 .986 1.13A6.396 6.396 0 0 0 24 13.536c0-3.44-2.652-6.191-6.054-6.445l-.002-.006a.634.634 0 0 0-.01-.022C16.749 4.358 14.026 2.5 10.837 2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8036f09137bee589 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodeIcon", "octicon octicon-code", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m11.28 3.22 4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L13.94 8l-3.72-3.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-6.56 0a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.06 8l3.72 3.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L.47 8.53a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.22 4.97a.75.75 0 0 1 1.06 0l6.5 6.5a.75.75 0 0 1 0 1.06l-6.5 6.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L21.19 12l-5.97-5.97a.75.75 0 0 1 0-1.06Zm-6.44 0a.75.75 0 0 1 0 1.06L2.81 12l5.97 5.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.5-6.5a.75.75 0 0 1 0-1.06l6.5-6.5a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$cb541c48306d5255 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodeOfConductIcon", "octicon octicon-code-of-conduct", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.048 2.241c.964-.709 2.079-1.238 3.325-1.241a4.616 4.616 0 0 1 3.282 1.355c.41.408.757.86.996 1.428.238.568.348 1.206.347 1.968 0 2.193-1.505 4.254-3.081 5.862-1.496 1.526-3.213 2.796-4.249 3.563l-.22.163a.749.749 0 0 1-.895 0l-.221-.163c-1.036-.767-2.753-2.037-4.249-3.563C1.51 10.008.007 7.952.002 5.762a4.614 4.614 0 0 1 1.353-3.407C3.123.585 6.223.537 8.048 2.24Zm-1.153.983c-1.25-1.033-3.321-.967-4.48.191a3.115 3.115 0 0 0-.913 2.335c0 1.556 1.109 3.24 2.652 4.813C5.463 11.898 6.96 13.032 8 13.805c.353-.262.758-.565 1.191-.905l-1.326-1.223a.75.75 0 0 1 1.018-1.102l1.48 1.366c.328-.281.659-.577.984-.887L9.99 9.802a.75.75 0 1 1 1.019-1.103l1.384 1.28c.295-.329.566-.661.81-.995L12.92 8.7l-1.167-1.168c-.674-.671-1.78-.664-2.474.03-.268.269-.538.537-.802.797-.893.882-2.319.843-3.185-.032-.346-.35-.693-.697-1.043-1.047a.75.75 0 0 1-.04-1.016c.162-.191.336-.401.52-.623.62-.748 1.356-1.637 2.166-2.417Zm7.112 4.442c.313-.65.491-1.293.491-1.916v-.001c0-.614-.088-1.045-.23-1.385-.143-.339-.357-.633-.673-.949a3.111 3.111 0 0 0-2.218-.915c-1.092.003-2.165.627-3.226 1.602-.823.755-1.554 1.637-2.228 2.45l-.127.154.562.566a.755.755 0 0 0 1.066.02l.794-.79c1.258-1.258 3.312-1.31 4.594-.032.396.394.792.791 1.173 1.173Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.828 4.328C5.26 1.896 9.5 1.881 11.935 4.317c.024.024.046.05.067.076 1.391-1.078 2.993-1.886 4.777-1.89a6.22 6.22 0 0 1 4.424 1.825c.559.56 1.023 1.165 1.34 1.922.318.756.47 1.617.468 2.663 0 2.972-2.047 5.808-4.269 8.074-2.098 2.14-4.507 3.924-5.974 5.009l-.311.23a.752.752 0 0 1-.897 0l-.312-.23c-1.466-1.085-3.875-2.869-5.973-5.009-2.22-2.263-4.264-5.095-4.27-8.063a6.216 6.216 0 0 1 1.823-4.596Zm8.033 1.042c-1.846-1.834-5.124-1.823-6.969.022a4.712 4.712 0 0 0-1.382 3.52c0 2.332 1.65 4.79 3.839 7.022 1.947 1.986 4.184 3.66 5.66 4.752a78.214 78.214 0 0 0 2.159-1.645l-2.14-1.974a.752.752 0 0 1 1.02-1.106l2.295 2.118c.616-.52 1.242-1.08 1.85-1.672l-2.16-1.992a.753.753 0 0 1 1.021-1.106l2.188 2.02a18.963 18.963 0 0 0 1.528-1.877l-.585-.586-1.651-1.652c-1.078-1.074-2.837-1.055-3.935.043-.379.38-.76.758-1.132 1.126-1.14 1.124-2.96 1.077-4.07-.043-.489-.495-.98-.988-1.475-1.482a.752.752 0 0 1-.04-1.019c.234-.276.483-.576.745-.893.928-1.12 2.023-2.442 3.234-3.576Zm9.725 6.77c.579-1.08.92-2.167.92-3.228.002-.899-.128-1.552-.35-2.08-.22-.526-.551-.974-1.017-1.44a4.71 4.71 0 0 0-3.356-1.384c-1.66.004-3.25.951-4.77 2.346-1.18 1.084-2.233 2.353-3.188 3.506l-.351.423c.331.332.663.664.993.998a1.375 1.375 0 0 0 1.943.03c.37-.365.748-.74 1.125-1.118 1.662-1.663 4.373-1.726 6.06-.045.56.558 1.12 1.12 1.658 1.658Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ffd8274d5306c25d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodeReviewIcon", "octicon octicon-code-review", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 13H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25v-8.5C0 1.784.784 1 1.75 1ZM1.5 2.75v8.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm5.28 1.72a.75.75 0 0 1 0 1.06L5.31 7l1.47 1.47a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0Zm2.44 0a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.69 7 9.22 5.53a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.3 6.74a.75.75 0 0 1-.04 1.06l-2.908 2.7 2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm3.44 1.06a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.749.749 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a3f70bb211ca95d5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodeSquareIcon", "octicon octicon-code-square", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Zm7.47 3.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L10.69 8 9.22 6.53a.75.75 0 0 1 0-1.06ZM6.78 6.53 5.31 8l1.47 1.47a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2-2a.75.75 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.3 8.24a.75.75 0 0 1-.04 1.06L7.352 12l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm3.44 1.06a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$2912aa6a4fe1542c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodescanIcon", "octicon octicon-codescan", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.47 4.97a.75.75 0 0 0 0 1.06L9.94 7.5 8.47 8.97a.75.75 0 1 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06l-2-2a.75.75 0 0 0-1.06 0ZM6.53 6.03a.75.75 0 0 0-1.06-1.06l-2 2a.75.75 0 0 0 0 1.06l2 2a.75.75 0 1 0 1.06-1.06L5.06 7.5l1.47-1.47Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.246 13.307a7.501 7.501 0 1 1 1.06-1.06l2.474 2.473a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM1.5 7.5a6.002 6.002 0 0 0 3.608 5.504 6.002 6.002 0 0 0 6.486-1.117.748.748 0 0 1 .292-.293A6 6 0 1 0 1.5 7.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.97 6.97a.75.75 0 0 0 0 1.06l2.47 2.47-2.47 2.47a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0ZM9.03 8.03a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06L6.56 10.5l2.47-2.47Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.5 0C16.299 0 21 4.701 21 10.5a10.457 10.457 0 0 1-2.564 6.875l4.344 4.345a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0Zm-9 10.5a9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$b731da09185e34de = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodescanCheckmarkIcon", "octicon octicon-codescan-checkmark", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.28 6.28a.75.75 0 1 0-1.06-1.06L6.25 8.19l-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3.5-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.5 15a7.5 7.5 0 1 1 5.807-2.754l2.473 2.474a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-2.474-2.473A7.472 7.472 0 0 1 7.5 15Zm0-13.5a6 6 0 1 0 4.094 10.386.748.748 0 0 1 .293-.292 6.002 6.002 0 0 0 1.117-6.486A6.002 6.002 0 0 0 7.5 1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.03 8.28a.75.75 0 0 0-1.06-1.06l-5.22 5.22-2.22-2.22a.75.75 0 1 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 1.06 0l5.75-5.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-4.345-4.344A10.457 10.457 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a98136388276bfe4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CodespacesIcon", "octicon octicon-codespaces", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 11.25c0-.966.784-1.75 1.75-1.75h12.5c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm2-9.5C2 .784 2.784 0 3.75 0h8.5C13.216 0 14 .784 14 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-8.5A1.75 1.75 0 0 1 2 6.75Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25Zm-2 9.5a.25.25 0 0 0-.25.25v3c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-3a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7 12.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm-4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.5 3.75C3.5 2.784 4.284 2 5.25 2h13.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 18.75 13H5.25a1.75 1.75 0 0 1-1.75-1.75Zm-2 12c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75ZM5.25 3.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h13.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Zm-2 12a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10 17.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$38f001d9cffdd080 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ColumnsIcon", "octicon octicon-columns", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 0h2.5C6.216 0 7 .784 7 1.75v12.5A1.75 1.75 0 0 1 5.25 16h-2.5A1.75 1.75 0 0 1 1 14.25V1.75C1 .784 1.784 0 2.75 0Zm8 0h2.5C14.216 0 15 .784 15 1.75v12.5A1.75 1.75 0 0 1 13.25 16h-2.5A1.75 1.75 0 0 1 9 14.25V1.75C9 .784 9.784 0 10.75 0ZM2.5 1.75v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Zm8 0v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 9.25 22h-5.5A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2Zm11 0h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22h-5.5A1.75 1.75 0 0 1 13 20.25V3.75c0-.966.784-1.75 1.75-1.75ZM3.5 3.75v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Zm11 0v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$e0f3610a2b19da79 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CommandPaletteIcon", "octicon octicon-command-palette", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m6.354 8.04-4.773 4.773a.75.75 0 1 0 1.061 1.06L7.945 8.57a.75.75 0 0 0 0-1.06L2.642 2.206a.75.75 0 0 0-1.06 1.061L6.353 8.04ZM8.75 11.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.045 18.894 9.94 12 3.045 5.106a.75.75 0 0 1 1.06-1.061l7.425 7.425a.75.75 0 0 1 0 1.06l-7.424 7.425a.75.75 0 0 1-1.061-1.06Zm8.205.606a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a3543c9c8473fb3d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CommentIcon", "octicon octicon-comment", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 13.25 12H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.749.749 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4f99ee6f250b3ace = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CommentAiIcon", "octicon octicon-comment-ai", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.75 1a.75.75 0 0 1 0 1.5h-5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2c.199 0 .39.079.53.22.141.14.22.331.22.53v2.19l2.72-2.72a.747.747 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-2a.75.75 0 0 1 1.5 0v2c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 13.25 12H9.06l-2.573 2.573A1.457 1.457 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25v-7.5C1 1.784 1.784 1 2.75 1h5Zm4.519-.837a.248.248 0 0 1 .466 0l.238.648a3.726 3.726 0 0 0 2.218 2.219l.649.238a.249.249 0 0 1 0 .467l-.649.238a3.725 3.725 0 0 0-2.218 2.218l-.238.649a.248.248 0 0 1-.466 0l-.239-.649a3.725 3.725 0 0 0-2.218-2.218l-.649-.238a.249.249 0 0 1 0-.467l.649-.238A3.726 3.726 0 0 0 12.03.811l.239-.648Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.25 2.5a.75.75 0 0 1 0 1.5h-8a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5c.199 0 .39.079.53.22.141.14.22.331.22.53v3.195l3.743-3.725a.75.75 0 0 1 .53-.22h9.977a.25.25 0 0 0 .25-.25v-4.5a.75.75 0 0 1 1.5 0v4.5c0 .464-.184.909-.513 1.237a1.746 1.746 0 0 1-1.237.513h-9.684l-3.579 3.57a1.45 1.45 0 0 1-1.588.316A1.456 1.456 0 0 1 5 21.04V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75V4.25c0-.966.784-1.75 1.75-1.75h8ZM17.748 1a.33.33 0 0 1 .192.061.33.33 0 0 1 .124.161l.323.88a5.051 5.051 0 0 0 3.008 3.007l.879.323a.332.332 0 0 1 .221.316.336.336 0 0 1-.221.316l-.879.323a5.034 5.034 0 0 0-1.836 1.172 5.034 5.034 0 0 0-1.172 1.836l-.323.879a.334.334 0 0 1-.316.221.332.332 0 0 1-.316-.221l-.323-.879a5.045 5.045 0 0 0-3.007-3.008l-.88-.323a.337.337 0 0 1 0-.632l.88-.323a5.062 5.062 0 0 0 1.836-1.171 5.062 5.062 0 0 0 1.171-1.836l.323-.88A.333.333 0 0 1 17.748 1Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a82b67e11f494532 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CommentDiscussionIcon", "octicon octicon-comment-discussion", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 1h8.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.458 1.458 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25v-5.5C0 1.784.784 1 1.75 1ZM1.5 2.75v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25Zm13 2a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.458 1.458 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l2.22 2.22v-2.19a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25v-9.5C0 1.784.784 1 1.75 1ZM1.5 2.75v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22.5 8.75a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5a.75.75 0 0 1 .53.22l2.72 2.72v-2.19a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$8304d1e764c66b97 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CommentLockedIcon", "octicon octicon-comment-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 6a3 3 0 0 1 3 3v1.168c.591.281 1 .884 1 1.582v2.5A1.75 1.75 0 0 1 14.25 16h-4.5A1.75 1.75 0 0 1 8 14.25v-2.5c0-.698.409-1.301 1-1.582V9a3 3 0 0 1 3-3Zm0 1.5A1.5 1.5 0 0 0 10.5 9v1h3V9A1.5 1.5 0 0 0 12 7.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.25 1A1.75 1.75 0 0 1 12 2.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25v5.5a.25.25 0 0 0 .25.25h1c.199 0 .39.079.53.22.141.14.22.331.22.53v2.19l2.72-2.72a.747.747 0 0 1 .53-.22h.35a.75.75 0 0 1 0 1.5h-.039l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25v-5.5A1.75 1.75 0 0 1 1.75 1h8.5Zm4 2c.966 0 1.75.784 1.75 1.75v.75c0-.061-.003-.115-.006-.164A.75.75 0 0 1 14.5 5.25v-.5a.25.25 0 0 0-.25-.25h-.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06.747.747 0 0 1 .53-.22h.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$65f6dd55db856ca2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ComposeIcon", "octicon octicon-compose", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m14.515.456.965.965a1.555 1.555 0 0 1 0 2.2L9.745 9.355a1.549 1.549 0 0 1-.672.396l-2.89.826a.67.67 0 0 1-.828-.474.66.66 0 0 1 .004-.35l.825-2.89c.073-.254.209-.486.396-.673L12.315.456c.144-.145.316-.259.505-.337a1.538 1.538 0 0 1 1.19 0c.189.078.361.192.505.337Zm-3.322 3.008-3.67 3.669a.214.214 0 0 0-.057.096L6.97 8.965l1.736-.496a.218.218 0 0 0 .096-.056l3.67-3.67Zm2.065-2.066L12.135 2.52l1.28 1.28 1.122-1.122a.216.216 0 0 0 .065-.157.216.216 0 0 0-.065-.157l-.965-.966a.216.216 0 0 0-.157-.065.226.226 0 0 0-.157.065Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 14.25V2.75A1.75 1.75 0 0 1 1.75 1H7a.75.75 0 0 1 0 1.5H1.75a.25.25 0 0 0-.25.25v11.5a.25.25 0 0 0 .25.25h11.5a.25.25 0 0 0 .25-.25V8.5a.75.75 0 0 1 1.5 0v5.75c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 13.25 16H1.75A1.75 1.75 0 0 1 0 14.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 21.25V4a1.75 1.75 0 0 1 1.75-1.75h7.51a.75.75 0 0 1 0 1.5H2.75A.25.25 0 0 0 2.5 4v17.25a.25.25 0 0 0 .25.25H20a.25.25 0 0 0 .25-.25V13a.75.75 0 0 1 1.5 0v8.25c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 20 23H2.75A1.75 1.75 0 0 1 1 21.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.013 1.427a1.75 1.75 0 0 1 2.474 0l1.086 1.086a1.75 1.75 0 0 1 0 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.25.929a.751.751 0 0 1-.928-.927l.929-3.25c.082-.287.235-.547.445-.758l8.61-8.61Zm-7.55 9.67a.241.241 0 0 0-.063.108l-.558 1.953 1.953-.558a.253.253 0 0 0 .108-.064L19.19 6.25l-1.44-1.44Zm8.964-8.61a.245.245 0 0 0-.177-.073.245.245 0 0 0-.177.073L18.811 3.75l1.439 1.44 1.263-1.263a.245.245 0 0 0 .073-.177.245.245 0 0 0-.073-.177Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6d6da6edaddd5876 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ContainerIcon", "octicon octicon-container", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m10.41.24 4.711 2.774c.544.316.878.897.879 1.526v5.01a1.77 1.77 0 0 1-.88 1.53l-7.753 4.521-.002.001a1.769 1.769 0 0 1-1.774 0H5.59L.873 12.85A1.761 1.761 0 0 1 0 11.327V6.292c0-.304.078-.598.22-.855l.004-.005.01-.019c.15-.262.369-.486.64-.643L8.641.239a1.752 1.752 0 0 1 1.765 0l.002.001ZM9.397 1.534l-7.17 4.182 4.116 2.388a.27.27 0 0 0 .269 0l7.152-4.148-4.115-2.422a.252.252 0 0 0-.252 0Zm-7.768 10.02 4.1 2.393V9.474a1.807 1.807 0 0 1-.138-.072L1.5 7.029v4.298c0 .095.05.181.129.227Zm8.6.642 1.521-.887v-4.45l-1.521.882ZM7.365 9.402h.001c-.044.026-.09.049-.136.071v4.472l1.5-.875V8.61Zm5.885 1.032 1.115-.65h.002a.267.267 0 0 0 .133-.232V5.264l-1.25.725Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.152.682a2.251 2.251 0 0 1 2.269 0l.007.004 6.957 4.276a2.277 2.277 0 0 1 1.126 1.964v7.516c0 .81-.432 1.56-1.133 1.968l-.002.001-11.964 7.037-.004.003c-.706.41-1.578.41-2.284 0l-.026-.015-6.503-4.502a2.268 2.268 0 0 1-1.096-1.943V9.438c0-.392.1-.77.284-1.1l.003-.006.014-.026c.197-.342.48-.627.82-.827h.002L13.152.681Zm.757 1.295h-.001L2.648 8.616l6.248 4.247a.775.775 0 0 0 .758-.01h.001l11.633-6.804-6.629-4.074a.75.75 0 0 0-.75.003ZM8.517 14.33a2.286 2.286 0 0 1-.393-.18l-.023-.014-6.102-4.147v7.003c0 .275.145.528.379.664l.025.014 6.114 4.232V14.33ZM18 9.709l-3.25 1.9v7.548L18 17.245Zm-7.59 4.438-.002.002a2.296 2.296 0 0 1-.391.18v7.612l3.233-1.902v-7.552Zm9.09-5.316v7.532l2.124-1.25a.776.776 0 0 0 .387-.671V7.363Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7a1ae7a9220f42df = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CopilotIcon", "octicon octicon-copilot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.998 15.035c-4.562 0-7.873-2.914-7.998-3.749V9.338c.085-.628.677-1.686 1.588-2.065.013-.07.024-.143.036-.218.029-.183.06-.384.126-.612-.201-.508-.254-1.084-.254-1.656 0-.87.128-1.769.693-2.484.579-.733 1.494-1.124 2.724-1.261 1.206-.134 2.262.034 2.944.765.05.053.096.108.139.165.044-.057.094-.112.143-.165.682-.731 1.738-.899 2.944-.765 1.23.137 2.145.528 2.724 1.261.566.715.693 1.614.693 2.484 0 .572-.053 1.148-.254 1.656.066.228.098.429.126.612.012.076.024.148.037.218.924.385 1.522 1.471 1.591 2.095v1.872c0 .766-3.351 3.795-8.002 3.795Zm0-1.485c2.28 0 4.584-1.11 5.002-1.433V7.862l-.023-.116c-.49.21-1.075.291-1.727.291-1.146 0-2.059-.327-2.71-.991A3.222 3.222 0 0 1 8 6.303a3.24 3.24 0 0 1-.544.743c-.65.664-1.563.991-2.71.991-.652 0-1.236-.081-1.727-.291l-.023.116v4.255c.419.323 2.722 1.433 5.002 1.433ZM6.762 2.83c-.193-.206-.637-.413-1.682-.297-1.019.113-1.479.404-1.713.7-.247.312-.369.789-.369 1.554 0 .793.129 1.171.308 1.371.162.181.519.379 1.442.379.853 0 1.339-.235 1.638-.54.315-.322.527-.827.617-1.553.117-.935-.037-1.395-.241-1.614Zm4.155-.297c-1.044-.116-1.488.091-1.681.297-.204.219-.359.679-.242 1.614.091.726.303 1.231.618 1.553.299.305.784.54 1.638.54.922 0 1.28-.198 1.442-.379.179-.2.308-.578.308-1.371 0-.765-.123-1.242-.37-1.554-.233-.296-.693-.587-1.713-.7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.25 9.037a.75.75 0 0 1 .75.75v1.501a.75.75 0 0 1-1.5 0V9.787a.75.75 0 0 1 .75-.75Zm4.25.75v1.501a.75.75 0 0 1-1.5 0V9.787a.75.75 0 0 1 1.5 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M23.922 16.992c-.861 1.495-5.859 5.023-11.922 5.023-6.063 0-11.061-3.528-11.922-5.023A.641.641 0 0 1 0 16.736v-2.869a.841.841 0 0 1 .053-.22c.372-.935 1.347-2.292 2.605-2.656.167-.429.414-1.055.644-1.517a10.195 10.195 0 0 1-.052-1.086c0-1.331.282-2.499 1.132-3.368.397-.406.89-.717 1.474-.952 1.399-1.136 3.392-2.093 6.122-2.093 2.731 0 4.767.957 6.166 2.093.584.235 1.077.546 1.474.952.85.869 1.132 2.037 1.132 3.368 0 .368-.014.733-.052 1.086.23.462.477 1.088.644 1.517 1.258.364 2.233 1.721 2.605 2.656a.832.832 0 0 1 .053.22v2.869a.641.641 0 0 1-.078.256ZM12.172 11h-.344a4.323 4.323 0 0 1-.355.508C10.703 12.455 9.555 13 7.965 13c-1.725 0-2.989-.359-3.782-1.259a2.005 2.005 0 0 1-.085-.104L4 11.741v6.585c1.435.779 4.514 2.179 8 2.179 3.486 0 6.565-1.4 8-2.179v-6.585l-.098-.104s-.033.045-.085.104c-.793.9-2.057 1.259-3.782 1.259-1.59 0-2.738-.545-3.508-1.492a4.323 4.323 0 0 1-.355-.508h-.016.016Zm.641-2.935c.136 1.057.403 1.913.878 2.497.442.544 1.134.938 2.344.938 1.573 0 2.292-.337 2.657-.751.384-.435.558-1.15.558-2.361 0-1.14-.243-1.847-.705-2.319-.477-.488-1.319-.862-2.824-1.025-1.487-.161-2.192.138-2.533.529-.269.307-.437.808-.438 1.578v.021c0 .265.021.562.063.893Zm-1.626 0c.042-.331.063-.628.063-.894v-.02c-.001-.77-.169-1.271-.438-1.578-.341-.391-1.046-.69-2.533-.529-1.505.163-2.347.537-2.824 1.025-.462.472-.705 1.179-.705 2.319 0 1.211.175 1.926.558 2.361.365.414 1.084.751 2.657.751 1.21 0 1.902-.394 2.344-.938.475-.584.742-1.44.878-2.497Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.5 14.25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1Zm-5 0a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1Z"
            }))
        },
        "48": {
            "width": 48,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M47.801 34.003c-1.72 2.988-11.706 10.037-23.82 10.037S1.881 36.991.161 34.003a1.309 1.309 0 0 1-.161-.57v-5.615c.012-.17.047-.338.11-.498.744-1.867 2.692-4.58 5.206-5.308.333-.855.826-2.106 1.287-3.029a20.112 20.112 0 0 1-.104-2.171c0-2.659.563-4.992 2.262-6.729.793-.811 1.777-1.433 2.945-1.901C14.502 5.911 18.483 4 23.938 4c5.455 0 9.523 1.911 12.319 4.182 1.167.468 2.151 1.09 2.944 1.901 1.699 1.737 2.263 4.07 2.263 6.729 0 .736-.027 1.465-.105 2.171.461.923.954 2.174 1.288 3.029 2.513.728 4.461 3.441 5.205 5.308.081.205.115.424.115.645v5.318c0 .252-.04.502-.166.72ZM24.325 22.031h-.688a8.52 8.52 0 0 1-.709 1.016c-1.537 1.892-3.833 2.98-7.008 2.98-3.447 0-5.972-.717-7.557-2.514a4.408 4.408 0 0 1-.171-.21l-.195.21v13.155c2.867 1.558 9.02 4.353 15.984 4.353s13.117-2.795 15.984-4.353V23.513l-.195-.21s-.066.091-.171.21c-1.584 1.797-4.11 2.514-7.557 2.514-3.175 0-5.47-1.088-7.008-2.98a8.637 8.637 0 0 1-.709-1.016h-.033.033Zm-1.969-5.864a14.31 14.31 0 0 0 .127-1.785v-.042c-.003-1.537-.339-2.538-.876-3.152-.681-.78-2.09-1.378-5.06-1.057-3.008.326-4.69 1.073-5.643 2.048-.923.944-1.408 2.356-1.408 4.633 0 2.42.348 3.849 1.115 4.719.729.827 2.165 1.499 5.309 1.499 2.417 0 3.799-.786 4.683-1.873.948-1.168 1.482-2.878 1.753-4.99Zm3.25 0c.271 2.112.805 3.822 1.754 4.99.883 1.087 2.265 1.873 4.682 1.873 3.145 0 4.58-.672 5.309-1.499.767-.87 1.116-2.299 1.116-4.719 0-2.277-.485-3.689-1.408-4.633-.954-.975-2.635-1.722-5.644-2.048-2.969-.321-4.378.277-5.06 1.057-.537.614-.873 1.615-.876 3.152v.042c.002.53.042 1.123.127 1.785Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M28.998 28.516c1.104 0 1.999.895 1.999 1.999v3.998a2 2 0 1 1-3.998 0v-3.998c0-1.104.895-1.999 1.999-1.999Zm-9.996 0c1.104 0 1.999.895 1.999 1.999v3.998a2 2 0 1 1-3.998 0v-3.998c0-1.104.895-1.999 1.999-1.999Z"
            }))
        },
        "96": {
            "width": 96,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M95.667 67.954C92.225 73.933 72.24 88.04 47.997 88.04 23.754 88.04 3.769 73.933.328 67.954c-.216-.375-.307-.796-.328-1.226V55.661c.019-.371.089-.736.226-1.081 1.489-3.738 5.386-9.166 10.417-10.623.667-1.712 1.655-4.215 2.576-6.062-.154-1.414-.208-2.872-.208-4.345 0-5.322 1.128-9.99 4.527-13.466 1.587-1.623 3.557-2.869 5.893-3.805 5.595-4.545 13.563-8.369 24.48-8.369s19.057 3.824 24.652 8.369c2.337.936 4.306 2.182 5.894 3.805 3.399 3.476 4.527 8.144 4.527 13.466 0 1.473-.054 2.931-.208 4.345.921 1.847 1.909 4.35 2.576 6.062 5.03 1.457 8.928 6.885 10.417 10.623.163.41.231.848.231 1.289v10.644c0 .504-.081 1.004-.333 1.441ZM48.686 43.993l-.3.001-1.077-.001c-.423.709-.894 1.39-1.418 2.035-3.078 3.787-7.672 5.964-14.026 5.964-6.897 0-11.952-1.435-15.123-5.032a7.886 7.886 0 0 1-.342-.419l-.39.419v26.326c5.737 3.118 18.05 8.713 31.987 8.713 13.938 0 26.251-5.595 31.988-8.713V46.96l-.39-.419s-.132.181-.342.419c-3.171 3.597-8.226 5.032-15.123 5.032-6.354 0-10.949-2.177-14.026-5.964a17.178 17.178 0 0 1-1.418-2.034h-.066l.066-.001Zm-3.94-11.733c.17-1.326.251-2.513.253-3.573v-.084c-.005-3.077-.678-5.079-1.752-6.308-1.365-1.562-4.184-2.758-10.127-2.115-6.021.652-9.386 2.146-11.294 4.098-1.847 1.889-2.818 4.715-2.818 9.272 0 4.842.698 7.703 2.232 9.443 1.459 1.655 4.332 3.001 10.625 3.001 4.837 0 7.603-1.573 9.371-3.749 1.899-2.336 2.967-5.759 3.51-9.985Zm6.503 0c.543 4.226 1.611 7.649 3.51 9.985 1.768 2.176 4.533 3.749 9.371 3.749 6.292 0 9.165-1.346 10.624-3.001 1.535-1.74 2.232-4.601 2.232-9.443 0-4.557-.97-7.383-2.817-9.272-1.908-1.952-5.274-3.446-11.294-4.098-5.943-.643-8.763.553-10.127 2.115-1.074 1.229-1.747 3.231-1.752 6.308v.084c.002 1.06.083 2.247.253 3.573Zm-2.563 11.734h.066l-.066-.001v.001Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M38.5 55.75a3.5 3.5 0 0 1 3.5 3.5v8.5a3.5 3.5 0 1 1-7 0v-8.5a3.5 3.5 0 0 1 3.5-3.5Zm19 0a3.5 3.5 0 0 1 3.5 3.5v8.5a3.5 3.5 0 1 1-7 0v-8.5a3.5 3.5 0 0 1 3.5-3.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$e5748a8abdfef92a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CopilotErrorIcon", "octicon octicon-copilot-error", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 11.24c0 .112-.072.274-.21.467L13 9.688V7.862l-.023-.116c-.49.21-1.075.291-1.727.291-.198 0-.388-.009-.571-.029L6.833 5.226a4.01 4.01 0 0 0 .17-.782c.117-.935-.037-1.395-.241-1.614-.193-.206-.637-.413-1.682-.297-.683.076-1.115.231-1.395.415l-1.257-.91c.579-.564 1.413-.877 2.485-.996 1.206-.134 2.262.034 2.944.765.05.053.096.108.139.165.044-.057.094-.112.143-.165.682-.731 1.738-.899 2.944-.765 1.23.137 2.145.528 2.724 1.261.566.715.693 1.614.693 2.484 0 .572-.053 1.148-.254 1.656.066.228.098.429.126.612.012.076.024.148.037.218.924.385 1.522 1.471 1.591 2.095Zm-5.083-8.707c-1.044-.116-1.488.091-1.681.297-.204.219-.359.679-.242 1.614.091.726.303 1.231.618 1.553.299.305.784.54 1.638.54.922 0 1.28-.198 1.442-.379.179-.2.308-.578.308-1.371 0-.765-.123-1.242-.37-1.554-.233-.296-.693-.587-1.713-.7Zm2.511 11.074c-1.393.776-3.272 1.428-5.43 1.428-4.562 0-7.873-2.914-7.998-3.749V9.338c.085-.628.677-1.686 1.588-2.065.013-.07.024-.143.036-.218.029-.183.06-.384.126-.612-.18-.455-.241-.963-.252-1.475L.31 4.107A.747.747 0 0 1 0 3.509V3.49a.748.748 0 0 1 .625-.73c.156-.026.306.047.435.139l14.667 10.578a.592.592 0 0 1 .227.264.752.752 0 0 1 .046.249v.022a.75.75 0 0 1-1.19.596Zm-1.367-.991L5.635 7.964a5.128 5.128 0 0 1-.889.073c-.652 0-1.236-.081-1.727-.291l-.023.116v4.255c.419.323 2.722 1.433 5.002 1.433 1.539 0 3.089-.505 4.063-.934Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$6a1620fc303afef = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CopilotWarningIcon", "octicon octicon-copilot-warning", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.498 14.811a4.53 4.53 0 0 1-1.161-1.337 4.476 4.476 0 0 1-.587-2.224 4.496 4.496 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5 4.5 4.5 0 0 1-7.252 3.561ZM10.5 8.75V11a.75.75 0 0 0 1.5 0V8.75a.75.75 0 1 0-1.5 0Zm.75 5.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m14.354 6.114-.05-.029a5.949 5.949 0 0 0-1.351-.589c.03-.19.047-.422.047-.709 0-.765-.123-1.242-.37-1.554-.233-.296-.693-.587-1.713-.7-1.044-.116-1.488.091-1.681.297-.204.219-.359.679-.242 1.614.058.462.165.834.316 1.127A6.025 6.025 0 0 0 6.369 7.76c-.472.185-1.015.277-1.623.277-.652 0-1.236-.081-1.727-.291l-.023.116v4.255c.265.205 1.285.725 2.577 1.079a5.937 5.937 0 0 0 .939 1.736C2.733 14.407.111 12.027 0 11.286V9.338c.085-.628.677-1.686 1.588-2.065.013-.07.024-.143.036-.218.029-.183.06-.384.126-.612-.201-.508-.254-1.084-.254-1.656 0-.87.128-1.769.693-2.484.579-.733 1.494-1.124 2.724-1.261 1.206-.134 2.262.034 2.944.765.05.053.096.108.139.165.044-.057.094-.112.143-.165.682-.731 1.738-.899 2.944-.765 1.23.137 2.145.528 2.724 1.261.566.715.693 1.614.693 2.484 0 .452-.033.906-.146 1.327ZM6.762 2.83c-.193-.206-.637-.413-1.682-.297-1.019.113-1.479.404-1.713.7-.247.312-.369.789-.369 1.554 0 .793.129 1.171.308 1.371.162.181.519.379 1.442.379.853 0 1.339-.235 1.638-.54.315-.322.527-.827.617-1.553.117-.935-.037-1.395-.241-1.614Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$51b6cd98f8778f0d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CopyIcon", "octicon octicon-copy", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a99af643ba9e93d6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CpuIcon", "octicon octicon-cpu", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.5.75V2h3V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75V5h1.25a.75.75 0 0 1 0 1.5H14v3h1.25a.75.75 0 0 1 0 1.5H14v1.25A1.75 1.75 0 0 1 12.25 14H11v1.25a.75.75 0 0 1-1.5 0V14h-3v1.25a.75.75 0 0 1-1.5 0V14H3.75A1.75 1.75 0 0 1 2 12.25V11H.75a.75.75 0 0 1 0-1.5H2v-3H.75a.75.75 0 0 1 0-1.5H2V3.75C2 2.784 2.784 2 3.75 2H5V.75a.75.75 0 0 1 1.5 0Zm5.75 11.75a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25ZM5.75 5h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 5.75 5Zm.75 4.5h3v-3h-3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 8h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 8.75 8Zm.75 6.5h5v-5h-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.25 1a.75.75 0 0 1 .75.75V4h2.25c.966 0 1.75.784 1.75 1.75V8h2.25a.75.75 0 0 1 0 1.5H20v5h2.25a.75.75 0 0 1 0 1.5H20v2.25A1.75 1.75 0 0 1 18.25 20H16v2.25a.75.75 0 0 1-1.5 0V20h-5v2.25a.75.75 0 0 1-1.5 0V20H5.75A1.75 1.75 0 0 1 4 18.25V16H1.75a.75.75 0 0 1 0-1.5H4v-5H1.75a.75.75 0 0 1 0-1.5H4V5.75C4 4.784 4.784 4 5.75 4H8V1.75a.75.75 0 0 1 1.5 0V4h5V1.75a.75.75 0 0 1 .75-.75Zm3 17.5a.25.25 0 0 0 .25-.25V5.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$9aecafbc92062ce3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CreditCardIcon", "octicon octicon-credit-card", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.75 9a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25ZM14.5 6.5h-13v5.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm0-2.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25V5h13Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.25 14a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25V4.75C0 3.784.784 3 1.75 3Zm-.25 7v9.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V10Zm0-5.25V8.5h21V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$63f0d8a59fc7d9b4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CrossReferenceIcon", "octicon octicon-cross-reference", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 3.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 13H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 14.543V13H2.75A1.75 1.75 0 0 1 1 11.25v-7.5C1 2.784 1.784 2 2.75 2h5.5a.75.75 0 0 1 0 1.5ZM16 1.25v4.146a.25.25 0 0 1-.427.177L14.03 4.03l-3.75 3.75a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l3.75-3.75-1.543-1.543A.25.25 0 0 1 11.604 1h4.146a.25.25 0 0 1 .25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L20.94 3h-3.69a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.72-3.72a.75.75 0 0 1 .53-.22h10a.25.25 0 0 0 .25-.25v-6a.75.75 0 0 1 1.5 0v6a1.75 1.75 0 0 1-1.75 1.75h-9.69l-3.573 3.573A1.457 1.457 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75V4.25c0-.966.784-1.75 1.75-1.75h11a.75.75 0 0 1 0 1.5h-11Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$d5639eecba0ce6ec = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("CrosshairsIcon", "octicon octicon-crosshairs", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 7.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5Zm3-7a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 8 .25Zm7 7a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Zm-7 3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9Zm-1.5 0a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 .25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 12 .25Zm-6 11a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5Zm17 0a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5Zm-11 6a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a2bc8cb49334c5d1 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DashIcon", "octicon octicon-dash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.5 12.75a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H5.25a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9f40554892cbf4af = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DatabaseIcon", "octicon octicon-database", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 3.5c0-.626.292-1.165.7-1.59.406-.422.956-.767 1.579-1.041C4.525.32 6.195 0 8 0c1.805 0 3.475.32 4.722.869.622.274 1.172.62 1.578 1.04.408.426.7.965.7 1.591v9c0 .626-.292 1.165-.7 1.59-.406.422-.956.767-1.579 1.041C11.476 15.68 9.806 16 8 16c-1.805 0-3.475-.32-4.721-.869-.623-.274-1.173-.62-1.579-1.04-.408-.426-.7-.965-.7-1.591Zm1.5 0c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 5.205 6.353 5.5 8 5.5c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55 0-.133-.058-.318-.282-.551-.227-.237-.591-.483-1.101-.707C11.102 1.795 9.647 1.5 8 1.5c-1.646 0-3.101.295-4.118.742-.508.224-.873.471-1.1.708-.224.232-.282.417-.282.55Zm0 4.5c0 .133.058.318.282.551.227.237.591.483 1.101.707C4.898 9.705 6.353 10 8 10c1.646 0 3.101-.295 4.118-.742.508-.224.873-.471 1.1-.708.224-.232.282-.417.282-.55V5.724c-.241.15-.503.286-.778.407C11.475 6.68 9.805 7 8 7c-1.805 0-3.475-.32-4.721-.869a6.15 6.15 0 0 1-.779-.407Zm0 2.225V12.5c0 .133.058.318.282.55.227.237.592.484 1.1.708 1.016.447 2.471.742 4.118.742 1.647 0 3.102-.295 4.117-.742.51-.224.874-.47 1.101-.707.224-.233.282-.418.282-.551v-2.275c-.241.15-.503.285-.778.406-1.247.549-2.917.869-4.722.869-1.805 0-3.475-.32-4.721-.869a6.327 6.327 0 0 1-.779-.406Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1.25c2.487 0 4.773.402 6.466 1.079.844.337 1.577.758 2.112 1.264.536.507.922 1.151.922 1.907v12.987l-.026.013h.026c0 .756-.386 1.4-.922 1.907-.535.506-1.268.927-2.112 1.264-1.693.677-3.979 1.079-6.466 1.079s-4.774-.402-6.466-1.079c-.844-.337-1.577-.758-2.112-1.264C2.886 19.9 2.5 19.256 2.5 18.5h.026l-.026-.013V5.5c0-.756.386-1.4.922-1.907.535-.506 1.268-.927 2.112-1.264C7.226 1.652 9.513 1.25 12 1.25ZM4 14.371v4.116l-.013.013H4c0 .211.103.487.453.817.351.332.898.666 1.638.962 1.475.589 3.564.971 5.909.971 2.345 0 4.434-.381 5.909-.971.739-.296 1.288-.63 1.638-.962.349-.33.453-.607.453-.817h.013L20 18.487v-4.116a7.85 7.85 0 0 1-1.534.8c-1.693.677-3.979 1.079-6.466 1.079s-4.774-.402-6.466-1.079a7.843 7.843 0 0 1-1.534-.8ZM20 12V7.871a7.85 7.85 0 0 1-1.534.8C16.773 9.348 14.487 9.75 12 9.75s-4.774-.402-6.466-1.079A7.85 7.85 0 0 1 4 7.871V12c0 .21.104.487.453.817.35.332.899.666 1.638.961 1.475.59 3.564.972 5.909.972 2.345 0 4.434-.382 5.909-.972.74-.295 1.287-.629 1.638-.96.35-.33.453-.607.453-.818ZM4 5.5c0 .211.103.487.453.817.351.332.898.666 1.638.962 1.475.589 3.564.971 5.909.971 2.345 0 4.434-.381 5.909-.971.739-.296 1.288-.63 1.638-.962.349-.33.453-.607.453-.817 0-.211-.103-.487-.453-.817-.351-.332-.898-.666-1.638-.962-1.475-.589-3.564-.971-5.909-.971-2.345 0-4.434.381-5.909.971-.739.296-1.288.63-1.638.962C4.104 5.013 4 5.29 4 5.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3751480e384bbd82 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DependabotIcon", "octicon octicon-dependabot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 7.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Zm5.25.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.25 0h2A.75.75 0 0 1 9 .75V3.5h3.25a2.25 2.25 0 0 1 2.25 2.25V8h.75a.75.75 0 0 1 0 1.5h-.75v2.75a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25V9.5H.75a.75.75 0 0 1 0-1.5h.75V5.75A2.25 2.25 0 0 1 3.75 3.5H7.5v-2H6.25a.75.75 0 0 1 0-1.5ZM3 5.75v6.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 11a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Zm7.25.75a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.813 1h2.437a.75.75 0 0 1 .75.75V5h6.75A2.25 2.25 0 0 1 22 7.25v5.25h1.25a.75.75 0 0 1 0 1.5H22v5.75A2.25 2.25 0 0 1 19.75 22H4.25A2.25 2.25 0 0 1 2 19.75V14H.75a.75.75 0 0 1 0-1.5H2V7.25A2.25 2.25 0 0 1 4.25 5h7.25V2.5H9.813A.75.75 0 0 1 9.812 1ZM3.5 7.25v12.5c0 .414.336.75.75.75h15.5a.75.75 0 0 0 .75-.75V7.25a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$ec27283855b6356a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DesktopDownloadIcon", "octicon octicon-desktop-download", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m4.927 5.427 2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 5H8.75V.75a.75.75 0 1 0-1.5 0V5H5.104a.25.25 0 0 0-.177.427Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.573 2.573a.25.25 0 0 0-.073.177v7.5a.25.25 0 0 0 .25.25h12.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-3a.75.75 0 1 1 0-1.5h3A1.75 1.75 0 0 1 16 2.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.75.75 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.192-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5A1.75 1.75 0 0 1 1.75 1h3a.75.75 0 0 1 0 1.5h-3a.25.25 0 0 0-.177.073ZM6.982 12a5.72 5.72 0 0 1-.765 2.5h3.566a5.72 5.72 0 0 1-.765-2.5H6.982Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.25 9.331V.75a.75.75 0 0 1 1.5 0v8.58l1.949-2.11A.75.75 0 1 1 15.8 8.237l-3.25 3.52a.75.75 0 0 1-1.102 0l-3.25-3.52A.75.75 0 1 1 9.3 7.22l1.949 2.111Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 3.75v11.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.75.75 0 0 1 0-1.5h5.5c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 21.25 17h-6.204c.171 1.375.805 2.652 1.769 3.757A.752.752 0 0 1 16.25 22h-8.5a.75.75 0 0 1-.566-1.243c.965-1.105 1.599-2.382 1.77-3.757H2.75A1.75 1.75 0 0 1 1 15.25V3.75C1 2.784 1.784 2 2.75 2h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25ZM10.463 17c-.126 1.266-.564 2.445-1.223 3.5h5.52c-.66-1.055-1.098-2.234-1.223-3.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$24558ca47a308df5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DeviceCameraIcon", "octicon octicon-device-camera", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 3c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1 0-.55.45-1 1-1h4c.55 0 1 .45 1 1Zm-4.5 9c1.94 0 3.5-1.56 3.5-3.5S12.44 5 10.5 5 7 6.56 7 8.5 8.56 12 10.5 12ZM13 8.5c0 1.38-1.13 2.5-2.5 2.5S8 9.87 8 8.5 9.13 6 10.5 6 13 7.13 13 8.5ZM6 5V4H2v1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.333 5.333c.734 0 1.334.6 1.334 1.334v12c0 .733-.6 1.333-1.334 1.333H2.667c-.734 0-1.334-.6-1.334-1.333v-12c0-.734.6-1.334 1.334-1.334C2.667 4.6 3.267 4 4 4h5.333c.734 0 1.334.6 1.334 1.333h10.666Zm-6 12A4.655 4.655 0 0 0 20 12.667 4.655 4.655 0 0 0 15.333 8a4.655 4.655 0 0 0-4.666 4.667 4.655 4.655 0 0 0 4.666 4.666Zm3.334-4.666A3.343 3.343 0 0 1 15.333 16 3.352 3.352 0 0 1 12 12.667a3.352 3.352 0 0 1 3.333-3.334 3.352 3.352 0 0 1 3.334 3.334ZM9.333 8V6.667H4V8h5.333Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$e11bb7c98c7dfbc5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DeviceCameraVideoIcon", "octicon octicon-device-camera-video", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 3.75v8.5a.75.75 0 0 1-1.136.643L11 10.575v.675A1.75 1.75 0 0 1 9.25 13h-7.5A1.75 1.75 0 0 1 0 11.25v-6.5C0 3.784.784 3 1.75 3h7.5c.966 0 1.75.784 1.75 1.75v.675l3.864-2.318A.75.75 0 0 1 16 3.75Zm-6.5 1a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-6.5ZM11 8.825l3.5 2.1v-5.85l-3.5 2.1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M24 5.25v13a.75.75 0 0 1-1.136.643L16.5 15.075v2.175A1.75 1.75 0 0 1 14.75 19h-13A1.75 1.75 0 0 1 0 17.25v-11C0 5.284.784 4.5 1.75 4.5h13c.966 0 1.75.784 1.75 1.75v2.175l6.364-3.818A.75.75 0 0 1 24 5.25Zm-9 1a.25.25 0 0 0-.25-.25h-13a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h13a.25.25 0 0 0 .25-.25v-11Zm1.5 7.075 6 3.6V6.575l-6 3.6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$64e9f470ca3ab9af = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DeviceDesktopIcon", "octicon octicon-device-desktop", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.25 1c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 14.25 12h-3.727c.099 1.041.52 1.872 1.292 2.757A.752.752 0 0 1 11.25 16h-6.5a.75.75 0 0 1-.565-1.243c.772-.885 1.192-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5C0 1.784.784 1 1.75 1ZM1.75 2.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25ZM9.018 12H6.982a5.72 5.72 0 0 1-.765 2.5h3.566a5.72 5.72 0 0 1-.765-2.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.954 17H2.75A1.75 1.75 0 0 1 1 15.25V3.75C1 2.784 1.784 2 2.75 2h18.5c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 21.25 17h-6.204c.171 1.375.805 2.652 1.769 3.757A.752.752 0 0 1 16.25 22h-8.5a.75.75 0 0 1-.565-1.243c.964-1.105 1.598-2.382 1.769-3.757ZM21.5 3.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25ZM13.537 17h-3.074c-.126 1.266-.564 2.445-1.223 3.5h5.52c-.659-1.055-1.098-2.234-1.223-3.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f5f71ba58a96f313 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DeviceMobileIcon", "octicon octicon-device-mobile", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 0h8.5C13.216 0 14 .784 14 1.75v12.5A1.75 1.75 0 0 1 12.25 16h-8.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.784 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.25 5.25A.75.75 0 0 1 11 4.5h2A.75.75 0 0 1 13 6h-2a.75.75 0 0 1-.75-.75ZM12 19.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 2.75C4 1.784 4.784 1 5.75 1h12.5c.966 0 1.75.784 1.75 1.75v18.5A1.75 1.75 0 0 1 18.25 23H5.75A1.75 1.75 0 0 1 4 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v18.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$ba4cac3c471c5034 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DevicesIcon", "octicon octicon-devices", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75V5a.75.75 0 0 1-1.5 0V2.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25H7A.75.75 0 0 1 7 12h-.268a5.712 5.712 0 0 1-.765 2.5H7A.75.75 0 0 1 7 16H4.5a.75.75 0 0 1-.565-1.243c.772-.885 1.193-1.716 1.292-2.757H1.75A1.75 1.75 0 0 1 0 10.25v-7.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.75 7h3.5c.967 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-5.5C9 7.784 9.783 7 10.75 7Zm-.25 1.75v5.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 3.75C1 2.784 1.784 2 2.75 2h18.5c.966 0 1.75.784 1.75 1.75v4a.75.75 0 0 1-1.5 0v-4a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h9a.75.75 0 0 1 0 1.5h-1.287c-.126 1.266-.564 2.445-1.223 3.5h2.51a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.565-1.243c.964-1.105 1.598-2.382 1.769-3.757H2.75A1.75 1.75 0 0 1 1 15.25V3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14 11.75c0-.967.783-1.75 1.75-1.75h5.5c.966 0 1.75.783 1.75 1.75v8.5A1.75 1.75 0 0 1 21.25 22h-5.5A1.75 1.75 0 0 1 14 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$5e3451d6d1223703 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiamondIcon", "octicon octicon-diamond", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.527 9.237a1.75 1.75 0 0 1 0-2.474L6.777.512a1.75 1.75 0 0 1 2.475 0l6.251 6.25a1.75 1.75 0 0 1 0 2.475l-6.25 6.251a1.75 1.75 0 0 1-2.475 0L.527 9.238Zm1.06-1.414a.25.25 0 0 0 0 .354l6.251 6.25a.25.25 0 0 0 .354 0l6.25-6.25a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.354 0l-6.25 6.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.527 13.237a1.75 1.75 0 0 1 0-2.474l9.272-9.273a1.75 1.75 0 0 1 2.475 0l9.272 9.273a1.75 1.75 0 0 1 0 2.474l-9.272 9.272a1.75 1.75 0 0 1-2.475 0Zm1.06-1.414a.25.25 0 0 0 0 .354l9.273 9.272a.25.25 0 0 0 .353 0l9.272-9.272a.25.25 0 0 0 0-.354l-9.272-9.272a.25.25 0 0 0-.353 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$20dfae02409785b4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiceIcon", "octicon octicon-dice", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 13.25 15H2.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1h10.5ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6-6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 20.25 22H3.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 2 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 13.5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 12 13.5Zm-5 5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 7 18.5Zm10-10a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 17 8.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$7757fa22cc9fb809 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiffIcon", "octicon octicon-diff", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 1.75V5H12a.75.75 0 0 1 0 1.5H8.75v3.25a.75.75 0 0 1-1.5 0V6.5H4A.75.75 0 0 1 4 5h3.25V1.75a.75.75 0 0 1 1.5 0ZM4 13h8a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 4 13Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.25 3.5a.75.75 0 0 1 .75.75V8.5h4.25a.75.75 0 0 1 0 1.5H13v4.25a.75.75 0 0 1-1.5 0V10H7.25a.75.75 0 0 1 0-1.5h4.25V4.25a.75.75 0 0 1 .75-.75ZM6.562 19.25a.75.75 0 0 1 .75-.75h9.938a.75.75 0 0 1 0 1.5H7.312a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$922260bf5f8ffbaa = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiffAddedIcon", "octicon octicon-diff-added", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1Zm10.5 1.5H2.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 4a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 8 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.75 7a.75.75 0 0 0-1.5 0v4.25H7a.75.75 0 0 0 0 1.5h4.25V17a.75.75 0 0 0 1.5 0v-4.25H17a.75.75 0 0 0 0-1.5h-4.25V7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 20.25V3.75A1.75 1.75 0 0 0 20.25 2H3.75ZM3.5 3.75a.25.25 0 0 1 .25-.25h16.5a.25.25 0 0 1 .25.25v16.5a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25V3.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$3e6f00c5163da869 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiffIgnoredIcon", "octicon octicon-diff-ignored", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm8.53 3.28-5.5 5.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l5.5-5.5a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 20.25V3.75A1.75 1.75 0 0 0 20.25 2H3.75ZM3.5 3.75a.25.25 0 0 1 .25-.25h16.5a.25.25 0 0 1 .25.25v16.5a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25V3.75Zm4.737 11.233a.75.75 0 0 0 1.061 1.06l7.027-7.026a.75.75 0 0 0-1.06-1.06l-7.028 7.026Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4149915caab8aa5e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiffModifiedIcon", "octicon octicon-diff-modified", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6e5f778d88fc462 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiffRemovedIcon", "octicon octicon-diff-removed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm8.5 6.25h-6.5a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.313 11.25a.75.75 0 0 0 0 1.5h9.937a.75.75 0 0 0 0-1.5H7.312Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 20.25V3.75A1.75 1.75 0 0 0 20.25 2H3.75ZM3.5 3.75a.25.25 0 0 1 .25-.25h16.5a.25.25 0 0 1 .25.25v16.5a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25V3.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$316a6a88990c13e4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiffRenamedIcon", "octicon octicon-diff-renamed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm9.03 6.03-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H4.75a.75.75 0 0 1 0-1.5h4.69L7.47 5.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.25 3.25a.75.75 0 0 1 0 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.75 12.75v3.347a.25.25 0 0 0 .436.166l3.672-4.096a.25.25 0 0 0 0-.334l-3.672-4.096a.25.25 0 0 0-.436.166v3.347h-7a.75.75 0 0 0 0 1.5h7Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$69ef1d9fb7859fb5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiscussionClosedIcon", "octicon octicon-discussion-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm-5.47.28-3 3a.747.747 0 0 1-1.06 0l-1.5-1.5a.749.749 0 1 1 1.06-1.06l.97.969L7.72 3.72a.749.749 0 1 1 1.06 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm-9.72-3.22-5 5a.747.747 0 0 1-1.06 0l-2.5-2.5a.749.749 0 1 1 1.06-1.06L7 8.689l4.47-4.469a.749.749 0 1 1 1.06 1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2516f0e9108eb4ee = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiscussionDuplicateIcon", "octicon octicon-discussion-duplicate", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm-6.282.03L5.03 7.468a.749.749 0 1 1-1.06-1.061L6.907 3.47a.75.75 0 0 1 1.061 1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25ZM11.28 5.53l-5 5a.749.749 0 1 1-1.06-1.06l5-5a.749.749 0 1 1 1.06 1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$e505b62afe0037a9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DiscussionOutdatedIcon", "octicon octicon-discussion-outdated", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h8.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.457 1.457 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25Zm1.75-.25a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.189L6.22 8.72a.747.747 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm12.5 2h-.5a.75.75 0 0 1 0-1.5h.5c.967 0 1.75.783 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.457 1.457 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 1 1 1.06-1.06l2.22 2.219V11.25a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM6.5 4v1.492l.466.187.036.015.812.375a.75.75 0 1 1-.628 1.362l-.795-.367-.92-.368A.75.75 0 0 1 5 6V4a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25ZM8.5 4.75v3.14l1.15.488a.608.608 0 0 1 .037.017l1.393.681a.75.75 0 0 1-.66 1.348l-1.374-.673-1.589-.674A.751.751 0 0 1 7 8.386V4.75a.75.75 0 0 1 1.5 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1638d451d4588271 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DotIcon", "octicon octicon-dot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7930088993b77a6b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DotFillIcon", "octicon octicon-dot-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4e54df4252b4a99c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DownloadIcon", "octicon octicon-download", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 17.25a.75.75 0 0 1 .75.75v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V18a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.22 9.97a.749.749 0 0 1 1.06 0l4.97 4.969V2.75a.75.75 0 0 1 1.5 0v12.189l4.97-4.969a.749.749 0 1 1 1.06 1.06l-6.25 6.25a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$10862138e9169702 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("DuplicateIcon", "octicon octicon-duplicate", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.5 3a.75.75 0 0 1 .75.75v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1 0-1.5h1v-1A.75.75 0 0 1 10.5 3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5C5 .784 5.784 0 6.75 0ZM6.5 1.75v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 5A1.75 1.75 0 0 0 0 6.75v7.5C0 15.216.784 16 1.75 16h7.5A1.75 1.75 0 0 0 11 14.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.513 6a.75.75 0 0 1 .75.75v2h1.987a.75.75 0 0 1 0 1.5h-1.987v2a.75.75 0 1 1-1.5 0v-2H11.75a.75.75 0 0 1 0-1.5h2.013v-2a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$fc6234d5b1c606d7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("EllipsisIcon", "octicon octicon-ellipsis", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 5.75C0 4.784.784 4 1.75 4h12.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 14.25 12H1.75A1.75 1.75 0 0 1 0 10.25ZM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22 9.75v5.5A1.75 1.75 0 0 1 20.25 17H3.75A1.75 1.75 0 0 1 2 15.25v-5.5C2 8.784 2.784 8 3.75 8h16.5c.966 0 1.75.784 1.75 1.75Zm-8.75 2.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Zm-6.5 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm10.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b86c71d6e0978b68 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ExclamationIcon", "octicon octicon-exclamation", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 11a2 2 0 1 1 .001 3.999A2 2 0 0 1 8 11ZM8 1a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-3 0v-6A1.5 1.5 0 0 1 8 1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 18.5a2 2 0 1 1 .001 3.999A2 2 0 0 1 12 18.5ZM12 2a1.5 1.5 0 0 1 1.5 1.5V15a1.5 1.5 0 0 1-3 0V3.5A1.5 1.5 0 0 1 12 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4b2c798a70974642 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("EyeIcon", "octicon octicon-eye", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 2c1.981 0 3.671.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.45.678-1.367 1.932-2.637 3.023C11.67 13.008 9.981 14 8 14c-1.981 0-3.671-.992-4.933-2.078C1.797 10.83.88 9.576.43 8.898a1.62 1.62 0 0 1 0-1.798c.45-.677 1.367-1.931 2.637-3.022C4.33 2.992 6.019 2 8 2ZM1.679 7.932a.12.12 0 0 0 0 .136c.411.622 1.241 1.75 2.366 2.717C5.176 11.758 6.527 12.5 8 12.5c1.473 0 2.825-.742 3.955-1.715 1.124-.967 1.954-2.096 2.366-2.717a.12.12 0 0 0 0-.136c-.412-.621-1.242-1.75-2.366-2.717C10.824 4.242 9.473 3.5 8 3.5c-1.473 0-2.825.742-3.955 1.715-1.124.967-1.954 2.096-2.366 2.717ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 3.5c3.432 0 6.124 1.534 8.054 3.241 1.926 1.703 3.132 3.61 3.616 4.46a1.6 1.6 0 0 1 0 1.598c-.484.85-1.69 2.757-3.616 4.461-1.929 1.706-4.622 3.24-8.054 3.24-3.432 0-6.124-1.534-8.054-3.24C2.02 15.558.814 13.65.33 12.8a1.6 1.6 0 0 1 0-1.598c.484-.85 1.69-2.757 3.616-4.462C5.875 5.034 8.568 3.5 12 3.5ZM1.633 11.945a.115.115 0 0 0-.017.055c.001.02.006.039.017.056.441.774 1.551 2.527 3.307 4.08C6.691 17.685 9.045 19 12 19c2.955 0 5.31-1.315 7.06-2.864 1.756-1.553 2.866-3.306 3.307-4.08a.111.111 0 0 0 .017-.056.111.111 0 0 0-.017-.056c-.441-.773-1.551-2.527-3.307-4.08C17.309 6.315 14.955 5 12 5 9.045 5 6.69 6.314 4.94 7.865c-1.756 1.552-2.866 3.306-3.307 4.08Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$f2c2531e46a6c1ea = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("EyeClosedIcon", "octicon octicon-eye-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.143 2.31a.75.75 0 0 1 1.047-.167l14.5 10.5a.75.75 0 1 1-.88 1.214l-2.248-1.628C11.346 13.19 9.792 14 8 14c-1.981 0-3.67-.992-4.933-2.078C1.797 10.832.88 9.577.43 8.9a1.619 1.619 0 0 1 0-1.797c.353-.533.995-1.42 1.868-2.305L.31 3.357A.75.75 0 0 1 .143 2.31Zm1.536 5.622A.12.12 0 0 0 1.657 8c0 .021.006.045.022.068.412.621 1.242 1.75 2.366 2.717C5.175 11.758 6.527 12.5 8 12.5c1.195 0 2.31-.488 3.29-1.191L9.063 9.695A2 2 0 0 1 6.058 7.52L3.529 5.688a14.207 14.207 0 0 0-1.85 2.244ZM8 3.5c-.516 0-1.017.09-1.499.251a.75.75 0 1 1-.473-1.423A6.207 6.207 0 0 1 8 2c1.981 0 3.67.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.11.166-.248.365-.41.587a.75.75 0 1 1-1.21-.887c.148-.201.272-.382.371-.53a.119.119 0 0 0 0-.137c-.412-.621-1.242-1.75-2.366-2.717C10.825 4.242 9.473 3.5 8 3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.052 5.837A9.715 9.715 0 0 1 12 5c2.955 0 5.309 1.315 7.06 2.864 1.756 1.553 2.866 3.307 3.307 4.08a.11.11 0 0 1 .016.055.122.122 0 0 1-.017.06 16.766 16.766 0 0 1-1.53 2.218.75.75 0 1 0 1.163.946 18.253 18.253 0 0 0 1.67-2.42 1.607 1.607 0 0 0 .001-1.602c-.485-.85-1.69-2.757-3.616-4.46C18.124 5.034 15.432 3.5 12 3.5c-1.695 0-3.215.374-4.552.963a.75.75 0 0 0 .604 1.373Zm11.114 12.15C17.328 19.38 14.933 20.5 12 20.5c-3.432 0-6.125-1.534-8.054-3.24C2.02 15.556.814 13.648.33 12.798a1.606 1.606 0 0 1 .001-1.6A18.283 18.283 0 0 1 3.648 7.01L1.317 5.362a.75.75 0 1 1 .866-1.224l20.5 14.5a.75.75 0 1 1-.866 1.224ZM4.902 7.898c-1.73 1.541-2.828 3.273-3.268 4.044a.112.112 0 0 0-.017.059c0 .015.003.034.016.055.441.774 1.551 2.527 3.307 4.08C6.69 17.685 9.045 19 12 19c2.334 0 4.29-.82 5.874-1.927l-3.516-2.487a3.5 3.5 0 0 1-5.583-3.949L4.902 7.899Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$6e3b45b659de5ab0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedDiscussionIcon", "octicon octicon-feed-discussion", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM4 5v5a1 1 0 0 0 1 1h1v1.5a.5.5 0 0 0 .854.354L8.707 11H11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3647c0e0c99821b2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedForkedIcon", "octicon octicon-feed-forked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM6 6.928a1.75 1.75 0 1 0-1 0V7.5A1.5 1.5 0 0 0 6.5 9h1v1.072a1.75 1.75 0 1 0 1 0V9h1A1.5 1.5 0 0 0 11 7.5v-.572a1.75 1.75 0 1 0-1 0V7.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a4dcaa8e6d385a92 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedHeartIcon", "octicon octicon-feed-heart", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm2.33-11.5c-1.22 0-1.83.5-2.323 1.136C7.513 5 6.903 4.5 5.682 4.5c-1.028 0-2.169.784-2.169 2.5 0 1.499 1.493 3.433 3.246 4.517.52.321.89.479 1.248.484.357-.005.728-.163 1.247-.484C11.007 10.433 12.5 8.5 12.5 7c0-1.716-1.14-2.5-2.17-2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ad245ed13629d5ff = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedIssueClosedIcon", "octicon octicon-feed-issue-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm3.457 6.957a.999.999 0 1 0-1.414-1.414L7.25 8.336 5.957 7.043a.999.999 0 1 0-1.414 1.414l2 2a.999.999 0 0 0 1.414 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$18ccf531e6b6c966 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedIssueDraftIcon", "octicon octicon-feed-issue-draft", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM3.802 7.334a.75.75 0 0 0-1.482-.233 5.8 5.8 0 0 0 0 1.798.749.749 0 1 0 1.482-.233 4.296 4.296 0 0 1 0-1.332ZM8 2.25a5.8 5.8 0 0 0-.899.07.749.749 0 1 0 .233 1.482 4.296 4.296 0 0 1 1.332 0 .75.75 0 0 0 .233-1.482A5.8 5.8 0 0 0 8 2.25Zm-.666 9.948a.75.75 0 0 0-.233 1.482 5.8 5.8 0 0 0 1.798 0 .749.749 0 1 0-.233-1.482 4.296 4.296 0 0 1-1.332 0Zm6.346-5.097a.749.749 0 1 0-1.482.233 4.296 4.296 0 0 1 0 1.332.75.75 0 0 0 1.482.233 5.8 5.8 0 0 0 0-1.798Zm-8.178-2.54a.75.75 0 0 0-.882-1.213A5.77 5.77 0 0 0 3.348 4.62a.749.749 0 1 0 1.213.882c.263-.361.58-.678.941-.941Zm-.941 5.937a.75.75 0 0 0-1.213.882 5.77 5.77 0 0 0 1.272 1.272.749.749 0 1 0 .882-1.213 4.285 4.285 0 0 1-.941-.941Zm6.819-7.15a.749.749 0 1 0-.882 1.213c.36.263.679.58.941.941a.75.75 0 0 0 1.213-.882 5.77 5.77 0 0 0-1.272-1.272Zm1.272 8.032a.749.749 0 1 0-1.213-.882c-.262.36-.581.679-.941.941a.75.75 0 0 0 .882 1.213 5.77 5.77 0 0 0 1.272-1.272Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$37a1aca90ae1bdeb = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedIssueOpenIcon", "octicon octicon-feed-issue-open", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 8a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-5.75a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 1 0 0-11.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$19cf581d7c4f6ce0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedIssueReopenIcon", "octicon octicon-feed-issue-reopen", function() {
    return {
        "16": {
            "width": 17,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.5 8a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm3.427-4.323a.25.25 0 0 0-.427.177V6c0 .138.112.25.25.25h2.146a.25.25 0 0 0 .177-.427l-.524-.524a4.003 4.003 0 0 1 6.862 1.858.75.75 0 0 0 1.467-.314 5.502 5.502 0 0 0-9.39-2.605Zm9.573 8.469V10a.25.25 0 0 0-.25-.25h-2.146a.25.25 0 0 0-.177.427l.524.524a4.002 4.002 0 0 1-6.862-1.858.75.75 0 0 0-1.467.314 5.502 5.502 0 0 0 9.39 2.605l.561.561a.25.25 0 0 0 .427-.177ZM10 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 10 8Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$46ac012c84cfbd37 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedMergedIcon", "octicon octicon-feed-merged", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.25-11.25A1.75 1.75 0 1 0 6 6.428v3.144a1.75 1.75 0 1 0 1 0V8.236A2.99 2.99 0 0 0 9 9h.571a1.75 1.75 0 1 0 0-1H9a2 2 0 0 1-1.957-1.586A1.75 1.75 0 0 0 8.25 4.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$845965101a187ab3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedPersonIcon", "octicon octicon-feed-person", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.847-8.145a2.502 2.502 0 1 0-1.694 0C5.471 8.261 4 9.775 4 11c0 .395.145.995 1 .995h6c.855 0 1-.6 1-.995 0-1.224-1.47-2.74-3.153-3.145Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$35d9a9d54c668cfa = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedPlusIcon", "octicon octicon-feed-plus", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm1.062 4.312a1 1 0 1 0-2 0v2.75h-2.75a1 1 0 0 0 0 2h2.75v2.75a1 1 0 1 0 2 0v-2.75h2.75a1 1 0 1 0 0-2h-2.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1929d2cb4ea72a9b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedPublicIcon", "octicon octicon-feed-public", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm4.5.25v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H7v-1.5a1.5 1.5 0 0 1 2.443-1.167.75.75 0 0 0 .943-1.166A3 3 0 0 0 5.5 5.75v1.5a1 1 0 0 0-1 1Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$aa4b9a44f79a79c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedPullRequestClosedIcon", "octicon octicon-feed-pull-request-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.5 12.25A1.75 1.75 0 0 0 6 8.822V6.928A1.752 1.752 0 0 0 5.5 3.5 1.75 1.75 0 0 0 5 6.928v1.894a1.752 1.752 0 0 0 .5 3.428Zm5-5a.5.5 0 0 0-.5.5v1.072a1.752 1.752 0 0 0 .5 3.428 1.75 1.75 0 0 0 .5-3.428V7.75a.5.5 0 0 0-.5-.5Zm1.255-2.763a.5.5 0 0 0-.707-.707l-.53.531-.531-.531a.5.5 0 0 0-.707.707l.531.531-.531.53a.5.5 0 0 0 .707.707l.531-.53.53.53a.5.5 0 0 0 .707-.707l-.53-.53Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$fda93545d93374f3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedPullRequestDraftIcon", "octicon octicon-feed-pull-request-draft", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm7.25 2.5c0-.793-.527-1.462-1.25-1.678V6.928A1.752 1.752 0 0 0 5.5 3.5 1.75 1.75 0 0 0 5 6.928v1.894a1.752 1.752 0 0 0 .5 3.428 1.75 1.75 0 0 0 1.75-1.75Zm3.25 1.75a1.75 1.75 0 1 0 .001-3.499 1.75 1.75 0 0 0-.001 3.499Zm0-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.75-3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$e6e8e3f3f4447edd = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedPullRequestOpenIcon", "octicon octicon-feed-pull-request-open", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm6.75 2.5c0-.793-.527-1.462-1.25-1.678V6.928A1.752 1.752 0 0 0 5 3.5a1.75 1.75 0 0 0-.5 3.428v1.894A1.752 1.752 0 0 0 5 12.25a1.75 1.75 0 0 0 1.75-1.75Zm3.25-5h.25a.5.5 0 0 1 .5.5v2.822a1.752 1.752 0 0 0 .5 3.428 1.75 1.75 0 0 0 .5-3.428V6a1.5 1.5 0 0 0-1.5-1.5H10V3.129a.25.25 0 0 0-.427-.177L7.702 4.823a.25.25 0 0 0 0 .354l1.871 1.871A.25.25 0 0 0 10 6.871Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5b656c3dada47b91 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedRepoIcon", "octicon octicon-feed-repo", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM5.5 4A1.5 1.5 0 0 0 4 5.5v5c0 .828.5 1.5 1 1.5v-1a1 1 0 0 1 1-1h5v1h-1v1h1.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Zm.5 7.25v2.514a.25.25 0 0 0 .426.178l.898-.888a.25.25 0 0 1 .352 0l.898.888A.25.25 0 0 0 9 13.764V11H6.25a.25.25 0 0 0-.25.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2a390681c250bed1 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedRocketIcon", "octicon octicon-feed-rocket", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.031-12a4.38 4.38 0 0 0-3.097 1.283l-.23.229c-.156.157-.308.32-.452.49H5.65a.876.876 0 0 0-.746.417l-.856 1.388a.377.377 0 0 0 .21.556l1.552.477 1.35 1.35.478 1.553a.374.374 0 0 0 .555.21l1.389-.855a.876.876 0 0 0 .416-.746V8.747c.17-.144.333-.295.49-.452l.23-.23A4.379 4.379 0 0 0 12 4.969v-.093A.876.876 0 0 0 11.124 4Zm-5.107 7.144h-.001a.809.809 0 0 0-1.33-.881c-.395.394-.564 1.258-.62 1.62a.12.12 0 0 0 .035.108.12.12 0 0 0 .108.035c.362-.056 1.226-.225 1.62-.619a.803.803 0 0 0 .188-.263Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$49060c19a6a6c823 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedStarIcon", "octicon octicon-feed-star", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm.252-12.932a.476.476 0 0 0-.682.195l-1.2 2.432-2.684.39a.477.477 0 0 0-.266.816l1.944 1.892-.46 2.674a.479.479 0 0 0 .694.504L8 10.709l2.4 1.261a.478.478 0 0 0 .694-.504l-.458-2.673L12.578 6.9a.479.479 0 0 0-.265-.815l-2.685-.39-1.2-2.432a.473.473 0 0 0-.176-.195Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9092ea4ea0ee0792 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedTagIcon", "octicon octicon-feed-tag", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.22 6.5a.72.72 0 1 1-1.44 0 .72.72 0 0 1 1.44 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM4 5v3.38c.001.397.159.778.44 1.059l3.211 3.213a1.202 1.202 0 0 0 1.698 0l3.303-3.303a1.202 1.202 0 0 0 0-1.698L9.439 4.44A1.5 1.5 0 0 0 8.379 4H5a1 1 0 0 0-1 1Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$e468f280fa64cb4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FeedTrophyIcon", "octicon octicon-feed-trophy", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11 5h1v1.146a1 1 0 0 1-.629.928L11 7.223V5ZM5 7.223l-.371-.149A1 1 0 0 1 4 6.146V5h1v2.223Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM3 5v1.146a2 2 0 0 0 1.257 1.858l.865.346a3.005 3.005 0 0 0 2.294 2.093C7.22 11.404 6.658 12 5.502 12H5.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1c-1.158 0-1.72-.595-1.916-1.557a3.005 3.005 0 0 0 2.294-2.094l.865-.346A2 2 0 0 0 13 6.146V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$8c1a3d13e85d78b7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileIcon", "octicon octicon-file", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 9 4.25V1.5Zm6.75.062V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4Zm10 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$360ea1c46a04f469 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileAddedIcon", "octicon octicon-file-added", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Zm4.48 3.758a.75.75 0 0 1 .755.745l.01 1.497h1.497a.75.75 0 0 1 0 1.5H9v1.507a.75.75 0 0 1-1.5 0V9.005l-1.502.01a.75.75 0 0 1-.01-1.5l1.507-.01-.01-1.492a.75.75 0 0 1 .745-.755Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$7845cd2940948f71 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileBadgeIcon", "octicon octicon-file-badge", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 1.5a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 1 13.25V1.75C1 .784 1.784 0 2.75 0h8a1.75 1.75 0 0 1 1.508.862.75.75 0 1 1-1.289.768.25.25 0 0 0-.219-.13h-8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 7a3.999 3.999 0 0 1 7.605-1.733 4 4 0 0 1-1.115 4.863l.995 4.973a.75.75 0 0 1-.991.852l-2.409-.876a.248.248 0 0 0-.17 0l-2.409.876a.75.75 0 0 1-.991-.852l.994-4.973A3.994 3.994 0 0 1 8 7Zm4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 6.5c-.373 0-.745-.051-1.104-.154l-.649 3.243 1.155-.42c.386-.14.81-.14 1.196 0l1.155.42-.649-3.243A4.004 4.004 0 0 1 12 11Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 2.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h6a.75.75 0 0 1 0 1.5H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10.982a2 2 0 0 1 1.414.586l.064.064.01.008.31.312a.75.75 0 0 1-1.06 1.06l-.078-.078-.004-.003-.093-.093c-.003-.003 0 0 0 0l-.21-.21a.5.5 0 0 0-.353-.146H4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18 6.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5Zm-5.75 4.25a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m21.283 14.866 1.455 8a.75.75 0 0 1-1.002.836l-3.296-1.24a1.25 1.25 0 0 0-.88 0l-3.296 1.24a.75.75 0 0 1-1.002-.836l1.455-8 1.475.268-1.217 6.698 2.056-.774a2.75 2.75 0 0 1 1.938 0l2.056.774-1.217-6.698 1.475-.268Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$99582237f60eb92e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileBinaryIcon", "octicon octicon-file-binary", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 1.75C4 .784 4.784 0 5.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 14.25 15h-9a.75.75 0 0 1 0-1.5h9a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 10 4.25V1.5H5.75a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0Zm-4 6C0 6.784.784 6 1.75 6h1.5C4.216 6 5 6.784 5 7.75v2.5A1.75 1.75 0 0 1 3.25 12h-1.5A1.75 1.75 0 0 1 0 10.25ZM6.75 6h1.5a.75.75 0 0 1 .75.75v3.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-3h-.75a.75.75 0 0 1 0-1.5Zm-5 1.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm9.75-5.938V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm12-.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 13.75C0 12.784.784 12 1.75 12h3c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75h-3A1.75 1.75 0 0 1 0 17.75Zm1.75-.25a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM9 12a.75.75 0 0 0 0 1.5h1.5V18H9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H12v-5.25a.75.75 0 0 0-.75-.75H9Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$64e5fb7fd8cdad3a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileCheckIcon", "octicon octicon-file-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.336 0c.464 0 .91.184 1.237.513l2.914 2.914c.33.328.513.773.513 1.237v3.587c0 .199-.079.39-.22.53a.747.747 0 0 1-1.06 0 .747.747 0 0 1-.22-.53V6h-2.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 9 4.25V1.5H3.75a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25H7c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06A.747.747 0 0 1 7 16H3.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 2 14.25V1.75C2 .784 2.784 0 3.75 0Zm.164 4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.259 10a.754.754 0 0 1 .686.472.746.746 0 0 1-.171.815l-4.557 4.45a.752.752 0 0 1-1.055-.01L8.22 13.778a.754.754 0 0 1 .04-1.02.748.748 0 0 1 1.02-.038l1.42 1.425 4.025-3.932a.753.753 0 0 1 .534-.213Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.982 1a2.013 2.013 0 0 1 1.415.586l4.017 4.018A2 2 0 0 1 21 7.018V11h-1.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.504.504 0 0 0-.354.146A.504.504 0 0 0 4.5 3v18c0 .133.053.26.146.354A.504.504 0 0 0 5 21.5h5V23H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h9.982ZM15 6.5c0 .133.053.26.146.354A.504.504 0 0 0 15.5 7h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.502.502 0 0 0 15 2.5v4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.25 21.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5h2.25Zm9.47-6.28a.749.749 0 1 1 1.06 1.06l-5.323 5.324a1.01 1.01 0 0 1-.707.292.991.991 0 0 1-.707-.292L12.72 19.28a.749.749 0 1 1 1.06-1.06l1.97 1.969 4.97-4.969Zm-1.22-2.97V10a.75.75 0 0 1 1.5 0v2.25a.75.75 0 0 1-1.5 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$d587cff9ccb0570b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileCodeIcon", "octicon octicon-file-code", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 1.75C4 .784 4.784 0 5.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 14.25 15h-9a.75.75 0 0 1 0-1.5h9a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 10 4.25V1.5H5.75a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Zm1.72 4.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.47-1.47-1.47-1.47a.75.75 0 0 1 0-1.06ZM3.28 7.78 1.81 9.25l1.47 1.47a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-2-2a.75.75 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Zm8.22-6.218V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm12-.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.53 12.24a.75.75 0 0 1-.039 1.06l-2.639 2.45 2.64 2.45a.75.75 0 1 1-1.022 1.1l-3.23-3a.75.75 0 0 1 0-1.1l3.23-3a.75.75 0 0 1 1.06.04Zm3.979 1.06a.75.75 0 1 1 1.02-1.1l3.231 3a.75.75 0 0 1 0 1.1l-3.23 3a.75.75 0 1 1-1.021-1.1l2.639-2.45-2.64-2.45Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$75ea36f6e1616f37 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileDiffIcon", "octicon octicon-file-diff", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 1.75C1 .784 1.784 0 2.75 0h7.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073ZM8 3.25a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0V7h-1.5a.75.75 0 0 1 0-1.5h1.5V4A.75.75 0 0 1 8 3.25Zm-3 8a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.5 6.75a.75.75 0 0 0-1.5 0V9H8.75a.75.75 0 0 0 0 1.5H11v2.25a.75.75 0 0 0 1.5 0V10.5h2.25a.75.75 0 0 0 0-1.5H12.5V6.75ZM8.75 16a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 1h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Zm-.5 2v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5a.5.5 0 0 0-.5.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$3f512b4e06c5cf93 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileDirectoryIcon", "octicon octicon-file-directory", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1H5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H7.5c-.55 0-1.07-.26-1.4-.7l-.9-1.2a.25.25 0 0 0-.2-.1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063c.046.069.124.11.207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V7.687a.25.25 0 0 0-.25-.25h-8.471a1.75 1.75 0 0 1-1.447-.765L8.928 4.61a.252.252 0 0 0-.208-.11Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$335a75d3502de44e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileDirectoryFillIcon", "octicon octicon-file-directory-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 1A1.75 1.75 0 0 0 0 2.75v10.5C0 14.216.784 15 1.75 15h12.5A1.75 1.75 0 0 0 16 13.25v-8.5A1.75 1.75 0 0 0 14.25 3H7.5a.25.25 0 0 1-.2-.1l-.9-1.2C6.07 1.26 5.55 1 5 1H1.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063c.046.069.124.11.207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1b267c5cc56290c5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileDirectoryOpenFillIcon", "octicon octicon-file-directory-open-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.513 1.513A1.75 1.75 0 0 1 1.75 1h3.5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1H13a1 1 0 0 1 1 1v.5H2.75a.75.75 0 0 0 0 1.5h11.978a1 1 0 0 1 .994 1.117L15 13.25A1.75 1.75 0 0 1 13.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75c0-.464.184-.91.513-1.237Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.971c.58 0 1.12.286 1.447.765l1.404 2.063a.25.25 0 0 0 .207.11h6.224c.966 0 1.75.783 1.75 1.75v.117H5.408a.848.848 0 0 0 0 1.695h15.484a1 1 0 0 1 .995 1.102L21 19.25c-.106 1.05-.784 1.75-1.75 1.75H3.75A1.75 1.75 0 0 1 2 19.25V4.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$582dd6b04cb9cbb0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileDirectorySymlinkIcon", "octicon octicon-file-directory-symlink", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1H5a1.75 1.75 0 0 1 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H5.375a.75.75 0 0 1 0-1.5h8.875a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H7.5a1.75 1.75 0 0 1-1.4-.7l-.9-1.2a.25.25 0 0 0-.2-.1H1.75a.25.25 0 0 0-.25.25v3a.75.75 0 0 1-1.5 0v-3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 12.237a2.25 2.25 0 0 1 2.262-2.249L4 9.989v1.938c0 .218.26.331.42.183l2.883-2.677a.25.25 0 0 0 0-.366L4.42 6.39a.25.25 0 0 0-.42.183v1.916l-.229-.001A3.75 3.75 0 0 0 0 12.237v1.013a.75.75 0 0 0 1.5 0v-1.013Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.971a1.75 1.75 0 0 1 1.447.765l1.404 2.063a.25.25 0 0 0 .207.11h8.471c.966 0 1.75.783 1.75 1.75V19.25A1.75 1.75 0 0 1 20.25 21H4.75a.75.75 0 0 1 0-1.5h15.5a.25.25 0 0 0 .25-.25V7.688a.25.25 0 0 0-.25-.25h-8.471a1.751 1.751 0 0 1-1.447-.766L8.928 4.609a.252.252 0 0 0-.207-.109H3.75a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m9.308 12.5-2.104-2.236a.75.75 0 1 1 1.092-1.028l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.75.75 0 1 1-1.092-1.028L9.308 14H4.09a2.59 2.59 0 0 0-2.59 2.59v3.16a.75.75 0 0 1-1.5 0v-3.16a4.09 4.09 0 0 1 4.09-4.09h5.218Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$45e0c3b06609db08 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileMediaIcon", "octicon octicon-file-media", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 13.25A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75ZM1.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h.94l.03-.03 6.077-6.078a1.75 1.75 0 0 1 2.412-.06L14.5 10.31V2.75a.25.25 0 0 0-.25-.25Zm12.5 11a.25.25 0 0 0 .25-.25v-.917l-4.298-3.889a.25.25 0 0 0-.344.009L4.81 13.5ZM7 6a2 2 0 1 1-3.999.001A2 2 0 0 1 7 6ZM5.5 6a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.75 21.5H2.25A1.75 1.75 0 0 1 .5 19.75V4.25c0-.966.784-1.75 1.75-1.75h19.5c.966 0 1.75.784 1.75 1.75v15.5a1.75 1.75 0 0 1-1.75 1.75ZM2.25 4a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h3.178L14 10.977a1.749 1.749 0 0 1 2.506-.032L22 16.44V4.25a.25.25 0 0 0-.25-.25ZM22 19.75v-1.19l-6.555-6.554a.248.248 0 0 0-.18-.073.247.247 0 0 0-.178.077L7.497 20H21.75a.25.25 0 0 0 .25-.25ZM10.5 9.25a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Zm-1.5 0a1.75 1.75 0 1 0-3.501.001A1.75 1.75 0 0 0 9 9.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7a31aa78af90c07 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileMovedIcon", "octicon octicon-file-moved", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073H3.75a.25.25 0 0 0-.25.25v6.5a.75.75 0 0 1-1.5 0v-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m5.427 15.573 3.146-3.146a.25.25 0 0 0 0-.354L5.427 8.927A.25.25 0 0 0 5 9.104V11.5H.75a.75.75 0 0 0 0 1.5H5v2.396c0 .223.27.335.427.177Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0V3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.21 14.25H1.75a.75.75 0 0 0 0 1.5h5.46s-.008 2.249 0 3.256a.75.75 0 0 0 1.262.542l4.285-4a.75.75 0 0 0 0-1.096l-4.285-4A.75.75 0 0 0 7.21 11v3.249Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$ac6910029b660cbb = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileRemovedIcon", "octicon octicon-file-removed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177l-2.914-2.914a.25.25 0 0 0-.177-.073Zm4.5 6h2.242a.75.75 0 0 1 0 1.5h-2.24l-2.254.015a.75.75 0 0 1-.01-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 12c0-.414.358-.75.8-.75h6.4c.442 0 .8.336.8.75s-.358.75-.8.75H8.8c-.442 0-.8-.336-.8-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$dd207c2d9efbb369 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileSubmoduleIcon", "octicon octicon-file-submodule", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1H5c.55 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm9.42 9.36 2.883-2.677a.25.25 0 0 0 0-.366L9.42 6.39a.249.249 0 0 0-.42.183V8.5H4.75a.75.75 0 0 0 0 1.5H9v1.927c0 .218.26.331.42.183Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 4.75C2 3.784 2.784 3 3.75 3h4.965a1.75 1.75 0 0 1 1.456.78l1.406 2.109a.25.25 0 0 0 .208.111h8.465c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25Zm12.78 4.97a.749.749 0 0 0-1.275.326.749.749 0 0 0 .215.734l1.72 1.72H6.75a.75.75 0 0 0 0 1.5h8.69l-1.72 1.72a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215l3-3a.75.75 0 0 0 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9f1ab1c55b1a75c2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileSymlinkFileIcon", "octicon octicon-file-symlink-file", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 1.75C2 .784 2.784 0 3.75 0h5.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 12.25 15h-7a.75.75 0 0 1 0-1.5h7a.25.25 0 0 0 .25-.25V6H9.75A1.75 1.75 0 0 1 8 4.25V1.5H3.75a.25.25 0 0 0-.25.25V4.5a.75.75 0 0 1-1.5 0Zm-.5 10.487v1.013a.75.75 0 0 1-1.5 0v-1.012a3.748 3.748 0 0 1 3.77-3.749L4 8.49V6.573a.25.25 0 0 1 .42-.183l2.883 2.678a.25.25 0 0 1 0 .366L4.42 12.111a.25.25 0 0 1-.42-.183V9.99l-.238-.003a2.25 2.25 0 0 0-2.262 2.25Zm8-10.675V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H4.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5a.5.5 0 0 0-.5.5v6.25a.75.75 0 0 1-1.5 0Zm6.308 11.5-2.104-2.236a.751.751 0 0 1 .369-1.255.749.749 0 0 1 .723.227l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.749.749 0 0 1-1.275-.293.751.751 0 0 1 .183-.735L9.308 16H4.09a2.59 2.59 0 0 0-2.59 2.59v3.16a.75.75 0 0 1-1.5 0v-3.16a4.09 4.09 0 0 1 4.09-4.09ZM15 2.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4b5c933f073b4437 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FileZipIcon", "octicon octicon-file-zip", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.5 1.75v11.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 2 13.25V1.75C2 .784 2.784 0 3.75 0h5.586c.464 0 .909.185 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v8.586A1.75 1.75 0 0 1 12.25 15h-.5a.75.75 0 0 1 0-1.5h.5a.25.25 0 0 0 .25-.25V4.664a.25.25 0 0 0-.073-.177L9.513 1.573a.25.25 0 0 0-.177-.073H7.25a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5h-3a.25.25 0 0 0-.25.25Zm3.75 8.75h.5c.966 0 1.75.784 1.75 1.75v3a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-3c0-.966.784-1.75 1.75-1.75ZM6 5.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 5.25Zm.75 2.25h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM8 6.75A.75.75 0 0 1 8.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 8 6.75ZM8.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM8 9.75A.75.75 0 0 1 8.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 8 9.75Zm-1 2.5v2.25h1v-2.25a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 2.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h1.75a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2h-2.75a.75.75 0 0 1 0-1.5H19a.5.5 0 0 0 .5-.5V7.018a.5.5 0 0 0-.146-.354l-4.018-4.018a.5.5 0 0 0-.354-.146H5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.5 15.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm-.75-2.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM12.25 6a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm-.75-2.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM9.75 13.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM9 11.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM9 5.25a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 9 5.25ZM11 17h1a2 2 0 0 1 2 2v4.25a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V19a2 2 0 0 1 2-2Zm-.5 2v3.5h2V19a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$28f6150e232898de = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FilterIcon", "octicon octicon-filter", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.75 3h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 6a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75ZM6 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$74ad349cc2aa8f35 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FilterRemoveIcon", "octicon octicon-filter-remove", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.384 4.57a.752.752 0 0 0 1.061 0 .752.752 0 0 0 0-1.061l-.884-.884.883-.884A.75.75 0 0 0 14.384.68l-.884.884-.884-.884a.75.75 0 0 0-1.06 1.061l.883.884-.883.884a.75.75 0 0 0 1.06 1.061l.884-.884.884.884ZM.75 3a.75.75 0 0 0 0 1.5H9A.75.75 0 0 0 9 3H.75ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.587 9.273a.75.75 0 1 0 1.061-1.061l-1.591-1.591 1.591-1.591a.749.749 0 1 0-1.061-1.06l-1.591 1.591-1.591-1.591a.749.749 0 1 0-1.06 1.06l1.591 1.591-1.591 1.591a.75.75 0 0 0 1.06 1.061l1.591-1.591 1.591 1.591ZM1.75 6a.75.75 0 0 0 0 1.5H14.5a.75.75 0 0 0 0-1.5H1.75ZM5 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$81671b8187e8d7ad = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FiscalHostIcon", "octicon octicon-fiscal-host", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 9.25h-.75a.75.75 0 0 1 0-1.5H4v-1.5h-.75a.75.75 0 0 1 0-1.5H4V3.5a1 1 0 0 1 1-1h7.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1ZM5.5 4v.793a.75.75 0 0 1 0 1.414v1.586a.75.75 0 0 1 0 1.414V10H12V4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.75 14.25V14h-9.5v.25a.75.75 0 0 1-1.5 0V14A1.75 1.75 0 0 1 0 12.25V1.75C0 .784.784 0 1.75 0h12.5C15.217 0 16 .784 16 1.75v10.5A1.75 1.75 0 0 1 14.25 14v.25a.75.75 0 0 1-1.5 0ZM1.75 1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 20.25 20H19v.25a1 1 0 1 1-2 0V20H6.997v.25a1 1 0 1 1-2 0V20H3.75A1.75 1.75 0 0 1 2 18.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75ZM14.318 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8.5A.75.75 0 1 0 6 10h1.5v2H6a.75.75 0 0 0 0 1.5h1.5V15A1.5 1.5 0 0 0 9 16.5h8a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 17 5.5H9A1.5 1.5 0 0 0 7.5 7v1.5H6ZM9 10a.75.75 0 0 0 0-1.5V7h8v8H9v-1.5A.75.75 0 0 0 9 12v-2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4fd8d63cb0915eb0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FlagIcon", "octicon octicon-flag", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 10.2108V2.22083C15 2.14083 14.98 2.07083 14.95 1.99083C14.95 1.97083 14.95 1.95083 14.94 1.93083C14.92 1.88083 14.88 1.84083 14.85 1.80083C14.82 1.76083 14.81 1.72083 14.78 1.69083C14.76 1.67083 14.74 1.67083 14.72 1.65083C14.66 1.60083 14.6 1.56083 14.53 1.53083C11.75 0.420826 9.67 1.28083 7.84 2.03083C6.11 2.75083 4.6 3.36083 2.5 2.60083V1.97083C2.5 1.56083 2.16 1.22083 1.75 1.22083C1.34 1.22083 1 1.56083 1 1.97083V14.4708C1 14.8808 1.34 15.2208 1.75 15.2208C2.16 15.2208 2.5 14.8808 2.5 14.4708V4.18083C3.16 4.37083 3.78 4.45083 4.37 4.45083C5.91 4.45083 7.22 3.91083 8.42 3.41083C10.08 2.72083 11.54 2.14083 13.51 2.76083V9.19083C11.23 8.63083 9.45 9.36083 7.85 10.0308C6.6 10.5508 5.44 11.0308 4.06 10.9508C3.68 10.9208 3.29 11.2408 3.26 11.6508C3.23 12.0608 3.55 12.4208 3.96 12.4508C4.1 12.4508 4.25 12.4608 4.38 12.4608C5.9 12.4608 7.18 11.9308 8.42 11.4208C10.21 10.6808 11.76 10.0408 13.98 10.9208C14.04 10.9408 14.1 10.9508 14.17 10.9508C14.2 10.9508 14.23 10.9708 14.26 10.9708C14.49 10.9708 14.71 10.8508 14.85 10.6608C14.89 10.6108 14.93 10.5708 14.95 10.5108C14.97 10.4608 14.97 10.4108 14.98 10.3608C14.98 10.3208 15.01 10.2808 15.01 10.2308L15 10.2108Z",
                fill: "currentColor"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.99 14.37V4.92C19.99 4.84 19.97 4.77 19.94 4.69C19.94 4.67 19.94 4.65 19.93 4.63C19.91 4.58 19.88 4.55 19.85 4.51C19.82 4.47 19.8 4.43 19.77 4.4C19.76 4.39 19.73 4.38 19.72 4.37C19.66 4.32 19.6 4.27 19.53 4.24C16.3 2.95 13.8 3.9 11.38 4.83C9.18 5.67 7.1 6.45 4.5 5.48V3.75C4.5 3.34 4.16 3 3.75 3C3.34 3 3 3.34 3 3.75V20.31C3 20.72 3.34 21.06 3.75 21.06C4.16 21.06 4.5 20.72 4.5 20.31V7.06C5.35 7.32 6.15 7.43 6.91 7.43C8.73 7.43 10.34 6.82 11.91 6.22C14.02 5.41 16.03 4.67 18.49 5.47V13.36C15.7 12.62 13.34 13.5 11.24 14.29C9.62 14.9 8.1 15.47 6.45 15.37C6.07 15.35 5.68 15.66 5.65 16.07C5.62 16.48 5.94 16.84 6.35 16.87C6.52 16.88 6.68 16.89 6.84 16.89C8.61 16.89 10.21 16.28 11.76 15.7C14.07 14.83 16.25 14 18.96 15.09C19.02 15.11 19.08 15.11 19.14 15.12C19.17 15.12 19.21 15.14 19.24 15.14C19.33 15.14 19.42 15.12 19.5 15.09C19.5 15.09 19.52 15.09 19.53 15.09C19.65 15.04 19.74 14.95 19.82 14.85C19.86 14.8 19.9 14.75 19.93 14.68C19.95 14.63 19.95 14.58 19.96 14.53C19.96 14.49 19.99 14.45 19.99 14.4V14.37Z",
                fill: "currentColor"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c1eff5f0d5951e22 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FlameIcon", "octicon octicon-flame", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.533.753V.752c.217 2.385 1.463 3.626 2.653 4.81C13.37 6.74 14.498 7.863 14.498 10c0 3.5-3 6-6.5 6S1.5 13.512 1.5 10c0-1.298.536-2.56 1.425-3.286.376-.308.862 0 1.035.454C4.46 8.487 5.581 8.419 6 8c.282-.282.341-.811-.003-1.5C4.34 3.187 7.035.75 8.77.146c.39-.137.726.194.763.607ZM7.998 14.5c2.832 0 5-1.98 5-4.5 0-1.463-.68-2.19-1.879-3.383l-.036-.037c-1.013-1.008-2.3-2.29-2.834-4.434-.322.256-.63.579-.864.953-.432.696-.621 1.58-.046 2.73.473.947.67 2.284-.278 3.232-.61.61-1.545.84-2.403.633a2.79 2.79 0 0 1-1.436-.874A3.198 3.198 0 0 0 3 10c0 2.53 2.164 4.5 4.998 4.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.265 1.627c0 3.545 1.869 5.327 3.479 7.021 1.54 1.62 3.006 3.163 3.006 6.102 0 4.812-3.753 8.25-8.565 8.25-4.813 0-8.935-3.421-8.935-8.25 0-2.039.962-4.011 2.509-4.899.305-.175.672.007.803.334C7.563 12.684 8.797 12.64 9.437 12c.388-.387.47-1.116-.004-2.062-2.405-4.812 1.863-8.279 4.2-8.854.336-.082.615.198.632.543ZM12.185 21.5c4.059 0 7.065-2.84 7.065-6.75 0-2.337-1.093-3.489-2.678-5.158l-.021-.023c-1.44-1.517-3.139-3.351-3.649-6.557a6.148 6.148 0 0 0-1.911 1.76c-.787 1.144-1.147 2.633-.216 4.495.603 1.205.777 2.74-.277 3.794-.657.657-1.762 1.1-2.956.586-.752-.324-1.353-.955-1.838-1.79-.567.706-.954 1.74-.954 2.893 0 3.847 3.288 6.75 7.435 6.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8620fe488949c4e3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FlowchartIcon", "octicon octicon-flowchart", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.25 5c.199 0 .39-.079.53-.22a.747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22V5Zm-2-1.5a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06c.14.141.331.22.53.22V3.5Zm7 8.75.53.53c.3-.3.3-.77 0-1.06l-.53.53Zm-1.47-2.53a.748.748 0 0 0-1.244.23.76.76 0 0 0 .184.83l.53-.53.53-.53Zm-1.06 4a.748.748 0 0 0 .23 1.244.76.76 0 0 0 .83-.184l-.53-.53-.53-.53Zm1.53-.72c.199 0 .39-.079.53-.22a.747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22V13Zm-6-1.5a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06c.14.141.331.22.53.22v-1.5Zm3.53-4.72.53-.53-1.06-1.06-.53.53.53.53.53.53ZM5.72 9.72l-.53.53 1.06 1.06.53-.53-.53-.53-.53-.53Zm3.53-5.47V3.5h-2V5h2v-.75Zm5 8 .53-.53-2-2-.53.53-.53.53 2 2 .53-.53Zm0 0-.53-.53-2 2 .53.53.53.53 2-2-.53-.53Zm-1 0v-.75h-6V13h6v-.75Zm-3-6-.53-.53-4 4 .53.53.53.53 4-4-.53-.53ZM3.25 2v.75h2v-1.5h-2V2Zm2 0v.75c.28 0 .5.22.5.5h1.5a2 2 0 0 0-2-2V2ZM6.5 3.25h-.75v2h1.5v-2H6.5Zm0 2h-.75c0 .133-.053.26-.146.354a.504.504 0 0 1-.354.146v1.5a2 2 0 0 0 2-2H6.5ZM5.25 6.5v-.75h-2v1.5h2V6.5Zm-2 0v-.75a.504.504 0 0 1-.354-.146.504.504 0 0 1-.146-.354h-1.5c0 1.1.9 2 2 2V6.5ZM2 5.25h.75v-2h-1.5v2H2Zm0-2h.75c0-.28.22-.5.5-.5v-1.5a2 2 0 0 0-2 2H2ZM11.25 2v.75h2v-1.5h-2V2Zm2 0v.75c.28 0 .5.22.5.5h1.5a2 2 0 0 0-2-2V2Zm1.25 1.25h-.75v2h1.5v-2h-.75Zm0 2h-.75c0 .133-.053.26-.146.354a.504.504 0 0 1-.354.146v1.5a2 2 0 0 0 2-2h-.75ZM13.25 6.5v-.75h-2v1.5h2V6.5Zm-2 0v-.75a.504.504 0 0 1-.354-.146.504.504 0 0 1-.146-.354h-1.5c0 1.1.9 2 2 2V6.5ZM10 5.25h.75v-2h-1.5v2H10Zm0-2h.75c0-.28.22-.5.5-.5v-1.5a2 2 0 0 0-2 2H10ZM3.25 10v.75h2v-1.5h-2V10Zm2 0v.75c.28 0 .5.22.5.5h1.5a2 2 0 0 0-2-2V10Zm1.25 1.25h-.75v2h1.5v-2H6.5Zm0 2h-.75c0 .133-.053.26-.146.354a.504.504 0 0 1-.354.146v1.5a2 2 0 0 0 2-2H6.5ZM5.25 14.5v-.75h-2v1.5h2v-.75Zm-2 0v-.75a.504.504 0 0 1-.354-.146.504.504 0 0 1-.146-.354h-1.5c0 1.1.9 2 2 2v-.75ZM2 13.25h.75v-2h-1.5v2H2Zm0-2h.75c0-.28.22-.5.5-.5v-1.5a2 2 0 0 0-2 2H2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 2a3 3 0 0 1 3 3v.75h2V5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-2.846 2.996L19 11h-3l-.154-.004a2.988 2.988 0 0 1-1.369-.413l-3.895 3.896c.264.446.418.965.418 1.521v.75h8.689l-2.219-2.22a.749.749 0 1 1 1.06-1.06l3.5 3.5a.749.749 0 0 1 0 1.06l-3.5 3.5a.749.749 0 1 1-1.06-1.06l2.219-2.22H11V19a3 3 0 0 1-2.846 2.996L8 22H5l-.154-.004a3.001 3.001 0 0 1-2.842-2.842L2 19v-3a3 3 0 0 1 3-3h3c.556 0 1.075.153 1.521.417l3.895-3.895a2.975 2.975 0 0 1-.412-1.368L13 8v-.75h-2V8a3 3 0 0 1-2.846 2.996L8 11H5l-.154-.004a3.001 3.001 0 0 1-2.842-2.842L2 8V5a3 3 0 0 1 3-3h3ZM5 14.5A1.5 1.5 0 0 0 3.5 16v3A1.5 1.5 0 0 0 5 20.5h3A1.5 1.5 0 0 0 9.5 19v-3A1.5 1.5 0 0 0 8 14.5H5Zm0-11A1.5 1.5 0 0 0 3.5 5v3A1.5 1.5 0 0 0 5 9.5h3A1.5 1.5 0 0 0 9.5 8V5A1.5 1.5 0 0 0 8 3.5H5Zm11 0A1.5 1.5 0 0 0 14.5 5v3A1.5 1.5 0 0 0 16 9.5h3A1.5 1.5 0 0 0 20.5 8V5A1.5 1.5 0 0 0 19 3.5h-3Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$997165af4676f911 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FocusCenterIcon", "octicon octicon-focus-center", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0v-2.5C1 1.784 1.784 1 2.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5ZM10 1.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75ZM1.75 10a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 1 13.25v-2.5a.75.75 0 0 1 .75-.75Zm12.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 13.25 15h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 .75-.75ZM8 10a2 2 0 1 0 .001-3.999A2 2 0 0 0 8 10Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 10a2 2 0 1 0 .001-3.999A2 2 0 0 0 8 10Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 15.25a.75.75 0 0 1 .75.75v4.25c0 .138.112.25.25.25H8A.75.75 0 0 1 8 22H3.75A1.75 1.75 0 0 1 2 20.25V16a.75.75 0 0 1 .75-.75Zm18.5 0A.75.75 0 0 1 22 16v4.25A1.75 1.75 0 0 1 20.25 22H16a.75.75 0 0 1 0-1.5h4.25a.25.25 0 0 0 .25-.25V16a.75.75 0 0 1 .75-.75ZM8 2a.75.75 0 0 1 0 1.5H3.75a.25.25 0 0 0-.25.25V8A.75.75 0 0 1 2 8V3.75C2 2.784 2.784 2 3.75 2H8Zm12.25 0c.966 0 1.75.784 1.75 1.75V8a.75.75 0 0 1-1.5 0V3.75a.25.25 0 0 0-.25-.25H16A.75.75 0 0 1 16 2h4.25ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$567273102fa6ef96 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FoldIcon", "octicon octicon-fold", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.896 2H8.75V.75a.75.75 0 0 0-1.5 0V2H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 2ZM8.75 15.25a.75.75 0 0 1-1.5 0V14H5.104a.25.25 0 0 1-.177-.427l2.896-2.896a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25Zm-6.5-6.5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 15c.199 0 .389.079.53.22l3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 16.81l-2.72 2.72a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25A.749.749 0 0 1 12 15Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.53 8.78a.75.75 0 0 1-1.06 0L8.22 5.53a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L12 7.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734ZM12 15.75a.75.75 0 0 1 .75.75v5.75a.75.75 0 0 1-1.5 0V16.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 8.5a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$acafa89e81b6b94a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FoldDownIcon", "octicon octicon-fold-down", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.177 14.323 2.896-2.896a.25.25 0 0 0-.177-.427H8.75V7.764a.75.75 0 1 0-1.5 0V11H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0ZM2.25 5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 4.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5a.75.75 0 0 1 .75.75ZM8.25 5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 4.25a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5a.75.75 0 0 1 .75.75Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 19a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 17.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 19Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 18a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 18ZM2.75 6a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 2.75 6Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6.75 6Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$7d2a0ecee4bb68a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("FoldUpIcon", "octicon octicon-fold-up", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.823 1.677 4.927 4.573A.25.25 0 0 0 5.104 5H7.25v3.236a.75.75 0 1 0 1.5 0V5h2.146a.25.25 0 0 0 .177-.427L8.177 1.677a.25.25 0 0 0-.354 0ZM13.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-3.75.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM7.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM4 11.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM1.75 11a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.47 5.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 6.81 9.28 9.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 5.5a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8A.75.75 0 0 1 12 5.5ZM2.75 18a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$70208e77f6c45b17 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GearIcon", "octicon octicon-gear", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8.2 8.2 0 0 1 .701.031C9.444.095 9.99.645 10.16 1.29l.288 1.107c.018.066.079.158.212.224.231.114.454.243.668.386.123.082.233.09.299.071l1.103-.303c.644-.176 1.392.021 1.82.63.27.385.506.792.704 1.218.315.675.111 1.422-.364 1.891l-.814.806c-.049.048-.098.147-.088.294.016.257.016.515 0 .772-.01.147.038.246.088.294l.814.806c.475.469.679 1.216.364 1.891a7.977 7.977 0 0 1-.704 1.217c-.428.61-1.176.807-1.82.63l-1.102-.302c-.067-.019-.177-.011-.3.071a5.909 5.909 0 0 1-.668.386c-.133.066-.194.158-.211.224l-.29 1.106c-.168.646-.715 1.196-1.458 1.26a8.006 8.006 0 0 1-1.402 0c-.743-.064-1.289-.614-1.458-1.26l-.289-1.106c-.018-.066-.079-.158-.212-.224a5.738 5.738 0 0 1-.668-.386c-.123-.082-.233-.09-.299-.071l-1.103.303c-.644.176-1.392-.021-1.82-.63a8.12 8.12 0 0 1-.704-1.218c-.315-.675-.111-1.422.363-1.891l.815-.806c.05-.048.098-.147.088-.294a6.214 6.214 0 0 1 0-.772c.01-.147-.038-.246-.088-.294l-.815-.806C.635 6.045.431 5.298.746 4.623a7.92 7.92 0 0 1 .704-1.217c.428-.61 1.176-.807 1.82-.63l1.102.302c.067.019.177.011.3-.071.214-.143.437-.272.668-.386.133-.066.194-.158.211-.224l.29-1.106C6.009.645 6.556.095 7.299.03 7.53.01 7.764 0 8 0Zm-.571 1.525c-.036.003-.108.036-.137.146l-.289 1.105c-.147.561-.549.967-.998 1.189-.173.086-.34.183-.5.29-.417.278-.97.423-1.529.27l-1.103-.303c-.109-.03-.175.016-.195.045-.22.312-.412.644-.573.99-.014.031-.021.11.059.19l.815.806c.411.406.562.957.53 1.456a4.709 4.709 0 0 0 0 .582c.032.499-.119 1.05-.53 1.456l-.815.806c-.081.08-.073.159-.059.19.162.346.353.677.573.989.02.03.085.076.195.046l1.102-.303c.56-.153 1.113-.008 1.53.27.161.107.328.204.501.29.447.222.85.629.997 1.189l.289 1.105c.029.109.101.143.137.146a6.6 6.6 0 0 0 1.142 0c.036-.003.108-.036.137-.146l.289-1.105c.147-.561.549-.967.998-1.189.173-.086.34-.183.5-.29.417-.278.97-.423 1.529-.27l1.103.303c.109.029.175-.016.195-.045.22-.313.411-.644.573-.99.014-.031.021-.11-.059-.19l-.815-.806c-.411-.406-.562-.957-.53-1.456a4.709 4.709 0 0 0 0-.582c-.032-.499.119-1.05.53-1.456l.815-.806c.081-.08.073-.159.059-.19a6.464 6.464 0 0 0-.573-.989c-.02-.03-.085-.076-.195-.046l-1.102.303c-.56.153-1.113.008-1.53-.27a4.44 4.44 0 0 0-.501-.29c-.447-.222-.85-.629-.997-1.189l-.289-1.105c-.029-.11-.101-.143-.137-.146a6.6 6.6 0 0 0-1.142 0ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c.266 0 .532.009.797.028.763.055 1.345.617 1.512 1.304l.352 1.45c.019.078.09.171.225.221.247.089.49.19.728.302.13.061.246.044.315.002l1.275-.776c.603-.368 1.411-.353 1.99.147.402.349.78.726 1.128 1.129.501.578.515 1.386.147 1.99l-.776 1.274c-.042.069-.058.185.002.315.112.238.213.481.303.728.048.135.142.205.22.225l1.45.352c.687.167 1.249.749 1.303 1.512.038.531.038 1.063 0 1.594-.054.763-.616 1.345-1.303 1.512l-1.45.352c-.078.019-.171.09-.221.225-.089.248-.19.491-.302.728-.061.13-.044.246-.002.315l.776 1.275c.368.603.353 1.411-.147 1.99-.349.402-.726.78-1.129 1.128-.578.501-1.386.515-1.99.147l-1.274-.776c-.069-.042-.185-.058-.314.002a8.606 8.606 0 0 1-.729.303c-.135.048-.205.142-.225.22l-.352 1.45c-.167.687-.749 1.249-1.512 1.303-.531.038-1.063.038-1.594 0-.763-.054-1.345-.616-1.512-1.303l-.352-1.45c-.019-.078-.09-.171-.225-.221a8.138 8.138 0 0 1-.728-.302c-.13-.061-.246-.044-.315-.002l-1.275.776c-.603.368-1.411.353-1.99-.147-.402-.349-.78-.726-1.128-1.129-.501-.578-.515-1.386-.147-1.99l.776-1.274c.042-.069.058-.185-.002-.314a8.606 8.606 0 0 1-.303-.729c-.048-.135-.142-.205-.22-.225l-1.45-.352c-.687-.167-1.249-.749-1.304-1.512a11.158 11.158 0 0 1 0-1.594c.055-.763.617-1.345 1.304-1.512l1.45-.352c.078-.019.171-.09.221-.225.089-.248.19-.491.302-.728.061-.13.044-.246.002-.315l-.776-1.275c-.368-.603-.353-1.411.147-1.99.349-.402.726-.78 1.129-1.128.578-.501 1.386-.515 1.99-.147l1.274.776c.069.042.185.058.315-.002.238-.112.481-.213.728-.303.135-.048.205-.142.225-.22l.352-1.45c.167-.687.749-1.249 1.512-1.304C11.466 1.01 11.732 1 12 1Zm-.69 1.525c-.055.004-.135.05-.161.161l-.353 1.45a1.832 1.832 0 0 1-1.172 1.277 7.147 7.147 0 0 0-.6.249 1.833 1.833 0 0 1-1.734-.074l-1.274-.776c-.098-.06-.186-.036-.228 0a9.774 9.774 0 0 0-.976.976c-.036.042-.06.131 0 .228l.776 1.274c.314.529.342 1.18.074 1.734a7.147 7.147 0 0 0-.249.6 1.831 1.831 0 0 1-1.278 1.173l-1.45.351c-.11.027-.156.107-.16.162a9.63 9.63 0 0 0 0 1.38c.004.055.05.135.161.161l1.45.353a1.832 1.832 0 0 1 1.277 1.172c.074.204.157.404.249.6.268.553.24 1.204-.074 1.733l-.776 1.275c-.06.098-.036.186 0 .228.301.348.628.675.976.976.042.036.131.06.228 0l1.274-.776a1.83 1.83 0 0 1 1.734-.075c.196.093.396.176.6.25a1.831 1.831 0 0 1 1.173 1.278l.351 1.45c.027.11.107.156.162.16a9.63 9.63 0 0 0 1.38 0c.055-.004.135-.05.161-.161l.353-1.45a1.834 1.834 0 0 1 1.172-1.278 6.82 6.82 0 0 0 .6-.248 1.831 1.831 0 0 1 1.733.074l1.275.776c.098.06.186.036.228 0 .348-.301.675-.628.976-.976.036-.042.06-.131 0-.228l-.776-1.275a1.834 1.834 0 0 1-.075-1.733c.093-.196.176-.396.25-.6a1.831 1.831 0 0 1 1.278-1.173l1.45-.351c.11-.027.156-.107.16-.162a9.63 9.63 0 0 0 0-1.38c-.004-.055-.05-.135-.161-.161l-1.45-.353c-.626-.152-1.08-.625-1.278-1.172a6.576 6.576 0 0 0-.248-.6 1.833 1.833 0 0 1 .074-1.734l.776-1.274c.06-.098.036-.186 0-.228a9.774 9.774 0 0 0-.976-.976c-.042-.036-.131-.06-.228 0l-1.275.776a1.831 1.831 0 0 1-1.733.074 6.88 6.88 0 0 0-.6-.249 1.835 1.835 0 0 1-1.173-1.278l-.351-1.45c-.027-.11-.107-.156-.162-.16a9.63 9.63 0 0 0-1.38 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$89472f18b6de8cda = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GiftIcon", "octicon octicon-gift", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.75A2.75 2.75 0 0 1 4.75 0c.983 0 1.873.42 2.57 1.232.268.318.497.668.68 1.042.183-.375.411-.725.68-1.044C9.376.42 10.266 0 11.25 0a2.75 2.75 0 0 1 2.45 4h.55c.966 0 1.75.784 1.75 1.75v2c0 .698-.409 1.301-1 1.582v4.918A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V9.332C.409 9.05 0 8.448 0 7.75v-2C0 4.784.784 4 1.75 4h.55c-.192-.375-.3-.8-.3-1.25ZM7.25 9.5H2.5v4.75c0 .138.112.25.25.25h4.5Zm1.5 0v5h4.5a.25.25 0 0 0 .25-.25V9.5Zm0-4V8h5.5a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25Zm-7 0a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h5.5V5.5h-5.5Zm3-4a1.25 1.25 0 0 0 0 2.5h2.309c-.233-.818-.542-1.401-.878-1.793-.43-.502-.915-.707-1.431-.707ZM8.941 4h2.309a1.25 1.25 0 0 0 0-2.5c-.516 0-1 .205-1.43.707-.337.392-.646.975-.879 1.793Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 3.75A3.75 3.75 0 0 1 7.5 0c1.455 0 3.436.901 4.5 3.11C13.064.901 15.044 0 16.5 0a3.75 3.75 0 0 1 3 6h1.75c.966 0 1.75.784 1.75 1.75v2.5c0 .698-.409 1.301-1 1.582v8.418A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-8.418c-.591-.282-1-.884-1-1.582v-2.5C1 6.784 1.784 6 2.75 6H4.5a3.733 3.733 0 0 1-.75-2.25ZM20.5 12h-7.75v8.5h7.5a.25.25 0 0 0 .25-.25Zm-9.25 8.5V12H3.5v8.25c0 .138.112.25.25.25Zm10-10a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-8.5v3Zm-18.5 0h8.5v-3h-8.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25Zm16-6.75A2.25 2.25 0 0 0 16.5 1.5c-1.15 0-3.433 1.007-3.72 4.5h3.72a2.25 2.25 0 0 0 2.25-2.25ZM11.22 6c-.287-3.493-2.57-4.5-3.72-4.5a2.25 2.25 0 1 0 0 4.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c812d10d519e0edb = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitBranchIcon", "octicon octicon-git-branch", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.5 3.25a2.25 2.25 0 1 1 3 2.122V6A2.5 2.5 0 0 1 10 8.5H6a1 1 0 0 0-1 1v1.128a2.251 2.251 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.5 0v1.836A2.493 2.493 0 0 1 6 7h4a1 1 0 0 0 1-1v-.628A2.25 2.25 0 0 1 9.5 3.25Zm-6 0a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm8.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM2.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.5 8.75v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-7a1.75 1.75 0 0 0-1.75 1.75H5A3.25 3.25 0 0 1 8.25 11h7a2.25 2.25 0 0 0 2.25-2.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$39c5fb0a37660ec3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitBranchCheckIcon", "octicon octicon-git-branch-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.26 10a.741.741 0 0 1 .414.133.75.75 0 0 1 .1 1.154l-4.557 4.45a.753.753 0 0 1-1.055-.008l-1.943-1.95a.755.755 0 0 1 .024-1.038.753.753 0 0 1 1.038-.022l1.42 1.427 4.026-3.933A.752.752 0 0 1 15.26 10Zm-3.51-9a2.252 2.252 0 0 1 1.942 3.389 2.252 2.252 0 0 1-1.192.983V6A2.5 2.5 0 0 1 10 8.5H6a.997.997 0 0 0-1 1v1.128a2.256 2.256 0 0 1 1.469 2.503A2.252 2.252 0 1 1 3.5 10.628V5.372a2.255 2.255 0 0 1-1.469-2.503A2.252 2.252 0 1 1 5 5.372v1.836A2.493 2.493 0 0 1 6 7h4a.997.997 0 0 0 1-1v-.628A2.252 2.252 0 0 1 11.75 1Zm-7.5 1.5a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06.747.747 0 0 0 1.06 0 .747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22Zm0 9.5a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06.747.747 0 0 0 1.06 0 .747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22Zm7.5-9.5a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06.747.747 0 0 0 1.06 0 .747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 19.25a3.248 3.248 0 0 1 2.505-3.164A.81.81 0 0 1 5 16V8c0-.029.002-.057.005-.086a3.247 3.247 0 0 1-2.486-3.539 3.25 3.25 0 1 1 3.976 3.539A.827.827 0 0 1 6.5 8v3.51A3.247 3.247 0 0 1 8.25 11h7a2.25 2.25 0 0 0 2.25-2.25v-.837a3.25 3.25 0 1 1 1.5 0v.837a3.752 3.752 0 0 1-3.75 3.75h-7a1.75 1.75 0 0 0-1.75 1.75V16a.81.81 0 0 1-.005.086A3.25 3.25 0 1 1 2.5 19.25ZM5.75 6.5c.464 0 .909-.184 1.237-.513a1.746 1.746 0 0 0 0-2.474 1.746 1.746 0 0 0-2.474 0A1.74 1.74 0 0 0 4 4.75a1.752 1.752 0 0 0 1.08 1.617c.213.088.44.133.67.133Zm0 14.5c.464 0 .909-.184 1.237-.513a1.746 1.746 0 0 0 0-2.474 1.746 1.746 0 0 0-2.474 0 1.746 1.746 0 0 0 0 2.474c.328.329.773.513 1.237.513ZM16.5 4.75a1.752 1.752 0 0 0 1.08 1.617A1.752 1.752 0 0 0 20 4.75c0-.464-.184-.909-.513-1.237a1.746 1.746 0 0 0-2.474 0A1.746 1.746 0 0 0 16.5 4.75Zm4.22 10.47a.749.749 0 1 1 1.06 1.06l-5.323 5.324a1.01 1.01 0 0 1-.707.292.991.991 0 0 1-.707-.292L12.72 19.28a.749.749 0 1 1 1.06-1.06l1.97 1.969 4.97-4.969Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$60c2c35f336e72eb = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitCommitIcon", "octicon octicon-git-commit", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.944 11h4.306a.75.75 0 0 1 0 1.5h-4.306a5.001 5.001 0 0 1-9.888 0H2.75a.75.75 0 0 1 0-1.5h4.306a5.001 5.001 0 0 1 9.888 0Zm-1.444.75a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f8d7191bd80f36 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitCompareIcon", "octicon octicon-git-compare", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM6 12v-1.646a.25.25 0 0 1 .427-.177l2.396 2.396a.25.25 0 0 1 0 .354l-2.396 2.396A.25.25 0 0 1 6 15.146V13.5H5A2.5 2.5 0 0 1 2.5 11V5.372a2.25 2.25 0 1 1 1.5 0V11a1 1 0 0 0 1 1ZM4 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM12.75 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.905 1.72a.75.75 0 0 1 0 1.06L12.685 4h4.065a3.75 3.75 0 0 1 3.75 3.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM7.5 4.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM4.25 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 4.25 6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.095 22.28a.75.75 0 0 1 0-1.06l1.22-1.22H7.25a3.75 3.75 0 0 1-3.75-3.75V7.5a.75.75 0 0 1 1.5 0v8.75a2.25 2.25 0 0 0 2.25 2.25h4.064l-1.22-1.22a.748.748 0 0 1 .332-1.265.75.75 0 0 1 .729.205l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$578402671e214a82 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitMergeIcon", "octicon octicon-git-merge", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.734 5.734 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218ZM4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 3.25a.75.75 0 1 0 0 .005V3.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 13.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-12.5 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-6a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 15Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.5 7.25c0 2.9 2.35 5.25 5.25 5.25h4.5V14h-4.5A6.75 6.75 0 0 1 5 7.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$3aec9aa2330d4752 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitMergeQueueIcon", "octicon octicon-git-merge-queue", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 4.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM3 7.75a.75.75 0 0 1 1.5 0v2.878a2.251 2.251 0 1 1-1.5 0Zm.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm5-7.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm5.75 2.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-1.5 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 6.5a1.75 1.75 0 1 1 .001-3.501A1.75 1.75 0 0 1 5.75 6.5ZM9.5 8.75a1.75 1.75 0 1 1 3.501.001A1.75 1.75 0 0 1 9.5 8.75ZM5.75 22.5a3.25 3.25 0 0 1-.745-6.414A.81.81 0 0 1 5 16v-5a.75.75 0 0 1 1.5 0v5a.81.81 0 0 1-.005.086A3.252 3.252 0 0 1 5.75 22.5ZM4 19.25a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 4 19.25Zm11-6.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25 1.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9a124e3933109cb2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitPullRequestIcon", "octicon octicon-git-pull-request", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-14.5 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM4.75 3a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 4.75 3Zm0 14.5a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 4.75 17.5Zm14.5 0a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.405 1.72a.75.75 0 0 1 0 1.06L12.185 4h4.065A3.75 3.75 0 0 1 20 7.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM4.75 7.25A.75.75 0 0 1 5.5 8v8A.75.75 0 0 1 4 16V8a.75.75 0 0 1 .75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$5026ec832c277e74 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitPullRequestClosedIcon", "octicon octicon-git-pull-request-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 5.5a.75.75 0 0 1 .75.75v3.378a2.251 2.251 0 1 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-2.03-5.273a.75.75 0 0 1 1.06 0l.97.97.97-.97a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.97.97.97.97a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-.97-.97-.97.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l.97-.97-.97-.97a.75.75 0 0 1 0-1.06ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22.266 2.711a.75.75 0 1 0-1.061-1.06l-1.983 1.983-1.984-1.983a.75.75 0 1 0-1.06 1.06l1.983 1.983-1.983 1.984a.75.75 0 0 0 1.06 1.06l1.984-1.983 1.983 1.983a.75.75 0 0 0 1.06-1.06l-1.983-1.984 1.984-1.983ZM4.75 1.5a3.25 3.25 0 0 1 .745 6.414A.827.827 0 0 1 5.5 8v8a.827.827 0 0 1-.005.086A3.25 3.25 0 0 1 4.75 22.5a3.25 3.25 0 0 1-.745-6.414A.827.827 0 0 1 4 16V8c0-.029.002-.057.005-.086A3.25 3.25 0 0 1 4.75 1.5ZM16 19.25a3.252 3.252 0 0 1 2.5-3.163V9.625a.75.75 0 0 1 1.5 0v6.462a3.252 3.252 0 0 1-.75 6.413A3.25 3.25 0 0 1 16 19.25ZM3 4.75a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 4.75Zm0 14.5a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 19.25Zm16.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$51ed17e21f1e5e24 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitPullRequestDraftIcon", "octicon octicon-git-pull-request-draft", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 14a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM14 7.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm0-4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 1.5a3.25 3.25 0 0 1 .745 6.414A.827.827 0 0 1 5.5 8v8a.827.827 0 0 1-.005.086A3.25 3.25 0 0 1 4.75 22.5a3.25 3.25 0 0 1-.745-6.414A.827.827 0 0 1 4 16V8c0-.029.002-.057.005-.086A3.25 3.25 0 0 1 4.75 1.5ZM16 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM3 4.75a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 4.75Zm0 14.5a1.75 1.75 0 1 0 3.501-.001A1.75 1.75 0 0 0 3 19.25Zm16.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Zm0-11.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM21 11.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5a2beef779c6a3e8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GitPullRequestLockedIcon", "octicon octicon-git-pull-request-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 6a3 3 0 0 1 3 3v1.169c.591.281 1 .883 1 1.581v2.5A1.75 1.75 0 0 1 14.25 16h-4.5A1.75 1.75 0 0 1 8 14.25v-2.5c0-.698.409-1.3 1-1.581V9a3 3 0 0 1 3-3Zm0 1.5A1.5 1.5 0 0 0 10.5 9v1h3V9A1.5 1.5 0 0 0 12 7.5ZM3.25 1A2.25 2.25 0 0 1 4 5.372v5.257a2.25 2.25 0 1 1-1.5 0V5.372A2.252 2.252 0 0 1 3.25 1Zm0 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM10 .854a.25.25 0 0 0-.427-.177L7.177 3.073a.251.251 0 0 0 0 .355l2.396 2.395A.25.25 0 0 0 10 5.646V.854Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.997 2.708A2.492 2.492 0 0 0 11 2.5h-1V4h1c.5 0 .891 0 .956.597a.735.735 0 0 0 .746.674.75.75 0 0 0 .746-.674c0-.097 0-.147-.066-.356 0 0-.041-.122-.073-.198a2.242 2.242 0 0 0-.209-.393 2.004 2.004 0 0 0-.327-.412l-.039-.036a2.78 2.78 0 0 0-.127-.114c-.01-.009-.019-.018-.03-.026a1.977 1.977 0 0 0-.172-.129l-.035-.023a3.087 3.087 0 0 0-.156-.095l-.047-.025a2.656 2.656 0 0 0-.17-.082Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a70e2e549144f66 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GlobeIcon", "octicon octicon-globe", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.78 8.75a9.64 9.64 0 0 0 1.363 4.177c.255.426.542.832.857 1.215.245-.296.551-.705.857-1.215A9.64 9.64 0 0 0 10.22 8.75Zm4.44-1.5a9.64 9.64 0 0 0-1.363-4.177c-.307-.51-.612-.919-.857-1.215a9.927 9.927 0 0 0-.857 1.215A9.64 9.64 0 0 0 5.78 7.25Zm-5.944 1.5H1.543a6.507 6.507 0 0 0 4.666 5.5c-.123-.181-.24-.365-.352-.552-.715-1.192-1.437-2.874-1.581-4.948Zm-2.733-1.5h2.733c.144-2.074.866-3.756 1.58-4.948.12-.197.237-.381.353-.552a6.507 6.507 0 0 0-4.666 5.5Zm10.181 1.5c-.144 2.074-.866 3.756-1.58 4.948-.12.197-.237.381-.353.552a6.507 6.507 0 0 0 4.666-5.5Zm2.733-1.5a6.507 6.507 0 0 0-4.666-5.5c.123.181.24.365.353.552.714 1.192 1.436 2.874 1.58 4.948Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm3.241 10.5v-.001c-.1-2.708-.992-4.904-1.89-6.452a13.919 13.919 0 0 0-1.304-1.88L12 3.11l-.047.059c-.354.425-.828 1.06-1.304 1.88-.898 1.547-1.79 3.743-1.89 6.451Zm-12.728 0h4.745c.1-3.037 1.1-5.49 2.093-7.204.39-.672.78-1.233 1.119-1.673C6.11 3.329 2.746 7 2.513 11.5Zm18.974 0C21.254 7 17.89 3.329 13.53 2.623c.339.44.729 1.001 1.119 1.673.993 1.714 1.993 4.167 2.093 7.204ZM8.787 13c.182 2.478 1.02 4.5 1.862 5.953.382.661.818 1.29 1.304 1.88l.047.057.047-.059c.354-.425.828-1.06 1.304-1.88.842-1.451 1.679-3.471 1.862-5.951Zm-1.504 0H2.552a9.505 9.505 0 0 0 7.918 8.377 15.773 15.773 0 0 1-1.119-1.673C8.413 18.085 7.47 15.807 7.283 13Zm9.434 0c-.186 2.807-1.13 5.085-2.068 6.704-.39.672-.78 1.233-1.118 1.673A9.506 9.506 0 0 0 21.447 13Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$134cbcd70c6693b8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GoalIcon", "octicon octicon-goal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.637 2.363h-.001l1.676.335c.09.018.164.084.19.173a.25.25 0 0 1-.062.249l-1.373 1.374a.876.876 0 0 1-.619.256H12.31L9.45 7.611A1.5 1.5 0 1 1 6.5 8a1.501 1.501 0 0 1 1.889-1.449l2.861-2.862V2.552c0-.232.092-.455.256-.619L12.88.559a.25.25 0 0 1 .249-.062c.089.026.155.1.173.19Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 8a6 6 0 1 0 11.769-1.656.751.751 0 1 1 1.442-.413 7.502 7.502 0 0 1-12.513 7.371A7.501 7.501 0 0 1 10.069.789a.75.75 0 0 1-.413 1.442A6.001 6.001 0 0 0 2 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 8a3.002 3.002 0 0 0 4.699 2.476 3 3 0 0 0 1.28-2.827.748.748 0 0 1 1.045-.782.75.75 0 0 1 .445.61A4.5 4.5 0 1 1 8.516 3.53a.75.75 0 1 1-.17 1.49A3 3 0 0 0 5 8Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.172 6.75h-1.861l-4.566 4.564a1.874 1.874 0 1 1-1.06-1.06l4.565-4.565V3.828a.94.94 0 0 1 .275-.664l1.73-1.73a.249.249 0 0 1 .25-.063c.089.026.155.1.173.191l.46 2.301 2.3.46c.09.018.164.084.19.173a.25.25 0 0 1-.062.249l-1.731 1.73a.937.937 0 0 1-.663.275Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.625 12A9.375 9.375 0 0 0 12 21.375 9.375 9.375 0 0 0 21.375 12c0-.898-.126-1.766-.361-2.587A.75.75 0 0 1 22.455 9c.274.954.42 1.96.42 3 0 6.006-4.869 10.875-10.875 10.875S1.125 18.006 1.125 12 5.994 1.125 12 1.125c1.015-.001 2.024.14 3 .419a.75.75 0 1 1-.413 1.442A9.39 9.39 0 0 0 12 2.625 9.375 9.375 0 0 0 2.625 12Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.125 12a4.874 4.874 0 1 0 9.717-.569.748.748 0 0 1 1.047-.798c.251.112.42.351.442.625a6.373 6.373 0 0 1-10.836 5.253 6.376 6.376 0 0 1 5.236-10.844.75.75 0 1 1-.17 1.49A4.876 4.876 0 0 0 7.125 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$1154891bc70a7bd = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GrabberIcon", "octicon octicon-grabber", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-4 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$717a5ffb6a14ac74 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GraphIcon", "octicon octicon-graph", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 1.75V13.5h13.75a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0Zm14.28 2.53-5.25 5.25a.75.75 0 0 1-1.06 0L7 7.06 4.28 9.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25a.75.75 0 0 1 1.06 0L10 7.94l4.72-4.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 2.75a.75.75 0 0 0-1.5 0v18.5c0 .414.336.75.75.75H20a.75.75 0 0 0 0-1.5H2.5V2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22.28 7.78a.75.75 0 0 0-1.06-1.06l-5.72 5.72-3.72-3.72a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 1 0 1.06 1.06l5.47-5.47 3.72 3.72a.75.75 0 0 0 1.06 0l6.25-6.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$37a42a3634c469c4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GraphBarHorizontalIcon", "octicon octicon-graph-bar-horizontal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.25 15H.75q-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53.219-.22.53-.22h14.5q.311 0 .53.22.22.219.22.53 0 .311-.22.53-.219.22-.53.22Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.25 7h2.5a.25.25 0 0 1 .25.25v6.5a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25v-6.5A.25.25 0 0 1 2.25 7Zm4-4h2.5a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25V3.25A.25.25 0 0 1 6.25 3Zm4 6h2.5a.25.25 0 0 1 .25.25v4.5a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25v-4.5a.25.25 0 0 1 .25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22.875 22.125H1.125q-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53.219-.22.53-.22h21.75q.311 0 .53.22.22.219.22.53 0 .311-.22.53-.219.22-.53.22Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 10.5h4a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25v-10a.25.25 0 0 1 .25-.25Zm6-6h4a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25v-16a.25.25 0 0 1 .25-.25Zm6 9h4a.25.25 0 0 1 .25.25v7a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25v-7a.25.25 0 0 1 .25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$7dbdd25586690a07 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("GraphBarVerticalIcon", "octicon octicon-graph-bar-vertical", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 15.25V.75q0-.311.22-.53.219-.22.53-.22.311 0 .53.22.22.219.22.53v14.5q0 .311-.22.53-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 3.25v2.5a.25.25 0 0 1-.25.25h-6.5A.25.25 0 0 1 2 5.75v-2.5A.25.25 0 0 1 2.25 3h6.5a.25.25 0 0 1 .25.25Zm4 4v2.5a.25.25 0 0 1-.25.25H2.25A.25.25 0 0 1 2 9.75v-2.5A.25.25 0 0 1 2.25 7h10.5a.25.25 0 0 1 .25.25Zm-6 4v2.5a.25.25 0 0 1-.25.25h-4.5a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h4.5a.25.25 0 0 1 .25.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.875 22.875V1.125q0-.311.22-.53.219-.22.53-.22.311 0 .53.22.22.219.22.53v21.75q0 .311-.22.53-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.5 4.75v4a.25.25 0 0 1-.25.25h-10A.25.25 0 0 1 3 8.75v-4a.25.25 0 0 1 .25-.25h10a.25.25 0 0 1 .25.25Zm6 6v4a.25.25 0 0 1-.25.25h-16a.25.25 0 0 1-.25-.25v-4a.25.25 0 0 1 .25-.25h16a.25.25 0 0 1 .25.25Zm-9 6v4a.25.25 0 0 1-.25.25h-7a.25.25 0 0 1-.25-.25v-4a.25.25 0 0 1 .25-.25h7a.25.25 0 0 1 .25.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$fc47a954fcd1cdda = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HashIcon", "octicon octicon-hash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.368 1.01a.75.75 0 0 1 .623.859L6.57 4.5h3.98l.46-2.868a.75.75 0 0 1 1.48.237L12.07 4.5h2.18a.75.75 0 0 1 0 1.5h-2.42l-.64 4h2.56a.75.75 0 0 1 0 1.5h-2.8l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H5.45l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H1.75a.75.75 0 0 1 0-1.5h2.42l.64-4H2.25a.75.75 0 0 1 0-1.5h2.8l.46-2.868a.75.75 0 0 1 .858-.622ZM9.67 10l.64-4H6.33l-.64 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.618 1.76a.75.75 0 0 1 .623.859L9.46 7.5h6.48l.82-5.118a.75.75 0 0 1 1.48.237L17.46 7.5h3.79a.75.75 0 0 1 0 1.5h-4.03l-.96 6h3.99a.75.75 0 0 1 0 1.5h-4.23l-.78 4.869a.75.75 0 0 1-1.48-.237l.74-4.632H8.02l-.78 4.869a.75.75 0 0 1-1.48-.237L6.5 16.5H2.745a.75.75 0 0 1 0-1.5H6.74l.96-6H3.75a.75.75 0 0 1 0-1.5h4.19l.82-5.118a.75.75 0 0 1 .858-.622ZM14.741 15l.96-6H9.22l-.96 6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$635e9dadffe43ee = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HeadingIcon", "octicon octicon-heading", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2a.75.75 0 0 1 .75.75V7h7V2.75a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0V8.5h-7v4.75a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 3.75 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.25 4a.75.75 0 0 1 .75.75V11h10V4.75a.75.75 0 0 1 1.5 0v14.5a.75.75 0 0 1-1.5 0V12.5H7v6.75a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 6.25 4Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$16f03ed71cfb60c9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HeartIcon", "octicon octicon-heart", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8 14.25.345.666a.75.75 0 0 1-.69 0l-.008-.004-.018-.01a7.152 7.152 0 0 1-.31-.17 22.055 22.055 0 0 1-3.434-2.414C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.045 5.231-3.885 6.818a22.066 22.066 0 0 1-3.744 2.584l-.018.01-.006.003h-.002ZM4.25 2.5c-1.336 0-2.75 1.164-2.75 3 0 2.15 1.58 4.144 3.365 5.682A20.58 20.58 0 0 0 8 13.393a20.58 20.58 0 0 0 3.135-2.211C12.92 9.644 14.5 7.65 14.5 5.5c0-1.836-1.414-3-2.75-3-1.373 0-2.609.986-3.029 2.456a.749.749 0 0 1-1.442 0C6.859 3.486 5.623 2.5 4.25 2.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12 20.703.343.667a.748.748 0 0 1-.686 0l-.003-.002-.007-.003-.025-.013a31.138 31.138 0 0 1-5.233-3.576C3.8 15.573 1 12.332 1 8.514v-.001C1 5.053 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262a31.148 31.148 0 0 1-5.233 3.576l-.025.013-.007.003-.002.001ZM6.736 4C4.657 4 2.5 5.88 2.5 8.514c0 3.107 2.324 5.96 4.861 8.12a29.655 29.655 0 0 0 4.566 3.175l.073.041.073-.04c.271-.153.661-.38 1.13-.674.94-.588 2.19-1.441 3.436-2.502 2.537-2.16 4.861-5.013 4.861-8.12C21.5 5.88 19.343 4 17.264 4c-2.106 0-3.801 1.389-4.553 3.643a.751.751 0 0 1-1.422 0C10.537 5.389 8.841 4 6.736 4Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b94f36847052a4cc = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HeartFillIcon", "octicon octicon-heart-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.655 14.916v-.001h-.002l-.006-.003-.018-.01a22.066 22.066 0 0 1-3.744-2.584C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.044 5.231-3.886 6.818a22.094 22.094 0 0 1-3.433 2.414 7.152 7.152 0 0 1-.31.17l-.018.01-.008.004a.75.75 0 0 1-.69 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8d345d913bfb227 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HistoryIcon", "octicon octicon-history", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m.427 1.927 1.215 1.215a8.002 8.002 0 1 1-1.6 5.685.75.75 0 1 1 1.493-.154 6.5 6.5 0 1 0 1.18-4.458l1.358 1.358A.25.25 0 0 1 3.896 6H.25A.25.25 0 0 1 0 5.75V2.104a.25.25 0 0 1 .427-.177ZM7.75 4a.75.75 0 0 1 .75.75v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5A.75.75 0 0 1 7.75 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.998 2.5A9.503 9.503 0 0 0 3.378 8H5.75a.75.75 0 0 1 0 1.5H2a1 1 0 0 1-1-1V4.75a.75.75 0 0 1 1.5 0v1.697A10.997 10.997 0 0 1 11.998 1C18.074 1 23 5.925 23 12s-4.926 11-11.002 11C6.014 23 1.146 18.223 1 12.275a.75.75 0 0 1 1.5-.037 9.5 9.5 0 0 0 9.498 9.262c5.248 0 9.502-4.253 9.502-9.5s-4.254-9.5-9.502-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$92c8767b874048d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HomeIcon", "octicon octicon-home", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.906.664a1.749 1.749 0 0 1 2.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0 1 13.25 15h-3.5a.75.75 0 0 1-.75-.75V9H7v5.25a.75.75 0 0 1-.75.75h-3.5A1.75 1.75 0 0 1 1 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2Zm1.25 1.171a.25.25 0 0 0-.312 0l-5.25 4.2a.25.25 0 0 0-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v5.25h2.75a.25.25 0 0 0 .25-.25V6.23a.25.25 0 0 0-.094-.195Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$43567ad5cdf3581e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HomeFillIcon", "octicon octicon-home-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.906.384a1.75 1.75 0 0 1 2.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019a1.75 1.75 0 0 1-1.75 1.75h-2.5a.75.75 0 0 1-.75-.75V8.72H6v5.25a.75.75 0 0 1-.75.75h-2.5A1.75 1.75 0 0 1 1 12.97V5.95c0-.531.242-1.034.657-1.366l5.249-4.2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.97 2.59a1.5 1.5 0 0 0-1.94 0l-7.5 6.363A1.5 1.5 0 0 0 3 10.097V19.5A1.5 1.5 0 0 0 4.5 21h4.75a.75.75 0 0 0 .75-.75V14h4v6.25c0 .414.336.75.75.75h4.75a1.5 1.5 0 0 0 1.5-1.5v-9.403a1.5 1.5 0 0 0-.53-1.144l-7.5-6.363Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$124ea60d66fc0e36 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HorizontalRuleIcon", "octicon octicon-horizontal-rule", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 7.75A.75.75 0 0 1 .75 7h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 7.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 12.75a.75.75 0 0 1 .75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2eec7cd412adbced = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HourglassIcon", "octicon octicon-hourglass", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 1h10.5a.75.75 0 0 1 0 1.5h-.75v1.25a4.75 4.75 0 0 1-1.9 3.8l-.333.25a.25.25 0 0 0 0 .4l.333.25a4.75 4.75 0 0 1 1.9 3.8v1.25h.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.75v-1.25a4.75 4.75 0 0 1 1.9-3.8l.333-.25a.25.25 0 0 0 0-.4L5.4 7.55a4.75 4.75 0 0 1-1.9-3.8V2.5h-.75a.75.75 0 0 1 0-1.5ZM11 2.5H5v1.25c0 1.023.482 1.986 1.3 2.6l.333.25c.934.7.934 2.1 0 2.8l-.333.25a3.251 3.251 0 0 0-1.3 2.6v1.25h6v-1.25a3.251 3.251 0 0 0-1.3-2.6l-.333-.25a1.748 1.748 0 0 1 0-2.8l.333-.25a3.251 3.251 0 0 0 1.3-2.6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 2h14.5a.75.75 0 0 1 0 1.5h-.75v2.982a4.75 4.75 0 0 1-2.215 4.017l-2.044 1.29a.25.25 0 0 0 0 .422l2.044 1.29a4.75 4.75 0 0 1 2.215 4.017V20.5h.75a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h.75v-2.982a4.75 4.75 0 0 1 2.215-4.017l2.044-1.29a.25.25 0 0 0 0-.422l-2.044-1.29A4.75 4.75 0 0 1 5.5 6.482V3.5h-.75a.75.75 0 0 1 0-1.5ZM17 3.5H7v2.982A3.25 3.25 0 0 0 8.516 9.23l2.044 1.29a1.75 1.75 0 0 1 0 2.96l-2.044 1.29A3.25 3.25 0 0 0 7 17.518V20.5h10v-2.982a3.25 3.25 0 0 0-1.516-2.748l-2.044-1.29a1.75 1.75 0 0 1 0-2.96l2.044-1.29A3.25 3.25 0 0 0 17 6.482Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1754a0cdd4c4236a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("HubotIcon", "octicon octicon-hubot", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 0 1 16 0v5.25a.75.75 0 0 1-1.5 0V8a6.5 6.5 0 1 0-13 0v5.25a.75.75 0 0 1-1.5 0Zm3-1.25C3 5.784 3.784 5 4.75 5h6.5c.966 0 1.75.784 1.75 1.75v1.5A1.75 1.75 0 0 1 11.25 10h-6.5A1.75 1.75 0 0 1 3 8.25Zm1.47-.53a.75.75 0 0 0 0 1.06l1.5 1.5a.75.75 0 0 0 1.06 0L8 7.81l.97.97a.75.75 0 0 0 1.06 0l1.5-1.5a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215l-.97.97-.97-.97a.75.75 0 0 0-1.06 0l-.97.97-.97-.97a.75.75 0 0 0-1.06 0Zm1.03 6.03a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 13C0 6.373 5.373 1 12 1s12 5.373 12 12v8.657a.75.75 0 0 1-1.5 0V13c0-5.799-4.701-10.5-10.5-10.5S1.5 7.201 1.5 13v8.657a.75.75 0 0 1-1.5 0V13Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 19.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM5.25 9.5h13.5c.966 0 1.75.784 1.75 1.75v3.5a1.75 1.75 0 0 1-1.75 1.75H5.25a1.75 1.75 0 0 1-1.75-1.75v-3.5c0-.966.784-1.75 1.75-1.75Zm.22 1.47a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0L12 12.56l2.47 2.47a.75.75 0 0 0 1.06 0l3-3a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L15 13.44l-2.47-2.47a.75.75 0 0 0-1.06 0L9 13.44l-2.47-2.47a.75.75 0 0 0-1.06 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6d90c795789f42a2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IdBadgeIcon", "octicon octicon-id-badge", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 7.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3Zm10 .25a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75ZM10.25 11a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5h2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.25 0h1.5c.966 0 1.75.784 1.75 1.75V3h3.75c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-8.5C0 3.784.784 3 1.75 3H5.5V1.75C5.5.784 6.284 0 7.25 0Zm3.232 4.5A1.75 1.75 0 0 1 8.75 6h-1.5a1.75 1.75 0 0 1-1.732-1.5H1.75a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM7 1.75v2.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 9 4.25v-2.5a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.75 3h2.5c.464 0 .909.184 1.237.513.329.328.513.773.513 1.237V7h5.25c.464 0 .909.184 1.237.513.329.328.513.773.513 1.237v10.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 20.25 21H3.75A1.75 1.75 0 0 1 2 19.25V8.75c0-.464.184-.909.513-1.237A1.746 1.746 0 0 1 3.75 7H9V4.75c0-.464.184-.909.513-1.237A1.746 1.746 0 0 1 10.75 3Zm3.646 6.573A1.753 1.753 0 0 1 13.25 10h-2.5a1.753 1.753 0 0 1-1.732-1.5H3.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V8.75a.25.25 0 0 0-.25-.25h-5.268c-.06.416-.268.797-.586 1.073Zm-8.25 1.573A.504.504 0 0 1 6.5 11h3c.133 0 .26.053.354.146A.504.504 0 0 1 10 11.5v5c0 .133-.053.26-.146.354A.504.504 0 0 1 9.5 17h-3a.504.504 0 0 1-.354-.146A.504.504 0 0 1 6 16.5v-5c0-.133.053-.26.146-.354ZM10.5 4.75v3.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Zm.72 7.47a.747.747 0 0 1 .53-.22h5.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-5.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Zm0 2.525a.747.747 0 0 1 .53-.22h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4a122bafaa48b23d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ImageIcon", "octicon octicon-image", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 13.25A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75ZM1.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h.94l.03-.03 6.077-6.078a1.75 1.75 0 0 1 2.412-.06L14.5 10.31V2.75a.25.25 0 0 0-.25-.25Zm12.5 11a.25.25 0 0 0 .25-.25v-.917l-4.298-3.889a.25.25 0 0 0-.344.009L4.81 13.5ZM7 6a2 2 0 1 1-3.999.001A2 2 0 0 1 7 6ZM5.5 6a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 3h14.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 19.25 21H4.75A1.75 1.75 0 0 1 3 19.25V4.75C3 3.784 3.784 3 4.75 3Zm14.5 1.5H4.75a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h.19l9.823-9.823a1.75 1.75 0 0 1 2.475 0l2.262 2.262V4.75a.25.25 0 0 0-.25-.25Zm.25 9.56-3.323-3.323a.25.25 0 0 0-.354 0L7.061 19.5H19.25a.25.25 0 0 0 .25-.25ZM8.5 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f146fd7f5447dd59 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("InboxIcon", "octicon octicon-inbox", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.8 2.06A1.75 1.75 0 0 1 4.41 1h7.18c.7 0 1.333.417 1.61 1.06l2.74 6.395c.04.093.06.194.06.295v4.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-4.5c0-.101.02-.202.06-.295Zm1.61.44a.25.25 0 0 0-.23.152L1.887 8H4.75a.75.75 0 0 1 .6.3L6.625 10h2.75l1.275-1.7a.75.75 0 0 1 .6-.3h2.863L11.82 2.652a.25.25 0 0 0-.23-.152Zm10.09 7h-2.875l-1.275 1.7a.75.75 0 0 1-.6.3h-3.5a.75.75 0 0 1-.6-.3L4.375 9.5H1.5v3.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.801 3.57A1.75 1.75 0 0 1 6.414 2.5h11.174c.702 0 1.337.42 1.611 1.067l3.741 8.828c.04.092.06.192.06.293v7.562A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25v-7.5c0-.1.02-.199.059-.291L4.8 3.571ZM6.414 4a.25.25 0 0 0-.23.153L2.88 12H8a.75.75 0 0 1 .648.372L10.18 15h3.638l1.533-2.628a.75.75 0 0 1 .64-.372l5.13-.051-3.304-7.797a.25.25 0 0 0-.23-.152ZM21.5 13.445l-5.067.05-1.535 2.633a.75.75 0 0 1-.648.372h-4.5a.75.75 0 0 1-.648-.372L7.57 13.5H2.5v6.75c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5ae8ddf56654ca4c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("InboxFillIcon", "octicon octicon-inbox-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.8 2.06A1.75 1.75 0 0 1 4.41 1h7.18c.7 0 1.333.417 1.61 1.06l2.74 6.395a.75.75 0 0 1 .06.295v4.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-4.5a.75.75 0 0 1 .06-.295L2.8 2.06Zm1.61.44a.25.25 0 0 0-.23.152L1.887 8H4.75a.75.75 0 0 1 .6.3L6.625 10h2.75l1.275-1.7a.75.75 0 0 1 .6-.3h2.863L11.82 2.652a.25.25 0 0 0-.23-.152H4.41Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.801 3.57A1.75 1.75 0 0 1 6.414 2.5h11.174c.702 0 1.337.42 1.611 1.067l3.741 8.828c.04.092.06.192.06.293v7.562A1.75 1.75 0 0 1 21.25 22H2.75A1.75 1.75 0 0 1 1 20.25v-7.5c0-.1.02-.199.059-.291L4.8 3.571ZM6.414 4a.25.25 0 0 0-.23.153L2.88 12H8a.75.75 0 0 1 .648.372L10.18 15h3.638l1.533-2.628a.75.75 0 0 1 .64-.372l5.13-.051-3.304-7.797a.25.25 0 0 0-.23-.152H6.414Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$29f7ef9a1b8bcf6e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("InfinityIcon", "octicon octicon-infinity", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 6.984c.59-.533 1.204-1.066 1.825-1.493.797-.548 1.7-.991 2.675-.991C14.414 4.5 16 6.086 16 8s-1.586 3.5-3.5 3.5c-.975 0-1.878-.444-2.675-.991-.621-.427-1.235-.96-1.825-1.493-.59.533-1.204 1.066-1.825 1.493-.797.547-1.7.991-2.675.991C1.586 11.5 0 9.914 0 8s1.586-3.5 3.5-3.5c.975 0 1.878.443 2.675.991.621.427 1.235.96 1.825 1.493ZM9.114 8c.536.483 1.052.922 1.56 1.273.704.483 1.3.727 1.826.727 1.086 0 2-.914 2-2 0-1.086-.914-2-2-2-.525 0-1.122.244-1.825.727-.51.35-1.025.79-1.561 1.273ZM3.5 6c-1.086 0-2 .914-2 2 0 1.086.914 2 2 2 .525 0 1.122-.244 1.825-.727.51-.35 1.025-.79 1.561-1.273-.536-.483-1.052-.922-1.56-1.273C4.621 6.244 4.025 6 3.5 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 11.16c.887-.933 1.813-1.865 2.78-2.6C15.952 7.668 17.267 7 18.75 7 21.657 7 24 9.615 24 12.25s-2.343 5.25-5.25 5.25c-1.483 0-2.798-.668-3.97-1.56-.967-.735-1.893-1.667-2.78-2.6-.887.933-1.813 1.865-2.78 2.6-1.172.892-2.487 1.56-3.97 1.56C2.343 17.5 0 14.885 0 12.25S2.343 7 5.25 7c1.483 0 2.798.667 3.97 1.56.967.735 1.893 1.667 2.78 2.6ZM5.25 8.5c-2.032 0-3.75 1.895-3.75 3.75S3.218 16 5.25 16c1.017 0 2.014-.457 3.062-1.253.89-.678 1.758-1.554 2.655-2.497-.897-.943-1.765-1.82-2.655-2.497C7.264 8.957 6.267 8.5 5.25 8.5Zm7.783 3.75c.897.943 1.765 1.82 2.655 2.497C16.736 15.543 17.733 16 18.75 16c2.032 0 3.75-1.895 3.75-3.75S20.782 8.5 18.75 8.5c-1.017 0-2.014.457-3.062 1.253-.89.678-1.758 1.554-2.655 2.497Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2957fc44b3d2481 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("InfoIcon", "octicon octicon-info", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6738f79126c9668 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueClosedIcon", "octicon octicon-issue-closed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.28 6.78a.75.75 0 0 0-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l3.5-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$36bcc74fd945fa9c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueDraftIcon", "octicon octicon-issue-draft", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.307 11.655a.75.75 0 0 1 .165 1.048 8.05 8.05 0 0 1-1.769 1.77.75.75 0 0 1-.883-1.214 6.552 6.552 0 0 0 1.44-1.439.75.75 0 0 1 1.047-.165Zm-2.652-9.962a.75.75 0 0 1 1.048-.165 8.05 8.05 0 0 1 1.77 1.769.75.75 0 0 1-1.214.883 6.552 6.552 0 0 0-1.439-1.44.75.75 0 0 1-.165-1.047ZM6.749.097a8.074 8.074 0 0 1 2.502 0 .75.75 0 1 1-.233 1.482 6.558 6.558 0 0 0-2.036 0A.751.751 0 0 1 6.749.097ZM.955 6.125a.75.75 0 0 1 .624.857 6.558 6.558 0 0 0 0 2.036.75.75 0 1 1-1.482.233 8.074 8.074 0 0 1 0-2.502.75.75 0 0 1 .858-.624Zm14.09 0a.75.75 0 0 1 .858.624c.13.829.13 1.673 0 2.502a.75.75 0 1 1-1.482-.233 6.558 6.558 0 0 0 0-2.036.75.75 0 0 1 .624-.857Zm-8.92 8.92a.75.75 0 0 1 .857-.624 6.558 6.558 0 0 0 2.036 0 .75.75 0 1 1 .233 1.482c-.829.13-1.673.13-2.502 0a.75.75 0 0 1-.624-.858Zm-4.432-3.39a.75.75 0 0 1 1.048.165 6.552 6.552 0 0 0 1.439 1.44.751.751 0 0 1-.883 1.212 8.05 8.05 0 0 1-1.77-1.769.75.75 0 0 1 .166-1.048Zm2.652-9.962A.75.75 0 0 1 4.18 2.74a6.556 6.556 0 0 0-1.44 1.44.751.751 0 0 1-1.212-.883 8.05 8.05 0 0 1 1.769-1.77.75.75 0 0 1 1.048.166Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.32 3.205a.75.75 0 0 1 1.046-.177 11.056 11.056 0 0 1 2.605 2.606.75.75 0 1 1-1.222.869 9.554 9.554 0 0 0-2.252-2.252.75.75 0 0 1-.177-1.046Zm3.475 14.115a.75.75 0 0 1 .176 1.046 11.07 11.07 0 0 1-2.605 2.605.75.75 0 1 1-.869-1.222 9.554 9.554 0 0 0 2.252-2.252.75.75 0 0 1 1.046-.177ZM2.018 9.543a.75.75 0 0 1 .615.864 9.571 9.571 0 0 0 0 3.186.75.75 0 1 1-1.48.25 11.07 11.07 0 0 1 0-3.686.75.75 0 0 1 .865-.614Zm7.525 12.439a.75.75 0 0 1 .864-.615 9.571 9.571 0 0 0 3.186 0 .75.75 0 1 1 .25 1.48 11.07 11.07 0 0 1-3.686 0 .75.75 0 0 1-.614-.865ZM6.68 3.205a.75.75 0 0 1-.177 1.046A9.558 9.558 0 0 0 4.25 6.503a.75.75 0 1 1-1.223-.87 11.056 11.056 0 0 1 2.606-2.605.75.75 0 0 1 1.046.177ZM3.205 17.32a.75.75 0 0 1 1.046.177 9.554 9.554 0 0 0 2.252 2.252.75.75 0 1 1-.87 1.223 11.056 11.056 0 0 1-2.605-2.606.75.75 0 0 1 .177-1.046Zm6.952-16.166a11.07 11.07 0 0 1 3.686 0 .75.75 0 0 1-.25 1.479 9.571 9.571 0 0 0-3.186 0 .75.75 0 1 1-.25-1.48Zm11.825 8.389a.75.75 0 0 1 .864.614 11.07 11.07 0 0 1 0 3.686.75.75 0 0 1-1.479-.25 9.571 9.571 0 0 0 0-3.186.75.75 0 0 1 .615-.864Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1ed5535f8a4bed8d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueLockedIcon", "octicon octicon-issue-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.001 6a3 3 0 0 1 3 3v1.168c.591.281 1 .884 1 1.582v2.5a1.75 1.75 0 0 1-1.75 1.75h-4.5a1.75 1.75 0 0 1-1.75-1.75v-2.5c0-.698.409-1.301 1-1.582V9a3 3 0 0 1 3-3Zm0 1.5a1.5 1.5 0 0 0-1.5 1.5v1h3V9a1.5 1.5 0 0 0-1.5-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.095.546a8.004 8.004 0 0 1 3.847-.49l.259.035a8.007 8.007 0 0 1 3.58 1.494l.207.16a7.997 7.997 0 0 1 2.148 2.639c.187.369-.005.807-.391.959-.386.152-.817-.04-1.013-.406a6.516 6.516 0 0 0-1.242-1.635l-.11-.105-.052-.046a5.601 5.601 0 0 0-.226-.193l-.049-.04-.042-.031a5.773 5.773 0 0 0-.249-.187l-.082-.057a6.275 6.275 0 0 0-.683-.411l-.028-.014a6.448 6.448 0 0 0-1.146-.458l-.039-.011a6.667 6.667 0 0 0-.376-.095l-.018-.005a6.137 6.137 0 0 0-.409-.075l-.003-.001h-.003l-.015-.002a7.553 7.553 0 0 0-.479-.051 5.582 5.582 0 0 0-.26-.015l-.155-.004L8 1.5c-.056 0-.112.003-.168.004-.054.001-.108.001-.162.004a6.436 6.436 0 0 0-.37.029l-.069.009c-.11.013-.218.029-.325.047l-.079.014a7.31 7.31 0 0 0-.383.082c-.27.066-.533.15-.788.249l-.016.005a6.598 6.598 0 0 0-1.096.553l-.083.053a6.974 6.974 0 0 0-.288.197l-.022.017a6.438 6.438 0 0 0-.609.509l-.064.061c-.082.079-.161.16-.238.243l-.038.039a7.194 7.194 0 0 0-.254.296l-.015.019c-.012.014-.022.029-.033.044a5.793 5.793 0 0 0-.188.249c-.018.025-.037.05-.054.076a6.468 6.468 0 0 0-.89 1.854l-.014.048a7.116 7.116 0 0 0-.084.327l-.02.089a6.429 6.429 0 0 0-.145 1.159l-.003.129L1.5 8c0 .066.003.131.005.196l.003.102a6.898 6.898 0 0 0 .034.434c.014.123.032.245.052.366l.007.034c.148.84.456 1.625.893 2.321l.034.052c.058.09.118.179.18.266l.054.076c.077.104.156.207.239.306l.024.029c.075.089.153.175.232.259l.073.077c.064.065.128.13.195.193.029.028.058.057.088.084a6.601 6.601 0 0 0 .299.259c.062.049.124.098.187.145l.072.052.146.104a6.46 6.46 0 0 0 1.929.904c.399.112.68.492.615.901-.065.409-.45.691-.851.588a8.005 8.005 0 0 1-3.041-1.528l-.202-.169A8.009 8.009 0 0 1 .059 7.03l.036-.259a8.007 8.007 0 0 1 1.507-3.574l.161-.207A8.005 8.005 0 0 1 5.095.546Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.001 6.5c.259 0 .511.068.733.192A3.984 3.984 0 0 0 8.001 9v.5a1.503 1.503 0 0 1-1.5-1.5 1.503 1.503 0 0 1 1.5-1.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$9e6406dfc15cbb05 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueOpenedIcon", "octicon octicon-issue-opened", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Zm9.5 2a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 14Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5daf76ad79f58bb6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueReopenedIcon", "octicon octicon-issue-reopened", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.029 2.217a6.5 6.5 0 0 1 9.437 5.11.75.75 0 1 0 1.492-.154 8 8 0 0 0-14.315-4.03L.427 1.927A.25.25 0 0 0 0 2.104V5.75A.25.25 0 0 0 .25 6h3.646a.25.25 0 0 0 .177-.427L2.715 4.215a6.491 6.491 0 0 1 2.314-1.998ZM1.262 8.169a.75.75 0 0 0-1.22.658 8.001 8.001 0 0 0 14.315 4.03l1.216 1.216a.25.25 0 0 0 .427-.177V10.25a.25.25 0 0 0-.25-.25h-3.646a.25.25 0 0 0-.177.427l1.358 1.358a6.501 6.501 0 0 1-11.751-3.11.75.75 0 0 0-.272-.506Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.06 9.06a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.38 8A9.502 9.502 0 0 1 12 2.5a9.502 9.502 0 0 1 9.215 7.182.75.75 0 1 0 1.456-.364C21.473 4.539 17.15 1 12 1a10.995 10.995 0 0 0-9.5 5.452V4.75a.75.75 0 0 0-1.5 0V8.5a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H3.38Zm-.595 6.318a.75.75 0 0 0-1.455.364C2.527 19.461 6.85 23 12 23c4.052 0 7.592-2.191 9.5-5.451v1.701a.75.75 0 0 0 1.5 0V15.5a1 1 0 0 0-1-1h-3.75a.75.75 0 0 0 0 1.5h2.37A9.502 9.502 0 0 1 12 21.5c-4.446 0-8.181-3.055-9.215-7.182Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.414 13.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$68537e8e4eadb58f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueTrackedByIcon", "octicon octicon-issue-tracked-by", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 8a6.5 6.5 0 0 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm3.573 5.823-2.896-2.896a.25.25 0 0 1 0-.354l2.896-2.896a.25.25 0 0 1 .427.177V11.5h3.25a.75.75 0 0 1 0 1.5H12v2.146a.25.25 0 0 1-.427.177Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5a9.5 9.5 0 1 0 0 19 .75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23L13.76 17.02a.308.308 0 0 0 0 .46ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$55a6f130ee0bae8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IssueTracksIcon", "octicon octicon-issue-tracks", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 8a6.5 6.5 0 0 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 1.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm2.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 12a9.5 9.5 0 1 1 19 0 .75.75 0 0 0 1.5 0c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11a.75.75 0 0 0 0-1.5A9.5 9.5 0 0 1 2.5 12Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2.5 2.75a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm3.75 2.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$1db7002dff4b104d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ItalicIcon", "octicon octicon-italic", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 2.75A.75.75 0 0 1 6.75 2h6.5a.75.75 0 0 1 0 1.5h-2.505l-3.858 9H9.25a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.505l3.858-9H6.75A.75.75 0 0 1 6 2.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10 4.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-3.514l-5.828 13h3.342a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.514l5.828-13H10.75a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1ac8e353f264c451 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("IterationsIcon", "octicon octicon-iterations", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 7.25a4.75 4.75 0 0 1 9.5 0 .75.75 0 0 0 1.5 0 6.25 6.25 0 1 0-6.25 6.25H12v2.146c0 .223.27.335.427.177l2.896-2.896a.25.25 0 0 0 0-.354l-2.896-2.896a.25.25 0 0 0-.427.177V12H7.25A4.75 4.75 0 0 1 2.5 7.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 10.5a8 8 0 1 1 16 0 .75.75 0 0 0 1.5 0 9.5 9.5 0 1 0-9.5 9.5h10.94l-2.72 2.72a.75.75 0 1 0 1.06 1.06l3.735-3.735c.44-.439.44-1.151 0-1.59L19.78 14.72a.75.75 0 0 0-1.06 1.06l2.72 2.72H10.5a8 8 0 0 1-8-8Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$21bf7011fb07ee55 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("KebabHorizontalIcon", "octicon octicon-kebab-horizontal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20 14a2 2 0 1 1-.001-3.999A2 2 0 0 1 20 14ZM6 12a2 2 0 1 1-3.999.001A2 2 0 0 1 6 12Zm8 0a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3dc0fe769dc7dcac = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("KeyIcon", "octicon octicon-key", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.5 0a5.499 5.499 0 1 1-1.288 10.848l-.932.932a.749.749 0 0 1-.53.22H7v.75a.749.749 0 0 1-.22.53l-.5.5a.749.749 0 0 1-.53.22H5v.75a.749.749 0 0 1-.22.53l-.5.5a.749.749 0 0 1-.53.22h-2A1.75 1.75 0 0 1 0 14.25v-2c0-.199.079-.389.22-.53l4.932-4.932A5.5 5.5 0 0 1 10.5 0Zm-4 5.5c-.001.431.069.86.205 1.269a.75.75 0 0 1-.181.768L1.5 12.56v1.69c0 .138.112.25.25.25h1.69l.06-.06v-1.19a.75.75 0 0 1 .75-.75h1.19l.06-.06v-1.19a.75.75 0 0 1 .75-.75h1.19l1.023-1.025a.75.75 0 0 1 .768-.18A4 4 0 1 0 6.5 5.5ZM11 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.75 8.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.75 0a8.25 8.25 0 1 1-2.541 16.101l-1.636 1.636a1.744 1.744 0 0 1-1.237.513H9.25a.25.25 0 0 0-.25.25v1.448a.876.876 0 0 1-.256.619l-.214.213a.75.75 0 0 1-.545.22H5.25a.25.25 0 0 0-.25.25v1A1.75 1.75 0 0 1 3.25 24h-1.5A1.75 1.75 0 0 1 0 22.25v-2.836c0-.464.185-.908.513-1.236l7.386-7.388A8.249 8.249 0 0 1 15.75 0ZM9 8.25a6.733 6.733 0 0 0 .463 2.462.75.75 0 0 1-.168.804l-7.722 7.721a.25.25 0 0 0-.073.177v2.836c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-1c0-.966.784-1.75 1.75-1.75H7.5v-1c0-.966.784-1.75 1.75-1.75h1.086a.25.25 0 0 0 .177-.073l1.971-1.972a.75.75 0 0 1 .804-.168A6.75 6.75 0 1 0 9 8.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$461de75d5470f3cd = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("KeyAsteriskIcon", "octicon octicon-key-asterisk", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75A2.75 2.75 0 0 1 2.75 0h10.5A2.75 2.75 0 0 1 16 2.75v10.5A2.75 2.75 0 0 1 13.25 16H2.75A2.75 2.75 0 0 1 0 13.25ZM2.75 1.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 4a.75.75 0 0 1 .75.75V6.7l1.69-.975a.75.75 0 0 1 .75 1.3L9.5 8l1.69.976a.75.75 0 0 1-.75 1.298L8.75 9.3v1.951a.75.75 0 0 1-1.5 0V9.299l-1.69.976a.75.75 0 0 1-.75-1.3L6.5 8l-1.69-.975a.75.75 0 0 1 .75-1.3l1.69.976V4.75A.75.75 0 0 1 8 4Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.75 8a.75.75 0 0 0-1.5 0v2.701l-2.34-1.35a.75.75 0 0 0-.75 1.298L10.5 12l-2.34 1.35a.75.75 0 1 0 .75 1.3l2.34-1.35V16a.75.75 0 0 0 1.5 0v-2.701l2.34 1.35a.75.75 0 0 0 .75-1.298L13.5 12l2.34-1.35a.75.75 0 0 0-.75-1.3l-2.34 1.351V8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$ed49a5296f9c40ce = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LawIcon", "octicon octicon-law", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75.75V2h.985c.304 0 .603.08.867.231l1.29.736c.038.022.08.033.124.033h2.234a.75.75 0 0 1 0 1.5h-.427l2.111 4.692a.75.75 0 0 1-.154.838l-.53-.53.529.531-.001.002-.002.002-.006.006-.006.005-.01.01-.045.04c-.21.176-.441.327-.686.45C14.556 10.78 13.88 11 13 11a4.498 4.498 0 0 1-2.023-.454 3.544 3.544 0 0 1-.686-.45l-.045-.04-.016-.015-.006-.006-.004-.004v-.001a.75.75 0 0 1-.154-.838L12.178 4.5h-.162c-.305 0-.604-.079-.868-.231l-1.29-.736a.245.245 0 0 0-.124-.033H8.75V13h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5V3.5h-.984a.245.245 0 0 0-.124.033l-1.289.737c-.265.15-.564.23-.869.23h-.162l2.112 4.692a.75.75 0 0 1-.154.838l-.53-.53.529.531-.001.002-.002.002-.006.006-.016.015-.045.04c-.21.176-.441.327-.686.45C4.556 10.78 3.88 11 3 11a4.498 4.498 0 0 1-2.023-.454 3.544 3.544 0 0 1-.686-.45l-.045-.04-.016-.015-.006-.006-.004-.004v-.001a.75.75 0 0 1-.154-.838L2.178 4.5H1.75a.75.75 0 0 1 0-1.5h2.234a.249.249 0 0 0 .125-.033l1.288-.737c.265-.15.564-.23.869-.23h.984V.75a.75.75 0 0 1 1.5 0Zm2.945 8.477c.285.135.718.273 1.305.273s1.02-.138 1.305-.273L13 6.327Zm-10 0c.285.135.718.273 1.305.273s1.02-.138 1.305-.273L3 6.327Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.75 2.75V4.5h1.975c.351 0 .694.106.984.303l1.697 1.154c.041.028.09.043.14.043h4.102a.75.75 0 0 1 0 1.5H20.07l3.366 7.68a.749.749 0 0 1-.23.896c-.1.074-.203.143-.31.206a6.296 6.296 0 0 1-.79.399 7.349 7.349 0 0 1-2.856.569 7.343 7.343 0 0 1-2.855-.568 6.205 6.205 0 0 1-.79-.4 3.205 3.205 0 0 1-.307-.202l-.005-.004a.749.749 0 0 1-.23-.896l3.368-7.68h-.886c-.351 0-.694-.106-.984-.303l-1.697-1.154a.246.246 0 0 0-.14-.043H12.75v14.5h4.487a.75.75 0 0 1 0 1.5H6.763a.75.75 0 0 1 0-1.5h4.487V6H9.275a.249.249 0 0 0-.14.043L7.439 7.197c-.29.197-.633.303-.984.303h-.886l3.368 7.68a.75.75 0 0 1-.209.878c-.08.065-.16.126-.31.223a6.077 6.077 0 0 1-.792.433 6.924 6.924 0 0 1-2.876.62 6.913 6.913 0 0 1-2.876-.62 6.077 6.077 0 0 1-.792-.433 3.483 3.483 0 0 1-.309-.221.762.762 0 0 1-.21-.88L3.93 7.5H2.353a.75.75 0 0 1 0-1.5h4.102c.05 0 .099-.015.141-.043l1.695-1.154c.29-.198.634-.303.985-.303h1.974V2.75a.75.75 0 0 1 1.5 0ZM2.193 15.198a5.414 5.414 0 0 0 2.557.635 5.414 5.414 0 0 0 2.557-.635L4.75 9.368Zm14.51-.024c.082.04.174.083.275.126.53.223 1.305.45 2.272.45a5.847 5.847 0 0 0 2.547-.576L19.25 9.367Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$870380bdcb26b5e8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LightBulbIcon", "octicon octicon-light-bulb", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5c-3.81 0-6.5 2.743-6.5 6.119 0 1.536.632 2.572 1.425 3.56.172.215.347.422.527.635l.096.112c.21.25.427.508.63.774.404.531.783 1.128.995 1.834a.75.75 0 0 1-1.436.432c-.138-.46-.397-.89-.753-1.357a18.111 18.111 0 0 0-.582-.714l-.092-.11c-.18-.212-.37-.436-.555-.667C4.87 12.016 4 10.651 4 8.618 4 4.363 7.415 1 12 1s8 3.362 8 7.619c0 2.032-.87 3.397-1.755 4.5-.185.23-.375.454-.555.667l-.092.109c-.21.248-.405.481-.582.714-.356.467-.615.898-.753 1.357a.751.751 0 0 1-1.437-.432c.213-.706.592-1.303.997-1.834.202-.266.419-.524.63-.774l.095-.112c.18-.213.355-.42.527-.634.793-.99 1.425-2.025 1.425-3.561C18.5 5.243 15.81 2.5 12 2.5ZM8.75 18h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5Zm.75 3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$69387b41dfc808f7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LinkIcon", "octicon octicon-link", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.78 3.653a3.936 3.936 0 1 1 5.567 5.567l-3.627 3.627a3.936 3.936 0 0 1-5.88-.353.75.75 0 0 0-1.18.928 5.436 5.436 0 0 0 8.12.486l3.628-3.628a5.436 5.436 0 1 0-7.688-7.688l-3 3a.75.75 0 0 0 1.06 1.061l3-3Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.28 11.153a3.936 3.936 0 0 1 5.88.353.75.75 0 0 0 1.18-.928 5.436 5.436 0 0 0-8.12-.486L2.592 13.72a5.436 5.436 0 1 0 7.688 7.688l3-3a.75.75 0 1 0-1.06-1.06l-3 3a3.936 3.936 0 0 1-5.567-5.568l3.627-3.627Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$2df139b4d9e44df1 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LinkExternalIcon", "octicon octicon-link-external", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 1.5 0v3.5A1.75 1.75 0 0 1 12.25 14h-8.5A1.75 1.75 0 0 1 2 12.25v-8.5C2 2.784 2.784 2 3.75 2Zm6.854-1h4.146a.25.25 0 0 1 .25.25v4.146a.25.25 0 0 1-.427.177L13.03 4.03 9.28 7.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.75-3.75-1.543-1.543A.25.25 0 0 1 10.604 1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L19.94 3h-3.69a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 4.25c0-.966.784-1.75 1.75-1.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h15.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5a1.75 1.75 0 0 1-1.75 1.75H4.25a1.75 1.75 0 0 1-1.75-1.75V4.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$337139085529da4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ListOrderedIcon", "octicon octicon-list-ordered", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 3.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 3.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75ZM.924 10.32a.5.5 0 0 1-.851-.525l.001-.001.001-.002.002-.004.007-.011c.097-.144.215-.273.348-.384.228-.19.588-.392 1.068-.392.468 0 .858.181 1.126.484.259.294.377.673.377 1.038 0 .987-.686 1.495-1.156 1.845l-.047.035c-.303.225-.522.4-.654.597h1.357a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5c0-1.005.692-1.52 1.167-1.875l.035-.025c.531-.396.8-.625.8-1.078a.57.57 0 0 0-.128-.376C1.806 10.068 1.695 10 1.5 10a.658.658 0 0 0-.429.163.835.835 0 0 0-.144.153ZM2.003 2.5V6h.503a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1h.503V3.308l-.28.14a.5.5 0 0 1-.446-.895l1.003-.5a.5.5 0 0 1 .723.447Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.604 3.089A.75.75 0 0 1 4 3.75V8.5h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.75V5.151l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037ZM8.75 5.5a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75ZM5.5 15.75c0-.704-.271-1.286-.72-1.686a2.302 2.302 0 0 0-1.53-.564c-.535 0-1.094.178-1.53.565-.449.399-.72.982-.72 1.685a.75.75 0 0 0 1.5 0c0-.296.104-.464.217-.564A.805.805 0 0 1 3.25 15c.215 0 .406.072.533.185.113.101.217.268.217.565 0 .332-.069.48-.21.657-.092.113-.216.24-.403.419l-.147.14c-.152.144-.33.313-.52.504l-1.5 1.5a.75.75 0 0 0-.22.53v.25c0 .414.336.75.75.75H5A.75.75 0 0 0 5 19H3.31l.47-.47c.176-.176.333-.324.48-.465l.165-.156a5.98 5.98 0 0 0 .536-.566c.358-.447.539-.925.539-1.593Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$58d7dc7a4e6c368e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ListUnorderedIcon", "octicon octicon-list-unordered", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 2.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 5.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ec1acb4261485f12 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LocationIcon", "octicon octicon-location", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.071 3.429h.001c3.905 3.905 3.905 10.237 0 14.142l-5.403 5.403a2.36 2.36 0 0 1-3.336 0l-5.375-5.375-.028-.028c-3.905-3.905-3.905-10.237 0-14.142 3.904-3.905 10.236-3.905 14.141 0ZM5.99 4.489v.001a8.5 8.5 0 0 0 0 12.02l.023.024.002.002 5.378 5.378a.859.859 0 0 0 1.214 0l5.403-5.404a8.5 8.5 0 0 0-.043-11.977A8.5 8.5 0 0 0 5.99 4.489Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$37ea31f99740f2be = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LockIcon", "octicon octicon-lock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 4a4 4 0 0 1 8 0v2h.25c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-5.5C2 6.784 2.784 6 3.75 6H4Zm8.25 3.5h-8.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM10.5 6V4a2.5 2.5 0 1 0-5 0v2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 9V7.25C6 3.845 8.503 1 12 1s6 2.845 6 6.25V9h.5a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9Zm-1.5 2.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Zm3-4.25V9h9V7.25c0-2.67-1.922-4.75-4.5-4.75-2.578 0-4.5 2.08-4.5 4.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$17de720b716854b5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LockupGithubIcon", "octicon octicon-lockup-github", function() {
    return {
        "16": {
            "width": 68,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M24.606 2.058c2.796 0 4.485 1.194 5.024 3.204l-2.504.597c-.306-1.092-1.18-1.69-2.52-1.69-1.995 0-3.072 1.311-3.072 3.801s1.048 3.83 3.014 3.83c1.656 0 2.7-.93 2.861-2.534h-3.065V7.17h5.592v1.326c0 3.48-2.024 5.417-5.432 5.417-3.378 0-5.504-2.316-5.504-5.942s2.17-5.912 5.606-5.912m28.554 8.372c0 1.005.45 1.559 1.31 1.559.99 0 1.747-.918 1.747-2.17V5.51h2.316v8.183h-2.316V12.31c-.436.888-1.485 1.529-2.606 1.529-1.791 0-2.767-.99-2.767-2.796V5.509h2.315z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M62.055 7.01c.471-.99 1.535-1.69 2.607-1.69 2.233 0 3.412 1.544 3.334 4.267.079 2.694-1.145 4.252-3.334 4.252-1.116 0-2.136-.641-2.621-1.558v1.412H59.74V2.277h2.315zm1.791.247c-.955 0-1.713.932-1.79 2.213v.131c.077 1.325.835 2.301 1.79 2.301 1.2 0 1.855-.888 1.777-2.315.078-1.442-.577-2.33-1.777-2.33"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M33.11 13.693h-2.3V5.51h2.3zm4.636-8.183h1.703v1.922h-1.703v3.713c0 .451.203.626.655.626h1.048v1.922h-1.878c-1.53 0-2.126-.655-2.126-2.039V7.432h-1.456V5.509h1.456V3.88l2.3-.54zm5.15-3.233v4.63h4.34v-4.63h2.475v11.416h-2.476V9.121h-4.34v4.572H40.42V2.277zM31.96 2a1.35 1.35 0 0 1 1.369 1.369 1.35 1.35 0 0 1-1.369 1.369 1.35 1.35 0 0 1-1.369-1.37A1.35 1.35 0 0 1 31.96 2M6.766 11.328c-2.063-.25-3.516-1.734-3.516-3.656 0-.781.281-1.625.75-2.188-.203-.515-.172-1.609.063-2.062.625-.078 1.468.25 1.968.703.594-.187 1.219-.281 1.985-.281.765 0 1.39.094 1.953.265.484-.437 1.344-.765 1.969-.687.218.422.25 1.515.046 2.047.5.593.766 1.39.766 2.203 0 1.922-1.453 3.375-3.547 3.64.531.344.89 1.094.89 1.954v1.625c0 .468.391.734.86.547C13.781 14.359 16 11.53 16 8.03 16 3.61 12.406 0 7.984 0 3.563 0 0 3.61 0 8.031a7.88 7.88 0 0 0 5.172 7.422c.422.156.828-.125.828-.547v-1.25c-.219.094-.5.156-.75.156-1.031 0-1.64-.562-2.078-1.609-.172-.422-.36-.672-.719-.719-.187-.015-.25-.093-.25-.187 0-.188.313-.328.625-.328.453 0 .844.281 1.25.86.313.452.64.655 1.031.655s.641-.14 1-.5c.266-.265.47-.5.657-.656"
            }))
        },
        "24": {
            "width": 103,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M36.472 3.088c4.225 0 6.777 1.805 7.591 4.841l-3.784.902c-.462-1.65-1.783-2.552-3.807-2.552-3.015 0-4.643 1.98-4.643 5.743s1.584 5.787 4.555 5.787c2.502 0 4.079-1.406 4.323-3.829h-4.631v-3.168h8.45v2.002c0 5.26-3.059 8.186-8.208 8.186C31.213 21 28 17.501 28 12.022c0-5.48 3.279-8.934 8.472-8.934M79.62 15.741c0 1.518.682 2.355 1.98 2.355 1.497 0 2.64-1.387 2.64-3.28V8.304h3.5V20.67h-3.5v-2.09c-.66 1.342-2.244 2.31-3.938 2.31-2.707 0-4.181-1.496-4.181-4.225V8.303h3.499z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M93.063 10.57C93.775 9.073 95.38 8.017 97 8.017c3.375 0 5.158 2.333 5.039 6.448.119 4.07-1.73 6.425-5.039 6.425-1.686 0-3.226-.968-3.96-2.355v2.135h-3.477V3.418h3.499zm2.706.374c-1.444 0-2.588 1.408-2.707 3.345v.198c.119 2.002 1.263 3.476 2.707 3.476 1.813 0 2.803-1.342 2.685-3.498.118-2.179-.872-3.521-2.685-3.521"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M49.323 20.67h-3.477V8.303h3.477zm7.004-12.367h2.575v2.905h-2.575v5.611c0 .682.308.946.99.946h1.585v2.905h-2.839c-2.31 0-3.212-.99-3.212-3.08v-6.382H50.65V8.303h2.2V5.84l3.477-.814zm7.783-4.885v6.998h6.558V3.418h3.74V20.67h-3.74v-6.91H64.11v6.91h-3.74V3.418zM47.584 3c1.167 0 2.069.902 2.069 2.069a2.04 2.04 0 0 1-2.069 2.068 2.04 2.04 0 0 1-2.068-2.068c0-1.167.902-2.069 2.068-2.069M10.226 17.284c-2.965-.36-5.054-2.493-5.054-5.256 0-1.123.404-2.336 1.078-3.144-.292-.741-.247-2.314.09-2.965.898-.112 2.111.36 2.83 1.01.853-.269 1.752-.404 2.853-.404 1.1 0 1.999.135 2.807.382.696-.629 1.932-1.1 2.83-.988.315.606.36 2.179.067 2.942.72.854 1.101 2 1.101 3.167 0 2.763-2.089 4.852-5.098 5.234.763.494 1.28 1.572 1.28 2.807v2.336c0 .674.561 1.056 1.235.786 4.066-1.55 7.255-5.615 7.255-10.646C23.5 6.188 18.334 1 11.978 1 5.62 1 .5 6.188.5 12.545c0 4.986 3.167 9.12 7.435 10.669.606.225 1.19-.18 1.19-.786V20.63a2.9 2.9 0 0 1-1.078.224c-1.483 0-2.359-.808-2.987-2.313-.247-.607-.517-.966-1.034-1.033-.27-.023-.359-.135-.359-.27 0-.27.45-.471.898-.471.652 0 1.213.404 1.797 1.235.45.651.921.943 1.483.943.561 0 .92-.202 1.437-.719.382-.381.674-.718.944-.943"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$f60c77e5a3352735 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LogIcon", "octicon octicon-log", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 8.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 5 8.25ZM4 10.5A.75.75 0 0 0 4 12h4a.75.75 0 0 0 0-1.5H4Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13-.005c1.654 0 3 1.328 3 3 0 .982-.338 1.933-.783 2.818-.443.879-1.028 1.758-1.582 2.588l-.011.017c-.568.853-1.104 1.659-1.501 2.446-.398.789-.623 1.494-.623 2.136a1.5 1.5 0 1 0 2.333-1.248.75.75 0 0 1 .834-1.246A3 3 0 0 1 13 16H3a3 3 0 0 1-3-3c0-1.582.891-3.135 1.777-4.506.209-.322.418-.637.623-.946.473-.709.923-1.386 1.287-2.048H2.51c-.576 0-1.381-.133-1.907-.783A2.68 2.68 0 0 1 0 2.995a3 3 0 0 1 3-3Zm0 1.5a1.5 1.5 0 0 0-1.5 1.5c0 .476.223.834.667 1.132A.75.75 0 0 1 11.75 5.5H5.368c-.467 1.003-1.141 2.015-1.773 2.963-.192.289-.381.571-.558.845C2.13 10.711 1.5 11.916 1.5 13A1.5 1.5 0 0 0 3 14.5h7.401A2.989 2.989 0 0 1 10 13c0-.979.338-1.928.784-2.812.441-.874 1.023-1.748 1.575-2.576l.017-.026c.568-.853 1.103-1.658 1.501-2.448.398-.79.623-1.497.623-2.143 0-.838-.669-1.5-1.5-1.5Zm-10 0a1.5 1.5 0 0 0-1.5 1.5c0 .321.1.569.27.778.097.12.325.227.74.227h7.674A2.737 2.737 0 0 1 10 2.995c0-.546.146-1.059.401-1.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.197 10a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-2.382 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-1.581 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.125 0h15.75a4.11 4.11 0 0 1 2.92 1.205A4.11 4.11 0 0 1 24 4.125c0 1.384-.476 2.794-1.128 4.16-.652 1.365-1.515 2.757-2.352 4.104l-.008.013c-.849 1.368-1.669 2.691-2.28 3.97-.614 1.283-.982 2.45-.982 3.503a2.625 2.625 0 1 0 4.083-2.183.75.75 0 1 1 .834-1.247A4.126 4.126 0 0 1 19.875 24H4.5a4.125 4.125 0 0 1-4.125-4.125c0-2.234 1.258-4.656 2.59-6.902.348-.586.702-1.162 1.05-1.728.8-1.304 1.567-2.553 2.144-3.738H3.39c-.823 0-1.886-.193-2.567-1.035A3.647 3.647 0 0 1 0 4.125 4.125 4.125 0 0 1 4.125 0ZM15.75 19.875c0-1.38.476-2.786 1.128-4.15.649-1.358 1.509-2.743 2.343-4.086l.017-.028c.849-1.367 1.669-2.692 2.28-3.972.614-1.285.982-2.457.982-3.514A2.615 2.615 0 0 0 19.875 1.5a2.625 2.625 0 0 0-2.625 2.625c0 .865.421 1.509 1.167 2.009A.75.75 0 0 1 18 7.507H7.812c-.65 1.483-1.624 3.069-2.577 4.619-.334.544-.666 1.083-.98 1.612-1.355 2.287-2.38 4.371-2.38 6.137A2.625 2.625 0 0 0 4.5 22.5h12.193a4.108 4.108 0 0 1-.943-2.625ZM1.5 4.125c-.01.511.163 1.008.487 1.403.254.313.74.479 1.402.479h12.86a3.648 3.648 0 0 1-.499-1.882 4.11 4.11 0 0 1 .943-2.625H4.125A2.625 2.625 0 0 0 1.5 4.125Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$1ea2365b5279873d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LogoGistIcon", "octicon octicon-logo-gist", function() {
    return {
        "16": {
            "width": 25,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.7 8.73v-1h3.52v5.69c-.78.37-1.95.64-3.59.64C1.11 14.06 0 11.37 0 8.03 0 4.69 1.13 2 4.63 2c1.62 0 2.64.33 3.28.66v1.05c-1.22-.5-2-.73-3.28-.73-2.57 0-3.48 2.21-3.48 5.06 0 2.85.91 5.05 3.47 5.05.89 0 1.98-.07 2.53-.34V8.73Zm10.98.69h.03c2.22.2 2.75.95 2.75 2.23 0 1.21-.76 2.41-3.14 2.41-.75 0-1.83-.19-2.33-.39v-.94c.47.17 1.22.36 2.33.36 1.62 0 2.06-.69 2.06-1.42 0-.71-.22-1.21-1.77-1.34-2.26-.2-2.73-1-2.73-2.08 0-1.11.72-2.31 2.92-2.31.73 0 1.56.09 2.25.39v.94c-.61-.2-1.22-.36-2.27-.36-1.55 0-1.88.57-1.88 1.34 0 .69.28 1.04 1.78 1.17Zm8.58-3.33v.85h-2.42v4.87c0 .95.53 1.34 1.5 1.34.2 0 .42 0 .61-.03v.89c-.17.03-.5.05-.69.05-1.31 0-2.5-.6-2.5-2.13v-5H19.2v-.48l1.56-.44V3.9l1.08-.31v2.5h2.42Zm-13.17-.03v6.41c0 .54.19.7.67.7v.89c-1.14 0-1.72-.47-1.72-1.72V6.06h1.05Zm.25-2.33c0 .44-.34.78-.78.78a.76.76 0 0 1-.77-.78c0-.44.32-.78.77-.78s.78.34.78.78Z"
            })
        },
        "24": {
            "width": 38,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.05 13.095v-1.5h5.28v8.535c-1.17.555-2.925.96-5.385.96C1.665 21.09 0 17.055 0 12.045S1.695 3 6.945 3c2.43 0 3.96.495 4.92.99v1.575c-1.83-.75-3-1.095-4.92-1.095-3.855 0-5.22 3.315-5.22 7.59s1.365 7.575 5.205 7.575c1.335 0 2.97-.105 3.795-.51v-6.03H7.05Zm16.47 1.035h.045c3.33.3 4.125 1.425 4.125 3.345 0 1.815-1.14 3.615-4.71 3.615-1.125 0-2.745-.285-3.495-.585v-1.41c.705.255 1.83.54 3.495.54 2.43 0 3.09-1.035 3.09-2.13 0-1.065-.33-1.815-2.655-2.01-3.39-.3-4.095-1.5-4.095-3.12 0-1.665 1.08-3.465 4.38-3.465 1.095 0 2.34.135 3.375.585v1.41c-.915-.3-1.83-.54-3.405-.54-2.325 0-2.82.855-2.82 2.01 0 1.035.42 1.56 2.67 1.755Zm12.87-4.995v1.275h-3.63v7.305c0 1.425.795 2.01 2.25 2.01.3 0 .63 0 .915-.045v1.335c-.255.045-.75.075-1.035.075-1.965 0-3.75-.9-3.75-3.195v-7.5H28.8v-.72l2.34-.66V5.85l1.62-.465v3.75h3.63ZM16.635 9.09v9.615c0 .81.285 1.05 1.005 1.05v1.335c-1.71 0-2.58-.705-2.58-2.58V9.09h1.575Zm.375-3.495c0 .66-.51 1.17-1.17 1.17a1.14 1.14 0 0 1-1.155-1.17c0-.66.48-1.17 1.155-1.17s1.17.51 1.17 1.17Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$84b1561256ace7fe = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LogoGithubIcon", "octicon octicon-logo-github", function() {
    return {
        "16": {
            "width": 49,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.606 2.058c2.796 0 4.485 1.194 5.024 3.204l-2.505.597c-.305-1.092-1.179-1.69-2.519-1.69-1.995 0-3.072 1.311-3.072 3.801s1.048 3.83 3.014 3.83c1.656 0 2.7-.93 2.861-2.534H5.344V7.17h5.592v1.326c0 3.48-2.024 5.417-5.432 5.417C2.126 13.912 0 11.596 0 7.97s2.17-5.912 5.606-5.912m28.554 8.373c0 1.005.45 1.559 1.31 1.559.99 0 1.747-.918 1.747-2.17V5.51h2.316v8.183h-2.316V12.31c-.436.888-1.485 1.529-2.606 1.529-1.791 0-2.767-.99-2.767-2.796V5.509h2.315z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M43.055 7.01c.471-.99 1.535-1.69 2.607-1.69 2.233 0 3.413 1.544 3.334 4.267.078 2.694-1.145 4.252-3.334 4.252-1.116 0-2.136-.641-2.621-1.558v1.412H40.74V2.277h2.315zm1.791.247c-.955 0-1.713.932-1.79 2.213v.131c.077 1.325.835 2.301 1.79 2.301 1.2 0 1.855-.888 1.777-2.315.078-1.442-.577-2.33-1.777-2.33"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.11 13.693h-2.3V5.51h2.3zm4.636-8.183h1.703v1.922h-1.703v3.713c0 .451.204.626.655.626h1.048v1.922h-1.878c-1.53 0-2.126-.655-2.126-2.039V7.432h-1.456V5.509h1.456V3.88l2.3-.54zm5.15-3.233v4.63h4.34v-4.63h2.475v11.416h-2.476V9.121h-4.34v4.572H21.42V2.277zM12.96 2a1.35 1.35 0 0 1 1.369 1.369 1.35 1.35 0 0 1-1.369 1.369 1.35 1.35 0 0 1-1.369-1.37A1.35 1.35 0 0 1 12.96 2"
            }))
        },
        "24": {
            "width": 74,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.472 3.088c4.225 0 6.777 1.805 7.592 4.841l-3.785.902c-.462-1.65-1.783-2.552-3.807-2.552-3.015 0-4.643 1.98-4.643 5.743s1.584 5.787 4.555 5.787c2.502 0 4.079-1.406 4.323-3.829H8.076v-3.168h8.45v2.002c0 5.26-3.059 8.186-8.208 8.186C3.213 21 0 17.501 0 12.022c0-5.48 3.279-8.934 8.472-8.934M51.62 15.741c0 1.518.682 2.355 1.98 2.355 1.496 0 2.64-1.387 2.64-3.28V8.304h3.5V20.67h-3.5v-2.09c-.66 1.342-2.244 2.31-3.938 2.31-2.707 0-4.181-1.496-4.181-4.225V8.303h3.499z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M65.063 10.57C65.775 9.073 67.38 8.017 69 8.017c3.375 0 5.157 2.333 5.04 6.448.118 4.07-1.73 6.425-5.04 6.425-1.686 0-3.226-.968-3.96-2.355v2.135h-3.477V3.418h3.499zm2.706.374c-1.444 0-2.588 1.408-2.707 3.345v.198c.119 2.002 1.263 3.476 2.707 3.476 1.813 0 2.803-1.342 2.685-3.498.118-2.179-.872-3.521-2.685-3.521"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.323 20.67h-3.477V8.303h3.477zm7.004-12.367h2.575v2.905h-2.575v5.611c0 .682.308.946.99.946h1.585v2.905h-2.839c-2.31 0-3.212-.99-3.212-3.08v-6.382H22.65V8.303h2.2V5.84l3.477-.814zm7.783-4.885v6.998h6.557V3.418h3.741V20.67h-3.74v-6.91H36.11v6.91h-3.74V3.418zM19.584 3c1.167 0 2.069.902 2.069 2.069a2.04 2.04 0 0 1-2.069 2.068 2.04 2.04 0 0 1-2.068-2.068c0-1.167.902-2.069 2.068-2.069"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$ab1b7565a980cdcc = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("LoopIcon", "octicon octicon-loop", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.896 4.559a6.25 6.25 0 0 1 8.839 0 .75.75 0 0 1-1.06 1.061 4.75 4.75 0 1 0 0 6.717L13.03 8.98l-1.553-1.554A.25.25 0 0 1 11.654 7h4.096a.25.25 0 0 1 .25.25v4.096a.25.25 0 0 1-.427.177l-1.482-1.482-3.356 3.356a6.25 6.25 0 0 1-8.839-8.838Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.109 5.603a9.001 9.001 0 0 1 12.728 0 .75.75 0 1 1-1.061 1.061 7.5 7.5 0 0 0-10.606 0 7.5 7.5 0 0 0 0 10.606 7.5 7.5 0 0 0 10.606 0l5.821-5.82H17.3a.75.75 0 0 1 0-1.5h4.75a1 1 0 0 1 1 1v4.75a.75.75 0 1 1-1.5 0v-3.083l-5.713 5.714A9 9 0 0 1 3.109 5.603Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$6c65bc9b1cd4941d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MailIcon", "octicon octicon-mail", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.76 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 18.75v-14C0 3.784.784 3 1.75 3ZM1.5 7.412V18.75c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0Zm0-2.662v.852l10.36 7a.25.25 0 0 0 .28 0l10.36-7V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$afa80e6d91a34fff = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MarkGithubIcon", "octicon octicon-mark-github", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.766 11.328c-2.063-.25-3.516-1.734-3.516-3.656 0-.781.281-1.625.75-2.188-.203-.515-.172-1.609.063-2.062.625-.078 1.468.25 1.968.703.594-.187 1.219-.281 1.985-.281.765 0 1.39.094 1.953.265.484-.437 1.344-.765 1.969-.687.218.422.25 1.515.046 2.047.5.593.766 1.39.766 2.203 0 1.922-1.453 3.375-3.547 3.64.531.344.89 1.094.89 1.954v1.625c0 .468.391.734.86.547C13.781 14.359 16 11.53 16 8.03 16 3.61 12.406 0 7.984 0 3.563 0 0 3.61 0 8.031a7.88 7.88 0 0 0 5.172 7.422c.422.156.828-.125.828-.547v-1.25c-.219.094-.5.156-.75.156-1.031 0-1.64-.562-2.078-1.609-.172-.422-.36-.672-.719-.719-.187-.015-.25-.093-.25-.187 0-.188.313-.328.625-.328.453 0 .844.281 1.25.86.313.452.64.655 1.031.655s.641-.14 1-.5c.266-.265.47-.5.657-.656"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.226 17.284c-2.965-.36-5.054-2.493-5.054-5.256 0-1.123.404-2.336 1.078-3.144-.292-.741-.247-2.314.09-2.965.898-.112 2.111.36 2.83 1.01.853-.269 1.752-.404 2.853-.404 1.1 0 1.999.135 2.807.382.696-.629 1.932-1.1 2.83-.988.315.606.36 2.179.067 2.942.72.854 1.101 2 1.101 3.167 0 2.763-2.089 4.852-5.098 5.234.763.494 1.28 1.572 1.28 2.807v2.336c0 .674.561 1.056 1.235.786 4.066-1.55 7.255-5.615 7.255-10.646C23.5 6.188 18.334 1 11.978 1 5.62 1 .5 6.188.5 12.545c0 4.986 3.167 9.12 7.435 10.669.606.225 1.19-.18 1.19-.786V20.63a2.9 2.9 0 0 1-1.078.224c-1.483 0-2.359-.808-2.987-2.313-.247-.607-.517-.966-1.034-1.033-.27-.023-.359-.135-.359-.27 0-.27.45-.471.898-.471.652 0 1.213.404 1.797 1.235.45.651.921.943 1.483.943.561 0 .92-.202 1.437-.719.382-.381.674-.718.944-.943"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8c30830df44f5ccc = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MarkdownIcon", "octicon octicon-markdown", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.85 3c.63 0 1.15.52 1.14 1.15v7.7c0 .63-.51 1.15-1.15 1.15H1.15C.52 13 0 12.48 0 11.84V4.15C0 3.52.52 3 1.15 3ZM9 11V5H7L5.5 7 4 5H2v6h2V8l1.5 1.92L7 8v3Zm2.99.5L14.5 8H13V5h-2v3H9.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22.289 4.5A1.71 1.71 0 0 1 24 6.226v11.557c0 .946-.766 1.726-1.726 1.726H1.726A1.74 1.74 0 0 1 0 17.768V6.226C0 5.28.78 4.5 1.726 4.5Zm-8.781 12.007V7.501h-3.002l-2.251 3.002-2.252-3.002H3.002v9.006h3.001v-4.503l2.252 2.882 2.251-2.882v4.503Zm4.489.75 3.767-5.253h-2.251V7.501h-3.002v4.503h-2.252Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ad8cd11d6f0ad24c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MaximizeIcon", "octicon octicon-maximize", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.137 8.803a.749.749 0 1 1 1.06 1.06L3.811 13.25H6a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v2.19l3.387-3.387ZM14.75 6a.75.75 0 0 1-1.5 0V3.811L9.863 7.197a.749.749 0 1 1-1.06-1.06L12.19 2.75H10a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.47 13.47a.749.749 0 1 1 1.06 1.06l-5.719 5.72H9a.75.75 0 0 1 0 1.5H3a.731.731 0 0 1-.133-.013l-.016-.003c-.014-.002-.026-.008-.039-.011-.034-.009-.067-.017-.099-.031a.659.659 0 0 1-.083-.044.696.696 0 0 1-.279-.279A.713.713 0 0 1 2.25 21v-6a.75.75 0 0 1 1.5 0v4.189l5.72-5.719ZM21 2.25a.72.72 0 0 1 .132.012l.016.003c.014.002.026.008.04.011.033.009.066.017.098.031a.659.659 0 0 1 .083.044.696.696 0 0 1 .279.279.659.659 0 0 1 .102.37v6a.75.75 0 0 1-1.5 0V4.811l-5.72 5.719a.749.749 0 1 1-1.06-1.06l5.719-5.72H15a.75.75 0 0 1 0-1.5h6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f2d93e7a75c08514 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("McpIcon", "octicon octicon-mcp", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.52 1.12a3.578 3.578 0 0 1 6.078 2.98 3.578 3.578 0 0 1 2.982 6.08l-3.292 3.293a.252.252 0 0 0 0 .354l.843.843a.749.749 0 1 1-1.06 1.06l-.844-.843a1.75 1.75 0 0 1 0-2.474L13.52 9.12a2.08 2.08 0 0 0 0-2.94 2.08 2.08 0 0 0-2.94 0L7.731 9.03A.75.75 0 0 1 6.67 7.97l2.85-2.85a2.08 2.08 0 0 0 0-2.94 2.08 2.08 0 0 0-2.94 0l-4.799 4.8A.75.75 0 0 1 .72 5.92Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.52 3.12a.749.749 0 1 1 1.06 1.06L5.731 7.03A2.079 2.079 0 0 0 8.67 9.97l2.85-2.85a.749.749 0 1 1 1.06 1.06l-2.849 2.85A3.578 3.578 0 0 1 4.67 5.97Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.795 1.694a4.287 4.287 0 0 1 6.061 0 4.28 4.28 0 0 1 1.181 3.819 4.282 4.282 0 0 1 3.819 1.181 4.287 4.287 0 0 1 0 6.061l-6.793 6.793a.249.249 0 0 0 0 .353l2.617 2.618a.75.75 0 1 1-1.061 1.061l-2.617-2.618a1.75 1.75 0 0 1 0-2.475l6.793-6.793a2.785 2.785 0 1 0-3.939-3.939l-5.9 5.9a.734.734 0 0 1-.249.165.749.749 0 0 1-.812-1.225l5.9-5.901a2.785 2.785 0 1 0-3.939-3.939L2.931 10.68A.75.75 0 1 1 1.87 9.619l7.925-7.925Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.42 4.069a.752.752 0 0 1 1.061 0 .752.752 0 0 1 0 1.061L7.33 11.28a2.788 2.788 0 0 0 0 3.94 2.788 2.788 0 0 0 3.94 0l6.15-6.151a.752.752 0 0 1 1.061 0 .752.752 0 0 1 0 1.061l-6.151 6.15a4.285 4.285 0 1 1-6.06-6.06l6.15-6.151Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$ea0da4856fb919cc = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MegaphoneIcon", "octicon octicon-megaphone", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 9a.75.75 0 0 1 .75.75c0 2.142.456 3.828.733 4.653a.122.122 0 0 0 .05.064.212.212 0 0 0 .117.033h1.31c.085 0 .18-.042.258-.152a.45.45 0 0 0 .075-.366A16.743 16.743 0 0 1 6 9.75a.75.75 0 0 1 1.5 0c0 1.588.25 2.926.494 3.85.293 1.113-.504 2.4-1.783 2.4H4.9c-.686 0-1.35-.41-1.589-1.12A16.4 16.4 0 0 1 2.5 9.75.75.75 0 0 1 3.25 9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 6a4 4 0 0 1 4-4h2.75a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75H4a4 4 0 0 1-4-4Zm4-2.5a2.5 2.5 0 1 0 0 5h2v-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.59.082A.75.75 0 0 1 16 .75v10.5a.75.75 0 0 1-1.189.608l-.002-.001h.001l-.014-.01a5.775 5.775 0 0 0-.422-.25 10.63 10.63 0 0 0-1.469-.64C11.576 10.484 9.536 10 6.75 10a.75.75 0 0 1 0-1.5c2.964 0 5.174.516 6.658 1.043.423.151.787.302 1.092.443V2.014c-.305.14-.669.292-1.092.443C11.924 2.984 9.713 3.5 6.75 3.5a.75.75 0 0 1 0-1.5c2.786 0 4.826-.484 6.155-.957.665-.236 1.154-.47 1.47-.64.144-.077.284-.161.421-.25l.014-.01a.75.75 0 0 1 .78-.061Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22 1.75v14.5a.75.75 0 0 1-.399.662c-.384.204-.783-.035-1.139-.248l-.003-.002c-.09-.054-.177-.107-.261-.15a15.53 15.53 0 0 0-2-.849c-1.738-.607-4.321-1.223-7.703-1.251a.833.833 0 0 1 .005.088c0 2.279.494 4.279.906 5.547.368 1.131-.438 2.453-1.732 2.453H7.661c-.696 0-1.36-.42-1.6-1.129C5.684 20.255 5 17.811 5 14.75v-.457A5.5 5.5 0 0 1 6.5 3.5h3.75c3.505 0 6.175-.61 7.955-1.21a15.88 15.88 0 0 0 2.002-.82 9.21 9.21 0 0 0 .49-.262c.048-.028.095-.055.142-.085A.751.751 0 0 1 22 1.75ZM10.5 12.912c3.564.029 6.313.678 8.193 1.335.737.258 1.34.517 1.807.74V2.993c-.467.216-1.073.467-1.815.718-1.878.634-4.624 1.26-8.185 1.288ZM6.5 5a4 4 0 0 0 0 8H9V5Zm0 9.75c0 2.847.638 5.123.982 6.141.018.051.074.109.179.109h2.013c.087 0 .179-.043.249-.147a.396.396 0 0 0 .057-.343C9.537 19.148 9 16.986 9 14.5H6.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$bcbc995d0a05f9c0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MentionIcon", "octicon octicon-mention", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 .5a7.499 7.499 0 0 1 7.499 7.462l.002.038v1.164a2.612 2.612 0 0 1-4.783 1.454A3.763 3.763 0 0 1 8 11.776 3.776 3.776 0 1 1 11.776 8v1.164a1.112 1.112 0 0 0 2.225 0L14 8a6 6 0 1 0-3.311 5.365.75.75 0 0 1 .673 1.341A7.5 7.5 0 1 1 8 .5Zm0 5.225a2.275 2.275 0 1 0 0 4.552 2.275 2.275 0 0 0 0-4.552Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.226 7.25c-2.623-4.542-8.432-6.098-12.974-3.475-4.543 2.622-6.099 8.431-3.477 12.974 2.623 4.542 8.431 6.099 12.974 3.477a.75.75 0 0 1 .75 1.299c-5.26 3.037-11.987 1.235-15.024-4.026C-.562 12.24 1.24 5.512 6.501 2.475 11.76-.562 18.488 1.24 21.525 6.501a10.959 10.959 0 0 1 1.455 4.826c.013.056.02.113.02.173v2.25a3.5 3.5 0 0 1-6.623 1.581 5.5 5.5 0 1 1 1.112-3.682.802.802 0 0 1 .011.129v1.972a2 2 0 1 0 4 0v-1.766a9.456 9.456 0 0 0-1.274-4.733ZM16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b0216cc98375f15e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MeterIcon", "octicon octicon-meter", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 1.5a6.5 6.5 0 1 0 6.016 4.035.75.75 0 0 1 1.388-.57 8 8 0 1 1-4.37-4.37.75.75 0 1 1-.569 1.389A6.473 6.473 0 0 0 8 1.5Zm6.28.22a.75.75 0 0 1 0 1.06l-4.063 4.064a2.5 2.5 0 1 1-1.06-1.06L13.22 1.72a.75.75 0 0 1 1.06 0ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5a9.5 9.5 0 1 0 9.5 9.5c0-1.406-.305-2.74-.852-3.939a.75.75 0 0 1 1.364-.622C22.648 8.829 23 10.374 23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1c1.626 0 3.17.353 4.561.988a.75.75 0 1 1-.622 1.364A9.463 9.463 0 0 0 12 2.5Zm9.03.47a.75.75 0 0 1 0 1.06l-6.445 6.446a3 3 0 1 1-1.06-1.06L19.97 2.97a.75.75 0 0 1 1.06 0ZM12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$734bc5bdc236c5d8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MilestoneIcon", "octicon octicon-milestone", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.75 0a.75.75 0 0 1 .75.75V3h3.634c.414 0 .814.147 1.13.414l2.07 1.75a1.75 1.75 0 0 1 0 2.672l-2.07 1.75a1.75 1.75 0 0 1-1.13.414H8.5v5.25a.75.75 0 0 1-1.5 0V10H2.75A1.75 1.75 0 0 1 1 8.25v-3.5C1 3.784 1.784 3 2.75 3H7V.75A.75.75 0 0 1 7.75 0Zm4.384 8.5a.25.25 0 0 0 .161-.06l2.07-1.75a.248.248 0 0 0 0-.38l-2.07-1.75a.25.25 0 0 0-.161-.06H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h9.384Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.75 1a.75.75 0 0 1 .75.75V4h6.532c.42 0 .826.15 1.143.425l3.187 2.75a1.75 1.75 0 0 1 0 2.65l-3.187 2.75a1.75 1.75 0 0 1-1.143.425H12.5v9.25a.75.75 0 0 1-1.5 0V13H3.75A1.75 1.75 0 0 1 2 11.25v-5.5C2 4.783 2.784 4 3.75 4H11V1.75a.75.75 0 0 1 .75-.75Zm7.282 4.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h15.282c.06 0 .118-.021.163-.06l3.188-2.75a.248.248 0 0 0 0-.38l-3.188-2.75a.249.249 0 0 0-.163-.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$95300d23f5f56d39 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MinimizeIcon", "octicon octicon-minimize", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.668 8.583a.69.69 0 0 1 .13.012l.017.003c.01.002.02.007.031.01.036.009.073.017.108.032a.727.727 0 0 1 .243.163.711.711 0 0 1 .126.176.62.62 0 0 1 .036.067.822.822 0 0 1 .058.287l-.001 4a.75.75 0 0 1-1.5 0v-2.188L2.53 14.53a.749.749 0 1 1-1.06-1.06l3.387-3.387H2.666a.75.75 0 0 1 0-1.5h4.002ZM13.47 1.47a.749.749 0 1 1 1.06 1.06l-3.385 3.386h2.188a.75.75 0 0 1 0 1.5l-4 .001a.738.738 0 0 1-.231-.041c-.019-.006-.038-.01-.056-.017a.62.62 0 0 1-.067-.036.711.711 0 0 1-.384-.525.72.72 0 0 1-.012-.132v-4a.75.75 0 0 1 1.5 0v2.191L13.47 1.47Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10 13.25a.71.71 0 0 1 .149.015c.013.002.026.008.039.011.033.009.066.017.098.031a.753.753 0 0 1 .363.323c.015.027.031.054.043.083a.731.731 0 0 1 .058.287v6a.75.75 0 0 1-1.5 0v-4.189L3.53 21.53a.749.749 0 1 1-1.06-1.06l5.72-5.72H4a.75.75 0 0 1 0-1.5h6ZM20.47 2.47a.749.749 0 1 1 1.06 1.06l-5.719 5.72H20a.75.75 0 0 1 0 1.5h-6a.731.731 0 0 1-.133-.013c-.005-.001-.011-.001-.016-.003-.014-.002-.026-.008-.039-.011-.034-.009-.067-.017-.099-.031-.029-.012-.056-.028-.083-.043a.731.731 0 0 1-.38-.649V4a.75.75 0 0 1 1.5 0v4.19l5.72-5.72Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4795e9bc1ad58779 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MirrorIcon", "octicon octicon-mirror", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.547 3.061A.75.75 0 0 1 16 3.75v8.5a.751.751 0 0 1-1.265.545l-4.5-4.25a.75.75 0 0 1 0-1.09l4.5-4.25a.75.75 0 0 1 .812-.144ZM0 12.25v-8.5a.751.751 0 0 1 1.265-.545l4.5 4.25a.75.75 0 0 1 0 1.09l-4.5 4.25A.75.75 0 0 1 0 12.25Zm1.5-6.76v5.02L4.158 8ZM11.842 8l2.658 2.51V5.49ZM8 4a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 4Zm.75-2.25v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 1.5 0Zm0 6v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 1.5 0ZM8 10a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 10Zm0 3a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 13Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.553 6.064A.75.75 0 0 1 22 6.75v10.5a.75.75 0 0 1-1.256.554l-5.75-5.25a.748.748 0 0 1 0-1.108l5.75-5.25a.75.75 0 0 1 .809-.132ZM2.447 17.936A.75.75 0 0 1 2 17.25V6.75a.75.75 0 0 1 1.256-.554l5.75 5.25a.748.748 0 0 1 0 1.108l-5.75 5.25a.75.75 0 0 1-.809.132ZM7.387 12 3.5 8.45v7.1L7.388 12Zm9.226 0 3.887 3.55v-7.1L16.612 12ZM12 2.75a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0 4a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm0-8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$41051b6be05d5fb0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MoonIcon", "octicon octicon-moon", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.598 1.591a.749.749 0 0 1 .785-.175 7.001 7.001 0 1 1-8.967 8.967.75.75 0 0 1 .961-.96 5.5 5.5 0 0 0 7.046-7.046.75.75 0 0 1 .175-.786Zm1.616 1.945a7 7 0 0 1-7.678 7.678 5.499 5.499 0 1 0 7.678-7.678Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.768 3.96v.001l-.002-.005a9.08 9.08 0 0 0-.218-.779c-.13-.394.21-.8.602-.67.29.096.575.205.855.328l.01.005A10.002 10.002 0 0 1 12 22a10.002 10.002 0 0 1-9.162-5.985l-.004-.01a9.722 9.722 0 0 1-.329-.855c-.13-.392.277-.732.67-.602.257.084.517.157.78.218l.004.002A9 9 0 0 0 14.999 6a9.09 9.09 0 0 0-.231-2.04ZM16.5 6c0 5.799-4.701 10.5-10.5 10.5-.426 0-.847-.026-1.26-.075A8.5 8.5 0 1 0 16.425 4.74c.05.413.075.833.075 1.259Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$44fe5cea2c0c4d87 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MortarBoardIcon", "octicon octicon-mortar-board", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.693 1.066a.747.747 0 0 1 .614 0l7.25 3.25a.75.75 0 0 1 0 1.368L13 6.831v2.794c0 1.024-.81 1.749-1.66 2.173-.893.447-2.075.702-3.34.702-.278 0-.55-.012-.816-.036a.75.75 0 0 1 .133-1.494c.22.02.45.03.683.03 1.082 0 2.025-.221 2.67-.543.69-.345.83-.682.83-.832V7.503L8.307 8.934a.747.747 0 0 1-.614 0L4 7.28v1.663c.296.105.575.275.812.512.438.438.688 1.059.688 1.796v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3c0-.737.25-1.358.688-1.796.237-.237.516-.407.812-.512V6.606L.443 5.684a.75.75 0 0 1 0-1.368ZM2.583 5 8 7.428 13.416 5 8 2.572ZM2.5 11.25v2.25H4v-2.25c0-.388-.125-.611-.25-.735a.697.697 0 0 0-.5-.203.707.707 0 0 0-.5.203c-.125.124-.25.347-.25.735Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.292 2.06v-.001l11.25 4.75a.749.749 0 0 1 0 1.382L19 10.108V15a.75.75 0 0 1-.11.391h-.001a2.84 2.84 0 0 1-.392.482c-.249.256-.625.58-1.163.896-1.08.638-2.776 1.23-5.334 1.23-.673 0-1.286-.041-1.846-.113a.75.75 0 0 1 .192-1.487c.492.063 1.042.1 1.654.1 2.317 0 3.746-.533 4.572-1.021.31-.178.596-.397.849-.65l.079-.085V10.74l-5.208 2.2a.75.75 0 0 1-.584 0L5.75 10.424v3.17c.502.129.96.391 1.327.758.579.578.923 1.41.923 2.428v4.5a.761.761 0 0 1-.345.634 2.157 2.157 0 0 1-.21.117 3.923 3.923 0 0 1-.52.213A6.121 6.121 0 0 1 5 22.532a6.092 6.092 0 0 1-1.925-.288 4.065 4.065 0 0 1-.52-.213 1.816 1.816 0 0 1-.22-.124.757.757 0 0 1-.335-.624v-4.5c0-1.02.344-1.85.923-2.43a2.904 2.904 0 0 1 1.327-.757V9.793L.458 8.19a.75.75 0 0 1 0-1.38l11.25-4.75a.75.75 0 0 1 .584 0ZM12 11.436 21.322 7.5 12 3.564 2.678 7.5ZM5 15c-.377 0-.745.141-1.017.413-.265.265-.483.7-.483 1.368v4.022c.299.105.797.228 1.5.228s1.201-.123 1.5-.228V16.78c0-.669-.218-1.103-.483-1.368A1.433 1.433 0 0 0 5 15Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$377cc1726837327f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MoveToBottomIcon", "octicon octicon-move-to-bottom", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.47 10.78a.749.749 0 0 0 1.06 0l3.75-3.75a.749.749 0 1 0-1.06-1.06L8.75 8.439V1.75a.75.75 0 0 0-1.5 0v6.689L4.78 5.97a.749.749 0 1 0-1.06 1.06l3.75 3.75ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 21.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75ZM5.22 9.97a.749.749 0 0 1 1.06 0l4.97 4.969V2.75a.75.75 0 0 1 1.5 0v12.189l4.97-4.969a.749.749 0 1 1 1.06 1.06l-6.25 6.25a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$abbe911aeef8ac4e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MoveToEndIcon", "octicon octicon-move-to-end", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m10.78 8.53-3.75 3.75a.749.749 0 1 1-1.06-1.06l2.469-2.47H1.75a.75.75 0 0 1 0-1.5h6.689L5.97 4.78a.749.749 0 1 1 1.06-1.06l3.75 3.75a.749.749 0 0 1 0 1.06ZM13 12.25v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.22 5.22a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06l-6.25 6.25a.749.749 0 1 1-1.06-1.06l4.969-4.97H1.75a.75.75 0 0 1 0-1.5h14.439L11.22 6.28a.749.749 0 0 1 0-1.06Zm10.03-1.47a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$58d69b94a766904b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MoveToStartIcon", "octicon octicon-move-to-start", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.22 7.47a.749.749 0 0 0 0 1.06l3.75 3.75a.749.749 0 1 0 1.06-1.06L7.561 8.75h6.689a.75.75 0 0 0 0-1.5H7.561l2.469-2.47a.749.749 0 1 0-1.06-1.06L5.22 7.47ZM3 3.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.78 18.78a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 1 1 1.06 1.06l-4.969 4.97H22.25a.75.75 0 0 1 0 1.5H7.811l4.969 4.97a.749.749 0 0 1 0 1.06ZM2.75 3.75a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$26c7c9b4256f6586 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MoveToTopIcon", "octicon octicon-move-to-top", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 2.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 2.25Zm5.53 2.97 3.75 3.75a.749.749 0 1 1-1.06 1.06L8.75 7.561v6.689a.75.75 0 0 1-1.5 0V7.561L4.78 10.03a.749.749 0 1 1-1.06-1.06l3.75-3.75a.749.749 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 3.5a.75.75 0 0 1 0-1.5h14.5a.75.75 0 0 1 0 1.5H4.75Zm.47 9.47a.749.749 0 1 0 1.06 1.06l4.97-4.969V21.25a.75.75 0 0 0 1.5 0V9.061l4.97 4.969a.749.749 0 1 0 1.06-1.06l-6.25-6.25a.749.749 0 0 0-1.06 0l-6.25 6.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c3be1c67d3739de0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MultiSelectIcon", "octicon octicon-multi-select", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 7.5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Zm0 5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5Zm-4-10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10.314-3.082L11.07 2.417A.25.25 0 0 1 11.256 2h4.488a.25.25 0 0 1 .186.417l-2.244 2.5a.25.25 0 0 1-.372 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 11.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm-5-12h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM19.309 7.918l-2.245-2.501A.25.25 0 0 1 17.25 5h4.49a.25.25 0 0 1 .185.417l-2.244 2.5a.25.25 0 0 1-.372 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$673ebbe14e3d731d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("MuteIcon", "octicon octicon-mute", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 2.75v10.5a.751.751 0 0 1-1.238.57L3.473 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.722l3.29-2.82A.75.75 0 0 1 8 2.75Zm3.28 2.47L13 6.94l1.72-1.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L14.06 8l1.72 1.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L13 9.06l-1.72 1.72a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L11.94 8l-1.72-1.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-7.042 1.1a.752.752 0 0 1-.488.18h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2c.179 0 .352.064.488.18L6.5 11.62V4.38Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 3.75v16.5a.75.75 0 0 1-1.255.555L5.46 16H2.75A1.75 1.75 0 0 1 1 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805A.75.75 0 0 1 12 3.75ZM6.255 9.305a.748.748 0 0 1-.505.195h-3a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h3c.187 0 .367.069.505.195l4.245 3.86V5.445ZM16.28 8.22a.75.75 0 1 0-1.06 1.06L17.94 12l-2.72 2.72a.75.75 0 1 0 1.06 1.06L19 13.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L20.06 12l2.72-2.72a.75.75 0 0 0-1.06-1.06L19 10.94l-2.72-2.72Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$19c0c984084c753 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("NoEntryIcon", "octicon octicon-no-entry", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.25 7.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Zm15.75.75H5.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7918cde1533be8c0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("NoEntryFillIcon", "octicon octicon-no-entry-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm3 5H3v2h6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a25745d11bf8bde9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("NodeIcon", "octicon octicon-node", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 5a1.507 1.507 0 0 0 1.061-.439 1.507 1.507 0 0 0 0-2.122 1.507 1.507 0 0 0-2.122 0 1.503 1.503 0 0 0 0 2.122C7.221 4.842 7.602 5 8 5Zm0 9a1.507 1.507 0 0 0 1.061-.439 1.507 1.507 0 0 0 0-2.122 1.507 1.507 0 0 0-2.122 0 1.503 1.503 0 0 0 0 2.122c.282.281.663.439 1.061.439Zm-7-2.5v-7a1.75 1.75 0 0 1 1.75-1.75H4.5a.75.75 0 0 1 0 1.5H2.75a.25.25 0 0 0-.25.25v7l.005.049a.246.246 0 0 0 .245.201H4.5a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 11.5Zm12.5 0v-7a.25.25 0 0 0-.201-.245l-.049-.005H11.5a.75.75 0 0 1 0-1.5h1.75A1.75 1.75 0 0 1 15 4.5v7c0 .464-.184.909-.513 1.237a1.746 1.746 0 0 1-1.237.513H11.5a.75.75 0 0 1 0-1.5h1.75a.25.25 0 0 0 .25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7Zm0 14a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 21ZM2 18V6a1.75 1.75 0 0 1 1.75-1.75H7.5a.75.75 0 0 1 0 1.5H3.75A.25.25 0 0 0 3.5 6v12l.005.049a.246.246 0 0 0 .245.201H7.5a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 18Zm18.5 0V6a.25.25 0 0 0-.25-.25H16.5a.75.75 0 0 1 0-1.5h3.75A1.75 1.75 0 0 1 22 6v12c0 .464-.184.909-.513 1.237a1.746 1.746 0 0 1-1.237.513H16.5a.75.75 0 0 1 0-1.5h3.75a.25.25 0 0 0 .25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ee28a268adaf5c94 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("NorthStarIcon", "octicon octicon-north-star", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.5.75a.75.75 0 0 0-1.5 0v5.19L4.391 3.33a.75.75 0 1 0-1.06 1.061L5.939 7H.75a.75.75 0 0 0 0 1.5h5.19l-2.61 2.609a.75.75 0 1 0 1.061 1.06L7 9.561v5.189a.75.75 0 0 0 1.5 0V9.56l2.609 2.61a.75.75 0 1 0 1.06-1.061L9.561 8.5h5.189a.75.75 0 0 0 0-1.5H9.56l2.61-2.609a.75.75 0 0 0-1.061-1.06L8.5 5.939V.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.5 1.25a.75.75 0 0 0-1.5 0v8.69L6.447 5.385a.75.75 0 1 0-1.061 1.06L9.94 11H1.25a.75.75 0 0 0 0 1.5h8.69l-4.554 4.553a.75.75 0 0 0 1.06 1.061L11 13.561v8.689a.75.75 0 0 0 1.5 0v-8.69l4.553 4.554a.75.75 0 0 0 1.061-1.06L13.561 12.5h8.689a.75.75 0 0 0 0-1.5h-8.69l4.554-4.553a.75.75 0 1 0-1.06-1.061L12.5 9.939V1.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$70371617cfe16c87 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("NoteIcon", "octicon octicon-note", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM3.5 6.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 8.75A.75.75 0 0 1 5.75 8h11.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 8.75Zm0 4a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$d54ddb7fa76bbee2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("NumberIcon", "octicon octicon-number", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 4.75A.75.75 0 0 1 9.75 4h4a.75.75 0 0 1 .53 1.28l-1.89 1.892c.312.076.604.18.867.319.742.391 1.244 1.063 1.244 2.005 0 .653-.231 1.208-.629 1.627-.386.408-.894.653-1.408.777-1.01.243-2.225.063-3.124-.527a.751.751 0 0 1 .822-1.254c.534.35 1.32.474 1.951.322.306-.073.53-.201.67-.349.129-.136.218-.32.218-.596 0-.308-.123-.509-.444-.678-.373-.197-.98-.318-1.806-.318a.75.75 0 0 1-.53-1.28l1.72-1.72H9.75A.75.75 0 0 1 9 4.75Zm-3.587 5.763c-.35-.05-.77.113-.983.572a.75.75 0 1 1-1.36-.632c.508-1.094 1.589-1.565 2.558-1.425 1 .145 1.872.945 1.872 2.222 0 1.433-1.088 2.192-1.79 2.681-.308.216-.571.397-.772.573H7a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75c0-.69.3-1.211.67-1.61.348-.372.8-.676 1.15-.92.8-.56 1.18-.904 1.18-1.474 0-.473-.267-.69-.587-.737ZM5.604.089A.75.75 0 0 1 6 .75v4.77h.711a.75.75 0 0 1 0 1.5H3.759a.75.75 0 0 1 0-1.5H4.5V2.15l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.003 7.754a.75.75 0 0 1 .75-.75h5.232a.75.75 0 0 1 .53 1.28l-2.776 2.777c.55.097 1.057.253 1.492.483.905.477 1.504 1.284 1.504 2.418 0 .966-.471 1.75-1.172 2.27-.687.511-1.587.77-2.521.77-1.367 0-2.274-.528-2.667-.756a.75.75 0 0 1 .755-1.297c.331.193.953.553 1.912.553.673 0 1.243-.188 1.627-.473.37-.275.566-.635.566-1.067 0-.5-.219-.836-.703-1.091-.538-.284-1.375-.443-2.471-.443a.75.75 0 0 1-.53-1.28l2.643-2.644h-3.421a.75.75 0 0 1-.75-.75ZM7.88 15.215a1.4 1.4 0 0 0-1.446.83.75.75 0 0 1-1.37-.61 2.899 2.899 0 0 1 2.986-1.71c.589.06 1.139.323 1.557.743.434.446.685 1.058.685 1.778 0 1.641-1.254 2.437-2.12 2.986-.538.341-1.18.694-1.495 1.273H9.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75c0-1.799 1.337-2.63 2.243-3.21 1.032-.659 1.55-1.031 1.55-1.8 0-.355-.116-.584-.26-.732a1.071 1.071 0 0 0-.652-.298Zm.234-13.121a.75.75 0 0 1 .386.656V9h1.252a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5H7V4.103l-.853.533a.749.749 0 1 1-.795-1.272l2-1.25a.749.749 0 0 1 .762-.02Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8a496f5a1e4249b1 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("OrganizationIcon", "octicon octicon-organization", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 16A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 0 0 .25-.25V8.285a.25.25 0 0 0-.111-.208l-1.055-.703a.749.749 0 1 1 .832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0 1 14.25 16h-3.5a.766.766 0 0 1-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 0 1-.75-.75V14h-1v1.25a.75.75 0 0 1-.75.75Zm-.25-1.75c0 .138.112.25.25.25H4v-1.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.25h2.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM3.75 6h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 3.75A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Zm4 3A.75.75 0 0 1 7.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 7 6.75ZM7.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 9.75A.75.75 0 0 1 3.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 9.75ZM7.75 9h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM5.5 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM6.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 12.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm.75-4.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 5.75A.75.75 0 0 1 9.75 5h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 5.75ZM13.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-.75-2.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM13.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 20V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17c0 .173-.022.34-.063.5H20a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.2-.4l-.5-.375a.75.75 0 0 1 .9-1.2l.5.375c.504.378.8.97.8 1.6v8a2 2 0 0 1-2 2h-3.562a.767.767 0 0 1-.166-.018c-.089.012-.18.018-.272.018h-3.75a.75.75 0 0 1-.75-.75V19h-3v2.25a.75.75 0 0 1-.75.75H4a2 2 0 0 1-2-2Zm2 .5h3v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$4e926151f2105842 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PackageIcon", "octicon octicon-package", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.878.392 5.25 3.045c.54.314.872.89.872 1.514v6.098a1.75 1.75 0 0 1-.872 1.514l-5.25 3.045a1.75 1.75 0 0 1-1.756 0l-5.25-3.045A1.75 1.75 0 0 1 1 11.049V4.951c0-.624.332-1.201.872-1.514L7.122.392a1.75 1.75 0 0 1 1.756 0ZM7.875 1.69l-4.63 2.685L8 7.133l4.755-2.758-4.63-2.685a.248.248 0 0 0-.25 0ZM2.5 5.677v5.372c0 .09.047.171.125.216l4.625 2.683V8.432Zm6.25 8.271 4.625-2.683a.25.25 0 0 0 .125-.216V5.677L8.75 8.432Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.876.64V.639l8.25 4.763c.541.313.875.89.875 1.515v9.525a1.75 1.75 0 0 1-.875 1.516l-8.25 4.762a1.748 1.748 0 0 1-1.75 0l-8.25-4.763a1.75 1.75 0 0 1-.875-1.515V6.917c0-.625.334-1.202.875-1.515L11.126.64a1.748 1.748 0 0 1 1.75 0Zm-1 1.298L4.251 6.34l7.75 4.474 7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0Zm.875 19.123 7.625-4.402a.25.25 0 0 0 .125-.216V7.639l-7.75 4.474ZM3.501 7.64v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$10ac854e619b28ae = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PackageDependenciesIcon", "octicon octicon-package-dependencies", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514V7.25a.75.75 0 0 1-1.5 0V5.677L7.75 8.432v6.384a1 1 0 0 1-1.502.865L.872 12.563A1.75 1.75 0 0 1 0 11.049V4.951c0-.624.332-1.2.872-1.514ZM7.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685L7 7.133l4.755-2.758ZM1.5 11.049a.25.25 0 0 0 .125.216l4.625 2.683V8.432L1.5 5.677Zm11.672-.282L11.999 12h3.251a.75.75 0 0 1 0 1.5h-3.251l1.173 1.233a.75.75 0 1 1-1.087 1.034l-2.378-2.5a.75.75 0 0 1 0-1.034l2.378-2.5a.75.75 0 0 1 1.087 1.034Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.126.64a1.748 1.748 0 0 1 1.75 0l8.25 4.762c.103.06.199.128.286.206a.75.75 0 0 1 .554.96c.023.113.035.23.035.35v3.332a.75.75 0 0 1-1.5 0V7.64l-7.75 4.474V22.36a.75.75 0 0 1-1.125.65l-8.75-5.052a1.75 1.75 0 0 1-.875-1.515V6.917c0-.119.012-.236.035-.35a.749.749 0 0 1 .554-.96c.088-.078.184-.146.286-.205L9.126.639Zm.875 10.173v.001l7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0L2.251 6.34Zm-8.5-3.175v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m16.617 17.5 2.895-2.702a.75.75 0 0 0-1.024-1.096l-4.285 4a.75.75 0 0 0 0 1.096l4.285 4a.75.75 0 1 0 1.024-1.096L16.617 19h6.633a.75.75 0 0 0 0-1.5h-6.633Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$73418c33e4867499 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PackageDependentsIcon", "octicon octicon-package-dependents", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.122.392a1.75 1.75 0 0 1 1.756 0l5.25 3.045c.54.313.872.89.872 1.514V7.25a.75.75 0 0 1-1.5 0V5.677L7.75 8.432v6.384a1 1 0 0 1-1.502.865L.872 12.563A1.75 1.75 0 0 1 0 11.049V4.951c0-.624.332-1.2.872-1.514ZM7.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685L7 7.133l4.755-2.758ZM1.5 11.049a.25.25 0 0 0 .125.216l4.625 2.683V8.432L1.5 5.677Zm10.828 3.684 1.173-1.233H10.25a.75.75 0 0 1 0-1.5h3.251l-1.173-1.233a.75.75 0 1 1 1.087-1.034l2.378 2.5a.75.75 0 0 1 0 1.034l-2.378 2.5a.75.75 0 0 1-1.087-1.034Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.126.64a1.748 1.748 0 0 1 1.75 0l8.25 4.762c.103.06.199.128.286.206a.75.75 0 0 1 .554.96c.023.113.035.23.035.35v3.332a.75.75 0 0 1-1.5 0V7.64l-7.75 4.474V22.36a.75.75 0 0 1-1.125.65l-8.75-5.052a1.75 1.75 0 0 1-.875-1.515V6.917c0-.119.012-.236.035-.35a.749.749 0 0 1 .554-.96c.088-.078.184-.146.286-.205L9.126.639Zm.875 10.173v.001l7.75-4.474-7.625-4.402a.248.248 0 0 0-.25 0L2.251 6.34Zm-8.5-3.175v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m21.347 17.5-2.894-2.702a.75.75 0 1 1 1.023-1.096l4.286 4a.75.75 0 0 1 0 1.096l-4.286 4a.75.75 0 1 1-1.023-1.096L21.347 19h-6.633a.75.75 0 0 1 0-1.5h6.633Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6963b889227d4aa4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PaintbrushIcon", "octicon octicon-paintbrush", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.134 1.535c.7-.509 1.416-.942 2.076-1.155.649-.21 1.463-.267 2.069.34.603.601.568 1.411.368 2.07-.202.668-.624 1.39-1.125 2.096-1.011 1.424-2.496 2.987-3.775 4.249-1.098 1.084-2.132 1.839-3.04 2.3a3.744 3.744 0 0 1-1.055 3.217c-.431.431-1.065.691-1.657.861-.614.177-1.294.287-1.914.357A21.151 21.151 0 0 1 .797 16H.743l.007-.75H.749L.742 16a.75.75 0 0 1-.743-.742l.743-.008-.742.007v-.054a21.25 21.25 0 0 1 .13-2.284c.067-.647.187-1.287.358-1.914.17-.591.43-1.226.86-1.657a3.746 3.746 0 0 1 3.227-1.054c.466-.893 1.225-1.907 2.314-2.982 1.271-1.255 2.833-2.75 4.245-3.777ZM1.62 13.089c-.051.464-.086.929-.104 1.395.466-.018.932-.053 1.396-.104a10.511 10.511 0 0 0 1.668-.309c.526-.151.856-.325 1.011-.48a2.25 2.25 0 1 0-3.182-3.182c-.155.155-.329.485-.48 1.01a10.515 10.515 0 0 0-.309 1.67Zm10.396-10.34c-1.224.89-2.605 2.189-3.822 3.384l1.718 1.718c1.21-1.205 2.51-2.597 3.387-3.833.47-.662.78-1.227.912-1.662.134-.444.032-.551.009-.575h-.001V1.78c-.014-.014-.113-.113-.548.027-.432.14-.995.462-1.655.942Zm-4.832 7.266-.001.001a9.859 9.859 0 0 0 1.63-1.142L7.155 7.216a9.7 9.7 0 0 0-1.161 1.607c.482.302.889.71 1.19 1.192Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.642 6.653c-1.31 1.812-3.251 3.86-4.945 5.575l-.091.092-2.69-2.69.098-.098c1.69-1.71 3.732-3.656 5.544-4.962.911-.657 1.715-1.115 2.353-1.318.652-.207.915-.091 1.039.033.113.113.231.367.019 1.02-.207.635-.668 1.436-1.327 2.348ZM10.9 10.736l2.605 2.605c-.88.754-1.684 1.294-2.378 1.655a4.832 4.832 0 0 0-1.892-1.89c.36-.69.903-1.482 1.665-2.37Zm-3.086 1.856a4.825 4.825 0 0 0-4.33 1.328c-.525.525-.88 1.302-1.13 2.079-.256.795-.43 1.682-.541 2.507a19.055 19.055 0 0 0-.173 2.216c-.004.3.003.567.022.778.009.104.022.212.044.31.01.05.027.113.053.18.02.051.074.178.19.295.117.117.245.17.297.19.066.026.13.043.178.054.099.021.207.035.31.044.211.019.479.025.779.021.603-.008 1.39-.06 2.216-.172.825-.112 1.711-.285 2.507-.54.776-.25 1.553-.606 2.079-1.132a4.825 4.825 0 0 0 1.327-4.333c1.209-.6 2.622-1.618 4.121-3.135 1.694-1.714 3.709-3.835 5.093-5.75.688-.952 1.258-1.904 1.538-2.764.274-.842.334-1.826-.384-2.544-.72-.719-1.703-.672-2.555-.401-.865.275-1.822.843-2.776 1.53-1.92 1.384-4.036 3.407-5.733 5.125-1.5 1.518-2.53 2.896-3.132 4.114Zm1.44 2.388a3.33 3.33 0 0 1 0 4.71c-.271.27-.774.537-1.478.763-.684.22-1.477.378-2.248.482-.769.104-1.495.152-2.035.16a9.247 9.247 0 0 1-.351-.002 9.182 9.182 0 0 1-.002-.35c.007-.542.055-1.267.16-2.036.104-.771.261-1.564.481-2.249.227-.703.493-1.206.764-1.478a3.33 3.33 0 0 1 4.71 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$bd597ed9308dedb4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PaperAirplaneIcon", "octicon octicon-paper-airplane", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.989 8 .064 2.68a1.342 1.342 0 0 1 1.85-1.462l13.402 5.744a1.13 1.13 0 0 1 0 2.076L1.913 14.782a1.343 1.343 0 0 1-1.85-1.463L.99 8Zm.603-5.288L2.38 7.25h4.87a.75.75 0 0 1 0 1.5H2.38l-.788 4.538L13.929 8Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.513 1.96a1.374 1.374 0 0 1 1.499-.21l19.335 9.215a1.147 1.147 0 0 1 0 2.07L3.012 22.25a1.374 1.374 0 0 1-1.947-1.46L2.49 12 1.065 3.21a1.375 1.375 0 0 1 .448-1.25Zm2.375 10.79-1.304 8.042L21.031 12 2.584 3.208l1.304 8.042h7.362a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a46755b952c02768 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PaperclipIcon", "octicon octicon-paperclip", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.212 3.02a1.753 1.753 0 0 0-2.478.003l-5.83 5.83a3.007 3.007 0 0 0-.88 2.127c0 .795.315 1.551.88 2.116.567.567 1.333.89 2.126.89.79 0 1.548-.321 2.116-.89l5.48-5.48a.75.75 0 0 1 1.061 1.06l-5.48 5.48a4.492 4.492 0 0 1-3.177 1.33c-1.2 0-2.345-.487-3.187-1.33a4.483 4.483 0 0 1-1.32-3.177c0-1.195.475-2.341 1.32-3.186l5.83-5.83a3.25 3.25 0 0 1 5.553 2.297c0 .863-.343 1.691-.953 2.301L7.439 12.39c-.375.377-.884.59-1.416.593a1.998 1.998 0 0 1-1.412-.593 1.992 1.992 0 0 1 0-2.828l5.48-5.48a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-5.48 5.48a.492.492 0 0 0 0 .707.499.499 0 0 0 .352.154.51.51 0 0 0 .356-.154l5.833-5.827a1.755 1.755 0 0 0 0-2.481Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.187 3.588a2.75 2.75 0 0 0-3.889 0L5.575 13.31a4.5 4.5 0 0 0 6.364 6.364l8.662-8.662a.75.75 0 0 1 1.061 1.06L13 20.735a6 6 0 0 1-8.485-8.485l9.723-9.723a4.247 4.247 0 0 1 4.124-1.139 4.247 4.247 0 0 1 3.025 3.025 4.247 4.247 0 0 1-1.139 4.124l-9.193 9.193a2.64 2.64 0 0 1-1.858.779 2.626 2.626 0 0 1-1.854-.779c-.196-.196-.338-.47-.43-.726a2.822 2.822 0 0 1-.168-.946c0-.7.284-1.373.775-1.864l8.132-8.131a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-8.131 8.132a1.148 1.148 0 0 0-.336.803c.003.204.053.405.146.587.01.018.018.028.02.032.22.215.501.332.786.332.29 0 .58-.121.798-.34l9.192-9.192a2.75 2.75 0 0 0 0-3.89Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$50e7a5e2e571d53b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PasskeyFillIcon", "octicon octicon-passkey-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.743 4.757a3.757 3.757 0 1 1 5.851 3.119 5.991 5.991 0 0 1 2.15 1.383c.17.17.257.405.258.646.003.598.001 1.197 0 1.795L11 12.778v.721a.5.5 0 0 1-.5.5H1.221a.749.749 0 0 1-.714-.784 6.004 6.004 0 0 1 3.899-5.339 3.754 3.754 0 0 1-1.663-3.119Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.75 6.875c0 .874-.448 1.643-1.127 2.09a.265.265 0 0 0-.123.22v.59c0 .067-.026.13-.073.177l-.356.356a.125.125 0 0 0 0 .177l.356.356c.047.047.073.11.073.176v.231c0 .067-.026.13-.073.177l-.356.356a.125.125 0 0 0 0 .177l.356.356c.047.047.073.11.073.177v.287a.247.247 0 0 1-.065.168l-.8.88a.52.52 0 0 1-.77 0l-.8-.88a.247.247 0 0 1-.065-.168V9.185a.264.264 0 0 0-.123-.22 2.5 2.5 0 1 1 3.873-2.09ZM14 6.5a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.496 2a5.25 5.25 0 0 0-2.519 9.857A9.006 9.006 0 0 0 .5 20.228a.751.751 0 0 0 .728.772h5.257c3.338.001 6.677.002 10.015 0a.5.5 0 0 0 .5-.5v-4.669a.95.95 0 0 0-.171-.551 9.02 9.02 0 0 0-4.814-3.423A5.25 5.25 0 0 0 9.496 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M23.625 10.313c0 1.31-.672 2.464-1.691 3.134a.398.398 0 0 0-.184.33v.886a.372.372 0 0 1-.11.265l-.534.534a.188.188 0 0 0 0 .265l.534.534c.071.07.11.166.11.265v.347a.374.374 0 0 1-.11.265l-.534.534a.188.188 0 0 0 0 .265l.534.534a.37.37 0 0 1 .11.265v.431a.379.379 0 0 1-.097.253l-1.2 1.319a.781.781 0 0 1-1.156 0l-1.2-1.319a.379.379 0 0 1-.097-.253v-5.39a.398.398 0 0 0-.184-.33 3.75 3.75 0 1 1 5.809-3.134ZM21 9.75a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a88dc56ae22bf1c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PasteIcon", "octicon octicon-paste", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.626 3.533a.249.249 0 0 0-.126.217v9.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-9.5a.249.249 0 0 0-.126-.217.75.75 0 0 1 .752-1.298c.541.313.874.89.874 1.515v9.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-9.5c0-.625.333-1.202.874-1.515a.75.75 0 0 1 .752 1.298ZM5.75 1h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 5 4.75v-3A.75.75 0 0 1 5.75 1Zm.75 3h3V2.5h-3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.962 2.513a.75.75 0 0 1-.475.949l-.816.272a.25.25 0 0 0-.171.237V21.25c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V3.97a.25.25 0 0 0-.17-.236l-.817-.272a.75.75 0 0 1 .474-1.424l.816.273A1.751 1.751 0 0 1 21 3.97v17.28A1.75 1.75 0 0 1 19.25 23H4.75A1.75 1.75 0 0 1 3 21.25V3.97a1.75 1.75 0 0 1 1.197-1.66l.816-.272a.75.75 0 0 1 .949.475Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7 1.75C7 .784 7.784 0 8.75 0h6.5C16.216 0 17 .784 17 1.75v1.5A1.75 1.75 0 0 1 15.25 5h-6.5A1.75 1.75 0 0 1 7 3.25Zm1.75-.25a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$9b47433640e5db3a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PauseIcon", "octicon octicon-pause", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 2h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm5 0h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 3H7.5A1.5 1.5 0 0 0 6 4.5v15A1.5 1.5 0 0 0 7.5 21H9a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 9 3Zm7.5 0H15a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 15 21h1.5a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 16.5 3Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$d2c72b688139a728 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PencilIcon", "octicon octicon-pencil", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.013 1.427a1.75 1.75 0 0 1 2.474 0l1.086 1.086a1.75 1.75 0 0 1 0 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 0 1-.927-.928l.929-3.25c.081-.286.235-.547.445-.758l8.61-8.61Zm.176 4.823L9.75 4.81l-6.286 6.287a.253.253 0 0 0-.064.108l-.558 1.953 1.953-.558a.253.253 0 0 0 .108-.064Zm1.238-3.763a.25.25 0 0 0-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 0 0 0-.354Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.263 2.177a1.75 1.75 0 0 1 2.474 0l2.586 2.586a1.75 1.75 0 0 1 0 2.474L19.53 10.03l-.012.013L8.69 20.378a1.753 1.753 0 0 1-.699.409l-5.523 1.68a.748.748 0 0 1-.747-.188.748.748 0 0 1-.188-.747l1.673-5.5a1.75 1.75 0 0 1 .466-.756L14.476 4.963ZM4.708 16.361a.26.26 0 0 0-.067.108l-1.264 4.154 4.177-1.271a.253.253 0 0 0 .1-.059l10.273-9.806-2.94-2.939-10.279 9.813ZM19 8.44l2.263-2.262a.25.25 0 0 0 0-.354l-2.586-2.586a.25.25 0 0 0-.354 0L16.061 5.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$768c63d12a5f543f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PencilAiIcon", "octicon octicon-pencil-ai", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.013 1.427a1.75 1.75 0 0 1 2.474 0l1.086 1.086a1.748 1.748 0 0 1 0 2.474l-8.609 8.61c-.21.21-.471.363-.757.445l-3.251.929a.748.748 0 0 1-.736-.191.748.748 0 0 1-.191-.736l.929-3.251a1.76 1.76 0 0 1 .445-.757Zm-7.549 9.67a.253.253 0 0 0-.064.108l-.558 1.953 1.953-.558a.253.253 0 0 0 .108-.064l6.286-6.286L9.75 4.811Zm8.963-8.61a.252.252 0 0 0-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.252.252 0 0 0 0-.354Zm-.158 6.676A.246.246 0 0 1 12.502 9a.246.246 0 0 1 .232.163l.238.648a3.724 3.724 0 0 0 2.219 2.219l.649.238a.248.248 0 0 1 .16.202v.063a.248.248 0 0 1-.16.202l-.649.238a3.721 3.721 0 0 0-2.219 2.218l-.238.649a.246.246 0 0 1-.193.16h-.079a.245.245 0 0 1-.193-.16l-.239-.649a3.737 3.737 0 0 0-2.218-2.218l-.649-.238a.248.248 0 0 1-.118-.376.254.254 0 0 1 .118-.091l.649-.238a3.724 3.724 0 0 0 2.218-2.219Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.263 2.177a1.748 1.748 0 0 1 2.474 0l2.586 2.586a1.748 1.748 0 0 1 0 2.474L19.53 10.03l-.012.012L8.69 20.378a1.753 1.753 0 0 1-.699.409l-5.523 1.681a.75.75 0 0 1-.935-.936l1.673-5.499c.088-.288.248-.549.466-.757L14.476 4.964Zm-2.275 4.371-10.28 9.813a.26.26 0 0 0-.067.108l-1.264 4.154 4.177-1.271a.253.253 0 0 0 .1-.059l10.273-9.805ZM19 8.439l2.263-2.262a.252.252 0 0 0 0-.354l-2.586-2.586a.252.252 0 0 0-.354 0L16.061 5.5Zm-.293 6.363a.312.312 0 0 1 .587 0l.298.815a4.685 4.685 0 0 0 2.791 2.791l.815.298a.312.312 0 0 1 0 .587l-.815.299a4.686 4.686 0 0 0-2.791 2.79l-.298.816a.312.312 0 0 1-.587 0l-.299-.816a4.687 4.687 0 0 0-2.79-2.79l-.816-.299a.312.312 0 0 1 0-.587l.816-.298a4.686 4.686 0 0 0 2.79-2.791l.299-.815Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a0096b57009ecc7c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PeopleIcon", "octicon octicon-people", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 5.5a3.5 3.5 0 1 1 5.898 2.549 5.508 5.508 0 0 1 3.034 4.084.75.75 0 1 1-1.482.235 4 4 0 0 0-7.9 0 .75.75 0 0 1-1.482-.236A5.507 5.507 0 0 1 3.102 8.05 3.493 3.493 0 0 1 2 5.5ZM11 4a3.001 3.001 0 0 1 2.22 5.018 5.01 5.01 0 0 1 2.56 3.012.749.749 0 0 1-.885.954.752.752 0 0 1-.549-.514 3.507 3.507 0 0 0-2.522-2.372.75.75 0 0 1-.574-.73v-.352a.75.75 0 0 1 .416-.672A1.5 1.5 0 0 0 11 5.5.75.75 0 0 1 11 4Zm-5.5-.5a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.5 8a5.5 5.5 0 1 1 8.596 4.547 9.005 9.005 0 0 1 5.9 8.18.751.751 0 0 1-1.5.045 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.499-.044 9.005 9.005 0 0 1 5.9-8.181A5.496 5.496 0 0 1 3.5 8ZM9 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm8.29 4c-.148 0-.292.01-.434.03a.75.75 0 1 1-.212-1.484 4.53 4.53 0 0 1 3.38 8.097 6.69 6.69 0 0 1 3.956 6.107.75.75 0 0 1-1.5 0 5.193 5.193 0 0 0-3.696-4.972l-.534-.16v-1.676l.41-.209A3.03 3.03 0 0 0 17.29 8Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$7dcc8f518762622d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PersonIcon", "octicon octicon-person", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.561 8.073a6.005 6.005 0 0 1 3.432 5.142.75.75 0 1 1-1.498.07 4.5 4.5 0 0 0-8.99 0 .75.75 0 0 1-1.498-.07 6.004 6.004 0 0 1 3.431-5.142 3.999 3.999 0 1 1 5.123 0ZM10.5 5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5a5.5 5.5 0 0 1 3.096 10.047 9.005 9.005 0 0 1 5.9 8.181.75.75 0 1 1-1.499.044 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.5-.045 9.005 9.005 0 0 1 5.9-8.18A5.5 5.5 0 0 1 12 2.5ZM8 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$d6ee0666164b3f7a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PersonAddIcon", "octicon octicon-person-add", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.9 8.548h-.001a5.528 5.528 0 0 1 3.1 4.659.75.75 0 1 1-1.498.086A4.01 4.01 0 0 0 5.5 9.5a4.01 4.01 0 0 0-4.001 3.793.75.75 0 1 1-1.498-.085 5.527 5.527 0 0 1 3.1-4.66 3.5 3.5 0 1 1 4.799 0ZM13.25 0a.75.75 0 0 1 .75.75V2h1.25a.75.75 0 0 1 0 1.5H14v1.25a.75.75 0 0 1-1.5 0V3.5h-1.25a.75.75 0 0 1 0-1.5h1.25V.75a.75.75 0 0 1 .75-.75ZM5.5 4a2 2 0 1 0-.001 3.999A2 2 0 0 0 5.5 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 9.5a5 5 0 1 1 7.916 4.062 7.973 7.973 0 0 1 5.018 7.166.75.75 0 1 1-1.499.044 6.469 6.469 0 0 0-12.932 0 .75.75 0 0 1-1.499-.044 7.972 7.972 0 0 1 5.059-7.181A4.994 4.994 0 0 1 4 9.5ZM9 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm10.25-5a.75.75 0 0 1 .75.75V4h2.25a.75.75 0 0 1 0 1.5H20v2.25a.75.75 0 0 1-1.5 0V5.5h-2.25a.75.75 0 0 1 0-1.5h2.25V1.75a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3a99346ff3f8771a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PersonFillIcon", "octicon octicon-person-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.243 4.757a3.757 3.757 0 1 1 5.851 3.119 6.006 6.006 0 0 1 3.9 5.339.75.75 0 0 1-.715.784H2.721a.75.75 0 0 1-.714-.784 6.006 6.006 0 0 1 3.9-5.34 3.753 3.753 0 0 1-1.664-3.118Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5a5.25 5.25 0 0 0-2.519 9.857 9.005 9.005 0 0 0-6.477 8.37.75.75 0 0 0 .727.773H20.27a.75.75 0 0 0 .727-.772 9.005 9.005 0 0 0-6.477-8.37A5.25 5.25 0 0 0 12 2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8dedaee0e594ee0e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PinIcon", "octicon octicon-pin", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m11.294.984 3.722 3.722a1.75 1.75 0 0 1-.504 2.826l-1.327.613a3.089 3.089 0 0 0-1.707 2.084l-.584 2.454c-.317 1.332-1.972 1.8-2.94.832L5.75 11.311 1.78 15.28a.749.749 0 1 1-1.06-1.06l3.969-3.97-2.204-2.204c-.968-.968-.5-2.623.832-2.94l2.454-.584a3.08 3.08 0 0 0 2.084-1.707l.613-1.327a1.75 1.75 0 0 1 2.826-.504ZM6.283 9.723l2.732 2.731a.25.25 0 0 0 .42-.119l.584-2.454a4.586 4.586 0 0 1 2.537-3.098l1.328-.613a.25.25 0 0 0 .072-.404l-3.722-3.722a.25.25 0 0 0-.404.072l-.613 1.328a4.584 4.584 0 0 1-3.098 2.537l-2.454.584a.25.25 0 0 0-.119.42l2.731 2.732Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m16.114 1.553 6.333 6.333a1.75 1.75 0 0 1-.603 2.869l-1.63.633a5.67 5.67 0 0 0-3.395 3.725l-1.131 3.959a1.75 1.75 0 0 1-2.92.757L9 16.061l-5.595 5.594a.749.749 0 1 1-1.06-1.06L7.939 15l-3.768-3.768a1.75 1.75 0 0 1 .757-2.92l3.959-1.131a5.666 5.666 0 0 0 3.725-3.395l.633-1.63a1.75 1.75 0 0 1 2.869-.603ZM5.232 10.171l8.597 8.597a.25.25 0 0 0 .417-.108l1.131-3.959A7.17 7.17 0 0 1 19.67 9.99l1.63-.634a.25.25 0 0 0 .086-.409l-6.333-6.333a.25.25 0 0 0-.409.086l-.634 1.63a7.17 7.17 0 0 1-4.711 4.293L5.34 9.754a.25.25 0 0 0-.108.417Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a65d9571846dd36c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PinSlashIcon", "octicon octicon-pin-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m1.655.595 13.75 13.75q.22.219.22.53 0 .311-.22.53-.219.22-.53.22-.311 0-.53-.22L.595 1.655q-.22-.219-.22-.53 0-.311.22-.53.219-.22.53-.22.311 0 .53.22ZM.72 14.22l4.5-4.5q.219-.22.53-.22.311 0 .53.22.22.219.22.53 0 .311-.22.53l-4.5 4.5q-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m5.424 6.146-1.759.419q-.143.034-.183.175-.04.141.064.245l5.469 5.469q.104.104.245.064.141-.04.175-.183l.359-1.509q.072-.302.337-.465.264-.163.567-.091.302.072.465.337.162.264.09.567l-.359 1.509q-.238.999-1.226 1.278-.988.28-1.714-.446L2.485 8.046q-.726-.726-.446-1.714.279-.988 1.278-1.226l1.759-.419q.303-.072.567.091.265.163.337.465.072.302-.091.567-.163.264-.465.336ZM7.47 3.47q.155-.156.247-.355l.751-1.627Q8.851.659 9.75.498q.899-.16 1.544.486l3.722 3.722q.646.645.486 1.544-.161.899-.99 1.282l-1.627.751q-.199.092-.355.247-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53.344-.345.787-.549l1.627-.751q.118-.055.141-.183.023-.128-.069-.221l-3.722-3.722q-.092-.092-.221-.069-.128.023-.183.141l-.751 1.627q-.204.443-.549.787-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.345 20.595 8.47 14.47q.219-.22.53-.22.311 0 .53.22.22.219.22.53 0 .311-.22.53l-6.125 6.125q-.219.22-.53.22-.311 0-.53-.22-.22-.219-.22-.53 0-.311.22-.53Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m16.72 11.97.358-.358a6.738 6.738 0 0 1 2.326-1.518l1.896-.738a.25.25 0 0 0 .086-.409l-6.333-6.333a.25.25 0 0 0-.409.086l-.521 1.34a8.663 8.663 0 0 1-2.243 3.265.75.75 0 0 1-1.01-1.11 7.132 7.132 0 0 0 1.854-2.699l.521-1.34a1.75 1.75 0 0 1 2.869-.603l6.333 6.333a1.75 1.75 0 0 1-.603 2.869l-1.896.737a5.26 5.26 0 0 0-1.81 1.18l-.358.358a.749.749 0 1 1-1.06-1.06Zm-12.549-.738a1.75 1.75 0 0 1 .757-2.92l3.366-.962.412 1.443-3.366.961a.25.25 0 0 0-.108.417l8.597 8.597a.25.25 0 0 0 .417-.108l.961-3.366 1.443.412-.962 3.366a1.75 1.75 0 0 1-2.92.757Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m3.405 2.095 18.75 18.75q.22.219.22.53 0 .311-.22.53-.219.22-.53.22-.311 0-.53-.22L2.345 3.155q-.22-.219-.22-.53 0-.311.22-.53.219-.22.53-.22.311 0 .53.22Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a5d40f2135ac4370 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PivotColumnIcon", "octicon octicon-pivot-column", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.217 0 16 .784 16 1.75v5.5a.75.75 0 0 1-1.5 0V6.5h-8v8h.75a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 0 14.25ZM1.5 6.5v7.75c0 .138.112.25.25.25H5v-8Zm5-1.5h8V1.75a.25.25 0 0 0-.25-.25H6.5ZM5 5V1.5H1.75a.25.25 0 0 0-.25.25V5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m11.017 9.89-2.882 2.677a.249.249 0 0 0 0 .366l2.882 2.677a.25.25 0 0 0 .421-.183V13.5H12.5A3.5 3.5 0 0 0 16 10a.75.75 0 0 0-1.5 0 2 2 0 0 1-2 2h-1.062v-1.927a.25.25 0 0 0-.421-.183Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.783 2.783 2 3.75 2h16.5c.966 0 1.75.783 1.75 1.75V10a.75.75 0 0 1-1.5 0V8.75H8.75V20.5H10a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25Zm6.75-.25v3.75H20.5v-3.5a.25.25 0 0 0-.25-.25Zm-1.5 17V8.75H3.5v11.5c0 .138.112.25.25.25ZM3.5 7.25h3.75V3.5h-3.5a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.25 12.312a.75.75 0 0 1 .75.75v2.626a3.75 3.75 0 0 1-3.75 3.75h-3.502l2.032 2.032a.749.749 0 1 1-1.06 1.06l-3.25-3.25a.749.749 0 0 1 0-1.06l3.25-3.25a.749.749 0 1 1 1.06 1.06l-1.907 1.908h3.377a2.25 2.25 0 0 0 2.25-2.25v-2.626a.75.75 0 0 1 .75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$a6630b90defda83f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PlayIcon", "octicon octicon-play", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm4.879-2.773 4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559V5.442a.25.25 0 0 1 .379-.215Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.5 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842l-5.576 3.584a.5.5 0 0 1-.77-.42Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$12e0cea57aa8d2f2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PlugIcon", "octicon octicon-plug", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 8H2.5a1 1 0 0 0-1 1v5.25a.75.75 0 0 1-1.5 0V9a2.5 2.5 0 0 1 2.5-2.5H4V5.133a1.75 1.75 0 0 1 1.533-1.737l2.831-.353.76-.913c.332-.4.825-.63 1.344-.63h.782c.966 0 1.75.784 1.75 1.75V4h2.25a.75.75 0 0 1 0 1.5H13v4h2.25a.75.75 0 0 1 0 1.5H13v.75a1.75 1.75 0 0 1-1.75 1.75h-.782c-.519 0-1.012-.23-1.344-.63l-.761-.912-2.83-.354A1.75 1.75 0 0 1 4 9.867Zm6.276-4.91-.95 1.14a.753.753 0 0 1-.483.265l-3.124.39a.25.25 0 0 0-.219.248v4.734c0 .126.094.233.219.249l3.124.39a.752.752 0 0 1 .483.264l.95 1.14a.25.25 0 0 0 .192.09h.782a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-.782a.25.25 0 0 0-.192.09Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7 11.5H2.938c-.794 0-1.438.644-1.438 1.437v8.313a.75.75 0 0 1-1.5 0v-8.312A2.939 2.939 0 0 1 2.937 10H7V6.151c0-.897.678-1.648 1.57-1.74l6.055-.626 1.006-1.174A1.752 1.752 0 0 1 16.96 2h1.29c.966 0 1.75.784 1.75 1.75V6h3.25a.75.75 0 0 1 0 1.5H20V14h3.25a.75.75 0 0 1 0 1.5H20v2.25a1.75 1.75 0 0 1-1.75 1.75h-1.29a1.75 1.75 0 0 1-1.329-.611l-1.006-1.174-6.055-.627A1.749 1.749 0 0 1 7 15.348Zm9.77-7.913v.001l-1.201 1.4a.75.75 0 0 1-.492.258l-6.353.657a.25.25 0 0 0-.224.249v9.196a.25.25 0 0 0 .224.249l6.353.657c.191.02.368.112.493.258l1.2 1.401a.252.252 0 0 0 .19.087h1.29a.25.25 0 0 0 .25-.25v-14a.25.25 0 0 0-.25-.25h-1.29a.252.252 0 0 0-.19.087Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f21ab0717a89c77f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PlusIcon", "octicon octicon-plus", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.75 4.5a.75.75 0 0 1 .75.75V11h5.75a.75.75 0 0 1 0 1.5H12.5v5.75a.75.75 0 0 1-1.5 0V12.5H5.25a.75.75 0 0 1 0-1.5H11V5.25a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$99bb4c5ac5bf5ec5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PlusCircleIcon", "octicon octicon-plus-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7.25-3.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$219c8b8c393795b3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ProjectIcon", "octicon octicon-project", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25ZM11.75 3a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 .75-.75Zm-8.25.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-1.5 0ZM8 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.25 6a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 1.5 0v-7.5A.75.75 0 0 0 7.25 6ZM12 6a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 6Zm4 .75a.75.75 0 0 1 1.5 0v9.5a.75.75 0 0 1-1.5 0v-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$1a80f113fc555686 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ProjectRoadmapIcon", "octicon octicon-project-roadmap", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.75 7a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM5 4.75A.75.75 0 0 1 5.75 4h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 4.75ZM6.75 10a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 7a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5ZM7 11.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM9.75 15a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$deb880182502ec00 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ProjectSymlinkIcon", "octicon octicon-project-symlink", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16h-8.5a.75.75 0 0 1 0-1.5h8.5a.25.25 0 0 0 .25-.25V6.5h-13v1.75a.75.75 0 0 1-1.5 0ZM6.5 5h8V1.75a.25.25 0 0 0-.25-.25H6.5Zm-5 0H5V1.5H1.75a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 13.737a2.25 2.25 0 0 1 2.262-2.25L4 11.49v1.938c0 .218.26.331.42.183l2.883-2.677a.25.25 0 0 0 0-.366L4.42 7.89a.25.25 0 0 0-.42.183V9.99l-.23-.001A3.75 3.75 0 0 0 0 13.738v1.012a.75.75 0 0 0 1.5 0v-1.013Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H9.75a.75.75 0 0 1 0-1.5h10.5a.25.25 0 0 0 .25-.25V9h-17v3A.75.75 0 0 1 2 12ZM9 7.5h11.5V3.75a.25.25 0 0 0-.25-.25H9Zm-5.5 0h4v-4H3.75a.25.25 0 0 0-.25.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m9.308 14.5-2.104-2.236a.75.75 0 1 1 1.092-1.028l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.75.75 0 1 1-1.092-1.028L9.308 16H6.09a2.59 2.59 0 0 0-2.59 2.59v2.66a.75.75 0 0 1-1.5 0v-2.66a4.09 4.09 0 0 1 4.09-4.09h3.218Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6d9633df09ef233d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ProjectTemplateIcon", "octicon octicon-project-template", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 1.75v1.562a.75.75 0 1 1-1.5 0V1.75C0 .784.784 0 1.75 0h1.562a.75.75 0 1 1 0 1.5H1.75a.25.25 0 0 0-.25.25ZM6.438 0h3.124a.75.75 0 1 1 0 1.5H6.438a.75.75 0 1 1 0-1.5Zm6.25 0h1.562C15.217 0 16 .784 16 1.75v1.562a.75.75 0 1 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-1.562a.75.75 0 1 1 0-1.5ZM1.5 6.438v3.124a.75.75 0 1 1-1.5 0V6.438a.75.75 0 1 1 1.5 0Zm14.5 0v3.124a.75.75 0 1 1-1.5 0V6.438a.75.75 0 1 1 1.5 0Zm-14.5 6.25v1.562c0 .138.112.25.25.25h1.562a.75.75 0 1 1 0 1.5H1.75A1.75 1.75 0 0 1 0 14.25v-1.562a.75.75 0 1 1 1.5 0Zm14.5 0v1.562A1.75 1.75 0 0 1 14.25 16h-1.562a.75.75 0 1 1 0-1.5h1.562a.25.25 0 0 0 .25-.25v-1.562a.75.75 0 1 1 1.5 0ZM6.438 14.5h3.124a.75.75 0 1 1 0 1.5H6.438a.75.75 0 1 1 0-1.5ZM6.5 3v1A.75.75 0 0 1 5 4V3a.75.75 0 0 1 1.5 0ZM2.25 5.75A.75.75 0 0 1 3 5h1a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm4.5 0A.75.75 0 0 1 7.5 5h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-1 1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75Zm.75 4v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0Zm3.5-5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 3.5a.25.25 0 0 0-.25.25v2.062a.75.75 0 1 1-1.5 0V3.75C2 2.783 2.783 2 3.75 2h2.062a.75.75 0 1 1 0 1.5Zm13.688-.75a.75.75 0 0 1 .75-.75h2.062c.966 0 1.75.783 1.75 1.75v2.062a.75.75 0 1 1-1.5 0V3.75a.25.25 0 0 0-.25-.25h-2.062a.75.75 0 0 1-.75-.75ZM2.75 17.438a.75.75 0 0 1 .75.75v2.062c0 .138.112.25.25.25h2.062a.75.75 0 1 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25v-2.062a.75.75 0 0 1 .75-.75Zm18.5 0a.75.75 0 0 1 .75.75v2.062A1.75 1.75 0 0 1 20.25 22h-2.062a.75.75 0 1 1 0-1.5h2.062a.25.25 0 0 0 .25-.25v-2.062a.75.75 0 0 1 .75-.75Zm-18.5-8.25a.75.75 0 0 1 .75.75v4.124a.75.75 0 1 1-1.5 0V9.938a.75.75 0 0 1 .75-.75ZM9.188 2.75a.75.75 0 0 1 .75-.75h4.124a.75.75 0 1 1 0 1.5H9.938a.75.75 0 0 1-.75-.75Zm0 18.5a.75.75 0 0 1 .75-.75h4.124a.75.75 0 1 1 0 1.5H9.938a.75.75 0 0 1-.75-.75ZM21.25 9.188a.75.75 0 0 1 .75.75v4.124a.75.75 0 1 1-1.5 0V9.938a.75.75 0 0 1 .75-.75ZM3.75 8.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm5.5 0A.75.75 0 0 1 10 7.5h2A.75.75 0 0 1 12 9h-2a.75.75 0 0 1-.75-.75Zm-1-4.5A.75.75 0 0 1 9 4.5v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm0 5.5A.75.75 0 0 1 9 10v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm0 4.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75ZM14 8.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$821b06bbcfc0bc3c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("PulseIcon", "octicon octicon-pulse", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 2c.306 0 .582.187.696.471L10 10.731l1.304-3.26A.751.751 0 0 1 12 7h3.25a.75.75 0 0 1 0 1.5h-2.742l-1.812 4.528a.751.751 0 0 1-1.392 0L6 4.77 4.696 8.03A.75.75 0 0 1 4 8.5H.75a.75.75 0 0 1 0-1.5h2.742l1.812-4.529A.751.751 0 0 1 6 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.002 2.5a.75.75 0 0 1 .691.464l6.302 15.305 2.56-6.301a.75.75 0 0 1 .695-.468h4a.75.75 0 0 1 0 1.5h-3.495l-3.06 7.532a.75.75 0 0 1-1.389.004L8.997 5.21l-3.054 7.329A.75.75 0 0 1 5.25 13H.75a.75.75 0 0 1 0-1.5h4l3.558-8.538a.75.75 0 0 1 .694-.462Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f314ed182f5da2a0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("QuestionIcon", "octicon octicon-question", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.92 6.085h.001a.749.749 0 1 1-1.342-.67c.169-.339.436-.701.849-.977C6.845 4.16 7.369 4 8 4a2.756 2.756 0 0 1 1.637.525c.503.377.863.965.863 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.103-.067.207-.132.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.97 8.265a1.45 1.45 0 0 0-.487.57.75.75 0 0 1-1.341-.67c.2-.402.513-.826.997-1.148C10.627 6.69 11.244 6.5 12 6.5c.658 0 1.369.195 1.934.619a2.45 2.45 0 0 1 1.004 2.006c0 1.033-.513 1.72-1.027 2.215-.19.183-.399.358-.579.508l-.147.123a4.329 4.329 0 0 0-.435.409v1.37a.75.75 0 1 1-1.5 0v-1.473c0-.237.067-.504.247-.736.22-.28.486-.517.718-.714l.183-.153.001-.001c.172-.143.324-.27.47-.412.368-.355.569-.676.569-1.136a.953.953 0 0 0-.404-.806C12.766 8.118 12.384 8 12 8c-.494 0-.814.121-1.03.265ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$62bd98fc131b5caa = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("QuoteIcon", "octicon octicon-quote", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 2.5h10.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Zm4 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2.5 7.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 6.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.25Zm5 6.063a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75Zm0 5.937a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75ZM3.75 11a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8eec67136a89853b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ReadIcon", "octicon octicon-read", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.115.65a1.752 1.752 0 0 1 1.77 0l6.25 3.663c.536.314.865.889.865 1.51v6.427A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25V5.823c0-.621.33-1.196.865-1.51Zm1.011 1.293a.252.252 0 0 0-.252 0l-5.72 3.353L6.468 7.76a2.748 2.748 0 0 1 3.066 0l4.312-2.464-5.719-3.353ZM13.15 12.5 8.772 9.06a1.25 1.25 0 0 0-1.544 0L2.85 12.5Zm1.35-5.85-3.687 2.106 3.687 2.897ZM5.187 8.756 1.5 6.65v5.003Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.89 1.767a2.252 2.252 0 0 1 2.22 0l9.75 5.525A2.25 2.25 0 0 1 24 9.249v9.501A2.25 2.25 0 0 1 21.75 21H2.25A2.25 2.25 0 0 1 0 18.75v-9.5c0-.81.435-1.558 1.14-1.958Zm1.48 1.305a.75.75 0 0 0-.74 0l-9.316 5.28 7.41 4.233a3.75 3.75 0 0 1 4.553 0l7.41-4.234-9.317-5.28ZM20.65 19.5l-7.26-5.704a2.25 2.25 0 0 0-2.78 0L3.35 19.5Zm1.85-9.886-6.95 3.971 6.663 5.236c.089.07.161.159.21.26a.745.745 0 0 0 .077-.331ZM8.45 13.585 1.5 9.614v9.136c0 .119.028.23.076.33a.744.744 0 0 1 .21-.259Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$d275b7689549104e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RedoIcon", "octicon octicon-redo", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.78 6.28a.749.749 0 0 0 0-1.06l-3.5-3.5a.749.749 0 1 0-1.06 1.06L12.439 5H5.251l-.001.007L5.251 5a.8.8 0 0 0-.171.019A4.501 4.501 0 0 0 5.5 14h1.704a.75.75 0 0 0 0-1.5H5.5a3 3 0 1 1 0-6h6.939L10.22 8.72a.749.749 0 1 0 1.06 1.06l3.5-3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.72 2.22a.75.75 0 0 1 1.06 0l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 1 1-1.06-1.06l4.97-4.97H8.25c-.797 0-2.008.245-3 .959-.952.686-1.75 1.835-1.75 3.791s.798 3.105 1.75 3.791c.992.714 2.203.959 3 .959h3a.75.75 0 0 1 0 1.5h-3c-1.037 0-2.575-.305-3.876-1.241C3.035 18.545 2 16.944 2 14.5c0-2.444 1.035-4.045 2.374-5.009C5.675 8.555 7.214 8.25 8.25 8.25h11.44l-4.97-4.97a.75.75 0 0 1 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$80f27d87499b3fd0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RelFilePathIcon", "octicon octicon-rel-file-path", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.94 3.045a.75.75 0 0 0-1.38-.59l-4.5 10.5a.75.75 0 1 0 1.38.59l4.5-10.5ZM5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M19.564 4.42a.75.75 0 0 0-1.378-.59l-6.75 15.75a.75.75 0 0 0 1.378.59l6.75-15.75ZM7 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3deff2d32499abf0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ReplyIcon", "octicon octicon-reply", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.78 1.97a.75.75 0 0 1 0 1.06L3.81 6h6.44A4.75 4.75 0 0 1 15 10.75v2.5a.75.75 0 0 1-1.5 0v-2.5a3.25 3.25 0 0 0-3.25-3.25H3.81l2.97 2.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L1.47 7.28a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.53 5.03a.75.75 0 1 0-1.06-1.06l-6.25 6.25a.75.75 0 0 0 0 1.06l6.25 6.25a.75.75 0 1 0 1.06-1.06L5.56 11.5H17a3.248 3.248 0 0 1 3.25 3.248v4.502a.75.75 0 0 0 1.5 0v-4.502A4.748 4.748 0 0 0 17 10H5.56l4.97-4.97Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f6ad8b175c0ae00f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoIcon", "octicon octicon-repo", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 2.75A2.75 2.75 0 0 1 5.75 0h14.5a.75.75 0 0 1 .75.75v20.5a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h5.25v-4H6A1.5 1.5 0 0 0 4.5 18v.75c0 .716.43 1.334 1.05 1.605a.75.75 0 0 1-.6 1.374A3.251 3.251 0 0 1 3 18.75ZM19.5 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.651A2.989 2.989 0 0 1 6 15h13.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7 18.25a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46a.25.25 0 0 1-.397-.2v-5.01Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$8efdb29470fa3267 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoCloneIcon", "octicon octicon-repo-clone", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.5 0A2.5 2.5 0 0 0 1 2.5v9A2.5 2.5 0 0 0 3.5 14h2.75a.75.75 0 0 0 0-1.5H3.5a1 1 0 0 1 0-2h2.75a.75.75 0 0 0 0-1.5H3.5c-.356 0-.694.074-1 .208V2.5a1 1 0 0 1 1-1h8v2.75a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75H3.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 8.058C8 7.023 8.75 6 9.887 6h5.363a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-.75.75h-5A2.25 2.25 0 0 1 8 13.75Zm6.5 3.442v-4H9.887c-.07 0-.156.031-.238.125a.663.663 0 0 0-.149.433v3.57c.235-.083.487-.128.75-.128Zm-5 2.25c0 .414.336.75.75.75h4.25V13h-4.25a.75.75 0 0 0-.75.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.375.375a2.5 2.5 0 0 0-2.5 2.5v15.25a2.5 2.5 0 0 0 2.5 2.5h5.187a.75.75 0 1 0 0-1.5H4.375a1 1 0 0 1-1-1v-1.75a1 1 0 0 1 1-1h5.687a.75.75 0 1 0 0-1.5H4.375c-.356 0-.694.074-1 .208V2.875a1 1 0 0 1 1-1h13.25v5.25a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-.75-.75h-14Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.375 12.087c0-1.396 1.005-2.712 2.456-2.712h8.044a.75.75 0 0 1 .75.75v12.75a.75.75 0 0 1-.75.75h-7.5a3 3 0 0 1-3-3Zm9.75 5.538v-6.75h-7.294c-.433 0-.956.441-.956 1.212v5.939a2.989 2.989 0 0 1 1.5-.401Zm-8.25 3a1.5 1.5 0 0 0 1.5 1.5h6.75v-3h-6.75a1.5 1.5 0 0 0-1.5 1.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$db3bfd5c93f5c260 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoDeleteIcon", "octicon octicon-repo-delete", function() {
    return {
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 0A2.75 2.75 0 0 0 3 2.75v16.5A2.75 2.75 0 0 0 5.75 22h8a.75.75 0 0 0 0-1.5h-8c-.69 0-1.25-.56-1.25-1.25V18A1.5 1.5 0 0 1 6 16.5h7.75a.75.75 0 0 0 0-1.5H6c-.546 0-1.059.146-1.5.401V2.75c0-.69.56-1.25 1.25-1.25H19.5v12.25a.75.75 0 0 0 1.5 0v-13a.75.75 0 0 0-.75-.75H5.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.22 16.22a.75.75 0 0 1 1.06 0L20 18.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L21.06 20l2.72 2.72a.75.75 0 1 1-1.06 1.06L20 21.06l-2.72 2.72a.75.75 0 1 1-1.06-1.06L18.94 20l-2.72-2.72a.75.75 0 0 1 0-1.06Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$8dcafe7e23737bf1 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoDeletedIcon", "octicon octicon-repo-deleted", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.492 2.492 0 0 1 4.5 9h3.75a.75.75 0 0 1 0 1.5H4.5a1 1 0 1 0 0 2h3.75a.75.75 0 0 1 0 1.5H4.5A2.5 2.5 0 0 1 2 11.5v-9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.28 10.22a.75.75 0 1 0-1.06 1.06L11.94 13l-1.72 1.72a.75.75 0 1 0 1.06 1.06L13 14.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L14.06 13l1.72-1.72a.75.75 0 1 0-1.06-1.06L13 11.94l-1.72-1.72Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$20ef8d42b776024 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoForkedIcon", "octicon octicon-repo-forked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.75 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-12.5 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5ZM12 21a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 12 21Zm6.25-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.5 7.75v1A2.25 2.25 0 0 0 8.75 11h6.5a2.25 2.25 0 0 0 2.25-2.25v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-6.5A3.75 3.75 0 0 1 5 8.75v-1Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.25 16.25v-5h1.5v5h-1.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$daf0b77b504b7e5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoForkedLockedIcon", "octicon octicon-repo-forked-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M9 10.167V9c0-1.657 1.343-3 3-3s3 1.343 3 3v1.167c.591.281 1 .884 1 1.583v2.5c0 .966-.783 1.75-1.75 1.75H9.75C8.784 15.999 8 15.216 8 14.25v-2.5c0-.699.409-1.302 1-1.583zM13.5 10H10.5V9c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v1z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M3.25 1c.531 0 1.045.187 1.45.529.406.342.678.817.768 1.34.088.523-.011 1.061-.28 1.519-.268.456-.689.805-1.189.982v.881c0 .199.079.388.22.529.14.14.332.219.53.219h3.095c-.052.428-.008.986.051 1.499H7.75v1.748c-.315.418-.5.938-.5 1.502v.294c-.087-.024-.172-.041-.256-.041-.199 0-.39.079-.53.22-.141.14-.22.348-.22.547 0 .199.079.388.22.529.14.14.331.219.53.219.086 0 .17-.016.25-.042v.796c0 .25.038.492.107.72-.118.02-.237.031-.357.031-.531 0-1.045-.187-1.45-.529-.406-.342-.678-.817-.768-1.34-.088-.523.011-1.061.28-1.519.268-.456.69-.805 1.19-.983V8.5h-2.5C3.15 8.5 2.578 8.263 2.16 7.84 1.737 7.418 1.5 6.846 1.5 6.249v-.881c-.5-.177-.922-.526-1.19-.982-.268-.457-.368-.996-.28-1.519.088-.523.36-.998.768-1.34C1.205 1.187 1.72 1 2.25 1h1zm0 1.499c-.199.0005-.39.079-.53.22-.14.141-.22.348-.22.547 0 .199.08.388.22.529.14.14.331.219.53.219.199 0 .39-.079.53-.219.141-.141.22-.33.22-.529 0-.199-.079-.406-.22-.547-.14-.141-.331-.22-.53-.22zm7.5.75c.531 0 1.045.187 1.45.529.406.342.678.817.768 1.34.088.523-.011 1.061-.28 1.519-.268.456-.689.805-1.189.982v1.341c0 .414.336.75.75.75h.25.25c.414 0 .75.336.75.75s-.336.75-.75.75h-.5c-1.657 0-3-1.343-3-3V8.75c0-.199.079-.388.22-.529.14-.14.332-.219.53-.219h1.01V5c0-.828.672-1.5 1.5-1.5zm0 1.499c-.199.0005-.39.079-.53.22-.14.141-.22.348-.22.547 0 .199.08.388.22.529.14.14.331.219.53.219.199 0 .39-.079.53-.219.141-.141.22-.33.22-.529 0-.199-.079-.406-.22-.547-.14-.141-.331-.22-.53-.22z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.63 7.749c0 .414-.336.75-.75.75-.414 0-.75-.336-.75-.75 0-.414.336-.75.75-.75.414 0 .75.336.75.75z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M15 14.5V16h-.25c-.966 0-1.75.783-1.75 1.75v4.5c0 .966.783 1.75 1.75 1.75h7.5c.966 0 1.75-.783 1.75-1.75v-4.5c0-.966-.783-1.75-1.75-1.75H22v-1.5c0-1.933-1.567-3.5-3.5-3.5S15 12.567 15 14.5zm3.5-2c-1.105 0-2 .895-2 2v1.5h4v-1.5c0-1.105-.895-2-2-2z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M11.75 22.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75c-.966 0-1.75-.783-1.75-1.75 0-1 .783-1.75 1.75-1.75.5 0 .75-.5.75-1v-3.75h1.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H8.75C7.507 11 6.5 9.993 6.5 8.75v-.839c1.433-.338 2.5-1.626 2.5-3.161 0-1.795-1.455-3.25-3.25-3.25S2.5 2.955 2.5 4.75c0 1.535 1.067 2.823 2.5 3.161v.839C5 10.821 6.679 12.5 8.75 12.5h2.5v3.587c-1.433.338-2.5 1.626-2.5 3.161 0 1.795 1.205 3.25 3.25 3.25zm-6-16c-.966 0-1.75-.783-1.75-1.75S4.783 3 5.75 3s1.75.783 1.75 1.75S6.716 6.5 5.75 6.5z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                d: "M18.25 10.25c.414 0 .75-.336.75-.75V7.587c1.433-.338 2.5-1.626 2.5-3.161 0-1.795-1.455-3.25-3.25-3.25S15 2.955 15 4.75c0 1.535 1.067 2.823 2.5 3.161V9.5c0 .414.336.75.75.75zm0-3.75c-.966 0-1.75-.783-1.75-1.75S17.283 3 18.25 3s1.75.783 1.75 1.75S19.217 6.5 18.25 6.5z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$144a2acfc46e9917 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoLockedIcon", "octicon octicon-repo-locked", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.492 2.492 0 0 1 4.5 9h1.75a.75.75 0 0 1 0 1.5H4.5a1 1 0 1 0 0 2h1.75a.75.75 0 0 1 0 1.5H4.5A2.5 2.5 0 0 1 2 11.5v-9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 10.168V9a3 3 0 1 1 6 0v1.168c.591.281 1 .884 1 1.582v2.5A1.75 1.75 0 0 1 14.25 16h-4.5A1.75 1.75 0 0 1 8 14.25v-2.5c0-.698.409-1.3 1-1.582ZM13.5 10V9a1.5 1.5 0 0 0-3 0v1Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 2.75A2.75 2.75 0 0 1 5.75 0h14.5a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.651A2.987 2.987 0 0 1 6 15h5.25a.75.75 0 0 1 0 1.5H6A1.5 1.5 0 0 0 4.5 18v1.25c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 3 19.25V2.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 14.5a3.5 3.5 0 1 1 7 0V16h.25c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 22.25 24h-7.5A1.75 1.75 0 0 1 13 22.25v-4.5c0-.966.784-1.75 1.75-1.75H15Zm3.5-2a2 2 0 0 0-2 2V16h4v-1.5a2 2 0 0 0-2-2Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$e848eaa92ac1d05f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoPullIcon", "octicon octicon-repo-pull", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 2.5A2.5 2.5 0 0 1 3.5 0h8.75a.75.75 0 0 1 .75.75V6a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 3.5 9h3a.75.75 0 0 1 0 1.5h-3a1 1 0 0 0 0 2h3a.75.75 0 0 1 0 1.5h-3A2.5 2.5 0 0 1 1 11.5v-9Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.21 13.479a.75.75 0 1 0 1.061 1.061l2.504-2.505a.75.75 0 0 0 0-1.061L13.271 8.47a.75.75 0 0 0-1.061 1.06l1.224 1.225H8.75a.75.75 0 1 0 0 1.5h4.685l-1.225 1.224Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.875 2.875a2.5 2.5 0 0 1 2.5-2.5h14a.75.75 0 0 1 .75.75v9.125a.75.75 0 0 1-1.5 0V1.875H4.375a1 1 0 0 0-1 1v11.208a2.486 2.486 0 0 1 1-.208h5.937a.75.75 0 1 1 0 1.5H4.375a1 1 0 0 0-1 1v1.75a1 1 0 0 0 1 1h6a.75.75 0 0 1 0 1.5h-6a2.5 2.5 0 0 1-2.5-2.5V2.875Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.643 20.484a.749.749 0 1 0 1.061 1.06l3.757-3.757a.75.75 0 0 0 0-1.06l-3.757-3.757a.75.75 0 0 0-1.061 1.06l2.476 2.477H13a.75.75 0 0 0 0 1.5h8.12l-2.477 2.477Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$855627263578491e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoPushIcon", "octicon octicon-repo-push", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V1.5h-8a1 1 0 0 0-1 1v6.708A2.493 2.493 0 0 1 4.5 9h2.25a.75.75 0 0 1 0 1.5H4.5a1 1 0 0 0 0 2h4.75a.75.75 0 0 1 0 1.5H4.5A2.5 2.5 0 0 1 2 11.5Zm12.23 7.79h-.001l-1.224-1.224v6.184a.75.75 0 0 1-1.5 0V9.066L10.28 10.29a.75.75 0 0 1-1.06-1.061l2.505-2.504a.75.75 0 0 1 1.06 0L15.29 9.23a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 0A2.75 2.75 0 0 0 3 2.75v16.5A2.75 2.75 0 0 0 5.75 22h10a.75.75 0 0 0 0-1.5h-10c-.69 0-1.25-.56-1.25-1.25V18A1.5 1.5 0 0 1 6 16.5h6.25a.75.75 0 0 0 0-1.5H6c-.546 0-1.059.146-1.5.401V2.75c0-.69.56-1.25 1.25-1.25H19.5v7a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75H5.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m20 13.903 2.202 2.359a.75.75 0 0 0 1.096-1.024l-3.5-3.75a.75.75 0 0 0-1.096 0l-3.5 3.75a.75.75 0 1 0 1.096 1.024l2.202-2.36v9.348a.75.75 0 0 0 1.5 0v-9.347Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$dac01e0ca183ddce = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RepoTemplateIcon", "octicon octicon-repo-template", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 8a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-.75a.75.75 0 0 1 0-1.5h.75v-.25a.75.75 0 0 1 .75-.75ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2ZM2.75 8a.75.75 0 0 1 .75.75v.268c.083-.012.166-.018.25-.018h.5a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.75c0 .28.114.532.3.714a.75.75 0 1 1-1.05 1.072A2.495 2.495 0 0 1 2 11.5V8.75A.75.75 0 0 1 2.75 8ZM11 .75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V1.5h-.75A.75.75 0 0 1 11 .75Zm-5 0A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 .75Zm0 9A.75.75 0 0 1 6.75 9h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 9.75ZM4.992.662a.75.75 0 0 1-.636.848c-.436.063-.783.41-.846.846a.751.751 0 0 1-1.485-.212A2.501 2.501 0 0 1 4.144.025a.75.75 0 0 1 .848.637ZM2.75 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 2.75 4Zm10.5 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 0A2.75 2.75 0 0 0 3 2.75v1a.75.75 0 0 0 1.5 0v-1c0-.69.56-1.25 1.25-1.25h1a.75.75 0 0 0 0-1.5h-1Zm4 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm7.5 0a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3ZM4.5 6.5a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V6.5Zm16.5 0a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V6.5ZM4.5 13.25a.75.75 0 0 0-1.5 0v5.5a3.25 3.25 0 0 0 1.95 2.98.75.75 0 1 0 .6-1.375A1.75 1.75 0 0 1 4.5 18.75V18A1.5 1.5 0 0 1 6 16.5h.75a.75.75 0 0 0 0-1.5H6c-.546 0-1.059.146-1.5.401V13.25Zm16.5 0a.75.75 0 0 0-1.5 0V15h-2.25a.75.75 0 0 0 0 1.5h2.25v4h-5.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 .75-.75v-8ZM9.75 15a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm-2.353 8.461A.25.25 0 0 1 7 23.26v-5.01a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b82c15e73e7acb32 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ReportIcon", "octicon octicon-report", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 4.25c0-.966.784-1.75 1.75-1.75h17.5c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-9.586a.25.25 0 0 0-.177.073l-3.5 3.5A1.458 1.458 0 0 1 5 21.043V18.5H3.25a1.75 1.75 0 0 1-1.75-1.75ZM3.25 4a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v3.19l3.427-3.427A1.75 1.75 0 0 1 11.164 17h9.586a.25.25 0 0 0 .25-.25V4.25a.25.25 0 0 0-.25-.25ZM12 6a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 12 6Zm0 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8e0d2500d5bd92ef = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RocketIcon", "octicon octicon-rocket", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.064 0h.186C15.216 0 16 .784 16 1.75v.186a8.752 8.752 0 0 1-2.564 6.186l-.458.459c-.314.314-.641.616-.979.904v3.207c0 .608-.315 1.172-.833 1.49l-2.774 1.707a.749.749 0 0 1-1.11-.418l-.954-3.102a1.214 1.214 0 0 1-.145-.125L3.754 9.816a1.218 1.218 0 0 1-.124-.145L.528 8.717a.749.749 0 0 1-.418-1.11l1.71-2.774A1.748 1.748 0 0 1 3.31 4h3.204c.288-.338.59-.665.904-.979l.459-.458A8.749 8.749 0 0 1 14.064 0ZM8.938 3.623h-.002l-.458.458c-.76.76-1.437 1.598-2.02 2.5l-1.5 2.317 2.143 2.143 2.317-1.5c.902-.583 1.74-1.26 2.499-2.02l.459-.458a7.25 7.25 0 0 0 2.123-5.127V1.75a.25.25 0 0 0-.25-.25h-.186a7.249 7.249 0 0 0-5.125 2.123ZM3.56 14.56c-.732.732-2.334 1.045-3.005 1.148a.234.234 0 0 1-.201-.064.234.234 0 0 1-.064-.201c.103-.671.416-2.273 1.15-3.003a1.502 1.502 0 1 1 2.12 2.12Zm6.94-3.935c-.088.06-.177.118-.266.175l-2.35 1.521.548 1.783 1.949-1.2a.25.25 0 0 0 .119-.213ZM3.678 8.116 5.2 5.766c.058-.09.117-.178.176-.266H3.309a.25.25 0 0 0-.213.119l-1.2 1.95ZM12 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.322.75h1.176a1.75 1.75 0 0 1 1.75 1.749v1.177a10.75 10.75 0 0 1-2.925 7.374l-1.228 1.304a23.699 23.699 0 0 1-1.596 1.542v5.038c0 .615-.323 1.184-.85 1.5l-4.514 2.709a.75.75 0 0 1-1.12-.488l-.963-4.572a1.305 1.305 0 0 1-.14-.129L8.04 15.96l-1.994-1.873a1.305 1.305 0 0 1-.129-.14l-4.571-.963a.75.75 0 0 1-.49-1.12l2.71-4.514c.316-.527.885-.85 1.5-.85h5.037a23.668 23.668 0 0 1 1.542-1.594l1.304-1.23A10.753 10.753 0 0 1 20.321.75Zm-6.344 4.018v-.001l-1.304 1.23a22.275 22.275 0 0 0-3.255 3.851l-2.193 3.29 1.859 1.744a.545.545 0 0 1 .034.034l1.743 1.858 3.288-2.192a22.263 22.263 0 0 0 3.854-3.257l1.228-1.303a9.251 9.251 0 0 0 2.517-6.346V2.5a.25.25 0 0 0-.25-.25h-1.177a9.252 9.252 0 0 0-6.344 2.518ZM6.5 21c-1.209 1.209-3.901 1.445-4.743 1.49a.236.236 0 0 1-.18-.067.236.236 0 0 1-.067-.18c.045-.842.281-3.534 1.49-4.743.9-.9 2.6-.9 3.5 0 .9.9.9 2.6 0 3.5Zm-.592-8.588L8.17 9.017c.23-.346.47-.685.717-1.017H5.066a.25.25 0 0 0-.214.121l-2.167 3.612ZM16 15.112c-.333.248-.672.487-1.018.718l-3.393 2.262.678 3.223 3.612-2.167a.25.25 0 0 0 .121-.214ZM17.5 8a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17.5 8Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$472271f3e918e2f4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RowsIcon", "octicon octicon-rows", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 10.75v2.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25v-2.5C0 9.784.784 9 1.75 9h12.5c.966 0 1.75.784 1.75 1.75Zm0-8v2.5A1.75 1.75 0 0 1 14.25 7H1.75A1.75 1.75 0 0 1 0 5.25v-2.5C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75Zm-1.75-.25H1.75a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm0 8H1.75a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22 3.75v5.5A1.75 1.75 0 0 1 20.25 11H3.75A1.75 1.75 0 0 1 2 9.25v-5.5C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75Zm0 11v5.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25v-5.5c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75ZM20.25 3.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Zm0 11H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$459b2edd884123b9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RssIcon", "octicon octicon-rss", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.002 2.725a.75.75 0 0 1 .797-.699C8.79 2.42 13.58 7.21 13.974 13.201a.75.75 0 0 1-1.497.098 10.502 10.502 0 0 0-9.776-9.776.747.747 0 0 1-.7-.798ZM2.84 7.05h-.002a7.002 7.002 0 0 1 6.113 6.111.75.75 0 0 1-1.49.178 5.503 5.503 0 0 0-4.8-4.8.75.75 0 0 1 .179-1.489ZM2 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.5 3.25a.75.75 0 0 1 .75-.75C14.053 2.5 22 10.447 22 20.25a.75.75 0 0 1-1.5 0C20.5 11.275 13.225 4 4.25 4a.75.75 0 0 1-.75-.75Zm.75 6.25C10.187 9.5 15 14.313 15 20.25a.75.75 0 0 1-1.5 0A9.25 9.25 0 0 0 4.25 11a.75.75 0 0 1 0-1.5ZM3.5 19a2 2 0 1 1 3.999-.001A2 2 0 0 1 3.5 19Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$19d31e296396343 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("RubyIcon", "octicon octicon-ruby", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.637 2.291A.748.748 0 0 1 4.23 2h7.54c.232 0 .451.107.593.291l3.48 4.5a.75.75 0 0 1-.072.999l-7.25 7a.75.75 0 0 1-1.042 0l-7.25-7a.75.75 0 0 1-.072-.999ZM4.598 3.5 1.754 7.177 8 13.207l6.246-6.03L11.402 3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.873 3.26A.748.748 0 0 1 6.44 3h11.31c.223 0 .434.099.576.27l5 6a.75.75 0 0 1-.028.992l-10.75 11.5a.75.75 0 0 1-1.096 0l-10.75-11.5a.75.75 0 0 1-.02-1.003l5.19-6Zm.91 1.24L2.258 9.73 12 20.153l9.75-10.43L17.399 4.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$837b367cdf149ef7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SandboxIcon", "octicon octicon-sandbox", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.71973 8.96973C8.01262 8.67683 8.48738 8.67683 8.78027 8.96973C9.07317 9.26262 9.07317 9.73738 8.78027 10.0303L7.31055 11.5L8.78027 12.9697C9.07317 13.2626 9.07317 13.7374 8.78027 14.0303C8.48738 14.3232 8.01262 14.3232 7.71973 14.0303L5.71973 12.0303C5.42683 11.7374 5.42683 11.2626 5.71973 10.9697L7.71973 8.96973ZM11.2197 8.96973C11.5126 8.67683 11.9874 8.67683 12.2803 8.96973L14.2803 10.9697C14.5732 11.2626 14.5732 11.7374 14.2803 12.0303L12.2803 14.0303C11.9874 14.3232 11.5126 14.3232 11.2197 14.0303C10.9268 13.7374 10.9268 13.2626 11.2197 12.9697L12.6895 11.5L11.2197 10.0303C10.9268 9.73738 10.9268 9.26262 11.2197 8.96973ZM14.5 8V1.75C14.5 1.61193 14.3881 1.5 14.25 1.5H1.75C1.61193 1.5 1.5 1.61193 1.5 1.75V14.25C1.5 14.3881 1.61193 14.5 1.75 14.5H3.5C3.91421 14.5 4.25 14.8358 4.25 15.25C4.25 15.6642 3.91421 16 3.5 16H1.75C0.783502 16 0 15.2165 0 14.25V1.75C0 0.783501 0.783502 0 1.75 0H14.25C15.2165 0 16 0.783502 16 1.75V8C16 8.41421 15.6642 8.75 15.25 8.75C14.8358 8.75 14.5 8.41421 14.5 8Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a2749bf554c976a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ScreenFullIcon", "octicon octicon-screen-full", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 10a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 1 13.25v-2.5a.75.75 0 0 1 .75-.75Zm12.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 13.25 15h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 .75-.75ZM2.75 2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0v-2.5C1 1.784 1.784 1 2.75 1h2.5a.75.75 0 0 1 0 1.5ZM10 1.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 15a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 3 19.25v-3.5a.75.75 0 0 1 .75-.75Zm16.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 19.25 21h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 .75-.75ZM4.75 4.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5C3 3.784 3.784 3 4.75 3h3.5a.75.75 0 0 1 0 1.5ZM15 3.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b85b311f30c27e1b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ScreenNormalIcon", "octicon octicon-screen-normal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.75 1a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 10 4.25v-2.5a.75.75 0 0 1 .75-.75Zm-5.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 4.25 6h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5A.75.75 0 0 1 5.25 1ZM1 10.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Zm9 1c0-.966.784-1.75 1.75-1.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.75 3a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 15 7.25v-3.5a.75.75 0 0 1 .75-.75Zm-7.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 7.25 9h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5A.75.75 0 0 1 8.25 3ZM3 15.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Zm12 1c0-.966.784-1.75 1.75-1.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$82eafebb825fc23f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SearchIcon", "octicon octicon-search", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.68 11.74a6 6 0 0 1-7.922-8.982 6 6 0 0 1 8.982 7.922l3.04 3.04a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM11.5 7a4.499 4.499 0 1 0-8.997 0A4.499 4.499 0 0 0 11.5 7Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.25 2a8.25 8.25 0 0 1 6.34 13.53l5.69 5.69a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-5.69-5.69A8.25 8.25 0 1 1 10.25 2ZM3.5 10.25a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$94639b65b951e28 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ServerIcon", "octicon octicon-server", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v4c0 .372-.116.717-.314 1 .198.283.314.628.314 1v4a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 12.75v-4c0-.358.109-.707.314-1a1.739 1.739 0 0 1-.314-1v-4C0 1.784.784 1 1.75 1ZM1.5 2.75v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm.25 5.75a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM7 4.75A.75.75 0 0 1 7.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75ZM7.75 10h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM3 4.75A.75.75 0 0 1 3.75 4h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 4.75ZM3.75 10h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.75 6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM6 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 7.25Zm4 9a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-3.25-.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 2h17.5c.966 0 1.75.784 1.75 1.75v7c0 .372-.116.716-.314 1 .198.284.314.628.314 1v7a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-7c0-.358.109-.707.314-1a1.741 1.741 0 0 1-.314-1v-7C1.5 2.784 2.284 2 3.25 2Zm0 10.5a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25Zm0-1.5h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$40148c7db598e4e0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShareIcon", "octicon octicon-share", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 6.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-6.5a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1 0-1.5h1c.966 0 1.75.784 1.75 1.75v6.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-6.5C2 5.784 2.784 5 3.75 5h1a.75.75 0 0 1 0 1.5ZM7.823.177a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v5.75a.75.75 0 0 1-1.5 0V3.5H5.104a.25.25 0 0 1-.177-.427Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.5 9.75v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V9.75a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V9.75C4 8.784 4.784 8 5.75 8h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25Zm7.03-8.53 3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-1.97-1.97v10.69a.75.75 0 0 1-1.5 0V3.56L9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$e200f86ace8b68ab = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShareAndroidIcon", "octicon octicon-share-android", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 3a3 3 0 0 1-5.175 2.066l-3.92 2.179a2.994 2.994 0 0 1 0 1.51l3.92 2.179a3 3 0 1 1-.73 1.31l-3.92-2.178a3 3 0 1 1 0-4.133l3.92-2.178A3 3 0 1 1 15 3Zm-1.5 10a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 13Zm-9-5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 4.5 8Zm9-5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20 5.5a3.498 3.498 0 0 1-6.062 2.385l-5.112 3.021a3.498 3.498 0 0 1 0 2.188l5.112 3.021a3.5 3.5 0 1 1-.764 1.29l-5.112-3.02a3.499 3.499 0 1 1-3.843-5.642 3.499 3.499 0 0 1 3.843.872l5.112-3.021A3.5 3.5 0 1 1 20 5.5Zm-1.5 13a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001Zm0-13a2 2 0 1 0-3.999-.001A2 2 0 0 0 18.5 5.5ZM5.5 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 5.5 14Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2d8598c0b89a07db = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShieldIcon", "octicon octicon-shield", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.467.133a1.748 1.748 0 0 1 1.066 0l5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667Zm.61 1.429a.25.25 0 0 0-.153 0l-5.25 1.68a.25.25 0 0 0-.174.238V7c0 1.358.275 2.666 1.057 3.86.784 1.194 2.121 2.34 4.366 3.297a.196.196 0 0 0 .154 0c2.245-.956 3.582-2.104 4.366-3.298C13.225 9.666 13.5 8.36 13.5 7V3.48a.251.251 0 0 0-.174-.237l-5.25-1.68ZM8.75 4.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 1.5 0ZM9 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13 15.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.46.637a1.748 1.748 0 0 1 1.08 0l8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.77 10.705-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.771 20.704 2 16.19 2 10V4.976c0-.76.49-1.43 1.21-1.664Zm.617 1.426a.253.253 0 0 0-.154 0L3.673 4.74a.25.25 0 0 0-.173.237V10c0 5.461 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.46 20.5 10V4.976a.25.25 0 0 0-.173-.237Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$da01a61080044588 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShieldCheckIcon", "octicon octicon-shield-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM11.28 6.28l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.97-2.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.53 9.78a.75.75 0 0 0-1.06-1.06L11 13.19l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.54.637 8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.771 10.704-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.77 20.705 2 16.19 2 10V4.976c0-.758.489-1.43 1.21-1.664L11.46.637a1.748 1.748 0 0 1 1.08 0Zm-.617 1.426-8.25 2.676a.249.249 0 0 0-.173.237V10c0 5.46 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.461 20.5 10V4.976a.25.25 0 0 0-.173-.237l-8.25-2.676a.253.253 0 0 0-.154 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$6f0043bfe7f5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShieldLockIcon", "octicon octicon-shield-lock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM9.5 6.5c0 .536-.286 1.032-.75 1.3v2.45a.75.75 0 0 1-1.5 0V7.8A1.5 1.5 0 1 1 9.5 6.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.46 1.137a1.748 1.748 0 0 1 1.08 0l8.25 2.675A1.75 1.75 0 0 1 22 5.476V10.5c0 6.19-3.77 10.705-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.771 21.204 2 16.69 2 10.5V5.476c0-.76.49-1.43 1.21-1.664Zm.617 1.426a.253.253 0 0 0-.154 0L3.673 5.24a.25.25 0 0 0-.173.237V10.5c0 5.461 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0c5.15-1.943 8.43-5.965 8.43-11.426V5.476a.25.25 0 0 0-.173-.237ZM13 12.232V15a1 1 0 0 1-2 0v-2.768a2 2 0 1 1 2 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c4c430b7c5f04a60 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShieldSlashIcon", "octicon octicon-shield-slash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.533.133a1.75 1.75 0 0 0-1.066 0l-2.091.67a.75.75 0 0 0 .457 1.428l2.09-.67a.25.25 0 0 1 .153 0l5.25 1.68a.25.25 0 0 1 .174.239V7c0 .233-.008.464-.025.694a.75.75 0 1 0 1.495.112c.02-.27.03-.538.03-.806V3.48a1.75 1.75 0 0 0-1.217-1.667L8.533.133ZM1 2.857l-.69-.5a.75.75 0 1 1 .88-1.214l14.5 10.5a.75.75 0 1 1-.88 1.214l-1.282-.928c-.995 1.397-2.553 2.624-4.864 3.608-.425.181-.905.18-1.329 0-2.447-1.042-4.049-2.356-5.032-3.855C1.32 10.182 1 8.566 1 7Zm1.5 1.086V7c0 1.358.275 2.666 1.057 3.86.784 1.194 2.121 2.34 4.366 3.297.05.02.106.02.153 0 2.127-.905 3.439-1.982 4.237-3.108Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.54 1.137a1.748 1.748 0 0 0-1.08 0L6.018 2.905a.75.75 0 1 0 .464 1.427l5.441-1.768a.239.239 0 0 1 .154 0l8.25 2.675a.249.249 0 0 1 .173.237V10.5c0 1.284-.24 2.83-.696 3.971a.75.75 0 1 0 1.392.557C21.74 13.67 22 11.927 22 10.5V5.476a1.75 1.75 0 0 0-1.21-1.664l-8.25-2.675ZM2.017 4.843l-.974-.748a.751.751 0 0 1 .914-1.19l20.5 15.75a.751.751 0 0 1-.914 1.19l-2.012-1.546-.702.852-.008.009a.07.07 0 0 1-.008.01c-1.603 1.821-3.731 3.223-6.214 4.16a1.699 1.699 0 0 1-1.198-.001C5.771 21.205 2 16.689 2 10.5V5c0-.054.006-.107.017-.157ZM3.5 5.982V10.5c0 5.461 3.281 9.483 8.431 11.426a.193.193 0 0 0 .138 0c2.283-.861 4.192-2.131 5.61-3.738l.662-.803Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8ecebf992ecfec05 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ShieldXIcon", "octicon octicon-shield-x", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM6.78 5.22 8 6.44l1.22-1.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 7.5l1.22 1.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 8.56 6.78 9.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 7.5 5.72 6.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.28 7.72a.75.75 0 0 0-1.06 1.06l2.72 2.72-2.72 2.72a.75.75 0 1 0 1.06 1.06L12 12.56l2.72 2.72a.75.75 0 1 0 1.06-1.06l-2.72-2.72 2.72-2.72a.75.75 0 0 0-1.06-1.06L12 10.44 9.28 7.72Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.54.637 8.25 2.675A1.75 1.75 0 0 1 22 4.976V10c0 6.19-3.771 10.704-9.401 12.83a1.704 1.704 0 0 1-1.198 0C5.77 20.705 2 16.19 2 10V4.976c0-.758.489-1.43 1.21-1.664L11.46.637a1.748 1.748 0 0 1 1.08 0Zm-.617 1.426-8.25 2.676a.249.249 0 0 0-.173.237V10c0 5.46 3.28 9.483 8.43 11.426a.199.199 0 0 0 .14 0C17.22 19.483 20.5 15.461 20.5 10V4.976a.25.25 0 0 0-.173-.237l-8.25-2.676a.253.253 0 0 0-.154 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$77b9724db3ed83b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SidebarCollapseIcon", "octicon octicon-sidebar-collapse", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.823 7.823a.25.25 0 0 1 0 .354l-2.396 2.396A.25.25 0 0 1 4 10.396V5.604a.25.25 0 0 1 .427-.177Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25H9.5v-13H1.75a.25.25 0 0 0-.25.25ZM11 14.5h3.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.22 14.47 9.69 12 7.22 9.53a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l3 3a.75.75 0 0 1 0 1.06l-3 3a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H15v-17H3.75a.25.25 0 0 0-.25.25Zm13 16.75h3.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H16.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$73de68ca909831b8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SidebarExpandIcon", "octicon octicon-sidebar-expand", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m4.177 7.823 2.396-2.396A.25.25 0 0 1 7 5.604v4.792a.25.25 0 0 1-.427.177L4.177 8.177a.25.25 0 0 1 0-.354Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25H9.5v-13Zm12.5 13a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H11v13Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.28 9.53 8.81 12l2.47 2.47a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-3-3a.75.75 0 0 1 0-1.06l3-3a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H15v-17H3.75a.25.25 0 0 0-.25.25Zm13 16.75h3.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H16.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$10cdd1f3e51de455 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SignInIcon", "octicon octicon-sign-in", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.75C2 1.784 2.784 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 2 13.25Zm6.56 4.5h5.69a.75.75 0 0 1 0 1.5H8.56l1.97 1.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L6.22 8.53a.75.75 0 0 1 0-1.06l3.25-3.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3.25c0-.966.784-1.75 1.75-1.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25v17.5c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 3 20.75Zm9.994 9.5 3.3 3.484a.75.75 0 0 1-1.088 1.032l-4.5-4.75a.75.75 0 0 1 0-1.032l4.5-4.75a.75.75 0 0 1 1.088 1.032l-3.3 3.484h8.256a.75.75 0 0 1 0 1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5bb2595dc31bfece = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SignOutIcon", "octicon octicon-sign-out", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2.75C2 1.784 2.784 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 2 13.25Zm10.44 4.5-1.97-1.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H6.75a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 3.25c0-.966.784-1.75 1.75-1.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.25.25 0 0 0-.25.25v17.5c0 .138.112.25.25.25h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 1 3 20.75Zm16.006 9.5H10.75a.75.75 0 0 1 0-1.5h8.256l-3.3-3.484a.75.75 0 0 1 1.088-1.032l4.5 4.75a.75.75 0 0 1 0 1.032l-4.5 4.75a.75.75 0 0 1-1.088-1.032Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$ba6370820a7d2625 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SingleSelectIcon", "octicon octicon-single-select", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m5.06 7.356 2.795 2.833c.08.081.21.081.29 0l2.794-2.833c.13-.131.038-.356-.145-.356H5.206c-.183 0-.275.225-.145.356Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m7.854 10.854 3.792 3.792a.5.5 0 0 0 .708 0l3.793-3.792a.5.5 0 0 0-.354-.854H8.207a.5.5 0 0 0-.353.854Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25Zm1.75-.25a.25.25 0 0 0-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$7d3458263f963d3 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SkipIcon", "octicon octicon-skip", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm9.78-2.22-5.5 5.5a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l5.5-5.5a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.28 7.78a.75.75 0 0 0-1.06-1.06l-9.5 9.5a.75.75 0 1 0 1.06 1.06l9.5-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$83062ed2ee1964bd = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SkipFillIcon", "octicon octicon-skip-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm11.333-2.167a.825.825 0 0 0-1.166-1.166l-5.5 5.5a.825.825 0 0 0 1.166 1.166Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.333-4.167a.825.825 0 0 0-1.166-1.166l-9.5 9.5a.825.825 0 0 0 1.166 1.166Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$2ec075e4def3a545 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SlidersIcon", "octicon octicon-sliders", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15 2.75a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75Zm-8.5.75v1.25a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-1.5 0V2H1.75a.75.75 0 0 0 0 1.5H6.5Zm1.25 5.25a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6ZM15 8a.75.75 0 0 1-.75.75H11.5V10a.75.75 0 1 1-1.5 0V6a.75.75 0 0 1 1.5 0v1.25h2.75A.75.75 0 0 1 15 8Zm-9 5.25v-2a.75.75 0 0 0-1.5 0v1.25H1.75a.75.75 0 0 0 0 1.5H4.5v1.25a.75.75 0 0 0 1.5 0v-2Zm9 0a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11 18.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm-8-12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 6.25Zm13 6a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM8.75 16a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 18.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm0-6a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75ZM16.75 10a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75ZM14 6.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75ZM11.25 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$663870aff582477c = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SmileyIcon", "octicon octicon-smiley", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm3.82 1.636a.75.75 0 0 1 1.038.175l.007.009c.103.118.22.222.35.31.264.178.683.37 1.285.37.602 0 1.02-.192 1.285-.371.13-.088.247-.192.35-.31l.007-.008a.75.75 0 0 1 1.222.87l-.022-.015c.02.013.021.015.021.015v.001l-.001.002-.002.003-.005.007-.014.019a2.066 2.066 0 0 1-.184.213c-.16.166-.338.316-.53.445-.63.418-1.37.638-2.127.629-.946 0-1.652-.308-2.126-.63a3.331 3.331 0 0 1-.715-.657l-.014-.02-.005-.006-.002-.003v-.002h-.001l.613-.432-.614.43a.75.75 0 0 1 .183-1.044ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5.25 2.25.592.416a97.71 97.71 0 0 0-.592-.416Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.456 14.494a.75.75 0 0 1 1.068.17 3.08 3.08 0 0 0 .572.492A3.381 3.381 0 0 0 12 15.72c.855 0 1.487-.283 1.904-.562a3.081 3.081 0 0 0 .572-.492l.021-.026a.75.75 0 0 1 1.197.905l-.027.034c-.013.016-.03.038-.052.063-.044.05-.105.119-.184.198a4.569 4.569 0 0 1-.695.566A4.88 4.88 0 0 1 12 17.22a4.88 4.88 0 0 1-2.736-.814 4.57 4.57 0 0 1-.695-.566 3.253 3.253 0 0 1-.236-.261c-.259-.332-.223-.824.123-1.084Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 10.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16.25 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$aab23ba5aafa1b33 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SmileyFrownIcon", "octicon octicon-smiley-frown", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a7.996 7.996 0 0 1 8 8 8 8 0 1 1-8-8Zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm0 7.996a3.775 3.775 0 0 1 2.127.629c.192.13.37.279.53.445.066.067.128.138.184.213l.015.019.004.008.002.002.001.002v.001a.625.625 0 0 1-.07.05l.071-.05a.753.753 0 0 1-.175 1.046.749.749 0 0 1-1.047-.175l-.007-.009a1.843 1.843 0 0 0-.35-.31c-.265-.179-.683-.371-1.285-.371-.602 0-1.021.192-1.285.37a1.843 1.843 0 0 0-.35.31l-.007.01a.747.747 0 0 1-1.038.174h-.001a.749.749 0 0 1-.183-1.044l.614.43-.612-.432v-.002l.002-.002.005-.007.014-.02a3.31 3.31 0 0 1 .715-.657c.474-.322 1.18-.63 2.126-.63ZM5 6a1 1 0 1 1 0 1.998A1 1 0 0 1 5 6Zm6 0a1 1 0 1 1 0 1.998A1 1 0 0 1 11 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm0 1.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Zm0 11.844c1.207 0 2.123.404 2.736.813.306.204.537.409.695.567.079.079.141.147.184.198l.052.062.026.035a.75.75 0 0 1-1.196.905l-.021-.026a1.853 1.853 0 0 0-.106-.114c-.1-.1-.255-.238-.466-.379A3.383 3.383 0 0 0 12 15.844c-.855 0-1.487.283-1.904.561a3.031 3.031 0 0 0-.572.493l-.021.026a.75.75 0 0 1-1.047.144c-.346-.26-.381-.752-.123-1.084.039-.049.118-.142.236-.26.158-.158.389-.363.695-.567A4.878 4.878 0 0 1 12 14.344ZM7.75 9.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm8.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b73b0c049abb5f02 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SmileyFrustratedIcon", "octicon octicon-smiley-frustrated", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a7.996 7.996 0 0 1 8 8 8 8 0 1 1-8-8Zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm0 6.75c2.487 0 3.518 1.98 3.727 2.818A.751.751 0 0 1 11 12H5a.75.75 0 0 1-.728-.932C4.482 10.23 5.513 8.25 8 8.25Zm3.259-3.854a.651.651 0 0 1 .482 1.208L10.75 6l.991.396a.651.651 0 0 1-.482 1.208L8.99 6.696a.75.75 0 0 1 0-1.392Zm-7.363.363a.651.651 0 0 1 .845-.363l2.268.908a.75.75 0 0 1 0 1.392l-2.268.908a.651.651 0 0 1-.483-1.208L5.25 6l-.992-.396a.65.65 0 0 1-.362-.845ZM8 9.75c-.822 0-1.383.351-1.746.75h3.492c-.363-.399-.924-.75-1.746-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm0 1.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Zm0 10.25c3.487 0 4.935 2.772 5.227 3.943a.748.748 0 0 1-.727.932h-9a.75.75 0 0 1-.728-.932C7.065 15.522 8.513 12.75 12 12.75Zm0 1.5c-1.785 0-2.832 1-3.363 1.875h6.726c-.531-.875-1.578-1.875-3.363-1.875ZM5.798 7.736a.75.75 0 0 1 .966-.438l4 1.5a.75.75 0 0 1 0 1.404l-4 1.5a.75.75 0 0 1-.528-1.404L8.363 9.5l-2.127-.798a.75.75 0 0 1-.438-.966Zm11.438-.438a.75.75 0 0 1 .528 1.404l-2.127.798 2.127.798a.75.75 0 0 1-.528 1.404l-4-1.5a.75.75 0 0 1 0-1.404l4-1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$914b25d1df2d35c7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SmileyGrinIcon", "octicon octicon-smiley-grin", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a7.996 7.996 0 0 1 8 8 8 8 0 1 1-8-8Zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm3 7.75a.75.75 0 0 1 .727.932C11.518 11.02 10.487 13 8 13s-3.518-1.98-3.728-2.818A.75.75 0 0 1 5 9.25ZM8.329 6.164c.895-1.788 3.447-1.788 4.342 0a.75.75 0 0 1-1.342.671.927.927 0 0 0-1.658 0 .75.75 0 0 1-1.342-.671Zm-5 0c.895-1.788 3.447-1.788 4.342 0a.75.75 0 0 1-1.342.671.927.927 0 0 0-1.658 0 .75.75 0 0 1-1.342-.671Zm2.925 4.586c.363.399.924.75 1.746.75s1.383-.351 1.746-.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm0 1.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Zm4.5 11.75a.75.75 0 0 1 .727.932c-.292 1.171-1.74 3.943-5.227 3.943s-4.935-2.772-5.228-3.943a.75.75 0 0 1 .728-.932h9Zm-7.863 1.5c.531.875 1.578 1.875 3.363 1.875s2.832-1 3.363-1.875H8.637ZM8 8.25c1.294 0 2.122.663 2.6 1.3a3.98 3.98 0 0 1 .588 1.135l.028.088.008.029.002.01.001.003v.002c.001.001-.001.001-.629.159l.629-.158a.749.749 0 0 1-1.454.369l-.001-.005a2.128 2.128 0 0 0-.074-.206 2.454 2.454 0 0 0-.298-.526c-.272-.363-.695-.7-1.4-.7s-1.128.337-1.4.7a2.454 2.454 0 0 0-.372.732h-.001a.75.75 0 0 1-1.455-.364l.63.158-.63-.159v-.001l.001-.001.001-.003.002-.01.008-.029.028-.088A3.98 3.98 0 0 1 5.4 9.55c.478-.637 1.306-1.3 2.6-1.3Zm8 0c1.294 0 2.122.663 2.6 1.3a3.98 3.98 0 0 1 .589 1.135l.027.088.008.029.002.01.001.003v.002c.001.001-.001.001-.629.159l.629-.158a.749.749 0 0 1-1.454.369v-.005l-.012-.038a2.454 2.454 0 0 0-.361-.694c-.272-.363-.695-.7-1.4-.7s-1.128.337-1.4.7a2.454 2.454 0 0 0-.373.732.75.75 0 0 1-1.454-.364l.629.158c-.627-.157-.63-.158-.629-.159v-.002l.001-.003.002-.01.008-.029.028-.088A3.98 3.98 0 0 1 13.4 9.55c.478-.637 1.306-1.3 2.6-1.3Zm-9.772 2.933v.001h-.001v-.002l.001.001Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$737327006ef4e322 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SmileyNeutralIcon", "octicon octicon-smiley-neutral", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 0a7.996 7.996 0 0 1 8 8 8 8 0 1 1-8-8Zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm2 8.75a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5ZM5 6a1 1 0 1 1 0 1.998A1 1 0 0 1 5 6Zm6 0a1 1 0 1 1 0 1.998A1 1 0 0 1 11 6Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm0 1.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Zm2.75 12.75a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5Zm-7-5.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm8.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$6a0a4b3755b1f7ee = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SortAscIcon", "octicon octicon-sort-asc", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.5 17.25a.75.75 0 0 1-1.5 0V7.56l-2.22 2.22a.75.75 0 1 1-1.06-1.06l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06L18.5 7.56v9.69Zm-15.75.25a.75.75 0 0 1 0-1.5h9.5a.75.75 0 0 1 0 1.5h-9.5Zm0-5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5h-5.5Zm0-5a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$42de415488f8b291 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SortDescIcon", "octicon octicon-sort-desc", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.5 16.44V6.75a.75.75 0 0 0-1.5 0v9.69l-2.22-2.22a.75.75 0 1 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22ZM2 7.25a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 2 7.25Zm0 5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$38ffce4a7986ba20 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SpaceIcon", "octicon octicon-space", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 13.25V2.75C0 1.784.784 1 1.75 1H5c.551 0 1.07.26 1.4.7l.9 1.2a.25.25 0 0 0 .2.1h6.75c.966 0 1.75.784 1.75 1.75v3.638a.75.75 0 0 1-1.5 0V4.75a.25.25 0 0 0-.25-.25H7.5a1.75 1.75 0 0 1-1.4-.7l-.9-1.2a.25.25 0 0 0-.2-.1H1.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h5.663l.076.004a.75.75 0 0 1 0 1.492L7.413 15H1.75A1.75 1.75 0 0 1 0 13.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.265 9.16a.248.248 0 0 1 .467 0l.237.649a3.726 3.726 0 0 0 2.219 2.218l.649.238a.249.249 0 0 1 0 .467l-.649.237a3.728 3.728 0 0 0-2.219 2.219l-.237.649a.249.249 0 0 1-.467 0l-.238-.649a3.726 3.726 0 0 0-2.218-2.219l-.649-.237a.248.248 0 0 1 0-.467l.649-.238a3.725 3.725 0 0 0 2.218-2.218l.238-.649Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.831 13.621a.337.337 0 0 1 .633 0l.322.88a5.052 5.052 0 0 0 3.008 3.008l.88.322a.337.337 0 0 1 0 .633l-.88.322a5.054 5.054 0 0 0-3.008 3.008l-.322.88a.337.337 0 0 1-.633 0l-.322-.88a5.054 5.054 0 0 0-3.008-3.008l-.88-.322a.337.337 0 0 1 0-.633l.88-.322a5.052 5.052 0 0 0 3.008-3.008l.322-.88Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 19.25V4.75C2 3.784 2.784 3 3.75 3h4.971a1.75 1.75 0 0 1 1.447.765l1.404 2.063c.047.069.125.11.207.11h8.471c.966 0 1.75.783 1.75 1.75v5.781a.75.75 0 0 1-1.5 0V7.688a.25.25 0 0 0-.25-.25h-8.471a1.753 1.753 0 0 1-1.447-.765L8.928 4.609a.253.253 0 0 0-.207-.109H3.75a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25H12a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 19.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$84203f63d6c0f0b1 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SpacingLargeIcon", "octicon octicon-spacing-large", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 2H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5Zm-3 5h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5Zm3 5H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.25 3H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Zm-4 8h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5Zm4 8H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a5368fd82c93ce3b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SpacingMediumIcon", "octicon octicon-spacing-medium", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 3H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5Zm-3 4h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5Zm3 4H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.25 5H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Zm-4 6h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5Zm4 6H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$fe1b0b81dd8ee0c4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SpacingSmallIcon", "octicon octicon-spacing-small", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.25 4H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5Zm-3 3h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5Zm3 3H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.25 7H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Zm-4 4h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5Zm4 4H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$1019ff5537a7252e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SparkleIcon", "octicon octicon-sparkle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.198.57c.275-.752 1.34-.752 1.615 0l.849 2.317a5.819 5.819 0 0 0 3.462 3.463l2.317.848c.753.275.753 1.34 0 1.615l-2.317.849a5.815 5.815 0 0 0-3.462 3.462l-.849 2.317c-.275.753-1.34.753-1.615 0l-.848-2.317a5.819 5.819 0 0 0-3.463-3.462L.57 8.813c-.752-.275-.752-1.34 0-1.615l2.317-.848A5.823 5.823 0 0 0 6.35 2.887L7.198.57Zm.562 2.833A7.323 7.323 0 0 1 3.403 7.76l-.673.246.673.246a7.324 7.324 0 0 1 4.357 4.356l.246.673.246-.673a7.322 7.322 0 0 1 4.356-4.356l.673-.246-.673-.246a7.324 7.324 0 0 1-4.356-4.357l-.246-.673-.246.673Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.191.565c.275-.754 1.342-.753 1.618 0l1.918 5.238a5.83 5.83 0 0 0 3.47 3.47l5.237 1.918c.755.275.755 1.342 0 1.618l-5.237 1.918a5.83 5.83 0 0 0-3.47 3.47l-1.918 5.237c-.276.755-1.343.755-1.618 0l-1.918-5.237a5.83 5.83 0 0 0-3.47-3.47L.565 12.809c-.753-.276-.754-1.342 0-1.618l5.238-1.918a5.83 5.83 0 0 0 3.47-3.47L11.191.565Zm-.505 5.756a7.336 7.336 0 0 1-4.365 4.365L2.73 12l3.591 1.315a7.333 7.333 0 0 1 4.365 4.365L12 21.269l1.315-3.589a7.33 7.33 0 0 1 4.365-4.365L21.269 12l-3.589-1.314a7.333 7.333 0 0 1-4.365-4.365L12 2.73l-1.314 3.591Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4f977e01eaf645e6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SparkleFillIcon", "octicon octicon-sparkle-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.53 1.282a.5.5 0 0 1 .94 0l.478 1.306a7.492 7.492 0 0 0 4.464 4.464l1.305.478a.5.5 0 0 1 0 .94l-1.305.478a7.492 7.492 0 0 0-4.464 4.464l-.478 1.305a.5.5 0 0 1-.94 0l-.478-1.305a7.492 7.492 0 0 0-4.464-4.464L1.282 8.47a.5.5 0 0 1 0-.94l1.306-.478a7.492 7.492 0 0 0 4.464-4.464Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.296 1.924c.24-.656 1.168-.656 1.408 0l.717 1.958a11.25 11.25 0 0 0 6.697 6.697l1.958.717c.657.24.657 1.168 0 1.408l-1.958.717a11.25 11.25 0 0 0-6.697 6.697l-.717 1.958c-.24.657-1.168.657-1.408 0l-.717-1.958a11.25 11.25 0 0 0-6.697-6.697l-1.958-.717c-.656-.24-.656-1.168 0-1.408l1.958-.717a11.25 11.25 0 0 0 6.697-6.697l.717-1.958Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$10ef3ed960475d9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SparklesFillIcon", "octicon octicon-sparkles-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.6 2.279a.426.426 0 0 1 .8 0l.407 1.112a6.386 6.386 0 0 0 3.802 3.802l1.112.407a.426.426 0 0 1 0 .8l-1.112.407a6.386 6.386 0 0 0-3.802 3.802l-.407 1.112a.426.426 0 0 1-.8 0l-.407-1.112a6.386 6.386 0 0 0-3.802-3.802L4.279 8.4a.426.426 0 0 1 0-.8l1.112-.407a6.386 6.386 0 0 0 3.802-3.802L9.6 2.279Zm-4.267 8.837a.178.178 0 0 1 .334 0l.169.464a2.662 2.662 0 0 0 1.584 1.584l.464.169a.178.178 0 0 1 0 .334l-.464.169a2.662 2.662 0 0 0-1.584 1.584l-.169.464a.178.178 0 0 1-.334 0l-.169-.464a2.662 2.662 0 0 0-1.584-1.584l-.464-.169a.178.178 0 0 1 0-.334l.464-.169a2.662 2.662 0 0 0 1.584-1.584l.169-.464ZM2.8.14a.213.213 0 0 1 .4 0l.203.556a3.2 3.2 0 0 0 1.901 1.901l.556.203a.213.213 0 0 1 0 .4l-.556.203a3.2 3.2 0 0 0-1.901 1.901L3.2 5.86a.213.213 0 0 1-.4 0l-.203-.556A3.2 3.2 0 0 0 .696 3.403L.14 3.2a.213.213 0 0 1 0-.4l.556-.203A3.2 3.2 0 0 0 2.597.696L2.8.14Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.4 3.419a.639.639 0 0 1 1.2 0l.61 1.668a9.587 9.587 0 0 0 5.703 5.703l1.668.61a.639.639 0 0 1 0 1.2l-1.668.61a9.587 9.587 0 0 0-5.703 5.703l-.61 1.668a.639.639 0 0 1-1.2 0l-.61-1.668a9.587 9.587 0 0 0-5.703-5.703l-1.668-.61a.639.639 0 0 1 0-1.2l1.668-.61a9.587 9.587 0 0 0 5.703-5.703l.61-1.668ZM8 16.675a.266.266 0 0 1 .5 0l.254.694a3.992 3.992 0 0 0 2.376 2.377l.695.254a.266.266 0 0 1 0 .5l-.695.254a3.992 3.992 0 0 0-2.376 2.377l-.254.694a.266.266 0 0 1-.5 0l-.254-.694a3.992 3.992 0 0 0-2.376-2.377l-.695-.254a.266.266 0 0 1 0-.5l.695-.254a3.992 3.992 0 0 0 2.376-2.377L8 16.675ZM4.2.21a.32.32 0 0 1 .6 0l.305.833a4.793 4.793 0 0 0 2.852 2.852l.833.305a.32.32 0 0 1 0 .6l-.833.305a4.793 4.793 0 0 0-2.852 2.852L4.8 8.79a.32.32 0 0 1-.6 0l-.305-.833a4.793 4.793 0 0 0-2.852-2.852L.21 4.8a.32.32 0 0 1 0-.6l.833-.305a4.793 4.793 0 0 0 2.852-2.852L4.2.21Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8266189590d70b8f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SplitViewIcon", "octicon octicon-split-view", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 14.25 16H1.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0ZM1.5 1.75v12.5c0 .138.112.25.25.25H7.5v-13H1.75a.25.25 0 0 0-.25.25ZM9 14.5h5.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25H9Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5c0 .464-.184.909-.513 1.237A1.746 1.746 0 0 1 20.25 22H3.75c-.464 0-.909-.184-1.237-.513A1.746 1.746 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25H11v-17H3.75a.25.25 0 0 0-.25.25Zm9 16.75h7.75a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H12.5v17Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5ac582d13947c6ee = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SponsorTiersIcon", "octicon octicon-sponsor-tiers", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.586 1C12.268 1 13.5 2.37 13.5 4.25c0 1.745-.996 3.359-2.622 4.831-.166.15-.336.297-.509.438l1.116 5.584a.75.75 0 0 1-.991.852l-2.409-.876a.25.25 0 0 0-.17 0l-2.409.876a.75.75 0 0 1-.991-.852L5.63 9.519a13.78 13.78 0 0 1-.51-.438C3.497 7.609 2.5 5.995 2.5 4.25 2.5 2.37 3.732 1 5.414 1c.963 0 1.843.403 2.474 1.073L8 2.198l.112-.125a3.385 3.385 0 0 1 2.283-1.068L10.586 1Zm-3.621 9.495-.718 3.594 1.155-.42a1.75 1.75 0 0 1 1.028-.051l.168.051 1.154.42-.718-3.592c-.199.13-.37.235-.505.314l-.169.097a.75.75 0 0 1-.72 0 9.54 9.54 0 0 1-.515-.308l-.16-.105ZM10.586 2.5c-.863 0-1.611.58-1.866 1.459-.209.721-1.231.721-1.44 0C7.025 3.08 6.277 2.5 5.414 2.5 4.598 2.5 4 3.165 4 4.25c0 1.23.786 2.504 2.128 3.719.49.443 1.018.846 1.546 1.198l.325.21.076-.047.251-.163a13.341 13.341 0 0 0 1.546-1.198C11.214 6.754 12 5.479 12 4.25c0-1.085-.598-1.75-1.414-1.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.004 1.25C18.311 1.25 20 3.128 20 5.75c0 2.292-1.23 4.464-3.295 6.485-.481.47-.98.909-1.482 1.31l.265 1.32 1.375 7.5a.75.75 0 0 1-.982.844l-3.512-1.207a.75.75 0 0 0-.488 0L8.37 23.209a.75.75 0 0 1-.982-.844l1.378-7.512.261-1.309c-.5-.4-1-.838-1.481-1.31C5.479 10.215 4.25 8.043 4.25 5.75c0-2.622 1.689-4.5 3.996-4.5 1.55 0 2.947.752 3.832 1.967l.047.067.047-.067a4.726 4.726 0 0 1 3.612-1.962l.22-.005ZM13.89 14.531c-.418.285-.828.542-1.218.77l-.18.103a.75.75 0 0 1-.734 0l-.071-.04-.46-.272c-.282-.173-.573-.36-.868-.562l-.121.605-1.145 6.239 2.3-.79a2.248 2.248 0 0 1 1.284-.054l.18.053 2.299.79-1.141-6.226-.125-.616ZM16.004 2.75c-1.464 0-2.731.983-3.159 2.459-.209.721-1.231.721-1.44 0-.428-1.476-1.695-2.459-3.16-2.459-1.44 0-2.495 1.173-2.495 3 0 1.811 1.039 3.647 2.844 5.412a19.624 19.624 0 0 0 3.734 2.84l-.019-.011-.184-.111.147-.088a19.81 19.81 0 0 0 3.015-2.278l.37-.352C17.46 9.397 18.5 7.561 18.5 5.75c0-1.827-1.055-3-2.496-3Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$c19d0dc844f6640 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SquareIcon", "octicon octicon-square", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 5.75C4 4.784 4.784 4 5.75 4h4.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 10.25 12h-4.5A1.75 1.75 0 0 1 4 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h4.5a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 7.75C6 6.784 6.784 6 7.75 6h8.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 18h-8.5A1.75 1.75 0 0 1 6 16.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$49b2d680c6371a49 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SquareCircleIcon", "octicon octicon-square-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5 5.75A.75.75 0 0 1 5.75 5h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11Zm0-1.5a9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7 8.75C7 7.784 7.784 7 8.75 7h6.5c.966 0 1.75.784 1.75 1.75v6.5A1.75 1.75 0 0 1 15.25 17h-6.5A1.75 1.75 0 0 1 7 15.25v-6.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$3a174202ac13cfc8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SquareFillIcon", "octicon octicon-square-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75 4h4.5c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 10.25 12h-4.5A1.75 1.75 0 0 1 4 10.25v-4.5C4 4.784 4.784 4 5.75 4Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.75 6h8.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 16.25 18h-8.5A1.75 1.75 0 0 1 6 16.25v-8.5C6 6.784 6.784 6 7.75 6Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$28ef317d670d123d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SquirrelIcon", "octicon octicon-squirrel", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.499.75a.75.75 0 0 1 1.5 0v.996C5.9 2.903 6.793 3.65 7.662 4.376l.24.202c-.036-.694.055-1.422.426-2.163C9.1.873 10.794-.045 12.622.26 14.408.558 16 1.94 16 4.25c0 1.278-.954 2.575-2.44 2.734l.146.508.065.22c.203.701.412 1.455.476 2.226.142 1.707-.4 3.03-1.487 3.898C11.714 14.671 10.27 15 8.75 15h-6a.75.75 0 0 1 0-1.5h1.376a4.484 4.484 0 0 1-.563-1.191 3.835 3.835 0 0 1-.05-2.063 4.647 4.647 0 0 1-2.025-.293.75.75 0 0 1 .525-1.406c1.357.507 2.376-.006 2.698-.318l.009-.01a.747.747 0 0 1 1.06 0 .748.748 0 0 1-.012 1.074c-.912.92-.992 1.835-.768 2.586.221.74.745 1.337 1.196 1.621H8.75c1.343 0 2.398-.296 3.074-.836.635-.507 1.036-1.31.928-2.602-.05-.603-.216-1.224-.422-1.93l-.064-.221c-.12-.407-.246-.84-.353-1.29a2.425 2.425 0 0 1-.507-.441 3.075 3.075 0 0 1-.633-1.248.75.75 0 0 1 1.455-.364c.046.185.144.436.31.627.146.168.353.305.712.305.738 0 1.25-.615 1.25-1.25 0-1.47-.95-2.315-2.123-2.51-1.172-.196-2.227.387-2.706 1.345-.46.92-.27 1.774.019 3.062l.042.19a.884.884 0 0 1 .01.05c.348.443.666.949.94 1.553a.75.75 0 1 1-1.365.62c-.553-1.217-1.32-1.94-2.3-2.768L6.7 5.527c-.814-.68-1.75-1.462-2.692-2.619a3.737 3.737 0 0 0-1.023.88c-.406.495-.663 1.036-.722 1.508.116.122.306.21.591.239.388.038.797-.06 1.032-.19a.75.75 0 0 1 .728 1.31c-.515.287-1.23.439-1.906.373-.682-.067-1.473-.38-1.879-1.193L.75 5.677V5.5c0-.984.48-1.94 1.077-2.664.46-.559 1.05-1.055 1.673-1.353V.75Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M18.377 3.49c-1.862-.31-3.718.62-4.456 2.095-.428.857-.691 1.624-.728 2.361-.035.71.138 1.444.67 2.252.644.854 1.199 1.913 1.608 3.346a.75.75 0 1 1-1.442.412c-.353-1.236-.82-2.135-1.372-2.865l-.008-.01c-.53-.698-1.14-1.242-1.807-1.778a50.724 50.724 0 0 0-.667-.524C9.024 7.884 7.71 6.863 6.471 5.16c-.59.287-1.248.798-1.806 1.454-.665.78-1.097 1.66-1.158 2.446.246.36.685.61 1.246.715.643.12 1.278.015 1.633-.182a.75.75 0 1 1 .728 1.311c-.723.402-1.728.516-2.637.346-.916-.172-1.898-.667-2.398-1.666L2 9.427V9.25c0-1.323.678-2.615 1.523-3.607.7-.824 1.59-1.528 2.477-1.917V2.75a.75.75 0 1 1 1.5 0v1.27c1.154 1.67 2.363 2.612 3.568 3.551.207.162.415.323.621.489.001-.063.003-.126.006-.188.052-1.034.414-2.017.884-2.958 1.06-2.118 3.594-3.313 6.044-2.904 1.225.204 2.329.795 3.125 1.748C22.546 4.713 23 5.988 23 7.5c0 1.496-.913 3.255-2.688 3.652.838 1.699 1.438 3.768 1.181 5.697-.269 2.017-1.04 3.615-2.582 4.675C17.409 22.558 15.288 23 12.5 23H4.75a.75.75 0 0 1 0-1.5h2.322c-.58-.701-.998-1.578-1.223-2.471-.327-1.3-.297-2.786.265-4.131-.92.091-1.985-.02-3.126-.445a.75.75 0 1 1 .524-1.406c1.964.733 3.428.266 4.045-.19.068-.06.137-.12.208-.18a.745.745 0 0 1 .861-.076.746.746 0 0 1 .32.368.752.752 0 0 1-.173.819c-.077.076-.16.15-.252.221-1.322 1.234-1.62 3.055-1.218 4.654.438 1.737 1.574 2.833 2.69 2.837H12.5c2.674 0 4.429-.433 5.56-1.212 1.094-.752 1.715-1.904 1.946-3.637.236-1.768-.445-3.845-1.407-5.529a.576.576 0 0 1-.012-.02 3.557 3.557 0 0 1-1.553-.94c-.556-.565-.89-1.243-1.012-1.73a.75.75 0 0 1 1.456-.364c.057.231.26.67.626 1.043.35.357.822.623 1.443.623 1.172 0 1.953-1.058 1.953-2.234 0-1.205-.357-2.127-.903-2.78-.547-.654-1.318-1.08-2.22-1.23Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f95b8a41f9121b54 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StackIcon", "octicon octicon-stack", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.122.392a1.75 1.75 0 0 1 1.756 0l5.003 2.902c.83.481.83 1.68 0 2.162L8.878 8.358a1.75 1.75 0 0 1-1.756 0L2.119 5.456a1.251 1.251 0 0 1 0-2.162ZM8.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685 4.63 2.685a.248.248 0 0 0 .25 0l4.63-2.685ZM1.601 7.789a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0L1.874 8.814A.75.75 0 0 1 1.6 7.789Zm0 3.5a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0l-5.248-3.044a.75.75 0 0 1-.273-1.025Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.063 1.456a1.749 1.749 0 0 1 1.874 0l8.383 5.316a1.751 1.751 0 0 1 0 2.956l-8.383 5.316a1.749 1.749 0 0 1-1.874 0L2.68 9.728a1.751 1.751 0 0 1 0-2.956Zm1.071 1.267a.25.25 0 0 0-.268 0L3.483 8.039a.25.25 0 0 0 0 .422l8.383 5.316a.25.25 0 0 0 .268 0l8.383-5.316a.25.25 0 0 0 0-.422Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.867 12.324a.75.75 0 0 1 1.035-.232l8.964 5.685a.25.25 0 0 0 .268 0l8.964-5.685a.75.75 0 0 1 .804 1.267l-8.965 5.685a1.749 1.749 0 0 1-1.874 0l-8.965-5.685a.75.75 0 0 1-.231-1.035Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.867 16.324a.75.75 0 0 1 1.035-.232l8.964 5.685a.25.25 0 0 0 .268 0l8.964-5.685a.75.75 0 0 1 .804 1.267l-8.965 5.685a1.749 1.749 0 0 1-1.874 0l-8.965-5.685a.75.75 0 0 1-.231-1.035Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$601dd338d29e50b6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StackCheckIcon", "octicon octicon-stack-check", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.12208 0.392445C7.66506 0.0775182 8.33496 0.0775182 8.87794 0.392445L13.8809 3.29381C14.711 3.77549 14.7108 4.97413 13.8809 5.45592L8.87794 8.35827C8.33508 8.67301 7.66494 8.67302 7.12208 8.35827L2.11915 5.45592C1.28917 4.97413 1.28904 3.77549 2.11915 3.29381L7.12208 0.392445ZM8.12501 1.6903C8.04751 1.64541 7.95251 1.64541 7.87501 1.6903L3.24415 4.37487L7.87501 7.06041C7.95239 7.10512 8.04762 7.10512 8.12501 7.06041L12.7549 4.37487L8.12501 1.6903Z",
                fill: "#010409"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.60157 7.78917C1.80937 7.4309 2.26769 7.30897 2.62598 7.51671L7.87501 10.5607C8.23282 10.7685 8.35484 11.227 8.14747 11.5851C7.93965 11.9434 7.48039 12.0654 7.12208 11.8575L1.87403 8.81359C1.51575 8.60579 1.39382 8.14747 1.60157 7.78917Z",
                fill: "#010409"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.60157 11.2892C1.80937 10.9309 2.26769 10.809 2.62598 11.0167L7.87501 14.0607C8.23282 14.2685 8.35484 14.727 8.14747 15.0851C7.93965 15.4434 7.48039 15.5654 7.12208 15.3575L1.87403 12.3136C1.51575 12.1058 1.39382 11.6475 1.60157 11.2892Z",
                fill: "#010409"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.7012 10.4894C14.9832 10.1863 15.4575 10.1693 15.7607 10.4513C16.0639 10.7334 16.0808 11.2076 15.7988 11.5109L12.0801 15.5109C11.9422 15.6591 11.7503 15.7456 11.5479 15.7501C11.3453 15.7546 11.1493 15.6764 11.0049 15.5343L9.22364 13.7823C8.92841 13.4918 8.9253 13.016 9.21583 12.7208C9.5064 12.426 9.98128 12.4226 10.2764 12.713L11.5068 13.9239L14.7012 10.4894Z",
                fill: "#010409"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$9fac3d0eed51aa48 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StackRemoveIcon", "octicon octicon-stack-remove", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.7193 10.2198C15.0121 9.92692 15.4869 9.92701 15.7798 10.2198C16.0727 10.5127 16.0727 10.9874 15.7798 11.2803L14.0601 13L15.7798 14.7198C16.0727 15.0127 16.0727 15.4874 15.7798 15.7803C15.4869 16.0729 15.0121 16.0731 14.7193 15.7803L12.9996 14.0606L11.2798 15.7803C10.9869 16.0729 10.5121 16.0731 10.2193 15.7803C9.92663 15.4875 9.92676 15.0127 10.2193 14.7198L11.939 13L10.2193 11.2803C9.92663 10.9875 9.92676 10.5127 10.2193 10.2198C10.5121 9.92692 10.9869 9.92701 11.2798 10.2198L12.9996 11.9395L14.7193 10.2198Z",
                fill: "#010409"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.60113 11.2891C1.80888 10.9309 2.26729 10.8091 2.62555 11.0167L7.87457 14.0606C8.23239 14.2684 8.3544 14.7269 8.14703 15.085C7.93913 15.4431 7.47985 15.5652 7.12164 15.3575L1.87359 12.3135C1.51562 12.1057 1.39367 11.6473 1.60113 11.2891Z",
                fill: "#010409"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.60113 7.78911C1.80888 7.43092 2.26729 7.30912 2.62555 7.51665L7.87457 10.5606C8.23239 10.7684 8.3544 11.2269 8.14703 11.585C7.93913 11.9431 7.47985 12.0652 7.12164 11.8575L1.87359 8.81353C1.51562 8.60571 1.39367 8.14728 1.60113 7.78911Z",
                fill: "#010409"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.12164 0.392627C7.66455 0.0777416 8.33456 0.0778247 8.8775 0.392627L13.8804 3.29399C14.7105 3.77567 14.7104 4.97432 13.8804 5.4561L8.8775 8.35845C8.33472 8.67294 7.66435 8.67311 7.12164 8.35845L2.11871 5.4561C1.28909 4.97432 1.28912 3.7758 2.11871 3.29399L7.12164 0.392627ZM8.12457 1.69048C8.04711 1.64572 7.952 1.64563 7.87457 1.69048L3.24371 4.37505L7.87457 7.0606C7.9518 7.10522 8.04727 7.10505 8.12457 7.0606L12.7545 4.37505L8.12457 1.69048Z",
                fill: "#010409"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$2ee28caa7f1e962e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StarIcon", "octicon octicon-star", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Zm0 2.445L6.615 5.5a.75.75 0 0 1-.564.41l-3.097.45 2.24 2.184a.75.75 0 0 1 .216.664l-.528 3.084 2.769-1.456a.75.75 0 0 1 .698 0l2.77 1.456-.53-3.084a.75.75 0 0 1 .216-.664l2.24-2.183-3.096-.45a.75.75 0 0 1-.564-.41L8 2.694Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 .25a.75.75 0 0 1 .673.418l3.058 6.197 6.839.994a.75.75 0 0 1 .415 1.279l-4.948 4.823 1.168 6.811a.751.751 0 0 1-1.088.791L12 18.347l-6.117 3.216a.75.75 0 0 1-1.088-.79l1.168-6.812-4.948-4.823a.75.75 0 0 1 .416-1.28l6.838-.993L11.328.668A.75.75 0 0 1 12 .25Zm0 2.445L9.44 7.882a.75.75 0 0 1-.565.41l-5.725.832 4.143 4.038a.748.748 0 0 1 .215.664l-.978 5.702 5.121-2.692a.75.75 0 0 1 .698 0l5.12 2.692-.977-5.702a.748.748 0 0 1 .215-.664l4.143-4.038-5.725-.831a.75.75 0 0 1-.565-.41L12 2.694Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$631562bf0758540f = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StarFillIcon", "octicon octicon-star-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.672.668 3.059 6.197 6.838.993a.75.75 0 0 1 .416 1.28l-4.948 4.823 1.168 6.812a.75.75 0 0 1-1.088.79L12 18.347l-6.116 3.216a.75.75 0 0 1-1.088-.791l1.168-6.811-4.948-4.823a.749.749 0 0 1 .416-1.279l6.838-.994L11.327.668a.75.75 0 0 1 1.345 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$dc6949a98411e916 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StopIcon", "octicon octicon-stop", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 7Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.328 1.47a.749.749 0 0 1 .53-.22h8.284c.199 0 .389.079.53.22l5.858 5.858c.141.14.22.33.22.53v8.284a.749.749 0 0 1-.22.53l-5.858 5.858a.749.749 0 0 1-.53.22H7.858a.749.749 0 0 1-.53-.22L1.47 16.672a.749.749 0 0 1-.22-.53V7.858c0-.199.079-.389.22-.53Zm.84 1.28L2.75 8.169v7.662l5.419 5.419h7.662l5.419-5.418V8.168L15.832 2.75Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$93c9322cdb01abe0 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StopwatchIcon", "octicon octicon-stopwatch", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.75.75A.75.75 0 0 1 6.5 0h3a.75.75 0 0 1 0 1.5h-.75v1l-.001.041a6.724 6.724 0 0 1 3.464 1.435l.007-.006.75-.75a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-.75.75-.006.007a6.75 6.75 0 1 1-10.548 0L2.72 5.03l-.75-.75a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l.75.75.007.006A6.72 6.72 0 0 1 7.25 2.541V1.5H6.5a.75.75 0 0 1-.75-.75ZM8 14.5a5.25 5.25 0 1 0-.001-10.501A5.25 5.25 0 0 0 8 14.5Zm.389-6.7 1.33-1.33a.75.75 0 1 1 1.061 1.06L9.45 8.861A1.503 1.503 0 0 1 8 10.75a1.499 1.499 0 1 1 .389-2.95Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.25 0h3.5a.75.75 0 0 1 0 1.5h-1v1.278a9.954 9.954 0 0 1 5.636 2.276L19.72 3.72a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.315 1.316A9.959 9.959 0 0 1 22 12.75c0 5.523-4.477 10-10 10s-10-4.477-10-10a9.959 9.959 0 0 1 2.535-6.654L3.22 4.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.335 1.334a9.958 9.958 0 0 1 5.635-2.276V1.5h-1a.75.75 0 0 1 0-1.5ZM12 21.25a8.5 8.5 0 1 0-.001-17.001A8.5 8.5 0 0 0 12 21.25Zm4.03-12.53a.75.75 0 0 1 0 1.06l-2.381 2.382a1.75 1.75 0 1 1-1.06-1.06l2.38-2.382a.75.75 0 0 1 1.061 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$25ec4ecc9c5701a5 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("StrikethroughIcon", "octicon octicon-strikethrough", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.055 8.5c.524.536.815 1.257.811 2.007a3.133 3.133 0 0 1-1.12 2.408C9.948 13.597 8.748 14 7.096 14c-1.706 0-3.104-.607-3.902-1.377a.751.751 0 0 1 1.042-1.079c.48.463 1.487.956 2.86.956 1.422 0 2.232-.346 2.676-.726.435-.372.594-.839.594-1.267 0-.472-.208-.857-.647-1.197-.448-.346-1.116-.623-1.951-.81H1.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5ZM7.581 3.25c-2.036 0-2.778 1.082-2.778 1.786 0 .055.002.107.006.157a.75.75 0 0 1-1.496.114 3.506 3.506 0 0 1-.01-.271c0-1.832 1.75-3.286 4.278-3.286 1.418 0 2.721.58 3.514 1.093a.75.75 0 1 1-.814 1.26c-.64-.414-1.662-.853-2.7-.853Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m16.533 12.5.054.043c.93.75 1.538 1.77 1.538 3.066a4.13 4.13 0 0 1-1.479 3.177c-1.058.904-2.679 1.464-4.974 1.464-2.35 0-4.252-.837-5.318-1.865a.75.75 0 1 1 1.042-1.08c.747.722 2.258 1.445 4.276 1.445 2.065 0 3.296-.504 3.999-1.105a2.63 2.63 0 0 0 .954-2.036c0-.764-.337-1.38-.979-1.898-.649-.523-1.598-.931-2.76-1.211H3.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5ZM12.36 5C9.37 5 8.105 6.613 8.105 7.848c0 .411.072.744.193 1.02a.75.75 0 0 1-1.373.603 3.988 3.988 0 0 1-.32-1.623c0-2.363 2.271-4.348 5.755-4.348 1.931 0 3.722.794 4.814 1.5a.75.75 0 1 1-.814 1.26c-.94-.607-2.448-1.26-4-1.26Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$cd27c497b93dbe8d = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SunIcon", "octicon octicon-sun", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm5.657-8.157a.75.75 0 0 1 0 1.061l-1.061 1.06a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.06-1.06a.75.75 0 0 1 1.06 0Zm-9.193 9.193a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 1 1-1.061-1.06l1.06-1.061a.75.75 0 0 1 1.061 0ZM8 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0ZM3 8a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 3 8Zm13 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 16 8Zm-8 5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 8 13Zm3.536-1.464a.75.75 0 0 1 1.06 0l1.061 1.06a.75.75 0 0 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 0-1.061ZM2.343 2.343a.75.75 0 0 1 1.061 0l1.06 1.061a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-1.06-1.06a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 1 0 0 11Zm-5.657.157a.75.75 0 0 1 0 1.06l-1.768 1.768a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.767-1.768a.75.75 0 0 1 1.061 0ZM3.515 3.515a.75.75 0 0 1 1.06 0l1.768 1.768a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L3.515 4.575a.75.75 0 0 1 0-1.06ZM12 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 12 0ZM4 12a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 4 12Zm8 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 12 20Zm12-8a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 24 12Zm-6.343 5.657a.75.75 0 0 1 1.06 0l1.768 1.768a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-1.768-1.767a.75.75 0 0 1 0-1.061Zm2.828-14.142a.75.75 0 0 1 0 1.06l-1.768 1.768a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l1.767-1.768a.75.75 0 0 1 1.061 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$6275f016a953141a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("SyncIcon", "octicon octicon-sync", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.705 8.005a.75.75 0 0 1 .834.656 5.5 5.5 0 0 0 9.592 2.97l-1.204-1.204a.25.25 0 0 1 .177-.427h3.646a.25.25 0 0 1 .25.25v3.646a.25.25 0 0 1-.427.177l-1.38-1.38A7.002 7.002 0 0 1 1.05 8.84a.75.75 0 0 1 .656-.834ZM8 2.5a5.487 5.487 0 0 0-4.131 1.869l1.204 1.204A.25.25 0 0 1 4.896 6H1.25A.25.25 0 0 1 1 5.75V2.104a.25.25 0 0 1 .427-.177l1.38 1.38A7.002 7.002 0 0 1 14.95 7.16a.75.75 0 0 1-1.49.178A5.5 5.5 0 0 0 8 2.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.38 8A9.502 9.502 0 0 1 12 2.5a9.502 9.502 0 0 1 9.215 7.182.75.75 0 1 0 1.456-.364C21.473 4.539 17.15 1 12 1a10.995 10.995 0 0 0-9.5 5.452V4.75a.75.75 0 0 0-1.5 0V8.5a1 1 0 0 0 1 1h3.75a.75.75 0 0 0 0-1.5H3.38Zm-.595 6.318a.75.75 0 0 0-1.455.364C2.527 19.461 6.85 23 12 23c4.052 0 7.592-2.191 9.5-5.451v1.701a.75.75 0 0 0 1.5 0V15.5a1 1 0 0 0-1-1h-3.75a.75.75 0 0 0 0 1.5h2.37A9.502 9.502 0 0 1 12 21.5c-4.446 0-8.181-3.055-9.215-7.182Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$101d1271c02245ef = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TabIcon", "octicon octicon-tab", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m10.78 8.53-3.75 3.75a.749.749 0 1 1-1.06-1.06l2.469-2.47H1.75a.75.75 0 0 1 0-1.5h6.689L5.97 4.78a.749.749 0 1 1 1.06-1.06l3.75 3.75a.749.749 0 0 1 0 1.06ZM13 12.25v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M22 4.25a.75.75 0 0 0-1.5 0v15a.75.75 0 0 0 1.5 0v-15Zm-9.72 14.28a.75.75 0 1 1-1.06-1.06l4.97-4.97H1.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.75.75 0 0 1 1.06-1.06l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$31b3da7e5240c9e6 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TabExternalIcon", "octicon octicon-tab-external", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.25 4a.25.25 0 0 0-.25.25v9a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h.75V4.25c0-.966.784-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v8.25h.75a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75v-9a.25.25 0 0 0-.25-.25h-9.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m7.97 7.97-2.75 2.75a.75.75 0 1 0 1.06 1.06l2.75-2.75 1.543 1.543a.25.25 0 0 0 .427-.177V6.25a.25.25 0 0 0-.25-.25H6.604a.25.25 0 0 0-.177.427L7.97 7.97Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 5.75C3 4.784 3.784 4 4.75 4h14.5c.966 0 1.75.784 1.75 1.75V18.5h2a.75.75 0 0 1 0 1.5h-2.65a.85.85 0 0 1-.85-.85V5.75a.25.25 0 0 0-.25-.25H4.75a.25.25 0 0 0-.25.25v13.4c0 .47-.38.85-.85.85H1a.75.75 0 0 1 0-1.5h2V5.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.404 13.7a.75.75 0 0 1-1.29.547 689.448 689.448 0 0 0-1.92-1.976l-4.141 4.14a.75.75 0 0 1-1.061-1.06l4.14-4.14-1.94-1.94A.75.75 0 0 1 10.703 8h4.95a.75.75 0 0 1 .75.75v4.95Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$560b0277c649ed6b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TableIcon", "octicon octicon-table", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25ZM6.5 6.5v8h7.75a.25.25 0 0 0 .25-.25V6.5Zm8-1.5V1.75a.25.25 0 0 0-.25-.25H6.5V5Zm-13 1.5v7.75c0 .138.112.25.25.25H5v-8ZM5 5V1.5H1.75a.25.25 0 0 0-.25.25V5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25ZM9 9v11.5h11.25a.25.25 0 0 0 .25-.25V9Zm11.5-1.5V3.75a.25.25 0 0 0-.25-.25H9v4ZM3.5 9v11.25c0 .138.112.25.25.25H7.5V9Zm4-1.5v-4H3.75a.25.25 0 0 0-.25.25V7.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$80beb1cb95701424 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TagIcon", "octicon octicon-tag", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.752 1.752 0 0 1 1 7.775Zm1.5 0c0 .066.026.13.073.177l6.25 6.25a.25.25 0 0 0 .354 0l5.025-5.025a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.177-.073H2.75a.25.25 0 0 0-.25.25ZM6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.75 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.5 1h8.44a1.5 1.5 0 0 1 1.06.44l10.25 10.25a1.5 1.5 0 0 1 0 2.12l-8.44 8.44a1.5 1.5 0 0 1-2.12 0L1.44 12A1.497 1.497 0 0 1 1 10.94V2.5A1.5 1.5 0 0 1 2.5 1Zm0 1.5v8.44l10.25 10.25 8.44-8.44L10.94 2.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$464aecc9a55fb878 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TasklistIcon", "octicon octicon-tasklist", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2 2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm4.655 8.595a.75.75 0 0 1 0 1.06L4.03 14.28a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.095-2.095a.75.75 0 0 1 1.06 0ZM9.75 2.5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm0 5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm0 5h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Zm-7.25-9v3h3v-3Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3 6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm1.5 4.5h4v-4h-4Zm8.25-5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm-2.97-2.53a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 2.97-2.97a.75.75 0 0 1 1.06 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4cb6639b7b9a0249 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TelescopeIcon", "octicon octicon-telescope", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.184 1.143v-.001l1.422 2.464a1.75 1.75 0 0 1-.757 2.451L3.104 11.713a1.75 1.75 0 0 1-2.275-.702l-.447-.775a1.75 1.75 0 0 1 .53-2.32L11.682.573a1.748 1.748 0 0 1 2.502.57Zm-4.709 9.32h-.001l2.644 3.863a.75.75 0 1 1-1.238.848l-1.881-2.75v2.826a.75.75 0 0 1-1.5 0v-2.826l-1.881 2.75a.75.75 0 1 1-1.238-.848l2.049-2.992a.746.746 0 0 1 .293-.253l1.809-.87a.749.749 0 0 1 .944.252ZM9.436 3.92h-.001l-4.97 3.39.942 1.63 5.42-2.61Zm3.091-2.108h.001l-1.85 1.26 1.505 2.605 2.016-.97a.247.247 0 0 0 .13-.151.247.247 0 0 0-.022-.199l-1.422-2.464a.253.253 0 0 0-.161-.119.254.254 0 0 0-.197.038ZM1.756 9.157a.25.25 0 0 0-.075.33l.447.775a.25.25 0 0 0 .325.1l1.598-.769-.83-1.436-1.465 1Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M.408 15.13a2 2 0 0 1 .59-2.642L17.038 1.33a1.999 1.999 0 0 1 2.85.602l2.828 4.644a2 2 0 0 1-.851 2.847l-17.762 8.43a2 2 0 0 1-2.59-.807Zm5.263-4.066 1.987 3.44 8.712-4.135-2.857-4.76Zm12.06-1.34.001-.001 3.49-1.656a.498.498 0 0 0 .212-.712l-2.826-4.644a.503.503 0 0 0-.713-.151l-3.148 2.19Zm-13.295 2.2L1.854 13.72a.5.5 0 0 0-.147.66l1.105 1.915a.5.5 0 0 0 .648.201l2.838-1.347ZM17.155 22.87a.75.75 0 0 0 .226-1.036l-4-6.239a.75.75 0 0 0-.941-.278l-2.75 1.25a.75.75 0 0 0-.318.274l-3.25 4.989a.75.75 0 0 0 1.256.819l3.131-4.806.51-.232v5.64a.75.75 0 1 0 1.5 0v-6.22l3.6 5.613a.75.75 0 0 0 1.036.226Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8d68df259ae2ded9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TelescopeFillIcon", "octicon octicon-telescope-fill", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.905.42a1.5 1.5 0 0 1 2.144.49l1.692 2.93a1.5 1.5 0 0 1-.649 2.102L2.895 11.815a1.5 1.5 0 0 1-1.95-.602l-.68-1.176a1.5 1.5 0 0 1 .455-1.99L11.905.422Zm-3.374 9.79a.75.75 0 0 1 .944.253l2.644 3.864a.751.751 0 0 1-1.238.847L9 12.424v2.826a.75.75 0 0 1-1.5 0v-2.826l-1.881 2.75a.75.75 0 1 1-1.238-.848l2.048-2.992a.752.752 0 0 1 .293-.252l1.81-.871Zm2.476-3.965v-.001l1.356-.653-1.52-2.631-1.243.848ZM3.279 8.119l.835 1.445 1.355-.653-.947-1.64Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.155 22.87a.75.75 0 0 0 .226-1.036l-4-6.239a.75.75 0 0 0-.941-.277l-2.75 1.25a.75.75 0 0 0-.318.273l-3.25 4.989a.75.75 0 0 0 1.256.819l3.131-4.806.51-.232v5.64a.75.75 0 1 0 1.5 0v-6.22l3.6 5.613a.75.75 0 0 0 1.036.226ZM.408 15.13a2 2 0 0 1 .59-2.642L17.038 1.33a1.999 1.999 0 0 1 2.85.602l2.828 4.644a2 2 0 0 1-.851 2.847l-17.762 8.43a2 2 0 0 1-2.59-.807Zm13.105-9.521 2.857 4.76 1.361-.646-2.984-4.973Zm-7.842 5.455-1.235.86 1.862 3.225 1.36-.645Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9ff5547afd06adf7 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TerminalIcon", "octicon octicon-terminal", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25Zm1.75-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM7.25 8a.749.749 0 0 1-.22.53l-2.25 2.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L5.44 8 3.72 6.28a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l2.25 2.25c.141.14.22.331.22.53Zm1.5 1.5h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.25 12a.75.75 0 0 1-.22.53l-2.75 2.75a.75.75 0 0 1-1.06-1.06L7.44 12 5.22 9.78a.75.75 0 1 1 1.06-1.06l2.75 2.75c.141.14.22.331.22.53Zm2 2a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$d771fc36eba591ce = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ThreeBarsIcon", "octicon octicon-three-bars", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 2.75A.75.75 0 0 1 1.75 2h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 2.75Zm0 5A.75.75 0 0 1 1.75 7h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75ZM1.75 12h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 5.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Zm0 6a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Zm0 6a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$d57a6722de6c45ee = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ThumbsdownIcon", "octicon octicon-thumbsdown", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.653 15.369a.75.75 0 0 1-.776.371l-.238-.04a3.25 3.25 0 0 1-2.591-4.099L4.506 10h-.665A3.25 3.25 0 0 1 .723 5.833l1.135-3.859A2.75 2.75 0 0 1 4.482 0H9.43c.78.003 1.538.25 2.168.702A1.752 1.752 0 0 1 12.989 0h1.272A1.75 1.75 0 0 1 16 1.75v6.5A1.75 1.75 0 0 1 14.25 10h-3.417a.25.25 0 0 0-.217.127ZM11.25 2.351l-.396-.33a2.248 2.248 0 0 0-1.44-.521H4.496a1.25 1.25 0 0 0-1.199.897L2.162 6.256A1.75 1.75 0 0 0 3.841 8.5H5.5a.75.75 0 0 1 .721.956l-.731 2.558a1.75 1.75 0 0 0 1.127 2.14L9.31 9.389a1.75 1.75 0 0 1 1.523-.889h.417Zm1.5 6.149h1.5a.25.25 0 0 0 .25-.25v-6.5a.25.25 0 0 0-.25-.25H13a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.651 21.622a.748.748 0 0 1-.808.361l-.127-.027a3.875 3.875 0 0 1-2.879-4.97L7.473 15H6.336c-2.645 0-4.513-2.591-3.676-5.1l1.559-4.678A3.25 3.25 0 0 1 7.302 3h5.289c1.031 0 2.029.354 2.828.999A1.75 1.75 0 0 1 17 3h2.25c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 19.25 15h-4.67a.251.251 0 0 0-.217.126l-3.712 6.496ZM15.25 5.84l-.684-.598a2.999 2.999 0 0 0-1.975-.742H7.302a1.75 1.75 0 0 0-1.66 1.197l-1.559 4.677A2.375 2.375 0 0 0 6.336 13.5H8.5a.75.75 0 0 1 .714.979l-.948 2.964a2.375 2.375 0 0 0 1.373 2.927l3.422-5.988a1.749 1.749 0 0 1 1.519-.882h.67V5.84Zm1.5 7.66h2.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H17a.25.25 0 0 0-.25.25v8.75Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8c9dd934a8e6d9f2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ThumbsupIcon", "octicon octicon-thumbsup", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M8.347.631A.75.75 0 0 1 9.123.26l.238.04a3.25 3.25 0 0 1 2.591 4.098L11.494 6h.665a3.25 3.25 0 0 1 3.118 4.167l-1.135 3.859A2.751 2.751 0 0 1 11.503 16H6.586a3.75 3.75 0 0 1-2.184-.702A1.75 1.75 0 0 1 3 16H1.75A1.75 1.75 0 0 1 0 14.25v-6.5C0 6.784.784 6 1.75 6h3.417a.25.25 0 0 0 .217-.127ZM4.75 13.649l.396.33c.404.337.914.521 1.44.521h4.917a1.25 1.25 0 0 0 1.2-.897l1.135-3.859A1.75 1.75 0 0 0 12.159 7.5H10.5a.75.75 0 0 1-.721-.956l.731-2.558a1.75 1.75 0 0 0-1.127-2.14L6.69 6.611a1.75 1.75 0 0 1-1.523.889H4.75ZM3.25 7.5h-1.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25H3a.25.25 0 0 0 .25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13.349 2.378a.748.748 0 0 1 .808-.361l.127.027a3.875 3.875 0 0 1 2.879 4.97L16.527 9h1.137c2.645 0 4.513 2.591 3.676 5.1l-1.559 4.678A3.25 3.25 0 0 1 16.698 21h-5.289a4.503 4.503 0 0 1-2.828-.999A1.75 1.75 0 0 1 7 21H4.75A1.75 1.75 0 0 1 3 19.25v-8.5C3 9.784 3.784 9 4.75 9h4.67a.251.251 0 0 0 .217-.126l3.712-6.496ZM8.75 18.16l.683.598a3.003 3.003 0 0 0 1.976.742h5.289a1.75 1.75 0 0 0 1.66-1.197l1.559-4.677a2.375 2.375 0 0 0-2.253-3.126H15.5a.75.75 0 0 1-.714-.979l.948-2.964a2.375 2.375 0 0 0-1.373-2.927l-3.422 5.988a1.749 1.749 0 0 1-1.519.882h-.67v7.66Zm-1.5-7.66h-2.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25H7a.25.25 0 0 0 .25-.25V10.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3d7439614fbf4d3e = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ToolsIcon", "octicon octicon-tools", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.433 2.304A4.492 4.492 0 0 0 3.5 6c0 1.598.832 3.002 2.09 3.802.518.328.929.923.902 1.64v.008l-.164 3.337a.75.75 0 1 1-1.498-.073l.163-3.33c.002-.085-.05-.216-.207-.316A5.996 5.996 0 0 1 2 6a5.993 5.993 0 0 1 2.567-4.92 1.482 1.482 0 0 1 1.673-.04c.462.296.76.827.76 1.423v2.82c0 .082.041.16.11.206l.75.51a.25.25 0 0 0 .28 0l.75-.51A.249.249 0 0 0 9 5.282V2.463c0-.596.298-1.127.76-1.423a1.482 1.482 0 0 1 1.673.04A5.993 5.993 0 0 1 14 6a5.996 5.996 0 0 1-2.786 5.068c-.157.1-.209.23-.207.315l.163 3.33a.752.752 0 0 1-1.094.714.75.75 0 0 1-.404-.64l-.164-3.345c-.027-.717.384-1.312.902-1.64A4.495 4.495 0 0 0 12.5 6a4.492 4.492 0 0 0-1.933-3.696c-.024.017-.067.067-.067.16v2.818a1.75 1.75 0 0 1-.767 1.448l-.75.51a1.75 1.75 0 0 1-1.966 0l-.75-.51A1.75 1.75 0 0 1 5.5 5.282V2.463c0-.092-.043-.142-.067-.159Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.875 2.292a.114.114 0 0 0-.032.018A7.239 7.239 0 0 0 4.75 8.25a7.248 7.248 0 0 0 3.654 6.297c.57.327.982.955.941 1.682v.002l-.317 6.058a.75.75 0 1 1-1.498-.078l.317-6.062v-.004c.006-.09-.047-.215-.188-.296A8.749 8.749 0 0 1 3.25 8.25a8.738 8.738 0 0 1 3.732-7.169 1.547 1.547 0 0 1 1.709-.064c.484.292.809.835.809 1.46v4.714a.25.25 0 0 0 .119.213l2.25 1.385c.08.05.182.05.262 0l2.25-1.385a.25.25 0 0 0 .119-.213V2.478c0-.626.325-1.169.81-1.461a1.547 1.547 0 0 1 1.708.064 8.741 8.741 0 0 1 3.732 7.17 8.747 8.747 0 0 1-4.41 7.598c-.14.081-.193.206-.188.296v.004l.318 6.062a.75.75 0 1 1-1.498.078l-.317-6.058v-.002c-.041-.727.37-1.355.94-1.682A7.247 7.247 0 0 0 19.25 8.25a7.239 7.239 0 0 0-3.093-5.94.114.114 0 0 0-.032-.018l-.01-.001c-.003 0-.014 0-.031.01-.036.022-.084.079-.084.177V7.19c0 .608-.315 1.172-.833 1.49l-2.25 1.385a1.75 1.75 0 0 1-1.834 0l-2.25-1.384A1.752 1.752 0 0 1 8 7.192V2.477c0-.098-.048-.155-.084-.176a.068.068 0 0 0-.031-.011l-.01.001Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$b405612484fbb0ad = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TrackedByClosedCompletedIcon", "octicon octicon-tracked-by-closed-completed", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 8a6.5 6.5 0 1 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.677 12.427 2.896 2.896a.25.25 0 0 0 .427-.177V13h3.25a.75.75 0 0 0 0-1.5H12V9.354a.25.25 0 0 0-.427-.177l-2.896 2.896a.25.25 0 0 0 0 .354ZM11.28 6.78a.749.749 0 1 0-1.06-1.06L7.25 8.689 5.78 7.22a.749.749 0 1 0-1.06 1.06l2 2a.749.749 0 0 0 1.06 0l3.5-3.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5.75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23l-3.728 3.314a.307.307 0 0 0 0 .46Zm3.521-8.2a.749.749 0 1 0-1.06-1.06l-5.97 5.969-2.47-2.469a.749.749 0 1 0-1.06 1.06l3 3a.749.749 0 0 0 1.06 0l6.5-6.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$b11d2801d5c8bee8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TrackedByClosedNotPlannedIcon", "octicon octicon-tracked-by-closed-not-planned", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.5 8a6.5 6.5 0 1 1 13 0A.75.75 0 0 0 16 8a8 8 0 1 0-8 8 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.677 12.427 2.896 2.896a.25.25 0 0 0 .427-.177V13h3.25a.75.75 0 0 0 0-1.5H12V9.354a.25.25 0 0 0-.427-.177l-2.896 2.896a.25.25 0 0 0 0 .354ZM11.28 5.78a.749.749 0 1 0-1.06-1.06l-5.5 5.5a.749.749 0 1 0 1.06 1.06l5.5-5.5Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 2.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5.75.75 0 0 1 0 1.5C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11a.75.75 0 0 1-1.5 0A9.5 9.5 0 0 0 12 2.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m13.759 17.48 3.728 3.314a.308.308 0 0 0 .513-.23V18h4.25a.75.75 0 0 0 0-1.5H18v-2.564a.308.308 0 0 0-.513-.23l-3.728 3.314a.307.307 0 0 0 0 .46Zm3.521-9.7a.749.749 0 1 0-1.06-1.06l-9.5 9.5a.749.749 0 1 0 1.06 1.06l9.5-9.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$d23329de703dffc4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TrashIcon", "octicon octicon-trash", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11 1.75V3h2.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75ZM4.496 6.675l.66 6.6a.25.25 0 0 0 .249.225h5.19a.25.25 0 0 0 .249-.225l.66-6.6a.75.75 0 0 1 1.492.149l-.66 6.6A1.748 1.748 0 0 1 10.595 15h-5.19a1.75 1.75 0 0 1-1.741-1.575l-.66-6.6a.75.75 0 1 1 1.492-.15ZM6.5 1.75V3h3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16 1.75V3h5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75Zm-6.5 0V3h5V1.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25ZM4.997 6.178a.75.75 0 1 0-1.493.144L4.916 20.92a1.75 1.75 0 0 0 1.742 1.58h10.684a1.75 1.75 0 0 0 1.742-1.581l1.413-14.597a.75.75 0 0 0-1.494-.144l-1.412 14.596a.25.25 0 0 1-.249.226H6.658a.25.25 0 0 1-.249-.226L4.997 6.178Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.206 7.501a.75.75 0 0 1 .793.705l.5 8.5A.75.75 0 1 1 9 16.794l-.5-8.5a.75.75 0 0 1 .705-.793Zm6.293.793A.75.75 0 1 0 14 8.206l-.5 8.5a.75.75 0 0 0 1.498.088l.5-8.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$b445c2dc6993f9f8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TriangleDownIcon", "octicon octicon-triangle-down", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m4.427 7.427 3.396 3.396a.25.25 0 0 0 .354 0l3.396-3.396A.25.25 0 0 0 11.396 7H4.604a.25.25 0 0 0-.177.427Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.646 15.146 5.854 9.354a.5.5 0 0 1 .353-.854h11.586a.5.5 0 0 1 .353.854l-5.793 5.792a.5.5 0 0 1-.707 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$62f44957433ecfbf = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TriangleLeftIcon", "octicon octicon-triangle-left", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.573 4.427 6.177 7.823a.25.25 0 0 0 0 .354l3.396 3.396a.25.25 0 0 0 .427-.177V4.604a.25.25 0 0 0-.427-.177Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.854 11.646 5.792-5.792a.5.5 0 0 1 .854.353v11.586a.5.5 0 0 1-.854.353l-5.792-5.792a.5.5 0 0 1 0-.708Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$43e4d35e8a44b537 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TriangleRightIcon", "octicon octicon-triangle-right", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m6.427 4.427 3.396 3.396a.25.25 0 0 1 0 .354l-3.396 3.396A.25.25 0 0 1 6 11.396V4.604a.25.25 0 0 1 .427-.177Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m15.146 12.354-5.792 5.792a.5.5 0 0 1-.854-.353V6.207a.5.5 0 0 1 .854-.353l5.792 5.792a.5.5 0 0 1 0 .708Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$9ff28f4659896371 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TriangleUpIcon", "octicon octicon-triangle-up", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m4.427 9.573 3.396-3.396a.25.25 0 0 1 .354 0l3.396 3.396a.25.25 0 0 1-.177.427H4.604a.25.25 0 0 1-.177-.427Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m12.354 8.854 5.792 5.792a.5.5 0 0 1-.353.854H6.207a.5.5 0 0 1-.353-.854l5.792-5.792a.5.5 0 0 1 .708 0Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$38852ed648a706e8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TrophyIcon", "octicon octicon-trophy", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.217 6.962A3.75 3.75 0 0 1 0 3.25v-.5C0 1.784.784 1 1.75 1h1.356c.228-.585.796-1 1.462-1h6.864c.647 0 1.227.397 1.462 1h1.356c.966 0 1.75.784 1.75 1.75v.5a3.75 3.75 0 0 1-3.217 3.712 5.014 5.014 0 0 1-2.771 3.117l.144 1.446c.005.05.03.12.114.204.086.087.217.17.373.227.283.103.618.274.89.568.285.31.467.723.467 1.226v.75h1.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H4v-.75c0-.503.182-.916.468-1.226.27-.294.606-.465.889-.568.139-.048.266-.126.373-.227.084-.085.109-.153.114-.204l.144-1.446a5.015 5.015 0 0 1-2.77-3.117ZM4.5 1.568V5.5a3.5 3.5 0 1 0 7 0V1.568a.068.068 0 0 0-.068-.068H4.568a.068.068 0 0 0-.068.068Zm2.957 8.902-.12 1.204c-.093.925-.858 1.47-1.467 1.691a.766.766 0 0 0-.3.176c-.037.04-.07.093-.07.21v.75h5v-.75c0-.117-.033-.17-.07-.21a.766.766 0 0 0-.3-.176c-.609-.221-1.374-.766-1.466-1.69l-.12-1.204a5.064 5.064 0 0 1-1.087 0ZM13 2.5v2.872a2.25 2.25 0 0 0 1.5-2.122v-.5a.25.25 0 0 0-.25-.25H13Zm-10 0H1.75a.25.25 0 0 0-.25.25v.5c0 .98.626 1.813 1.5 2.122Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.09 10.121A5.251 5.251 0 0 1 1 5V3.75C1 2.784 1.784 2 2.75 2h2.364c.236-.586.81-1 1.48-1h10.812c.67 0 1.244.414 1.48 1h2.489c.966 0 1.75.784 1.75 1.75V5a5.252 5.252 0 0 1-4.219 5.149 7.01 7.01 0 0 1-4.644 5.478l.231 3.003a.5.5 0 0 0 .034.031c.079.065.303.203.836.282.838.124 1.637.81 1.637 1.807v.75h2.25a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5H7v-.75c0-.996.8-1.683 1.637-1.807.533-.08.757-.217.836-.282a.5.5 0 0 0 .034-.031l.231-3.003A7.012 7.012 0 0 1 5.09 10.12ZM6.5 2.594V9a5.5 5.5 0 1 0 11 0V2.594a.094.094 0 0 0-.094-.094H6.594a.094.094 0 0 0-.094.094Zm4.717 13.363-.215 2.793-.001.021-.003.043a1.212 1.212 0 0 1-.022.147c-.05.237-.194.567-.553.86-.348.286-.853.5-1.566.605a.478.478 0 0 0-.274.136.264.264 0 0 0-.083.188v.75h7v-.75a.264.264 0 0 0-.083-.188.478.478 0 0 0-.274-.136c-.713-.105-1.218-.32-1.567-.604-.358-.294-.502-.624-.552-.86a1.22 1.22 0 0 1-.025-.19l-.001-.022-.215-2.793a7.069 7.069 0 0 1-1.566 0ZM19 8.578A3.751 3.751 0 0 0 21.625 5V3.75a.25.25 0 0 0-.25-.25H19ZM5 3.5H2.75a.25.25 0 0 0-.25.25V5A3.752 3.752 0 0 0 5 8.537Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f857f420ac44f7ca = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("TypographyIcon", "octicon octicon-typography", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.71 10H2.332l-.874 2.498a.75.75 0 0 1-1.415-.496l3.39-9.688a1.217 1.217 0 0 1 2.302.018l3.227 9.681a.75.75 0 0 1-1.423.474Zm3.13-4.358C10.53 4.374 11.87 4 13 4c1.5 0 3 .939 3 2.601v5.649a.75.75 0 0 1-1.448.275C13.995 12.82 13.3 13 12.5 13c-.77 0-1.514-.231-2.078-.709-.577-.488-.922-1.199-.922-2.041 0-.694.265-1.411.887-1.944C11 7.78 11.88 7.5 13 7.5h1.5v-.899c0-.54-.5-1.101-1.5-1.101-.869 0-1.528.282-1.84.858a.75.75 0 1 1-1.32-.716ZM6.21 8.5 4.574 3.594 2.857 8.5Zm8.29.5H13c-.881 0-1.375.22-1.637.444-.253.217-.363.5-.363.806 0 .408.155.697.39.896.249.21.63.354 1.11.354.732 0 1.26-.209 1.588-.449.35-.257.412-.495.412-.551Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.414 15H3.586l-1.631 4.505a.75.75 0 1 1-1.41-.51l5.08-14.03a1.463 1.463 0 0 1 2.75 0l5.08 14.03a.75.75 0 1 1-1.411.51Zm4.532-5.098c.913-1.683 2.703-2.205 4.284-2.205 1.047 0 2.084.312 2.878.885.801.577 1.392 1.455 1.392 2.548v8.12a.75.75 0 0 1-1.5 0v-.06l-.044.025c-.893.52-2.096.785-3.451.785-1.051 0-2.048-.315-2.795-.948-.76-.643-1.217-1.578-1.217-2.702 0-.919.349-1.861 1.168-2.563.81-.694 2-1.087 3.569-1.087H22v-1.57c0-.503-.263-.967-.769-1.332-.513-.37-1.235-.6-2.001-.6-1.319 0-2.429.43-2.966 1.42a.75.75 0 0 1-1.318-.716ZM9.87 13.5 7 5.572 4.13 13.5Zm12.13.7h-2.77c-1.331 0-2.134.333-2.593.726a1.822 1.822 0 0 0-.644 1.424c0 .689.267 1.203.686 1.557.43.365 1.065.593 1.826.593 1.183 0 2.102-.235 2.697-.581.582-.34.798-.74.798-1.134Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$941fd5c4dbed963a = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UndoIcon", "octicon octicon-undo", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.22 6.28a.749.749 0 0 1 0-1.06l3.5-3.5a.749.749 0 1 1 1.06 1.06L3.561 5h7.188l.001.007L10.749 5c.058 0 .116.007.171.019A4.501 4.501 0 0 1 10.5 14H8.796a.75.75 0 0 1 0-1.5H10.5a3 3 0 1 0 0-6H3.561L5.78 8.72a.749.749 0 1 1-1.06 1.06l-3.5-3.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.53 2.22a.75.75 0 0 0-1.06 0L2.22 8.47a.75.75 0 0 0 0 1.06l6.25 6.25a.75.75 0 0 0 1.06-1.06L4.56 9.75H16c.797 0 2.008.245 3 .959.952.686 1.75 1.835 1.75 3.791s-.798 3.105-1.75 3.791c-.992.714-2.203.959-3 .959h-3a.75.75 0 0 0 0 1.5h3c1.037 0 2.575-.305 3.876-1.241 1.339-.964 2.374-2.565 2.374-5.009 0-2.444-1.035-4.045-2.374-5.009C18.575 8.555 17.036 8.25 16 8.25H4.56l4.97-4.97a.75.75 0 0 0 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$87a56d71ff3174dc = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnfoldIcon", "octicon octicon-unfold", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m8.177.677 2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25a.75.75 0 0 1-1.5 0V4H5.104a.25.25 0 0 1-.177-.427L7.823.677a.25.25 0 0 1 .354 0ZM7.25 10.75a.75.75 0 0 1 1.5 0V12h2.146a.25.25 0 0 1 .177.427l-2.896 2.896a.25.25 0 0 1-.354 0l-2.896-2.896A.25.25 0 0 1 5.104 12H7.25v-1.25Zm-5-2a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 23a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 21.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 23Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.47 1.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 2.81 9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042ZM12 22.25a.75.75 0 0 1-.75-.75v-5.75a.75.75 0 0 1 1.5 0v5.75a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 12 1.5Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$39927e15d1e906 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnlinkIcon", "octicon octicon-unlink", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12.914 5.914a2 2 0 0 0-2.828-2.828l-.837.837a.75.75 0 1 1-1.06-1.061l.836-.837a3.5 3.5 0 1 1 4.95 4.95l-.195.194a.75.75 0 0 1-1.06-1.06l.194-.195Zm-1.87 3.482a.759.759 0 0 1-.07.079c-.63.63-1.468 1.108-2.343 1.263-.89.159-1.86-.017-2.606-.763a.75.75 0 1 1 1.06-1.06c.329.327.767.438 1.284.347.493-.088 1.018-.36 1.445-.752l-1.247-.897a.709.709 0 0 1-.01-.008l-.295-.212c-.94-.597-1.984-.499-2.676.193l-2.5 2.5a2 2 0 1 0 2.828 2.828l.837-.836a.75.75 0 0 1 1.06 1.06l-.836.837a3.5 3.5 0 0 1-4.95-4.95l2.5-2.5a3.472 3.472 0 0 1 1.354-.848L2.312 3.109a.75.75 0 0 1 .876-1.218l5.93 4.27c.115.074.226.155.335.24l6.235 4.49a.75.75 0 0 1-.876 1.218l-3.768-2.713Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M20.347 3.653a3.936 3.936 0 0 0-5.567 0l-1.75 1.75a.75.75 0 0 1-1.06-1.06l1.75-1.75a5.436 5.436 0 0 1 7.688 7.687l-1.564 1.564a.75.75 0 0 1-1.06-1.06l1.563-1.564a3.936 3.936 0 0 0 0-5.567ZM9.786 12.369a.75.75 0 0 1 1.053.125c.096.122.2.24.314.353 1.348 1.348 3.386 1.587 4.89.658l-3.922-2.858a.745.745 0 0 1-.057-.037c-1.419-1.013-3.454-.787-4.784.543L3.653 14.78a3.936 3.936 0 0 0 5.567 5.567l3-3a.75.75 0 1 1 1.06 1.06l-3 3a5.436 5.436 0 1 1-7.688-7.687l3.628-3.628a5.517 5.517 0 0 1 3.014-1.547l-7.05-5.136a.75.75 0 0 1 .883-1.213l20.25 14.75a.75.75 0 0 1-.884 1.213l-5.109-3.722c-2.155 1.709-5.278 1.425-7.232-.53a5.491 5.491 0 0 1-.431-.485.75.75 0 0 1 .125-1.053Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$caf8e4bd765e502b = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnlockIcon", "octicon octicon-unlock", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.5 4v2h7A1.5 1.5 0 0 1 14 7.5v6a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5v-6A1.5 1.5 0 0 1 3.499 6H4V4a4 4 0 0 1 7.371-2.154.75.75 0 0 1-1.264.808A2.5 2.5 0 0 0 5.5 4Zm-2 3.5v6h9v-6h-9Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.5 7.25V9h11a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9H6V7.25C6 3.845 8.503 1 12 1c2.792 0 4.971 1.825 5.718 4.31a.75.75 0 1 1-1.436.432C15.71 3.84 14.079 2.5 12 2.5c-2.578 0-4.5 2.08-4.5 4.75Zm-3 4.25v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$f2d95e4d836f4853 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnmuteIcon", "octicon octicon-unmute", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.563 2.069A.75.75 0 0 1 8 2.75v10.5a.751.751 0 0 1-1.238.57L3.472 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.723l3.289-2.82a.75.75 0 0 1 .801-.111ZM6.5 4.38 4.238 6.319a.748.748 0 0 1-.488.181h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2c.179 0 .352.064.488.18L6.5 11.62Zm6.096-2.038a.75.75 0 0 1 1.06 0 8 8 0 0 1 0 11.314.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042 6.5 6.5 0 0 0 0-9.193.75.75 0 0 1 0-1.06Zm-1.06 2.121-.001.001a5 5 0 0 1 0 7.07.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734 3.5 3.5 0 0 0 0-4.95.75.75 0 1 1 1.061-1.061Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.553 3.064A.75.75 0 0 1 12 3.75v16.5a.75.75 0 0 1-1.255.555L5.46 16H2.75A1.75 1.75 0 0 1 1 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805a.752.752 0 0 1 .808-.13ZM10.5 5.445l-4.245 3.86a.748.748 0 0 1-.505.195h-3a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h3c.187 0 .367.069.505.195l4.245 3.86Zm8.218-1.223a.75.75 0 0 1 1.06 0c4.296 4.296 4.296 11.26 0 15.556a.75.75 0 0 1-1.06-1.06 9.5 9.5 0 0 0 0-13.436.75.75 0 0 1 0-1.06Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M16.243 7.757a.75.75 0 1 0-1.061 1.061 4.5 4.5 0 0 1 0 6.364.75.75 0 0 0 1.06 1.06 6 6 0 0 0 0-8.485Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$65442da726e1dd57 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnreadIcon", "octicon octicon-unread", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.5 3.5H1.75a.25.25 0 0 0-.25.25v.32L8 7.88l3.02-1.77a.75.75 0 0 1 .758 1.295L8.379 9.397a.75.75 0 0 1-.758 0L1.5 5.809v6.441c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4.5a.75.75 0 0 1 1.5 0v4.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25V4.513a.75.75 0 0 1 0-.027V3.75C0 2.784.784 2 1.75 2h8.75a.75.75 0 0 1 0 1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 4.5a.25.25 0 0 0-.25.25v.852l10.36 7a.25.25 0 0 0 .28 0l5.69-3.845A.75.75 0 0 1 18.67 10l-5.69 3.845c-.592.4-1.368.4-1.96 0L1.5 7.412V19.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25V4.75C0 3.784.784 3 1.75 3h15.5a.75.75 0 0 1 0 1.5H1.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M24 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$f41d6ce12454a717 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnverifiedIcon", "octicon octicon-unverified", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6.415.52a2.677 2.677 0 0 1 3.17 0l.928.68c.153.113.33.186.518.215l1.138.175a2.678 2.678 0 0 1 2.241 2.24l.175 1.138c.029.187.102.365.215.518l.68.928a2.677 2.677 0 0 1 0 3.17l-.68.928a1.186 1.186 0 0 0-.215.518l-.175 1.138a2.678 2.678 0 0 1-2.241 2.241l-1.138.175a1.186 1.186 0 0 0-.518.215l-.928.68a2.677 2.677 0 0 1-3.17 0l-.928-.68a1.186 1.186 0 0 0-.518-.215L3.83 14.41a2.678 2.678 0 0 1-2.24-2.24l-.175-1.138a1.186 1.186 0 0 0-.215-.518l-.68-.928a2.677 2.677 0 0 1 0-3.17l.68-.928a1.17 1.17 0 0 0 .215-.518l.175-1.14a2.678 2.678 0 0 1 2.24-2.24l1.138-.175c.187-.029.365-.102.518-.215l.928-.68Zm2.282 1.209a1.18 1.18 0 0 0-1.394 0l-.928.68a2.67 2.67 0 0 1-1.18.489l-1.136.174a1.18 1.18 0 0 0-.987.987l-.174 1.137a2.67 2.67 0 0 1-.489 1.18l-.68.927c-.305.415-.305.98 0 1.394l.68.928c.256.348.423.752.489 1.18l.174 1.136c.078.51.478.909.987.987l1.137.174c.427.066.831.233 1.18.489l.927.68c.415.305.98.305 1.394 0l.928-.68a2.67 2.67 0 0 1 1.18-.489l1.136-.174c.51-.078.909-.478.987-.987l.174-1.137c.066-.427.233-.831.489-1.18l.68-.927c.305-.415.305-.98 0-1.394l-.68-.928a2.67 2.67 0 0 1-.489-1.18l-.174-1.136a1.18 1.18 0 0 0-.987-.987l-1.137-.174a2.67 2.67 0 0 1-1.18-.489ZM6.92 6.085h.001a.75.75 0 0 1-1.342-.67c.169-.339.436-.701.849-.977C6.846 4.16 7.369 4 8 4a2.76 2.76 0 0 1 1.638.525c.502.377.862.965.862 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.109-.073.22-.139.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M13 16.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2.517-7.665c.112-.223.268-.424.488-.57C11.186 8.12 11.506 8 12 8c.384 0 .766.118 1.034.319a.953.953 0 0 1 .403.806c0 .48-.218.81-.62 1.186a9.293 9.293 0 0 1-.409.354 19.8 19.8 0 0 0-.294.249c-.246.213-.524.474-.738.795l-.126.19V13.5a.75.75 0 0 0 1.5 0v-1.12c.09-.1.203-.208.347-.333.063-.055.14-.119.222-.187.166-.14.358-.3.52-.452.536-.5 1.098-1.2 1.098-2.283a2.45 2.45 0 0 0-1.003-2.006C13.37 6.695 12.658 6.5 12 6.5c-.756 0-1.373.191-1.861.517a2.944 2.944 0 0 0-.997 1.148.75.75 0 0 0 1.341.67Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.864 1.2a3.61 3.61 0 0 1 4.272 0l1.375 1.01c.274.2.593.333.929.384l1.686.259a3.61 3.61 0 0 1 3.021 3.02l.259 1.687c.051.336.183.655.384.929l1.01 1.375a3.61 3.61 0 0 1 0 4.272l-1.01 1.375a2.106 2.106 0 0 0-.384.929l-.259 1.686a3.61 3.61 0 0 1-3.02 3.021l-1.687.259a2.106 2.106 0 0 0-.929.384l-1.375 1.01a3.61 3.61 0 0 1-4.272 0l-1.375-1.01a2.106 2.106 0 0 0-.929-.384l-1.686-.259a3.61 3.61 0 0 1-3.021-3.02l-.259-1.687a2.106 2.106 0 0 0-.384-.929L1.2 14.136a3.61 3.61 0 0 1 0-4.272l1.01-1.375c.201-.274.333-.593.384-.929l.259-1.686a3.61 3.61 0 0 1 3.02-3.021l1.687-.259c.336-.051.655-.183.929-.384Zm3.384 1.209a2.11 2.11 0 0 0-2.496 0l-1.376 1.01a3.61 3.61 0 0 1-1.589.658l-1.686.258a2.111 2.111 0 0 0-1.766 1.766l-.258 1.686a3.614 3.614 0 0 1-.658 1.59l-1.01 1.375a2.11 2.11 0 0 0 0 2.496l1.01 1.376a3.61 3.61 0 0 1 .658 1.589l.258 1.686a2.11 2.11 0 0 0 1.766 1.765l1.686.26a3.613 3.613 0 0 1 1.59.657l1.375 1.01a2.11 2.11 0 0 0 2.496 0l1.376-1.01a3.61 3.61 0 0 1 1.589-.658l1.686-.258a2.11 2.11 0 0 0 1.765-1.766l.26-1.686a3.613 3.613 0 0 1 .657-1.59l1.01-1.375a2.11 2.11 0 0 0 0-2.496l-1.01-1.376a3.61 3.61 0 0 1-.658-1.589l-.258-1.686a2.111 2.111 0 0 0-1.766-1.766l-1.686-.258a3.614 3.614 0 0 1-1.59-.658Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$5182ef75faaaa686 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UnwrapIcon", "octicon octicon-unwrap", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 2.75c0-.199.079-.39.22-.53A.747.747 0 0 1 1.75 2h12.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H1.75a.747.747 0 0 1-.53-.22.747.747 0 0 1-.22-.53Zm0 5c0-.199.079-.39.22-.53A.747.747 0 0 1 1.75 7h12.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H1.75a.747.747 0 0 1-.53-.22.747.747 0 0 1-.22-.53ZM1.75 12h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06.747.747 0 0 1 .53-.22Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 5.25a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06c.14.141.331.22.53.22h16.5c.199 0 .39-.079.53-.22a.747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22H3.75Zm0 6a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06c.14.141.331.22.53.22h16.5c.199 0 .39-.079.53-.22a.747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22H3.75Zm0 6a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06c.14.141.331.22.53.22h5.5c.199 0 .39-.079.53-.22a.747.747 0 0 0 0-1.06.747.747 0 0 0-.53-.22h-5.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8df90684a752ef81 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("UploadIcon", "octicon octicon-upload", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M11.78 4.72a.749.749 0 1 1-1.06 1.06L8.75 3.811V9.5a.75.75 0 0 1-1.5 0V3.811L5.28 5.78a.749.749 0 1 1-1.06-1.06l3.25-3.25a.749.749 0 0 1 1.06 0l3.25 3.25Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4 20.25V18a.75.75 0 0 1 1.5 0v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$bb5f9bdd1b41e5db = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("VerifiedIcon", "octicon octicon-verified", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m9.585.52.929.68c.153.112.331.186.518.215l1.138.175a2.678 2.678 0 0 1 2.24 2.24l.174 1.139c.029.187.103.365.215.518l.68.928a2.677 2.677 0 0 1 0 3.17l-.68.928a1.174 1.174 0 0 0-.215.518l-.175 1.138a2.678 2.678 0 0 1-2.241 2.241l-1.138.175a1.17 1.17 0 0 0-.518.215l-.928.68a2.677 2.677 0 0 1-3.17 0l-.928-.68a1.174 1.174 0 0 0-.518-.215L3.83 14.41a2.678 2.678 0 0 1-2.24-2.24l-.175-1.138a1.17 1.17 0 0 0-.215-.518l-.68-.928a2.677 2.677 0 0 1 0-3.17l.68-.928c.112-.153.186-.331.215-.518l.175-1.14a2.678 2.678 0 0 1 2.24-2.24l1.139-.175c.187-.029.365-.103.518-.215l.928-.68a2.677 2.677 0 0 1 3.17 0ZM7.303 1.728l-.927.68a2.67 2.67 0 0 1-1.18.489l-1.137.174a1.179 1.179 0 0 0-.987.987l-.174 1.136a2.677 2.677 0 0 1-.489 1.18l-.68.928a1.18 1.18 0 0 0 0 1.394l.68.927c.256.348.424.753.489 1.18l.174 1.137c.078.509.478.909.987.987l1.136.174a2.67 2.67 0 0 1 1.18.489l.928.68c.414.305.979.305 1.394 0l.927-.68a2.67 2.67 0 0 1 1.18-.489l1.137-.174a1.18 1.18 0 0 0 .987-.987l.174-1.136a2.67 2.67 0 0 1 .489-1.18l.68-.928a1.176 1.176 0 0 0 0-1.394l-.68-.927a2.686 2.686 0 0 1-.489-1.18l-.174-1.137a1.179 1.179 0 0 0-.987-.987l-1.136-.174a2.677 2.677 0 0 1-1.18-.489l-.928-.68a1.176 1.176 0 0 0-1.394 0ZM11.28 6.78l-3.75 3.75a.75.75 0 0 1-1.06 0L4.72 8.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L7 8.94l3.22-3.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17.03 9.78a.75.75 0 0 0-1.06-1.06l-5.47 5.47-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6-6Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "m14.136 1.2 1.375 1.01c.274.201.593.333.929.384l1.687.259a3.61 3.61 0 0 1 3.02 3.021l.259 1.686c.051.336.183.655.384.929l1.01 1.375a3.61 3.61 0 0 1 0 4.272l-1.01 1.375a2.106 2.106 0 0 0-.384.929l-.259 1.687a3.61 3.61 0 0 1-3.021 3.02l-1.686.259a2.106 2.106 0 0 0-.929.384l-1.375 1.01a3.61 3.61 0 0 1-4.272 0l-1.375-1.01a2.106 2.106 0 0 0-.929-.384l-1.687-.259a3.61 3.61 0 0 1-3.02-3.021l-.259-1.686a2.117 2.117 0 0 0-.384-.929L1.2 14.136a3.61 3.61 0 0 1 0-4.272l1.01-1.375c.201-.274.333-.593.384-.929l.259-1.687a3.61 3.61 0 0 1 3.021-3.02l1.686-.259c.336-.051.655-.183.929-.384L9.864 1.2a3.61 3.61 0 0 1 4.272 0Zm-3.384 1.209-1.375 1.01a3.614 3.614 0 0 1-1.59.658l-1.686.258a2.111 2.111 0 0 0-1.766 1.766l-.258 1.686a3.61 3.61 0 0 1-.658 1.589l-1.01 1.376a2.11 2.11 0 0 0 0 2.496l1.01 1.375c.344.469.57 1.015.658 1.59l.258 1.686c.14.911.855 1.626 1.766 1.766l1.686.258a3.61 3.61 0 0 1 1.589.658l1.376 1.01a2.11 2.11 0 0 0 2.496 0l1.375-1.01a3.613 3.613 0 0 1 1.59-.657l1.686-.26a2.11 2.11 0 0 0 1.766-1.765l.258-1.686a3.61 3.61 0 0 1 .658-1.589l1.01-1.376a2.11 2.11 0 0 0 0-2.496l-1.01-1.375a3.613 3.613 0 0 1-.657-1.59l-.26-1.686a2.11 2.11 0 0 0-1.765-1.766l-1.686-.258a3.61 3.61 0 0 1-1.589-.658l-1.376-1.01a2.11 2.11 0 0 0-2.496 0Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$40e4d1cbca290dd9 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("VersionsIcon", "octicon octicon-versions", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.75 14A1.75 1.75 0 0 1 6 12.25v-8.5C6 2.784 6.784 2 7.75 2h6.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14Zm-.25-1.75c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25ZM4.9 3.508a.75.75 0 0 1-.274 1.025.249.249 0 0 0-.126.217v6.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.75 1.75 0 0 1 3 11.25v-6.5c0-.649.353-1.214.874-1.516a.75.75 0 0 1 1.025.274ZM1.625 5.533h.001a.249.249 0 0 0-.126.217v4.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 0 10.25v-4.5a1.748 1.748 0 0 1 .873-1.516.75.75 0 1 1 .752 1.299Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2Zm-.5-2a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5ZM6.17 4.165a.75.75 0 0 1-.335 1.006c-.228.114-.295.177-.315.201a.035.035 0 0 0-.008.016.423.423 0 0 0-.012.112v13c0 .07.008.102.012.112a.03.03 0 0 0 .008.016c.02.024.087.087.315.201a.749.749 0 1 1-.67 1.342c-.272-.136-.58-.315-.81-.598C4.1 19.259 4 18.893 4 18.5v-13c0-.393.1-.759.355-1.073.23-.283.538-.462.81-.598a.75.75 0 0 1 1.006.336ZM2.15 5.624a.75.75 0 0 1-.274 1.025c-.15.087-.257.17-.32.245C1.5 6.96 1.5 6.99 1.5 7v10c0 .01 0 .04.056.106.063.074.17.158.32.245a.75.75 0 0 1-.752 1.298C.73 18.421 0 17.907 0 17V7c0-.907.73-1.42 1.124-1.65a.75.75 0 0 1 1.025.274Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$4ec8735ec23c8112 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("VideoIcon", "octicon octicon-video", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M6 10.559V5.442a.25.25 0 0 1 .379-.215l4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842L9.77 16.005a.5.5 0 0 1-.77-.42Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$3bd3093d45bd8057 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("VscodeIcon", "octicon octicon-vscode", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.863 13.919a.796.796 0 0 1-.644.025.795.795 0 0 1-.279-.183L4.816 9.063l-2.232 1.703a.54.54 0 0 1-.691-.031l-.716-.655a.546.546 0 0 1 0-.805L3.112 7.5 1.177 5.725a.546.546 0 0 1 0-.805l.716-.655a.54.54 0 0 1 .691-.031l2.232 1.703L9.94 1.239a.805.805 0 0 1 .923-.159l2.677 1.295c.281.136.46.422.46.736V8h-3.248V4.534L6.864 7.5l3.888 2.966V8H14v3.889c0 .314-.179.6-.46.736l-2.677 1.294Z"
            })
        },
        "32": {
            "width": 32,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M21.727 27.839a1.612 1.612 0 0 1-1.847-.316L9.632 18.125l-4.463 3.406a1.078 1.078 0 0 1-1.383-.062L2.354 20.16a1.093 1.093 0 0 1-.001-1.61L6.224 15l-3.871-3.55a1.093 1.093 0 0 1 .001-1.61l1.432-1.309a1.078 1.078 0 0 1 1.383-.062l4.463 3.406L19.88 2.477a1.612 1.612 0 0 1 1.847-.316L27.08 4.75c.562.272.92.844.92 1.472V16h-6.496V9.067L13.728 15l7.776 5.933V16H28v7.778c0 .628-.358 1.2-.92 1.472l-5.353 2.589Z"
            })
        },
        "48": {
            "width": 48,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M32.59 41.758a2.41 2.41 0 0 1-2.77-.474L14.448 27.188l-6.695 5.109a1.618 1.618 0 0 1-2.074-.093l-2.147-1.963a1.64 1.64 0 0 1-.002-2.416L9.336 22.5 3.53 17.175a1.64 1.64 0 0 1 .002-2.416l2.147-1.963a1.618 1.618 0 0 1 2.074-.093l6.695 5.109L29.82 3.716a2.419 2.419 0 0 1 2.77-.475l8.03 3.884A2.451 2.451 0 0 1 42 9.333V24h-9.744V13.601L20.593 22.5l11.663 8.899V24H42v11.667c0 .941-.537 1.8-1.38 2.208l-8.03 3.883Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$3c46f390a1e1dd55 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("WebhookIcon", "octicon octicon-webhook", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.5 4.25a2.25 2.25 0 0 1 4.5 0 .75.75 0 0 0 1.5 0 3.75 3.75 0 1 0-6.14 2.889l-2.272 4.258a.75.75 0 0 0 1.324.706L7 7.25a.75.75 0 0 0-.309-1.015A2.25 2.25 0 0 1 5.5 4.25Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.364 3.607a.75.75 0 0 1 1.03.257l2.608 4.349a3.75 3.75 0 1 1-.628 6.785.75.75 0 0 1 .752-1.299 2.25 2.25 0 1 0-.033-3.88.75.75 0 0 1-1.03-.256L7.107 4.636a.75.75 0 0 1 .257-1.03Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.9 8.776A.75.75 0 0 1 2.625 9.8 2.25 2.25 0 1 0 6 11.75a.75.75 0 0 1 .75-.751h5.5a.75.75 0 0 1 0 1.5H7.425a3.751 3.751 0 1 1-5.55-3.998.75.75 0 0 1 1.024.274Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$e168ed240d9b8ab4 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("WorkflowIcon", "octicon octicon-workflow", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 1.75C0 .784.784 0 1.75 0h3.5C6.216 0 7 .784 7 1.75v3.5A1.75 1.75 0 0 1 5.25 7H4v4a1 1 0 0 0 1 1h4v-1.25C9 9.784 9.784 9 10.75 9h3.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-.75H5A2.5 2.5 0 0 1 2.5 11V7h-.75A1.75 1.75 0 0 1 0 5.25Zm1.75-.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Zm9 9a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 3a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H7v4.063C7 16.355 7.644 17 8.438 17H12.5v-2.5a2 2 0 0 1 2-2H21a2 2 0 0 1 2 2V21a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-2.5H8.437A2.939 2.939 0 0 1 5.5 15.562V11.5H3a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5ZM14.5 14a.5.5 0 0 0-.5.5V21a.5.5 0 0 0 .5.5H21a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$93a804c703d50d67 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("WrapIcon", "octicon octicon-wrap", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.75 7a.747.747 0 0 0-.53.22.747.747 0 0 0 0 1.06c.14.141.331.22.53.22h10c.464 0 .909.184 1.237.513a1.746 1.746 0 0 1 0 2.474A1.746 1.746 0 0 1 11.75 12h-1.464v-.464a.675.675 0 0 0-.375-.607.687.687 0 0 0-.711.064l-1.619 1.214a.679.679 0 0 0 0 1.086L9.2 14.507a.683.683 0 0 0 .711.064.685.685 0 0 0 .375-.607V13.5h1.464A3.247 3.247 0 0 0 15 10.25 3.247 3.247 0 0 0 11.75 7h-10ZM1 2.75c0-.199.079-.39.22-.53A.747.747 0 0 1 1.75 2h12.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H1.75a.747.747 0 0 1-.53-.22.747.747 0 0 1-.22-.53ZM1.75 12h3.5c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-3.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06.747.747 0 0 1 .53-.22Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M17 11.25c1.114 0 2.173.277 2.969.914.818.655 1.281 1.629 1.281 2.836 0 1.207-.463 2.181-1.281 2.836-.796.637-1.855.914-2.969.914h-.5v.982a.5.5 0 0 1-.75.433l-3-1.732a.5.5 0 0 1 0-.866l3-1.732a.5.5 0 0 1 .75.433v.982h.5c.886 0 1.577-.223 2.031-.586.432-.345.719-.871.719-1.664 0-.793-.287-1.319-.719-1.664-.454-.363-1.145-.586-2.031-.586H3.82a.75.75 0 0 1 0-1.5H17Zm-7.75 6c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22h-5.5a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06.747.747 0 0 1 .53-.22h5.5Zm11-12c.199 0 .39.079.53.22a.747.747 0 0 1 0 1.06.747.747 0 0 1-.53.22H3.75a.747.747 0 0 1-.53-.22.747.747 0 0 1 0-1.06.747.747 0 0 1 .53-.22h16.5Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$5e658a8851ae9322 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("XIcon", "octicon octicon-x", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.22 2.22a.749.749 0 0 1 1.06 0L6 4.939 8.72 2.22a.749.749 0 1 1 1.06 1.06L7.061 6 9.78 8.72a.749.749 0 1 1-1.06 1.06L6 7.061 3.28 9.78a.749.749 0 1 1-1.06-1.06L4.939 6 2.22 3.28a.749.749 0 0 1 0-1.06Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$a5090bbd7fc88fde = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("XCircleIcon", "octicon octicon-x-circle", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.344 2.343h-.001a8 8 0 0 1 11.314 11.314A8.002 8.002 0 0 1 .234 10.089a8 8 0 0 1 2.11-7.746Zm1.06 10.253a6.5 6.5 0 1 0 9.108-9.275 6.5 6.5 0 0 0-9.108 9.275ZM6.03 4.97 8 6.94l1.97-1.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l1.97 1.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-1.97 1.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L6.94 8 4.97 6.03a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.036 7.976a.75.75 0 0 0-1.06 1.06L10.939 12l-2.963 2.963a.75.75 0 1 0 1.06 1.06L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.75.75 0 1 0-1.06-1.06L12 10.939 9.036 7.976Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$70fa3c998d3a2ac8 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("XCircleFillIcon", "octicon octicon-x-circle-fill", function() {
    return {
        "12": {
            "width": 12,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1.757 10.243a6.001 6.001 0 1 1 8.488-8.486 6.001 6.001 0 0 1-8.488 8.486ZM6 4.763l-2-2L2.763 4l2 2-2 2L4 9.237l2-2 2 2L9.237 8l-2-2 2-2L8 2.763Z"
            })
        },
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M2.343 13.657A8 8 0 1 1 13.658 2.343 8 8 0 0 1 2.343 13.657ZM6.03 4.97a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L6.94 8 4.97 9.97a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L8 9.06l1.97 1.97a.749.749 0 0 0 1.275-.326.749.749 0 0 0-.215-.734L9.06 8l1.97-1.97a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L8 6.94Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm8.036-4.024a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L10.939 12l-2.963 2.963a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L12 10.939Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$8cd5177e02a3dea2 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ZapIcon", "octicon octicon-zap", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M9.504.43a1.516 1.516 0 0 1 2.437 1.713L10.415 5.5h2.123c1.57 0 2.346 1.909 1.22 3.004l-7.34 7.142a1.249 1.249 0 0 1-.871.354h-.302a1.25 1.25 0 0 1-1.157-1.723L5.633 10.5H3.462c-1.57 0-2.346-1.909-1.22-3.004L9.503.429Zm1.047 1.074L3.286 8.571A.25.25 0 0 0 3.462 9H6.75a.75.75 0 0 1 .694 1.034l-1.713 4.188 6.982-6.793A.25.25 0 0 0 12.538 7H9.25a.75.75 0 0 1-.683-1.06l2.008-4.418.003-.006a.036.036 0 0 0-.004-.009l-.006-.006-.008-.001c-.003 0-.006.002-.009.004Z"
            })
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M15.716 1.329a1.341 1.341 0 0 1 2.109 1.55L15.147 9h4.161c1.623 0 2.372 2.016 1.143 3.075L8.102 22.721a1.148 1.148 0 0 1-1.81-1.317L8.996 15H4.674c-1.619 0-2.37-2.008-1.148-3.07l12.19-10.6Zm.452 1.595L4.51 13.061a.25.25 0 0 0 .164.439h5.45a.749.749 0 0 1 .692 1.041l-2.559 6.066 11.215-9.668a.25.25 0 0 0-.164-.439H14a.75.75 0 0 1-.687-1.05Z"
            })
        }
    };
});
var $9c65e6561322b2ec$export$418cedbcfc990387 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ZoomInIcon", "octicon octicon-zoom-in", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M3.75 7.5a.75.75 0 0 1 .75-.75h2.25V4.5a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 0 1 0 1.5H8.25v2.25a.75.75 0 0 1-1.5 0V8.25H4.5a.75.75 0 0 1-.75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M7.5 0a7.5 7.5 0 0 1 5.807 12.247l2.473 2.473a.749.749 0 1 1-1.06 1.06l-2.473-2.473A7.5 7.5 0 1 1 7.5 0Zm-6 7.5a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M10.5 5.75a.75.75 0 0 1 .75.75v3.25h3.25a.75.75 0 0 1 0 1.5h-3.25v3.25a.75.75 0 0 1-1.5 0v-3.25H6.5a.75.75 0 0 1 0-1.5h3.25V6.5a.75.75 0 0 1 .75-.75Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 1 1-1.06 1.06l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
            }))
        }
    };
});
var $9c65e6561322b2ec$export$fbd55a4c69e8e024 = /*#__PURE__*/ $9c65e6561322b2ec$var$createIconComponent("ZoomOutIcon", "octicon octicon-zoom-out", function() {
    return {
        "16": {
            "width": 16,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M4.5 6.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 7.5a7.5 7.5 0 1 1 13.307 4.747l2.473 2.473a.749.749 0 1 1-1.06 1.06l-2.473-2.473A7.5 7.5 0 0 1 0 7.5Zm7.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
            }))
        },
        "24": {
            "width": 24,
            "path": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M14.5 11.25a.75.75 0 0 0 0-1.5h-8a.75.75 0 0 0 0 1.5h8Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: "M0 10.5C0 4.701 4.701 0 10.5 0S21 4.701 21 10.5c0 2.63-.967 5.033-2.564 6.875l4.344 4.345a.749.749 0 1 1-1.06 1.06l-4.345-4.344A10.459 10.459 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5Zm10.5-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
            }))
        }
    };
});



// pkg/dist-src/index.js
// pkg/dist-src/index.js
// pkg/dist-src/defaults.js
function $a87c5f5ec76959fb$export$7935961ef7719cb0() {
    if (typeof navigator === "object" && "userAgent" in navigator) return navigator.userAgent;
    return "<environment undetectable>";
}


// pkg/dist-src/version.js
var $53a307ba91c136eb$var$VERSION = "0.0.0-development";
// pkg/dist-src/defaults.js
var $53a307ba91c136eb$var$userAgent = `octokit-endpoint.js/${$53a307ba91c136eb$var$VERSION} ${(0, $a87c5f5ec76959fb$export$7935961ef7719cb0)()}`;
var $53a307ba91c136eb$var$DEFAULTS = {
    method: "GET",
    baseUrl: "https://api.github.com",
    headers: {
        accept: "application/vnd.github.v3+json",
        "user-agent": $53a307ba91c136eb$var$userAgent
    },
    mediaType: {
        format: ""
    }
};
// pkg/dist-src/util/lowercase-keys.js
function $53a307ba91c136eb$var$lowercaseKeys(object) {
    if (!object) return {};
    return Object.keys(object).reduce((newObj, key)=>{
        newObj[key.toLowerCase()] = object[key];
        return newObj;
    }, {});
}
// pkg/dist-src/util/is-plain-object.js
function $53a307ba91c136eb$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null) return false;
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.prototype.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor === "function" && Ctor instanceof Ctor && Function.prototype.call(Ctor) === Function.prototype.call(value);
}
// pkg/dist-src/util/merge-deep.js
function $53a307ba91c136eb$var$mergeDeep(defaults, options) {
    const result = Object.assign({}, defaults);
    Object.keys(options).forEach((key)=>{
        if ($53a307ba91c136eb$var$isPlainObject(options[key])) {
            if (!(key in defaults)) Object.assign(result, {
                [key]: options[key]
            });
            else result[key] = $53a307ba91c136eb$var$mergeDeep(defaults[key], options[key]);
        } else Object.assign(result, {
            [key]: options[key]
        });
    });
    return result;
}
// pkg/dist-src/util/remove-undefined-properties.js
function $53a307ba91c136eb$var$removeUndefinedProperties(obj) {
    for(const key in obj)if (obj[key] === void 0) delete obj[key];
    return obj;
}
// pkg/dist-src/merge.js
function $53a307ba91c136eb$var$merge(defaults, route, options) {
    if (typeof route === "string") {
        let [method, url] = route.split(" ");
        options = Object.assign(url ? {
            method: method,
            url: url
        } : {
            url: method
        }, options);
    } else options = Object.assign({}, route);
    options.headers = $53a307ba91c136eb$var$lowercaseKeys(options.headers);
    $53a307ba91c136eb$var$removeUndefinedProperties(options);
    $53a307ba91c136eb$var$removeUndefinedProperties(options.headers);
    const mergedOptions = $53a307ba91c136eb$var$mergeDeep(defaults || {}, options);
    if (options.url === "/graphql") {
        if (defaults && defaults.mediaType.previews?.length) mergedOptions.mediaType.previews = defaults.mediaType.previews.filter((preview)=>!mergedOptions.mediaType.previews.includes(preview)).concat(mergedOptions.mediaType.previews);
        mergedOptions.mediaType.previews = (mergedOptions.mediaType.previews || []).map((preview)=>preview.replace(/-preview/, ""));
    }
    return mergedOptions;
}
// pkg/dist-src/util/add-query-parameters.js
function $53a307ba91c136eb$var$addQueryParameters(url, parameters) {
    const separator = /\?/.test(url) ? "&" : "?";
    const names = Object.keys(parameters);
    if (names.length === 0) return url;
    return url + separator + names.map((name)=>{
        if (name === "q") return "q=" + parameters.q.split("+").map(encodeURIComponent).join("+");
        return `${name}=${encodeURIComponent(parameters[name])}`;
    }).join("&");
}
// pkg/dist-src/util/extract-url-variable-names.js
var $53a307ba91c136eb$var$urlVariableRegex = /\{[^{}}]+\}/g;
function $53a307ba91c136eb$var$removeNonChars(variableName) {
    return variableName.replace(/(?:^\W+)|(?:(?<!\W)\W+$)/g, "").split(/,/);
}
function $53a307ba91c136eb$var$extractUrlVariableNames(url) {
    const matches = url.match($53a307ba91c136eb$var$urlVariableRegex);
    if (!matches) return [];
    return matches.map($53a307ba91c136eb$var$removeNonChars).reduce((a, b)=>a.concat(b), []);
}
// pkg/dist-src/util/omit.js
function $53a307ba91c136eb$var$omit(object, keysToOmit) {
    const result = {
        __proto__: null
    };
    for (const key of Object.keys(object))if (keysToOmit.indexOf(key) === -1) result[key] = object[key];
    return result;
}
// pkg/dist-src/util/url-template.js
function $53a307ba91c136eb$var$encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
        if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, "[").replace(/%5D/g, "]");
        return part;
    }).join("");
}
function $53a307ba91c136eb$var$encodeUnreserved(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
function $53a307ba91c136eb$var$encodeValue(operator, value, key) {
    value = operator === "+" || operator === "#" ? $53a307ba91c136eb$var$encodeReserved(value) : $53a307ba91c136eb$var$encodeUnreserved(value);
    if (key) return $53a307ba91c136eb$var$encodeUnreserved(key) + "=" + value;
    else return value;
}
function $53a307ba91c136eb$var$isDefined(value) {
    return value !== void 0 && value !== null;
}
function $53a307ba91c136eb$var$isKeyOperator(operator) {
    return operator === ";" || operator === "&" || operator === "?";
}
function $53a307ba91c136eb$var$getValues(context, operator, key, modifier) {
    var value = context[key], result = [];
    if ($53a307ba91c136eb$var$isDefined(value) && value !== "") {
        if (typeof value === "string" || typeof value === "number" || typeof value === "bigint" || typeof value === "boolean") {
            value = value.toString();
            if (modifier && modifier !== "*") value = value.substring(0, parseInt(modifier, 10));
            result.push($53a307ba91c136eb$var$encodeValue(operator, value, $53a307ba91c136eb$var$isKeyOperator(operator) ? key : ""));
        } else if (modifier === "*") {
            if (Array.isArray(value)) value.filter($53a307ba91c136eb$var$isDefined).forEach(function(value2) {
                result.push($53a307ba91c136eb$var$encodeValue(operator, value2, $53a307ba91c136eb$var$isKeyOperator(operator) ? key : ""));
            });
            else Object.keys(value).forEach(function(k) {
                if ($53a307ba91c136eb$var$isDefined(value[k])) result.push($53a307ba91c136eb$var$encodeValue(operator, value[k], k));
            });
        } else {
            const tmp = [];
            if (Array.isArray(value)) value.filter($53a307ba91c136eb$var$isDefined).forEach(function(value2) {
                tmp.push($53a307ba91c136eb$var$encodeValue(operator, value2));
            });
            else Object.keys(value).forEach(function(k) {
                if ($53a307ba91c136eb$var$isDefined(value[k])) {
                    tmp.push($53a307ba91c136eb$var$encodeUnreserved(k));
                    tmp.push($53a307ba91c136eb$var$encodeValue(operator, value[k].toString()));
                }
            });
            if ($53a307ba91c136eb$var$isKeyOperator(operator)) result.push($53a307ba91c136eb$var$encodeUnreserved(key) + "=" + tmp.join(","));
            else if (tmp.length !== 0) result.push(tmp.join(","));
        }
    } else {
        if (operator === ";") {
            if ($53a307ba91c136eb$var$isDefined(value)) result.push($53a307ba91c136eb$var$encodeUnreserved(key));
        } else if (value === "" && (operator === "&" || operator === "?")) result.push($53a307ba91c136eb$var$encodeUnreserved(key) + "=");
        else if (value === "") result.push("");
    }
    return result;
}
function $53a307ba91c136eb$var$parseUrl(template) {
    return {
        expand: $53a307ba91c136eb$var$expand.bind(null, template)
    };
}
function $53a307ba91c136eb$var$expand(template, context) {
    var operators = [
        "+",
        "#",
        ".",
        "/",
        ";",
        "?",
        "&"
    ];
    template = template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
        if (expression) {
            let operator = "";
            const values = [];
            if (operators.indexOf(expression.charAt(0)) !== -1) {
                operator = expression.charAt(0);
                expression = expression.substr(1);
            }
            expression.split(/,/g).forEach(function(variable) {
                var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                values.push($53a307ba91c136eb$var$getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
            });
            if (operator && operator !== "+") {
                var separator = ",";
                if (operator === "?") separator = "&";
                else if (operator !== "#") separator = operator;
                return (values.length !== 0 ? operator : "") + values.join(separator);
            } else return values.join(",");
        } else return $53a307ba91c136eb$var$encodeReserved(literal);
    });
    if (template === "/") return template;
    else return template.replace(/\/$/, "");
}
// pkg/dist-src/parse.js
function $53a307ba91c136eb$var$parse(options) {
    let method = options.method.toUpperCase();
    let url = (options.url || "/").replace(/:([a-z]\w+)/g, "{$1}");
    let headers = Object.assign({}, options.headers);
    let body;
    let parameters = $53a307ba91c136eb$var$omit(options, [
        "method",
        "baseUrl",
        "url",
        "headers",
        "request",
        "mediaType"
    ]);
    const urlVariableNames = $53a307ba91c136eb$var$extractUrlVariableNames(url);
    url = $53a307ba91c136eb$var$parseUrl(url).expand(parameters);
    if (!/^http/.test(url)) url = options.baseUrl + url;
    const omittedParameters = Object.keys(options).filter((option)=>urlVariableNames.includes(option)).concat("baseUrl");
    const remainingParameters = $53a307ba91c136eb$var$omit(parameters, omittedParameters);
    const isBinaryRequest = /application\/octet-stream/i.test(headers.accept);
    if (!isBinaryRequest) {
        if (options.mediaType.format) headers.accept = headers.accept.split(/,/).map((format)=>format.replace(/application\/vnd(\.\w+)(\.v3)?(\.\w+)?(\+json)?$/, `application/vnd$1$2.${options.mediaType.format}`)).join(",");
        if (url.endsWith("/graphql")) {
            if (options.mediaType.previews?.length) {
                const previewsFromAcceptHeader = headers.accept.match(/(?<![\w-])[\w-]+(?=-preview)/g) || [];
                headers.accept = previewsFromAcceptHeader.concat(options.mediaType.previews).map((preview)=>{
                    const format = options.mediaType.format ? `.${options.mediaType.format}` : "+json";
                    return `application/vnd.github.${preview}-preview${format}`;
                }).join(",");
            }
        }
    }
    if ([
        "GET",
        "HEAD"
    ].includes(method)) url = $53a307ba91c136eb$var$addQueryParameters(url, remainingParameters);
    else {
        if ("data" in remainingParameters) body = remainingParameters.data;
        else if (Object.keys(remainingParameters).length) body = remainingParameters;
    }
    if (!headers["content-type"] && typeof body !== "undefined") headers["content-type"] = "application/json; charset=utf-8";
    if ([
        "PATCH",
        "PUT"
    ].includes(method) && typeof body === "undefined") body = "";
    return Object.assign({
        method: method,
        url: url,
        headers: headers
    }, typeof body !== "undefined" ? {
        body: body
    } : null, options.request ? {
        request: options.request
    } : null);
}
// pkg/dist-src/endpoint-with-defaults.js
function $53a307ba91c136eb$var$endpointWithDefaults(defaults, route, options) {
    return $53a307ba91c136eb$var$parse($53a307ba91c136eb$var$merge(defaults, route, options));
}
// pkg/dist-src/with-defaults.js
function $53a307ba91c136eb$var$withDefaults(oldDefaults, newDefaults) {
    const DEFAULTS2 = $53a307ba91c136eb$var$merge(oldDefaults, newDefaults);
    const endpoint2 = $53a307ba91c136eb$var$endpointWithDefaults.bind(null, DEFAULTS2);
    return Object.assign(endpoint2, {
        DEFAULTS: DEFAULTS2,
        defaults: $53a307ba91c136eb$var$withDefaults.bind(null, DEFAULTS2),
        merge: $53a307ba91c136eb$var$merge.bind(null, DEFAULTS2),
        parse: $53a307ba91c136eb$var$parse
    });
}
// pkg/dist-src/index.js
var $53a307ba91c136eb$export$125e2b775860041f = $53a307ba91c136eb$var$withDefaults(null, $53a307ba91c136eb$var$DEFAULTS);



var $ad7d2c921615b517$exports = {};
"use strict";
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ Object.defineProperty($ad7d2c921615b517$exports, "__esModule", {
    value: true
});
$ad7d2c921615b517$exports.format = $ad7d2c921615b517$var$format;
$ad7d2c921615b517$exports.parse = $ad7d2c921615b517$var$parse;
const $ad7d2c921615b517$var$TEXT_REGEXP = /^[\u0009\u0020-\u007e\u0080-\u00ff]*$/;
const $ad7d2c921615b517$var$TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
/**
 * RegExp to match chars that must be quoted-pair in RFC 9110 sec 5.6.4
 */ const $ad7d2c921615b517$var$QUOTE_REGEXP = /[\\"]/g;
/**
 * RegExp to match type in RFC 9110 sec 8.3.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */ const $ad7d2c921615b517$var$TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
/**
 * Null object perf optimization. Faster than `Object.create(null)` and `{ __proto__: null }`.
 */ const $ad7d2c921615b517$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Format an object into a `Content-Type` header.
 */ function $ad7d2c921615b517$var$format(obj) {
    const { type: type, parameters: parameters } = obj;
    if (!type || !$ad7d2c921615b517$var$TYPE_REGEXP.test(type)) throw new TypeError(`Invalid type: ${type}`);
    let result = type;
    if (parameters) for (const param of Object.keys(parameters)){
        if (!$ad7d2c921615b517$var$TOKEN_REGEXP.test(param)) throw new TypeError(`Invalid parameter name: ${param}`);
        result += `; ${param}=${$ad7d2c921615b517$var$qstring(parameters[param])}`;
    }
    return result;
}
/**
 * Parse a `Content-Type` header.
 */ function $ad7d2c921615b517$var$parse(header, options) {
    const len = header.length;
    let index = $ad7d2c921615b517$var$skipOWS(header, 0, len);
    const valueStart = index;
    index = $ad7d2c921615b517$var$skipValue(header, index, len);
    const valueEnd = $ad7d2c921615b517$var$trailingOWS(header, valueStart, index);
    const type = header.slice(valueStart, valueEnd).toLowerCase();
    const parameters = options?.parameters === false ? new $ad7d2c921615b517$var$NullObject() : $ad7d2c921615b517$var$parseParameters(header, index, len);
    return {
        type: type,
        parameters: parameters
    };
}
const $ad7d2c921615b517$var$SP = 32; // " "
const $ad7d2c921615b517$var$HTAB = 9; // "\t"
const $ad7d2c921615b517$var$SEMI = 59; // ";"
const $ad7d2c921615b517$var$EQ = 61; // "="
const $ad7d2c921615b517$var$DQUOTE = 34; // '"'
const $ad7d2c921615b517$var$BSLASH = 92; // "\\"
/**
 * Parses the parameters of a `Content-Type` header starting at the given index.
 */ function $ad7d2c921615b517$var$parseParameters(header, index, len) {
    const parameters = new $ad7d2c921615b517$var$NullObject();
    parameter: while(index < len){
        index = $ad7d2c921615b517$var$skipOWS(header, index + 1 /* Skip over ; */ , len);
        const keyStart = index;
        while(index < len){
            const code = header.charCodeAt(index);
            if (code === $ad7d2c921615b517$var$SEMI) continue parameter;
            if (code === $ad7d2c921615b517$var$EQ) {
                const keyEnd = $ad7d2c921615b517$var$trailingOWS(header, keyStart, index);
                const key = header.slice(keyStart, keyEnd).toLowerCase();
                index = $ad7d2c921615b517$var$skipOWS(header, index + 1, len);
                if (index < len && header.charCodeAt(index) === $ad7d2c921615b517$var$DQUOTE) {
                    index++;
                    let value = "";
                    while(index < len){
                        const code = header.charCodeAt(index++);
                        if (code === $ad7d2c921615b517$var$DQUOTE) {
                            index = $ad7d2c921615b517$var$skipValue(header, index, len);
                            if (parameters[key] === undefined) parameters[key] = value;
                            break;
                        }
                        if (code === $ad7d2c921615b517$var$BSLASH && index < len) {
                            value += header[index++];
                            continue;
                        }
                        value += String.fromCharCode(code);
                    }
                    continue parameter;
                }
                const valueStart = index;
                index = $ad7d2c921615b517$var$skipValue(header, index, len);
                if (parameters[key] === undefined) {
                    const valueEnd = $ad7d2c921615b517$var$trailingOWS(header, valueStart, index);
                    parameters[key] = header.slice(valueStart, valueEnd);
                }
                continue parameter;
            }
            index++;
        }
    }
    return parameters;
}
/**
 * Skip over characters until a semicolon.
 */ function $ad7d2c921615b517$var$skipValue(str, index, len) {
    while(index < len){
        const char = str.charCodeAt(index);
        if (char === $ad7d2c921615b517$var$SEMI) break;
        index++;
    }
    return index;
}
/**
 * Skip optional whitespace (OWS) in an HTTP header value.
 *
 * OWS is defined in RFC 9110 sec 5.6.3 as SP (" ") or HTAB ("\t").
 */ function $ad7d2c921615b517$var$skipOWS(header, index, len) {
    while(index < len){
        const char = header.charCodeAt(index);
        if (char !== $ad7d2c921615b517$var$SP && char !== $ad7d2c921615b517$var$HTAB) break;
        index++;
    }
    return index;
}
/**
 * Trim optional whitespace (OWS) from the end of a substring.
 *
 * OWS is defined in RFC 9110 sec 5.6.3 as SP (" ") or HTAB ("\t").
 */ function $ad7d2c921615b517$var$trailingOWS(header, start, end) {
    while(end > start){
        const char = header.charCodeAt(end - 1);
        if (char !== $ad7d2c921615b517$var$SP && char !== $ad7d2c921615b517$var$HTAB) break;
        end--;
    }
    return end;
}
/**
 * Serialize a parameter value.
 */ function $ad7d2c921615b517$var$qstring(str) {
    if ($ad7d2c921615b517$var$TOKEN_REGEXP.test(str)) return str;
    if ($ad7d2c921615b517$var$TEXT_REGEXP.test(str)) return `"${str.replace($ad7d2c921615b517$var$QUOTE_REGEXP, "\\$&")}"`;
    throw new TypeError(`Invalid parameter value: ${str}`);
}


const $cefdd33e221e0f5b$var$intRegex = /^-?\d+$/;
const $cefdd33e221e0f5b$var$noiseValue = /^-?\d+n+$/; // Noise - strings that match the custom format before being converted to it
const $cefdd33e221e0f5b$var$originalStringify = JSON.stringify;
const $cefdd33e221e0f5b$var$originalParse = JSON.parse;
const $cefdd33e221e0f5b$var$customFormat = /^-?\d+n$/;
const $cefdd33e221e0f5b$var$bigIntsStringify = /([\[:])?"(-?\d+)n"($|([\\n]|\s)*(\s|[\\n])*[,\}\]])/g;
const $cefdd33e221e0f5b$var$noiseStringify = /([\[:])?("-?\d+n+)n("$|"([\\n]|\s)*(\s|[\\n])*[,\}\]])/g;
/**
 * @typedef {(this: any, key: string | number | undefined, value: any) => any} Replacer
 * @typedef {(key: string | number | undefined, value: any, context?: { source: string }) => any} Reviver
 */ /**
 * Converts a JavaScript value to a JSON string.
 *
 * Supports serialization of BigInt values using two strategies:
 * 1. Custom format "123n" → "123" (universal fallback)
 * 2. Native JSON.rawJSON() (Node.js 22+, fastest) when available
 *
 * All other values are serialized exactly like native JSON.stringify().
 *
 * @param {*} value The value to convert to a JSON string.
 * @param {Replacer | Array<string | number> | null} [replacer]
 *   A function that alters the behavior of the stringification process,
 *   or an array of strings/numbers to indicate properties to exclude.
 * @param {string | number} [space]
 *   A string or number to specify indentation or pretty-printing.
 * @returns {string} The JSON string representation.
 */ const $cefdd33e221e0f5b$export$95da2e76982fabe = (value, replacer, space)=>{
    if ("rawJSON" in JSON) return $cefdd33e221e0f5b$var$originalStringify(value, (key, value)=>{
        if (typeof value === "bigint") return JSON.rawJSON(value.toString());
        if (typeof replacer === "function") return replacer(key, value);
        if (Array.isArray(replacer) && replacer.includes(key)) return value;
        return value;
    }, space);
    if (!value) return $cefdd33e221e0f5b$var$originalStringify(value, replacer, space);
    const convertedToCustomJSON = $cefdd33e221e0f5b$var$originalStringify(value, (key, value)=>{
        const isNoise = typeof value === "string" && $cefdd33e221e0f5b$var$noiseValue.test(value);
        if (isNoise) return value.toString() + "n"; // Mark noise values with additional "n" to offset the deletion of one "n" during the processing
        if (typeof value === "bigint") return value.toString() + "n";
        if (typeof replacer === "function") return replacer(key, value);
        if (Array.isArray(replacer) && replacer.includes(key)) return value;
        return value;
    }, space);
    const processedJSON = convertedToCustomJSON.replace($cefdd33e221e0f5b$var$bigIntsStringify, "$1$2$3"); // Delete one "n" off the end of every BigInt value
    const denoisedJSON = processedJSON.replace($cefdd33e221e0f5b$var$noiseStringify, "$1$2$3"); // Remove one "n" off the end of every noisy string
    return denoisedJSON;
};
const $cefdd33e221e0f5b$var$featureCache = new Map();
/**
 * Detects if the current JSON.parse implementation supports the context.source feature.
 *
 * Uses toString() fingerprinting to cache results and automatically detect runtime
 * replacements of JSON.parse (polyfills, mocks, etc.).
 *
 * @returns {boolean} true if context.source is supported, false otherwise.
 */ const $cefdd33e221e0f5b$var$isContextSourceSupported = ()=>{
    const parseFingerprint = JSON.parse.toString();
    if ($cefdd33e221e0f5b$var$featureCache.has(parseFingerprint)) return $cefdd33e221e0f5b$var$featureCache.get(parseFingerprint);
    try {
        const result = JSON.parse("1", (_, __, context)=>!!context?.source && context.source === "1");
        $cefdd33e221e0f5b$var$featureCache.set(parseFingerprint, result);
        return result;
    } catch  {
        $cefdd33e221e0f5b$var$featureCache.set(parseFingerprint, false);
        return false;
    }
};
/**
 * Reviver function that converts custom-format BigInt strings back to BigInt values.
 * Also handles "noise" strings that accidentally match the BigInt format.
 *
 * @param {string | number | undefined} key The object key.
 * @param {*} value The value being parsed.
 * @param {object} [context] Parse context (if supported by JSON.parse).
 * @param {Reviver} [userReviver] User's custom reviver function.
 * @returns {any} The transformed value.
 */ const $cefdd33e221e0f5b$var$convertMarkedBigIntsReviver = (key, value, context, userReviver)=>{
    const isCustomFormatBigInt = typeof value === "string" && $cefdd33e221e0f5b$var$customFormat.test(value);
    if (isCustomFormatBigInt) return BigInt(value.slice(0, -1));
    const isNoiseValue = typeof value === "string" && $cefdd33e221e0f5b$var$noiseValue.test(value);
    if (isNoiseValue) return value.slice(0, -1);
    if (typeof userReviver !== "function") return value;
    return userReviver(key, value, context);
};
/**
 * Fast JSON.parse implementation (~2x faster than classic fallback).
 * Uses JSON.parse's context.source feature to detect integers and convert
 * large numbers directly to BigInt without string manipulation.
 *
 * Does not support legacy custom format from v1 of this library.
 *
 * @param {string} text JSON string to parse.
 * @param {Reviver} [reviver] Transform function to apply to each value.
 * @returns {any} Parsed JavaScript value.
 */ const $cefdd33e221e0f5b$var$JSONParseV2 = (text, reviver)=>{
    return JSON.parse(text, (key, value, context)=>{
        const isBigNumber = typeof value === "number" && (value > Number.MAX_SAFE_INTEGER || value < Number.MIN_SAFE_INTEGER);
        const isInt = context && $cefdd33e221e0f5b$var$intRegex.test(context.source);
        const isBigInt = isBigNumber && isInt;
        if (isBigInt) return BigInt(context.source);
        if (typeof reviver !== "function") return value;
        return reviver(key, value, context);
    });
};
const $cefdd33e221e0f5b$var$MAX_INT = Number.MAX_SAFE_INTEGER.toString();
const $cefdd33e221e0f5b$var$MAX_DIGITS = $cefdd33e221e0f5b$var$MAX_INT.length;
const $cefdd33e221e0f5b$var$stringsOrLargeNumbers = /"(?:\\.|[^"])*"|-?(0|[1-9][0-9]*)(\.[0-9]+)?([eE][+-]?[0-9]+)?/g;
const $cefdd33e221e0f5b$var$noiseValueWithQuotes = /^"-?\d+n+"$/; // Noise - strings that match the custom format before being converted to it
/**
 * Converts a JSON string into a JavaScript value.
 *
 * Supports parsing of large integers using two strategies:
 * 1. Classic fallback: Marks large numbers with "123n" format, then converts to BigInt
 * 2. Fast path (JSONParseV2): Uses context.source feature (~2x faster) when available
 *
 * All other JSON values are parsed exactly like native JSON.parse().
 *
 * @param {string} text A valid JSON string.
 * @param {Reviver} [reviver]
 *   A function that transforms the results. This function is called for each member
 *   of the object. If a member contains nested objects, the nested objects are
 *   transformed before the parent object is.
 * @returns {any} The parsed JavaScript value.
 * @throws {SyntaxError} If text is not valid JSON.
 */ const $cefdd33e221e0f5b$export$3969146df1258ac = (text, reviver)=>{
    if (!text) return $cefdd33e221e0f5b$var$originalParse(text, reviver);
    if ($cefdd33e221e0f5b$var$isContextSourceSupported()) return $cefdd33e221e0f5b$var$JSONParseV2(text, reviver); // Shortcut to a faster (2x) and simpler version
    // Find and mark big numbers with "n"
    const serializedData = text.replace($cefdd33e221e0f5b$var$stringsOrLargeNumbers, (text, digits, fractional, exponential)=>{
        const isString = text[0] === '"';
        const isNoise = isString && $cefdd33e221e0f5b$var$noiseValueWithQuotes.test(text);
        if (isNoise) return text.substring(0, text.length - 1) + 'n"'; // Mark noise values with additional "n" to offset the deletion of one "n" during the processing
        const isFractionalOrExponential = fractional || exponential;
        const isLessThanMaxSafeInt = digits && (digits.length < $cefdd33e221e0f5b$var$MAX_DIGITS || digits.length === $cefdd33e221e0f5b$var$MAX_DIGITS && digits <= $cefdd33e221e0f5b$var$MAX_INT); // With a fixed number of digits, we can correctly use lexicographical comparison to do a numeric comparison
        if (isString || isFractionalOrExponential || isLessThanMaxSafeInt) return text;
        return '"' + text + 'n"';
    });
    return $cefdd33e221e0f5b$var$originalParse(serializedData, (key, value, context)=>$cefdd33e221e0f5b$var$convertMarkedBigIntsReviver(key, value, context, reviver));
};


class $bb12fa2010634178$export$43ee7d0e4f429743 extends Error {
    name;
    /**
   * http status code
   */ status;
    /**
   * Request options that lead to the error.
   */ request;
    /**
   * Response object if a response was received
   */ response;
    constructor(message, statusCode, options){
        super(message, {
            cause: options.cause
        });
        this.name = "HttpError";
        this.status = Number.parseInt(statusCode);
        if (Number.isNaN(this.status)) this.status = 0;
        /* v8 ignore else -- @preserve -- Bug with vitest coverage where it sees an else branch that doesn't exist */ if ("response" in options) this.response = options.response;
        const requestCopy = Object.assign({}, options.request);
        if (options.request.headers.authorization) requestCopy.headers = Object.assign({}, options.request.headers, {
            authorization: options.request.headers.authorization.replace(/(?<! ) .*$/, " [REDACTED]")
        });
        requestCopy.url = requestCopy.url.replace(/\bclient_secret=\w+/g, "client_secret=[REDACTED]").replace(/\baccess_token=\w+/g, "access_token=[REDACTED]");
        this.request = requestCopy;
    }
}


// pkg/dist-src/version.js
var $53bfbc9d73101eb2$var$VERSION = "10.0.9";
// pkg/dist-src/defaults.js
var $53bfbc9d73101eb2$var$defaults_default = {
    headers: {
        "user-agent": `octokit-request.js/${$53bfbc9d73101eb2$var$VERSION} ${(0, $a87c5f5ec76959fb$export$7935961ef7719cb0)()}`
    }
};
// pkg/dist-src/is-plain-object.js
function $53bfbc9d73101eb2$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null) return false;
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.prototype.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor === "function" && Ctor instanceof Ctor && Function.prototype.call(Ctor) === Function.prototype.call(value);
}
var $53bfbc9d73101eb2$var$noop = ()=>"";
async function $53bfbc9d73101eb2$var$fetchWrapper(requestOptions) {
    const fetch = requestOptions.request?.fetch || globalThis.fetch;
    if (!fetch) throw new Error("fetch is not set. Please pass a fetch implementation as new Octokit({ request: { fetch }}). Learn more at https://github.com/octokit/octokit.js/#fetch-missing");
    const log = requestOptions.request?.log || console;
    const parseSuccessResponseBody = requestOptions.request?.parseSuccessResponseBody !== false;
    const body = $53bfbc9d73101eb2$var$isPlainObject(requestOptions.body) || Array.isArray(requestOptions.body) ? (0, $cefdd33e221e0f5b$export$95da2e76982fabe)(requestOptions.body) : requestOptions.body;
    const requestHeaders = Object.fromEntries(Object.entries(requestOptions.headers).map(([name, value])=>[
            name,
            String(value)
        ]));
    let fetchResponse;
    try {
        fetchResponse = await fetch(requestOptions.url, {
            method: requestOptions.method,
            body: body,
            redirect: requestOptions.request?.redirect,
            headers: requestHeaders,
            signal: requestOptions.request?.signal,
            // duplex must be set if request.body is ReadableStream or Async Iterables.
            // See https://fetch.spec.whatwg.org/#dom-requestinit-duplex.
            ...requestOptions.body && {
                duplex: "half"
            }
        });
    } catch (error) {
        let message = "Unknown Error";
        if (error instanceof Error) {
            if (error.name === "AbortError") {
                error.status = 500;
                throw error;
            }
            message = error.message;
            if (error.name === "TypeError" && "cause" in error) {
                if (error.cause instanceof Error) message = error.cause.message;
                else if (typeof error.cause === "string") message = error.cause;
            }
        }
        const requestError = new (0, $bb12fa2010634178$export$43ee7d0e4f429743)(message, 500, {
            request: requestOptions
        });
        requestError.cause = error;
        throw requestError;
    }
    const status = fetchResponse.status;
    const url = fetchResponse.url;
    const responseHeaders = {};
    for (const [key, value] of fetchResponse.headers)responseHeaders[key] = value;
    const octokitResponse = {
        url: url,
        status: status,
        headers: responseHeaders,
        data: ""
    };
    if ("deprecation" in responseHeaders) {
        const matches = responseHeaders.link && responseHeaders.link.match(/<([^<>]+)>; rel="deprecation"/);
        const deprecationLink = matches && matches.pop();
        log.warn(`[@octokit/request] "${requestOptions.method} ${requestOptions.url}" is deprecated. It is scheduled to be removed on ${responseHeaders.sunset}${deprecationLink ? `. See ${deprecationLink}` : ""}`);
    }
    if (status === 204 || status === 205) return octokitResponse;
    if (requestOptions.method === "HEAD") {
        if (status < 400) return octokitResponse;
        throw new (0, $bb12fa2010634178$export$43ee7d0e4f429743)(fetchResponse.statusText, status, {
            response: octokitResponse,
            request: requestOptions
        });
    }
    if (status === 304) {
        octokitResponse.data = await $53bfbc9d73101eb2$var$getResponseData(fetchResponse);
        throw new (0, $bb12fa2010634178$export$43ee7d0e4f429743)("Not modified", status, {
            response: octokitResponse,
            request: requestOptions
        });
    }
    if (status >= 400) {
        octokitResponse.data = await $53bfbc9d73101eb2$var$getResponseData(fetchResponse);
        throw new (0, $bb12fa2010634178$export$43ee7d0e4f429743)($53bfbc9d73101eb2$var$toErrorMessage(octokitResponse.data), status, {
            response: octokitResponse,
            request: requestOptions
        });
    }
    octokitResponse.data = parseSuccessResponseBody ? await $53bfbc9d73101eb2$var$getResponseData(fetchResponse) : fetchResponse.body;
    return octokitResponse;
}
async function $53bfbc9d73101eb2$var$getResponseData(response) {
    const contentType = response.headers.get("content-type");
    if (!contentType) return response.text().catch($53bfbc9d73101eb2$var$noop);
    const mimetype = (0, $ad7d2c921615b517$exports.parse)(contentType);
    if ($53bfbc9d73101eb2$var$isJSONResponse(mimetype)) {
        let text = "";
        try {
            text = await response.text();
            return (0, $cefdd33e221e0f5b$export$3969146df1258ac)(text);
        } catch (err) {
            return text;
        }
    } else if (mimetype.type.startsWith("text/") || mimetype.parameters.charset?.toLowerCase() === "utf-8") return response.text().catch($53bfbc9d73101eb2$var$noop);
    else return response.arrayBuffer().catch(/* v8 ignore next -- @preserve */ ()=>new ArrayBuffer(0));
}
function $53bfbc9d73101eb2$var$isJSONResponse(mimetype) {
    return mimetype.type === "application/json" || mimetype.type === "application/scim+json";
}
function $53bfbc9d73101eb2$var$toErrorMessage(data) {
    if (typeof data === "string") return data;
    if (data instanceof ArrayBuffer) return "Unknown error";
    if ("message" in data) {
        const suffix = "documentation_url" in data ? ` - ${data.documentation_url}` : "";
        return Array.isArray(data.errors) ? `${data.message}: ${data.errors.map((v)=>JSON.stringify(v)).join(", ")}${suffix}` : `${data.message}${suffix}`;
    }
    return `Unknown error: ${JSON.stringify(data)}`;
}
// pkg/dist-src/with-defaults.js
function $53bfbc9d73101eb2$var$withDefaults(oldEndpoint, newDefaults) {
    const endpoint2 = oldEndpoint.defaults(newDefaults);
    const newApi = function(route, parameters) {
        const endpointOptions = endpoint2.merge(route, parameters);
        if (!endpointOptions.request || !endpointOptions.request.hook) return $53bfbc9d73101eb2$var$fetchWrapper(endpoint2.parse(endpointOptions));
        const request2 = (route2, parameters2)=>{
            return $53bfbc9d73101eb2$var$fetchWrapper(endpoint2.parse(endpoint2.merge(route2, parameters2)));
        };
        Object.assign(request2, {
            endpoint: endpoint2,
            defaults: $53bfbc9d73101eb2$var$withDefaults.bind(null, endpoint2)
        });
        return endpointOptions.request.hook(request2, endpointOptions);
    };
    return Object.assign(newApi, {
        endpoint: endpoint2,
        defaults: $53bfbc9d73101eb2$var$withDefaults.bind(null, endpoint2)
    });
}
// pkg/dist-src/index.js
var $53bfbc9d73101eb2$export$b5fe3f66a567bec0 = $53bfbc9d73101eb2$var$withDefaults((0, $53a307ba91c136eb$export$125e2b775860041f), $53bfbc9d73101eb2$var$defaults_default);
 /* v8 ignore next -- @preserve */  /* v8 ignore else -- @preserve */ 


// pkg/dist-src/version.js
var $39f88b0047acdf3a$var$VERSION = "0.0.0-development";
// pkg/dist-src/error.js
function $39f88b0047acdf3a$var$_buildMessageForResponseErrors(data) {
    return `Request failed due to following response errors:
` + data.errors.map((e)=>` - ${e.message}`).join("\n");
}
var $39f88b0047acdf3a$export$d19deff0ec585725 = class extends Error {
    constructor(request2, headers, response){
        super($39f88b0047acdf3a$var$_buildMessageForResponseErrors(response));
        this.request = request2;
        this.headers = headers;
        this.response = response;
        this.errors = response.errors;
        this.data = response.data;
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    }
    name = "GraphqlResponseError";
    errors;
    data;
};
// pkg/dist-src/graphql.js
var $39f88b0047acdf3a$var$NON_VARIABLE_OPTIONS = [
    "method",
    "baseUrl",
    "url",
    "headers",
    "request",
    "query",
    "mediaType",
    "operationName"
];
var $39f88b0047acdf3a$var$FORBIDDEN_VARIABLE_OPTIONS = [
    "query",
    "method",
    "url"
];
var $39f88b0047acdf3a$var$GHES_V3_SUFFIX_REGEX = /\/api\/v3\/?$/;
function $39f88b0047acdf3a$var$graphql(request2, query, options) {
    if (options) {
        if (typeof query === "string" && "query" in options) return Promise.reject(new Error(`[@octokit/graphql] "query" cannot be used as variable name`));
        for(const key in options){
            if (!$39f88b0047acdf3a$var$FORBIDDEN_VARIABLE_OPTIONS.includes(key)) continue;
            return Promise.reject(new Error(`[@octokit/graphql] "${key}" cannot be used as variable name`));
        }
    }
    const parsedOptions = typeof query === "string" ? Object.assign({
        query: query
    }, options) : query;
    const requestOptions = Object.keys(parsedOptions).reduce((result, key)=>{
        if ($39f88b0047acdf3a$var$NON_VARIABLE_OPTIONS.includes(key)) {
            result[key] = parsedOptions[key];
            return result;
        }
        if (!result.variables) result.variables = {};
        result.variables[key] = parsedOptions[key];
        return result;
    }, {});
    const baseUrl = parsedOptions.baseUrl || request2.endpoint.DEFAULTS.baseUrl;
    if ($39f88b0047acdf3a$var$GHES_V3_SUFFIX_REGEX.test(baseUrl)) requestOptions.url = baseUrl.replace($39f88b0047acdf3a$var$GHES_V3_SUFFIX_REGEX, "/api/graphql");
    return request2(requestOptions).then((response)=>{
        if (response.data.errors) {
            const headers = {};
            for (const key of Object.keys(response.headers))headers[key] = response.headers[key];
            throw new $39f88b0047acdf3a$export$d19deff0ec585725(requestOptions, headers, response.data);
        }
        return response.data.data;
    });
}
// pkg/dist-src/with-defaults.js
function $39f88b0047acdf3a$var$withDefaults(request2, newDefaults) {
    const newRequest = request2.defaults(newDefaults);
    const newApi = (query, options)=>{
        return $39f88b0047acdf3a$var$graphql(newRequest, query, options);
    };
    return Object.assign(newApi, {
        defaults: $39f88b0047acdf3a$var$withDefaults.bind(null, newRequest),
        endpoint: newRequest.endpoint
    });
}
// pkg/dist-src/index.js
var $39f88b0047acdf3a$export$1eb4e7c0ed67b035 = $39f88b0047acdf3a$var$withDefaults((0, $53bfbc9d73101eb2$export$b5fe3f66a567bec0), {
    headers: {
        "user-agent": `octokit-graphql.js/${$39f88b0047acdf3a$var$VERSION} ${(0, $a87c5f5ec76959fb$export$7935961ef7719cb0)()}`
    },
    method: "POST",
    url: "/graphql"
});
function $39f88b0047acdf3a$export$9eb07bf38af78249(customRequest) {
    return $39f88b0047acdf3a$var$withDefaults(customRequest, {
        method: "POST",
        url: "/graphql"
    });
}



// @ts-check
// @ts-check
function $b7b1148e0bfb71b3$export$6503ec6e8aabbaf(state, name, method, options) {
    if (typeof method !== "function") throw new Error("method for before hook must be a function");
    if (!options) options = {};
    if (Array.isArray(name)) return name.reverse().reduce((callback, name)=>{
        return $b7b1148e0bfb71b3$export$6503ec6e8aabbaf.bind(null, state, name, callback, options);
    }, method)();
    return Promise.resolve().then(()=>{
        if (!state.registry[name]) return method(options);
        return state.registry[name].reduce((method, registered)=>{
            return registered.hook.bind(null, method, options);
        }, method)();
    });
}


// @ts-check
function $90a3f56ebb6cddc6$export$f99777bb87ac6904(state, kind, name, hook) {
    const orig = hook;
    if (!state.registry[name]) state.registry[name] = [];
    if (kind === "before") hook = (method, options)=>{
        return Promise.resolve().then(orig.bind(null, options)).then(method.bind(null, options));
    };
    if (kind === "after") hook = (method, options)=>{
        let result;
        return Promise.resolve().then(method.bind(null, options)).then((result_)=>{
            result = result_;
            return orig(result, options);
        }).then(()=>{
            return result;
        });
    };
    if (kind === "error") hook = (method, options)=>{
        return Promise.resolve().then(method.bind(null, options)).catch((error)=>{
            return orig(error, options);
        });
    };
    state.registry[name].push({
        hook: hook,
        orig: orig
    });
}


// @ts-check
function $a2f52b4942f9cd26$export$4840506845da1500(state, name, method) {
    if (!state.registry[name]) return;
    const index = state.registry[name].map((registered)=>{
        return registered.orig;
    }).indexOf(method);
    if (index === -1) return;
    state.registry[name].splice(index, 1);
}


// bind with array of arguments: https://stackoverflow.com/a/21792913
const $bb82c4293bb17b99$var$bind = Function.bind;
const $bb82c4293bb17b99$var$bindable = $bb82c4293bb17b99$var$bind.bind($bb82c4293bb17b99$var$bind);
function $bb82c4293bb17b99$var$bindApi(hook, state, name) {
    const removeHookRef = $bb82c4293bb17b99$var$bindable((0, $a2f52b4942f9cd26$export$4840506845da1500), null).apply(null, name ? [
        state,
        name
    ] : [
        state
    ]);
    hook.api = {
        remove: removeHookRef
    };
    hook.remove = removeHookRef;
    [
        "before",
        "error",
        "after",
        "wrap"
    ].forEach((kind)=>{
        const args = name ? [
            state,
            kind,
            name
        ] : [
            state,
            kind
        ];
        hook[kind] = hook.api[kind] = $bb82c4293bb17b99$var$bindable((0, $90a3f56ebb6cddc6$export$f99777bb87ac6904), null).apply(null, args);
    });
}
function $bb82c4293bb17b99$var$Singular() {
    const singularHookName = Symbol("Singular");
    const singularHookState = {
        registry: {}
    };
    const singularHook = (0, $b7b1148e0bfb71b3$export$6503ec6e8aabbaf).bind(null, singularHookState, singularHookName);
    $bb82c4293bb17b99$var$bindApi(singularHook, singularHookState, singularHookName);
    return singularHook;
}
function $bb82c4293bb17b99$var$Collection() {
    const state = {
        registry: {}
    };
    const hook = (0, $b7b1148e0bfb71b3$export$6503ec6e8aabbaf).bind(null, state);
    $bb82c4293bb17b99$var$bindApi(hook, state);
    return hook;
}
var $bb82c4293bb17b99$export$2e2bcd8739ae039 = {
    Singular: $bb82c4293bb17b99$var$Singular,
    Collection: $bb82c4293bb17b99$var$Collection
};




// pkg/dist-src/is-jwt.js
var $3ac55cb79dba4535$var$b64url = "(?:[a-zA-Z0-9_-]+)";
var $3ac55cb79dba4535$var$sep = "\\.";
var $3ac55cb79dba4535$var$jwtRE = new RegExp(`^${$3ac55cb79dba4535$var$b64url}${$3ac55cb79dba4535$var$sep}${$3ac55cb79dba4535$var$b64url}${$3ac55cb79dba4535$var$sep}${$3ac55cb79dba4535$var$b64url}$`);
var $3ac55cb79dba4535$var$isJWT = $3ac55cb79dba4535$var$jwtRE.test.bind($3ac55cb79dba4535$var$jwtRE);
// pkg/dist-src/auth.js
async function $3ac55cb79dba4535$var$auth(token) {
    const isApp = $3ac55cb79dba4535$var$isJWT(token);
    const isInstallation = token.startsWith("v1.") || token.startsWith("ghs_");
    const isUserToServer = token.startsWith("ghu_");
    const tokenType = isApp ? "app" : isInstallation ? "installation" : isUserToServer ? "user-to-server" : "oauth";
    return {
        type: "token",
        token: token,
        tokenType: tokenType
    };
}
// pkg/dist-src/with-authorization-prefix.js
function $3ac55cb79dba4535$var$withAuthorizationPrefix(token) {
    if (token.split(/\./).length === 3) return `bearer ${token}`;
    return `token ${token}`;
}
// pkg/dist-src/hook.js
async function $3ac55cb79dba4535$var$hook(token, request, route, parameters) {
    const endpoint = request.endpoint.merge(route, parameters);
    endpoint.headers.authorization = $3ac55cb79dba4535$var$withAuthorizationPrefix(token);
    return request(endpoint);
}
// pkg/dist-src/index.js
var $3ac55cb79dba4535$export$acf0006d85231cb6 = function createTokenAuth2(token) {
    if (!token) throw new Error("[@octokit/auth-token] No token passed to createTokenAuth");
    if (typeof token !== "string") throw new Error("[@octokit/auth-token] Token passed to createTokenAuth is not a string");
    token = token.replace(/^(token|bearer) +/i, "");
    return Object.assign($3ac55cb79dba4535$var$auth.bind(null, token), {
        hook: $3ac55cb79dba4535$var$hook.bind(null, token)
    });
};


const $ba64ce8805a5137d$export$a4ad2735b021c132 = "7.0.6";


const $e1bec7210289ec8a$var$noop = ()=>{};
const $e1bec7210289ec8a$var$consoleWarn = console.warn.bind(console);
const $e1bec7210289ec8a$var$consoleError = console.error.bind(console);
function $e1bec7210289ec8a$var$createLogger(logger = {}) {
    if (typeof logger.debug !== "function") logger.debug = $e1bec7210289ec8a$var$noop;
    if (typeof logger.info !== "function") logger.info = $e1bec7210289ec8a$var$noop;
    if (typeof logger.warn !== "function") logger.warn = $e1bec7210289ec8a$var$consoleWarn;
    if (typeof logger.error !== "function") logger.error = $e1bec7210289ec8a$var$consoleError;
    return logger;
}
const $e1bec7210289ec8a$var$userAgentTrail = `octokit-core.js/${(0, $ba64ce8805a5137d$export$a4ad2735b021c132)} ${(0, $a87c5f5ec76959fb$export$7935961ef7719cb0)()}`;
class $e1bec7210289ec8a$export$d19f1ac68c042717 {
    static VERSION = (0, $ba64ce8805a5137d$export$a4ad2735b021c132);
    static defaults(defaults) {
        const OctokitWithDefaults = class extends this {
            constructor(...args){
                const options = args[0] || {};
                if (typeof defaults === "function") {
                    super(defaults(options));
                    return;
                }
                super(Object.assign({}, defaults, options, options.userAgent && defaults.userAgent ? {
                    userAgent: `${options.userAgent} ${defaults.userAgent}`
                } : null));
            }
        };
        return OctokitWithDefaults;
    }
    static plugins = [];
    /**
   * Attach a plugin (or many) to your Octokit instance.
   *
   * @example
   * const API = Octokit.plugin(plugin1, plugin2, plugin3, ...)
   */ static plugin(...newPlugins) {
        const currentPlugins = this.plugins;
        const NewOctokit = class extends this {
            static plugins = currentPlugins.concat(newPlugins.filter((plugin)=>!currentPlugins.includes(plugin)));
        };
        return NewOctokit;
    }
    constructor(options = {}){
        const hook = new (0, $bb82c4293bb17b99$export$2e2bcd8739ae039).Collection();
        const requestDefaults = {
            baseUrl: (0, $53bfbc9d73101eb2$export$b5fe3f66a567bec0).endpoint.DEFAULTS.baseUrl,
            headers: {},
            request: Object.assign({}, options.request, {
                // @ts-ignore internal usage only, no need to type
                hook: hook.bind(null, "request")
            }),
            mediaType: {
                previews: [],
                format: ""
            }
        };
        requestDefaults.headers["user-agent"] = options.userAgent ? `${options.userAgent} ${$e1bec7210289ec8a$var$userAgentTrail}` : $e1bec7210289ec8a$var$userAgentTrail;
        if (options.baseUrl) requestDefaults.baseUrl = options.baseUrl;
        if (options.previews) requestDefaults.mediaType.previews = options.previews;
        if (options.timeZone) requestDefaults.headers["time-zone"] = options.timeZone;
        this.request = (0, $53bfbc9d73101eb2$export$b5fe3f66a567bec0).defaults(requestDefaults);
        this.graphql = (0, $39f88b0047acdf3a$export$9eb07bf38af78249)(this.request).defaults(requestDefaults);
        this.log = $e1bec7210289ec8a$var$createLogger(options.log);
        this.hook = hook;
        if (!options.authStrategy) {
            if (!options.auth) this.auth = async ()=>({
                    type: "unauthenticated"
                });
            else {
                const auth = (0, $3ac55cb79dba4535$export$acf0006d85231cb6)(options.auth);
                hook.wrap("request", auth.hook);
                this.auth = auth;
            }
        } else {
            const { authStrategy: authStrategy, ...otherOptions } = options;
            const auth = authStrategy(Object.assign({
                request: this.request,
                log: this.log,
                // we pass the current octokit instance as well as its constructor options
                // to allow for authentication strategies that return a new octokit instance
                // that shares the same internal state as the current one. The original
                // requirement for this was the "event-octokit" authentication strategy
                // of https://github.com/probot/octokit-auth-probot.
                octokit: this,
                octokitOptions: otherOptions
            }, options.auth));
            hook.wrap("request", auth.hook);
            this.auth = auth;
        }
        const classConstructor = this.constructor;
        for(let i = 0; i < classConstructor.plugins.length; ++i)Object.assign(this, classConstructor.plugins[i](this, options));
    }
    // assigned during constructor
    request;
    graphql;
    log;
    hook;
    // TODO: type `octokit.auth` based on passed options.authStrategy
    auth;
}


const $2602e95f08405cbe$export$a4ad2735b021c132 = "6.0.0";


function $1d50f8968a9c93ea$export$1c1276d455e5a49b(octokit) {
    octokit.hook.wrap("request", (request, options)=>{
        octokit.log.debug("request", options);
        const start = Date.now();
        const requestOptions = octokit.request.endpoint.parse(options);
        const path = requestOptions.url.replace(options.baseUrl, "");
        return request(options).then((response)=>{
            const requestId = response.headers["x-github-request-id"];
            octokit.log.info(`${requestOptions.method} ${path} - ${response.status} with id ${requestId} in ${Date.now() - start}ms`);
            return response;
        }).catch((error)=>{
            const requestId = error.response?.headers["x-github-request-id"] || "UNKNOWN";
            octokit.log.error(`${requestOptions.method} ${path} - ${error.status} with id ${requestId} in ${Date.now() - start}ms`);
            throw error;
        });
    });
}
$1d50f8968a9c93ea$export$1c1276d455e5a49b.VERSION = (0, $2602e95f08405cbe$export$a4ad2735b021c132);


// pkg/dist-src/version.js
var $1dae16d4eecbbc46$var$VERSION = "0.0.0-development";
// pkg/dist-src/normalize-paginated-list-response.js
function $1dae16d4eecbbc46$var$normalizePaginatedListResponse(response) {
    if (!response.data) return {
        ...response,
        data: []
    };
    const responseNeedsNormalization = ("total_count" in response.data || "total_commits" in response.data) && !("url" in response.data);
    if (!responseNeedsNormalization) return response;
    const incompleteResults = response.data.incomplete_results;
    const repositorySelection = response.data.repository_selection;
    const totalCount = response.data.total_count;
    const totalCommits = response.data.total_commits;
    delete response.data.incomplete_results;
    delete response.data.repository_selection;
    delete response.data.total_count;
    delete response.data.total_commits;
    const namespaceKey = Object.keys(response.data)[0];
    const data = response.data[namespaceKey];
    response.data = data;
    if (typeof incompleteResults !== "undefined") response.data.incomplete_results = incompleteResults;
    if (typeof repositorySelection !== "undefined") response.data.repository_selection = repositorySelection;
    response.data.total_count = totalCount;
    response.data.total_commits = totalCommits;
    return response;
}
// pkg/dist-src/iterator.js
function $1dae16d4eecbbc46$var$iterator(octokit, route, parameters) {
    const options = typeof route === "function" ? route.endpoint(parameters) : octokit.request.endpoint(route, parameters);
    const requestMethod = typeof route === "function" ? route : octokit.request;
    const method = options.method;
    const headers = options.headers;
    let url = options.url;
    return {
        [Symbol.asyncIterator]: ()=>({
                async next () {
                    if (!url) return {
                        done: true
                    };
                    try {
                        const response = await requestMethod({
                            method: method,
                            url: url,
                            headers: headers
                        });
                        const normalizedResponse = $1dae16d4eecbbc46$var$normalizePaginatedListResponse(response);
                        url = ((normalizedResponse.headers.link || "").match(/<([^<>]+)>;\s*rel="next"/) || [])[1];
                        if (!url && "total_commits" in normalizedResponse.data) {
                            const parsedUrl = new URL(normalizedResponse.url);
                            const params = parsedUrl.searchParams;
                            const page = parseInt(params.get("page") || "1", 10);
                            const per_page = parseInt(params.get("per_page") || "250", 10);
                            if (page * per_page < normalizedResponse.data.total_commits) {
                                params.set("page", String(page + 1));
                                url = parsedUrl.toString();
                            }
                        }
                        return {
                            value: normalizedResponse
                        };
                    } catch (error) {
                        if (error.status !== 409) throw error;
                        url = "";
                        return {
                            value: {
                                status: 200,
                                headers: {},
                                data: []
                            }
                        };
                    }
                }
            })
    };
}
// pkg/dist-src/paginate.js
function $1dae16d4eecbbc46$var$paginate(octokit, route, parameters, mapFn) {
    if (typeof parameters === "function") {
        mapFn = parameters;
        parameters = void 0;
    }
    return $1dae16d4eecbbc46$var$gather(octokit, [], $1dae16d4eecbbc46$var$iterator(octokit, route, parameters)[Symbol.asyncIterator](), mapFn);
}
function $1dae16d4eecbbc46$var$gather(octokit, results, iterator2, mapFn) {
    return iterator2.next().then((result)=>{
        if (result.done) return results;
        let earlyExit = false;
        function done() {
            earlyExit = true;
        }
        results = results.concat(mapFn ? mapFn(result.value, done) : result.value.data);
        if (earlyExit) return results;
        return $1dae16d4eecbbc46$var$gather(octokit, results, iterator2, mapFn);
    });
}
// pkg/dist-src/compose-paginate.js
var $1dae16d4eecbbc46$export$44fe6ff56a1118b0 = Object.assign($1dae16d4eecbbc46$var$paginate, {
    iterator: $1dae16d4eecbbc46$var$iterator
});
// pkg/dist-src/generated/paginating-endpoints.js
var $1dae16d4eecbbc46$export$f72c3e329f772158 = [
    "GET /advisories",
    "GET /app/hook/deliveries",
    "GET /app/installation-requests",
    "GET /app/installations",
    "GET /assignments/{assignment_id}/accepted_assignments",
    "GET /classrooms",
    "GET /classrooms/{classroom_id}/assignments",
    "GET /enterprises/{enterprise}/code-security/configurations",
    "GET /enterprises/{enterprise}/code-security/configurations/{configuration_id}/repositories",
    "GET /enterprises/{enterprise}/dependabot/alerts",
    "GET /enterprises/{enterprise}/teams",
    "GET /enterprises/{enterprise}/teams/{enterprise-team}/memberships",
    "GET /enterprises/{enterprise}/teams/{enterprise-team}/organizations",
    "GET /events",
    "GET /gists",
    "GET /gists/public",
    "GET /gists/starred",
    "GET /gists/{gist_id}/comments",
    "GET /gists/{gist_id}/commits",
    "GET /gists/{gist_id}/forks",
    "GET /installation/repositories",
    "GET /issues",
    "GET /licenses",
    "GET /marketplace_listing/plans",
    "GET /marketplace_listing/plans/{plan_id}/accounts",
    "GET /marketplace_listing/stubbed/plans",
    "GET /marketplace_listing/stubbed/plans/{plan_id}/accounts",
    "GET /networks/{owner}/{repo}/events",
    "GET /notifications",
    "GET /organizations",
    "GET /organizations/{org}/dependabot/repository-access",
    "GET /orgs/{org}/actions/cache/usage-by-repository",
    "GET /orgs/{org}/actions/hosted-runners",
    "GET /orgs/{org}/actions/permissions/repositories",
    "GET /orgs/{org}/actions/permissions/self-hosted-runners/repositories",
    "GET /orgs/{org}/actions/runner-groups",
    "GET /orgs/{org}/actions/runner-groups/{runner_group_id}/hosted-runners",
    "GET /orgs/{org}/actions/runner-groups/{runner_group_id}/repositories",
    "GET /orgs/{org}/actions/runner-groups/{runner_group_id}/runners",
    "GET /orgs/{org}/actions/runners",
    "GET /orgs/{org}/actions/secrets",
    "GET /orgs/{org}/actions/secrets/{secret_name}/repositories",
    "GET /orgs/{org}/actions/variables",
    "GET /orgs/{org}/actions/variables/{name}/repositories",
    "GET /orgs/{org}/attestations/repositories",
    "GET /orgs/{org}/attestations/{subject_digest}",
    "GET /orgs/{org}/blocks",
    "GET /orgs/{org}/campaigns",
    "GET /orgs/{org}/code-scanning/alerts",
    "GET /orgs/{org}/code-security/configurations",
    "GET /orgs/{org}/code-security/configurations/{configuration_id}/repositories",
    "GET /orgs/{org}/codespaces",
    "GET /orgs/{org}/codespaces/secrets",
    "GET /orgs/{org}/codespaces/secrets/{secret_name}/repositories",
    "GET /orgs/{org}/copilot/billing/seats",
    "GET /orgs/{org}/copilot/metrics",
    "GET /orgs/{org}/dependabot/alerts",
    "GET /orgs/{org}/dependabot/secrets",
    "GET /orgs/{org}/dependabot/secrets/{secret_name}/repositories",
    "GET /orgs/{org}/events",
    "GET /orgs/{org}/failed_invitations",
    "GET /orgs/{org}/hooks",
    "GET /orgs/{org}/hooks/{hook_id}/deliveries",
    "GET /orgs/{org}/insights/api/route-stats/{actor_type}/{actor_id}",
    "GET /orgs/{org}/insights/api/subject-stats",
    "GET /orgs/{org}/insights/api/user-stats/{user_id}",
    "GET /orgs/{org}/installations",
    "GET /orgs/{org}/invitations",
    "GET /orgs/{org}/invitations/{invitation_id}/teams",
    "GET /orgs/{org}/issues",
    "GET /orgs/{org}/members",
    "GET /orgs/{org}/members/{username}/codespaces",
    "GET /orgs/{org}/migrations",
    "GET /orgs/{org}/migrations/{migration_id}/repositories",
    "GET /orgs/{org}/organization-roles/{role_id}/teams",
    "GET /orgs/{org}/organization-roles/{role_id}/users",
    "GET /orgs/{org}/outside_collaborators",
    "GET /orgs/{org}/packages",
    "GET /orgs/{org}/packages/{package_type}/{package_name}/versions",
    "GET /orgs/{org}/personal-access-token-requests",
    "GET /orgs/{org}/personal-access-token-requests/{pat_request_id}/repositories",
    "GET /orgs/{org}/personal-access-tokens",
    "GET /orgs/{org}/personal-access-tokens/{pat_id}/repositories",
    "GET /orgs/{org}/private-registries",
    "GET /orgs/{org}/projects",
    "GET /orgs/{org}/projectsV2",
    "GET /orgs/{org}/projectsV2/{project_number}/fields",
    "GET /orgs/{org}/projectsV2/{project_number}/items",
    "GET /orgs/{org}/properties/values",
    "GET /orgs/{org}/public_members",
    "GET /orgs/{org}/repos",
    "GET /orgs/{org}/rulesets",
    "GET /orgs/{org}/rulesets/rule-suites",
    "GET /orgs/{org}/rulesets/{ruleset_id}/history",
    "GET /orgs/{org}/secret-scanning/alerts",
    "GET /orgs/{org}/security-advisories",
    "GET /orgs/{org}/settings/immutable-releases/repositories",
    "GET /orgs/{org}/settings/network-configurations",
    "GET /orgs/{org}/team/{team_slug}/copilot/metrics",
    "GET /orgs/{org}/teams",
    "GET /orgs/{org}/teams/{team_slug}/discussions",
    "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments",
    "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}/reactions",
    "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/reactions",
    "GET /orgs/{org}/teams/{team_slug}/invitations",
    "GET /orgs/{org}/teams/{team_slug}/members",
    "GET /orgs/{org}/teams/{team_slug}/projects",
    "GET /orgs/{org}/teams/{team_slug}/repos",
    "GET /orgs/{org}/teams/{team_slug}/teams",
    "GET /projects/{project_id}/collaborators",
    "GET /repos/{owner}/{repo}/actions/artifacts",
    "GET /repos/{owner}/{repo}/actions/caches",
    "GET /repos/{owner}/{repo}/actions/organization-secrets",
    "GET /repos/{owner}/{repo}/actions/organization-variables",
    "GET /repos/{owner}/{repo}/actions/runners",
    "GET /repos/{owner}/{repo}/actions/runs",
    "GET /repos/{owner}/{repo}/actions/runs/{run_id}/artifacts",
    "GET /repos/{owner}/{repo}/actions/runs/{run_id}/attempts/{attempt_number}/jobs",
    "GET /repos/{owner}/{repo}/actions/runs/{run_id}/jobs",
    "GET /repos/{owner}/{repo}/actions/secrets",
    "GET /repos/{owner}/{repo}/actions/variables",
    "GET /repos/{owner}/{repo}/actions/workflows",
    "GET /repos/{owner}/{repo}/actions/workflows/{workflow_id}/runs",
    "GET /repos/{owner}/{repo}/activity",
    "GET /repos/{owner}/{repo}/assignees",
    "GET /repos/{owner}/{repo}/attestations/{subject_digest}",
    "GET /repos/{owner}/{repo}/branches",
    "GET /repos/{owner}/{repo}/check-runs/{check_run_id}/annotations",
    "GET /repos/{owner}/{repo}/check-suites/{check_suite_id}/check-runs",
    "GET /repos/{owner}/{repo}/code-scanning/alerts",
    "GET /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}/instances",
    "GET /repos/{owner}/{repo}/code-scanning/analyses",
    "GET /repos/{owner}/{repo}/codespaces",
    "GET /repos/{owner}/{repo}/codespaces/devcontainers",
    "GET /repos/{owner}/{repo}/codespaces/secrets",
    "GET /repos/{owner}/{repo}/collaborators",
    "GET /repos/{owner}/{repo}/comments",
    "GET /repos/{owner}/{repo}/comments/{comment_id}/reactions",
    "GET /repos/{owner}/{repo}/commits",
    "GET /repos/{owner}/{repo}/commits/{commit_sha}/comments",
    "GET /repos/{owner}/{repo}/commits/{commit_sha}/pulls",
    "GET /repos/{owner}/{repo}/commits/{ref}/check-runs",
    "GET /repos/{owner}/{repo}/commits/{ref}/check-suites",
    "GET /repos/{owner}/{repo}/commits/{ref}/status",
    "GET /repos/{owner}/{repo}/commits/{ref}/statuses",
    "GET /repos/{owner}/{repo}/compare/{basehead}",
    "GET /repos/{owner}/{repo}/compare/{base}...{head}",
    "GET /repos/{owner}/{repo}/contributors",
    "GET /repos/{owner}/{repo}/dependabot/alerts",
    "GET /repos/{owner}/{repo}/dependabot/secrets",
    "GET /repos/{owner}/{repo}/deployments",
    "GET /repos/{owner}/{repo}/deployments/{deployment_id}/statuses",
    "GET /repos/{owner}/{repo}/environments",
    "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment-branch-policies",
    "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment_protection_rules/apps",
    "GET /repos/{owner}/{repo}/environments/{environment_name}/secrets",
    "GET /repos/{owner}/{repo}/environments/{environment_name}/variables",
    "GET /repos/{owner}/{repo}/events",
    "GET /repos/{owner}/{repo}/forks",
    "GET /repos/{owner}/{repo}/hooks",
    "GET /repos/{owner}/{repo}/hooks/{hook_id}/deliveries",
    "GET /repos/{owner}/{repo}/invitations",
    "GET /repos/{owner}/{repo}/issues",
    "GET /repos/{owner}/{repo}/issues/comments",
    "GET /repos/{owner}/{repo}/issues/comments/{comment_id}/reactions",
    "GET /repos/{owner}/{repo}/issues/events",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/comments",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/dependencies/blocked_by",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/dependencies/blocking",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/events",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/labels",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/reactions",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/sub_issues",
    "GET /repos/{owner}/{repo}/issues/{issue_number}/timeline",
    "GET /repos/{owner}/{repo}/keys",
    "GET /repos/{owner}/{repo}/labels",
    "GET /repos/{owner}/{repo}/milestones",
    "GET /repos/{owner}/{repo}/milestones/{milestone_number}/labels",
    "GET /repos/{owner}/{repo}/notifications",
    "GET /repos/{owner}/{repo}/pages/builds",
    "GET /repos/{owner}/{repo}/projects",
    "GET /repos/{owner}/{repo}/pulls",
    "GET /repos/{owner}/{repo}/pulls/comments",
    "GET /repos/{owner}/{repo}/pulls/comments/{comment_id}/reactions",
    "GET /repos/{owner}/{repo}/pulls/{pull_number}/comments",
    "GET /repos/{owner}/{repo}/pulls/{pull_number}/commits",
    "GET /repos/{owner}/{repo}/pulls/{pull_number}/files",
    "GET /repos/{owner}/{repo}/pulls/{pull_number}/reviews",
    "GET /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}/comments",
    "GET /repos/{owner}/{repo}/releases",
    "GET /repos/{owner}/{repo}/releases/{release_id}/assets",
    "GET /repos/{owner}/{repo}/releases/{release_id}/reactions",
    "GET /repos/{owner}/{repo}/rules/branches/{branch}",
    "GET /repos/{owner}/{repo}/rulesets",
    "GET /repos/{owner}/{repo}/rulesets/rule-suites",
    "GET /repos/{owner}/{repo}/rulesets/{ruleset_id}/history",
    "GET /repos/{owner}/{repo}/secret-scanning/alerts",
    "GET /repos/{owner}/{repo}/secret-scanning/alerts/{alert_number}/locations",
    "GET /repos/{owner}/{repo}/security-advisories",
    "GET /repos/{owner}/{repo}/stargazers",
    "GET /repos/{owner}/{repo}/subscribers",
    "GET /repos/{owner}/{repo}/tags",
    "GET /repos/{owner}/{repo}/teams",
    "GET /repos/{owner}/{repo}/topics",
    "GET /repositories",
    "GET /search/code",
    "GET /search/commits",
    "GET /search/issues",
    "GET /search/labels",
    "GET /search/repositories",
    "GET /search/topics",
    "GET /search/users",
    "GET /teams/{team_id}/discussions",
    "GET /teams/{team_id}/discussions/{discussion_number}/comments",
    "GET /teams/{team_id}/discussions/{discussion_number}/comments/{comment_number}/reactions",
    "GET /teams/{team_id}/discussions/{discussion_number}/reactions",
    "GET /teams/{team_id}/invitations",
    "GET /teams/{team_id}/members",
    "GET /teams/{team_id}/projects",
    "GET /teams/{team_id}/repos",
    "GET /teams/{team_id}/teams",
    "GET /user/blocks",
    "GET /user/codespaces",
    "GET /user/codespaces/secrets",
    "GET /user/emails",
    "GET /user/followers",
    "GET /user/following",
    "GET /user/gpg_keys",
    "GET /user/installations",
    "GET /user/installations/{installation_id}/repositories",
    "GET /user/issues",
    "GET /user/keys",
    "GET /user/marketplace_purchases",
    "GET /user/marketplace_purchases/stubbed",
    "GET /user/memberships/orgs",
    "GET /user/migrations",
    "GET /user/migrations/{migration_id}/repositories",
    "GET /user/orgs",
    "GET /user/packages",
    "GET /user/packages/{package_type}/{package_name}/versions",
    "GET /user/public_emails",
    "GET /user/repos",
    "GET /user/repository_invitations",
    "GET /user/social_accounts",
    "GET /user/ssh_signing_keys",
    "GET /user/starred",
    "GET /user/subscriptions",
    "GET /user/teams",
    "GET /users",
    "GET /users/{username}/attestations/{subject_digest}",
    "GET /users/{username}/events",
    "GET /users/{username}/events/orgs/{org}",
    "GET /users/{username}/events/public",
    "GET /users/{username}/followers",
    "GET /users/{username}/following",
    "GET /users/{username}/gists",
    "GET /users/{username}/gpg_keys",
    "GET /users/{username}/keys",
    "GET /users/{username}/orgs",
    "GET /users/{username}/packages",
    "GET /users/{username}/projects",
    "GET /users/{username}/projectsV2",
    "GET /users/{username}/projectsV2/{project_number}/fields",
    "GET /users/{username}/projectsV2/{project_number}/items",
    "GET /users/{username}/received_events",
    "GET /users/{username}/received_events/public",
    "GET /users/{username}/repos",
    "GET /users/{username}/social_accounts",
    "GET /users/{username}/ssh_signing_keys",
    "GET /users/{username}/starred",
    "GET /users/{username}/subscriptions"
];
// pkg/dist-src/paginating-endpoints.js
function $1dae16d4eecbbc46$export$d31615f298c9ee6(arg) {
    if (typeof arg === "string") return $1dae16d4eecbbc46$export$f72c3e329f772158.includes(arg);
    else return false;
}
// pkg/dist-src/index.js
function $1dae16d4eecbbc46$export$d8def7ab7602fc50(octokit) {
    return {
        paginate: Object.assign($1dae16d4eecbbc46$var$paginate.bind(null, octokit), {
            iterator: $1dae16d4eecbbc46$var$iterator.bind(null, octokit)
        })
    };
}
$1dae16d4eecbbc46$export$d8def7ab7602fc50.VERSION = $1dae16d4eecbbc46$var$VERSION;


const $8b9c3a2d778f9042$export$a4ad2735b021c132 = "17.0.0";


const $fec2aee19b3e615a$var$Endpoints = {
    actions: {
        addCustomLabelsToSelfHostedRunnerForOrg: [
            "POST /orgs/{org}/actions/runners/{runner_id}/labels"
        ],
        addCustomLabelsToSelfHostedRunnerForRepo: [
            "POST /repos/{owner}/{repo}/actions/runners/{runner_id}/labels"
        ],
        addRepoAccessToSelfHostedRunnerGroupInOrg: [
            "PUT /orgs/{org}/actions/runner-groups/{runner_group_id}/repositories/{repository_id}"
        ],
        addSelectedRepoToOrgSecret: [
            "PUT /orgs/{org}/actions/secrets/{secret_name}/repositories/{repository_id}"
        ],
        addSelectedRepoToOrgVariable: [
            "PUT /orgs/{org}/actions/variables/{name}/repositories/{repository_id}"
        ],
        approveWorkflowRun: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/approve"
        ],
        cancelWorkflowRun: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/cancel"
        ],
        createEnvironmentVariable: [
            "POST /repos/{owner}/{repo}/environments/{environment_name}/variables"
        ],
        createHostedRunnerForOrg: [
            "POST /orgs/{org}/actions/hosted-runners"
        ],
        createOrUpdateEnvironmentSecret: [
            "PUT /repos/{owner}/{repo}/environments/{environment_name}/secrets/{secret_name}"
        ],
        createOrUpdateOrgSecret: [
            "PUT /orgs/{org}/actions/secrets/{secret_name}"
        ],
        createOrUpdateRepoSecret: [
            "PUT /repos/{owner}/{repo}/actions/secrets/{secret_name}"
        ],
        createOrgVariable: [
            "POST /orgs/{org}/actions/variables"
        ],
        createRegistrationTokenForOrg: [
            "POST /orgs/{org}/actions/runners/registration-token"
        ],
        createRegistrationTokenForRepo: [
            "POST /repos/{owner}/{repo}/actions/runners/registration-token"
        ],
        createRemoveTokenForOrg: [
            "POST /orgs/{org}/actions/runners/remove-token"
        ],
        createRemoveTokenForRepo: [
            "POST /repos/{owner}/{repo}/actions/runners/remove-token"
        ],
        createRepoVariable: [
            "POST /repos/{owner}/{repo}/actions/variables"
        ],
        createWorkflowDispatch: [
            "POST /repos/{owner}/{repo}/actions/workflows/{workflow_id}/dispatches"
        ],
        deleteActionsCacheById: [
            "DELETE /repos/{owner}/{repo}/actions/caches/{cache_id}"
        ],
        deleteActionsCacheByKey: [
            "DELETE /repos/{owner}/{repo}/actions/caches{?key,ref}"
        ],
        deleteArtifact: [
            "DELETE /repos/{owner}/{repo}/actions/artifacts/{artifact_id}"
        ],
        deleteCustomImageFromOrg: [
            "DELETE /orgs/{org}/actions/hosted-runners/images/custom/{image_definition_id}"
        ],
        deleteCustomImageVersionFromOrg: [
            "DELETE /orgs/{org}/actions/hosted-runners/images/custom/{image_definition_id}/versions/{version}"
        ],
        deleteEnvironmentSecret: [
            "DELETE /repos/{owner}/{repo}/environments/{environment_name}/secrets/{secret_name}"
        ],
        deleteEnvironmentVariable: [
            "DELETE /repos/{owner}/{repo}/environments/{environment_name}/variables/{name}"
        ],
        deleteHostedRunnerForOrg: [
            "DELETE /orgs/{org}/actions/hosted-runners/{hosted_runner_id}"
        ],
        deleteOrgSecret: [
            "DELETE /orgs/{org}/actions/secrets/{secret_name}"
        ],
        deleteOrgVariable: [
            "DELETE /orgs/{org}/actions/variables/{name}"
        ],
        deleteRepoSecret: [
            "DELETE /repos/{owner}/{repo}/actions/secrets/{secret_name}"
        ],
        deleteRepoVariable: [
            "DELETE /repos/{owner}/{repo}/actions/variables/{name}"
        ],
        deleteSelfHostedRunnerFromOrg: [
            "DELETE /orgs/{org}/actions/runners/{runner_id}"
        ],
        deleteSelfHostedRunnerFromRepo: [
            "DELETE /repos/{owner}/{repo}/actions/runners/{runner_id}"
        ],
        deleteWorkflowRun: [
            "DELETE /repos/{owner}/{repo}/actions/runs/{run_id}"
        ],
        deleteWorkflowRunLogs: [
            "DELETE /repos/{owner}/{repo}/actions/runs/{run_id}/logs"
        ],
        disableSelectedRepositoryGithubActionsOrganization: [
            "DELETE /orgs/{org}/actions/permissions/repositories/{repository_id}"
        ],
        disableWorkflow: [
            "PUT /repos/{owner}/{repo}/actions/workflows/{workflow_id}/disable"
        ],
        downloadArtifact: [
            "GET /repos/{owner}/{repo}/actions/artifacts/{artifact_id}/{archive_format}"
        ],
        downloadJobLogsForWorkflowRun: [
            "GET /repos/{owner}/{repo}/actions/jobs/{job_id}/logs"
        ],
        downloadWorkflowRunAttemptLogs: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/attempts/{attempt_number}/logs"
        ],
        downloadWorkflowRunLogs: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/logs"
        ],
        enableSelectedRepositoryGithubActionsOrganization: [
            "PUT /orgs/{org}/actions/permissions/repositories/{repository_id}"
        ],
        enableWorkflow: [
            "PUT /repos/{owner}/{repo}/actions/workflows/{workflow_id}/enable"
        ],
        forceCancelWorkflowRun: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/force-cancel"
        ],
        generateRunnerJitconfigForOrg: [
            "POST /orgs/{org}/actions/runners/generate-jitconfig"
        ],
        generateRunnerJitconfigForRepo: [
            "POST /repos/{owner}/{repo}/actions/runners/generate-jitconfig"
        ],
        getActionsCacheList: [
            "GET /repos/{owner}/{repo}/actions/caches"
        ],
        getActionsCacheUsage: [
            "GET /repos/{owner}/{repo}/actions/cache/usage"
        ],
        getActionsCacheUsageByRepoForOrg: [
            "GET /orgs/{org}/actions/cache/usage-by-repository"
        ],
        getActionsCacheUsageForOrg: [
            "GET /orgs/{org}/actions/cache/usage"
        ],
        getAllowedActionsOrganization: [
            "GET /orgs/{org}/actions/permissions/selected-actions"
        ],
        getAllowedActionsRepository: [
            "GET /repos/{owner}/{repo}/actions/permissions/selected-actions"
        ],
        getArtifact: [
            "GET /repos/{owner}/{repo}/actions/artifacts/{artifact_id}"
        ],
        getCustomImageForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/images/custom/{image_definition_id}"
        ],
        getCustomImageVersionForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/images/custom/{image_definition_id}/versions/{version}"
        ],
        getCustomOidcSubClaimForRepo: [
            "GET /repos/{owner}/{repo}/actions/oidc/customization/sub"
        ],
        getEnvironmentPublicKey: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/secrets/public-key"
        ],
        getEnvironmentSecret: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/secrets/{secret_name}"
        ],
        getEnvironmentVariable: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/variables/{name}"
        ],
        getGithubActionsDefaultWorkflowPermissionsOrganization: [
            "GET /orgs/{org}/actions/permissions/workflow"
        ],
        getGithubActionsDefaultWorkflowPermissionsRepository: [
            "GET /repos/{owner}/{repo}/actions/permissions/workflow"
        ],
        getGithubActionsPermissionsOrganization: [
            "GET /orgs/{org}/actions/permissions"
        ],
        getGithubActionsPermissionsRepository: [
            "GET /repos/{owner}/{repo}/actions/permissions"
        ],
        getHostedRunnerForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/{hosted_runner_id}"
        ],
        getHostedRunnersGithubOwnedImagesForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/images/github-owned"
        ],
        getHostedRunnersLimitsForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/limits"
        ],
        getHostedRunnersMachineSpecsForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/machine-sizes"
        ],
        getHostedRunnersPartnerImagesForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/images/partner"
        ],
        getHostedRunnersPlatformsForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/platforms"
        ],
        getJobForWorkflowRun: [
            "GET /repos/{owner}/{repo}/actions/jobs/{job_id}"
        ],
        getOrgPublicKey: [
            "GET /orgs/{org}/actions/secrets/public-key"
        ],
        getOrgSecret: [
            "GET /orgs/{org}/actions/secrets/{secret_name}"
        ],
        getOrgVariable: [
            "GET /orgs/{org}/actions/variables/{name}"
        ],
        getPendingDeploymentsForRun: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/pending_deployments"
        ],
        getRepoPermissions: [
            "GET /repos/{owner}/{repo}/actions/permissions",
            {},
            {
                renamed: [
                    "actions",
                    "getGithubActionsPermissionsRepository"
                ]
            }
        ],
        getRepoPublicKey: [
            "GET /repos/{owner}/{repo}/actions/secrets/public-key"
        ],
        getRepoSecret: [
            "GET /repos/{owner}/{repo}/actions/secrets/{secret_name}"
        ],
        getRepoVariable: [
            "GET /repos/{owner}/{repo}/actions/variables/{name}"
        ],
        getReviewsForRun: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/approvals"
        ],
        getSelfHostedRunnerForOrg: [
            "GET /orgs/{org}/actions/runners/{runner_id}"
        ],
        getSelfHostedRunnerForRepo: [
            "GET /repos/{owner}/{repo}/actions/runners/{runner_id}"
        ],
        getWorkflow: [
            "GET /repos/{owner}/{repo}/actions/workflows/{workflow_id}"
        ],
        getWorkflowAccessToRepository: [
            "GET /repos/{owner}/{repo}/actions/permissions/access"
        ],
        getWorkflowRun: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}"
        ],
        getWorkflowRunAttempt: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/attempts/{attempt_number}"
        ],
        getWorkflowRunUsage: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/timing"
        ],
        getWorkflowUsage: [
            "GET /repos/{owner}/{repo}/actions/workflows/{workflow_id}/timing"
        ],
        listArtifactsForRepo: [
            "GET /repos/{owner}/{repo}/actions/artifacts"
        ],
        listCustomImageVersionsForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/images/custom/{image_definition_id}/versions"
        ],
        listCustomImagesForOrg: [
            "GET /orgs/{org}/actions/hosted-runners/images/custom"
        ],
        listEnvironmentSecrets: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/secrets"
        ],
        listEnvironmentVariables: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/variables"
        ],
        listGithubHostedRunnersInGroupForOrg: [
            "GET /orgs/{org}/actions/runner-groups/{runner_group_id}/hosted-runners"
        ],
        listHostedRunnersForOrg: [
            "GET /orgs/{org}/actions/hosted-runners"
        ],
        listJobsForWorkflowRun: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/jobs"
        ],
        listJobsForWorkflowRunAttempt: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/attempts/{attempt_number}/jobs"
        ],
        listLabelsForSelfHostedRunnerForOrg: [
            "GET /orgs/{org}/actions/runners/{runner_id}/labels"
        ],
        listLabelsForSelfHostedRunnerForRepo: [
            "GET /repos/{owner}/{repo}/actions/runners/{runner_id}/labels"
        ],
        listOrgSecrets: [
            "GET /orgs/{org}/actions/secrets"
        ],
        listOrgVariables: [
            "GET /orgs/{org}/actions/variables"
        ],
        listRepoOrganizationSecrets: [
            "GET /repos/{owner}/{repo}/actions/organization-secrets"
        ],
        listRepoOrganizationVariables: [
            "GET /repos/{owner}/{repo}/actions/organization-variables"
        ],
        listRepoSecrets: [
            "GET /repos/{owner}/{repo}/actions/secrets"
        ],
        listRepoVariables: [
            "GET /repos/{owner}/{repo}/actions/variables"
        ],
        listRepoWorkflows: [
            "GET /repos/{owner}/{repo}/actions/workflows"
        ],
        listRunnerApplicationsForOrg: [
            "GET /orgs/{org}/actions/runners/downloads"
        ],
        listRunnerApplicationsForRepo: [
            "GET /repos/{owner}/{repo}/actions/runners/downloads"
        ],
        listSelectedReposForOrgSecret: [
            "GET /orgs/{org}/actions/secrets/{secret_name}/repositories"
        ],
        listSelectedReposForOrgVariable: [
            "GET /orgs/{org}/actions/variables/{name}/repositories"
        ],
        listSelectedRepositoriesEnabledGithubActionsOrganization: [
            "GET /orgs/{org}/actions/permissions/repositories"
        ],
        listSelfHostedRunnersForOrg: [
            "GET /orgs/{org}/actions/runners"
        ],
        listSelfHostedRunnersForRepo: [
            "GET /repos/{owner}/{repo}/actions/runners"
        ],
        listWorkflowRunArtifacts: [
            "GET /repos/{owner}/{repo}/actions/runs/{run_id}/artifacts"
        ],
        listWorkflowRuns: [
            "GET /repos/{owner}/{repo}/actions/workflows/{workflow_id}/runs"
        ],
        listWorkflowRunsForRepo: [
            "GET /repos/{owner}/{repo}/actions/runs"
        ],
        reRunJobForWorkflowRun: [
            "POST /repos/{owner}/{repo}/actions/jobs/{job_id}/rerun"
        ],
        reRunWorkflow: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/rerun"
        ],
        reRunWorkflowFailedJobs: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/rerun-failed-jobs"
        ],
        removeAllCustomLabelsFromSelfHostedRunnerForOrg: [
            "DELETE /orgs/{org}/actions/runners/{runner_id}/labels"
        ],
        removeAllCustomLabelsFromSelfHostedRunnerForRepo: [
            "DELETE /repos/{owner}/{repo}/actions/runners/{runner_id}/labels"
        ],
        removeCustomLabelFromSelfHostedRunnerForOrg: [
            "DELETE /orgs/{org}/actions/runners/{runner_id}/labels/{name}"
        ],
        removeCustomLabelFromSelfHostedRunnerForRepo: [
            "DELETE /repos/{owner}/{repo}/actions/runners/{runner_id}/labels/{name}"
        ],
        removeSelectedRepoFromOrgSecret: [
            "DELETE /orgs/{org}/actions/secrets/{secret_name}/repositories/{repository_id}"
        ],
        removeSelectedRepoFromOrgVariable: [
            "DELETE /orgs/{org}/actions/variables/{name}/repositories/{repository_id}"
        ],
        reviewCustomGatesForRun: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/deployment_protection_rule"
        ],
        reviewPendingDeploymentsForRun: [
            "POST /repos/{owner}/{repo}/actions/runs/{run_id}/pending_deployments"
        ],
        setAllowedActionsOrganization: [
            "PUT /orgs/{org}/actions/permissions/selected-actions"
        ],
        setAllowedActionsRepository: [
            "PUT /repos/{owner}/{repo}/actions/permissions/selected-actions"
        ],
        setCustomLabelsForSelfHostedRunnerForOrg: [
            "PUT /orgs/{org}/actions/runners/{runner_id}/labels"
        ],
        setCustomLabelsForSelfHostedRunnerForRepo: [
            "PUT /repos/{owner}/{repo}/actions/runners/{runner_id}/labels"
        ],
        setCustomOidcSubClaimForRepo: [
            "PUT /repos/{owner}/{repo}/actions/oidc/customization/sub"
        ],
        setGithubActionsDefaultWorkflowPermissionsOrganization: [
            "PUT /orgs/{org}/actions/permissions/workflow"
        ],
        setGithubActionsDefaultWorkflowPermissionsRepository: [
            "PUT /repos/{owner}/{repo}/actions/permissions/workflow"
        ],
        setGithubActionsPermissionsOrganization: [
            "PUT /orgs/{org}/actions/permissions"
        ],
        setGithubActionsPermissionsRepository: [
            "PUT /repos/{owner}/{repo}/actions/permissions"
        ],
        setSelectedReposForOrgSecret: [
            "PUT /orgs/{org}/actions/secrets/{secret_name}/repositories"
        ],
        setSelectedReposForOrgVariable: [
            "PUT /orgs/{org}/actions/variables/{name}/repositories"
        ],
        setSelectedRepositoriesEnabledGithubActionsOrganization: [
            "PUT /orgs/{org}/actions/permissions/repositories"
        ],
        setWorkflowAccessToRepository: [
            "PUT /repos/{owner}/{repo}/actions/permissions/access"
        ],
        updateEnvironmentVariable: [
            "PATCH /repos/{owner}/{repo}/environments/{environment_name}/variables/{name}"
        ],
        updateHostedRunnerForOrg: [
            "PATCH /orgs/{org}/actions/hosted-runners/{hosted_runner_id}"
        ],
        updateOrgVariable: [
            "PATCH /orgs/{org}/actions/variables/{name}"
        ],
        updateRepoVariable: [
            "PATCH /repos/{owner}/{repo}/actions/variables/{name}"
        ]
    },
    activity: {
        checkRepoIsStarredByAuthenticatedUser: [
            "GET /user/starred/{owner}/{repo}"
        ],
        deleteRepoSubscription: [
            "DELETE /repos/{owner}/{repo}/subscription"
        ],
        deleteThreadSubscription: [
            "DELETE /notifications/threads/{thread_id}/subscription"
        ],
        getFeeds: [
            "GET /feeds"
        ],
        getRepoSubscription: [
            "GET /repos/{owner}/{repo}/subscription"
        ],
        getThread: [
            "GET /notifications/threads/{thread_id}"
        ],
        getThreadSubscriptionForAuthenticatedUser: [
            "GET /notifications/threads/{thread_id}/subscription"
        ],
        listEventsForAuthenticatedUser: [
            "GET /users/{username}/events"
        ],
        listNotificationsForAuthenticatedUser: [
            "GET /notifications"
        ],
        listOrgEventsForAuthenticatedUser: [
            "GET /users/{username}/events/orgs/{org}"
        ],
        listPublicEvents: [
            "GET /events"
        ],
        listPublicEventsForRepoNetwork: [
            "GET /networks/{owner}/{repo}/events"
        ],
        listPublicEventsForUser: [
            "GET /users/{username}/events/public"
        ],
        listPublicOrgEvents: [
            "GET /orgs/{org}/events"
        ],
        listReceivedEventsForUser: [
            "GET /users/{username}/received_events"
        ],
        listReceivedPublicEventsForUser: [
            "GET /users/{username}/received_events/public"
        ],
        listRepoEvents: [
            "GET /repos/{owner}/{repo}/events"
        ],
        listRepoNotificationsForAuthenticatedUser: [
            "GET /repos/{owner}/{repo}/notifications"
        ],
        listReposStarredByAuthenticatedUser: [
            "GET /user/starred"
        ],
        listReposStarredByUser: [
            "GET /users/{username}/starred"
        ],
        listReposWatchedByUser: [
            "GET /users/{username}/subscriptions"
        ],
        listStargazersForRepo: [
            "GET /repos/{owner}/{repo}/stargazers"
        ],
        listWatchedReposForAuthenticatedUser: [
            "GET /user/subscriptions"
        ],
        listWatchersForRepo: [
            "GET /repos/{owner}/{repo}/subscribers"
        ],
        markNotificationsAsRead: [
            "PUT /notifications"
        ],
        markRepoNotificationsAsRead: [
            "PUT /repos/{owner}/{repo}/notifications"
        ],
        markThreadAsDone: [
            "DELETE /notifications/threads/{thread_id}"
        ],
        markThreadAsRead: [
            "PATCH /notifications/threads/{thread_id}"
        ],
        setRepoSubscription: [
            "PUT /repos/{owner}/{repo}/subscription"
        ],
        setThreadSubscription: [
            "PUT /notifications/threads/{thread_id}/subscription"
        ],
        starRepoForAuthenticatedUser: [
            "PUT /user/starred/{owner}/{repo}"
        ],
        unstarRepoForAuthenticatedUser: [
            "DELETE /user/starred/{owner}/{repo}"
        ]
    },
    apps: {
        addRepoToInstallation: [
            "PUT /user/installations/{installation_id}/repositories/{repository_id}",
            {},
            {
                renamed: [
                    "apps",
                    "addRepoToInstallationForAuthenticatedUser"
                ]
            }
        ],
        addRepoToInstallationForAuthenticatedUser: [
            "PUT /user/installations/{installation_id}/repositories/{repository_id}"
        ],
        checkToken: [
            "POST /applications/{client_id}/token"
        ],
        createFromManifest: [
            "POST /app-manifests/{code}/conversions"
        ],
        createInstallationAccessToken: [
            "POST /app/installations/{installation_id}/access_tokens"
        ],
        deleteAuthorization: [
            "DELETE /applications/{client_id}/grant"
        ],
        deleteInstallation: [
            "DELETE /app/installations/{installation_id}"
        ],
        deleteToken: [
            "DELETE /applications/{client_id}/token"
        ],
        getAuthenticated: [
            "GET /app"
        ],
        getBySlug: [
            "GET /apps/{app_slug}"
        ],
        getInstallation: [
            "GET /app/installations/{installation_id}"
        ],
        getOrgInstallation: [
            "GET /orgs/{org}/installation"
        ],
        getRepoInstallation: [
            "GET /repos/{owner}/{repo}/installation"
        ],
        getSubscriptionPlanForAccount: [
            "GET /marketplace_listing/accounts/{account_id}"
        ],
        getSubscriptionPlanForAccountStubbed: [
            "GET /marketplace_listing/stubbed/accounts/{account_id}"
        ],
        getUserInstallation: [
            "GET /users/{username}/installation"
        ],
        getWebhookConfigForApp: [
            "GET /app/hook/config"
        ],
        getWebhookDelivery: [
            "GET /app/hook/deliveries/{delivery_id}"
        ],
        listAccountsForPlan: [
            "GET /marketplace_listing/plans/{plan_id}/accounts"
        ],
        listAccountsForPlanStubbed: [
            "GET /marketplace_listing/stubbed/plans/{plan_id}/accounts"
        ],
        listInstallationReposForAuthenticatedUser: [
            "GET /user/installations/{installation_id}/repositories"
        ],
        listInstallationRequestsForAuthenticatedApp: [
            "GET /app/installation-requests"
        ],
        listInstallations: [
            "GET /app/installations"
        ],
        listInstallationsForAuthenticatedUser: [
            "GET /user/installations"
        ],
        listPlans: [
            "GET /marketplace_listing/plans"
        ],
        listPlansStubbed: [
            "GET /marketplace_listing/stubbed/plans"
        ],
        listReposAccessibleToInstallation: [
            "GET /installation/repositories"
        ],
        listSubscriptionsForAuthenticatedUser: [
            "GET /user/marketplace_purchases"
        ],
        listSubscriptionsForAuthenticatedUserStubbed: [
            "GET /user/marketplace_purchases/stubbed"
        ],
        listWebhookDeliveries: [
            "GET /app/hook/deliveries"
        ],
        redeliverWebhookDelivery: [
            "POST /app/hook/deliveries/{delivery_id}/attempts"
        ],
        removeRepoFromInstallation: [
            "DELETE /user/installations/{installation_id}/repositories/{repository_id}",
            {},
            {
                renamed: [
                    "apps",
                    "removeRepoFromInstallationForAuthenticatedUser"
                ]
            }
        ],
        removeRepoFromInstallationForAuthenticatedUser: [
            "DELETE /user/installations/{installation_id}/repositories/{repository_id}"
        ],
        resetToken: [
            "PATCH /applications/{client_id}/token"
        ],
        revokeInstallationAccessToken: [
            "DELETE /installation/token"
        ],
        scopeToken: [
            "POST /applications/{client_id}/token/scoped"
        ],
        suspendInstallation: [
            "PUT /app/installations/{installation_id}/suspended"
        ],
        unsuspendInstallation: [
            "DELETE /app/installations/{installation_id}/suspended"
        ],
        updateWebhookConfigForApp: [
            "PATCH /app/hook/config"
        ]
    },
    billing: {
        getGithubActionsBillingOrg: [
            "GET /orgs/{org}/settings/billing/actions"
        ],
        getGithubActionsBillingUser: [
            "GET /users/{username}/settings/billing/actions"
        ],
        getGithubBillingPremiumRequestUsageReportOrg: [
            "GET /organizations/{org}/settings/billing/premium_request/usage"
        ],
        getGithubBillingPremiumRequestUsageReportUser: [
            "GET /users/{username}/settings/billing/premium_request/usage"
        ],
        getGithubBillingUsageReportOrg: [
            "GET /organizations/{org}/settings/billing/usage"
        ],
        getGithubBillingUsageReportUser: [
            "GET /users/{username}/settings/billing/usage"
        ],
        getGithubPackagesBillingOrg: [
            "GET /orgs/{org}/settings/billing/packages"
        ],
        getGithubPackagesBillingUser: [
            "GET /users/{username}/settings/billing/packages"
        ],
        getSharedStorageBillingOrg: [
            "GET /orgs/{org}/settings/billing/shared-storage"
        ],
        getSharedStorageBillingUser: [
            "GET /users/{username}/settings/billing/shared-storage"
        ]
    },
    campaigns: {
        createCampaign: [
            "POST /orgs/{org}/campaigns"
        ],
        deleteCampaign: [
            "DELETE /orgs/{org}/campaigns/{campaign_number}"
        ],
        getCampaignSummary: [
            "GET /orgs/{org}/campaigns/{campaign_number}"
        ],
        listOrgCampaigns: [
            "GET /orgs/{org}/campaigns"
        ],
        updateCampaign: [
            "PATCH /orgs/{org}/campaigns/{campaign_number}"
        ]
    },
    checks: {
        create: [
            "POST /repos/{owner}/{repo}/check-runs"
        ],
        createSuite: [
            "POST /repos/{owner}/{repo}/check-suites"
        ],
        get: [
            "GET /repos/{owner}/{repo}/check-runs/{check_run_id}"
        ],
        getSuite: [
            "GET /repos/{owner}/{repo}/check-suites/{check_suite_id}"
        ],
        listAnnotations: [
            "GET /repos/{owner}/{repo}/check-runs/{check_run_id}/annotations"
        ],
        listForRef: [
            "GET /repos/{owner}/{repo}/commits/{ref}/check-runs"
        ],
        listForSuite: [
            "GET /repos/{owner}/{repo}/check-suites/{check_suite_id}/check-runs"
        ],
        listSuitesForRef: [
            "GET /repos/{owner}/{repo}/commits/{ref}/check-suites"
        ],
        rerequestRun: [
            "POST /repos/{owner}/{repo}/check-runs/{check_run_id}/rerequest"
        ],
        rerequestSuite: [
            "POST /repos/{owner}/{repo}/check-suites/{check_suite_id}/rerequest"
        ],
        setSuitesPreferences: [
            "PATCH /repos/{owner}/{repo}/check-suites/preferences"
        ],
        update: [
            "PATCH /repos/{owner}/{repo}/check-runs/{check_run_id}"
        ]
    },
    codeScanning: {
        commitAutofix: [
            "POST /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}/autofix/commits"
        ],
        createAutofix: [
            "POST /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}/autofix"
        ],
        createVariantAnalysis: [
            "POST /repos/{owner}/{repo}/code-scanning/codeql/variant-analyses"
        ],
        deleteAnalysis: [
            "DELETE /repos/{owner}/{repo}/code-scanning/analyses/{analysis_id}{?confirm_delete}"
        ],
        deleteCodeqlDatabase: [
            "DELETE /repos/{owner}/{repo}/code-scanning/codeql/databases/{language}"
        ],
        getAlert: [
            "GET /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}",
            {},
            {
                renamedParameters: {
                    alert_id: "alert_number"
                }
            }
        ],
        getAnalysis: [
            "GET /repos/{owner}/{repo}/code-scanning/analyses/{analysis_id}"
        ],
        getAutofix: [
            "GET /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}/autofix"
        ],
        getCodeqlDatabase: [
            "GET /repos/{owner}/{repo}/code-scanning/codeql/databases/{language}"
        ],
        getDefaultSetup: [
            "GET /repos/{owner}/{repo}/code-scanning/default-setup"
        ],
        getSarif: [
            "GET /repos/{owner}/{repo}/code-scanning/sarifs/{sarif_id}"
        ],
        getVariantAnalysis: [
            "GET /repos/{owner}/{repo}/code-scanning/codeql/variant-analyses/{codeql_variant_analysis_id}"
        ],
        getVariantAnalysisRepoTask: [
            "GET /repos/{owner}/{repo}/code-scanning/codeql/variant-analyses/{codeql_variant_analysis_id}/repos/{repo_owner}/{repo_name}"
        ],
        listAlertInstances: [
            "GET /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}/instances"
        ],
        listAlertsForOrg: [
            "GET /orgs/{org}/code-scanning/alerts"
        ],
        listAlertsForRepo: [
            "GET /repos/{owner}/{repo}/code-scanning/alerts"
        ],
        listAlertsInstances: [
            "GET /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}/instances",
            {},
            {
                renamed: [
                    "codeScanning",
                    "listAlertInstances"
                ]
            }
        ],
        listCodeqlDatabases: [
            "GET /repos/{owner}/{repo}/code-scanning/codeql/databases"
        ],
        listRecentAnalyses: [
            "GET /repos/{owner}/{repo}/code-scanning/analyses"
        ],
        updateAlert: [
            "PATCH /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}"
        ],
        updateDefaultSetup: [
            "PATCH /repos/{owner}/{repo}/code-scanning/default-setup"
        ],
        uploadSarif: [
            "POST /repos/{owner}/{repo}/code-scanning/sarifs"
        ]
    },
    codeSecurity: {
        attachConfiguration: [
            "POST /orgs/{org}/code-security/configurations/{configuration_id}/attach"
        ],
        attachEnterpriseConfiguration: [
            "POST /enterprises/{enterprise}/code-security/configurations/{configuration_id}/attach"
        ],
        createConfiguration: [
            "POST /orgs/{org}/code-security/configurations"
        ],
        createConfigurationForEnterprise: [
            "POST /enterprises/{enterprise}/code-security/configurations"
        ],
        deleteConfiguration: [
            "DELETE /orgs/{org}/code-security/configurations/{configuration_id}"
        ],
        deleteConfigurationForEnterprise: [
            "DELETE /enterprises/{enterprise}/code-security/configurations/{configuration_id}"
        ],
        detachConfiguration: [
            "DELETE /orgs/{org}/code-security/configurations/detach"
        ],
        getConfiguration: [
            "GET /orgs/{org}/code-security/configurations/{configuration_id}"
        ],
        getConfigurationForRepository: [
            "GET /repos/{owner}/{repo}/code-security-configuration"
        ],
        getConfigurationsForEnterprise: [
            "GET /enterprises/{enterprise}/code-security/configurations"
        ],
        getConfigurationsForOrg: [
            "GET /orgs/{org}/code-security/configurations"
        ],
        getDefaultConfigurations: [
            "GET /orgs/{org}/code-security/configurations/defaults"
        ],
        getDefaultConfigurationsForEnterprise: [
            "GET /enterprises/{enterprise}/code-security/configurations/defaults"
        ],
        getRepositoriesForConfiguration: [
            "GET /orgs/{org}/code-security/configurations/{configuration_id}/repositories"
        ],
        getRepositoriesForEnterpriseConfiguration: [
            "GET /enterprises/{enterprise}/code-security/configurations/{configuration_id}/repositories"
        ],
        getSingleConfigurationForEnterprise: [
            "GET /enterprises/{enterprise}/code-security/configurations/{configuration_id}"
        ],
        setConfigurationAsDefault: [
            "PUT /orgs/{org}/code-security/configurations/{configuration_id}/defaults"
        ],
        setConfigurationAsDefaultForEnterprise: [
            "PUT /enterprises/{enterprise}/code-security/configurations/{configuration_id}/defaults"
        ],
        updateConfiguration: [
            "PATCH /orgs/{org}/code-security/configurations/{configuration_id}"
        ],
        updateEnterpriseConfiguration: [
            "PATCH /enterprises/{enterprise}/code-security/configurations/{configuration_id}"
        ]
    },
    codesOfConduct: {
        getAllCodesOfConduct: [
            "GET /codes_of_conduct"
        ],
        getConductCode: [
            "GET /codes_of_conduct/{key}"
        ]
    },
    codespaces: {
        addRepositoryForSecretForAuthenticatedUser: [
            "PUT /user/codespaces/secrets/{secret_name}/repositories/{repository_id}"
        ],
        addSelectedRepoToOrgSecret: [
            "PUT /orgs/{org}/codespaces/secrets/{secret_name}/repositories/{repository_id}"
        ],
        checkPermissionsForDevcontainer: [
            "GET /repos/{owner}/{repo}/codespaces/permissions_check"
        ],
        codespaceMachinesForAuthenticatedUser: [
            "GET /user/codespaces/{codespace_name}/machines"
        ],
        createForAuthenticatedUser: [
            "POST /user/codespaces"
        ],
        createOrUpdateOrgSecret: [
            "PUT /orgs/{org}/codespaces/secrets/{secret_name}"
        ],
        createOrUpdateRepoSecret: [
            "PUT /repos/{owner}/{repo}/codespaces/secrets/{secret_name}"
        ],
        createOrUpdateSecretForAuthenticatedUser: [
            "PUT /user/codespaces/secrets/{secret_name}"
        ],
        createWithPrForAuthenticatedUser: [
            "POST /repos/{owner}/{repo}/pulls/{pull_number}/codespaces"
        ],
        createWithRepoForAuthenticatedUser: [
            "POST /repos/{owner}/{repo}/codespaces"
        ],
        deleteForAuthenticatedUser: [
            "DELETE /user/codespaces/{codespace_name}"
        ],
        deleteFromOrganization: [
            "DELETE /orgs/{org}/members/{username}/codespaces/{codespace_name}"
        ],
        deleteOrgSecret: [
            "DELETE /orgs/{org}/codespaces/secrets/{secret_name}"
        ],
        deleteRepoSecret: [
            "DELETE /repos/{owner}/{repo}/codespaces/secrets/{secret_name}"
        ],
        deleteSecretForAuthenticatedUser: [
            "DELETE /user/codespaces/secrets/{secret_name}"
        ],
        exportForAuthenticatedUser: [
            "POST /user/codespaces/{codespace_name}/exports"
        ],
        getCodespacesForUserInOrg: [
            "GET /orgs/{org}/members/{username}/codespaces"
        ],
        getExportDetailsForAuthenticatedUser: [
            "GET /user/codespaces/{codespace_name}/exports/{export_id}"
        ],
        getForAuthenticatedUser: [
            "GET /user/codespaces/{codespace_name}"
        ],
        getOrgPublicKey: [
            "GET /orgs/{org}/codespaces/secrets/public-key"
        ],
        getOrgSecret: [
            "GET /orgs/{org}/codespaces/secrets/{secret_name}"
        ],
        getPublicKeyForAuthenticatedUser: [
            "GET /user/codespaces/secrets/public-key"
        ],
        getRepoPublicKey: [
            "GET /repos/{owner}/{repo}/codespaces/secrets/public-key"
        ],
        getRepoSecret: [
            "GET /repos/{owner}/{repo}/codespaces/secrets/{secret_name}"
        ],
        getSecretForAuthenticatedUser: [
            "GET /user/codespaces/secrets/{secret_name}"
        ],
        listDevcontainersInRepositoryForAuthenticatedUser: [
            "GET /repos/{owner}/{repo}/codespaces/devcontainers"
        ],
        listForAuthenticatedUser: [
            "GET /user/codespaces"
        ],
        listInOrganization: [
            "GET /orgs/{org}/codespaces",
            {},
            {
                renamedParameters: {
                    org_id: "org"
                }
            }
        ],
        listInRepositoryForAuthenticatedUser: [
            "GET /repos/{owner}/{repo}/codespaces"
        ],
        listOrgSecrets: [
            "GET /orgs/{org}/codespaces/secrets"
        ],
        listRepoSecrets: [
            "GET /repos/{owner}/{repo}/codespaces/secrets"
        ],
        listRepositoriesForSecretForAuthenticatedUser: [
            "GET /user/codespaces/secrets/{secret_name}/repositories"
        ],
        listSecretsForAuthenticatedUser: [
            "GET /user/codespaces/secrets"
        ],
        listSelectedReposForOrgSecret: [
            "GET /orgs/{org}/codespaces/secrets/{secret_name}/repositories"
        ],
        preFlightWithRepoForAuthenticatedUser: [
            "GET /repos/{owner}/{repo}/codespaces/new"
        ],
        publishForAuthenticatedUser: [
            "POST /user/codespaces/{codespace_name}/publish"
        ],
        removeRepositoryForSecretForAuthenticatedUser: [
            "DELETE /user/codespaces/secrets/{secret_name}/repositories/{repository_id}"
        ],
        removeSelectedRepoFromOrgSecret: [
            "DELETE /orgs/{org}/codespaces/secrets/{secret_name}/repositories/{repository_id}"
        ],
        repoMachinesForAuthenticatedUser: [
            "GET /repos/{owner}/{repo}/codespaces/machines"
        ],
        setRepositoriesForSecretForAuthenticatedUser: [
            "PUT /user/codespaces/secrets/{secret_name}/repositories"
        ],
        setSelectedReposForOrgSecret: [
            "PUT /orgs/{org}/codespaces/secrets/{secret_name}/repositories"
        ],
        startForAuthenticatedUser: [
            "POST /user/codespaces/{codespace_name}/start"
        ],
        stopForAuthenticatedUser: [
            "POST /user/codespaces/{codespace_name}/stop"
        ],
        stopInOrganization: [
            "POST /orgs/{org}/members/{username}/codespaces/{codespace_name}/stop"
        ],
        updateForAuthenticatedUser: [
            "PATCH /user/codespaces/{codespace_name}"
        ]
    },
    copilot: {
        addCopilotSeatsForTeams: [
            "POST /orgs/{org}/copilot/billing/selected_teams"
        ],
        addCopilotSeatsForUsers: [
            "POST /orgs/{org}/copilot/billing/selected_users"
        ],
        cancelCopilotSeatAssignmentForTeams: [
            "DELETE /orgs/{org}/copilot/billing/selected_teams"
        ],
        cancelCopilotSeatAssignmentForUsers: [
            "DELETE /orgs/{org}/copilot/billing/selected_users"
        ],
        copilotMetricsForOrganization: [
            "GET /orgs/{org}/copilot/metrics"
        ],
        copilotMetricsForTeam: [
            "GET /orgs/{org}/team/{team_slug}/copilot/metrics"
        ],
        getCopilotOrganizationDetails: [
            "GET /orgs/{org}/copilot/billing"
        ],
        getCopilotSeatDetailsForUser: [
            "GET /orgs/{org}/members/{username}/copilot"
        ],
        listCopilotSeats: [
            "GET /orgs/{org}/copilot/billing/seats"
        ]
    },
    credentials: {
        revoke: [
            "POST /credentials/revoke"
        ]
    },
    dependabot: {
        addSelectedRepoToOrgSecret: [
            "PUT /orgs/{org}/dependabot/secrets/{secret_name}/repositories/{repository_id}"
        ],
        createOrUpdateOrgSecret: [
            "PUT /orgs/{org}/dependabot/secrets/{secret_name}"
        ],
        createOrUpdateRepoSecret: [
            "PUT /repos/{owner}/{repo}/dependabot/secrets/{secret_name}"
        ],
        deleteOrgSecret: [
            "DELETE /orgs/{org}/dependabot/secrets/{secret_name}"
        ],
        deleteRepoSecret: [
            "DELETE /repos/{owner}/{repo}/dependabot/secrets/{secret_name}"
        ],
        getAlert: [
            "GET /repos/{owner}/{repo}/dependabot/alerts/{alert_number}"
        ],
        getOrgPublicKey: [
            "GET /orgs/{org}/dependabot/secrets/public-key"
        ],
        getOrgSecret: [
            "GET /orgs/{org}/dependabot/secrets/{secret_name}"
        ],
        getRepoPublicKey: [
            "GET /repos/{owner}/{repo}/dependabot/secrets/public-key"
        ],
        getRepoSecret: [
            "GET /repos/{owner}/{repo}/dependabot/secrets/{secret_name}"
        ],
        listAlertsForEnterprise: [
            "GET /enterprises/{enterprise}/dependabot/alerts"
        ],
        listAlertsForOrg: [
            "GET /orgs/{org}/dependabot/alerts"
        ],
        listAlertsForRepo: [
            "GET /repos/{owner}/{repo}/dependabot/alerts"
        ],
        listOrgSecrets: [
            "GET /orgs/{org}/dependabot/secrets"
        ],
        listRepoSecrets: [
            "GET /repos/{owner}/{repo}/dependabot/secrets"
        ],
        listSelectedReposForOrgSecret: [
            "GET /orgs/{org}/dependabot/secrets/{secret_name}/repositories"
        ],
        removeSelectedRepoFromOrgSecret: [
            "DELETE /orgs/{org}/dependabot/secrets/{secret_name}/repositories/{repository_id}"
        ],
        repositoryAccessForOrg: [
            "GET /organizations/{org}/dependabot/repository-access"
        ],
        setRepositoryAccessDefaultLevel: [
            "PUT /organizations/{org}/dependabot/repository-access/default-level"
        ],
        setSelectedReposForOrgSecret: [
            "PUT /orgs/{org}/dependabot/secrets/{secret_name}/repositories"
        ],
        updateAlert: [
            "PATCH /repos/{owner}/{repo}/dependabot/alerts/{alert_number}"
        ],
        updateRepositoryAccessForOrg: [
            "PATCH /organizations/{org}/dependabot/repository-access"
        ]
    },
    dependencyGraph: {
        createRepositorySnapshot: [
            "POST /repos/{owner}/{repo}/dependency-graph/snapshots"
        ],
        diffRange: [
            "GET /repos/{owner}/{repo}/dependency-graph/compare/{basehead}"
        ],
        exportSbom: [
            "GET /repos/{owner}/{repo}/dependency-graph/sbom"
        ]
    },
    emojis: {
        get: [
            "GET /emojis"
        ]
    },
    enterpriseTeamMemberships: {
        add: [
            "PUT /enterprises/{enterprise}/teams/{enterprise-team}/memberships/{username}"
        ],
        bulkAdd: [
            "POST /enterprises/{enterprise}/teams/{enterprise-team}/memberships/add"
        ],
        bulkRemove: [
            "POST /enterprises/{enterprise}/teams/{enterprise-team}/memberships/remove"
        ],
        get: [
            "GET /enterprises/{enterprise}/teams/{enterprise-team}/memberships/{username}"
        ],
        list: [
            "GET /enterprises/{enterprise}/teams/{enterprise-team}/memberships"
        ],
        remove: [
            "DELETE /enterprises/{enterprise}/teams/{enterprise-team}/memberships/{username}"
        ]
    },
    enterpriseTeamOrganizations: {
        add: [
            "PUT /enterprises/{enterprise}/teams/{enterprise-team}/organizations/{org}"
        ],
        bulkAdd: [
            "POST /enterprises/{enterprise}/teams/{enterprise-team}/organizations/add"
        ],
        bulkRemove: [
            "POST /enterprises/{enterprise}/teams/{enterprise-team}/organizations/remove"
        ],
        delete: [
            "DELETE /enterprises/{enterprise}/teams/{enterprise-team}/organizations/{org}"
        ],
        getAssignment: [
            "GET /enterprises/{enterprise}/teams/{enterprise-team}/organizations/{org}"
        ],
        getAssignments: [
            "GET /enterprises/{enterprise}/teams/{enterprise-team}/organizations"
        ]
    },
    enterpriseTeams: {
        create: [
            "POST /enterprises/{enterprise}/teams"
        ],
        delete: [
            "DELETE /enterprises/{enterprise}/teams/{team_slug}"
        ],
        get: [
            "GET /enterprises/{enterprise}/teams/{team_slug}"
        ],
        list: [
            "GET /enterprises/{enterprise}/teams"
        ],
        update: [
            "PATCH /enterprises/{enterprise}/teams/{team_slug}"
        ]
    },
    gists: {
        checkIsStarred: [
            "GET /gists/{gist_id}/star"
        ],
        create: [
            "POST /gists"
        ],
        createComment: [
            "POST /gists/{gist_id}/comments"
        ],
        delete: [
            "DELETE /gists/{gist_id}"
        ],
        deleteComment: [
            "DELETE /gists/{gist_id}/comments/{comment_id}"
        ],
        fork: [
            "POST /gists/{gist_id}/forks"
        ],
        get: [
            "GET /gists/{gist_id}"
        ],
        getComment: [
            "GET /gists/{gist_id}/comments/{comment_id}"
        ],
        getRevision: [
            "GET /gists/{gist_id}/{sha}"
        ],
        list: [
            "GET /gists"
        ],
        listComments: [
            "GET /gists/{gist_id}/comments"
        ],
        listCommits: [
            "GET /gists/{gist_id}/commits"
        ],
        listForUser: [
            "GET /users/{username}/gists"
        ],
        listForks: [
            "GET /gists/{gist_id}/forks"
        ],
        listPublic: [
            "GET /gists/public"
        ],
        listStarred: [
            "GET /gists/starred"
        ],
        star: [
            "PUT /gists/{gist_id}/star"
        ],
        unstar: [
            "DELETE /gists/{gist_id}/star"
        ],
        update: [
            "PATCH /gists/{gist_id}"
        ],
        updateComment: [
            "PATCH /gists/{gist_id}/comments/{comment_id}"
        ]
    },
    git: {
        createBlob: [
            "POST /repos/{owner}/{repo}/git/blobs"
        ],
        createCommit: [
            "POST /repos/{owner}/{repo}/git/commits"
        ],
        createRef: [
            "POST /repos/{owner}/{repo}/git/refs"
        ],
        createTag: [
            "POST /repos/{owner}/{repo}/git/tags"
        ],
        createTree: [
            "POST /repos/{owner}/{repo}/git/trees"
        ],
        deleteRef: [
            "DELETE /repos/{owner}/{repo}/git/refs/{ref}"
        ],
        getBlob: [
            "GET /repos/{owner}/{repo}/git/blobs/{file_sha}"
        ],
        getCommit: [
            "GET /repos/{owner}/{repo}/git/commits/{commit_sha}"
        ],
        getRef: [
            "GET /repos/{owner}/{repo}/git/ref/{ref}"
        ],
        getTag: [
            "GET /repos/{owner}/{repo}/git/tags/{tag_sha}"
        ],
        getTree: [
            "GET /repos/{owner}/{repo}/git/trees/{tree_sha}"
        ],
        listMatchingRefs: [
            "GET /repos/{owner}/{repo}/git/matching-refs/{ref}"
        ],
        updateRef: [
            "PATCH /repos/{owner}/{repo}/git/refs/{ref}"
        ]
    },
    gitignore: {
        getAllTemplates: [
            "GET /gitignore/templates"
        ],
        getTemplate: [
            "GET /gitignore/templates/{name}"
        ]
    },
    hostedCompute: {
        createNetworkConfigurationForOrg: [
            "POST /orgs/{org}/settings/network-configurations"
        ],
        deleteNetworkConfigurationFromOrg: [
            "DELETE /orgs/{org}/settings/network-configurations/{network_configuration_id}"
        ],
        getNetworkConfigurationForOrg: [
            "GET /orgs/{org}/settings/network-configurations/{network_configuration_id}"
        ],
        getNetworkSettingsForOrg: [
            "GET /orgs/{org}/settings/network-settings/{network_settings_id}"
        ],
        listNetworkConfigurationsForOrg: [
            "GET /orgs/{org}/settings/network-configurations"
        ],
        updateNetworkConfigurationForOrg: [
            "PATCH /orgs/{org}/settings/network-configurations/{network_configuration_id}"
        ]
    },
    interactions: {
        getRestrictionsForAuthenticatedUser: [
            "GET /user/interaction-limits"
        ],
        getRestrictionsForOrg: [
            "GET /orgs/{org}/interaction-limits"
        ],
        getRestrictionsForRepo: [
            "GET /repos/{owner}/{repo}/interaction-limits"
        ],
        getRestrictionsForYourPublicRepos: [
            "GET /user/interaction-limits",
            {},
            {
                renamed: [
                    "interactions",
                    "getRestrictionsForAuthenticatedUser"
                ]
            }
        ],
        removeRestrictionsForAuthenticatedUser: [
            "DELETE /user/interaction-limits"
        ],
        removeRestrictionsForOrg: [
            "DELETE /orgs/{org}/interaction-limits"
        ],
        removeRestrictionsForRepo: [
            "DELETE /repos/{owner}/{repo}/interaction-limits"
        ],
        removeRestrictionsForYourPublicRepos: [
            "DELETE /user/interaction-limits",
            {},
            {
                renamed: [
                    "interactions",
                    "removeRestrictionsForAuthenticatedUser"
                ]
            }
        ],
        setRestrictionsForAuthenticatedUser: [
            "PUT /user/interaction-limits"
        ],
        setRestrictionsForOrg: [
            "PUT /orgs/{org}/interaction-limits"
        ],
        setRestrictionsForRepo: [
            "PUT /repos/{owner}/{repo}/interaction-limits"
        ],
        setRestrictionsForYourPublicRepos: [
            "PUT /user/interaction-limits",
            {},
            {
                renamed: [
                    "interactions",
                    "setRestrictionsForAuthenticatedUser"
                ]
            }
        ]
    },
    issues: {
        addAssignees: [
            "POST /repos/{owner}/{repo}/issues/{issue_number}/assignees"
        ],
        addBlockedByDependency: [
            "POST /repos/{owner}/{repo}/issues/{issue_number}/dependencies/blocked_by"
        ],
        addLabels: [
            "POST /repos/{owner}/{repo}/issues/{issue_number}/labels"
        ],
        addSubIssue: [
            "POST /repos/{owner}/{repo}/issues/{issue_number}/sub_issues"
        ],
        checkUserCanBeAssigned: [
            "GET /repos/{owner}/{repo}/assignees/{assignee}"
        ],
        checkUserCanBeAssignedToIssue: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/assignees/{assignee}"
        ],
        create: [
            "POST /repos/{owner}/{repo}/issues"
        ],
        createComment: [
            "POST /repos/{owner}/{repo}/issues/{issue_number}/comments"
        ],
        createLabel: [
            "POST /repos/{owner}/{repo}/labels"
        ],
        createMilestone: [
            "POST /repos/{owner}/{repo}/milestones"
        ],
        deleteComment: [
            "DELETE /repos/{owner}/{repo}/issues/comments/{comment_id}"
        ],
        deleteLabel: [
            "DELETE /repos/{owner}/{repo}/labels/{name}"
        ],
        deleteMilestone: [
            "DELETE /repos/{owner}/{repo}/milestones/{milestone_number}"
        ],
        get: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}"
        ],
        getComment: [
            "GET /repos/{owner}/{repo}/issues/comments/{comment_id}"
        ],
        getEvent: [
            "GET /repos/{owner}/{repo}/issues/events/{event_id}"
        ],
        getLabel: [
            "GET /repos/{owner}/{repo}/labels/{name}"
        ],
        getMilestone: [
            "GET /repos/{owner}/{repo}/milestones/{milestone_number}"
        ],
        getParent: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/parent"
        ],
        list: [
            "GET /issues"
        ],
        listAssignees: [
            "GET /repos/{owner}/{repo}/assignees"
        ],
        listComments: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/comments"
        ],
        listCommentsForRepo: [
            "GET /repos/{owner}/{repo}/issues/comments"
        ],
        listDependenciesBlockedBy: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/dependencies/blocked_by"
        ],
        listDependenciesBlocking: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/dependencies/blocking"
        ],
        listEvents: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/events"
        ],
        listEventsForRepo: [
            "GET /repos/{owner}/{repo}/issues/events"
        ],
        listEventsForTimeline: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/timeline"
        ],
        listForAuthenticatedUser: [
            "GET /user/issues"
        ],
        listForOrg: [
            "GET /orgs/{org}/issues"
        ],
        listForRepo: [
            "GET /repos/{owner}/{repo}/issues"
        ],
        listLabelsForMilestone: [
            "GET /repos/{owner}/{repo}/milestones/{milestone_number}/labels"
        ],
        listLabelsForRepo: [
            "GET /repos/{owner}/{repo}/labels"
        ],
        listLabelsOnIssue: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/labels"
        ],
        listMilestones: [
            "GET /repos/{owner}/{repo}/milestones"
        ],
        listSubIssues: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/sub_issues"
        ],
        lock: [
            "PUT /repos/{owner}/{repo}/issues/{issue_number}/lock"
        ],
        removeAllLabels: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/labels"
        ],
        removeAssignees: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/assignees"
        ],
        removeDependencyBlockedBy: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/dependencies/blocked_by/{issue_id}"
        ],
        removeLabel: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/labels/{name}"
        ],
        removeSubIssue: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/sub_issue"
        ],
        reprioritizeSubIssue: [
            "PATCH /repos/{owner}/{repo}/issues/{issue_number}/sub_issues/priority"
        ],
        setLabels: [
            "PUT /repos/{owner}/{repo}/issues/{issue_number}/labels"
        ],
        unlock: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/lock"
        ],
        update: [
            "PATCH /repos/{owner}/{repo}/issues/{issue_number}"
        ],
        updateComment: [
            "PATCH /repos/{owner}/{repo}/issues/comments/{comment_id}"
        ],
        updateLabel: [
            "PATCH /repos/{owner}/{repo}/labels/{name}"
        ],
        updateMilestone: [
            "PATCH /repos/{owner}/{repo}/milestones/{milestone_number}"
        ]
    },
    licenses: {
        get: [
            "GET /licenses/{license}"
        ],
        getAllCommonlyUsed: [
            "GET /licenses"
        ],
        getForRepo: [
            "GET /repos/{owner}/{repo}/license"
        ]
    },
    markdown: {
        render: [
            "POST /markdown"
        ],
        renderRaw: [
            "POST /markdown/raw",
            {
                headers: {
                    "content-type": "text/plain; charset=utf-8"
                }
            }
        ]
    },
    meta: {
        get: [
            "GET /meta"
        ],
        getAllVersions: [
            "GET /versions"
        ],
        getOctocat: [
            "GET /octocat"
        ],
        getZen: [
            "GET /zen"
        ],
        root: [
            "GET /"
        ]
    },
    migrations: {
        deleteArchiveForAuthenticatedUser: [
            "DELETE /user/migrations/{migration_id}/archive"
        ],
        deleteArchiveForOrg: [
            "DELETE /orgs/{org}/migrations/{migration_id}/archive"
        ],
        downloadArchiveForOrg: [
            "GET /orgs/{org}/migrations/{migration_id}/archive"
        ],
        getArchiveForAuthenticatedUser: [
            "GET /user/migrations/{migration_id}/archive"
        ],
        getStatusForAuthenticatedUser: [
            "GET /user/migrations/{migration_id}"
        ],
        getStatusForOrg: [
            "GET /orgs/{org}/migrations/{migration_id}"
        ],
        listForAuthenticatedUser: [
            "GET /user/migrations"
        ],
        listForOrg: [
            "GET /orgs/{org}/migrations"
        ],
        listReposForAuthenticatedUser: [
            "GET /user/migrations/{migration_id}/repositories"
        ],
        listReposForOrg: [
            "GET /orgs/{org}/migrations/{migration_id}/repositories"
        ],
        listReposForUser: [
            "GET /user/migrations/{migration_id}/repositories",
            {},
            {
                renamed: [
                    "migrations",
                    "listReposForAuthenticatedUser"
                ]
            }
        ],
        startForAuthenticatedUser: [
            "POST /user/migrations"
        ],
        startForOrg: [
            "POST /orgs/{org}/migrations"
        ],
        unlockRepoForAuthenticatedUser: [
            "DELETE /user/migrations/{migration_id}/repos/{repo_name}/lock"
        ],
        unlockRepoForOrg: [
            "DELETE /orgs/{org}/migrations/{migration_id}/repos/{repo_name}/lock"
        ]
    },
    oidc: {
        getOidcCustomSubTemplateForOrg: [
            "GET /orgs/{org}/actions/oidc/customization/sub"
        ],
        updateOidcCustomSubTemplateForOrg: [
            "PUT /orgs/{org}/actions/oidc/customization/sub"
        ]
    },
    orgs: {
        addSecurityManagerTeam: [
            "PUT /orgs/{org}/security-managers/teams/{team_slug}",
            {},
            {
                deprecated: "octokit.rest.orgs.addSecurityManagerTeam() is deprecated, see https://docs.github.com/rest/orgs/security-managers#add-a-security-manager-team"
            }
        ],
        assignTeamToOrgRole: [
            "PUT /orgs/{org}/organization-roles/teams/{team_slug}/{role_id}"
        ],
        assignUserToOrgRole: [
            "PUT /orgs/{org}/organization-roles/users/{username}/{role_id}"
        ],
        blockUser: [
            "PUT /orgs/{org}/blocks/{username}"
        ],
        cancelInvitation: [
            "DELETE /orgs/{org}/invitations/{invitation_id}"
        ],
        checkBlockedUser: [
            "GET /orgs/{org}/blocks/{username}"
        ],
        checkMembershipForUser: [
            "GET /orgs/{org}/members/{username}"
        ],
        checkPublicMembershipForUser: [
            "GET /orgs/{org}/public_members/{username}"
        ],
        convertMemberToOutsideCollaborator: [
            "PUT /orgs/{org}/outside_collaborators/{username}"
        ],
        createArtifactStorageRecord: [
            "POST /orgs/{org}/artifacts/metadata/storage-record"
        ],
        createInvitation: [
            "POST /orgs/{org}/invitations"
        ],
        createIssueType: [
            "POST /orgs/{org}/issue-types"
        ],
        createWebhook: [
            "POST /orgs/{org}/hooks"
        ],
        customPropertiesForOrgsCreateOrUpdateOrganizationValues: [
            "PATCH /organizations/{org}/org-properties/values"
        ],
        customPropertiesForOrgsGetOrganizationValues: [
            "GET /organizations/{org}/org-properties/values"
        ],
        customPropertiesForReposCreateOrUpdateOrganizationDefinition: [
            "PUT /orgs/{org}/properties/schema/{custom_property_name}"
        ],
        customPropertiesForReposCreateOrUpdateOrganizationDefinitions: [
            "PATCH /orgs/{org}/properties/schema"
        ],
        customPropertiesForReposCreateOrUpdateOrganizationValues: [
            "PATCH /orgs/{org}/properties/values"
        ],
        customPropertiesForReposDeleteOrganizationDefinition: [
            "DELETE /orgs/{org}/properties/schema/{custom_property_name}"
        ],
        customPropertiesForReposGetOrganizationDefinition: [
            "GET /orgs/{org}/properties/schema/{custom_property_name}"
        ],
        customPropertiesForReposGetOrganizationDefinitions: [
            "GET /orgs/{org}/properties/schema"
        ],
        customPropertiesForReposGetOrganizationValues: [
            "GET /orgs/{org}/properties/values"
        ],
        delete: [
            "DELETE /orgs/{org}"
        ],
        deleteAttestationsBulk: [
            "POST /orgs/{org}/attestations/delete-request"
        ],
        deleteAttestationsById: [
            "DELETE /orgs/{org}/attestations/{attestation_id}"
        ],
        deleteAttestationsBySubjectDigest: [
            "DELETE /orgs/{org}/attestations/digest/{subject_digest}"
        ],
        deleteIssueType: [
            "DELETE /orgs/{org}/issue-types/{issue_type_id}"
        ],
        deleteWebhook: [
            "DELETE /orgs/{org}/hooks/{hook_id}"
        ],
        disableSelectedRepositoryImmutableReleasesOrganization: [
            "DELETE /orgs/{org}/settings/immutable-releases/repositories/{repository_id}"
        ],
        enableSelectedRepositoryImmutableReleasesOrganization: [
            "PUT /orgs/{org}/settings/immutable-releases/repositories/{repository_id}"
        ],
        get: [
            "GET /orgs/{org}"
        ],
        getImmutableReleasesSettings: [
            "GET /orgs/{org}/settings/immutable-releases"
        ],
        getImmutableReleasesSettingsRepositories: [
            "GET /orgs/{org}/settings/immutable-releases/repositories"
        ],
        getMembershipForAuthenticatedUser: [
            "GET /user/memberships/orgs/{org}"
        ],
        getMembershipForUser: [
            "GET /orgs/{org}/memberships/{username}"
        ],
        getOrgRole: [
            "GET /orgs/{org}/organization-roles/{role_id}"
        ],
        getOrgRulesetHistory: [
            "GET /orgs/{org}/rulesets/{ruleset_id}/history"
        ],
        getOrgRulesetVersion: [
            "GET /orgs/{org}/rulesets/{ruleset_id}/history/{version_id}"
        ],
        getWebhook: [
            "GET /orgs/{org}/hooks/{hook_id}"
        ],
        getWebhookConfigForOrg: [
            "GET /orgs/{org}/hooks/{hook_id}/config"
        ],
        getWebhookDelivery: [
            "GET /orgs/{org}/hooks/{hook_id}/deliveries/{delivery_id}"
        ],
        list: [
            "GET /organizations"
        ],
        listAppInstallations: [
            "GET /orgs/{org}/installations"
        ],
        listArtifactStorageRecords: [
            "GET /orgs/{org}/artifacts/{subject_digest}/metadata/storage-records"
        ],
        listAttestationRepositories: [
            "GET /orgs/{org}/attestations/repositories"
        ],
        listAttestations: [
            "GET /orgs/{org}/attestations/{subject_digest}"
        ],
        listAttestationsBulk: [
            "POST /orgs/{org}/attestations/bulk-list{?per_page,before,after}"
        ],
        listBlockedUsers: [
            "GET /orgs/{org}/blocks"
        ],
        listFailedInvitations: [
            "GET /orgs/{org}/failed_invitations"
        ],
        listForAuthenticatedUser: [
            "GET /user/orgs"
        ],
        listForUser: [
            "GET /users/{username}/orgs"
        ],
        listInvitationTeams: [
            "GET /orgs/{org}/invitations/{invitation_id}/teams"
        ],
        listIssueTypes: [
            "GET /orgs/{org}/issue-types"
        ],
        listMembers: [
            "GET /orgs/{org}/members"
        ],
        listMembershipsForAuthenticatedUser: [
            "GET /user/memberships/orgs"
        ],
        listOrgRoleTeams: [
            "GET /orgs/{org}/organization-roles/{role_id}/teams"
        ],
        listOrgRoleUsers: [
            "GET /orgs/{org}/organization-roles/{role_id}/users"
        ],
        listOrgRoles: [
            "GET /orgs/{org}/organization-roles"
        ],
        listOrganizationFineGrainedPermissions: [
            "GET /orgs/{org}/organization-fine-grained-permissions"
        ],
        listOutsideCollaborators: [
            "GET /orgs/{org}/outside_collaborators"
        ],
        listPatGrantRepositories: [
            "GET /orgs/{org}/personal-access-tokens/{pat_id}/repositories"
        ],
        listPatGrantRequestRepositories: [
            "GET /orgs/{org}/personal-access-token-requests/{pat_request_id}/repositories"
        ],
        listPatGrantRequests: [
            "GET /orgs/{org}/personal-access-token-requests"
        ],
        listPatGrants: [
            "GET /orgs/{org}/personal-access-tokens"
        ],
        listPendingInvitations: [
            "GET /orgs/{org}/invitations"
        ],
        listPublicMembers: [
            "GET /orgs/{org}/public_members"
        ],
        listSecurityManagerTeams: [
            "GET /orgs/{org}/security-managers",
            {},
            {
                deprecated: "octokit.rest.orgs.listSecurityManagerTeams() is deprecated, see https://docs.github.com/rest/orgs/security-managers#list-security-manager-teams"
            }
        ],
        listWebhookDeliveries: [
            "GET /orgs/{org}/hooks/{hook_id}/deliveries"
        ],
        listWebhooks: [
            "GET /orgs/{org}/hooks"
        ],
        pingWebhook: [
            "POST /orgs/{org}/hooks/{hook_id}/pings"
        ],
        redeliverWebhookDelivery: [
            "POST /orgs/{org}/hooks/{hook_id}/deliveries/{delivery_id}/attempts"
        ],
        removeMember: [
            "DELETE /orgs/{org}/members/{username}"
        ],
        removeMembershipForUser: [
            "DELETE /orgs/{org}/memberships/{username}"
        ],
        removeOutsideCollaborator: [
            "DELETE /orgs/{org}/outside_collaborators/{username}"
        ],
        removePublicMembershipForAuthenticatedUser: [
            "DELETE /orgs/{org}/public_members/{username}"
        ],
        removeSecurityManagerTeam: [
            "DELETE /orgs/{org}/security-managers/teams/{team_slug}",
            {},
            {
                deprecated: "octokit.rest.orgs.removeSecurityManagerTeam() is deprecated, see https://docs.github.com/rest/orgs/security-managers#remove-a-security-manager-team"
            }
        ],
        reviewPatGrantRequest: [
            "POST /orgs/{org}/personal-access-token-requests/{pat_request_id}"
        ],
        reviewPatGrantRequestsInBulk: [
            "POST /orgs/{org}/personal-access-token-requests"
        ],
        revokeAllOrgRolesTeam: [
            "DELETE /orgs/{org}/organization-roles/teams/{team_slug}"
        ],
        revokeAllOrgRolesUser: [
            "DELETE /orgs/{org}/organization-roles/users/{username}"
        ],
        revokeOrgRoleTeam: [
            "DELETE /orgs/{org}/organization-roles/teams/{team_slug}/{role_id}"
        ],
        revokeOrgRoleUser: [
            "DELETE /orgs/{org}/organization-roles/users/{username}/{role_id}"
        ],
        setImmutableReleasesSettings: [
            "PUT /orgs/{org}/settings/immutable-releases"
        ],
        setImmutableReleasesSettingsRepositories: [
            "PUT /orgs/{org}/settings/immutable-releases/repositories"
        ],
        setMembershipForUser: [
            "PUT /orgs/{org}/memberships/{username}"
        ],
        setPublicMembershipForAuthenticatedUser: [
            "PUT /orgs/{org}/public_members/{username}"
        ],
        unblockUser: [
            "DELETE /orgs/{org}/blocks/{username}"
        ],
        update: [
            "PATCH /orgs/{org}"
        ],
        updateIssueType: [
            "PUT /orgs/{org}/issue-types/{issue_type_id}"
        ],
        updateMembershipForAuthenticatedUser: [
            "PATCH /user/memberships/orgs/{org}"
        ],
        updatePatAccess: [
            "POST /orgs/{org}/personal-access-tokens/{pat_id}"
        ],
        updatePatAccesses: [
            "POST /orgs/{org}/personal-access-tokens"
        ],
        updateWebhook: [
            "PATCH /orgs/{org}/hooks/{hook_id}"
        ],
        updateWebhookConfigForOrg: [
            "PATCH /orgs/{org}/hooks/{hook_id}/config"
        ]
    },
    packages: {
        deletePackageForAuthenticatedUser: [
            "DELETE /user/packages/{package_type}/{package_name}"
        ],
        deletePackageForOrg: [
            "DELETE /orgs/{org}/packages/{package_type}/{package_name}"
        ],
        deletePackageForUser: [
            "DELETE /users/{username}/packages/{package_type}/{package_name}"
        ],
        deletePackageVersionForAuthenticatedUser: [
            "DELETE /user/packages/{package_type}/{package_name}/versions/{package_version_id}"
        ],
        deletePackageVersionForOrg: [
            "DELETE /orgs/{org}/packages/{package_type}/{package_name}/versions/{package_version_id}"
        ],
        deletePackageVersionForUser: [
            "DELETE /users/{username}/packages/{package_type}/{package_name}/versions/{package_version_id}"
        ],
        getAllPackageVersionsForAPackageOwnedByAnOrg: [
            "GET /orgs/{org}/packages/{package_type}/{package_name}/versions",
            {},
            {
                renamed: [
                    "packages",
                    "getAllPackageVersionsForPackageOwnedByOrg"
                ]
            }
        ],
        getAllPackageVersionsForAPackageOwnedByTheAuthenticatedUser: [
            "GET /user/packages/{package_type}/{package_name}/versions",
            {},
            {
                renamed: [
                    "packages",
                    "getAllPackageVersionsForPackageOwnedByAuthenticatedUser"
                ]
            }
        ],
        getAllPackageVersionsForPackageOwnedByAuthenticatedUser: [
            "GET /user/packages/{package_type}/{package_name}/versions"
        ],
        getAllPackageVersionsForPackageOwnedByOrg: [
            "GET /orgs/{org}/packages/{package_type}/{package_name}/versions"
        ],
        getAllPackageVersionsForPackageOwnedByUser: [
            "GET /users/{username}/packages/{package_type}/{package_name}/versions"
        ],
        getPackageForAuthenticatedUser: [
            "GET /user/packages/{package_type}/{package_name}"
        ],
        getPackageForOrganization: [
            "GET /orgs/{org}/packages/{package_type}/{package_name}"
        ],
        getPackageForUser: [
            "GET /users/{username}/packages/{package_type}/{package_name}"
        ],
        getPackageVersionForAuthenticatedUser: [
            "GET /user/packages/{package_type}/{package_name}/versions/{package_version_id}"
        ],
        getPackageVersionForOrganization: [
            "GET /orgs/{org}/packages/{package_type}/{package_name}/versions/{package_version_id}"
        ],
        getPackageVersionForUser: [
            "GET /users/{username}/packages/{package_type}/{package_name}/versions/{package_version_id}"
        ],
        listDockerMigrationConflictingPackagesForAuthenticatedUser: [
            "GET /user/docker/conflicts"
        ],
        listDockerMigrationConflictingPackagesForOrganization: [
            "GET /orgs/{org}/docker/conflicts"
        ],
        listDockerMigrationConflictingPackagesForUser: [
            "GET /users/{username}/docker/conflicts"
        ],
        listPackagesForAuthenticatedUser: [
            "GET /user/packages"
        ],
        listPackagesForOrganization: [
            "GET /orgs/{org}/packages"
        ],
        listPackagesForUser: [
            "GET /users/{username}/packages"
        ],
        restorePackageForAuthenticatedUser: [
            "POST /user/packages/{package_type}/{package_name}/restore{?token}"
        ],
        restorePackageForOrg: [
            "POST /orgs/{org}/packages/{package_type}/{package_name}/restore{?token}"
        ],
        restorePackageForUser: [
            "POST /users/{username}/packages/{package_type}/{package_name}/restore{?token}"
        ],
        restorePackageVersionForAuthenticatedUser: [
            "POST /user/packages/{package_type}/{package_name}/versions/{package_version_id}/restore"
        ],
        restorePackageVersionForOrg: [
            "POST /orgs/{org}/packages/{package_type}/{package_name}/versions/{package_version_id}/restore"
        ],
        restorePackageVersionForUser: [
            "POST /users/{username}/packages/{package_type}/{package_name}/versions/{package_version_id}/restore"
        ]
    },
    privateRegistries: {
        createOrgPrivateRegistry: [
            "POST /orgs/{org}/private-registries"
        ],
        deleteOrgPrivateRegistry: [
            "DELETE /orgs/{org}/private-registries/{secret_name}"
        ],
        getOrgPrivateRegistry: [
            "GET /orgs/{org}/private-registries/{secret_name}"
        ],
        getOrgPublicKey: [
            "GET /orgs/{org}/private-registries/public-key"
        ],
        listOrgPrivateRegistries: [
            "GET /orgs/{org}/private-registries"
        ],
        updateOrgPrivateRegistry: [
            "PATCH /orgs/{org}/private-registries/{secret_name}"
        ]
    },
    projects: {
        addItemForOrg: [
            "POST /orgs/{org}/projectsV2/{project_number}/items"
        ],
        addItemForUser: [
            "POST /users/{username}/projectsV2/{project_number}/items"
        ],
        deleteItemForOrg: [
            "DELETE /orgs/{org}/projectsV2/{project_number}/items/{item_id}"
        ],
        deleteItemForUser: [
            "DELETE /users/{username}/projectsV2/{project_number}/items/{item_id}"
        ],
        getFieldForOrg: [
            "GET /orgs/{org}/projectsV2/{project_number}/fields/{field_id}"
        ],
        getFieldForUser: [
            "GET /users/{username}/projectsV2/{project_number}/fields/{field_id}"
        ],
        getForOrg: [
            "GET /orgs/{org}/projectsV2/{project_number}"
        ],
        getForUser: [
            "GET /users/{username}/projectsV2/{project_number}"
        ],
        getOrgItem: [
            "GET /orgs/{org}/projectsV2/{project_number}/items/{item_id}"
        ],
        getUserItem: [
            "GET /users/{username}/projectsV2/{project_number}/items/{item_id}"
        ],
        listFieldsForOrg: [
            "GET /orgs/{org}/projectsV2/{project_number}/fields"
        ],
        listFieldsForUser: [
            "GET /users/{username}/projectsV2/{project_number}/fields"
        ],
        listForOrg: [
            "GET /orgs/{org}/projectsV2"
        ],
        listForUser: [
            "GET /users/{username}/projectsV2"
        ],
        listItemsForOrg: [
            "GET /orgs/{org}/projectsV2/{project_number}/items"
        ],
        listItemsForUser: [
            "GET /users/{username}/projectsV2/{project_number}/items"
        ],
        updateItemForOrg: [
            "PATCH /orgs/{org}/projectsV2/{project_number}/items/{item_id}"
        ],
        updateItemForUser: [
            "PATCH /users/{username}/projectsV2/{project_number}/items/{item_id}"
        ]
    },
    pulls: {
        checkIfMerged: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/merge"
        ],
        create: [
            "POST /repos/{owner}/{repo}/pulls"
        ],
        createReplyForReviewComment: [
            "POST /repos/{owner}/{repo}/pulls/{pull_number}/comments/{comment_id}/replies"
        ],
        createReview: [
            "POST /repos/{owner}/{repo}/pulls/{pull_number}/reviews"
        ],
        createReviewComment: [
            "POST /repos/{owner}/{repo}/pulls/{pull_number}/comments"
        ],
        deletePendingReview: [
            "DELETE /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}"
        ],
        deleteReviewComment: [
            "DELETE /repos/{owner}/{repo}/pulls/comments/{comment_id}"
        ],
        dismissReview: [
            "PUT /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}/dismissals"
        ],
        get: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}"
        ],
        getReview: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}"
        ],
        getReviewComment: [
            "GET /repos/{owner}/{repo}/pulls/comments/{comment_id}"
        ],
        list: [
            "GET /repos/{owner}/{repo}/pulls"
        ],
        listCommentsForReview: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}/comments"
        ],
        listCommits: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/commits"
        ],
        listFiles: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/files"
        ],
        listRequestedReviewers: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/requested_reviewers"
        ],
        listReviewComments: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/comments"
        ],
        listReviewCommentsForRepo: [
            "GET /repos/{owner}/{repo}/pulls/comments"
        ],
        listReviews: [
            "GET /repos/{owner}/{repo}/pulls/{pull_number}/reviews"
        ],
        merge: [
            "PUT /repos/{owner}/{repo}/pulls/{pull_number}/merge"
        ],
        removeRequestedReviewers: [
            "DELETE /repos/{owner}/{repo}/pulls/{pull_number}/requested_reviewers"
        ],
        requestReviewers: [
            "POST /repos/{owner}/{repo}/pulls/{pull_number}/requested_reviewers"
        ],
        submitReview: [
            "POST /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}/events"
        ],
        update: [
            "PATCH /repos/{owner}/{repo}/pulls/{pull_number}"
        ],
        updateBranch: [
            "PUT /repos/{owner}/{repo}/pulls/{pull_number}/update-branch"
        ],
        updateReview: [
            "PUT /repos/{owner}/{repo}/pulls/{pull_number}/reviews/{review_id}"
        ],
        updateReviewComment: [
            "PATCH /repos/{owner}/{repo}/pulls/comments/{comment_id}"
        ]
    },
    rateLimit: {
        get: [
            "GET /rate_limit"
        ]
    },
    reactions: {
        createForCommitComment: [
            "POST /repos/{owner}/{repo}/comments/{comment_id}/reactions"
        ],
        createForIssue: [
            "POST /repos/{owner}/{repo}/issues/{issue_number}/reactions"
        ],
        createForIssueComment: [
            "POST /repos/{owner}/{repo}/issues/comments/{comment_id}/reactions"
        ],
        createForPullRequestReviewComment: [
            "POST /repos/{owner}/{repo}/pulls/comments/{comment_id}/reactions"
        ],
        createForRelease: [
            "POST /repos/{owner}/{repo}/releases/{release_id}/reactions"
        ],
        createForTeamDiscussionCommentInOrg: [
            "POST /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}/reactions"
        ],
        createForTeamDiscussionInOrg: [
            "POST /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/reactions"
        ],
        deleteForCommitComment: [
            "DELETE /repos/{owner}/{repo}/comments/{comment_id}/reactions/{reaction_id}"
        ],
        deleteForIssue: [
            "DELETE /repos/{owner}/{repo}/issues/{issue_number}/reactions/{reaction_id}"
        ],
        deleteForIssueComment: [
            "DELETE /repos/{owner}/{repo}/issues/comments/{comment_id}/reactions/{reaction_id}"
        ],
        deleteForPullRequestComment: [
            "DELETE /repos/{owner}/{repo}/pulls/comments/{comment_id}/reactions/{reaction_id}"
        ],
        deleteForRelease: [
            "DELETE /repos/{owner}/{repo}/releases/{release_id}/reactions/{reaction_id}"
        ],
        deleteForTeamDiscussion: [
            "DELETE /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/reactions/{reaction_id}"
        ],
        deleteForTeamDiscussionComment: [
            "DELETE /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}/reactions/{reaction_id}"
        ],
        listForCommitComment: [
            "GET /repos/{owner}/{repo}/comments/{comment_id}/reactions"
        ],
        listForIssue: [
            "GET /repos/{owner}/{repo}/issues/{issue_number}/reactions"
        ],
        listForIssueComment: [
            "GET /repos/{owner}/{repo}/issues/comments/{comment_id}/reactions"
        ],
        listForPullRequestReviewComment: [
            "GET /repos/{owner}/{repo}/pulls/comments/{comment_id}/reactions"
        ],
        listForRelease: [
            "GET /repos/{owner}/{repo}/releases/{release_id}/reactions"
        ],
        listForTeamDiscussionCommentInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}/reactions"
        ],
        listForTeamDiscussionInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/reactions"
        ]
    },
    repos: {
        acceptInvitation: [
            "PATCH /user/repository_invitations/{invitation_id}",
            {},
            {
                renamed: [
                    "repos",
                    "acceptInvitationForAuthenticatedUser"
                ]
            }
        ],
        acceptInvitationForAuthenticatedUser: [
            "PATCH /user/repository_invitations/{invitation_id}"
        ],
        addAppAccessRestrictions: [
            "POST /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/apps",
            {},
            {
                mapToData: "apps"
            }
        ],
        addCollaborator: [
            "PUT /repos/{owner}/{repo}/collaborators/{username}"
        ],
        addStatusCheckContexts: [
            "POST /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks/contexts",
            {},
            {
                mapToData: "contexts"
            }
        ],
        addTeamAccessRestrictions: [
            "POST /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/teams",
            {},
            {
                mapToData: "teams"
            }
        ],
        addUserAccessRestrictions: [
            "POST /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/users",
            {},
            {
                mapToData: "users"
            }
        ],
        cancelPagesDeployment: [
            "POST /repos/{owner}/{repo}/pages/deployments/{pages_deployment_id}/cancel"
        ],
        checkAutomatedSecurityFixes: [
            "GET /repos/{owner}/{repo}/automated-security-fixes"
        ],
        checkCollaborator: [
            "GET /repos/{owner}/{repo}/collaborators/{username}"
        ],
        checkImmutableReleases: [
            "GET /repos/{owner}/{repo}/immutable-releases"
        ],
        checkPrivateVulnerabilityReporting: [
            "GET /repos/{owner}/{repo}/private-vulnerability-reporting"
        ],
        checkVulnerabilityAlerts: [
            "GET /repos/{owner}/{repo}/vulnerability-alerts"
        ],
        codeownersErrors: [
            "GET /repos/{owner}/{repo}/codeowners/errors"
        ],
        compareCommits: [
            "GET /repos/{owner}/{repo}/compare/{base}...{head}"
        ],
        compareCommitsWithBasehead: [
            "GET /repos/{owner}/{repo}/compare/{basehead}"
        ],
        createAttestation: [
            "POST /repos/{owner}/{repo}/attestations"
        ],
        createAutolink: [
            "POST /repos/{owner}/{repo}/autolinks"
        ],
        createCommitComment: [
            "POST /repos/{owner}/{repo}/commits/{commit_sha}/comments"
        ],
        createCommitSignatureProtection: [
            "POST /repos/{owner}/{repo}/branches/{branch}/protection/required_signatures"
        ],
        createCommitStatus: [
            "POST /repos/{owner}/{repo}/statuses/{sha}"
        ],
        createDeployKey: [
            "POST /repos/{owner}/{repo}/keys"
        ],
        createDeployment: [
            "POST /repos/{owner}/{repo}/deployments"
        ],
        createDeploymentBranchPolicy: [
            "POST /repos/{owner}/{repo}/environments/{environment_name}/deployment-branch-policies"
        ],
        createDeploymentProtectionRule: [
            "POST /repos/{owner}/{repo}/environments/{environment_name}/deployment_protection_rules"
        ],
        createDeploymentStatus: [
            "POST /repos/{owner}/{repo}/deployments/{deployment_id}/statuses"
        ],
        createDispatchEvent: [
            "POST /repos/{owner}/{repo}/dispatches"
        ],
        createForAuthenticatedUser: [
            "POST /user/repos"
        ],
        createFork: [
            "POST /repos/{owner}/{repo}/forks"
        ],
        createInOrg: [
            "POST /orgs/{org}/repos"
        ],
        createOrUpdateEnvironment: [
            "PUT /repos/{owner}/{repo}/environments/{environment_name}"
        ],
        createOrUpdateFileContents: [
            "PUT /repos/{owner}/{repo}/contents/{path}"
        ],
        createOrgRuleset: [
            "POST /orgs/{org}/rulesets"
        ],
        createPagesDeployment: [
            "POST /repos/{owner}/{repo}/pages/deployments"
        ],
        createPagesSite: [
            "POST /repos/{owner}/{repo}/pages"
        ],
        createRelease: [
            "POST /repos/{owner}/{repo}/releases"
        ],
        createRepoRuleset: [
            "POST /repos/{owner}/{repo}/rulesets"
        ],
        createUsingTemplate: [
            "POST /repos/{template_owner}/{template_repo}/generate"
        ],
        createWebhook: [
            "POST /repos/{owner}/{repo}/hooks"
        ],
        customPropertiesForReposCreateOrUpdateRepositoryValues: [
            "PATCH /repos/{owner}/{repo}/properties/values"
        ],
        customPropertiesForReposGetRepositoryValues: [
            "GET /repos/{owner}/{repo}/properties/values"
        ],
        declineInvitation: [
            "DELETE /user/repository_invitations/{invitation_id}",
            {},
            {
                renamed: [
                    "repos",
                    "declineInvitationForAuthenticatedUser"
                ]
            }
        ],
        declineInvitationForAuthenticatedUser: [
            "DELETE /user/repository_invitations/{invitation_id}"
        ],
        delete: [
            "DELETE /repos/{owner}/{repo}"
        ],
        deleteAccessRestrictions: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/restrictions"
        ],
        deleteAdminBranchProtection: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/enforce_admins"
        ],
        deleteAnEnvironment: [
            "DELETE /repos/{owner}/{repo}/environments/{environment_name}"
        ],
        deleteAutolink: [
            "DELETE /repos/{owner}/{repo}/autolinks/{autolink_id}"
        ],
        deleteBranchProtection: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection"
        ],
        deleteCommitComment: [
            "DELETE /repos/{owner}/{repo}/comments/{comment_id}"
        ],
        deleteCommitSignatureProtection: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/required_signatures"
        ],
        deleteDeployKey: [
            "DELETE /repos/{owner}/{repo}/keys/{key_id}"
        ],
        deleteDeployment: [
            "DELETE /repos/{owner}/{repo}/deployments/{deployment_id}"
        ],
        deleteDeploymentBranchPolicy: [
            "DELETE /repos/{owner}/{repo}/environments/{environment_name}/deployment-branch-policies/{branch_policy_id}"
        ],
        deleteFile: [
            "DELETE /repos/{owner}/{repo}/contents/{path}"
        ],
        deleteInvitation: [
            "DELETE /repos/{owner}/{repo}/invitations/{invitation_id}"
        ],
        deleteOrgRuleset: [
            "DELETE /orgs/{org}/rulesets/{ruleset_id}"
        ],
        deletePagesSite: [
            "DELETE /repos/{owner}/{repo}/pages"
        ],
        deletePullRequestReviewProtection: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/required_pull_request_reviews"
        ],
        deleteRelease: [
            "DELETE /repos/{owner}/{repo}/releases/{release_id}"
        ],
        deleteReleaseAsset: [
            "DELETE /repos/{owner}/{repo}/releases/assets/{asset_id}"
        ],
        deleteRepoRuleset: [
            "DELETE /repos/{owner}/{repo}/rulesets/{ruleset_id}"
        ],
        deleteWebhook: [
            "DELETE /repos/{owner}/{repo}/hooks/{hook_id}"
        ],
        disableAutomatedSecurityFixes: [
            "DELETE /repos/{owner}/{repo}/automated-security-fixes"
        ],
        disableDeploymentProtectionRule: [
            "DELETE /repos/{owner}/{repo}/environments/{environment_name}/deployment_protection_rules/{protection_rule_id}"
        ],
        disableImmutableReleases: [
            "DELETE /repos/{owner}/{repo}/immutable-releases"
        ],
        disablePrivateVulnerabilityReporting: [
            "DELETE /repos/{owner}/{repo}/private-vulnerability-reporting"
        ],
        disableVulnerabilityAlerts: [
            "DELETE /repos/{owner}/{repo}/vulnerability-alerts"
        ],
        downloadArchive: [
            "GET /repos/{owner}/{repo}/zipball/{ref}",
            {},
            {
                renamed: [
                    "repos",
                    "downloadZipballArchive"
                ]
            }
        ],
        downloadTarballArchive: [
            "GET /repos/{owner}/{repo}/tarball/{ref}"
        ],
        downloadZipballArchive: [
            "GET /repos/{owner}/{repo}/zipball/{ref}"
        ],
        enableAutomatedSecurityFixes: [
            "PUT /repos/{owner}/{repo}/automated-security-fixes"
        ],
        enableImmutableReleases: [
            "PUT /repos/{owner}/{repo}/immutable-releases"
        ],
        enablePrivateVulnerabilityReporting: [
            "PUT /repos/{owner}/{repo}/private-vulnerability-reporting"
        ],
        enableVulnerabilityAlerts: [
            "PUT /repos/{owner}/{repo}/vulnerability-alerts"
        ],
        generateReleaseNotes: [
            "POST /repos/{owner}/{repo}/releases/generate-notes"
        ],
        get: [
            "GET /repos/{owner}/{repo}"
        ],
        getAccessRestrictions: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/restrictions"
        ],
        getAdminBranchProtection: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/enforce_admins"
        ],
        getAllDeploymentProtectionRules: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment_protection_rules"
        ],
        getAllEnvironments: [
            "GET /repos/{owner}/{repo}/environments"
        ],
        getAllStatusCheckContexts: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks/contexts"
        ],
        getAllTopics: [
            "GET /repos/{owner}/{repo}/topics"
        ],
        getAppsWithAccessToProtectedBranch: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/apps"
        ],
        getAutolink: [
            "GET /repos/{owner}/{repo}/autolinks/{autolink_id}"
        ],
        getBranch: [
            "GET /repos/{owner}/{repo}/branches/{branch}"
        ],
        getBranchProtection: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection"
        ],
        getBranchRules: [
            "GET /repos/{owner}/{repo}/rules/branches/{branch}"
        ],
        getClones: [
            "GET /repos/{owner}/{repo}/traffic/clones"
        ],
        getCodeFrequencyStats: [
            "GET /repos/{owner}/{repo}/stats/code_frequency"
        ],
        getCollaboratorPermissionLevel: [
            "GET /repos/{owner}/{repo}/collaborators/{username}/permission"
        ],
        getCombinedStatusForRef: [
            "GET /repos/{owner}/{repo}/commits/{ref}/status"
        ],
        getCommit: [
            "GET /repos/{owner}/{repo}/commits/{ref}"
        ],
        getCommitActivityStats: [
            "GET /repos/{owner}/{repo}/stats/commit_activity"
        ],
        getCommitComment: [
            "GET /repos/{owner}/{repo}/comments/{comment_id}"
        ],
        getCommitSignatureProtection: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/required_signatures"
        ],
        getCommunityProfileMetrics: [
            "GET /repos/{owner}/{repo}/community/profile"
        ],
        getContent: [
            "GET /repos/{owner}/{repo}/contents/{path}"
        ],
        getContributorsStats: [
            "GET /repos/{owner}/{repo}/stats/contributors"
        ],
        getCustomDeploymentProtectionRule: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment_protection_rules/{protection_rule_id}"
        ],
        getDeployKey: [
            "GET /repos/{owner}/{repo}/keys/{key_id}"
        ],
        getDeployment: [
            "GET /repos/{owner}/{repo}/deployments/{deployment_id}"
        ],
        getDeploymentBranchPolicy: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment-branch-policies/{branch_policy_id}"
        ],
        getDeploymentStatus: [
            "GET /repos/{owner}/{repo}/deployments/{deployment_id}/statuses/{status_id}"
        ],
        getEnvironment: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}"
        ],
        getLatestPagesBuild: [
            "GET /repos/{owner}/{repo}/pages/builds/latest"
        ],
        getLatestRelease: [
            "GET /repos/{owner}/{repo}/releases/latest"
        ],
        getOrgRuleSuite: [
            "GET /orgs/{org}/rulesets/rule-suites/{rule_suite_id}"
        ],
        getOrgRuleSuites: [
            "GET /orgs/{org}/rulesets/rule-suites"
        ],
        getOrgRuleset: [
            "GET /orgs/{org}/rulesets/{ruleset_id}"
        ],
        getOrgRulesets: [
            "GET /orgs/{org}/rulesets"
        ],
        getPages: [
            "GET /repos/{owner}/{repo}/pages"
        ],
        getPagesBuild: [
            "GET /repos/{owner}/{repo}/pages/builds/{build_id}"
        ],
        getPagesDeployment: [
            "GET /repos/{owner}/{repo}/pages/deployments/{pages_deployment_id}"
        ],
        getPagesHealthCheck: [
            "GET /repos/{owner}/{repo}/pages/health"
        ],
        getParticipationStats: [
            "GET /repos/{owner}/{repo}/stats/participation"
        ],
        getPullRequestReviewProtection: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/required_pull_request_reviews"
        ],
        getPunchCardStats: [
            "GET /repos/{owner}/{repo}/stats/punch_card"
        ],
        getReadme: [
            "GET /repos/{owner}/{repo}/readme"
        ],
        getReadmeInDirectory: [
            "GET /repos/{owner}/{repo}/readme/{dir}"
        ],
        getRelease: [
            "GET /repos/{owner}/{repo}/releases/{release_id}"
        ],
        getReleaseAsset: [
            "GET /repos/{owner}/{repo}/releases/assets/{asset_id}"
        ],
        getReleaseByTag: [
            "GET /repos/{owner}/{repo}/releases/tags/{tag}"
        ],
        getRepoRuleSuite: [
            "GET /repos/{owner}/{repo}/rulesets/rule-suites/{rule_suite_id}"
        ],
        getRepoRuleSuites: [
            "GET /repos/{owner}/{repo}/rulesets/rule-suites"
        ],
        getRepoRuleset: [
            "GET /repos/{owner}/{repo}/rulesets/{ruleset_id}"
        ],
        getRepoRulesetHistory: [
            "GET /repos/{owner}/{repo}/rulesets/{ruleset_id}/history"
        ],
        getRepoRulesetVersion: [
            "GET /repos/{owner}/{repo}/rulesets/{ruleset_id}/history/{version_id}"
        ],
        getRepoRulesets: [
            "GET /repos/{owner}/{repo}/rulesets"
        ],
        getStatusChecksProtection: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks"
        ],
        getTeamsWithAccessToProtectedBranch: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/teams"
        ],
        getTopPaths: [
            "GET /repos/{owner}/{repo}/traffic/popular/paths"
        ],
        getTopReferrers: [
            "GET /repos/{owner}/{repo}/traffic/popular/referrers"
        ],
        getUsersWithAccessToProtectedBranch: [
            "GET /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/users"
        ],
        getViews: [
            "GET /repos/{owner}/{repo}/traffic/views"
        ],
        getWebhook: [
            "GET /repos/{owner}/{repo}/hooks/{hook_id}"
        ],
        getWebhookConfigForRepo: [
            "GET /repos/{owner}/{repo}/hooks/{hook_id}/config"
        ],
        getWebhookDelivery: [
            "GET /repos/{owner}/{repo}/hooks/{hook_id}/deliveries/{delivery_id}"
        ],
        listActivities: [
            "GET /repos/{owner}/{repo}/activity"
        ],
        listAttestations: [
            "GET /repos/{owner}/{repo}/attestations/{subject_digest}"
        ],
        listAutolinks: [
            "GET /repos/{owner}/{repo}/autolinks"
        ],
        listBranches: [
            "GET /repos/{owner}/{repo}/branches"
        ],
        listBranchesForHeadCommit: [
            "GET /repos/{owner}/{repo}/commits/{commit_sha}/branches-where-head"
        ],
        listCollaborators: [
            "GET /repos/{owner}/{repo}/collaborators"
        ],
        listCommentsForCommit: [
            "GET /repos/{owner}/{repo}/commits/{commit_sha}/comments"
        ],
        listCommitCommentsForRepo: [
            "GET /repos/{owner}/{repo}/comments"
        ],
        listCommitStatusesForRef: [
            "GET /repos/{owner}/{repo}/commits/{ref}/statuses"
        ],
        listCommits: [
            "GET /repos/{owner}/{repo}/commits"
        ],
        listContributors: [
            "GET /repos/{owner}/{repo}/contributors"
        ],
        listCustomDeploymentRuleIntegrations: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment_protection_rules/apps"
        ],
        listDeployKeys: [
            "GET /repos/{owner}/{repo}/keys"
        ],
        listDeploymentBranchPolicies: [
            "GET /repos/{owner}/{repo}/environments/{environment_name}/deployment-branch-policies"
        ],
        listDeploymentStatuses: [
            "GET /repos/{owner}/{repo}/deployments/{deployment_id}/statuses"
        ],
        listDeployments: [
            "GET /repos/{owner}/{repo}/deployments"
        ],
        listForAuthenticatedUser: [
            "GET /user/repos"
        ],
        listForOrg: [
            "GET /orgs/{org}/repos"
        ],
        listForUser: [
            "GET /users/{username}/repos"
        ],
        listForks: [
            "GET /repos/{owner}/{repo}/forks"
        ],
        listInvitations: [
            "GET /repos/{owner}/{repo}/invitations"
        ],
        listInvitationsForAuthenticatedUser: [
            "GET /user/repository_invitations"
        ],
        listLanguages: [
            "GET /repos/{owner}/{repo}/languages"
        ],
        listPagesBuilds: [
            "GET /repos/{owner}/{repo}/pages/builds"
        ],
        listPublic: [
            "GET /repositories"
        ],
        listPullRequestsAssociatedWithCommit: [
            "GET /repos/{owner}/{repo}/commits/{commit_sha}/pulls"
        ],
        listReleaseAssets: [
            "GET /repos/{owner}/{repo}/releases/{release_id}/assets"
        ],
        listReleases: [
            "GET /repos/{owner}/{repo}/releases"
        ],
        listTags: [
            "GET /repos/{owner}/{repo}/tags"
        ],
        listTeams: [
            "GET /repos/{owner}/{repo}/teams"
        ],
        listWebhookDeliveries: [
            "GET /repos/{owner}/{repo}/hooks/{hook_id}/deliveries"
        ],
        listWebhooks: [
            "GET /repos/{owner}/{repo}/hooks"
        ],
        merge: [
            "POST /repos/{owner}/{repo}/merges"
        ],
        mergeUpstream: [
            "POST /repos/{owner}/{repo}/merge-upstream"
        ],
        pingWebhook: [
            "POST /repos/{owner}/{repo}/hooks/{hook_id}/pings"
        ],
        redeliverWebhookDelivery: [
            "POST /repos/{owner}/{repo}/hooks/{hook_id}/deliveries/{delivery_id}/attempts"
        ],
        removeAppAccessRestrictions: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/apps",
            {},
            {
                mapToData: "apps"
            }
        ],
        removeCollaborator: [
            "DELETE /repos/{owner}/{repo}/collaborators/{username}"
        ],
        removeStatusCheckContexts: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks/contexts",
            {},
            {
                mapToData: "contexts"
            }
        ],
        removeStatusCheckProtection: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks"
        ],
        removeTeamAccessRestrictions: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/teams",
            {},
            {
                mapToData: "teams"
            }
        ],
        removeUserAccessRestrictions: [
            "DELETE /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/users",
            {},
            {
                mapToData: "users"
            }
        ],
        renameBranch: [
            "POST /repos/{owner}/{repo}/branches/{branch}/rename"
        ],
        replaceAllTopics: [
            "PUT /repos/{owner}/{repo}/topics"
        ],
        requestPagesBuild: [
            "POST /repos/{owner}/{repo}/pages/builds"
        ],
        setAdminBranchProtection: [
            "POST /repos/{owner}/{repo}/branches/{branch}/protection/enforce_admins"
        ],
        setAppAccessRestrictions: [
            "PUT /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/apps",
            {},
            {
                mapToData: "apps"
            }
        ],
        setStatusCheckContexts: [
            "PUT /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks/contexts",
            {},
            {
                mapToData: "contexts"
            }
        ],
        setTeamAccessRestrictions: [
            "PUT /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/teams",
            {},
            {
                mapToData: "teams"
            }
        ],
        setUserAccessRestrictions: [
            "PUT /repos/{owner}/{repo}/branches/{branch}/protection/restrictions/users",
            {},
            {
                mapToData: "users"
            }
        ],
        testPushWebhook: [
            "POST /repos/{owner}/{repo}/hooks/{hook_id}/tests"
        ],
        transfer: [
            "POST /repos/{owner}/{repo}/transfer"
        ],
        update: [
            "PATCH /repos/{owner}/{repo}"
        ],
        updateBranchProtection: [
            "PUT /repos/{owner}/{repo}/branches/{branch}/protection"
        ],
        updateCommitComment: [
            "PATCH /repos/{owner}/{repo}/comments/{comment_id}"
        ],
        updateDeploymentBranchPolicy: [
            "PUT /repos/{owner}/{repo}/environments/{environment_name}/deployment-branch-policies/{branch_policy_id}"
        ],
        updateInformationAboutPagesSite: [
            "PUT /repos/{owner}/{repo}/pages"
        ],
        updateInvitation: [
            "PATCH /repos/{owner}/{repo}/invitations/{invitation_id}"
        ],
        updateOrgRuleset: [
            "PUT /orgs/{org}/rulesets/{ruleset_id}"
        ],
        updatePullRequestReviewProtection: [
            "PATCH /repos/{owner}/{repo}/branches/{branch}/protection/required_pull_request_reviews"
        ],
        updateRelease: [
            "PATCH /repos/{owner}/{repo}/releases/{release_id}"
        ],
        updateReleaseAsset: [
            "PATCH /repos/{owner}/{repo}/releases/assets/{asset_id}"
        ],
        updateRepoRuleset: [
            "PUT /repos/{owner}/{repo}/rulesets/{ruleset_id}"
        ],
        updateStatusCheckPotection: [
            "PATCH /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks",
            {},
            {
                renamed: [
                    "repos",
                    "updateStatusCheckProtection"
                ]
            }
        ],
        updateStatusCheckProtection: [
            "PATCH /repos/{owner}/{repo}/branches/{branch}/protection/required_status_checks"
        ],
        updateWebhook: [
            "PATCH /repos/{owner}/{repo}/hooks/{hook_id}"
        ],
        updateWebhookConfigForRepo: [
            "PATCH /repos/{owner}/{repo}/hooks/{hook_id}/config"
        ],
        uploadReleaseAsset: [
            "POST /repos/{owner}/{repo}/releases/{release_id}/assets{?name,label}",
            {
                baseUrl: "https://uploads.github.com"
            }
        ]
    },
    search: {
        code: [
            "GET /search/code"
        ],
        commits: [
            "GET /search/commits"
        ],
        issuesAndPullRequests: [
            "GET /search/issues"
        ],
        labels: [
            "GET /search/labels"
        ],
        repos: [
            "GET /search/repositories"
        ],
        topics: [
            "GET /search/topics"
        ],
        users: [
            "GET /search/users"
        ]
    },
    secretScanning: {
        createPushProtectionBypass: [
            "POST /repos/{owner}/{repo}/secret-scanning/push-protection-bypasses"
        ],
        getAlert: [
            "GET /repos/{owner}/{repo}/secret-scanning/alerts/{alert_number}"
        ],
        getScanHistory: [
            "GET /repos/{owner}/{repo}/secret-scanning/scan-history"
        ],
        listAlertsForOrg: [
            "GET /orgs/{org}/secret-scanning/alerts"
        ],
        listAlertsForRepo: [
            "GET /repos/{owner}/{repo}/secret-scanning/alerts"
        ],
        listLocationsForAlert: [
            "GET /repos/{owner}/{repo}/secret-scanning/alerts/{alert_number}/locations"
        ],
        listOrgPatternConfigs: [
            "GET /orgs/{org}/secret-scanning/pattern-configurations"
        ],
        updateAlert: [
            "PATCH /repos/{owner}/{repo}/secret-scanning/alerts/{alert_number}"
        ],
        updateOrgPatternConfigs: [
            "PATCH /orgs/{org}/secret-scanning/pattern-configurations"
        ]
    },
    securityAdvisories: {
        createFork: [
            "POST /repos/{owner}/{repo}/security-advisories/{ghsa_id}/forks"
        ],
        createPrivateVulnerabilityReport: [
            "POST /repos/{owner}/{repo}/security-advisories/reports"
        ],
        createRepositoryAdvisory: [
            "POST /repos/{owner}/{repo}/security-advisories"
        ],
        createRepositoryAdvisoryCveRequest: [
            "POST /repos/{owner}/{repo}/security-advisories/{ghsa_id}/cve"
        ],
        getGlobalAdvisory: [
            "GET /advisories/{ghsa_id}"
        ],
        getRepositoryAdvisory: [
            "GET /repos/{owner}/{repo}/security-advisories/{ghsa_id}"
        ],
        listGlobalAdvisories: [
            "GET /advisories"
        ],
        listOrgRepositoryAdvisories: [
            "GET /orgs/{org}/security-advisories"
        ],
        listRepositoryAdvisories: [
            "GET /repos/{owner}/{repo}/security-advisories"
        ],
        updateRepositoryAdvisory: [
            "PATCH /repos/{owner}/{repo}/security-advisories/{ghsa_id}"
        ]
    },
    teams: {
        addOrUpdateMembershipForUserInOrg: [
            "PUT /orgs/{org}/teams/{team_slug}/memberships/{username}"
        ],
        addOrUpdateRepoPermissionsInOrg: [
            "PUT /orgs/{org}/teams/{team_slug}/repos/{owner}/{repo}"
        ],
        checkPermissionsForRepoInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/repos/{owner}/{repo}"
        ],
        create: [
            "POST /orgs/{org}/teams"
        ],
        createDiscussionCommentInOrg: [
            "POST /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments"
        ],
        createDiscussionInOrg: [
            "POST /orgs/{org}/teams/{team_slug}/discussions"
        ],
        deleteDiscussionCommentInOrg: [
            "DELETE /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}"
        ],
        deleteDiscussionInOrg: [
            "DELETE /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}"
        ],
        deleteInOrg: [
            "DELETE /orgs/{org}/teams/{team_slug}"
        ],
        getByName: [
            "GET /orgs/{org}/teams/{team_slug}"
        ],
        getDiscussionCommentInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}"
        ],
        getDiscussionInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}"
        ],
        getMembershipForUserInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/memberships/{username}"
        ],
        list: [
            "GET /orgs/{org}/teams"
        ],
        listChildInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/teams"
        ],
        listDiscussionCommentsInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments"
        ],
        listDiscussionsInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/discussions"
        ],
        listForAuthenticatedUser: [
            "GET /user/teams"
        ],
        listMembersInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/members"
        ],
        listPendingInvitationsInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/invitations"
        ],
        listReposInOrg: [
            "GET /orgs/{org}/teams/{team_slug}/repos"
        ],
        removeMembershipForUserInOrg: [
            "DELETE /orgs/{org}/teams/{team_slug}/memberships/{username}"
        ],
        removeRepoInOrg: [
            "DELETE /orgs/{org}/teams/{team_slug}/repos/{owner}/{repo}"
        ],
        updateDiscussionCommentInOrg: [
            "PATCH /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}/comments/{comment_number}"
        ],
        updateDiscussionInOrg: [
            "PATCH /orgs/{org}/teams/{team_slug}/discussions/{discussion_number}"
        ],
        updateInOrg: [
            "PATCH /orgs/{org}/teams/{team_slug}"
        ]
    },
    users: {
        addEmailForAuthenticated: [
            "POST /user/emails",
            {},
            {
                renamed: [
                    "users",
                    "addEmailForAuthenticatedUser"
                ]
            }
        ],
        addEmailForAuthenticatedUser: [
            "POST /user/emails"
        ],
        addSocialAccountForAuthenticatedUser: [
            "POST /user/social_accounts"
        ],
        block: [
            "PUT /user/blocks/{username}"
        ],
        checkBlocked: [
            "GET /user/blocks/{username}"
        ],
        checkFollowingForUser: [
            "GET /users/{username}/following/{target_user}"
        ],
        checkPersonIsFollowedByAuthenticated: [
            "GET /user/following/{username}"
        ],
        createGpgKeyForAuthenticated: [
            "POST /user/gpg_keys",
            {},
            {
                renamed: [
                    "users",
                    "createGpgKeyForAuthenticatedUser"
                ]
            }
        ],
        createGpgKeyForAuthenticatedUser: [
            "POST /user/gpg_keys"
        ],
        createPublicSshKeyForAuthenticated: [
            "POST /user/keys",
            {},
            {
                renamed: [
                    "users",
                    "createPublicSshKeyForAuthenticatedUser"
                ]
            }
        ],
        createPublicSshKeyForAuthenticatedUser: [
            "POST /user/keys"
        ],
        createSshSigningKeyForAuthenticatedUser: [
            "POST /user/ssh_signing_keys"
        ],
        deleteAttestationsBulk: [
            "POST /users/{username}/attestations/delete-request"
        ],
        deleteAttestationsById: [
            "DELETE /users/{username}/attestations/{attestation_id}"
        ],
        deleteAttestationsBySubjectDigest: [
            "DELETE /users/{username}/attestations/digest/{subject_digest}"
        ],
        deleteEmailForAuthenticated: [
            "DELETE /user/emails",
            {},
            {
                renamed: [
                    "users",
                    "deleteEmailForAuthenticatedUser"
                ]
            }
        ],
        deleteEmailForAuthenticatedUser: [
            "DELETE /user/emails"
        ],
        deleteGpgKeyForAuthenticated: [
            "DELETE /user/gpg_keys/{gpg_key_id}",
            {},
            {
                renamed: [
                    "users",
                    "deleteGpgKeyForAuthenticatedUser"
                ]
            }
        ],
        deleteGpgKeyForAuthenticatedUser: [
            "DELETE /user/gpg_keys/{gpg_key_id}"
        ],
        deletePublicSshKeyForAuthenticated: [
            "DELETE /user/keys/{key_id}",
            {},
            {
                renamed: [
                    "users",
                    "deletePublicSshKeyForAuthenticatedUser"
                ]
            }
        ],
        deletePublicSshKeyForAuthenticatedUser: [
            "DELETE /user/keys/{key_id}"
        ],
        deleteSocialAccountForAuthenticatedUser: [
            "DELETE /user/social_accounts"
        ],
        deleteSshSigningKeyForAuthenticatedUser: [
            "DELETE /user/ssh_signing_keys/{ssh_signing_key_id}"
        ],
        follow: [
            "PUT /user/following/{username}"
        ],
        getAuthenticated: [
            "GET /user"
        ],
        getById: [
            "GET /user/{account_id}"
        ],
        getByUsername: [
            "GET /users/{username}"
        ],
        getContextForUser: [
            "GET /users/{username}/hovercard"
        ],
        getGpgKeyForAuthenticated: [
            "GET /user/gpg_keys/{gpg_key_id}",
            {},
            {
                renamed: [
                    "users",
                    "getGpgKeyForAuthenticatedUser"
                ]
            }
        ],
        getGpgKeyForAuthenticatedUser: [
            "GET /user/gpg_keys/{gpg_key_id}"
        ],
        getPublicSshKeyForAuthenticated: [
            "GET /user/keys/{key_id}",
            {},
            {
                renamed: [
                    "users",
                    "getPublicSshKeyForAuthenticatedUser"
                ]
            }
        ],
        getPublicSshKeyForAuthenticatedUser: [
            "GET /user/keys/{key_id}"
        ],
        getSshSigningKeyForAuthenticatedUser: [
            "GET /user/ssh_signing_keys/{ssh_signing_key_id}"
        ],
        list: [
            "GET /users"
        ],
        listAttestations: [
            "GET /users/{username}/attestations/{subject_digest}"
        ],
        listAttestationsBulk: [
            "POST /users/{username}/attestations/bulk-list{?per_page,before,after}"
        ],
        listBlockedByAuthenticated: [
            "GET /user/blocks",
            {},
            {
                renamed: [
                    "users",
                    "listBlockedByAuthenticatedUser"
                ]
            }
        ],
        listBlockedByAuthenticatedUser: [
            "GET /user/blocks"
        ],
        listEmailsForAuthenticated: [
            "GET /user/emails",
            {},
            {
                renamed: [
                    "users",
                    "listEmailsForAuthenticatedUser"
                ]
            }
        ],
        listEmailsForAuthenticatedUser: [
            "GET /user/emails"
        ],
        listFollowedByAuthenticated: [
            "GET /user/following",
            {},
            {
                renamed: [
                    "users",
                    "listFollowedByAuthenticatedUser"
                ]
            }
        ],
        listFollowedByAuthenticatedUser: [
            "GET /user/following"
        ],
        listFollowersForAuthenticatedUser: [
            "GET /user/followers"
        ],
        listFollowersForUser: [
            "GET /users/{username}/followers"
        ],
        listFollowingForUser: [
            "GET /users/{username}/following"
        ],
        listGpgKeysForAuthenticated: [
            "GET /user/gpg_keys",
            {},
            {
                renamed: [
                    "users",
                    "listGpgKeysForAuthenticatedUser"
                ]
            }
        ],
        listGpgKeysForAuthenticatedUser: [
            "GET /user/gpg_keys"
        ],
        listGpgKeysForUser: [
            "GET /users/{username}/gpg_keys"
        ],
        listPublicEmailsForAuthenticated: [
            "GET /user/public_emails",
            {},
            {
                renamed: [
                    "users",
                    "listPublicEmailsForAuthenticatedUser"
                ]
            }
        ],
        listPublicEmailsForAuthenticatedUser: [
            "GET /user/public_emails"
        ],
        listPublicKeysForUser: [
            "GET /users/{username}/keys"
        ],
        listPublicSshKeysForAuthenticated: [
            "GET /user/keys",
            {},
            {
                renamed: [
                    "users",
                    "listPublicSshKeysForAuthenticatedUser"
                ]
            }
        ],
        listPublicSshKeysForAuthenticatedUser: [
            "GET /user/keys"
        ],
        listSocialAccountsForAuthenticatedUser: [
            "GET /user/social_accounts"
        ],
        listSocialAccountsForUser: [
            "GET /users/{username}/social_accounts"
        ],
        listSshSigningKeysForAuthenticatedUser: [
            "GET /user/ssh_signing_keys"
        ],
        listSshSigningKeysForUser: [
            "GET /users/{username}/ssh_signing_keys"
        ],
        setPrimaryEmailVisibilityForAuthenticated: [
            "PATCH /user/email/visibility",
            {},
            {
                renamed: [
                    "users",
                    "setPrimaryEmailVisibilityForAuthenticatedUser"
                ]
            }
        ],
        setPrimaryEmailVisibilityForAuthenticatedUser: [
            "PATCH /user/email/visibility"
        ],
        unblock: [
            "DELETE /user/blocks/{username}"
        ],
        unfollow: [
            "DELETE /user/following/{username}"
        ],
        updateAuthenticated: [
            "PATCH /user"
        ]
    }
};
var $fec2aee19b3e615a$export$2e2bcd8739ae039 = $fec2aee19b3e615a$var$Endpoints;


const $e64f72f2fd07cbe3$var$endpointMethodsMap = /* @__PURE__ */ new Map();
for (const [scope, endpoints] of Object.entries((0, $fec2aee19b3e615a$export$2e2bcd8739ae039)))for (const [methodName, endpoint] of Object.entries(endpoints)){
    const [route, defaults, decorations] = endpoint;
    const [method, url] = route.split(/ /);
    const endpointDefaults = Object.assign({
        method: method,
        url: url
    }, defaults);
    if (!$e64f72f2fd07cbe3$var$endpointMethodsMap.has(scope)) $e64f72f2fd07cbe3$var$endpointMethodsMap.set(scope, /* @__PURE__ */ new Map());
    $e64f72f2fd07cbe3$var$endpointMethodsMap.get(scope).set(methodName, {
        scope: scope,
        methodName: methodName,
        endpointDefaults: endpointDefaults,
        decorations: decorations
    });
}
const $e64f72f2fd07cbe3$var$handler = {
    has ({ scope: scope }, methodName) {
        return $e64f72f2fd07cbe3$var$endpointMethodsMap.get(scope).has(methodName);
    },
    getOwnPropertyDescriptor (target, methodName) {
        return {
            value: this.get(target, methodName),
            // ensures method is in the cache
            configurable: true,
            writable: true,
            enumerable: true
        };
    },
    defineProperty (target, methodName, descriptor) {
        Object.defineProperty(target.cache, methodName, descriptor);
        return true;
    },
    deleteProperty (target, methodName) {
        delete target.cache[methodName];
        return true;
    },
    ownKeys ({ scope: scope }) {
        return [
            ...$e64f72f2fd07cbe3$var$endpointMethodsMap.get(scope).keys()
        ];
    },
    set (target, methodName, value) {
        return target.cache[methodName] = value;
    },
    get ({ octokit: octokit, scope: scope, cache: cache }, methodName) {
        if (cache[methodName]) return cache[methodName];
        const method = $e64f72f2fd07cbe3$var$endpointMethodsMap.get(scope).get(methodName);
        if (!method) return void 0;
        const { endpointDefaults: endpointDefaults, decorations: decorations } = method;
        if (decorations) cache[methodName] = $e64f72f2fd07cbe3$var$decorate(octokit, scope, methodName, endpointDefaults, decorations);
        else cache[methodName] = octokit.request.defaults(endpointDefaults);
        return cache[methodName];
    }
};
function $e64f72f2fd07cbe3$export$3b214893ba7a03d2(octokit) {
    const newMethods = {};
    for (const scope of $e64f72f2fd07cbe3$var$endpointMethodsMap.keys())newMethods[scope] = new Proxy({
        octokit: octokit,
        scope: scope,
        cache: {}
    }, $e64f72f2fd07cbe3$var$handler);
    return newMethods;
}
function $e64f72f2fd07cbe3$var$decorate(octokit, scope, methodName, defaults, decorations) {
    const requestWithDefaults = octokit.request.defaults(defaults);
    function withDecorations(...args) {
        let options = requestWithDefaults.endpoint.merge(...args);
        if (decorations.mapToData) {
            options = Object.assign({}, options, {
                data: options[decorations.mapToData],
                [decorations.mapToData]: void 0
            });
            return requestWithDefaults(options);
        }
        if (decorations.renamed) {
            const [newScope, newMethodName] = decorations.renamed;
            octokit.log.warn(`octokit.${scope}.${methodName}() has been renamed to octokit.${newScope}.${newMethodName}()`);
        }
        if (decorations.deprecated) octokit.log.warn(decorations.deprecated);
        if (decorations.renamedParameters) {
            const options2 = requestWithDefaults.endpoint.merge(...args);
            for (const [name, alias] of Object.entries(decorations.renamedParameters))if (name in options2) {
                octokit.log.warn(`"${name}" parameter is deprecated for "octokit.${scope}.${methodName}()". Use "${alias}" instead`);
                if (!(alias in options2)) options2[alias] = options2[name];
                delete options2[name];
            }
            return requestWithDefaults(options2);
        }
        return requestWithDefaults(...args);
    }
    return Object.assign(withDecorations, requestWithDefaults);
}


function $c7aa5b4d595bb95f$export$a1fe24cc78039d62(octokit) {
    const api = (0, $e64f72f2fd07cbe3$export$3b214893ba7a03d2)(octokit);
    return {
        rest: api
    };
}
$c7aa5b4d595bb95f$export$a1fe24cc78039d62.VERSION = (0, $8b9c3a2d778f9042$export$a4ad2735b021c132);
function $c7aa5b4d595bb95f$export$fb02754b3672af31(octokit) {
    const api = (0, $e64f72f2fd07cbe3$export$3b214893ba7a03d2)(octokit);
    return {
        ...api,
        rest: api
    };
}
$c7aa5b4d595bb95f$export$fb02754b3672af31.VERSION = (0, $8b9c3a2d778f9042$export$a4ad2735b021c132);


const $c64ec9fe4de74683$export$a4ad2735b021c132 = "22.0.1";


const $cbd19688a58ede89$export$d19f1ac68c042717 = (0, $e1bec7210289ec8a$export$d19f1ac68c042717).plugin((0, $1d50f8968a9c93ea$export$1c1276d455e5a49b), (0, $c7aa5b4d595bb95f$export$fb02754b3672af31), (0, $1dae16d4eecbbc46$export$d8def7ab7602fc50)).defaults({
    userAgent: `octokit-rest.js/${(0, $c64ec9fe4de74683$export$a4ad2735b021c132)}`
});



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $78701249fecd496d$exports = {};

$parcel$export($78701249fecd496d$exports, "FOCUS_EVENT", () => $78701249fecd496d$export$831c820ad60f9d12);
$parcel$export($78701249fecd496d$exports, "RECONNECT_EVENT", () => $78701249fecd496d$export$24e9454cb99a11dc);
$parcel$export($78701249fecd496d$exports, "MUTATE_EVENT", () => $78701249fecd496d$export$75ea288459391154);
$parcel$export($78701249fecd496d$exports, "ERROR_REVALIDATE_EVENT", () => $78701249fecd496d$export$b019c3839228f243);
const $78701249fecd496d$export$831c820ad60f9d12 = 0;
const $78701249fecd496d$export$24e9454cb99a11dc = 1;
const $78701249fecd496d$export$75ea288459391154 = 2;
const $78701249fecd496d$export$b019c3839228f243 = 3;


var $0790fe16af8106e5$var$has = Object.prototype.hasOwnProperty;
function $0790fe16af8106e5$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $0790fe16af8106e5$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($0790fe16af8106e5$var$has.call(foo, ctor) && ++len && !$0790fe16af8106e5$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$0790fe16af8106e5$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


'use client';
// Global state used to deduplicate requests and store listeners
const $e30a63e8d43c13f6$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $e30a63e8d43c13f6$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $e30a63e8d43c13f6$export$ebd11618f299a286();
const $e30a63e8d43c13f6$export$c4ce752e73470fba = Object;
const $e30a63e8d43c13f6$export$f1e1789686576879 = (v)=>v === $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08;
const $e30a63e8d43c13f6$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $e30a63e8d43c13f6$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $e30a63e8d43c13f6$export$ef35774e6d314e91 = (x)=>$e30a63e8d43c13f6$export$407448d2b89b1813(x.then);
const $e30a63e8d43c13f6$var$EMPTY_CACHE = {};
const $e30a63e8d43c13f6$var$INITIAL_CACHE = {};
const $e30a63e8d43c13f6$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $e30a63e8d43c13f6$export$23f2a1d2818174ef = typeof window != $e30a63e8d43c13f6$var$STR_UNDEFINED;
const $e30a63e8d43c13f6$export$efccba1c4a2ef57b = typeof document != $e30a63e8d43c13f6$var$STR_UNDEFINED;
const $e30a63e8d43c13f6$export$d141bba7fdc215a3 = $e30a63e8d43c13f6$export$23f2a1d2818174ef && 'Deno' in window;
const $e30a63e8d43c13f6$export$4a5767248b18ef41 = ()=>$e30a63e8d43c13f6$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $e30a63e8d43c13f6$var$STR_UNDEFINED;
const $e30a63e8d43c13f6$export$df995fae86a55f06 = (cache, key)=>{
    const state = $e30a63e8d43c13f6$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$e30a63e8d43c13f6$export$f1e1789686576879(key) && cache.get(key) || $e30a63e8d43c13f6$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$e30a63e8d43c13f6$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $e30a63e8d43c13f6$var$INITIAL_CACHE)) $e30a63e8d43c13f6$var$INITIAL_CACHE[key] = prev;
                state[5](key, $e30a63e8d43c13f6$export$953cecd6e717a553(prev, info), prev || $e30a63e8d43c13f6$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$e30a63e8d43c13f6$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $e30a63e8d43c13f6$var$INITIAL_CACHE) return $e30a63e8d43c13f6$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$e30a63e8d43c13f6$export$f1e1789686576879(key) && cache.get(key) || $e30a63e8d43c13f6$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $e30a63e8d43c13f6$var$online = true;
const $e30a63e8d43c13f6$var$isOnline = ()=>$e30a63e8d43c13f6$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$e30a63e8d43c13f6$var$onWindowEvent, $e30a63e8d43c13f6$var$offWindowEvent] = $e30a63e8d43c13f6$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $e30a63e8d43c13f6$export$ebd11618f299a286,
    $e30a63e8d43c13f6$export$ebd11618f299a286
];
const $e30a63e8d43c13f6$var$isVisible = ()=>{
    const visibilityState = $e30a63e8d43c13f6$export$efccba1c4a2ef57b && document.visibilityState;
    return $e30a63e8d43c13f6$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $e30a63e8d43c13f6$var$initFocus = (callback)=>{
    // focus revalidate
    if ($e30a63e8d43c13f6$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $e30a63e8d43c13f6$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($e30a63e8d43c13f6$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $e30a63e8d43c13f6$var$offWindowEvent('focus', callback);
    };
};
const $e30a63e8d43c13f6$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $e30a63e8d43c13f6$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $e30a63e8d43c13f6$var$online = false;
    };
    $e30a63e8d43c13f6$var$onWindowEvent('online', onOnline);
    $e30a63e8d43c13f6$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $e30a63e8d43c13f6$var$offWindowEvent('online', onOnline);
        $e30a63e8d43c13f6$var$offWindowEvent('offline', onOffline);
    };
};
const $e30a63e8d43c13f6$export$ffb5f4729a158638 = {
    isOnline: $e30a63e8d43c13f6$var$isOnline,
    isVisible: $e30a63e8d43c13f6$var$isVisible
};
const $e30a63e8d43c13f6$export$9e5f44173e64f162 = {
    initFocus: $e30a63e8d43c13f6$var$initFocus,
    initReconnect: $e30a63e8d43c13f6$var$initReconnect
};
const $e30a63e8d43c13f6$export$43caf9889c228507 = !(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId;
const $e30a63e8d43c13f6$export$9bb611d729802a56 = !$e30a63e8d43c13f6$export$23f2a1d2818174ef || $e30a63e8d43c13f6$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $e30a63e8d43c13f6$export$625550452a3fa3ec = (f)=>$e30a63e8d43c13f6$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $e30a63e8d43c13f6$export$3b14a55fb2447963 = $e30a63e8d43c13f6$export$9bb611d729802a56 ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $e30a63e8d43c13f6$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $e30a63e8d43c13f6$export$90a7f3efeed30595 = !$e30a63e8d43c13f6$export$9bb611d729802a56 && $e30a63e8d43c13f6$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($e30a63e8d43c13f6$var$navigatorConnection.effectiveType) || $e30a63e8d43c13f6$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $e30a63e8d43c13f6$var$table = new WeakMap();
const $e30a63e8d43c13f6$var$getTypeName = (value)=>$e30a63e8d43c13f6$export$c4ce752e73470fba.prototype.toString.call(value);
const $e30a63e8d43c13f6$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $e30a63e8d43c13f6$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $e30a63e8d43c13f6$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $e30a63e8d43c13f6$var$getTypeName(arg);
    const isDate = $e30a63e8d43c13f6$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $e30a63e8d43c13f6$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $e30a63e8d43c13f6$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($e30a63e8d43c13f6$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $e30a63e8d43c13f6$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$e30a63e8d43c13f6$var$counter + '~';
        $e30a63e8d43c13f6$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $e30a63e8d43c13f6$export$882b5998b3b9117c(arg[index]) + ',';
            $e30a63e8d43c13f6$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $e30a63e8d43c13f6$export$c4ce752e73470fba.keys(arg).sort();
            while(!$e30a63e8d43c13f6$export$f1e1789686576879(index = keys.pop()))if (!$e30a63e8d43c13f6$export$f1e1789686576879(arg[index])) result += index + ':' + $e30a63e8d43c13f6$export$882b5998b3b9117c(arg[index]) + ',';
            $e30a63e8d43c13f6$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $e30a63e8d43c13f6$export$2408f22a0fab9ae5 = (key)=>{
    if ($e30a63e8d43c13f6$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $e30a63e8d43c13f6$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $e30a63e8d43c13f6$var$__timestamp = 0;
const $e30a63e8d43c13f6$export$ae1af26003f05816 = ()=>++$e30a63e8d43c13f6$var$__timestamp;
async function $e30a63e8d43c13f6$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $e30a63e8d43c13f6$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($e30a63e8d43c13f6$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $e30a63e8d43c13f6$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $e30a63e8d43c13f6$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $e30a63e8d43c13f6$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $e30a63e8d43c13f6$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($78701249fecd496d$export$75ea288459391154).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $e30a63e8d43c13f6$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$e30a63e8d43c13f6$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $e30a63e8d43c13f6$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $e30a63e8d43c13f6$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($e30a63e8d43c13f6$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $e30a63e8d43c13f6$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($e30a63e8d43c13f6$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08,
                        _c: $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08,
                    _c: $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $e30a63e8d43c13f6$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $e30a63e8d43c13f6$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $e30a63e8d43c13f6$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$e30a63e8d43c13f6$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $e30a63e8d43c13f6$export$953cecd6e717a553($e30a63e8d43c13f6$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $e30a63e8d43c13f6$export$7ccc53e8f1e7dfc5.bind($e30a63e8d43c13f6$export$3a6d5c9ae78a2c08, provider);
        let unmount = $e30a63e8d43c13f6$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$e30a63e8d43c13f6$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $e30a63e8d43c13f6$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$e30a63e8d43c13f6$export$9bb611d729802a56) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($e30a63e8d43c13f6$export$3a6d5c9ae78a2c08, $e30a63e8d43c13f6$var$revalidateAllKeys.bind($e30a63e8d43c13f6$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $78701249fecd496d$export$831c820ad60f9d12)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($e30a63e8d43c13f6$export$3a6d5c9ae78a2c08, $e30a63e8d43c13f6$var$revalidateAllKeys.bind($e30a63e8d43c13f6$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $78701249fecd496d$export$24e9454cb99a11dc)));
                    unmount = ()=>{
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseFocus && releaseFocus();
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $e30a63e8d43c13f6$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $e30a63e8d43c13f6$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $e30a63e8d43c13f6$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$e30a63e8d43c13f6$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $e30a63e8d43c13f6$export$342063e11d6c3cad = (0, $0790fe16af8106e5$export$de8294bb3be0322f);
// Default cache provider
const [$e30a63e8d43c13f6$export$db3b6bfb95261072, $e30a63e8d43c13f6$export$35e795649ee09318] = $e30a63e8d43c13f6$export$dda1d9f60106f0e9(new Map());
// Default config
const $e30a63e8d43c13f6$export$4368d992c4eafac0 = $e30a63e8d43c13f6$export$953cecd6e717a553({
    // events
    onLoadingSlow: $e30a63e8d43c13f6$export$ebd11618f299a286,
    onSuccess: $e30a63e8d43c13f6$export$ebd11618f299a286,
    onError: $e30a63e8d43c13f6$export$ebd11618f299a286,
    onErrorRetry: $e30a63e8d43c13f6$var$onErrorRetry,
    onDiscarded: $e30a63e8d43c13f6$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $e30a63e8d43c13f6$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $e30a63e8d43c13f6$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $e30a63e8d43c13f6$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $e30a63e8d43c13f6$export$db3b6bfb95261072,
    mutate: $e30a63e8d43c13f6$export$35e795649ee09318,
    fallback: {}
}, $e30a63e8d43c13f6$export$ffb5f4729a158638);
const $e30a63e8d43c13f6$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $e30a63e8d43c13f6$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $e30a63e8d43c13f6$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $e30a63e8d43c13f6$export$25ce5a424b770e84 = (0, $acw62.createContext)({});
const $e30a63e8d43c13f6$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $acw62.useContext)($e30a63e8d43c13f6$export$25ce5a424b770e84);
    const isFunctionalConfig = $e30a63e8d43c13f6$export$407448d2b89b1813(value);
    const config = (0, $acw62.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $acw62.useMemo)(()=>isFunctionalConfig ? config : $e30a63e8d43c13f6$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $acw62.useRef)($e30a63e8d43c13f6$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $e30a63e8d43c13f6$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $e30a63e8d43c13f6$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $e30a63e8d43c13f6$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $acw62.createElement)($e30a63e8d43c13f6$export$25ce5a424b770e84.Provider, $e30a63e8d43c13f6$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};



const $31b819a8af02b76f$export$8667f065faedc62c = '$inf$';



var $acw62 = parcelRequire("acw62");

// @ts-expect-error
const $73ef0a5623b28096$var$enableDevtools = (0, $e30a63e8d43c13f6$export$23f2a1d2818174ef) && window.__SWR_DEVTOOLS_USE__;
const $73ef0a5623b28096$var$use = $73ef0a5623b28096$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $73ef0a5623b28096$var$setupDevTools = ()=>{
    if ($73ef0a5623b28096$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
};
const $73ef0a5623b28096$export$a3295358bff77e = (args)=>{
    return (0, $e30a63e8d43c13f6$export$407448d2b89b1813)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $73ef0a5623b28096$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $acw62.useContext)((0, $e30a63e8d43c13f6$export$25ce5a424b770e84));
    const mergedConfig = (0, $acw62.useMemo)(()=>(0, $e30a63e8d43c13f6$export$953cecd6e717a553)((0, $e30a63e8d43c13f6$export$4368d992c4eafac0), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $73ef0a5623b28096$export$513ccb98c53b8039 = (key_, fetcher)=>{
    // preload should be a no-op on the server
    if (0, $e30a63e8d43c13f6$export$9bb611d729802a56) return undefined;
    const [key, fnArg] = (0, $e30a63e8d43c13f6$export$2408f22a0fab9ae5)(key_);
    const [, , , PRELOAD] = (0, $e30a63e8d43c13f6$export$8b22cf2602fb60ce).get((0, $e30a63e8d43c13f6$export$db3b6bfb95261072));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $73ef0a5623b28096$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $e30a63e8d43c13f6$export$2408f22a0fab9ae5)(key_);
            const [, , , PRELOAD] = (0, $e30a63e8d43c13f6$export$8b22cf2602fb60ce).get((0, $e30a63e8d43c13f6$export$db3b6bfb95261072));
            if (key.startsWith((0, $31b819a8af02b76f$export$8667f065faedc62c))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $e30a63e8d43c13f6$export$f1e1789686576879)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $73ef0a5623b28096$var$BUILT_IN_MIDDLEWARE = $73ef0a5623b28096$var$use.concat($73ef0a5623b28096$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $73ef0a5623b28096$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $73ef0a5623b28096$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $73ef0a5623b28096$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $e30a63e8d43c13f6$export$2d1720544b23b823)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($73ef0a5623b28096$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $73ef0a5623b28096$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $73ef0a5623b28096$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $73ef0a5623b28096$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$73ef0a5623b28096$var$setupDevTools();


// Shared state between server components and client components
const $9ef683e011c31ff0$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $9ef683e011c31ff0$var$UNDEFINED = /*#__NOINLINE__*/ $9ef683e011c31ff0$var$noop();
const $9ef683e011c31ff0$var$OBJECT = Object;
const $9ef683e011c31ff0$var$isUndefined = (v)=>v === $9ef683e011c31ff0$var$UNDEFINED;
const $9ef683e011c31ff0$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $9ef683e011c31ff0$var$table = new WeakMap();
const $9ef683e011c31ff0$var$getTypeName = (value)=>$9ef683e011c31ff0$var$OBJECT.prototype.toString.call(value);
const $9ef683e011c31ff0$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $9ef683e011c31ff0$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $9ef683e011c31ff0$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $9ef683e011c31ff0$var$getTypeName(arg);
    const isDate = $9ef683e011c31ff0$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $9ef683e011c31ff0$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $9ef683e011c31ff0$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($9ef683e011c31ff0$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $9ef683e011c31ff0$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$9ef683e011c31ff0$var$counter + '~';
        $9ef683e011c31ff0$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $9ef683e011c31ff0$var$stableHash(arg[index]) + ',';
            $9ef683e011c31ff0$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $9ef683e011c31ff0$var$OBJECT.keys(arg).sort();
            while(!$9ef683e011c31ff0$var$isUndefined(index = keys.pop()))if (!$9ef683e011c31ff0$var$isUndefined(arg[index])) result += index + ':' + $9ef683e011c31ff0$var$stableHash(arg[index]) + ',';
            $9ef683e011c31ff0$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $9ef683e011c31ff0$var$serialize = (key)=>{
    if ($9ef683e011c31ff0$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $9ef683e011c31ff0$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $9ef683e011c31ff0$export$dbab534a48e651ef = (key)=>$9ef683e011c31ff0$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $9ef683e011c31ff0$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $9ef683e011c31ff0$var$WITH_DEDUPE = {
    dedupe: true
};
const $9ef683e011c31ff0$var$resolvedUndef = Promise.resolve((0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08));
const $9ef683e011c31ff0$var$sub = ()=>(0, $e30a63e8d43c13f6$export$ebd11618f299a286);
/**
 * The core implementation of the useSWR hook.
 *
 * This is the main handler function that implements all SWR functionality including
 * data fetching, caching, revalidation, error handling, and state management.
 * It manages the complete lifecycle of SWR requests from initialization through
 * cleanup.
 *
 * Key responsibilities:
 * - Key serialization and normalization
 * - Cache state management and synchronization
 * - Automatic and manual revalidation
 * - Error handling and retry logic
 * - Suspense integration
 * - Loading state management
 * - Effect cleanup and memory management
 *
 * @template Data - The type of data returned by the fetcher
 * @template Error - The type of error that can be thrown
 *
 * @param _key - The SWR key (string, array, object, function, or falsy)
 * @param fetcher - The fetcher function to retrieve data, or null to disable fetching
 * @param config - Complete SWR configuration object with both public and internal options
 *
 * @returns SWRResponse object containing data, error, mutate function, and loading states
 *
 * @internal This is the internal implementation. Use `useSWR` instead.
 */ const $9ef683e011c31ff0$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData, strictServerPrefetchWarning: strictServerPrefetchWarning } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $e30a63e8d43c13f6$export$8b22cf2602fb60ce).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $e30a63e8d43c13f6$export$2408f22a0fab9ae5)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $acw62.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $acw62.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $acw62.useRef)(key);
    const fetcherRef = (0, $acw62.useRef)(fetcher);
    const configRef = (0, $acw62.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache, key);
    const stateDependencies = (0, $acw62.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $e30a63e8d43c13f6$export$f1e1789686576879)(fallbackData) ? (0, $e30a63e8d43c13f6$export$f1e1789686576879)(config.fallback) ? (0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $e30a63e8d43c13f6$export$f1e1789686576879)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const isInitialMount = !initialMountedRef.current;
    const getSnapshot = (0, $acw62.useMemo)(()=>{
        const cachedData = getCache();
        const initialData = getInitialCache();
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $e30a63e8d43c13f6$export$953cecd6e717a553)(state);
            delete snapshot._k;
            const shouldStartRequest = (()=>{
                if (!key) return false;
                if (!fetcher) return false;
                // If it's paused, we skip revalidation.
                if (getConfig().isPaused()) return false;
                // If `revalidateOnMount` is set, we take the value directly.
                if (isInitialMount && !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
                const data = !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(fallback) ? fallback : snapshot.data;
                if (suspense) return (0, $e30a63e8d43c13f6$export$f1e1789686576879)(data) || revalidateIfStale;
                return (0, $e30a63e8d43c13f6$export$f1e1789686576879)(data) || revalidateIfStale;
            })();
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)((0, $acw62.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $e30a63e8d43c13f6$export$f1e1789686576879)(cachedData) ? fallback && (0, $e30a63e8d43c13f6$export$ef35774e6d314e91)(fallback) ? $9ef683e011c31ff0$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $acw62.useRef)(data);
    const returnedData = keepPreviousData ? (0, $e30a63e8d43c13f6$export$f1e1789686576879)(cachedData) ? (0, $e30a63e8d43c13f6$export$f1e1789686576879)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    const hasKeyButNoData = key && (0, $e30a63e8d43c13f6$export$f1e1789686576879)(data);
    const hydrationRef = (0, $acw62.useRef)(null);
    // Note: the conditionally hook call is fine because the environment
    // `IS_SERVER` never changes.
    // @ts-expect-error -- use hydrationRef directly
    !(0, $e30a63e8d43c13f6$export$9bb611d729802a56) && // getServerSnapshot is only called during hydration
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)($9ef683e011c31ff0$var$sub, ()=>{
        hydrationRef.current = false;
        return hydrationRef;
    }, ()=>{
        hydrationRef.current = true;
        return hydrationRef;
    });
    const isHydration = hydrationRef.current;
    // During the initial SSR render, warn if the key has no data pre-fetched via:
    // - fallback data
    // - preload calls
    // - initial data from the cache provider
    // We only warn once for each key during Hydration.
    if (strictServerPrefetchWarning && isHydration && !suspense && hasKeyButNoData) console.warn(`Missing pre-initiated data for serialized key "${key}" during server-side rendering. Data fetching should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        if (!key || !fetcher) return false;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $e30a63e8d43c13f6$export$f1e1789686576879)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $e30a63e8d43c13f6$export$f1e1789686576879)(data) || revalidateIfStale;
    })();
    const defaultValidatingState = isInitialMount && shouldDoInitialRevalidation;
    const isValidating = (0, $e30a63e8d43c13f6$export$f1e1789686576879)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $e30a63e8d43c13f6$export$f1e1789686576879)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $acw62.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $e30a63e8d43c13f6$export$43caf9889c228507) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $e30a63e8d43c13f6$export$f1e1789686576879)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $e30a63e8d43c13f6$export$f1e1789686576879)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $e30a63e8d43c13f6$export$ae1af26003f05816)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $e30a63e8d43c13f6$export$f1e1789686576879)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $e30a63e8d43c13f6$export$407448d2b89b1813)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $78701249fecd496d$exports).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $acw62.useCallback)((...args)=>{
        return (0, $e30a63e8d43c13f6$export$7ccc53e8f1e7dfc5)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $e30a63e8d43c13f6$export$3b14a55fb2447963)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $e30a63e8d43c13f6$export$f1e1789686576879)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $e30a63e8d43c13f6$export$3b14a55fb2447963)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08), $9ef683e011c31ff0$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $78701249fecd496d$exports).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $78701249fecd496d$exports).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $78701249fecd496d$exports).MUTATE_EVENT) return revalidate();
            else if (type == (0, $78701249fecd496d$exports).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $73ef0a5623b28096$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $e30a63e8d43c13f6$export$f1e1789686576879)(data) || (0, $e30a63e8d43c13f6$export$9bb611d729802a56)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $e30a63e8d43c13f6$export$625550452a3fa3ec)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $e30a63e8d43c13f6$export$3b14a55fb2447963)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $e30a63e8d43c13f6$export$407448d2b89b1813)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($9ef683e011c31ff0$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $acw62.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $e30a63e8d43c13f6$export$43caf9889c228507) && (0, $e30a63e8d43c13f6$export$9bb611d729802a56) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(req) && hasKeyButNoData ? boundMutate(req) : $9ef683e011c31ff0$var$resolvedUndef;
        $9ef683e011c31ff0$var$use(mutateReq);
        if (!(0, $e30a63e8d43c13f6$export$f1e1789686576879)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($9ef683e011c31ff0$var$WITH_DEDUPE) : $9ef683e011c31ff0$var$resolvedUndef;
        if (!(0, $e30a63e8d43c13f6$export$f1e1789686576879)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $9ef683e011c31ff0$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $9ef683e011c31ff0$export$4c7bbecdacc3ca2c = (0, $e30a63e8d43c13f6$export$c4ce752e73470fba).defineProperty((0, $e30a63e8d43c13f6$export$39b482c5e57630a8), 'defaultValue', {
    value: (0, $e30a63e8d43c13f6$export$4368d992c4eafac0)
});
/**
 * A hook to fetch data.
 *
 * @see {@link https://swr.vercel.app}
 *
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $9ef683e011c31ff0$export$2e2bcd8739ae039 = (0, $73ef0a5623b28096$export$84d44e54e14b0133)($9ef683e011c31ff0$var$useSWRHandler);


const $9efcf42537b67d79$var$CLIENT_ID = '07a30b365ca6f9eb8c5f';
const $9efcf42537b67d79$export$85c7dd0b0150981e = new (0, $cbd19688a58ede89$export$d19f1ac68c042717)({
    auth: localStorage.token
});
const $9efcf42537b67d79$export$1eb4e7c0ed67b035 = (0, $39f88b0047acdf3a$export$1eb4e7c0ed67b035).defaults({
    headers: {
        authorization: `token ${localStorage.token}`,
        'If-None-Match': ''
    }
});
function $9efcf42537b67d79$var$runQuery([query, options]) {
    return $9efcf42537b67d79$export$1eb4e7c0ed67b035(query, options);
}
function $9efcf42537b67d79$export$dd0a697e1782aedd(query, options) {
    return (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        query,
        options
    ], $9efcf42537b67d79$var$runQuery);
}
function $9efcf42537b67d79$export$513ccb98c53b8039(query, options) {
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        query,
        options
    ], $9efcf42537b67d79$var$runQuery);
}
async function $9efcf42537b67d79$export$596d806903d1f59e() {
    let url = new URL(location.href);
    let code = url.searchParams.get('code');
    if (!code) {
        let redirect = new URL('https://github.com/login/oauth/authorize');
        redirect.searchParams.set('client_id', $9efcf42537b67d79$var$CLIENT_ID);
        redirect.searchParams.set('scope', 'repo notifications read:user');
        location.replace(redirect);
        return;
    }
    try {
        let res = await fetch('https://github-lite.pages.dev/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: code
            })
        });
        let json = await res.json();
        if (json.error) {
            console.log(json);
            return;
        }
        localStorage.token = json.token;
        url.searchParams.delete('code');
        location.replace(url);
    } catch (err) {
        console.log(err);
    // location.reload();
    }
}




var $acw62 = parcelRequire("acw62");






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e77d43ed667323b$export$dcf14c9974fe2767(props, ref) {
    let { elementType: elementType = 'a', onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onClick: onClick, isDisabled: isDisabled, ...otherProps } = props;
    let linkProps = {};
    if (elementType !== 'a') linkProps = {
        role: 'link',
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)(props, ref);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onClick: onClick,
        isDisabled: isDisabled,
        ref: ref
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(otherProps, {
        labelable: true
    });
    let interactionHandlers = (0, $195af97314dd822a$export$9d1611c77c2fe928)(focusableProps, pressProps);
    let router = (0, $dc5a334d7ad7481f$export$9a302a45f65d0572)();
    let routerLinkProps = (0, $dc5a334d7ad7481f$export$7e924b3091a3bd18)(props);
    return {
        isPressed: isPressed,
        linkProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, routerLinkProps, {
            ...interactionHandlers,
            ...linkProps,
            'aria-disabled': isDisabled || undefined,
            'aria-current': props['aria-current'],
            onClick: (e)=>{
                pressProps.onClick?.(e);
                (0, $dc5a334d7ad7481f$export$13aea1a3cb5e3f1f)(e, router, props.href, props.routerOptions);
            }
        })
    };
}





var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6ddc0a4000e0be42$export$e2509388b49734e7 = (0, $acw62.createContext)(null);
const $6ddc0a4000e0be42$export$a6c7ac8248d6e38a = (0, $acw62.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $6ddc0a4000e0be42$export$e2509388b49734e7);
    let elementType = props.href && !props.isDisabled ? 'a' : 'span';
    let { linkProps: linkProps, isPressed: isPressed } = (0, $1e77d43ed667323b$export$dcf14c9974fe2767)({
        ...props,
        elementType: elementType
    }, ref);
    let ElementType = (0, $78f7e4721048d8d5$export$df3a06d6289f983e)[elementType];
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)(props);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $0cde480b945a073a$export$4e328f61c538687f)();
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-Link',
        values: {
            isCurrent: !!props['aria-current'],
            isDisabled: props.isDisabled || false,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        }
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        ref: ref,
        slot: props.slot || undefined,
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, linkProps, hoverProps, focusProps),
        "data-focused": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-pressed": isPressed || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-current": !!props['aria-current'] || undefined,
        "data-disabled": props.isDisabled || undefined
    }, renderProps.children);
});



//#region src/constants.ts
const $6986aac91971cc6d$export$b583bc7fc1f35cf2 = "diffs-container";
const $6986aac91971cc6d$export$5d8096ed6304226f = (()=>{
    try {
        return false;
    } catch  {
        return false;
    }
})();
const $6986aac91971cc6d$export$64db5225fde41a22 = /(?=^From [a-f0-9]+ .+$)/m;
const $6986aac91971cc6d$export$b75cb078234a235b = /(?=^diff --git)/gm;
const $6986aac91971cc6d$export$78d496632eb5f480 = /(?=^---\s+\S)/gm;
const $6986aac91971cc6d$export$7d6a48f2f5fa6256 = /(?=^@@ )/gm;
const $6986aac91971cc6d$export$890de5fd0aae4952 = /^@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@(?: (.*))?/m;
const $6986aac91971cc6d$export$e38f52bd77a3998f = /(?<=\n)/;
const $6986aac91971cc6d$export$9ebdc190d177668f = /^(---|\+\+\+)\s+([^\t\r\n]+)/;
const $6986aac91971cc6d$export$5f2aa894870f6d12 = /^(---|\+\+\+)\s+[ab]\/([^\t\r\n]+)/;
const $6986aac91971cc6d$export$29edab3653b8abd8 = /^diff --git (?:"a\/(.+?)"|a\/(.+?)) (?:"b\/(.+?)"|b\/(.+?))$/;
const $6986aac91971cc6d$export$9ef7bb7f59189d = /^index ([0-9a-f]+)\.\.([0-9a-f]+)(?: (\d+))?$/i;
const $6986aac91971cc6d$export$27bb7a016053d82f = /^<{7,}(?:\s.*)?$/;
const $6986aac91971cc6d$export$fa318698bde06c81 = /^\|{7,}(?:\s.*)?$/;
const $6986aac91971cc6d$export$a4cbc584c4f320f1 = /^={7,}$/;
const $6986aac91971cc6d$export$d22db74036528f70 = /^>{7,}(?:\s.*)?$/;
const $6986aac91971cc6d$export$69d2d3bd52efd12a = "header-prefix";
const $6986aac91971cc6d$export$f5d94b4150f59afc = "header-metadata";
const $6986aac91971cc6d$export$87f913619cd5fa67 = "header-custom";
const $6986aac91971cc6d$export$bcfc57767d137a59 = {
    dark: "pierre-dark",
    light: "pierre-light"
};
const $6986aac91971cc6d$export$4ce037b01ed1780d = "data-theme-css";
const $6986aac91971cc6d$export$26189492e726cd65 = "data-unsafe-css";
const $6986aac91971cc6d$export$4145a617a0026c98 = "data-core-css";
const $6986aac91971cc6d$export$a3a60f81190d4ebe = "data-diffs-scrollbar-measure";
const $6986aac91971cc6d$export$de04582b73a6bf54 = "--diffs-scrollbar-gutter-measured";
const $6986aac91971cc6d$export$54c265eef46f12ac = 1;
const $6986aac91971cc6d$export$b31ab775814f11e2 = 1e5;
const $6986aac91971cc6d$export$e77df7b39261553f = {
    hunkLineCount: 50,
    lineHeight: 20,
    diffHeaderHeight: 44,
    spacing: 8
};
const $6986aac91971cc6d$export$c5e987fe582d77c0 = {
    ...$6986aac91971cc6d$export$e77df7b39261553f,
    hunkLineCount: 1
};
const $6986aac91971cc6d$export$8e5cf365ea11c6b = {
    paddingTop: 8,
    paddingBottom: 8,
    gap: 8
};
const $6986aac91971cc6d$export$9de45920e0505112 = {
    omega: .015,
    positionEpsilon: .5,
    velocityEpsilon: .05
};
const $6986aac91971cc6d$export$6c97fd980b17f9d2 = Object.freeze({
    fromStart: 0,
    fromEnd: 0
});
const $6986aac91971cc6d$export$de9ceafea6c24cf3 = {
    startingLine: 0,
    totalLines: Infinity,
    bufferBefore: 0,
    bufferAfter: 0
};
const $6986aac91971cc6d$export$af82796f7deef107 = {
    startingLine: 0,
    totalLines: 0,
    bufferBefore: 0,
    bufferAfter: 0
};


//#region src/utils/areObjectsEqual.ts
function $3ec53e4f7bbd4269$export$1db8244ab969c6c6(objA, objB, omitKeys) {
    if (objA === objB || objA == null || objB == null) return objA === objB;
    const omitSet = new Set(omitKeys);
    const keysA = Object.keys(objA);
    const keysBSet = new Set(Object.keys(objB));
    for (const key of keysA){
        keysBSet.delete(key);
        if (omitSet.has(key)) continue;
        if (!(key in objB) || objA[key] !== objB[key]) return false;
    }
    for (const key of Array.from(keysBSet))if (!omitSet.has(key)) return false;
    return true;
}


//#region src/utils/areThemesEqual.ts
function $0246eee5e18b0420$export$e40448283aec01f1(themeA, themeB) {
    if (themeA == null || themeB == null || typeof themeA === "string" || typeof themeB === "string") return themeA === themeB;
    return themeA.dark === themeB.dark && themeA.light === themeB.light;
}


//#region src/utils/areOptionsEqual.ts
function $5e49faa8df06196c$export$1ace03bbcd701468(optionsA, optionsB) {
    const themeA = optionsA?.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59);
    const themeB = optionsB?.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59);
    const diffOptsA = $5e49faa8df06196c$var$getParseDiffOptions(optionsA);
    const diffOptsB = $5e49faa8df06196c$var$getParseDiffOptions(optionsB);
    return (0, $0246eee5e18b0420$export$e40448283aec01f1)(themeA, themeB) && (0, $3ec53e4f7bbd4269$export$1db8244ab969c6c6)(optionsA, optionsB, [
        "theme",
        "parseDiffOptions"
    ]) && (0, $3ec53e4f7bbd4269$export$1db8244ab969c6c6)(diffOptsA, diffOptsB);
}
function $5e49faa8df06196c$var$getParseDiffOptions(options) {
    if (options != null && "parseDiffOptions" in options) return options.parseDiffOptions;
}



//#region src/managers/UniversalRenderingManager.ts
let $c4a6ed6d38b63558$var$callbacks = /* @__PURE__ */ new Set();
let $c4a6ed6d38b63558$var$frameId = null;
function $c4a6ed6d38b63558$export$7b4bf160c2c55328(callback) {
    $c4a6ed6d38b63558$var$callbacks.add(callback);
    $c4a6ed6d38b63558$var$frameId ??= requestAnimationFrame($c4a6ed6d38b63558$var$render);
}
function $c4a6ed6d38b63558$export$932f2205472a6595(callback) {
    $c4a6ed6d38b63558$var$callbacks.delete(callback);
    if ($c4a6ed6d38b63558$var$callbacks.size === 0 && $c4a6ed6d38b63558$var$frameId != null) {
        cancelAnimationFrame($c4a6ed6d38b63558$var$frameId);
        $c4a6ed6d38b63558$var$frameId = null;
    }
}
function $c4a6ed6d38b63558$var$render(time) {
    const toIterate = new Set($c4a6ed6d38b63558$var$callbacks);
    $c4a6ed6d38b63558$var$callbacks.clear();
    for (const callback of toIterate)try {
        callback(time);
    } catch (error) {
        console.error(error);
    }
    if ($c4a6ed6d38b63558$var$callbacks.size > 0) $c4a6ed6d38b63558$var$frameId = requestAnimationFrame($c4a6ed6d38b63558$var$render);
    else $c4a6ed6d38b63558$var$frameId = null;
}



//#region src/utils/areSelectionsEqual.ts
function $b650ccf3ff2748b4$export$cfda57044a46e9e2(selectionA, selectionB) {
    return selectionA?.start === selectionB?.start && selectionA?.end === selectionB?.end && selectionA?.side === selectionB?.side && selectionA?.endSide === selectionB?.endSide;
}



//#region src/utils/createWindowFromScrollPosition.ts
function $71eae0748844a945$export$182aa6646dae80cc({ scrollTop: scrollTop, scrollHeight: scrollHeight, height: height, fitPerfectly: fitPerfectly = false, fitPerfectlyOverscroll: fitPerfectlyOverscroll = 0, overscrollSize: overscrollSize }) {
    const windowHeight = height + overscrollSize * 2;
    const effectiveHeight = fitPerfectly ? height + fitPerfectlyOverscroll * 2 : windowHeight;
    scrollHeight = Math.max(scrollHeight, effectiveHeight);
    if (windowHeight >= scrollHeight || fitPerfectly) {
        const top$1 = Math.max(scrollTop - fitPerfectlyOverscroll, 0);
        const bottom$1 = Math.min(scrollTop + effectiveHeight, scrollHeight);
        return {
            top: top$1,
            bottom: Math.max(bottom$1, top$1)
        };
    }
    let top = scrollTop + height / 2 - windowHeight / 2;
    let bottom = top + windowHeight;
    if (top < 0) top = 0;
    if (bottom > scrollHeight) bottom = scrollHeight;
    top = Math.floor(Math.max(top, 0));
    return {
        top: top,
        bottom: Math.ceil(Math.max(Math.min(bottom, scrollHeight), top))
    };
}


//#region src/utils/isStyleNode.ts
function $0d4053e5b759c704$export$1405a8e7808a3d28(element) {
    if (typeof HTMLStyleElement !== "undefined" && element instanceof HTMLStyleElement) return true;
    const tagName = element.tagName ?? element.nodeName;
    return typeof tagName === "string" && tagName.toLowerCase() === "style";
}


//#region src/utils/prefersReducedMotion.ts
function $930cfefdc5651f76$export$ff7706047246b98b() {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}


//#region src/utils/roundToDevicePixel.ts
/**
* Snap a CSS-pixel value to the nearest device-pixel boundary. Browsers store
* scrollTop on the device-pixel grid on fractional-DPR displays (1.25x, 1.5x,
* etc.), so rounding computed scroll targets against that grid keeps delta
* math settling cleanly instead of hovering around fractional residuals.
*
* Reads window.devicePixelRatio fresh on each call so monitor-switching and
* zoom changes are picked up without needing to flush any cached value.
*/ function $57a3bb19b0510d4e$export$8c36de38ff643fe0(value) {
    const dpr = window.devicePixelRatio ?? 1;
    return Math.round(value * dpr) / dpr;
}






//#region src/utils/computeVirtualFileMetrics.ts
function $f700fc78f9a614b9$export$1acb458e99845a9f(metrics) {
    return {
        ...(0, $6986aac91971cc6d$export$e77df7b39261553f),
        ...metrics
    };
}
function $f700fc78f9a614b9$export$79fff7cc5b11b8b(metrics, disableFileHeader) {
    const paddingTop = $f700fc78f9a614b9$export$6bfc180fb586b15a(metrics, disableFileHeader);
    return disableFileHeader ? paddingTop : metrics.diffHeaderHeight + paddingTop;
}
function $f700fc78f9a614b9$export$6bfc180fb586b15a(metrics, disableFileHeader) {
    return metrics.paddingTop ?? (disableFileHeader ? metrics.spacing : 0);
}
function $f700fc78f9a614b9$export$7dbace702b635f2(metrics) {
    return metrics.paddingBottom ?? metrics.spacing;
}
function $f700fc78f9a614b9$export$84b205b9d7905293(type) {
    switch(type){
        case "simple":
            return 4;
        case "metadata":
        case "line-info":
        case "line-info-basic":
        case "custom":
            return 32;
    }
}


//#region src/utils/iterateOverFile.ts
/**
* Iterates over lines in a file with optional windowing support.
*
* Similar to `iterateOverDiff` but simplified for linear file content.
* Supports viewport windowing for virtualization scenarios.
*
* @param props - Configuration for iteration
* @param props.lines - Pre-split array of lines (use splitFileContents() to create from string)
* @param props.startingLine - Optional starting line index (0-based, default: 0)
* @param props.totalLines - Optional max lines to iterate (default: Infinity)
* @param props.callback - Callback invoked for each line in the window.
*                         Return `true` to stop iteration early.
*
* @example
* ```typescript
* const lines = splitFileContents('line1\nline2\nline3');
* iterateOverFile({
*   lines,
*   startingLine: 0,
*   totalLines: 10,
*   callback: ({ lineIndex, lineNumber, content, isLastLine }) => {
*     console.log(`Line ${lineNumber}: ${content}`);
*     if (content.includes('stop')) return true; // Stop iteration
*   }
* });
* ```
*/ function $d2a7ea3ff52c7aba$export$bd45a6ae4d225463({ lines: lines, startingLine: startingLine = 0, totalLines: totalLines = Infinity, callback: callback }) {
    const len = Math.min(startingLine + totalLines, lines.length);
    const lastLineIndex = (()=>{
        const lastLine = lines.at(-1);
        if (lastLine === "" || lastLine === "\n" || lastLine === "\r\n" || lastLine === "\r") return Math.max(0, lines.length - 2);
        return lines.length - 1;
    })();
    for(let lineIndex = startingLine; lineIndex < len; lineIndex++){
        const isLastLine = lineIndex === lastLineIndex;
        if (callback({
            lineIndex: lineIndex,
            lineNumber: lineIndex + 1,
            content: lines[lineIndex],
            isLastLine: isLastLine
        }) === true || isLastLine) break;
    }
}






//#region src/utils/areSelectionPointsEqual.ts
function $75787b05c237bca2$export$631bac48ee645801(a, b) {
    return a.lineNumber === b.lineNumber && a.side === b.side;
}


//#region src/utils/hast_utils.ts
function $f6f1fb01992c2ec8$export$696d4285af91566e(value) {
    return {
        type: "text",
        value: value
    };
}
function $f6f1fb01992c2ec8$export$2099ac7106a04fb9({ tagName: tagName, children: children = [], properties: properties = {} }) {
    return {
        type: "element",
        tagName: tagName,
        properties: properties,
        children: children
    };
}
function $f6f1fb01992c2ec8$export$2f9411727149fee9({ name: name, width: width = 16, height: height = 16, properties: properties }) {
    return $f6f1fb01992c2ec8$export$2099ac7106a04fb9({
        tagName: "svg",
        properties: {
            width: width,
            height: height,
            viewBox: "0 0 16 16",
            ...properties
        },
        children: [
            $f6f1fb01992c2ec8$export$2099ac7106a04fb9({
                tagName: "use",
                properties: {
                    href: `#${name.replace(/^#/, "")}`
                }
            })
        ]
    });
}
function $f6f1fb01992c2ec8$export$839d57c14284d860(nodes) {
    let firstChild = nodes.children[0];
    while(firstChild != null){
        if (firstChild.type === "element" && firstChild.tagName === "code") return firstChild;
        if ("children" in firstChild) firstChild = firstChild.children[0];
        else firstChild = null;
    }
}
function $f6f1fb01992c2ec8$export$275418e72db785cd(children) {
    return $f6f1fb01992c2ec8$export$2099ac7106a04fb9({
        tagName: "div",
        properties: {
            "data-gutter": ""
        },
        children: children
    });
}
function $f6f1fb01992c2ec8$export$6fcf2c49524b5dc1(lineType, lineNumber, lineIndex, properties = {}) {
    return $f6f1fb01992c2ec8$export$2099ac7106a04fb9({
        tagName: "div",
        properties: {
            "data-line-type": lineType,
            "data-column-number": lineNumber,
            "data-line-index": lineIndex,
            ...properties
        },
        children: lineNumber != null ? [
            $f6f1fb01992c2ec8$export$2099ac7106a04fb9({
                tagName: "span",
                properties: {
                    "data-line-number-content": ""
                },
                children: [
                    $f6f1fb01992c2ec8$export$696d4285af91566e(`${lineNumber}`)
                ]
            })
        ] : void 0
    });
}
function $f6f1fb01992c2ec8$export$8622585bcb778ce3(type, bufferType, size) {
    return $f6f1fb01992c2ec8$export$2099ac7106a04fb9({
        tagName: "div",
        properties: {
            "data-gutter-buffer": bufferType,
            "data-buffer-size": size,
            "data-line-type": bufferType === "annotation" ? void 0 : type,
            style: bufferType === "annotation" ? `grid-row: span ${size};` : `grid-row: span ${size};min-height:calc(${size} * 1lh);`
        }
    });
}


//#region src/utils/createGutterUtilityElement.ts
function $d08db92ce491bda4$export$96dc444f01cd03d9() {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "button",
        properties: {
            "data-utility-button": "",
            type: "button"
        },
        children: [
            (0, $f6f1fb01992c2ec8$export$2f9411727149fee9)({
                name: "diffs-icon-plus",
                properties: {
                    "data-icon": ""
                }
            })
        ]
    });
}


/**
 * @import {Nodes, Parents, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 * @import {Options as StringifyEntitiesOptions} from 'stringify-entities'
 */ /**
 * @typedef {Omit<StringifyEntitiesOptions, 'attribute' | 'escapeOnly' | 'subset'>} CharacterReferences
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [allowDangerousCharacters=false]
 *   Do not encode some characters which cause XSS vulnerabilities in older
 *   browsers (default: `false`).
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Allow `raw` nodes and insert them as raw HTML (default: `false`).
 *
 *   When `false`, `Raw` nodes are encoded.
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowParseErrors=false]
 *   Do not encode characters which cause parse errors (even though they work),
 *   to save bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [bogusComments=false]
 *   Use “bogus comments” instead of comments to save byes: `<?charlie>`
 *   instead of `<!--charlie-->` (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {CharacterReferences | null | undefined} [characterReferences]
 *   Configure how to serialize character references (optional).
 * @property {boolean | null | undefined} [closeEmptyElements=false]
 *   Close SVG elements without any content with slash (`/`) on the opening tag
 *   instead of an end tag: `<circle />` instead of `<circle></circle>`
 *   (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the HTML space.
 * @property {boolean | null | undefined} [closeSelfClosing=false]
 *   Close self-closing nodes with an extra slash (`/`): `<img />` instead of
 *   `<img>` (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [collapseEmptyAttributes=false]
 *   Collapse empty attributes: get `class` instead of `class=""` (default:
 *   `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: boolean attributes (such as `hidden`) are always collapsed.
 * @property {boolean | null | undefined} [omitOptionalTags=false]
 *   Omit optional opening and closing tags (default: `false`).
 *
 *   For example, in `<ol><li>one</li><li>two</li></ol>`, both `</li>` closing
 *   tags can be omitted.
 *   The first because it’s followed by another `li`, the last because it’s
 *   followed by nothing.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [preferUnquoted=false]
 *   Leave attributes unquoted if that results in less bytes (default: `false`).
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [quoteSmart=false]
 *   Use the other quote if that results in less bytes (default: `false`).
 * @property {Quote | null | undefined} [quote='"']
 *   Preferred quote to use (default: `'"'`).
 * @property {Space | null | undefined} [space='html']
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it (default: `'html'`).
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use [`xast`][xast] if you need to support SVG as XML.
 * @property {boolean | null | undefined} [tightAttributes=false]
 *   Join attributes together, without whitespace, if possible: get
 *   `class="a b"title="c d"` instead of `class="a b" title="c d"` to save
 *   bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightCommaSeparatedLists=false]
 *   Join known comma-separated attribute values with just a comma (`,`),
 *   instead of padding them on the right as well (`,␠`, where `␠` represents a
 *   space) (default: `false`).
 * @property {boolean | null | undefined} [tightDoctype=false]
 *   Drop unneeded spaces in doctypes: `<!doctypehtml>` instead of
 *   `<!doctype html>` to save bytes (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightSelfClosing=false]
 *   Do not use an extra space when closing self-closing elements: `<img/>`
 *   instead of `<img />` (default: `false`).
 *
 *   > 👉 **Note**: only used if `closeSelfClosing: true` or
 *   > `closeEmptyElements: true`.
 * @property {boolean | null | undefined} [upperDoctype=false]
 *   Use a `<!DOCTYPE…` instead of `<!doctype…` (default: `false`).
 *
 *   Useless except for XHTML.
 * @property {ReadonlyArray<string> | null | undefined} [voids]
 *   Tag names of elements to serialize without closing tag (default: `html-void-elements`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: It’s highly unlikely that you want to pass this, because
 *   > hast is not for XML, and HTML will not add more void elements.
 *
 * @typedef {'"' | "'"} Quote
 *   HTML quotes for attribute values.
 *
 * @typedef {Omit<Required<{[key in keyof Options]: Exclude<Options[key], null | undefined>}>, 'space' | 'quote'>} Settings
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Parents | undefined) => string} all
 *   Serialize the children of a parent node.
 * @property {Quote} alternative
 *   Alternative quote.
 * @property {(node: Nodes, index: number | undefined, parent: Parents | undefined) => string} one
 *   Serialize one node.
 * @property {Quote} quote
 *   Preferred quote.
 * @property {Schema} schema
 *   Current schema.
 * @property {Settings} settings
 *   User configuration.
 */ /**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $ab9d94f2edae641a$export$762508062d068de = [
    'area',
    'base',
    'basefont',
    'bgsound',
    'br',
    'col',
    'command',
    'embed',
    'frame',
    'hr',
    'image',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];


// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $ebcb43fb277eac89$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$ebcb43fb277eac89$export$19342e026b58ebb7.prototype.normal = {};
$ebcb43fb277eac89$export$19342e026b58ebb7.prototype.property = {};
$ebcb43fb277eac89$export$19342e026b58ebb7.prototype.space = undefined;


function $9557e96728c042cf$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $ebcb43fb277eac89$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ /**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $e8e4f4c42f412e49$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


/**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $5570beed4f72c7cb$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.attribute = '';
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.booleanish = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.boolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.defined = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.number = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.property = '';
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.space = undefined;


var $7bb28a628b951544$exports = {};

$parcel$export($7bb28a628b951544$exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377);
$parcel$export($7bb28a628b951544$exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f);
$parcel$export($7bb28a628b951544$exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa);
$parcel$export($7bb28a628b951544$exports, "number", () => $7bb28a628b951544$export$98e628dec113755e);
$parcel$export($7bb28a628b951544$exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e);
$parcel$export($7bb28a628b951544$exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3);
$parcel$export($7bb28a628b951544$exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd);
let $7bb28a628b951544$var$powers = 0;
const $7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return 2 ** ++$7bb28a628b951544$var$powers;
}


const $de3826e2cce515f8$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($7bb28a628b951544$exports);
class $de3826e2cce515f8$export$ea6b9f0064e88c9b extends (0, $5570beed4f72c7cb$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $de3826e2cce515f8$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $de3826e2cce515f8$var$checks.length){
            const check = $de3826e2cce515f8$var$checks[index];
            $de3826e2cce515f8$var$mark(this, $de3826e2cce515f8$var$checks[index], (mask & $7bb28a628b951544$exports[check]) === $7bb28a628b951544$exports[check]);
        }
    }
}
$de3826e2cce515f8$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) values[key] = value;
}



function $9ab7a0f2f5273cb1$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $de3826e2cce515f8$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $e8e4f4c42f412e49$export$a3295358bff77e)(property)] = property;
        normals[(0, $e8e4f4c42f412e49$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $ebcb43fb277eac89$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $90343b68c9a7ed34$export$4d2d26490572750a = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaColIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaColSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaControls: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaLevel: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaPressed: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaRowIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaRowSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaSelected: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueMin: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueNow: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $fa5ee16f731231fb$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f2ac7ad36db76cd1$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $fa5ee16f731231fb$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $71d94da779c1399e$export$c0bb0b647f701bb5 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        acceptCharset: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        accessKey: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $7bb28a628b951544$export$4a21f16c33752377),
        allowPaymentRequest: (0, $7bb28a628b951544$export$4a21f16c33752377),
        allowUserMedia: (0, $7bb28a628b951544$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $7bb28a628b951544$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        autoFocus: (0, $7bb28a628b951544$export$4a21f16c33752377),
        autoPlay: (0, $7bb28a628b951544$export$4a21f16c33752377),
        blocking: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $7bb28a628b951544$export$4a21f16c33752377),
        cite: null,
        className: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        cols: (0, $7bb28a628b951544$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        controls: (0, $7bb28a628b951544$export$4a21f16c33752377),
        controlsList: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        coords: (0, $7bb28a628b951544$export$98e628dec113755e) | (0, $7bb28a628b951544$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $7bb28a628b951544$export$4a21f16c33752377),
        defer: (0, $7bb28a628b951544$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $7bb28a628b951544$export$4a21f16c33752377),
        download: (0, $7bb28a628b951544$export$242ac3d3042558aa),
        draggable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $7bb28a628b951544$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        height: (0, $7bb28a628b951544$export$98e628dec113755e),
        hidden: (0, $7bb28a628b951544$export$242ac3d3042558aa),
        high: (0, $7bb28a628b951544$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        httpEquiv: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $7bb28a628b951544$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $7bb28a628b951544$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        itemRef: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        itemScope: (0, $7bb28a628b951544$export$4a21f16c33752377),
        itemType: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $7bb28a628b951544$export$4a21f16c33752377),
        low: (0, $7bb28a628b951544$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        multiple: (0, $7bb28a628b951544$export$4a21f16c33752377),
        muted: (0, $7bb28a628b951544$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noValidate: (0, $7bb28a628b951544$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $7bb28a628b951544$export$4a21f16c33752377),
        optimum: (0, $7bb28a628b951544$export$98e628dec113755e),
        pattern: null,
        ping: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $7bb28a628b951544$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $7bb28a628b951544$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        required: (0, $7bb28a628b951544$export$4a21f16c33752377),
        reversed: (0, $7bb28a628b951544$export$4a21f16c33752377),
        rows: (0, $7bb28a628b951544$export$98e628dec113755e),
        rowSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        sandbox: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $7bb28a628b951544$export$4a21f16c33752377),
        seamless: (0, $7bb28a628b951544$export$4a21f16c33752377),
        selected: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shadowRootClonable: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $7bb28a628b951544$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $7bb28a628b951544$export$98e628dec113755e),
        spellCheck: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $7bb28a628b951544$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $7bb28a628b951544$export$4a21f16c33752377),
        useMap: null,
        value: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        width: (0, $7bb28a628b951544$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $7bb28a628b951544$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $7bb28a628b951544$export$4a21f16c33752377),
        declare: (0, $7bb28a628b951544$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $7bb28a628b951544$export$98e628dec113755e),
        leftMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        marginWidth: (0, $7bb28a628b951544$export$98e628dec113755e),
        noResize: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noHref: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noShade: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noWrap: (0, $7bb28a628b951544$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $7bb28a628b951544$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $7bb28a628b951544$export$4a21f16c33752377),
        disableRemotePlayback: (0, $7bb28a628b951544$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $7bb28a628b951544$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $f2ac7ad36db76cd1$export$32b9e4cec9c208e1)
});





const $81184b40caf3b243$export$7ed1367e7fa1ad68 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        accentHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $7bb28a628b951544$export$98e628dec113755e),
        amplitude: (0, $7bb28a628b951544$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $7bb28a628b951544$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $7bb28a628b951544$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $7bb28a628b951544$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        className: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $7bb28a628b951544$export$98e628dec113755e),
        diffuseConstant: (0, $7bb28a628b951544$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $7bb28a628b951544$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $7bb28a628b951544$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $7bb28a628b951544$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $7bb28a628b951544$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $7bb28a628b951544$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        g2: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        glyphName: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $7bb28a628b951544$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $7bb28a628b951544$export$98e628dec113755e),
        horizOriginX: (0, $7bb28a628b951544$export$98e628dec113755e),
        horizOriginY: (0, $7bb28a628b951544$export$98e628dec113755e),
        id: null,
        ideographic: (0, $7bb28a628b951544$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $7bb28a628b951544$export$98e628dec113755e),
        k: (0, $7bb28a628b951544$export$98e628dec113755e),
        k1: (0, $7bb28a628b951544$export$98e628dec113755e),
        k2: (0, $7bb28a628b951544$export$98e628dec113755e),
        k3: (0, $7bb28a628b951544$export$98e628dec113755e),
        k4: (0, $7bb28a628b951544$export$98e628dec113755e),
        kernelMatrix: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $7bb28a628b951544$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $7bb28a628b951544$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        overlineThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $7bb28a628b951544$export$98e628dec113755e),
        pointsAtY: (0, $7bb28a628b951544$export$98e628dec113755e),
        pointsAtZ: (0, $7bb28a628b951544$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        rev: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFonts: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFormats: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $7bb28a628b951544$export$98e628dec113755e),
        specularExponent: (0, $7bb28a628b951544$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        strikethroughThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $7bb28a628b951544$export$98e628dec113755e),
        strokeOpacity: (0, $7bb28a628b951544$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $7bb28a628b951544$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        tabIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $7bb28a628b951544$export$98e628dec113755e),
        targetY: (0, $7bb28a628b951544$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        underlineThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $7bb28a628b951544$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $7bb28a628b951544$export$98e628dec113755e),
        vMathematical: (0, $7bb28a628b951544$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $7bb28a628b951544$export$98e628dec113755e),
        vIdeographic: (0, $7bb28a628b951544$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $7bb28a628b951544$export$98e628dec113755e),
        vertOriginX: (0, $7bb28a628b951544$export$98e628dec113755e),
        vertOriginY: (0, $7bb28a628b951544$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $fa5ee16f731231fb$export$5b10b3bc32d7efbc)
});



const $54e6fef78f3cbe14$export$2bd1230ec7600845 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $6b2d9925b04ededa$export$e20c24a128671213 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $f2ac7ad36db76cd1$export$32b9e4cec9c208e1)
});



const $9c2001df32d7e0eb$export$f2913fe8983302e = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});



/**
 * @import {Schema} from 'property-information'
 */ 


const $a05ae03077f3d80b$var$cap = /[A-Z]/g;
const $a05ae03077f3d80b$var$dash = /-[a-z]/g;
const $a05ae03077f3d80b$var$valid = /^data[-\w.:]+$/i;
function $a05ae03077f3d80b$export$71aa6c912b956294(schema, value) {
    const normal = (0, $e8e4f4c42f412e49$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $5570beed4f72c7cb$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $a05ae03077f3d80b$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($a05ae03077f3d80b$var$dash, $a05ae03077f3d80b$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$a05ae03077f3d80b$var$dash.test(rest)) {
                let dashes = rest.replace($a05ae03077f3d80b$var$cap, $a05ae03077f3d80b$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $de3826e2cce515f8$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $a05ae03077f3d80b$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $a05ae03077f3d80b$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}



const $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5 = (0, $9557e96728c042cf$export$4950aa0f605343fb)([
    (0, $90343b68c9a7ed34$export$4d2d26490572750a),
    (0, $71d94da779c1399e$export$c0bb0b647f701bb5),
    (0, $54e6fef78f3cbe14$export$2bd1230ec7600845),
    (0, $6b2d9925b04ededa$export$e20c24a128671213),
    (0, $9c2001df32d7e0eb$export$f2913fe8983302e)
], 'html');
const $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68 = (0, $9557e96728c042cf$export$4950aa0f605343fb)([
    (0, $90343b68c9a7ed34$export$4d2d26490572750a),
    (0, $81184b40caf3b243$export$7ed1367e7fa1ad68),
    (0, $54e6fef78f3cbe14$export$2bd1230ec7600845),
    (0, $6b2d9925b04ededa$export$e20c24a128671213),
    (0, $9c2001df32d7e0eb$export$f2913fe8983302e)
], 'svg');


/**
 * @import {Nodes, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $3a55c7b5e19fe99f$var$own = {}.hasOwnProperty;
function $3a55c7b5e19fe99f$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $3a55c7b5e19fe99f$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $3a55c7b5e19fe99f$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Comment, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ /**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $65c16094d2969a64$var$defaultSubsetRegex = /["&'<>`]/g;
const $65c16094d2969a64$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $65c16094d2969a64$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $65c16094d2969a64$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $65c16094d2969a64$var$subsetToRegexCache = new WeakMap();
function $65c16094d2969a64$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $65c16094d2969a64$var$charactersToExpressionCached(options.subset) : $65c16094d2969a64$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($65c16094d2969a64$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($65c16094d2969a64$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $65c16094d2969a64$var$charactersToExpressionCached(subset) {
    let cached = $65c16094d2969a64$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $65c16094d2969a64$var$charactersToExpression(subset);
        $65c16094d2969a64$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $65c16094d2969a64$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($65c16094d2969a64$var$regexEscapeRegex, '\\$&'));
    return new RegExp('(?:' + groups.join('|') + ')', 'g');
}


/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ const $75dd587808a4aaab$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $75dd587808a4aaab$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = '&#x' + code.toString(16).toUpperCase();
    return omit && next && !$75dd587808a4aaab$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


const $c5f78eea402c0d26$var$decimalRegex = /\d/;
function $c5f78eea402c0d26$export$63ad841d70774900(code, next, omit) {
    const value = '&#' + String(code);
    return omit && next && !$c5f78eea402c0d26$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


/**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $bbe5b7456579297f$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $4786becb152d1d93$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: '&',
    lt: '<',
    gt: '>',
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};


/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $eafdce1927fd4652$export$39b76096d2f1d598 = [
    'cent',
    'copy',
    'divide',
    'gt',
    'lt',
    'not',
    'para',
    'times'
];


const $87ef8f4c330daa20$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $87ef8f4c330daa20$var$characters = {};
/** @type {string} */ let $87ef8f4c330daa20$var$key;
for($87ef8f4c330daa20$var$key in 0, $4786becb152d1d93$export$40952e41c47e8e55)if ($87ef8f4c330daa20$var$own.call((0, $4786becb152d1d93$export$40952e41c47e8e55), $87ef8f4c330daa20$var$key)) $87ef8f4c330daa20$var$characters[(0, $4786becb152d1d93$export$40952e41c47e8e55)[$87ef8f4c330daa20$var$key]] = $87ef8f4c330daa20$var$key;
const $87ef8f4c330daa20$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $87ef8f4c330daa20$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($87ef8f4c330daa20$var$own.call($87ef8f4c330daa20$var$characters, character)) {
        const name = $87ef8f4c330daa20$var$characters[character];
        const value = '&' + name;
        if (omit && (0, $bbe5b7456579297f$export$9545335bdecb4b8c).includes(name) && !(0, $eafdce1927fd4652$export$39b76096d2f1d598).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $87ef8f4c330daa20$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ';';
    }
    return '';
}


function $b23b470fdf6d3871$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $75dd587808a4aaab$export$ef12b12fd64fa3cc)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $87ef8f4c330daa20$export$b1e14dcd42472e57)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $c5f78eea402c0d26$export$63ad841d70774900)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}


/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $ad6f4d389d64d4ee$export$83cfa611e0071208(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


function $34c8ed9f7f067530$export$aca9de459d63ca2e(value, options) {
    return (0, $65c16094d2969a64$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $b23b470fdf6d3871$export$f53904683bee23d7)
    }, options));
}
function $34c8ed9f7f067530$export$a2577b9dadf100a3(value, options) {
    return (0, $65c16094d2969a64$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $ad6f4d389d64d4ee$export$83cfa611e0071208)
    }, options));
}


const $808668093c235903$var$htmlCommentRegex = /^>|^->|<!--|-->|--!>|<!-$/g;
// Declare arrays as variables so it can be cached by `stringifyEntities`
const $808668093c235903$var$bogusCommentEntitySubset = [
    '>'
];
const $808668093c235903$var$commentEntitySubset = [
    '<',
    '>'
];
function $808668093c235903$export$4a34f930e789283c(node, _1, _2, state) {
    // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>
    return state.settings.bogusComments ? '<?' + (0, $34c8ed9f7f067530$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $808668093c235903$var$bogusCommentEntitySubset
    })) + '>' : '<!--' + node.value.replace($808668093c235903$var$htmlCommentRegex, encode) + '-->';
    /**
   * @param {string} $0
   */ function encode($0) {
        return (0, $34c8ed9f7f067530$export$aca9de459d63ca2e)($0, Object.assign({}, state.settings.characterReferences, {
            subset: $808668093c235903$var$commentEntitySubset
        }));
    }
}


/**
 * @import {Doctype, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a doctype.
 *
 * @param {Doctype} _1
 *   Node to handle.
 * @param {number | undefined} _2
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _3
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $05a479efcf9acdac$export$3c172dfa1c27da99(_1, _2, _3, state) {
    return '<!' + (state.settings.upperDoctype ? 'DOCTYPE' : 'doctype') + (state.settings.tightDoctype ? '' : ' ') + 'html>';
}


/**
 * @import {Element, Parents, Properties} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $d213d2d8a1d4dc2a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $79f9d1c25aee8303$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $79f9d1c25aee8303$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $38edd4def83e695e$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $38edd4def83e695e$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}



/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $1c96ecd7b01e42d9$var$re = /[ \t\n\f\r]/g;
function $1c96ecd7b01e42d9$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $1c96ecd7b01e42d9$var$empty(thing.value) : false : $1c96ecd7b01e42d9$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $1c96ecd7b01e42d9$var$empty(value) {
    return value.replace($1c96ecd7b01e42d9$var$re, '') === '';
}


/**
 * @import {Parents, RootContent} from 'hast'
 */ 
const $c5c003a931864e74$export$a0f7cf204d8f22ba = $c5c003a931864e74$var$siblings(1);
const $c5c003a931864e74$export$b103c35f55382246 = $c5c003a931864e74$var$siblings(-1);
/** @type {Array<RootContent>} */ const $c5c003a931864e74$var$emptyChildren = [];
/**
 * Factory to check siblings in a direction.
 *
 * @param {number} increment
 */ function $c5c003a931864e74$var$siblings(increment) {
    return sibling;
    /**
   * Find applicable siblings in a direction.
   *
   * @template {Parents} Parent
   *   Parent type.
   * @param {Parent | undefined} parent
   *   Parent.
   * @param {number | undefined} index
   *   Index of child in `parent`.
   * @param {boolean | undefined} [includeWhitespace=false]
   *   Whether to include whitespace (default: `false`).
   * @returns {Parent extends {children: Array<infer Child>} ? Child | undefined : never}
   *   Child of parent.
   */ function sibling(parent, index, includeWhitespace) {
        const siblings = parent ? parent.children : $c5c003a931864e74$var$emptyChildren;
        let offset = (index || 0) + increment;
        let next = siblings[offset];
        if (!includeWhitespace) while(next && (0, $1c96ecd7b01e42d9$export$7af1228ff777d175)(next)){
            offset += increment;
            next = siblings[offset];
        }
        // @ts-expect-error: it’s a correct child.
        return next;
    }
}


/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @callback OmitHandle
 *   Check if a tag can be omitted.
 * @param {Element} element
 *   Element to check.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether to omit a tag.
 *
 */ const $cd11ade637dd7c40$var$own = {}.hasOwnProperty;
function $cd11ade637dd7c40$export$67d072dabf9c1c63(handlers) {
    return omit;
    /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */ function omit(node, index, parent) {
        return $cd11ade637dd7c40$var$own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
    }
}


const $748c4da9bff43cd4$export$4e69df80cd44263b = (0, $cd11ade637dd7c40$export$67d072dabf9c1c63)({
    body: $748c4da9bff43cd4$var$body,
    caption: $748c4da9bff43cd4$var$headOrColgroupOrCaption,
    colgroup: $748c4da9bff43cd4$var$headOrColgroupOrCaption,
    dd: $748c4da9bff43cd4$var$dd,
    dt: $748c4da9bff43cd4$var$dt,
    head: $748c4da9bff43cd4$var$headOrColgroupOrCaption,
    html: $748c4da9bff43cd4$var$html,
    li: $748c4da9bff43cd4$var$li,
    optgroup: $748c4da9bff43cd4$var$optgroup,
    option: $748c4da9bff43cd4$var$option,
    p: $748c4da9bff43cd4$var$p,
    rp: $748c4da9bff43cd4$var$rubyElement,
    rt: $748c4da9bff43cd4$var$rubyElement,
    tbody: $748c4da9bff43cd4$var$tbody,
    td: $748c4da9bff43cd4$var$cells,
    tfoot: $748c4da9bff43cd4$var$tfoot,
    th: $748c4da9bff43cd4$var$cells,
    thead: $748c4da9bff43cd4$var$thead,
    tr: $748c4da9bff43cd4$var$tr
});
/**
 * Macro for `</head>`, `</colgroup>`, and `</caption>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$headOrColgroupOrCaption(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index, true);
    return !next || next.type !== 'comment' && !(next.type === 'text' && (0, $1c96ecd7b01e42d9$export$7af1228ff777d175)(next.value.charAt(0)));
}
/**
 * Whether to omit `</html>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$html(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</body>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$body(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</p>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$p(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return next ? next.type === 'element' && (next.tagName === 'address' || next.tagName === 'article' || next.tagName === 'aside' || next.tagName === 'blockquote' || next.tagName === 'details' || next.tagName === 'div' || next.tagName === 'dl' || next.tagName === 'fieldset' || next.tagName === 'figcaption' || next.tagName === 'figure' || next.tagName === 'footer' || next.tagName === 'form' || next.tagName === 'h1' || next.tagName === 'h2' || next.tagName === 'h3' || next.tagName === 'h4' || next.tagName === 'h5' || next.tagName === 'h6' || next.tagName === 'header' || next.tagName === 'hgroup' || next.tagName === 'hr' || next.tagName === 'main' || next.tagName === 'menu' || next.tagName === 'nav' || next.tagName === 'ol' || next.tagName === 'p' || next.tagName === 'pre' || next.tagName === 'section' || next.tagName === 'table' || next.tagName === 'ul') : !parent || // Confusing parent.
    !(parent.type === 'element' && (parent.tagName === 'a' || parent.tagName === 'audio' || parent.tagName === 'del' || parent.tagName === 'ins' || parent.tagName === 'map' || parent.tagName === 'noscript' || parent.tagName === 'video'));
}
/**
 * Whether to omit `</li>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$li(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'li';
}
/**
 * Whether to omit `</dt>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$dt(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd'));
}
/**
 * Whether to omit `</dd>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$dd(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd');
}
/**
 * Whether to omit `</rt>` or `</rp>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$rubyElement(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'rp' || next.tagName === 'rt');
}
/**
 * Whether to omit `</optgroup>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$optgroup(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'optgroup';
}
/**
 * Whether to omit `</option>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$option(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'option' || next.tagName === 'optgroup');
}
/**
 * Whether to omit `</thead>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$thead(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot'));
}
/**
 * Whether to omit `</tbody>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$tbody(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot');
}
/**
 * Whether to omit `</tfoot>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$tfoot(_, index, parent) {
    return !(0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
}
/**
 * Whether to omit `</tr>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$tr(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'tr';
}
/**
 * Whether to omit `</td>` or `</th>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $748c4da9bff43cd4$var$cells(_, index, parent) {
    const next = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'td' || next.tagName === 'th');
}


/**
 * @import {Element, Parents} from 'hast'
 */ 



const $a3ab30f7892ce4df$export$47fa9d71658d4a69 = (0, $cd11ade637dd7c40$export$67d072dabf9c1c63)({
    body: $a3ab30f7892ce4df$var$body,
    colgroup: $a3ab30f7892ce4df$var$colgroup,
    head: $a3ab30f7892ce4df$var$head,
    html: $a3ab30f7892ce4df$var$html,
    tbody: $a3ab30f7892ce4df$var$tbody
});
/**
 * Whether to omit `<html>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$html(node) {
    const head = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(node, -1);
    return !head || head.type !== 'comment';
}
/**
 * Whether to omit `<head>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$head(node) {
    /** @type {Set<string>} */ const seen = new Set();
    // Whether `srcdoc` or not,
    // make sure the content model at least doesn’t have too many `base`s/`title`s.
    for (const child of node.children)if (child.type === 'element' && (child.tagName === 'base' || child.tagName === 'title')) {
        if (seen.has(child.tagName)) return false;
        seen.add(child.tagName);
    }
    // “May be omitted if the element is empty,
    // or if the first thing inside the head element is an element.”
    const child = node.children[0];
    return !child || child.type === 'element';
}
/**
 * Whether to omit `<body>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$body(node) {
    const head = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(node, -1, true);
    return !head || head.type !== 'comment' && !(head.type === 'text' && (0, $1c96ecd7b01e42d9$export$7af1228ff777d175)(head.value.charAt(0))) && !(head.type === 'element' && (head.tagName === 'meta' || head.tagName === 'link' || head.tagName === 'script' || head.tagName === 'style' || head.tagName === 'template'));
}
/**
 * Whether to omit `<colgroup>`.
 * The spec describes some logic for the opening tag, but it’s easier to
 * implement in the closing tag, to the same effect, so we handle it there
 * instead.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$colgroup(node, index, parent) {
    const previous = (0, $c5c003a931864e74$export$b103c35f55382246)(parent, index);
    const head = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(node, -1, true);
    // Previous colgroup was already omitted.
    if (parent && previous && previous.type === 'element' && previous.tagName === 'colgroup' && (0, $748c4da9bff43cd4$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'col');
}
/**
 * Whether to omit `<tbody>`.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $a3ab30f7892ce4df$var$tbody(node, index, parent) {
    const previous = (0, $c5c003a931864e74$export$b103c35f55382246)(parent, index);
    const head = (0, $c5c003a931864e74$export$a0f7cf204d8f22ba)(node, -1);
    // Previous table section was already omitted.
    if (parent && previous && previous.type === 'element' && (previous.tagName === 'thead' || previous.tagName === 'tbody') && (0, $748c4da9bff43cd4$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'tr');
}


/**
 * Maps of subsets.
 *
 * Each value is a matrix of tuples.
 * The value at `0` causes parse errors, the value at `1` is valid.
 * Of both, the value at `0` is unsafe, and the value at `1` is safe.
 *
 * @type {Record<'double' | 'name' | 'single' | 'unquoted', Array<[Array<string>, Array<string>]>>}
 */ const $59737dbcf91cb899$var$constants = {
    // See: <https://html.spec.whatwg.org/#attribute-name-state>.
    name: [
        [
            '\t\n\f\r &/=>'.split(''),
            '\t\n\f\r "&\'/=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'/<=>'.split(''),
            '\0\t\n\f\r "&\'/<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
    unquoted: [
        [
            '\t\n\f\r &>'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'<=>`'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
    single: [
        [
            "&'".split(''),
            '"&\'`'.split('')
        ],
        [
            "\0&'".split(''),
            '\0"&\'`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
    double: [
        [
            '"&'.split(''),
            '"&\'`'.split('')
        ],
        [
            '\0"&'.split(''),
            '\0"&\'`'.split('')
        ]
    ]
};
function $59737dbcf91cb899$export$8454457683f90105(node, index, parent, state) {
    const schema = state.schema;
    const omit = schema.space === 'svg' ? false : state.settings.omitOptionalTags;
    let selfClosing = schema.space === 'svg' ? state.settings.closeEmptyElements : state.settings.voids.includes(node.tagName.toLowerCase());
    /** @type {Array<string>} */ const parts = [];
    /** @type {string} */ let last;
    if (schema.space === 'html' && node.tagName === 'svg') state.schema = (0, $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68);
    const attributes = $59737dbcf91cb899$var$serializeAttributes(state, node.properties);
    const content = state.all(schema.space === 'html' && node.tagName === 'template' ? node.content : node);
    state.schema = schema;
    // If the node is categorised as void, but it has children, remove the
    // categorisation.
    // This enables for example `menuitem`s, which are void in W3C HTML but not
    // void in WHATWG HTML, to be stringified properly.
    // Note: `menuitem` has since been removed from the HTML spec, and so is no
    // longer void.
    if (content) selfClosing = false;
    if (attributes || !omit || !(0, $a3ab30f7892ce4df$export$47fa9d71658d4a69)(node, index, parent)) {
        parts.push('<', node.tagName, attributes ? ' ' + attributes : '');
        if (selfClosing && (schema.space === 'svg' || state.settings.closeSelfClosing)) {
            last = attributes.charAt(attributes.length - 1);
            if (!state.settings.tightSelfClosing || last === '/' || last && last !== '"' && last !== "'") parts.push(' ');
            parts.push('/');
        }
        parts.push('>');
    }
    parts.push(content);
    if (!selfClosing && (!omit || !(0, $748c4da9bff43cd4$export$4e69df80cd44263b)(node, index, parent))) parts.push('</' + node.tagName + '>');
    return parts.join('');
}
/**
 * @param {State} state
 * @param {Properties | null | undefined} properties
 * @returns {string}
 */ function $59737dbcf91cb899$var$serializeAttributes(state, properties) {
    /** @type {Array<string>} */ const values = [];
    let index = -1;
    /** @type {string} */ let key;
    if (properties) {
        for(key in properties)if (properties[key] !== null && properties[key] !== undefined) {
            const value = $59737dbcf91cb899$var$serializeAttribute(state, key, properties[key]);
            if (value) values.push(value);
        }
    }
    while(++index < values.length){
        const last = state.settings.tightAttributes ? values[index].charAt(values[index].length - 1) : undefined;
        // In tight mode, don’t add a space after quoted attributes.
        if (index !== values.length - 1 && last !== '"' && last !== "'") values[index] += ' ';
    }
    return values.join('');
}
/**
 * @param {State} state
 * @param {string} key
 * @param {Properties[keyof Properties]} value
 * @returns {string}
 */ function $59737dbcf91cb899$var$serializeAttribute(state, key, value) {
    const info = (0, $a05ae03077f3d80b$export$71aa6c912b956294)(state.schema, key);
    const x = state.settings.allowParseErrors && state.schema.space === 'html' ? 0 : 1;
    const y = state.settings.allowDangerousCharacters ? 0 : 1;
    let quote = state.quote;
    /** @type {string | undefined} */ let result;
    if (info.overloadedBoolean && (value === info.attribute || value === '')) value = true;
    else if ((info.boolean || info.overloadedBoolean) && (typeof value !== 'string' || value === info.attribute || value === '')) value = Boolean(value);
    if (value === null || value === undefined || value === false || typeof value === 'number' && Number.isNaN(value)) return '';
    const name = (0, $34c8ed9f7f067530$export$aca9de459d63ca2e)(info.attribute, Object.assign({}, state.settings.characterReferences, {
        // Always encode without parse errors in non-HTML.
        subset: $59737dbcf91cb899$var$constants.name[x][y]
    }));
    // No value.
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (Firefox, Safari, Chrome),
    // so I can’t test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/main/lib/svg.js>
    if (value === true) return name;
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = Array.isArray(value) ? (info.commaSeparated ? (0, $79f9d1c25aee8303$export$fac44ee5b035f737) : (0, $38edd4def83e695e$export$fac44ee5b035f737))(value, {
        padLeft: !state.settings.tightCommaSeparatedLists
    }) : String(value);
    if (state.settings.collapseEmptyAttributes && !value) return name;
    // Check unquoted value.
    if (state.settings.preferUnquoted) result = (0, $34c8ed9f7f067530$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
        attribute: true,
        subset: $59737dbcf91cb899$var$constants.unquoted[x][y]
    }));
    // If we don’t want unquoted, or if `value` contains character references when
    // unquoted…
    if (result !== value) {
        // If the alternative is less common than `quote`, switch.
        if (state.settings.quoteSmart && (0, $d213d2d8a1d4dc2a$export$fa42eaa97a352e23)(value, quote) > (0, $d213d2d8a1d4dc2a$export$fa42eaa97a352e23)(value, state.alternative)) quote = state.alternative;
        result = quote + (0, $34c8ed9f7f067530$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
            // Always encode without parse errors in non-HTML.
            subset: (quote === "'" ? $59737dbcf91cb899$var$constants.single : $59737dbcf91cb899$var$constants.double)[x][y],
            attribute: true
        })) + quote;
    }
    // Don’t add a `=` for unquoted empties.
    return name + (result ? '=' + result : result);
}


/**
 * @import {Parents} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ /**
 * @import {Parents, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ 
// Declare array as variable so it can be cached by `stringifyEntities`
const $881b75e46443a8ac$var$textEntitySubset = [
    '<',
    '&'
];
function $881b75e46443a8ac$export$6f093cfa640b7166(node, _, parent, state) {
    // Check if content of `node` should be escaped.
    return parent && parent.type === 'element' && (parent.tagName === 'script' || parent.tagName === 'style') ? node.value : (0, $34c8ed9f7f067530$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $881b75e46443a8ac$var$textEntitySubset
    }));
}


function $5e1a8ad143cd4167$export$1776c186c69df29e(node, index, parent, state) {
    return state.settings.allowDangerousHtml ? node.value : (0, $881b75e46443a8ac$export$6f093cfa640b7166)(node, index, parent, state);
}


/**
 * @import {Parents, Root} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a root.
 *
 * @param {Root} node
 *   Node to handle.
 * @param {number | undefined} _1
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _2
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $6f6f5a39bff6d564$export$e8e78c978b129247(node, _1, _2, state) {
    return state.all(node);
}



const $3234c449d92b02c9$export$8f34ce051745d39e = (0, $3a55c7b5e19fe99f$export$d6a12bfbbedf6185)('type', {
    invalid: $3234c449d92b02c9$var$invalid,
    unknown: $3234c449d92b02c9$var$unknown,
    handlers: {
        comment: $808668093c235903$export$4a34f930e789283c,
        doctype: $05a479efcf9acdac$export$3c172dfa1c27da99,
        element: $59737dbcf91cb899$export$8454457683f90105,
        raw: $5e1a8ad143cd4167$export$1776c186c69df29e,
        root: $6f6f5a39bff6d564$export$e8e78c978b129247,
        text: $881b75e46443a8ac$export$6f093cfa640b7166
    }
});
/**
 * Fail when a non-node is found in the tree.
 *
 * @param {unknown} node
 *   Unknown value.
 * @returns {never}
 *   Never.
 */ function $3234c449d92b02c9$var$invalid(node) {
    throw new Error('Expected node, not `' + node + '`');
}
/**
 * Fail when a node with an unknown type is found in the tree.
 *
 * @param {unknown} node_
 *  Unknown node.
 * @returns {never}
 *   Never.
 */ function $3234c449d92b02c9$var$unknown(node_) {
    // `type` is guaranteed by runtime JS.
    const node = /** @type {Nodes} */ node_;
    throw new Error('Cannot compile unknown node `' + node.type + '`');
}


/** @type {Options} */ const $59ad8c13d9107e7c$var$emptyOptions = {};
/** @type {CharacterReferences} */ const $59ad8c13d9107e7c$var$emptyCharacterReferences = {};
/** @type {Array<never>} */ const $59ad8c13d9107e7c$var$emptyChildren = [];
function $59ad8c13d9107e7c$export$a10125c086a4df16(tree, options) {
    const options_ = options || $59ad8c13d9107e7c$var$emptyOptions;
    const quote = options_.quote || '"';
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error('Invalid quote `' + quote + '`, expected `\'` or `"`');
    /** @type {State} */ const state = {
        one: $59ad8c13d9107e7c$var$one,
        all: $59ad8c13d9107e7c$export$84bf76cd7afc7469,
        settings: {
            omitOptionalTags: options_.omitOptionalTags || false,
            allowParseErrors: options_.allowParseErrors || false,
            allowDangerousCharacters: options_.allowDangerousCharacters || false,
            quoteSmart: options_.quoteSmart || false,
            preferUnquoted: options_.preferUnquoted || false,
            tightAttributes: options_.tightAttributes || false,
            upperDoctype: options_.upperDoctype || false,
            tightDoctype: options_.tightDoctype || false,
            bogusComments: options_.bogusComments || false,
            tightCommaSeparatedLists: options_.tightCommaSeparatedLists || false,
            tightSelfClosing: options_.tightSelfClosing || false,
            collapseEmptyAttributes: options_.collapseEmptyAttributes || false,
            allowDangerousHtml: options_.allowDangerousHtml || false,
            voids: options_.voids || (0, $ab9d94f2edae641a$export$762508062d068de),
            characterReferences: options_.characterReferences || $59ad8c13d9107e7c$var$emptyCharacterReferences,
            closeSelfClosing: options_.closeSelfClosing || false,
            closeEmptyElements: options_.closeEmptyElements || false
        },
        schema: options_.space === 'svg' ? (0, $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68) : (0, $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5),
        quote: quote,
        alternative: alternative
    };
    return state.one(Array.isArray(tree) ? {
        type: 'root',
        children: tree
    } : tree, undefined, undefined);
}
/**
 * Serialize a node.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   Node to handle.
 * @param {number | undefined} index
 *   Index of `node` in `parent.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {string}
 *   Serialized node.
 */ function $59ad8c13d9107e7c$var$one(node, index, parent) {
    return (0, $3234c449d92b02c9$export$8f34ce051745d39e)(node, index, parent, this);
}
function $59ad8c13d9107e7c$export$84bf76cd7afc7469(parent) {
    /** @type {Array<string>} */ const results = [];
    const children = parent && parent.children || $59ad8c13d9107e7c$var$emptyChildren;
    let index = -1;
    while(++index < children.length)results[index] = this.one(children[index], index, parent);
    return results.join('');
}


//#region src/managers/InteractionManager.ts
var $12fff3ed1f91ca75$export$aaa80641d584351c = class {
    hoveredLine;
    hoveredToken;
    pre;
    gutterUtilityLine;
    gutterUtilityContainer;
    gutterUtilityButton;
    gutterUtilitySlot;
    interactiveLinesAttr = false;
    interactiveLineNumbersAttr = false;
    hasPointerListeners = false;
    hasDocumentPointerListeners = false;
    selectedRange = null;
    proposedSelectedRange;
    renderedSelectionRange;
    selectionAnchor;
    queuedSelectionRender;
    pointerSession = {
        mode: "idle"
    };
    constructor(mode, options){
        this.mode = mode;
        this.options = options;
    }
    setOptions(options) {
        this.options = options;
    }
    cleanUp() {
        this.pre?.removeEventListener("click", this.handlePointerClick);
        this.pre?.removeEventListener("pointerdown", this.handlePointerDown);
        this.pre?.removeEventListener("pointermove", this.handlePointerMove);
        this.pre?.removeEventListener("pointerleave", this.handlePointerLeave);
        this.pre?.removeAttribute("data-interactive-lines");
        this.pre?.removeAttribute("data-interactive-line-numbers");
        this.pre = void 0;
        this.gutterUtilityContainer?.remove();
        this.gutterUtilityLine = void 0;
        this.gutterUtilityContainer = void 0;
        this.gutterUtilityButton = void 0;
        this.gutterUtilitySlot = void 0;
        this.clearHoveredLine();
        this.clearHoveredToken();
        this.detachDocumentPointerListeners();
        this.clearPointerSession();
        if (this.queuedSelectionRender != null) {
            cancelAnimationFrame(this.queuedSelectionRender);
            this.queuedSelectionRender = void 0;
        }
        this.interactiveLinesAttr = false;
        this.interactiveLineNumbersAttr = false;
        this.hasPointerListeners = false;
    }
    setup(pre) {
        this.setSelectionDirty();
        const { usesCustomGutterUtility: usesCustomGutterUtility = false, enableGutterUtility: enableGutterUtility = false } = this.options;
        if (this.pre !== pre) {
            this.cleanUp();
            this.pre = pre;
        }
        if (enableGutterUtility) this.ensureGutterUtilityNode(usesCustomGutterUtility);
        else if (this.gutterUtilityContainer != null) {
            this.gutterUtilityContainer.remove();
            this.gutterUtilityLine = void 0;
            this.gutterUtilityContainer = void 0;
            this.gutterUtilityButton = void 0;
            this.gutterUtilitySlot = void 0;
            if (this.pointerSession.mode === "gutterSelecting") {
                this.clearPointerSession();
                this.detachDocumentPointerListeners();
            }
        }
        this.syncPointerListeners(pre);
        this.updateInteractiveLineAttributes();
        this.renderSelection();
        this.placeUtility();
    }
    setSelectionDirty() {
        this.renderedSelectionRange = void 0;
    }
    isSelectionDirty() {
        return this.renderedSelectionRange === null;
    }
    setSelection(range, options) {
        const isRangeChange = !(range === this.selectedRange || (0, $b650ccf3ff2748b4$export$cfda57044a46e9e2)(range ?? void 0, this.selectedRange ?? void 0));
        if (!this.isSelectionDirty() && !isRangeChange) return;
        this.proposedSelectedRange = void 0;
        this.selectedRange = range;
        this.renderSelection();
        this.placeUtility();
        if (isRangeChange && options?.notify !== false) this.notifySelectionCommitted();
    }
    getSelection() {
        return this.selectedRange;
    }
    getHoveredLine = ()=>{
        const gutterUtilityLine = this.gutterUtilityLine ?? this.hoveredLine;
        if (gutterUtilityLine != null) {
            if (this.mode === "diff" && gutterUtilityLine.type === "diff-line") return {
                lineNumber: gutterUtilityLine.lineNumber,
                side: gutterUtilityLine.annotationSide
            };
            if (this.mode === "file" && gutterUtilityLine.type === "line") return {
                lineNumber: gutterUtilityLine.lineNumber
            };
        }
    };
    handlePointerClick = (event)=>{
        const { onHunkExpand: onHunkExpand, onLineClick: onLineClick, onLineNumberClick: onLineNumberClick, onTokenClick: onTokenClick, onMergeConflictActionClick: onMergeConflictActionClick } = this.options;
        if (onHunkExpand == null && onLineClick == null && onLineNumberClick == null && onMergeConflictActionClick == null && onTokenClick == null) return;
        if (this.options.onGutterUtilityClick != null && $12fff3ed1f91ca75$var$isGutterUtilityPath(event.composedPath())) return;
        $12fff3ed1f91ca75$var$debugLogIfEnabled(this.options.__debugPointerEvents, "click", "FileDiff.DEBUG.handlePointerClick:", event);
        this.handlePointerEvent({
            eventType: "click",
            event: event
        });
    };
    handlePointerMove = (event)=>{
        if (event.pointerType !== "mouse") return;
        const { lineHoverHighlight: lineHoverHighlight = "disabled", onLineEnter: onLineEnter, onLineLeave: onLineLeave, onTokenEnter: onTokenEnter, onTokenLeave: onTokenLeave, enableGutterUtility: enableGutterUtility = false } = this.options;
        if (lineHoverHighlight === "disabled" && !enableGutterUtility && onLineEnter == null && onLineLeave == null && onTokenEnter == null && onTokenLeave == null) return;
        $12fff3ed1f91ca75$var$debugLogIfEnabled(this.options.__debugPointerEvents, "move", "FileDiff.DEBUG.handlePointerMove:", event);
        this.handlePointerEvent({
            eventType: "move",
            event: event
        });
    };
    handlePointerLeave = (event)=>{
        const { __debugPointerEvents: __debugPointerEvents } = this.options;
        $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, "move", "FileDiff.DEBUG.handlePointerLeave: no event");
        if (this.hoveredLine == null && this.hoveredToken == null) {
            $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, "move", "FileDiff.DEBUG.handlePointerLeave: returned early, no hovered line or token");
            return;
        }
        if (this.hoveredToken != null) {
            this.options.onTokenLeave?.(this.hoveredToken, event);
            this.clearHoveredToken();
        }
        if (this.hoveredLine != null) {
            this.options.onLineLeave?.({
                ...this.hoveredLine,
                event: event
            });
            this.clearHoveredLine();
        }
        this.placeUtility();
    };
    handlePointerEvent({ eventType: eventType, event: event }) {
        const { __debugPointerEvents: __debugPointerEvents } = this.options;
        const composedPath = event.composedPath();
        $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, eventType, "FileDiff.DEBUG.handlePointerEvent:", {
            eventType: eventType,
            composedPath: composedPath
        });
        const target = this.resolvePointerTarget(composedPath);
        $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, eventType, "FileDiff.DEBUG.handlePointerEvent: resolvePointerTarget result:", target);
        const { onLineClick: onLineClick, onLineNumberClick: onLineNumberClick, onLineEnter: onLineEnter, onLineLeave: onLineLeave, onTokenClick: onTokenClick, onTokenEnter: onTokenEnter, onTokenLeave: onTokenLeave, onHunkExpand: onHunkExpand, onMergeConflictActionClick: onMergeConflictActionClick } = this.options;
        switch(eventType){
            case "move":
                {
                    const sameLine = $12fff3ed1f91ca75$var$isHoverableLinePointerTarget(target) && this.hoveredLine?.lineElement === target.lineElement;
                    if (!($12fff3ed1f91ca75$var$isTokenPointerTarget(target) && this.hoveredToken?.tokenElement === target.tokenElement)) {
                        if (this.hoveredToken != null) {
                            onTokenLeave?.(this.hoveredToken, event);
                            this.clearHoveredToken();
                        }
                        if ($12fff3ed1f91ca75$var$isTokenPointerTarget(target)) {
                            this.setHoveredToken(this.toTokenEventBaseProps(target));
                            onTokenEnter?.(this.hoveredToken, event);
                        }
                    }
                    if (!sameLine) {
                        if (this.hoveredLine != null) {
                            onLineLeave?.({
                                ...this.hoveredLine,
                                event: event
                            });
                            this.clearHoveredLine();
                        }
                        if ($12fff3ed1f91ca75$var$isHoverableLinePointerTarget(target)) {
                            this.setHoveredLine(this.toEventBaseProps(target));
                            this.placeUtility();
                            onLineEnter?.({
                                ...this.hoveredLine,
                                event: event
                            });
                        } else this.placeUtility();
                    }
                    break;
                }
            case "click":
                {
                    if (target == null) break;
                    if ($12fff3ed1f91ca75$var$isMergeConflictActionPointerTarget(target) && onMergeConflictActionClick != null) {
                        onMergeConflictActionClick(target);
                        break;
                    }
                    if ($12fff3ed1f91ca75$var$isExpandoPointerTarget(target) && onHunkExpand != null) {
                        onHunkExpand(target.hunkIndex, target.all || event.shiftKey ? "both" : target.direction, target.all || event.shiftKey ? Number.POSITIVE_INFINITY : void 0);
                        break;
                    }
                    if (!$12fff3ed1f91ca75$var$isHoverableLinePointerTarget(target)) break;
                    if ($12fff3ed1f91ca75$var$isTokenPointerTarget(target) && onTokenClick != null) onTokenClick(this.toTokenEventBaseProps(target), event);
                    const eventBase = this.toEventBaseProps(target);
                    if (onLineNumberClick != null && target.numberColumn) onLineNumberClick({
                        ...eventBase,
                        event: event
                    });
                    else if (onLineClick != null) onLineClick({
                        ...eventBase,
                        event: event
                    });
                    break;
                }
        }
    }
    syncPointerListeners(pre) {
        const { __debugPointerEvents: __debugPointerEvents, lineHoverHighlight: lineHoverHighlight = "disabled", onLineClick: onLineClick, onLineNumberClick: onLineNumberClick, onLineEnter: onLineEnter, onLineLeave: onLineLeave, onTokenClick: onTokenClick, onTokenEnter: onTokenEnter, onTokenLeave: onTokenLeave, onHunkExpand: onHunkExpand, onMergeConflictActionClick: onMergeConflictActionClick, enableGutterUtility: enableGutterUtility = false, enableLineSelection: enableLineSelection = false, onGutterUtilityClick: onGutterUtilityClick } = this.options;
        const enableGutterSelection = onGutterUtilityClick != null;
        const shouldAttachPointerListeners = lineHoverHighlight !== "disabled" || onLineClick != null || onLineNumberClick != null || onLineEnter != null || onLineLeave != null || onTokenClick != null || onTokenEnter != null || onTokenLeave != null || onHunkExpand != null || onMergeConflictActionClick != null || enableGutterUtility || enableLineSelection || enableGutterSelection;
        if (shouldAttachPointerListeners && !this.hasPointerListeners) {
            pre.addEventListener("click", this.handlePointerClick);
            pre.addEventListener("pointerdown", this.handlePointerDown);
            pre.addEventListener("pointermove", this.handlePointerMove);
            pre.addEventListener("pointerleave", this.handlePointerLeave);
            this.hasPointerListeners = true;
            $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, "click", "FileDiff.DEBUG.attachEventListeners: Attaching click events for:", (()=>{
                const reasons = [];
                if (__debugPointerEvents === "both" || __debugPointerEvents === "click") {
                    if (onLineClick != null) reasons.push("onLineClick");
                    if (onLineNumberClick != null) reasons.push("onLineNumberClick");
                    if (onHunkExpand != null) reasons.push("expandable hunk separators");
                    if (onMergeConflictActionClick != null) reasons.push("merge conflict actions");
                }
                return reasons;
            })());
            $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, "move", "FileDiff.DEBUG.attachEventListeners: Attaching pointer move event");
            $12fff3ed1f91ca75$var$debugLogIfEnabled(__debugPointerEvents, "move", "FileDiff.DEBUG.attachEventListeners: Attaching pointer leave event");
        } else if (!shouldAttachPointerListeners && this.hasPointerListeners) {
            pre.removeEventListener("click", this.handlePointerClick);
            pre.removeEventListener("pointerdown", this.handlePointerDown);
            pre.removeEventListener("pointermove", this.handlePointerMove);
            pre.removeEventListener("pointerleave", this.handlePointerLeave);
            this.hasPointerListeners = false;
        }
        const hasActiveLineSelectionSession = this.pointerSession.mode === "selecting" || this.pointerSession.mode === "pendingSingleLineUnselect";
        const hasActiveGutterSelectionSession = this.pointerSession.mode === "gutterSelecting";
        if (!enableLineSelection && hasActiveLineSelectionSession || !enableGutterSelection && hasActiveGutterSelectionSession) {
            this.clearPointerSession();
            this.detachDocumentPointerListeners();
            this.selectionAnchor = void 0;
            this.clearPendingSingleLineState();
        }
    }
    updateInteractiveLineAttributes() {
        if (this.pre == null) return;
        const { onLineClick: onLineClick, onLineNumberClick: onLineNumberClick, enableLineSelection: enableLineSelection = false } = this.options;
        const shouldHaveInteractiveLines = onLineClick != null;
        const shouldHaveInteractiveLineNumbers = onLineNumberClick != null || enableLineSelection;
        if (shouldHaveInteractiveLines && !this.interactiveLinesAttr) {
            this.pre.setAttribute("data-interactive-lines", "");
            this.interactiveLinesAttr = true;
        } else if (!shouldHaveInteractiveLines && this.interactiveLinesAttr) {
            this.pre.removeAttribute("data-interactive-lines");
            this.interactiveLinesAttr = false;
        }
        if (shouldHaveInteractiveLineNumbers && !this.interactiveLineNumbersAttr) {
            this.pre.setAttribute("data-interactive-line-numbers", "");
            this.interactiveLineNumbersAttr = true;
        } else if (!shouldHaveInteractiveLineNumbers && this.interactiveLineNumbersAttr) {
            this.pre.removeAttribute("data-interactive-line-numbers");
            this.interactiveLineNumbersAttr = false;
        }
    }
    handlePointerDown = (event)=>{
        if (event.pointerType === "mouse" && event.button !== 0 || this.pre == null || this.pointerSession.mode !== "idle") return;
        const path = event.composedPath();
        if ($12fff3ed1f91ca75$var$isGutterUtilityPath(path) && this.options.onGutterUtilityClick != null) this.startGutterSelectionFromPointerDown(event);
        else {
            if (event.pointerType !== "mouse") this.revealUtilityFromGutterPath(path);
            this.startLineSelectionFromPointerDown(event);
        }
    };
    startLineSelectionFromPointerDown(event) {
        const { enableLineSelection: enableLineSelection = false } = this.options;
        if (!enableLineSelection) return;
        const pointerInfo = this.resolveSelectionInfo(event, {
            source: "event-path",
            requireNumberColumn: true
        });
        if (pointerInfo == null) return;
        const { pre: pre } = this;
        if (pre == null) return;
        event.preventDefault();
        const { lineNumber: lineNumber, eventSide: eventSide, lineIndex: lineIndex } = pointerInfo;
        if (event.shiftKey && this.selectedRange != null) {
            const rowRange = this.getIndexesFromSelection(this.selectedRange, pre.getAttribute("data-diff-type") === "split");
            if (rowRange == null) return;
            const useStart = rowRange.start <= rowRange.end ? lineIndex >= rowRange.start : lineIndex <= rowRange.end;
            this.selectionAnchor = {
                lineNumber: useStart ? this.selectedRange.start : this.selectedRange.end,
                side: useStart ? this.selectedRange.side : this.selectedRange.endSide ?? this.selectedRange.side
            };
            this.updateSelection(lineNumber, eventSide, false);
            this.notifySelectionStart(this.getCurrentSelectionRange());
            this.pointerSession = {
                mode: "selecting",
                pointerId: event.pointerId
            };
            this.attachDocumentPointerListeners();
            return;
        }
        if (this.selectedRange?.start === lineNumber && this.selectedRange?.end === lineNumber) {
            const point = {
                lineNumber: lineNumber,
                side: eventSide
            };
            this.selectionAnchor = point;
            this.pointerSession = {
                mode: "pendingSingleLineUnselect",
                pointerId: event.pointerId,
                anchor: point,
                pending: point
            };
            this.attachDocumentPointerListeners();
            return;
        }
        if (this.options.controlledSelection === true) this.proposedSelectedRange = null;
        else this.selectedRange = null;
        this.placeUtility();
        this.selectionAnchor = {
            lineNumber: lineNumber,
            side: eventSide
        };
        this.updateSelection(lineNumber, eventSide, false);
        this.notifySelectionStart(this.getCurrentSelectionRange());
        this.pointerSession = {
            mode: "selecting",
            pointerId: event.pointerId
        };
        this.attachDocumentPointerListeners();
    }
    startGutterSelectionFromPointerDown(event) {
        const { enableLineSelection: enableLineSelection = false, onGutterUtilityClick: onGutterUtilityClick } = this.options;
        if (onGutterUtilityClick == null) return;
        const selectedEndpoints = this.currentSelectionEnds();
        const point = selectedEndpoints?.bottom ?? this.resolveSelectionPoint(event, {
            source: "event-path",
            excludeUtility: false
        });
        const anchor = selectedEndpoints?.top ?? point;
        if (point == null || anchor == null) return;
        event.preventDefault();
        event.stopPropagation();
        this.pointerSession = {
            mode: "gutterSelecting",
            pointerId: event.pointerId,
            anchor: anchor,
            current: point
        };
        if (enableLineSelection) {
            this.selectionAnchor = {
                lineNumber: anchor.lineNumber,
                side: anchor.side
            };
            this.updateSelection(point.lineNumber, point.side, false);
            this.notifySelectionStart(this.getCurrentSelectionRange());
        }
        this.attachDocumentPointerListeners();
    }
    handleDocumentPointerMove = (event)=>{
        const { enableLineSelection: enableLineSelection = false } = this.options;
        switch(this.pointerSession.mode){
            case "idle":
                return;
            case "gutterSelecting":
                {
                    if (event.pointerId !== this.pointerSession.pointerId) return;
                    event.preventDefault();
                    const point = this.resolveSelectionPoint(event, {
                        source: "coordinates-first"
                    });
                    if (point == null) return;
                    this.pointerSession.current = point;
                    if (enableLineSelection === true) this.updateSelection(point.lineNumber, point.side);
                    return;
                }
            case "selecting":
                {
                    if (event.pointerId !== this.pointerSession.pointerId) return;
                    event.preventDefault();
                    const pointerInfo = this.resolveSelectionInfo(event, {
                        source: "coordinates-first",
                        requireNumberColumn: false
                    });
                    if (pointerInfo == null || this.selectionAnchor == null) return;
                    this.updateSelection(pointerInfo.lineNumber, pointerInfo.eventSide);
                    return;
                }
            case "pendingSingleLineUnselect":
                {
                    if (event.pointerId !== this.pointerSession.pointerId) return;
                    event.preventDefault();
                    const pointerInfo = this.resolveSelectionInfo(event, {
                        source: "coordinates-first",
                        requireNumberColumn: false
                    });
                    if (pointerInfo == null || this.selectionAnchor == null) return;
                    const point = {
                        lineNumber: pointerInfo.lineNumber,
                        side: pointerInfo.eventSide
                    };
                    if ((0, $75787b05c237bca2$export$631bac48ee645801)(this.pointerSession.pending, point)) return;
                    this.updateSelection(pointerInfo.lineNumber, pointerInfo.eventSide, false);
                    this.notifySelectionStart(this.getCurrentSelectionRange());
                    this.notifySelectionChangeDelta();
                    this.pointerSession = {
                        mode: "selecting",
                        pointerId: event.pointerId
                    };
                    return;
                }
        }
    };
    handleDocumentPointerUp = (event)=>{
        const { enableLineSelection: enableLineSelection = false, onGutterUtilityClick: onGutterUtilityClick } = this.options;
        switch(this.pointerSession.mode){
            case "idle":
                return;
            case "gutterSelecting":
                {
                    if (event.pointerId !== this.pointerSession.pointerId) return;
                    event.preventDefault();
                    const point = this.resolveSelectionPoint(event, {
                        source: "coordinates-first"
                    });
                    if (point != null) {
                        this.pointerSession.current = point;
                        if (enableLineSelection) this.updateSelection(point.lineNumber, point.side);
                    }
                    onGutterUtilityClick?.(this.buildSelectedLineRange(this.pointerSession.anchor, this.pointerSession.current));
                    this.selectionAnchor = void 0;
                    if (enableLineSelection) {
                        this.notifySelectionEnd(this.getCurrentSelectionRange());
                        this.notifySelectionCommitted();
                        this.clearProposedSelection();
                    }
                    this.clearPointerSession();
                    this.detachDocumentPointerListeners();
                    return;
                }
            case "pendingSingleLineUnselect":
                if (event.pointerId !== this.pointerSession.pointerId) return;
                event.preventDefault();
                this.updateSelection(null, void 0, false);
                this.selectionAnchor = void 0;
                this.clearPendingSingleLineState();
                this.detachDocumentPointerListeners();
                this.notifySelectionEnd(this.getCurrentSelectionRange());
                this.notifySelectionCommitted();
                this.clearProposedSelection();
                return;
            case "selecting":
                if (event.pointerId !== this.pointerSession.pointerId) return;
                event.preventDefault();
                this.selectionAnchor = void 0;
                this.detachDocumentPointerListeners();
                this.clearPointerSession();
                this.notifySelectionEnd(this.getCurrentSelectionRange());
                this.notifySelectionCommitted();
                this.clearProposedSelection();
        }
    };
    handleDocumentPointerCancel = (event)=>{
        switch(this.pointerSession.mode){
            case "idle":
                return;
            case "gutterSelecting":
            case "selecting":
            case "pendingSingleLineUnselect":
                if ("pointerId" in this.pointerSession) {
                    if (event.pointerId !== this.pointerSession.pointerId) return;
                }
                this.selectionAnchor = void 0;
                this.clearProposedSelection();
                this.clearPendingSingleLineState();
                this.clearPointerSession();
                this.detachDocumentPointerListeners();
        }
    };
    clearHoveredLine() {
        if (this.hoveredLine == null) return;
        this.hoveredLine.lineElement.removeAttribute("data-hovered");
        this.hoveredLine.numberElement.removeAttribute("data-hovered");
        this.hoveredLine = void 0;
    }
    setHoveredLine(hoveredLine) {
        const { lineHoverHighlight: lineHoverHighlight = "disabled" } = this.options;
        if (this.hoveredLine != null) this.clearHoveredLine();
        this.hoveredLine = hoveredLine;
        if (lineHoverHighlight !== "disabled") {
            if (lineHoverHighlight === "both" || lineHoverHighlight === "line") this.hoveredLine.lineElement.setAttribute("data-hovered", "");
            if (lineHoverHighlight === "both" || lineHoverHighlight === "number") this.hoveredLine.numberElement.setAttribute("data-hovered", "");
        }
    }
    clearHoveredToken() {
        if (this.hoveredToken == null) return;
        this.hoveredToken = void 0;
    }
    setHoveredToken(hoveredToken) {
        if (this.hoveredToken != null) this.clearHoveredToken();
        this.hoveredToken = hoveredToken;
    }
    ensureGutterUtilityNode(useCustomGutterUtility) {
        if (this.gutterUtilityContainer == null) {
            this.gutterUtilityContainer = document.createElement("div");
            this.gutterUtilityContainer.setAttribute("data-gutter-utility-slot", "");
        }
        if (useCustomGutterUtility) {
            if (this.gutterUtilityButton != null) {
                this.gutterUtilityButton.remove();
                this.gutterUtilityButton = void 0;
            }
            if (this.gutterUtilitySlot == null) {
                this.gutterUtilitySlot = document.createElement("slot");
                this.gutterUtilitySlot.name = "gutter-utility-slot";
            }
            if (this.gutterUtilitySlot.parentNode !== this.gutterUtilityContainer) this.gutterUtilityContainer.replaceChildren(this.gutterUtilitySlot);
        } else {
            this.gutterUtilitySlot?.remove();
            this.gutterUtilitySlot = void 0;
            if (this.gutterUtilityButton == null) {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = (0, $59ad8c13d9107e7c$export$a10125c086a4df16)((0, $d08db92ce491bda4$export$96dc444f01cd03d9)());
                const utilityButton = tempDiv.firstElementChild;
                if (!(utilityButton instanceof HTMLButtonElement)) throw new Error("InteractionManager.ensureGutterUtilityNode: Node element should be a button");
                utilityButton.remove();
                this.gutterUtilityButton = utilityButton;
            }
            if (this.gutterUtilityButton.parentNode !== this.gutterUtilityContainer) this.gutterUtilityContainer.replaceChildren(this.gutterUtilityButton);
        }
    }
    revealUtilityFromGutterPath(path) {
        if (this.placeUtilityFromSelection()) return;
        const target = this.resolvePointerTarget(path);
        if ($12fff3ed1f91ca75$var$isLinePointerTarget(target) && target.numberColumn) this.showUtilityOnLine(this.toEventBaseProps(target));
    }
    placeUtility() {
        if (this.placeUtilityFromSelection()) return;
        if (this.hoveredLine != null) {
            this.showUtilityOnLine(this.hoveredLine);
            return;
        }
        this.hideUtility();
    }
    placeUtilityFromSelection() {
        const endpoints = this.currentSelectionEnds();
        if (endpoints == null) return false;
        const target = this.targetForSelectionPoint(endpoints.bottom);
        if (target == null) this.hideUtility();
        else this.showUtilityOnLine(this.toEventBaseProps(target));
        return true;
    }
    showUtilityOnLine(line) {
        if (this.gutterUtilityContainer == null) return;
        this.gutterUtilityLine = line;
        line.numberElement.appendChild(this.gutterUtilityContainer);
    }
    hideUtility() {
        this.gutterUtilityContainer?.remove();
        this.gutterUtilityLine = void 0;
    }
    currentSelectionEnds() {
        const range = this.getCurrentSelectionRange();
        return range == null ? void 0 : this.selectionEnds(range);
    }
    selectionEnds(range) {
        const start = {
            lineNumber: range.start,
            side: range.side
        };
        const end = {
            lineNumber: range.end,
            side: range.endSide ?? range.side
        };
        const startIndex = this.selectionPointRowIndex(start);
        const endIndex = this.selectionPointRowIndex(end);
        if (startIndex == null || endIndex == null) return;
        return startIndex > endIndex ? {
            top: end,
            bottom: start
        } : {
            top: start,
            bottom: end
        };
    }
    selectionPointRowIndex(point) {
        const indexes = this.getLineIndex(point.lineNumber, point.side);
        if (indexes == null) return;
        return this.isSplitDiff() ? indexes[1] : indexes[0];
    }
    targetForSelectionPoint(point) {
        if (this.pre == null) return;
        const indexes = this.getLineIndex(point.lineNumber, point.side);
        if (indexes == null) return;
        const lineIndex = this.mode === "diff" ? `${indexes[0]},${indexes[1]}` : `${indexes[0]}`;
        const candidates = this.pre.querySelectorAll(`[data-column-number="${point.lineNumber}"][data-line-index="${lineIndex}"]`);
        for (const element of candidates){
            if (!(element instanceof HTMLElement)) continue;
            const target = this.resolvePointerTarget($12fff3ed1f91ca75$var$getElementPath(element));
            if (!$12fff3ed1f91ca75$var$isLinePointerTarget(target)) continue;
            if (this.mode === "diff" && point.side != null && target.side !== point.side) continue;
            return target;
        }
    }
    attachDocumentPointerListeners() {
        if (this.hasDocumentPointerListeners) return;
        document.addEventListener("pointermove", this.handleDocumentPointerMove);
        document.addEventListener("pointerup", this.handleDocumentPointerUp);
        document.addEventListener("pointercancel", this.handleDocumentPointerCancel);
        this.hasDocumentPointerListeners = true;
    }
    detachDocumentPointerListeners() {
        if (!this.hasDocumentPointerListeners) return;
        document.removeEventListener("pointermove", this.handleDocumentPointerMove);
        document.removeEventListener("pointerup", this.handleDocumentPointerUp);
        document.removeEventListener("pointercancel", this.handleDocumentPointerCancel);
        this.hasDocumentPointerListeners = false;
    }
    clearPointerSession() {
        this.pointerSession = {
            mode: "idle"
        };
    }
    clearPendingSingleLineState() {
        if (this.pointerSession.mode === "pendingSingleLineUnselect") this.pointerSession = {
            mode: "idle"
        };
    }
    selectionInfoFromPath(path, requireNumberColumn) {
        const target = this.resolvePointerTarget(path);
        if (!$12fff3ed1f91ca75$var$isLinePointerTarget(target)) return;
        if (requireNumberColumn && !target.numberColumn) return;
        if (target.splitLineIndex == null) return;
        return {
            lineIndex: target.splitLineIndex,
            lineNumber: target.lineNumber,
            eventSide: this.mode === "diff" ? target.side : void 0
        };
    }
    resolveSelectionInfo(event, options) {
        const path = this.resolveSelectionPath(event, options);
        return path != null ? this.selectionInfoFromPath(path, options.requireNumberColumn) : void 0;
    }
    selectionPointFromPath(path) {
        const target = this.resolvePointerTarget(path);
        if (!$12fff3ed1f91ca75$var$isLinePointerTarget(target)) return;
        return {
            lineNumber: target.lineNumber,
            side: this.mode === "diff" ? target.side : void 0
        };
    }
    resolveSelectionPoint(event, options) {
        const path = this.resolveSelectionPath(event, options);
        return path != null ? this.selectionPointFromPath(path) : void 0;
    }
    resolveSelectionPath(event, options) {
        const excludeUtility = options.excludeUtility !== false;
        switch(options.source){
            case "event-path":
                return this.pathFromEventPath(event.composedPath(), excludeUtility);
            case "coordinates-first":
                {
                    const coordinatePath = this.pathFromCoordinates(event, excludeUtility);
                    if (coordinatePath !== void 0) return coordinatePath ?? void 0;
                    return this.pathFromEventPath(event.composedPath(), excludeUtility);
                }
        }
    }
    pathFromCoordinates(event, excludeUtility) {
        const coordinateTarget = this.hitTest(event);
        if (coordinateTarget === void 0) return;
        if (coordinateTarget === null) return null;
        return this.pathFromElement(coordinateTarget, excludeUtility) ?? null;
    }
    pathFromEventPath(path, excludeUtility) {
        if (excludeUtility && $12fff3ed1f91ca75$var$isGutterUtilityPath(path)) return;
        for (const element of path)if (element instanceof Element) return this.pathFromElement(element, excludeUtility);
    }
    pathFromElement(element, excludeUtility) {
        const path = $12fff3ed1f91ca75$var$getElementPath(element);
        if (excludeUtility && $12fff3ed1f91ca75$var$isGutterUtilityPath(path)) return;
        const row = $12fff3ed1f91ca75$var$closestSelectableRow(element);
        if (row != null) return $12fff3ed1f91ca75$var$getElementPath(row);
        return this.pathFromAnnotationSlot(element);
    }
    pathFromAnnotationSlot(element) {
        const point = $12fff3ed1f91ca75$var$selectionPointFromAnnotationSlotName($12fff3ed1f91ca75$var$getAnnotationSlotName(element));
        if (point == null) return;
        const target = this.targetForSelectionPoint(point);
        return target != null ? $12fff3ed1f91ca75$var$getElementPath(target.lineElement) : void 0;
    }
    hitTest(event) {
        if (!Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return;
        const root = this.pre?.getRootNode();
        const elementFromPointRoot = $12fff3ed1f91ca75$var$hasElementFromPoint(root) ? root : $12fff3ed1f91ca75$var$hasElementFromPoint(document) ? document : void 0;
        if (elementFromPointRoot == null) return;
        return elementFromPointRoot.elementFromPoint(event.clientX, event.clientY);
    }
    getLineIndex(lineNumber, side) {
        const { getLineIndex: getLineIndex } = this.options;
        return getLineIndex != null ? getLineIndex(lineNumber, side) : [
            lineNumber - 1,
            lineNumber - 1
        ];
    }
    getCurrentSelectionRange() {
        return this.proposedSelectedRange !== void 0 ? this.proposedSelectedRange : this.selectedRange;
    }
    clearProposedSelection() {
        this.proposedSelectedRange = void 0;
    }
    updateSelection(currentLine, side, emitChange = true) {
        const previousRange = this.getCurrentSelectionRange();
        let nextRange;
        if (currentLine == null) nextRange = null;
        else {
            const anchorSide = this.selectionAnchor?.side ?? side;
            const anchorLine = this.selectionAnchor?.lineNumber ?? currentLine;
            nextRange = this.buildSelectionRange(anchorLine, currentLine, anchorSide, side);
        }
        if ((0, $b650ccf3ff2748b4$export$cfda57044a46e9e2)(previousRange ?? void 0, nextRange ?? void 0)) return;
        if (this.options.controlledSelection === true) this.proposedSelectedRange = nextRange;
        else {
            this.selectedRange = nextRange;
            this.queuedSelectionRender ??= requestAnimationFrame(this.renderSelection);
        }
        this.placeUtility();
        if (emitChange) this.notifySelectionChangeDelta();
    }
    getIndexesFromSelection(selectedRange, split) {
        if (this.pre == null) return;
        const startIndexes = this.getLineIndex(selectedRange.start, selectedRange.side);
        const finalIndexes = this.getLineIndex(selectedRange.end, selectedRange.endSide ?? selectedRange.side);
        return startIndexes != null && finalIndexes != null ? {
            start: split ? startIndexes[1] : startIndexes[0],
            end: split ? finalIndexes[1] : finalIndexes[0]
        } : void 0;
    }
    renderSelection = ()=>{
        if (this.queuedSelectionRender != null) {
            cancelAnimationFrame(this.queuedSelectionRender);
            this.queuedSelectionRender = void 0;
        }
        if (this.pre == null || this.renderedSelectionRange === this.selectedRange) return;
        const allSelected = this.pre.querySelectorAll("[data-selected-line]");
        for (const element of allSelected)element.removeAttribute("data-selected-line");
        this.renderedSelectionRange = this.selectedRange;
        if (this.selectedRange == null) return;
        const { children: codeElements } = this.pre;
        if (codeElements.length === 0) return;
        if (codeElements.length > 2) {
            console.error(codeElements);
            throw new Error("InteractionManager.renderSelection: Somehow there are more than 2 code elements...");
        }
        const split = this.pre.getAttribute("data-diff-type") === "split";
        const rowRange = this.getIndexesFromSelection(this.selectedRange, split);
        if (rowRange == null) {
            console.error({
                rowRange: rowRange,
                selectedRange: this.selectedRange
            });
            throw new Error("InteractionManager.renderSelection: No valid rowRange");
        }
        const isSingle = rowRange.start === rowRange.end;
        const first = Math.min(rowRange.start, rowRange.end);
        const last = Math.max(rowRange.start, rowRange.end);
        for (const code of codeElements){
            const [gutter, content] = code.children;
            const len = content.children.length;
            if (len !== gutter.children.length) throw new Error("InteractionManager.renderSelection: gutter and content children dont match, something is wrong");
            for(let i = 0; i < len; i++){
                const contentElement = content.children[i];
                const gutterElement = gutter.children[i];
                if (!(contentElement instanceof HTMLElement) || !(gutterElement instanceof HTMLElement)) continue;
                const lineIndex = this.parseLineIndex(contentElement, split);
                if ((lineIndex ?? 0) > last) break;
                if (lineIndex == null || lineIndex < first) continue;
                let attributeValue = isSingle ? "single" : lineIndex === first ? "first" : lineIndex === last ? "last" : "";
                contentElement.setAttribute("data-selected-line", attributeValue);
                gutterElement.setAttribute("data-selected-line", attributeValue);
                if (gutterElement.nextSibling instanceof HTMLElement && contentElement.nextSibling instanceof HTMLElement && (contentElement.nextSibling.hasAttribute("data-line-annotation") || contentElement.nextSibling.hasAttribute("data-merge-conflict-actions"))) {
                    if (isSingle) {
                        attributeValue = "last";
                        contentElement.setAttribute("data-selected-line", "first");
                    } else if (lineIndex === first) attributeValue = "";
                    else if (lineIndex === last) contentElement.setAttribute("data-selected-line", "");
                    contentElement.nextSibling.setAttribute("data-selected-line", attributeValue);
                    gutterElement.nextSibling.setAttribute("data-selected-line", attributeValue);
                }
            }
        }
    };
    notifySelectionCommitted() {
        this.options.onLineSelected?.(this.getCurrentSelectionRange() ?? null);
    }
    notifySelectionChangeDelta() {
        this.options.onLineSelectionChange?.(this.getCurrentSelectionRange() ?? null);
    }
    notifySelectionStart(range) {
        this.options.onLineSelectionStart?.(range);
    }
    notifySelectionEnd(range) {
        this.options.onLineSelectionEnd?.(range);
    }
    toEventBaseProps(target) {
        if (this.mode === "file") return {
            type: "line",
            lineElement: target.lineElement,
            lineNumber: target.lineNumber,
            numberColumn: target.numberColumn,
            numberElement: target.numberElement
        };
        return {
            type: "diff-line",
            annotationSide: target.side,
            lineType: target.lineType,
            lineElement: target.lineElement,
            numberElement: target.numberElement,
            lineNumber: target.lineNumber,
            numberColumn: target.numberColumn
        };
    }
    toTokenEventBaseProps({ lineCharEnd: lineCharEnd, lineCharStart: lineCharStart, lineNumber: lineNumber, side: side, tokenElement: tokenElement, tokenText: tokenText }) {
        if (this.mode === "file") return {
            type: "token",
            lineCharEnd: lineCharEnd,
            lineCharStart: lineCharStart,
            lineNumber: lineNumber,
            tokenElement: tokenElement,
            tokenText: tokenText
        };
        return {
            type: "token",
            lineCharEnd: lineCharEnd,
            lineCharStart: lineCharStart,
            lineNumber: lineNumber,
            side: side,
            tokenElement: tokenElement,
            tokenText: tokenText
        };
    }
    buildSelectedLineRange(anchor, current) {
        return this.buildSelectionRange(anchor.lineNumber, current.lineNumber, anchor.side, current.side);
    }
    buildSelectionRange(start, end, side, endSide) {
        return {
            start: start,
            end: end,
            ...side != null ? {
                side: side
            } : {},
            ...side !== endSide && endSide != null ? {
                endSide: endSide
            } : {}
        };
    }
    resolvePointerTarget(path) {
        let numberColumn = false;
        let lineType;
        let codeElement;
        let lineElement;
        let lineIndexValue;
        let numberElement;
        let tokenElement;
        let tokenInfo;
        let expandInfo;
        let lineNumber;
        let mergeConflictActionTarget;
        for (const element of path){
            if (!(element instanceof HTMLElement)) continue;
            if (mergeConflictActionTarget == null && element.hasAttribute("data-merge-conflict-action")) {
                const resolutionValue = element.getAttribute("data-merge-conflict-action") ?? void 0;
                const conflictIndexValue = element.getAttribute("data-merge-conflict-conflict-index") ?? void 0;
                const conflictIndex = conflictIndexValue != null ? Number.parseInt(conflictIndexValue, 10) : NaN;
                if ($12fff3ed1f91ca75$var$isMergeConflictResolution(resolutionValue) && Number.isFinite(conflictIndex)) mergeConflictActionTarget = {
                    kind: "merge-conflict-action",
                    resolution: resolutionValue,
                    conflictIndex: conflictIndex
                };
            }
            if (tokenElement == null && element.hasAttribute("data-char")) {
                tokenElement = element;
                const startAttr = element.getAttribute("data-char");
                if (startAttr != null) {
                    const lineCharStart = Number.parseInt(startAttr, 10);
                    if (!Number.isNaN(lineCharStart)) {
                        const tokenText = element.textContent ?? "";
                        const lineCharEnd = lineCharStart + tokenText.length;
                        if (tokenText.trim() !== "" || this.options.enableTokenInteractionsOnWhitespace === true) tokenInfo = {
                            tokenElement: tokenElement,
                            lineCharStart: lineCharStart,
                            lineCharEnd: lineCharEnd,
                            tokenText: tokenText
                        };
                        continue;
                    }
                }
            }
            const columnNumber = numberElement == null ? element.getAttribute("data-column-number") ?? void 0 : void 0;
            if (columnNumber != null) {
                numberElement = element;
                lineNumber = Number.parseInt(columnNumber, 10);
                numberColumn = true;
                lineType = $12fff3ed1f91ca75$var$getLineTypeFromElement(element);
                lineIndexValue = element.getAttribute("data-line-index") ?? void 0;
                continue;
            }
            const lineAttr = lineElement == null ? element.getAttribute("data-line") ?? void 0 : void 0;
            if (lineAttr != null) {
                lineElement = element;
                lineNumber = Number.parseInt(lineAttr, 10);
                lineType = $12fff3ed1f91ca75$var$getLineTypeFromElement(element);
                lineIndexValue = element.getAttribute("data-line-index") ?? void 0;
                continue;
            }
            if (expandInfo == null && (element.hasAttribute("data-expand-button") || element.hasAttribute("data-unmodified-lines"))) {
                expandInfo = {
                    hunkIndex: void 0,
                    direction: (()=>{
                        if (element.hasAttribute("data-expand-up")) return "up";
                        if (element.hasAttribute("data-expand-down")) return "down";
                        return "both";
                    })(),
                    all: element.hasAttribute("data-expand-all-button")
                };
                continue;
            }
            const expandIndexValue = expandInfo != null ? element.getAttribute("data-expand-index") ?? void 0 : void 0;
            if (expandInfo != null && expandIndexValue != null) {
                const expandIndex = Number.parseInt(expandIndexValue, 10);
                if (!Number.isNaN(expandIndex)) expandInfo.hunkIndex = expandIndex;
                continue;
            }
            if (codeElement == null && element.hasAttribute("data-code")) {
                codeElement = element;
                break;
            }
        }
        if (mergeConflictActionTarget != null) return mergeConflictActionTarget;
        if (expandInfo?.hunkIndex != null) return {
            type: "line-info",
            hunkIndex: expandInfo.hunkIndex,
            direction: expandInfo.direction,
            all: expandInfo.all
        };
        lineElement ??= lineIndexValue != null ? $12fff3ed1f91ca75$var$queryHTMLElement(codeElement, `[data-line][data-line-index="${lineIndexValue}"]`) : void 0;
        numberElement ??= lineIndexValue != null ? $12fff3ed1f91ca75$var$queryHTMLElement(codeElement, `[data-column-number][data-line-index="${lineIndexValue}"]`) : void 0;
        if (codeElement == null || lineElement == null || numberElement == null || lineType == null || lineNumber == null || Number.isNaN(lineNumber)) return;
        const splitLineIndex = this.parseLineIndex(lineElement, this.isSplitDiff());
        if (tokenInfo != null) {
            if (this.mode === "file") return {
                kind: "token",
                lineType: lineType,
                lineElement: lineElement,
                lineNumber: lineNumber,
                numberColumn: numberColumn,
                numberElement: numberElement,
                side: void 0,
                splitLineIndex: splitLineIndex,
                ...tokenInfo
            };
            return {
                kind: "token",
                lineType: lineType,
                lineElement: lineElement,
                lineNumber: lineNumber,
                numberColumn: numberColumn,
                numberElement: numberElement,
                side: $12fff3ed1f91ca75$var$getAnnotationSide(lineType, codeElement),
                splitLineIndex: splitLineIndex,
                ...tokenInfo
            };
        }
        if (this.mode === "file") return {
            kind: "line",
            lineType: lineType,
            lineElement: lineElement,
            lineNumber: lineNumber,
            numberColumn: numberColumn,
            numberElement: numberElement,
            side: void 0,
            splitLineIndex: splitLineIndex
        };
        return {
            kind: "line",
            lineType: lineType,
            lineElement: lineElement,
            lineNumber: lineNumber,
            numberColumn: numberColumn,
            numberElement: numberElement,
            side: $12fff3ed1f91ca75$var$getAnnotationSide(lineType, codeElement),
            splitLineIndex: splitLineIndex
        };
    }
    isSplitDiff() {
        return this.pre?.getAttribute("data-diff-type") === "split";
    }
    parseLineIndex(element, split) {
        const lineIndexes = (element.getAttribute("data-line-index") ?? "").split(",").map((value)=>Number.parseInt(value, 10)).filter((value)=>!Number.isNaN(value));
        if (split && lineIndexes.length === 2) return lineIndexes[1];
        if (!split) return lineIndexes[0];
    }
};
function $12fff3ed1f91ca75$export$81858fc3df89d648({ enableTokenInteractionsOnWhitespace: enableTokenInteractionsOnWhitespace, enableGutterUtility: enableGutterUtility, lineHoverHighlight: lineHoverHighlight, onGutterUtilityClick: onGutterUtilityClick, onLineClick: onLineClick, onLineEnter: onLineEnter, onLineLeave: onLineLeave, onLineNumberClick: onLineNumberClick, onTokenClick: onTokenClick, onTokenEnter: onTokenEnter, onTokenLeave: onTokenLeave, renderGutterUtility: renderGutterUtility, __debugPointerEvents: __debugPointerEvents, enableLineSelection: enableLineSelection, controlledSelection: controlledSelection, onLineSelected: onLineSelected, onLineSelectionStart: onLineSelectionStart, onLineSelectionChange: onLineSelectionChange, onLineSelectionEnd: onLineSelectionEnd }, onHunkExpand, getLineIndex, onMergeConflictActionClick) {
    return {
        enableTokenInteractionsOnWhitespace: enableTokenInteractionsOnWhitespace,
        enableGutterUtility: $12fff3ed1f91ca75$var$resolveEnableGutterUtilityOption({
            enableGutterUtility: enableGutterUtility,
            renderGutterUtility: renderGutterUtility,
            onGutterUtilityClick: onGutterUtilityClick
        }),
        usesCustomGutterUtility: renderGutterUtility != null,
        lineHoverHighlight: lineHoverHighlight,
        onGutterUtilityClick: onGutterUtilityClick,
        onHunkExpand: onHunkExpand,
        onMergeConflictActionClick: onMergeConflictActionClick,
        onLineClick: onLineClick,
        onLineEnter: onLineEnter,
        onLineLeave: onLineLeave,
        onLineNumberClick: onLineNumberClick,
        onTokenClick: onTokenClick,
        onTokenEnter: onTokenEnter,
        onTokenLeave: onTokenLeave,
        __debugPointerEvents: __debugPointerEvents,
        enableLineSelection: enableLineSelection,
        controlledSelection: controlledSelection,
        onLineSelected: onLineSelected,
        onLineSelectionStart: onLineSelectionStart,
        onLineSelectionChange: onLineSelectionChange,
        onLineSelectionEnd: onLineSelectionEnd,
        getLineIndex: getLineIndex
    };
}
function $12fff3ed1f91ca75$var$resolveEnableGutterUtilityOption({ enableGutterUtility: enableGutterUtility, renderGutterUtility: renderGutterUtility, onGutterUtilityClick: onGutterUtilityClick }) {
    if (onGutterUtilityClick != null && renderGutterUtility != null) throw new Error("Cannot use both 'onGutterUtilityClick' and 'renderGutterUtility'. Use only one gutter utility API.");
    return enableGutterUtility ?? false;
}
function $12fff3ed1f91ca75$var$isLinePointerTarget(target) {
    return target != null && "kind" in target && target.kind === "line";
}
function $12fff3ed1f91ca75$var$isTokenPointerTarget(target) {
    return target != null && "kind" in target && target.kind === "token";
}
function $12fff3ed1f91ca75$var$isHoverableLinePointerTarget(target) {
    return $12fff3ed1f91ca75$var$isLinePointerTarget(target) || $12fff3ed1f91ca75$var$isTokenPointerTarget(target);
}
function $12fff3ed1f91ca75$var$isExpandoPointerTarget(target) {
    return "type" in target && target.type === "line-info";
}
function $12fff3ed1f91ca75$var$isMergeConflictActionPointerTarget(target) {
    return "kind" in target && target.kind === "merge-conflict-action";
}
function $12fff3ed1f91ca75$var$isMergeConflictResolution(value) {
    return value === "current" || value === "incoming" || value === "both";
}
function $12fff3ed1f91ca75$var$queryHTMLElement(parent, query) {
    const element = parent?.querySelector(query);
    return element instanceof HTMLElement ? element : void 0;
}
function $12fff3ed1f91ca75$var$getElementPath(element) {
    const path = [];
    let current = element;
    while(current != null){
        path.push(current);
        current = current.parentNode;
    }
    return path;
}
function $12fff3ed1f91ca75$var$closestSelectableRow(element) {
    const row = element.closest("[data-line], [data-column-number]");
    if (row instanceof HTMLElement) return row;
    const annotationRow = element.closest("[data-line-annotation], [data-gutter-buffer=\"annotation\"]");
    if (!(annotationRow instanceof HTMLElement)) return;
    const previousRow = annotationRow.previousElementSibling;
    return previousRow instanceof HTMLElement && (previousRow.hasAttribute("data-line") || previousRow.hasAttribute("data-column-number")) ? previousRow : void 0;
}
function $12fff3ed1f91ca75$var$getAnnotationSlotName(element) {
    const slottedElement = element.closest("[slot^=\"annotation-\"]");
    if (slottedElement instanceof HTMLElement) return slottedElement.getAttribute("slot") ?? void 0;
    if (element instanceof HTMLElement) {
        const slotName = element.getAttribute("name") ?? void 0;
        return slotName != null && slotName.startsWith("annotation-") ? slotName : void 0;
    }
}
function $12fff3ed1f91ca75$var$selectionPointFromAnnotationSlotName(slotName) {
    if (slotName == null) return;
    const match = /^annotation-(?:(additions|deletions)-)?(\d+)$/.exec(slotName);
    if (match == null) return;
    const lineNumber = Number.parseInt(match[2], 10);
    if (!Number.isFinite(lineNumber)) return;
    return {
        lineNumber: lineNumber,
        side: match[1]
    };
}
function $12fff3ed1f91ca75$var$hasElementFromPoint(value) {
    return value != null && typeof value.elementFromPoint === "function";
}
function $12fff3ed1f91ca75$var$getAnnotationSide(lineType, codeElement) {
    switch(lineType){
        case "change-deletion":
            return "deletions";
        case "change-addition":
            return "additions";
        default:
            return codeElement.hasAttribute("data-deletions") ? "deletions" : "additions";
    }
}
function $12fff3ed1f91ca75$var$getLineTypeFromElement(element) {
    const lineType = element.getAttribute("data-line-type");
    if (lineType == null) return;
    switch(lineType){
        case "change-deletion":
        case "change-addition":
        case "context":
        case "context-expanded":
            return lineType;
        default:
            return;
    }
}
function $12fff3ed1f91ca75$var$isGutterUtilityPath(path) {
    for (const element of path){
        if (!(element instanceof HTMLElement)) continue;
        if (element.hasAttribute("data-utility-button") || element.hasAttribute("data-gutter-utility-slot") || element.getAttribute("slot") === "gutter-utility-slot" || element.getAttribute("name") === "gutter-utility-slot") return true;
    }
    return false;
}
function $12fff3ed1f91ca75$var$debugLogIfEnabled(debugLogType = "none", logIfType, ...args) {
    switch(debugLogType){
        case "none":
            return;
        case "both":
            break;
        case "click":
            if (logIfType !== "click") return;
            break;
        case "move":
            if (logIfType !== "move") return;
            break;
    }
    console.log(...args);
}


//#region src/managers/ResizeManager.ts
var $44ea84d1b8c4f335$export$c2996b1539fb6bb1 = class ResizeManager {
    static resizeObserver;
    static managersByElement = /* @__PURE__ */ new Map();
    static getResizeObserver() {
        const resizeObserver = ResizeManager.resizeObserver ?? new ResizeObserver(ResizeManager.handleSharedResizeEntries);
        ResizeManager.resizeObserver = resizeObserver;
        return resizeObserver;
    }
    static handleSharedResizeEntries(entries) {
        const entriesByManager = /* @__PURE__ */ new Map();
        for (const entry of entries){
            const manager = ResizeManager.managersByElement.get(entry.target);
            if (manager == null) continue;
            const managerEntries = entriesByManager.get(manager);
            if (managerEntries == null) entriesByManager.set(manager, [
                entry
            ]);
            else managerEntries.push(entry);
        }
        for (const [manager, managerEntries] of entriesByManager)manager.handleResizeEntries(managerEntries);
    }
    observedNodes = /* @__PURE__ */ new Map();
    setup(pre, disableAnnotations) {
        const annotationUpdates = /* @__PURE__ */ new Set();
        let columnCount = 0;
        const observedNodes = new Map(this.observedNodes);
        this.observedNodes.clear();
        for (const element of pre.children){
            if (columnCount === 2) break;
            const codeElement = (()=>{
                if (element instanceof HTMLElement && element.tagName === "CODE") return element;
            })();
            if (codeElement == null) continue;
            columnCount++;
            let item = observedNodes.get(codeElement);
            if (item != null && item.type !== "code") throw new Error("ResizeManager.setup: somehow a code node is being used for an annotation, should be impossible");
            let numberElement = codeElement.firstElementChild;
            if (!(numberElement instanceof HTMLElement)) numberElement = null;
            if (item != null) {
                this.observedNodes.set(codeElement, item);
                observedNodes.delete(codeElement);
                if (item.numberElement !== numberElement) {
                    if (item.numberElement != null) {
                        this.unobserve(item.numberElement);
                        observedNodes.delete(item.numberElement);
                    }
                    if (numberElement != null) {
                        this.observe(numberElement);
                        observedNodes.delete(numberElement);
                        this.observedNodes.set(numberElement, item);
                    }
                    item.numberElement = numberElement;
                    item.numberWidth = 0;
                } else if (item.numberElement != null) {
                    observedNodes.delete(item.numberElement);
                    this.observedNodes.set(item.numberElement, item);
                } else item.numberWidth = 0;
            } else {
                item = {
                    type: "code",
                    codeElement: codeElement,
                    numberElement: numberElement,
                    codeWidth: "auto",
                    numberWidth: 0
                };
                this.observedNodes.set(codeElement, item);
                this.observe(codeElement);
                if (numberElement != null) {
                    this.observedNodes.set(numberElement, item);
                    this.observe(numberElement);
                }
            }
        }
        if (columnCount > 1 && !disableAnnotations) {
            const annotationElements = pre.querySelectorAll("[data-line-annotation*=\",\"]");
            const elementMap = /* @__PURE__ */ new Map();
            for (const element of annotationElements){
                if (!(element instanceof HTMLElement)) continue;
                const lineAnnotation = element.getAttribute("data-line-annotation") ?? "";
                if (!/^\d+,\d+$/.test(lineAnnotation)) {
                    console.error("DiffFileRenderer.setupResizeObserver: Invalid element or annotation", {
                        lineAnnotation: lineAnnotation,
                        element: element
                    });
                    continue;
                }
                let pairs = elementMap.get(lineAnnotation);
                if (pairs == null) {
                    pairs = [];
                    elementMap.set(lineAnnotation, pairs);
                }
                pairs.push(element);
            }
            for (const [key, pair] of elementMap){
                if (pair.length !== 2) {
                    console.error("DiffFileRenderer.setupResizeObserver: Bad Pair", key, pair);
                    continue;
                }
                const [container1, container2] = pair;
                const child1 = container1.firstElementChild;
                const child2 = container2.firstElementChild;
                if (!(container1 instanceof HTMLElement) || !(container2 instanceof HTMLElement) || !(child1 instanceof HTMLElement) || !(child2 instanceof HTMLElement)) continue;
                let item = observedNodes.get(child1);
                if (item != null) {
                    this.observedNodes.set(child1, item);
                    this.observedNodes.set(child2, item);
                    observedNodes.delete(child1);
                    observedNodes.delete(child2);
                    continue;
                }
                const child1Height = child1.getBoundingClientRect().height;
                const child2Height = child2.getBoundingClientRect().height;
                item = {
                    type: "annotations",
                    column1: {
                        container: container1,
                        child: child1,
                        childHeight: child1Height
                    },
                    column2: {
                        container: container2,
                        child: child2,
                        childHeight: child2Height
                    },
                    currentHeight: "auto"
                };
                annotationUpdates.add({
                    child1: child1,
                    child2: child2,
                    item: item,
                    newHeight: Math.max(child1Height, child2Height)
                });
            }
            for (const pendingUpdate of annotationUpdates){
                this.applyNewHeight(pendingUpdate.item, pendingUpdate.newHeight);
                this.observedNodes.set(pendingUpdate.child1, pendingUpdate.item);
                this.observedNodes.set(pendingUpdate.child2, pendingUpdate.item);
                this.observe(pendingUpdate.child1);
                this.observe(pendingUpdate.child2);
            }
            annotationUpdates.clear();
        }
        for (const [element, item] of observedNodes){
            this.unobserve(element);
            if (item.type === "code") $44ea84d1b8c4f335$var$cleanupStaleCodeItem(item);
            else $44ea84d1b8c4f335$var$cleanupStaleAnnotationItem(item);
        }
        observedNodes.clear();
    }
    cleanUp() {
        for (const element of this.observedNodes.keys())this.unobserve(element);
        this.observedNodes.clear();
    }
    observe(element) {
        const { managersByElement: managersByElement } = ResizeManager;
        const owner = managersByElement.get(element);
        if (owner === this) return;
        else if (owner != null && owner !== this) throw new Error("ResizeManager.observe: element is already owned by another ResizeManager");
        managersByElement.set(element, this);
        ResizeManager.getResizeObserver().observe(element);
    }
    unobserve(element) {
        const { managersByElement: managersByElement, resizeObserver: resizeObserver } = ResizeManager;
        const owner = managersByElement.get(element);
        if (owner == null) return;
        else if (owner !== this) throw new Error("ResizeManager.unobserve: element is owned by another ResizeManager");
        managersByElement.delete(element);
        resizeObserver?.unobserve(element);
        if (resizeObserver != null && managersByElement.size === 0) {
            resizeObserver.disconnect();
            ResizeManager.resizeObserver = void 0;
        }
    }
    handleResizeEntries(entries) {
        const codeUpdates = /* @__PURE__ */ new Map();
        const annotationUpdates = /* @__PURE__ */ new Set();
        for (const entry of entries){
            const { target: target, borderBoxSize: borderBoxSize, contentBoxSize: contentBoxSize } = entry;
            if (!(target instanceof HTMLElement)) {
                console.error("ResizeManager.handleResizeEntries: Invalid element for ResizeObserver", entry);
                continue;
            }
            const item = this.observedNodes.get(target);
            if (item == null) {
                console.error("ResizeManager.handleResizeEntries: Not a valid observed node", entry);
                continue;
            }
            if (item.type === "annotations") {
                const column = (()=>{
                    if (target === item.column1.child) return item.column1;
                    if (target === item.column2.child) return item.column2;
                })();
                if (column == null) {
                    console.error(`ResizeManager.handleResizeEntries: Couldn't find a column for`, {
                        item: item,
                        target: target
                    });
                    continue;
                }
                column.childHeight = borderBoxSize[0].blockSize;
                annotationUpdates.add(item);
            } else if (item.type === "code") {
                const update = codeUpdates.get(item) ?? {};
                const inlineSize = contentBoxSize[0].inlineSize;
                if (target === item.codeElement) update.codeInlineSize = inlineSize;
                else if (target === item.numberElement) update.numberInlineSize = inlineSize;
                codeUpdates.set(item, update);
            }
        }
        this.applyAnnotationUpdates(annotationUpdates);
        annotationUpdates.clear();
        this.applyColumnUpdates(codeUpdates);
        codeUpdates.clear();
    }
    applyAnnotationUpdates(annotationUpdates) {
        for (const item of annotationUpdates)this.applyNewHeight(item, Math.max(item.column1.childHeight, item.column2.childHeight));
    }
    applyColumnUpdates = (queuedUpdates)=>{
        for (const [item, update] of queuedUpdates){
            const nextCodeWidth = update.codeInlineSize != null ? $44ea84d1b8c4f335$var$resolveCodeWidth(update.codeInlineSize) : item.codeWidth;
            const nextNumberWidth = update.numberInlineSize != null ? $44ea84d1b8c4f335$var$resolveNumberWidth(update.numberInlineSize) : item.numberWidth;
            const codeWidthChanged = nextCodeWidth !== item.codeWidth;
            const numberWidthChanged = nextNumberWidth !== item.numberWidth;
            if (!codeWidthChanged && !numberWidthChanged) continue;
            item.codeWidth = nextCodeWidth;
            item.numberWidth = nextNumberWidth;
            if (codeWidthChanged) item.codeElement.style.setProperty("--diffs-column-width", `${typeof nextCodeWidth === "number" ? `${nextCodeWidth}px` : "auto"}`);
            if (numberWidthChanged) item.codeElement.style.setProperty("--diffs-column-number-width", `${nextNumberWidth === 0 ? "auto" : `${nextNumberWidth}px`}`);
            if (codeWidthChanged || numberWidthChanged && nextCodeWidth !== "auto") {
                const targetWidth = typeof nextCodeWidth === "number" ? Math.max(nextCodeWidth - nextNumberWidth, 0) : 0;
                item.codeElement.style.setProperty("--diffs-column-content-width", `${targetWidth > 0 ? `${targetWidth}px` : "auto"}`);
            }
        }
    };
    applyNewHeight(item, newHeight) {
        if (newHeight !== item.currentHeight) {
            item.currentHeight = Math.max(newHeight, 0);
            item.column1.container.style.setProperty("--diffs-annotation-min-height", `${item.currentHeight}px`);
            item.column2.container.style.setProperty("--diffs-annotation-min-height", `${item.currentHeight}px`);
        }
    }
};
function $44ea84d1b8c4f335$var$resolveCodeWidth(inlineSize) {
    const width = Math.max(Math.floor(inlineSize), 0);
    return width === 0 ? "auto" : width;
}
function $44ea84d1b8c4f335$var$resolveNumberWidth(inlineSize) {
    return Math.max(Math.ceil(inlineSize), 0);
}
function $44ea84d1b8c4f335$var$cleanupStaleCodeItem(item) {
    if (item.codeElement.isConnected) {
        item.codeElement.style.removeProperty("--diffs-column-content-width");
        item.codeElement.style.removeProperty("--diffs-column-number-width");
        item.codeElement.style.removeProperty("--diffs-column-width");
    }
}
function $44ea84d1b8c4f335$var$cleanupStaleAnnotationItem(item) {
    if (item.column1.container.isConnected) item.column1.container.style.removeProperty("--diffs-annotation-min-height");
    if (item.column2.container.isConnected) item.column2.container.style.removeProperty("--diffs-annotation-min-height");
}


//#region src/utils/areFilesEqual.ts
function $2f249b89688d7794$export$66ae137c56162891(fileA, fileB) {
    return fileA?.cacheKey === fileB?.cacheKey && fileA?.contents === fileB?.contents && fileA?.name === fileB?.name && fileA?.lang === fileB?.lang;
}


//#region src/utils/areRenderRangesEqual.ts
function $27129b485d2e8f5d$export$7df1d5d844442f33(renderRangeA, renderRangeB) {
    if (renderRangeA == null || renderRangeB == null) return renderRangeA === renderRangeB;
    return renderRangeA.startingLine === renderRangeB.startingLine && renderRangeA.totalLines === renderRangeB.totalLines && renderRangeA.bufferBefore === renderRangeB.bufferBefore && renderRangeA.bufferAfter === renderRangeB.bufferAfter;
}


//#region src/utils/getLineAnnotationName.ts
function $ac9bb0f0aa61e1e0$export$3619c1a4d9651049(annotation) {
    return `annotation-${"side" in annotation ? `${annotation.side}-` : ""}${annotation.lineNumber}`;
}


//#region src/utils/getFiletypeFromFileName.ts
const $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT = /* @__PURE__ */ new Map();
let $350fbdca8afa0197$var$customExtensionsVersion = 0;
const $350fbdca8afa0197$export$5f537794774250b7 = {
    "1c": "1c",
    abap: "abap",
    as: "actionscript-3",
    ada: "ada",
    adb: "ada",
    ads: "ada",
    adoc: "asciidoc",
    asciidoc: "asciidoc",
    "component.html": "angular-html",
    "component.ts": "angular-ts",
    conf: "nginx",
    htaccess: "apache",
    cls: "tex",
    trigger: "apex",
    apl: "apl",
    applescript: "applescript",
    scpt: "applescript",
    ara: "ara",
    asm: "asm",
    s: "riscv",
    astro: "astro",
    awk: "awk",
    bal: "ballerina",
    sh: "zsh",
    bash: "zsh",
    bat: "cmd",
    cmd: "cmd",
    be: "berry",
    beancount: "beancount",
    bib: "bibtex",
    bicep: "bicep",
    "blade.php": "blade",
    bsl: "bsl",
    c: "c",
    h: "objective-cpp",
    cs: "csharp",
    cpp: "cpp",
    hpp: "cpp",
    cc: "cpp",
    cxx: "cpp",
    hh: "cpp",
    cdc: "cdc",
    cairo: "cairo",
    clar: "clarity",
    clj: "clojure",
    cljs: "clojure",
    cljc: "clojure",
    soy: "soy",
    cmake: "cmake",
    "CMakeLists.txt": "cmake",
    cob: "cobol",
    cbl: "cobol",
    cobol: "cobol",
    CODEOWNERS: "codeowners",
    ql: "ql",
    coffee: "coffeescript",
    lisp: "lisp",
    cl: "lisp",
    lsp: "lisp",
    log: "log",
    v: "verilog",
    cql: "cql",
    cr: "crystal",
    css: "css",
    csv: "csv",
    cue: "cue",
    cypher: "cypher",
    cyp: "cypher",
    d: "d",
    dart: "dart",
    dax: "dax",
    desktop: "desktop",
    diff: "diff",
    patch: "diff",
    Dockerfile: "dockerfile",
    dockerfile: "dockerfile",
    env: "dotenv",
    dm: "dream-maker",
    edge: "edge",
    el: "emacs-lisp",
    ex: "elixir",
    exs: "elixir",
    elm: "elm",
    erb: "erb",
    erl: "erlang",
    hrl: "erlang",
    f: "fortran-fixed-form",
    for: "fortran-fixed-form",
    fs: "fsharp",
    fsi: "fsharp",
    fsx: "fsharp",
    f03: "f03",
    f08: "f08",
    f18: "f18",
    f77: "f77",
    f90: "fortran-free-form",
    f95: "fortran-free-form",
    fnl: "fennel",
    fish: "fish",
    ftl: "ftl",
    tres: "gdresource",
    res: "gdresource",
    gd: "gdscript",
    gdshader: "gdshader",
    gs: "genie",
    feature: "gherkin",
    COMMIT_EDITMSG: "git-commit",
    "git-rebase-todo": "git-rebase",
    gjs: "glimmer-js",
    gleam: "gleam",
    gts: "glimmer-ts",
    glsl: "glsl",
    vert: "glsl",
    frag: "glsl",
    shader: "shaderlab",
    gp: "gnuplot",
    plt: "gnuplot",
    gnuplot: "gnuplot",
    go: "go",
    graphql: "graphql",
    gql: "graphql",
    groovy: "groovy",
    gvy: "groovy",
    hack: "hack",
    haml: "haml",
    hbs: "handlebars",
    handlebars: "handlebars",
    hs: "haskell",
    lhs: "haskell",
    hx: "haxe",
    hcl: "hcl",
    hjson: "hjson",
    hlsl: "hlsl",
    fx: "hlsl",
    html: "html",
    htm: "html",
    http: "http",
    rest: "http",
    hxml: "hxml",
    hy: "hy",
    imba: "imba",
    ini: "ini",
    cfg: "ini",
    jade: "pug",
    pug: "pug",
    java: "java",
    js: "javascript",
    mjs: "javascript",
    cjs: "javascript",
    jinja: "jinja",
    jinja2: "jinja",
    j2: "jinja",
    jison: "jison",
    jl: "julia",
    json: "json",
    json5: "json5",
    jsonc: "jsonc",
    jsonl: "jsonl",
    jsonnet: "jsonnet",
    libsonnet: "jsonnet",
    jssm: "jssm",
    jsx: "jsx",
    kt: "kotlin",
    kts: "kts",
    kql: "kusto",
    tex: "tex",
    ltx: "tex",
    lean: "lean4",
    less: "less",
    liquid: "liquid",
    lit: "lit",
    ll: "llvm",
    logo: "logo",
    lua: "lua",
    luau: "luau",
    Makefile: "makefile",
    mk: "makefile",
    makefile: "makefile",
    md: "markdown",
    markdown: "markdown",
    marko: "marko",
    m: "wolfram",
    mat: "matlab",
    mdc: "mdc",
    mdx: "mdx",
    wiki: "wikitext",
    mediawiki: "wikitext",
    mmd: "mermaid",
    mermaid: "mermaid",
    mips: "mipsasm",
    mojo: "mojo",
    "\uD83D\uDD25": "mojo",
    move: "move",
    nar: "narrat",
    nf: "nextflow",
    nim: "nim",
    nims: "nim",
    nimble: "nim",
    nix: "nix",
    nu: "nushell",
    mm: "objective-cpp",
    ml: "ocaml",
    mli: "ocaml",
    mll: "ocaml",
    mly: "ocaml",
    pas: "pascal",
    p: "pascal",
    pl: "prolog",
    pm: "perl",
    t: "perl",
    raku: "raku",
    p6: "raku",
    pl6: "raku",
    php: "php",
    phtml: "php",
    pls: "plsql",
    sql: "sql",
    po: "po",
    polar: "polar",
    pcss: "postcss",
    pot: "pot",
    potx: "potx",
    pq: "powerquery",
    pqm: "powerquery",
    ps1: "powershell",
    psm1: "powershell",
    psd1: "powershell",
    prisma: "prisma",
    pro: "prolog",
    P: "prolog",
    properties: "properties",
    proto: "protobuf",
    pp: "puppet",
    purs: "purescript",
    py: "python",
    pyw: "python",
    pyi: "python",
    qml: "qml",
    qmldir: "qmldir",
    qss: "qss",
    r: "r",
    R: "r",
    rkt: "racket",
    rktl: "racket",
    razor: "razor",
    cshtml: "razor",
    rb: "ruby",
    rbw: "ruby",
    reg: "reg",
    regex: "regexp",
    rel: "rel",
    rs: "rust",
    rst: "rst",
    rake: "ruby",
    gemspec: "ruby",
    jbuilder: "ruby",
    builder: "ruby",
    rabl: "ruby",
    arb: "ruby",
    ru: "ruby",
    podspec: "ruby",
    Gemfile: "ruby",
    Rakefile: "ruby",
    Guardfile: "ruby",
    Capfile: "ruby",
    Berksfile: "ruby",
    Brewfile: "ruby",
    Vagrantfile: "ruby",
    Thorfile: "ruby",
    Appraisals: "ruby",
    Dangerfile: "ruby",
    sas: "sas",
    sass: "sass",
    scala: "scala",
    sc: "scala",
    scm: "scheme",
    ss: "scheme",
    sld: "scheme",
    scss: "scss",
    sdbl: "sdbl",
    shadergraph: "shader",
    st: "smalltalk",
    sol: "solidity",
    sparql: "sparql",
    rq: "sparql",
    spl: "splunk",
    config: "ssh-config",
    do: "stata",
    ado: "stata",
    dta: "stata",
    styl: "stylus",
    stylus: "stylus",
    svelte: "svelte",
    swift: "swift",
    sv: "system-verilog",
    svh: "system-verilog",
    service: "systemd",
    socket: "systemd",
    device: "systemd",
    timer: "systemd",
    talon: "talonscript",
    tasl: "tasl",
    tcl: "tcl",
    templ: "templ",
    tf: "tf",
    tfvars: "tfvars",
    toml: "toml",
    ts: "typescript",
    tsp: "typespec",
    tsv: "tsv",
    tsx: "tsx",
    ttl: "turtle",
    twig: "twig",
    typ: "typst",
    vv: "v",
    vala: "vala",
    vapi: "vala",
    vb: "vb",
    vbs: "vb",
    bas: "vb",
    vh: "verilog",
    vhd: "vhdl",
    vhdl: "vhdl",
    vim: "vimscript",
    vue: "vue",
    "vine.ts": "vue-vine",
    vy: "vyper",
    wasm: "wasm",
    wat: "wasm",
    wy: "\u6587\u8A00",
    wgsl: "wgsl",
    wit: "wit",
    wl: "wolfram",
    nb: "wolfram",
    xml: "xml",
    xsl: "xsl",
    xslt: "xsl",
    yaml: "yaml",
    yml: "yml",
    zs: "zenscript",
    zig: "zig",
    zsh: "zsh",
    sty: "tex"
};
function $350fbdca8afa0197$export$c90416708c3e3b9(fileName) {
    if ($350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.has(fileName)) return $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.get(fileName) ?? "text";
    if ($350fbdca8afa0197$export$5f537794774250b7[fileName] != null) return $350fbdca8afa0197$export$5f537794774250b7[fileName];
    const compoundMatch = fileName.match(/\.([^/\\]+\.[^/\\]+)$/);
    if (compoundMatch != null) {
        if ($350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.has(compoundMatch[1])) return $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.get(compoundMatch[1]) ?? "text";
        if ($350fbdca8afa0197$export$5f537794774250b7[compoundMatch[1]] != null) return $350fbdca8afa0197$export$5f537794774250b7[compoundMatch[1]] ?? "text";
    }
    const simpleMatch = fileName.match(/\.([^.]+)$/)?.[1] ?? "";
    if ($350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.has(simpleMatch)) return $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.get(simpleMatch) ?? "text";
    return $350fbdca8afa0197$export$5f537794774250b7[simpleMatch] ?? "text";
}
function $350fbdca8afa0197$export$8712ebf7a6902915(version, map) {
    if (version <= $350fbdca8afa0197$var$customExtensionsVersion) return false;
    $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.clear();
    for(const key in map){
        const lang = map[key];
        if (lang != null) $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.set(key, lang);
    }
    $350fbdca8afa0197$var$customExtensionsVersion = version;
    return true;
}
function $350fbdca8afa0197$export$57722d6cacc4c14b() {
    return $350fbdca8afa0197$var$customExtensionsVersion;
}
function $350fbdca8afa0197$export$8eca8dc8d0155122(key, lang) {
    const existing = $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.get(key);
    if (existing === lang) return false;
    if (existing != null) console.warn(`setCustomExtension: overriding custom mapping for "${key}" from "${existing}" to "${lang}"`);
    $350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT.set(key, lang);
    $350fbdca8afa0197$var$customExtensionsVersion++;
    return true;
}
function $350fbdca8afa0197$export$d97a82fa7de98085() {
    return Object.fromEntries($350fbdca8afa0197$var$CUSTOM_EXTENSION_TO_FILE_FORMAT);
}


//#region src/utils/isFilePlainText.ts
function $15de751b18238005$export$4d513fdf32c04fe0(file) {
    return (file.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(file.name)) === "text";
}





//#region src/highlighter/languages/constants.ts
const $afd67e7e9e3398b6$export$440dc6ff9aa62a31 = /* @__PURE__ */ new Map();
const $afd67e7e9e3398b6$export$76097dbde99d9f89 = /* @__PURE__ */ new Map();
const $afd67e7e9e3398b6$export$9f176c210211a0f6 = /* @__PURE__ */ new Map();
const $afd67e7e9e3398b6$export$caef546f4d949032 = /* @__PURE__ */ new Set();


//#region src/highlighter/languages/areLanguagesAttached.ts
function $78bde705d027ffd2$export$fa78c2fcbeceac38(languages) {
    for (const language of Array.isArray(languages) ? languages : [
        languages
    ]){
        if (language === "text" || language === "ansi") continue;
        if (!(0, $afd67e7e9e3398b6$export$caef546f4d949032).has(language)) return false;
    }
    return true;
}



//#region src/highlighter/languages/attachResolvedLanguages.ts
function $63d7daf2cbedb23d$export$648bcf6cfa65db4(resolvedLanguages, highlighter) {
    resolvedLanguages = Array.isArray(resolvedLanguages) ? resolvedLanguages : [
        resolvedLanguages
    ];
    for (const resolvedLang of resolvedLanguages){
        if ((0, $afd67e7e9e3398b6$export$caef546f4d949032).has(resolvedLang.name)) continue;
        let lang = (0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).get(resolvedLang.name);
        if (lang == null) {
            lang = resolvedLang;
            (0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).set(resolvedLang.name, lang);
        }
        (0, $afd67e7e9e3398b6$export$caef546f4d949032).add(lang.name);
        highlighter.loadLanguageSync(lang.data);
    }
}



//#region src/highlighter/languages/cleanUpResolvedLanguages.ts
function $03592043e37c3a6a$export$15930efdd75fda59() {
    (0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).clear();
    (0, $afd67e7e9e3398b6$export$caef546f4d949032).clear();
}




//#region src/utils/isWorkerContext.ts
function $c7c05f3bbf3bd887$export$3ff2f5c75c098e85() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}













































































































































































































































const $f9082090a7ce57f6$export$fa9b44344f5e1d6b = [
    {
        "id": "abap",
        "name": "ABAP",
        "import": ()=>(parcelRequire("1kxNS"))
    },
    {
        "id": "actionscript-3",
        "name": "ActionScript",
        "import": ()=>(parcelRequire("17RAS"))
    },
    {
        "id": "ada",
        "name": "Ada",
        "import": ()=>(parcelRequire("9cAOC"))
    },
    {
        "id": "angular-html",
        "name": "Angular HTML",
        "import": ()=>(parcelRequire("ig1zj"))
    },
    {
        "id": "angular-ts",
        "name": "Angular TypeScript",
        "import": ()=>(parcelRequire("izwJa"))
    },
    {
        "id": "apache",
        "name": "Apache Conf",
        "import": ()=>(parcelRequire("5ICjr"))
    },
    {
        "id": "apex",
        "name": "Apex",
        "import": ()=>(parcelRequire("cnA9B"))
    },
    {
        "id": "apl",
        "name": "APL",
        "import": ()=>(parcelRequire("hWRf7"))
    },
    {
        "id": "applescript",
        "name": "AppleScript",
        "import": ()=>(parcelRequire("hNE8N"))
    },
    {
        "id": "ara",
        "name": "Ara",
        "import": ()=>(parcelRequire("iu44M"))
    },
    {
        "id": "asciidoc",
        "name": "AsciiDoc",
        "aliases": [
            "adoc"
        ],
        "import": ()=>(parcelRequire("9bosY"))
    },
    {
        "id": "asm",
        "name": "Assembly",
        "import": ()=>(parcelRequire("lS6VR"))
    },
    {
        "id": "astro",
        "name": "Astro",
        "import": ()=>(parcelRequire("i3E6M"))
    },
    {
        "id": "awk",
        "name": "AWK",
        "import": ()=>(parcelRequire("btvxz"))
    },
    {
        "id": "ballerina",
        "name": "Ballerina",
        "import": ()=>(parcelRequire("cw4kp"))
    },
    {
        "id": "bat",
        "name": "Batch File",
        "aliases": [
            "batch"
        ],
        "import": ()=>(parcelRequire("azW6p"))
    },
    {
        "id": "beancount",
        "name": "Beancount",
        "import": ()=>(parcelRequire("4mam3"))
    },
    {
        "id": "berry",
        "name": "Berry",
        "aliases": [
            "be"
        ],
        "import": ()=>(parcelRequire("7eQZD"))
    },
    {
        "id": "bibtex",
        "name": "BibTeX",
        "import": ()=>(parcelRequire("hCWPF"))
    },
    {
        "id": "bicep",
        "name": "Bicep",
        "import": ()=>(parcelRequire("7TqMi"))
    },
    {
        "id": "bird2",
        "name": "BIRD2 Configuration",
        "aliases": [
            "bird"
        ],
        "import": ()=>(parcelRequire("hE34J"))
    },
    {
        "id": "blade",
        "name": "Blade",
        "import": ()=>(parcelRequire("beNf0"))
    },
    {
        "id": "bsl",
        "name": "1C (Enterprise)",
        "aliases": [
            "1c"
        ],
        "import": ()=>(parcelRequire("kHo6B"))
    },
    {
        "id": "c",
        "name": "C",
        "import": ()=>(parcelRequire("aKj1q"))
    },
    {
        "id": "c3",
        "name": "C3",
        "import": ()=>(parcelRequire("lzpRT"))
    },
    {
        "id": "cadence",
        "name": "Cadence",
        "aliases": [
            "cdc"
        ],
        "import": ()=>(parcelRequire("jzDwI"))
    },
    {
        "id": "cairo",
        "name": "Cairo",
        "import": ()=>(parcelRequire("30ZNd"))
    },
    {
        "id": "clarity",
        "name": "Clarity",
        "import": ()=>(parcelRequire("2tMCN"))
    },
    {
        "id": "clojure",
        "name": "Clojure",
        "aliases": [
            "clj"
        ],
        "import": ()=>(parcelRequire("gtVuc"))
    },
    {
        "id": "cmake",
        "name": "CMake",
        "import": ()=>(parcelRequire("eUGnc"))
    },
    {
        "id": "cobol",
        "name": "COBOL",
        "import": ()=>(parcelRequire("dyVBz"))
    },
    {
        "id": "codeowners",
        "name": "CODEOWNERS",
        "import": ()=>(parcelRequire("4l5Qy"))
    },
    {
        "id": "codeql",
        "name": "CodeQL",
        "aliases": [
            "ql"
        ],
        "import": ()=>(parcelRequire("j8xYK"))
    },
    {
        "id": "coffee",
        "name": "CoffeeScript",
        "aliases": [
            "coffeescript"
        ],
        "import": ()=>(parcelRequire("h41Lj"))
    },
    {
        "id": "common-lisp",
        "name": "Common Lisp",
        "aliases": [
            "lisp"
        ],
        "import": ()=>(parcelRequire("bEnnP"))
    },
    {
        "id": "coq",
        "name": "Coq",
        "import": ()=>(parcelRequire("9S5d7"))
    },
    {
        "id": "cpp",
        "name": "C++",
        "aliases": [
            "c++"
        ],
        "import": ()=>(parcelRequire("2cOfd"))
    },
    {
        "id": "crystal",
        "name": "Crystal",
        "import": ()=>(parcelRequire("dCiDK"))
    },
    {
        "id": "csharp",
        "name": "C#",
        "aliases": [
            "c#",
            "cs"
        ],
        "import": ()=>(parcelRequire("kF8sz"))
    },
    {
        "id": "css",
        "name": "CSS",
        "import": ()=>(parcelRequire("7IOMu"))
    },
    {
        "id": "csv",
        "name": "CSV",
        "import": ()=>(parcelRequire("lIwSa"))
    },
    {
        "id": "cue",
        "name": "CUE",
        "import": ()=>(parcelRequire("kjjFK"))
    },
    {
        "id": "cypher",
        "name": "Cypher",
        "aliases": [
            "cql"
        ],
        "import": ()=>(parcelRequire("73vIF"))
    },
    {
        "id": "d",
        "name": "D",
        "import": ()=>(parcelRequire("fscaG"))
    },
    {
        "id": "dart",
        "name": "Dart",
        "import": ()=>(parcelRequire("gf49Y"))
    },
    {
        "id": "dax",
        "name": "DAX",
        "import": ()=>(parcelRequire("ls28k"))
    },
    {
        "id": "desktop",
        "name": "Desktop",
        "import": ()=>(parcelRequire("9zt8E"))
    },
    {
        "id": "diff",
        "name": "Diff",
        "import": ()=>(parcelRequire("d9ttx"))
    },
    {
        "id": "docker",
        "name": "Dockerfile",
        "aliases": [
            "dockerfile"
        ],
        "import": ()=>(parcelRequire("9FVmB"))
    },
    {
        "id": "dotenv",
        "name": "dotEnv",
        "import": ()=>(parcelRequire("caf89"))
    },
    {
        "id": "dream-maker",
        "name": "Dream Maker",
        "import": ()=>(parcelRequire("aXQ0q"))
    },
    {
        "id": "edge",
        "name": "Edge",
        "import": ()=>(parcelRequire("6Ui8X"))
    },
    {
        "id": "elixir",
        "name": "Elixir",
        "import": ()=>(parcelRequire("ekYxJ"))
    },
    {
        "id": "elm",
        "name": "Elm",
        "import": ()=>(parcelRequire("ePH0I"))
    },
    {
        "id": "emacs-lisp",
        "name": "Emacs Lisp",
        "aliases": [
            "elisp"
        ],
        "import": ()=>(parcelRequire("g46lE"))
    },
    {
        "id": "erb",
        "name": "ERB",
        "import": ()=>(parcelRequire("kozFG"))
    },
    {
        "id": "erlang",
        "name": "Erlang",
        "aliases": [
            "erl"
        ],
        "import": ()=>(parcelRequire("e5AY1"))
    },
    {
        "id": "fennel",
        "name": "Fennel",
        "import": ()=>(parcelRequire("iJ2Y2"))
    },
    {
        "id": "fish",
        "name": "Fish",
        "import": ()=>(parcelRequire("3QNQm"))
    },
    {
        "id": "fluent",
        "name": "Fluent",
        "aliases": [
            "ftl"
        ],
        "import": ()=>(parcelRequire("jy5Gc"))
    },
    {
        "id": "fortran-fixed-form",
        "name": "Fortran (Fixed Form)",
        "aliases": [
            "f",
            "for",
            "f77"
        ],
        "import": ()=>(parcelRequire("7y8d1"))
    },
    {
        "id": "fortran-free-form",
        "name": "Fortran (Free Form)",
        "aliases": [
            "f90",
            "f95",
            "f03",
            "f08",
            "f18"
        ],
        "import": ()=>(parcelRequire("fZxB7"))
    },
    {
        "id": "fsharp",
        "name": "F#",
        "aliases": [
            "f#",
            "fs"
        ],
        "import": ()=>(parcelRequire("8wJiH"))
    },
    {
        "id": "gdresource",
        "name": "GDResource",
        "aliases": [
            "tscn",
            "tres"
        ],
        "import": ()=>(parcelRequire("d5GRw"))
    },
    {
        "id": "gdscript",
        "name": "GDScript",
        "aliases": [
            "gd"
        ],
        "import": ()=>(parcelRequire("cPOzu"))
    },
    {
        "id": "gdshader",
        "name": "GDShader",
        "import": ()=>(parcelRequire("kKoub"))
    },
    {
        "id": "genie",
        "name": "Genie",
        "import": ()=>(parcelRequire("99ODJ"))
    },
    {
        "id": "gherkin",
        "name": "Gherkin",
        "import": ()=>(parcelRequire("hQ8Ix"))
    },
    {
        "id": "git-commit",
        "name": "Git Commit Message",
        "import": ()=>(parcelRequire("bxkxY"))
    },
    {
        "id": "git-rebase",
        "name": "Git Rebase Message",
        "import": ()=>(parcelRequire("dFNCn"))
    },
    {
        "id": "gleam",
        "name": "Gleam",
        "import": ()=>(parcelRequire("6wb2d"))
    },
    {
        "id": "glimmer-js",
        "name": "Glimmer JS",
        "aliases": [
            "gjs"
        ],
        "import": ()=>(parcelRequire("e67bp"))
    },
    {
        "id": "glimmer-ts",
        "name": "Glimmer TS",
        "aliases": [
            "gts"
        ],
        "import": ()=>(parcelRequire("bOfya"))
    },
    {
        "id": "glsl",
        "name": "GLSL",
        "import": ()=>(parcelRequire("lxjm8"))
    },
    {
        "id": "gn",
        "name": "GN",
        "import": ()=>(parcelRequire("kI08N"))
    },
    {
        "id": "gnuplot",
        "name": "Gnuplot",
        "import": ()=>(parcelRequire("1Zlit"))
    },
    {
        "id": "go",
        "name": "Go",
        "import": ()=>(parcelRequire("6f0iC"))
    },
    {
        "id": "graphql",
        "name": "GraphQL",
        "aliases": [
            "gql"
        ],
        "import": ()=>(parcelRequire("fkgiI"))
    },
    {
        "id": "groovy",
        "name": "Groovy",
        "import": ()=>(parcelRequire("h6zvN"))
    },
    {
        "id": "hack",
        "name": "Hack",
        "import": ()=>(parcelRequire("5dqT9"))
    },
    {
        "id": "haml",
        "name": "Ruby Haml",
        "import": ()=>(parcelRequire("7DI29"))
    },
    {
        "id": "handlebars",
        "name": "Handlebars",
        "aliases": [
            "hbs"
        ],
        "import": ()=>(parcelRequire("fl9hx"))
    },
    {
        "id": "haskell",
        "name": "Haskell",
        "aliases": [
            "hs"
        ],
        "import": ()=>(parcelRequire("hPFjJ"))
    },
    {
        "id": "haxe",
        "name": "Haxe",
        "import": ()=>(parcelRequire("fV5mD"))
    },
    {
        "id": "hcl",
        "name": "HashiCorp HCL",
        "import": ()=>(parcelRequire("gJihM"))
    },
    {
        "id": "hjson",
        "name": "Hjson",
        "import": ()=>(parcelRequire("h3NBU"))
    },
    {
        "id": "hlsl",
        "name": "HLSL",
        "import": ()=>(parcelRequire("ggfVM"))
    },
    {
        "id": "html",
        "name": "HTML",
        "import": ()=>(parcelRequire("2kpqY"))
    },
    {
        "id": "html-derivative",
        "name": "HTML (Derivative)",
        "import": ()=>(parcelRequire("gC6J4"))
    },
    {
        "id": "http",
        "name": "HTTP",
        "import": ()=>(parcelRequire("1Vo2U"))
    },
    {
        "id": "hurl",
        "name": "Hurl",
        "import": ()=>(parcelRequire("6sM9I"))
    },
    {
        "id": "hxml",
        "name": "HXML",
        "import": ()=>(parcelRequire("c53kG"))
    },
    {
        "id": "hy",
        "name": "Hy",
        "import": ()=>(parcelRequire("cf1v6"))
    },
    {
        "id": "imba",
        "name": "Imba",
        "import": ()=>(parcelRequire("yIzc6"))
    },
    {
        "id": "ini",
        "name": "INI",
        "aliases": [
            "properties"
        ],
        "import": ()=>(parcelRequire("hJQHe"))
    },
    {
        "id": "java",
        "name": "Java",
        "import": ()=>(parcelRequire("gyF7G"))
    },
    {
        "id": "javascript",
        "name": "JavaScript",
        "aliases": [
            "js",
            "cjs",
            "mjs"
        ],
        "import": ()=>(parcelRequire("7wwms"))
    },
    {
        "id": "jinja",
        "name": "Jinja",
        "import": ()=>(parcelRequire("jXlSw"))
    },
    {
        "id": "jison",
        "name": "Jison",
        "import": ()=>(parcelRequire("99JXb"))
    },
    {
        "id": "json",
        "name": "JSON",
        "import": ()=>(parcelRequire("cx3iL"))
    },
    {
        "id": "json5",
        "name": "JSON5",
        "import": ()=>(parcelRequire("iqiTU"))
    },
    {
        "id": "jsonc",
        "name": "JSON with Comments",
        "import": ()=>(parcelRequire("8bJe4"))
    },
    {
        "id": "jsonl",
        "name": "JSON Lines",
        "import": ()=>(parcelRequire("ausat"))
    },
    {
        "id": "jsonnet",
        "name": "Jsonnet",
        "import": ()=>(parcelRequire("5fmdv"))
    },
    {
        "id": "jssm",
        "name": "JSSM",
        "aliases": [
            "fsl"
        ],
        "import": ()=>(parcelRequire("7WnHE"))
    },
    {
        "id": "jsx",
        "name": "JSX",
        "import": ()=>(parcelRequire("frtMl"))
    },
    {
        "id": "julia",
        "name": "Julia",
        "aliases": [
            "jl"
        ],
        "import": ()=>(parcelRequire("knvWN"))
    },
    {
        "id": "just",
        "name": "Just",
        "import": ()=>(parcelRequire("fwr6Z"))
    },
    {
        "id": "kdl",
        "name": "KDL",
        "import": ()=>(parcelRequire("9RpKq"))
    },
    {
        "id": "kotlin",
        "name": "Kotlin",
        "aliases": [
            "kt",
            "kts"
        ],
        "import": ()=>(parcelRequire("aMstF"))
    },
    {
        "id": "kusto",
        "name": "Kusto",
        "aliases": [
            "kql"
        ],
        "import": ()=>(parcelRequire("7H6al"))
    },
    {
        "id": "latex",
        "name": "LaTeX",
        "import": ()=>(parcelRequire("9DmQd"))
    },
    {
        "id": "lean",
        "name": "Lean 4",
        "aliases": [
            "lean4"
        ],
        "import": ()=>(parcelRequire("e19Ts"))
    },
    {
        "id": "less",
        "name": "Less",
        "import": ()=>(parcelRequire("8Oblf"))
    },
    {
        "id": "liquid",
        "name": "Liquid",
        "import": ()=>(parcelRequire("1YFd5"))
    },
    {
        "id": "llvm",
        "name": "LLVM IR",
        "import": ()=>(parcelRequire("ha7Re"))
    },
    {
        "id": "log",
        "name": "Log file",
        "import": ()=>(parcelRequire("78xhL"))
    },
    {
        "id": "logo",
        "name": "Logo",
        "import": ()=>(parcelRequire("16bns"))
    },
    {
        "id": "lua",
        "name": "Lua",
        "import": ()=>(parcelRequire("6cdSN"))
    },
    {
        "id": "luau",
        "name": "Luau",
        "import": ()=>(parcelRequire("kuOb2"))
    },
    {
        "id": "make",
        "name": "Makefile",
        "aliases": [
            "makefile"
        ],
        "import": ()=>(parcelRequire("lLpGm"))
    },
    {
        "id": "markdown",
        "name": "Markdown",
        "aliases": [
            "md"
        ],
        "import": ()=>(parcelRequire("cPE41"))
    },
    {
        "id": "marko",
        "name": "Marko",
        "import": ()=>(parcelRequire("aSG3t"))
    },
    {
        "id": "matlab",
        "name": "MATLAB",
        "import": ()=>(parcelRequire("gRwBK"))
    },
    {
        "id": "mdc",
        "name": "MDC",
        "import": ()=>(parcelRequire("fMV6c"))
    },
    {
        "id": "mdx",
        "name": "MDX",
        "import": ()=>(parcelRequire("6wL6F"))
    },
    {
        "id": "mermaid",
        "name": "Mermaid",
        "aliases": [
            "mmd"
        ],
        "import": ()=>(parcelRequire("ioHKy"))
    },
    {
        "id": "mipsasm",
        "name": "MIPS Assembly",
        "aliases": [
            "mips"
        ],
        "import": ()=>(parcelRequire("grQxT"))
    },
    {
        "id": "mojo",
        "name": "Mojo",
        "import": ()=>(parcelRequire("9lk1O"))
    },
    {
        "id": "moonbit",
        "name": "MoonBit",
        "aliases": [
            "mbt",
            "mbti"
        ],
        "import": ()=>(parcelRequire("9oAYk"))
    },
    {
        "id": "move",
        "name": "Move",
        "import": ()=>(parcelRequire("860P7"))
    },
    {
        "id": "narrat",
        "name": "Narrat Language",
        "aliases": [
            "nar"
        ],
        "import": ()=>(parcelRequire("ewUDn"))
    },
    {
        "id": "nextflow",
        "name": "Nextflow",
        "aliases": [
            "nf"
        ],
        "import": ()=>(parcelRequire("9mZIr"))
    },
    {
        "id": "nextflow-groovy",
        "name": "nextflow-groovy",
        "import": ()=>(parcelRequire("lxsW4"))
    },
    {
        "id": "nginx",
        "name": "Nginx",
        "import": ()=>(parcelRequire("cxK1U"))
    },
    {
        "id": "nim",
        "name": "Nim",
        "import": ()=>(parcelRequire("541Oj"))
    },
    {
        "id": "nix",
        "name": "Nix",
        "import": ()=>(parcelRequire("71NUC"))
    },
    {
        "id": "nushell",
        "name": "nushell",
        "aliases": [
            "nu"
        ],
        "import": ()=>(parcelRequire("iR2Df"))
    },
    {
        "id": "objective-c",
        "name": "Objective-C",
        "aliases": [
            "objc"
        ],
        "import": ()=>(parcelRequire("4LJlw"))
    },
    {
        "id": "objective-cpp",
        "name": "Objective-C++",
        "import": ()=>(parcelRequire("hdjqq"))
    },
    {
        "id": "ocaml",
        "name": "OCaml",
        "import": ()=>(parcelRequire("5QNu4"))
    },
    {
        "id": "odin",
        "name": "Odin",
        "import": ()=>(parcelRequire("cVrM5"))
    },
    {
        "id": "openscad",
        "name": "OpenSCAD",
        "aliases": [
            "scad"
        ],
        "import": ()=>(parcelRequire("W9f2E"))
    },
    {
        "id": "pascal",
        "name": "Pascal",
        "import": ()=>(parcelRequire("hoyiK"))
    },
    {
        "id": "perl",
        "name": "Perl",
        "import": ()=>(parcelRequire("jMFMh"))
    },
    {
        "id": "php",
        "name": "PHP",
        "import": ()=>(parcelRequire("dEuPA"))
    },
    {
        "id": "pkl",
        "name": "Pkl",
        "import": ()=>(parcelRequire("57dKa"))
    },
    {
        "id": "plsql",
        "name": "PL/SQL",
        "import": ()=>(parcelRequire("buzt7"))
    },
    {
        "id": "po",
        "name": "Gettext PO",
        "aliases": [
            "pot",
            "potx"
        ],
        "import": ()=>(parcelRequire("9pnvI"))
    },
    {
        "id": "polar",
        "name": "Polar",
        "import": ()=>(parcelRequire("6EF8x"))
    },
    {
        "id": "postcss",
        "name": "PostCSS",
        "import": ()=>(parcelRequire("i0cSS"))
    },
    {
        "id": "powerquery",
        "name": "PowerQuery",
        "import": ()=>(parcelRequire("9CXjy"))
    },
    {
        "id": "powershell",
        "name": "PowerShell",
        "aliases": [
            "ps",
            "ps1"
        ],
        "import": ()=>(parcelRequire("1pL9D"))
    },
    {
        "id": "prisma",
        "name": "Prisma",
        "import": ()=>(parcelRequire("kDAsT"))
    },
    {
        "id": "prolog",
        "name": "Prolog",
        "import": ()=>(parcelRequire("5HDED"))
    },
    {
        "id": "proto",
        "name": "Protocol Buffer 3",
        "aliases": [
            "protobuf"
        ],
        "import": ()=>(parcelRequire("arD2g"))
    },
    {
        "id": "pug",
        "name": "Pug",
        "aliases": [
            "jade"
        ],
        "import": ()=>(parcelRequire("iHpqd"))
    },
    {
        "id": "puppet",
        "name": "Puppet",
        "import": ()=>(parcelRequire("32hw9"))
    },
    {
        "id": "purescript",
        "name": "PureScript",
        "import": ()=>(parcelRequire("8QiAU"))
    },
    {
        "id": "python",
        "name": "Python",
        "aliases": [
            "py"
        ],
        "import": ()=>(parcelRequire("4cUhM"))
    },
    {
        "id": "qml",
        "name": "QML",
        "import": ()=>(parcelRequire("4IwaY"))
    },
    {
        "id": "qmldir",
        "name": "QML Directory",
        "import": ()=>(parcelRequire("1s7pq"))
    },
    {
        "id": "qss",
        "name": "Qt Style Sheets",
        "import": ()=>(parcelRequire("jszie"))
    },
    {
        "id": "r",
        "name": "R",
        "import": ()=>(parcelRequire("cD4mp"))
    },
    {
        "id": "racket",
        "name": "Racket",
        "import": ()=>(parcelRequire("7I3sy"))
    },
    {
        "id": "raku",
        "name": "Raku",
        "aliases": [
            "perl6"
        ],
        "import": ()=>(parcelRequire("50iyw"))
    },
    {
        "id": "razor",
        "name": "ASP.NET Razor",
        "import": ()=>(parcelRequire("beq76"))
    },
    {
        "id": "reg",
        "name": "Windows Registry Script",
        "import": ()=>(parcelRequire("gGFZa"))
    },
    {
        "id": "regexp",
        "name": "RegExp",
        "aliases": [
            "regex"
        ],
        "import": ()=>(parcelRequire("gPLW0"))
    },
    {
        "id": "rel",
        "name": "Rel",
        "import": ()=>(parcelRequire("cwXmW"))
    },
    {
        "id": "riscv",
        "name": "RISC-V",
        "import": ()=>(parcelRequire("9hPYF"))
    },
    {
        "id": "ron",
        "name": "RON",
        "import": ()=>(parcelRequire("2OabP"))
    },
    {
        "id": "rosmsg",
        "name": "ROS Interface",
        "import": ()=>(parcelRequire("39n2K"))
    },
    {
        "id": "rst",
        "name": "reStructuredText",
        "import": ()=>(parcelRequire("k4NYq"))
    },
    {
        "id": "ruby",
        "name": "Ruby",
        "aliases": [
            "rb"
        ],
        "import": ()=>(parcelRequire("hDqWD"))
    },
    {
        "id": "rust",
        "name": "Rust",
        "aliases": [
            "rs"
        ],
        "import": ()=>(parcelRequire("dvdJW"))
    },
    {
        "id": "sas",
        "name": "SAS",
        "import": ()=>(parcelRequire("6K078"))
    },
    {
        "id": "sass",
        "name": "Sass",
        "import": ()=>(parcelRequire("5g5IS"))
    },
    {
        "id": "scala",
        "name": "Scala",
        "import": ()=>(parcelRequire("2p3AB"))
    },
    {
        "id": "scheme",
        "name": "Scheme",
        "import": ()=>(parcelRequire("d6X7F"))
    },
    {
        "id": "scss",
        "name": "SCSS",
        "import": ()=>(parcelRequire("i4LQ8"))
    },
    {
        "id": "sdbl",
        "name": "1C (Query)",
        "aliases": [
            "1c-query"
        ],
        "import": ()=>(parcelRequire("aPuRP"))
    },
    {
        "id": "shaderlab",
        "name": "ShaderLab",
        "aliases": [
            "shader"
        ],
        "import": ()=>(parcelRequire("21taf"))
    },
    {
        "id": "shellscript",
        "name": "Shell",
        "aliases": [
            "bash",
            "sh",
            "shell",
            "zsh"
        ],
        "import": ()=>(parcelRequire("bk3Tm"))
    },
    {
        "id": "shellsession",
        "name": "Shell Session",
        "aliases": [
            "console"
        ],
        "import": ()=>(parcelRequire("6IgB5"))
    },
    {
        "id": "smalltalk",
        "name": "Smalltalk",
        "import": ()=>(parcelRequire("ei3ke"))
    },
    {
        "id": "solidity",
        "name": "Solidity",
        "import": ()=>(parcelRequire("azSDu"))
    },
    {
        "id": "soy",
        "name": "Closure Templates",
        "aliases": [
            "closure-templates"
        ],
        "import": ()=>(parcelRequire("fnQ8C"))
    },
    {
        "id": "sparql",
        "name": "SPARQL",
        "import": ()=>(parcelRequire("9N6lA"))
    },
    {
        "id": "splunk",
        "name": "Splunk Query Language",
        "aliases": [
            "spl"
        ],
        "import": ()=>(parcelRequire("di01K"))
    },
    {
        "id": "sql",
        "name": "SQL",
        "import": ()=>(parcelRequire("2cNsB"))
    },
    {
        "id": "ssh-config",
        "name": "SSH Config",
        "import": ()=>(parcelRequire("2CNnu"))
    },
    {
        "id": "stata",
        "name": "Stata",
        "import": ()=>(parcelRequire("2gtB2"))
    },
    {
        "id": "stylus",
        "name": "Stylus",
        "aliases": [
            "styl"
        ],
        "import": ()=>(parcelRequire("dgovY"))
    },
    {
        "id": "surrealql",
        "name": "SurrealQL",
        "aliases": [
            "surql"
        ],
        "import": ()=>(parcelRequire("93oAw"))
    },
    {
        "id": "svelte",
        "name": "Svelte",
        "import": ()=>(parcelRequire("iv3g3"))
    },
    {
        "id": "swift",
        "name": "Swift",
        "import": ()=>(parcelRequire("bkG1D"))
    },
    {
        "id": "system-verilog",
        "name": "SystemVerilog",
        "import": ()=>(parcelRequire("c2799"))
    },
    {
        "id": "systemd",
        "name": "Systemd Units",
        "import": ()=>(parcelRequire("5b8pP"))
    },
    {
        "id": "talonscript",
        "name": "TalonScript",
        "aliases": [
            "talon"
        ],
        "import": ()=>(parcelRequire("enqpG"))
    },
    {
        "id": "tasl",
        "name": "Tasl",
        "import": ()=>(parcelRequire("hpGL1"))
    },
    {
        "id": "tcl",
        "name": "Tcl",
        "import": ()=>(parcelRequire("16g7s"))
    },
    {
        "id": "templ",
        "name": "Templ",
        "import": ()=>(parcelRequire("d76ck"))
    },
    {
        "id": "terraform",
        "name": "Terraform",
        "aliases": [
            "tf",
            "tfvars"
        ],
        "import": ()=>(parcelRequire("lqHgs"))
    },
    {
        "id": "tex",
        "name": "TeX",
        "import": ()=>(parcelRequire("5vrnu"))
    },
    {
        "id": "toml",
        "name": "TOML",
        "import": ()=>(parcelRequire("8YvjL"))
    },
    {
        "id": "ts-tags",
        "name": "TypeScript with Tags",
        "aliases": [
            "lit"
        ],
        "import": ()=>(parcelRequire("eeNQB"))
    },
    {
        "id": "tsv",
        "name": "TSV",
        "import": ()=>(parcelRequire("fLLfn"))
    },
    {
        "id": "tsx",
        "name": "TSX",
        "import": ()=>(parcelRequire("h6i1u"))
    },
    {
        "id": "turtle",
        "name": "Turtle",
        "import": ()=>(parcelRequire("7NEJZ"))
    },
    {
        "id": "twig",
        "name": "Twig",
        "import": ()=>(parcelRequire("hPu5O"))
    },
    {
        "id": "typescript",
        "name": "TypeScript",
        "aliases": [
            "ts",
            "cts",
            "mts"
        ],
        "import": ()=>(parcelRequire("hGPOo"))
    },
    {
        "id": "typespec",
        "name": "TypeSpec",
        "aliases": [
            "tsp"
        ],
        "import": ()=>(parcelRequire("8dmba"))
    },
    {
        "id": "typst",
        "name": "Typst",
        "aliases": [
            "typ"
        ],
        "import": ()=>(parcelRequire("i3k1R"))
    },
    {
        "id": "v",
        "name": "V",
        "import": ()=>(parcelRequire("eG73g"))
    },
    {
        "id": "vala",
        "name": "Vala",
        "import": ()=>(parcelRequire("1K9Lk"))
    },
    {
        "id": "vb",
        "name": "Visual Basic",
        "aliases": [
            "cmd"
        ],
        "import": ()=>(parcelRequire("cYAbL"))
    },
    {
        "id": "verilog",
        "name": "Verilog",
        "import": ()=>(parcelRequire("8PjQ5"))
    },
    {
        "id": "vhdl",
        "name": "VHDL",
        "import": ()=>(parcelRequire("3OXZt"))
    },
    {
        "id": "viml",
        "name": "Vim Script",
        "aliases": [
            "vim",
            "vimscript"
        ],
        "import": ()=>(parcelRequire("4TJPD"))
    },
    {
        "id": "vue",
        "name": "Vue",
        "import": ()=>(parcelRequire("8zsoI"))
    },
    {
        "id": "vue-html",
        "name": "Vue HTML",
        "import": ()=>(parcelRequire("aCWTI"))
    },
    {
        "id": "vue-vine",
        "name": "Vue Vine",
        "import": ()=>(parcelRequire("60eUy"))
    },
    {
        "id": "vyper",
        "name": "Vyper",
        "aliases": [
            "vy"
        ],
        "import": ()=>(parcelRequire("kRLoY"))
    },
    {
        "id": "wasm",
        "name": "WebAssembly",
        "import": ()=>(parcelRequire("7adgQ"))
    },
    {
        "id": "wenyan",
        "name": "Wenyan",
        "aliases": [
            "\u6587\u8A00"
        ],
        "import": ()=>(parcelRequire("f1mbI"))
    },
    {
        "id": "wgsl",
        "name": "WGSL",
        "import": ()=>(parcelRequire("czaSJ"))
    },
    {
        "id": "wikitext",
        "name": "Wikitext",
        "aliases": [
            "mediawiki",
            "wiki"
        ],
        "import": ()=>(parcelRequire("fzHxO"))
    },
    {
        "id": "wit",
        "name": "WebAssembly Interface Types",
        "import": ()=>(parcelRequire("gN3GG"))
    },
    {
        "id": "wolfram",
        "name": "Wolfram",
        "aliases": [
            "wl"
        ],
        "import": ()=>(parcelRequire("dBGU0"))
    },
    {
        "id": "xml",
        "name": "XML",
        "import": ()=>(parcelRequire("4CzwD"))
    },
    {
        "id": "xsl",
        "name": "XSL",
        "import": ()=>(parcelRequire("70Cvu"))
    },
    {
        "id": "yaml",
        "name": "YAML",
        "aliases": [
            "yml"
        ],
        "import": ()=>(parcelRequire("5aDGl"))
    },
    {
        "id": "zenscript",
        "name": "ZenScript",
        "import": ()=>(parcelRequire("6l3M9"))
    },
    {
        "id": "zig",
        "name": "Zig",
        "import": ()=>(parcelRequire("8B2If"))
    }
];
const $f9082090a7ce57f6$export$6b047f358129d556 = Object.fromEntries($f9082090a7ce57f6$export$fa9b44344f5e1d6b.map((i)=>[
        i.id,
        i.import
    ]));
const $f9082090a7ce57f6$export$adb824ab82230928 = Object.fromEntries($f9082090a7ce57f6$export$fa9b44344f5e1d6b.flatMap((i)=>i.aliases?.map((a)=>[
            a,
            i.import
        ]) || []));
const $f9082090a7ce57f6$export$318f38c9fe99838b = {
    ...$f9082090a7ce57f6$export$6b047f358129d556,
    ...$f9082090a7ce57f6$export$adb824ab82230928
};


//#region src/highlighter/languages/resolveLanguage.ts
async function $d9d27917a97241a9$export$fd43f4122341a86b(lang) {
    if ((0, $c7c05f3bbf3bd887$export$3ff2f5c75c098e85)()) throw new Error(`resolveLanguage("${lang}") cannot be called from a worker context. Languages must be pre-resolved on the main thread and passed to the worker via the resolvedLanguages parameter.`);
    const resolver = (0, $afd67e7e9e3398b6$export$76097dbde99d9f89).get(lang);
    if (resolver != null) return resolver;
    try {
        let loader = (0, $afd67e7e9e3398b6$export$9f176c210211a0f6).get(lang);
        if (loader == null && Object.prototype.hasOwnProperty.call((0, $f9082090a7ce57f6$export$318f38c9fe99838b), lang)) loader = (0, $f9082090a7ce57f6$export$318f38c9fe99838b)[lang];
        if (loader == null) throw new Error(`resolveLanguage: "${lang}" not found in bundled or custom languages`);
        const resolver$1 = loader().then(({ default: data })=>{
            const resolvedLang = {
                name: lang,
                data: data
            };
            if (!(0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).has(lang)) (0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).set(lang, resolvedLang);
            return resolvedLang;
        });
        (0, $afd67e7e9e3398b6$export$76097dbde99d9f89).set(lang, resolver$1);
        return await resolver$1;
    } finally{
        (0, $afd67e7e9e3398b6$export$76097dbde99d9f89).delete(lang);
    }
}


//#region src/highlighter/languages/getResolvedOrResolveLanguage.ts
function $043fc06f42768105$export$4d019cfecfbb353a(language) {
    return (0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).get(language) ?? (0, $d9d27917a97241a9$export$fd43f4122341a86b)(language);
}


//#region src/highlighter/themes/constants.ts
const $e663a760095f022f$export$517305f1f1af691 = /* @__PURE__ */ new Map();
const $e663a760095f022f$export$5f9337448df52729 = /* @__PURE__ */ new Map();
const $e663a760095f022f$export$d2de3753cd1ff872 = /* @__PURE__ */ new Map();
const $e663a760095f022f$export$3d8dda72fbfe74c9 = /* @__PURE__ */ new Set();


//#region src/highlighter/themes/attachResolvedThemes.ts
function $b5e7a3dd7253d51b$export$3bf43cacd1a90d16(themes, highlighter) {
    themes = Array.isArray(themes) ? themes : [
        themes
    ];
    for (let themeRef of themes){
        let resolvedTheme;
        if (typeof themeRef === "string") {
            resolvedTheme = (0, $e663a760095f022f$export$517305f1f1af691).get(themeRef);
            if (resolvedTheme == null) throw new Error(`loadResolvedThemes: ${themeRef} is not resolved, you must resolve it before calling loadResolvedThemes`);
        } else {
            resolvedTheme = themeRef;
            themeRef = themeRef.name;
            if (!(0, $e663a760095f022f$export$517305f1f1af691).has(themeRef)) (0, $e663a760095f022f$export$517305f1f1af691).set(themeRef, resolvedTheme);
        }
        if ((0, $e663a760095f022f$export$3d8dda72fbfe74c9).has(themeRef)) continue;
        (0, $e663a760095f022f$export$3d8dda72fbfe74c9).add(themeRef);
        highlighter.loadThemeSync(resolvedTheme);
    }
}



//#region src/highlighter/themes/cleanUpResolvedThemes.ts
function $204038051b556f81$export$f3c0a6a5f1fe8e78() {
    (0, $e663a760095f022f$export$517305f1f1af691).clear();
    (0, $e663a760095f022f$export$3d8dda72fbfe74c9).clear();
}






































































const $ae97e0ad66dd4e9b$export$450307aa9833a0bb = [
    {
        "id": "andromeeda",
        "displayName": "Andromeeda",
        "type": "dark",
        "import": ()=>(parcelRequire("h1DC1"))
    },
    {
        "id": "aurora-x",
        "displayName": "Aurora X",
        "type": "dark",
        "import": ()=>(parcelRequire("537yu"))
    },
    {
        "id": "ayu-dark",
        "displayName": "Ayu Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("5vbnl"))
    },
    {
        "id": "ayu-light",
        "displayName": "Ayu Light",
        "type": "light",
        "import": ()=>(parcelRequire("4chEh"))
    },
    {
        "id": "ayu-mirage",
        "displayName": "Ayu Mirage",
        "type": "dark",
        "import": ()=>(parcelRequire("bnODD"))
    },
    {
        "id": "catppuccin-frappe",
        "displayName": "Catppuccin Frapp\xE9",
        "type": "dark",
        "import": ()=>(parcelRequire("kMS5v"))
    },
    {
        "id": "catppuccin-latte",
        "displayName": "Catppuccin Latte",
        "type": "light",
        "import": ()=>(parcelRequire("2zv84"))
    },
    {
        "id": "catppuccin-macchiato",
        "displayName": "Catppuccin Macchiato",
        "type": "dark",
        "import": ()=>(parcelRequire("aT3DP"))
    },
    {
        "id": "catppuccin-mocha",
        "displayName": "Catppuccin Mocha",
        "type": "dark",
        "import": ()=>(parcelRequire("kG3mz"))
    },
    {
        "id": "dark-plus",
        "displayName": "Dark Plus",
        "type": "dark",
        "import": ()=>(parcelRequire("dBxMr"))
    },
    {
        "id": "dracula",
        "displayName": "Dracula Theme",
        "type": "dark",
        "import": ()=>(parcelRequire("9BOQz"))
    },
    {
        "id": "dracula-soft",
        "displayName": "Dracula Theme Soft",
        "type": "dark",
        "import": ()=>(parcelRequire("cV2T5"))
    },
    {
        "id": "everforest-dark",
        "displayName": "Everforest Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("cifvz"))
    },
    {
        "id": "everforest-light",
        "displayName": "Everforest Light",
        "type": "light",
        "import": ()=>(parcelRequire("4opac"))
    },
    {
        "id": "github-dark",
        "displayName": "GitHub Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("8l7q7"))
    },
    {
        "id": "github-dark-default",
        "displayName": "GitHub Dark Default",
        "type": "dark",
        "import": ()=>(parcelRequire("3EHZ7"))
    },
    {
        "id": "github-dark-dimmed",
        "displayName": "GitHub Dark Dimmed",
        "type": "dark",
        "import": ()=>(parcelRequire("f29qU"))
    },
    {
        "id": "github-dark-high-contrast",
        "displayName": "GitHub Dark High Contrast",
        "type": "dark",
        "import": ()=>(parcelRequire("40rDn"))
    },
    {
        "id": "github-light",
        "displayName": "GitHub Light",
        "type": "light",
        "import": ()=>(parcelRequire("ahqjs"))
    },
    {
        "id": "github-light-default",
        "displayName": "GitHub Light Default",
        "type": "light",
        "import": ()=>(parcelRequire("a61sh"))
    },
    {
        "id": "github-light-high-contrast",
        "displayName": "GitHub Light High Contrast",
        "type": "light",
        "import": ()=>(parcelRequire("cAmHn"))
    },
    {
        "id": "gruvbox-dark-hard",
        "displayName": "Gruvbox Dark Hard",
        "type": "dark",
        "import": ()=>(parcelRequire("1TfLI"))
    },
    {
        "id": "gruvbox-dark-medium",
        "displayName": "Gruvbox Dark Medium",
        "type": "dark",
        "import": ()=>(parcelRequire("6JPFE"))
    },
    {
        "id": "gruvbox-dark-soft",
        "displayName": "Gruvbox Dark Soft",
        "type": "dark",
        "import": ()=>(parcelRequire("5S23W"))
    },
    {
        "id": "gruvbox-light-hard",
        "displayName": "Gruvbox Light Hard",
        "type": "light",
        "import": ()=>(parcelRequire("4I4vw"))
    },
    {
        "id": "gruvbox-light-medium",
        "displayName": "Gruvbox Light Medium",
        "type": "light",
        "import": ()=>(parcelRequire("53oQ4"))
    },
    {
        "id": "gruvbox-light-soft",
        "displayName": "Gruvbox Light Soft",
        "type": "light",
        "import": ()=>(parcelRequire("9FCXG"))
    },
    {
        "id": "horizon",
        "displayName": "Horizon",
        "type": "dark",
        "import": ()=>(parcelRequire("j98nV"))
    },
    {
        "id": "horizon-bright",
        "displayName": "Horizon Bright",
        "type": "dark",
        "import": ()=>(parcelRequire("5B5TG"))
    },
    {
        "id": "houston",
        "displayName": "Houston",
        "type": "dark",
        "import": ()=>(parcelRequire("51JxB"))
    },
    {
        "id": "kanagawa-dragon",
        "displayName": "Kanagawa Dragon",
        "type": "dark",
        "import": ()=>(parcelRequire("2qUDj"))
    },
    {
        "id": "kanagawa-lotus",
        "displayName": "Kanagawa Lotus",
        "type": "light",
        "import": ()=>(parcelRequire("24UOY"))
    },
    {
        "id": "kanagawa-wave",
        "displayName": "Kanagawa Wave",
        "type": "dark",
        "import": ()=>(parcelRequire("4B9BJ"))
    },
    {
        "id": "laserwave",
        "displayName": "LaserWave",
        "type": "dark",
        "import": ()=>(parcelRequire("8cwCq"))
    },
    {
        "id": "light-plus",
        "displayName": "Light Plus",
        "type": "light",
        "import": ()=>(parcelRequire("iqE7T"))
    },
    {
        "id": "material-theme",
        "displayName": "Material Theme",
        "type": "dark",
        "import": ()=>(parcelRequire("6rCTW"))
    },
    {
        "id": "material-theme-darker",
        "displayName": "Material Theme Darker",
        "type": "dark",
        "import": ()=>(parcelRequire("3oofz"))
    },
    {
        "id": "material-theme-lighter",
        "displayName": "Material Theme Lighter",
        "type": "light",
        "import": ()=>(parcelRequire("eJEBc"))
    },
    {
        "id": "material-theme-ocean",
        "displayName": "Material Theme Ocean",
        "type": "dark",
        "import": ()=>(parcelRequire("2FjmX"))
    },
    {
        "id": "material-theme-palenight",
        "displayName": "Material Theme Palenight",
        "type": "dark",
        "import": ()=>(parcelRequire("4CfuP"))
    },
    {
        "id": "min-dark",
        "displayName": "Min Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("44DNi"))
    },
    {
        "id": "min-light",
        "displayName": "Min Light",
        "type": "light",
        "import": ()=>(parcelRequire("rHwQW"))
    },
    {
        "id": "monokai",
        "displayName": "Monokai",
        "type": "dark",
        "import": ()=>(parcelRequire("57sT0"))
    },
    {
        "id": "night-owl",
        "displayName": "Night Owl",
        "type": "dark",
        "import": ()=>(parcelRequire("kzpSl"))
    },
    {
        "id": "night-owl-light",
        "displayName": "Night Owl Light",
        "type": "light",
        "import": ()=>(parcelRequire("iRZPM"))
    },
    {
        "id": "nord",
        "displayName": "Nord",
        "type": "dark",
        "import": ()=>(parcelRequire("g4TUv"))
    },
    {
        "id": "one-dark-pro",
        "displayName": "One Dark Pro",
        "type": "dark",
        "import": ()=>(parcelRequire("2y7eV"))
    },
    {
        "id": "one-light",
        "displayName": "One Light",
        "type": "light",
        "import": ()=>(parcelRequire("j2naT"))
    },
    {
        "id": "plastic",
        "displayName": "Plastic",
        "type": "dark",
        "import": ()=>(parcelRequire("aI7gx"))
    },
    {
        "id": "poimandres",
        "displayName": "Poimandres",
        "type": "dark",
        "import": ()=>(parcelRequire("5F93B"))
    },
    {
        "id": "red",
        "displayName": "Red",
        "type": "dark",
        "import": ()=>(parcelRequire("9W8gU"))
    },
    {
        "id": "rose-pine",
        "displayName": "Ros\xE9 Pine",
        "type": "dark",
        "import": ()=>(parcelRequire("cyHaQ"))
    },
    {
        "id": "rose-pine-dawn",
        "displayName": "Ros\xE9 Pine Dawn",
        "type": "light",
        "import": ()=>(parcelRequire("xJH6B"))
    },
    {
        "id": "rose-pine-moon",
        "displayName": "Ros\xE9 Pine Moon",
        "type": "dark",
        "import": ()=>(parcelRequire("2BN6c"))
    },
    {
        "id": "slack-dark",
        "displayName": "Slack Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("jklKV"))
    },
    {
        "id": "slack-ochin",
        "displayName": "Slack Ochin",
        "type": "light",
        "import": ()=>(parcelRequire("ijVNE"))
    },
    {
        "id": "snazzy-light",
        "displayName": "Snazzy Light",
        "type": "light",
        "import": ()=>(parcelRequire("48BGn"))
    },
    {
        "id": "solarized-dark",
        "displayName": "Solarized Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("kvV5t"))
    },
    {
        "id": "solarized-light",
        "displayName": "Solarized Light",
        "type": "light",
        "import": ()=>(parcelRequire("2gk3g"))
    },
    {
        "id": "synthwave-84",
        "displayName": "Synthwave '84",
        "type": "dark",
        "import": ()=>(parcelRequire("5DH0m"))
    },
    {
        "id": "tokyo-night",
        "displayName": "Tokyo Night",
        "type": "dark",
        "import": ()=>(parcelRequire("9JdxH"))
    },
    {
        "id": "vesper",
        "displayName": "Vesper",
        "type": "dark",
        "import": ()=>(parcelRequire("65y68"))
    },
    {
        "id": "vitesse-black",
        "displayName": "Vitesse Black",
        "type": "dark",
        "import": ()=>(parcelRequire("lSxTn"))
    },
    {
        "id": "vitesse-dark",
        "displayName": "Vitesse Dark",
        "type": "dark",
        "import": ()=>(parcelRequire("ibOgu"))
    },
    {
        "id": "vitesse-light",
        "displayName": "Vitesse Light",
        "type": "light",
        "import": ()=>(parcelRequire("fokKh"))
    }
];
const $ae97e0ad66dd4e9b$export$b55f4ff8dd492310 = Object.fromEntries($ae97e0ad66dd4e9b$export$450307aa9833a0bb.map((i)=>[
        i.id,
        i.import
    ]));

class $a16ed6e909c7cb00$export$5003b41ce90ff8c9 extends Error {
    constructor(message){
        super(message);
        this.name = "ShikiError";
    }
}


// src/utils.ts
function $0fea3078b1feac63$var$clone(something) {
    return $0fea3078b1feac63$var$doClone(something);
}
function $0fea3078b1feac63$var$doClone(something) {
    if (Array.isArray(something)) return $0fea3078b1feac63$var$cloneArray(something);
    if (something instanceof RegExp) return something;
    if (typeof something === "object") return $0fea3078b1feac63$var$cloneObj(something);
    return something;
}
function $0fea3078b1feac63$var$cloneArray(arr) {
    let r = [];
    for(let i = 0, len = arr.length; i < len; i++)r[i] = $0fea3078b1feac63$var$doClone(arr[i]);
    return r;
}
function $0fea3078b1feac63$var$cloneObj(obj) {
    let r = {};
    for(let key in obj)r[key] = $0fea3078b1feac63$var$doClone(obj[key]);
    return r;
}
function $0fea3078b1feac63$var$mergeObjects(target, ...sources) {
    sources.forEach((source)=>{
        for(let key in source)target[key] = source[key];
    });
    return target;
}
function $0fea3078b1feac63$var$basename(path) {
    const idx = ~path.lastIndexOf("/") || ~path.lastIndexOf("\\");
    if (idx === 0) return path;
    else if (~idx === path.length - 1) return $0fea3078b1feac63$var$basename(path.substring(0, path.length - 1));
    else return path.substr(~idx + 1);
}
var $0fea3078b1feac63$var$CAPTURING_REGEX_SOURCE = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g;
var $0fea3078b1feac63$var$RegexSource = class {
    static hasCaptures(regexSource) {
        if (regexSource === null) return false;
        $0fea3078b1feac63$var$CAPTURING_REGEX_SOURCE.lastIndex = 0;
        return $0fea3078b1feac63$var$CAPTURING_REGEX_SOURCE.test(regexSource);
    }
    static replaceCaptures(regexSource, captureSource, captureIndices) {
        return regexSource.replace($0fea3078b1feac63$var$CAPTURING_REGEX_SOURCE, (match, index, commandIndex, command)=>{
            let capture = captureIndices[parseInt(index || commandIndex, 10)];
            if (capture) {
                let result = captureSource.substring(capture.start, capture.end);
                while(result[0] === ".")result = result.substring(1);
                switch(command){
                    case "downcase":
                        return result.toLowerCase();
                    case "upcase":
                        return result.toUpperCase();
                    default:
                        return result;
                }
            } else return match;
        });
    }
};
function $0fea3078b1feac63$var$strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $0fea3078b1feac63$var$strArrCmp(a, b) {
    if (a === null && b === null) return 0;
    if (!a) return -1;
    if (!b) return 1;
    let len1 = a.length;
    let len2 = b.length;
    if (len1 === len2) {
        for(let i = 0; i < len1; i++){
            let res = $0fea3078b1feac63$var$strcmp(a[i], b[i]);
            if (res !== 0) return res;
        }
        return 0;
    }
    return len1 - len2;
}
function $0fea3078b1feac63$var$isValidHexColor(hex) {
    if (/^#[0-9a-f]{6}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{8}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{3}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{4}$/i.test(hex)) return true;
    return false;
}
function $0fea3078b1feac63$var$escapeRegExpCharacters(value) {
    return value.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var $0fea3078b1feac63$var$CachedFn = class {
    constructor(fn){
        this.fn = fn;
    }
    cache = /* @__PURE__ */ new Map();
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const value = this.fn(key);
        this.cache.set(key, value);
        return value;
    }
};
// src/theme.ts
var $0fea3078b1feac63$export$14faa19a0f3bbeb2 = class {
    constructor(_colorMap, _defaults, _root){
        this._colorMap = _colorMap;
        this._defaults = _defaults;
        this._root = _root;
    }
    static createFromRawTheme(source, colorMap) {
        return this.createFromParsedTheme($0fea3078b1feac63$var$parseTheme(source), colorMap);
    }
    static createFromParsedTheme(source, colorMap) {
        return $0fea3078b1feac63$var$resolveParsedThemeRules(source, colorMap);
    }
    _cachedMatchRoot = new $0fea3078b1feac63$var$CachedFn((scopeName)=>this._root.match(scopeName));
    getColorMap() {
        return this._colorMap.getColorMap();
    }
    getDefaults() {
        return this._defaults;
    }
    match(scopePath) {
        if (scopePath === null) return this._defaults;
        const scopeName = scopePath.scopeName;
        const matchingTrieElements = this._cachedMatchRoot.get(scopeName);
        const effectiveRule = matchingTrieElements.find((v)=>$0fea3078b1feac63$var$_scopePathMatchesParentScopes(scopePath.parent, v.parentScopes));
        if (!effectiveRule) return null;
        return new $0fea3078b1feac63$var$StyleAttributes(effectiveRule.fontStyle, effectiveRule.foreground, effectiveRule.background);
    }
};
var $0fea3078b1feac63$var$ScopeStack = class _ScopeStack {
    constructor(parent, scopeName){
        this.parent = parent;
        this.scopeName = scopeName;
    }
    static push(path, scopeNames) {
        for (const name of scopeNames)path = new _ScopeStack(path, name);
        return path;
    }
    static from(...segments) {
        let result = null;
        for(let i = 0; i < segments.length; i++)result = new _ScopeStack(result, segments[i]);
        return result;
    }
    push(scopeName) {
        return new _ScopeStack(this, scopeName);
    }
    getSegments() {
        let item = this;
        const result = [];
        while(item){
            result.push(item.scopeName);
            item = item.parent;
        }
        result.reverse();
        return result;
    }
    toString() {
        return this.getSegments().join(" ");
    }
    extends(other) {
        if (this === other) return true;
        if (this.parent === null) return false;
        return this.parent.extends(other);
    }
    getExtensionIfDefined(base) {
        const result = [];
        let item = this;
        while(item && item !== base){
            result.push(item.scopeName);
            item = item.parent;
        }
        return item === base ? result.reverse() : void 0;
    }
};
function $0fea3078b1feac63$var$_scopePathMatchesParentScopes(scopePath, parentScopes) {
    if (parentScopes.length === 0) return true;
    for(let index = 0; index < parentScopes.length; index++){
        let scopePattern = parentScopes[index];
        let scopeMustMatch = false;
        if (scopePattern === ">") {
            if (index === parentScopes.length - 1) return false;
            scopePattern = parentScopes[++index];
            scopeMustMatch = true;
        }
        while(scopePath){
            if ($0fea3078b1feac63$var$_matchesScope(scopePath.scopeName, scopePattern)) break;
            if (scopeMustMatch) return false;
            scopePath = scopePath.parent;
        }
        if (!scopePath) return false;
        scopePath = scopePath.parent;
    }
    return true;
}
function $0fea3078b1feac63$var$_matchesScope(scopeName, scopePattern) {
    return scopePattern === scopeName || scopeName.startsWith(scopePattern) && scopeName[scopePattern.length] === ".";
}
var $0fea3078b1feac63$var$StyleAttributes = class {
    constructor(fontStyle, foregroundId, backgroundId){
        this.fontStyle = fontStyle;
        this.foregroundId = foregroundId;
        this.backgroundId = backgroundId;
    }
};
function $0fea3078b1feac63$var$parseTheme(source) {
    if (!source) return [];
    if (!source.settings || !Array.isArray(source.settings)) return [];
    let settings = source.settings;
    let result = [], resultLen = 0;
    for(let i = 0, len = settings.length; i < len; i++){
        let entry = settings[i];
        if (!entry.settings) continue;
        let scopes;
        if (typeof entry.scope === "string") {
            let _scope = entry.scope;
            _scope = _scope.replace(/^[,]+/, "");
            _scope = _scope.replace(/[,]+$/, "");
            scopes = _scope.split(",");
        } else if (Array.isArray(entry.scope)) scopes = entry.scope;
        else scopes = [
            ""
        ];
        let fontStyle = -1 /* NotSet */ ;
        if (typeof entry.settings.fontStyle === "string") {
            fontStyle = 0 /* None */ ;
            let segments = entry.settings.fontStyle.split(" ");
            for(let j = 0, lenJ = segments.length; j < lenJ; j++){
                let segment = segments[j];
                switch(segment){
                    case "italic":
                        fontStyle = fontStyle | 1 /* Italic */ ;
                        break;
                    case "bold":
                        fontStyle = fontStyle | 2 /* Bold */ ;
                        break;
                    case "underline":
                        fontStyle = fontStyle | 4 /* Underline */ ;
                        break;
                    case "strikethrough":
                        fontStyle = fontStyle | 8 /* Strikethrough */ ;
                        break;
                }
            }
        }
        let foreground = null;
        if (typeof entry.settings.foreground === "string" && $0fea3078b1feac63$var$isValidHexColor(entry.settings.foreground)) foreground = entry.settings.foreground;
        let background = null;
        if (typeof entry.settings.background === "string" && $0fea3078b1feac63$var$isValidHexColor(entry.settings.background)) background = entry.settings.background;
        for(let j = 0, lenJ = scopes.length; j < lenJ; j++){
            let _scope = scopes[j].trim();
            let segments = _scope.split(" ");
            let scope = segments[segments.length - 1];
            let parentScopes = null;
            if (segments.length > 1) {
                parentScopes = segments.slice(0, segments.length - 1);
                parentScopes.reverse();
            }
            result[resultLen++] = new $0fea3078b1feac63$var$ParsedThemeRule(scope, parentScopes, i, fontStyle, foreground, background);
        }
    }
    return result;
}
var $0fea3078b1feac63$var$ParsedThemeRule = class {
    constructor(scope, parentScopes, index, fontStyle, foreground, background){
        this.scope = scope;
        this.parentScopes = parentScopes;
        this.index = index;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
};
var $0fea3078b1feac63$export$23b468d4ca3f8c96 = /* @__PURE__ */ ((FontStyle2)=>{
    FontStyle2[FontStyle2["NotSet"] = -1] = "NotSet";
    FontStyle2[FontStyle2["None"] = 0] = "None";
    FontStyle2[FontStyle2["Italic"] = 1] = "Italic";
    FontStyle2[FontStyle2["Bold"] = 2] = "Bold";
    FontStyle2[FontStyle2["Underline"] = 4] = "Underline";
    FontStyle2[FontStyle2["Strikethrough"] = 8] = "Strikethrough";
    return FontStyle2;
})($0fea3078b1feac63$export$23b468d4ca3f8c96 || {});
function $0fea3078b1feac63$var$resolveParsedThemeRules(parsedThemeRules, _colorMap) {
    parsedThemeRules.sort((a, b)=>{
        let r = $0fea3078b1feac63$var$strcmp(a.scope, b.scope);
        if (r !== 0) return r;
        r = $0fea3078b1feac63$var$strArrCmp(a.parentScopes, b.parentScopes);
        if (r !== 0) return r;
        return a.index - b.index;
    });
    let defaultFontStyle = 0 /* None */ ;
    let defaultForeground = "#000000";
    let defaultBackground = "#ffffff";
    while(parsedThemeRules.length >= 1 && parsedThemeRules[0].scope === ""){
        let incomingDefaults = parsedThemeRules.shift();
        if (incomingDefaults.fontStyle !== -1 /* NotSet */ ) defaultFontStyle = incomingDefaults.fontStyle;
        if (incomingDefaults.foreground !== null) defaultForeground = incomingDefaults.foreground;
        if (incomingDefaults.background !== null) defaultBackground = incomingDefaults.background;
    }
    let colorMap = new $0fea3078b1feac63$var$ColorMap(_colorMap);
    let defaults = new $0fea3078b1feac63$var$StyleAttributes(defaultFontStyle, colorMap.getId(defaultForeground), colorMap.getId(defaultBackground));
    let root = new $0fea3078b1feac63$var$ThemeTrieElement(new $0fea3078b1feac63$var$ThemeTrieElementRule(0, null, -1 /* NotSet */ , 0, 0), []);
    for(let i = 0, len = parsedThemeRules.length; i < len; i++){
        let rule = parsedThemeRules[i];
        root.insert(0, rule.scope, rule.parentScopes, rule.fontStyle, colorMap.getId(rule.foreground), colorMap.getId(rule.background));
    }
    return new $0fea3078b1feac63$export$14faa19a0f3bbeb2(colorMap, defaults, root);
}
var $0fea3078b1feac63$var$ColorMap = class {
    _isFrozen;
    _lastColorId;
    _id2color;
    _color2id;
    constructor(_colorMap){
        this._lastColorId = 0;
        this._id2color = [];
        this._color2id = /* @__PURE__ */ Object.create(null);
        if (Array.isArray(_colorMap)) {
            this._isFrozen = true;
            for(let i = 0, len = _colorMap.length; i < len; i++){
                this._color2id[_colorMap[i]] = i;
                this._id2color[i] = _colorMap[i];
            }
        } else this._isFrozen = false;
    }
    getId(color) {
        if (color === null) return 0;
        color = color.toUpperCase();
        let value = this._color2id[color];
        if (value) return value;
        if (this._isFrozen) throw new Error(`Missing color in color map - ${color}`);
        value = ++this._lastColorId;
        this._color2id[color] = value;
        this._id2color[value] = color;
        return value;
    }
    getColorMap() {
        return this._id2color.slice(0);
    }
};
var $0fea3078b1feac63$var$emptyParentScopes = Object.freeze([]);
var $0fea3078b1feac63$var$ThemeTrieElementRule = class _ThemeTrieElementRule {
    scopeDepth;
    parentScopes;
    fontStyle;
    foreground;
    background;
    constructor(scopeDepth, parentScopes, fontStyle, foreground, background){
        this.scopeDepth = scopeDepth;
        this.parentScopes = parentScopes || $0fea3078b1feac63$var$emptyParentScopes;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
    clone() {
        return new _ThemeTrieElementRule(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
    }
    static cloneArr(arr) {
        let r = [];
        for(let i = 0, len = arr.length; i < len; i++)r[i] = arr[i].clone();
        return r;
    }
    acceptOverwrite(scopeDepth, fontStyle, foreground, background) {
        if (this.scopeDepth > scopeDepth) console.log("how did this happen?");
        else this.scopeDepth = scopeDepth;
        if (fontStyle !== -1 /* NotSet */ ) this.fontStyle = fontStyle;
        if (foreground !== 0) this.foreground = foreground;
        if (background !== 0) this.background = background;
    }
};
var $0fea3078b1feac63$var$ThemeTrieElement = class _ThemeTrieElement {
    constructor(_mainRule, rulesWithParentScopes = [], _children = {}){
        this._mainRule = _mainRule;
        this._children = _children;
        this._rulesWithParentScopes = rulesWithParentScopes;
    }
    _rulesWithParentScopes;
    static _cmpBySpecificity(a, b) {
        if (a.scopeDepth !== b.scopeDepth) return b.scopeDepth - a.scopeDepth;
        let aParentIndex = 0;
        let bParentIndex = 0;
        while(true){
            if (a.parentScopes[aParentIndex] === ">") aParentIndex++;
            if (b.parentScopes[bParentIndex] === ">") bParentIndex++;
            if (aParentIndex >= a.parentScopes.length || bParentIndex >= b.parentScopes.length) break;
            const parentScopeLengthDiff = b.parentScopes[bParentIndex].length - a.parentScopes[aParentIndex].length;
            if (parentScopeLengthDiff !== 0) return parentScopeLengthDiff;
            aParentIndex++;
            bParentIndex++;
        }
        return b.parentScopes.length - a.parentScopes.length;
    }
    match(scope) {
        if (scope !== "") {
            let dotIndex = scope.indexOf(".");
            let head;
            let tail;
            if (dotIndex === -1) {
                head = scope;
                tail = "";
            } else {
                head = scope.substring(0, dotIndex);
                tail = scope.substring(dotIndex + 1);
            }
            if (this._children.hasOwnProperty(head)) return this._children[head].match(tail);
        }
        const rules = this._rulesWithParentScopes.concat(this._mainRule);
        rules.sort(_ThemeTrieElement._cmpBySpecificity);
        return rules;
    }
    insert(scopeDepth, scope, parentScopes, fontStyle, foreground, background) {
        if (scope === "") {
            this._doInsertHere(scopeDepth, parentScopes, fontStyle, foreground, background);
            return;
        }
        let dotIndex = scope.indexOf(".");
        let head;
        let tail;
        if (dotIndex === -1) {
            head = scope;
            tail = "";
        } else {
            head = scope.substring(0, dotIndex);
            tail = scope.substring(dotIndex + 1);
        }
        let child;
        if (this._children.hasOwnProperty(head)) child = this._children[head];
        else {
            child = new _ThemeTrieElement(this._mainRule.clone(), $0fea3078b1feac63$var$ThemeTrieElementRule.cloneArr(this._rulesWithParentScopes));
            this._children[head] = child;
        }
        child.insert(scopeDepth + 1, tail, parentScopes, fontStyle, foreground, background);
    }
    _doInsertHere(scopeDepth, parentScopes, fontStyle, foreground, background) {
        if (parentScopes === null) {
            this._mainRule.acceptOverwrite(scopeDepth, fontStyle, foreground, background);
            return;
        }
        for(let i = 0, len = this._rulesWithParentScopes.length; i < len; i++){
            let rule = this._rulesWithParentScopes[i];
            if ($0fea3078b1feac63$var$strArrCmp(rule.parentScopes, parentScopes) === 0) {
                rule.acceptOverwrite(scopeDepth, fontStyle, foreground, background);
                return;
            }
        }
        if (fontStyle === -1 /* NotSet */ ) fontStyle = this._mainRule.fontStyle;
        if (foreground === 0) foreground = this._mainRule.foreground;
        if (background === 0) background = this._mainRule.background;
        this._rulesWithParentScopes.push(new $0fea3078b1feac63$var$ThemeTrieElementRule(scopeDepth, parentScopes, fontStyle, foreground, background));
    }
};
// src/encodedTokenAttributes.ts
var $0fea3078b1feac63$export$90e5db14803ea047 = class _EncodedTokenMetadata {
    static toBinaryStr(encodedTokenAttributes) {
        return encodedTokenAttributes.toString(2).padStart(32, "0");
    }
    static print(encodedTokenAttributes) {
        const languageId = _EncodedTokenMetadata.getLanguageId(encodedTokenAttributes);
        const tokenType = _EncodedTokenMetadata.getTokenType(encodedTokenAttributes);
        const fontStyle = _EncodedTokenMetadata.getFontStyle(encodedTokenAttributes);
        const foreground = _EncodedTokenMetadata.getForeground(encodedTokenAttributes);
        const background = _EncodedTokenMetadata.getBackground(encodedTokenAttributes);
        console.log({
            languageId: languageId,
            tokenType: tokenType,
            fontStyle: fontStyle,
            foreground: foreground,
            background: background
        });
    }
    static getLanguageId(encodedTokenAttributes) {
        return (encodedTokenAttributes & 255 /* LANGUAGEID_MASK */ ) >>> 0 /* LANGUAGEID_OFFSET */ ;
    }
    static getTokenType(encodedTokenAttributes) {
        return (encodedTokenAttributes & 768 /* TOKEN_TYPE_MASK */ ) >>> 8 /* TOKEN_TYPE_OFFSET */ ;
    }
    static containsBalancedBrackets(encodedTokenAttributes) {
        return (encodedTokenAttributes & 1024 /* BALANCED_BRACKETS_MASK */ ) !== 0;
    }
    static getFontStyle(encodedTokenAttributes) {
        return (encodedTokenAttributes & 30720 /* FONT_STYLE_MASK */ ) >>> 11 /* FONT_STYLE_OFFSET */ ;
    }
    static getForeground(encodedTokenAttributes) {
        return (encodedTokenAttributes & 16744448 /* FOREGROUND_MASK */ ) >>> 15 /* FOREGROUND_OFFSET */ ;
    }
    static getBackground(encodedTokenAttributes) {
        return (encodedTokenAttributes & 4278190080 /* BACKGROUND_MASK */ ) >>> 24 /* BACKGROUND_OFFSET */ ;
    }
    /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */ static set(encodedTokenAttributes, languageId, tokenType, containsBalancedBrackets, fontStyle, foreground, background) {
        let _languageId = _EncodedTokenMetadata.getLanguageId(encodedTokenAttributes);
        let _tokenType = _EncodedTokenMetadata.getTokenType(encodedTokenAttributes);
        let _containsBalancedBracketsBit = _EncodedTokenMetadata.containsBalancedBrackets(encodedTokenAttributes) ? 1 : 0;
        let _fontStyle = _EncodedTokenMetadata.getFontStyle(encodedTokenAttributes);
        let _foreground = _EncodedTokenMetadata.getForeground(encodedTokenAttributes);
        let _background = _EncodedTokenMetadata.getBackground(encodedTokenAttributes);
        if (languageId !== 0) _languageId = languageId;
        if (tokenType !== 8 /* NotSet */ ) _tokenType = $0fea3078b1feac63$var$fromOptionalTokenType(tokenType);
        if (containsBalancedBrackets !== null) _containsBalancedBracketsBit = containsBalancedBrackets ? 1 : 0;
        if (fontStyle !== -1 /* NotSet */ ) _fontStyle = fontStyle;
        if (foreground !== 0) _foreground = foreground;
        if (background !== 0) _background = background;
        return (_languageId << 0 /* LANGUAGEID_OFFSET */  | _tokenType << 8 /* TOKEN_TYPE_OFFSET */  | _containsBalancedBracketsBit << 10 /* BALANCED_BRACKETS_OFFSET */  | _fontStyle << 11 /* FONT_STYLE_OFFSET */  | _foreground << 15 /* FOREGROUND_OFFSET */  | _background << 24 /* BACKGROUND_OFFSET */ ) >>> 0;
    }
};
function $0fea3078b1feac63$var$toOptionalTokenType(standardType) {
    return standardType;
}
function $0fea3078b1feac63$var$fromOptionalTokenType(standardType) {
    return standardType;
}
// src/matcher.ts
function $0fea3078b1feac63$var$createMatchers(selector, matchesName) {
    const results = [];
    const tokenizer = $0fea3078b1feac63$var$newTokenizer(selector);
    let token = tokenizer.next();
    while(token !== null){
        let priority = 0;
        if (token.length === 2 && token.charAt(1) === ":") {
            switch(token.charAt(0)){
                case "R":
                    priority = 1;
                    break;
                case "L":
                    priority = -1;
                    break;
                default:
                    console.log(`Unknown priority ${token} in scope selector`);
            }
            token = tokenizer.next();
        }
        let matcher = parseConjunction();
        results.push({
            matcher: matcher,
            priority: priority
        });
        if (token !== ",") break;
        token = tokenizer.next();
    }
    return results;
    function parseOperand() {
        if (token === "-") {
            token = tokenizer.next();
            const expressionToNegate = parseOperand();
            return (matcherInput)=>!!expressionToNegate && !expressionToNegate(matcherInput);
        }
        if (token === "(") {
            token = tokenizer.next();
            const expressionInParents = parseInnerExpression();
            if (token === ")") token = tokenizer.next();
            return expressionInParents;
        }
        if ($0fea3078b1feac63$var$isIdentifier(token)) {
            const identifiers = [];
            do {
                identifiers.push(token);
                token = tokenizer.next();
            }while ($0fea3078b1feac63$var$isIdentifier(token));
            return (matcherInput)=>matchesName(identifiers, matcherInput);
        }
        return null;
    }
    function parseConjunction() {
        const matchers = [];
        let matcher = parseOperand();
        while(matcher){
            matchers.push(matcher);
            matcher = parseOperand();
        }
        return (matcherInput)=>matchers.every((matcher2)=>matcher2(matcherInput));
    }
    function parseInnerExpression() {
        const matchers = [];
        let matcher = parseConjunction();
        while(matcher){
            matchers.push(matcher);
            if (token === "|" || token === ",") do token = tokenizer.next();
            while (token === "|" || token === ",");
            else break;
            matcher = parseConjunction();
        }
        return (matcherInput)=>matchers.some((matcher2)=>matcher2(matcherInput));
    }
}
function $0fea3078b1feac63$var$isIdentifier(token) {
    return !!token && !!token.match(/[\w\.:]+/);
}
function $0fea3078b1feac63$var$newTokenizer(input) {
    let regex = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g;
    let match = regex.exec(input);
    return {
        next: ()=>{
            if (!match) return null;
            const res = match[0];
            match = regex.exec(input);
            return res;
        }
    };
}
// src/onigLib.ts
var $0fea3078b1feac63$export$94e52bf7f3697178 = /* @__PURE__ */ ((FindOption2)=>{
    FindOption2[FindOption2["None"] = 0] = "None";
    FindOption2[FindOption2["NotBeginString"] = 1] = "NotBeginString";
    FindOption2[FindOption2["NotEndString"] = 2] = "NotEndString";
    FindOption2[FindOption2["NotBeginPosition"] = 4] = "NotBeginPosition";
    FindOption2[FindOption2["DebugCall"] = 8] = "DebugCall";
    return FindOption2;
})($0fea3078b1feac63$export$94e52bf7f3697178 || {});
function $0fea3078b1feac63$export$2b6cad23a17023a7(str) {
    if (typeof str.dispose === "function") str.dispose();
}
// src/grammar/grammarDependencies.ts
var $0fea3078b1feac63$var$TopLevelRuleReference = class {
    constructor(scopeName){
        this.scopeName = scopeName;
    }
    toKey() {
        return this.scopeName;
    }
};
var $0fea3078b1feac63$var$TopLevelRepositoryRuleReference = class {
    constructor(scopeName, ruleName){
        this.scopeName = scopeName;
        this.ruleName = ruleName;
    }
    toKey() {
        return `${this.scopeName}#${this.ruleName}`;
    }
};
var $0fea3078b1feac63$var$ExternalReferenceCollector = class {
    _references = [];
    _seenReferenceKeys = /* @__PURE__ */ new Set();
    get references() {
        return this._references;
    }
    visitedRule = /* @__PURE__ */ new Set();
    add(reference) {
        const key = reference.toKey();
        if (this._seenReferenceKeys.has(key)) return;
        this._seenReferenceKeys.add(key);
        this._references.push(reference);
    }
};
var $0fea3078b1feac63$var$ScopeDependencyProcessor = class {
    constructor(repo, initialScopeName){
        this.repo = repo;
        this.initialScopeName = initialScopeName;
        this.seenFullScopeRequests.add(this.initialScopeName);
        this.Q = [
            new $0fea3078b1feac63$var$TopLevelRuleReference(this.initialScopeName)
        ];
    }
    seenFullScopeRequests = /* @__PURE__ */ new Set();
    seenPartialScopeRequests = /* @__PURE__ */ new Set();
    Q;
    processQueue() {
        const q = this.Q;
        this.Q = [];
        const deps = new $0fea3078b1feac63$var$ExternalReferenceCollector();
        for (const dep of q)$0fea3078b1feac63$var$collectReferencesOfReference(dep, this.initialScopeName, this.repo, deps);
        for (const dep of deps.references)if (dep instanceof $0fea3078b1feac63$var$TopLevelRuleReference) {
            if (this.seenFullScopeRequests.has(dep.scopeName)) continue;
            this.seenFullScopeRequests.add(dep.scopeName);
            this.Q.push(dep);
        } else {
            if (this.seenFullScopeRequests.has(dep.scopeName)) continue;
            if (this.seenPartialScopeRequests.has(dep.toKey())) continue;
            this.seenPartialScopeRequests.add(dep.toKey());
            this.Q.push(dep);
        }
    }
};
function $0fea3078b1feac63$var$collectReferencesOfReference(reference, baseGrammarScopeName, repo, result) {
    const selfGrammar = repo.lookup(reference.scopeName);
    if (!selfGrammar) {
        if (reference.scopeName === baseGrammarScopeName) throw new Error(`No grammar provided for <${baseGrammarScopeName}>`);
        return;
    }
    const baseGrammar = repo.lookup(baseGrammarScopeName);
    if (reference instanceof $0fea3078b1feac63$var$TopLevelRuleReference) $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRule({
        baseGrammar: baseGrammar,
        selfGrammar: selfGrammar
    }, result);
    else $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, {
        baseGrammar: baseGrammar,
        selfGrammar: selfGrammar,
        repository: selfGrammar.repository
    }, result);
    const injections = repo.injections(reference.scopeName);
    if (injections) for (const injection of injections)result.add(new $0fea3078b1feac63$var$TopLevelRuleReference(injection));
}
function $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRepositoryRule(ruleName, context, result) {
    if (context.repository && context.repository[ruleName]) {
        const rule = context.repository[ruleName];
        $0fea3078b1feac63$var$collectExternalReferencesInRules([
            rule
        ], context, result);
    }
}
function $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRule(context, result) {
    if (context.selfGrammar.patterns && Array.isArray(context.selfGrammar.patterns)) $0fea3078b1feac63$var$collectExternalReferencesInRules(context.selfGrammar.patterns, {
        ...context,
        repository: context.selfGrammar.repository
    }, result);
    if (context.selfGrammar.injections) $0fea3078b1feac63$var$collectExternalReferencesInRules(Object.values(context.selfGrammar.injections), {
        ...context,
        repository: context.selfGrammar.repository
    }, result);
}
function $0fea3078b1feac63$var$collectExternalReferencesInRules(rules, context, result) {
    for (const rule of rules){
        if (result.visitedRule.has(rule)) continue;
        result.visitedRule.add(rule);
        const patternRepository = rule.repository ? $0fea3078b1feac63$var$mergeObjects({}, context.repository, rule.repository) : context.repository;
        if (Array.isArray(rule.patterns)) $0fea3078b1feac63$var$collectExternalReferencesInRules(rule.patterns, {
            ...context,
            repository: patternRepository
        }, result);
        const include = rule.include;
        if (!include) continue;
        const reference = $0fea3078b1feac63$var$parseInclude(include);
        switch(reference.kind){
            case 0 /* Base */ :
                $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRule({
                    ...context,
                    selfGrammar: context.baseGrammar
                }, result);
                break;
            case 1 /* Self */ :
                $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRule(context, result);
                break;
            case 2 /* RelativeReference */ :
                $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, {
                    ...context,
                    repository: patternRepository
                }, result);
                break;
            case 3 /* TopLevelReference */ :
            case 4 /* TopLevelRepositoryReference */ :
                const selfGrammar = reference.scopeName === context.selfGrammar.scopeName ? context.selfGrammar : reference.scopeName === context.baseGrammar.scopeName ? context.baseGrammar : void 0;
                if (selfGrammar) {
                    const newContext = {
                        baseGrammar: context.baseGrammar,
                        selfGrammar: selfGrammar,
                        repository: patternRepository
                    };
                    if (reference.kind === 4 /* TopLevelRepositoryReference */ ) $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, newContext, result);
                    else $0fea3078b1feac63$var$collectExternalReferencesInTopLevelRule(newContext, result);
                } else if (reference.kind === 4 /* TopLevelRepositoryReference */ ) result.add(new $0fea3078b1feac63$var$TopLevelRepositoryRuleReference(reference.scopeName, reference.ruleName));
                else result.add(new $0fea3078b1feac63$var$TopLevelRuleReference(reference.scopeName));
                break;
        }
    }
}
var $0fea3078b1feac63$var$BaseReference = class {
    kind = 0 /* Base */ ;
};
var $0fea3078b1feac63$var$SelfReference = class {
    kind = 1 /* Self */ ;
};
var $0fea3078b1feac63$var$RelativeReference = class {
    constructor(ruleName){
        this.ruleName = ruleName;
    }
    kind = 2 /* RelativeReference */ ;
};
var $0fea3078b1feac63$var$TopLevelReference = class {
    constructor(scopeName){
        this.scopeName = scopeName;
    }
    kind = 3 /* TopLevelReference */ ;
};
var $0fea3078b1feac63$var$TopLevelRepositoryReference = class {
    constructor(scopeName, ruleName){
        this.scopeName = scopeName;
        this.ruleName = ruleName;
    }
    kind = 4 /* TopLevelRepositoryReference */ ;
};
function $0fea3078b1feac63$var$parseInclude(include) {
    if (include === "$base") return new $0fea3078b1feac63$var$BaseReference();
    else if (include === "$self") return new $0fea3078b1feac63$var$SelfReference();
    const indexOfSharp = include.indexOf("#");
    if (indexOfSharp === -1) return new $0fea3078b1feac63$var$TopLevelReference(include);
    else if (indexOfSharp === 0) return new $0fea3078b1feac63$var$RelativeReference(include.substring(1));
    else {
        const scopeName = include.substring(0, indexOfSharp);
        const ruleName = include.substring(indexOfSharp + 1);
        return new $0fea3078b1feac63$var$TopLevelRepositoryReference(scopeName, ruleName);
    }
}
// src/rule.ts
var $0fea3078b1feac63$var$HAS_BACK_REFERENCES = /\\(\d+)/;
var $0fea3078b1feac63$var$BACK_REFERENCING_END = /\\(\d+)/g;
var $0fea3078b1feac63$var$ruleIdSymbol = Symbol("RuleId");
var $0fea3078b1feac63$var$endRuleId = -1;
var $0fea3078b1feac63$var$whileRuleId = -2;
function $0fea3078b1feac63$var$ruleIdFromNumber(id) {
    return id;
}
function $0fea3078b1feac63$var$ruleIdToNumber(id) {
    return id;
}
var $0fea3078b1feac63$var$Rule = class {
    $location;
    id;
    _nameIsCapturing;
    _name;
    _contentNameIsCapturing;
    _contentName;
    constructor($location, id, name, contentName){
        this.$location = $location;
        this.id = id;
        this._name = name || null;
        this._nameIsCapturing = $0fea3078b1feac63$var$RegexSource.hasCaptures(this._name);
        this._contentName = contentName || null;
        this._contentNameIsCapturing = $0fea3078b1feac63$var$RegexSource.hasCaptures(this._contentName);
    }
    get debugName() {
        const location = this.$location ? `${$0fea3078b1feac63$var$basename(this.$location.filename)}:${this.$location.line}` : "unknown";
        return `${this.constructor.name}#${this.id} @ ${location}`;
    }
    getName(lineText, captureIndices) {
        if (!this._nameIsCapturing || this._name === null || lineText === null || captureIndices === null) return this._name;
        return $0fea3078b1feac63$var$RegexSource.replaceCaptures(this._name, lineText, captureIndices);
    }
    getContentName(lineText, captureIndices) {
        if (!this._contentNameIsCapturing || this._contentName === null) return this._contentName;
        return $0fea3078b1feac63$var$RegexSource.replaceCaptures(this._contentName, lineText, captureIndices);
    }
};
var $0fea3078b1feac63$var$CaptureRule = class extends $0fea3078b1feac63$var$Rule {
    retokenizeCapturedWithRuleId;
    constructor($location, id, name, contentName, retokenizeCapturedWithRuleId){
        super($location, id, name, contentName);
        this.retokenizeCapturedWithRuleId = retokenizeCapturedWithRuleId;
    }
    dispose() {}
    collectPatterns(grammar, out) {
        throw new Error("Not supported!");
    }
    compile(grammar, endRegexSource) {
        throw new Error("Not supported!");
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        throw new Error("Not supported!");
    }
};
var $0fea3078b1feac63$var$MatchRule = class extends $0fea3078b1feac63$var$Rule {
    _match;
    captures;
    _cachedCompiledPatterns;
    constructor($location, id, name, match, captures){
        super($location, id, name, null);
        this._match = new $0fea3078b1feac63$var$RegExpSource(match, this.id);
        this.captures = captures;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    get debugMatchRegExp() {
        return `${this._match.source}`;
    }
    collectPatterns(grammar, out) {
        out.push(this._match);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $0fea3078b1feac63$var$RegExpSourceList();
            this.collectPatterns(grammar, this._cachedCompiledPatterns);
        }
        return this._cachedCompiledPatterns;
    }
};
var $0fea3078b1feac63$var$IncludeOnlyRule = class extends $0fea3078b1feac63$var$Rule {
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    constructor($location, id, name, contentName, patterns){
        super($location, id, name, contentName);
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    collectPatterns(grammar, out) {
        for (const pattern of this.patterns){
            const rule = grammar.getRule(pattern);
            rule.collectPatterns(grammar, out);
        }
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $0fea3078b1feac63$var$RegExpSourceList();
            this.collectPatterns(grammar, this._cachedCompiledPatterns);
        }
        return this._cachedCompiledPatterns;
    }
};
var $0fea3078b1feac63$var$BeginEndRule = class extends $0fea3078b1feac63$var$Rule {
    _begin;
    beginCaptures;
    _end;
    endHasBackReferences;
    endCaptures;
    applyEndPatternLast;
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    constructor($location, id, name, contentName, begin, beginCaptures, end, endCaptures, applyEndPatternLast, patterns){
        super($location, id, name, contentName);
        this._begin = new $0fea3078b1feac63$var$RegExpSource(begin, this.id);
        this.beginCaptures = beginCaptures;
        this._end = new $0fea3078b1feac63$var$RegExpSource(end ? end : "\uFFFF", -1);
        this.endHasBackReferences = this._end.hasBackReferences;
        this.endCaptures = endCaptures;
        this.applyEndPatternLast = applyEndPatternLast || false;
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    get debugBeginRegExp() {
        return `${this._begin.source}`;
    }
    get debugEndRegExp() {
        return `${this._end.source}`;
    }
    getEndWithResolvedBackReferences(lineText, captureIndices) {
        return this._end.resolveBackReferences(lineText, captureIndices);
    }
    collectPatterns(grammar, out) {
        out.push(this._begin);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar, endRegexSource).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar, endRegexSource).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar, endRegexSource) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $0fea3078b1feac63$var$RegExpSourceList();
            for (const pattern of this.patterns){
                const rule = grammar.getRule(pattern);
                rule.collectPatterns(grammar, this._cachedCompiledPatterns);
            }
            if (this.applyEndPatternLast) this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end);
            else this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
        }
        if (this._end.hasBackReferences) {
            if (this.applyEndPatternLast) this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, endRegexSource);
            else this._cachedCompiledPatterns.setSource(0, endRegexSource);
        }
        return this._cachedCompiledPatterns;
    }
};
var $0fea3078b1feac63$var$BeginWhileRule = class extends $0fea3078b1feac63$var$Rule {
    _begin;
    beginCaptures;
    whileCaptures;
    _while;
    whileHasBackReferences;
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    _cachedCompiledWhilePatterns;
    constructor($location, id, name, contentName, begin, beginCaptures, _while, whileCaptures, patterns){
        super($location, id, name, contentName);
        this._begin = new $0fea3078b1feac63$var$RegExpSource(begin, this.id);
        this.beginCaptures = beginCaptures;
        this.whileCaptures = whileCaptures;
        this._while = new $0fea3078b1feac63$var$RegExpSource(_while, $0fea3078b1feac63$var$whileRuleId);
        this.whileHasBackReferences = this._while.hasBackReferences;
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
        this._cachedCompiledWhilePatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
        if (this._cachedCompiledWhilePatterns) {
            this._cachedCompiledWhilePatterns.dispose();
            this._cachedCompiledWhilePatterns = null;
        }
    }
    get debugBeginRegExp() {
        return `${this._begin.source}`;
    }
    get debugWhileRegExp() {
        return `${this._while.source}`;
    }
    getWhileWithResolvedBackReferences(lineText, captureIndices) {
        return this._while.resolveBackReferences(lineText, captureIndices);
    }
    collectPatterns(grammar, out) {
        out.push(this._begin);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $0fea3078b1feac63$var$RegExpSourceList();
            for (const pattern of this.patterns){
                const rule = grammar.getRule(pattern);
                rule.collectPatterns(grammar, this._cachedCompiledPatterns);
            }
        }
        return this._cachedCompiledPatterns;
    }
    compileWhile(grammar, endRegexSource) {
        return this._getCachedCompiledWhilePatterns(grammar, endRegexSource).compile(grammar);
    }
    compileWhileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledWhilePatterns(grammar, endRegexSource).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledWhilePatterns(grammar, endRegexSource) {
        if (!this._cachedCompiledWhilePatterns) {
            this._cachedCompiledWhilePatterns = new $0fea3078b1feac63$var$RegExpSourceList();
            this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while);
        }
        if (this._while.hasBackReferences) this._cachedCompiledWhilePatterns.setSource(0, endRegexSource ? endRegexSource : "\uFFFF");
        return this._cachedCompiledWhilePatterns;
    }
};
var $0fea3078b1feac63$var$RuleFactory = class _RuleFactory {
    static createCaptureRule(helper, $location, name, contentName, retokenizeCapturedWithRuleId) {
        return helper.registerRule((id)=>{
            return new $0fea3078b1feac63$var$CaptureRule($location, id, name, contentName, retokenizeCapturedWithRuleId);
        });
    }
    static getCompiledRuleId(desc, helper, repository) {
        if (!desc.id) helper.registerRule((id)=>{
            desc.id = id;
            if (desc.match) return new $0fea3078b1feac63$var$MatchRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.match, _RuleFactory._compileCaptures(desc.captures, helper, repository));
            if (typeof desc.begin === "undefined") {
                if (desc.repository) repository = $0fea3078b1feac63$var$mergeObjects({}, repository, desc.repository);
                let patterns = desc.patterns;
                if (typeof patterns === "undefined" && desc.include) patterns = [
                    {
                        include: desc.include
                    }
                ];
                return new $0fea3078b1feac63$var$IncludeOnlyRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, _RuleFactory._compilePatterns(patterns, helper, repository));
            }
            if (desc.while) return new $0fea3078b1feac63$var$BeginWhileRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, desc.begin, _RuleFactory._compileCaptures(desc.beginCaptures || desc.captures, helper, repository), desc.while, _RuleFactory._compileCaptures(desc.whileCaptures || desc.captures, helper, repository), _RuleFactory._compilePatterns(desc.patterns, helper, repository));
            return new $0fea3078b1feac63$var$BeginEndRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, desc.begin, _RuleFactory._compileCaptures(desc.beginCaptures || desc.captures, helper, repository), desc.end, _RuleFactory._compileCaptures(desc.endCaptures || desc.captures, helper, repository), desc.applyEndPatternLast, _RuleFactory._compilePatterns(desc.patterns, helper, repository));
        });
        return desc.id;
    }
    static _compileCaptures(captures, helper, repository) {
        let r = [];
        if (captures) {
            let maximumCaptureId = 0;
            for(const captureId in captures){
                if (captureId === "$vscodeTextmateLocation") continue;
                const numericCaptureId = parseInt(captureId, 10);
                if (numericCaptureId > maximumCaptureId) maximumCaptureId = numericCaptureId;
            }
            for(let i = 0; i <= maximumCaptureId; i++)r[i] = null;
            for(const captureId in captures){
                if (captureId === "$vscodeTextmateLocation") continue;
                const numericCaptureId = parseInt(captureId, 10);
                let retokenizeCapturedWithRuleId = 0;
                if (captures[captureId].patterns) retokenizeCapturedWithRuleId = _RuleFactory.getCompiledRuleId(captures[captureId], helper, repository);
                r[numericCaptureId] = _RuleFactory.createCaptureRule(helper, captures[captureId].$vscodeTextmateLocation, captures[captureId].name, captures[captureId].contentName, retokenizeCapturedWithRuleId);
            }
        }
        return r;
    }
    static _compilePatterns(patterns, helper, repository) {
        let r = [];
        if (patterns) for(let i = 0, len = patterns.length; i < len; i++){
            const pattern = patterns[i];
            let ruleId = -1;
            if (pattern.include) {
                const reference = $0fea3078b1feac63$var$parseInclude(pattern.include);
                switch(reference.kind){
                    case 0 /* Base */ :
                    case 1 /* Self */ :
                        ruleId = _RuleFactory.getCompiledRuleId(repository[pattern.include], helper, repository);
                        break;
                    case 2 /* RelativeReference */ :
                        let localIncludedRule = repository[reference.ruleName];
                        if (localIncludedRule) ruleId = _RuleFactory.getCompiledRuleId(localIncludedRule, helper, repository);
                        break;
                    case 3 /* TopLevelReference */ :
                    case 4 /* TopLevelRepositoryReference */ :
                        const externalGrammarName = reference.scopeName;
                        const externalGrammarInclude = reference.kind === 4 /* TopLevelRepositoryReference */  ? reference.ruleName : null;
                        const externalGrammar = helper.getExternalGrammar(externalGrammarName, repository);
                        if (externalGrammar) {
                            if (externalGrammarInclude) {
                                let externalIncludedRule = externalGrammar.repository[externalGrammarInclude];
                                if (externalIncludedRule) ruleId = _RuleFactory.getCompiledRuleId(externalIncludedRule, helper, externalGrammar.repository);
                            } else ruleId = _RuleFactory.getCompiledRuleId(externalGrammar.repository.$self, helper, externalGrammar.repository);
                        } else ;
                        break;
                }
            } else ruleId = _RuleFactory.getCompiledRuleId(pattern, helper, repository);
            if (ruleId !== -1) {
                const rule = helper.getRule(ruleId);
                let skipRule = false;
                if (rule instanceof $0fea3078b1feac63$var$IncludeOnlyRule || rule instanceof $0fea3078b1feac63$var$BeginEndRule || rule instanceof $0fea3078b1feac63$var$BeginWhileRule) {
                    if (rule.hasMissingPatterns && rule.patterns.length === 0) skipRule = true;
                }
                if (skipRule) continue;
                r.push(ruleId);
            }
        }
        return {
            patterns: r,
            hasMissingPatterns: (patterns ? patterns.length : 0) !== r.length
        };
    }
};
var $0fea3078b1feac63$var$RegExpSource = class _RegExpSource {
    source;
    ruleId;
    hasAnchor;
    hasBackReferences;
    _anchorCache;
    constructor(regExpSource, ruleId){
        if (regExpSource && typeof regExpSource === "string") {
            const len = regExpSource.length;
            let lastPushedPos = 0;
            let output = [];
            let hasAnchor = false;
            for(let pos = 0; pos < len; pos++){
                const ch = regExpSource.charAt(pos);
                if (ch === "\\") {
                    if (pos + 1 < len) {
                        const nextCh = regExpSource.charAt(pos + 1);
                        if (nextCh === "z") {
                            output.push(regExpSource.substring(lastPushedPos, pos));
                            output.push("$(?!\\n)(?<!\\n)");
                            lastPushedPos = pos + 2;
                        } else if (nextCh === "A" || nextCh === "G") hasAnchor = true;
                        pos++;
                    }
                }
            }
            this.hasAnchor = hasAnchor;
            if (lastPushedPos === 0) this.source = regExpSource;
            else {
                output.push(regExpSource.substring(lastPushedPos, len));
                this.source = output.join("");
            }
        } else {
            this.hasAnchor = false;
            this.source = regExpSource;
        }
        if (this.hasAnchor) this._anchorCache = this._buildAnchorCache();
        else this._anchorCache = null;
        this.ruleId = ruleId;
        if (typeof this.source === "string") this.hasBackReferences = $0fea3078b1feac63$var$HAS_BACK_REFERENCES.test(this.source);
        else this.hasBackReferences = false;
    }
    clone() {
        return new _RegExpSource(this.source, this.ruleId);
    }
    setSource(newSource) {
        if (this.source === newSource) return;
        this.source = newSource;
        if (this.hasAnchor) this._anchorCache = this._buildAnchorCache();
    }
    resolveBackReferences(lineText, captureIndices) {
        if (typeof this.source !== "string") throw new Error("This method should only be called if the source is a string");
        let capturedValues = captureIndices.map((capture)=>{
            return lineText.substring(capture.start, capture.end);
        });
        $0fea3078b1feac63$var$BACK_REFERENCING_END.lastIndex = 0;
        return this.source.replace($0fea3078b1feac63$var$BACK_REFERENCING_END, (match, g1)=>{
            return $0fea3078b1feac63$var$escapeRegExpCharacters(capturedValues[parseInt(g1, 10)] || "");
        });
    }
    _buildAnchorCache() {
        if (typeof this.source !== "string") throw new Error("This method should only be called if the source is a string");
        let A0_G0_result = [];
        let A0_G1_result = [];
        let A1_G0_result = [];
        let A1_G1_result = [];
        let pos, len, ch, nextCh;
        for(pos = 0, len = this.source.length; pos < len; pos++){
            ch = this.source.charAt(pos);
            A0_G0_result[pos] = ch;
            A0_G1_result[pos] = ch;
            A1_G0_result[pos] = ch;
            A1_G1_result[pos] = ch;
            if (ch === "\\") {
                if (pos + 1 < len) {
                    nextCh = this.source.charAt(pos + 1);
                    if (nextCh === "A") {
                        A0_G0_result[pos + 1] = "\uFFFF";
                        A0_G1_result[pos + 1] = "\uFFFF";
                        A1_G0_result[pos + 1] = "A";
                        A1_G1_result[pos + 1] = "A";
                    } else if (nextCh === "G") {
                        A0_G0_result[pos + 1] = "\uFFFF";
                        A0_G1_result[pos + 1] = "G";
                        A1_G0_result[pos + 1] = "\uFFFF";
                        A1_G1_result[pos + 1] = "G";
                    } else {
                        A0_G0_result[pos + 1] = nextCh;
                        A0_G1_result[pos + 1] = nextCh;
                        A1_G0_result[pos + 1] = nextCh;
                        A1_G1_result[pos + 1] = nextCh;
                    }
                    pos++;
                }
            }
        }
        return {
            A0_G0: A0_G0_result.join(""),
            A0_G1: A0_G1_result.join(""),
            A1_G0: A1_G0_result.join(""),
            A1_G1: A1_G1_result.join("")
        };
    }
    resolveAnchors(allowA, allowG) {
        if (!this.hasAnchor || !this._anchorCache || typeof this.source !== "string") return this.source;
        if (allowA) {
            if (allowG) return this._anchorCache.A1_G1;
            else return this._anchorCache.A1_G0;
        } else {
            if (allowG) return this._anchorCache.A0_G1;
            else return this._anchorCache.A0_G0;
        }
    }
};
var $0fea3078b1feac63$var$RegExpSourceList = class {
    _items;
    _hasAnchors;
    _cached;
    _anchorCache;
    constructor(){
        this._items = [];
        this._hasAnchors = false;
        this._cached = null;
        this._anchorCache = {
            A0_G0: null,
            A0_G1: null,
            A1_G0: null,
            A1_G1: null
        };
    }
    dispose() {
        this._disposeCaches();
    }
    _disposeCaches() {
        if (this._cached) {
            this._cached.dispose();
            this._cached = null;
        }
        if (this._anchorCache.A0_G0) {
            this._anchorCache.A0_G0.dispose();
            this._anchorCache.A0_G0 = null;
        }
        if (this._anchorCache.A0_G1) {
            this._anchorCache.A0_G1.dispose();
            this._anchorCache.A0_G1 = null;
        }
        if (this._anchorCache.A1_G0) {
            this._anchorCache.A1_G0.dispose();
            this._anchorCache.A1_G0 = null;
        }
        if (this._anchorCache.A1_G1) {
            this._anchorCache.A1_G1.dispose();
            this._anchorCache.A1_G1 = null;
        }
    }
    push(item) {
        this._items.push(item);
        this._hasAnchors = this._hasAnchors || item.hasAnchor;
    }
    unshift(item) {
        this._items.unshift(item);
        this._hasAnchors = this._hasAnchors || item.hasAnchor;
    }
    length() {
        return this._items.length;
    }
    setSource(index, newSource) {
        if (this._items[index].source !== newSource) {
            this._disposeCaches();
            this._items[index].setSource(newSource);
        }
    }
    compile(onigLib) {
        if (!this._cached) {
            let regExps = this._items.map((e)=>e.source);
            this._cached = new $0fea3078b1feac63$var$CompiledRule(onigLib, regExps, this._items.map((e)=>e.ruleId));
        }
        return this._cached;
    }
    compileAG(onigLib, allowA, allowG) {
        if (!this._hasAnchors) return this.compile(onigLib);
        else {
            if (allowA) {
                if (allowG) {
                    if (!this._anchorCache.A1_G1) this._anchorCache.A1_G1 = this._resolveAnchors(onigLib, allowA, allowG);
                    return this._anchorCache.A1_G1;
                } else {
                    if (!this._anchorCache.A1_G0) this._anchorCache.A1_G0 = this._resolveAnchors(onigLib, allowA, allowG);
                    return this._anchorCache.A1_G0;
                }
            } else if (allowG) {
                if (!this._anchorCache.A0_G1) this._anchorCache.A0_G1 = this._resolveAnchors(onigLib, allowA, allowG);
                return this._anchorCache.A0_G1;
            } else {
                if (!this._anchorCache.A0_G0) this._anchorCache.A0_G0 = this._resolveAnchors(onigLib, allowA, allowG);
                return this._anchorCache.A0_G0;
            }
        }
    }
    _resolveAnchors(onigLib, allowA, allowG) {
        let regExps = this._items.map((e)=>e.resolveAnchors(allowA, allowG));
        return new $0fea3078b1feac63$var$CompiledRule(onigLib, regExps, this._items.map((e)=>e.ruleId));
    }
};
var $0fea3078b1feac63$var$CompiledRule = class {
    constructor(onigLib, regExps, rules){
        this.regExps = regExps;
        this.rules = rules;
        this.scanner = onigLib.createOnigScanner(regExps);
    }
    scanner;
    dispose() {
        if (typeof this.scanner.dispose === "function") this.scanner.dispose();
    }
    toString() {
        const r = [];
        for(let i = 0, len = this.rules.length; i < len; i++)r.push("   - " + this.rules[i] + ": " + this.regExps[i]);
        return r.join("\n");
    }
    findNextMatchSync(string, startPosition, options) {
        const result = this.scanner.findNextMatchSync(string, startPosition, options);
        if (!result) return null;
        return {
            ruleId: this.rules[result.index],
            captureIndices: result.captureIndices
        };
    }
};
// src/grammar/basicScopesAttributeProvider.ts
var $0fea3078b1feac63$var$BasicScopeAttributes = class {
    constructor(languageId, tokenType){
        this.languageId = languageId;
        this.tokenType = tokenType;
    }
};
var $0fea3078b1feac63$var$BasicScopeAttributesProvider = class _BasicScopeAttributesProvider {
    _defaultAttributes;
    _embeddedLanguagesMatcher;
    constructor(initialLanguageId, embeddedLanguages){
        this._defaultAttributes = new $0fea3078b1feac63$var$BasicScopeAttributes(initialLanguageId, 8 /* NotSet */ );
        this._embeddedLanguagesMatcher = new $0fea3078b1feac63$var$ScopeMatcher(Object.entries(embeddedLanguages || {}));
    }
    getDefaultAttributes() {
        return this._defaultAttributes;
    }
    getBasicScopeAttributes(scopeName) {
        if (scopeName === null) return _BasicScopeAttributesProvider._NULL_SCOPE_METADATA;
        return this._getBasicScopeAttributes.get(scopeName);
    }
    static _NULL_SCOPE_METADATA = new $0fea3078b1feac63$var$BasicScopeAttributes(0, 0);
    _getBasicScopeAttributes = new $0fea3078b1feac63$var$CachedFn((scopeName)=>{
        const languageId = this._scopeToLanguage(scopeName);
        const standardTokenType = this._toStandardTokenType(scopeName);
        return new $0fea3078b1feac63$var$BasicScopeAttributes(languageId, standardTokenType);
    });
    /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */ _scopeToLanguage(scope) {
        return this._embeddedLanguagesMatcher.match(scope) || 0;
    }
    _toStandardTokenType(scopeName) {
        const m = scopeName.match(_BasicScopeAttributesProvider.STANDARD_TOKEN_TYPE_REGEXP);
        if (!m) return 8 /* NotSet */ ;
        switch(m[1]){
            case "comment":
                return 1 /* Comment */ ;
            case "string":
                return 2 /* String */ ;
            case "regex":
                return 3 /* RegEx */ ;
            case "meta.embedded":
                return 0 /* Other */ ;
        }
        throw new Error("Unexpected match for standard token type!");
    }
    static STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex|meta\.embedded)\b/;
};
var $0fea3078b1feac63$var$ScopeMatcher = class {
    values;
    scopesRegExp;
    constructor(values){
        if (values.length === 0) {
            this.values = null;
            this.scopesRegExp = null;
        } else {
            this.values = new Map(values);
            const escapedScopes = values.map(([scopeName, value])=>$0fea3078b1feac63$var$escapeRegExpCharacters(scopeName));
            escapedScopes.sort();
            escapedScopes.reverse();
            this.scopesRegExp = new RegExp(`^((${escapedScopes.join(")|(")}))($|\\.)`, "");
        }
    }
    match(scope) {
        if (!this.scopesRegExp) return void 0;
        const m = scope.match(this.scopesRegExp);
        if (!m) return void 0;
        return this.values.get(m[1]);
    }
};
// src/debug.ts
var $0fea3078b1feac63$var$DebugFlags = {
    InDebugMode: false
};
var $0fea3078b1feac63$var$UseOnigurumaFindOptions = false;
// src/grammar/tokenizeString.ts
var $0fea3078b1feac63$var$TokenizeStringResult = class {
    constructor(stack, stoppedEarly){
        this.stack = stack;
        this.stoppedEarly = stoppedEarly;
    }
};
function $0fea3078b1feac63$var$_tokenizeString(grammar, lineText, isFirstLine, linePos, stack, lineTokens, checkWhileConditions, timeLimit) {
    const lineLength = lineText.content.length;
    let STOP = false;
    let anchorPosition = -1;
    if (checkWhileConditions) {
        const whileCheckResult = $0fea3078b1feac63$var$_checkWhileConditions(grammar, lineText, isFirstLine, linePos, stack, lineTokens);
        stack = whileCheckResult.stack;
        linePos = whileCheckResult.linePos;
        isFirstLine = whileCheckResult.isFirstLine;
        anchorPosition = whileCheckResult.anchorPosition;
    }
    const startTime = Date.now();
    while(!STOP){
        if (timeLimit !== 0) {
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime > timeLimit) return new $0fea3078b1feac63$var$TokenizeStringResult(stack, true);
        }
        scanNext();
    }
    return new $0fea3078b1feac63$var$TokenizeStringResult(stack, false);
    function scanNext() {
        const r = $0fea3078b1feac63$var$matchRuleOrInjections(grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
        if (!r) {
            lineTokens.produce(stack, lineLength);
            STOP = true;
            return;
        }
        const captureIndices = r.captureIndices;
        const matchedRuleId = r.matchedRuleId;
        const hasAdvanced = captureIndices && captureIndices.length > 0 ? captureIndices[0].end > linePos : false;
        if (matchedRuleId === $0fea3078b1feac63$var$endRuleId) {
            const poppedRule = stack.getRule(grammar);
            lineTokens.produce(stack, captureIndices[0].start);
            stack = stack.withContentNameScopesList(stack.nameScopesList);
            $0fea3078b1feac63$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, poppedRule.endCaptures, captureIndices);
            lineTokens.produce(stack, captureIndices[0].end);
            const popped = stack;
            stack = stack.parent;
            anchorPosition = popped.getAnchorPos();
            if (!hasAdvanced && popped.getEnterPos() === linePos) {
                stack = popped;
                lineTokens.produce(stack, lineLength);
                STOP = true;
                return;
            }
        } else {
            const _rule = grammar.getRule(matchedRuleId);
            lineTokens.produce(stack, captureIndices[0].start);
            const beforePush = stack;
            const scopeName = _rule.getName(lineText.content, captureIndices);
            const nameScopesList = stack.contentNameScopesList.pushAttributed(scopeName, grammar);
            stack = stack.push(matchedRuleId, linePos, anchorPosition, captureIndices[0].end === lineLength, null, nameScopesList, nameScopesList);
            if (_rule instanceof $0fea3078b1feac63$var$BeginEndRule) {
                const pushedRule = _rule;
                $0fea3078b1feac63$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, pushedRule.beginCaptures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                anchorPosition = captureIndices[0].end;
                const contentName = pushedRule.getContentName(lineText.content, captureIndices);
                const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
                stack = stack.withContentNameScopesList(contentNameScopesList);
                if (pushedRule.endHasBackReferences) stack = stack.withEndRule(pushedRule.getEndWithResolvedBackReferences(lineText.content, captureIndices));
                if (!hasAdvanced && beforePush.hasSameRuleAs(stack)) {
                    stack = stack.pop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            } else if (_rule instanceof $0fea3078b1feac63$var$BeginWhileRule) {
                const pushedRule = _rule;
                $0fea3078b1feac63$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, pushedRule.beginCaptures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                anchorPosition = captureIndices[0].end;
                const contentName = pushedRule.getContentName(lineText.content, captureIndices);
                const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
                stack = stack.withContentNameScopesList(contentNameScopesList);
                if (pushedRule.whileHasBackReferences) stack = stack.withEndRule(pushedRule.getWhileWithResolvedBackReferences(lineText.content, captureIndices));
                if (!hasAdvanced && beforePush.hasSameRuleAs(stack)) {
                    stack = stack.pop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            } else {
                const matchingRule = _rule;
                $0fea3078b1feac63$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, matchingRule.captures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                stack = stack.pop();
                if (!hasAdvanced) {
                    stack = stack.safePop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            }
        }
        if (captureIndices[0].end > linePos) {
            linePos = captureIndices[0].end;
            isFirstLine = false;
        }
    }
}
function $0fea3078b1feac63$var$_checkWhileConditions(grammar, lineText, isFirstLine, linePos, stack, lineTokens) {
    let anchorPosition = stack.beginRuleCapturedEOL ? 0 : -1;
    const whileRules = [];
    for(let node = stack; node; node = node.pop()){
        const nodeRule = node.getRule(grammar);
        if (nodeRule instanceof $0fea3078b1feac63$var$BeginWhileRule) whileRules.push({
            rule: nodeRule,
            stack: node
        });
    }
    for(let whileRule = whileRules.pop(); whileRule; whileRule = whileRules.pop()){
        const { ruleScanner: ruleScanner, findOptions: findOptions } = $0fea3078b1feac63$var$prepareRuleWhileSearch(whileRule.rule, grammar, whileRule.stack.endRule, isFirstLine, linePos === anchorPosition);
        const r = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
        if (r) {
            const matchedRuleId = r.ruleId;
            if (matchedRuleId !== $0fea3078b1feac63$var$whileRuleId) {
                stack = whileRule.stack.pop();
                break;
            }
            if (r.captureIndices && r.captureIndices.length) {
                lineTokens.produce(whileRule.stack, r.captureIndices[0].start);
                $0fea3078b1feac63$var$handleCaptures(grammar, lineText, isFirstLine, whileRule.stack, lineTokens, whileRule.rule.whileCaptures, r.captureIndices);
                lineTokens.produce(whileRule.stack, r.captureIndices[0].end);
                anchorPosition = r.captureIndices[0].end;
                if (r.captureIndices[0].end > linePos) {
                    linePos = r.captureIndices[0].end;
                    isFirstLine = false;
                }
            }
        } else {
            stack = whileRule.stack.pop();
            break;
        }
    }
    return {
        stack: stack,
        linePos: linePos,
        anchorPosition: anchorPosition,
        isFirstLine: isFirstLine
    };
}
function $0fea3078b1feac63$var$matchRuleOrInjections(grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    const matchResult = $0fea3078b1feac63$var$matchRule(grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
    const injections = grammar.getInjections();
    if (injections.length === 0) return matchResult;
    const injectionResult = $0fea3078b1feac63$var$matchInjections(injections, grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
    if (!injectionResult) return matchResult;
    if (!matchResult) return injectionResult;
    const matchResultScore = matchResult.captureIndices[0].start;
    const injectionResultScore = injectionResult.captureIndices[0].start;
    if (injectionResultScore < matchResultScore || injectionResult.priorityMatch && injectionResultScore === matchResultScore) return injectionResult;
    return matchResult;
}
function $0fea3078b1feac63$var$matchRule(grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    const rule = stack.getRule(grammar);
    const { ruleScanner: ruleScanner, findOptions: findOptions } = $0fea3078b1feac63$var$prepareRuleSearch(rule, grammar, stack.endRule, isFirstLine, linePos === anchorPosition);
    const r = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
    if (r) return {
        captureIndices: r.captureIndices,
        matchedRuleId: r.ruleId
    };
    return null;
}
function $0fea3078b1feac63$var$matchInjections(injections, grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    let bestMatchRating = Number.MAX_VALUE;
    let bestMatchCaptureIndices = null;
    let bestMatchRuleId;
    let bestMatchResultPriority = 0;
    const scopes = stack.contentNameScopesList.getScopeNames();
    for(let i = 0, len = injections.length; i < len; i++){
        const injection = injections[i];
        if (!injection.matcher(scopes)) continue;
        const rule = grammar.getRule(injection.ruleId);
        const { ruleScanner: ruleScanner, findOptions: findOptions } = $0fea3078b1feac63$var$prepareRuleSearch(rule, grammar, null, isFirstLine, linePos === anchorPosition);
        const matchResult = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
        if (!matchResult) continue;
        const matchRating = matchResult.captureIndices[0].start;
        if (matchRating >= bestMatchRating) continue;
        bestMatchRating = matchRating;
        bestMatchCaptureIndices = matchResult.captureIndices;
        bestMatchRuleId = matchResult.ruleId;
        bestMatchResultPriority = injection.priority;
        if (bestMatchRating === linePos) break;
    }
    if (bestMatchCaptureIndices) return {
        priorityMatch: bestMatchResultPriority === -1,
        captureIndices: bestMatchCaptureIndices,
        matchedRuleId: bestMatchRuleId
    };
    return null;
}
function $0fea3078b1feac63$var$prepareRuleSearch(rule, grammar, endRegexSource, allowA, allowG) {
    if ($0fea3078b1feac63$var$UseOnigurumaFindOptions) {
        const ruleScanner2 = rule.compile(grammar, endRegexSource);
        const findOptions = $0fea3078b1feac63$var$getFindOptions(allowA, allowG);
        return {
            ruleScanner: ruleScanner2,
            findOptions: findOptions
        };
    }
    const ruleScanner = rule.compileAG(grammar, endRegexSource, allowA, allowG);
    return {
        ruleScanner: ruleScanner,
        findOptions: 0 /* None */ 
    };
}
function $0fea3078b1feac63$var$prepareRuleWhileSearch(rule, grammar, endRegexSource, allowA, allowG) {
    if ($0fea3078b1feac63$var$UseOnigurumaFindOptions) {
        const ruleScanner2 = rule.compileWhile(grammar, endRegexSource);
        const findOptions = $0fea3078b1feac63$var$getFindOptions(allowA, allowG);
        return {
            ruleScanner: ruleScanner2,
            findOptions: findOptions
        };
    }
    const ruleScanner = rule.compileWhileAG(grammar, endRegexSource, allowA, allowG);
    return {
        ruleScanner: ruleScanner,
        findOptions: 0 /* None */ 
    };
}
function $0fea3078b1feac63$var$getFindOptions(allowA, allowG) {
    let options = 0 /* None */ ;
    if (!allowA) options |= 1 /* NotBeginString */ ;
    if (!allowG) options |= 4 /* NotBeginPosition */ ;
    return options;
}
function $0fea3078b1feac63$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, captures, captureIndices) {
    if (captures.length === 0) return;
    const lineTextContent = lineText.content;
    const len = Math.min(captures.length, captureIndices.length);
    const localStack = [];
    const maxEnd = captureIndices[0].end;
    for(let i = 0; i < len; i++){
        const captureRule = captures[i];
        if (captureRule === null) continue;
        const captureIndex = captureIndices[i];
        if (captureIndex.length === 0) continue;
        if (captureIndex.start > maxEnd) break;
        while(localStack.length > 0 && localStack[localStack.length - 1].endPos <= captureIndex.start){
            lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, localStack[localStack.length - 1].endPos);
            localStack.pop();
        }
        if (localStack.length > 0) lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, captureIndex.start);
        else lineTokens.produce(stack, captureIndex.start);
        if (captureRule.retokenizeCapturedWithRuleId) {
            const scopeName = captureRule.getName(lineTextContent, captureIndices);
            const nameScopesList = stack.contentNameScopesList.pushAttributed(scopeName, grammar);
            const contentName = captureRule.getContentName(lineTextContent, captureIndices);
            const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
            const stackClone = stack.push(captureRule.retokenizeCapturedWithRuleId, captureIndex.start, -1, false, null, nameScopesList, contentNameScopesList);
            const onigSubStr = grammar.createOnigString(lineTextContent.substring(0, captureIndex.end));
            $0fea3078b1feac63$var$_tokenizeString(grammar, onigSubStr, isFirstLine && captureIndex.start === 0, captureIndex.start, stackClone, lineTokens, false, /* no time limit */ 0);
            $0fea3078b1feac63$export$2b6cad23a17023a7(onigSubStr);
            continue;
        }
        const captureRuleScopeName = captureRule.getName(lineTextContent, captureIndices);
        if (captureRuleScopeName !== null) {
            const base = localStack.length > 0 ? localStack[localStack.length - 1].scopes : stack.contentNameScopesList;
            const captureRuleScopesList = base.pushAttributed(captureRuleScopeName, grammar);
            localStack.push(new $0fea3078b1feac63$var$LocalStackElement(captureRuleScopesList, captureIndex.end));
        }
    }
    while(localStack.length > 0){
        lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, localStack[localStack.length - 1].endPos);
        localStack.pop();
    }
}
var $0fea3078b1feac63$var$LocalStackElement = class {
    scopes;
    endPos;
    constructor(scopes, endPos){
        this.scopes = scopes;
        this.endPos = endPos;
    }
};
// src/grammar/grammar.ts
function $0fea3078b1feac63$var$createGrammar(scopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, onigLib) {
    return new $0fea3078b1feac63$var$Grammar(scopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, onigLib);
}
function $0fea3078b1feac63$var$collectInjections(result, selector, rule, ruleFactoryHelper, grammar) {
    const matchers = $0fea3078b1feac63$var$createMatchers(selector, $0fea3078b1feac63$var$nameMatcher);
    const ruleId = $0fea3078b1feac63$var$RuleFactory.getCompiledRuleId(rule, ruleFactoryHelper, grammar.repository);
    for (const matcher of matchers)result.push({
        debugSelector: selector,
        matcher: matcher.matcher,
        ruleId: ruleId,
        grammar: grammar,
        priority: matcher.priority
    });
}
function $0fea3078b1feac63$var$nameMatcher(identifers, scopes) {
    if (scopes.length < identifers.length) return false;
    let lastIndex = 0;
    return identifers.every((identifier)=>{
        for(let i = lastIndex; i < scopes.length; i++)if ($0fea3078b1feac63$var$scopesAreMatching(scopes[i], identifier)) {
            lastIndex = i + 1;
            return true;
        }
        return false;
    });
}
function $0fea3078b1feac63$var$scopesAreMatching(thisScopeName, scopeName) {
    if (!thisScopeName) return false;
    if (thisScopeName === scopeName) return true;
    const len = scopeName.length;
    return thisScopeName.length > len && thisScopeName.substr(0, len) === scopeName && thisScopeName[len] === ".";
}
var $0fea3078b1feac63$var$Grammar = class {
    constructor(_rootScopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, _onigLib){
        this._rootScopeName = _rootScopeName;
        this.balancedBracketSelectors = balancedBracketSelectors;
        this._onigLib = _onigLib;
        this._basicScopeAttributesProvider = new $0fea3078b1feac63$var$BasicScopeAttributesProvider(initialLanguage, embeddedLanguages);
        this._rootId = -1;
        this._lastRuleId = 0;
        this._ruleId2desc = [
            null
        ];
        this._includedGrammars = {};
        this._grammarRepository = grammarRepository;
        this._grammar = $0fea3078b1feac63$var$initGrammar(grammar, null);
        this._injections = null;
        this._tokenTypeMatchers = [];
        if (tokenTypes) for (const selector of Object.keys(tokenTypes)){
            const matchers = $0fea3078b1feac63$var$createMatchers(selector, $0fea3078b1feac63$var$nameMatcher);
            for (const matcher of matchers)this._tokenTypeMatchers.push({
                matcher: matcher.matcher,
                type: tokenTypes[selector]
            });
        }
    }
    _rootId;
    _lastRuleId;
    _ruleId2desc;
    _includedGrammars;
    _grammarRepository;
    _grammar;
    _injections;
    _basicScopeAttributesProvider;
    _tokenTypeMatchers;
    get themeProvider() {
        return this._grammarRepository;
    }
    dispose() {
        for (const rule of this._ruleId2desc)if (rule) rule.dispose();
    }
    createOnigScanner(sources) {
        return this._onigLib.createOnigScanner(sources);
    }
    createOnigString(sources) {
        return this._onigLib.createOnigString(sources);
    }
    getMetadataForScope(scope) {
        return this._basicScopeAttributesProvider.getBasicScopeAttributes(scope);
    }
    _collectInjections() {
        const grammarRepository = {
            lookup: (scopeName2)=>{
                if (scopeName2 === this._rootScopeName) return this._grammar;
                return this.getExternalGrammar(scopeName2);
            },
            injections: (scopeName2)=>{
                return this._grammarRepository.injections(scopeName2);
            }
        };
        const result = [];
        const scopeName = this._rootScopeName;
        const grammar = grammarRepository.lookup(scopeName);
        if (grammar) {
            const rawInjections = grammar.injections;
            if (rawInjections) for(let expression in rawInjections)$0fea3078b1feac63$var$collectInjections(result, expression, rawInjections[expression], this, grammar);
            const injectionScopeNames = this._grammarRepository.injections(scopeName);
            if (injectionScopeNames) injectionScopeNames.forEach((injectionScopeName)=>{
                const injectionGrammar = this.getExternalGrammar(injectionScopeName);
                if (injectionGrammar) {
                    const selector = injectionGrammar.injectionSelector;
                    if (selector) $0fea3078b1feac63$var$collectInjections(result, selector, injectionGrammar, this, injectionGrammar);
                }
            });
        }
        result.sort((i1, i2)=>i1.priority - i2.priority);
        return result;
    }
    getInjections() {
        if (this._injections === null) this._injections = this._collectInjections();
        return this._injections;
    }
    registerRule(factory) {
        const id = ++this._lastRuleId;
        const result = factory($0fea3078b1feac63$var$ruleIdFromNumber(id));
        this._ruleId2desc[id] = result;
        return result;
    }
    getRule(ruleId) {
        return this._ruleId2desc[$0fea3078b1feac63$var$ruleIdToNumber(ruleId)];
    }
    getExternalGrammar(scopeName, repository) {
        if (this._includedGrammars[scopeName]) return this._includedGrammars[scopeName];
        else if (this._grammarRepository) {
            const rawIncludedGrammar = this._grammarRepository.lookup(scopeName);
            if (rawIncludedGrammar) {
                this._includedGrammars[scopeName] = $0fea3078b1feac63$var$initGrammar(rawIncludedGrammar, repository && repository.$base);
                return this._includedGrammars[scopeName];
            }
        }
        return void 0;
    }
    tokenizeLine(lineText, prevState, timeLimit = 0) {
        const r = this._tokenize(lineText, prevState, false, timeLimit);
        return {
            tokens: r.lineTokens.getResult(r.ruleStack, r.lineLength),
            ruleStack: r.ruleStack,
            stoppedEarly: r.stoppedEarly
        };
    }
    tokenizeLine2(lineText, prevState, timeLimit = 0) {
        const r = this._tokenize(lineText, prevState, true, timeLimit);
        return {
            tokens: r.lineTokens.getBinaryResult(r.ruleStack, r.lineLength),
            ruleStack: r.ruleStack,
            stoppedEarly: r.stoppedEarly
        };
    }
    _tokenize(lineText, prevState, emitBinaryTokens, timeLimit) {
        if (this._rootId === -1) {
            this._rootId = $0fea3078b1feac63$var$RuleFactory.getCompiledRuleId(this._grammar.repository.$self, this, this._grammar.repository);
            this.getInjections();
        }
        let isFirstLine;
        if (!prevState || prevState === $0fea3078b1feac63$var$StateStackImpl.NULL) {
            isFirstLine = true;
            const rawDefaultMetadata = this._basicScopeAttributesProvider.getDefaultAttributes();
            const defaultStyle = this.themeProvider.getDefaults();
            const defaultMetadata = $0fea3078b1feac63$export$90e5db14803ea047.set(0, rawDefaultMetadata.languageId, rawDefaultMetadata.tokenType, null, defaultStyle.fontStyle, defaultStyle.foregroundId, defaultStyle.backgroundId);
            const rootScopeName = this.getRule(this._rootId).getName(null, null);
            let scopeList;
            if (rootScopeName) scopeList = $0fea3078b1feac63$var$AttributedScopeStack.createRootAndLookUpScopeName(rootScopeName, defaultMetadata, this);
            else scopeList = $0fea3078b1feac63$var$AttributedScopeStack.createRoot("unknown", defaultMetadata);
            prevState = new $0fea3078b1feac63$var$StateStackImpl(null, this._rootId, -1, -1, false, null, scopeList, scopeList);
        } else {
            isFirstLine = false;
            prevState.reset();
        }
        lineText = lineText + "\n";
        const onigLineText = this.createOnigString(lineText);
        const lineLength = onigLineText.content.length;
        const lineTokens = new $0fea3078b1feac63$var$LineTokens(emitBinaryTokens, lineText, this._tokenTypeMatchers, this.balancedBracketSelectors);
        const r = $0fea3078b1feac63$var$_tokenizeString(this, onigLineText, isFirstLine, 0, prevState, lineTokens, true, timeLimit);
        $0fea3078b1feac63$export$2b6cad23a17023a7(onigLineText);
        return {
            lineLength: lineLength,
            lineTokens: lineTokens,
            ruleStack: r.stack,
            stoppedEarly: r.stoppedEarly
        };
    }
};
function $0fea3078b1feac63$var$initGrammar(grammar, base) {
    grammar = $0fea3078b1feac63$var$clone(grammar);
    grammar.repository = grammar.repository || {};
    grammar.repository.$self = {
        $vscodeTextmateLocation: grammar.$vscodeTextmateLocation,
        patterns: grammar.patterns,
        name: grammar.scopeName
    };
    grammar.repository.$base = base || grammar.repository.$self;
    return grammar;
}
var $0fea3078b1feac63$var$AttributedScopeStack = class _AttributedScopeStack {
    /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */ constructor(parent, scopePath, tokenAttributes){
        this.parent = parent;
        this.scopePath = scopePath;
        this.tokenAttributes = tokenAttributes;
    }
    static fromExtension(namesScopeList, contentNameScopesList) {
        let current = namesScopeList;
        let scopeNames = namesScopeList?.scopePath ?? null;
        for (const frame of contentNameScopesList){
            scopeNames = $0fea3078b1feac63$var$ScopeStack.push(scopeNames, frame.scopeNames);
            current = new _AttributedScopeStack(current, scopeNames, frame.encodedTokenAttributes);
        }
        return current;
    }
    static createRoot(scopeName, tokenAttributes) {
        return new _AttributedScopeStack(null, new $0fea3078b1feac63$var$ScopeStack(null, scopeName), tokenAttributes);
    }
    static createRootAndLookUpScopeName(scopeName, tokenAttributes, grammar) {
        const rawRootMetadata = grammar.getMetadataForScope(scopeName);
        const scopePath = new $0fea3078b1feac63$var$ScopeStack(null, scopeName);
        const rootStyle = grammar.themeProvider.themeMatch(scopePath);
        const resolvedTokenAttributes = _AttributedScopeStack.mergeAttributes(tokenAttributes, rawRootMetadata, rootStyle);
        return new _AttributedScopeStack(null, scopePath, resolvedTokenAttributes);
    }
    get scopeName() {
        return this.scopePath.scopeName;
    }
    toString() {
        return this.getScopeNames().join(" ");
    }
    equals(other) {
        return _AttributedScopeStack.equals(this, other);
    }
    static equals(a, b) {
        do {
            if (a === b) return true;
            if (!a && !b) return true;
            if (!a || !b) return false;
            if (a.scopeName !== b.scopeName || a.tokenAttributes !== b.tokenAttributes) return false;
            a = a.parent;
            b = b.parent;
        }while (true);
    }
    static mergeAttributes(existingTokenAttributes, basicScopeAttributes, styleAttributes) {
        let fontStyle = -1 /* NotSet */ ;
        let foreground = 0;
        let background = 0;
        if (styleAttributes !== null) {
            fontStyle = styleAttributes.fontStyle;
            foreground = styleAttributes.foregroundId;
            background = styleAttributes.backgroundId;
        }
        return $0fea3078b1feac63$export$90e5db14803ea047.set(existingTokenAttributes, basicScopeAttributes.languageId, basicScopeAttributes.tokenType, null, fontStyle, foreground, background);
    }
    pushAttributed(scopePath, grammar) {
        if (scopePath === null) return this;
        if (scopePath.indexOf(" ") === -1) return _AttributedScopeStack._pushAttributed(this, scopePath, grammar);
        const scopes = scopePath.split(/ /g);
        let result = this;
        for (const scope of scopes)result = _AttributedScopeStack._pushAttributed(result, scope, grammar);
        return result;
    }
    static _pushAttributed(target, scopeName, grammar) {
        const rawMetadata = grammar.getMetadataForScope(scopeName);
        const newPath = target.scopePath.push(scopeName);
        const scopeThemeMatchResult = grammar.themeProvider.themeMatch(newPath);
        const metadata = _AttributedScopeStack.mergeAttributes(target.tokenAttributes, rawMetadata, scopeThemeMatchResult);
        return new _AttributedScopeStack(target, newPath, metadata);
    }
    getScopeNames() {
        return this.scopePath.getSegments();
    }
    getExtensionIfDefined(base) {
        const result = [];
        let self = this;
        while(self && self !== base){
            result.push({
                encodedTokenAttributes: self.tokenAttributes,
                scopeNames: self.scopePath.getExtensionIfDefined(self.parent?.scopePath ?? null)
            });
            self = self.parent;
        }
        return self === base ? result.reverse() : void 0;
    }
};
var $0fea3078b1feac63$var$StateStackImpl = class _StateStackImpl {
    /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */ constructor(parent, ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList){
        this.parent = parent;
        this.ruleId = ruleId;
        this.beginRuleCapturedEOL = beginRuleCapturedEOL;
        this.endRule = endRule;
        this.nameScopesList = nameScopesList;
        this.contentNameScopesList = contentNameScopesList;
        this.depth = this.parent ? this.parent.depth + 1 : 1;
        this._enterPos = enterPos;
        this._anchorPos = anchorPos;
    }
    _stackElementBrand = void 0;
    // TODO remove me
    static NULL = new _StateStackImpl(null, 0, 0, 0, false, null, null, null);
    /**
   * The position on the current line where this state was pushed.
   * This is relevant only while tokenizing a line, to detect endless loops.
   * Its value is meaningless across lines.
   */ _enterPos;
    /**
   * The captured anchor position when this stack element was pushed.
   * This is relevant only while tokenizing a line, to restore the anchor position when popping.
   * Its value is meaningless across lines.
   */ _anchorPos;
    /**
   * The depth of the stack.
   */ depth;
    equals(other) {
        if (other === null) return false;
        return _StateStackImpl._equals(this, other);
    }
    static _equals(a, b) {
        if (a === b) return true;
        if (!this._structuralEquals(a, b)) return false;
        return $0fea3078b1feac63$var$AttributedScopeStack.equals(a.contentNameScopesList, b.contentNameScopesList);
    }
    /**
   * A structural equals check. Does not take into account `scopes`.
   */ static _structuralEquals(a, b) {
        do {
            if (a === b) return true;
            if (!a && !b) return true;
            if (!a || !b) return false;
            if (a.depth !== b.depth || a.ruleId !== b.ruleId || a.endRule !== b.endRule) return false;
            a = a.parent;
            b = b.parent;
        }while (true);
    }
    clone() {
        return this;
    }
    static _reset(el) {
        while(el){
            el._enterPos = -1;
            el._anchorPos = -1;
            el = el.parent;
        }
    }
    reset() {
        _StateStackImpl._reset(this);
    }
    pop() {
        return this.parent;
    }
    safePop() {
        if (this.parent) return this.parent;
        return this;
    }
    push(ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList) {
        return new _StateStackImpl(this, ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList);
    }
    getEnterPos() {
        return this._enterPos;
    }
    getAnchorPos() {
        return this._anchorPos;
    }
    getRule(grammar) {
        return grammar.getRule(this.ruleId);
    }
    toString() {
        const r = [];
        this._writeString(r, 0);
        return "[" + r.join(",") + "]";
    }
    _writeString(res, outIndex) {
        if (this.parent) outIndex = this.parent._writeString(res, outIndex);
        res[outIndex++] = `(${this.ruleId}, ${this.nameScopesList?.toString()}, ${this.contentNameScopesList?.toString()})`;
        return outIndex;
    }
    withContentNameScopesList(contentNameScopeStack) {
        if (this.contentNameScopesList === contentNameScopeStack) return this;
        return this.parent.push(this.ruleId, this._enterPos, this._anchorPos, this.beginRuleCapturedEOL, this.endRule, this.nameScopesList, contentNameScopeStack);
    }
    withEndRule(endRule) {
        if (this.endRule === endRule) return this;
        return new _StateStackImpl(this.parent, this.ruleId, this._enterPos, this._anchorPos, this.beginRuleCapturedEOL, endRule, this.nameScopesList, this.contentNameScopesList);
    }
    // Used to warn of endless loops
    hasSameRuleAs(other) {
        let el = this;
        while(el && el._enterPos === other._enterPos){
            if (el.ruleId === other.ruleId) return true;
            el = el.parent;
        }
        return false;
    }
    toStateStackFrame() {
        return {
            ruleId: $0fea3078b1feac63$var$ruleIdToNumber(this.ruleId),
            beginRuleCapturedEOL: this.beginRuleCapturedEOL,
            endRule: this.endRule,
            nameScopesList: this.nameScopesList?.getExtensionIfDefined(this.parent?.nameScopesList ?? null) ?? [],
            contentNameScopesList: this.contentNameScopesList?.getExtensionIfDefined(this.nameScopesList) ?? []
        };
    }
    static pushFrame(self, frame) {
        const namesScopeList = $0fea3078b1feac63$var$AttributedScopeStack.fromExtension(self?.nameScopesList ?? null, frame.nameScopesList);
        return new _StateStackImpl(self, $0fea3078b1feac63$var$ruleIdFromNumber(frame.ruleId), frame.enterPos ?? -1, frame.anchorPos ?? -1, frame.beginRuleCapturedEOL, frame.endRule, namesScopeList, $0fea3078b1feac63$var$AttributedScopeStack.fromExtension(namesScopeList, frame.contentNameScopesList));
    }
};
var $0fea3078b1feac63$var$BalancedBracketSelectors = class {
    balancedBracketScopes;
    unbalancedBracketScopes;
    allowAny = false;
    constructor(balancedBracketScopes, unbalancedBracketScopes){
        this.balancedBracketScopes = balancedBracketScopes.flatMap((selector)=>{
            if (selector === "*") {
                this.allowAny = true;
                return [];
            }
            return $0fea3078b1feac63$var$createMatchers(selector, $0fea3078b1feac63$var$nameMatcher).map((m)=>m.matcher);
        });
        this.unbalancedBracketScopes = unbalancedBracketScopes.flatMap((selector)=>$0fea3078b1feac63$var$createMatchers(selector, $0fea3078b1feac63$var$nameMatcher).map((m)=>m.matcher));
    }
    get matchesAlways() {
        return this.allowAny && this.unbalancedBracketScopes.length === 0;
    }
    get matchesNever() {
        return this.balancedBracketScopes.length === 0 && !this.allowAny;
    }
    match(scopes) {
        for (const excluder of this.unbalancedBracketScopes){
            if (excluder(scopes)) return false;
        }
        for (const includer of this.balancedBracketScopes){
            if (includer(scopes)) return true;
        }
        return this.allowAny;
    }
};
var $0fea3078b1feac63$var$LineTokens = class {
    constructor(emitBinaryTokens, lineText, tokenTypeOverrides, balancedBracketSelectors){
        this.balancedBracketSelectors = balancedBracketSelectors;
        this._emitBinaryTokens = emitBinaryTokens;
        this._tokenTypeOverrides = tokenTypeOverrides;
        this._lineText = null;
        this._tokens = [];
        this._binaryTokens = [];
        this._lastTokenEndIndex = 0;
    }
    _emitBinaryTokens;
    /**
   * defined only if `false`.
   */ _lineText;
    /**
   * used only if `_emitBinaryTokens` is false.
   */ _tokens;
    /**
   * used only if `_emitBinaryTokens` is true.
   */ _binaryTokens;
    _lastTokenEndIndex;
    _tokenTypeOverrides;
    produce(stack, endIndex) {
        this.produceFromScopes(stack.contentNameScopesList, endIndex);
    }
    produceFromScopes(scopesList, endIndex) {
        if (this._lastTokenEndIndex >= endIndex) return;
        if (this._emitBinaryTokens) {
            let metadata = scopesList?.tokenAttributes ?? 0;
            let containsBalancedBrackets = false;
            if (this.balancedBracketSelectors?.matchesAlways) containsBalancedBrackets = true;
            if (this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
                const scopes2 = scopesList?.getScopeNames() ?? [];
                for (const tokenType of this._tokenTypeOverrides)if (tokenType.matcher(scopes2)) metadata = $0fea3078b1feac63$export$90e5db14803ea047.set(metadata, 0, $0fea3078b1feac63$var$toOptionalTokenType(tokenType.type), null, -1 /* NotSet */ , 0, 0);
                if (this.balancedBracketSelectors) containsBalancedBrackets = this.balancedBracketSelectors.match(scopes2);
            }
            if (containsBalancedBrackets) metadata = $0fea3078b1feac63$export$90e5db14803ea047.set(metadata, 0, 8 /* NotSet */ , containsBalancedBrackets, -1 /* NotSet */ , 0, 0);
            if (this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === metadata) {
                this._lastTokenEndIndex = endIndex;
                return;
            }
            this._binaryTokens.push(this._lastTokenEndIndex);
            this._binaryTokens.push(metadata);
            this._lastTokenEndIndex = endIndex;
            return;
        }
        const scopes = scopesList?.getScopeNames() ?? [];
        this._tokens.push({
            startIndex: this._lastTokenEndIndex,
            endIndex: endIndex,
            scopes: // value: lineText.substring(lastTokenEndIndex, endIndex),
            scopes
        });
        this._lastTokenEndIndex = endIndex;
    }
    getResult(stack, lineLength) {
        if (this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === lineLength - 1) this._tokens.pop();
        if (this._tokens.length === 0) {
            this._lastTokenEndIndex = -1;
            this.produce(stack, lineLength);
            this._tokens[this._tokens.length - 1].startIndex = 0;
        }
        return this._tokens;
    }
    getBinaryResult(stack, lineLength) {
        if (this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === lineLength - 1) {
            this._binaryTokens.pop();
            this._binaryTokens.pop();
        }
        if (this._binaryTokens.length === 0) {
            this._lastTokenEndIndex = -1;
            this.produce(stack, lineLength);
            this._binaryTokens[this._binaryTokens.length - 2] = 0;
        }
        const result = new Uint32Array(this._binaryTokens.length);
        for(let i = 0, len = this._binaryTokens.length; i < len; i++)result[i] = this._binaryTokens[i];
        return result;
    }
};
// src/registry.ts
var $0fea3078b1feac63$var$SyncRegistry = class {
    constructor(theme, _onigLib){
        this._onigLib = _onigLib;
        this._theme = theme;
    }
    _grammars = /* @__PURE__ */ new Map();
    _rawGrammars = /* @__PURE__ */ new Map();
    _injectionGrammars = /* @__PURE__ */ new Map();
    _theme;
    dispose() {
        for (const grammar of this._grammars.values())grammar.dispose();
    }
    setTheme(theme) {
        this._theme = theme;
    }
    getColorMap() {
        return this._theme.getColorMap();
    }
    /**
   * Add `grammar` to registry and return a list of referenced scope names
   */ addGrammar(grammar, injectionScopeNames) {
        this._rawGrammars.set(grammar.scopeName, grammar);
        if (injectionScopeNames) this._injectionGrammars.set(grammar.scopeName, injectionScopeNames);
    }
    /**
   * Lookup a raw grammar.
   */ lookup(scopeName) {
        return this._rawGrammars.get(scopeName);
    }
    /**
   * Returns the injections for the given grammar
   */ injections(targetScope) {
        return this._injectionGrammars.get(targetScope);
    }
    /**
   * Get the default theme settings
   */ getDefaults() {
        return this._theme.getDefaults();
    }
    /**
   * Match a scope in the theme.
   */ themeMatch(scopePath) {
        return this._theme.match(scopePath);
    }
    /**
   * Lookup a grammar.
   */ grammarForScopeName(scopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors) {
        if (!this._grammars.has(scopeName)) {
            let rawGrammar = this._rawGrammars.get(scopeName);
            if (!rawGrammar) return null;
            this._grammars.set(scopeName, $0fea3078b1feac63$var$createGrammar(scopeName, rawGrammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, this, this._onigLib));
        }
        return this._grammars.get(scopeName);
    }
};
// src/index.ts
var $0fea3078b1feac63$export$4d9facee29974f3 = class {
    _options;
    _syncRegistry;
    _ensureGrammarCache;
    constructor(options){
        this._options = options;
        this._syncRegistry = new $0fea3078b1feac63$var$SyncRegistry($0fea3078b1feac63$export$14faa19a0f3bbeb2.createFromRawTheme(options.theme, options.colorMap), options.onigLib);
        this._ensureGrammarCache = /* @__PURE__ */ new Map();
    }
    dispose() {
        this._syncRegistry.dispose();
    }
    /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */ setTheme(theme, colorMap) {
        this._syncRegistry.setTheme($0fea3078b1feac63$export$14faa19a0f3bbeb2.createFromRawTheme(theme, colorMap));
    }
    /**
   * Returns a lookup array for color ids.
   */ getColorMap() {
        return this._syncRegistry.getColorMap();
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */ loadGrammarWithEmbeddedLanguages(initialScopeName, initialLanguage, embeddedLanguages) {
        return this.loadGrammarWithConfiguration(initialScopeName, initialLanguage, {
            embeddedLanguages: embeddedLanguages
        });
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */ loadGrammarWithConfiguration(initialScopeName, initialLanguage, configuration) {
        return this._loadGrammar(initialScopeName, initialLanguage, configuration.embeddedLanguages, configuration.tokenTypes, new $0fea3078b1feac63$var$BalancedBracketSelectors(configuration.balancedBracketSelectors || [], configuration.unbalancedBracketSelectors || []));
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */ loadGrammar(initialScopeName) {
        return this._loadGrammar(initialScopeName, 0, null, null, null);
    }
    _loadGrammar(initialScopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors) {
        const dependencyProcessor = new $0fea3078b1feac63$var$ScopeDependencyProcessor(this._syncRegistry, initialScopeName);
        while(dependencyProcessor.Q.length > 0){
            dependencyProcessor.Q.map((request)=>this._loadSingleGrammar(request.scopeName));
            dependencyProcessor.processQueue();
        }
        return this._grammarForScopeName(initialScopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors);
    }
    _loadSingleGrammar(scopeName) {
        if (!this._ensureGrammarCache.has(scopeName)) {
            this._doLoadSingleGrammar(scopeName);
            this._ensureGrammarCache.set(scopeName, true);
        }
    }
    _doLoadSingleGrammar(scopeName) {
        const grammar = this._options.loadGrammar(scopeName);
        if (grammar) {
            const injections = typeof this._options.getInjections === "function" ? this._options.getInjections(scopeName) : void 0;
            this._syncRegistry.addGrammar(grammar, injections);
        }
    }
    /**
   * Adds a rawGrammar.
   */ addGrammar(rawGrammar, injections = [], initialLanguage = 0, embeddedLanguages = null) {
        this._syncRegistry.addGrammar(rawGrammar, injections);
        return this._grammarForScopeName(rawGrammar.scopeName, initialLanguage, embeddedLanguages);
    }
    /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */ _grammarForScopeName(scopeName, initialLanguage = 0, embeddedLanguages = null, tokenTypes = null, balancedBracketSelectors = null) {
        return this._syncRegistry.grammarForScopeName(scopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors);
    }
};
var $0fea3078b1feac63$export$17227441e89ee693 = $0fea3078b1feac63$var$StateStackImpl.NULL;



function $047e2e8c411a40db$export$2f5d8722891c6610(theme, options) {
    const replacements = typeof theme === "string" ? {} : {
        ...theme.colorReplacements
    };
    const themeName = typeof theme === "string" ? theme : theme.name;
    for (const [key, value] of Object.entries(options?.colorReplacements || {})){
        if (typeof value === "string") replacements[key] = value;
        else if (key === themeName) Object.assign(replacements, value);
    }
    return replacements;
}
function $047e2e8c411a40db$export$ef30c5cede3b6b4a(color, replacements) {
    if (!color) return color;
    return replacements?.[color?.toLowerCase()] || color;
}
function $047e2e8c411a40db$export$45b10814cc054894(x) {
    return Array.isArray(x) ? x : [
        x
    ];
}
async function $047e2e8c411a40db$export$4643bb4b0bbd3390(p) {
    return Promise.resolve(typeof p === "function" ? p() : p).then((r)=>r.default || r);
}
function $047e2e8c411a40db$export$f98db15a0683bb96(lang) {
    return !lang || [
        "plaintext",
        "txt",
        "text",
        "plain"
    ].includes(lang);
}
function $047e2e8c411a40db$export$5c3e2a1e13c5c906(lang) {
    return lang === "ansi" || $047e2e8c411a40db$export$f98db15a0683bb96(lang);
}
function $047e2e8c411a40db$export$3e6bc683d2a50c25(theme) {
    return theme === "none";
}
function $047e2e8c411a40db$export$cd4537af2d43769e(theme) {
    return $047e2e8c411a40db$export$3e6bc683d2a50c25(theme);
}
function $047e2e8c411a40db$export$12efa744f94fc0a9(node, className) {
    if (!className) return node;
    node.properties ||= {};
    node.properties.class ||= [];
    if (typeof node.properties.class === "string") node.properties.class = node.properties.class.split(/\s+/g);
    if (!Array.isArray(node.properties.class)) node.properties.class = [];
    const targets = Array.isArray(className) ? className : className.split(/\s+/g);
    for (const c of targets)if (c && !node.properties.class.includes(c)) node.properties.class.push(c);
    return node;
}
function $047e2e8c411a40db$export$88c07fe39db9eaa1(code, preserveEnding = false) {
    if (code.length === 0) return [
        [
            "",
            0
        ]
    ];
    const parts = code.split(/(\r?\n)/g);
    let index = 0;
    const lines = [];
    for(let i = 0; i < parts.length; i += 2){
        const line = preserveEnding ? parts[i] + (parts[i + 1] || "") : parts[i];
        lines.push([
            line,
            index
        ]);
        index += parts[i].length;
        index += parts[i + 1]?.length || 0;
    }
    return lines;
}
function $047e2e8c411a40db$export$a1eb53fafbd3302c(code) {
    const lines = $047e2e8c411a40db$export$88c07fe39db9eaa1(code, true).map(([line])=>line);
    function indexToPos(index) {
        if (index === code.length) return {
            line: lines.length - 1,
            character: lines[lines.length - 1].length
        };
        let character = index;
        let line = 0;
        for (const lineText of lines){
            if (character < lineText.length) break;
            character -= lineText.length;
            line++;
        }
        return {
            line: line,
            character: character
        };
    }
    function posToIndex(line, character) {
        let index = 0;
        for(let i = 0; i < line; i++)index += lines[i].length;
        index += character;
        return index;
    }
    return {
        lines: lines,
        indexToPos: indexToPos,
        posToIndex: posToIndex
    };
}
function $047e2e8c411a40db$export$5f773a1df8c6e1aa(code, _lang, highlighter) {
    const langs = /* @__PURE__ */ new Set();
    for (const match of code.matchAll(/:?lang=["']([^"']+)["']/g)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll(/(?:```|~~~)([\w-]+)/g)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll(/\\begin\{([\w-]+)\}/g)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll(/<script\s+(?:type|lang)=["']([^"']+)["']/gi)){
        const fullType = match[1].toLowerCase().trim();
        const lang = fullType.includes("/") ? fullType.split("/").pop() : fullType;
        if (lang) langs.add(lang);
    }
    if (!highlighter) return Array.from(langs);
    const bundle = highlighter.getBundledLanguages();
    return Array.from(langs).filter((l)=>l && bundle[l]);
}
const $047e2e8c411a40db$var$DEFAULT_COLOR_LIGHT_DARK = "light-dark()";
const $047e2e8c411a40db$var$COLOR_KEYS = [
    "color",
    "background-color"
];
function $047e2e8c411a40db$export$b3cd5664f2c9e388(token, offsets) {
    let lastOffset = 0;
    const tokens = [];
    for (const offset of offsets){
        if (offset > lastOffset) tokens.push({
            ...token,
            content: token.content.slice(lastOffset, offset),
            offset: token.offset + lastOffset
        });
        lastOffset = offset;
    }
    if (lastOffset < token.content.length) tokens.push({
        ...token,
        content: token.content.slice(lastOffset),
        offset: token.offset + lastOffset
    });
    return tokens;
}
function $047e2e8c411a40db$export$d3e0fdeef870cacb(tokens, breakpoints) {
    const sorted = Array.from(breakpoints instanceof Set ? breakpoints : new Set(breakpoints)).sort((a, b)=>a - b);
    if (!sorted.length) return tokens;
    return tokens.map((line)=>{
        return line.flatMap((token)=>{
            const breakpointsInToken = sorted.filter((i)=>token.offset < i && i < token.offset + token.content.length).map((i)=>i - token.offset).sort((a, b)=>a - b);
            if (!breakpointsInToken.length) return token;
            return $047e2e8c411a40db$export$b3cd5664f2c9e388(token, breakpointsInToken);
        });
    });
}
function $047e2e8c411a40db$export$5a4c68029315ecd7(merged, variantsOrder, cssVariablePrefix, defaultColor, colorsRendering = "css-vars") {
    const token = {
        content: merged.content,
        explanation: merged.explanation,
        offset: merged.offset
    };
    const styles = variantsOrder.map((t)=>$047e2e8c411a40db$export$94ffab218337d127(merged.variants[t]));
    const styleKeys = new Set(styles.flatMap((t)=>Object.keys(t)));
    const mergedStyles = {};
    const varKey = (idx, key)=>{
        const keyName = key === "color" ? "" : key === "background-color" ? "-bg" : `-${key}`;
        return cssVariablePrefix + variantsOrder[idx] + (key === "color" ? "" : keyName);
    };
    styles.forEach((cur, idx)=>{
        for (const key of styleKeys){
            const value = cur[key] || "inherit";
            if (idx === 0 && defaultColor && $047e2e8c411a40db$var$COLOR_KEYS.includes(key)) {
                if (defaultColor === $047e2e8c411a40db$var$DEFAULT_COLOR_LIGHT_DARK && styles.length > 1) {
                    const lightIndex = variantsOrder.findIndex((t)=>t === "light");
                    const darkIndex = variantsOrder.findIndex((t)=>t === "dark");
                    if (lightIndex === -1 || darkIndex === -1) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)('When using `defaultColor: "light-dark()"`, you must provide both `light` and `dark` themes');
                    const lightValue = styles[lightIndex][key] || "inherit";
                    const darkValue = styles[darkIndex][key] || "inherit";
                    mergedStyles[key] = `light-dark(${lightValue}, ${darkValue})`;
                    if (colorsRendering === "css-vars") mergedStyles[varKey(idx, key)] = value;
                } else mergedStyles[key] = value;
            } else if (colorsRendering === "css-vars") mergedStyles[varKey(idx, key)] = value;
        }
    });
    token.htmlStyle = mergedStyles;
    return token;
}
function $047e2e8c411a40db$export$94ffab218337d127(token) {
    const styles = {};
    if (token.color) styles.color = token.color;
    if (token.bgColor) styles["background-color"] = token.bgColor;
    if (token.fontStyle) {
        if (token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Italic) styles["font-style"] = "italic";
        if (token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Bold) styles["font-weight"] = "bold";
        const decorations = [];
        if (token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Underline) decorations.push("underline");
        if (token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Strikethrough) decorations.push("line-through");
        if (decorations.length) styles["text-decoration"] = decorations.join(" ");
    }
    return styles;
}
function $047e2e8c411a40db$export$10559b52119e8d5f(token) {
    if (typeof token === "string") return token;
    return Object.entries(token).map(([key, value])=>`${key}:${value}`).join(";");
}
const $047e2e8c411a40db$var$_grammarStateMap = /* @__PURE__ */ new WeakMap();
function $047e2e8c411a40db$var$setLastGrammarStateToMap(keys, state) {
    $047e2e8c411a40db$var$_grammarStateMap.set(keys, state);
}
function $047e2e8c411a40db$var$getLastGrammarStateFromMap(keys) {
    return $047e2e8c411a40db$var$_grammarStateMap.get(keys);
}
class $047e2e8c411a40db$var$GrammarState {
    /**
   * Theme to Stack mapping
   */ _stacks = {};
    lang;
    get themes() {
        return Object.keys(this._stacks);
    }
    get theme() {
        return this.themes[0];
    }
    get _stack() {
        return this._stacks[this.theme];
    }
    /**
   * Static method to create a initial grammar state.
   */ static initial(lang, themes) {
        return new $047e2e8c411a40db$var$GrammarState(Object.fromEntries($047e2e8c411a40db$export$45b10814cc054894(themes).map((theme)=>[
                theme,
                (0, $0fea3078b1feac63$export$17227441e89ee693)
            ])), lang);
    }
    constructor(...args){
        if (args.length === 2) {
            const [stacksMap, lang] = args;
            this.lang = lang;
            this._stacks = stacksMap;
        } else {
            const [stack, lang, theme] = args;
            this.lang = lang;
            this._stacks = {
                [theme]: stack
            };
        }
    }
    /**
   * Get the internal stack object.
   * @internal
   */ getInternalStack(theme = this.theme) {
        return this._stacks[theme];
    }
    getScopes(theme = this.theme) {
        return $047e2e8c411a40db$var$getScopes(this._stacks[theme]);
    }
    toJSON() {
        return {
            lang: this.lang,
            theme: this.theme,
            themes: this.themes,
            scopes: this.getScopes()
        };
    }
}
function $047e2e8c411a40db$var$getScopes(stack) {
    const scopes = [];
    const visited = /* @__PURE__ */ new Set();
    function pushScope(stack2) {
        if (visited.has(stack2)) return;
        visited.add(stack2);
        const name = stack2?.nameScopesList?.scopeName;
        if (name) scopes.push(name);
        if (stack2.parent) pushScope(stack2.parent);
    }
    pushScope(stack);
    return scopes;
}
function $047e2e8c411a40db$var$getGrammarStack(state, theme) {
    if (!(state instanceof $047e2e8c411a40db$var$GrammarState)) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)("Invalid grammar state");
    return state.getInternalStack(theme);
}
function $047e2e8c411a40db$export$b094ad6c92e029a8() {
    const map = /* @__PURE__ */ new WeakMap();
    function getContext(shiki) {
        if (!map.has(shiki.meta)) {
            let normalizePosition = function(p) {
                if (typeof p === "number") {
                    if (p < 0 || p > shiki.source.length) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Invalid decoration offset: ${p}. Code length: ${shiki.source.length}`);
                    return {
                        ...converter.indexToPos(p),
                        offset: p
                    };
                } else {
                    const line = converter.lines[p.line];
                    if (line === void 0) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Invalid decoration position ${JSON.stringify(p)}. Lines length: ${converter.lines.length}`);
                    let character = p.character;
                    if (character < 0) character = line.length + character;
                    if (character < 0 || character > line.length) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Invalid decoration position ${JSON.stringify(p)}. Line ${p.line} length: ${line.length}`);
                    return {
                        ...p,
                        character: character,
                        offset: converter.posToIndex(p.line, character)
                    };
                }
            };
            const converter = $047e2e8c411a40db$export$a1eb53fafbd3302c(shiki.source);
            const decorations = (shiki.options.decorations || []).map((d)=>({
                    ...d,
                    start: normalizePosition(d.start),
                    end: normalizePosition(d.end)
                }));
            $047e2e8c411a40db$var$verifyIntersections(decorations);
            map.set(shiki.meta, {
                decorations: decorations,
                converter: converter,
                source: shiki.source
            });
        }
        return map.get(shiki.meta);
    }
    return {
        name: "shiki:decorations",
        tokens (tokens) {
            if (!this.options.decorations?.length) return;
            const ctx = getContext(this);
            const breakpoints = ctx.decorations.flatMap((d)=>[
                    d.start.offset,
                    d.end.offset
                ]);
            const splitted = $047e2e8c411a40db$export$d3e0fdeef870cacb(tokens, breakpoints);
            return splitted;
        },
        code (codeEl) {
            if (!this.options.decorations?.length) return;
            const ctx = getContext(this);
            const lines = Array.from(codeEl.children).filter((i)=>i.type === "element" && i.tagName === "span");
            if (lines.length !== ctx.converter.lines.length) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Number of lines in code element (${lines.length}) does not match the number of lines in the source (${ctx.converter.lines.length}). Failed to apply decorations.`);
            function applyLineSection(line, start, end, decoration) {
                const lineEl = lines[line];
                let text = "";
                let startIndex = -1;
                let endIndex = -1;
                if (start === 0) startIndex = 0;
                if (end === 0) endIndex = 0;
                if (end === Number.POSITIVE_INFINITY) endIndex = lineEl.children.length;
                if (startIndex === -1 || endIndex === -1) for(let i = 0; i < lineEl.children.length; i++){
                    text += $047e2e8c411a40db$var$stringify(lineEl.children[i]);
                    if (startIndex === -1 && text.length === start) startIndex = i + 1;
                    if (endIndex === -1 && text.length === end) endIndex = i + 1;
                }
                if (startIndex === -1) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Failed to find start index for decoration ${JSON.stringify(decoration.start)}`);
                if (endIndex === -1) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Failed to find end index for decoration ${JSON.stringify(decoration.end)}`);
                const children = lineEl.children.slice(startIndex, endIndex);
                if (!decoration.alwaysWrap && children.length === lineEl.children.length) applyDecoration(lineEl, decoration, "line");
                else if (!decoration.alwaysWrap && children.length === 1 && children[0].type === "element") applyDecoration(children[0], decoration, "token");
                else {
                    const wrapper = {
                        type: "element",
                        tagName: "span",
                        properties: {},
                        children: children
                    };
                    applyDecoration(wrapper, decoration, "wrapper");
                    lineEl.children.splice(startIndex, children.length, wrapper);
                }
            }
            function applyLine(line, decoration) {
                lines[line] = applyDecoration(lines[line], decoration, "line");
            }
            function applyDecoration(el, decoration, type) {
                const properties = decoration.properties || {};
                const transform = decoration.transform || ((i)=>i);
                el.tagName = decoration.tagName || "span";
                el.properties = {
                    ...el.properties,
                    ...properties,
                    class: el.properties.class
                };
                if (decoration.properties?.class) $047e2e8c411a40db$export$12efa744f94fc0a9(el, decoration.properties.class);
                el = transform(el, type) || el;
                return el;
            }
            const lineApplies = [];
            const sorted = ctx.decorations.sort((a, b)=>b.start.offset - a.start.offset || a.end.offset - b.end.offset);
            for (const decoration of sorted){
                const { start: start, end: end } = decoration;
                if (start.line === end.line) applyLineSection(start.line, start.character, end.character, decoration);
                else if (start.line < end.line) {
                    applyLineSection(start.line, start.character, Number.POSITIVE_INFINITY, decoration);
                    for(let i = start.line + 1; i < end.line; i++)lineApplies.unshift(()=>applyLine(i, decoration));
                    applyLineSection(end.line, 0, end.character, decoration);
                }
            }
            lineApplies.forEach((i)=>i());
        }
    };
}
function $047e2e8c411a40db$var$verifyIntersections(items) {
    for(let i = 0; i < items.length; i++){
        const foo = items[i];
        if (foo.start.offset > foo.end.offset) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Invalid decoration range: ${JSON.stringify(foo.start)} - ${JSON.stringify(foo.end)}`);
        for(let j = i + 1; j < items.length; j++){
            const bar = items[j];
            const isFooHasBarStart = foo.start.offset <= bar.start.offset && bar.start.offset < foo.end.offset;
            const isFooHasBarEnd = foo.start.offset < bar.end.offset && bar.end.offset <= foo.end.offset;
            const isBarHasFooStart = bar.start.offset <= foo.start.offset && foo.start.offset < bar.end.offset;
            const isBarHasFooEnd = bar.start.offset < foo.end.offset && foo.end.offset <= bar.end.offset;
            if (isFooHasBarStart || isFooHasBarEnd || isBarHasFooStart || isBarHasFooEnd) {
                if (isFooHasBarStart && isFooHasBarEnd) continue;
                if (isBarHasFooStart && isBarHasFooEnd) continue;
                if (isBarHasFooStart && foo.start.offset === foo.end.offset) continue;
                if (isFooHasBarEnd && bar.start.offset === bar.end.offset) continue;
                throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Decorations ${JSON.stringify(foo.start)} and ${JSON.stringify(bar.start)} intersect.`);
            }
        }
    }
}
function $047e2e8c411a40db$var$stringify(el) {
    if (el.type === "text") return el.value;
    if (el.type === "element") return el.children.map($047e2e8c411a40db$var$stringify).join("");
    return "";
}
const $047e2e8c411a40db$var$builtInTransformers = [
    /* @__PURE__ */ $047e2e8c411a40db$export$b094ad6c92e029a8()
];
function $047e2e8c411a40db$var$getTransformers(options) {
    const transformers = $047e2e8c411a40db$var$sortTransformersByEnforcement(options.transformers || []);
    return [
        ...transformers.pre,
        ...transformers.normal,
        ...transformers.post,
        ...$047e2e8c411a40db$var$builtInTransformers
    ];
}
function $047e2e8c411a40db$var$sortTransformersByEnforcement(transformers) {
    const pre = [];
    const post = [];
    const normal = [];
    for (const transformer of transformers)switch(transformer.enforce){
        case "pre":
            pre.push(transformer);
            break;
        case "post":
            post.push(transformer);
            break;
        default:
            normal.push(transformer);
    }
    return {
        pre: pre,
        post: post,
        normal: normal
    };
}
// src/colors.ts
var $047e2e8c411a40db$var$namedColors = [
    "black",
    "red",
    "green",
    "yellow",
    "blue",
    "magenta",
    "cyan",
    "white",
    "brightBlack",
    "brightRed",
    "brightGreen",
    "brightYellow",
    "brightBlue",
    "brightMagenta",
    "brightCyan",
    "brightWhite"
];
// src/decorations.ts
var $047e2e8c411a40db$var$decorations = {
    1: "bold",
    2: "dim",
    3: "italic",
    4: "underline",
    7: "reverse",
    8: "hidden",
    9: "strikethrough"
};
// src/parser.ts
function $047e2e8c411a40db$var$findSequence(value, position) {
    const nextEscape = value.indexOf("\x1B", position);
    if (nextEscape !== -1) {
        if (value[nextEscape + 1] === "[") {
            const nextClose = value.indexOf("m", nextEscape);
            if (nextClose !== -1) return {
                sequence: value.substring(nextEscape + 2, nextClose).split(";"),
                startPosition: nextEscape,
                position: nextClose + 1
            };
        }
    }
    return {
        position: value.length
    };
}
function $047e2e8c411a40db$var$parseColor(sequence) {
    const colorMode = sequence.shift();
    if (colorMode === "2") {
        const rgb = sequence.splice(0, 3).map((x)=>Number.parseInt(x));
        if (rgb.length !== 3 || rgb.some((x)=>Number.isNaN(x))) return;
        return {
            type: "rgb",
            rgb: rgb
        };
    } else if (colorMode === "5") {
        const index = sequence.shift();
        if (index) return {
            type: "table",
            index: Number(index)
        };
    }
}
function $047e2e8c411a40db$var$parseSequence(sequence) {
    const commands = [];
    while(sequence.length > 0){
        const code = sequence.shift();
        if (!code) continue;
        const codeInt = Number.parseInt(code);
        if (Number.isNaN(codeInt)) continue;
        if (codeInt === 0) commands.push({
            type: "resetAll"
        });
        else if (codeInt <= 9) {
            const decoration = $047e2e8c411a40db$var$decorations[codeInt];
            if (decoration) commands.push({
                type: "setDecoration",
                value: $047e2e8c411a40db$var$decorations[codeInt]
            });
        } else if (codeInt <= 29) {
            const decoration = $047e2e8c411a40db$var$decorations[codeInt - 20];
            if (decoration) {
                commands.push({
                    type: "resetDecoration",
                    value: decoration
                });
                if (decoration === "dim") commands.push({
                    type: "resetDecoration",
                    value: "bold"
                });
            }
        } else if (codeInt <= 37) commands.push({
            type: "setForegroundColor",
            value: {
                type: "named",
                name: $047e2e8c411a40db$var$namedColors[codeInt - 30]
            }
        });
        else if (codeInt === 38) {
            const color = $047e2e8c411a40db$var$parseColor(sequence);
            if (color) commands.push({
                type: "setForegroundColor",
                value: color
            });
        } else if (codeInt === 39) commands.push({
            type: "resetForegroundColor"
        });
        else if (codeInt <= 47) commands.push({
            type: "setBackgroundColor",
            value: {
                type: "named",
                name: $047e2e8c411a40db$var$namedColors[codeInt - 40]
            }
        });
        else if (codeInt === 48) {
            const color = $047e2e8c411a40db$var$parseColor(sequence);
            if (color) commands.push({
                type: "setBackgroundColor",
                value: color
            });
        } else if (codeInt === 49) commands.push({
            type: "resetBackgroundColor"
        });
        else if (codeInt === 53) commands.push({
            type: "setDecoration",
            value: "overline"
        });
        else if (codeInt === 55) commands.push({
            type: "resetDecoration",
            value: "overline"
        });
        else if (codeInt >= 90 && codeInt <= 97) commands.push({
            type: "setForegroundColor",
            value: {
                type: "named",
                name: $047e2e8c411a40db$var$namedColors[codeInt - 90 + 8]
            }
        });
        else if (codeInt >= 100 && codeInt <= 107) commands.push({
            type: "setBackgroundColor",
            value: {
                type: "named",
                name: $047e2e8c411a40db$var$namedColors[codeInt - 100 + 8]
            }
        });
    }
    return commands;
}
function $047e2e8c411a40db$var$createAnsiSequenceParser() {
    let foreground = null;
    let background = null;
    let decorations2 = /* @__PURE__ */ new Set();
    return {
        parse (value) {
            const tokens = [];
            let position = 0;
            do {
                const findResult = $047e2e8c411a40db$var$findSequence(value, position);
                const text = findResult.sequence ? value.substring(position, findResult.startPosition) : value.substring(position);
                if (text.length > 0) tokens.push({
                    value: text,
                    foreground: foreground,
                    background: background,
                    decorations: new Set(decorations2)
                });
                if (findResult.sequence) {
                    const commands = $047e2e8c411a40db$var$parseSequence(findResult.sequence);
                    for (const styleToken of commands){
                        if (styleToken.type === "resetAll") {
                            foreground = null;
                            background = null;
                            decorations2.clear();
                        } else if (styleToken.type === "resetForegroundColor") foreground = null;
                        else if (styleToken.type === "resetBackgroundColor") background = null;
                        else if (styleToken.type === "resetDecoration") decorations2.delete(styleToken.value);
                    }
                    for (const styleToken of commands){
                        if (styleToken.type === "setForegroundColor") foreground = styleToken.value;
                        else if (styleToken.type === "setBackgroundColor") background = styleToken.value;
                        else if (styleToken.type === "setDecoration") decorations2.add(styleToken.value);
                    }
                }
                position = findResult.position;
            }while (position < value.length);
            return tokens;
        }
    };
}
// src/palette.ts
var $047e2e8c411a40db$var$defaultNamedColorsMap = {
    black: "#000000",
    red: "#bb0000",
    green: "#00bb00",
    yellow: "#bbbb00",
    blue: "#0000bb",
    magenta: "#ff00ff",
    cyan: "#00bbbb",
    white: "#eeeeee",
    brightBlack: "#555555",
    brightRed: "#ff5555",
    brightGreen: "#00ff00",
    brightYellow: "#ffff55",
    brightBlue: "#5555ff",
    brightMagenta: "#ff55ff",
    brightCyan: "#55ffff",
    brightWhite: "#ffffff"
};
function $047e2e8c411a40db$var$createColorPalette(namedColorsMap = $047e2e8c411a40db$var$defaultNamedColorsMap) {
    function namedColor(name) {
        return namedColorsMap[name];
    }
    function rgbColor(rgb) {
        return `#${rgb.map((x)=>Math.max(0, Math.min(x, 255)).toString(16).padStart(2, "0")).join("")}`;
    }
    let colorTable;
    function getColorTable() {
        if (colorTable) return colorTable;
        colorTable = [];
        for(let i = 0; i < $047e2e8c411a40db$var$namedColors.length; i++)colorTable.push(namedColor($047e2e8c411a40db$var$namedColors[i]));
        let levels = [
            0,
            95,
            135,
            175,
            215,
            255
        ];
        for(let r = 0; r < 6; r++){
            for(let g = 0; g < 6; g++)for(let b = 0; b < 6; b++)colorTable.push(rgbColor([
                levels[r],
                levels[g],
                levels[b]
            ]));
        }
        let level = 8;
        for(let i = 0; i < 24; i++, level += 10)colorTable.push(rgbColor([
            level,
            level,
            level
        ]));
        return colorTable;
    }
    function tableColor(index) {
        return getColorTable()[index];
    }
    function value(color) {
        switch(color.type){
            case "named":
                return namedColor(color.name);
            case "rgb":
                return rgbColor(color.rgb);
            case "table":
                return tableColor(color.index);
        }
    }
    return {
        value: value
    };
}
const $047e2e8c411a40db$var$defaultAnsiColors = {
    black: "#000000",
    red: "#cd3131",
    green: "#0DBC79",
    yellow: "#E5E510",
    blue: "#2472C8",
    magenta: "#BC3FBC",
    cyan: "#11A8CD",
    white: "#E5E5E5",
    brightBlack: "#666666",
    brightRed: "#F14C4C",
    brightGreen: "#23D18B",
    brightYellow: "#F5F543",
    brightBlue: "#3B8EEA",
    brightMagenta: "#D670D6",
    brightCyan: "#29B8DB",
    brightWhite: "#FFFFFF"
};
function $047e2e8c411a40db$export$1e0554f7c12b87ed(theme, fileContents, options) {
    const colorReplacements = $047e2e8c411a40db$export$2f5d8722891c6610(theme, options);
    const lines = $047e2e8c411a40db$export$88c07fe39db9eaa1(fileContents);
    const ansiPalette = Object.fromEntries($047e2e8c411a40db$var$namedColors.map((name)=>{
        const key = `terminal.ansi${name[0].toUpperCase()}${name.substring(1)}`;
        const themeColor = theme.colors?.[key];
        return [
            name,
            themeColor || $047e2e8c411a40db$var$defaultAnsiColors[name]
        ];
    }));
    const colorPalette = $047e2e8c411a40db$var$createColorPalette(ansiPalette);
    const parser = $047e2e8c411a40db$var$createAnsiSequenceParser();
    return lines.map((line)=>parser.parse(line[0]).map((token)=>{
            let color;
            let bgColor;
            if (token.decorations.has("reverse")) {
                color = token.background ? colorPalette.value(token.background) : theme.bg;
                bgColor = token.foreground ? colorPalette.value(token.foreground) : theme.fg;
            } else {
                color = token.foreground ? colorPalette.value(token.foreground) : theme.fg;
                bgColor = token.background ? colorPalette.value(token.background) : void 0;
            }
            color = $047e2e8c411a40db$export$ef30c5cede3b6b4a(color, colorReplacements);
            bgColor = $047e2e8c411a40db$export$ef30c5cede3b6b4a(bgColor, colorReplacements);
            if (token.decorations.has("dim")) color = $047e2e8c411a40db$var$dimColor(color);
            let fontStyle = (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).None;
            if (token.decorations.has("bold")) fontStyle |= (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Bold;
            if (token.decorations.has("italic")) fontStyle |= (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Italic;
            if (token.decorations.has("underline")) fontStyle |= (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Underline;
            if (token.decorations.has("strikethrough")) fontStyle |= (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Strikethrough;
            return {
                content: token.value,
                offset: line[1],
                color: // TODO: more accurate offset? might need to fork ansi-sequence-parser
                color,
                bgColor: bgColor,
                fontStyle: fontStyle
            };
        }));
}
function $047e2e8c411a40db$var$dimColor(color) {
    const hexMatch = color.match(/#([0-9a-f]{3,8})/i);
    if (hexMatch) {
        const hex = hexMatch[1];
        if (hex.length === 8) {
            const alpha = Math.round(Number.parseInt(hex.slice(6, 8), 16) / 2).toString(16).padStart(2, "0");
            return `#${hex.slice(0, 6)}${alpha}`;
        } else if (hex.length === 6) return `#${hex}80`;
        else if (hex.length === 4) {
            const r = hex[0];
            const g = hex[1];
            const b = hex[2];
            const a = hex[3];
            const alpha = Math.round(Number.parseInt(`${a}${a}`, 16) / 2).toString(16).padStart(2, "0");
            return `#${r}${r}${g}${g}${b}${b}${alpha}`;
        } else if (hex.length === 3) {
            const r = hex[0];
            const g = hex[1];
            const b = hex[2];
            return `#${r}${r}${g}${g}${b}${b}80`;
        }
    }
    const cssVarMatch = color.match(/var\((--[\w-]+-ansi-[\w-]+)\)/);
    if (cssVarMatch) return `var(${cssVarMatch[1]}-dim)`;
    return color;
}
function $047e2e8c411a40db$export$9fcc555cdbb165d8(internal, code, options = {}) {
    const { theme: themeName = internal.getLoadedThemes()[0] } = options;
    const lang = internal.resolveLangAlias(options.lang || "text");
    if ($047e2e8c411a40db$export$f98db15a0683bb96(lang) || $047e2e8c411a40db$export$3e6bc683d2a50c25(themeName)) return $047e2e8c411a40db$export$88c07fe39db9eaa1(code).map((line)=>[
            {
                content: line[0],
                offset: line[1]
            }
        ]);
    const { theme: theme, colorMap: colorMap } = internal.setTheme(themeName);
    if (lang === "ansi") return $047e2e8c411a40db$export$1e0554f7c12b87ed(theme, code, options);
    const _grammar = internal.getLanguage(options.lang || "text");
    if (options.grammarState) {
        if (options.grammarState.lang !== _grammar.name) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Grammar state language "${options.grammarState.lang}" does not match highlight language "${_grammar.name}"`);
        if (!options.grammarState.themes.includes(theme.name)) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Grammar state themes "${options.grammarState.themes}" do not contain highlight theme "${theme.name}"`);
    }
    return $047e2e8c411a40db$export$54c7d59470f3dc59(code, _grammar, theme, colorMap, options);
}
function $047e2e8c411a40db$var$getLastGrammarState(...args) {
    if (args.length === 2) return $047e2e8c411a40db$var$getLastGrammarStateFromMap(args[1]);
    const [internal, code, options = {}] = args;
    const { lang: lang = "text", theme: themeName = internal.getLoadedThemes()[0] } = options;
    if ($047e2e8c411a40db$export$f98db15a0683bb96(lang) || $047e2e8c411a40db$export$3e6bc683d2a50c25(themeName)) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)("Plain language does not have grammar state");
    if (lang === "ansi") throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)("ANSI language does not have grammar state");
    const { theme: theme, colorMap: colorMap } = internal.setTheme(themeName);
    const _grammar = internal.getLanguage(lang);
    return new $047e2e8c411a40db$var$GrammarState($047e2e8c411a40db$var$_tokenizeWithTheme(code, _grammar, theme, colorMap, options).stateStack, _grammar.name, theme.name);
}
function $047e2e8c411a40db$export$54c7d59470f3dc59(code, grammar, theme, colorMap, options) {
    const result = $047e2e8c411a40db$var$_tokenizeWithTheme(code, grammar, theme, colorMap, options);
    const grammarState = new $047e2e8c411a40db$var$GrammarState(result.stateStack, grammar.name, theme.name);
    $047e2e8c411a40db$var$setLastGrammarStateToMap(result.tokens, grammarState);
    return result.tokens;
}
function $047e2e8c411a40db$var$_tokenizeWithTheme(code, grammar, theme, colorMap, options) {
    const colorReplacements = $047e2e8c411a40db$export$2f5d8722891c6610(theme, options);
    const { tokenizeMaxLineLength: tokenizeMaxLineLength = 0, tokenizeTimeLimit: tokenizeTimeLimit = 500 } = options;
    const lines = $047e2e8c411a40db$export$88c07fe39db9eaa1(code);
    let stateStack = options.grammarState ? $047e2e8c411a40db$var$getGrammarStack(options.grammarState, theme.name) ?? (0, $0fea3078b1feac63$export$17227441e89ee693) : options.grammarContextCode != null ? $047e2e8c411a40db$var$_tokenizeWithTheme(options.grammarContextCode, grammar, theme, colorMap, {
        ...options,
        grammarState: void 0,
        grammarContextCode: void 0
    }).stateStack : (0, $0fea3078b1feac63$export$17227441e89ee693);
    let actual = [];
    const final = [];
    for(let i = 0, len = lines.length; i < len; i++){
        const [line, lineOffset] = lines[i];
        if (line === "") {
            actual = [];
            final.push([]);
            continue;
        }
        if (tokenizeMaxLineLength > 0 && line.length >= tokenizeMaxLineLength) {
            actual = [];
            final.push([
                {
                    content: line,
                    offset: lineOffset,
                    color: "",
                    fontStyle: 0
                }
            ]);
            continue;
        }
        let resultWithScopes;
        let tokensWithScopes;
        let tokensWithScopesIndex;
        if (options.includeExplanation) {
            resultWithScopes = grammar.tokenizeLine(line, stateStack, tokenizeTimeLimit);
            tokensWithScopes = resultWithScopes.tokens;
            tokensWithScopesIndex = 0;
        }
        const result = grammar.tokenizeLine2(line, stateStack, tokenizeTimeLimit);
        const tokensLength = result.tokens.length / 2;
        for(let j = 0; j < tokensLength; j++){
            const startIndex = result.tokens[2 * j];
            const nextStartIndex = j + 1 < tokensLength ? result.tokens[2 * j + 2] : line.length;
            if (startIndex === nextStartIndex) continue;
            const metadata = result.tokens[2 * j + 1];
            const color = $047e2e8c411a40db$export$ef30c5cede3b6b4a(colorMap[(0, $0fea3078b1feac63$export$90e5db14803ea047).getForeground(metadata)], colorReplacements);
            const fontStyle = (0, $0fea3078b1feac63$export$90e5db14803ea047).getFontStyle(metadata);
            const token = {
                content: line.substring(startIndex, nextStartIndex),
                offset: lineOffset + startIndex,
                color: color,
                fontStyle: fontStyle
            };
            if (options.includeExplanation) {
                const themeSettingsSelectors = [];
                if (options.includeExplanation !== "scopeName") for (const setting of theme.settings){
                    let selectors;
                    switch(typeof setting.scope){
                        case "string":
                            selectors = setting.scope.split(/,/).map((scope)=>scope.trim());
                            break;
                        case "object":
                            selectors = setting.scope;
                            break;
                        default:
                            continue;
                    }
                    themeSettingsSelectors.push({
                        settings: setting,
                        selectors: selectors.map((selector)=>selector.split(/ /))
                    });
                }
                token.explanation = [];
                let offset = 0;
                while(startIndex + offset < nextStartIndex){
                    const tokenWithScopes = tokensWithScopes[tokensWithScopesIndex];
                    const tokenWithScopesText = line.substring(tokenWithScopes.startIndex, tokenWithScopes.endIndex);
                    offset += tokenWithScopesText.length;
                    token.explanation.push({
                        content: tokenWithScopesText,
                        scopes: options.includeExplanation === "scopeName" ? $047e2e8c411a40db$var$explainThemeScopesNameOnly(tokenWithScopes.scopes) : $047e2e8c411a40db$var$explainThemeScopesFull(themeSettingsSelectors, tokenWithScopes.scopes)
                    });
                    tokensWithScopesIndex += 1;
                }
            }
            actual.push(token);
        }
        final.push(actual);
        actual = [];
        stateStack = result.ruleStack;
    }
    return {
        tokens: final,
        stateStack: stateStack
    };
}
function $047e2e8c411a40db$var$explainThemeScopesNameOnly(scopes) {
    return scopes.map((scope)=>({
            scopeName: scope
        }));
}
function $047e2e8c411a40db$var$explainThemeScopesFull(themeSelectors, scopes) {
    const result = [];
    for(let i = 0, len = scopes.length; i < len; i++){
        const scope = scopes[i];
        result[i] = {
            scopeName: scope,
            themeMatches: $047e2e8c411a40db$var$explainThemeScope(themeSelectors, scope, scopes.slice(0, i))
        };
    }
    return result;
}
function $047e2e8c411a40db$var$matchesOne(selector, scope) {
    return selector === scope || scope.substring(0, selector.length) === selector && scope[selector.length] === ".";
}
function $047e2e8c411a40db$var$matches(selectors, scope, parentScopes) {
    if (!$047e2e8c411a40db$var$matchesOne(selectors[selectors.length - 1], scope)) return false;
    let selectorParentIndex = selectors.length - 2;
    let parentIndex = parentScopes.length - 1;
    while(selectorParentIndex >= 0 && parentIndex >= 0){
        if ($047e2e8c411a40db$var$matchesOne(selectors[selectorParentIndex], parentScopes[parentIndex])) selectorParentIndex -= 1;
        parentIndex -= 1;
    }
    if (selectorParentIndex === -1) return true;
    return false;
}
function $047e2e8c411a40db$var$explainThemeScope(themeSettingsSelectors, scope, parentScopes) {
    const result = [];
    for (const { selectors: selectors, settings: settings } of themeSettingsSelectors){
        for (const selectorPieces of selectors)if ($047e2e8c411a40db$var$matches(selectorPieces, scope, parentScopes)) {
            result.push(settings);
            break;
        }
    }
    return result;
}
function $047e2e8c411a40db$export$99552db3190ba9d3(internal, code, options) {
    const themes = Object.entries(options.themes).filter((i)=>i[1]).map((i)=>({
            color: i[0],
            theme: i[1]
        }));
    const themedTokens = themes.map((t)=>{
        const tokens2 = $047e2e8c411a40db$export$9fcc555cdbb165d8(internal, code, {
            ...options,
            theme: t.theme
        });
        const state = $047e2e8c411a40db$var$getLastGrammarStateFromMap(tokens2);
        const theme = typeof t.theme === "string" ? t.theme : t.theme.name;
        return {
            tokens: tokens2,
            state: state,
            theme: theme
        };
    });
    const tokens = $047e2e8c411a40db$var$syncThemesTokenization(...themedTokens.map((i)=>i.tokens));
    const mergedTokens = tokens[0].map((line, lineIdx)=>line.map((_token, tokenIdx)=>{
            const mergedToken = {
                content: _token.content,
                variants: {},
                offset: _token.offset
            };
            if ("includeExplanation" in options && options.includeExplanation) mergedToken.explanation = _token.explanation;
            tokens.forEach((t, themeIdx)=>{
                const { content: _, explanation: __, offset: ___, ...styles } = t[lineIdx][tokenIdx];
                mergedToken.variants[themes[themeIdx].color] = styles;
            });
            return mergedToken;
        }));
    const mergedGrammarState = themedTokens[0].state ? new $047e2e8c411a40db$var$GrammarState(Object.fromEntries(themedTokens.map((s)=>[
            s.theme,
            s.state?.getInternalStack(s.theme)
        ])), themedTokens[0].state.lang) : void 0;
    if (mergedGrammarState) $047e2e8c411a40db$var$setLastGrammarStateToMap(mergedTokens, mergedGrammarState);
    return mergedTokens;
}
function $047e2e8c411a40db$var$syncThemesTokenization(...themes) {
    const outThemes = themes.map(()=>[]);
    const count = themes.length;
    for(let i = 0; i < themes[0].length; i++){
        const lines = themes.map((t)=>t[i]);
        const outLines = outThemes.map(()=>[]);
        outThemes.forEach((t, i2)=>t.push(outLines[i2]));
        const indexes = lines.map(()=>0);
        const current = lines.map((l)=>l[0]);
        while(current.every((t)=>t)){
            const minLength = Math.min(...current.map((t)=>t.content.length));
            for(let n = 0; n < count; n++){
                const token = current[n];
                if (token.content.length === minLength) {
                    outLines[n].push(token);
                    indexes[n] += 1;
                    current[n] = lines[n][indexes[n]];
                } else {
                    outLines[n].push({
                        ...token,
                        content: token.content.slice(0, minLength)
                    });
                    current[n] = {
                        ...token,
                        content: token.content.slice(minLength),
                        offset: token.offset + minLength
                    };
                }
            }
        }
    }
    return outThemes;
}
function $047e2e8c411a40db$export$93965dfc9a82f052(internal, code, options) {
    let bg;
    let fg;
    let tokens;
    let themeName;
    let rootStyle;
    let grammarState;
    if ("themes" in options) {
        const { defaultColor: defaultColor = "light", cssVariablePrefix: cssVariablePrefix = "--shiki-", colorsRendering: colorsRendering = "css-vars" } = options;
        const themes = Object.entries(options.themes).filter((i)=>i[1]).map((i)=>({
                color: i[0],
                theme: i[1]
            })).sort((a, b)=>a.color === defaultColor ? -1 : b.color === defaultColor ? 1 : 0);
        if (themes.length === 0) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)("`themes` option must not be empty");
        const themeTokens = $047e2e8c411a40db$export$99552db3190ba9d3(internal, code, options);
        grammarState = $047e2e8c411a40db$var$getLastGrammarStateFromMap(themeTokens);
        if (defaultColor && $047e2e8c411a40db$var$DEFAULT_COLOR_LIGHT_DARK !== defaultColor && !themes.find((t)=>t.color === defaultColor)) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`\`themes\` option must contain the defaultColor key \`${defaultColor}\``);
        const themeRegs = themes.map((t)=>internal.getTheme(t.theme));
        const themesOrder = themes.map((t)=>t.color);
        tokens = themeTokens.map((line)=>line.map((token)=>$047e2e8c411a40db$export$5a4c68029315ecd7(token, themesOrder, cssVariablePrefix, defaultColor, colorsRendering)));
        if (grammarState) $047e2e8c411a40db$var$setLastGrammarStateToMap(tokens, grammarState);
        const themeColorReplacements = themes.map((t)=>$047e2e8c411a40db$export$2f5d8722891c6610(t.theme, options));
        fg = $047e2e8c411a40db$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, "fg", colorsRendering);
        bg = $047e2e8c411a40db$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, "bg", colorsRendering);
        themeName = `shiki-themes ${themeRegs.map((t)=>t.name).join(" ")}`;
        rootStyle = defaultColor ? void 0 : [
            fg,
            bg
        ].join(";");
    } else if ("theme" in options) {
        const colorReplacements = $047e2e8c411a40db$export$2f5d8722891c6610(options.theme, options);
        tokens = $047e2e8c411a40db$export$9fcc555cdbb165d8(internal, code, options);
        const _theme = internal.getTheme(options.theme);
        bg = $047e2e8c411a40db$export$ef30c5cede3b6b4a(_theme.bg, colorReplacements);
        fg = $047e2e8c411a40db$export$ef30c5cede3b6b4a(_theme.fg, colorReplacements);
        themeName = _theme.name;
        grammarState = $047e2e8c411a40db$var$getLastGrammarStateFromMap(tokens);
    } else throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)("Invalid options, either `theme` or `themes` must be provided");
    return {
        tokens: tokens,
        fg: fg,
        bg: bg,
        themeName: themeName,
        rootStyle: rootStyle,
        grammarState: grammarState
    };
}
function $047e2e8c411a40db$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, property, colorsRendering) {
    return themes.map((t, idx)=>{
        const value = $047e2e8c411a40db$export$ef30c5cede3b6b4a(themeRegs[idx][property], themeColorReplacements[idx]) || "inherit";
        const cssVar = `${cssVariablePrefix + t.color}${property === "bg" ? "-bg" : ""}:${value}`;
        if (idx === 0 && defaultColor) {
            if (defaultColor === $047e2e8c411a40db$var$DEFAULT_COLOR_LIGHT_DARK && themes.length > 1) {
                const lightIndex = themes.findIndex((t2)=>t2.color === "light");
                const darkIndex = themes.findIndex((t2)=>t2.color === "dark");
                if (lightIndex === -1 || darkIndex === -1) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)('When using `defaultColor: "light-dark()"`, you must provide both `light` and `dark` themes');
                const lightValue = $047e2e8c411a40db$export$ef30c5cede3b6b4a(themeRegs[lightIndex][property], themeColorReplacements[lightIndex]) || "inherit";
                const darkValue = $047e2e8c411a40db$export$ef30c5cede3b6b4a(themeRegs[darkIndex][property], themeColorReplacements[darkIndex]) || "inherit";
                return `light-dark(${lightValue}, ${darkValue});${cssVar}`;
            }
            return value;
        }
        if (colorsRendering === "css-vars") return cssVar;
        return null;
    }).filter((i)=>!!i).join(";");
}
function $047e2e8c411a40db$export$9b49c0a3202a858c(internal, code, options, transformerContext = {
    meta: {},
    options: options,
    codeToHast: (_code, _options)=>$047e2e8c411a40db$export$9b49c0a3202a858c(internal, _code, _options),
    codeToTokens: (_code, _options)=>$047e2e8c411a40db$export$93965dfc9a82f052(internal, _code, _options)
}) {
    let input = code;
    for (const transformer of $047e2e8c411a40db$var$getTransformers(options))input = transformer.preprocess?.call(transformerContext, input, options) || input;
    let { tokens: tokens, fg: fg, bg: bg, themeName: themeName, rootStyle: rootStyle, grammarState: grammarState } = $047e2e8c411a40db$export$93965dfc9a82f052(internal, input, options);
    const { mergeWhitespaces: mergeWhitespaces = true, mergeSameStyleTokens: mergeSameStyleTokens = false } = options;
    if (mergeWhitespaces === true) tokens = $047e2e8c411a40db$var$mergeWhitespaceTokens(tokens);
    else if (mergeWhitespaces === "never") tokens = $047e2e8c411a40db$var$splitWhitespaceTokens(tokens);
    if (mergeSameStyleTokens) tokens = $047e2e8c411a40db$var$mergeAdjacentStyledTokens(tokens);
    const contextSource = {
        ...transformerContext,
        get source () {
            return input;
        }
    };
    for (const transformer of $047e2e8c411a40db$var$getTransformers(options))tokens = transformer.tokens?.call(contextSource, tokens) || tokens;
    return $047e2e8c411a40db$export$ac3d0a92e97ad33e(tokens, {
        ...options,
        fg: fg,
        bg: bg,
        themeName: themeName,
        rootStyle: options.rootStyle === false ? false : options.rootStyle ?? rootStyle
    }, contextSource, grammarState);
}
function $047e2e8c411a40db$export$ac3d0a92e97ad33e(tokens, options, transformerContext, grammarState = $047e2e8c411a40db$var$getLastGrammarStateFromMap(tokens)) {
    const transformers = $047e2e8c411a40db$var$getTransformers(options);
    const lines = [];
    const root = {
        type: "root",
        children: []
    };
    const { structure: structure = "classic", tabindex: tabindex = "0" } = options;
    const properties = {
        class: `shiki ${options.themeName || ""}`
    };
    if (options.rootStyle !== false) {
        if (options.rootStyle != null) properties.style = options.rootStyle;
        else properties.style = `background-color:${options.bg};color:${options.fg}`;
    }
    if (tabindex !== false && tabindex != null) properties.tabindex = tabindex.toString();
    for (const [key, value] of Object.entries(options.meta || {}))if (!key.startsWith("_")) properties[key] = value;
    let preNode = {
        type: "element",
        tagName: "pre",
        properties: properties,
        children: [],
        data: options.data
    };
    let codeNode = {
        type: "element",
        tagName: "code",
        properties: {},
        children: lines
    };
    const lineNodes = [];
    const context = {
        ...transformerContext,
        structure: structure,
        addClassToHast: $047e2e8c411a40db$export$12efa744f94fc0a9,
        get source () {
            return transformerContext.source;
        },
        get tokens () {
            return tokens;
        },
        get options () {
            return options;
        },
        get root () {
            return root;
        },
        get pre () {
            return preNode;
        },
        get code () {
            return codeNode;
        },
        get lines () {
            return lineNodes;
        }
    };
    tokens.forEach((line, idx)=>{
        if (idx) {
            if (structure === "inline") root.children.push({
                type: "element",
                tagName: "br",
                properties: {},
                children: []
            });
            else if (structure === "classic") lines.push({
                type: "text",
                value: "\n"
            });
        }
        let lineNode = {
            type: "element",
            tagName: "span",
            properties: {
                class: "line"
            },
            children: []
        };
        let col = 0;
        for (const token of line){
            let tokenNode = {
                type: "element",
                tagName: "span",
                properties: {
                    ...token.htmlAttrs
                },
                children: [
                    {
                        type: "text",
                        value: token.content
                    }
                ]
            };
            const style = $047e2e8c411a40db$export$10559b52119e8d5f(token.htmlStyle || $047e2e8c411a40db$export$94ffab218337d127(token));
            if (style) tokenNode.properties.style = style;
            for (const transformer of transformers)tokenNode = transformer?.span?.call(context, tokenNode, idx + 1, col, lineNode, token) || tokenNode;
            if (structure === "inline") root.children.push(tokenNode);
            else if (structure === "classic") lineNode.children.push(tokenNode);
            col += token.content.length;
        }
        if (structure === "classic") {
            for (const transformer of transformers)lineNode = transformer?.line?.call(context, lineNode, idx + 1) || lineNode;
            lineNodes.push(lineNode);
            lines.push(lineNode);
        } else if (structure === "inline") lineNodes.push(lineNode);
    });
    if (structure === "classic") {
        for (const transformer of transformers)codeNode = transformer?.code?.call(context, codeNode) || codeNode;
        preNode.children.push(codeNode);
        for (const transformer of transformers)preNode = transformer?.pre?.call(context, preNode) || preNode;
        root.children.push(preNode);
    } else if (structure === "inline") {
        const syntheticLines = [];
        let currentLine = {
            type: "element",
            tagName: "span",
            properties: {
                class: "line"
            },
            children: []
        };
        for (const child of root.children){
            if (child.type === "element" && child.tagName === "br") {
                syntheticLines.push(currentLine);
                currentLine = {
                    type: "element",
                    tagName: "span",
                    properties: {
                        class: "line"
                    },
                    children: []
                };
            } else if (child.type === "element" || child.type === "text") currentLine.children.push(child);
        }
        syntheticLines.push(currentLine);
        const syntheticCode = {
            type: "element",
            tagName: "code",
            properties: {},
            children: syntheticLines
        };
        let transformedCode = syntheticCode;
        for (const transformer of transformers)transformedCode = transformer?.code?.call(context, transformedCode) || transformedCode;
        root.children = [];
        for(let i = 0; i < transformedCode.children.length; i++){
            if (i > 0) root.children.push({
                type: "element",
                tagName: "br",
                properties: {},
                children: []
            });
            const line = transformedCode.children[i];
            if (line.type === "element") root.children.push(...line.children);
        }
    }
    let result = root;
    for (const transformer of transformers)result = transformer?.root?.call(context, result) || result;
    if (grammarState) $047e2e8c411a40db$var$setLastGrammarStateToMap(result, grammarState);
    return result;
}
function $047e2e8c411a40db$var$mergeWhitespaceTokens(tokens) {
    return tokens.map((line)=>{
        const newLine = [];
        let carryOnContent = "";
        let firstOffset;
        line.forEach((token, idx)=>{
            const isDecorated = token.fontStyle && (token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Underline || token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Strikethrough);
            const couldMerge = !isDecorated;
            if (couldMerge && token.content.match(/^\s+$/) && line[idx + 1]) {
                if (firstOffset === void 0) firstOffset = token.offset;
                carryOnContent += token.content;
            } else if (carryOnContent) {
                if (couldMerge) newLine.push({
                    ...token,
                    offset: firstOffset,
                    content: carryOnContent + token.content
                });
                else newLine.push({
                    content: carryOnContent,
                    offset: firstOffset
                }, token);
                firstOffset = void 0;
                carryOnContent = "";
            } else newLine.push(token);
        });
        return newLine;
    });
}
function $047e2e8c411a40db$var$splitWhitespaceTokens(tokens) {
    return tokens.map((line)=>{
        return line.flatMap((token)=>{
            if (token.content.match(/^\s+$/)) return token;
            const match = token.content.match(/^(\s*)(.*?)(\s*)$/);
            if (!match) return token;
            const [, leading, content, trailing] = match;
            if (!leading && !trailing) return token;
            const expanded = [
                {
                    ...token,
                    offset: token.offset + leading.length,
                    content: content
                }
            ];
            if (leading) expanded.unshift({
                content: leading,
                offset: token.offset
            });
            if (trailing) expanded.push({
                content: trailing,
                offset: token.offset + leading.length + content.length
            });
            return expanded;
        });
    });
}
function $047e2e8c411a40db$var$mergeAdjacentStyledTokens(tokens) {
    return tokens.map((line)=>{
        const newLine = [];
        for (const token of line){
            if (newLine.length === 0) {
                newLine.push({
                    ...token
                });
                continue;
            }
            const prevToken = newLine[newLine.length - 1];
            const prevStyle = $047e2e8c411a40db$export$10559b52119e8d5f(prevToken.htmlStyle || $047e2e8c411a40db$export$94ffab218337d127(prevToken));
            const currentStyle = $047e2e8c411a40db$export$10559b52119e8d5f(token.htmlStyle || $047e2e8c411a40db$export$94ffab218337d127(token));
            const isPrevDecorated = prevToken.fontStyle && (prevToken.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Underline || prevToken.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Strikethrough);
            const isDecorated = token.fontStyle && (token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Underline || token.fontStyle & (0, $0fea3078b1feac63$export$23b468d4ca3f8c96).Strikethrough);
            if (!isPrevDecorated && !isDecorated && prevStyle === currentStyle) prevToken.content += token.content;
            else newLine.push({
                ...token
            });
        }
        return newLine;
    });
}
const $047e2e8c411a40db$export$4f3973dc2959ebf3 = (0, $59ad8c13d9107e7c$export$a10125c086a4df16);
function $047e2e8c411a40db$export$74ba11990fba86b4(internal, code, options) {
    const context = {
        meta: {},
        options: options,
        codeToHast: (_code, _options)=>$047e2e8c411a40db$export$9b49c0a3202a858c(internal, _code, _options),
        codeToTokens: (_code, _options)=>$047e2e8c411a40db$export$93965dfc9a82f052(internal, _code, _options)
    };
    let result = $047e2e8c411a40db$export$4f3973dc2959ebf3($047e2e8c411a40db$export$9b49c0a3202a858c(internal, code, options, context));
    for (const transformer of $047e2e8c411a40db$var$getTransformers(options))result = transformer.postprocess?.call(context, result, options) || result;
    return result;
}
const $047e2e8c411a40db$var$VSCODE_FALLBACK_EDITOR_FG = {
    light: "#333333",
    dark: "#bbbbbb"
};
const $047e2e8c411a40db$var$VSCODE_FALLBACK_EDITOR_BG = {
    light: "#fffffe",
    dark: "#1e1e1e"
};
const $047e2e8c411a40db$var$RESOLVED_KEY = "__shiki_resolved";
function $047e2e8c411a40db$export$7cb37fb596e67020(rawTheme) {
    if (rawTheme?.[$047e2e8c411a40db$var$RESOLVED_KEY]) return rawTheme;
    const theme = {
        ...rawTheme
    };
    if (theme.tokenColors && !theme.settings) {
        theme.settings = theme.tokenColors;
        delete theme.tokenColors;
    }
    theme.type ||= "dark";
    theme.colorReplacements = {
        ...theme.colorReplacements
    };
    theme.settings ||= [];
    let { bg: bg, fg: fg } = theme;
    if (!bg || !fg) {
        const globalSetting = theme.settings ? theme.settings.find((s)=>!s.name && !s.scope) : void 0;
        if (globalSetting?.settings?.foreground) fg = globalSetting.settings.foreground;
        if (globalSetting?.settings?.background) bg = globalSetting.settings.background;
        if (!fg && theme?.colors?.["editor.foreground"]) fg = theme.colors["editor.foreground"];
        if (!bg && theme?.colors?.["editor.background"]) bg = theme.colors["editor.background"];
        if (!fg) fg = theme.type === "light" ? $047e2e8c411a40db$var$VSCODE_FALLBACK_EDITOR_FG.light : $047e2e8c411a40db$var$VSCODE_FALLBACK_EDITOR_FG.dark;
        if (!bg) bg = theme.type === "light" ? $047e2e8c411a40db$var$VSCODE_FALLBACK_EDITOR_BG.light : $047e2e8c411a40db$var$VSCODE_FALLBACK_EDITOR_BG.dark;
        theme.fg = fg;
        theme.bg = bg;
    }
    if (!(theme.settings[0] && theme.settings[0].settings && !theme.settings[0].scope)) theme.settings.unshift({
        settings: {
            foreground: theme.fg,
            background: theme.bg
        }
    });
    let replacementCount = 0;
    const replacementMap = /* @__PURE__ */ new Map();
    function getReplacementColor(value) {
        if (replacementMap.has(value)) return replacementMap.get(value);
        replacementCount += 1;
        const hex = `#${replacementCount.toString(16).padStart(8, "0").toLowerCase()}`;
        if (theme.colorReplacements?.[`#${hex}`]) return getReplacementColor(value);
        replacementMap.set(value, hex);
        return hex;
    }
    theme.settings = theme.settings.map((setting)=>{
        const replaceFg = setting.settings?.foreground && !setting.settings.foreground.startsWith("#");
        const replaceBg = setting.settings?.background && !setting.settings.background.startsWith("#");
        if (!replaceFg && !replaceBg) return setting;
        const clone = {
            ...setting,
            settings: {
                ...setting.settings
            }
        };
        if (replaceFg) {
            const replacement = getReplacementColor(setting.settings.foreground);
            theme.colorReplacements[replacement] = setting.settings.foreground;
            clone.settings.foreground = replacement;
        }
        if (replaceBg) {
            const replacement = getReplacementColor(setting.settings.background);
            theme.colorReplacements[replacement] = setting.settings.background;
            clone.settings.background = replacement;
        }
        return clone;
    });
    for (const key of Object.keys(theme.colors || {})){
        if (key === "editor.foreground" || key === "editor.background" || key.startsWith("terminal.ansi")) {
            if (!theme.colors[key]?.startsWith("#")) {
                const replacement = getReplacementColor(theme.colors[key]);
                theme.colorReplacements[replacement] = theme.colors[key];
                theme.colors[key] = replacement;
            }
        }
    }
    Object.defineProperty(theme, $047e2e8c411a40db$var$RESOLVED_KEY, {
        enumerable: false,
        writable: false,
        value: true
    });
    return theme;
}
async function $047e2e8c411a40db$var$resolveLangs(langs) {
    return Array.from(new Set((await Promise.all(langs.filter((l)=>!$047e2e8c411a40db$export$5c3e2a1e13c5c906(l)).map(async (lang)=>await $047e2e8c411a40db$export$4643bb4b0bbd3390(lang).then((r)=>Array.isArray(r) ? r : [
                r
            ])))).flat()));
}
async function $047e2e8c411a40db$var$resolveThemes(themes) {
    const resolved = await Promise.all(themes.map(async (theme)=>$047e2e8c411a40db$export$cd4537af2d43769e(theme) ? null : $047e2e8c411a40db$export$7cb37fb596e67020(await $047e2e8c411a40db$export$4643bb4b0bbd3390(theme))));
    return resolved.filter((i)=>!!i);
}
let $047e2e8c411a40db$var$_emitDeprecation = 3;
let $047e2e8c411a40db$var$_emitError = false;
function $047e2e8c411a40db$export$c06e404fb817380c(emitDeprecation = true, emitError = false) {
    $047e2e8c411a40db$var$_emitDeprecation = emitDeprecation;
    $047e2e8c411a40db$var$_emitError = emitError;
}
function $047e2e8c411a40db$export$606a5c06d13e04b6(message, version = 3) {
    if (!$047e2e8c411a40db$var$_emitDeprecation) return;
    if (typeof $047e2e8c411a40db$var$_emitDeprecation === "number" && version > $047e2e8c411a40db$var$_emitDeprecation) return;
    if ($047e2e8c411a40db$var$_emitError) throw new Error(`[SHIKI DEPRECATE]: ${message}`);
    else console.trace(`[SHIKI DEPRECATE]: ${message}`);
}
class $047e2e8c411a40db$var$ShikiError extends Error {
    constructor(message){
        super(message);
        this.name = "ShikiError";
    }
}
function $047e2e8c411a40db$var$resolveLangAlias(name, alias) {
    if (!alias) return name;
    if (alias[name]) {
        const resolved = /* @__PURE__ */ new Set([
            name
        ]);
        while(alias[name]){
            name = alias[name];
            if (resolved.has(name)) throw new $047e2e8c411a40db$var$ShikiError(`Circular alias \`${Array.from(resolved).join(" -> ")} -> ${name}\``);
            resolved.add(name);
        }
    }
    return name;
}
class $047e2e8c411a40db$var$Registry extends (0, $0fea3078b1feac63$export$4d9facee29974f3) {
    constructor(_resolver, _themes, _langs, _alias = {}){
        super(_resolver);
        this._resolver = _resolver;
        this._themes = _themes;
        this._langs = _langs;
        this._alias = _alias;
        this._themes.map((t)=>this.loadTheme(t));
        this.loadLanguages(this._langs);
    }
    _resolvedThemes = /* @__PURE__ */ new Map();
    _resolvedGrammars = /* @__PURE__ */ new Map();
    _langMap = /* @__PURE__ */ new Map();
    _langGraph = /* @__PURE__ */ new Map();
    _textmateThemeCache = /* @__PURE__ */ new WeakMap();
    _loadedThemesCache = null;
    _loadedLanguagesCache = null;
    getTheme(theme) {
        if (typeof theme === "string") return this._resolvedThemes.get(theme);
        else return this.loadTheme(theme);
    }
    loadTheme(theme) {
        const _theme = $047e2e8c411a40db$export$7cb37fb596e67020(theme);
        if (_theme.name) {
            this._resolvedThemes.set(_theme.name, _theme);
            this._loadedThemesCache = null;
        }
        return _theme;
    }
    getLoadedThemes() {
        if (!this._loadedThemesCache) this._loadedThemesCache = [
            ...this._resolvedThemes.keys()
        ];
        return this._loadedThemesCache;
    }
    // Override and re-implement this method to cache the textmate themes as `TextMateTheme.createFromRawTheme`
    // is expensive. Themes can switch often especially for dual-theme support.
    //
    // The parent class also accepts `colorMap` as the second parameter, but since we don't use that,
    // we omit here so it's easier to cache the themes.
    setTheme(theme) {
        let textmateTheme = this._textmateThemeCache.get(theme);
        if (!textmateTheme) {
            textmateTheme = (0, $0fea3078b1feac63$export$14faa19a0f3bbeb2).createFromRawTheme(theme);
            this._textmateThemeCache.set(theme, textmateTheme);
        }
        this._syncRegistry.setTheme(textmateTheme);
    }
    getGrammar(name) {
        name = $047e2e8c411a40db$var$resolveLangAlias(name, this._alias);
        return this._resolvedGrammars.get(name);
    }
    loadLanguage(lang) {
        if (this.getGrammar(lang.name)) return;
        const embeddedLazilyBy = new Set([
            ...this._langMap.values()
        ].filter((i)=>i.embeddedLangsLazy?.includes(lang.name)));
        this._resolver.addLanguage(lang);
        const grammarConfig = {
            balancedBracketSelectors: lang.balancedBracketSelectors || [
                "*"
            ],
            unbalancedBracketSelectors: lang.unbalancedBracketSelectors || []
        };
        this._syncRegistry._rawGrammars.set(lang.scopeName, lang);
        const g = this.loadGrammarWithConfiguration(lang.scopeName, 1, grammarConfig);
        g.name = lang.name;
        this._resolvedGrammars.set(lang.name, g);
        if (lang.aliases) lang.aliases.forEach((alias)=>{
            this._alias[alias] = lang.name;
        });
        this._loadedLanguagesCache = null;
        if (embeddedLazilyBy.size) for (const e of embeddedLazilyBy){
            this._resolvedGrammars.delete(e.name);
            this._loadedLanguagesCache = null;
            this._syncRegistry?._injectionGrammars?.delete(e.scopeName);
            this._syncRegistry?._grammars?.delete(e.scopeName);
            this.loadLanguage(this._langMap.get(e.name));
        }
    }
    dispose() {
        super.dispose();
        this._resolvedThemes.clear();
        this._resolvedGrammars.clear();
        this._langMap.clear();
        this._langGraph.clear();
        this._loadedThemesCache = null;
    }
    loadLanguages(langs) {
        for (const lang of langs)this.resolveEmbeddedLanguages(lang);
        const langsGraphArray = Array.from(this._langGraph.entries());
        const missingLangs = langsGraphArray.filter(([_, lang])=>!lang);
        if (missingLangs.length) {
            const dependents = langsGraphArray.filter(([_, lang])=>{
                if (!lang) return false;
                const embedded = lang.embeddedLanguages || lang.embeddedLangs;
                return embedded?.some((l)=>missingLangs.map(([name])=>name).includes(l));
            }).filter((lang)=>!missingLangs.includes(lang));
            throw new $047e2e8c411a40db$var$ShikiError(`Missing languages ${missingLangs.map(([name])=>`\`${name}\``).join(", ")}, required by ${dependents.map(([name])=>`\`${name}\``).join(", ")}`);
        }
        for (const [_, lang] of langsGraphArray)this._resolver.addLanguage(lang);
        for (const [_, lang] of langsGraphArray)this.loadLanguage(lang);
    }
    getLoadedLanguages() {
        if (!this._loadedLanguagesCache) this._loadedLanguagesCache = [
            .../* @__PURE__ */ new Set([
                ...this._resolvedGrammars.keys(),
                ...Object.keys(this._alias)
            ])
        ];
        return this._loadedLanguagesCache;
    }
    resolveEmbeddedLanguages(lang) {
        this._langMap.set(lang.name, lang);
        this._langGraph.set(lang.name, lang);
        const embedded = lang.embeddedLanguages ?? lang.embeddedLangs;
        if (embedded) for (const embeddedLang of embedded)this._langGraph.set(embeddedLang, this._langMap.get(embeddedLang));
    }
}
class $047e2e8c411a40db$var$Resolver {
    _langs = /* @__PURE__ */ new Map();
    _scopeToLang = /* @__PURE__ */ new Map();
    _injections = /* @__PURE__ */ new Map();
    _onigLib;
    constructor(engine, langs){
        this._onigLib = {
            createOnigScanner: (patterns)=>engine.createScanner(patterns),
            createOnigString: (s)=>engine.createString(s)
        };
        langs.forEach((i)=>this.addLanguage(i));
    }
    get onigLib() {
        return this._onigLib;
    }
    getLangRegistration(langIdOrAlias) {
        return this._langs.get(langIdOrAlias);
    }
    loadGrammar(scopeName) {
        return this._scopeToLang.get(scopeName);
    }
    addLanguage(l) {
        this._langs.set(l.name, l);
        if (l.aliases) l.aliases.forEach((a)=>{
            this._langs.set(a, l);
        });
        this._scopeToLang.set(l.scopeName, l);
        if (l.injectTo) l.injectTo.forEach((i)=>{
            if (!this._injections.get(i)) this._injections.set(i, []);
            this._injections.get(i).push(l.scopeName);
        });
    }
    getInjections(scopeName) {
        const scopeParts = scopeName.split(".");
        let injections = [];
        for(let i = 1; i <= scopeParts.length; i++){
            const subScopeName = scopeParts.slice(0, i).join(".");
            injections = [
                ...injections,
                ...this._injections.get(subScopeName) || []
            ];
        }
        return injections;
    }
}
let $047e2e8c411a40db$var$instancesCount = 0;
function $047e2e8c411a40db$export$b748e45347fc3413(options) {
    $047e2e8c411a40db$var$instancesCount += 1;
    if (options.warnings !== false && $047e2e8c411a40db$var$instancesCount >= 10 && $047e2e8c411a40db$var$instancesCount % 10 === 0) console.warn(`[Shiki] ${$047e2e8c411a40db$var$instancesCount} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
    let isDisposed = false;
    if (!options.engine) throw new $047e2e8c411a40db$var$ShikiError("`engine` option is required for synchronous mode");
    const langs = (options.langs || []).flat(1);
    const themes = (options.themes || []).flat(1).map($047e2e8c411a40db$export$7cb37fb596e67020);
    const resolver = new $047e2e8c411a40db$var$Resolver(options.engine, langs);
    const _registry = new $047e2e8c411a40db$var$Registry(resolver, themes, langs, options.langAlias);
    let _lastTheme;
    function resolveLangAlias$1(name) {
        return $047e2e8c411a40db$var$resolveLangAlias(name, options.langAlias);
    }
    function getLanguage(name) {
        ensureNotDisposed();
        const _lang = _registry.getGrammar(typeof name === "string" ? name : name.name);
        if (!_lang) throw new $047e2e8c411a40db$var$ShikiError(`Language \`${name}\` not found, you may need to load it first`);
        return _lang;
    }
    function getTheme(name) {
        if (name === "none") return {
            bg: "",
            fg: "",
            name: "none",
            settings: [],
            type: "dark"
        };
        ensureNotDisposed();
        const _theme = _registry.getTheme(name);
        if (!_theme) throw new $047e2e8c411a40db$var$ShikiError(`Theme \`${name}\` not found, you may need to load it first`);
        return _theme;
    }
    function setTheme(name) {
        ensureNotDisposed();
        const theme = getTheme(name);
        if (_lastTheme !== name) {
            _registry.setTheme(theme);
            _lastTheme = name;
        }
        const colorMap = _registry.getColorMap();
        return {
            theme: theme,
            colorMap: colorMap
        };
    }
    function getLoadedThemes() {
        ensureNotDisposed();
        return _registry.getLoadedThemes();
    }
    function getLoadedLanguages() {
        ensureNotDisposed();
        return _registry.getLoadedLanguages();
    }
    function loadLanguageSync(...langs2) {
        ensureNotDisposed();
        _registry.loadLanguages(langs2.flat(1));
    }
    async function loadLanguage(...langs2) {
        return loadLanguageSync(await $047e2e8c411a40db$var$resolveLangs(langs2));
    }
    function loadThemeSync(...themes2) {
        ensureNotDisposed();
        for (const theme of themes2.flat(1))_registry.loadTheme(theme);
    }
    async function loadTheme(...themes2) {
        ensureNotDisposed();
        return loadThemeSync(await $047e2e8c411a40db$var$resolveThemes(themes2));
    }
    function ensureNotDisposed() {
        if (isDisposed) throw new $047e2e8c411a40db$var$ShikiError("Shiki instance has been disposed");
    }
    function dispose() {
        if (isDisposed) return;
        isDisposed = true;
        _registry.dispose();
        $047e2e8c411a40db$var$instancesCount -= 1;
    }
    return {
        setTheme: setTheme,
        getTheme: getTheme,
        getLanguage: getLanguage,
        getLoadedThemes: getLoadedThemes,
        getLoadedLanguages: getLoadedLanguages,
        resolveLangAlias: resolveLangAlias$1,
        loadLanguage: loadLanguage,
        loadLanguageSync: loadLanguageSync,
        loadTheme: loadTheme,
        loadThemeSync: loadThemeSync,
        dispose: dispose,
        [Symbol.dispose]: dispose
    };
}
async function $047e2e8c411a40db$export$e584c153725e36c2(options) {
    if (!options.engine) $047e2e8c411a40db$export$606a5c06d13e04b6("`engine` option is required. Use `createOnigurumaEngine` or `createJavaScriptRegexEngine` to create an engine.");
    const [themes, langs, engine] = await Promise.all([
        $047e2e8c411a40db$var$resolveThemes(options.themes || []),
        $047e2e8c411a40db$var$resolveLangs(options.langs || []),
        options.engine
    ]);
    return $047e2e8c411a40db$export$b748e45347fc3413({
        ...options,
        themes: themes,
        langs: langs,
        engine: engine
    });
}
async function $047e2e8c411a40db$export$731e59ef5bc9b980(options) {
    const internal = await $047e2e8c411a40db$export$e584c153725e36c2(options);
    return {
        getLastGrammarState: (...args)=>$047e2e8c411a40db$var$getLastGrammarState(internal, ...args),
        codeToTokensBase: (code, options2)=>$047e2e8c411a40db$export$9fcc555cdbb165d8(internal, code, options2),
        codeToTokensWithThemes: (code, options2)=>$047e2e8c411a40db$export$99552db3190ba9d3(internal, code, options2),
        codeToTokens: (code, options2)=>$047e2e8c411a40db$export$93965dfc9a82f052(internal, code, options2),
        codeToHast: (code, options2)=>$047e2e8c411a40db$export$9b49c0a3202a858c(internal, code, options2),
        codeToHtml: (code, options2)=>$047e2e8c411a40db$export$74ba11990fba86b4(internal, code, options2),
        getBundledLanguages: ()=>({}),
        getBundledThemes: ()=>({}),
        ...internal,
        getInternalContext: ()=>internal
    };
}
function $047e2e8c411a40db$export$f38e8c16be9dd57d(options) {
    const internal = $047e2e8c411a40db$export$b748e45347fc3413(options);
    return {
        getLastGrammarState: (...args)=>$047e2e8c411a40db$var$getLastGrammarState(internal, ...args),
        codeToTokensBase: (code, options2)=>$047e2e8c411a40db$export$9fcc555cdbb165d8(internal, code, options2),
        codeToTokensWithThemes: (code, options2)=>$047e2e8c411a40db$export$99552db3190ba9d3(internal, code, options2),
        codeToTokens: (code, options2)=>$047e2e8c411a40db$export$93965dfc9a82f052(internal, code, options2),
        codeToHast: (code, options2)=>$047e2e8c411a40db$export$9b49c0a3202a858c(internal, code, options2),
        codeToHtml: (code, options2)=>$047e2e8c411a40db$export$74ba11990fba86b4(internal, code, options2),
        getBundledLanguages: ()=>({}),
        getBundledThemes: ()=>({}),
        ...internal,
        getInternalContext: ()=>internal
    };
}
function $047e2e8c411a40db$export$708f4903c06f244f(createHighlighter) {
    let _shiki;
    async function getSingletonHighlighterCore2(options) {
        if (!_shiki) {
            _shiki = createHighlighter({
                ...options,
                themes: options.themes || [],
                langs: options.langs || []
            });
            return _shiki;
        } else {
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        }
    }
    return getSingletonHighlighterCore2;
}
const $047e2e8c411a40db$export$ebfcaa8c37a8db2c = /* @__PURE__ */ $047e2e8c411a40db$export$708f4903c06f244f($047e2e8c411a40db$export$731e59ef5bc9b980);
function $047e2e8c411a40db$export$8ca362031a26944a(options) {
    const bundledLanguages = options.langs;
    const bundledThemes = options.themes;
    const engine = options.engine;
    async function createHighlighter(options2) {
        function resolveLang(lang) {
            if (typeof lang === "string") {
                lang = options2.langAlias?.[lang] || lang;
                if ($047e2e8c411a40db$export$5c3e2a1e13c5c906(lang)) return [];
                const bundle = bundledLanguages[lang];
                if (!bundle) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Language \`${lang}\` is not included in this bundle. You may want to load it from external source.`);
                return bundle;
            }
            return lang;
        }
        function resolveTheme(theme) {
            if ($047e2e8c411a40db$export$cd4537af2d43769e(theme)) return "none";
            if (typeof theme === "string") {
                const bundle = bundledThemes[theme];
                if (!bundle) throw new (0, $a16ed6e909c7cb00$export$5003b41ce90ff8c9)(`Theme \`${theme}\` is not included in this bundle. You may want to load it from external source.`);
                return bundle;
            }
            return theme;
        }
        const _themes = (options2.themes ?? []).map((i)=>resolveTheme(i));
        const langs = (options2.langs ?? []).map((i)=>resolveLang(i));
        const core = await $047e2e8c411a40db$export$731e59ef5bc9b980({
            engine: options2.engine ?? engine(),
            ...options2,
            themes: _themes,
            langs: langs
        });
        return {
            ...core,
            loadLanguage (...langs2) {
                return core.loadLanguage(...langs2.map(resolveLang));
            },
            loadTheme (...themes) {
                return core.loadTheme(...themes.map(resolveTheme));
            },
            getBundledLanguages () {
                return bundledLanguages;
            },
            getBundledThemes () {
                return bundledThemes;
            }
        };
    }
    return createHighlighter;
}
function $047e2e8c411a40db$export$c08cf9c73e9e5934(createHighlighter) {
    let _shiki;
    async function getSingletonHighlighter(options = {}) {
        if (!_shiki) {
            _shiki = createHighlighter({
                ...options,
                themes: [],
                langs: []
            });
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        } else {
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        }
    }
    return getSingletonHighlighter;
}
function $047e2e8c411a40db$export$3706d1cd2b0dba33(createHighlighter, config) {
    const getSingletonHighlighter = $047e2e8c411a40db$export$c08cf9c73e9e5934(createHighlighter);
    async function get(code, options) {
        const shiki = await getSingletonHighlighter({
            langs: [
                options.lang
            ],
            themes: "theme" in options ? [
                options.theme
            ] : Object.values(options.themes)
        });
        const langs = await config?.guessEmbeddedLanguages?.(code, options.lang, shiki);
        if (langs) await shiki.loadLanguage(...langs);
        return shiki;
    }
    return {
        getSingletonHighlighter (options) {
            return getSingletonHighlighter(options);
        },
        async codeToHtml (code, options) {
            const shiki = await get(code, options);
            return shiki.codeToHtml(code, options);
        },
        async codeToHast (code, options) {
            const shiki = await get(code, options);
            return shiki.codeToHast(code, options);
        },
        async codeToTokens (code, options) {
            const shiki = await get(code, options);
            return shiki.codeToTokens(code, options);
        },
        async codeToTokensBase (code, options) {
            const shiki = await get(code, options);
            return shiki.codeToTokensBase(code, options);
        },
        async codeToTokensWithThemes (code, options) {
            const shiki = await get(code, options);
            return shiki.codeToTokensWithThemes(code, options);
        },
        async getLastGrammarState (code, options) {
            const shiki = await getSingletonHighlighter({
                langs: [
                    options.lang
                ],
                themes: [
                    options.theme
                ]
            });
            return shiki.getLastGrammarState(code, options);
        }
    };
}
const $047e2e8c411a40db$export$229f6f62f893e922 = $047e2e8c411a40db$export$8ca362031a26944a;
function $047e2e8c411a40db$export$73f45de8f69a7c80(options = {}) {
    const { name: name = "css-variables", variablePrefix: variablePrefix = "--shiki-", fontStyle: fontStyle = true } = options;
    const variable = (name2)=>{
        if (options.variableDefaults?.[name2]) return `var(${variablePrefix}${name2}, ${options.variableDefaults[name2]})`;
        return `var(${variablePrefix}${name2})`;
    };
    const theme = {
        name: name,
        type: "dark",
        colors: {
            "editor.foreground": variable("foreground"),
            "editor.background": variable("background"),
            "terminal.ansiBlack": variable("ansi-black"),
            "terminal.ansiRed": variable("ansi-red"),
            "terminal.ansiGreen": variable("ansi-green"),
            "terminal.ansiYellow": variable("ansi-yellow"),
            "terminal.ansiBlue": variable("ansi-blue"),
            "terminal.ansiMagenta": variable("ansi-magenta"),
            "terminal.ansiCyan": variable("ansi-cyan"),
            "terminal.ansiWhite": variable("ansi-white"),
            "terminal.ansiBrightBlack": variable("ansi-bright-black"),
            "terminal.ansiBrightRed": variable("ansi-bright-red"),
            "terminal.ansiBrightGreen": variable("ansi-bright-green"),
            "terminal.ansiBrightYellow": variable("ansi-bright-yellow"),
            "terminal.ansiBrightBlue": variable("ansi-bright-blue"),
            "terminal.ansiBrightMagenta": variable("ansi-bright-magenta"),
            "terminal.ansiBrightCyan": variable("ansi-bright-cyan"),
            "terminal.ansiBrightWhite": variable("ansi-bright-white")
        },
        tokenColors: [
            {
                scope: [
                    "keyword.operator.accessor",
                    "meta.group.braces.round.function.arguments",
                    "meta.template.expression",
                    "markup.fenced_code meta.embedded.block"
                ],
                settings: {
                    foreground: variable("foreground")
                }
            },
            {
                scope: "emphasis",
                settings: {
                    fontStyle: "italic"
                }
            },
            {
                scope: [
                    "strong",
                    "markup.heading.markdown",
                    "markup.bold.markdown"
                ],
                settings: {
                    fontStyle: "bold"
                }
            },
            {
                scope: [
                    "markup.italic.markdown"
                ],
                settings: {
                    fontStyle: "italic"
                }
            },
            {
                scope: "meta.link.inline.markdown",
                settings: {
                    fontStyle: "underline",
                    foreground: variable("token-link")
                }
            },
            {
                scope: [
                    "string",
                    "markup.fenced_code",
                    "markup.inline"
                ],
                settings: {
                    foreground: variable("token-string")
                }
            },
            {
                scope: [
                    "comment",
                    "string.quoted.docstring.multi"
                ],
                settings: {
                    foreground: variable("token-comment")
                }
            },
            {
                scope: [
                    "constant.numeric",
                    "constant.language",
                    "constant.other.placeholder",
                    "constant.character.format.placeholder",
                    "variable.language.this",
                    "variable.other.object",
                    "variable.other.class",
                    "variable.other.constant",
                    "meta.property-name",
                    "meta.property-value",
                    "support"
                ],
                settings: {
                    foreground: variable("token-constant")
                }
            },
            {
                scope: [
                    "keyword",
                    "storage.modifier",
                    "storage.type",
                    "storage.control.clojure",
                    "entity.name.function.clojure",
                    "entity.name.tag.yaml",
                    "support.function.node",
                    "support.type.property-name.json",
                    "punctuation.separator.key-value",
                    "punctuation.definition.template-expression"
                ],
                settings: {
                    foreground: variable("token-keyword")
                }
            },
            {
                scope: "variable.parameter.function",
                settings: {
                    foreground: variable("token-parameter")
                }
            },
            {
                scope: [
                    "support.function",
                    "entity.name.type",
                    "entity.other.inherited-class",
                    "meta.function-call",
                    "meta.instance.constructor",
                    "entity.other.attribute-name",
                    "entity.name.function",
                    "constant.keyword.clojure"
                ],
                settings: {
                    foreground: variable("token-function")
                }
            },
            {
                scope: [
                    "entity.name.tag",
                    "string.quoted",
                    "string.regexp",
                    "string.interpolated",
                    "string.template",
                    "string.unquoted.plain.out.yaml",
                    "keyword.other.template"
                ],
                settings: {
                    foreground: variable("token-string-expression")
                }
            },
            {
                scope: [
                    "punctuation.definition.arguments",
                    "punctuation.definition.dict",
                    "punctuation.separator",
                    "meta.function-call.arguments"
                ],
                settings: {
                    foreground: variable("token-punctuation")
                }
            },
            {
                // [Custom] Markdown links
                scope: [
                    "markup.underline.link",
                    "punctuation.definition.metadata.markdown"
                ],
                settings: {
                    foreground: variable("token-link")
                }
            },
            {
                // [Custom] Markdown list
                scope: [
                    "beginning.punctuation.definition.list.markdown"
                ],
                settings: {
                    foreground: variable("token-string")
                }
            },
            {
                // [Custom] Markdown punctuation definition brackets
                scope: [
                    "punctuation.definition.string.begin.markdown",
                    "punctuation.definition.string.end.markdown",
                    "string.other.link.title.markdown",
                    "string.other.link.description.markdown"
                ],
                settings: {
                    foreground: variable("token-keyword")
                }
            },
            {
                // [Custom] Diff
                scope: [
                    "markup.inserted",
                    "meta.diff.header.to-file",
                    "punctuation.definition.inserted"
                ],
                settings: {
                    foreground: variable("token-inserted")
                }
            },
            {
                scope: [
                    "markup.deleted",
                    "meta.diff.header.from-file",
                    "punctuation.definition.deleted"
                ],
                settings: {
                    foreground: variable("token-deleted")
                }
            },
            {
                scope: [
                    "markup.changed",
                    "punctuation.definition.changed"
                ],
                settings: {
                    foreground: variable("token-changed")
                }
            }
        ]
    };
    if (!fontStyle) theme.tokenColors = theme.tokenColors?.map((tokenColor)=>{
        if (tokenColor.settings?.fontStyle) delete tokenColor.settings.fontStyle;
        return tokenColor;
    });
    return theme;
}


//#region src/highlighter/themes/resolveTheme.ts
async function $f14bbb1aa2411005$export$da5ffdb7039764e9(themeName) {
    if ((0, $c7c05f3bbf3bd887$export$3ff2f5c75c098e85)()) throw new Error(`resolveTheme("${themeName}") cannot be called from a worker context. Themes must be pre-resolved on the main thread and passed to the worker via the resolvedLanguages parameter.`);
    const resolver = (0, $e663a760095f022f$export$5f9337448df52729).get(themeName);
    if (resolver != null) return resolver;
    try {
        const loader = (0, $e663a760095f022f$export$d2de3753cd1ff872).get(themeName) ?? (0, $ae97e0ad66dd4e9b$export$b55f4ff8dd492310)[themeName];
        if (loader == null) throw new Error(`resolveTheme: No valid loader for ${themeName}`);
        const resolver$1 = loader().then((result)=>{
            return $f14bbb1aa2411005$var$normalizeAndCacheResolvedTheme(themeName, "default" in result ? result.default : result);
        });
        (0, $e663a760095f022f$export$5f9337448df52729).set(themeName, resolver$1);
        const theme = await resolver$1;
        if (theme.name !== themeName) throw new Error(`resolvedTheme: themeName: ${themeName} does not match theme.name: ${theme.name}`);
        (0, $e663a760095f022f$export$517305f1f1af691).set(theme.name, theme);
        return theme;
    } finally{
        (0, $e663a760095f022f$export$5f9337448df52729).delete(themeName);
    }
}
function $f14bbb1aa2411005$var$normalizeAndCacheResolvedTheme(themeName, themeData) {
    const resolvedTheme = (0, $e663a760095f022f$export$517305f1f1af691).get(themeName);
    if (resolvedTheme != null) return resolvedTheme;
    themeData = (0, $047e2e8c411a40db$export$7cb37fb596e67020)(themeData);
    (0, $e663a760095f022f$export$517305f1f1af691).set(themeName, themeData);
    return themeData;
}


//#region src/highlighter/themes/getResolvedOrResolveTheme.ts
function $13ad887817b0c006$export$406f844df6312956(themeName) {
    return (0, $e663a760095f022f$export$517305f1f1af691).get(themeName) ?? (0, $f14bbb1aa2411005$export$da5ffdb7039764e9)(themeName);
}



//#region src/highlighter/themes/registerCustomTheme.ts
function $b897030c4040ecda$export$7fb6c5a4253e769a(themeName, loader) {
    if ((0, $e663a760095f022f$export$d2de3753cd1ff872).has(themeName)) {
        console.error("SharedHighlight.registerCustomTheme: theme name already registered", themeName);
        return;
    }
    (0, $e663a760095f022f$export$d2de3753cd1ff872).set(themeName, loader);
}





/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $7c049fd770a07e8d$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
class $7c049fd770a07e8d$var$ShikiError extends Error {
    constructor(message){
        super(message);
        this.name = "ShikiError";
    }
}
function $7c049fd770a07e8d$var$getHeapMax() {
    return 2147483648;
}
function $7c049fd770a07e8d$var$_emscripten_get_now() {
    return typeof performance !== "undefined" ? performance.now() : Date.now();
}
const $7c049fd770a07e8d$var$alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
async function $7c049fd770a07e8d$var$main(init) {
    let wasmMemory;
    let buffer;
    const binding = {};
    function updateGlobalBufferAndViews(buf) {
        buffer = buf;
        binding.HEAPU8 = new Uint8Array(buf);
        binding.HEAPU32 = new Uint32Array(buf);
    }
    function _emscripten_memcpy_big(dest, src, num) {
        binding.HEAPU8.copyWithin(dest, src, src + num);
    }
    function emscripten_realloc_buffer(size) {
        try {
            wasmMemory.grow(size - buffer.byteLength + 65535 >>> 16);
            updateGlobalBufferAndViews(wasmMemory.buffer);
            return 1;
        } catch  {}
    }
    function _emscripten_resize_heap(requestedSize) {
        const oldSize = binding.HEAPU8.length;
        requestedSize = requestedSize >>> 0;
        const maxHeapSize = $7c049fd770a07e8d$var$getHeapMax();
        if (requestedSize > maxHeapSize) return false;
        for(let cutDown = 1; cutDown <= 4; cutDown *= 2){
            let overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            const newSize = Math.min(maxHeapSize, $7c049fd770a07e8d$var$alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            const replacement = emscripten_realloc_buffer(newSize);
            if (replacement) return true;
        }
        return false;
    }
    const UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
    function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead = 1024) {
        const endIdx = idx + maxBytesToRead;
        let endPtr = idx;
        while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
        if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
        let str = "";
        while(idx < endPtr){
            let u0 = heapOrArray[idx++];
            if (!(u0 & 128)) {
                str += String.fromCharCode(u0);
                continue;
            }
            const u1 = heapOrArray[idx++] & 63;
            if ((u0 & 224) === 192) {
                str += String.fromCharCode((u0 & 31) << 6 | u1);
                continue;
            }
            const u2 = heapOrArray[idx++] & 63;
            if ((u0 & 240) === 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            if (u0 < 65536) str += String.fromCharCode(u0);
            else {
                const ch = u0 - 65536;
                str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
        }
        return str;
    }
    function UTF8ToString(ptr, maxBytesToRead) {
        return ptr ? UTF8ArrayToString(binding.HEAPU8, ptr, maxBytesToRead) : "";
    }
    const asmLibraryArg = {
        emscripten_get_now: $7c049fd770a07e8d$var$_emscripten_get_now,
        emscripten_memcpy_big: _emscripten_memcpy_big,
        emscripten_resize_heap: _emscripten_resize_heap,
        fd_write: ()=>0
    };
    async function createWasm() {
        const info = {
            env: asmLibraryArg,
            wasi_snapshot_preview1: asmLibraryArg
        };
        const exports$1 = await init(info);
        wasmMemory = exports$1.memory;
        updateGlobalBufferAndViews(wasmMemory.buffer);
        Object.assign(binding, exports$1);
        binding.UTF8ToString = UTF8ToString;
    }
    await createWasm();
    return binding;
}
var $7c049fd770a07e8d$var$__defProp = Object.defineProperty;
var $7c049fd770a07e8d$var$__defNormalProp = (obj, key, value)=>key in obj ? $7c049fd770a07e8d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7c049fd770a07e8d$var$__publicField = (obj, key, value)=>$7c049fd770a07e8d$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
let $7c049fd770a07e8d$var$onigBinding = null;
function $7c049fd770a07e8d$var$throwLastOnigError(onigBinding2) {
    throw new $7c049fd770a07e8d$var$ShikiError(onigBinding2.UTF8ToString(onigBinding2.getLastOnigError()));
}
class $7c049fd770a07e8d$var$UtfString {
    constructor(str){
        $7c049fd770a07e8d$var$__publicField(this, "utf16Length");
        $7c049fd770a07e8d$var$__publicField(this, "utf8Length");
        $7c049fd770a07e8d$var$__publicField(this, "utf16Value");
        $7c049fd770a07e8d$var$__publicField(this, "utf8Value");
        $7c049fd770a07e8d$var$__publicField(this, "utf16OffsetToUtf8");
        $7c049fd770a07e8d$var$__publicField(this, "utf8OffsetToUtf16");
        const utf16Length = str.length;
        const utf8Length = $7c049fd770a07e8d$var$UtfString._utf8ByteLength(str);
        const computeIndicesMapping = utf8Length !== utf16Length;
        const utf16OffsetToUtf8 = computeIndicesMapping ? new Uint32Array(utf16Length + 1) : null;
        if (computeIndicesMapping) utf16OffsetToUtf8[utf16Length] = utf8Length;
        const utf8OffsetToUtf16 = computeIndicesMapping ? new Uint32Array(utf8Length + 1) : null;
        if (computeIndicesMapping) utf8OffsetToUtf16[utf8Length] = utf16Length;
        const utf8Value = new Uint8Array(utf8Length);
        let i8 = 0;
        for(let i16 = 0; i16 < utf16Length; i16++){
            const charCode = str.charCodeAt(i16);
            let codePoint = charCode;
            let wasSurrogatePair = false;
            if (charCode >= 55296 && charCode <= 56319) {
                if (i16 + 1 < utf16Length) {
                    const nextCharCode = str.charCodeAt(i16 + 1);
                    if (nextCharCode >= 56320 && nextCharCode <= 57343) {
                        codePoint = (charCode - 55296 << 10) + 65536 | nextCharCode - 56320;
                        wasSurrogatePair = true;
                    }
                }
            }
            if (computeIndicesMapping) {
                utf16OffsetToUtf8[i16] = i8;
                if (wasSurrogatePair) utf16OffsetToUtf8[i16 + 1] = i8;
                if (codePoint <= 127) utf8OffsetToUtf16[i8 + 0] = i16;
                else if (codePoint <= 2047) {
                    utf8OffsetToUtf16[i8 + 0] = i16;
                    utf8OffsetToUtf16[i8 + 1] = i16;
                } else if (codePoint <= 65535) {
                    utf8OffsetToUtf16[i8 + 0] = i16;
                    utf8OffsetToUtf16[i8 + 1] = i16;
                    utf8OffsetToUtf16[i8 + 2] = i16;
                } else {
                    utf8OffsetToUtf16[i8 + 0] = i16;
                    utf8OffsetToUtf16[i8 + 1] = i16;
                    utf8OffsetToUtf16[i8 + 2] = i16;
                    utf8OffsetToUtf16[i8 + 3] = i16;
                }
            }
            if (codePoint <= 127) utf8Value[i8++] = codePoint;
            else if (codePoint <= 2047) {
                utf8Value[i8++] = 192 | (codePoint & 1984) >>> 6;
                utf8Value[i8++] = 128 | (codePoint & 63) >>> 0;
            } else if (codePoint <= 65535) {
                utf8Value[i8++] = 224 | (codePoint & 61440) >>> 12;
                utf8Value[i8++] = 128 | (codePoint & 4032) >>> 6;
                utf8Value[i8++] = 128 | (codePoint & 63) >>> 0;
            } else {
                utf8Value[i8++] = 240 | (codePoint & 1835008) >>> 18;
                utf8Value[i8++] = 128 | (codePoint & 258048) >>> 12;
                utf8Value[i8++] = 128 | (codePoint & 4032) >>> 6;
                utf8Value[i8++] = 128 | (codePoint & 63) >>> 0;
            }
            if (wasSurrogatePair) i16++;
        }
        this.utf16Length = utf16Length;
        this.utf8Length = utf8Length;
        this.utf16Value = str;
        this.utf8Value = utf8Value;
        this.utf16OffsetToUtf8 = utf16OffsetToUtf8;
        this.utf8OffsetToUtf16 = utf8OffsetToUtf16;
    }
    static _utf8ByteLength(str) {
        let result = 0;
        for(let i = 0, len = str.length; i < len; i++){
            const charCode = str.charCodeAt(i);
            let codepoint = charCode;
            let wasSurrogatePair = false;
            if (charCode >= 55296 && charCode <= 56319) {
                if (i + 1 < len) {
                    const nextCharCode = str.charCodeAt(i + 1);
                    if (nextCharCode >= 56320 && nextCharCode <= 57343) {
                        codepoint = (charCode - 55296 << 10) + 65536 | nextCharCode - 56320;
                        wasSurrogatePair = true;
                    }
                }
            }
            if (codepoint <= 127) result += 1;
            else if (codepoint <= 2047) result += 2;
            else if (codepoint <= 65535) result += 3;
            else result += 4;
            if (wasSurrogatePair) i++;
        }
        return result;
    }
    createString(onigBinding2) {
        const result = onigBinding2.omalloc(this.utf8Length);
        onigBinding2.HEAPU8.set(this.utf8Value, result);
        return result;
    }
}
const $7c049fd770a07e8d$var$_OnigString = class _OnigString {
    constructor(str){
        $7c049fd770a07e8d$var$__publicField(this, "id", ++_OnigString.LAST_ID);
        $7c049fd770a07e8d$var$__publicField(this, "_onigBinding");
        $7c049fd770a07e8d$var$__publicField(this, "content");
        $7c049fd770a07e8d$var$__publicField(this, "utf16Length");
        $7c049fd770a07e8d$var$__publicField(this, "utf8Length");
        $7c049fd770a07e8d$var$__publicField(this, "utf16OffsetToUtf8");
        $7c049fd770a07e8d$var$__publicField(this, "utf8OffsetToUtf16");
        $7c049fd770a07e8d$var$__publicField(this, "ptr");
        if (!$7c049fd770a07e8d$var$onigBinding) throw new $7c049fd770a07e8d$var$ShikiError("Must invoke loadWasm first.");
        this._onigBinding = $7c049fd770a07e8d$var$onigBinding;
        this.content = str;
        const utfString = new $7c049fd770a07e8d$var$UtfString(str);
        this.utf16Length = utfString.utf16Length;
        this.utf8Length = utfString.utf8Length;
        this.utf16OffsetToUtf8 = utfString.utf16OffsetToUtf8;
        this.utf8OffsetToUtf16 = utfString.utf8OffsetToUtf16;
        if (this.utf8Length < 1e4 && !_OnigString._sharedPtrInUse) {
            if (!_OnigString._sharedPtr) _OnigString._sharedPtr = $7c049fd770a07e8d$var$onigBinding.omalloc(1e4);
            _OnigString._sharedPtrInUse = true;
            $7c049fd770a07e8d$var$onigBinding.HEAPU8.set(utfString.utf8Value, _OnigString._sharedPtr);
            this.ptr = _OnigString._sharedPtr;
        } else this.ptr = utfString.createString($7c049fd770a07e8d$var$onigBinding);
    }
    convertUtf8OffsetToUtf16(utf8Offset) {
        if (this.utf8OffsetToUtf16) {
            if (utf8Offset < 0) return 0;
            if (utf8Offset > this.utf8Length) return this.utf16Length;
            return this.utf8OffsetToUtf16[utf8Offset];
        }
        return utf8Offset;
    }
    convertUtf16OffsetToUtf8(utf16Offset) {
        if (this.utf16OffsetToUtf8) {
            if (utf16Offset < 0) return 0;
            if (utf16Offset > this.utf16Length) return this.utf8Length;
            return this.utf16OffsetToUtf8[utf16Offset];
        }
        return utf16Offset;
    }
    dispose() {
        if (this.ptr === _OnigString._sharedPtr) _OnigString._sharedPtrInUse = false;
        else this._onigBinding.ofree(this.ptr);
    }
};
$7c049fd770a07e8d$var$__publicField($7c049fd770a07e8d$var$_OnigString, "LAST_ID", 0);
$7c049fd770a07e8d$var$__publicField($7c049fd770a07e8d$var$_OnigString, "_sharedPtr", 0);
// a pointer to a string of 10000 bytes
$7c049fd770a07e8d$var$__publicField($7c049fd770a07e8d$var$_OnigString, "_sharedPtrInUse", false);
let $7c049fd770a07e8d$var$OnigString = $7c049fd770a07e8d$var$_OnigString;
class $7c049fd770a07e8d$var$OnigScanner {
    constructor(patterns){
        $7c049fd770a07e8d$var$__publicField(this, "_onigBinding");
        $7c049fd770a07e8d$var$__publicField(this, "_ptr");
        if (!$7c049fd770a07e8d$var$onigBinding) throw new $7c049fd770a07e8d$var$ShikiError("Must invoke loadWasm first.");
        const strPtrsArr = [];
        const strLenArr = [];
        for(let i = 0, len = patterns.length; i < len; i++){
            const utfString = new $7c049fd770a07e8d$var$UtfString(patterns[i]);
            strPtrsArr[i] = utfString.createString($7c049fd770a07e8d$var$onigBinding);
            strLenArr[i] = utfString.utf8Length;
        }
        const strPtrsPtr = $7c049fd770a07e8d$var$onigBinding.omalloc(4 * patterns.length);
        $7c049fd770a07e8d$var$onigBinding.HEAPU32.set(strPtrsArr, strPtrsPtr / 4);
        const strLenPtr = $7c049fd770a07e8d$var$onigBinding.omalloc(4 * patterns.length);
        $7c049fd770a07e8d$var$onigBinding.HEAPU32.set(strLenArr, strLenPtr / 4);
        const scannerPtr = $7c049fd770a07e8d$var$onigBinding.createOnigScanner(strPtrsPtr, strLenPtr, patterns.length);
        for(let i = 0, len = patterns.length; i < len; i++)$7c049fd770a07e8d$var$onigBinding.ofree(strPtrsArr[i]);
        $7c049fd770a07e8d$var$onigBinding.ofree(strLenPtr);
        $7c049fd770a07e8d$var$onigBinding.ofree(strPtrsPtr);
        if (scannerPtr === 0) $7c049fd770a07e8d$var$throwLastOnigError($7c049fd770a07e8d$var$onigBinding);
        this._onigBinding = $7c049fd770a07e8d$var$onigBinding;
        this._ptr = scannerPtr;
    }
    dispose() {
        this._onigBinding.freeOnigScanner(this._ptr);
    }
    findNextMatchSync(string, startPosition, arg) {
        let options = 0 /* None */ ;
        if (typeof arg === "number") options = arg;
        if (typeof string === "string") {
            string = new $7c049fd770a07e8d$var$OnigString(string);
            const result = this._findNextMatchSync(string, startPosition, false, options);
            string.dispose();
            return result;
        }
        return this._findNextMatchSync(string, startPosition, false, options);
    }
    _findNextMatchSync(string, startPosition, debugCall, options) {
        const onigBinding2 = this._onigBinding;
        const resultPtr = onigBinding2.findNextOnigScannerMatch(this._ptr, string.id, string.ptr, string.utf8Length, string.convertUtf16OffsetToUtf8(startPosition), options);
        if (resultPtr === 0) return null;
        const HEAPU32 = onigBinding2.HEAPU32;
        let offset = resultPtr / 4;
        const index = HEAPU32[offset++];
        const count = HEAPU32[offset++];
        const captureIndices = [];
        for(let i = 0; i < count; i++){
            const beg = string.convertUtf8OffsetToUtf16(HEAPU32[offset++]);
            const end = string.convertUtf8OffsetToUtf16(HEAPU32[offset++]);
            captureIndices[i] = {
                start: beg,
                end: end,
                length: end - beg
            };
        }
        return {
            index: index,
            captureIndices: captureIndices
        };
    }
}
function $7c049fd770a07e8d$var$isInstantiatorOptionsObject(dataOrOptions) {
    return typeof dataOrOptions.instantiator === "function";
}
function $7c049fd770a07e8d$var$isInstantiatorModule(dataOrOptions) {
    return typeof dataOrOptions.default === "function";
}
function $7c049fd770a07e8d$var$isDataOptionsObject(dataOrOptions) {
    return typeof dataOrOptions.data !== "undefined";
}
function $7c049fd770a07e8d$var$isResponse(dataOrOptions) {
    return typeof Response !== "undefined" && dataOrOptions instanceof Response;
}
function $7c049fd770a07e8d$var$isArrayBuffer(data) {
    return typeof ArrayBuffer !== "undefined" && (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) || typeof $7c049fd770a07e8d$require$Buffer !== "undefined" && $7c049fd770a07e8d$require$Buffer.isBuffer?.(data) || typeof SharedArrayBuffer !== "undefined" && data instanceof SharedArrayBuffer || typeof Uint32Array !== "undefined" && data instanceof Uint32Array;
}
let $7c049fd770a07e8d$var$initPromise;
function $7c049fd770a07e8d$export$2fb43d49c8cdf2b1(options) {
    if ($7c049fd770a07e8d$var$initPromise) return $7c049fd770a07e8d$var$initPromise;
    async function _load() {
        $7c049fd770a07e8d$var$onigBinding = await $7c049fd770a07e8d$var$main(async (info)=>{
            let instance = options;
            instance = await instance;
            if (typeof instance === "function") instance = await instance(info);
            if (typeof instance === "function") instance = await instance(info);
            if ($7c049fd770a07e8d$var$isInstantiatorOptionsObject(instance)) instance = await instance.instantiator(info);
            else if ($7c049fd770a07e8d$var$isInstantiatorModule(instance)) instance = await instance.default(info);
            else {
                if ($7c049fd770a07e8d$var$isDataOptionsObject(instance)) instance = instance.data;
                if ($7c049fd770a07e8d$var$isResponse(instance)) {
                    if (typeof WebAssembly.instantiateStreaming === "function") instance = await $7c049fd770a07e8d$var$_makeResponseStreamingLoader(instance)(info);
                    else instance = await $7c049fd770a07e8d$var$_makeResponseNonStreamingLoader(instance)(info);
                } else if ($7c049fd770a07e8d$var$isArrayBuffer(instance)) instance = await $7c049fd770a07e8d$var$_makeArrayBufferLoader(instance)(info);
                else if (instance instanceof WebAssembly.Module) instance = await $7c049fd770a07e8d$var$_makeArrayBufferLoader(instance)(info);
                else if ("default" in instance && instance.default instanceof WebAssembly.Module) instance = await $7c049fd770a07e8d$var$_makeArrayBufferLoader(instance.default)(info);
            }
            if ("instance" in instance) instance = instance.instance;
            if ("exports" in instance) instance = instance.exports;
            return instance;
        });
    }
    $7c049fd770a07e8d$var$initPromise = _load();
    return $7c049fd770a07e8d$var$initPromise;
}
function $7c049fd770a07e8d$var$_makeArrayBufferLoader(data) {
    return (importObject)=>WebAssembly.instantiate(data, importObject);
}
function $7c049fd770a07e8d$var$_makeResponseStreamingLoader(data) {
    return (importObject)=>WebAssembly.instantiateStreaming(data, importObject);
}
function $7c049fd770a07e8d$var$_makeResponseNonStreamingLoader(data) {
    return async (importObject)=>{
        const arrayBuffer = await data.arrayBuffer();
        return WebAssembly.instantiate(arrayBuffer, importObject);
    };
}
let $7c049fd770a07e8d$var$_defaultWasmLoader;
function $7c049fd770a07e8d$export$f36d8d1c7b5211c4(_loader) {
    $7c049fd770a07e8d$var$_defaultWasmLoader = _loader;
}
function $7c049fd770a07e8d$export$99a7f31e392436a6() {
    return $7c049fd770a07e8d$var$_defaultWasmLoader;
}
async function $7c049fd770a07e8d$export$aecbd6e886bd9a16(options) {
    if (options) await $7c049fd770a07e8d$export$2fb43d49c8cdf2b1(options);
    return {
        createScanner (patterns) {
            return new $7c049fd770a07e8d$var$OnigScanner(patterns.map((p)=>typeof p === "string" ? p : p.source));
        },
        createString (s) {
            return new $7c049fd770a07e8d$var$OnigString(s);
        }
    };
}



const $57ed8b60370ea5fd$export$615c15ca8b0fd571 = /* @__PURE__ */ (0, $047e2e8c411a40db$export$8ca362031a26944a)({
    langs: (0, $f9082090a7ce57f6$export$318f38c9fe99838b),
    themes: (0, $ae97e0ad66dd4e9b$export$b55f4ff8dd492310),
    engine: ()=>(0, $7c049fd770a07e8d$export$aecbd6e886bd9a16)((parcelRequire("amcJb")))
});
const { codeToHtml: $57ed8b60370ea5fd$export$74ba11990fba86b4, codeToHast: $57ed8b60370ea5fd$export$9b49c0a3202a858c, codeToTokens: $57ed8b60370ea5fd$export$93965dfc9a82f052, codeToTokensBase: $57ed8b60370ea5fd$export$9fcc555cdbb165d8, codeToTokensWithThemes: $57ed8b60370ea5fd$export$99552db3190ba9d3, getSingletonHighlighter: $57ed8b60370ea5fd$export$b1276848bb7d1d91, getLastGrammarState: $57ed8b60370ea5fd$export$e79a48b8b5fd83c5 } = /* @__PURE__ */ (0, $047e2e8c411a40db$export$3706d1cd2b0dba33)($57ed8b60370ea5fd$export$615c15ca8b0fd571, {
    guessEmbeddedLanguages: $047e2e8c411a40db$export$5f773a1df8c6e1aa
});

// src/utils.js
"use strict";
function $c99286ead618e025$export$3226cf1d9b7b4bea(e) {
    if ([
        ...e
    ].length !== 1) throw new Error(`Expected "${e}" to be a single code point`);
    return e.codePointAt(0);
}
function $c99286ead618e025$export$c4ed59b257196722(e, t, n) {
    return e.has(t) || e.set(t, n), e.get(t);
}
const $c99286ead618e025$export$7b650c03beb4e566 = new Set([
    "alnum",
    "alpha",
    "ascii",
    "blank",
    "cntrl",
    "digit",
    "graph",
    "lower",
    "print",
    "punct",
    "space",
    "upper",
    "word",
    "xdigit"
]), $c99286ead618e025$export$43caf9889c228507 = String.raw;
function $c99286ead618e025$export$3b765e00c48ca2ba(e, t) {
    if (e == null) throw new Error(t ?? "Value expected");
    return e;
}


"use strict";
const $44e29ec366021ed3$var$m = (0, $c99286ead618e025$export$43caf9889c228507)`\[\^?`, $44e29ec366021ed3$var$b = `c.? | C(?:-.?)?|${(0, $c99286ead618e025$export$43caf9889c228507)`[pP]\{(?:\^?[-\x20_]*[A-Za-z][-\x20\w]*\})?`}|${(0, $c99286ead618e025$export$43caf9889c228507)`x[89A-Fa-f]\p{AHex}(?:\\x[89A-Fa-f]\p{AHex})*`}|${(0, $c99286ead618e025$export$43caf9889c228507)`u(?:\p{AHex}{4})? | x\{[^\}]*\}? | x\p{AHex}{0,2}`}|${(0, $c99286ead618e025$export$43caf9889c228507)`o\{[^\}]*\}?`}|${(0, $c99286ead618e025$export$43caf9889c228507)`\d{1,3}`}`, $44e29ec366021ed3$var$y = /[?*+][?+]?|\{(?:\d+(?:,\d*)?|,\d+)\}\??/, $44e29ec366021ed3$var$C = new RegExp((0, $c99286ead618e025$export$43caf9889c228507)`
  \\ (?:
    ${$44e29ec366021ed3$var$b}
    | [gk]<[^>]*>?
    | [gk]'[^']*'?
    | .
  )
  | \( (?:
    \? (?:
      [:=!>({]
      | <[=!]
      | <[^>]*>
      | '[^']*'
      | ~\|?
      | #(?:[^)\\]|\\.?)*
      | [^:)]*[:)]
    )?
    | \*[^\)]*\)?
  )?
  | (?:${$44e29ec366021ed3$var$y.source})+
  | ${$44e29ec366021ed3$var$m}
  | .
`.replace(/\s+/g, ""), "gsu"), $44e29ec366021ed3$var$T = new RegExp((0, $c99286ead618e025$export$43caf9889c228507)`
  \\ (?:
    ${$44e29ec366021ed3$var$b}
    | .
  )
  | \[:(?:\^?\p{Alpha}+|\^):\]
  | ${$44e29ec366021ed3$var$m}
  | &&
  | .
`.replace(/\s+/g, ""), "gsu");
function $44e29ec366021ed3$export$660b2ee2d4fb4eff(e, n = {}) {
    const t = {
        flags: "",
        ...n,
        rules: {
            captureGroup: !1,
            singleline: !1,
            ...n.rules
        }
    };
    if (typeof e != "string") throw new Error("String expected as pattern");
    const o = $44e29ec366021ed3$var$Y(t.flags), s = [
        o.extended
    ], a = {
        captureGroup: t.rules.captureGroup,
        getCurrentModX () {
            return s.at(-1);
        },
        numOpenGroups: 0,
        popModX () {
            s.pop();
        },
        pushModX (u) {
            s.push(u);
        },
        replaceCurrentModX (u) {
            s[s.length - 1] = u;
        },
        singleline: t.rules.singleline
    };
    let r = [], i;
    for($44e29ec366021ed3$var$C.lastIndex = 0; i = $44e29ec366021ed3$var$C.exec(e);){
        const u = $44e29ec366021ed3$var$F(a, e, i[0], $44e29ec366021ed3$var$C.lastIndex);
        u.tokens ? r.push(...u.tokens) : u.token && r.push(u.token), u.lastIndex !== void 0 && ($44e29ec366021ed3$var$C.lastIndex = u.lastIndex);
    }
    const l = [];
    let c = 0;
    r.filter((u)=>u.type === "GroupOpen").forEach((u)=>{
        u.kind === "capturing" ? u.number = ++c : u.raw === "(" && l.push(u);
    }), c || l.forEach((u, S)=>{
        u.kind = "capturing", u.number = S + 1;
    });
    const g = c || l.length;
    return {
        tokens: r.map((u)=>u.type === "EscapedNumber" ? $44e29ec366021ed3$var$ee(u, g) : u).flat(),
        flags: o
    };
}
function $44e29ec366021ed3$var$F(e, n, t, o) {
    const [s, a] = t;
    if (t === "[" || t === "[^") {
        const r = $44e29ec366021ed3$var$K(n, t, o);
        return {
            tokens: r.tokens,
            lastIndex: r.lastIndex
        };
    }
    if (s === "\\") {
        if ("AbBGyYzZ".includes(a)) return {
            token: $44e29ec366021ed3$var$w(t, t)
        };
        if (/^\\g[<']/.test(t)) {
            if (!/^\\g(?:<[^>]+>|'[^']+')$/.test(t)) throw new Error(`Invalid group name "${t}"`);
            return {
                token: $44e29ec366021ed3$var$R(t)
            };
        }
        if (/^\\k[<']/.test(t)) {
            if (!/^\\k(?:<[^>]+>|'[^']+')$/.test(t)) throw new Error(`Invalid group name "${t}"`);
            return {
                token: $44e29ec366021ed3$var$A(t)
            };
        }
        if (a === "K") return {
            token: $44e29ec366021ed3$var$I("keep", t)
        };
        if (a === "N" || a === "R") return {
            token: $44e29ec366021ed3$var$k("newline", t, {
                negate: a === "N"
            })
        };
        if (a === "O") return {
            token: $44e29ec366021ed3$var$k("any", t)
        };
        if (a === "X") return {
            token: $44e29ec366021ed3$var$k("text_segment", t)
        };
        const r = $44e29ec366021ed3$var$x(t, {
            inCharClass: !1
        });
        return Array.isArray(r) ? {
            tokens: r
        } : {
            token: r
        };
    }
    if (s === "(") {
        if (a === "*") return {
            token: $44e29ec366021ed3$var$j(t)
        };
        if (t === "(?{") throw new Error(`Unsupported callout "${t}"`);
        if (t.startsWith("(?#")) {
            if (n[o] !== ")") throw new Error('Unclosed comment group "(?#"');
            return {
                lastIndex: o + 1
            };
        }
        if (/^\(\?[-imx]+[:)]$/.test(t)) return {
            token: $44e29ec366021ed3$var$L(t, e)
        };
        if (e.pushModX(e.getCurrentModX()), e.numOpenGroups++, t === "(" && !e.captureGroup || t === "(?:") return {
            token: $44e29ec366021ed3$var$f("group", t)
        };
        if (t === "(?>") return {
            token: $44e29ec366021ed3$var$f("atomic", t)
        };
        if (t === "(?=" || t === "(?!" || t === "(?<=" || t === "(?<!") return {
            token: $44e29ec366021ed3$var$f(t[2] === "<" ? "lookbehind" : "lookahead", t, {
                negate: t.endsWith("!")
            })
        };
        if (t === "(" && e.captureGroup || t.startsWith("(?<") && t.endsWith(">") || t.startsWith("(?'") && t.endsWith("'")) return {
            token: $44e29ec366021ed3$var$f("capturing", t, {
                ...t !== "(" && {
                    name: t.slice(3, -1)
                }
            })
        };
        if (t.startsWith("(?~")) {
            if (t === "(?~|") throw new Error(`Unsupported absence function kind "${t}"`);
            return {
                token: $44e29ec366021ed3$var$f("absence_repeater", t)
            };
        }
        throw t === "(?(" ? new Error(`Unsupported conditional "${t}"`) : new Error(`Invalid or unsupported group option "${t}"`);
    }
    if (t === ")") {
        if (e.popModX(), e.numOpenGroups--, e.numOpenGroups < 0) throw new Error('Unmatched ")"');
        return {
            token: $44e29ec366021ed3$var$Q(t)
        };
    }
    if (e.getCurrentModX()) {
        if (t === "#") {
            const r = n.indexOf(`
`, o);
            return {
                lastIndex: r === -1 ? n.length : r
            };
        }
        if (/^\s$/.test(t)) {
            const r = /\s+/y;
            return r.lastIndex = o, {
                lastIndex: r.exec(n) ? r.lastIndex : o
            };
        }
    }
    if (t === ".") return {
        token: $44e29ec366021ed3$var$k("dot", t)
    };
    if (t === "^" || t === "$") {
        const r = e.singleline ? ({
            "^": (0, $c99286ead618e025$export$43caf9889c228507)`\A`,
            $: (0, $c99286ead618e025$export$43caf9889c228507)`\Z`
        })[t] : t;
        return {
            token: $44e29ec366021ed3$var$w(r, t)
        };
    }
    return t === "|" ? {
        token: $44e29ec366021ed3$var$P(t)
    } : $44e29ec366021ed3$var$y.test(t) ? {
        tokens: $44e29ec366021ed3$var$te(t)
    } : {
        token: $44e29ec366021ed3$var$d((0, $c99286ead618e025$export$3226cf1d9b7b4bea)(t), t)
    };
}
function $44e29ec366021ed3$var$K(e, n, t) {
    const o = [
        $44e29ec366021ed3$var$E(n[1] === "^", n)
    ];
    let s = 1, a;
    for($44e29ec366021ed3$var$T.lastIndex = t; a = $44e29ec366021ed3$var$T.exec(e);){
        const r = a[0];
        if (r[0] === "[" && r[1] !== ":") s++, o.push($44e29ec366021ed3$var$E(r[1] === "^", r));
        else if (r === "]") {
            if (o.at(-1).type === "CharacterClassOpen") o.push($44e29ec366021ed3$var$d(93, r));
            else if (s--, o.push($44e29ec366021ed3$var$z(r)), !s) break;
        } else {
            const i = $44e29ec366021ed3$var$X(r);
            Array.isArray(i) ? o.push(...i) : o.push(i);
        }
    }
    return {
        tokens: o,
        lastIndex: $44e29ec366021ed3$var$T.lastIndex || e.length
    };
}
function $44e29ec366021ed3$var$X(e) {
    if (e[0] === "\\") return $44e29ec366021ed3$var$x(e, {
        inCharClass: !0
    });
    if (e[0] === "[") {
        const n = /\[:(?<negate>\^?)(?<name>[a-z]+):\]/.exec(e);
        if (!n || !(0, $c99286ead618e025$export$7b650c03beb4e566).has(n.groups.name)) throw new Error(`Invalid POSIX class "${e}"`);
        return $44e29ec366021ed3$var$k("posix", e, {
            value: n.groups.name,
            negate: !!n.groups.negate
        });
    }
    return e === "-" ? $44e29ec366021ed3$var$U(e) : e === "&&" ? $44e29ec366021ed3$var$H(e) : $44e29ec366021ed3$var$d((0, $c99286ead618e025$export$3226cf1d9b7b4bea)(e), e);
}
function $44e29ec366021ed3$var$x(e, { inCharClass: n }) {
    const t = e[1];
    if (t === "c" || t === "C") return $44e29ec366021ed3$var$Z(e);
    if ("dDhHsSwW".includes(t)) return $44e29ec366021ed3$var$q(e);
    if (e.startsWith((0, $c99286ead618e025$export$43caf9889c228507)`\o{`)) throw new Error(`Incomplete, invalid, or unsupported octal code point "${e}"`);
    if (/^\\[pP]\{/.test(e)) {
        if (e.length === 3) throw new Error(`Incomplete or invalid Unicode property "${e}"`);
        return $44e29ec366021ed3$var$V(e);
    }
    if (/^\\x[89A-Fa-f]\p{AHex}/u.test(e)) try {
        const o = e.split(/\\x/).slice(1).map((i)=>parseInt(i, 16)), s = new TextDecoder("utf-8", {
            ignoreBOM: !0,
            fatal: !0
        }).decode(new Uint8Array(o)), a = new TextEncoder;
        return [
            ...s
        ].map((i)=>{
            const l = [
                ...a.encode(i)
            ].map((c)=>`\\x${c.toString(16)}`).join("");
            return $44e29ec366021ed3$var$d((0, $c99286ead618e025$export$3226cf1d9b7b4bea)(i), l);
        });
    } catch  {
        throw new Error(`Multibyte code "${e}" incomplete or invalid in Oniguruma`);
    }
    if (t === "u" || t === "x") return $44e29ec366021ed3$var$d($44e29ec366021ed3$var$J(e), e);
    if ($44e29ec366021ed3$var$$.has(t)) return $44e29ec366021ed3$var$d($44e29ec366021ed3$var$$.get(t), e);
    if (/\d/.test(t)) return $44e29ec366021ed3$var$W(n, e);
    if (e === "\\") throw new Error((0, $c99286ead618e025$export$43caf9889c228507)`Incomplete escape "\"`);
    if (t === "M") throw new Error(`Unsupported meta "${e}"`);
    if ([
        ...e
    ].length === 2) return $44e29ec366021ed3$var$d(e.codePointAt(1), e);
    throw new Error(`Unexpected escape "${e}"`);
}
function $44e29ec366021ed3$var$P(e) {
    return {
        type: "Alternator",
        raw: e
    };
}
function $44e29ec366021ed3$var$w(e, n) {
    return {
        type: "Assertion",
        kind: e,
        raw: n
    };
}
function $44e29ec366021ed3$var$A(e) {
    return {
        type: "Backreference",
        raw: e
    };
}
function $44e29ec366021ed3$var$d(e, n) {
    return {
        type: "Character",
        value: e,
        raw: n
    };
}
function $44e29ec366021ed3$var$z(e) {
    return {
        type: "CharacterClassClose",
        raw: e
    };
}
function $44e29ec366021ed3$var$U(e) {
    return {
        type: "CharacterClassHyphen",
        raw: e
    };
}
function $44e29ec366021ed3$var$H(e) {
    return {
        type: "CharacterClassIntersector",
        raw: e
    };
}
function $44e29ec366021ed3$var$E(e, n) {
    return {
        type: "CharacterClassOpen",
        negate: e,
        raw: n
    };
}
function $44e29ec366021ed3$var$k(e, n, t = {}) {
    return {
        type: "CharacterSet",
        kind: e,
        ...t,
        raw: n
    };
}
function $44e29ec366021ed3$var$I(e, n, t = {}) {
    return e === "keep" ? {
        type: "Directive",
        kind: e,
        raw: n
    } : {
        type: "Directive",
        kind: e,
        flags: (0, $c99286ead618e025$export$3b765e00c48ca2ba)(t.flags),
        raw: n
    };
}
function $44e29ec366021ed3$var$W(e, n) {
    return {
        type: "EscapedNumber",
        inCharClass: e,
        raw: n
    };
}
function $44e29ec366021ed3$var$Q(e) {
    return {
        type: "GroupClose",
        raw: e
    };
}
function $44e29ec366021ed3$var$f(e, n, t = {}) {
    return {
        type: "GroupOpen",
        kind: e,
        ...t,
        raw: n
    };
}
function $44e29ec366021ed3$var$D(e, n, t, o) {
    return {
        type: "NamedCallout",
        kind: e,
        tag: n,
        arguments: t,
        raw: o
    };
}
function $44e29ec366021ed3$var$_(e, n, t, o) {
    return {
        type: "Quantifier",
        kind: e,
        min: n,
        max: t,
        raw: o
    };
}
function $44e29ec366021ed3$var$R(e) {
    return {
        type: "Subroutine",
        raw: e
    };
}
const $44e29ec366021ed3$var$B = new Set([
    "COUNT",
    "CMP",
    "ERROR",
    "FAIL",
    "MAX",
    "MISMATCH",
    "SKIP",
    "TOTAL_COUNT"
]), $44e29ec366021ed3$var$$ = new Map([
    [
        "a",
        7
    ],
    [
        "b",
        8
    ],
    [
        "e",
        27
    ],
    [
        "f",
        12
    ],
    [
        "n",
        10
    ],
    [
        "r",
        13
    ],
    [
        "t",
        9
    ],
    [
        "v",
        11
    ]
]);
function $44e29ec366021ed3$var$Z(e) {
    const n = e[1] === "c" ? e[2] : e[3];
    if (!n || !/[A-Za-z]/.test(n)) throw new Error(`Unsupported control character "${e}"`);
    return $44e29ec366021ed3$var$d((0, $c99286ead618e025$export$3226cf1d9b7b4bea)(n.toUpperCase()) - 64, e);
}
function $44e29ec366021ed3$var$L(e, n) {
    let { on: t, off: o } = /^\(\?(?<on>[imx]*)(?:-(?<off>[-imx]*))?/.exec(e).groups;
    o ??= "";
    const s = (n.getCurrentModX() || t.includes("x")) && !o.includes("x"), a = $44e29ec366021ed3$var$v(t), r = $44e29ec366021ed3$var$v(o), i = {};
    if (a && (i.enable = a), r && (i.disable = r), e.endsWith(")")) return n.replaceCurrentModX(s), $44e29ec366021ed3$var$I("flags", e, {
        flags: i
    });
    if (e.endsWith(":")) return n.pushModX(s), n.numOpenGroups++, $44e29ec366021ed3$var$f("group", e, {
        ...(a || r) && {
            flags: i
        }
    });
    throw new Error(`Unexpected flag modifier "${e}"`);
}
function $44e29ec366021ed3$var$j(e) {
    const n = /\(\*(?<name>[A-Za-z_]\w*)?(?:\[(?<tag>(?:[A-Za-z_]\w*)?)\])?(?:\{(?<args>[^}]*)\})?\)/.exec(e);
    if (!n) throw new Error(`Incomplete or invalid named callout "${e}"`);
    const { name: t, tag: o, args: s } = n.groups;
    if (!t) throw new Error(`Invalid named callout "${e}"`);
    if (o === "") throw new Error(`Named callout tag with empty value not allowed "${e}"`);
    const a = s ? s.split(",").filter((g)=>g !== "").map((g)=>/^[+-]?\d+$/.test(g) ? +g : g) : [], [r, i, l] = a, c = $44e29ec366021ed3$var$B.has(t) ? t.toLowerCase() : "custom";
    switch(c){
        case "fail":
        case "mismatch":
        case "skip":
            if (a.length > 0) throw new Error(`Named callout arguments not allowed "${a}"`);
            break;
        case "error":
            if (a.length > 1) throw new Error(`Named callout allows only one argument "${a}"`);
            if (typeof r == "string") throw new Error(`Named callout argument must be a number "${r}"`);
            break;
        case "max":
            if (!a.length || a.length > 2) throw new Error(`Named callout must have one or two arguments "${a}"`);
            if (typeof r == "string" && !/^[A-Za-z_]\w*$/.test(r)) throw new Error(`Named callout argument one must be a tag or number "${r}"`);
            if (a.length === 2 && (typeof i == "number" || !/^[<>X]$/.test(i))) throw new Error(`Named callout optional argument two must be '<', '>', or 'X' "${i}"`);
            break;
        case "count":
        case "total_count":
            if (a.length > 1) throw new Error(`Named callout allows only one argument "${a}"`);
            if (a.length === 1 && (typeof r == "number" || !/^[<>X]$/.test(r))) throw new Error(`Named callout optional argument must be '<', '>', or 'X' "${r}"`);
            break;
        case "cmp":
            if (a.length !== 3) throw new Error(`Named callout must have three arguments "${a}"`);
            if (typeof r == "string" && !/^[A-Za-z_]\w*$/.test(r)) throw new Error(`Named callout argument one must be a tag or number "${r}"`);
            if (typeof i == "number" || !/^(?:[<>!=]=|[<>])$/.test(i)) throw new Error(`Named callout argument two must be '==', '!=', '>', '<', '>=', or '<=' "${i}"`);
            if (typeof l == "string" && !/^[A-Za-z_]\w*$/.test(l)) throw new Error(`Named callout argument three must be a tag or number "${l}"`);
            break;
        case "custom":
            throw new Error(`Undefined callout name "${t}"`);
        default:
            throw new Error(`Unexpected named callout kind "${c}"`);
    }
    return $44e29ec366021ed3$var$D(c, o ?? null, s?.split(",") ?? null, e);
}
function $44e29ec366021ed3$var$O(e) {
    let n = null, t, o;
    if (e[0] === "{") {
        const { minStr: s, maxStr: a } = /^\{(?<minStr>\d*)(?:,(?<maxStr>\d*))?/.exec(e).groups, r = 1e5;
        if (+s > r || a && +a > r) throw new Error("Quantifier value unsupported in Oniguruma");
        if (t = +s, o = a === void 0 ? +s : a === "" ? 1 / 0 : +a, t > o && (n = "possessive", [t, o] = [
            o,
            t
        ]), e.endsWith("?")) {
            if (n === "possessive") throw new Error('Unsupported possessive interval quantifier chain with "?"');
            n = "lazy";
        } else n || (n = "greedy");
    } else t = e[0] === "+" ? 1 : 0, o = e[0] === "?" ? 1 : 1 / 0, n = e[1] === "+" ? "possessive" : e[1] === "?" ? "lazy" : "greedy";
    return $44e29ec366021ed3$var$_(n, t, o, e);
}
function $44e29ec366021ed3$var$q(e) {
    const n = e[1].toLowerCase();
    return $44e29ec366021ed3$var$k({
        d: "digit",
        h: "hex",
        s: "space",
        w: "word"
    }[n], e, {
        negate: e[1] !== n
    });
}
function $44e29ec366021ed3$var$V(e) {
    const { p: n, neg: t, value: o } = /^\\(?<p>[pP])\{(?<neg>\^?)(?<value>[^}]+)/.exec(e).groups;
    return $44e29ec366021ed3$var$k("property", e, {
        value: o,
        negate: n === "P" && !t || n === "p" && !!t
    });
}
function $44e29ec366021ed3$var$v(e) {
    const n = {};
    return e.includes("i") && (n.ignoreCase = !0), e.includes("m") && (n.dotAll = !0), e.includes("x") && (n.extended = !0), Object.keys(n).length ? n : null;
}
function $44e29ec366021ed3$var$Y(e) {
    const n = {
        ignoreCase: !1,
        dotAll: !1,
        extended: !1,
        digitIsAscii: !1,
        posixIsAscii: !1,
        spaceIsAscii: !1,
        wordIsAscii: !1,
        textSegmentMode: null
    };
    for(let t = 0; t < e.length; t++){
        const o = e[t];
        if (!"imxDPSWy".includes(o)) throw new Error(`Invalid flag "${o}"`);
        if (o === "y") {
            if (!/^y{[gw]}/.test(e.slice(t))) throw new Error('Invalid or unspecified flag "y" mode');
            n.textSegmentMode = e[t + 2] === "g" ? "grapheme" : "word", t += 3;
            continue;
        }
        n[({
            i: "ignoreCase",
            m: "dotAll",
            x: "extended",
            D: "digitIsAscii",
            P: "posixIsAscii",
            S: "spaceIsAscii",
            W: "wordIsAscii"
        })[o]] = !0;
    }
    return n;
}
function $44e29ec366021ed3$var$J(e) {
    if (/^(?:\\u(?!\p{AHex}{4})|\\x(?!\p{AHex}{1,2}|\{\p{AHex}{1,8}\}))/u.test(e)) throw new Error(`Incomplete or invalid escape "${e}"`);
    const n = e[2] === "{" ? /^\\x\{\s*(?<hex>\p{AHex}+)/u.exec(e).groups.hex : e.slice(2);
    return parseInt(n, 16);
}
function $44e29ec366021ed3$var$ee(e, n) {
    const { raw: t, inCharClass: o } = e, s = t.slice(1);
    if (!o && (s !== "0" && s.length === 1 || s[0] !== "0" && +s <= n)) return [
        $44e29ec366021ed3$var$A(t)
    ];
    const a = [], r = s.match(/^[0-7]+|\d/g);
    for(let i = 0; i < r.length; i++){
        const l = r[i];
        let c;
        if (i === 0 && l !== "8" && l !== "9") {
            if (c = parseInt(l, 8), c > 127) throw new Error((0, $c99286ead618e025$export$43caf9889c228507)`Octal encoded byte above 177 unsupported "${t}"`);
        } else c = (0, $c99286ead618e025$export$3226cf1d9b7b4bea)(l);
        a.push($44e29ec366021ed3$var$d(c, (i === 0 ? "\\" : "") + l));
    }
    return a;
}
function $44e29ec366021ed3$var$te(e) {
    const n = [], t = new RegExp($44e29ec366021ed3$var$y, "gy");
    let o;
    for(; o = t.exec(e);){
        const s = o[0];
        if (s[0] === "{") {
            const a = /^\{(?<min>\d+),(?<max>\d+)\}\??$/.exec(s);
            if (a) {
                const { min: r, max: i } = a.groups;
                if (+r > +i && s.endsWith("?")) {
                    t.lastIndex--, n.push($44e29ec366021ed3$var$O(s.slice(0, -1)));
                    continue;
                }
            }
        }
        n.push($44e29ec366021ed3$var$O(s));
    }
    return n;
}



"use strict";
function $9adc2a332adf8d3e$export$dcb3ae0c3f199df3(e, t) {
    if (!Array.isArray(e.body)) throw new Error("Expected node with body array");
    if (e.body.length !== 1) return !1;
    const r = e.body[0];
    return !t || Object.keys(t).every((n)=>t[n] === r[n]);
}
function $9adc2a332adf8d3e$export$bce313fa0917d31c(e) {
    return !(!$9adc2a332adf8d3e$var$i.has(e.type) || e.type === "AbsenceFunction" && e.kind !== "repeater");
}
const $9adc2a332adf8d3e$var$i = new Set([
    "AbsenceFunction",
    "CapturingGroup",
    "Group",
    "LookaroundAssertion",
    "Regex"
]);
function $9adc2a332adf8d3e$export$ba95449642bd2f29(e) {
    return $9adc2a332adf8d3e$var$y.has(e.type);
}
const $9adc2a332adf8d3e$var$y = new Set([
    "AbsenceFunction",
    "Backreference",
    "CapturingGroup",
    "Character",
    "CharacterClass",
    "CharacterSet",
    "Group",
    "Quantifier",
    "Subroutine"
]);


"use strict";
function $4e3b66797d9e7d60$export$98e6a39c04603d36(e, r = {}) {
    const n = {
        flags: "",
        normalizeUnknownPropertyNames: !1,
        skipBackrefValidation: !1,
        skipLookbehindValidation: !1,
        skipPropertyNameValidation: !1,
        unicodePropertyMap: null,
        ...r,
        rules: {
            captureGroup: !1,
            singleline: !1,
            ...r.rules
        }
    }, o = (0, $44e29ec366021ed3$export$660b2ee2d4fb4eff)(e, {
        flags: n.flags,
        rules: {
            captureGroup: n.rules.captureGroup,
            singleline: n.rules.singleline
        }
    }), i = (p, N)=>{
        const u = o.tokens[t.nextIndex];
        switch(t.parent = p, t.nextIndex++, u.type){
            case "Alternator":
                return $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd();
            case "Assertion":
                return $4e3b66797d9e7d60$var$W(u);
            case "Backreference":
                return $4e3b66797d9e7d60$var$X(u, t);
            case "Character":
                return $4e3b66797d9e7d60$export$4d63783c2be0a38c(u.value, {
                    useLastValid: !!N.isCheckingRangeEnd
                });
            case "CharacterClassHyphen":
                return $4e3b66797d9e7d60$var$ee(u, t, N);
            case "CharacterClassOpen":
                return $4e3b66797d9e7d60$var$re(u, t, N);
            case "CharacterSet":
                return $4e3b66797d9e7d60$var$ne(u, t);
            case "Directive":
                return $4e3b66797d9e7d60$export$5b526547d047f0c5(u.kind, {
                    flags: u.flags
                });
            case "GroupOpen":
                return $4e3b66797d9e7d60$var$te(u, t, N);
            case "NamedCallout":
                return $4e3b66797d9e7d60$export$c55dc041d92a68d5(u.kind, u.tag, u.arguments);
            case "Quantifier":
                return $4e3b66797d9e7d60$var$oe(u, t);
            case "Subroutine":
                return $4e3b66797d9e7d60$var$ae(u, t);
            default:
                throw new Error(`Unexpected token type "${u.type}"`);
        }
    }, t = {
        capturingGroups: [],
        hasNumberedRef: !1,
        namedGroupsByName: new Map,
        nextIndex: 0,
        normalizeUnknownPropertyNames: n.normalizeUnknownPropertyNames,
        parent: null,
        skipBackrefValidation: n.skipBackrefValidation,
        skipLookbehindValidation: n.skipLookbehindValidation,
        skipPropertyNameValidation: n.skipPropertyNameValidation,
        subroutines: [],
        tokens: o.tokens,
        unicodePropertyMap: n.unicodePropertyMap,
        walk: i
    }, d = $4e3b66797d9e7d60$export$98d2929ccc6bd916($4e3b66797d9e7d60$export$bf8c332f00a76460(o.flags));
    let s = d.body[0];
    for(; t.nextIndex < o.tokens.length;){
        const p = i(s, {});
        p.type === "Alternative" ? (d.body.push(p), s = p) : s.body.push(p);
    }
    const { capturingGroups: a, hasNumberedRef: l, namedGroupsByName: c, subroutines: f } = t;
    if (l && c.size && !n.rules.captureGroup) throw new Error("Numbered backref/subroutine not allowed when using named capture");
    for (const { ref: p } of f)if (typeof p == "number") {
        if (p > a.length) throw new Error("Subroutine uses a group number that's not defined");
        p && (a[p - 1].isSubroutined = !0);
    } else if (c.has(p)) {
        if (c.get(p).length > 1) throw new Error((0, $c99286ead618e025$export$43caf9889c228507)`Subroutine uses a duplicate group name "\g<${p}>"`);
        c.get(p)[0].isSubroutined = !0;
    } else throw new Error((0, $c99286ead618e025$export$43caf9889c228507)`Subroutine uses a group name that's not defined "\g<${p}>"`);
    return d;
}
function $4e3b66797d9e7d60$var$W({ kind: e }) {
    return $4e3b66797d9e7d60$export$987f29926deb46c2((0, $c99286ead618e025$export$3b765e00c48ca2ba)({
        "^": "line_start",
        $: "line_end",
        "\\A": "string_start",
        "\\b": "word_boundary",
        "\\B": "word_boundary",
        "\\G": "search_start",
        "\\y": "text_segment_boundary",
        "\\Y": "text_segment_boundary",
        "\\z": "string_end",
        "\\Z": "string_end_newline"
    }[e], `Unexpected assertion kind "${e}"`), {
        negate: e === (0, $c99286ead618e025$export$43caf9889c228507)`\B` || e === (0, $c99286ead618e025$export$43caf9889c228507)`\Y`
    });
}
function $4e3b66797d9e7d60$var$X({ raw: e }, r) {
    const n = /^\\k[<']/.test(e), o = n ? e.slice(3, -1) : e.slice(1), i = (t, d = !1)=>{
        const s = r.capturingGroups.length;
        let a = !1;
        if (t > s) {
            if (r.skipBackrefValidation) a = !0;
            else throw new Error(`Not enough capturing groups defined to the left "${e}"`);
        }
        return r.hasNumberedRef = !0, $4e3b66797d9e7d60$export$19ee8a21aa784111(d ? s + 1 - t : t, {
            orphan: a
        });
    };
    if (n) {
        const t = /^(?<sign>-?)0*(?<num>[1-9]\d*)$/.exec(o);
        if (t) return i(+t.groups.num, !!t.groups.sign);
        if (/[-+]/.test(o)) throw new Error(`Invalid backref name "${e}"`);
        if (!r.namedGroupsByName.has(o)) throw new Error(`Group name not defined to the left "${e}"`);
        return $4e3b66797d9e7d60$export$19ee8a21aa784111(o);
    }
    return i(+o);
}
function $4e3b66797d9e7d60$var$ee(e, r, n) {
    const { tokens: o, walk: i } = r, t = r.parent, d = t.body.at(-1), s = o[r.nextIndex];
    if (!n.isCheckingRangeEnd && d && d.type !== "CharacterClass" && d.type !== "CharacterClassRange" && s && s.type !== "CharacterClassOpen" && s.type !== "CharacterClassClose" && s.type !== "CharacterClassIntersector") {
        const a = i(t, {
            ...n,
            isCheckingRangeEnd: !0
        });
        if (d.type === "Character" && a.type === "Character") return t.body.pop(), $4e3b66797d9e7d60$export$4249e19df10db8da(d, a);
        throw new Error("Invalid character class range");
    }
    return $4e3b66797d9e7d60$export$4d63783c2be0a38c((0, $c99286ead618e025$export$3226cf1d9b7b4bea)("-"));
}
function $4e3b66797d9e7d60$var$re({ negate: e }, r, n) {
    const { tokens: o, walk: i } = r, t = [
        $4e3b66797d9e7d60$export$9e021a2c1a31ab55()
    ], d = o[r.nextIndex];
    let s = $4e3b66797d9e7d60$var$z(d);
    for(; s.type !== "CharacterClassClose";){
        if (s.type === "CharacterClassIntersector") t.push($4e3b66797d9e7d60$export$9e021a2c1a31ab55()), r.nextIndex++;
        else {
            const l = t.at(-1);
            l.body.push(i(l, n));
        }
        s = $4e3b66797d9e7d60$var$z(o[r.nextIndex], d);
    }
    const a = $4e3b66797d9e7d60$export$9e021a2c1a31ab55({
        negate: e
    });
    return t.length === 1 ? a.body = t[0].body : (a.kind = "intersection", a.body = t.map((l)=>l.body.length === 1 ? l.body[0] : l)), r.nextIndex++, a;
}
function $4e3b66797d9e7d60$var$ne({ kind: e, negate: r, value: n }, o) {
    const { normalizeUnknownPropertyNames: i, skipPropertyNameValidation: t, unicodePropertyMap: d } = o;
    if (e === "property") {
        const s = $4e3b66797d9e7d60$export$74643d1fe038be1a(n);
        if ((0, $c99286ead618e025$export$7b650c03beb4e566).has(s) && !d?.has(s)) e = "posix", n = s;
        else return $4e3b66797d9e7d60$export$3968c6d753b95879(n, {
            negate: r,
            normalizeUnknownPropertyNames: i,
            skipPropertyNameValidation: t,
            unicodePropertyMap: d
        });
    }
    return e === "posix" ? $4e3b66797d9e7d60$export$7a84b53e0fed4c59(n, {
        negate: r
    }) : $4e3b66797d9e7d60$export$247758b45a713079(e, {
        negate: r
    });
}
function $4e3b66797d9e7d60$var$te(e, r, n) {
    const { tokens: o, capturingGroups: i, namedGroupsByName: t, skipLookbehindValidation: d, walk: s } = r, a = $4e3b66797d9e7d60$var$ie(e), l = a.type === "AbsenceFunction", c = $4e3b66797d9e7d60$var$$(a), f = c && a.negate;
    if (a.type === "CapturingGroup" && (i.push(a), a.name && (0, $c99286ead618e025$export$c4ed59b257196722)(t, a.name, []).push(a)), l && n.isInAbsenceFunction) throw new Error("Nested absence function not supported by Oniguruma");
    let p = $4e3b66797d9e7d60$var$D(o[r.nextIndex]);
    for(; p.type !== "GroupClose";){
        if (p.type === "Alternator") a.body.push($4e3b66797d9e7d60$export$4506b1bb0cf5d8dd()), r.nextIndex++;
        else {
            const N = a.body.at(-1), u = s(N, {
                ...n,
                isInAbsenceFunction: n.isInAbsenceFunction || l,
                isInLookbehind: n.isInLookbehind || c,
                isInNegLookbehind: n.isInNegLookbehind || f
            });
            if (N.body.push(u), (c || n.isInLookbehind) && !d) {
                const v = "Lookbehind includes a pattern not allowed by Oniguruma";
                if (f || n.isInNegLookbehind) {
                    if ($4e3b66797d9e7d60$var$M(u) || u.type === "CapturingGroup") throw new Error(v);
                } else if ($4e3b66797d9e7d60$var$M(u) || $4e3b66797d9e7d60$var$$(u) && u.negate) throw new Error(v);
            }
        }
        p = $4e3b66797d9e7d60$var$D(o[r.nextIndex]);
    }
    return r.nextIndex++, a;
}
function $4e3b66797d9e7d60$var$oe({ kind: e, min: r, max: n }, o) {
    const i = o.parent, t = i.body.at(-1);
    if (!t || !(0, $9adc2a332adf8d3e$export$ba95449642bd2f29)(t)) throw new Error("Quantifier requires a repeatable token");
    const d = $4e3b66797d9e7d60$export$169ce51b0f523e68(e, r, n, t);
    return i.body.pop(), d;
}
function $4e3b66797d9e7d60$var$ae({ raw: e }, r) {
    const { capturingGroups: n, subroutines: o } = r;
    let i = e.slice(3, -1);
    const t = /^(?<sign>[-+]?)0*(?<num>[1-9]\d*)$/.exec(i);
    if (t) {
        const s = +t.groups.num, a = n.length;
        if (r.hasNumberedRef = !0, i = ({
            "": s,
            "+": a + s,
            "-": a + 1 - s
        })[t.groups.sign], i < 1) throw new Error("Invalid subroutine number");
    } else i === "0" && (i = 0);
    const d = $4e3b66797d9e7d60$export$3b50b5d6d0004cab(i);
    return o.push(d), d;
}
function $4e3b66797d9e7d60$export$1f057c6c5c67512c(e, r) {
    if (e !== "repeater") throw new Error(`Unexpected absence function kind "${e}"`);
    return {
        type: "AbsenceFunction",
        kind: e,
        body: $4e3b66797d9e7d60$var$h(r?.body)
    };
}
function $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd(e) {
    return {
        type: "Alternative",
        body: $4e3b66797d9e7d60$var$V(e?.body)
    };
}
function $4e3b66797d9e7d60$export$987f29926deb46c2(e, r) {
    const n = {
        type: "Assertion",
        kind: e
    };
    return (e === "word_boundary" || e === "text_segment_boundary") && (n.negate = !!r?.negate), n;
}
function $4e3b66797d9e7d60$export$19ee8a21aa784111(e, r) {
    const n = !!r?.orphan;
    return {
        type: "Backreference",
        ref: e,
        ...n && {
            orphan: n
        }
    };
}
function $4e3b66797d9e7d60$export$e8bb25176ecaca85(e, r) {
    const n = {
        name: void 0,
        isSubroutined: !1,
        ...r
    };
    if (n.name !== void 0 && !$4e3b66797d9e7d60$var$se(n.name)) throw new Error(`Group name "${n.name}" invalid in Oniguruma`);
    return {
        type: "CapturingGroup",
        number: e,
        ...n.name && {
            name: n.name
        },
        ...n.isSubroutined && {
            isSubroutined: n.isSubroutined
        },
        body: $4e3b66797d9e7d60$var$h(r?.body)
    };
}
function $4e3b66797d9e7d60$export$4d63783c2be0a38c(e, r) {
    const n = {
        useLastValid: !1,
        ...r
    };
    if (e > 1114111) {
        const o = e.toString(16);
        if (n.useLastValid) e = 1114111;
        else throw e > 1310719 ? new Error(`Invalid code point out of range "\\x{${o}}"`) : new Error(`Invalid code point out of range in JS "\\x{${o}}"`);
    }
    return {
        type: "Character",
        value: e
    };
}
function $4e3b66797d9e7d60$export$9e021a2c1a31ab55(e) {
    const r = {
        kind: "union",
        negate: !1,
        ...e
    };
    return {
        type: "CharacterClass",
        kind: r.kind,
        negate: r.negate,
        body: $4e3b66797d9e7d60$var$V(e?.body)
    };
}
function $4e3b66797d9e7d60$export$4249e19df10db8da(e, r) {
    if (r.value < e.value) throw new Error("Character class range out of order");
    return {
        type: "CharacterClassRange",
        min: e,
        max: r
    };
}
function $4e3b66797d9e7d60$export$247758b45a713079(e, r) {
    const n = !!r?.negate, o = {
        type: "CharacterSet",
        kind: e
    };
    return (e === "digit" || e === "hex" || e === "newline" || e === "space" || e === "word") && (o.negate = n), (e === "text_segment" || e === "newline" && !n) && (o.variableLength = !0), o;
}
function $4e3b66797d9e7d60$export$5b526547d047f0c5(e, r = {}) {
    if (e === "keep") return {
        type: "Directive",
        kind: e
    };
    if (e === "flags") return {
        type: "Directive",
        kind: e,
        flags: (0, $c99286ead618e025$export$3b765e00c48ca2ba)(r.flags)
    };
    throw new Error(`Unexpected directive kind "${e}"`);
}
function $4e3b66797d9e7d60$export$bf8c332f00a76460(e) {
    return {
        type: "Flags",
        ...e
    };
}
function $4e3b66797d9e7d60$export$856f728536d122cb(e) {
    const r = e?.atomic, n = e?.flags;
    if (r && n) throw new Error("Atomic group cannot have flags");
    return {
        type: "Group",
        ...r && {
            atomic: r
        },
        ...n && {
            flags: n
        },
        body: $4e3b66797d9e7d60$var$h(e?.body)
    };
}
function $4e3b66797d9e7d60$export$a1c731c64d750557(e) {
    const r = {
        behind: !1,
        negate: !1,
        ...e
    };
    return {
        type: "LookaroundAssertion",
        kind: r.behind ? "lookbehind" : "lookahead",
        negate: r.negate,
        body: $4e3b66797d9e7d60$var$h(e?.body)
    };
}
function $4e3b66797d9e7d60$export$c55dc041d92a68d5(e, r, n) {
    return {
        type: "NamedCallout",
        kind: e,
        tag: r,
        arguments: n
    };
}
function $4e3b66797d9e7d60$export$7a84b53e0fed4c59(e, r) {
    const n = !!r?.negate;
    if (!(0, $c99286ead618e025$export$7b650c03beb4e566).has(e)) throw new Error(`Invalid POSIX class "${e}"`);
    return {
        type: "CharacterSet",
        kind: "posix",
        value: e,
        negate: n
    };
}
function $4e3b66797d9e7d60$export$169ce51b0f523e68(e, r, n, o) {
    if (r > n) throw new Error("Invalid reversed quantifier range");
    return {
        type: "Quantifier",
        kind: e,
        min: r,
        max: n,
        body: o
    };
}
function $4e3b66797d9e7d60$export$98d2929ccc6bd916(e, r) {
    return {
        type: "Regex",
        body: $4e3b66797d9e7d60$var$h(r?.body),
        flags: e
    };
}
function $4e3b66797d9e7d60$export$3b50b5d6d0004cab(e) {
    return {
        type: "Subroutine",
        ref: e
    };
}
function $4e3b66797d9e7d60$export$3968c6d753b95879(e, r) {
    const n = {
        negate: !1,
        normalizeUnknownPropertyNames: !1,
        skipPropertyNameValidation: !1,
        unicodePropertyMap: null,
        ...r
    };
    let o = n.unicodePropertyMap?.get($4e3b66797d9e7d60$export$74643d1fe038be1a(e));
    if (!o) {
        if (n.normalizeUnknownPropertyNames) o = $4e3b66797d9e7d60$var$de(e);
        else if (n.unicodePropertyMap && !n.skipPropertyNameValidation) throw new Error((0, $c99286ead618e025$export$43caf9889c228507)`Invalid Unicode property "\p{${e}}"`);
    }
    return {
        type: "CharacterSet",
        kind: "property",
        value: o ?? e,
        negate: n.negate
    };
}
function $4e3b66797d9e7d60$var$ie({ flags: e, kind: r, name: n, negate: o, number: i }) {
    switch(r){
        case "absence_repeater":
            return $4e3b66797d9e7d60$export$1f057c6c5c67512c("repeater");
        case "atomic":
            return $4e3b66797d9e7d60$export$856f728536d122cb({
                atomic: !0
            });
        case "capturing":
            return $4e3b66797d9e7d60$export$e8bb25176ecaca85(i, {
                name: n
            });
        case "group":
            return $4e3b66797d9e7d60$export$856f728536d122cb({
                flags: e
            });
        case "lookahead":
        case "lookbehind":
            return $4e3b66797d9e7d60$export$a1c731c64d750557({
                behind: r === "lookbehind",
                negate: o
            });
        default:
            throw new Error(`Unexpected group kind "${r}"`);
    }
}
function $4e3b66797d9e7d60$var$h(e) {
    if (e === void 0) e = [
        $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd()
    ];
    else if (!Array.isArray(e) || !e.length || !e.every((r)=>r.type === "Alternative")) throw new Error("Invalid body; expected array of one or more Alternative nodes");
    return e;
}
function $4e3b66797d9e7d60$var$V(e) {
    if (e === void 0) e = [];
    else if (!Array.isArray(e) || !e.every((r)=>!!r.type)) throw new Error("Invalid body; expected array of nodes");
    return e;
}
function $4e3b66797d9e7d60$var$M(e) {
    return e.type === "LookaroundAssertion" && e.kind === "lookahead";
}
function $4e3b66797d9e7d60$var$$(e) {
    return e.type === "LookaroundAssertion" && e.kind === "lookbehind";
}
function $4e3b66797d9e7d60$var$se(e) {
    return /^[\p{Alpha}\p{Pc}][^)]*$/u.test(e);
}
function $4e3b66797d9e7d60$var$de(e) {
    return e.trim().replace(/[- _]+/g, "_").replace(/[A-Z][a-z]+(?=[A-Z])/g, "$&_").replace(/[A-Za-z]+/g, (r)=>r[0].toUpperCase() + r.slice(1).toLowerCase());
}
function $4e3b66797d9e7d60$export$74643d1fe038be1a(e) {
    return e.replace(/[- _]+/g, "").toLowerCase();
}
function $4e3b66797d9e7d60$var$z(e, r) {
    const n = r;
    return (0, $c99286ead618e025$export$3b765e00c48ca2ba)(e, `Unclosed character class${n?.type === "Character" && n.value === 93 && n.raw === "]" ? ' (started with "]")' : ""}`);
}
function $4e3b66797d9e7d60$var$D(e) {
    return (0, $c99286ead618e025$export$3b765e00c48ca2ba)(e, "Unclosed group");
}



"use strict";
function $ed4615b60e8f202d$export$df3f009e3d155b20(a, v, N = null) {
    function b(e, s) {
        for(let t = 0; t < e.length; t++){
            const r = n(e[t], s, t, e);
            t = Math.max(-1, t + r);
        }
    }
    function n(e, s = null, t = null, r = null) {
        let i = 0, c = !1;
        const d = {
            node: e,
            parent: s,
            key: t,
            container: r,
            root: a,
            remove () {
                $ed4615b60e8f202d$var$x(r).splice(Math.max(0, $ed4615b60e8f202d$var$l(t) + i), 1), i--, c = !0;
            },
            removeAllNextSiblings () {
                return $ed4615b60e8f202d$var$x(r).splice($ed4615b60e8f202d$var$l(t) + 1);
            },
            removeAllPrevSiblings () {
                const o = $ed4615b60e8f202d$var$l(t) + i;
                return i -= o, $ed4615b60e8f202d$var$x(r).splice(0, Math.max(0, o));
            },
            replaceWith (o, m = {}) {
                const y = !!m.traverse;
                r ? r[Math.max(0, $ed4615b60e8f202d$var$l(t) + i)] = o : (0, $c99286ead618e025$export$3b765e00c48ca2ba)(s, "Can't replace root node")[t] = o, y && n(o, s, t, r), c = !0;
            },
            replaceWithMultiple (o, m = {}) {
                const y = !!m.traverse;
                if ($ed4615b60e8f202d$var$x(r).splice(Math.max(0, $ed4615b60e8f202d$var$l(t) + i), 1, ...o), i += o.length - 1, y) {
                    let g = 0;
                    for(let p = 0; p < o.length; p++)g += n(o[p], s, $ed4615b60e8f202d$var$l(t) + p + g, r);
                }
                c = !0;
            },
            skip () {
                c = !0;
            }
        }, { type: f } = e, u = v["*"], h = v[f], R = typeof u == "function" ? u : u?.enter, P = typeof h == "function" ? h : h?.enter;
        if (R?.(d, N), P?.(d, N), !c) switch(f){
            case "AbsenceFunction":
            case "Alternative":
            case "CapturingGroup":
            case "CharacterClass":
            case "Group":
            case "LookaroundAssertion":
                b(e.body, e);
                break;
            case "Assertion":
            case "Backreference":
            case "Character":
            case "CharacterSet":
            case "Directive":
            case "Flags":
            case "NamedCallout":
            case "Subroutine":
                break;
            case "CharacterClassRange":
                n(e.min, e, "min"), n(e.max, e, "max");
                break;
            case "Quantifier":
                n(e.body, e, "body");
                break;
            case "Regex":
                b(e.body, e), n(e.flags, e, "flags");
                break;
            default:
                throw new Error(`Unexpected node type "${f}"`);
        }
        return h?.exit?.(d, N), u?.exit?.(d, N), i;
    }
    return n(a), a;
}
function $ed4615b60e8f202d$var$x(a) {
    if (!Array.isArray(a)) throw new Error("Container expected");
    return a;
}
function $ed4615b60e8f202d$var$l(a) {
    if (typeof a != "number") throw new Error("Numeric key expected");
    return a;
}


// Separating some utils for improved tree shaking of the `./internals` export
const $f3bc9093a75f73af$export$aad7db1ad7d1ebf6 = String.raw`\(\?(?:[:=!>A-Za-z\-]|<[=!]|\(DEFINE\))`;
/**
Updates the array in place by incrementing each value greater than or equal to the threshold.
@param {Array<number>} arr
@param {number} threshold
*/ function $f3bc9093a75f73af$export$36c21f3893d5d884(arr, threshold) {
    for(let i = 0; i < arr.length; i++)if (arr[i] >= threshold) arr[i]++;
}
/**
@param {string} str
@param {number} pos
@param {string} oldValue
@param {string} newValue
@returns {string}
*/ function $f3bc9093a75f73af$export$77102e08492d3f08(str, pos, oldValue, newValue) {
    return str.slice(0, pos) + newValue + str.slice(pos + oldValue.length);
}


// Constant properties for tracking regex syntax context
const $d3a2a6242b0a60d2$export$841858b892ce1f4c = Object.freeze({
    DEFAULT: 'DEFAULT',
    CHAR_CLASS: 'CHAR_CLASS'
});
function $d3a2a6242b0a60d2$export$cc028768286a8626(expression, needle, replacement, context) {
    const re = new RegExp(String.raw`${needle}|(?<$skip>\[\^?|\\?.)`, 'gsu');
    const negated = [
        false
    ];
    let numCharClassesOpen = 0;
    let result = '';
    for (const match of expression.matchAll(re)){
        const { 0: m, groups: { $skip: $skip } } = match;
        if (!$skip && (!context || context === $d3a2a6242b0a60d2$export$841858b892ce1f4c.DEFAULT === !numCharClassesOpen)) {
            if (replacement instanceof Function) result += replacement(match, {
                context: numCharClassesOpen ? $d3a2a6242b0a60d2$export$841858b892ce1f4c.CHAR_CLASS : $d3a2a6242b0a60d2$export$841858b892ce1f4c.DEFAULT,
                negated: negated[negated.length - 1]
            });
            else result += replacement;
            continue;
        }
        if (m[0] === '[') {
            numCharClassesOpen++;
            negated.push(m[1] === '^');
        } else if (m === ']' && numCharClassesOpen) {
            numCharClassesOpen--;
            negated.pop();
        }
        result += m;
    }
    return result;
}
function $d3a2a6242b0a60d2$export$7bfdeaa3faf4ba53(expression, needle, callback, context) {
    // Do this the easy way
    $d3a2a6242b0a60d2$export$cc028768286a8626(expression, needle, callback, context);
}
function $d3a2a6242b0a60d2$export$e12e3c9be364c7a2(expression, needle, pos = 0, context) {
    // Quick partial test; avoid the loop if not needed
    if (!new RegExp(needle, 'su').test(expression)) return null;
    const re = new RegExp(`${needle}|(?<$skip>\\\\?.)`, 'gsu');
    re.lastIndex = pos;
    let numCharClassesOpen = 0;
    let match;
    while(match = re.exec(expression)){
        const { 0: m, groups: { $skip: $skip } } = match;
        if (!$skip && (!context || context === $d3a2a6242b0a60d2$export$841858b892ce1f4c.DEFAULT === !numCharClassesOpen)) return match;
        if (m === '[') numCharClassesOpen++;
        else if (m === ']' && numCharClassesOpen) numCharClassesOpen--;
        // Avoid an infinite loop on zero-length matches
        if (re.lastIndex == match.index) re.lastIndex++;
    }
    return null;
}
function $d3a2a6242b0a60d2$export$4d52bbdae9cd6e0c(expression, needle, context) {
    // Do this the easy way
    return !!$d3a2a6242b0a60d2$export$e12e3c9be364c7a2(expression, needle, 0, context);
}
function $d3a2a6242b0a60d2$export$6eaa51400fdf7c32(expression, contentsStartPos) {
    const token = /\\?./gsu;
    token.lastIndex = contentsStartPos;
    let contentsEndPos = expression.length;
    let numCharClassesOpen = 0;
    // Starting search within an open group, after the group's opening
    let numGroupsOpen = 1;
    let match;
    while(match = token.exec(expression)){
        const [m] = match;
        if (m === '[') numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            if (m === '(') numGroupsOpen++;
            else if (m === ')') {
                numGroupsOpen--;
                if (!numGroupsOpen) {
                    contentsEndPos = match.index;
                    break;
                }
            }
        } else if (m === ']') numCharClassesOpen--;
    }
    return expression.slice(contentsStartPos, contentsEndPos);
}


/**
@import {PluginData, PluginResult} from './regex.js';
*/ const $1bdab06fb3077cb8$var$atomicPluginToken = new RegExp(String.raw`(?<noncapturingStart>${(0, $f3bc9093a75f73af$export$aad7db1ad7d1ebf6)})|(?<capturingStart>\((?:\?<[^>]+>)?)|\\?.`, 'gsu');
/**
Apply transformations for atomic groups: `(?>…)`.
@param {string} expression
@param {PluginData} [data]
@returns {Required<PluginResult>}
*/ function $1bdab06fb3077cb8$export$a573bc8e40d39511(expression, data) {
    const hiddenCaptures = data?.hiddenCaptures ?? [];
    // Capture transfer is used by <github.com/slevithan/oniguruma-to-es>
    let captureTransfers = data?.captureTransfers ?? new Map();
    if (!/\(\?>/.test(expression)) return {
        pattern: expression,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
    const aGDelim = '(?>';
    const emulatedAGDelim = '(?:(?=(';
    const captureNumMap = [
        0
    ];
    const addedHiddenCaptures = [];
    let numCapturesBeforeAG = 0;
    let numAGs = 0;
    let aGPos = NaN;
    let hasProcessedAG;
    do {
        hasProcessedAG = false;
        let numCharClassesOpen = 0;
        let numGroupsOpenInAG = 0;
        let inAG = false;
        let match;
        $1bdab06fb3077cb8$var$atomicPluginToken.lastIndex = Number.isNaN(aGPos) ? 0 : aGPos + emulatedAGDelim.length;
        while(match = $1bdab06fb3077cb8$var$atomicPluginToken.exec(expression)){
            const { 0: m, index: index, groups: { capturingStart: capturingStart, noncapturingStart: noncapturingStart } } = match;
            if (m === '[') numCharClassesOpen++;
            else if (!numCharClassesOpen) {
                if (m === aGDelim && !inAG) {
                    aGPos = index;
                    inAG = true;
                } else if (inAG && noncapturingStart) numGroupsOpenInAG++;
                else if (capturingStart) {
                    if (inAG) numGroupsOpenInAG++;
                    else {
                        numCapturesBeforeAG++;
                        captureNumMap.push(numCapturesBeforeAG + numAGs);
                    }
                } else if (m === ')' && inAG) {
                    if (!numGroupsOpenInAG) {
                        numAGs++;
                        const addedCaptureNum = numCapturesBeforeAG + numAGs;
                        // Replace `expression` and use `<$$N>` as a temporary wrapper for the backref so it
                        // can avoid backref renumbering afterward. Wrap the whole substitution (including the
                        // lookahead and following backref) in a noncapturing group to handle following
                        // quantifiers and literal digits
                        expression = `${expression.slice(0, aGPos)}${emulatedAGDelim}${expression.slice(aGPos + aGDelim.length, index)}))<$$${addedCaptureNum}>)${expression.slice(index + 1)}`;
                        hasProcessedAG = true;
                        addedHiddenCaptures.push(addedCaptureNum);
                        (0, $f3bc9093a75f73af$export$36c21f3893d5d884)(hiddenCaptures, addedCaptureNum);
                        if (captureTransfers.size) {
                            const newCaptureTransfers = new Map();
                            captureTransfers.forEach((from, to)=>{
                                newCaptureTransfers.set(to >= addedCaptureNum ? to + 1 : to, from.map((f)=>f >= addedCaptureNum ? f + 1 : f));
                            });
                            captureTransfers = newCaptureTransfers;
                        }
                        break;
                    }
                    numGroupsOpenInAG--;
                }
            } else if (m === ']') numCharClassesOpen--;
        }
    // Start over from the beginning of the atomic group's contents, in case the processed group
    // contains additional atomic groups
    }while (hasProcessedAG);
    hiddenCaptures.push(...addedHiddenCaptures);
    // Second pass to adjust numbered backrefs
    expression = (0, $d3a2a6242b0a60d2$export$cc028768286a8626)(expression, String.raw`\\(?<backrefNum>[1-9]\d*)|<\$\$(?<wrappedBackrefNum>\d+)>`, ({ 0: m, groups: { backrefNum: backrefNum, wrappedBackrefNum: wrappedBackrefNum } })=>{
        if (backrefNum) {
            const bNum = +backrefNum;
            if (bNum > captureNumMap.length - 1) throw new Error(`Backref "${m}" greater than number of captures`);
            return `\\${captureNumMap[bNum]}`;
        }
        return `\\${wrappedBackrefNum}`;
    }, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT);
    return {
        pattern: expression,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
}
const $1bdab06fb3077cb8$var$baseQuantifier = String.raw`(?:[?*+]|\{\d+(?:,\d*)?\})`;
// Complete tokenizer for base syntax; doesn't (need to) know about character-class-only syntax
const $1bdab06fb3077cb8$var$possessivePluginToken = new RegExp(String.raw`
\\(?: \d+
  | c[A-Za-z]
  | [gk]<[^>]+>
  | [pPu]\{[^\}]+\}
  | u[A-Fa-f\d]{4}
  | x[A-Fa-f\d]{2}
  )
| \((?: \? (?: [:=!>]
  | <(?:[=!]|[^>]+>)
  | [A-Za-z\-]+:
  | \(DEFINE\)
  ))?
| (?<qBase>${$1bdab06fb3077cb8$var$baseQuantifier})(?<qMod>[?+]?)(?<invalidQ>[?*+\{]?)
| \\?.
`.replace(/\s+/g, ''), 'gsu');
/**
Transform posessive quantifiers into atomic groups. The posessessive quantifiers are:
`?+`, `*+`, `++`, `{N}+`, `{N,}+`, `{N,N}+`.
This follows Java, PCRE, Perl, and Python.
Possessive quantifiers in Oniguruma and Onigmo are only: `?+`, `*+`, `++`.
@param {string} expression
@returns {PluginResult}
*/ function $1bdab06fb3077cb8$export$777a2fba7d8a1541(expression) {
    if (!new RegExp(`${$1bdab06fb3077cb8$var$baseQuantifier}\\+`).test(expression)) return {
        pattern: expression
    };
    const openGroupIndices = [];
    let lastGroupIndex = null;
    let lastCharClassIndex = null;
    let lastToken = '';
    let numCharClassesOpen = 0;
    let match;
    $1bdab06fb3077cb8$var$possessivePluginToken.lastIndex = 0;
    while(match = $1bdab06fb3077cb8$var$possessivePluginToken.exec(expression)){
        const { 0: m, index: index, groups: { qBase: qBase, qMod: qMod, invalidQ: invalidQ } } = match;
        if (m === '[') {
            if (!numCharClassesOpen) lastCharClassIndex = index;
            numCharClassesOpen++;
        } else if (m === ']') {
            if (numCharClassesOpen) numCharClassesOpen--;
            else lastCharClassIndex = null;
        } else if (!numCharClassesOpen) {
            if (qMod === '+' && lastToken && !lastToken.startsWith('(')) {
                // Invalid following quantifier would become valid via the wrapping group
                if (invalidQ) throw new Error(`Invalid quantifier "${m}"`);
                let charsAdded = -1; // -1 for removed trailing `+`
                // Possessivizing fixed repetition quantifiers like `{2}` does't change their behavior, so
                // avoid doing so (convert them to greedy)
                if (/^\{\d+\}$/.test(qBase)) expression = (0, $f3bc9093a75f73af$export$77102e08492d3f08)(expression, index + qBase.length, qMod, '');
                else {
                    if (lastToken === ')' || lastToken === ']') {
                        const nodeIndex = lastToken === ')' ? lastGroupIndex : lastCharClassIndex;
                        // Unmatched `)` would break out of the wrapping group and mess with handling.
                        // Unmatched `]` wouldn't be a problem, but it's unnecessary to have dedicated support
                        // for unescaped `]++` since this won't work with flag u or v anyway
                        if (nodeIndex === null) throw new Error(`Invalid unmatched "${lastToken}"`);
                        expression = `${expression.slice(0, nodeIndex)}(?>${expression.slice(nodeIndex, index)}${qBase})${expression.slice(index + m.length)}`;
                    } else expression = `${expression.slice(0, index - lastToken.length)}(?>${lastToken}${qBase})${expression.slice(index + m.length)}`;
                    charsAdded += 4; // `(?>)`
                }
                $1bdab06fb3077cb8$var$possessivePluginToken.lastIndex += charsAdded;
            } else if (m[0] === '(') openGroupIndices.push(index);
            else if (m === ')') lastGroupIndex = openGroupIndices.length ? openGroupIndices.pop() : null;
        }
        lastToken = m;
    }
    return {
        pattern: expression
    };
}


/**
Works the same as JavaScript's native `RegExp` constructor in all contexts, but automatically
adjusts subpattern matches and indices (with flag `d`) to account for captures added as part of
emulating extended syntax.
*/ class $efdc88a5bcf3701e$export$7c3361faba0d4671 extends RegExp {
    // Avoid `#private` to allow for subclassing
    /**
  @private
  @type {Map<number, {
    hidden: true;
  }>}
  */ _captureMap;
    /**
  @overload
  @param {string} expression
  @param {string} [flags]
  @param {{
    hiddenCaptures?: Array<number>;
  }} [options]
  */ /**
  @overload
  @param {RegExpSubclass} expression
  @param {string} [flags]
  */ constructor(expression, flags, options){
        // Argument `options` isn't provided when regexes are copied via `new RegExpSubclass(regexp)`,
        // including as part of the internal handling of string methods `matchAll` and `split`
        if (expression instanceof RegExp) {
            if (options) throw new Error('Cannot provide options when copying a regexp');
            super(expression, flags);
            if (expression instanceof $efdc88a5bcf3701e$export$7c3361faba0d4671) this._captureMap = expression._captureMap;
            else this._captureMap = new Map();
        } else {
            super(expression, flags);
            const hiddenCaptures = options?.hiddenCaptures ?? [];
            this._captureMap = $efdc88a5bcf3701e$var$createCaptureMap(hiddenCaptures);
        }
    }
    /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray | null}
  */ exec(str) {
        const match = super.exec(str);
        if (!match || !this._captureMap.size) return match;
        const matchCopy = [
            ...match
        ];
        // Empty all but the first value of the array while preserving its other properties
        match.length = 1;
        let indicesCopy;
        if (this.hasIndices) {
            indicesCopy = [
                ...match.indices
            ];
            match.indices.length = 1;
        }
        for(let i = 1; i < matchCopy.length; i++)if (!this._captureMap.get(i)?.hidden) {
            match.push(matchCopy[i]);
            if (this.hasIndices) match.indices.push(indicesCopy[i]);
        }
        return match;
    }
}
/**
Build the capturing group map, with hidden captures marked to indicate their submatches shouldn't
appear in match results.
@param {Array<number>} hiddenCaptures
@returns {Map<number, {
  hidden: true;
}>}
*/ function $efdc88a5bcf3701e$var$createCaptureMap(hiddenCaptures) {
    const captureMap = new Map();
    for (const num of hiddenCaptures)captureMap.set(num, {
        hidden: true
    });
    return captureMap;
}





const $7b47be2fc3e8818c$var$r = String.raw;
const $7b47be2fc3e8818c$var$gRToken = $7b47be2fc3e8818c$var$r`\\g<(?<gRNameOrNum>[^>&]+)&R=(?<gRDepth>[^>]+)>`;
const $7b47be2fc3e8818c$var$recursiveToken = $7b47be2fc3e8818c$var$r`\(\?R=(?<rDepth>[^\)]+)\)|${$7b47be2fc3e8818c$var$gRToken}`;
const $7b47be2fc3e8818c$var$namedCaptureDelim = $7b47be2fc3e8818c$var$r`\(\?<(?![=!])(?<captureName>[^>]+)>`;
const $7b47be2fc3e8818c$var$captureDelim = $7b47be2fc3e8818c$var$r`${$7b47be2fc3e8818c$var$namedCaptureDelim}|(?<unnamed>\()(?!\?)`;
const $7b47be2fc3e8818c$var$token = new RegExp($7b47be2fc3e8818c$var$r`${$7b47be2fc3e8818c$var$namedCaptureDelim}|${$7b47be2fc3e8818c$var$recursiveToken}|\(\?|\\?.`, 'gsu');
const $7b47be2fc3e8818c$var$overlappingRecursionMsg = 'Cannot use multiple overlapping recursions';
/**
@param {string} pattern
@param {{
  flags?: string;
  captureTransfers?: Map<number, Array<number>>;
  hiddenCaptures?: Array<number>;
  mode?: 'plugin' | 'external';
}} [data]
@returns {{
  pattern: string;
  captureTransfers: Map<number, Array<number>>;
  hiddenCaptures: Array<number>;
}}
*/ function $7b47be2fc3e8818c$export$74c5cab0f9a94551(pattern, data) {
    const { hiddenCaptures: hiddenCaptures, mode: mode } = {
        hiddenCaptures: [],
        mode: 'plugin',
        ...data
    };
    // Capture transfer is used by <github.com/slevithan/oniguruma-to-es>
    let captureTransfers = data?.captureTransfers ?? new Map();
    // Keep the initial fail-check (which avoids unneeded processing) as fast as possible by testing
    // without the accuracy improvement of using `hasUnescaped` with `Context.DEFAULT`
    if (!new RegExp($7b47be2fc3e8818c$var$recursiveToken, 'su').test(pattern)) return {
        pattern: pattern,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
    if (mode === 'plugin' && (0, $d3a2a6242b0a60d2$export$4d52bbdae9cd6e0c)(pattern, $7b47be2fc3e8818c$var$r`\(\?\(DEFINE\)`, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT)) throw new Error('DEFINE groups cannot be used with recursion');
    const addedHiddenCaptures = [];
    const hasNumberedBackref = (0, $d3a2a6242b0a60d2$export$4d52bbdae9cd6e0c)(pattern, $7b47be2fc3e8818c$var$r`\\[1-9]`, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT);
    const groupContentsStartPos = new Map();
    const openGroups = [];
    let hasRecursed = false;
    let numCharClassesOpen = 0;
    let numCapturesPassed = 0;
    let match;
    $7b47be2fc3e8818c$var$token.lastIndex = 0;
    while(match = $7b47be2fc3e8818c$var$token.exec(pattern)){
        const { 0: m, groups: { captureName: captureName, rDepth: rDepth, gRNameOrNum: gRNameOrNum, gRDepth: gRDepth } } = match;
        if (m === '[') numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            // `(?R=N)`
            if (rDepth) {
                $7b47be2fc3e8818c$var$assertMaxInBounds(rDepth);
                if (hasRecursed) throw new Error($7b47be2fc3e8818c$var$overlappingRecursionMsg);
                if (hasNumberedBackref) // Could add support for numbered backrefs with extra effort, but it's probably not worth
                // it. To trigger this error, the regex must include recursion and one of the following:
                // - An interpolated regex that contains a numbered backref (since other numbered
                //   backrefs are prevented by implicit flag n).
                // - A numbered backref, when flag n is explicitly disabled.
                // Note that Regex+'s extended syntax (atomic groups and sometimes subroutines) can also
                // add numbered backrefs, but those work fine because external plugins like this one run
                // *before* the transformation of built-in syntax extensions
                throw new Error(// When used in `external` mode by transpilers other than Regex+, backrefs might have
                // gone through conversion from named to numbered, so avoid a misleading error
                `${mode === 'external' ? 'Backrefs' : 'Numbered backrefs'} cannot be used with global recursion`);
                const left = pattern.slice(0, match.index);
                const right = pattern.slice($7b47be2fc3e8818c$var$token.lastIndex);
                if ((0, $d3a2a6242b0a60d2$export$4d52bbdae9cd6e0c)(right, $7b47be2fc3e8818c$var$recursiveToken, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT)) throw new Error($7b47be2fc3e8818c$var$overlappingRecursionMsg);
                const reps = +rDepth - 1;
                pattern = $7b47be2fc3e8818c$var$makeRecursive(left, right, reps, false, hiddenCaptures, addedHiddenCaptures, numCapturesPassed);
                captureTransfers = $7b47be2fc3e8818c$var$mapCaptureTransfers(captureTransfers, left, reps, addedHiddenCaptures.length, 0, numCapturesPassed);
                break;
            // `\g<name&R=N>`, `\g<number&R=N>`
            } else if (gRNameOrNum) {
                $7b47be2fc3e8818c$var$assertMaxInBounds(gRDepth);
                let isWithinReffedGroup = false;
                for (const g of openGroups)if (g.name === gRNameOrNum || g.num === +gRNameOrNum) {
                    isWithinReffedGroup = true;
                    if (g.hasRecursedWithin) throw new Error($7b47be2fc3e8818c$var$overlappingRecursionMsg);
                    break;
                }
                if (!isWithinReffedGroup) throw new Error($7b47be2fc3e8818c$var$r`Recursive \g cannot be used outside the referenced group "${mode === 'external' ? gRNameOrNum : $7b47be2fc3e8818c$var$r`\g<${gRNameOrNum}&R=${gRDepth}>`}"`);
                const startPos = groupContentsStartPos.get(gRNameOrNum);
                const groupContents = (0, $d3a2a6242b0a60d2$export$6eaa51400fdf7c32)(pattern, startPos);
                if (hasNumberedBackref && (0, $d3a2a6242b0a60d2$export$4d52bbdae9cd6e0c)(groupContents, $7b47be2fc3e8818c$var$r`${$7b47be2fc3e8818c$var$namedCaptureDelim}|\((?!\?)`, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT)) throw new Error(// When used in `external` mode by transpilers other than Regex+, backrefs might have
                // gone through conversion from named to numbered, so avoid a misleading error
                `${mode === 'external' ? 'Backrefs' : 'Numbered backrefs'} cannot be used with recursion of capturing groups`);
                const groupContentsLeft = pattern.slice(startPos, match.index);
                const groupContentsRight = groupContents.slice(groupContentsLeft.length + m.length);
                const numAddedHiddenCapturesPreExpansion = addedHiddenCaptures.length;
                const reps = +gRDepth - 1;
                const expansion = $7b47be2fc3e8818c$var$makeRecursive(groupContentsLeft, groupContentsRight, reps, true, hiddenCaptures, addedHiddenCaptures, numCapturesPassed);
                captureTransfers = $7b47be2fc3e8818c$var$mapCaptureTransfers(captureTransfers, groupContentsLeft, reps, addedHiddenCaptures.length - numAddedHiddenCapturesPreExpansion, numAddedHiddenCapturesPreExpansion, numCapturesPassed);
                const pre = pattern.slice(0, startPos);
                const post = pattern.slice(startPos + groupContents.length);
                // Modify the string we're looping over
                pattern = `${pre}${expansion}${post}`;
                // Step forward for the next loop iteration
                $7b47be2fc3e8818c$var$token.lastIndex += expansion.length - m.length - groupContentsLeft.length - groupContentsRight.length;
                openGroups.forEach((g)=>g.hasRecursedWithin = true);
                hasRecursed = true;
            } else if (captureName) {
                numCapturesPassed++;
                groupContentsStartPos.set(String(numCapturesPassed), $7b47be2fc3e8818c$var$token.lastIndex);
                groupContentsStartPos.set(captureName, $7b47be2fc3e8818c$var$token.lastIndex);
                openGroups.push({
                    num: numCapturesPassed,
                    name: captureName
                });
            } else if (m[0] === '(') {
                const isUnnamedCapture = m === '(';
                if (isUnnamedCapture) {
                    numCapturesPassed++;
                    groupContentsStartPos.set(String(numCapturesPassed), $7b47be2fc3e8818c$var$token.lastIndex);
                }
                openGroups.push(isUnnamedCapture ? {
                    num: numCapturesPassed
                } : {});
            } else if (m === ')') openGroups.pop();
        } else if (m === ']') numCharClassesOpen--;
    }
    hiddenCaptures.push(...addedHiddenCaptures);
    return {
        pattern: pattern,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
}
/**
@param {string} max
*/ function $7b47be2fc3e8818c$var$assertMaxInBounds(max) {
    const errMsg = `Max depth must be integer between 2 and 100; used ${max}`;
    if (!/^[1-9]\d*$/.test(max)) throw new Error(errMsg);
    max = +max;
    if (max < 2 || max > 100) throw new Error(errMsg);
}
/**
@param {string} left
@param {string} right
@param {number} reps
@param {boolean} isSubpattern
@param {Array<number>} hiddenCaptures
@param {Array<number>} addedHiddenCaptures
@param {number} numCapturesPassed
@returns {string}
*/ function $7b47be2fc3e8818c$var$makeRecursive(left, right, reps, isSubpattern, hiddenCaptures, addedHiddenCaptures, numCapturesPassed) {
    const namesInRecursed = new Set();
    // Can skip this work if not needed
    if (isSubpattern) (0, $d3a2a6242b0a60d2$export$7bfdeaa3faf4ba53)(left + right, $7b47be2fc3e8818c$var$namedCaptureDelim, ({ groups: { captureName: captureName } })=>{
        namesInRecursed.add(captureName);
    }, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT);
    const rest = [
        reps,
        isSubpattern ? namesInRecursed : null,
        hiddenCaptures,
        addedHiddenCaptures,
        numCapturesPassed
    ];
    // Depth 2: 'left(?:left(?:)right)right'
    // Depth 3: 'left(?:left(?:left(?:)right)right)right'
    // Empty group in the middle separates tokens and absorbs a following quantifier if present
    return `${left}${$7b47be2fc3e8818c$var$repeatWithDepth(`(?:${left}`, 'forward', ...rest)}(?:)${$7b47be2fc3e8818c$var$repeatWithDepth(`${right})`, 'backward', ...rest)}${right}`;
}
/**
@param {string} pattern
@param {'forward' | 'backward'} direction
@param {number} reps
@param {Set<string> | null} namesInRecursed
@param {Array<number>} hiddenCaptures
@param {Array<number>} addedHiddenCaptures
@param {number} numCapturesPassed
@returns {string}
*/ function $7b47be2fc3e8818c$var$repeatWithDepth(pattern, direction, reps, namesInRecursed, hiddenCaptures, addedHiddenCaptures, numCapturesPassed) {
    const startNum = 2;
    const getDepthNum = (i)=>direction === 'forward' ? i + startNum : reps - i + startNum - 1;
    let result = '';
    for(let i = 0; i < reps; i++){
        const depthNum = getDepthNum(i);
        result += (0, $d3a2a6242b0a60d2$export$cc028768286a8626)(pattern, $7b47be2fc3e8818c$var$r`${$7b47be2fc3e8818c$var$captureDelim}|\\k<(?<backref>[^>]+)>`, ({ 0: m, groups: { captureName: captureName, unnamed: unnamed, backref: backref } })=>{
            if (backref && namesInRecursed && !namesInRecursed.has(backref)) // Don't alter backrefs to groups outside the recursed subpattern
            return m;
            const suffix = `_$${depthNum}`;
            if (unnamed || captureName) {
                const addedCaptureNum = numCapturesPassed + addedHiddenCaptures.length + 1;
                addedHiddenCaptures.push(addedCaptureNum);
                $7b47be2fc3e8818c$var$incrementIfAtLeast(hiddenCaptures, addedCaptureNum);
                return unnamed ? m : `(?<${captureName}${suffix}>`;
            }
            return $7b47be2fc3e8818c$var$r`\k<${backref}${suffix}>`;
        }, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT);
    }
    return result;
}
/**
Updates the array in place by incrementing each value greater than or equal to the threshold.
@param {Array<number>} arr
@param {number} threshold
*/ function $7b47be2fc3e8818c$var$incrementIfAtLeast(arr, threshold) {
    for(let i = 0; i < arr.length; i++)if (arr[i] >= threshold) arr[i]++;
}
/**
@param {Map<number, Array<number>>} captureTransfers
@param {string} left
@param {number} reps
@param {number} numCapturesAddedInExpansion
@param {number} numAddedHiddenCapturesPreExpansion
@param {number} numCapturesPassed
@returns {Map<number, Array<number>>}
*/ function $7b47be2fc3e8818c$var$mapCaptureTransfers(captureTransfers, left, reps, numCapturesAddedInExpansion, numAddedHiddenCapturesPreExpansion, numCapturesPassed) {
    if (captureTransfers.size && numCapturesAddedInExpansion) {
        let numCapturesInLeft = 0;
        (0, $d3a2a6242b0a60d2$export$7bfdeaa3faf4ba53)(left, $7b47be2fc3e8818c$var$captureDelim, ()=>numCapturesInLeft++, (0, $d3a2a6242b0a60d2$export$841858b892ce1f4c).DEFAULT);
        // Is 0 for global recursion
        const recursionDelimCaptureNum = numCapturesPassed - numCapturesInLeft + numAddedHiddenCapturesPreExpansion;
        const newCaptureTransfers = new Map();
        captureTransfers.forEach((from, to)=>{
            const numCapturesInRight = (numCapturesAddedInExpansion - numCapturesInLeft * reps) / reps;
            const numCapturesAddedInLeft = numCapturesInLeft * reps;
            const newTo = to > recursionDelimCaptureNum + numCapturesInLeft ? to + numCapturesAddedInExpansion : to;
            const newFrom = [];
            for (const f of from){
                // Before the recursed subpattern
                if (f <= recursionDelimCaptureNum) newFrom.push(f);
                else if (f > recursionDelimCaptureNum + numCapturesInLeft + numCapturesInRight) newFrom.push(f + numCapturesAddedInExpansion);
                else if (f <= recursionDelimCaptureNum + numCapturesInLeft) for(let i = 0; i <= reps; i++)newFrom.push(f + numCapturesInLeft * i);
                else for(let i = 0; i <= reps; i++)newFrom.push(f + numCapturesAddedInLeft + numCapturesInRight * i);
            }
            newCaptureTransfers.set(newTo, newFrom);
        });
        return newCaptureTransfers;
    }
    return captureTransfers;
}


var $ee2fdfa8e1ecd950$var$cp = String.fromCodePoint;
var $ee2fdfa8e1ecd950$var$r = String.raw;
var $ee2fdfa8e1ecd950$var$envFlags = {};
var $ee2fdfa8e1ecd950$var$globalRegExp = globalThis.RegExp;
$ee2fdfa8e1ecd950$var$envFlags.flagGroups = (()=>{
    try {
        new $ee2fdfa8e1ecd950$var$globalRegExp("(?i:)");
    } catch  {
        return false;
    }
    return true;
})();
$ee2fdfa8e1ecd950$var$envFlags.unicodeSets = (()=>{
    try {
        new $ee2fdfa8e1ecd950$var$globalRegExp("[[]]", "v");
    } catch  {
        return false;
    }
    return true;
})();
$ee2fdfa8e1ecd950$var$envFlags.bugFlagVLiteralHyphenIsRange = $ee2fdfa8e1ecd950$var$envFlags.unicodeSets ? (()=>{
    try {
        new $ee2fdfa8e1ecd950$var$globalRegExp($ee2fdfa8e1ecd950$var$r`[\d\-a]`, "v");
    } catch  {
        return true;
    }
    return false;
})() : false;
$ee2fdfa8e1ecd950$var$envFlags.bugNestedClassIgnoresNegation = $ee2fdfa8e1ecd950$var$envFlags.unicodeSets && new $ee2fdfa8e1ecd950$var$globalRegExp("[[^a]]", "v").test("a");
function $ee2fdfa8e1ecd950$var$getNewCurrentFlags(current, { enable: enable, disable: disable }) {
    return {
        dotAll: !disable?.dotAll && !!(enable?.dotAll || current.dotAll),
        ignoreCase: !disable?.ignoreCase && !!(enable?.ignoreCase || current.ignoreCase)
    };
}
function $ee2fdfa8e1ecd950$var$getOrInsert(map, key, defaultValue) {
    if (!map.has(key)) map.set(key, defaultValue);
    return map.get(key);
}
function $ee2fdfa8e1ecd950$var$isMinTarget(target, min) {
    return $ee2fdfa8e1ecd950$var$EsVersion[target] >= $ee2fdfa8e1ecd950$var$EsVersion[min];
}
function $ee2fdfa8e1ecd950$var$throwIfNullish(value, msg) {
    if (value == null) throw new Error(msg ?? "Value expected");
    return value;
}
// src/options.js
var $ee2fdfa8e1ecd950$var$EsVersion = {
    ES2025: 2025,
    ES2024: 2024,
    ES2018: 2018
};
var $ee2fdfa8e1ecd950$var$Target = /** @type {const} */ {
    auto: "auto",
    ES2025: "ES2025",
    ES2024: "ES2024",
    ES2018: "ES2018"
};
function $ee2fdfa8e1ecd950$var$getOptions(options = {}) {
    if (({}).toString.call(options) !== "[object Object]") throw new Error("Unexpected options");
    if (options.target !== void 0 && !$ee2fdfa8e1ecd950$var$Target[options.target]) throw new Error(`Unexpected target "${options.target}"`);
    const opts = {
        // Sets the level of emulation rigor/strictness.
        accuracy: "default",
        // Disables advanced emulation that relies on returning a `RegExp` subclass, resulting in
        // certain patterns not being emulatable.
        avoidSubclass: false,
        // Oniguruma flags; a string with `i`, `m`, `x`, `D`, `S`, `W`, `y{g}` in any order (all
        // optional). Oniguruma's `m` is equivalent to JavaScript's `s` (`dotAll`).
        flags: "",
        // Include JavaScript flag `g` (`global`) in the result.
        global: false,
        // Include JavaScript flag `d` (`hasIndices`) in the result.
        hasIndices: false,
        // Delay regex construction until first use if the transpiled pattern is at least this length.
        lazyCompileLength: Infinity,
        // JavaScript version used for generated regexes. Using `auto` detects the best value based on
        // your environment. Later targets allow faster processing, simpler generated source, and
        // support for additional features.
        target: "auto",
        // Disables minifications that simplify the pattern without changing the meaning.
        verbose: false,
        ...options,
        // Advanced options that override standard behavior, error checking, and flags when enabled.
        rules: {
            // Useful with TextMate grammars that merge backreferences across patterns.
            allowOrphanBackrefs: false,
            // Use ASCII `\b` and `\B`, which increases search performance of generated regexes.
            asciiWordBoundaries: false,
            // Allow unnamed captures and numbered calls (backreferences and subroutines) when using
            // named capture. This is Oniguruma option `ONIG_OPTION_CAPTURE_GROUP`; on by default in
            // `vscode-oniguruma`.
            captureGroup: false,
            // Change the recursion depth limit from Oniguruma's `20` to an integer `2`–`20`.
            recursionLimit: 20,
            // `^` as `\A`; `$` as`\Z`. Improves search performance of generated regexes without changing
            // the meaning if searching line by line. This is Oniguruma option `ONIG_OPTION_SINGLELINE`.
            singleline: false,
            ...options.rules
        }
    };
    if (opts.target === "auto") opts.target = $ee2fdfa8e1ecd950$var$envFlags.flagGroups ? "ES2025" : $ee2fdfa8e1ecd950$var$envFlags.unicodeSets ? "ES2024" : "ES2018";
    return opts;
}
var $ee2fdfa8e1ecd950$var$asciiSpaceChar = "[	-\r ]";
var $ee2fdfa8e1ecd950$var$CharsWithoutIgnoreCaseExpansion = /* @__PURE__ */ new Set([
    $ee2fdfa8e1ecd950$var$cp(304),
    // İ
    $ee2fdfa8e1ecd950$var$cp(305)
]);
var $ee2fdfa8e1ecd950$var$defaultWordChar = $ee2fdfa8e1ecd950$var$r`[\p{L}\p{M}\p{N}\p{Pc}]`;
function $ee2fdfa8e1ecd950$var$getIgnoreCaseMatchChars(char) {
    if ($ee2fdfa8e1ecd950$var$CharsWithoutIgnoreCaseExpansion.has(char)) return [
        char
    ];
    const set = /* @__PURE__ */ new Set();
    const lower = char.toLowerCase();
    const upper = lower.toUpperCase();
    const title = $ee2fdfa8e1ecd950$var$LowerToTitleCaseMap.get(lower);
    const altLower = $ee2fdfa8e1ecd950$var$LowerToAlternativeLowerCaseMap.get(lower);
    const altUpper = $ee2fdfa8e1ecd950$var$LowerToAlternativeUpperCaseMap.get(lower);
    if ([
        ...upper
    ].length === 1) set.add(upper);
    altUpper && set.add(altUpper);
    title && set.add(title);
    set.add(lower);
    altLower && set.add(altLower);
    return [
        ...set
    ];
}
var $ee2fdfa8e1ecd950$var$JsUnicodePropertyMap = /* @__PURE__ */ new Map(`C Other
Cc Control cntrl
Cf Format
Cn Unassigned
Co Private_Use
Cs Surrogate
L Letter
LC Cased_Letter
Ll Lowercase_Letter
Lm Modifier_Letter
Lo Other_Letter
Lt Titlecase_Letter
Lu Uppercase_Letter
M Mark Combining_Mark
Mc Spacing_Mark
Me Enclosing_Mark
Mn Nonspacing_Mark
N Number
Nd Decimal_Number digit
Nl Letter_Number
No Other_Number
P Punctuation punct
Pc Connector_Punctuation
Pd Dash_Punctuation
Pe Close_Punctuation
Pf Final_Punctuation
Pi Initial_Punctuation
Po Other_Punctuation
Ps Open_Punctuation
S Symbol
Sc Currency_Symbol
Sk Modifier_Symbol
Sm Math_Symbol
So Other_Symbol
Z Separator
Zl Line_Separator
Zp Paragraph_Separator
Zs Space_Separator
ASCII
ASCII_Hex_Digit AHex
Alphabetic Alpha
Any
Assigned
Bidi_Control Bidi_C
Bidi_Mirrored Bidi_M
Case_Ignorable CI
Cased
Changes_When_Casefolded CWCF
Changes_When_Casemapped CWCM
Changes_When_Lowercased CWL
Changes_When_NFKC_Casefolded CWKCF
Changes_When_Titlecased CWT
Changes_When_Uppercased CWU
Dash
Default_Ignorable_Code_Point DI
Deprecated Dep
Diacritic Dia
Emoji
Emoji_Component EComp
Emoji_Modifier EMod
Emoji_Modifier_Base EBase
Emoji_Presentation EPres
Extended_Pictographic ExtPict
Extender Ext
Grapheme_Base Gr_Base
Grapheme_Extend Gr_Ext
Hex_Digit Hex
IDS_Binary_Operator IDSB
IDS_Trinary_Operator IDST
ID_Continue IDC
ID_Start IDS
Ideographic Ideo
Join_Control Join_C
Logical_Order_Exception LOE
Lowercase Lower
Math
Noncharacter_Code_Point NChar
Pattern_Syntax Pat_Syn
Pattern_White_Space Pat_WS
Quotation_Mark QMark
Radical
Regional_Indicator RI
Sentence_Terminal STerm
Soft_Dotted SD
Terminal_Punctuation Term
Unified_Ideograph UIdeo
Uppercase Upper
Variation_Selector VS
White_Space space
XID_Continue XIDC
XID_Start XIDS`.split(/\s/).map((p)=>[
        (0, $4e3b66797d9e7d60$export$74643d1fe038be1a)(p),
        p
    ]));
var $ee2fdfa8e1ecd950$var$LowerToAlternativeLowerCaseMap = /* @__PURE__ */ new Map([
    [
        "s",
        $ee2fdfa8e1ecd950$var$cp(383)
    ],
    // s, ſ
    [
        $ee2fdfa8e1ecd950$var$cp(383),
        "s"
    ]
]);
var $ee2fdfa8e1ecd950$var$LowerToAlternativeUpperCaseMap = /* @__PURE__ */ new Map([
    [
        $ee2fdfa8e1ecd950$var$cp(223),
        $ee2fdfa8e1ecd950$var$cp(7838)
    ],
    // ß, ẞ
    [
        $ee2fdfa8e1ecd950$var$cp(107),
        $ee2fdfa8e1ecd950$var$cp(8490)
    ],
    // k, K (Kelvin)
    [
        $ee2fdfa8e1ecd950$var$cp(229),
        $ee2fdfa8e1ecd950$var$cp(8491)
    ],
    // å, Å (Angstrom)
    [
        $ee2fdfa8e1ecd950$var$cp(969),
        $ee2fdfa8e1ecd950$var$cp(8486)
    ]
]);
var $ee2fdfa8e1ecd950$var$LowerToTitleCaseMap = new Map([
    $ee2fdfa8e1ecd950$var$titleEntry(453),
    $ee2fdfa8e1ecd950$var$titleEntry(456),
    $ee2fdfa8e1ecd950$var$titleEntry(459),
    $ee2fdfa8e1ecd950$var$titleEntry(498),
    ...$ee2fdfa8e1ecd950$var$titleRange(8072, 8079),
    ...$ee2fdfa8e1ecd950$var$titleRange(8088, 8095),
    ...$ee2fdfa8e1ecd950$var$titleRange(8104, 8111),
    $ee2fdfa8e1ecd950$var$titleEntry(8124),
    $ee2fdfa8e1ecd950$var$titleEntry(8140),
    $ee2fdfa8e1ecd950$var$titleEntry(8188)
]);
var $ee2fdfa8e1ecd950$var$PosixClassMap = /* @__PURE__ */ new Map([
    [
        "alnum",
        $ee2fdfa8e1ecd950$var$r`[\p{Alpha}\p{Nd}]`
    ],
    [
        "alpha",
        $ee2fdfa8e1ecd950$var$r`\p{Alpha}`
    ],
    [
        "ascii",
        $ee2fdfa8e1ecd950$var$r`\p{ASCII}`
    ],
    [
        "blank",
        $ee2fdfa8e1ecd950$var$r`[\p{Zs}\t]`
    ],
    [
        "cntrl",
        $ee2fdfa8e1ecd950$var$r`\p{Cc}`
    ],
    [
        "digit",
        $ee2fdfa8e1ecd950$var$r`\p{Nd}`
    ],
    [
        "graph",
        $ee2fdfa8e1ecd950$var$r`[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]`
    ],
    [
        "lower",
        $ee2fdfa8e1ecd950$var$r`\p{Lower}`
    ],
    [
        "print",
        $ee2fdfa8e1ecd950$var$r`[[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]\p{Zs}]`
    ],
    [
        "punct",
        $ee2fdfa8e1ecd950$var$r`[\p{P}\p{S}]`
    ],
    // Updated value from Onig 6.9.9; changed from Unicode `\p{punct}`
    [
        "space",
        $ee2fdfa8e1ecd950$var$r`\p{space}`
    ],
    [
        "upper",
        $ee2fdfa8e1ecd950$var$r`\p{Upper}`
    ],
    [
        "word",
        $ee2fdfa8e1ecd950$var$r`[\p{Alpha}\p{M}\p{Nd}\p{Pc}]`
    ],
    [
        "xdigit",
        $ee2fdfa8e1ecd950$var$r`\p{AHex}`
    ]
]);
function $ee2fdfa8e1ecd950$var$range(start, end) {
    const range2 = [];
    for(let i = start; i <= end; i++)range2.push(i);
    return range2;
}
function $ee2fdfa8e1ecd950$var$titleEntry(codePoint) {
    const char = $ee2fdfa8e1ecd950$var$cp(codePoint);
    return [
        char.toLowerCase(),
        char
    ];
}
function $ee2fdfa8e1ecd950$var$titleRange(start, end) {
    return $ee2fdfa8e1ecd950$var$range(start, end).map((codePoint)=>$ee2fdfa8e1ecd950$var$titleEntry(codePoint));
}
var $ee2fdfa8e1ecd950$var$UnicodePropertiesWithSpecificCase = /* @__PURE__ */ new Set([
    "Lower",
    "Lowercase",
    "Upper",
    "Uppercase",
    "Ll",
    "Lowercase_Letter",
    "Lt",
    "Titlecase_Letter",
    "Lu",
    "Uppercase_Letter"
]);
function $ee2fdfa8e1ecd950$var$transform(ast, options) {
    const opts = {
        // A couple edge cases exist where options `accuracy` and `bestEffortTarget` are used:
        // - `CharacterSet` kind `text_segment` (`\X`): An exact representation would require heavy
        //   Unicode data; a best-effort approximation requires knowing the target.
        // - `CharacterSet` kind `posix` with values `graph` and `print`: Their complex Unicode
        //   representations would be hard to change to ASCII versions after the fact in the generator
        //   based on `target`/`accuracy`, so produce the appropriate structure here.
        accuracy: "default",
        asciiWordBoundaries: false,
        avoidSubclass: false,
        bestEffortTarget: "ES2025",
        ...options
    };
    $ee2fdfa8e1ecd950$var$addParentProperties(ast);
    const firstPassState = {
        accuracy: opts.accuracy,
        asciiWordBoundaries: opts.asciiWordBoundaries,
        avoidSubclass: opts.avoidSubclass,
        flagDirectivesByAlt: /* @__PURE__ */ new Map(),
        jsGroupNameMap: /* @__PURE__ */ new Map(),
        minTargetEs2024: $ee2fdfa8e1ecd950$var$isMinTarget(opts.bestEffortTarget, "ES2024"),
        passedLookbehind: false,
        strategy: null,
        // Subroutines can appear before the groups they ref, so collect reffed nodes for a second pass 
        subroutineRefMap: /* @__PURE__ */ new Map(),
        supportedGNodes: /* @__PURE__ */ new Set(),
        digitIsAscii: ast.flags.digitIsAscii,
        spaceIsAscii: ast.flags.spaceIsAscii,
        wordIsAscii: ast.flags.wordIsAscii
    };
    (0, $ed4615b60e8f202d$export$df3f009e3d155b20)(ast, $ee2fdfa8e1ecd950$var$FirstPassVisitor, firstPassState);
    const globalFlags = {
        dotAll: ast.flags.dotAll,
        ignoreCase: ast.flags.ignoreCase
    };
    const secondPassState = {
        currentFlags: globalFlags,
        prevFlags: null,
        globalFlags: globalFlags,
        groupOriginByCopy: /* @__PURE__ */ new Map(),
        groupsByName: /* @__PURE__ */ new Map(),
        multiplexCapturesToLeftByRef: /* @__PURE__ */ new Map(),
        openRefs: /* @__PURE__ */ new Map(),
        reffedNodesByReferencer: /* @__PURE__ */ new Map(),
        subroutineRefMap: firstPassState.subroutineRefMap
    };
    (0, $ed4615b60e8f202d$export$df3f009e3d155b20)(ast, $ee2fdfa8e1ecd950$var$SecondPassVisitor, secondPassState);
    const thirdPassState = {
        groupsByName: secondPassState.groupsByName,
        highestOrphanBackref: 0,
        numCapturesToLeft: 0,
        reffedNodesByReferencer: secondPassState.reffedNodesByReferencer
    };
    (0, $ed4615b60e8f202d$export$df3f009e3d155b20)(ast, $ee2fdfa8e1ecd950$var$ThirdPassVisitor, thirdPassState);
    ast._originMap = secondPassState.groupOriginByCopy;
    ast._strategy = firstPassState.strategy;
    return ast;
}
var $ee2fdfa8e1ecd950$var$FirstPassVisitor = {
    AbsenceFunction ({ node: node, parent: parent, replaceWith: replaceWith }) {
        const { body: body, kind: kind } = node;
        if (kind === "repeater") {
            const innerGroup = (0, $4e3b66797d9e7d60$export$856f728536d122cb)();
            innerGroup.body[0].body.push(// Insert own alts as `body`
            (0, $4e3b66797d9e7d60$export$a1c731c64d750557)({
                negate: true,
                body: body
            }), (0, $4e3b66797d9e7d60$export$3968c6d753b95879)("Any"));
            const outerGroup = (0, $4e3b66797d9e7d60$export$856f728536d122cb)();
            outerGroup.body[0].body.push((0, $4e3b66797d9e7d60$export$169ce51b0f523e68)("greedy", 0, Infinity, innerGroup));
            replaceWith($ee2fdfa8e1ecd950$var$setParentDeep(outerGroup, parent), {
                traverse: true
            });
        } else throw new Error(`Unsupported absence function "(?~|"`);
    },
    Alternative: {
        enter ({ node: node, parent: parent, key: key }, { flagDirectivesByAlt: flagDirectivesByAlt }) {
            const flagDirectives = node.body.filter((el)=>el.kind === "flags");
            for(let i = key + 1; i < parent.body.length; i++){
                const forwardSiblingAlt = parent.body[i];
                $ee2fdfa8e1ecd950$var$getOrInsert(flagDirectivesByAlt, forwardSiblingAlt, []).push(...flagDirectives);
            }
        },
        exit ({ node: node }, { flagDirectivesByAlt: flagDirectivesByAlt }) {
            if (flagDirectivesByAlt.get(node)?.length) {
                const flags = $ee2fdfa8e1ecd950$var$getCombinedFlagModsFromFlagNodes(flagDirectivesByAlt.get(node));
                if (flags) {
                    const flagGroup = (0, $4e3b66797d9e7d60$export$856f728536d122cb)({
                        flags: flags
                    });
                    flagGroup.body[0].body = node.body;
                    node.body = [
                        $ee2fdfa8e1ecd950$var$setParentDeep(flagGroup, node)
                    ];
                }
            }
        }
    },
    Assertion ({ node: node, parent: parent, key: key, container: container, root: root, remove: remove, replaceWith: replaceWith }, state) {
        const { kind: kind, negate: negate } = node;
        const { asciiWordBoundaries: asciiWordBoundaries, avoidSubclass: avoidSubclass, supportedGNodes: supportedGNodes, wordIsAscii: wordIsAscii } = state;
        if (kind === "text_segment_boundary") throw new Error(`Unsupported text segment boundary "\\${negate ? "Y" : "y"}"`);
        else if (kind === "line_end") replaceWith($ee2fdfa8e1ecd950$var$setParentDeep((0, $4e3b66797d9e7d60$export$a1c731c64d750557)({
            body: [
                (0, $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd)({
                    body: [
                        (0, $4e3b66797d9e7d60$export$987f29926deb46c2)("string_end")
                    ]
                }),
                (0, $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd)({
                    body: [
                        (0, $4e3b66797d9e7d60$export$4d63783c2be0a38c)(10)
                    ]
                })
            ]
        }), parent));
        else if (kind === "line_start") replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$parseFragment($ee2fdfa8e1ecd950$var$r`(?<=\A|\n(?!\z))`, {
            skipLookbehindValidation: true
        }), parent));
        else if (kind === "search_start") {
            if (supportedGNodes.has(node)) {
                root.flags.sticky = true;
                remove();
            } else {
                const prev = container[key - 1];
                if (prev && $ee2fdfa8e1ecd950$var$isAlwaysNonZeroLength(prev)) replaceWith($ee2fdfa8e1ecd950$var$setParentDeep((0, $4e3b66797d9e7d60$export$a1c731c64d750557)({
                    negate: true
                }), parent));
                else if (avoidSubclass) throw new Error($ee2fdfa8e1ecd950$var$r`Uses "\G" in a way that requires a subclass`);
                else {
                    replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$987f29926deb46c2)("string_start"), parent));
                    state.strategy = "clip_search";
                }
            }
        } else if (kind === "string_end" || kind === "string_start") ;
        else if (kind === "string_end_newline") replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$parseFragment($ee2fdfa8e1ecd950$var$r`(?=\n?\z)`), parent));
        else if (kind === "word_boundary") {
            if (!wordIsAscii && !asciiWordBoundaries) {
                const b = `(?:(?<=${$ee2fdfa8e1ecd950$var$defaultWordChar})(?!${$ee2fdfa8e1ecd950$var$defaultWordChar})|(?<!${$ee2fdfa8e1ecd950$var$defaultWordChar})(?=${$ee2fdfa8e1ecd950$var$defaultWordChar}))`;
                const B = `(?:(?<=${$ee2fdfa8e1ecd950$var$defaultWordChar})(?=${$ee2fdfa8e1ecd950$var$defaultWordChar})|(?<!${$ee2fdfa8e1ecd950$var$defaultWordChar})(?!${$ee2fdfa8e1ecd950$var$defaultWordChar}))`;
                replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$parseFragment(negate ? B : b), parent));
            }
        } else throw new Error(`Unexpected assertion kind "${kind}"`);
    },
    Backreference ({ node: node }, { jsGroupNameMap: jsGroupNameMap }) {
        let { ref: ref } = node;
        if (typeof ref === "string" && !$ee2fdfa8e1ecd950$var$isValidJsGroupName(ref)) {
            ref = $ee2fdfa8e1ecd950$var$getAndStoreJsGroupName(ref, jsGroupNameMap);
            node.ref = ref;
        }
    },
    CapturingGroup ({ node: node }, { jsGroupNameMap: jsGroupNameMap, subroutineRefMap: subroutineRefMap }) {
        let { name: name } = node;
        if (name && !$ee2fdfa8e1ecd950$var$isValidJsGroupName(name)) {
            name = $ee2fdfa8e1ecd950$var$getAndStoreJsGroupName(name, jsGroupNameMap);
            node.name = name;
        }
        subroutineRefMap.set(node.number, node);
        if (name) subroutineRefMap.set(name, node);
    },
    CharacterClassRange ({ node: node, parent: parent, replaceWith: replaceWith }) {
        if (parent.kind === "intersection") {
            const cc = (0, $4e3b66797d9e7d60$export$9e021a2c1a31ab55)({
                body: [
                    node
                ]
            });
            replaceWith($ee2fdfa8e1ecd950$var$setParentDeep(cc, parent), {
                traverse: true
            });
        }
    },
    CharacterSet ({ node: node, parent: parent, replaceWith: replaceWith }, { accuracy: accuracy, minTargetEs2024: minTargetEs2024, digitIsAscii: digitIsAscii, spaceIsAscii: spaceIsAscii, wordIsAscii: wordIsAscii }) {
        const { kind: kind, negate: negate, value: value } = node;
        if (digitIsAscii && (kind === "digit" || value === "digit")) {
            replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$247758b45a713079)("digit", {
                negate: negate
            }), parent));
            return;
        }
        if (spaceIsAscii && (kind === "space" || value === "space")) {
            replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$setNegate($ee2fdfa8e1ecd950$var$parseFragment($ee2fdfa8e1ecd950$var$asciiSpaceChar), negate), parent));
            return;
        }
        if (wordIsAscii && (kind === "word" || value === "word")) {
            replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$247758b45a713079)("word", {
                negate: negate
            }), parent));
            return;
        }
        if (kind === "any") replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$3968c6d753b95879)("Any"), parent));
        else if (kind === "digit") replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$3968c6d753b95879)("Nd", {
            negate: negate
        }), parent));
        else if (kind === "dot") ;
        else if (kind === "text_segment") {
            if (accuracy === "strict") throw new Error($ee2fdfa8e1ecd950$var$r`Use of "\X" requires non-strict accuracy`);
            const eBase = "\\p{Emoji}(?:\\p{EMod}|\\uFE0F\\u20E3?|[\\x{E0020}-\\x{E007E}]+\\x{E007F})?";
            const emoji = $ee2fdfa8e1ecd950$var$r`\p{RI}{2}|${eBase}(?:\u200D${eBase})*`;
            replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$parseFragment(// Close approximation of an extended grapheme cluster; see <unicode.org/reports/tr29/>
            $ee2fdfa8e1ecd950$var$r`(?>\r\n|${minTargetEs2024 ? $ee2fdfa8e1ecd950$var$r`\p{RGI_Emoji}` : emoji}|\P{M}\p{M}*)`, // Allow JS property `RGI_Emoji` through
            {
                skipPropertyNameValidation: true
            }), parent));
        } else if (kind === "hex") replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$3968c6d753b95879)("AHex", {
            negate: negate
        }), parent));
        else if (kind === "newline") replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$parseFragment(negate ? "[^\n]" : "(?>\r\n?|[\n\v\f\x85\u2028\u2029])"), parent));
        else if (kind === "posix") {
            if (!minTargetEs2024 && (value === "graph" || value === "print")) {
                if (accuracy === "strict") throw new Error(`POSIX class "${value}" requires min target ES2024 or non-strict accuracy`);
                let ascii = {
                    graph: "!-~",
                    print: " -~"
                }[value];
                if (negate) ascii = `\0-${$ee2fdfa8e1ecd950$var$cp(ascii.codePointAt(0) - 1)}${$ee2fdfa8e1ecd950$var$cp(ascii.codePointAt(2) + 1)}-\u{10FFFF}`;
                replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$parseFragment(`[${ascii}]`), parent));
            } else replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$setNegate($ee2fdfa8e1ecd950$var$parseFragment($ee2fdfa8e1ecd950$var$PosixClassMap.get(value)), negate), parent));
        } else if (kind === "property") {
            if (!$ee2fdfa8e1ecd950$var$JsUnicodePropertyMap.has((0, $4e3b66797d9e7d60$export$74643d1fe038be1a)(value))) node.key = "sc";
        } else if (kind === "space") replaceWith($ee2fdfa8e1ecd950$var$setParent((0, $4e3b66797d9e7d60$export$3968c6d753b95879)("space", {
            negate: negate
        }), parent));
        else if (kind === "word") replaceWith($ee2fdfa8e1ecd950$var$setParentDeep($ee2fdfa8e1ecd950$var$setNegate($ee2fdfa8e1ecd950$var$parseFragment($ee2fdfa8e1ecd950$var$defaultWordChar), negate), parent));
        else throw new Error(`Unexpected character set kind "${kind}"`);
    },
    Directive ({ node: node, parent: parent, root: root, remove: remove, replaceWith: replaceWith, removeAllPrevSiblings: removeAllPrevSiblings, removeAllNextSiblings: removeAllNextSiblings }) {
        const { kind: kind, flags: flags } = node;
        if (kind === "flags") {
            if (!flags.enable && !flags.disable) remove();
            else {
                const flagGroup = (0, $4e3b66797d9e7d60$export$856f728536d122cb)({
                    flags: flags
                });
                flagGroup.body[0].body = removeAllNextSiblings();
                replaceWith($ee2fdfa8e1ecd950$var$setParentDeep(flagGroup, parent), {
                    traverse: true
                });
            }
        } else if (kind === "keep") {
            const firstAlt = root.body[0];
            const hasWrapperGroup = root.body.length === 1 && // Not emulatable if within a `CapturingGroup`
            (0, $9adc2a332adf8d3e$export$dcb3ae0c3f199df3)(firstAlt, {
                type: "Group"
            }) && firstAlt.body[0].body.length === 1;
            const topLevel = hasWrapperGroup ? firstAlt.body[0] : root;
            if (parent.parent !== topLevel || topLevel.body.length > 1) throw new Error($ee2fdfa8e1ecd950$var$r`Uses "\K" in a way that's unsupported`);
            const lookbehind = (0, $4e3b66797d9e7d60$export$a1c731c64d750557)({
                behind: true
            });
            lookbehind.body[0].body = removeAllPrevSiblings();
            replaceWith($ee2fdfa8e1ecd950$var$setParentDeep(lookbehind, parent));
        } else throw new Error(`Unexpected directive kind "${kind}"`);
    },
    Flags ({ node: node, parent: parent }) {
        if (node.posixIsAscii) throw new Error('Unsupported flag "P"');
        if (node.textSegmentMode === "word") throw new Error('Unsupported flag "y{w}"');
        [
            "digitIsAscii",
            // Flag D
            "extended",
            // Flag x
            "posixIsAscii",
            // Flag P
            "spaceIsAscii",
            // Flag S
            "wordIsAscii",
            // Flag W
            "textSegmentMode"
        ].forEach((f)=>delete node[f]);
        Object.assign(node, {
            // JS flag g; no Onig equiv
            global: false,
            // JS flag d; no Onig equiv
            hasIndices: false,
            // JS flag m; no Onig equiv but its behavior is always on in Onig. Onig's only line break
            // char is line feed, unlike JS, so this flag isn't used since it would produce inaccurate
            // results (also allows `^` and `$` to be used in the generator for string start and end)
            multiline: false,
            // JS flag y; no Onig equiv, but used for `\G` emulation
            sticky: node.sticky ?? false
        });
        parent.options = {
            disable: {
                // Onig uses different rules for flag x than Regex+, so disable the implicit flag
                x: true,
                // Onig has no flag to control "named capture only" mode but contextually applies its
                // behavior when named capturing is used, so disable Regex+'s implicit flag for it
                n: true
            },
            force: {
                // Always add flag v because we're generating an AST that relies on it (it enables JS
                // support for Onig features nested classes, intersection, Unicode properties, etc.).
                // However, the generator might disable flag v based on its `target` option
                v: true
            }
        };
    },
    Group ({ node: node }) {
        if (!node.flags) return;
        const { enable: enable, disable: disable } = node.flags;
        enable?.extended && delete enable.extended;
        disable?.extended && delete disable.extended;
        enable?.dotAll && disable?.dotAll && delete enable.dotAll;
        enable?.ignoreCase && disable?.ignoreCase && delete enable.ignoreCase;
        enable && !Object.keys(enable).length && delete node.flags.enable;
        disable && !Object.keys(disable).length && delete node.flags.disable;
        !node.flags.enable && !node.flags.disable && delete node.flags;
    },
    LookaroundAssertion ({ node: node }, state) {
        const { kind: kind } = node;
        if (kind === "lookbehind") state.passedLookbehind = true;
    },
    NamedCallout ({ node: node, parent: parent, replaceWith: replaceWith }) {
        const { kind: kind } = node;
        if (kind === "fail") replaceWith($ee2fdfa8e1ecd950$var$setParentDeep((0, $4e3b66797d9e7d60$export$a1c731c64d750557)({
            negate: true
        }), parent));
        else throw new Error(`Unsupported named callout "(*${kind.toUpperCase()}"`);
    },
    Quantifier ({ node: node }) {
        if (node.body.type === "Quantifier") {
            const group = (0, $4e3b66797d9e7d60$export$856f728536d122cb)();
            group.body[0].body.push(node.body);
            node.body = $ee2fdfa8e1ecd950$var$setParentDeep(group, node);
        }
    },
    Regex: {
        enter ({ node: node }, { supportedGNodes: supportedGNodes }) {
            const leadingGs = [];
            let hasAltWithLeadG = false;
            let hasAltWithoutLeadG = false;
            for (const alt of node.body)if (alt.body.length === 1 && alt.body[0].kind === "search_start") alt.body.pop();
            else {
                const leadingG = $ee2fdfa8e1ecd950$var$getLeadingG(alt.body);
                if (leadingG) {
                    hasAltWithLeadG = true;
                    Array.isArray(leadingG) ? leadingGs.push(...leadingG) : leadingGs.push(leadingG);
                } else hasAltWithoutLeadG = true;
            }
            if (hasAltWithLeadG && !hasAltWithoutLeadG) leadingGs.forEach((g)=>supportedGNodes.add(g));
        },
        exit (_, { accuracy: accuracy, passedLookbehind: passedLookbehind, strategy: strategy }) {
            if (accuracy === "strict" && passedLookbehind && strategy) throw new Error($ee2fdfa8e1ecd950$var$r`Uses "\G" in a way that requires non-strict accuracy`);
        }
    },
    Subroutine ({ node: node }, { jsGroupNameMap: jsGroupNameMap }) {
        let { ref: ref } = node;
        if (typeof ref === "string" && !$ee2fdfa8e1ecd950$var$isValidJsGroupName(ref)) {
            ref = $ee2fdfa8e1ecd950$var$getAndStoreJsGroupName(ref, jsGroupNameMap);
            node.ref = ref;
        }
    }
};
var $ee2fdfa8e1ecd950$var$SecondPassVisitor = {
    Backreference ({ node: node }, { multiplexCapturesToLeftByRef: multiplexCapturesToLeftByRef, reffedNodesByReferencer: reffedNodesByReferencer }) {
        const { orphan: orphan, ref: ref } = node;
        if (!orphan) reffedNodesByReferencer.set(node, [
            ...multiplexCapturesToLeftByRef.get(ref).map(({ node: node2 })=>node2)
        ]);
    },
    CapturingGroup: {
        enter ({ node: node, parent: parent, replaceWith: replaceWith, skip: skip }, { groupOriginByCopy: groupOriginByCopy, groupsByName: groupsByName, multiplexCapturesToLeftByRef: multiplexCapturesToLeftByRef, openRefs: openRefs, reffedNodesByReferencer: reffedNodesByReferencer }) {
            const origin = groupOriginByCopy.get(node);
            if (origin && openRefs.has(node.number)) {
                const recursion2 = $ee2fdfa8e1ecd950$var$setParent($ee2fdfa8e1ecd950$var$createRecursion(node.number), parent);
                reffedNodesByReferencer.set(recursion2, openRefs.get(node.number));
                replaceWith(recursion2);
                return;
            }
            openRefs.set(node.number, node);
            multiplexCapturesToLeftByRef.set(node.number, []);
            if (node.name) $ee2fdfa8e1ecd950$var$getOrInsert(multiplexCapturesToLeftByRef, node.name, []);
            const multiplexNodes = multiplexCapturesToLeftByRef.get(node.name ?? node.number);
            for(let i = 0; i < multiplexNodes.length; i++){
                const multiplex = multiplexNodes[i];
                if (// This group is from subroutine expansion, and there's a multiplex value from either the
                // origin node or a prior subroutine expansion group with the same origin
                origin === multiplex.node || origin && origin === multiplex.origin || // This group is not from subroutine expansion, and it comes after a subroutine expansion
                // group that refers to this group
                node === multiplex.origin) {
                    multiplexNodes.splice(i, 1);
                    break;
                }
            }
            multiplexCapturesToLeftByRef.get(node.number).push({
                node: node,
                origin: origin
            });
            if (node.name) multiplexCapturesToLeftByRef.get(node.name).push({
                node: node,
                origin: origin
            });
            if (node.name) {
                const groupsWithSameName = $ee2fdfa8e1ecd950$var$getOrInsert(groupsByName, node.name, /* @__PURE__ */ new Map());
                let hasDuplicateNameToRemove = false;
                if (origin) hasDuplicateNameToRemove = true;
                else {
                    for (const groupInfo of groupsWithSameName.values())if (!groupInfo.hasDuplicateNameToRemove) {
                        hasDuplicateNameToRemove = true;
                        break;
                    }
                }
                groupsByName.get(node.name).set(node, {
                    node: node,
                    hasDuplicateNameToRemove: hasDuplicateNameToRemove
                });
            }
        },
        exit ({ node: node }, { openRefs: openRefs }) {
            if (openRefs.get(node.number) === node) openRefs.delete(node.number);
        }
    },
    Group: {
        enter ({ node: node }, state) {
            state.prevFlags = state.currentFlags;
            if (node.flags) state.currentFlags = $ee2fdfa8e1ecd950$var$getNewCurrentFlags(state.currentFlags, node.flags);
        },
        exit (_, state) {
            state.currentFlags = state.prevFlags;
        }
    },
    Subroutine ({ node: node, parent: parent, replaceWith: replaceWith }, state) {
        const { isRecursive: isRecursive, ref: ref } = node;
        if (isRecursive) {
            let reffed = parent;
            while(reffed = reffed.parent){
                if (reffed.type === "CapturingGroup" && (reffed.name === ref || reffed.number === ref)) break;
            }
            state.reffedNodesByReferencer.set(node, reffed);
            return;
        }
        const reffedGroupNode = state.subroutineRefMap.get(ref);
        const isGlobalRecursion = ref === 0;
        const expandedSubroutine = isGlobalRecursion ? $ee2fdfa8e1ecd950$var$createRecursion(0) : // The reffed group might itself contain subroutines, which are expanded during sub-traversal
        $ee2fdfa8e1ecd950$var$cloneCapturingGroup(reffedGroupNode, state.groupOriginByCopy, null);
        let replacement = expandedSubroutine;
        if (!isGlobalRecursion) {
            const reffedGroupFlagMods = $ee2fdfa8e1ecd950$var$getCombinedFlagModsFromFlagNodes($ee2fdfa8e1ecd950$var$getAllParents(reffedGroupNode, (p)=>p.type === "Group" && !!p.flags));
            const reffedGroupFlags = reffedGroupFlagMods ? $ee2fdfa8e1ecd950$var$getNewCurrentFlags(state.globalFlags, reffedGroupFlagMods) : state.globalFlags;
            if (!$ee2fdfa8e1ecd950$var$areFlagsEqual(reffedGroupFlags, state.currentFlags)) {
                replacement = (0, $4e3b66797d9e7d60$export$856f728536d122cb)({
                    flags: $ee2fdfa8e1ecd950$var$getFlagModsFromFlags(reffedGroupFlags)
                });
                replacement.body[0].body.push(expandedSubroutine);
            }
        }
        replaceWith($ee2fdfa8e1ecd950$var$setParentDeep(replacement, parent), {
            traverse: !isGlobalRecursion
        });
    }
};
var $ee2fdfa8e1ecd950$var$ThirdPassVisitor = {
    Backreference ({ node: node, parent: parent, replaceWith: replaceWith }, state) {
        if (node.orphan) {
            state.highestOrphanBackref = Math.max(state.highestOrphanBackref, node.ref);
            return;
        }
        const reffedNodes = state.reffedNodesByReferencer.get(node);
        const participants = reffedNodes.filter((reffed)=>$ee2fdfa8e1ecd950$var$canParticipateWithNode(reffed, node));
        if (!participants.length) replaceWith($ee2fdfa8e1ecd950$var$setParentDeep((0, $4e3b66797d9e7d60$export$a1c731c64d750557)({
            negate: true
        }), parent));
        else if (participants.length > 1) {
            const group = (0, $4e3b66797d9e7d60$export$856f728536d122cb)({
                atomic: true,
                body: participants.reverse().map((reffed)=>(0, $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd)({
                        body: [
                            (0, $4e3b66797d9e7d60$export$19ee8a21aa784111)(reffed.number)
                        ]
                    }))
            });
            replaceWith($ee2fdfa8e1ecd950$var$setParentDeep(group, parent));
        } else node.ref = participants[0].number;
    },
    CapturingGroup ({ node: node }, state) {
        node.number = ++state.numCapturesToLeft;
        if (node.name) {
            if (state.groupsByName.get(node.name).get(node).hasDuplicateNameToRemove) delete node.name;
        }
    },
    Regex: {
        exit ({ node: node }, state) {
            const numCapsNeeded = Math.max(state.highestOrphanBackref - state.numCapturesToLeft, 0);
            for(let i = 0; i < numCapsNeeded; i++){
                const emptyCapture = (0, $4e3b66797d9e7d60$export$e8bb25176ecaca85)();
                node.body.at(-1).body.push(emptyCapture);
            }
        }
    },
    Subroutine ({ node: node }, state) {
        if (!node.isRecursive || node.ref === 0) return;
        node.ref = state.reffedNodesByReferencer.get(node).number;
    }
};
function $ee2fdfa8e1ecd950$var$addParentProperties(root) {
    (0, $ed4615b60e8f202d$export$df3f009e3d155b20)(root, {
        "*" ({ node: node, parent: parent }) {
            node.parent = parent;
        }
    });
}
function $ee2fdfa8e1ecd950$var$areFlagsEqual(a, b) {
    return a.dotAll === b.dotAll && a.ignoreCase === b.ignoreCase;
}
function $ee2fdfa8e1ecd950$var$canParticipateWithNode(capture, node) {
    let rightmostPoint = node;
    do {
        if (rightmostPoint.type === "Regex") return false;
        if (rightmostPoint.type === "Alternative") continue;
        if (rightmostPoint === capture) return false;
        const kidsOfParent = $ee2fdfa8e1ecd950$var$getKids(rightmostPoint.parent);
        for (const kid of kidsOfParent){
            if (kid === rightmostPoint) break;
            if (kid === capture || $ee2fdfa8e1ecd950$var$isAncestorOf(kid, capture)) return true;
        }
    }while (rightmostPoint = rightmostPoint.parent);
    throw new Error("Unexpected path");
}
function $ee2fdfa8e1ecd950$var$cloneCapturingGroup(obj, originMap, up, up2) {
    const store = Array.isArray(obj) ? [] : {};
    for (const [key, value] of Object.entries(obj)){
        if (key === "parent") store.parent = Array.isArray(up) ? up2 : up;
        else if (value && typeof value === "object") store[key] = $ee2fdfa8e1ecd950$var$cloneCapturingGroup(value, originMap, store, up);
        else {
            if (key === "type" && value === "CapturingGroup") originMap.set(store, originMap.get(obj) ?? obj);
            store[key] = value;
        }
    }
    return store;
}
function $ee2fdfa8e1ecd950$var$createRecursion(ref) {
    const node = (0, $4e3b66797d9e7d60$export$3b50b5d6d0004cab)(ref);
    node.isRecursive = true;
    return node;
}
function $ee2fdfa8e1ecd950$var$getAllParents(node, filterFn) {
    const results = [];
    while(node = node.parent)if (!filterFn || filterFn(node)) results.push(node);
    return results;
}
function $ee2fdfa8e1ecd950$var$getAndStoreJsGroupName(name, map) {
    if (map.has(name)) return map.get(name);
    const jsName = `$${map.size}_${name.replace(/^[^$_\p{IDS}]|[^$\u200C\u200D\p{IDC}]/ug, "_")}`;
    map.set(name, jsName);
    return jsName;
}
function $ee2fdfa8e1ecd950$var$getCombinedFlagModsFromFlagNodes(flagNodes) {
    const flagProps = [
        "dotAll",
        "ignoreCase"
    ];
    const combinedFlags = {
        enable: {},
        disable: {}
    };
    flagNodes.forEach(({ flags: flags })=>{
        flagProps.forEach((prop)=>{
            if (flags.enable?.[prop]) {
                delete combinedFlags.disable[prop];
                combinedFlags.enable[prop] = true;
            }
            if (flags.disable?.[prop]) combinedFlags.disable[prop] = true;
        });
    });
    if (!Object.keys(combinedFlags.enable).length) delete combinedFlags.enable;
    if (!Object.keys(combinedFlags.disable).length) delete combinedFlags.disable;
    if (combinedFlags.enable || combinedFlags.disable) return combinedFlags;
    return null;
}
function $ee2fdfa8e1ecd950$var$getFlagModsFromFlags({ dotAll: dotAll, ignoreCase: ignoreCase }) {
    const mods = {};
    if (dotAll || ignoreCase) {
        mods.enable = {};
        dotAll && (mods.enable.dotAll = true);
        ignoreCase && (mods.enable.ignoreCase = true);
    }
    if (!dotAll || !ignoreCase) {
        mods.disable = {};
        !dotAll && (mods.disable.dotAll = true);
        !ignoreCase && (mods.disable.ignoreCase = true);
    }
    return mods;
}
function $ee2fdfa8e1ecd950$var$getKids(node) {
    if (!node) throw new Error("Node expected");
    const { body: body } = node;
    return Array.isArray(body) ? body : body ? [
        body
    ] : null;
}
function $ee2fdfa8e1ecd950$var$getLeadingG(els) {
    const firstToConsider = els.find((el)=>el.kind === "search_start" || $ee2fdfa8e1ecd950$var$isLoneGLookaround(el, {
            negate: false
        }) || !$ee2fdfa8e1ecd950$var$isAlwaysZeroLength(el));
    if (!firstToConsider) return null;
    if (firstToConsider.kind === "search_start") return firstToConsider;
    if (firstToConsider.type === "LookaroundAssertion") return firstToConsider.body[0].body[0];
    if (firstToConsider.type === "CapturingGroup" || firstToConsider.type === "Group") {
        const gNodesForGroup = [];
        for (const alt of firstToConsider.body){
            const leadingG = $ee2fdfa8e1ecd950$var$getLeadingG(alt.body);
            if (!leadingG) return null;
            Array.isArray(leadingG) ? gNodesForGroup.push(...leadingG) : gNodesForGroup.push(leadingG);
        }
        return gNodesForGroup;
    }
    return null;
}
function $ee2fdfa8e1ecd950$var$isAncestorOf(node, descendant) {
    const kids = $ee2fdfa8e1ecd950$var$getKids(node) ?? [];
    for (const kid of kids){
        if (kid === descendant || $ee2fdfa8e1ecd950$var$isAncestorOf(kid, descendant)) return true;
    }
    return false;
}
function $ee2fdfa8e1ecd950$var$isAlwaysZeroLength({ type: type }) {
    return type === "Assertion" || type === "Directive" || type === "LookaroundAssertion";
}
function $ee2fdfa8e1ecd950$var$isAlwaysNonZeroLength(node) {
    const types = [
        "Character",
        "CharacterClass",
        "CharacterSet"
    ];
    return types.includes(node.type) || node.type === "Quantifier" && node.min && types.includes(node.body.type);
}
function $ee2fdfa8e1ecd950$var$isLoneGLookaround(node, options) {
    const opts = {
        negate: null,
        ...options
    };
    return node.type === "LookaroundAssertion" && (opts.negate === null || node.negate === opts.negate) && node.body.length === 1 && (0, $9adc2a332adf8d3e$export$dcb3ae0c3f199df3)(node.body[0], {
        type: "Assertion",
        kind: "search_start"
    });
}
function $ee2fdfa8e1ecd950$var$isValidJsGroupName(name) {
    return /^[$_\p{IDS}][$\u200C\u200D\p{IDC}]*$/u.test(name);
}
function $ee2fdfa8e1ecd950$var$parseFragment(pattern, options) {
    const ast = (0, $4e3b66797d9e7d60$export$98e6a39c04603d36)(pattern, {
        ...options,
        // Providing a custom set of Unicode property names avoids converting some JS Unicode
        // properties (ex: `\p{Alpha}`) to Onig POSIX classes
        unicodePropertyMap: $ee2fdfa8e1ecd950$var$JsUnicodePropertyMap
    });
    const alts = ast.body;
    if (alts.length > 1 || alts[0].body.length > 1) return (0, $4e3b66797d9e7d60$export$856f728536d122cb)({
        body: alts
    });
    return alts[0].body[0];
}
function $ee2fdfa8e1ecd950$var$setNegate(node, negate) {
    node.negate = negate;
    return node;
}
function $ee2fdfa8e1ecd950$var$setParent(node, parent) {
    node.parent = parent;
    return node;
}
function $ee2fdfa8e1ecd950$var$setParentDeep(node, parent) {
    $ee2fdfa8e1ecd950$var$addParentProperties(node);
    node.parent = parent;
    return node;
}
function $ee2fdfa8e1ecd950$var$generate(ast, options) {
    const opts = $ee2fdfa8e1ecd950$var$getOptions(options);
    const minTargetEs2024 = $ee2fdfa8e1ecd950$var$isMinTarget(opts.target, "ES2024");
    const minTargetEs2025 = $ee2fdfa8e1ecd950$var$isMinTarget(opts.target, "ES2025");
    const recursionLimit = opts.rules.recursionLimit;
    if (!Number.isInteger(recursionLimit) || recursionLimit < 2 || recursionLimit > 20) throw new Error("Invalid recursionLimit; use 2-20");
    let hasCaseInsensitiveNode = null;
    let hasCaseSensitiveNode = null;
    if (!minTargetEs2025) {
        const iStack = [
            ast.flags.ignoreCase
        ];
        (0, $ed4615b60e8f202d$export$df3f009e3d155b20)(ast, $ee2fdfa8e1ecd950$var$FlagModifierVisitor, {
            getCurrentModI: ()=>iStack.at(-1),
            popModI () {
                iStack.pop();
            },
            pushModI (isIOn) {
                iStack.push(isIOn);
            },
            setHasCasedChar () {
                if (iStack.at(-1)) hasCaseInsensitiveNode = true;
                else hasCaseSensitiveNode = true;
            }
        });
    }
    const appliedGlobalFlags = {
        dotAll: ast.flags.dotAll,
        // - Turn global flag i on if a case insensitive node was used and no case sensitive nodes were
        //   used (to avoid unnecessary node expansion).
        // - Turn global flag i off if a case sensitive node was used (since case sensitivity can't be
        //   forced without the use of ES2025 flag groups)
        ignoreCase: !!((ast.flags.ignoreCase || hasCaseInsensitiveNode) && !hasCaseSensitiveNode)
    };
    let lastNode = ast;
    const state = {
        accuracy: opts.accuracy,
        appliedGlobalFlags: appliedGlobalFlags,
        captureMap: /* @__PURE__ */ new Map(),
        currentFlags: {
            dotAll: ast.flags.dotAll,
            ignoreCase: ast.flags.ignoreCase
        },
        inCharClass: false,
        lastNode: lastNode,
        originMap: ast._originMap,
        recursionLimit: recursionLimit,
        useAppliedIgnoreCase: !!(!minTargetEs2025 && hasCaseInsensitiveNode && hasCaseSensitiveNode),
        useFlagMods: minTargetEs2025,
        useFlagV: minTargetEs2024,
        verbose: opts.verbose
    };
    function gen(node) {
        state.lastNode = lastNode;
        lastNode = node;
        const fn = $ee2fdfa8e1ecd950$var$throwIfNullish($ee2fdfa8e1ecd950$var$generator[node.type], `Unexpected node type "${node.type}"`);
        return fn(node, state, gen);
    }
    const result = {
        pattern: ast.body.map(gen).join("|"),
        // Could reset `lastNode` at this point via `lastNode = ast`, but it isn't needed by flags
        flags: gen(ast.flags),
        options: {
            ...ast.options
        }
    };
    if (!minTargetEs2024) {
        delete result.options.force.v;
        result.options.disable.v = true;
        result.options.unicodeSetsPlugin = null;
    }
    result._captureTransfers = /* @__PURE__ */ new Map();
    result._hiddenCaptures = [];
    state.captureMap.forEach((value, key)=>{
        if (value.hidden) result._hiddenCaptures.push(key);
        if (value.transferTo) $ee2fdfa8e1ecd950$var$getOrInsert(result._captureTransfers, value.transferTo, []).push(key);
    });
    return result;
}
var $ee2fdfa8e1ecd950$var$FlagModifierVisitor = {
    "*": {
        enter ({ node: node }, state) {
            if ($ee2fdfa8e1ecd950$var$isAnyGroup(node)) {
                const currentModI = state.getCurrentModI();
                state.pushModI(node.flags ? $ee2fdfa8e1ecd950$var$getNewCurrentFlags({
                    ignoreCase: currentModI
                }, node.flags).ignoreCase : currentModI);
            }
        },
        exit ({ node: node }, state) {
            if ($ee2fdfa8e1ecd950$var$isAnyGroup(node)) state.popModI();
        }
    },
    Backreference (_, state) {
        state.setHasCasedChar();
    },
    Character ({ node: node }, state) {
        if ($ee2fdfa8e1ecd950$var$charHasCase($ee2fdfa8e1ecd950$var$cp(node.value))) state.setHasCasedChar();
    },
    CharacterClassRange ({ node: node, skip: skip }, state) {
        skip();
        if ($ee2fdfa8e1ecd950$var$getCasesOutsideCharClassRange(node, {
            firstOnly: true
        }).length) state.setHasCasedChar();
    },
    CharacterSet ({ node: node }, state) {
        if (node.kind === "property" && $ee2fdfa8e1ecd950$var$UnicodePropertiesWithSpecificCase.has(node.value)) state.setHasCasedChar();
    }
};
var $ee2fdfa8e1ecd950$var$generator = {
    /**
  @param {AlternativeNode} node
  */ Alternative ({ body: body }, _, gen) {
        return body.map(gen).join("");
    },
    /**
  @param {AssertionNode} node
  */ Assertion ({ kind: kind, negate: negate }) {
        if (kind === "string_end") return "$";
        if (kind === "string_start") return "^";
        if (kind === "word_boundary") return negate ? $ee2fdfa8e1ecd950$var$r`\B` : $ee2fdfa8e1ecd950$var$r`\b`;
        throw new Error(`Unexpected assertion kind "${kind}"`);
    },
    /**
  @param {BackreferenceNode} node
  */ Backreference ({ ref: ref }, state) {
        if (typeof ref !== "number") throw new Error("Unexpected named backref in transformed AST");
        if (!state.useFlagMods && state.accuracy === "strict" && state.currentFlags.ignoreCase && !state.captureMap.get(ref).ignoreCase) throw new Error("Use of case-insensitive backref to case-sensitive group requires target ES2025 or non-strict accuracy");
        return "\\" + ref;
    },
    /**
  @param {CapturingGroupNode} node
  */ CapturingGroup (node, state, gen) {
        const { body: body, name: name, number: number } = node;
        const data = {
            ignoreCase: state.currentFlags.ignoreCase
        };
        const origin = state.originMap.get(node);
        if (origin) {
            data.hidden = true;
            if (number > origin.number) data.transferTo = origin.number;
        }
        state.captureMap.set(number, data);
        return `(${name ? `?<${name}>` : ""}${body.map(gen).join("|")})`;
    },
    /**
  @param {CharacterNode} node
  */ Character ({ value: value }, state) {
        const char = $ee2fdfa8e1ecd950$var$cp(value);
        const escaped = $ee2fdfa8e1ecd950$var$getCharEscape(value, {
            escDigit: state.lastNode.type === "Backreference",
            inCharClass: state.inCharClass,
            useFlagV: state.useFlagV
        });
        if (escaped !== char) return escaped;
        if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase && $ee2fdfa8e1ecd950$var$charHasCase(char)) {
            const cases = $ee2fdfa8e1ecd950$var$getIgnoreCaseMatchChars(char);
            return state.inCharClass ? cases.join("") : cases.length > 1 ? `[${cases.join("")}]` : cases[0];
        }
        return char;
    },
    /**
  @param {CharacterClassNode} node
  */ CharacterClass (node, state, gen) {
        const { kind: kind, negate: negate, parent: parent } = node;
        let { body: body } = node;
        if (kind === "intersection" && !state.useFlagV) throw new Error("Use of character class intersection requires min target ES2024");
        if ($ee2fdfa8e1ecd950$var$envFlags.bugFlagVLiteralHyphenIsRange && state.useFlagV && body.some($ee2fdfa8e1ecd950$var$isLiteralHyphen)) body = [
            (0, $4e3b66797d9e7d60$export$4d63783c2be0a38c)(45),
            ...body.filter((kid)=>!$ee2fdfa8e1ecd950$var$isLiteralHyphen(kid))
        ];
        const genClass = ()=>`[${negate ? "^" : ""}${body.map(gen).join(kind === "intersection" ? "&&" : "")}]`;
        if (!state.inCharClass) {
            if (// Already established `kind !== 'intersection'` if `!state.useFlagV`; don't check again
            (!state.useFlagV || $ee2fdfa8e1ecd950$var$envFlags.bugNestedClassIgnoresNegation) && !negate) {
                const negatedChildClasses = body.filter((kid)=>kid.type === "CharacterClass" && kid.kind === "union" && kid.negate);
                if (negatedChildClasses.length) {
                    const group = (0, $4e3b66797d9e7d60$export$856f728536d122cb)();
                    const groupFirstAlt = group.body[0];
                    group.parent = parent;
                    groupFirstAlt.parent = group;
                    body = body.filter((kid)=>!negatedChildClasses.includes(kid));
                    node.body = body;
                    if (body.length) {
                        node.parent = groupFirstAlt;
                        groupFirstAlt.body.push(node);
                    } else group.body.pop();
                    negatedChildClasses.forEach((cc)=>{
                        const newAlt = (0, $4e3b66797d9e7d60$export$4506b1bb0cf5d8dd)({
                            body: [
                                cc
                            ]
                        });
                        cc.parent = newAlt;
                        newAlt.parent = group;
                        group.body.push(newAlt);
                    });
                    return gen(group);
                }
            }
            state.inCharClass = true;
            const result = genClass();
            state.inCharClass = false;
            return result;
        }
        const firstEl = body[0];
        if (// Already established that the parent is a char class via `inCharClass`; don't check again
        kind === "union" && !negate && firstEl && // Allows many nested classes to work with `target` ES2018 which doesn't support nesting
        ((!state.useFlagV || !state.verbose) && parent.kind === "union" && !($ee2fdfa8e1ecd950$var$envFlags.bugFlagVLiteralHyphenIsRange && state.useFlagV) || !state.verbose && parent.kind === "intersection" && // JS doesn't allow intersection with union or ranges
        body.length === 1 && firstEl.type !== "CharacterClassRange")) return body.map(gen).join("");
        if (!state.useFlagV && parent.type === "CharacterClass") throw new Error("Uses nested character class in a way that requires min target ES2024");
        return genClass();
    },
    /**
  @param {CharacterClassRangeNode} node
  */ CharacterClassRange (node, state) {
        const min = node.min.value;
        const max = node.max.value;
        const escOpts = {
            escDigit: false,
            inCharClass: true,
            useFlagV: state.useFlagV
        };
        const minStr = $ee2fdfa8e1ecd950$var$getCharEscape(min, escOpts);
        const maxStr = $ee2fdfa8e1ecd950$var$getCharEscape(max, escOpts);
        const extraChars = /* @__PURE__ */ new Set();
        if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase) {
            const charsOutsideRange = $ee2fdfa8e1ecd950$var$getCasesOutsideCharClassRange(node);
            const ranges = $ee2fdfa8e1ecd950$var$getCodePointRangesFromChars(charsOutsideRange);
            ranges.forEach((value)=>{
                extraChars.add(Array.isArray(value) ? `${$ee2fdfa8e1ecd950$var$getCharEscape(value[0], escOpts)}-${$ee2fdfa8e1ecd950$var$getCharEscape(value[1], escOpts)}` : $ee2fdfa8e1ecd950$var$getCharEscape(value, escOpts));
            });
        }
        return `${minStr}-${maxStr}${[
            ...extraChars
        ].join("")}`;
    },
    /**
  @param {CharacterSetNode} node
  */ CharacterSet ({ kind: kind, negate: negate, value: value, key: key }, state) {
        if (kind === "dot") return state.currentFlags.dotAll ? state.appliedGlobalFlags.dotAll || state.useFlagMods ? "." : "[^]" : // Onig's only line break char is line feed, unlike JS
        $ee2fdfa8e1ecd950$var$r`[^\n]`;
        if (kind === "digit") return negate ? $ee2fdfa8e1ecd950$var$r`\D` : $ee2fdfa8e1ecd950$var$r`\d`;
        if (kind === "property") {
            if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase && $ee2fdfa8e1ecd950$var$UnicodePropertiesWithSpecificCase.has(value)) throw new Error(`Unicode property "${value}" can't be case-insensitive when other chars have specific case`);
            return `${negate ? $ee2fdfa8e1ecd950$var$r`\P` : $ee2fdfa8e1ecd950$var$r`\p`}{${key ? `${key}=` : ""}${value}}`;
        }
        if (kind === "word") return negate ? $ee2fdfa8e1ecd950$var$r`\W` : $ee2fdfa8e1ecd950$var$r`\w`;
        throw new Error(`Unexpected character set kind "${kind}"`);
    },
    /**
  @param {FlagsNode} node
  */ Flags (node, state) {
        return(// The transformer should never turn on the properties for flags d, g, m since Onig doesn't
        // have equivs. Flag m is never used since Onig uses different line break chars than JS
        // (node.hasIndices ? 'd' : '') +
        // (node.global ? 'g' : '') +
        // (node.multiline ? 'm' : '') +
        (state.appliedGlobalFlags.ignoreCase ? "i" : "") + (node.dotAll ? "s" : "") + (node.sticky ? "y" : ""));
    },
    /**
  @param {GroupNode} node
  */ Group ({ atomic: atomic2, body: body, flags: flags, parent: parent }, state, gen) {
        const currentFlags = state.currentFlags;
        if (flags) state.currentFlags = $ee2fdfa8e1ecd950$var$getNewCurrentFlags(currentFlags, flags);
        const contents = body.map(gen).join("|");
        const result = !state.verbose && body.length === 1 && // Single alt
        parent.type !== "Quantifier" && !atomic2 && (!state.useFlagMods || !flags) ? contents : `(?${$ee2fdfa8e1ecd950$var$getGroupPrefix(atomic2, flags, state.useFlagMods)}${contents})`;
        state.currentFlags = currentFlags;
        return result;
    },
    /**
  @param {LookaroundAssertionNode} node
  */ LookaroundAssertion ({ body: body, kind: kind, negate: negate }, _, gen) {
        const prefix = `${kind === "lookahead" ? "" : "<"}${negate ? "!" : "="}`;
        return `(?${prefix}${body.map(gen).join("|")})`;
    },
    /**
  @param {QuantifierNode} node
  */ Quantifier (node, _, gen) {
        return gen(node.body) + $ee2fdfa8e1ecd950$var$getQuantifierStr(node);
    },
    /**
  @param {SubroutineNode & {isRecursive: true}} node
  */ Subroutine ({ isRecursive: isRecursive, ref: ref }, state) {
        if (!isRecursive) throw new Error("Unexpected non-recursive subroutine in transformed AST");
        const limit = state.recursionLimit;
        return ref === 0 ? `(?R=${limit})` : $ee2fdfa8e1ecd950$var$r`\g<${ref}&R=${limit}>`;
    }
};
var $ee2fdfa8e1ecd950$var$BaseEscapeChars = /* @__PURE__ */ new Set([
    "$",
    "(",
    ")",
    "*",
    "+",
    ".",
    "?",
    "[",
    "\\",
    "]",
    "^",
    "{",
    "|",
    "}"
]);
var $ee2fdfa8e1ecd950$var$CharClassEscapeChars = /* @__PURE__ */ new Set([
    "-",
    "\\",
    "]",
    "^",
    // Literal `[` doesn't require escaping with flag u, but this can help work around regex source
    // linters and regex syntax processors that expect unescaped `[` to create a nested class
    "["
]);
var $ee2fdfa8e1ecd950$var$CharClassEscapeCharsFlagV = /* @__PURE__ */ new Set([
    "(",
    ")",
    "-",
    "/",
    "[",
    "\\",
    "]",
    "^",
    "{",
    "|",
    "}",
    // Double punctuators; also includes already-listed `-` and `^`
    "!",
    "#",
    "$",
    "%",
    "&",
    "*",
    "+",
    ",",
    ".",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "`",
    "~"
]);
var $ee2fdfa8e1ecd950$var$CharCodeEscapeMap = /* @__PURE__ */ new Map([
    [
        9,
        $ee2fdfa8e1ecd950$var$r`\t`
    ],
    // horizontal tab
    [
        10,
        $ee2fdfa8e1ecd950$var$r`\n`
    ],
    // line feed
    [
        11,
        $ee2fdfa8e1ecd950$var$r`\v`
    ],
    // vertical tab
    [
        12,
        $ee2fdfa8e1ecd950$var$r`\f`
    ],
    // form feed
    [
        13,
        $ee2fdfa8e1ecd950$var$r`\r`
    ],
    // carriage return
    [
        8232,
        $ee2fdfa8e1ecd950$var$r`\u2028`
    ],
    // line separator
    [
        8233,
        $ee2fdfa8e1ecd950$var$r`\u2029`
    ],
    // paragraph separator
    [
        65279,
        $ee2fdfa8e1ecd950$var$r`\uFEFF`
    ]
]);
var $ee2fdfa8e1ecd950$var$casedRe = /^\p{Cased}$/u;
function $ee2fdfa8e1ecd950$var$charHasCase(char) {
    return $ee2fdfa8e1ecd950$var$casedRe.test(char);
}
function $ee2fdfa8e1ecd950$var$getCasesOutsideCharClassRange(node, options) {
    const firstOnly = !!options?.firstOnly;
    const min = node.min.value;
    const max = node.max.value;
    const found = [];
    if (min < 65 && (max === 65535 || max >= 131071) || min === 65536 && max >= 131071) return found;
    for(let i = min; i <= max; i++){
        const char = $ee2fdfa8e1ecd950$var$cp(i);
        if (!$ee2fdfa8e1ecd950$var$charHasCase(char)) continue;
        const charsOutsideRange = $ee2fdfa8e1ecd950$var$getIgnoreCaseMatchChars(char).filter((caseOfChar)=>{
            const num = caseOfChar.codePointAt(0);
            return num < min || num > max;
        });
        if (charsOutsideRange.length) {
            found.push(...charsOutsideRange);
            if (firstOnly) break;
        }
    }
    return found;
}
function $ee2fdfa8e1ecd950$var$getCharEscape(codePoint, { escDigit: escDigit, inCharClass: inCharClass, useFlagV: useFlagV }) {
    if ($ee2fdfa8e1ecd950$var$CharCodeEscapeMap.has(codePoint)) return $ee2fdfa8e1ecd950$var$CharCodeEscapeMap.get(codePoint);
    if (// Control chars, etc.; condition modeled on the Chrome developer console's display for strings
    codePoint < 32 || codePoint > 126 && codePoint < 160 || // Unicode planes 4-16; unassigned, special purpose, and private use area
    codePoint > 262143 || // Avoid corrupting a preceding backref by immediately following it with a literal digit
    escDigit && $ee2fdfa8e1ecd950$var$isDigitCharCode(codePoint)) return codePoint > 255 ? `\\u{${codePoint.toString(16).toUpperCase()}}` : `\\x${codePoint.toString(16).toUpperCase().padStart(2, "0")}`;
    const escapeChars = inCharClass ? useFlagV ? $ee2fdfa8e1ecd950$var$CharClassEscapeCharsFlagV : $ee2fdfa8e1ecd950$var$CharClassEscapeChars : $ee2fdfa8e1ecd950$var$BaseEscapeChars;
    const char = $ee2fdfa8e1ecd950$var$cp(codePoint);
    return (escapeChars.has(char) ? "\\" : "") + char;
}
function $ee2fdfa8e1ecd950$var$getCodePointRangesFromChars(chars) {
    const codePoints = chars.map((char)=>char.codePointAt(0)).sort((a, b)=>a - b);
    const values = [];
    let start = null;
    for(let i = 0; i < codePoints.length; i++){
        if (codePoints[i + 1] === codePoints[i] + 1) start ??= codePoints[i];
        else if (start === null) values.push(codePoints[i]);
        else {
            values.push([
                start,
                codePoints[i]
            ]);
            start = null;
        }
    }
    return values;
}
function $ee2fdfa8e1ecd950$var$getGroupPrefix(atomic2, flagMods, useFlagMods) {
    if (atomic2) return ">";
    let mods = "";
    if (flagMods && useFlagMods) {
        const { enable: enable, disable: disable } = flagMods;
        mods = (enable?.ignoreCase ? "i" : "") + (enable?.dotAll ? "s" : "") + (disable ? "-" : "") + (disable?.ignoreCase ? "i" : "") + (disable?.dotAll ? "s" : "");
    }
    return `${mods}:`;
}
function $ee2fdfa8e1ecd950$var$getQuantifierStr({ kind: kind, max: max, min: min }) {
    let base;
    if (!min && max === 1) base = "?";
    else if (!min && max === Infinity) base = "*";
    else if (min === 1 && max === Infinity) base = "+";
    else if (min === max) base = `{${min}}`;
    else base = `{${min},${max === Infinity ? "" : max}}`;
    return base + ({
        greedy: "",
        lazy: "?",
        possessive: "+"
    })[kind];
}
function $ee2fdfa8e1ecd950$var$isAnyGroup({ type: type }) {
    return type === "CapturingGroup" || type === "Group" || type === "LookaroundAssertion";
}
function $ee2fdfa8e1ecd950$var$isDigitCharCode(value) {
    return value > 47 && value < 58;
}
function $ee2fdfa8e1ecd950$var$isLiteralHyphen({ type: type, value: value }) {
    return type === "Character" && value === 45;
}
// src/subclass.js
var $ee2fdfa8e1ecd950$export$121cb31e8b3a6ab5 = class _EmulatedRegExp extends RegExp {
    /**
  @type {Map<number, {
    hidden?: true;
    transferTo?: number;
  }>}
  */ #captureMap = /* @__PURE__ */ new Map();
    /**
  @type {RegExp | EmulatedRegExp | null}
  */ #compiled = null;
    /**
  @type {string}
  */ #pattern;
    /**
  @type {Map<number, string>?}
  */ #nameMap = null;
    /**
  @type {string?}
  */ #strategy = null;
    /**
  Can be used to serialize the instance.
  @type {EmulatedRegExpOptions}
  */ rawOptions = {};
    // Override the getter with one that works with lazy-compiled regexes
    get source() {
        return this.#pattern || "(?:)";
    }
    /**
  @overload
  @param {string} pattern
  @param {string} [flags]
  @param {EmulatedRegExpOptions} [options]
  */ /**
  @overload
  @param {EmulatedRegExp} pattern
  @param {string} [flags]
  */ constructor(pattern, flags, options){
        const lazyCompile = !!options?.lazyCompile;
        if (pattern instanceof RegExp) {
            if (options) throw new Error("Cannot provide options when copying a regexp");
            const re = pattern;
            super(re, flags);
            this.#pattern = re.source;
            if (re instanceof _EmulatedRegExp) {
                this.#captureMap = re.#captureMap;
                this.#nameMap = re.#nameMap;
                this.#strategy = re.#strategy;
                this.rawOptions = re.rawOptions;
            }
        } else {
            const opts = {
                hiddenCaptures: [],
                strategy: null,
                transfers: [],
                ...options
            };
            super(lazyCompile ? "" : pattern, flags);
            this.#pattern = pattern;
            this.#captureMap = $ee2fdfa8e1ecd950$var$createCaptureMap(opts.hiddenCaptures, opts.transfers);
            this.#strategy = opts.strategy;
            this.rawOptions = options ?? {};
        }
        if (!lazyCompile) this.#compiled = this;
    }
    /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray?}
  */ exec(str) {
        if (!this.#compiled) {
            const { lazyCompile: lazyCompile, ...rest } = this.rawOptions;
            this.#compiled = new _EmulatedRegExp(this.#pattern, this.flags, rest);
        }
        const useLastIndex = this.global || this.sticky;
        const pos = this.lastIndex;
        if (this.#strategy === "clip_search" && useLastIndex && pos) {
            this.lastIndex = 0;
            const match = this.#execCore(str.slice(pos));
            if (match) {
                $ee2fdfa8e1ecd950$var$adjustMatchDetailsForOffset(match, pos, str, this.hasIndices);
                this.lastIndex += pos;
            }
            return match;
        }
        return this.#execCore(str);
    }
    /**
  Adds support for hidden and transfer captures.
  @param {string} str
  @returns
  */ #execCore(str) {
        this.#compiled.lastIndex = this.lastIndex;
        const match = super.exec.call(this.#compiled, str);
        this.lastIndex = this.#compiled.lastIndex;
        if (!match || !this.#captureMap.size) return match;
        const matchCopy = [
            ...match
        ];
        match.length = 1;
        let indicesCopy;
        if (this.hasIndices) {
            indicesCopy = [
                ...match.indices
            ];
            match.indices.length = 1;
        }
        const mappedNums = [
            0
        ];
        for(let i = 1; i < matchCopy.length; i++){
            const { hidden: hidden, transferTo: transferTo } = this.#captureMap.get(i) ?? {};
            if (hidden) mappedNums.push(null);
            else {
                mappedNums.push(match.length);
                match.push(matchCopy[i]);
                if (this.hasIndices) match.indices.push(indicesCopy[i]);
            }
            if (transferTo && matchCopy[i] !== void 0) {
                const to = mappedNums[transferTo];
                if (!to) throw new Error(`Invalid capture transfer to "${to}"`);
                match[to] = matchCopy[i];
                if (this.hasIndices) match.indices[to] = indicesCopy[i];
                if (match.groups) {
                    if (!this.#nameMap) this.#nameMap = $ee2fdfa8e1ecd950$var$createNameMap(this.source);
                    const name = this.#nameMap.get(transferTo);
                    if (name) {
                        match.groups[name] = matchCopy[i];
                        if (this.hasIndices) match.indices.groups[name] = indicesCopy[i];
                    }
                }
            }
        }
        return match;
    }
};
function $ee2fdfa8e1ecd950$var$adjustMatchDetailsForOffset(match, offset, input, hasIndices) {
    match.index += offset;
    match.input = input;
    if (hasIndices) {
        const indices = match.indices;
        for(let i = 0; i < indices.length; i++){
            const arr = indices[i];
            if (arr) indices[i] = [
                arr[0] + offset,
                arr[1] + offset
            ];
        }
        const groupIndices = indices.groups;
        if (groupIndices) Object.keys(groupIndices).forEach((key)=>{
            const arr = groupIndices[key];
            if (arr) groupIndices[key] = [
                arr[0] + offset,
                arr[1] + offset
            ];
        });
    }
}
function $ee2fdfa8e1ecd950$var$createCaptureMap(hiddenCaptures, transfers) {
    const captureMap = /* @__PURE__ */ new Map();
    for (const num of hiddenCaptures)captureMap.set(num, {
        hidden: true
    });
    for (const [to, from] of transfers)for (const num of from)$ee2fdfa8e1ecd950$var$getOrInsert(captureMap, num, {}).transferTo = to;
    return captureMap;
}
function $ee2fdfa8e1ecd950$var$createNameMap(pattern) {
    const re = /(?<capture>\((?:\?<(?![=!])(?<name>[^>]+)>|(?!\?)))|\\?./gsu;
    const map = /* @__PURE__ */ new Map();
    let numCharClassesOpen = 0;
    let numCaptures = 0;
    let match;
    while(match = re.exec(pattern)){
        const { 0: m, groups: { capture: capture, name: name } } = match;
        if (m === "[") numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            if (capture) {
                numCaptures++;
                if (name) map.set(numCaptures, name);
            }
        } else if (m === "]") numCharClassesOpen--;
    }
    return map;
}
function $ee2fdfa8e1ecd950$export$238374f1b270e387(pattern, options) {
    const d = $ee2fdfa8e1ecd950$export$7a4833dc970906e0(pattern, options);
    if (d.options) return new $ee2fdfa8e1ecd950$export$121cb31e8b3a6ab5(d.pattern, d.flags, d.options);
    return new RegExp(d.pattern, d.flags);
}
function $ee2fdfa8e1ecd950$export$7a4833dc970906e0(pattern, options) {
    const opts = $ee2fdfa8e1ecd950$var$getOptions(options);
    const onigurumaAst = (0, $4e3b66797d9e7d60$export$98e6a39c04603d36)(pattern, {
        flags: opts.flags,
        normalizeUnknownPropertyNames: true,
        rules: {
            captureGroup: opts.rules.captureGroup,
            singleline: opts.rules.singleline
        },
        skipBackrefValidation: opts.rules.allowOrphanBackrefs,
        unicodePropertyMap: $ee2fdfa8e1ecd950$var$JsUnicodePropertyMap
    });
    const regexPlusAst = $ee2fdfa8e1ecd950$var$transform(onigurumaAst, {
        accuracy: opts.accuracy,
        asciiWordBoundaries: opts.rules.asciiWordBoundaries,
        avoidSubclass: opts.avoidSubclass,
        bestEffortTarget: opts.target
    });
    const generated = $ee2fdfa8e1ecd950$var$generate(regexPlusAst, opts);
    const recursionResult = (0, $7b47be2fc3e8818c$export$74c5cab0f9a94551)(generated.pattern, {
        captureTransfers: generated._captureTransfers,
        hiddenCaptures: generated._hiddenCaptures,
        mode: "external"
    });
    const possessiveResult = (0, $1bdab06fb3077cb8$export$777a2fba7d8a1541)(recursionResult.pattern);
    const atomicResult = (0, $1bdab06fb3077cb8$export$a573bc8e40d39511)(possessiveResult.pattern, {
        captureTransfers: recursionResult.captureTransfers,
        hiddenCaptures: recursionResult.hiddenCaptures
    });
    const details = {
        pattern: atomicResult.pattern,
        flags: `${opts.hasIndices ? "d" : ""}${opts.global ? "g" : ""}${generated.flags}${generated.options.disable.v ? "u" : "v"}`
    };
    if (opts.avoidSubclass) {
        if (opts.lazyCompileLength !== Infinity) throw new Error("Lazy compilation requires subclass");
    } else {
        const hiddenCaptures = atomicResult.hiddenCaptures.sort((a, b)=>a - b);
        const transfers = Array.from(atomicResult.captureTransfers);
        const strategy = regexPlusAst._strategy;
        const lazyCompile = details.pattern.length >= opts.lazyCompileLength;
        if (hiddenCaptures.length || transfers.length || strategy || lazyCompile) details.options = {
            ...hiddenCaptures.length && {
                hiddenCaptures: hiddenCaptures
            },
            ...transfers.length && {
                transfers: transfers
            },
            ...strategy && {
                strategy: strategy
            },
            ...lazyCompile && {
                lazyCompile: lazyCompile
            }
        };
    }
    return details;
}


const $28b8b92250641a81$var$MAX = 4294967295;
class $28b8b92250641a81$export$b4171a6734a65d42 {
    constructor(patterns, options = {}){
        this.patterns = patterns;
        this.options = options;
        const { forgiving: forgiving = false, cache: cache, regexConstructor: regexConstructor } = options;
        if (!regexConstructor) throw new Error("Option `regexConstructor` is not provided");
        this.regexps = patterns.map((p)=>{
            if (typeof p !== "string") return p;
            const cached = cache?.get(p);
            if (cached) {
                if (cached instanceof RegExp) return cached;
                if (forgiving) return null;
                throw cached;
            }
            try {
                const regex = regexConstructor(p);
                cache?.set(p, regex);
                return regex;
            } catch (e) {
                cache?.set(p, e);
                if (forgiving) return null;
                throw e;
            }
        });
    }
    regexps;
    findNextMatchSync(string, startPosition, _options) {
        const str = typeof string === "string" ? string : string.content;
        const pending = [];
        function toResult(index, match, offset = 0) {
            return {
                index: index,
                captureIndices: match.indices.map((indice)=>{
                    if (indice == null) return {
                        start: $28b8b92250641a81$var$MAX,
                        end: $28b8b92250641a81$var$MAX,
                        length: 0
                    };
                    return {
                        start: indice[0] + offset,
                        end: indice[1] + offset,
                        length: indice[1] - indice[0]
                    };
                })
            };
        }
        for(let i = 0; i < this.regexps.length; i++){
            const regexp = this.regexps[i];
            if (!regexp) continue;
            try {
                regexp.lastIndex = startPosition;
                const match = regexp.exec(str);
                if (!match) continue;
                if (match.index === startPosition) return toResult(i, match, 0);
                pending.push([
                    i,
                    match,
                    0
                ]);
            } catch (e) {
                if (this.options.forgiving) continue;
                throw e;
            }
        }
        if (pending.length) {
            const minIndex = Math.min(...pending.map((m)=>m[1].index));
            for (const [i, match, offset] of pending){
                if (match.index === minIndex) return toResult(i, match, offset);
            }
        }
        return null;
    }
}


function $0b24e062d32bcfa9$export$70b386be05242d0f(pattern, options) {
    return (0, $ee2fdfa8e1ecd950$export$238374f1b270e387)(pattern, {
        global: true,
        hasIndices: true,
        // This has no benefit for the standard JS engine, but it avoids a perf penalty for
        // precompiled grammars when constructing extremely long patterns that aren't always used
        lazyCompileLength: 3e3,
        rules: {
            // Needed since TextMate grammars merge backrefs across patterns
            allowOrphanBackrefs: true,
            // Improves search performance for generated regexes
            asciiWordBoundaries: true,
            // Follow `vscode-oniguruma` which enables this Oniguruma option by default
            captureGroup: true,
            // Oniguruma uses depth limit `20`; lowered here to keep regexes shorter and maybe
            // sometimes faster, but can be increased if issues reported due to low limit
            recursionLimit: 5,
            // Oniguruma option for `^`->`\A`, `$`->`\Z`; improves search performance without any
            // change in meaning since TM grammars search line by line
            singleline: true
        },
        ...options
    });
}
function $0b24e062d32bcfa9$export$d1f38b498ee0de14(options = {}) {
    const _options = Object.assign({
        target: "auto",
        cache: /* @__PURE__ */ new Map()
    }, options);
    _options.regexConstructor ||= (pattern)=>$0b24e062d32bcfa9$export$70b386be05242d0f(pattern, {
            target: _options.target
        });
    return {
        createScanner (patterns) {
            return new (0, $28b8b92250641a81$export$b4171a6734a65d42)(patterns, _options);
        },
        createString (s) {
            return {
                content: s
            };
        }
    };
}


//#region src/highlighter/shared_highlighter.ts
let $5038ef2223d0d43d$var$highlighter;

async function $5038ef2223d0d43d$export$3ae4f582c943284e({ themes: themes, langs: langs, preferredHighlighter: preferredHighlighter = "shiki-js" }) {
    $5038ef2223d0d43d$var$highlighter ??= (0, $57ed8b60370ea5fd$export$615c15ca8b0fd571)({
        themes: [],
        langs: [
            "text"
        ],
        engine: preferredHighlighter === "shiki-wasm" ? (0, $7c049fd770a07e8d$export$aecbd6e886bd9a16)((parcelRequire("amcJb"))) : (0, $0b24e062d32bcfa9$export$d1f38b498ee0de14)()
    });
    const instance = $5038ef2223d0d43d$export$25c8668e859c634a($5038ef2223d0d43d$var$highlighter) ? await $5038ef2223d0d43d$var$highlighter : $5038ef2223d0d43d$var$highlighter;
    $5038ef2223d0d43d$var$highlighter = instance;
    const languageLoaders = [];
    for (const language of langs){
        if (language === "text" || language === "ansi") continue;
        const maybeResolvedLanguage = (0, $043fc06f42768105$export$4d019cfecfbb353a)(language);
        if ("then" in maybeResolvedLanguage) languageLoaders.push(maybeResolvedLanguage);
        else (0, $63d7daf2cbedb23d$export$648bcf6cfa65db4)(maybeResolvedLanguage, instance);
    }
    const themeLoaders = [];
    for (const themeName of themes){
        const maybeResolvedTheme = (0, $13ad887817b0c006$export$406f844df6312956)(themeName);
        if ("then" in maybeResolvedTheme) themeLoaders.push(maybeResolvedTheme);
        else (0, $b5e7a3dd7253d51b$export$3bf43cacd1a90d16)(maybeResolvedTheme, $5038ef2223d0d43d$var$highlighter);
    }
    if (languageLoaders.length > 0 || themeLoaders.length > 0) await Promise.all([
        Promise.all(languageLoaders).then((languages)=>{
            (0, $63d7daf2cbedb23d$export$648bcf6cfa65db4)(languages, instance);
        }),
        Promise.all(themeLoaders).then((themes$1)=>{
            (0, $b5e7a3dd7253d51b$export$3bf43cacd1a90d16)(themes$1, instance);
        })
    ]);
    return instance;
}
function $5038ef2223d0d43d$export$2ca9faaf1f2f0cb2(h = $5038ef2223d0d43d$var$highlighter) {
    return h != null && !("then" in h);
}
function $5038ef2223d0d43d$export$b046b6d0abcdff6a() {
    if ($5038ef2223d0d43d$var$highlighter != null && !("then" in $5038ef2223d0d43d$var$highlighter)) return $5038ef2223d0d43d$var$highlighter;
}
function $5038ef2223d0d43d$export$25c8668e859c634a(h = $5038ef2223d0d43d$var$highlighter) {
    return h != null && "then" in h;
}
function $5038ef2223d0d43d$export$480f8306c5d72a40(h = $5038ef2223d0d43d$var$highlighter) {
    return h == null;
}
async function $5038ef2223d0d43d$export$99c89a496c88537b(options) {
    await $5038ef2223d0d43d$export$3ae4f582c943284e(options);
}
async function $5038ef2223d0d43d$export$de0e8b67bf6f4804() {
    if ($5038ef2223d0d43d$var$highlighter == null) return;
    (await $5038ef2223d0d43d$var$highlighter).dispose();
    (0, $03592043e37c3a6a$export$15930efdd75fda59)();
    (0, $204038051b556f81$export$f3c0a6a5f1fe8e78)();
    $5038ef2223d0d43d$var$highlighter = void 0;
}

(0, $b897030c4040ecda$export$7fb6c5a4253e769a)("pierre-dark", async ()=>{
    const { default: theme } = await (parcelRequire("3mqtg"));
    return {
        ...theme,
        name: "pierre-dark"
    };
});

(0, $b897030c4040ecda$export$7fb6c5a4253e769a)("pierre-dark-soft", async ()=>{
    const { default: theme } = await (parcelRequire("9VI5I"));
    return {
        ...theme,
        name: "pierre-dark-soft"
    };
});

(0, $b897030c4040ecda$export$7fb6c5a4253e769a)("pierre-light", async ()=>{
    const { default: theme } = await (parcelRequire("jNeD4"));
    return {
        ...theme,
        name: "pierre-light"
    };
});

(0, $b897030c4040ecda$export$7fb6c5a4253e769a)("pierre-light-soft", async ()=>{
    const { default: theme } = await (parcelRequire("Lg2z3"));
    return {
        ...theme,
        name: "pierre-light-soft"
    };
});



//#region src/utils/getThemes.ts
function $1aa1190ca9b15e96$export$a11593be0c51d6a7(theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59)) {
    const themesArr = [];
    if (typeof theme === "string") themesArr.push(theme);
    else {
        themesArr.push(theme.dark);
        themesArr.push(theme.light);
    }
    return themesArr;
}




//#region src/highlighter/themes/areThemesAttached.ts
function $e1de8f8a9ed7d4cd$export$5ce36088543a0a6f(themes) {
    for (const theme of (0, $1aa1190ca9b15e96$export$a11593be0c51d6a7)(themes))if (!(0, $e663a760095f022f$export$3d8dda72fbfe74c9).has(theme)) return false;
    return true;
}



//#region src/highlighter/themes/hasResolvedThemes.ts
function $bf2dbe218dfe08c0$export$94034355ed3693a6(themeNames) {
    for (const themeName of themeNames)if (!(0, $e663a760095f022f$export$517305f1f1af691).has(themeName)) return false;
    return true;
}



//#region src/utils/areFileRenderOptionsEqual.ts
function $9739dc975c8bf830$export$9edcb29d52fcb8e5(optionsA, optionsB) {
    return (0, $0246eee5e18b0420$export$e40448283aec01f1)(optionsA.theme, optionsB.theme) && optionsA.useTokenTransformer === optionsB.useTokenTransformer && optionsA.tokenizeMaxLineLength === optionsB.tokenizeMaxLineLength;
}





//#region src/utils/createAnnotationElement.ts
function $03fd4bd96344ff46$export$a11205b4d57749fb(span) {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: [
            (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                tagName: "div",
                children: span.annotations?.map((slotId)=>(0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                        tagName: "slot",
                        properties: {
                            name: slotId
                        }
                    })),
                properties: {
                    "data-annotation-content": ""
                }
            })
        ],
        properties: {
            "data-line-annotation": `${span.hunkIndex},${span.lineIndex}`
        }
    });
}



//#region src/utils/createContentColumn.ts
function $a72acb3cb61e0911$export$ae45562cd268c97b(children, rowCount) {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: children,
        properties: {
            "data-content": "",
            style: `grid-row: span ${rowCount}`
        }
    });
}




//#region src/utils/getIconForType.ts
function $7dcb249c32b7d83f$export$f3ed558d05877d5d(type) {
    switch(type){
        case "file":
            return "diffs-icon-file-code";
        case "change":
            return "diffs-icon-symbol-modified";
        case "new":
            return "diffs-icon-symbol-added";
        case "deleted":
            return "diffs-icon-symbol-deleted";
        case "rename-pure":
        case "rename-changed":
            return "diffs-icon-symbol-moved";
    }
}


//#region src/utils/createFileHeaderElement.ts
function $70ef609d54bc0682$export$de00955f585ed124({ fileOrDiff: fileOrDiff, mode: mode, stickyHeader: stickyHeader }) {
    const fileDiff = "type" in fileOrDiff ? fileOrDiff : void 0;
    const properties = {
        "data-diffs-header": mode,
        "data-change-type": fileDiff?.type,
        "data-sticky": stickyHeader ? "" : void 0
    };
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: [
            mode === "custom" ? (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                tagName: "slot",
                properties: {
                    name: (0, $6986aac91971cc6d$export$87f913619cd5fa67)
                }
            }) : $70ef609d54bc0682$var$createHeaderElement({
                name: fileOrDiff.name,
                prevName: "prevName" in fileOrDiff ? fileOrDiff.prevName : void 0,
                iconType: fileDiff?.type ?? "file"
            }),
            ...mode === "custom" ? [] : [
                $70ef609d54bc0682$var$createMetadataElement(fileDiff)
            ]
        ],
        properties: properties
    });
}
function $70ef609d54bc0682$var$createHeaderElement({ name: name, prevName: prevName, iconType: iconType }) {
    const children = [
        (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "slot",
            properties: {
                name: (0, $6986aac91971cc6d$export$69d2d3bd52efd12a)
            }
        }),
        (0, $f6f1fb01992c2ec8$export$2f9411727149fee9)({
            name: (0, $7dcb249c32b7d83f$export$f3ed558d05877d5d)(iconType),
            properties: {
                "data-change-icon": iconType
            }
        })
    ];
    if (prevName != null) {
        children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "div",
            children: [
                (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                    tagName: "bdi",
                    children: [
                        (0, $f6f1fb01992c2ec8$export$696d4285af91566e)(prevName)
                    ]
                })
            ],
            properties: {
                "data-prev-name": ""
            }
        }));
        children.push((0, $f6f1fb01992c2ec8$export$2f9411727149fee9)({
            name: "diffs-icon-arrow-right-short",
            properties: {
                "data-rename-icon": ""
            }
        }));
    }
    children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: [
            (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                tagName: "bdi",
                children: [
                    (0, $f6f1fb01992c2ec8$export$696d4285af91566e)(name)
                ]
            })
        ],
        properties: {
            "data-title": ""
        }
    }));
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: children,
        properties: {
            "data-header-content": ""
        }
    });
}
function $70ef609d54bc0682$var$createMetadataElement(fileDiff) {
    const children = [];
    if (fileDiff != null) {
        let additions = 0;
        let deletions = 0;
        for (const hunk of fileDiff.hunks){
            additions += hunk.additionLines;
            deletions += hunk.deletionLines;
        }
        if (deletions > 0 || additions === 0) children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "span",
            children: [
                (0, $f6f1fb01992c2ec8$export$696d4285af91566e)(`-${deletions}`)
            ],
            properties: {
                "data-deletions-count": ""
            }
        }));
        if (additions > 0 || deletions === 0) children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "span",
            children: [
                (0, $f6f1fb01992c2ec8$export$696d4285af91566e)(`+${additions}`)
            ],
            properties: {
                "data-additions-count": ""
            }
        }));
    }
    children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "slot",
        properties: {
            name: (0, $6986aac91971cc6d$export$f5d94b4150f59afc)
        }
    }));
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: children,
        properties: {
            "data-metadata": ""
        }
    });
}



//#region src/utils/createPreElement.ts
function $d98c49a6cb7f2b6e$export$bbf52dba466bc3d2(options) {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "pre",
        properties: $d98c49a6cb7f2b6e$export$16f12c4406dc691(options)
    });
}
function $d98c49a6cb7f2b6e$export$16f12c4406dc691({ diffIndicators: diffIndicators, disableBackground: disableBackground, disableLineNumbers: disableLineNumbers, overflow: overflow, split: split, totalLines: totalLines, type: type, customProperties: customProperties }) {
    return {
        ...customProperties,
        "data-diff": type === "diff" ? "" : void 0,
        "data-file": type === "file" ? "" : void 0,
        "data-diff-type": type === "diff" ? split ? "split" : "single" : void 0,
        "data-overflow": overflow,
        "data-disable-line-numbers": disableLineNumbers ? "" : void 0,
        "data-background": !disableBackground ? "" : void 0,
        "data-indicators": diffIndicators === "bars" || diffIndicators === "classic" ? diffIndicators : void 0,
        tabIndex: 0,
        style: `--diffs-min-number-column-width-default:${`${totalLines}`.length}ch;`
    };
}




//#region src/utils/getHighlighterOptions.ts
function $3dc03ceed6671d25$export$d8fa3650d67306ca(lang, { theme: theme, preferredHighlighter: preferredHighlighter = "shiki-js" }) {
    return {
        langs: [
            lang ?? "text"
        ],
        themes: (0, $1aa1190ca9b15e96$export$a11593be0c51d6a7)(theme),
        preferredHighlighter: preferredHighlighter
    };
}





//#region src/utils/splitFileContents.ts
/**
* Splits file contents into lines using the same logic as diff parsing.
* - Preserves trailing newlines on each line
*
* @param contents - The raw file contents string
* @returns Array of lines with newlines preserved
*/ function $d26b46ce8ae8b6da$export$745e60fc52f3cfed(contents) {
    return contents !== "" ? contents.split((0, $6986aac91971cc6d$export$e38f52bd77a3998f)) : [];
}





//#region src/utils/cleanLastNewline.ts
function $edf66b00d8168e8a$export$b6130a543868c75e(contents) {
    return contents.replace(/\n$|\r\n$/, "");
}




//#region src/utils/processLine.ts
function $78371dee7efe83b3$export$7f0a012bc07d0fce(node, line, state) {
    const lineInfo = typeof state.lineInfo === "function" ? state.lineInfo(line) : state.lineInfo[line - 1];
    if (lineInfo == null) {
        const errorMessage = `processLine: line ${line}, contains no state.lineInfo`;
        console.error(errorMessage, {
            node: node,
            line: line,
            state: state
        });
        throw new Error(errorMessage);
    }
    node.tagName = "div";
    node.properties["data-line"] = lineInfo.lineNumber;
    node.properties["data-alt-line"] = lineInfo.altLineNumber;
    node.properties["data-line-type"] = lineInfo.type;
    node.properties["data-line-index"] = lineInfo.lineIndex;
    if (node.children.length === 0) node.children.push((0, $f6f1fb01992c2ec8$export$696d4285af91566e)("\n"));
    return node;
}



//#region src/utils/wrapTokenFragments.ts
const $d44689f51ce99760$var$NO_TOKEN = Symbol("no-token");
const $d44689f51ce99760$var$MULTIPLE_TOKENS = Symbol("multiple-tokens");
function $d44689f51ce99760$export$92ac62c33ed5937c(container) {
    const ownTokenChar = $d44689f51ce99760$var$getTokenChar(container);
    if (ownTokenChar != null) return ownTokenChar;
    let containerTokenState = $d44689f51ce99760$var$NO_TOKEN;
    const wrappedChildren = [];
    let currentTokenChildren = [];
    let currentTokenChar;
    const flushTokenChildren = ()=>{
        if (currentTokenChildren.length === 0 || currentTokenChar == null) {
            currentTokenChildren = [];
            currentTokenChar = void 0;
            return;
        }
        if (currentTokenChildren.length === 1) {
            const child = currentTokenChildren[0];
            if (child?.type === "element") {
                $d44689f51ce99760$var$setTokenChar(child, currentTokenChar);
                for (const grandChild of child.children)$d44689f51ce99760$var$stripTokenChar(grandChild);
            } else $d44689f51ce99760$var$stripTokenChar(child);
            wrappedChildren.push(child);
            currentTokenChildren = [];
            currentTokenChar = void 0;
            return;
        }
        for (const child of currentTokenChildren)$d44689f51ce99760$var$stripTokenChar(child);
        wrappedChildren.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "span",
            properties: {
                "data-char": currentTokenChar
            },
            children: currentTokenChildren
        }));
        currentTokenChildren = [];
        currentTokenChar = void 0;
    };
    const mergeContainerTokenState = (childTokenState)=>{
        if (childTokenState === $d44689f51ce99760$var$NO_TOKEN) return;
        if (childTokenState === $d44689f51ce99760$var$MULTIPLE_TOKENS) {
            containerTokenState = $d44689f51ce99760$var$MULTIPLE_TOKENS;
            return;
        }
        if (containerTokenState === $d44689f51ce99760$var$NO_TOKEN) {
            containerTokenState = childTokenState;
            return;
        }
        if (containerTokenState !== childTokenState) containerTokenState = $d44689f51ce99760$var$MULTIPLE_TOKENS;
    };
    for (const child of container.children){
        const childTokenState = child.type === "element" ? $d44689f51ce99760$export$92ac62c33ed5937c(child) : $d44689f51ce99760$var$NO_TOKEN;
        mergeContainerTokenState(childTokenState);
        if (typeof childTokenState !== "number") {
            flushTokenChildren();
            wrappedChildren.push(child);
            continue;
        }
        if (currentTokenChar != null && currentTokenChar !== childTokenState) flushTokenChildren();
        currentTokenChar ??= childTokenState;
        currentTokenChildren.push(child);
    }
    flushTokenChildren();
    container.children = wrappedChildren;
    return containerTokenState;
}
function $d44689f51ce99760$var$getTokenChar(node) {
    const value = node.properties["data-char"];
    if (typeof value === "number") return value;
}
function $d44689f51ce99760$var$stripTokenChar(node) {
    if (node.type !== "element") return;
    node.properties["data-char"] = void 0;
    for (const child of node.children)$d44689f51ce99760$var$stripTokenChar(child);
}
function $d44689f51ce99760$var$setTokenChar(node, char) {
    node.properties["data-char"] = char;
}


const $6f85c47ad52e92f6$var$matchers = [
    [
        /^(<!--)(.+)(-->)$/,
        false
    ],
    [
        /^(\/\*)(.+)(\*\/)$/,
        false
    ],
    [
        /^(\/\/|["'#]|;{1,2}|%{1,2}|--)(.*)$/,
        true
    ],
    /**
   * for multi-line comments like this
   */ [
        /^(\*)(.+)$/,
        true
    ]
];
function $6f85c47ad52e92f6$var$parseComments(lines, jsx, matchAlgorithm) {
    const out = [];
    for (const line of lines){
        if (matchAlgorithm === "v3") {
            const splittedElements = line.children.flatMap((element, idx)=>{
                if (element.type !== "element") return element;
                const token = element.children[0];
                if (token.type !== "text") return element;
                const isLast = idx === line.children.length - 1;
                const isComment = $6f85c47ad52e92f6$var$matchToken(token.value, isLast);
                if (!isComment) return element;
                const rawSplits = token.value.split(/(\s+\/\/)/);
                if (rawSplits.length <= 1) return element;
                let splits = [
                    rawSplits[0]
                ];
                for(let i = 1; i < rawSplits.length; i += 2)splits.push(rawSplits[i] + (rawSplits[i + 1] || ""));
                splits = splits.filter(Boolean);
                if (splits.length <= 1) return element;
                return splits.map((split)=>{
                    return {
                        ...element,
                        children: [
                            {
                                type: "text",
                                value: split
                            }
                        ]
                    };
                });
            });
            if (splittedElements.length !== line.children.length) line.children = splittedElements;
        }
        const elements = line.children;
        let start = elements.length - 1;
        if (matchAlgorithm === "v1") start = 0;
        else if (jsx) start = elements.length - 2;
        for(let i = Math.max(start, 0); i < elements.length; i++){
            const token = elements[i];
            if (token.type !== "element") continue;
            const head = token.children.at(0);
            if (head?.type !== "text") continue;
            const isLast = i === elements.length - 1;
            let match = $6f85c47ad52e92f6$var$matchToken(head.value, isLast);
            let additionalTokens;
            if (!match && i > 0 && head.value.trim().startsWith("[!code")) {
                const prevToken = elements[i - 1];
                if (prevToken?.type === "element") {
                    const prevHead = prevToken.children.at(0);
                    if (prevHead?.type === "text" && prevHead.value.includes("//")) {
                        const combinedValue = prevHead.value + head.value;
                        const combinedMatch = $6f85c47ad52e92f6$var$matchToken(combinedValue, isLast);
                        if (combinedMatch) {
                            match = combinedMatch;
                            out.push({
                                info: combinedMatch,
                                line: line,
                                token: prevToken,
                                // Use the previous token as the main token
                                isLineCommentOnly: elements.length === 2 && prevToken.children.length === 1 && token.children.length === 1,
                                isJsxStyle: false,
                                additionalTokens: [
                                    token
                                ]
                            });
                            continue;
                        }
                    }
                }
            }
            if (!match) continue;
            if (jsx && !isLast && i !== 0) {
                const isJsxStyle = $6f85c47ad52e92f6$var$isValue(elements[i - 1], "{") && $6f85c47ad52e92f6$var$isValue(elements[i + 1], "}");
                out.push({
                    info: match,
                    line: line,
                    token: token,
                    isLineCommentOnly: elements.length === 3 && token.children.length === 1,
                    isJsxStyle: isJsxStyle,
                    additionalTokens: additionalTokens
                });
            } else out.push({
                info: match,
                line: line,
                token: token,
                isLineCommentOnly: elements.length === 1 && token.children.length === 1,
                isJsxStyle: false,
                additionalTokens: additionalTokens
            });
        }
    }
    return out;
}
function $6f85c47ad52e92f6$var$isValue(element, value) {
    if (element.type !== "element") return false;
    const text = element.children[0];
    if (text.type !== "text") return false;
    return text.value.trim() === value;
}
function $6f85c47ad52e92f6$var$matchToken(text, isLast) {
    let trimmed = text.trimStart();
    const spaceFront = text.length - trimmed.length;
    trimmed = trimmed.trimEnd();
    const spaceEnd = text.length - trimmed.length - spaceFront;
    for (const [matcher, endOfLine] of $6f85c47ad52e92f6$var$matchers){
        if (endOfLine && !isLast) continue;
        const result = matcher.exec(trimmed);
        if (!result) continue;
        return [
            " ".repeat(spaceFront) + result[1],
            result[2],
            result[3] ? result[3] + " ".repeat(spaceEnd) : void 0
        ];
    }
}
function $6f85c47ad52e92f6$var$v1ClearEndCommentPrefix(text) {
    const match = text.match(/(?:\/\/|["'#]|;{1,2}|%{1,2}|--)(\s*)$/);
    if (match && match[1].trim().length === 0) return text.slice(0, match.index);
    return text;
}
function $6f85c47ad52e92f6$export$fb4a1aa7bba30401(name, regex, onMatch, matchAlgorithm) {
    if (matchAlgorithm == null) matchAlgorithm = "v3";
    return {
        name: name,
        code (code) {
            const lines = code.children.filter((i)=>i.type === "element");
            const linesToRemove = [];
            code.data ??= {};
            const data = code.data;
            data._shiki_notation ??= $6f85c47ad52e92f6$var$parseComments(lines, [
                "jsx",
                "tsx"
            ].includes(this.options.lang), matchAlgorithm);
            const parsed = data._shiki_notation;
            for (const comment of parsed){
                if (comment.info[1].length === 0) continue;
                let lineIdx = lines.indexOf(comment.line);
                if (comment.isLineCommentOnly && matchAlgorithm !== "v1") lineIdx++;
                let replaced = false;
                comment.info[1] = comment.info[1].replace(regex, (...match)=>{
                    if (onMatch.call(this, match, comment.line, comment.token, lines, lineIdx)) {
                        replaced = true;
                        return "";
                    }
                    return match[0];
                });
                if (!replaced) continue;
                if (matchAlgorithm === "v1") comment.info[1] = $6f85c47ad52e92f6$var$v1ClearEndCommentPrefix(comment.info[1]);
                const isEmpty = comment.info[1].trim().length === 0;
                if (isEmpty) comment.info[1] = "";
                if (isEmpty && comment.isLineCommentOnly) linesToRemove.push(comment.line);
                else if (isEmpty && comment.isJsxStyle) comment.line.children.splice(comment.line.children.indexOf(comment.token) - 1, 3);
                else if (isEmpty) {
                    if (comment.additionalTokens) for(let j = comment.additionalTokens.length - 1; j >= 0; j--){
                        const additionalToken = comment.additionalTokens[j];
                        const tokenIndex = comment.line.children.indexOf(additionalToken);
                        if (tokenIndex !== -1) comment.line.children.splice(tokenIndex, 1);
                    }
                    comment.line.children.splice(comment.line.children.indexOf(comment.token), 1);
                } else {
                    const head = comment.token.children[0];
                    if (head.type === "text") {
                        head.value = comment.info.join("");
                        if (comment.additionalTokens) for (const additionalToken of comment.additionalTokens){
                            const additionalHead = additionalToken.children[0];
                            if (additionalHead?.type === "text") additionalHead.value = "";
                        }
                    }
                }
            }
            for (const line of linesToRemove){
                const index = code.children.indexOf(line);
                const nextLine = code.children[index + 1];
                let removeLength = 1;
                if (nextLine?.type === "text" && nextLine?.value === "\n") removeLength = 2;
                code.children.splice(index, removeLength);
            }
        }
    };
}
function $6f85c47ad52e92f6$export$ef83bc69cce2f9f7(lineOptions = []) {
    return {
        name: "@shikijs/transformers:compact-line-options",
        line (node, line) {
            const lineOption = lineOptions.find((o)=>o.line === line);
            if (lineOption?.classes) this.addClassToHast(node, lineOption.classes);
            return node;
        }
    };
}
function $6f85c47ad52e92f6$export$9c41ef715fa0b753(meta) {
    if (!meta) return null;
    const match = meta.match(/\{([\d,-]+)\}/);
    if (!match) return null;
    const lines = match[1].split(",").flatMap((v)=>{
        const range = v.split("-").map((n)=>Number.parseInt(n, 10));
        return range.length === 1 ? [
            range[0]
        ] : Array.from({
            length: range[1] - range[0] + 1
        }, (_, i)=>range[0] + i);
    });
    return lines;
}
const $6f85c47ad52e92f6$var$symbol = /* @__PURE__ */ Symbol("highlighted-lines");
function $6f85c47ad52e92f6$export$89d4961c95fae3fc(options = {}) {
    const { className: className = "highlighted", zeroIndexed: zeroIndexed = false } = options;
    return {
        name: "@shikijs/transformers:meta-highlight",
        line (node, lineNumber) {
            if (!this.options.meta?.__raw) return;
            const meta = this.meta;
            meta[$6f85c47ad52e92f6$var$symbol] ??= $6f85c47ad52e92f6$export$9c41ef715fa0b753(this.options.meta.__raw);
            const highlightedLines = meta[$6f85c47ad52e92f6$var$symbol] ?? [];
            const effectiveLine = zeroIndexed ? lineNumber - 1 : lineNumber;
            if (highlightedLines.includes(effectiveLine)) this.addClassToHast(node, className);
            return node;
        }
    };
}
function $6f85c47ad52e92f6$export$86c88d76eaacf2ce(meta) {
    if (!meta) return [];
    const match = Array.from(meta.matchAll(/\/((?:\\.|[^/])+)\//g));
    return match.map((v)=>v[1].replace(/\\(.)/g, "$1"));
}
function $6f85c47ad52e92f6$export$e11b30d1c153fde5(options = {}) {
    const { className: className = "highlighted-word" } = options;
    return {
        name: "@shikijs/transformers:meta-word-highlight",
        preprocess (code, options2) {
            if (!this.options.meta?.__raw) return;
            const words = $6f85c47ad52e92f6$export$86c88d76eaacf2ce(this.options.meta.__raw);
            options2.decorations ||= [];
            for (const word of words){
                const indexes = $6f85c47ad52e92f6$export$db7cc1637140e3bd(code, word);
                for (const index of indexes)options2.decorations.push({
                    start: index,
                    end: index + word.length,
                    properties: {
                        class: className
                    }
                });
            }
        }
    };
}
function $6f85c47ad52e92f6$export$db7cc1637140e3bd(str, substr) {
    const indexes = [];
    let cursor = 0;
    while(true){
        const index = str.indexOf(substr, cursor);
        if (index === -1 || index >= str.length) break;
        if (index < cursor) break;
        indexes.push(index);
        cursor = index + substr.length;
    }
    return indexes;
}
function $6f85c47ad52e92f6$var$escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $6f85c47ad52e92f6$export$ff8cb51c08589bef(options = {}, name = "@shikijs/transformers:notation-map") {
    const { classMap: classMap = {}, classActivePre: classActivePre, classActiveCode: classActiveCode } = options;
    return $6f85c47ad52e92f6$export$fb4a1aa7bba30401(name, new RegExp(`#?\\s*\\[!code (${Object.keys(classMap).map($6f85c47ad52e92f6$var$escapeRegExp).join("|")})(:\\d+)?\\]`, "gi"), function([_, match, range = ":1"], _line, _comment, lines, index) {
        const lineNum = Number.parseInt(range.slice(1), 10);
        for(let i = index; i < Math.min(index + lineNum, lines.length); i++)this.addClassToHast(lines[i], classMap[match]);
        if (classActivePre) this.addClassToHast(this.pre, classActivePre);
        if (classActiveCode) this.addClassToHast(this.code, classActiveCode);
        return true;
    }, options.matchAlgorithm);
}
function $6f85c47ad52e92f6$export$a2d24baabb3467dd(options = {}) {
    const { classLineAdd: classLineAdd = "diff add", classLineRemove: classLineRemove = "diff remove", classActivePre: classActivePre = "has-diff", classActiveCode: classActiveCode } = options;
    return $6f85c47ad52e92f6$export$ff8cb51c08589bef({
        classMap: {
            "++": classLineAdd,
            "--": classLineRemove
        },
        classActivePre: classActivePre,
        classActiveCode: classActiveCode,
        matchAlgorithm: options.matchAlgorithm
    }, "@shikijs/transformers:notation-diff");
}
function $6f85c47ad52e92f6$export$408949410470c71a(options = {}) {
    const { classMap: classMap = {
        error: [
            "highlighted",
            "error"
        ],
        warning: [
            "highlighted",
            "warning"
        ],
        info: [
            "highlighted",
            "info"
        ]
    }, classActivePre: classActivePre = "has-highlighted", classActiveCode: classActiveCode } = options;
    return $6f85c47ad52e92f6$export$ff8cb51c08589bef({
        classMap: classMap,
        classActivePre: classActivePre,
        classActiveCode: classActiveCode,
        matchAlgorithm: options.matchAlgorithm
    }, "@shikijs/transformers:notation-error-level");
}
function $6f85c47ad52e92f6$export$23e7dae3af02e892(options = {}) {
    const { classActiveLine: classActiveLine = "focused", classActivePre: classActivePre = "has-focused", classActiveCode: classActiveCode } = options;
    return $6f85c47ad52e92f6$export$ff8cb51c08589bef({
        classMap: {
            focus: classActiveLine
        },
        classActivePre: classActivePre,
        classActiveCode: classActiveCode,
        matchAlgorithm: options.matchAlgorithm
    }, "@shikijs/transformers:notation-focus");
}
function $6f85c47ad52e92f6$export$5730b2357d969c40(options = {}) {
    const { classActiveLine: classActiveLine = "highlighted", classActivePre: classActivePre = "has-highlighted", classActiveCode: classActiveCode } = options;
    return $6f85c47ad52e92f6$export$ff8cb51c08589bef({
        classMap: {
            highlight: classActiveLine,
            hl: classActiveLine
        },
        classActivePre: classActivePre,
        classActiveCode: classActiveCode,
        matchAlgorithm: options.matchAlgorithm
    }, "@shikijs/transformers:notation-highlight");
}
function $6f85c47ad52e92f6$var$highlightWordInLine(line, ignoredElement, word, className) {
    const content = $6f85c47ad52e92f6$var$getTextContent(line);
    let index = content.indexOf(word);
    while(index !== -1){
        $6f85c47ad52e92f6$var$highlightRange.call(this, line.children, ignoredElement, index, word.length, className);
        index = content.indexOf(word, index + 1);
    }
}
function $6f85c47ad52e92f6$var$getTextContent(element) {
    if (element.type === "text") return element.value;
    if (element.type === "element" && element.tagName === "span") return element.children.map($6f85c47ad52e92f6$var$getTextContent).join("");
    return "";
}
function $6f85c47ad52e92f6$var$highlightRange(elements, ignoredElement, index, len, className) {
    let currentIdx = 0;
    for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        if (element.type !== "element" || element.tagName !== "span" || element === ignoredElement) continue;
        const textNode = element.children[0];
        if (textNode.type !== "text") continue;
        if ($6f85c47ad52e92f6$var$hasOverlap([
            currentIdx,
            currentIdx + textNode.value.length - 1
        ], [
            index,
            index + len
        ])) {
            const start = Math.max(0, index - currentIdx);
            const length = len - Math.max(0, currentIdx - index);
            if (length === 0) continue;
            const separated = $6f85c47ad52e92f6$var$separateToken(element, textNode, start, length);
            this.addClassToHast(separated[1], className);
            const output = separated.filter(Boolean);
            elements.splice(i, 1, ...output);
            i += output.length - 1;
        }
        currentIdx += textNode.value.length;
    }
}
function $6f85c47ad52e92f6$var$hasOverlap(range1, range2) {
    return range1[0] <= range2[1] && range1[1] >= range2[0];
}
function $6f85c47ad52e92f6$var$separateToken(span, textNode, index, len) {
    const text = textNode.value;
    const createNode = (value)=>$6f85c47ad52e92f6$var$inheritElement(span, {
            children: [
                {
                    type: "text",
                    value: value
                }
            ]
        });
    return [
        index > 0 ? createNode(text.slice(0, index)) : void 0,
        createNode(text.slice(index, index + len)),
        index + len < text.length ? createNode(text.slice(index + len)) : void 0
    ];
}
function $6f85c47ad52e92f6$var$inheritElement(original, overrides) {
    return {
        ...original,
        properties: {
            ...original.properties
        },
        ...overrides
    };
}
function $6f85c47ad52e92f6$export$ea87fd06167efe20(options = {}) {
    const { classActiveWord: classActiveWord = "highlighted-word", classActivePre: classActivePre } = options;
    return $6f85c47ad52e92f6$export$fb4a1aa7bba30401("@shikijs/transformers:notation-highlight-word", /\s*\[!code word:((?:\\.|[^:\]])+)(:\d+)?\]/, function([_, word, range], _line, comment, lines, index) {
        const lineNum = range ? Number.parseInt(range.slice(1), 10) : lines.length;
        word = word.replace(/\\(.)/g, "$1");
        for(let i = index; i < Math.min(index + lineNum, lines.length); i++)$6f85c47ad52e92f6$var$highlightWordInLine.call(this, lines[i], comment, word, classActiveWord);
        if (classActivePre) this.addClassToHast(this.pre, classActivePre);
        return true;
    }, options.matchAlgorithm);
}
function $6f85c47ad52e92f6$export$7832581c3342f841(options = {}) {
    const { removeEmptyLines: removeEmptyLines = true } = options;
    return {
        name: "@shikijs/transformers:remove-comments",
        preprocess (_code, options2) {
            if (options2.includeExplanation !== true && options2.includeExplanation !== "scopeName") throw new Error("`transformerRemoveComments` requires `includeExplanation` to be set to `true` or `'scopeName'`");
        },
        tokens (tokens) {
            const result = [];
            for (const line of tokens){
                const filteredLine = [];
                let hasComment = false;
                for (const token of line){
                    const isComment = token.explanation?.some((exp)=>exp.scopes.some((s)=>s.scopeName.startsWith("comment")));
                    if (isComment) hasComment = true;
                    else filteredLine.push(token);
                }
                if (removeEmptyLines && hasComment) {
                    const isAllWhitespace = filteredLine.every((token)=>!token.content.trim());
                    if (isAllWhitespace) continue;
                }
                result.push(filteredLine);
            }
            return result;
        }
    };
}
function $6f85c47ad52e92f6$export$1dcf0a9fa65b844a() {
    return {
        name: "@shikijs/transformers:remove-line-break",
        code (code) {
            code.children = code.children.filter((line)=>!(line.type === "text" && line.value === "\n"));
        }
    };
}
function $6f85c47ad52e92f6$export$f9555c2e2b3d0dee() {
    return {
        name: "@shikijs/transformers:remove-notation-escape",
        code (hast) {
            function replace(node) {
                if (node.type === "text") node.value = node.value.replace("[\\!code", "[!code");
                else if ("children" in node) for (const child of node.children)replace(child);
            }
            replace(hast);
            return hast;
        }
    };
}
function $6f85c47ad52e92f6$export$2879387743ddc5c6(options = {}) {
    return {
        name: "@shikijs/transformers:render-indent-guides",
        code (hast) {
            const indent = Number(this.options.meta?.indent ?? this.options.meta?.__raw?.match(/\{indent:(\d+|false)\}/)?.[1] ?? options.indent ?? 2);
            if (Number.isNaN(indent) || indent <= 0) return hast;
            const indentRegex = new RegExp(` {${indent}}| {0,${indent - 1}}	| {1,}$`, "g");
            const emptyLines = [];
            let level = 0;
            for (const line of hast.children){
                if (line.type !== "element") continue;
                const first = line.children[0];
                if (first?.type !== "element" || first?.children[0]?.type !== "text") {
                    emptyLines.push([
                        line,
                        level
                    ]);
                    continue;
                }
                const text = first.children[0];
                const blanks = text.value.split(/[^ \t]/, 1)[0];
                const ranges = [];
                for (const match of blanks.matchAll(indentRegex)){
                    const start = match.index;
                    const end = start + match[0].length;
                    ranges.push([
                        start,
                        end
                    ]);
                }
                for (const [line2, level2] of emptyLines)line2.children.unshift(...Array.from({
                    length: Math.min(ranges.length, level2 + 1)
                }, (_, i)=>({
                        type: "element",
                        tagName: "span",
                        properties: {
                            class: "indent",
                            style: `--indent-offset: ${i * indent}ch;`
                        },
                        children: []
                    })));
                emptyLines.length = 0;
                level = ranges.length;
                if (ranges.length) {
                    line.children.unshift(...ranges.map(([start, end])=>({
                            type: "element",
                            tagName: "span",
                            properties: {
                                class: "indent"
                            },
                            children: [
                                {
                                    type: "text",
                                    value: text.value.slice(start, end)
                                }
                            ]
                        })));
                    text.value = text.value.slice(ranges.at(-1)[1]);
                }
            }
            return hast;
        }
    };
}
function $6f85c47ad52e92f6$var$isTab(part) {
    return part === "	";
}
function $6f85c47ad52e92f6$var$isSpace(part) {
    return part === " " || part === "	";
}
function $6f85c47ad52e92f6$var$separateContinuousSpaces(inputs) {
    const result = [];
    let current = "";
    function bump() {
        if (current.length) result.push(current);
        current = "";
    }
    inputs.forEach((part, idx)=>{
        if ($6f85c47ad52e92f6$var$isTab(part)) {
            bump();
            result.push(part);
        } else if ($6f85c47ad52e92f6$var$isSpace(part) && ($6f85c47ad52e92f6$var$isSpace(inputs[idx - 1]) || $6f85c47ad52e92f6$var$isSpace(inputs[idx + 1]))) {
            bump();
            result.push(part);
        } else current += part;
    });
    bump();
    return result;
}
function $6f85c47ad52e92f6$var$splitSpaces(parts, type, renderContinuousSpaces = true) {
    if (type === "all") return parts;
    let leftCount = 0;
    let rightCount = 0;
    if (type === "boundary" || type === "leading") for(let i = 0; i < parts.length; i++){
        if ($6f85c47ad52e92f6$var$isSpace(parts[i])) leftCount++;
        else break;
    }
    if (type === "boundary" || type === "trailing") for(let i = parts.length - 1; i >= 0; i--){
        if ($6f85c47ad52e92f6$var$isSpace(parts[i])) rightCount++;
        else break;
    }
    const middle = parts.slice(leftCount, parts.length - rightCount);
    return [
        ...parts.slice(0, leftCount),
        ...renderContinuousSpaces ? $6f85c47ad52e92f6$var$separateContinuousSpaces(middle) : [
            middle.join("")
        ],
        ...parts.slice(parts.length - rightCount)
    ];
}
function $6f85c47ad52e92f6$export$848be1f9038ec922(options = {}) {
    const classMap = {
        " ": options.classSpace ?? "space",
        "	": options.classTab ?? "tab"
    };
    const position = options.position ?? "all";
    const keys = Object.keys(classMap);
    return {
        name: "@shikijs/transformers:render-whitespace",
        // We use `root` hook here to ensure it runs after all other transformers
        root (root) {
            const pre = root.children[0];
            const code = pre.tagName === "pre" ? pre.children[0] : {
                children: [
                    root
                ]
            };
            code.children.forEach((line)=>{
                if (line.type !== "element" && line.type !== "root") return;
                const elements = line.children.filter((token)=>token.type === "element");
                const last = elements.length - 1;
                line.children = line.children.flatMap((token)=>{
                    if (token.type !== "element") return token;
                    const index = elements.indexOf(token);
                    if (position === "boundary" && index !== 0 && index !== last) return token;
                    if (position === "trailing" && index !== last) return token;
                    if (position === "leading" && index !== 0) return token;
                    const node = token.children[0];
                    if (node.type !== "text" || !node.value) return token;
                    const parts = $6f85c47ad52e92f6$var$splitSpaces(node.value.split(/([ \t])/).filter((i)=>i.length), position === "boundary" && index === last && last !== 0 ? "trailing" : position, position !== "trailing" && position !== "leading");
                    if (parts.length <= 1) return token;
                    return parts.map((part)=>{
                        const clone = {
                            ...token,
                            properties: {
                                ...token.properties
                            }
                        };
                        clone.children = [
                            {
                                type: "text",
                                value: part
                            }
                        ];
                        if (keys.includes(part)) {
                            this.addClassToHast(clone, classMap[part]);
                            delete clone.properties.style;
                        }
                        return clone;
                    });
                });
            });
        }
    };
}
function $6f85c47ad52e92f6$export$39f6d04e93b7ba64(options = {}) {
    const { classPrefix: classPrefix = "__shiki_", classSuffix: classSuffix = "", classReplacer: classReplacer = (className)=>className } = options;
    const classToStyle = /* @__PURE__ */ new Map();
    function stringifyStyle(style) {
        return Object.entries(style).map(([key, value])=>`${key}:${value}`).join(";");
    }
    function registerStyle(style) {
        const str = typeof style === "string" ? style : stringifyStyle(style);
        let className = classPrefix + $6f85c47ad52e92f6$var$cyrb53(str) + classSuffix;
        className = classReplacer(className);
        if (!classToStyle.has(className)) classToStyle.set(className, typeof style === "string" ? style : {
            ...style
        });
        return className;
    }
    return {
        name: "@shikijs/transformers:style-to-class",
        pre (t) {
            if (!t.properties.style) return;
            const className = registerStyle(t.properties.style);
            delete t.properties.style;
            this.addClassToHast(t, className);
        },
        tokens (lines) {
            for (const line of lines)for (const token of line){
                if (!token.htmlStyle) continue;
                const className = registerStyle(token.htmlStyle);
                token.htmlStyle = {};
                token.htmlAttrs ||= {};
                if (!token.htmlAttrs.class) token.htmlAttrs.class = className;
                else token.htmlAttrs.class += ` ${className}`;
            }
        },
        getClassRegistry () {
            return classToStyle;
        },
        getCSS () {
            let css = "";
            for (const [className, style] of classToStyle.entries())css += `.${className}{${typeof style === "string" ? style : stringifyStyle(style)}}`;
            return css;
        },
        clearRegistry () {
            classToStyle.clear();
        }
    };
}
function $6f85c47ad52e92f6$var$cyrb53(str, seed = 0) {
    let h1 = 3735928559 ^ seed;
    let h2 = 1103547991 ^ seed;
    for(let i = 0, ch; i < str.length; i++){
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36).slice(0, 6);
}


//#region src/utils/createTransformerWithState.ts
function $8eabaf3795872bdc$export$b288a91f7d0d05d6(useTokenTransformer = false, useCSSClasses = false) {
    const state = {
        lineInfo: []
    };
    const transformers = [
        {
            line (node) {
                delete node.properties.class;
                return node;
            },
            pre (pre) {
                const code = (0, $f6f1fb01992c2ec8$export$839d57c14284d860)(pre);
                const children = [];
                if (code != null) {
                    let index = 1;
                    for (const node of code.children){
                        if (node.type !== "element") continue;
                        if (useTokenTransformer) (0, $d44689f51ce99760$export$92ac62c33ed5937c)(node);
                        children.push((0, $78371dee7efe83b3$export$7f0a012bc07d0fce)(node, index, state));
                        index++;
                    }
                    code.children = children;
                }
                return pre;
            },
            ...useTokenTransformer ? {
                tokens (lines) {
                    for (const line of lines){
                        let col = 0;
                        for (const token of line){
                            const tokenWithOriginalRange = token;
                            tokenWithOriginalRange.__lineChar ??= col;
                            col += token.content.length;
                        }
                    }
                },
                preprocess (_code, options) {
                    options.mergeWhitespaces = "never";
                },
                span (hast, _line, _char, _lineElement, token) {
                    if (token?.offset != null && token.content != null) {
                        const tokenChar = token.__lineChar;
                        if (tokenChar != null) hast.properties["data-char"] = tokenChar;
                        return hast;
                    }
                    return hast;
                }
            } : null
        }
    ];
    if (useCSSClasses) transformers.push($8eabaf3795872bdc$var$tokenStyleNormalizer, $8eabaf3795872bdc$var$toClass);
    return {
        state: state,
        transformers: transformers,
        toClass: $8eabaf3795872bdc$var$toClass
    };
}
const $8eabaf3795872bdc$var$toClass = (0, $6f85c47ad52e92f6$export$39f6d04e93b7ba64)({
    classPrefix: "hl-"
});
const $8eabaf3795872bdc$var$tokenStyleNormalizer = {
    name: "token-style-normalizer",
    tokens (lines) {
        for (const line of lines)for (const token of line){
            if (token.htmlStyle != null) continue;
            const style = {};
            if (token.color != null) style.color = token.color;
            if (token.bgColor != null) style["background-color"] = token.bgColor;
            if (token.fontStyle != null && token.fontStyle !== 0) {
                if ((token.fontStyle & 1) !== 0) style["font-style"] = "italic";
                if ((token.fontStyle & 2) !== 0) style["font-weight"] = "bold";
                if ((token.fontStyle & 4) !== 0) style["text-decoration"] = "underline";
            }
            if (Object.keys(style).length > 0) token.htmlStyle = style;
        }
    }
};


//#region src/utils/formatCSSVariablePrefix.ts
function $ab1b0607c7492dc4$export$df7d907f3fbd85f9(type) {
    return `--${type === "token" ? "diffs-token" : "diffs"}-`;
}




//#region src/utils/getHighlighterThemeStyles.ts
function $2dcbebec51687b3b$export$4dfa4d391e354885({ theme: theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59), highlighter: highlighter, prefix: prefix }) {
    let styles = "";
    if (typeof theme === "string") {
        const themeData = highlighter.getTheme(theme);
        styles += `color:${themeData.fg};`;
        styles += `background-color:${themeData.bg};`;
        styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}fg:${themeData.fg};`;
        styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}bg:${themeData.bg};`;
        styles += $2dcbebec51687b3b$var$getThemeVariables(themeData, prefix);
    } else {
        let themeData = highlighter.getTheme(theme.dark);
        styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}dark:${themeData.fg};`;
        styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}dark-bg:${themeData.bg};`;
        styles += $2dcbebec51687b3b$var$getThemeVariables(themeData, "dark");
        themeData = highlighter.getTheme(theme.light);
        styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}light:${themeData.fg};`;
        styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}light-bg:${themeData.bg};`;
        styles += $2dcbebec51687b3b$var$getThemeVariables(themeData, "light");
    }
    return styles;
}
function $2dcbebec51687b3b$var$getThemeVariables(themeData, modePrefix) {
    modePrefix = modePrefix != null ? `${modePrefix}-` : "";
    let styles = "";
    const additionGreen = themeData.colors?.["gitDecoration.addedResourceForeground"] ?? themeData.colors?.["terminal.ansiGreen"];
    if (additionGreen != null) styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}${modePrefix}addition-color:${additionGreen};`;
    const deletionRed = themeData.colors?.["gitDecoration.deletedResourceForeground"] ?? themeData.colors?.["terminal.ansiRed"];
    if (deletionRed != null) styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}${modePrefix}deletion-color:${deletionRed};`;
    const modifiedBlue = themeData.colors?.["gitDecoration.modifiedResourceForeground"] ?? themeData.colors?.["terminal.ansiBlue"];
    if (modifiedBlue != null) styles += `${(0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("global")}${modePrefix}modified-color:${modifiedBlue};`;
    return styles;
}


//#region src/utils/getLineNodes.ts
function $fb43f60ae112d7f4$export$c18bf1cf224af47d(nodes) {
    let firstChild = nodes.children[0];
    while(firstChild != null){
        if (firstChild.type === "element" && firstChild.tagName === "code") return firstChild.children;
        if ("children" in firstChild) firstChild = firstChild.children[0];
        else firstChild = null;
    }
    console.error(nodes);
    throw new Error("getLineNodes: Unable to find children");
}



//#region src/utils/renderFileWithHighlighter.ts
const $64eb39638c0b85af$var$DEFAULT_PLAIN_TEXT_OPTIONS = {
    forcePlainText: false
};
function $64eb39638c0b85af$export$b0a36636bcffa870(file, highlighter, { theme: theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59), tokenizeMaxLineLength: tokenizeMaxLineLength, useTokenTransformer: useTokenTransformer }, { forcePlainText: forcePlainText, startingLine: startingLine, totalLines: totalLines, lines: lines } = $64eb39638c0b85af$var$DEFAULT_PLAIN_TEXT_OPTIONS) {
    if (forcePlainText) {
        startingLine ??= 0;
        totalLines ??= Infinity;
    } else {
        startingLine = 0;
        totalLines = Infinity;
    }
    const isWindowedHighlight = startingLine > 0 || totalLines < Infinity;
    const { state: state, transformers: transformers } = (0, $8eabaf3795872bdc$export$b288a91f7d0d05d6)(useTokenTransformer);
    const lang = forcePlainText ? "text" : file.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(file.name);
    const baseThemeType = typeof theme === "string" ? highlighter.getTheme(theme).type : void 0;
    const themeStyles = (0, $2dcbebec51687b3b$export$4dfa4d391e354885)({
        theme: theme,
        highlighter: highlighter
    });
    state.lineInfo = (shikiLineNumber)=>({
            type: "context",
            lineIndex: shikiLineNumber - 1 + startingLine,
            lineNumber: shikiLineNumber + startingLine
        });
    const hastConfig = (()=>{
        if (typeof theme === "string") return {
            lang: lang,
            theme: theme,
            transformers: transformers,
            defaultColor: false,
            cssVariablePrefix: (0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("token"),
            tokenizeMaxLineLength: tokenizeMaxLineLength
        };
        return {
            lang: lang,
            themes: theme,
            transformers: transformers,
            defaultColor: false,
            cssVariablePrefix: (0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("token"),
            tokenizeMaxLineLength: tokenizeMaxLineLength
        };
    })();
    const highlightedLines = (0, $fb43f60ae112d7f4$export$c18bf1cf224af47d)(highlighter.codeToHast(isWindowedHighlight ? $64eb39638c0b85af$var$extractWindowedFileContent(lines ?? (0, $d26b46ce8ae8b6da$export$745e60fc52f3cfed)(file.contents), startingLine, totalLines) : (0, $edf66b00d8168e8a$export$b6130a543868c75e)(file.contents), hastConfig));
    const code = isWindowedHighlight ? new Array(startingLine) : highlightedLines;
    if (isWindowedHighlight) code.push(...highlightedLines);
    return {
        code: code,
        themeStyles: themeStyles,
        baseThemeType: baseThemeType
    };
}
function $64eb39638c0b85af$var$extractWindowedFileContent(lines, startingLine, totalLines) {
    let windowContent = "";
    (0, $d2a7ea3ff52c7aba$export$bd45a6ae4d225463)({
        lines: lines,
        startingLine: startingLine,
        totalLines: totalLines,
        callback ({ content: content }) {
            windowContent += content;
        }
    });
    return windowContent;
}


//#region src/utils/shouldUseTokenTransformer.ts
function $0b5b6647dbdfacae$export$b3fc1fc961cc0c(options) {
    return options.useTokenTransformer === true || options.onTokenClick != null || options.onTokenEnter != null || options.onTokenLeave != null;
}



//#region src/renderers/FileRenderer.ts
let $4acbe3dda9969d81$var$instanceId = -1;
var $4acbe3dda9969d81$export$dd452f961566808f = class {
    __id = `file-renderer:${++$4acbe3dda9969d81$var$instanceId}`;
    highlighter;
    renderCache;
    computedLang = "text";
    lineAnnotations = {};
    lineCache;
    constructor(options = {
        theme: (0, $6986aac91971cc6d$export$bcfc57767d137a59)
    }, onRenderUpdate, workerManager){
        this.options = options;
        this.onRenderUpdate = onRenderUpdate;
        this.workerManager = workerManager;
        if (workerManager?.isWorkingPool() !== true) this.highlighter = (0, $e1de8f8a9ed7d4cd$export$5ce36088543a0a6f)(options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59)) ? (0, $5038ef2223d0d43d$export$b046b6d0abcdff6a)() : void 0;
    }
    setOptions(options) {
        this.options = options;
    }
    mergeOptions(options) {
        this.options = {
            ...this.options,
            ...options
        };
    }
    setLineAnnotations(lineAnnotations) {
        this.lineAnnotations = {};
        for (const annotation of lineAnnotations){
            const arr = this.lineAnnotations[annotation.lineNumber] ?? [];
            this.lineAnnotations[annotation.lineNumber] = arr;
            arr.push(annotation);
        }
    }
    cleanUp() {
        this.recycle();
        this.workerManager = void 0;
        this.onRenderUpdate = void 0;
    }
    recycle() {
        this.renderCache = void 0;
        this.highlighter = void 0;
        this.workerManager?.cleanUpTasks(this);
        this.lineCache = void 0;
    }
    hydrate(file) {
        const { options: options } = this.getRenderOptions(file);
        const massiveFile = $4acbe3dda9969d81$var$isFileMassive(this.getOrCreateLineCache(file).length, this.getTokenizeMaxLength());
        let cache = this.workerManager?.getFileResultCache(file);
        if (cache != null && !(0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(options, cache.options)) cache = void 0;
        this.renderCache ??= {
            file: file,
            options: options,
            highlighted: !massiveFile && !(0, $15de751b18238005$export$4d513fdf32c04fe0)(file),
            result: massiveFile ? void 0 : cache?.result,
            renderRange: void 0
        };
        if (this.workerManager?.isWorkingPool() === true) {
            if (this.renderCache.result == null && !massiveFile) this.workerManager.highlightFileAST(this, file);
        } else if (this.highlighter == null) {
            this.computedLang = file.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(file.name);
            this.initializeHighlighter();
        }
    }
    getRenderOptions(file) {
        const options = (()=>{
            if (this.workerManager?.isWorkingPool() === true) return this.workerManager.getFileRenderOptions();
            const { theme: theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59), tokenizeMaxLineLength: tokenizeMaxLineLength = 1e3 } = this.options;
            return {
                theme: theme,
                useTokenTransformer: (0, $0b5b6647dbdfacae$export$b3fc1fc961cc0c)(this.options),
                tokenizeMaxLineLength: tokenizeMaxLineLength
            };
        })();
        const { renderCache: renderCache } = this;
        if (renderCache?.result == null) return {
            options: options,
            forceHighlight: true
        };
        if (!(0, $2f249b89688d7794$export$66ae137c56162891)(file, renderCache.file) || !(0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(options, renderCache.options)) return {
            options: options,
            forceHighlight: true
        };
        return {
            options: options,
            forceHighlight: false
        };
    }
    getOrCreateLineCache(file) {
        if (file.cacheKey == null) {
            this.lineCache = void 0;
            return (0, $d26b46ce8ae8b6da$export$745e60fc52f3cfed)(file.contents);
        }
        let { lineCache: lineCache } = this;
        if (lineCache == null || lineCache.cacheKey !== file.cacheKey) lineCache = {
            cacheKey: file.cacheKey,
            lines: (0, $d26b46ce8ae8b6da$export$745e60fc52f3cfed)(file.contents)
        };
        this.lineCache = lineCache;
        return lineCache.lines;
    }
    renderFile(file = this.renderCache?.file, renderRange = (0, $6986aac91971cc6d$export$de9ceafea6c24cf3)) {
        if (file == null) return;
        let { options: options, forceHighlight: forceHighlight } = this.getRenderOptions(file);
        const cache = this.getMatchingWorkerResultCache(file, options);
        if (cache != null && !this.hasHighlightedRenderCache(file, options)) {
            this.renderCache = {
                file: file,
                highlighted: true,
                renderRange: void 0,
                ...cache
            };
            forceHighlight = false;
        }
        this.renderCache ??= {
            file: file,
            highlighted: false,
            options: options,
            result: void 0,
            renderRange: void 0
        };
        const lines = this.getOrCreateLineCache(file);
        const hasContent = file.contents.length > 0;
        const forcePlainText = !hasContent || (0, $15de751b18238005$export$4d513fdf32c04fe0)(file) || $4acbe3dda9969d81$var$isFileMassive(lines.length, this.getTokenizeMaxLength());
        const newContent = !(0, $2f249b89688d7794$export$66ae137c56162891)(file, this.renderCache.file);
        const newRenderRange = !(0, $27129b485d2e8f5d$export$7df1d5d844442f33)(this.renderCache.renderRange, renderRange);
        if (this.workerManager?.isWorkingPool() === true) {
            if (forcePlainText || this.renderCache.result == null || !this.renderCache.highlighted && (newContent || newRenderRange)) {
                this.renderCache.file = file;
                this.renderCache.options = options;
                this.renderCache.highlighted = false;
                if (this.renderCache.result == null || newContent || newRenderRange || forceHighlight) this.renderCache.result = this.workerManager.getPlainFileAST(file, renderRange.startingLine, renderRange.totalLines, lines);
                this.renderCache.renderRange = renderRange;
            }
            if (!forcePlainText && hasContent && (!this.renderCache.highlighted || forceHighlight)) this.workerManager.highlightFileAST(this, file);
        } else {
            this.computedLang = file.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(file.name);
            const hasThemes = this.highlighter != null && (0, $e1de8f8a9ed7d4cd$export$5ce36088543a0a6f)(options.theme);
            const hasLangs = this.highlighter != null && (0, $78bde705d027ffd2$export$fa78c2fcbeceac38)(this.computedLang);
            const canHighlight = !forcePlainText && hasLangs;
            if (this.highlighter != null && hasThemes && (forceHighlight || forcePlainText || !this.renderCache.highlighted && canHighlight || this.renderCache.result == null)) {
                const { result: result, options: options$1 } = this.renderFileWithHighlighter(file, this.highlighter, forcePlainText || !hasLangs);
                this.renderCache = {
                    file: file,
                    options: options$1,
                    highlighted: canHighlight,
                    result: result,
                    renderRange: void 0
                };
            }
            if (!hasThemes || !forcePlainText && !hasLangs) this.asyncHighlight(file).then(({ result: result, options: options$1 })=>{
                if (this.renderCache != null) this.renderCache.highlighted = false;
                this.onHighlightSuccess(file, result, options$1, !forcePlainText);
            });
        }
        return this.renderCache.result != null ? this.processFileResult(this.renderCache.file, renderRange, this.renderCache.result) : void 0;
    }
    async asyncRender(file, renderRange = (0, $6986aac91971cc6d$export$de9ceafea6c24cf3)) {
        const { result: result } = await this.asyncHighlight(file);
        return this.processFileResult(file, renderRange, result);
    }
    async asyncHighlight(file) {
        const forcePlainText = $4acbe3dda9969d81$var$isFileMassive(this.getOrCreateLineCache(file).length, this.getTokenizeMaxLength());
        this.computedLang = forcePlainText ? "text" : file.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(file.name);
        const hasThemes = this.highlighter != null && (0, $bf2dbe218dfe08c0$export$94034355ed3693a6)((0, $1aa1190ca9b15e96$export$a11593be0c51d6a7)(this.options.theme));
        const hasLangs = forcePlainText || this.highlighter != null && (0, $78bde705d027ffd2$export$fa78c2fcbeceac38)(this.computedLang);
        if (this.highlighter == null || !hasThemes || !hasLangs) this.highlighter = await this.initializeHighlighter();
        return this.renderFileWithHighlighter(file, this.highlighter, forcePlainText);
    }
    renderFileWithHighlighter(file, highlighter, forcePlainText = false) {
        const { options: options } = this.getRenderOptions(file);
        return {
            result: (0, $64eb39638c0b85af$export$b0a36636bcffa870)(file, highlighter, options, {
                forcePlainText: forcePlainText
            }),
            options: options
        };
    }
    processFileResult(file, renderRange, { code: code, themeStyles: themeStyles, baseThemeType: baseThemeType }) {
        const { disableFileHeader: disableFileHeader = false } = this.options;
        const contentArray = [];
        const gutter = (0, $f6f1fb01992c2ec8$export$275418e72db785cd)();
        const lines = this.getOrCreateLineCache(file);
        let rowCount = 0;
        (0, $d2a7ea3ff52c7aba$export$bd45a6ae4d225463)({
            lines: lines,
            startingLine: renderRange.startingLine,
            totalLines: renderRange.totalLines,
            callback: ({ lineIndex: lineIndex, lineNumber: lineNumber })=>{
                const line = code[lineIndex];
                if (line == null) {
                    const message = "FileRenderer.processFileResult: Line doesnt exist";
                    console.error(message, {
                        name: file.name,
                        lineIndex: lineIndex,
                        lineNumber: lineNumber,
                        lines: lines
                    });
                    throw new Error(message);
                }
                if (line != null) {
                    gutter.children.push((0, $f6f1fb01992c2ec8$export$6fcf2c49524b5dc1)("context", lineNumber, `${lineIndex}`));
                    contentArray.push(line);
                    rowCount++;
                    const annotations = this.lineAnnotations[lineNumber];
                    if (annotations != null) {
                        gutter.children.push((0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)("context", "annotation", 1));
                        contentArray.push((0, $03fd4bd96344ff46$export$a11205b4d57749fb)({
                            type: "annotation",
                            hunkIndex: 0,
                            lineIndex: lineNumber,
                            annotations: annotations.map((annotation)=>(0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation))
                        }));
                        rowCount++;
                    }
                }
            }
        });
        gutter.properties.style = `grid-row: span ${rowCount}`;
        return {
            gutterAST: gutter.children ?? [],
            contentAST: contentArray,
            preAST: this.createPreElement(lines.length),
            headerAST: !disableFileHeader ? this.renderHeader(file) : void 0,
            totalLines: lines.length,
            rowCount: rowCount,
            themeStyles: themeStyles,
            baseThemeType: baseThemeType,
            bufferBefore: renderRange.bufferBefore,
            bufferAfter: renderRange.bufferAfter,
            css: ""
        };
    }
    renderHeader(file) {
        const { headerRenderMode: headerRenderMode = "default", stickyHeader: stickyHeader = false } = this.options;
        return (0, $70ef609d54bc0682$export$de00955f585ed124)({
            fileOrDiff: file,
            mode: headerRenderMode,
            stickyHeader: stickyHeader
        });
    }
    renderFullHTML(result) {
        return (0, $59ad8c13d9107e7c$export$a10125c086a4df16)(this.renderFullAST(result));
    }
    renderFullAST(result, children = []) {
        children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "code",
            children: this.renderCodeAST(result),
            properties: {
                "data-code": ""
            }
        }));
        return {
            ...result.preAST,
            children: children
        };
    }
    renderCodeAST(result) {
        const gutter = (0, $f6f1fb01992c2ec8$export$275418e72db785cd)();
        gutter.children = result.gutterAST;
        gutter.properties.style = `grid-row: span ${result.rowCount}`;
        return [
            gutter,
            (0, $a72acb3cb61e0911$export$ae45562cd268c97b)(result.contentAST, result.rowCount)
        ];
    }
    renderPartialHTML(children, includeCodeNode = false) {
        if (!includeCodeNode) return (0, $59ad8c13d9107e7c$export$a10125c086a4df16)(children);
        return (0, $59ad8c13d9107e7c$export$a10125c086a4df16)((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "code",
            children: children,
            properties: {
                "data-code": ""
            }
        }));
    }
    async initializeHighlighter() {
        this.highlighter = await (0, $5038ef2223d0d43d$export$3ae4f582c943284e)((0, $3dc03ceed6671d25$export$d8fa3650d67306ca)(this.computedLang, this.options));
        return this.highlighter;
    }
    onHighlightSuccess(file, result, options, highlighted = true) {
        if (this.renderCache == null) return;
        const triggerRenderUpdate = !(0, $2f249b89688d7794$export$66ae137c56162891)(file, this.renderCache.file) || !this.renderCache.highlighted || !(0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(options, this.renderCache.options);
        this.renderCache = {
            file: file,
            options: options,
            highlighted: highlighted,
            result: result,
            renderRange: void 0
        };
        if (triggerRenderUpdate) this.onRenderUpdate?.();
    }
    getMatchingWorkerResultCache(file, options) {
        const cache = this.workerManager?.getFileResultCache(file);
        if (cache == null || !(0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(options, cache.options)) return;
        return cache;
    }
    hasHighlightedRenderCache(file, options) {
        const { renderCache: renderCache } = this;
        return renderCache?.result != null && renderCache.highlighted && (0, $2f249b89688d7794$export$66ae137c56162891)(file, renderCache.file) && (0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(options, renderCache.options);
    }
    onHighlightError(error) {
        console.error(error);
    }
    getTokenizeMaxLength() {
        return this.options.tokenizeMaxLength ?? (0, $6986aac91971cc6d$export$b31ab775814f11e2);
    }
    createPreElement(totalLines) {
        const { disableLineNumbers: disableLineNumbers = false, overflow: overflow = "scroll" } = this.options;
        return (0, $d98c49a6cb7f2b6e$export$bbf52dba466bc3d2)({
            type: "file",
            diffIndicators: "none",
            disableBackground: true,
            disableLineNumbers: disableLineNumbers,
            overflow: overflow,
            split: false,
            totalLines: totalLines
        });
    }
};
function $4acbe3dda9969d81$var$isFileMassive(lineCount, tokenizeMaxLength) {
    return lineCount > tokenizeMaxLength;
}


//#region src/sprite.ts
const $166d24462d2ee37b$export$ddccfde1db76f444 = `<svg data-icon-sprite aria-hidden="true" width="0" height="0">
  <symbol id="diffs-icon-arrow-right-short" viewBox="0 0 16 16">
    <path d="M8.47 4.22a.75.75 0 0 0 0 1.06l1.97 1.97H3.75a.75.75 0 0 0 0 1.5h6.69l-1.97 1.97a.75.75 0 1 0 1.06 1.06l3.25-3.25a.75.75 0 0 0 0-1.06L9.53 4.22a.75.75 0 0 0-1.06 0"/>
  </symbol>
  <symbol id="diffs-icon-brand-github" viewBox="0 0 16 16">
    <path d="M8 0c4.42 0 8 3.58 8 8a8.01 8.01 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27s-1.36.09-2 .27c-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8"/>
  </symbol>
  <symbol id="diffs-icon-chevron" viewBox="0 0 16 16">
    <path d="M1.47 4.47a.75.75 0 0 1 1.06 0L8 9.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06"/>
  </symbol>
  <symbol id="diffs-icon-chevrons-narrow" viewBox="0 0 10 16">
    <path d="M4.47 2.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1-1.06 1.06L5 3.81 2.28 6.53a.75.75 0 0 1-1.06-1.06zM1.22 9.47a.75.75 0 0 1 1.06 0L5 12.19l2.72-2.72a.75.75 0 0 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 0 1 0-1.06"/>
  </symbol>
  <symbol id="diffs-icon-diff-split" viewBox="0 0 16 16">
    <path d="M14 0H8.5v16H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-1.5 6.5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0"/><path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5.5V0zm.5 7.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1" opacity=".3"/>
  </symbol>
  <symbol id="diffs-icon-diff-unified" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.5h16zm-8-4a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1A.5.5 0 0 0 8 10" clip-rule="evenodd"/><path fill-rule="evenodd" d="M14 0a2 2 0 0 1 2 2v5.5H0V2a2 2 0 0 1 2-2zM6.5 3.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z" clip-rule="evenodd" opacity=".4"/>
  </symbol>
  <symbol id="diffs-icon-expand" viewBox="0 0 16 16">
    <path d="M3.47 5.47a.75.75 0 0 1 1.06 0L8 8.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06"/>
  </symbol>
  <symbol id="diffs-icon-expand-all" viewBox="0 0 16 16">
    <path d="M11.47 9.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L8 12.94zM7.526 1.418a.75.75 0 0 1 1.004.052l4 4a.75.75 0 1 1-1.06 1.06L8 3.06 4.53 6.53a.75.75 0 1 1-1.06-1.06l4-4z"/>
  </symbol>
  <symbol id="diffs-icon-file-code" viewBox="0 0 16 16">
    <path d="M10.75 0c.199 0 .39.08.53.22l3.5 3.5c.14.14.22.331.22.53v9A2.75 2.75 0 0 1 12.25 16h-8.5A2.75 2.75 0 0 1 1 13.25V2.75A2.75 2.75 0 0 1 3.75 0zm-7 1.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V5h-1.25A2.25 2.25 0 0 1 10 2.75V1.5z"/><path d="M7.248 6.19a.75.75 0 0 1 .063 1.058L5.753 9l1.558 1.752a.75.75 0 0 1-1.122.996l-2-2.25a.75.75 0 0 1 0-.996l2-2.25a.75.75 0 0 1 1.06-.063M8.69 7.248a.75.75 0 1 1 1.12-.996l2 2.25a.75.75 0 0 1 0 .996l-2 2.25a.75.75 0 1 1-1.12-.996L10.245 9z"/>
  </symbol>
  <symbol id="diffs-icon-plus" viewBox="0 0 16 16">
    <path d="M8 3a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 8 3"/>
  </symbol>
  <symbol id="diffs-icon-symbol-added" viewBox="0 0 16 16">
    <path d="M8 4a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 8 4"/><path d="M1.788 4.296c.196-.88.478-1.381.802-1.706s.826-.606 1.706-.802C5.194 1.588 6.387 1.5 8 1.5s2.806.088 3.704.288c.88.196 1.381.478 1.706.802s.607.826.802 1.706c.2.898.288 2.091.288 3.704s-.088 2.806-.288 3.704c-.195.88-.478 1.381-.802 1.706s-.826.607-1.706.802c-.898.2-2.091.288-3.704.288s-2.806-.088-3.704-.288c-.88-.195-1.381-.478-1.706-.802s-.606-.826-.802-1.706C1.588 10.806 1.5 9.613 1.5 8s.088-2.806.288-3.704M8 0C1.412 0 0 1.412 0 8s1.412 8 8 8 8-1.412 8-8-1.412-8-8-8"/>
  </symbol>
  <symbol id="diffs-icon-symbol-deleted" viewBox="0 0 16 16">
    <path d="M4 8a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 4 8"/><path d="M1.788 4.296c.196-.88.478-1.381.802-1.706s.826-.606 1.706-.802C5.194 1.588 6.387 1.5 8 1.5s2.806.088 3.704.288c.88.196 1.381.478 1.706.802s.607.826.802 1.706c.2.898.288 2.091.288 3.704s-.088 2.806-.288 3.704c-.195.88-.478 1.381-.802 1.706s-.826.607-1.706.802c-.898.2-2.091.288-3.704.288s-2.806-.088-3.704-.288c-.88-.195-1.381-.478-1.706-.802s-.606-.826-.802-1.706C1.588 10.806 1.5 9.613 1.5 8s.088-2.806.288-3.704M8 0C1.412 0 0 1.412 0 8s1.412 8 8 8 8-1.412 8-8-1.412-8-8-8"/>
  </symbol>
  <symbol id="diffs-icon-symbol-diffstat" viewBox="0 0 16 16">
    <path d="M1.788 4.296c.196-.88.478-1.381.802-1.706s.826-.606 1.706-.802C5.194 1.588 6.387 1.5 8 1.5s2.806.088 3.704.288c.88.196 1.381.478 1.706.802s.607.826.802 1.706c.2.898.288 2.091.288 3.704s-.088 2.806-.288 3.704c-.195.88-.478 1.381-.802 1.706s-.826.607-1.706.802c-.898.2-2.091.288-3.704.288s-2.806-.088-3.704-.288c-.88-.195-1.381-.478-1.706-.802s-.606-.826-.802-1.706C1.588 10.806 1.5 9.613 1.5 8s.088-2.806.288-3.704M8 0C1.412 0 0 1.412 0 8s1.412 8 8 8 8-1.412 8-8-1.412-8-8-8"/><path d="M8.75 4.296a.75.75 0 0 0-1.5 0V6.25h-2a.75.75 0 0 0 0 1.5h2v1.5h1.5v-1.5h2a.75.75 0 0 0 0-1.5h-2zM5.25 10a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"/>
  </symbol>
  <symbol id="diffs-icon-symbol-ignored" viewBox="0 0 16 16">
    <path d="M1.5 8c0 1.613.088 2.806.288 3.704.196.88.478 1.381.802 1.706s.826.607 1.706.802c.898.2 2.091.288 3.704.288s2.806-.088 3.704-.288c.88-.195 1.381-.478 1.706-.802s.607-.826.802-1.706c.2-.898.288-2.091.288-3.704s-.088-2.806-.288-3.704c-.195-.88-.478-1.381-.802-1.706s-.826-.606-1.706-.802C10.806 1.588 9.613 1.5 8 1.5s-2.806.088-3.704.288c-.88.196-1.381.478-1.706.802s-.606.826-.802 1.706C1.588 5.194 1.5 6.387 1.5 8M0 8c0-6.588 1.412-8 8-8s8 1.412 8 8-1.412 8-8 8-8-1.412-8-8m11.53-2.47a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06z"/>
  </symbol>
  <symbol id="diffs-icon-symbol-modified" viewBox="0 0 16 16">
    <path d="M1.5 8c0 1.613.088 2.806.288 3.704.196.88.478 1.381.802 1.706s.826.607 1.706.802c.898.2 2.091.288 3.704.288s2.806-.088 3.704-.288c.88-.195 1.381-.478 1.706-.802s.607-.826.802-1.706c.2-.898.288-2.091.288-3.704s-.088-2.806-.288-3.704c-.195-.88-.478-1.381-.802-1.706s-.826-.606-1.706-.802C10.806 1.588 9.613 1.5 8 1.5s-2.806.088-3.704.288c-.88.196-1.381.478-1.706.802s-.606.826-.802 1.706C1.588 5.194 1.5 6.387 1.5 8M0 8c0-6.588 1.412-8 8-8s8 1.412 8 8-1.412 8-8 8-8-1.412-8-8m8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
  </symbol>
  <symbol id="diffs-icon-symbol-moved" viewBox="0 0 16 16">
    <path d="M1.788 4.296c.196-.88.478-1.381.802-1.706s.826-.606 1.706-.802C5.194 1.588 6.387 1.5 8 1.5s2.806.088 3.704.288c.88.196 1.381.478 1.706.802s.607.826.802 1.706c.2.898.288 2.091.288 3.704s-.088 2.806-.288 3.704c-.195.88-.478 1.381-.802 1.706s-.826.607-1.706.802c-.898.2-2.091.288-3.704.288s-2.806-.088-3.704-.288c-.88-.195-1.381-.478-1.706-.802s-.606-.826-.802-1.706C1.588 10.806 1.5 9.613 1.5 8s.088-2.806.288-3.704M8 0C1.412 0 0 1.412 0 8s1.412 8 8 8 8-1.412 8-8-1.412-8-8-8"/><path d="M8.495 4.695a.75.75 0 0 0-.05 1.06L10.486 8l-2.041 2.246a.75.75 0 0 0 1.11 1.008l2.5-2.75a.75.75 0 0 0 0-1.008l-2.5-2.75a.75.75 0 0 0-1.06-.051m-4 0a.75.75 0 0 0-.05 1.06l2.044 2.248-1.796 1.995a.75.75 0 0 0 1.114 1.004l2.25-2.5a.75.75 0 0 0-.002-1.007l-2.5-2.75a.75.75 0 0 0-1.06-.05"/>
  </symbol>
  <symbol id="diffs-icon-symbol-ref" viewBox="0 0 16 16">
    <path d="M1.5 8c0 1.613.088 2.806.288 3.704.196.88.478 1.381.802 1.706.286.286.71.54 1.41.73V1.86c-.7.19-1.124.444-1.41.73-.324.325-.606.826-.802 1.706C1.588 5.194 1.5 6.387 1.5 8m4 6.397c.697.07 1.522.103 2.5.103 1.613 0 2.806-.088 3.704-.288.88-.195 1.381-.478 1.706-.802s.607-.826.802-1.706c.2-.898.288-2.091.288-3.704s-.088-2.806-.288-3.704c-.195-.88-.478-1.381-.802-1.706s-.826-.606-1.706-.802C10.806 1.588 9.613 1.5 8 1.5c-.978 0-1.803.033-2.5.103zM0 8c0-6.588 1.412-8 8-8s8 1.412 8 8-1.412 8-8 8-8-1.412-8-8m7-2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"/>
  </symbol>
</svg>`;


//#region src/utils/areLineAnnotationsEqual.ts
function $15bd6ef2dafde664$export$1ab29c66b6d99142(annotationA, annotationB) {
    return annotationA.lineNumber === annotationB.lineNumber && annotationA.metadata === annotationB.metadata;
}


//#region src/utils/arePrePropertiesEqual.ts
function $0f5986330d731e6d$export$732d2d41c8f0dbb(propsA, propsB) {
    if (propsA == null || propsB == null) return propsA === propsB;
    return $0f5986330d731e6d$var$areCustomPropertiesEqual(propsA.customProperties, propsB.customProperties) && propsA.type === propsB.type && propsA.diffIndicators === propsB.diffIndicators && propsA.disableBackground === propsB.disableBackground && propsA.disableLineNumbers === propsB.disableLineNumbers && propsA.overflow === propsB.overflow && propsA.split === propsB.split && propsA.totalLines === propsB.totalLines;
}
const $0f5986330d731e6d$var$EMPTY_CUSTOM_PROPERTIES = {};
function $0f5986330d731e6d$var$areCustomPropertiesEqual(customPropertiesA = $0f5986330d731e6d$var$EMPTY_CUSTOM_PROPERTIES, customPropertiesB = $0f5986330d731e6d$var$EMPTY_CUSTOM_PROPERTIES) {
    if (customPropertiesA === customPropertiesB) return true;
    const keysA = Object.keys(customPropertiesA);
    const keysB = Object.keys(customPropertiesB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA)if (customPropertiesA[key] !== customPropertiesB[key]) return false;
    return true;
}


//#region src/utils/createAnnotationWrapperNode.ts
function $c2c6bb2973b29e85$export$4b9f37d754cdceeb(slot) {
    const wrapper = document.createElement("div");
    wrapper.dataset.annotationSlot = "";
    wrapper.slot = slot;
    wrapper.style.whiteSpace = "normal";
    return wrapper;
}


//#region src/utils/createGutterUtilityContentNode.ts
function $b4d03e340999f061$export$9c2f722fd7aacea4() {
    const gutterUtilityContent = document.createElement("div");
    gutterUtilityContent.slot = "gutter-utility-slot";
    gutterUtilityContent.style.position = "absolute";
    gutterUtilityContent.style.top = "0";
    gutterUtilityContent.style.bottom = "0";
    gutterUtilityContent.style.textAlign = "center";
    gutterUtilityContent.style.whiteSpace = "normal";
    gutterUtilityContent.style.touchAction = "none";
    return gutterUtilityContent;
}



//#region src/utils/createUnsafeCSSStyleNode.ts
function $2b516b4212841f75$export$c520e3d3d812f648() {
    const node = document.createElement("style");
    node.setAttribute((0, $6986aac91971cc6d$export$26189492e726cd65), "");
    return node;
}



//#region src/utils/scrollbarGutter.ts
let $6c5a73e7fcb28098$var$measuredScrollbarGutter;
function $6c5a73e7fcb28098$export$c8735f53e6551891(shadowRoot) {
    if ($6c5a73e7fcb28098$var$measuredScrollbarGutter != null) return $6c5a73e7fcb28098$var$measuredScrollbarGutter;
    const host = shadowRoot.host;
    if (typeof HTMLElement !== "undefined" && host instanceof HTMLElement && !host.isConnected) return;
    const wrapper = document.createElement("div");
    wrapper.setAttribute("data-code", "");
    wrapper.setAttribute((0, $6986aac91971cc6d$export$a3a60f81190d4ebe), "true");
    const child = document.createElement("div");
    child.style.position = "relative";
    child.style.width = "200%";
    child.style.height = "200%";
    wrapper.appendChild(child);
    shadowRoot.appendChild(wrapper);
    $6c5a73e7fcb28098$var$measuredScrollbarGutter = Math.max(wrapper.offsetHeight - wrapper.clientHeight, 0);
    wrapper.remove();
    return $6c5a73e7fcb28098$var$measuredScrollbarGutter;
}
function $6c5a73e7fcb28098$export$86c6d0d7c11d6880(scrollbarGutter) {
    return `${0, $6986aac91971cc6d$export$de04582b73a6bf54}: ${scrollbarGutter == null ? "var(--diffs-scrollbar-gutter-fallback)" : `${scrollbarGutter}px`};`;
}



//#region src/style.css
var $ab5cc133a59d900d$export$2e2bcd8739ae039 = "@layer base,theme,rendered,unsafe;@layer base{:host{--diffs-font-fallback:\"SF Mono\", Monaco, Consolas, \"Ubuntu Mono\", \"Liberation Mono\", \"Courier New\", monospace;--diffs-header-font-fallback:system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif;--diffs-mixer:light-dark(#000,#fff);--diffs-gap-fallback:8px;--diffs-scrollbar-gutter-fallback:6px;--diffs-scrollbar-gutter:var(--diffs-scrollbar-gutter-override,var(--diffs-scrollbar-gutter-measured,var(--diffs-scrollbar-gutter-fallback)));--diffs-added-light:#0dbe4e;--diffs-added-dark:#5ecc71;--diffs-modified-light:#009fff;--diffs-modified-dark:#69b1ff;--diffs-deleted-light:#ff2e3f;--diffs-deleted-dark:#ff6762;color-scheme:light dark;font-family:var(--diffs-header-font-family,var(--diffs-header-font-fallback));font-size:var(--diffs-font-size,13px);line-height:var(--diffs-line-height,20px);font-feature-settings:var(--diffs-font-features);--diffs-bg:light-dark(var(--diffs-light-bg,#fff),var(--diffs-dark-bg,#000));--diffs-bg-buffer:var(--diffs-bg-buffer-override,light-dark(color-mix(in lab, var(--diffs-bg) 92%, var(--diffs-mixer)),color-mix(in lab, var(--diffs-bg) 92%, var(--diffs-mixer))));--diffs-bg-context:var(--diffs-bg-context-override,light-dark(color-mix(in lab, var(--diffs-bg) 98.5%, var(--diffs-mixer)),color-mix(in lab, var(--diffs-bg) 92.5%, var(--diffs-mixer))));--diffs-bg-context-gutter:var(--diffs-bg-context-gutter-override,light-dark(color-mix(in lab, var(--diffs-bg-context) 90%, var(--diffs-bg)),color-mix(in lab, var(--diffs-bg-context) 45%, var(--diffs-bg))));--diffs-bg-separator:var(--diffs-bg-separator-override,light-dark(color-mix(in lab, var(--diffs-bg) 96%, var(--diffs-mixer)),color-mix(in lab, var(--diffs-bg) 85%, var(--diffs-mixer))));--diffs-fg:light-dark(var(--diffs-light,#000),var(--diffs-dark,#fff));--diffs-fg-number:var(--diffs-fg-number-override,light-dark(color-mix(in lab, var(--diffs-fg) 65%, var(--diffs-bg)),color-mix(in lab, var(--diffs-fg) 65%, var(--diffs-bg))));--diffs-fg-conflict-marker:var(--diffs-fg-conflict-marker-override,var(--diffs-fg-number));--diffs-deletion-base:var(--diffs-deletion-color-override,light-dark(var(--diffs-light-deletion-color,var(--diffs-deletion-color,var(--diffs-deleted-light))),var(--diffs-dark-deletion-color,var(--diffs-deletion-color,var(--diffs-deleted-dark)))));--diffs-addition-base:var(--diffs-addition-color-override,light-dark(var(--diffs-light-addition-color,var(--diffs-addition-color,var(--diffs-added-light))),var(--diffs-dark-addition-color,var(--diffs-addition-color,var(--diffs-added-dark)))));--diffs-modified-base:var(--diffs-modified-color-override,light-dark(var(--diffs-light-modified-color,var(--diffs-modified-color,var(--diffs-modified-light))),var(--diffs-dark-modified-color,var(--diffs-modified-color,var(--diffs-modified-dark)))));--diffs-bg-deletion:var(--diffs-bg-deletion-override,light-dark(color-mix(in lab, var(--diffs-bg) 88%, var(--diffs-deletion-base)),color-mix(in lab, var(--diffs-bg) 80%, var(--diffs-deletion-base))));--diffs-bg-deletion-emphasis:var(--diffs-bg-deletion-emphasis-override,light-dark(rgb(from var(--diffs-deletion-base) r g b / .15),rgb(from var(--diffs-deletion-base) r g b / .2)));--diffs-bg-addition:var(--diffs-bg-addition-override,light-dark(color-mix(in lab, var(--diffs-bg) 88%, var(--diffs-addition-base)),color-mix(in lab, var(--diffs-bg) 80%, var(--diffs-addition-base))));--diffs-bg-addition-emphasis:var(--diffs-bg-addition-emphasis-override,light-dark(rgb(from var(--diffs-addition-base) r g b / .15),rgb(from var(--diffs-addition-base) r g b / .2)));--diffs-selection-base:var(--diffs-modified-base);--diffs-selection-number-fg:light-dark(color-mix(in lab, var(--diffs-selection-base) 65%, var(--diffs-mixer)),color-mix(in lab, var(--diffs-selection-base) 75%, var(--diffs-mixer)));background-color:var(--diffs-bg);color:var(--diffs-fg);display:block}pre,code,[data-error-wrapper]{isolation:isolate;font-family:var(--diffs-font-family,var(--diffs-font-fallback));outline:none;margin:0;padding:0;display:block}pre,code{background-color:var(--diffs-bg)}code{contain:content}*,:before,:after{box-sizing:border-box}[data-icon-sprite]{display:none}[data-diffs-header],[data-separator]{font-family:var(--diffs-header-font-family,var(--diffs-header-font-fallback))}[data-diffs-header][data-sticky]{z-index:1;background-color:var(--diffs-bg);position:sticky;top:0}[data-file-info]{color:var(--fg);background-color:color-mix(in lab, var(--bg) 98%, var(--fg));border-block:1px solid color-mix(in lab, var(--bg) 95%, var(--fg));padding:10px;font-weight:700}[data-diff],[data-file]{--diffs-grid-number-column-width:minmax(min-content, max-content);--diffs-code-grid:var(--diffs-grid-number-column-width) 1fr}[data-dehydrated]:is([data-diff],[data-file]){--diffs-code-grid:var(--diffs-grid-number-column-width) minmax(0, 1fr)}:is([data-diff],[data-file]):hover [data-code]::-webkit-scrollbar-thumb{background-color:var(--diffs-bg-context)}@supports (-webkit-touch-callout:none){:host{--diffs-scrollbar-gutter-fallback:0px}}[data-line] span{color:light-dark(var(--diffs-token-light,var(--diffs-light)),var(--diffs-token-dark,var(--diffs-dark)));background-color:light-dark(var(--diffs-token-light-bg,inherit),var(--diffs-token-dark-bg,inherit));font-weight:light-dark(var(--diffs-token-light-font-weight,inherit),var(--diffs-token-dark-font-weight,inherit));font-style:light-dark(var(--diffs-token-light-font-style,inherit),var(--diffs-token-dark-font-style,inherit));-webkit-text-decoration:light-dark(var(--diffs-token-light-text-decoration,inherit),var(--diffs-token-dark-text-decoration,inherit));text-decoration:light-dark(var(--diffs-token-light-text-decoration,inherit),var(--diffs-token-dark-text-decoration,inherit))}[data-line],[data-gutter-buffer],[data-column-number],[data-line-annotation],[data-no-newline],[data-merge-conflict],[data-merge-conflict-actions]{--diffs-computed-decoration-bg:var(--diffs-bg);--diffs-computed-diff-line-bg:var(--diffs-bg);--diffs-computed-selected-line-bg:var(--diffs-bg);color:var(--diffs-fg);background-color:var(--diffs-line-bg,var(--diffs-bg))}@media (pointer:fine){:is([data-line],[data-gutter-buffer],[data-column-number],[data-line-annotation],[data-no-newline],[data-merge-conflict],[data-merge-conflict-actions]):where([data-hovered]){--diffs-computed-hovered-line-bg:light-dark(color-mix(in lab, var(--diffs-computed-selected-line-bg) 97%, var(--diffs-bg-hover-override,var(--diffs-mixer))),color-mix(in lab, var(--diffs-computed-selected-line-bg) 91%, var(--diffs-bg-hover-override,var(--diffs-mixer))));--diffs-line-bg:var(--diffs-computed-hovered-line-bg,inherit)}}[data-decoration-bg]:is([data-line],[data-no-newline]){--mix-deco-light:92%;--mix-deco-dark:85%}[data-decoration-bg][data-decoration-bg-depth=\"2\"]:is([data-line],[data-no-newline]){--mix-deco-light:88%;--mix-deco-dark:80%}[data-decoration-bg][data-decoration-bg-depth=\"3\"]:is([data-line],[data-no-newline]){--mix-deco-light:85%;--mix-deco-dark:78%}@media (pointer:fine){[data-decoration-bg][data-hovered]:is([data-line],[data-no-newline]):not([data-selected-line]){--mix-deco-light:85%;--mix-deco-dark:85%}[data-decoration-bg][data-hovered][data-decoration-bg-depth=\"2\"]:is([data-line],[data-no-newline]):not([data-selected-line]){--mix-deco-light:83%;--mix-deco-dark:83%}[data-decoration-bg][data-hovered][data-decoration-bg-depth=\"3\"]:is([data-line],[data-no-newline]):not([data-selected-line]){--mix-deco-light:81%;--mix-deco-dark:81%}}[data-decoration-bg]:is([data-line],[data-no-newline]){--diffs-computed-decoration-bg:light-dark(color-mix(in lab, var(--diffs-bg) var(--mix-deco-light), var(--diffs-decoration-bg)),color-mix(in lab, var(--diffs-bg) var(--mix-deco-dark), var(--diffs-decoration-bg)));--diffs-computed-diff-line-bg:var(--diffs-computed-decoration-bg);--diffs-computed-selected-line-bg:var(--diffs-computed-decoration-bg);--diffs-line-bg:var(--diffs-computed-decoration-bg)}[data-line-annotation],[data-gutter-buffer=annotation]{--diffs-annotation-bg:var(--diffs-bg-context);--diffs-computed-decoration-bg:var(--diffs-annotation-bg);--diffs-computed-diff-line-bg:var(--diffs-annotation-bg);--diffs-computed-selected-line-bg:var(--diffs-annotation-bg);--diffs-line-bg:var(--diffs-annotation-bg)}[data-merge-conflict-actions],[data-gutter-buffer=merge-conflict-action],[data-gutter-buffer=merge-conflict-marker-base],[data-gutter-buffer=merge-conflict-marker-separator],[data-merge-conflict=marker-base],[data-merge-conflict=marker-separator]{--diffs-computed-decoration-bg:var(--diffs-bg-context);--diffs-computed-diff-line-bg:var(--diffs-bg-context);--diffs-computed-selected-line-bg:var(--diffs-bg-context);--diffs-line-bg:var(--diffs-bg-context)}[data-gutter-buffer=merge-conflict-marker-start],[data-merge-conflict=marker-start]{--diffs-computed-decoration-bg:light-dark(color-mix(in lab, var(--diffs-bg) 78%, var(--conflict-bg-current-header-override,var(--diffs-addition-base))),color-mix(in lab, var(--diffs-bg) 68%, var(--conflict-bg-current-header-override,var(--diffs-addition-base))));--diffs-computed-diff-line-bg:var(--diffs-computed-decoration-bg);--diffs-computed-selected-line-bg:var(--diffs-computed-decoration-bg);--diffs-line-bg:var(--diffs-computed-decoration-bg)}[data-gutter-buffer=merge-conflict-marker-end],[data-merge-conflict=marker-end]{--diffs-computed-decoration-bg:light-dark(color-mix(in lab, var(--diffs-bg) 78%, var(--conflict-bg-incoming-header-override,var(--diffs-modified-base))),color-mix(in lab, var(--diffs-bg) 68%, var(--conflict-bg-incoming-header-override,var(--diffs-modified-base))));--diffs-computed-diff-line-bg:var(--diffs-computed-decoration-bg);--diffs-computed-selected-line-bg:var(--diffs-computed-decoration-bg);--diffs-line-bg:var(--diffs-computed-decoration-bg)}[data-has-merge-conflict] [data-line-annotation],[data-has-merge-conflict] [data-gutter-buffer=annotation]{--diffs-computed-decoration-bg:var(--diffs-bg);--diffs-computed-diff-line-bg:var(--diffs-bg);--diffs-computed-selected-line-bg:var(--diffs-bg);--diffs-line-bg:var(--diffs-bg)}:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number]{--mix-light:91%;--mix-dark:85%}:where([data-background]) [data-line],:where([data-background]) [data-no-newline]{--mix-light:88%;--mix-dark:80%}:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]{--diffs-diff-line-mix-target:var(--diffs-bg)}[data-line-type=change-deletion]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-diff-line-mix-target:var(--diffs-bg-deletion-override,var(--diffs-deletion-base))}@media (pointer:fine){[data-line-type=change-deletion][data-hovered]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--mix-light:80%;--mix-dark:75%}}[data-line-type=change-deletion]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]):where([data-gutter-buffer],[data-column-number]){color:var(--diffs-fg-number-deletion-override,var(--diffs-deletion-base));--diffs-diff-line-mix-target:var(--diffs-bg-deletion-number-override,var(--diffs-deletion-base))}[data-line-type=change-deletion]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-computed-diff-line-bg:light-dark(color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-light), var(--diffs-diff-line-mix-target)),color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-dark), var(--diffs-diff-line-mix-target)));--diffs-computed-selected-line-bg:var(--diffs-computed-diff-line-bg);--diffs-line-bg:var(--diffs-computed-diff-line-bg,inherit)}[data-line-type=change-addition]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-diff-line-mix-target:var(--diffs-bg-addition-override,var(--diffs-addition-base))}@media (pointer:fine){[data-line-type=change-addition][data-hovered]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--mix-light:80%;--mix-dark:70%}}[data-line-type=change-addition]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]):where([data-gutter-buffer],[data-column-number]){color:var(--diffs-fg-number-addition-override,var(--diffs-addition-base));--diffs-diff-line-mix-target:var(--diffs-bg-addition-number-override,var(--diffs-addition-base))}[data-line-type=change-addition]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-computed-diff-line-bg:light-dark(color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-light), var(--diffs-diff-line-mix-target)),color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-dark), var(--diffs-diff-line-mix-target)));--diffs-computed-selected-line-bg:var(--diffs-computed-diff-line-bg);--diffs-line-bg:var(--diffs-computed-diff-line-bg,inherit)}[data-merge-conflict=current]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-diff-line-mix-target:var(--conflict-bg-current-override,var(--diffs-addition-base))}[data-merge-conflict=current]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]):where([data-gutter-buffer],[data-column-number]){color:var(--diffs-fg-number-addition-override,var(--diffs-addition-base));--diffs-diff-line-mix-target:var(--conflict-bg-current-number-override,var(--diffs-addition-base))}@media (pointer:fine){[data-merge-conflict=current][data-hovered]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--mix-light:80%;--mix-dark:70%}}[data-merge-conflict=current]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-computed-diff-line-bg:light-dark(color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-light), var(--diffs-diff-line-mix-target)),color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-dark), var(--diffs-diff-line-mix-target)));--diffs-computed-selected-line-bg:var(--diffs-computed-diff-line-bg);--diffs-line-bg:var(--diffs-computed-diff-line-bg,inherit)}[data-merge-conflict=incoming]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-diff-line-mix-target:var(--conflict-bg-incoming-override,var(--diffs-modified-base))}[data-merge-conflict=incoming]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]):where([data-gutter-buffer],[data-column-number]){color:var(--diffs-modified-base);--diffs-diff-line-mix-target:var(--conflict-bg-incoming-number-override,var(--diffs-modified-base))}@media (pointer:fine){[data-merge-conflict=incoming][data-hovered]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--mix-light:80%;--mix-dark:70%}}[data-merge-conflict=incoming]:is(:where([data-background]) [data-gutter-buffer],:where([data-background]) [data-column-number],:where([data-background]) [data-line],:where([data-background]) [data-no-newline]){--diffs-computed-diff-line-bg:light-dark(color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-light), var(--diffs-diff-line-mix-target)),color-mix(in lab, var(--diffs-computed-decoration-bg) var(--mix-dark), var(--diffs-diff-line-mix-target)));--diffs-computed-selected-line-bg:var(--diffs-computed-diff-line-bg);--diffs-line-bg:var(--diffs-computed-diff-line-bg,inherit)}[data-gutter-buffer],[data-column-number],[data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]{--diffs-selection-mix-target:var(--diffs-bg-selection-override,var(--diffs-selection-base))}[data-selected-line]:is([data-gutter-buffer],[data-column-number],[data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]):where([data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]){--mix-selection-light:82%;--mix-selection-dark:75%}@media (pointer:fine){[data-selected-line][data-hovered]:is([data-gutter-buffer],[data-column-number],[data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]):where([data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]):not([data-merge-conflict],[data-line-type=change-addition],[data-line-type=change-deletion]){--mix-selection-light:75%;--mix-selection-dark:70%}}[data-selected-line]:is([data-gutter-buffer],[data-column-number],[data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]):where([data-gutter-buffer],[data-column-number]){--mix-selection-light:75%;--mix-selection-dark:60%;--diffs-selection-mix-target:var(--diffs-bg-selection-number-override,var(--diffs-selection-base))}@media (pointer:fine){[data-selected-line][data-hovered]:is([data-gutter-buffer],[data-column-number],[data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]):where([data-gutter-buffer],[data-column-number]):not([data-merge-conflict],[data-line-type=change-addition],[data-line-type=change-deletion]){--mix-selection-light:70%;--mix-selection-dark:55%}}[data-selected-line]:is([data-gutter-buffer],[data-column-number],[data-line],[data-line-annotation],[data-merge-conflict],[data-merge-conflict-actions],[data-no-newline]){--diffs-computed-selected-line-bg:light-dark(color-mix(in lab, var(--diffs-computed-diff-line-bg) var(--mix-selection-light), var(--diffs-selection-mix-target)),color-mix(in lab, var(--diffs-computed-diff-line-bg) var(--mix-selection-dark), var(--diffs-selection-mix-target)));--diffs-line-bg:var(--diffs-computed-selected-line-bg,inherit)}[data-selected-line]:is([data-gutter-buffer],[data-column-number]){color:var(--diffs-selection-number-fg)}[data-no-newline]{-webkit-user-select:none;user-select:none}[data-no-newline] span{opacity:.6}[data-diff-type=split][data-overflow=scroll]{grid-template-columns:1fr 1fr;display:grid}[data-diff-type=split][data-overflow=scroll] [data-additions]{border-left:1px solid var(--diffs-bg)}[data-diff-type=split][data-overflow=scroll] [data-deletions]{border-right:1px solid var(--diffs-bg)}[data-code]{grid-auto-flow:dense;grid-template-columns:var(--diffs-code-grid);overflow:var(--diffs-overflow-override,scroll) clip;overscroll-behavior-x:none;tab-size:var(--diffs-tab-size,2);padding-top:var(--diffs-gap-block,var(--diffs-gap-fallback));padding-bottom:max(0px, calc(var(--diffs-gap-block,var(--diffs-gap-fallback)) - var(--diffs-scrollbar-gutter)));scrollbar-gutter:stable;align-self:flex-start;display:grid}[data-diffs-scrollbar-measure]{opacity:0;pointer-events:none;scrollbar-gutter:auto;grid-template-columns:none;width:100px;height:100px;padding:0;position:absolute;top:-200px;left:-200px}[data-container-size]{container-type:inline-size}[data-code]::-webkit-scrollbar{width:0;height:var(--diffs-scrollbar-gutter)}[data-code]::-webkit-scrollbar-track{background:0 0}[data-code]::-webkit-scrollbar-thumb{background-color:#0000;background-clip:content-box;border:1px solid #0000;border-radius:3px}[data-code]::-webkit-scrollbar-corner{background-color:#0000}@supports ((-moz-appearance:none)){[data-code]{scrollbar-width:thin;scrollbar-color:var(--diffs-bg-context) transparent;padding-bottom:var(--diffs-gap-block,var(--diffs-gap-fallback))}}:is([data-diffs-header]~[data-diff],[data-diffs-header]~[data-file]) [data-code],[data-overflow=wrap]:is([data-diffs-header]~[data-diff],[data-diffs-header]~[data-file]){padding-top:0}[data-gutter]{grid-template-rows:subgrid;grid-template-columns:subgrid;z-index:3;background-color:var(--diffs-bg);grid-column:1;display:grid;position:relative}[data-gutter] [data-gutter-buffer],[data-gutter] [data-column-number]{border-right:var(--diffs-gap-style,2px solid var(--diffs-bg))}[data-content]{grid-template-rows:subgrid;grid-template-columns:subgrid;background-color:var(--diffs-bg);grid-column:2;min-width:0;display:grid}[data-diff-type=split][data-overflow=wrap]{grid-auto-flow:dense;grid-template-columns:repeat(2, var(--diffs-code-grid));padding-block:var(--diffs-gap-block,var(--diffs-gap-fallback));display:grid}[data-diff-type=split][data-overflow=wrap] [data-deletions]{display:contents}:is([data-diff-type=split][data-overflow=wrap] [data-deletions]) [data-gutter]{grid-column:1}:is([data-diff-type=split][data-overflow=wrap] [data-deletions]) [data-content]{border-right:1px solid var(--diffs-bg);grid-column:2}[data-diff-type=split][data-overflow=wrap] [data-additions]{display:contents}:is([data-diff-type=split][data-overflow=wrap] [data-additions]) [data-gutter]{border-left:1px solid var(--diffs-bg);grid-column:3}:is([data-diff-type=split][data-overflow=wrap] [data-additions]) [data-content]{grid-column:4}[data-overflow=scroll] [data-gutter]{position:sticky;left:0}[data-interactive-lines] [data-line]{cursor:pointer}[data-interactive-line-numbers] [data-column-number]{cursor:pointer;touch-action:none}[data-content-buffer],[data-gutter-buffer]{-webkit-user-select:none;user-select:none;min-height:1lh;position:relative}[data-gutter-buffer]{padding-left:2ch;padding-right:1ch}[data-gutter-buffer]:before{content:\"\";min-width:var(--diffs-min-number-column-width,var(--diffs-min-number-column-width-default,3ch));display:block}[data-gutter-buffer=annotation]{--diffs-annotation-bg:var(--diffs-bg-context-gutter);min-height:0}[data-gutter-buffer=buffer]{--diffs-line-bg:var(--diffs-bg-context-gutter)}[data-content-buffer]{background-position:5px 0;background-size:8px 8px;background-origin:border-box;background-image:repeating-linear-gradient(-45deg, transparent, transparent 4.242px, var(--diffs-bg-buffer) 4.242px, var(--diffs-bg-buffer) 5.656px);grid-column:1}[data-separator]{box-sizing:content-box;background-color:var(--diffs-bg)}[data-separator=simple]{min-height:4px}[data-separator=line-info],[data-separator=line-info-basic],[data-separator=metadata],[data-separator=simple]{background-color:var(--diffs-bg-separator)}[data-separator=line-info],[data-separator=line-info-basic],[data-separator=metadata]{height:32px;position:relative}[data-separator-wrapper]{-webkit-user-select:none;user-select:none;fill:currentColor;background-color:var(--diffs-bg);align-items:center;height:100%;display:flex;position:absolute;inset-inline:0}[data-content] [data-separator-wrapper]{display:none}[data-separator=metadata] [data-separator-wrapper]{background-color:var(--diffs-bg-separator);height:100%;color:var(--diffs-fg-number);white-space:nowrap;text-overflow:ellipsis;min-width:min-content;padding-inline:1ch;inset-inline:100% auto;overflow:hidden}[data-separator=line-info]{margin-block:var(--diffs-gap-block,var(--diffs-gap-fallback))}[data-separator=line-info] [data-separator-wrapper]{min-width:16px}[data-separator=line-info-basic],[data-separator=metadata]{margin-block:0}[data-separator=line-info][data-separator-first]{margin-top:0}[data-separator=line-info][data-separator-last]{margin-bottom:0}[data-expand-index] [data-separator-wrapper]{grid-template-columns:32px auto;display:grid}[data-expand-index] [data-separator-wrapper][data-separator-multi-button]{grid-template-columns:32px 32px auto}[data-expand-button],[data-separator-content]{background-color:var(--diffs-bg-separator);flex:none;align-items:center;display:flex}[data-expand-index] [data-separator-content]:hover{cursor:pointer;text-decoration:underline}[data-expand-button]{cursor:pointer;min-width:32px;color:var(--diffs-fg-number);border-right:2px solid var(--diffs-bg);flex-shrink:0;justify-content:center;align-self:stretch}[data-expand-button]:hover{color:var(--diffs-fg)}[data-expand-button][data-expand-all-button]{display:none}[data-expand-down] [data-icon]{transform:scaleY(-1)}[data-separator-content]{height:100%;color:var(--diffs-fg-number);flex:auto;justify-content:flex-start;padding:0 1ch;overflow:hidden}:is([data-separator=line-info],[data-separator=line-info-basic]) [data-separator-content]{-webkit-user-select:none;user-select:none;height:100%;overflow:clip}[data-unmodified-lines]{text-overflow:ellipsis;white-space:nowrap;flex:0 auto;min-width:0;display:block;overflow:hidden}@supports (width:1cqi){[data-unified] [data-separator=line-info] [data-separator-wrapper]{padding-inline:var(--diffs-gap-inline,var(--diffs-gap-fallback));width:100cqi}:is([data-unified] [data-separator=line-info] [data-separator-wrapper]) [data-separator-content]{border-radius:6px}[data-unified] [data-separator=line-info][data-expand-index] [data-separator-wrapper] [data-separator-content]{border-top-left-radius:unset;border-bottom-left-radius:unset}[data-gutter] [data-separator=line-info] [data-separator-wrapper]{padding-left:var(--diffs-gap-inline,var(--diffs-gap-fallback))}[data-gutter] [data-separator=line-info] [data-separator-content]{border-top-left-radius:6px;border-bottom-left-radius:6px}[data-gutter] [data-separator=line-info][data-expand-index] [data-separator-content]{border-top-left-radius:unset;border-bottom-left-radius:unset}[data-additions] [data-content] [data-separator=line-info]{background-color:var(--diffs-bg)}:is([data-additions] [data-content] [data-separator=line-info]) [data-separator-wrapper]{display:none}[data-additions] [data-gutter] [data-separator=line-info] [data-separator-wrapper]{background-color:var(--diffs-bg-separator);border-top-right-radius:6px;border-bottom-right-radius:6px;height:100%;display:block}:is([data-additions] [data-gutter] [data-separator=line-info] [data-separator-wrapper]) [data-separator-content],:is([data-additions] [data-gutter] [data-separator=line-info] [data-separator-wrapper]) [data-expand-button]{display:none}[data-overflow=scroll] [data-additions] [data-gutter] [data-separator=line-info] [data-separator-wrapper]{width:calc(100cqi - var(--diffs-gap-inline,var(--diffs-gap-fallback)))}[data-overflow=wrap] [data-additions] [data-content] [data-separator=line-info] [data-separator-wrapper]{background-color:var(--diffs-bg-separator);height:100%;margin-right:var(--diffs-gap-inline,var(--diffs-gap-fallback));border-top-right-radius:6px;border-bottom-right-radius:6px;display:block}:is([data-overflow=wrap] [data-additions] [data-content] [data-separator=line-info] [data-separator-wrapper]) [data-separator-content],:is([data-overflow=wrap] [data-additions] [data-content] [data-separator=line-info] [data-separator-wrapper]) [data-expand-button]{display:none}:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-both],:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-down],:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-up]{border-top-left-radius:6px;border-bottom-left-radius:6px}@media (pointer:fine){[data-separator-multi-button]:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-up]{border-top-left-radius:6px;border-bottom-left-radius:unset}[data-separator-multi-button]:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-down]{border-bottom-left-radius:6px;border-top-left-radius:unset}}}@media (pointer:coarse){[data-separator=line-info-basic] [data-separator-wrapper][data-separator-multi-button]{grid-template-columns:34px 34px auto}:is([data-separator=line-info-basic] [data-separator-wrapper][data-separator-multi-button]) [data-separator-content]{grid-column:unset;grid-row:unset}@supports (width:1cqi){:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-both],:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-down],:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-up],[data-separator-multi-button]:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-up]{border-top-left-radius:6px;border-bottom-left-radius:6px}[data-separator-multi-button]:is([data-separator=line-info] [data-separator-wrapper]) [data-expand-down]{border-bottom-left-radius:unset;border-top-left-radius:unset}}}@media (pointer:fine){[data-separator-wrapper][data-separator-multi-button]{grid-template-rows:50% 50%;display:grid}[data-separator-wrapper][data-separator-multi-button] [data-separator-content]{grid-area:1/2/-1;min-width:min-content}[data-separator-wrapper][data-separator-multi-button] [data-expand-button]{grid-column:1}[data-separator=line-info] [data-separator-wrapper],[data-separator=line-info] [data-separator-wrapper][data-separator-multi-button]{grid-template-columns:34px auto}[data-separator=line-info-basic][data-expand-index] [data-separator-wrapper]{grid-template-columns:100% auto}:is(:is([data-separator=line-info],[data-separator=line-info-basic]) [data-separator-multi-button]) [data-expand-up]{border-bottom:1px solid var(--diffs-bg);border-right:2px solid var(--diffs-bg)}:is(:is([data-separator=line-info],[data-separator=line-info-basic]) [data-separator-multi-button]) [data-expand-down]{border-top:1px solid var(--diffs-bg);border-right:2px solid var(--diffs-bg)}}[data-additions] [data-gutter] [data-separator-wrapper],[data-additions] [data-separator=line-info-basic] [data-separator-wrapper],[data-content] [data-separator-wrapper]{display:none}[data-line-annotation]{min-height:var(--diffs-annotation-min-height,0);z-index:2}[data-merge-conflict-actions]{z-index:2}[data-separator=custom]{grid-template-columns:subgrid;display:grid}[data-line],[data-column-number],[data-no-newline]{padding-inline:1ch;position:relative}[data-indicators=classic] [data-line]{padding-inline-start:2ch}:is([data-no-newline]:is([data-indicators=classic] [data-line-type=change-addition],[data-indicators=classic] [data-line-type=change-deletion]),[data-line]:is([data-indicators=classic] [data-line-type=change-addition],[data-indicators=classic] [data-line-type=change-deletion])):before{-webkit-user-select:none;user-select:none;width:1ch;height:1lh;display:inline-block;position:absolute;top:0;left:0}:is([data-line]:is([data-indicators=classic] [data-line-type=change-addition]),[data-no-newline]:is([data-indicators=classic] [data-line-type=change-addition])):before{content:\"+\";color:var(--diffs-addition-base)}:is([data-line]:is([data-indicators=classic] [data-line-type=change-deletion]),[data-no-newline]:is([data-indicators=classic] [data-line-type=change-deletion])):before{content:\"-\";color:var(--diffs-deletion-base)}[data-column-number]:is([data-indicators=bars] [data-line-type=change-deletion],[data-indicators=bars] [data-line-type=change-addition]):before{content:\"\";-webkit-user-select:none;user-select:none;contain:strict;width:4px;height:100%;display:block;position:absolute;top:0;left:0}[data-column-number]:is([data-indicators=bars] [data-line-type=change-deletion]):before{background-image:linear-gradient(0deg, var(--diffs-bg-deletion) 50%, var(--diffs-deletion-base) 50%);background-repeat:repeat;background-size:2px 2px;background-size:calc(1lh/round(1lh / 2px)) calc(1lh/round(1lh / 2px))}[data-column-number]:is([data-indicators=bars] [data-line-type=change-addition]):before{background-color:var(--diffs-addition-base)}[data-overflow=wrap] [data-line],[data-overflow=wrap] [data-annotation-content]{white-space:pre-wrap;word-break:break-word}[data-overflow=scroll] [data-line]{white-space:pre;min-height:1lh}[data-column-number]{box-sizing:content-box;text-align:right;-webkit-user-select:none;user-select:none;color:var(--diffs-fg-number);padding-left:2ch}[data-line-number-content]{min-width:var(--diffs-min-number-column-width,var(--diffs-min-number-column-width-default,3ch));z-index:1;display:inline-block;position:relative}[data-disable-line-numbers] [data-gutter-buffer],[data-disable-line-numbers] [data-column-number]{min-width:4px;padding:0}:is([data-disable-line-numbers] [data-gutter-buffer],[data-disable-line-numbers] [data-column-number]):before{min-width:0}[data-disable-line-numbers] [data-line-number-content]{display:none}[data-disable-line-numbers] [data-gutter-utility-slot]{right:unset;justify-content:flex-start;left:0}[data-disable-line-numbers][data-indicators=bars] [data-gutter-utility-slot]{left:6px}[data-file][data-disable-line-numbers] [data-gutter-buffer],[data-file][data-disable-line-numbers] [data-column-number]{border-right:0;min-width:0}[data-diff-span]{-webkit-box-decoration-break:clone;box-decoration-break:clone;border-radius:3px}[data-line-type=change-addition] [data-diff-span]{background-color:var(--diffs-bg-addition-emphasis)}[data-line-type=change-deletion] [data-diff-span]{background-color:var(--diffs-bg-deletion-emphasis)}[data-merge-conflict=marker-start],[data-merge-conflict=marker-base],[data-merge-conflict=marker-separator],[data-merge-conflict=marker-end]{color:var(--diffs-fg);padding-left:1ch}[data-merge-conflict=marker-start],[data-merge-conflict=marker-end]{align-items:center;display:flex}:is([data-merge-conflict=marker-start],[data-merge-conflict=marker-end]):after{color:var(--diffs-fg-conflict-marker);font-size:.75rem;font-style:normal;line-height:1.25rem;font-family:var(--diffs-header-font-family,var(--diffs-header-font-fallback));padding-left:1ch}[data-merge-conflict=marker-start]:after{content:\"(Current Change)\"}[data-merge-conflict=marker-end]:after{content:\"(Incoming Change)\"}[data-merge-conflict-actions-content]{min-height:1.75rem;font-family:var(--diffs-header-font-family,var(--diffs-header-font-fallback));color:var(--diffs-fg);align-items:center;gap:.25rem;padding-inline:.5rem;font-size:.75rem;line-height:1.2;display:flex}[data-merge-conflict-action]{appearance:none;color:var(--diffs-fg-number);font:inherit;cursor:pointer;background:0 0;border:0;padding:0;font-style:normal}[data-merge-conflict-action]:hover{color:var(--diffs-fg)}[data-merge-conflict-action=current]:hover{color:var(--diffs-addition-base)}[data-merge-conflict-action=incoming]:hover{color:var(--diffs-modified-base)}[data-merge-conflict-action-separator]{color:var(--diffs-fg-number);opacity:.6;-webkit-user-select:none;user-select:none}[data-diffs-header=default]{background-color:var(--diffs-bg);justify-content:space-between;align-items:center;gap:var(--diffs-gap-inline,var(--diffs-gap-fallback));min-height:calc(1lh + var(--diffs-gap-block,var(--diffs-gap-fallback))*3);z-index:2;flex-direction:row;padding-inline:16px;display:flex;position:relative;top:0}[data-header-content]{align-items:center;gap:var(--diffs-gap-inline,var(--diffs-gap-fallback));white-space:nowrap;flex-direction:row;min-width:0;display:flex}[data-header-content] [data-prev-name],[data-header-content] [data-title]{text-overflow:ellipsis;white-space:nowrap;direction:rtl;min-width:0;overflow:hidden}[data-prev-name]{opacity:.7}[data-rename-icon]{fill:currentColor;flex-grow:0;flex-shrink:0}[data-diffs-header=default] [data-metadata]{white-space:nowrap;align-items:center;gap:1ch;display:flex}[data-diffs-header=default] [data-additions-count]{font-family:var(--diffs-font-family,var(--diffs-font-fallback));color:var(--diffs-addition-base)}[data-diffs-header=default] [data-deletions-count]{font-family:var(--diffs-font-family,var(--diffs-font-fallback));color:var(--diffs-deletion-base)}[data-change-icon]{fill:currentColor;flex-shrink:0}[data-change-icon=change],[data-change-icon=rename-pure],[data-change-icon=rename-changed]{color:var(--diffs-modified-base)}[data-change-icon=new]{color:var(--diffs-addition-base)}[data-change-icon=deleted]{color:var(--diffs-deletion-base)}[data-change-icon=file]{opacity:.6}[data-annotation-content]{z-index:2;isolation:isolate;align-self:flex-start;min-width:0;display:flow-root;position:relative}[data-overflow=scroll] [data-annotation-content],[data-overflow=scroll] [data-merge-conflict-actions-content]{width:var(--diffs-column-content-width,auto);left:var(--diffs-column-number-width,0);position:sticky}[data-annotation-slot]{text-wrap-mode:wrap;word-break:normal;white-space-collapse:collapse}[data-gutter-utility-slot]{touch-action:none;justify-content:flex-end;display:flex;position:absolute;top:0;bottom:0;right:0}[data-utility-button]{appearance:none;cursor:pointer;width:1lh;height:1lh;font-size:var(--diffs-font-size,13px);line-height:var(--diffs-line-height,20px);background-color:var(--diffs-modified-base);color:var(--diffs-bg);fill:currentColor;z-index:4;touch-action:none;border:none;border-radius:4px;justify-content:center;align-items:center;margin-right:calc(1ch - 1lh);padding:0;display:flex;position:relative}[data-utility-button]:before{content:\"\";display:block;position:absolute;inset:0 0 0 -4px}[data-decoration-bar-stack]{pointer-events:none;isolation:isolate;z-index:1;background-color:var(--diffs-decoration-bar-color,transparent);box-sizing:content-box;border-left:2px solid var(--diffs-bg);border-right:2px solid var(--diffs-bg);width:6px;position:absolute;top:0;bottom:0;right:-2px}[data-decoration-bar-depth=\"1\"] [data-decoration-bar-stack]{background-color:color-mix(in lab, var(--diffs-bg) 20%, var(--diffs-decoration-bar-color,transparent))}[data-decoration-bar-depth=\"2\"] [data-decoration-bar-stack]{background-color:color-mix(in lab, var(--diffs-bg) 45%, var(--diffs-decoration-bar-color,transparent))}[data-decoration-bar-depth=\"3\"] [data-decoration-bar-stack]{background-color:color-mix(in lab, var(--diffs-bg) 65%, var(--diffs-decoration-bar-color,transparent))}[data-decoration-bar-start] [data-decoration-bar-stack]{border-top-left-radius:5px;border-top-right-radius:5px}[data-decoration-bar-end] [data-decoration-bar-stack]{z-index:3;border-bottom-right-radius:5px;border-bottom-left-radius:5px}[data-placeholder]{contain:strict}[data-error-wrapper]{padding:var(--diffs-gap-block,var(--diffs-gap-fallback)) var(--diffs-gap-inline,var(--diffs-gap-fallback));scrollbar-width:none;max-height:400px;overflow:auto}[data-error-wrapper] [data-error-message]{color:var(--diffs-deletion-base);font-size:18px;font-weight:700}[data-error-wrapper] [data-error-stack]{color:var(--diffs-fg-number)}}@layer theme,rendered,unsafe;";



//#region src/utils/cssWrappers.ts
const $001f0bd23af5fd92$var$LAYER_ORDER = `@layer base, theme, rendered, unsafe;`;
const $001f0bd23af5fd92$var$SCROLLBAR_GUTTER_DECLARATION_PATTERN = /* @__PURE__ */ new RegExp(`${$001f0bd23af5fd92$var$escapeRegExp((0, $6986aac91971cc6d$export$de04582b73a6bf54))}\\s*:\\s*[^;]+;`);
function $001f0bd23af5fd92$export$4cef9b3a5f74297a(mainCSS) {
    return `${$001f0bd23af5fd92$var$LAYER_ORDER}
${0, $ab5cc133a59d900d$export$2e2bcd8739ae039}
@layer theme {
  ${mainCSS}
}`;
}
function $001f0bd23af5fd92$export$bf3957559e751562(unsafeCSS) {
    return `${$001f0bd23af5fd92$var$LAYER_ORDER}
@layer unsafe {
  ${unsafeCSS}
}`;
}
function $001f0bd23af5fd92$export$c514b17fd29d7d29(themeCSS, themeType = "system", scrollbarGutter) {
    return `${$001f0bd23af5fd92$var$LAYER_ORDER}
@layer rendered {
  :host {${themeType === "system" ? "" : `
  color-scheme: ${themeType};`}
  ${(0, $6c5a73e7fcb28098$export$86c6d0d7c11d6880)(scrollbarGutter)}
  ${themeCSS}
  }
}`;
}
function $001f0bd23af5fd92$export$bfd64041029ebdb4(themeCSS, scrollbarGutter) {
    const scrollbarGutterRule = (0, $6c5a73e7fcb28098$export$86c6d0d7c11d6880)(scrollbarGutter);
    return themeCSS.replace($001f0bd23af5fd92$var$SCROLLBAR_GUTTER_DECLARATION_PATTERN, scrollbarGutterRule);
}
function $001f0bd23af5fd92$var$escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}


//#region src/utils/getOrCreateCodeNode.ts
function $1f97c906c36c90b4$export$e74beb130200ec1d({ code: code, pre: pre, columnType: columnType, rowSpan: rowSpan, containerSize: containerSize = false } = {}) {
    if (code == null) {
        code = document.createElement("code");
        code.setAttribute("data-code", "");
        if (columnType != null) code.setAttribute(`data-${columnType}`, "");
        pre?.appendChild(code);
    }
    if (rowSpan != null) code.style.setProperty("grid-row", `span ${rowSpan}`);
    else code.style.removeProperty("grid-row");
    if (containerSize) code.setAttribute("data-container-size", "");
    else code.removeAttribute("data-container-size");
    return code;
}



//#region src/utils/hostTheme.ts
function $56283d44ece37dbc$export$a0a7f1f190c55d90({ shadowRoot: shadowRoot, currentNode: currentNode, themeCSS: themeCSS }) {
    if (themeCSS.trim() === "") {
        currentNode?.remove();
        return;
    }
    currentNode ??= $56283d44ece37dbc$export$80aa154b4ce43a6d();
    currentNode.textContent = themeCSS;
    if (currentNode.parentNode !== shadowRoot) shadowRoot.appendChild(currentNode);
    return currentNode;
}
function $56283d44ece37dbc$export$80aa154b4ce43a6d() {
    const node = document.createElement("style");
    node.setAttribute((0, $6986aac91971cc6d$export$4ce037b01ed1780d), "");
    return node;
}


//#region src/utils/prerenderHTMLIfNecessary.ts
function $7951d831173cd21c$export$2793dc7c568f39d4(element, html) {
    if (html == null) return;
    const shadowRoot = element.shadowRoot ?? element.attachShadow({
        mode: "open"
    });
    if (shadowRoot.innerHTML === "") shadowRoot.innerHTML = html;
}


//#region src/utils/setWrapperNodeProps.ts
function $c1b1c6b8488e516b$export$fcea31ce4b8860ec(pre, { type: type, diffIndicators: diffIndicators, disableBackground: disableBackground, disableLineNumbers: disableLineNumbers, overflow: overflow, split: split, totalLines: totalLines, customProperties: customProperties }) {
    if (customProperties != null) for(const key in customProperties){
        const value = customProperties[key];
        if (value != null) pre.setAttribute(key, `${value}`);
    }
    if (type === "diff") {
        pre.setAttribute("data-diff", "");
        pre.removeAttribute("data-file");
    } else {
        pre.setAttribute("data-file", "");
        pre.removeAttribute("data-diff");
    }
    switch(diffIndicators){
        case "bars":
        case "classic":
            pre.setAttribute("data-indicators", diffIndicators);
            break;
        case "none":
            pre.removeAttribute("data-indicators");
            break;
    }
    if (disableLineNumbers) pre.setAttribute("data-disable-line-numbers", "");
    else pre.removeAttribute("data-disable-line-numbers");
    if (disableBackground) pre.removeAttribute("data-background");
    else pre.setAttribute("data-background", "");
    if (type === "diff") pre.setAttribute("data-diff-type", split ? "split" : "single");
    else pre.removeAttribute("data-diff-type");
    pre.setAttribute("data-overflow", overflow);
    pre.tabIndex = 0;
    pre.style.setProperty("--diffs-min-number-column-width-default", `${`${totalLines}`.length}ch`);
    return pre;
}





//#region src/components/web-components.ts
if (typeof HTMLElement !== "undefined" && customElements.get((0, $6986aac91971cc6d$export$b583bc7fc1f35cf2)) == null) {
    let sheet;
    class FileDiffContainer extends HTMLElement {
        constructor(){
            super();
            if (this.shadowRoot != null) return;
            const shadowRoot = this.attachShadow({
                mode: "open"
            });
            if (sheet == null) {
                sheet = new CSSStyleSheet();
                sheet.replaceSync((0, $ab5cc133a59d900d$export$2e2bcd8739ae039));
            }
            shadowRoot.adoptedStyleSheets = [
                sheet
            ];
        }
        connectedCallback() {
            (0, $6c5a73e7fcb28098$export$c8735f53e6551891)(this.shadowRoot ?? this.attachShadow({
                mode: "open"
            }));
        }
    }
    customElements.define((0, $6986aac91971cc6d$export$b583bc7fc1f35cf2), FileDiffContainer);
}
const $7b74b50028a59173$export$98ca8dd7f9e1f79e = true;



//#region src/components/File.ts
const $25cd466ecc388b00$var$EMPTY_STRINGS = [];
let $25cd466ecc388b00$var$instanceId = -1;
var $25cd466ecc388b00$export$b6afa8811b7e644e = class {
    static LoadedCustomComponent = (0, $7b74b50028a59173$export$98ca8dd7f9e1f79e);
    __id = `file:${++$25cd466ecc388b00$var$instanceId}`;
    fileContainer;
    spriteSVG;
    pre;
    code;
    bufferBefore;
    bufferAfter;
    themeCSSStyle;
    appliedThemeCSS;
    hasAdoptedThemeCSS = false;
    unsafeCSSStyle;
    appliedUnsafeCSS;
    gutterUtilityContent;
    errorWrapper;
    placeHolder;
    lastRenderedHeaderHTML;
    cachedHeaderHTML;
    appliedPreAttributes;
    lastRowCount;
    headerElement;
    headerCustom;
    headerPrefix;
    headerMetadata;
    fileRenderer;
    resizeManager;
    interactionManager;
    annotationCache = /* @__PURE__ */ new Map();
    lineAnnotations = [];
    managersDirty = false;
    file;
    renderRange;
    enabled = true;
    constructor(options = {
        theme: (0, $6986aac91971cc6d$export$bcfc57767d137a59)
    }, workerManager, isContainerManaged = false){
        this.options = options;
        this.workerManager = workerManager;
        this.isContainerManaged = isContainerManaged;
        this.fileRenderer = new (0, $4acbe3dda9969d81$export$dd452f961566808f)(options, this.handleHighlightRender, this.workerManager);
        this.resizeManager = new (0, $44ea84d1b8c4f335$export$c2996b1539fb6bb1)();
        this.interactionManager = new (0, $12fff3ed1f91ca75$export$aaa80641d584351c)("file", (0, $12fff3ed1f91ca75$export$81858fc3df89d648)(options));
        this.workerManager?.subscribeToThemeChanges(this);
    }
    handleHighlightRender = ()=>{
        this.rerender();
    };
    rerender() {
        if (!this.enabled || this.file == null) return;
        this.render({
            file: this.file,
            forceRender: true,
            renderRange: this.renderRange
        });
    }
    setOptions(options) {
        if (options == null) return;
        this.options = options;
        this.cachedHeaderHTML = void 0;
        this.interactionManager.setOptions((0, $12fff3ed1f91ca75$export$81858fc3df89d648)(options));
    }
    mergeOptions(options) {
        this.options = {
            ...this.options,
            ...options
        };
    }
    setThemeType(themeType) {
        if ((this.options.themeType ?? "system") === themeType) return;
        this.mergeOptions({
            themeType: themeType
        });
        this.applyCachedThemeState(themeType);
    }
    applyCachedThemeState(themeType) {
        if (typeof this.options.theme === "string" || this.fileContainer == null || this.appliedThemeCSS == null) return false;
        const effectiveThemeType = this.appliedThemeCSS.baseThemeType ?? themeType;
        if (this.appliedThemeCSS.themeType === effectiveThemeType) return false;
        this.applyThemeState(this.fileContainer, this.appliedThemeCSS.themeStyles, themeType, this.appliedThemeCSS.baseThemeType);
        return true;
    }
    hasThemeChanged() {
        return this.appliedThemeCSS != null && !(0, $0246eee5e18b0420$export$e40448283aec01f1)(this.appliedThemeCSS.theme, this.options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59));
    }
    getHoveredLine = ()=>{
        return this.interactionManager.getHoveredLine();
    };
    setLineAnnotations(lineAnnotations) {
        this.lineAnnotations = lineAnnotations;
    }
    setSelectedLines(range, options) {
        this.interactionManager.setSelection(range, options);
    }
    flushManagers() {
        if (!this.managersDirty || this.pre == null) {
            this.managersDirty = false;
            return;
        }
        const { overflow: overflow = "scroll" } = this.options;
        this.interactionManager.setup(this.pre);
        this.resizeManager.setup(this.pre, overflow === "wrap");
        this.managersDirty = false;
    }
    cleanUp(recycle = false) {
        this.resizeManager.cleanUp();
        this.interactionManager.cleanUp();
        this.managersDirty = false;
        this.workerManager?.unsubscribeToThemeChanges(this);
        this.renderRange = void 0;
        if (!this.isContainerManaged) this.fileContainer?.remove();
        this.fileContainer = void 0;
        this.lineAnnotations = [];
        this.annotationCache.clear();
        this.pre = void 0;
        this.bufferBefore = void 0;
        this.bufferAfter = void 0;
        this.appliedPreAttributes = void 0;
        this.lastRowCount = void 0;
        this.headerElement = void 0;
        this.headerPrefix = void 0;
        this.headerMetadata = void 0;
        this.headerCustom = void 0;
        this.lastRenderedHeaderHTML = void 0;
        if (!recycle) this.cachedHeaderHTML = void 0;
        this.errorWrapper = void 0;
        this.themeCSSStyle = void 0;
        this.appliedThemeCSS = void 0;
        this.hasAdoptedThemeCSS = false;
        this.unsafeCSSStyle = void 0;
        this.appliedUnsafeCSS = void 0;
        this.placeHolder = void 0;
        this.unsafeCSSStyle = void 0;
        if (recycle) this.fileRenderer.recycle();
        else {
            this.fileRenderer.cleanUp();
            this.workerManager = void 0;
            this.file = void 0;
        }
        this.enabled = false;
    }
    virtualizedSetup() {
        this.enabled = true;
        this.workerManager?.subscribeToThemeChanges(this);
    }
    hydrate(props) {
        const { fileContainer: fileContainer, prerenderedHTML: prerenderedHTML, preventEmit: preventEmit = false, file: file, lineAnnotations: lineAnnotations } = props;
        this.hydrateElements(fileContainer, prerenderedHTML);
        if ($25cd466ecc388b00$var$shouldRenderCode(this.pre, file, this.options.collapsed) || $25cd466ecc388b00$var$shouldRenderHeader(this.headerElement, file, this.options.disableFileHeader)) this.render({
            ...props,
            preventEmit: true
        });
        else this.hydrationSetup({
            file: file,
            lineAnnotations: lineAnnotations
        });
        if (!preventEmit) this.emitPostRender();
    }
    hydrateElements(fileContainer, prerenderedHTML) {
        (0, $7951d831173cd21c$export$2793dc7c568f39d4)(fileContainer, prerenderedHTML);
        for (const element of Array.from(fileContainer.shadowRoot?.children ?? [])){
            if (element instanceof SVGElement) {
                this.spriteSVG = element;
                continue;
            }
            if (!(element instanceof HTMLElement)) continue;
            if (element instanceof HTMLPreElement) {
                this.pre = element;
                this.appliedPreAttributes = void 0;
                continue;
            }
            if (element instanceof HTMLStyleElement && element.hasAttribute((0, $6986aac91971cc6d$export$4ce037b01ed1780d))) {
                this.themeCSSStyle = element;
                continue;
            }
            if (element instanceof HTMLStyleElement && element.hasAttribute((0, $6986aac91971cc6d$export$26189492e726cd65))) {
                this.unsafeCSSStyle = element;
                this.appliedUnsafeCSS = element.textContent;
                continue;
            }
            if ("diffsHeader" in element.dataset) {
                this.headerElement = element;
                this.lastRenderedHeaderHTML = void 0;
                continue;
            }
        }
        if (this.pre != null) {
            this.syncCodeNodeFromPre(this.pre);
            this.pre.removeAttribute("data-dehydrated");
        }
        this.fileContainer = fileContainer;
        this.hydrateMeasuredScrollbar();
    }
    hydrationSetup({ file: file, lineAnnotations: lineAnnotations }) {
        this.lineAnnotations = lineAnnotations ?? this.lineAnnotations;
        this.file = file;
        this.fileRenderer.setOptions({
            ...this.options,
            headerRenderMode: this.options.renderCustomHeader != null ? "custom" : "default"
        });
        if (this.pre == null) return;
        this.fileRenderer.hydrate(file);
        this.renderAnnotations();
        this.renderGutterUtility();
        this.injectUnsafeCSS();
        this.managersDirty = true;
        this.flushManagers();
    }
    getOrCreateLineCache(file = this.file) {
        return file != null ? this.fileRenderer.getOrCreateLineCache(file) : $25cd466ecc388b00$var$EMPTY_STRINGS;
    }
    render({ file: file, fileContainer: fileContainer, forceRender: forceRender = false, preventEmit: preventEmit = false, containerWrapper: containerWrapper, deferManagers: deferManagers = false, lineAnnotations: lineAnnotations, renderRange: renderRange }) {
        const { collapsed: collapsed = false, themeType: themeType = "system" } = this.options;
        if (!this.enabled) throw new Error("File.render: attempting to call render after cleaned up");
        const nextRenderRange = collapsed ? void 0 : renderRange;
        const previousRenderRange = this.renderRange;
        const themeChanged = this.hasThemeChanged();
        const annotationsChanged = lineAnnotations != null && (lineAnnotations.length > 0 || this.lineAnnotations.length > 0) ? lineAnnotations !== this.lineAnnotations : false;
        const didFileChange = !(0, $2f249b89688d7794$export$66ae137c56162891)(this.file, file);
        if (!collapsed && !forceRender && (0, $27129b485d2e8f5d$export$7df1d5d844442f33)(nextRenderRange, this.renderRange) && !didFileChange && !annotationsChanged && !themeChanged) return this.applyCachedThemeState(themeType);
        this.renderRange = nextRenderRange;
        if (didFileChange) this.cachedHeaderHTML = void 0;
        this.file = file;
        this.fileRenderer.setOptions({
            ...this.options,
            headerRenderMode: this.options.renderCustomHeader != null ? "custom" : "default"
        });
        if (lineAnnotations != null) this.setLineAnnotations(lineAnnotations);
        this.fileRenderer.setLineAnnotations(this.lineAnnotations);
        const { disableErrorHandling: disableErrorHandling = false, disableFileHeader: disableFileHeader = false } = this.options;
        if (disableFileHeader) {
            if (this.headerElement != null) {
                this.headerElement.remove();
                this.headerElement = void 0;
                this.lastRenderedHeaderHTML = void 0;
            }
            this.clearHeaderSlots();
        }
        fileContainer = this.getOrCreateFileContainerNode(fileContainer, containerWrapper);
        this.applyCachedThemeState(themeType);
        if (collapsed) {
            this.removeRenderedCode();
            this.clearAuxiliaryNodes();
            try {
                const fileResult = this.fileRenderer.renderFile(file, (0, $6986aac91971cc6d$export$af82796f7deef107));
                if (fileResult != null) this.applyThemeState(fileContainer, fileResult.themeStyles, themeType, fileResult.baseThemeType);
                if (fileResult?.headerAST != null) this.applyHeaderToDOM(fileResult.headerAST, fileContainer);
                this.injectUnsafeCSS();
            } catch (error) {
                if (disableErrorHandling) throw error;
                console.error(error);
                if (error instanceof Error) this.applyErrorToDOM(error, fileContainer);
            }
            if (!preventEmit) this.emitPostRender();
            return true;
        }
        try {
            const pre = this.getOrCreatePreNode(fileContainer);
            if (!this.canPartiallyRender(forceRender, annotationsChanged, didFileChange || themeChanged) || !this.applyPartialRender(previousRenderRange, nextRenderRange)) {
                const fileResult = this.fileRenderer.renderFile(file, nextRenderRange);
                if (fileResult == null) {
                    if (this.workerManager?.isInitialized() === false) this.workerManager.initialize().then(()=>this.rerender());
                    return false;
                }
                this.applyThemeState(fileContainer, fileResult.themeStyles, themeType, fileResult.baseThemeType);
                if (fileResult.headerAST != null) this.applyHeaderToDOM(fileResult.headerAST, fileContainer);
                this.applyFullRender(fileResult, pre);
            }
            this.applyBuffers(pre, nextRenderRange);
            this.injectUnsafeCSS();
            this.managersDirty = true;
            if (!deferManagers) this.flushManagers();
            this.renderAnnotations();
            this.renderGutterUtility();
        } catch (error) {
            if (disableErrorHandling) throw error;
            console.error(error);
            if (error instanceof Error) this.applyErrorToDOM(error, fileContainer);
        }
        if (!preventEmit) this.emitPostRender();
        return true;
    }
    emitPostRender() {
        if (this.fileContainer != null) this.options.onPostRender?.(this.fileContainer, this);
    }
    removeRenderedCode() {
        this.resizeManager.cleanUp();
        this.interactionManager.cleanUp();
        this.bufferBefore?.remove();
        this.bufferBefore = void 0;
        this.bufferAfter?.remove();
        this.bufferAfter = void 0;
        this.code?.remove();
        this.code = void 0;
        this.pre?.remove();
        this.pre = void 0;
        this.appliedPreAttributes = void 0;
        this.lastRowCount = void 0;
    }
    clearAuxiliaryNodes() {
        for (const { element: element } of this.annotationCache.values())element.remove();
        this.annotationCache.clear();
        this.gutterUtilityContent?.remove();
        this.gutterUtilityContent = void 0;
    }
    canPartiallyRender(forceRender, annotationsChanged, didContentChange) {
        if (forceRender || annotationsChanged || didContentChange) return false;
        return true;
    }
    renderPlaceholder(height) {
        if (this.fileContainer == null) return false;
        this.cleanChildNodes();
        if (this.placeHolder == null) {
            const shadowRoot = this.fileContainer.shadowRoot ?? this.fileContainer.attachShadow({
                mode: "open"
            });
            this.placeHolder = document.createElement("div");
            this.placeHolder.dataset.placeholder = "";
            shadowRoot.appendChild(this.placeHolder);
        }
        this.placeHolder.style.setProperty("height", `${height}px`);
        return true;
    }
    primeHighlightCache() {
        const { file: file, workerManager: workerManager } = this;
        if (file == null || file.cacheKey == null || workerManager == null || (0, $15de751b18238005$export$4d513fdf32c04fe0)(file)) return;
        if (this.fileRenderer.getOrCreateLineCache(file).length > (this.options.tokenizeMaxLength ?? (0, $6986aac91971cc6d$export$b31ab775814f11e2))) return;
        workerManager.primeFileHighlightCache(file);
    }
    cleanChildNodes() {
        this.resizeManager.cleanUp();
        this.interactionManager.cleanUp();
        this.bufferAfter?.remove();
        this.bufferBefore?.remove();
        this.code?.remove();
        this.errorWrapper?.remove();
        this.headerElement?.remove();
        this.gutterUtilityContent?.remove();
        this.headerPrefix?.remove();
        this.headerMetadata?.remove();
        this.headerCustom?.remove();
        this.pre?.remove();
        this.spriteSVG?.remove();
        this.themeCSSStyle?.remove();
        this.unsafeCSSStyle?.remove();
        this.bufferAfter = void 0;
        this.bufferBefore = void 0;
        this.code = void 0;
        this.errorWrapper = void 0;
        this.headerElement = void 0;
        this.gutterUtilityContent = void 0;
        this.headerPrefix = void 0;
        this.headerMetadata = void 0;
        this.headerCustom = void 0;
        this.pre = void 0;
        this.spriteSVG = void 0;
        this.themeCSSStyle = void 0;
        this.appliedThemeCSS = void 0;
        this.hasAdoptedThemeCSS = false;
        this.unsafeCSSStyle = void 0;
        this.appliedUnsafeCSS = void 0;
        this.lastRenderedHeaderHTML = void 0;
        this.lastRowCount = void 0;
    }
    renderAnnotations() {
        if (this.isContainerManaged || this.fileContainer == null) {
            for (const { element: element } of this.annotationCache.values())element.remove();
            this.annotationCache.clear();
            return;
        }
        const staleAnnotations = new Map(this.annotationCache);
        const { renderAnnotation: renderAnnotation } = this.options;
        if (renderAnnotation != null && this.lineAnnotations.length > 0) for (const [index, annotation] of this.lineAnnotations.entries()){
            const id = `${index}-${(0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation)}`;
            let cache = this.annotationCache.get(id);
            if (cache == null || !(0, $15bd6ef2dafde664$export$1ab29c66b6d99142)(annotation, cache.annotation)) {
                cache?.element.remove();
                const content = renderAnnotation(annotation);
                if (content == null) continue;
                cache = {
                    element: (0, $c2c6bb2973b29e85$export$4b9f37d754cdceeb)((0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation)),
                    annotation: annotation
                };
                cache.element.appendChild(content);
                this.fileContainer.appendChild(cache.element);
                this.annotationCache.set(id, cache);
            }
            staleAnnotations.delete(id);
        }
        for (const [id, { element: element }] of staleAnnotations.entries()){
            this.annotationCache.delete(id);
            element.remove();
        }
    }
    renderGutterUtility() {
        const { renderGutterUtility: renderGutterUtility } = this.options;
        if (this.fileContainer == null || renderGutterUtility == null) {
            this.gutterUtilityContent?.remove();
            this.gutterUtilityContent = void 0;
            return;
        }
        const element = renderGutterUtility(this.interactionManager.getHoveredLine);
        if (element != null && this.gutterUtilityContent != null) return;
        else if (element == null) {
            this.gutterUtilityContent?.remove();
            this.gutterUtilityContent = void 0;
            return;
        }
        const gutterUtilityContent = (0, $b4d03e340999f061$export$9c2f722fd7aacea4)();
        gutterUtilityContent.appendChild(element);
        this.fileContainer.appendChild(gutterUtilityContent);
        this.gutterUtilityContent = gutterUtilityContent;
    }
    injectUnsafeCSS() {
        const { unsafeCSS: unsafeCSS } = this.options;
        const shadowRoot = this.fileContainer?.shadowRoot;
        if (shadowRoot == null) return;
        if (unsafeCSS == null || unsafeCSS === "") {
            if (this.unsafeCSSStyle != null) {
                this.unsafeCSSStyle.remove();
                this.unsafeCSSStyle = void 0;
            }
            this.appliedUnsafeCSS = void 0;
            return;
        }
        if (this.unsafeCSSStyle?.parentNode === shadowRoot && this.appliedUnsafeCSS === unsafeCSS) return;
        this.unsafeCSSStyle ??= (0, $2b516b4212841f75$export$c520e3d3d812f648)();
        if (this.unsafeCSSStyle.parentNode !== shadowRoot) shadowRoot.appendChild(this.unsafeCSSStyle);
        this.unsafeCSSStyle.textContent = (0, $001f0bd23af5fd92$export$bf3957559e751562)(unsafeCSS);
        this.appliedUnsafeCSS = unsafeCSS;
    }
    applyThemeState(container, themeStyles, themeType, baseThemeType) {
        const shadowRoot = container.shadowRoot ?? container.attachShadow({
            mode: "open"
        });
        const effectiveThemeType = baseThemeType ?? themeType;
        const currentTheme = this.options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59);
        const theme = typeof currentTheme === "string" ? currentTheme : {
            ...currentTheme
        };
        const scrollbarGutter = (0, $6c5a73e7fcb28098$export$c8735f53e6551891)(shadowRoot);
        if (this.themeCSSStyle?.parentNode === shadowRoot && this.appliedThemeCSS?.themeStyles === themeStyles && this.appliedThemeCSS.themeType === effectiveThemeType && this.appliedThemeCSS.scrollbarGutter === scrollbarGutter) {
            this.appliedThemeCSS.theme = theme;
            return;
        }
        if (this.hasAdoptedThemeCSS && this.themeCSSStyle?.parentNode === shadowRoot) {
            this.hasAdoptedThemeCSS = false;
            this.appliedThemeCSS = {
                theme: theme,
                themeStyles: themeStyles,
                themeType: effectiveThemeType,
                baseThemeType: baseThemeType,
                scrollbarGutter: scrollbarGutter
            };
            return;
        }
        this.themeCSSStyle = (0, $56283d44ece37dbc$export$a0a7f1f190c55d90)({
            shadowRoot: shadowRoot,
            currentNode: this.themeCSSStyle,
            themeCSS: (0, $001f0bd23af5fd92$export$c514b17fd29d7d29)(themeStyles, effectiveThemeType, scrollbarGutter)
        });
        this.appliedThemeCSS = this.themeCSSStyle != null ? {
            theme: theme,
            themeStyles: themeStyles,
            themeType: effectiveThemeType,
            baseThemeType: baseThemeType,
            scrollbarGutter: scrollbarGutter
        } : void 0;
    }
    hydrateMeasuredScrollbar() {
        const shadowRoot = this.fileContainer?.shadowRoot;
        if (shadowRoot == null || this.themeCSSStyle == null) return;
        this.themeCSSStyle.textContent = (0, $001f0bd23af5fd92$export$bfd64041029ebdb4)(this.themeCSSStyle.textContent ?? "", (0, $6c5a73e7fcb28098$export$c8735f53e6551891)(shadowRoot));
    }
    applyFullRender(result, pre) {
        this.cleanupErrorWrapper();
        this.applyPreNodeAttributes(pre, result);
        this.code = (0, $1f97c906c36c90b4$export$e74beb130200ec1d)({
            code: this.code
        });
        this.code.innerHTML = this.fileRenderer.renderPartialHTML(this.fileRenderer.renderCodeAST(result));
        pre.replaceChildren(this.code);
        this.lastRowCount = result.rowCount;
    }
    applyPartialRender(previousRenderRange, renderRange) {
        if (previousRenderRange == null || renderRange == null) return false;
        const { file: file, code: code } = this;
        const columns = code != null ? this.getColumns(code) : void 0;
        if (file == null || code == null || columns == null) return false;
        const previousStart = previousRenderRange.startingLine;
        const nextStart = renderRange.startingLine;
        const previousEnd = previousRenderRange.totalLines === Infinity ? Number.POSITIVE_INFINITY : previousStart + previousRenderRange.totalLines;
        const nextEnd = renderRange.totalLines === Infinity ? Number.POSITIVE_INFINITY : nextStart + renderRange.totalLines;
        const overlapStart = Math.max(previousStart, nextStart);
        const overlapEnd = Math.min(previousEnd, nextEnd);
        if (overlapEnd <= overlapStart) return false;
        if (!this.trimDOMToOverlap(columns.gutter, overlapStart, overlapEnd) || !this.trimDOMToOverlap(columns.content, overlapStart, overlapEnd)) return false;
        let { length: rowCount } = columns.content.children;
        const renderChunk = (startingLine, totalLines)=>{
            if (totalLines <= 0) return;
            return this.fileRenderer.renderFile(file, {
                startingLine: startingLine,
                totalLines: totalLines,
                bufferBefore: 0,
                bufferAfter: 0
            });
        };
        const prependResult = nextStart < overlapStart ? renderChunk(nextStart, overlapStart - nextStart) : void 0;
        if (prependResult === void 0 && nextStart < overlapStart) return false;
        const appendTotalLines = nextEnd === Number.POSITIVE_INFINITY ? Number.POSITIVE_INFINITY : Math.max(0, nextEnd - overlapEnd);
        const appendResult = nextEnd > overlapEnd ? renderChunk(overlapEnd, appendTotalLines) : void 0;
        if (appendResult === void 0 && nextEnd > overlapEnd) return false;
        this.cleanupErrorWrapper();
        if (prependResult != null) {
            columns.gutter.insertAdjacentHTML("afterbegin", this.fileRenderer.renderPartialHTML(prependResult.gutterAST));
            columns.content.insertAdjacentHTML("afterbegin", this.fileRenderer.renderPartialHTML(prependResult.contentAST));
            rowCount += prependResult.rowCount;
        }
        if (appendResult != null) {
            columns.gutter.insertAdjacentHTML("beforeend", this.fileRenderer.renderPartialHTML(appendResult.gutterAST));
            columns.content.insertAdjacentHTML("beforeend", this.fileRenderer.renderPartialHTML(appendResult.contentAST));
            rowCount += appendResult.rowCount;
        }
        if (this.lastRowCount !== rowCount) {
            columns.gutter.style.setProperty("grid-row", `span ${rowCount}`);
            columns.content.style.setProperty("grid-row", `span ${rowCount}`);
            this.lastRowCount = rowCount;
        }
        return true;
    }
    getColumns(code) {
        const gutter = code.children[0];
        const content = code.children[1];
        if (!(gutter instanceof HTMLElement) || !(content instanceof HTMLElement) || gutter.dataset.gutter == null || content.dataset.content == null) return;
        return {
            gutter: gutter,
            content: content
        };
    }
    trimDOMToOverlap(container, overlapStart, overlapEnd) {
        const boundaryIndices = this.getDOMBoundaryIndices(container, [
            overlapStart,
            overlapEnd
        ]);
        const startIndex = boundaryIndices.get(overlapStart) ?? container.children.length;
        const endIndex = boundaryIndices.get(overlapEnd) ?? container.children.length;
        if (startIndex > endIndex) return false;
        for(let i = container.children.length - 1; i >= endIndex; i -= 1)container.children[i]?.remove();
        for(let i = startIndex - 1; i >= 0; i -= 1)container.children[i]?.remove();
        return true;
    }
    getDOMBoundaryIndices(container, boundaries) {
        const sortedBoundaries = [
            ...new Set(boundaries)
        ].sort((a, b)=>a - b);
        const boundaryIndices = /* @__PURE__ */ new Map();
        if (sortedBoundaries.length === 0) return boundaryIndices;
        let boundaryIndex = 0;
        let nextBoundary = sortedBoundaries[boundaryIndex];
        const { children: children } = container;
        for(let i = 0; i < children.length; i += 1){
            const child = children[i];
            if (!(child instanceof HTMLElement)) continue;
            const lineIndex = this.getLineIndexFromDOMNode(child);
            if (lineIndex == null) continue;
            while(nextBoundary != null && lineIndex >= nextBoundary){
                boundaryIndices.set(nextBoundary, i);
                boundaryIndex += 1;
                nextBoundary = sortedBoundaries[boundaryIndex];
            }
            if (boundaryIndex >= sortedBoundaries.length) break;
        }
        for (const boundary of sortedBoundaries)if (!boundaryIndices.has(boundary)) boundaryIndices.set(boundary, children.length);
        return boundaryIndices;
    }
    getLineIndexFromDOMNode(node) {
        const lineIndexAttr = node.dataset.lineIndex;
        if (lineIndexAttr == null) return;
        const parsed = Number(lineIndexAttr);
        return Number.isNaN(parsed) ? void 0 : parsed;
    }
    applyBuffers(pre, renderRange) {
        if (renderRange == null || this.shouldDisableVirtualizationBuffers()) {
            if (this.bufferBefore != null) {
                this.bufferBefore.remove();
                this.bufferBefore = void 0;
            }
            if (this.bufferAfter != null) {
                this.bufferAfter.remove();
                this.bufferAfter = void 0;
            }
            return;
        }
        if (renderRange.bufferBefore > 0) {
            if (this.bufferBefore == null) {
                this.bufferBefore = document.createElement("div");
                this.bufferBefore.dataset.virtualizerBuffer = "before";
                pre.before(this.bufferBefore);
            }
            this.bufferBefore.style.setProperty("height", `${renderRange.bufferBefore}px`);
            this.bufferBefore.style.setProperty("contain", "strict");
        } else if (this.bufferBefore != null) {
            this.bufferBefore.remove();
            this.bufferBefore = void 0;
        }
        if (renderRange.bufferAfter > 0) {
            if (this.bufferAfter == null) {
                this.bufferAfter = document.createElement("div");
                this.bufferAfter.dataset.virtualizerBuffer = "after";
                pre.after(this.bufferAfter);
            }
            this.bufferAfter.style.setProperty("height", `${renderRange.bufferAfter}px`);
            this.bufferAfter.style.setProperty("contain", "strict");
        } else if (this.bufferAfter != null) {
            this.bufferAfter.remove();
            this.bufferAfter = void 0;
        }
    }
    shouldDisableVirtualizationBuffers() {
        return this.options.disableVirtualizationBuffers ?? false;
    }
    applyHeaderToDOM(headerAST, container) {
        const { file: file } = this;
        if (file == null) return;
        this.cleanupErrorWrapper();
        this.placeHolder?.remove();
        this.placeHolder = void 0;
        const headerHTML = this.cachedHeaderHTML ?? (0, $59ad8c13d9107e7c$export$a10125c086a4df16)(headerAST);
        this.cachedHeaderHTML = headerHTML;
        if (headerHTML !== this.lastRenderedHeaderHTML) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = headerHTML;
            const newHeader = tempDiv.firstElementChild;
            if (!(newHeader instanceof HTMLElement)) return;
            if (this.headerElement != null) container.shadowRoot?.replaceChild(newHeader, this.headerElement);
            else container.shadowRoot?.prepend(newHeader);
            this.headerElement = newHeader;
            this.lastRenderedHeaderHTML = headerHTML;
        }
        if (this.isContainerManaged) return;
        const { renderHeaderPrefix: renderHeaderPrefix, renderCustomHeader: renderCustomHeader, renderHeaderMetadata: renderHeaderMetadata } = this.options;
        if (renderCustomHeader != null) {
            const content = renderCustomHeader(file) ?? void 0;
            this.headerCustom = this.upsertHeaderSlotElement(container, this.headerCustom, (0, $6986aac91971cc6d$export$87f913619cd5fa67), content);
            this.headerPrefix?.remove();
            this.headerMetadata?.remove();
            this.headerPrefix = void 0;
            this.headerMetadata = void 0;
        } else {
            const prefix = renderHeaderPrefix?.(file) ?? void 0;
            const content = renderHeaderMetadata?.(file) ?? void 0;
            this.headerPrefix = this.upsertHeaderSlotElement(container, this.headerPrefix, (0, $6986aac91971cc6d$export$69d2d3bd52efd12a), prefix);
            this.headerMetadata = this.upsertHeaderSlotElement(container, this.headerMetadata, (0, $6986aac91971cc6d$export$f5d94b4150f59afc), content);
            this.headerCustom?.remove();
            this.headerCustom = void 0;
        }
    }
    clearHeaderSlots() {
        this.headerPrefix?.remove();
        this.headerMetadata?.remove();
        this.headerCustom?.remove();
        this.headerPrefix = void 0;
        this.headerMetadata = void 0;
        this.headerCustom = void 0;
    }
    upsertHeaderSlotElement(container, current, slot, content) {
        if (content == null) {
            current?.remove();
            return;
        }
        const element = current ?? this.createHeaderSlotElement(slot);
        if (current == null) container.appendChild(element);
        this.replaceHeaderSlotContent(element, content);
        return element;
    }
    replaceHeaderSlotContent(element, content) {
        element.replaceChildren();
        if (content instanceof Element) element.appendChild(content);
        else element.innerText = `${content}`;
    }
    createHeaderSlotElement(slot) {
        const element = document.createElement("div");
        element.slot = slot;
        return element;
    }
    getOrCreateFileContainerNode(fileContainer, parentNode) {
        const previousContainer = this.fileContainer;
        this.fileContainer = fileContainer ?? this.fileContainer ?? document.createElement((0, $6986aac91971cc6d$export$b583bc7fc1f35cf2));
        const containerChanged = previousContainer !== this.fileContainer;
        if (previousContainer != null && containerChanged) {
            this.lastRenderedHeaderHTML = void 0;
            this.headerElement = void 0;
        }
        if (parentNode != null && this.fileContainer.parentNode !== parentNode) parentNode.appendChild(this.fileContainer);
        if (containerChanged) this.adoptReusableShellElements(this.fileContainer);
        this.ensureSpriteSVG(this.fileContainer);
        return this.fileContainer;
    }
    adoptReusableShellElements(fileContainer) {
        const { shadowRoot: shadowRoot } = fileContainer;
        if (shadowRoot == null) return;
        for (const element of shadowRoot.children)if (element instanceof SVGElement) this.spriteSVG ??= element;
        else if ((0, $0d4053e5b759c704$export$1405a8e7808a3d28)(element) && element.hasAttribute((0, $6986aac91971cc6d$export$4ce037b01ed1780d))) {
            this.themeCSSStyle ??= element;
            this.hasAdoptedThemeCSS = true;
        } else if ((0, $0d4053e5b759c704$export$1405a8e7808a3d28)(element) && element.hasAttribute((0, $6986aac91971cc6d$export$26189492e726cd65))) {
            this.unsafeCSSStyle ??= element;
            this.appliedUnsafeCSS ??= this.options.unsafeCSS ?? void 0;
        }
    }
    ensureSpriteSVG(fileContainer) {
        const shadowRoot = fileContainer.shadowRoot ?? fileContainer.attachShadow({
            mode: "open"
        });
        if (this.spriteSVG == null) {
            const fragment = document.createElement("div");
            fragment.innerHTML = (0, $166d24462d2ee37b$export$ddccfde1db76f444);
            const firstChild = fragment.firstChild;
            if (firstChild instanceof SVGElement) this.spriteSVG = firstChild;
        }
        if (this.spriteSVG != null && this.spriteSVG.parentNode !== shadowRoot) shadowRoot.appendChild(this.spriteSVG);
    }
    getOrCreatePreNode(container) {
        const shadowRoot = container.shadowRoot ?? container.attachShadow({
            mode: "open"
        });
        if (this.pre == null) {
            this.pre = document.createElement("pre");
            this.appliedPreAttributes = void 0;
            this.code = void 0;
            shadowRoot.appendChild(this.pre);
        } else if (this.pre.parentNode !== shadowRoot) {
            container.shadowRoot?.appendChild(this.pre);
            this.appliedPreAttributes = void 0;
        }
        this.placeHolder?.remove();
        this.placeHolder = void 0;
        return this.pre;
    }
    syncCodeNodeFromPre(pre) {
        this.code = void 0;
        for (const child of Array.from(pre.children)){
            if (!(child instanceof HTMLElement)) continue;
            if (child.hasAttribute("data-code")) {
                this.code = child;
                return;
            }
        }
    }
    applyPreNodeAttributes(pre, { totalLines: totalLines }) {
        const { overflow: overflow = "scroll", disableLineNumbers: disableLineNumbers = false } = this.options;
        const preProperties = {
            type: "file",
            split: false,
            overflow: overflow,
            disableLineNumbers: disableLineNumbers,
            diffIndicators: "none",
            disableBackground: true,
            totalLines: totalLines
        };
        if ((0, $0f5986330d731e6d$export$732d2d41c8f0dbb)(preProperties, this.appliedPreAttributes)) return;
        (0, $c1b1c6b8488e516b$export$fcea31ce4b8860ec)(pre, preProperties);
        this.appliedPreAttributes = preProperties;
    }
    applyErrorToDOM(error, container) {
        this.cleanupErrorWrapper();
        this.pre?.remove();
        this.pre = void 0;
        this.appliedPreAttributes = void 0;
        const shadowRoot = container.shadowRoot ?? container.attachShadow({
            mode: "open"
        });
        this.errorWrapper ??= document.createElement("div");
        this.errorWrapper.dataset.errorWrapper = "";
        this.errorWrapper.textContent = "";
        shadowRoot.appendChild(this.errorWrapper);
        const errorMessage = document.createElement("div");
        errorMessage.dataset.errorMessage = "";
        errorMessage.innerText = error.message;
        this.errorWrapper.appendChild(errorMessage);
        const errorStack = document.createElement("pre");
        errorStack.dataset.errorStack = "";
        errorStack.innerText = error.stack ?? "No Error Stack";
        this.errorWrapper.appendChild(errorStack);
    }
    cleanupErrorWrapper() {
        this.errorWrapper?.remove();
        this.errorWrapper = void 0;
    }
};
function $25cd466ecc388b00$var$shouldRenderCode(pre, file, collapsed = false) {
    return !collapsed && pre == null && file != null;
}
function $25cd466ecc388b00$var$shouldRenderHeader(headerElement, file, disableFileHeader = false) {
    return headerElement == null && file != null && !disableFileHeader;
}


//#region src/components/VirtualizedFile.ts
const $04b40a9847bcadbe$var$LAYOUT_CHECKPOINT_INTERVAL = 5e3;
let $04b40a9847bcadbe$var$instanceId = -1;
function $04b40a9847bcadbe$var$hasFileLayoutOptionChanged(previousOptions, nextOptions) {
    return (previousOptions.overflow ?? "scroll") !== (nextOptions.overflow ?? "scroll") || (previousOptions.collapsed ?? false) !== (nextOptions.collapsed ?? false) || (previousOptions.disableLineNumbers ?? false) !== (nextOptions.disableLineNumbers ?? false) || (previousOptions.disableFileHeader ?? false) !== (nextOptions.disableFileHeader ?? false) || previousOptions.unsafeCSS !== nextOptions.unsafeCSS;
}
var $04b40a9847bcadbe$export$6ddfbce10e697151 = class extends (0, $25cd466ecc388b00$export$b6afa8811b7e644e) {
    __id = `virtualized-file:${++$04b40a9847bcadbe$var$instanceId}`;
    top;
    height = 0;
    cache = {
        heights: /* @__PURE__ */ new Map(),
        checkpoints: []
    };
    isVisible = false;
    isSetup = false;
    layoutDirty = true;
    forceRenderOverride;
    constructor(options, virtualizer, metrics = (0, $6986aac91971cc6d$export$e77df7b39261553f), workerManager, isContainerManaged = false){
        super(options, workerManager, isContainerManaged);
        this.virtualizer = virtualizer;
        this.metrics = metrics;
    }
    setMetrics(metrics, force = false) {
        if (!force && (0, $3ec53e4f7bbd4269$export$1db8244ab969c6c6)(this.metrics, metrics)) return;
        this.metrics = metrics;
        this.resetLayoutCache();
    }
    getLineHeight(lineIndex, hasMetadataLine = false) {
        const cached = this.cache.heights.get(lineIndex);
        if (cached != null) return cached;
        const multiplier = hasMetadataLine ? 2 : 1;
        return this.metrics.lineHeight * multiplier;
    }
    setOptions(options) {
        if (options == null) return;
        const { options: previousOptions } = this;
        const optionsChanged = !(0, $5e49faa8df06196c$export$1ace03bbcd701468)(previousOptions, options);
        const layoutChanged = $04b40a9847bcadbe$var$hasFileLayoutOptionChanged(previousOptions, options);
        super.setOptions(options);
        if (layoutChanged) this.resetLayoutCache(true);
        if (optionsChanged) this.forceRenderOverride = true;
        if (optionsChanged && this.isSimpleMode()) this.virtualizer.instanceChanged(this, layoutChanged);
    }
    resetLayoutCache(recompute = false) {
        this.layoutDirty = true;
        this.cache.heights.clear();
        this.cache.checkpoints = [];
        this.renderRange = void 0;
        if (recompute && this.isSimpleMode()) this.computeApproximateSize();
    }
    reconcileHeights() {
        let hasHeightChange = false;
        if (this.fileContainer == null || this.file == null) {
            if (this.height !== 0) hasHeightChange = true;
            this.height = 0;
            return hasHeightChange;
        }
        const { overflow: overflow = "scroll" } = this.options;
        this.top = this.getVirtualizedTop();
        if (overflow === "scroll" && this.lineAnnotations.length === 0 && !this.isResizeDebuggingEnabled()) return hasHeightChange;
        if (this.code == null) return hasHeightChange;
        const content = this.code.children[1];
        if (!(content instanceof HTMLElement)) return hasHeightChange;
        for (const line of content.children){
            if (!(line instanceof HTMLElement)) continue;
            const lineIndexAttr = line.dataset.lineIndex;
            if (lineIndexAttr == null) continue;
            const lineIndex = Number(lineIndexAttr);
            let measuredHeight = line.getBoundingClientRect().height;
            let hasMetadata = false;
            if (line.nextElementSibling instanceof HTMLElement && ("lineAnnotation" in line.nextElementSibling.dataset || "noNewline" in line.nextElementSibling.dataset)) {
                if ("noNewline" in line.nextElementSibling.dataset) hasMetadata = true;
                measuredHeight += line.nextElementSibling.getBoundingClientRect().height;
            }
            const expectedHeight = this.getLineHeight(lineIndex, hasMetadata);
            if (measuredHeight === expectedHeight) continue;
            hasHeightChange = true;
            if (measuredHeight === this.metrics.lineHeight * (hasMetadata ? 2 : 1)) this.cache.heights.delete(lineIndex);
            else this.cache.heights.set(lineIndex, measuredHeight);
        }
        if (hasHeightChange || this.isResizeDebuggingEnabled()) this.computeApproximateSize(true);
        return hasHeightChange;
    }
    onRender = (dirty)=>{
        if (this.fileContainer == null || this.file == null) return false;
        if (dirty) this.top = this.getVirtualizedTop();
        return this.render({
            file: this.file
        });
    };
    prepareVirtualizedItem(file) {
        if (this.file !== file) this.layoutDirty = true;
        this.file = file;
        this.top = this.getVirtualizedTop();
        this.computeApproximateSize();
        return this.height;
    }
    getLinePosition(lineNumber) {
        if (this.file == null) return;
        const { disableFileHeader: disableFileHeader = false, collapsed: collapsed = false } = this.options;
        const lastLineIndex = $04b40a9847bcadbe$var$getLastVisibleLineIndex(this.getOrCreateLineCache(this.file));
        let top = (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        if (collapsed || lastLineIndex < 0) return {
            top: top,
            height: 0
        };
        const clampedLineIndex = Math.min(Math.max(lineNumber - 1, 0), lastLineIndex);
        const { overflow: overflow = "scroll" } = this.options;
        const { lineHeight: lineHeight } = this.metrics;
        if (overflow === "scroll" && this.lineAnnotations.length === 0) return {
            top: top + clampedLineIndex * lineHeight,
            height: lineHeight
        };
        const checkpoint = this.getLayoutCheckpointBeforeLineIndex(clampedLineIndex);
        top = checkpoint?.top ?? top;
        for(let lineIndex = checkpoint?.lineIndex ?? 0; lineIndex < clampedLineIndex; lineIndex++)top += this.getLineHeight(lineIndex, false);
        return {
            top: top,
            height: this.getLineHeight(clampedLineIndex, false)
        };
    }
    getNumericScrollAnchor(localViewportTop) {
        if (this.file == null || this.renderRange == null) return;
        const { disableFileHeader: disableFileHeader = false, collapsed: collapsed = false, overflow: overflow = "scroll" } = this.options;
        if (collapsed || this.renderRange.totalLines <= 0) return;
        const lastLineIndex = $04b40a9847bcadbe$var$getLastVisibleLineIndex(this.getOrCreateLineCache(this.file));
        if (lastLineIndex < 0) return;
        const headerRegion = (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        const firstRenderedLineIndex = Math.min(this.renderRange.startingLine, lastLineIndex);
        const lastRenderedLineIndex = Math.min(firstRenderedLineIndex + this.renderRange.totalLines - 1, lastLineIndex);
        if (lastRenderedLineIndex < firstRenderedLineIndex) return;
        if (overflow === "scroll" && this.lineAnnotations.length === 0) {
            const { lineHeight: lineHeight } = this.metrics;
            const firstRenderedLineTop = headerRegion + this.renderRange.bufferBefore;
            const lineIndex = firstRenderedLineIndex + Math.max(Math.ceil((localViewportTop - firstRenderedLineTop) / lineHeight), 0);
            if (lineIndex > lastRenderedLineIndex) return;
            return {
                lineNumber: lineIndex + 1,
                top: headerRegion + lineIndex * lineHeight
            };
        }
        let top = headerRegion + this.renderRange.bufferBefore;
        for(let lineIndex = firstRenderedLineIndex; lineIndex <= lastRenderedLineIndex; lineIndex++){
            if (top >= localViewportTop) return {
                lineNumber: lineIndex + 1,
                top: top
            };
            top += this.getLineHeight(lineIndex);
        }
    }
    getVirtualizedHeight() {
        return this.height;
    }
    getAdvancedStickySpecs(windowSpecs) {
        if (this.top == null || this.file == null) return;
        if (this.options.collapsed === true) return {
            topOffset: this.top,
            height: this.height
        };
        const renderRange = windowSpecs != null ? this.computeRenderRangeFromWindow(this.file, this.top, windowSpecs) : this.renderRange;
        if (renderRange == null) return;
        const { bufferBefore: bufferBefore, bufferAfter: bufferAfter, totalLines: totalLines } = renderRange;
        return {
            topOffset: this.top + bufferBefore + (totalLines === 0 ? bufferAfter : 0),
            height: this.height - (bufferBefore + bufferAfter)
        };
    }
    cleanUp(recycle = false) {
        if (this.fileContainer != null && this.isSimpleMode()) this.getSimpleVirtualizer()?.disconnect(this.fileContainer);
        if (!recycle) this.layoutDirty = true;
        this.isSetup = false;
        super.cleanUp(recycle);
    }
    computeApproximateSize(force = false) {
        const shouldValidateSize = this.isResizeDebuggingEnabled();
        if (!force && !this.layoutDirty && !shouldValidateSize) return;
        const isFirstCompute = this.height === 0;
        this.height = 0;
        this.cache.checkpoints = [];
        if (this.file == null) {
            this.layoutDirty = false;
            return;
        }
        const { disableFileHeader: disableFileHeader = false, collapsed: collapsed = false, overflow: overflow = "scroll" } = this.options;
        const { lineHeight: lineHeight } = this.metrics;
        const lines = this.getOrCreateLineCache(this.file);
        const headerRegion = (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        const paddingBottom = (0, $f700fc78f9a614b9$export$7dbace702b635f2)(this.metrics);
        this.height += headerRegion;
        if (collapsed) {
            this.layoutDirty = false;
            return;
        }
        if (overflow === "scroll" && this.lineAnnotations.length === 0) this.height += this.getOrCreateLineCache(this.file).length * lineHeight;
        else (0, $d2a7ea3ff52c7aba$export$bd45a6ae4d225463)({
            lines: lines,
            callback: ({ lineIndex: lineIndex })=>{
                this.addLayoutCheckpoint(lineIndex, this.height);
                this.height += this.getLineHeight(lineIndex, false);
            }
        });
        if (lines.length > 0) this.height += paddingBottom;
        if (this.fileContainer != null && shouldValidateSize && !isFirstCompute) {
            const rect = this.fileContainer.getBoundingClientRect();
            if (rect.height !== this.height) console.log("VirtualizedFile.computeApproximateSize: computed height doesnt match", {
                name: this.file.name,
                elementHeight: rect.height,
                computedHeight: this.height
            });
            else console.log("VirtualizedFile.computeApproximateSize: computed height IS CORRECT");
        }
        this.layoutDirty = false;
    }
    setVisibility(visible) {
        if (this.isAdvancedMode() || this.fileContainer == null) return;
        if (visible && !this.isVisible) {
            this.top = this.getVirtualizedTop();
            this.isVisible = true;
        } else if (!visible && this.isVisible) {
            this.isVisible = false;
            this.rerender();
        }
    }
    rerender() {
        if (!this.enabled || this.file == null) return;
        this.forceRenderOverride = true;
        this.virtualizer.instanceChanged(this, false);
    }
    render({ fileContainer: fileContainer, file: file, forceRender: forceRender = false, ...props }) {
        const { forceRenderOverride: forceRenderOverride, isSetup: isSetup } = this;
        this.forceRenderOverride = void 0;
        this.file ??= file;
        fileContainer = this.getOrCreateFileContainerNode(fileContainer);
        if (this.file == null) {
            console.error("VirtualizedFile.render: attempting to virtually render when we dont have file");
            return false;
        }
        if (!isSetup) {
            this.computeApproximateSize();
            const virtualizer = this.getSimpleVirtualizer();
            this.top ??= this.getVirtualizedTop();
            if (this.isAdvancedMode()) this.isVisible = true;
            else {
                if (virtualizer == null) throw new Error("VirtualizedFile.render: simple virtualizer is not available");
                virtualizer.connect(fileContainer, this);
                this.isVisible = virtualizer.isInstanceVisible(this.top ?? 0, this.height);
            }
            this.isSetup = true;
        } else this.top ??= this.getVirtualizedTop();
        if (!this.isVisible && this.isSimpleMode()) return this.renderPlaceholder(this.height);
        const windowSpecs = this.virtualizer.getWindowSpecs();
        const fileTop = this.top ?? 0;
        const renderRange = this.computeRenderRangeFromWindow(this.file, fileTop, windowSpecs);
        return super.render({
            file: this.file,
            fileContainer: fileContainer,
            renderRange: renderRange,
            forceRender: forceRenderOverride ?? forceRender,
            ...props
        });
    }
    syncVirtualizedTop() {
        this.top = this.getVirtualizedTop();
    }
    shouldDisableVirtualizationBuffers() {
        return this.isAdvancedMode() || super.shouldDisableVirtualizationBuffers();
    }
    isSimpleMode() {
        return this.virtualizer.type === "simple";
    }
    isAdvancedMode() {
        return this.virtualizer.type === "advanced";
    }
    addLayoutCheckpoint(lineIndex, top) {
        if (lineIndex % $04b40a9847bcadbe$var$LAYOUT_CHECKPOINT_INTERVAL !== 0) return;
        this.cache.checkpoints.push({
            lineIndex: lineIndex,
            top: top
        });
    }
    getLayoutCheckpointBeforeLineIndex(lineIndex) {
        if (lineIndex <= 0 || this.cache.checkpoints.length === 0) return;
        let low = 0;
        let high = this.cache.checkpoints.length - 1;
        let result;
        while(low <= high){
            const mid = low + high >> 1;
            const checkpoint = this.cache.checkpoints[mid];
            if (checkpoint == null) throw new Error("VirtualizedFile: invalid checkpoint index");
            if (checkpoint.lineIndex <= lineIndex) {
                result = checkpoint;
                low = mid + 1;
            } else high = mid - 1;
        }
        return result;
    }
    getLayoutCheckpointBeforeTop(top, hunkLineCount) {
        let low = 0;
        let high = this.cache.checkpoints.length - 1;
        let resultIndex = -1;
        while(low <= high){
            const mid = low + high >> 1;
            const checkpoint = this.cache.checkpoints[mid];
            if (checkpoint == null) throw new Error("VirtualizedFile: invalid checkpoint index");
            if (checkpoint.top <= top) {
                resultIndex = mid;
                low = mid + 1;
            } else high = mid - 1;
        }
        if (hunkLineCount == null) return resultIndex >= 0 ? this.cache.checkpoints[resultIndex] : void 0;
        for(let index = resultIndex; index >= 0; index--){
            const checkpoint = this.cache.checkpoints[index];
            if (checkpoint == null) throw new Error("VirtualizedFile: invalid checkpoint index");
            if (checkpoint.lineIndex % hunkLineCount === 0) return checkpoint;
        }
    }
    getVirtualizedTop() {
        if (this.virtualizer.type === "advanced") return this.virtualizer.getLocalTopForInstance(this);
        return this.fileContainer != null ? this.virtualizer.getOffsetInScrollContainer(this.fileContainer) : 0;
    }
    getSimpleVirtualizer() {
        return this.virtualizer.type === "simple" ? this.virtualizer : void 0;
    }
    isResizeDebuggingEnabled() {
        return this.getSimpleVirtualizer()?.config.resizeDebugging ?? false;
    }
    computeRenderRangeFromWindow(file, fileTop, { top: top, bottom: bottom }) {
        const { disableFileHeader: disableFileHeader = false, overflow: overflow = "scroll" } = this.options;
        const { hunkLineCount: hunkLineCount, lineHeight: lineHeight } = this.metrics;
        const lines = this.getOrCreateLineCache(file);
        const lineCount = lines.length;
        const fileHeight = this.height;
        const headerRegion = (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        const paddingBottom = lineCount > 0 ? (0, $f700fc78f9a614b9$export$7dbace702b635f2)(this.metrics) : 0;
        if (fileTop < top - fileHeight || fileTop > bottom) return {
            startingLine: 0,
            totalLines: 0,
            bufferBefore: 0,
            bufferAfter: fileHeight - headerRegion - paddingBottom
        };
        if (lineCount <= hunkLineCount) return {
            startingLine: 0,
            totalLines: hunkLineCount,
            bufferBefore: 0,
            bufferAfter: 0
        };
        const estimatedTargetLines = Math.ceil(Math.max(bottom - top, 0) / lineHeight);
        const totalLines = Math.ceil(estimatedTargetLines / hunkLineCount) * hunkLineCount + hunkLineCount * 2;
        const totalHunks = totalLines / hunkLineCount;
        const viewportCenter = (top + bottom) / 2;
        if (overflow === "scroll" && this.lineAnnotations.length === 0) {
            const centerLine = Math.floor((viewportCenter - (fileTop + headerRegion)) / lineHeight);
            const idealStartHunk$1 = Math.floor(centerLine / hunkLineCount) - Math.floor(totalHunks / 2);
            const totalHunksInFile = Math.ceil(lineCount / hunkLineCount);
            const startingLine$1 = Math.max(0, Math.min(idealStartHunk$1, totalHunksInFile)) * hunkLineCount;
            const clampedTotalLines$1 = idealStartHunk$1 < 0 ? totalLines + idealStartHunk$1 * hunkLineCount : totalLines;
            const bufferBefore$1 = startingLine$1 * lineHeight;
            const renderedLines = Math.min(clampedTotalLines$1, lineCount - startingLine$1);
            return {
                startingLine: startingLine$1,
                totalLines: clampedTotalLines$1,
                bufferBefore: bufferBefore$1,
                bufferAfter: Math.max(0, (lineCount - startingLine$1 - renderedLines) * lineHeight)
            };
        }
        const overflowHunks = totalHunks;
        const hunkOffsets = [];
        const checkpoint = this.getLayoutCheckpointBeforeTop(Math.max(0, top - fileTop - totalLines * lineHeight * 2), hunkLineCount);
        let absoluteLineTop = fileTop + (checkpoint?.top ?? headerRegion);
        let currentLine = checkpoint?.lineIndex ?? 0;
        let firstVisibleHunk;
        let centerHunk;
        let overflowCounter;
        (0, $d2a7ea3ff52c7aba$export$bd45a6ae4d225463)({
            lines: lines,
            startingLine: checkpoint?.lineIndex ?? 0,
            callback: ({ lineIndex: lineIndex })=>{
                const isAtHunkBoundary = currentLine % hunkLineCount === 0;
                const currentHunk = Math.floor(currentLine / hunkLineCount);
                if (isAtHunkBoundary) {
                    hunkOffsets[currentHunk] = absoluteLineTop - (fileTop + headerRegion);
                    if (overflowCounter != null) {
                        if (overflowCounter <= 0) return true;
                        overflowCounter--;
                    }
                }
                const lineHeight$1 = this.getLineHeight(lineIndex, false);
                if (absoluteLineTop > top - lineHeight$1 && absoluteLineTop < bottom) firstVisibleHunk ??= currentHunk;
                if (absoluteLineTop + lineHeight$1 > viewportCenter) centerHunk ??= currentHunk;
                if (overflowCounter == null && absoluteLineTop >= bottom && isAtHunkBoundary) overflowCounter = overflowHunks;
                currentLine++;
                absoluteLineTop += lineHeight$1;
                return false;
            }
        });
        if (firstVisibleHunk == null) return {
            startingLine: 0,
            totalLines: 0,
            bufferBefore: 0,
            bufferAfter: fileHeight - headerRegion - paddingBottom
        };
        centerHunk ??= firstVisibleHunk;
        const idealStartHunk = Math.round(centerHunk - totalHunks / 2);
        const maxStartHunk = Math.max(0, Math.ceil(lineCount / hunkLineCount) - totalHunks);
        const startHunk = Math.max(0, Math.min(idealStartHunk, maxStartHunk));
        const startingLine = startHunk * hunkLineCount;
        const clampedTotalLines = idealStartHunk < 0 ? totalLines + idealStartHunk * hunkLineCount : totalLines;
        const bufferBefore = hunkOffsets[startHunk] ?? 0;
        const finalHunkIndex = startHunk + clampedTotalLines / hunkLineCount;
        return {
            startingLine: startingLine,
            totalLines: clampedTotalLines,
            bufferBefore: bufferBefore,
            bufferAfter: finalHunkIndex < hunkOffsets.length ? fileHeight - headerRegion - hunkOffsets[finalHunkIndex] - paddingBottom : fileHeight - (absoluteLineTop - fileTop) - paddingBottom
        };
    }
};
function $04b40a9847bcadbe$var$getLastVisibleLineIndex(lines) {
    const lastLine = lines.at(-1);
    if (lastLine == null || lastLine === "" || lastLine === "\n" || lastLine === "\r\n" || lastLine === "\r") return lines.length - 2;
    return lines.length - 1;
}







//#region src/utils/iterateOverDiff.ts
function $14677931af57706f$export$62615825adc21c24({ diff: diff, diffStyle: diffStyle, startingLine: startingLine = 0, totalLines: totalLines = Infinity, expandedHunks: expandedHunks, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac), callback: callback }) {
    const iterationStart = $14677931af57706f$var$getIterationStartState({
        diff: diff,
        diffStyle: diffStyle,
        startingLine: startingLine,
        expandedHunks: expandedHunks,
        collapsedContextThreshold: collapsedContextThreshold
    });
    const state = {
        finalHunk: diff.hunks.at(-1),
        viewportStart: startingLine,
        viewportEnd: startingLine + totalLines,
        isWindowedHighlight: startingLine > 0 || totalLines < Infinity,
        splitCount: iterationStart.splitCount,
        unifiedCount: iterationStart.unifiedCount,
        shouldBreak () {
            if (!state.isWindowedHighlight) return false;
            const breakUnified = state.unifiedCount >= startingLine + totalLines;
            const breakSplit = state.splitCount >= startingLine + totalLines;
            if (diffStyle === "unified") return breakUnified;
            else if (diffStyle === "split") return breakSplit;
            else return breakUnified && breakSplit;
        },
        shouldSkip (unifiedHeight, splitHeight) {
            if (!state.isWindowedHighlight) return false;
            const skipUnified = state.unifiedCount + unifiedHeight < startingLine;
            const skipSplit = state.splitCount + splitHeight < startingLine;
            if (diffStyle === "unified") return skipUnified;
            else if (diffStyle === "split") return skipSplit;
            else return skipUnified && skipSplit;
        },
        incrementCounts (unifiedValue, splitValue) {
            if (diffStyle === "unified" || diffStyle === "both") state.unifiedCount += unifiedValue;
            if (diffStyle === "split" || diffStyle === "both") state.splitCount += splitValue;
        },
        isInWindow (unifiedHeight, splitHeight) {
            if (!state.isWindowedHighlight) return true;
            const unifiedInWindow = state.isInUnifiedWindow(unifiedHeight);
            const splitInWindow = state.isInSplitWindow(splitHeight);
            if (diffStyle === "unified") return unifiedInWindow;
            else if (diffStyle === "split") return splitInWindow;
            else return unifiedInWindow || splitInWindow;
        },
        isInUnifiedWindow (unifiedHeight) {
            return !state.isWindowedHighlight || state.unifiedCount >= startingLine - unifiedHeight && state.unifiedCount < startingLine + totalLines;
        },
        isInSplitWindow (splitHeight) {
            return !state.isWindowedHighlight || state.splitCount >= startingLine - splitHeight && state.splitCount < startingLine + totalLines;
        },
        emit (props, silent = false) {
            if (!silent) {
                if (diffStyle === "unified") state.incrementCounts(1, 0);
                else if (diffStyle === "split") state.incrementCounts(0, 1);
                else state.incrementCounts(1, 1);
            }
            return callback(props) ?? false;
        }
    };
    hunkIterator: for(let hunkIndex = iterationStart.hunkIndex; hunkIndex < diff.hunks.length; hunkIndex++){
        const hunk = diff.hunks[hunkIndex];
        if (hunk == null) throw new Error("iterateOverDiff: invalid hunk index");
        if (state.shouldBreak()) break;
        const leadingRegion = $14677931af57706f$var$getExpandedRegion(diff.isPartial, hunk.collapsedBefore, expandedHunks, hunkIndex, collapsedContextThreshold);
        const trailingRegion = (()=>{
            if (hunk !== state.finalHunk || !$14677931af57706f$var$hasFinalCollapsedHunk(diff)) return;
            const additionRemaining = diff.additionLines.length - (hunk.additionLineIndex + hunk.additionCount);
            const deletionRemaining = diff.deletionLines.length - (hunk.deletionLineIndex + hunk.deletionCount);
            if (additionRemaining !== deletionRemaining) throw new Error(`iterateOverDiff: trailing context mismatch (additions=${additionRemaining}, deletions=${deletionRemaining}) for ${diff.name}`);
            const trailingRangeSize = Math.min(additionRemaining, deletionRemaining);
            return $14677931af57706f$var$getExpandedRegion(diff.isPartial, trailingRangeSize, expandedHunks, diff.hunks.length, collapsedContextThreshold);
        })();
        const expandedLineCount = leadingRegion.fromStart + leadingRegion.fromEnd;
        function getTrailingCollapsedAfter(unifiedLineIndex$1, splitLineIndex$1) {
            if (trailingRegion == null || trailingRegion.collapsedLines <= 0 || trailingRegion.fromStart + trailingRegion.fromEnd > 0) return 0;
            if (diffStyle === "unified") return unifiedLineIndex$1 === hunk.unifiedLineStart + hunk.unifiedLineCount - 1 ? trailingRegion.collapsedLines : 0;
            return splitLineIndex$1 === hunk.splitLineStart + hunk.splitLineCount - 1 ? trailingRegion.collapsedLines : 0;
        }
        function getPendingCollapsed() {
            if (leadingRegion.collapsedLines === 0) return 0;
            const value = leadingRegion.collapsedLines;
            leadingRegion.collapsedLines = 0;
            return value;
        }
        if (!state.shouldSkip(expandedLineCount, expandedLineCount)) {
            let unifiedLineIndex$1 = hunk.unifiedLineStart - leadingRegion.rangeSize;
            let splitLineIndex$1 = hunk.splitLineStart - leadingRegion.rangeSize;
            let deletionLineIndex$1 = hunk.deletionLineIndex - leadingRegion.rangeSize;
            let additionLineIndex$1 = hunk.additionLineIndex - leadingRegion.rangeSize;
            let deletionLineNumber$1 = hunk.deletionStart - leadingRegion.rangeSize;
            let additionLineNumber$1 = hunk.additionStart - leadingRegion.rangeSize;
            const [startIndex, endIndex] = $14677931af57706f$var$getEqualLineIterationRange(state, leadingRegion.fromStart, diffStyle);
            if (startIndex > 0) state.incrementCounts(startIndex, startIndex);
            let index = startIndex;
            while(index < leadingRegion.fromStart){
                if (index >= endIndex) {
                    state.incrementCounts(leadingRegion.fromStart - index, leadingRegion.fromStart - index);
                    break;
                }
                if (state.isInWindow(0, 0)) {
                    if (state.emit({
                        hunkIndex: hunkIndex,
                        hunk: hunk,
                        collapsedBefore: 0,
                        collapsedAfter: 0,
                        type: "context-expanded",
                        deletionLine: {
                            lineNumber: deletionLineNumber$1 + index,
                            lineIndex: deletionLineIndex$1 + index,
                            noEOFCR: false,
                            unifiedLineIndex: unifiedLineIndex$1 + index,
                            splitLineIndex: splitLineIndex$1 + index
                        },
                        additionLine: {
                            unifiedLineIndex: unifiedLineIndex$1 + index,
                            splitLineIndex: splitLineIndex$1 + index,
                            lineIndex: additionLineIndex$1 + index,
                            lineNumber: additionLineNumber$1 + index,
                            noEOFCR: false
                        }
                    })) break hunkIterator;
                } else state.incrementCounts(1, 1);
                index++;
            }
            unifiedLineIndex$1 = hunk.unifiedLineStart - leadingRegion.fromEnd;
            splitLineIndex$1 = hunk.splitLineStart - leadingRegion.fromEnd;
            deletionLineIndex$1 = hunk.deletionLineIndex - leadingRegion.fromEnd;
            additionLineIndex$1 = hunk.additionLineIndex - leadingRegion.fromEnd;
            deletionLineNumber$1 = hunk.deletionStart - leadingRegion.fromEnd;
            additionLineNumber$1 = hunk.additionStart - leadingRegion.fromEnd;
            const [fromEndStartIndex, fromEndEndIndex] = $14677931af57706f$var$getEqualLineIterationRange(state, leadingRegion.fromEnd, diffStyle);
            if (fromEndStartIndex > 0) state.incrementCounts(fromEndStartIndex, fromEndStartIndex);
            index = fromEndStartIndex;
            while(index < leadingRegion.fromEnd){
                if (index >= fromEndEndIndex) {
                    state.incrementCounts(leadingRegion.fromEnd - index, leadingRegion.fromEnd - index);
                    break;
                }
                if (state.isInWindow(0, 0)) {
                    if (state.emit({
                        hunkIndex: hunkIndex,
                        hunk: hunk,
                        collapsedBefore: getPendingCollapsed(),
                        collapsedAfter: 0,
                        type: "context-expanded",
                        deletionLine: {
                            lineNumber: deletionLineNumber$1 + index,
                            lineIndex: deletionLineIndex$1 + index,
                            noEOFCR: false,
                            unifiedLineIndex: unifiedLineIndex$1 + index,
                            splitLineIndex: splitLineIndex$1 + index
                        },
                        additionLine: {
                            unifiedLineIndex: unifiedLineIndex$1 + index,
                            splitLineIndex: splitLineIndex$1 + index,
                            lineIndex: additionLineIndex$1 + index,
                            lineNumber: additionLineNumber$1 + index,
                            noEOFCR: false
                        }
                    })) break hunkIterator;
                } else state.incrementCounts(1, 1);
                index++;
            }
        } else {
            state.incrementCounts(expandedLineCount, expandedLineCount);
            getPendingCollapsed();
        }
        let unifiedLineIndex = hunk.unifiedLineStart;
        let splitLineIndex = hunk.splitLineStart;
        let deletionLineIndex = hunk.deletionLineIndex;
        let additionLineIndex = hunk.additionLineIndex;
        let deletionLineNumber = hunk.deletionStart;
        let additionLineNumber = hunk.additionStart;
        const lastContent = hunk.hunkContent.at(-1);
        for (const content of hunk.hunkContent){
            if (state.shouldBreak()) break hunkIterator;
            const isLastContent = content === lastContent;
            if (content.type === "context") {
                if (!state.shouldSkip(content.lines, content.lines)) {
                    const [startIndex, endIndex] = $14677931af57706f$var$getEqualLineIterationRange(state, content.lines, diffStyle);
                    if (startIndex > 0) state.incrementCounts(startIndex, startIndex);
                    let index = startIndex;
                    while(index < content.lines){
                        if (index >= endIndex) {
                            state.incrementCounts(content.lines - index, content.lines - index);
                            break;
                        }
                        if (state.isInWindow(0, 0)) {
                            const isLastLine = isLastContent && index === content.lines - 1;
                            const unifiedRowIndex = unifiedLineIndex + index;
                            const splitRowIndex = splitLineIndex + index;
                            if (state.emit({
                                hunkIndex: hunkIndex,
                                hunk: hunk,
                                collapsedBefore: getPendingCollapsed(),
                                collapsedAfter: getTrailingCollapsedAfter(unifiedRowIndex, splitRowIndex),
                                type: "context",
                                deletionLine: {
                                    lineNumber: deletionLineNumber + index,
                                    lineIndex: deletionLineIndex + index,
                                    noEOFCR: isLastLine && hunk.noEOFCRDeletions,
                                    unifiedLineIndex: unifiedRowIndex,
                                    splitLineIndex: splitRowIndex
                                },
                                additionLine: {
                                    unifiedLineIndex: unifiedRowIndex,
                                    splitLineIndex: splitRowIndex,
                                    lineIndex: additionLineIndex + index,
                                    lineNumber: additionLineNumber + index,
                                    noEOFCR: isLastLine && hunk.noEOFCRAdditions
                                }
                            })) break hunkIterator;
                        } else state.incrementCounts(1, 1);
                        index++;
                    }
                } else {
                    state.incrementCounts(content.lines, content.lines);
                    getPendingCollapsed();
                }
                unifiedLineIndex += content.lines;
                splitLineIndex += content.lines;
                deletionLineIndex += content.lines;
                additionLineIndex += content.lines;
                deletionLineNumber += content.lines;
                additionLineNumber += content.lines;
            } else {
                const splitCount = Math.max(content.deletions, content.additions);
                const unifiedCount = content.deletions + content.additions;
                if (!state.shouldSkip(unifiedCount, splitCount)) {
                    const iterationRanges = $14677931af57706f$var$getChangeIterationRanges(state, content, diffStyle);
                    for (const [rangeStart, rangeEnd] of iterationRanges)for(let index = rangeStart; index < rangeEnd; index++){
                        const collapsedAfter = getTrailingCollapsedAfter(unifiedLineIndex + index, diffStyle === "unified" ? splitLineIndex + (index < content.deletions ? index : index - content.deletions) : splitLineIndex + index);
                        if (state.emit($14677931af57706f$var$getChangeLineData({
                            hunkIndex: hunkIndex,
                            hunk: hunk,
                            collapsedBefore: getPendingCollapsed(),
                            collapsedAfter: collapsedAfter,
                            diffStyle: diffStyle,
                            index: index,
                            unifiedLineIndex: unifiedLineIndex,
                            splitLineIndex: splitLineIndex,
                            additionLineIndex: additionLineIndex,
                            deletionLineIndex: deletionLineIndex,
                            additionLineNumber: additionLineNumber,
                            deletionLineNumber: deletionLineNumber,
                            content: content,
                            isLastContent: isLastContent,
                            unifiedCount: unifiedCount,
                            splitCount: splitCount
                        }), true)) break hunkIterator;
                    }
                }
                getPendingCollapsed();
                state.incrementCounts(unifiedCount, splitCount);
                unifiedLineIndex += unifiedCount;
                splitLineIndex += splitCount;
                deletionLineIndex += content.deletions;
                additionLineIndex += content.additions;
                deletionLineNumber += content.deletions;
                additionLineNumber += content.additions;
            }
        }
        if (trailingRegion != null) {
            const { collapsedLines: collapsedLines, fromStart: fromStart, fromEnd: fromEnd } = trailingRegion;
            const len = fromStart + fromEnd;
            const [startIndex, endIndex] = $14677931af57706f$var$getEqualLineIterationRange(state, len, diffStyle);
            if (startIndex > 0) state.incrementCounts(startIndex, startIndex);
            let index = startIndex;
            while(index < len){
                if (state.shouldBreak()) break hunkIterator;
                if (index >= endIndex) {
                    state.incrementCounts(len - index, len - index);
                    break;
                }
                if (state.isInWindow(0, 0)) {
                    const isLastLine = index === len - 1;
                    if (state.emit({
                        hunkIndex: diff.hunks.length,
                        hunk: void 0,
                        collapsedBefore: 0,
                        collapsedAfter: isLastLine ? collapsedLines : 0,
                        type: "context-expanded",
                        deletionLine: {
                            lineNumber: deletionLineNumber + index,
                            lineIndex: deletionLineIndex + index,
                            noEOFCR: false,
                            unifiedLineIndex: unifiedLineIndex + index,
                            splitLineIndex: splitLineIndex + index
                        },
                        additionLine: {
                            unifiedLineIndex: unifiedLineIndex + index,
                            splitLineIndex: splitLineIndex + index,
                            lineIndex: additionLineIndex + index,
                            lineNumber: additionLineNumber + index,
                            noEOFCR: false
                        }
                    })) break hunkIterator;
                } else state.incrementCounts(1, 1);
                index++;
            }
        }
    }
}
function $14677931af57706f$var$getIterationStartState({ diff: diff, diffStyle: diffStyle, startingLine: startingLine, expandedHunks: expandedHunks, collapsedContextThreshold: collapsedContextThreshold }) {
    if (startingLine <= 0 || diffStyle === "both") return {
        hunkIndex: 0,
        splitCount: 0,
        unifiedCount: 0
    };
    const prefixCounts = $14677931af57706f$var$getHunkPrefixCounts({
        diff: diff,
        expandedHunks: expandedHunks,
        collapsedContextThreshold: collapsedContextThreshold
    });
    let low = 0;
    let high = diff.hunks.length - 1;
    let result = diff.hunks.length;
    while(low <= high){
        const mid = low + high >> 1;
        const counts$1 = prefixCounts[mid + 1];
        if (counts$1 == null) throw new Error("iterateOverDiff: invalid hunk prefix index");
        if ((diffStyle === "unified" ? counts$1.unifiedCount : counts$1.splitCount) > startingLine) {
            result = mid;
            high = mid - 1;
        } else low = mid + 1;
    }
    if (result >= diff.hunks.length) {
        const counts$1 = prefixCounts[diff.hunks.length];
        if (counts$1 == null) throw new Error("iterateOverDiff: invalid terminal hunk prefix index");
        return {
            hunkIndex: diff.hunks.length,
            splitCount: counts$1.splitCount,
            unifiedCount: counts$1.unifiedCount
        };
    }
    const counts = prefixCounts[result];
    if (counts == null) throw new Error("iterateOverDiff: invalid selected hunk prefix index");
    return {
        hunkIndex: result,
        splitCount: counts.splitCount,
        unifiedCount: counts.unifiedCount
    };
}
function $14677931af57706f$var$getHunkPrefixCounts({ diff: diff, expandedHunks: expandedHunks, collapsedContextThreshold: collapsedContextThreshold }) {
    let splitCount = 0;
    let unifiedCount = 0;
    const finalHunkIndex = diff.hunks.length - 1;
    const prefixCounts = [
        {
            splitCount: 0,
            unifiedCount: 0
        }
    ];
    for(let index = 0; index < diff.hunks.length; index++){
        const hunk = diff.hunks[index];
        if (hunk == null) throw new Error("iterateOverDiff: invalid hunk summary index");
        const leadingRegion = $14677931af57706f$var$getExpandedRegion(diff.isPartial, hunk.collapsedBefore, expandedHunks, index, collapsedContextThreshold);
        const leadingCount = leadingRegion.fromStart + leadingRegion.fromEnd;
        splitCount += leadingCount + hunk.splitLineCount;
        unifiedCount += leadingCount + hunk.unifiedLineCount;
        if (index === finalHunkIndex && $14677931af57706f$var$hasFinalCollapsedHunk(diff)) {
            const trailingRangeSize = $14677931af57706f$var$getTrailingRangeSize(diff, hunk);
            const trailingRegion = $14677931af57706f$var$getExpandedRegion(diff.isPartial, trailingRangeSize, expandedHunks, diff.hunks.length, collapsedContextThreshold);
            const trailingCount = trailingRegion.fromStart + trailingRegion.fromEnd;
            splitCount += trailingCount;
            unifiedCount += trailingCount;
        }
        prefixCounts.push({
            splitCount: splitCount,
            unifiedCount: unifiedCount
        });
    }
    return prefixCounts;
}
function $14677931af57706f$var$getEqualLineIterationRange(state, count, diffStyle) {
    if (!state.isWindowedHighlight || count <= 0) return [
        0,
        count
    ];
    const ranges = [];
    function pushRange(currentCount) {
        const start$1 = Math.max(0, state.viewportStart - currentCount);
        const end$1 = Math.min(count, state.viewportEnd - currentCount);
        if (end$1 > start$1) ranges.push([
            start$1,
            end$1
        ]);
    }
    if (diffStyle !== "split") pushRange(state.unifiedCount);
    if (diffStyle !== "unified") pushRange(state.splitCount);
    if (ranges.length === 0) return [
        0,
        0
    ];
    let start = ranges[0][0];
    let end = ranges[0][1];
    for(let index = 1; index < ranges.length; index++){
        const range = ranges[index];
        start = Math.min(start, range[0]);
        end = Math.max(end, range[1]);
    }
    return [
        start,
        end
    ];
}
function $14677931af57706f$var$getTrailingRangeSize(diff, hunk) {
    const additionRemaining = diff.additionLines.length - (hunk.additionLineIndex + hunk.additionCount);
    const deletionRemaining = diff.deletionLines.length - (hunk.deletionLineIndex + hunk.deletionCount);
    if (additionRemaining !== deletionRemaining) throw new Error(`iterateOverDiff: trailing context mismatch (additions=${additionRemaining}, deletions=${deletionRemaining}) for ${diff.name}`);
    return Math.min(additionRemaining, deletionRemaining);
}
function $14677931af57706f$var$getExpandedRegion(isPartial, rangeSize, expandedHunks, hunkIndex, collapsedContextThreshold) {
    rangeSize = Math.max(rangeSize, 0);
    if (rangeSize === 0 || isPartial) return {
        fromStart: 0,
        fromEnd: 0,
        rangeSize: rangeSize,
        collapsedLines: Math.max(rangeSize, 0)
    };
    if (expandedHunks === true || rangeSize <= collapsedContextThreshold) return {
        fromStart: rangeSize,
        fromEnd: 0,
        rangeSize: rangeSize,
        collapsedLines: 0
    };
    const region = expandedHunks?.get(hunkIndex);
    const fromStart = Math.min(Math.max(region?.fromStart ?? 0, 0), rangeSize);
    const fromEnd = Math.min(Math.max(region?.fromEnd ?? 0, 0), rangeSize);
    const expandedCount = fromStart + fromEnd;
    const renderAll = expandedCount >= rangeSize;
    return {
        fromStart: renderAll ? rangeSize : fromStart,
        fromEnd: renderAll ? 0 : fromEnd,
        rangeSize: rangeSize,
        collapsedLines: Math.max(rangeSize - expandedCount, 0)
    };
}
function $14677931af57706f$var$hasFinalCollapsedHunk(diff) {
    const lastHunk = diff.hunks.at(-1);
    if (lastHunk == null || diff.isPartial || diff.additionLines.length === 0 || diff.deletionLines.length === 0) return false;
    return lastHunk.additionLineIndex + lastHunk.additionCount < diff.additionLines.length || lastHunk.deletionLineIndex + lastHunk.deletionCount < diff.deletionLines.length;
}
function $14677931af57706f$var$getChangeIterationRanges(state, content, diffStyle) {
    if (!state.isWindowedHighlight) return [
        [
            0,
            diffStyle === "unified" ? content.deletions + content.additions : Math.max(content.deletions, content.additions)
        ]
    ];
    const useUnified = diffStyle !== "split";
    const useSplit = diffStyle !== "unified";
    const iterationSpace = diffStyle === "unified" ? "unified" : "split";
    const iterationRanges = [];
    function getVisibleRange(start, count) {
        if (start + count <= state.viewportStart || start >= state.viewportEnd) return;
        const visibleStart = Math.max(0, state.viewportStart - start);
        const visibleEnd = Math.min(count, state.viewportEnd - start);
        return visibleEnd > visibleStart ? [
            visibleStart,
            visibleEnd
        ] : void 0;
    }
    function mapRangeToIteration(range, kind) {
        if (iterationSpace === "split") return range;
        return kind === "additions" ? [
            range[0] + content.deletions,
            range[1] + content.deletions
        ] : range;
    }
    function pushRange(range, kind) {
        if (range == null) return;
        const [start, end] = mapRangeToIteration(range, kind);
        if (end > start) iterationRanges.push([
            start,
            end
        ]);
    }
    if (useUnified) {
        pushRange(getVisibleRange(state.unifiedCount, content.deletions), "deletions");
        pushRange(getVisibleRange(state.unifiedCount + content.deletions, content.additions), "additions");
    }
    if (useSplit) {
        pushRange(getVisibleRange(state.splitCount, content.deletions), "deletions");
        pushRange(getVisibleRange(state.splitCount, content.additions), "additions");
    }
    if (iterationRanges.length === 0) return iterationRanges;
    iterationRanges.sort((a, b)=>a[0] - b[0]);
    const merged = [
        iterationRanges[0]
    ];
    for (const [start, end] of iterationRanges.slice(1)){
        const last = merged[merged.length - 1];
        if (start <= last[1]) last[1] = Math.max(last[1], end);
        else merged.push([
            start,
            end
        ]);
    }
    return merged;
}
function $14677931af57706f$var$getChangeLineData({ hunkIndex: hunkIndex, hunk: hunk, collapsedAfter: collapsedAfter, collapsedBefore: collapsedBefore, diffStyle: diffStyle, index: index, unifiedLineIndex: unifiedLineIndex, splitLineIndex: splitLineIndex, additionLineIndex: additionLineIndex, deletionLineIndex: deletionLineIndex, additionLineNumber: additionLineNumber, deletionLineNumber: deletionLineNumber, content: content, isLastContent: isLastContent, unifiedCount: unifiedCount, splitCount: splitCount }) {
    const unifiedDeletionLineIndex = index < content.deletions ? unifiedLineIndex + index : void 0;
    const unifiedAdditionLineIndex = diffStyle === "unified" ? index >= content.deletions ? unifiedLineIndex + index : void 0 : index < content.additions ? unifiedLineIndex + content.deletions + index : void 0;
    const resolvedSplitLineIndex = diffStyle === "unified" ? splitLineIndex + (index < content.deletions ? index : index - content.deletions) : splitLineIndex + index;
    const deletionLineIndexValue = index < content.deletions ? deletionLineIndex + index : void 0;
    const deletionLineNumberValue = index < content.deletions ? deletionLineNumber + index : void 0;
    const additionLineIndexValue = diffStyle === "unified" ? index >= content.deletions ? additionLineIndex + (index - content.deletions) : void 0 : index < content.additions ? additionLineIndex + index : void 0;
    const additionLineNumberValue = diffStyle === "unified" ? index >= content.deletions ? additionLineNumber + (index - content.deletions) : void 0 : index < content.additions ? additionLineNumber + index : void 0;
    const noEOFCRDeletion = diffStyle === "unified" ? isLastContent && index === content.deletions - 1 && hunk.noEOFCRDeletions : isLastContent && index === splitCount - 1 && hunk.noEOFCRDeletions;
    const noEOFCRAddition = diffStyle === "unified" ? isLastContent && index === unifiedCount - 1 && hunk.noEOFCRAdditions : isLastContent && index === splitCount - 1 && hunk.noEOFCRAdditions;
    const deletionLine = deletionLineIndexValue != null && deletionLineNumberValue != null && unifiedDeletionLineIndex != null ? {
        lineNumber: deletionLineNumberValue,
        lineIndex: deletionLineIndexValue,
        noEOFCR: noEOFCRDeletion,
        unifiedLineIndex: unifiedDeletionLineIndex,
        splitLineIndex: resolvedSplitLineIndex
    } : void 0;
    const additionLine = additionLineIndexValue != null && additionLineNumberValue != null && unifiedAdditionLineIndex != null ? {
        unifiedLineIndex: unifiedAdditionLineIndex,
        splitLineIndex: resolvedSplitLineIndex,
        lineIndex: additionLineIndexValue,
        lineNumber: additionLineNumberValue,
        noEOFCR: noEOFCRAddition
    } : void 0;
    if (deletionLine == null && additionLine != null) return {
        type: "change",
        hunkIndex: hunkIndex,
        hunk: hunk,
        collapsedAfter: collapsedAfter,
        collapsedBefore: collapsedBefore,
        deletionLine: void 0,
        additionLine: additionLine
    };
    else if (deletionLine != null && additionLine == null) return {
        type: "change",
        hunkIndex: hunkIndex,
        hunk: hunk,
        collapsedAfter: collapsedAfter,
        collapsedBefore: collapsedBefore,
        deletionLine: deletionLine,
        additionLine: void 0
    };
    if (deletionLine == null || additionLine == null) throw new Error("iterateOverDiff: missing change line data");
    return {
        type: "change",
        hunkIndex: hunkIndex,
        hunk: hunk,
        collapsedAfter: collapsedAfter,
        collapsedBefore: collapsedBefore,
        deletionLine: deletionLine,
        additionLine: additionLine
    };
}




//#region src/utils/detachString.ts
const $3afaaa4566fbdd0b$var$stringDetachEncoder = new TextEncoder();
const $3afaaa4566fbdd0b$var$stringDetachDecoder = new TextDecoder("utf-8", {
    ignoreBOM: true
});
const $3afaaa4566fbdd0b$var$SURROGATE_CODE_UNIT_PATTERN = /[\uD800-\uDFFF]/;
const $3afaaa4566fbdd0b$var$STRING_DETACH_INITIAL_BUFFER_SIZE = 1024;
let $3afaaa4566fbdd0b$var$stringDetachBuffer = new Uint8Array($3afaaa4566fbdd0b$var$STRING_DETACH_INITIAL_BUFFER_SIZE);
function $3afaaa4566fbdd0b$export$670bae09e62de74c() {
    if ($3afaaa4566fbdd0b$var$stringDetachBuffer.length !== $3afaaa4566fbdd0b$var$STRING_DETACH_INITIAL_BUFFER_SIZE) $3afaaa4566fbdd0b$var$stringDetachBuffer = new Uint8Array($3afaaa4566fbdd0b$var$STRING_DETACH_INITIAL_BUFFER_SIZE);
}
function $3afaaa4566fbdd0b$export$2adfb951ae863eb8(value) {
    if (value.length === 0) return value;
    if ($3afaaa4566fbdd0b$var$SURROGATE_CODE_UNIT_PATTERN.test(value)) return JSON.parse(JSON.stringify(value));
    const requiredByteLength = value.length * 3;
    if ($3afaaa4566fbdd0b$var$stringDetachBuffer.length < requiredByteLength) $3afaaa4566fbdd0b$var$stringDetachBuffer = new Uint8Array(requiredByteLength);
    const { written: written } = $3afaaa4566fbdd0b$var$stringDetachEncoder.encodeInto(value, $3afaaa4566fbdd0b$var$stringDetachBuffer);
    return $3afaaa4566fbdd0b$var$stringDetachDecoder.decode($3afaaa4566fbdd0b$var$stringDetachBuffer.subarray(0, written));
}


//#region src/utils/parsePatchFiles.ts
function $9fe687489fc907dc$export$fe27c534897865ae(data, cacheKeyPrefix, throwOnError) {
    try {
        return $9fe687489fc907dc$var$_processPatch(data, cacheKeyPrefix, throwOnError);
    } finally{
        (0, $3afaaa4566fbdd0b$export$670bae09e62de74c)();
    }
}
function $9fe687489fc907dc$var$_processPatch(data, cacheKeyPrefix, throwOnError = false) {
    const isGitDiff = $9fe687489fc907dc$var$isGitDiffPatch(data);
    const rawFiles = isGitDiff ? $9fe687489fc907dc$var$splitAtLinePrefix(data, "diff --git") : data.split((0, $6986aac91971cc6d$export$78d496632eb5f480));
    let patchMetadata;
    const files = [];
    for (const fileOrPatchMetadata of rawFiles){
        if (isGitDiff && !(0, $6986aac91971cc6d$export$b75cb078234a235b).test(fileOrPatchMetadata)) {
            if (patchMetadata == null) patchMetadata = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(fileOrPatchMetadata);
            else if (throwOnError) throw Error("parsePatchContent: unknown file blob");
            else console.error("parsePatchContent: unknown file blob:", fileOrPatchMetadata);
            continue;
        } else if (!isGitDiff && !(0, $6986aac91971cc6d$export$78d496632eb5f480).test(fileOrPatchMetadata)) {
            if (patchMetadata == null) patchMetadata = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(fileOrPatchMetadata);
            else if (throwOnError) throw Error("parsePatchContent: unknown file blob");
            else console.error("parsePatchContent: unknown file blob:", fileOrPatchMetadata);
            continue;
        }
        const currentFile = $9fe687489fc907dc$var$_processFile(fileOrPatchMetadata, {
            cacheKey: cacheKeyPrefix != null ? `${cacheKeyPrefix}-${files.length}` : void 0,
            isGitDiff: isGitDiff,
            throwOnError: throwOnError
        });
        if (currentFile != null) files.push(currentFile);
    }
    return {
        patchMetadata: patchMetadata,
        files: files
    };
}
function $9fe687489fc907dc$export$e3af4d503e89baa0(fileDiffString, options) {
    try {
        return $9fe687489fc907dc$var$_processFile(fileDiffString, options);
    } finally{
        (0, $3afaaa4566fbdd0b$export$670bae09e62de74c)();
    }
}
function $9fe687489fc907dc$var$_processFile(fileDiffString, { cacheKey: cacheKey, isGitDiff: isGitDiff = (0, $6986aac91971cc6d$export$b75cb078234a235b).test(fileDiffString), oldFile: oldFile, newFile: newFile, throwOnError: throwOnError = false } = {}) {
    let lastHunkEnd = 0;
    const hunks = $9fe687489fc907dc$var$splitAtLinePrefix(fileDiffString, "@@ ");
    let currentFile;
    const isPartial = oldFile == null || newFile == null;
    let deletionLineIndex = 0;
    let additionLineIndex = 0;
    for (const hunk of hunks){
        const lines = $9fe687489fc907dc$var$splitWithNewlines(hunk);
        const firstLine = lines[0];
        if (firstLine == null) {
            if (throwOnError) throw Error("parsePatchContent: invalid hunk");
            else console.error("parsePatchContent: invalid hunk", hunk);
            continue;
        }
        const fileHeader = $9fe687489fc907dc$var$parseHunkHeader(firstLine);
        let additionLines = 0;
        let deletionLines = 0;
        if (fileHeader == null || currentFile == null) {
            if (currentFile != null) {
                if (throwOnError) throw Error("parsePatchContent: Invalid hunk");
                else console.error("parsePatchContent: Invalid hunk", hunk);
                continue;
            }
            currentFile = {
                name: "",
                type: "change",
                hunks: [],
                splitLineCount: 0,
                unifiedLineCount: 0,
                isPartial: isPartial,
                additionLines: !isPartial && oldFile != null && newFile != null ? $9fe687489fc907dc$var$splitFileContents(newFile.contents) : [],
                deletionLines: !isPartial && oldFile != null && newFile != null ? $9fe687489fc907dc$var$splitFileContents(oldFile.contents) : [],
                cacheKey: $9fe687489fc907dc$var$maybeDetachOptionalString(cacheKey)
            };
            if (currentFile.additionLines.length === 1 && newFile?.contents === "") currentFile.additionLines.length = 0;
            if (currentFile.deletionLines.length === 1 && oldFile?.contents === "") currentFile.deletionLines.length = 0;
            for (const line of lines){
                if (line.startsWith("diff --git")) {
                    const [, , prevName, , name] = line.trim().match((0, $6986aac91971cc6d$export$29edab3653b8abd8)) ?? [];
                    currentFile.name = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(name.trim());
                    if (prevName !== name) currentFile.prevName = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(prevName.trim());
                    continue;
                }
                const filenameMatch = line.startsWith("---") || line.startsWith("+++") ? line.match(isGitDiff ? (0, $6986aac91971cc6d$export$5f2aa894870f6d12) : (0, $6986aac91971cc6d$export$9ebdc190d177668f)) : null;
                if (filenameMatch != null) {
                    const [, type, fileName] = filenameMatch;
                    if (type === "---" && fileName !== "/dev/null") {
                        const detachedFileName = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(fileName.trim());
                        currentFile.prevName = detachedFileName;
                        currentFile.name = detachedFileName;
                    } else if (type === "+++" && fileName !== "/dev/null") currentFile.name = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(fileName.trim());
                } else if (isGitDiff) {
                    if (line.startsWith("new mode ")) currentFile.mode = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(line.slice(8).trim());
                    if (line.startsWith("old mode ")) currentFile.prevMode = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(line.slice(8).trim());
                    if (line.startsWith("new file mode")) {
                        currentFile.type = "new";
                        currentFile.mode = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(line.slice(13).trim());
                    }
                    if (line.startsWith("deleted file mode")) {
                        currentFile.type = "deleted";
                        currentFile.mode = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(line.slice(17).trim());
                    }
                    if (line.startsWith("similarity index")) {
                        if (line.startsWith("similarity index 100%")) currentFile.type = "rename-pure";
                        else currentFile.type = "rename-changed";
                    }
                    if (line.startsWith("index ")) {
                        const [, prevObjectId, newObjectId, mode] = line.trim().match((0, $6986aac91971cc6d$export$9ef7bb7f59189d)) ?? [];
                        if (prevObjectId != null) currentFile.prevObjectId = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(prevObjectId);
                        if (newObjectId != null) currentFile.newObjectId = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(newObjectId);
                        if (mode != null) currentFile.mode = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(mode);
                    }
                    if (line.startsWith("rename from ")) currentFile.prevName = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(line.slice(12).trim());
                    if (line.startsWith("rename to ")) currentFile.name = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(line.slice(10).trim());
                }
            }
            continue;
        }
        let currentContent;
        let lastLineType;
        while(lines.length > 0 && (lines[lines.length - 1] === "\n" || lines[lines.length - 1] === "\r" || lines[lines.length - 1] === "\r\n" || lines[lines.length - 1] === ""))lines.pop();
        const { additionStart: additionStart, deletionStart: deletionStart } = fileHeader;
        deletionLineIndex = isPartial ? deletionLineIndex : deletionStart - 1;
        additionLineIndex = isPartial ? additionLineIndex : additionStart - 1;
        const hunkData = {
            collapsedBefore: 0,
            splitLineCount: 0,
            splitLineStart: 0,
            unifiedLineCount: 0,
            unifiedLineStart: 0,
            additionCount: fileHeader.additionCount,
            additionStart: additionStart,
            additionLines: additionLines,
            deletionCount: fileHeader.deletionCount,
            deletionStart: deletionStart,
            deletionLines: deletionLines,
            deletionLineIndex: deletionLineIndex,
            additionLineIndex: additionLineIndex,
            hunkContent: [],
            hunkContext: $9fe687489fc907dc$var$maybeDetachOptionalString(fileHeader.hunkContext),
            hunkSpecs: (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(firstLine),
            noEOFCRAdditions: false,
            noEOFCRDeletions: false
        };
        let parsedAdditionLines = 0;
        let parsedDeletionLines = 0;
        for(let lineIndex = 1; lineIndex < lines.length; lineIndex++){
            const rawLine = lines[lineIndex];
            if (parsedAdditionLines >= hunkData.additionCount && parsedDeletionLines >= hunkData.deletionCount && !rawLine.startsWith("\\")) break;
            const firstChar = rawLine[0];
            if (firstChar !== "+" && firstChar !== "-" && firstChar !== " " && firstChar !== "\\") {
                console.error(`parseLineType: Invalid firstChar: "${firstChar}", full line: "${rawLine}"`);
                console.error("processFile: invalid rawLine:", rawLine);
                continue;
            }
            const type = $9fe687489fc907dc$var$parseRawLineType(firstChar);
            if (type === "addition") {
                const line = $9fe687489fc907dc$var$getParsedLineContent(rawLine);
                if (currentContent == null || currentContent.type !== "change") {
                    currentContent = $9fe687489fc907dc$var$createContentGroup("change", deletionLineIndex, additionLineIndex);
                    hunkData.hunkContent.push(currentContent);
                }
                additionLineIndex++;
                parsedAdditionLines++;
                if (isPartial) currentFile.additionLines.push(line);
                currentContent.additions++;
                additionLines++;
                lastLineType = "addition";
            } else if (type === "deletion") {
                const line = $9fe687489fc907dc$var$getParsedLineContent(rawLine);
                if (currentContent == null || currentContent.type !== "change") {
                    currentContent = $9fe687489fc907dc$var$createContentGroup("change", deletionLineIndex, additionLineIndex);
                    hunkData.hunkContent.push(currentContent);
                }
                deletionLineIndex++;
                parsedDeletionLines++;
                if (isPartial) currentFile.deletionLines.push(line);
                currentContent.deletions++;
                deletionLines++;
                lastLineType = "deletion";
            } else if (type === "context") {
                const line = $9fe687489fc907dc$var$getParsedLineContent(rawLine);
                if (currentContent == null || currentContent.type !== "context") {
                    currentContent = $9fe687489fc907dc$var$createContentGroup("context", deletionLineIndex, additionLineIndex);
                    hunkData.hunkContent.push(currentContent);
                }
                additionLineIndex++;
                deletionLineIndex++;
                parsedAdditionLines++;
                parsedDeletionLines++;
                if (isPartial) {
                    currentFile.deletionLines.push(line);
                    currentFile.additionLines.push(line);
                }
                currentContent.lines++;
                lastLineType = "context";
            } else if (type === "metadata" && currentContent != null) {
                if (currentContent.type === "context") {
                    hunkData.noEOFCRAdditions = true;
                    hunkData.noEOFCRDeletions = true;
                } else if (lastLineType === "deletion") hunkData.noEOFCRDeletions = true;
                else if (lastLineType === "addition") hunkData.noEOFCRAdditions = true;
                if (isPartial && (lastLineType === "addition" || lastLineType === "context")) {
                    const lastIndex = currentFile.additionLines.length - 1;
                    if (lastIndex >= 0) currentFile.additionLines[lastIndex] = (0, $edf66b00d8168e8a$export$b6130a543868c75e)(currentFile.additionLines[lastIndex]);
                }
                if (isPartial && (lastLineType === "deletion" || lastLineType === "context")) {
                    const lastIndex = currentFile.deletionLines.length - 1;
                    if (lastIndex >= 0) currentFile.deletionLines[lastIndex] = (0, $edf66b00d8168e8a$export$b6130a543868c75e)(currentFile.deletionLines[lastIndex]);
                }
            }
        }
        hunkData.additionLines = additionLines;
        hunkData.deletionLines = deletionLines;
        hunkData.collapsedBefore = Math.max(hunkData.additionStart - 1 - lastHunkEnd, 0);
        currentFile.hunks.push(hunkData);
        lastHunkEnd = hunkData.additionStart + hunkData.additionCount - 1;
        for (const content of hunkData.hunkContent)if (content.type === "context") {
            hunkData.splitLineCount += content.lines;
            hunkData.unifiedLineCount += content.lines;
        } else {
            hunkData.splitLineCount += Math.max(content.additions, content.deletions);
            hunkData.unifiedLineCount += content.deletions + content.additions;
        }
        hunkData.splitLineStart = currentFile.splitLineCount + hunkData.collapsedBefore;
        hunkData.unifiedLineStart = currentFile.unifiedLineCount + hunkData.collapsedBefore;
        currentFile.splitLineCount += hunkData.collapsedBefore + hunkData.splitLineCount;
        currentFile.unifiedLineCount += hunkData.collapsedBefore + hunkData.unifiedLineCount;
    }
    if (currentFile == null) return;
    if (currentFile.hunks.length > 0 && !isPartial && currentFile.additionLines.length > 0 && currentFile.deletionLines.length > 0) {
        const lastHunk = currentFile.hunks[currentFile.hunks.length - 1];
        const lastHunkEnd$1 = lastHunk.additionStart + lastHunk.additionCount - 1;
        const totalFileLines = currentFile.additionLines.length;
        const collapsedAfter = Math.max(totalFileLines - lastHunkEnd$1, 0);
        currentFile.splitLineCount += collapsedAfter;
        currentFile.unifiedLineCount += collapsedAfter;
    }
    if (!isGitDiff) {
        if (currentFile.prevName != null && currentFile.name !== currentFile.prevName) {
            if (currentFile.hunks.length > 0) currentFile.type = "rename-changed";
            else currentFile.type = "rename-pure";
        } else if ((oldFile == null || oldFile.contents === "") && newFile != null && newFile.contents !== "") currentFile.type = "new";
        else if (oldFile != null && oldFile.contents !== "" && (newFile == null || newFile.contents === "")) currentFile.type = "deleted";
    }
    if (currentFile.type !== "rename-pure" && currentFile.type !== "rename-changed") currentFile.prevName = void 0;
    return currentFile;
}
/**
* Parses a patch file string into an array of parsed patches.
*
* @param data - The raw patch file content (supports multi-commit patches)
* @param cacheKeyPrefix - Optional prefix for generating cache keys. When provided,
*   each file in the patch will get a cache key in the format `prefix-patchIndex-fileIndex`.
*   This enables caching of rendered diff results in the worker pool.
*/ function $9fe687489fc907dc$export$31a4476216ccf196(data, cacheKeyPrefix, throwOnError = false) {
    const patches = [];
    const rawPatches = $9fe687489fc907dc$var$hasCommitMetadataBoundary(data) ? data.split((0, $6986aac91971cc6d$export$64db5225fde41a22)) : [
        data
    ];
    for (const patch of rawPatches)try {
        patches.push($9fe687489fc907dc$export$fe27c534897865ae(patch, cacheKeyPrefix != null ? `${cacheKeyPrefix}-${patches.length}` : void 0, throwOnError));
    } catch (error) {
        if (throwOnError) throw error;
        else console.error(error);
    }
    return patches;
}
function $9fe687489fc907dc$var$hasCommitMetadataBoundary(data) {
    return data.startsWith("From ") || data.includes("\nFrom ");
}
function $9fe687489fc907dc$var$splitFileContents(contents) {
    const lines = $9fe687489fc907dc$var$splitWithNewlines(contents);
    for(let index = 0; index < lines.length; index++)lines[index] = (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(lines[index]);
    return lines;
}
function $9fe687489fc907dc$var$splitWithNewlines(contents) {
    if (contents.length === 0) return [
        ""
    ];
    const lines = [];
    let startIndex = 0;
    for(;;){
        const newlineIndex = contents.indexOf("\n", startIndex);
        if (newlineIndex === -1) break;
        lines.push(contents.slice(startIndex, newlineIndex + 1));
        startIndex = newlineIndex + 1;
    }
    if (startIndex < contents.length) lines.push(contents.slice(startIndex));
    return lines;
}
function $9fe687489fc907dc$var$parseHunkHeader(line) {
    if (!line.startsWith("@@ -")) return;
    let index = 4;
    const deletionStartResult = $9fe687489fc907dc$var$readPositiveInteger(line, index);
    if (deletionStartResult == null) return;
    const deletionStart = deletionStartResult.value;
    index = deletionStartResult.endIndex;
    let deletionCount = 1;
    if (line[index] === ",") {
        const deletionCountResult = $9fe687489fc907dc$var$readPositiveInteger(line, index + 1);
        if (deletionCountResult == null) return;
        deletionCount = deletionCountResult.value;
        index = deletionCountResult.endIndex;
    }
    if (line[index] !== " " || line[index + 1] !== "+") return;
    index += 2;
    const additionStartResult = $9fe687489fc907dc$var$readPositiveInteger(line, index);
    if (additionStartResult == null) return;
    const additionStart = additionStartResult.value;
    index = additionStartResult.endIndex;
    let additionCount = 1;
    if (line[index] === ",") {
        const additionCountResult = $9fe687489fc907dc$var$readPositiveInteger(line, index + 1);
        if (additionCountResult == null) return;
        additionCount = additionCountResult.value;
        index = additionCountResult.endIndex;
    }
    if (line[index] !== " " || line[index + 1] !== "@" || line[index + 2] !== "@") return;
    let hunkContext;
    const contextStartIndex = index + 3;
    if (line[contextStartIndex] === " ") hunkContext = $9fe687489fc907dc$var$trimLineEnd(line.slice(contextStartIndex + 1));
    return {
        additionCount: additionCount,
        additionStart: additionStart,
        deletionCount: deletionCount,
        deletionStart: deletionStart,
        hunkContext: hunkContext
    };
}
function $9fe687489fc907dc$var$readPositiveInteger(value, startIndex) {
    let index = startIndex;
    let parsedValue = 0;
    for(; index < value.length; index++){
        const digit = value.charCodeAt(index) - 48;
        if (digit < 0 || digit > 9) break;
        parsedValue = parsedValue * 10 + digit;
    }
    if (index === startIndex) return;
    return {
        value: parsedValue,
        endIndex: index
    };
}
function $9fe687489fc907dc$var$trimLineEnd(value) {
    if (value.endsWith("\r\n")) return value.slice(0, -2);
    if (value.endsWith("\n")) return value.slice(0, -1);
    return value;
}
function $9fe687489fc907dc$var$isGitDiffPatch(data) {
    return data.startsWith("diff --git") || data.includes("\ndiff --git");
}
function $9fe687489fc907dc$var$splitAtLinePrefix(contents, prefix) {
    if (contents.length === 0) return [
        ""
    ];
    const newlinePrefix = `\n${prefix}`;
    const firstBoundaryIndex = contents.startsWith(prefix) ? 0 : $9fe687489fc907dc$var$findLinePrefixIndex(contents, newlinePrefix, 0);
    if (firstBoundaryIndex === -1) return [
        contents
    ];
    const parts = [];
    if (firstBoundaryIndex > 0) parts.push(contents.slice(0, firstBoundaryIndex));
    let startIndex = firstBoundaryIndex;
    for(;;){
        const nextBoundaryIndex = $9fe687489fc907dc$var$findLinePrefixIndex(contents, newlinePrefix, startIndex + 1);
        if (nextBoundaryIndex === -1) break;
        parts.push(contents.slice(startIndex, nextBoundaryIndex));
        startIndex = nextBoundaryIndex;
    }
    parts.push(contents.slice(startIndex));
    return parts;
}
function $9fe687489fc907dc$var$findLinePrefixIndex(contents, newlinePrefix, fromIndex) {
    const index = contents.indexOf(newlinePrefix, fromIndex);
    return index === -1 ? -1 : index + 1;
}
function $9fe687489fc907dc$var$maybeDetachOptionalString(value) {
    return value == null ? value : (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(value);
}
function $9fe687489fc907dc$var$parseRawLineType(firstChar) {
    return firstChar === " " ? "context" : firstChar === "\\" ? "metadata" : firstChar === "+" ? "addition" : "deletion";
}
function $9fe687489fc907dc$var$getParsedLineContent(rawLine) {
    const processedLine = rawLine.slice(1);
    return (0, $3afaaa4566fbdd0b$export$2adfb951ae863eb8)(processedLine === "" ? "\n" : processedLine);
}
function $9fe687489fc907dc$var$createContentGroup(type, deletionLineIndex, additionLineIndex) {
    if (type === "change") return {
        type: "change",
        additions: 0,
        deletions: 0,
        additionLineIndex: additionLineIndex,
        deletionLineIndex: deletionLineIndex
    };
    return {
        type: "context",
        lines: 0,
        additionLineIndex: additionLineIndex,
        deletionLineIndex: deletionLineIndex
    };
}


class $d57b1677955bba91$export$2e2bcd8739ae039 {
    diff(oldStr, newStr, // Type below is not accurate/complete - see above for full possibilities - but it compiles
    options = {}) {
        let callback;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        } else if ('callback' in options) callback = options.callback;
        // Allow subclasses to massage the input prior to running
        const oldString = this.castInput(oldStr, options);
        const newString = this.castInput(newStr, options);
        const oldTokens = this.removeEmpty(this.tokenize(oldString, options));
        const newTokens = this.removeEmpty(this.tokenize(newString, options));
        return this.diffWithOptionsObj(oldTokens, newTokens, options, callback);
    }
    diffWithOptionsObj(oldTokens, newTokens, options, callback) {
        var _a;
        const done = (value)=>{
            value = this.postProcess(value, options);
            if (callback) {
                setTimeout(function() {
                    callback(value);
                }, 0);
                return undefined;
            } else return value;
        };
        const newLen = newTokens.length, oldLen = oldTokens.length;
        let editLength = 1;
        let maxEditLength = newLen + oldLen;
        if (options.maxEditLength != null) maxEditLength = Math.min(maxEditLength, options.maxEditLength);
        const maxExecutionTime = (_a = options.timeout) !== null && _a !== void 0 ? _a : Infinity;
        const abortAfterTimestamp = Date.now() + maxExecutionTime;
        const bestPath = [
            {
                oldPos: -1,
                lastComponent: undefined
            }
        ];
        // Seed editLength = 0, i.e. the content starts with the same values
        let newPos = this.extractCommon(bestPath[0], newTokens, oldTokens, 0, options);
        if (bestPath[0].oldPos + 1 >= oldLen && newPos + 1 >= newLen) // Identity per the equality and tokenizer
        return done(this.buildValues(bestPath[0].lastComponent, newTokens, oldTokens));
        // Once we hit the right edge of the edit graph on some diagonal k, we can
        // definitely reach the end of the edit graph in no more than k edits, so
        // there's no point in considering any moves to diagonal k+1 any more (from
        // which we're guaranteed to need at least k+1 more edits).
        // Similarly, once we've reached the bottom of the edit graph, there's no
        // point considering moves to lower diagonals.
        // We record this fact by setting minDiagonalToConsider and
        // maxDiagonalToConsider to some finite value once we've hit the edge of
        // the edit graph.
        // This optimization is not faithful to the original algorithm presented in
        // Myers's paper, which instead pointlessly extends D-paths off the end of
        // the edit graph - see page 7 of Myers's paper which notes this point
        // explicitly and illustrates it with a diagram. This has major performance
        // implications for some common scenarios. For instance, to compute a diff
        // where the new text simply appends d characters on the end of the
        // original text of length n, the true Myers algorithm will take O(n+d^2)
        // time while this optimization needs only O(n+d) time.
        let minDiagonalToConsider = -Infinity, maxDiagonalToConsider = Infinity;
        // Main worker method. checks all permutations of a given edit length for acceptance.
        const execEditLength = ()=>{
            for(let diagonalPath = Math.max(minDiagonalToConsider, -editLength); diagonalPath <= Math.min(maxDiagonalToConsider, editLength); diagonalPath += 2){
                let basePath;
                const removePath = bestPath[diagonalPath - 1], addPath = bestPath[diagonalPath + 1];
                if (removePath) // No one else is going to attempt to use this value, clear it
                // @ts-expect-error - perf optimisation. This type-violating value will never be read.
                bestPath[diagonalPath - 1] = undefined;
                let canAdd = false;
                if (addPath) {
                    // what newPos will be after we do an insertion:
                    const addPathNewPos = addPath.oldPos - diagonalPath;
                    canAdd = addPath && 0 <= addPathNewPos && addPathNewPos < newLen;
                }
                const canRemove = removePath && removePath.oldPos + 1 < oldLen;
                if (!canAdd && !canRemove) {
                    // If this path is a terminal then prune
                    // @ts-expect-error - perf optimisation. This type-violating value will never be read.
                    bestPath[diagonalPath] = undefined;
                    continue;
                }
                // Select the diagonal that we want to branch from. We select the prior
                // path whose position in the old string is the farthest from the origin
                // and does not pass the bounds of the diff graph
                if (!canRemove || canAdd && removePath.oldPos < addPath.oldPos) basePath = this.addToPath(addPath, true, false, 0, options);
                else basePath = this.addToPath(removePath, false, true, 1, options);
                newPos = this.extractCommon(basePath, newTokens, oldTokens, diagonalPath, options);
                if (basePath.oldPos + 1 >= oldLen && newPos + 1 >= newLen) // If we have hit the end of both strings, then we are done
                return done(this.buildValues(basePath.lastComponent, newTokens, oldTokens)) || true;
                else {
                    bestPath[diagonalPath] = basePath;
                    if (basePath.oldPos + 1 >= oldLen) maxDiagonalToConsider = Math.min(maxDiagonalToConsider, diagonalPath - 1);
                    if (newPos + 1 >= newLen) minDiagonalToConsider = Math.max(minDiagonalToConsider, diagonalPath + 1);
                }
            }
            editLength++;
        };
        // Performs the length of edit iteration. Is a bit fugly as this has to support the
        // sync and async mode which is never fun. Loops over execEditLength until a value
        // is produced, or until the edit length exceeds options.maxEditLength (if given),
        // in which case it will return undefined.
        if (callback) (function exec() {
            setTimeout(function() {
                if (editLength > maxEditLength || Date.now() > abortAfterTimestamp) return callback(undefined);
                if (!execEditLength()) exec();
            }, 0);
        })();
        else while(editLength <= maxEditLength && Date.now() <= abortAfterTimestamp){
            const ret = execEditLength();
            if (ret) return ret;
        }
    }
    addToPath(path, added, removed, oldPosInc, options) {
        const last = path.lastComponent;
        if (last && !options.oneChangePerToken && last.added === added && last.removed === removed) return {
            oldPos: path.oldPos + oldPosInc,
            lastComponent: {
                count: last.count + 1,
                added: added,
                removed: removed,
                previousComponent: last.previousComponent
            }
        };
        else return {
            oldPos: path.oldPos + oldPosInc,
            lastComponent: {
                count: 1,
                added: added,
                removed: removed,
                previousComponent: last
            }
        };
    }
    extractCommon(basePath, newTokens, oldTokens, diagonalPath, options) {
        const newLen = newTokens.length, oldLen = oldTokens.length;
        let oldPos = basePath.oldPos, newPos = oldPos - diagonalPath, commonCount = 0;
        while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(oldTokens[oldPos + 1], newTokens[newPos + 1], options)){
            newPos++;
            oldPos++;
            commonCount++;
            if (options.oneChangePerToken) basePath.lastComponent = {
                count: 1,
                previousComponent: basePath.lastComponent,
                added: false,
                removed: false
            };
        }
        if (commonCount && !options.oneChangePerToken) basePath.lastComponent = {
            count: commonCount,
            previousComponent: basePath.lastComponent,
            added: false,
            removed: false
        };
        basePath.oldPos = oldPos;
        return newPos;
    }
    equals(left, right, options) {
        if (options.comparator) return options.comparator(left, right);
        else return left === right || !!options.ignoreCase && left.toLowerCase() === right.toLowerCase();
    }
    removeEmpty(array) {
        const ret = [];
        for(let i = 0; i < array.length; i++)if (array[i]) ret.push(array[i]);
        return ret;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    castInput(value, options) {
        return value;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tokenize(value, options) {
        return Array.from(value);
    }
    join(chars) {
        // Assumes ValueT is string, which is the case for most subclasses.
        // When it's false, e.g. in diffArrays, this method needs to be overridden (e.g. with a no-op)
        // Yes, the casts are verbose and ugly, because this pattern - of having the base class SORT OF
        // assume tokens and values are strings, but not completely - is weird and janky.
        return chars.join('');
    }
    postProcess(changeObjects, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    options) {
        return changeObjects;
    }
    get useLongestToken() {
        return false;
    }
    buildValues(lastComponent, newTokens, oldTokens) {
        // First we convert our linked list of components in reverse order to an
        // array in the right order:
        const components = [];
        let nextComponent;
        while(lastComponent){
            components.push(lastComponent);
            nextComponent = lastComponent.previousComponent;
            delete lastComponent.previousComponent;
            lastComponent = nextComponent;
        }
        components.reverse();
        const componentLen = components.length;
        let componentPos = 0, newPos = 0, oldPos = 0;
        for(; componentPos < componentLen; componentPos++){
            const component = components[componentPos];
            if (!component.removed) {
                if (!component.added && this.useLongestToken) {
                    let value = newTokens.slice(newPos, newPos + component.count);
                    value = value.map(function(value, i) {
                        const oldValue = oldTokens[oldPos + i];
                        return oldValue.length > value.length ? oldValue : value;
                    });
                    component.value = this.join(value);
                } else component.value = this.join(newTokens.slice(newPos, newPos + component.count));
                newPos += component.count;
                // Common case
                if (!component.added) oldPos += component.count;
            } else {
                component.value = this.join(oldTokens.slice(oldPos, oldPos + component.count));
                oldPos += component.count;
            }
        }
        return components;
    }
}


function $c3f8fcbd3f3d9b12$export$c21133b4499f5374(options, defaults) {
    if (typeof options === 'function') defaults.callback = options;
    else if (options) {
        for(const name in options)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(options, name)) defaults[name] = options[name];
    }
    return defaults;
}


class $4fe1fd1ffdae67cc$var$LineDiff extends (0, $d57b1677955bba91$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        this.tokenize = $4fe1fd1ffdae67cc$export$660b2ee2d4fb4eff;
    }
    equals(left, right, options) {
        // If we're ignoring whitespace, we need to normalise lines by stripping
        // whitespace before checking equality. (This has an annoying interaction
        // with newlineIsToken that requires special handling: if newlines get their
        // own token, then we DON'T want to trim the *newline* tokens down to empty
        // strings, since this would cause us to treat whitespace-only line content
        // as equal to a separator between lines, which would be weird and
        // inconsistent with the documented behavior of the options.)
        if (options.ignoreWhitespace) {
            if (!options.newlineIsToken || !left.includes('\n')) left = left.trim();
            if (!options.newlineIsToken || !right.includes('\n')) right = right.trim();
        } else if (options.ignoreNewlineAtEof && !options.newlineIsToken) {
            if (left.endsWith('\n')) left = left.slice(0, -1);
            if (right.endsWith('\n')) right = right.slice(0, -1);
        }
        return super.equals(left, right, options);
    }
}
const $4fe1fd1ffdae67cc$export$ab62ee490ea249f1 = new $4fe1fd1ffdae67cc$var$LineDiff();
function $4fe1fd1ffdae67cc$export$a2a88fc03c6c0a3(oldStr, newStr, options) {
    return $4fe1fd1ffdae67cc$export$ab62ee490ea249f1.diff(oldStr, newStr, options);
}
function $4fe1fd1ffdae67cc$export$cd9eeaf4d4607510(oldStr, newStr, options) {
    options = (0, $c3f8fcbd3f3d9b12$export$c21133b4499f5374)(options, {
        ignoreWhitespace: true
    });
    return $4fe1fd1ffdae67cc$export$ab62ee490ea249f1.diff(oldStr, newStr, options);
}
function $4fe1fd1ffdae67cc$export$660b2ee2d4fb4eff(value, options) {
    if (options.stripTrailingCr) // remove one \r before \n to match GNU diff's --strip-trailing-cr behavior
    value = value.replace(/\r\n/g, '\n');
    const retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/);
    // Ignore the final empty token that occurs if the string ends with a new line
    if (!linesAndNewlines[linesAndNewlines.length - 1]) linesAndNewlines.pop();
    // Merge the content and line separators into single tokens
    for(let i = 0; i < linesAndNewlines.length; i++){
        const line = linesAndNewlines[i];
        if (i % 2 && !options.newlineIsToken) retLines[retLines.length - 1] += line;
        else retLines.push(line);
    }
    return retLines;
}


const $e8dc251f16a342f7$export$6fe85aa6792db095 = {
    includeIndex: true,
    includeUnderline: true,
    includeFileHeaders: true
};
const $e8dc251f16a342f7$export$fad80516f75fcf57 = {
    includeIndex: false,
    includeUnderline: false,
    includeFileHeaders: true
};
const $e8dc251f16a342f7$export$1624e873a123e1d0 = {
    includeIndex: false,
    includeUnderline: false,
    includeFileHeaders: false
};
function $e8dc251f16a342f7$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
    let optionsObj;
    if (!options) optionsObj = {};
    else if (typeof options === 'function') optionsObj = {
        callback: options
    };
    else optionsObj = options;
    if (typeof optionsObj.context === 'undefined') optionsObj.context = 4;
    // We copy this into its own variable to placate TypeScript, which thinks
    // optionsObj.context might be undefined in the callbacks below.
    const context = optionsObj.context;
    // @ts-expect-error (runtime check for something that is correctly a static type error)
    if (optionsObj.newlineIsToken) throw new Error('newlineIsToken may not be used with patch-generation functions, only with diffing functions');
    if (!optionsObj.callback) return diffLinesResultToPatch((0, $4fe1fd1ffdae67cc$export$a2a88fc03c6c0a3)(oldStr, newStr, optionsObj));
    else {
        const { callback: callback } = optionsObj;
        (0, $4fe1fd1ffdae67cc$export$a2a88fc03c6c0a3)(oldStr, newStr, Object.assign(Object.assign({}, optionsObj), {
            callback: (diff)=>{
                const patch = diffLinesResultToPatch(diff);
                // TypeScript is unhappy without the cast because it does not understand that `patch` may
                // be undefined here only if `callback` is StructuredPatchCallbackAbortable:
                callback(patch);
            }
        }));
    }
    function diffLinesResultToPatch(diff) {
        // STEP 1: Build up the patch with no "\ No newline at end of file" lines and with the arrays
        //         of lines containing trailing newline characters. We'll tidy up later...
        if (!diff) return;
        diff.push({
            value: '',
            lines: []
        }); // Append an empty value to make cleanup easier
        function contextLines(lines) {
            return lines.map(function(entry) {
                return ' ' + entry;
            });
        }
        const hunks = [];
        let oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
        for(let i = 0; i < diff.length; i++){
            const current = diff[i], lines = current.lines || $e8dc251f16a342f7$var$splitLines(current.value);
            current.lines = lines;
            if (current.added || current.removed) {
                // If we have previous context, start with that
                if (!oldRangeStart) {
                    const prev = diff[i - 1];
                    oldRangeStart = oldLine;
                    newRangeStart = newLine;
                    if (prev) {
                        curRange = context > 0 ? contextLines(prev.lines.slice(-context)) : [];
                        oldRangeStart -= curRange.length;
                        newRangeStart -= curRange.length;
                    }
                }
                // Output our changes
                for (const line of lines)curRange.push((current.added ? '+' : '-') + line);
                // Track the updated file position
                if (current.added) newLine += lines.length;
                else oldLine += lines.length;
            } else {
                // Identical context lines. Track line changes
                if (oldRangeStart) {
                    // Close out any changes that have been output (or join overlapping)
                    if (lines.length <= context * 2 && i < diff.length - 2) // Overlapping
                    for (const line of contextLines(lines))curRange.push(line);
                    else {
                        // end the range and output
                        const contextSize = Math.min(lines.length, context);
                        for (const line of contextLines(lines.slice(0, contextSize)))curRange.push(line);
                        const hunk = {
                            oldStart: oldRangeStart,
                            oldLines: oldLine - oldRangeStart + contextSize,
                            newStart: newRangeStart,
                            newLines: newLine - newRangeStart + contextSize,
                            lines: curRange
                        };
                        hunks.push(hunk);
                        oldRangeStart = 0;
                        newRangeStart = 0;
                        curRange = [];
                    }
                }
                oldLine += lines.length;
                newLine += lines.length;
            }
        }
        // Step 2: eliminate the trailing `\n` from each line of each hunk, and, where needed, add
        //         "\ No newline at end of file".
        for (const hunk of hunks){
            for(let i = 0; i < hunk.lines.length; i++)if (hunk.lines[i].endsWith('\n')) hunk.lines[i] = hunk.lines[i].slice(0, -1);
            else {
                hunk.lines.splice(i + 1, 0, '\\ No newline at end of file');
                i++; // Skip the line we just added, then continue iterating
            }
        }
        return {
            oldFileName: oldFileName,
            newFileName: newFileName,
            oldHeader: oldHeader,
            newHeader: newHeader,
            hunks: hunks
        };
    }
}
function $e8dc251f16a342f7$export$3c97ed4bbaa81f7a(patch, headerOptions) {
    if (!headerOptions) headerOptions = $e8dc251f16a342f7$export$6fe85aa6792db095;
    if (Array.isArray(patch)) {
        if (patch.length > 1 && !headerOptions.includeFileHeaders) throw new Error("Cannot omit file headers on a multi-file patch. (The result would be unparseable; how would a tool trying to apply the patch know which changes are to which file?)");
        return patch.map((p)=>$e8dc251f16a342f7$export$3c97ed4bbaa81f7a(p, headerOptions)).join('\n');
    }
    const ret = [];
    if (headerOptions.includeIndex && patch.oldFileName == patch.newFileName) ret.push('Index: ' + patch.oldFileName);
    if (headerOptions.includeUnderline) ret.push('===================================================================');
    if (headerOptions.includeFileHeaders) {
        ret.push('--- ' + patch.oldFileName + (typeof patch.oldHeader === 'undefined' ? '' : '\t' + patch.oldHeader));
        ret.push('+++ ' + patch.newFileName + (typeof patch.newHeader === 'undefined' ? '' : '\t' + patch.newHeader));
    }
    for(let i = 0; i < patch.hunks.length; i++){
        const hunk = patch.hunks[i];
        // Unified Diff Format quirk: If the chunk size is 0,
        // the first number is one lower than one would expect.
        // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
        if (hunk.oldLines === 0) hunk.oldStart -= 1;
        if (hunk.newLines === 0) hunk.newStart -= 1;
        ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
        for (const line of hunk.lines)ret.push(line);
    }
    return ret.join('\n') + '\n';
}
function $e8dc251f16a342f7$export$80aac8782e10a34f(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
    if (typeof options === 'function') options = {
        callback: options
    };
    if (!(options === null || options === void 0 ? void 0 : options.callback)) {
        const patchObj = $e8dc251f16a342f7$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);
        if (!patchObj) return;
        return $e8dc251f16a342f7$export$3c97ed4bbaa81f7a(patchObj, options === null || options === void 0 ? void 0 : options.headerOptions);
    } else {
        const { callback: callback } = options;
        $e8dc251f16a342f7$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, Object.assign(Object.assign({}, options), {
            callback: (patchObj)=>{
                if (!patchObj) callback(undefined);
                else callback($e8dc251f16a342f7$export$3c97ed4bbaa81f7a(patchObj, options.headerOptions));
            }
        }));
    }
}
function $e8dc251f16a342f7$export$4b8f0727f602f200(fileName, oldStr, newStr, oldHeader, newHeader, options) {
    return $e8dc251f16a342f7$export$80aac8782e10a34f(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
}
/**
 * Split `text` into an array of lines, including the trailing newline character (where present)
 */ function $e8dc251f16a342f7$var$splitLines(text) {
    const hasTrailingNl = text.endsWith('\n');
    const result = text.split('\n').map((line)=>line + '\n');
    if (hasTrailingNl) result.pop();
    else result.push(result.pop().slice(0, -1));
    return result;
}


//#region src/utils/parseDiffFromFile.ts
/**
* Parses a diff from two file contents objects.
*
* If both `oldFile` and `newFile` have a `cacheKey`, the resulting diff will
* automatically get a combined cache key in the format `oldKey:newKey`.
*/ function $80c7965a049ab6e5$export$98aafcdfd1bcb1be(oldFile, newFile, options, throwOnError = false) {
    const fileData = (0, $9fe687489fc907dc$export$e3af4d503e89baa0)((0, $e8dc251f16a342f7$export$80aac8782e10a34f)(oldFile.name, newFile.name, oldFile.contents, newFile.contents, oldFile.header, newFile.header, options), {
        cacheKey: (()=>{
            if (oldFile.cacheKey != null && newFile.cacheKey != null) return `${oldFile.cacheKey}:${newFile.cacheKey}`;
        })(),
        oldFile: oldFile,
        newFile: newFile,
        throwOnError: throwOnError
    });
    if (fileData == null) throw new Error("parseDiffFrom: FileInvalid diff -- probably need to fix something -- if the files are the same maybe?");
    if (newFile.lang != null) fileData.lang = newFile.lang;
    return fileData;
}























//#region src/managers/ScrollSyncManager.ts
var $4e32724a2af3c2d6$export$2d605f5da0332df8 = class {
    isDeletionsScrolling = false;
    isAdditionsScrolling = false;
    timeoutId = -1;
    codeDeletions;
    codeAdditions;
    enabled = false;
    cleanUp() {
        if (!this.enabled) return;
        this.codeDeletions?.removeEventListener("scroll", this.handleDeletionsScroll);
        this.codeAdditions?.removeEventListener("scroll", this.handleAdditionsScroll);
        clearTimeout(this.timeoutId);
        this.codeDeletions = void 0;
        this.codeAdditions = void 0;
        this.enabled = false;
    }
    setup(pre, codeDeletions, codeAdditions) {
        if (codeDeletions == null || codeAdditions == null) for (const element of pre.children ?? []){
            if (!(element instanceof HTMLElement)) continue;
            if ("deletions" in element.dataset) codeDeletions = element;
            else if ("additions" in element.dataset) codeAdditions = element;
        }
        if (codeAdditions == null || codeDeletions == null) {
            this.cleanUp();
            return;
        }
        if (this.codeDeletions !== codeDeletions) {
            this.codeDeletions?.removeEventListener("scroll", this.handleDeletionsScroll);
            this.codeDeletions = codeDeletions;
            codeDeletions.addEventListener("scroll", this.handleDeletionsScroll, {
                passive: true
            });
        }
        if (this.codeAdditions !== codeAdditions) {
            this.codeAdditions?.removeEventListener("scroll", this.handleAdditionsScroll);
            this.codeAdditions = codeAdditions;
            codeAdditions.addEventListener("scroll", this.handleAdditionsScroll, {
                passive: true
            });
        }
        this.enabled = true;
    }
    handleDeletionsScroll = ()=>{
        if (this.isAdditionsScrolling) return;
        this.isDeletionsScrolling = true;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(()=>{
            this.isDeletionsScrolling = false;
        }, 300);
        this.codeAdditions?.scrollTo({
            left: this.codeDeletions?.scrollLeft
        });
    };
    handleAdditionsScroll = ()=>{
        if (this.isDeletionsScrolling) return;
        this.isAdditionsScrolling = true;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(()=>{
            this.isAdditionsScrolling = false;
        }, 300);
        this.codeDeletions?.scrollTo({
            left: this.codeAdditions?.scrollLeft
        });
    };
};



//#region src/utils/isDiffPlainText.ts
function $ac8a37f5a3c58257$export$e92605dcb43e76fc(diff) {
    const computedLang = diff.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(diff.name);
    const computedPreviousLang = diff.lang ?? (diff.prevName != null ? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(diff.prevName) : "text");
    return computedLang === "text" && computedPreviousLang === "text";
}


















//#region src/utils/areDiffRenderOptionsEqual.ts
function $f47ec40e1ade4b8f$export$2234c8b26b4dfe19(optionsA, optionsB) {
    return (0, $0246eee5e18b0420$export$e40448283aec01f1)(optionsA.theme, optionsB.theme) && optionsA.useTokenTransformer === optionsB.useTokenTransformer && optionsA.tokenizeMaxLineLength === optionsB.tokenizeMaxLineLength && optionsA.lineDiffType === optionsB.lineDiffType && optionsA.maxLineDiffLength === optionsB.maxLineDiffLength;
}


//#region src/utils/areDiffTargetsEqual.ts
function $dba1055e9d278b35$export$3ad525473176feb1(diffA, diffB) {
    return diffA === diffB || diffA?.cacheKey != null && diffA.cacheKey === diffB?.cacheKey;
}



//#region src/utils/createEmptyRowBuffer.ts
function $2bedb99ff5e4f346$export$1d4ec6e35ce12893(size) {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        properties: {
            "data-content-buffer": "",
            "data-buffer-size": size,
            style: `grid-row: span ${size};min-height:calc(${size} * 1lh)`
        }
    });
}



//#region src/utils/createNoNewlineElement.ts
function $ad7c9e088ba31ab3$export$6f465003dc977e6d(type) {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: [
            (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                tagName: "span",
                children: [
                    (0, $f6f1fb01992c2ec8$export$696d4285af91566e)("No newline at end of file")
                ]
            })
        ],
        properties: {
            "data-no-newline": "",
            "data-line-type": type,
            "data-column-content": ""
        }
    });
}



//#region src/utils/createSeparator.ts
function $467c81971f656628$var$createExpandButton(type) {
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: [
            (0, $f6f1fb01992c2ec8$export$2f9411727149fee9)({
                name: type === "both" ? "diffs-icon-expand-all" : "diffs-icon-expand",
                properties: {
                    "data-icon": ""
                }
            })
        ],
        properties: {
            role: "button",
            "data-expand-button": "",
            "data-expand-both": type === "both" ? "" : void 0,
            "data-expand-up": type === "up" ? "" : void 0,
            "data-expand-down": type === "down" ? "" : void 0
        }
    });
}
function $467c81971f656628$export$2f446885d1462a2f({ type: type, content: content, expandIndex: expandIndex, chunked: chunked = false, slotName: slotName, isFirstHunk: isFirstHunk, isLastHunk: isLastHunk }) {
    let buttonCount = 0;
    const children = [];
    if (type === "metadata" && content != null) children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: [
            (0, $f6f1fb01992c2ec8$export$696d4285af91566e)(content)
        ],
        properties: {
            "data-separator-wrapper": ""
        }
    }));
    if ((type === "line-info" || type === "line-info-basic") && content != null) {
        const contentChildren = [];
        if (expandIndex != null) {
            if (!chunked) {
                contentChildren.push($467c81971f656628$var$createExpandButton(!isFirstHunk && !isLastHunk ? "both" : isFirstHunk ? "down" : "up"));
                buttonCount++;
            } else {
                if (!isFirstHunk) {
                    contentChildren.push($467c81971f656628$var$createExpandButton("up"));
                    buttonCount++;
                }
                if (!isLastHunk) {
                    contentChildren.push($467c81971f656628$var$createExpandButton("down"));
                    buttonCount++;
                }
            }
        }
        contentChildren.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "div",
            children: [
                (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                    tagName: "span",
                    children: [
                        (0, $f6f1fb01992c2ec8$export$696d4285af91566e)(content)
                    ],
                    properties: {
                        "data-unmodified-lines": ""
                    }
                })
            ],
            properties: {
                "data-separator-content": ""
            }
        }));
        if (chunked && expandIndex != null) contentChildren.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "div",
            children: [
                (0, $f6f1fb01992c2ec8$export$696d4285af91566e)("Expand all")
            ],
            properties: {
                role: "button",
                "data-expand-button": "",
                "data-expand-all-button": ""
            }
        }));
        children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "div",
            children: contentChildren,
            properties: {
                "data-separator-wrapper": "",
                "data-separator-multi-button": buttonCount > 1 ? "" : void 0
            }
        }));
    }
    if (type === "custom" && slotName != null) children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "slot",
        properties: {
            name: slotName
        }
    }));
    return (0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
        tagName: "div",
        children: children,
        properties: {
            "data-separator": children.length === 0 ? "simple" : type,
            "data-expand-index": expandIndex,
            "data-separator-first": isFirstHunk ? "" : void 0,
            "data-separator-last": isLastHunk ? "" : void 0
        }
    });
}


//#region src/utils/getHunkSeparatorSlotName.ts
function $f1d4f75c6830f6c7$export$79318a5690a6a67c(type, hunkIndex) {
    return `hunk-separator-${type}-${hunkIndex}`;
}


//#region src/utils/getTotalLineCountFromHunks.ts
function $e6fb4b0b54142a9f$export$d3f1a6c0d274d994(hunks) {
    const lastHunk = hunks.at(-1);
    if (lastHunk == null) return 0;
    return Math.max(lastHunk.additionStart + lastHunk.additionCount, lastHunk.deletionStart + lastHunk.deletionCount);
}


//#region src/utils/isDefaultRenderRange.ts
function $21c8eb6d7f07b5b0$export$e14e0cdc699e8e20(renderRange) {
    return renderRange.startingLine === 0 && renderRange.totalLines === Infinity && renderRange.bufferBefore === 0 && renderRange.bufferAfter === 0;
}












//#region src/utils/parseDiffDecorations.ts
function $f7a2cee45883e48d$export$87d096fbee48ce80({ line: line, spanStart: spanStart, spanLength: spanLength }) {
    return {
        start: {
            line: line,
            character: spanStart
        },
        end: {
            line: line,
            character: spanStart + spanLength
        },
        properties: {
            "data-diff-span": ""
        },
        alwaysWrap: true
    };
}
function $f7a2cee45883e48d$export$a2e48160801caed({ item: item, arr: arr, enableJoin: enableJoin, isNeutral: isNeutral = false, isLastItem: isLastItem = false }) {
    const lastItem = arr[arr.length - 1];
    if (lastItem == null || isLastItem || !enableJoin) {
        arr.push([
            isNeutral ? 0 : 1,
            item.value
        ]);
        return;
    }
    const isLastItemNeutral = lastItem[0] === 0;
    if (isNeutral === isLastItemNeutral || isNeutral && item.value.length === 1 && !isLastItemNeutral) {
        lastItem[1] += item.value;
        return;
    }
    arr.push([
        isNeutral ? 0 : 1,
        item.value
    ]);
}



class $d5f86155ad1115b9$var$CharacterDiff extends (0, $d57b1677955bba91$export$2e2bcd8739ae039) {
}
const $d5f86155ad1115b9$export$7ca665effb3e6ce5 = new $d5f86155ad1115b9$var$CharacterDiff();
function $d5f86155ad1115b9$export$325021f2061a40f5(oldStr, newStr, options) {
    return $d5f86155ad1115b9$export$7ca665effb3e6ce5.diff(oldStr, newStr, options);
}


function $522b35a8e51f20dc$export$79b570479388804a(str1, str2) {
    let i;
    for(i = 0; i < str1.length && i < str2.length; i++){
        if (str1[i] != str2[i]) return str1.slice(0, i);
    }
    return str1.slice(0, i);
}
function $522b35a8e51f20dc$export$72b7bdd32a5d419c(str1, str2) {
    let i;
    // Unlike longestCommonPrefix, we need a special case to handle all scenarios
    // where we return the empty string since str1.slice(-0) will return the
    // entire string.
    if (!str1 || !str2 || str1[str1.length - 1] != str2[str2.length - 1]) return '';
    for(i = 0; i < str1.length && i < str2.length; i++){
        if (str1[str1.length - (i + 1)] != str2[str2.length - (i + 1)]) return str1.slice(-i);
    }
    return str1.slice(-i);
}
function $522b35a8e51f20dc$export$22ef8700548ec20(string, oldPrefix, newPrefix) {
    if (string.slice(0, oldPrefix.length) != oldPrefix) throw Error(`string ${JSON.stringify(string)} doesn't start with prefix ${JSON.stringify(oldPrefix)}; this is a bug`);
    return newPrefix + string.slice(oldPrefix.length);
}
function $522b35a8e51f20dc$export$5ec0d2836752f6f9(string, oldSuffix, newSuffix) {
    if (!oldSuffix) return string + newSuffix;
    if (string.slice(-oldSuffix.length) != oldSuffix) throw Error(`string ${JSON.stringify(string)} doesn't end with suffix ${JSON.stringify(oldSuffix)}; this is a bug`);
    return string.slice(0, -oldSuffix.length) + newSuffix;
}
function $522b35a8e51f20dc$export$f2888183a34644d4(string, oldPrefix) {
    return $522b35a8e51f20dc$export$22ef8700548ec20(string, oldPrefix, '');
}
function $522b35a8e51f20dc$export$aac196711902dc7(string, oldSuffix) {
    return $522b35a8e51f20dc$export$5ec0d2836752f6f9(string, oldSuffix, '');
}
function $522b35a8e51f20dc$export$87cbcebd9d601a4f(string1, string2) {
    return string2.slice(0, $522b35a8e51f20dc$var$overlapCount(string1, string2));
}
// Nicked from https://stackoverflow.com/a/60422853/1709587
function $522b35a8e51f20dc$var$overlapCount(a, b) {
    // Deal with cases where the strings differ in length
    let startA = 0;
    if (a.length > b.length) startA = a.length - b.length;
    let endB = b.length;
    if (a.length < b.length) endB = a.length;
    // Create a back-reference for each index
    //   that should be followed in case of a mismatch.
    //   We only need B to make these references:
    const map = Array(endB);
    let k = 0; // Index that lags behind j
    map[0] = 0;
    for(let j = 1; j < endB; j++){
        if (b[j] == b[k]) map[j] = map[k]; // skip over the same character (optional optimisation)
        else map[j] = k;
        while(k > 0 && b[j] != b[k])k = map[k];
        if (b[j] == b[k]) k++;
    }
    // Phase 2: use these references while iterating over A
    k = 0;
    for(let i = startA; i < a.length; i++){
        while(k > 0 && a[i] != b[k])k = map[k];
        if (a[i] == b[k]) k++;
    }
    return k;
}
function $522b35a8e51f20dc$export$9fe0cdf2eb1dc0e6(string) {
    return string.includes('\r\n') && !string.startsWith('\n') && !string.match(/[^\r]\n/);
}
function $522b35a8e51f20dc$export$1213ac36419a9419(string) {
    return !string.includes('\r\n') && string.includes('\n');
}
function $522b35a8e51f20dc$export$36887699017cd794(string) {
    // Yes, this looks overcomplicated and dumb - why not replace the whole function with
    //     return string.match(/\s*$/)[0]
    // you ask? Because:
    // 1. the trap described at https://markamery.com/blog/quadratic-time-regexes/ would mean doing
    //    this would cause this function to take O(n²) time in the worst case (specifically when
    //    there is a massive run of NON-TRAILING whitespace in `string`), and
    // 2. the fix proposed in the same blog post, of using a negative lookbehind, is incompatible
    //    with old Safari versions that we'd like to not break if possible (see
    //    https://github.com/kpdecker/jsdiff/pull/550)
    // It feels absurd to do this with an explicit loop instead of a regex, but I really can't see a
    // better way that doesn't result in broken behaviour.
    let i;
    for(i = string.length - 1; i >= 0; i--){
        if (!string[i].match(/\s/)) break;
    }
    return string.substring(i + 1);
}
function $522b35a8e51f20dc$export$a23146986e7c5c23(string) {
    // Thankfully the annoying considerations described in trailingWs don't apply here:
    const match = string.match(/^\s*/);
    return match ? match[0] : '';
}


// Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
//
// Chars/ranges counted as "word" characters by this regex are as follows:
//
// + U+00AD  Soft hyphen
// + 00C0–00FF (letters with diacritics from the Latin-1 Supplement), except:
//   - U+00D7  × Multiplication sign
//   - U+00F7  ÷ Division sign
// + Latin Extended-A, 0100–017F
// + Latin Extended-B, 0180–024F
// + IPA Extensions, 0250–02AF
// + Spacing Modifier Letters, 02B0–02FF, except:
//   - U+02C7  ˇ &#711;  Caron
//   - U+02D8  ˘ &#728;  Breve
//   - U+02D9  ˙ &#729;  Dot Above
//   - U+02DA  ˚ &#730;  Ring Above
//   - U+02DB  ˛ &#731;  Ogonek
//   - U+02DC  ˜ &#732;  Small Tilde
//   - U+02DD  ˝ &#733;  Double Acute Accent
// + Latin Extended Additional, 1E00–1EFF
const $92d521d03e53a52f$var$extendedWordChars = "a-zA-Z0-9_\\u{AD}\\u{C0}-\\u{D6}\\u{D8}-\\u{F6}\\u{F8}-\\u{2C6}\\u{2C8}-\\u{2D7}\\u{2DE}-\\u{2FF}\\u{1E00}-\\u{1EFF}";
// Each token is one of the following:
// - A punctuation mark plus the surrounding whitespace
// - A word plus the surrounding whitespace
// - Pure whitespace (but only in the special case where the entire text
//   is just whitespace)
//
// We have to include surrounding whitespace in the tokens because the two
// alternative approaches produce horribly broken results:
// * If we just discard the whitespace, we can't fully reproduce the original
//   text from the sequence of tokens and any attempt to render the diff will
//   get the whitespace wrong.
// * If we have separate tokens for whitespace, then in a typical text every
//   second token will be a single space character. But this often results in
//   the optimal diff between two texts being a perverse one that preserves
//   the spaces between words but deletes and reinserts actual common words.
//   See https://github.com/kpdecker/jsdiff/issues/160#issuecomment-1866099640
//   for an example.
//
// Keeping the surrounding whitespace of course has implications for .equals
// and .join, not just .tokenize.
// This regex does NOT fully implement the tokenization rules described above.
// Instead, it gives runs of whitespace their own "token". The tokenize method
// then handles stitching whitespace tokens onto adjacent word or punctuation
// tokens.
const $92d521d03e53a52f$var$tokenizeIncludingWhitespace = new RegExp(`[${$92d521d03e53a52f$var$extendedWordChars}]+|\\s+|[^${$92d521d03e53a52f$var$extendedWordChars}]`, 'ug');
class $92d521d03e53a52f$var$WordDiff extends (0, $d57b1677955bba91$export$2e2bcd8739ae039) {
    equals(left, right, options) {
        if (options.ignoreCase) {
            left = left.toLowerCase();
            right = right.toLowerCase();
        }
        return left.trim() === right.trim();
    }
    tokenize(value, options = {}) {
        let parts;
        if (options.intlSegmenter) {
            const segmenter = options.intlSegmenter;
            if (segmenter.resolvedOptions().granularity != 'word') throw new Error('The segmenter passed must have a granularity of "word"');
            // We want `parts` to be an array whose elements alternate between being
            // pure whitespace and being pure non-whitespace. This is ALMOST what the
            // segments returned by a word-based Intl.Segmenter already look like,
            // and therefore we can ALMOST get what we want by simply doing...
            //     parts = Array.from(segmenter.segment(value), segment => segment.segment);
            // ... but not QUITE, because there's of one annoying special case: every
            // newline character gets its own segment, instead of sharing a segment
            // with other surrounding whitespace. We therefore need to manually merge
            // consecutive segments of whitespace into a single part:
            parts = [];
            for (const segmentObj of Array.from(segmenter.segment(value))){
                const segment = segmentObj.segment;
                if (parts.length && /\s/.test(parts[parts.length - 1]) && /\s/.test(segment)) parts[parts.length - 1] += segment;
                else parts.push(segment);
            }
        } else parts = value.match($92d521d03e53a52f$var$tokenizeIncludingWhitespace) || [];
        const tokens = [];
        let prevPart = null;
        parts.forEach((part)=>{
            if (/\s/.test(part)) {
                if (prevPart == null) tokens.push(part);
                else tokens.push(tokens.pop() + part);
            } else if (prevPart != null && /\s/.test(prevPart)) {
                if (tokens[tokens.length - 1] == prevPart) tokens.push(tokens.pop() + part);
                else tokens.push(prevPart + part);
            } else tokens.push(part);
            prevPart = part;
        });
        return tokens;
    }
    join(tokens) {
        // Tokens being joined here will always have appeared consecutively in the
        // same text, so we can simply strip off the leading whitespace from all the
        // tokens except the first (and except any whitespace-only tokens - but such
        // a token will always be the first and only token anyway) and then join them
        // and the whitespace around words and punctuation will end up correct.
        return tokens.map((token, i)=>{
            if (i == 0) return token;
            else return token.replace(/^\s+/, '');
        }).join('');
    }
    postProcess(changes, options) {
        if (!changes || options.oneChangePerToken) return changes;
        let lastKeep = null;
        // Change objects representing any insertion or deletion since the last
        // "keep" change object. There can be at most one of each.
        let insertion = null;
        let deletion = null;
        changes.forEach((change)=>{
            if (change.added) insertion = change;
            else if (change.removed) deletion = change;
            else {
                if (insertion || deletion) $92d521d03e53a52f$var$dedupeWhitespaceInChangeObjects(lastKeep, deletion, insertion, change);
                lastKeep = change;
                insertion = null;
                deletion = null;
            }
        });
        if (insertion || deletion) $92d521d03e53a52f$var$dedupeWhitespaceInChangeObjects(lastKeep, deletion, insertion, null);
        return changes;
    }
}
const $92d521d03e53a52f$export$bcda4af332628932 = new $92d521d03e53a52f$var$WordDiff();
function $92d521d03e53a52f$export$5643fba310ccb33(oldStr, newStr, options) {
    // This option has never been documented and never will be (it's clearer to
    // just call `diffWordsWithSpace` directly if you need that behavior), but
    // has existed in jsdiff for a long time, so we retain support for it here
    // for the sake of backwards compatibility.
    if ((options === null || options === void 0 ? void 0 : options.ignoreWhitespace) != null && !options.ignoreWhitespace) return $92d521d03e53a52f$export$3941790a84174c86(oldStr, newStr, options);
    return $92d521d03e53a52f$export$bcda4af332628932.diff(oldStr, newStr, options);
}
function $92d521d03e53a52f$var$dedupeWhitespaceInChangeObjects(startKeep, deletion, insertion, endKeep) {
    // Before returning, we tidy up the leading and trailing whitespace of the
    // change objects to eliminate cases where trailing whitespace in one object
    // is repeated as leading whitespace in the next.
    // Below are examples of the outcomes we want here to explain the code.
    // I=insert, K=keep, D=delete
    // 1. diffing 'foo bar baz' vs 'foo baz'
    //    Prior to cleanup, we have K:'foo ' D:' bar ' K:' baz'
    //    After cleanup, we want:   K:'foo ' D:'bar ' K:'baz'
    //
    // 2. Diffing 'foo bar baz' vs 'foo qux baz'
    //    Prior to cleanup, we have K:'foo ' D:' bar ' I:' qux ' K:' baz'
    //    After cleanup, we want K:'foo ' D:'bar' I:'qux' K:' baz'
    //
    // 3. Diffing 'foo\nbar baz' vs 'foo baz'
    //    Prior to cleanup, we have K:'foo ' D:'\nbar ' K:' baz'
    //    After cleanup, we want K'foo' D:'\nbar' K:' baz'
    //
    // 4. Diffing 'foo baz' vs 'foo\nbar baz'
    //    Prior to cleanup, we have K:'foo\n' I:'\nbar ' K:' baz'
    //    After cleanup, we ideally want K'foo' I:'\nbar' K:' baz'
    //    but don't actually manage this currently (the pre-cleanup change
    //    objects don't contain enough information to make it possible).
    //
    // 5. Diffing 'foo   bar baz' vs 'foo  baz'
    //    Prior to cleanup, we have K:'foo  ' D:'   bar ' K:'  baz'
    //    After cleanup, we want K:'foo  ' D:' bar ' K:'baz'
    //
    // Our handling is unavoidably imperfect in the case where there's a single
    // indel between keeps and the whitespace has changed. For instance, consider
    // diffing 'foo\tbar\nbaz' vs 'foo baz'. Unless we create an extra change
    // object to represent the insertion of the space character (which isn't even
    // a token), we have no way to avoid losing information about the texts'
    // original whitespace in the result we return. Still, we do our best to
    // output something that will look sensible if we e.g. print it with
    // insertions in green and deletions in red.
    // Between two "keep" change objects (or before the first or after the last
    // change object), we can have either:
    // * A "delete" followed by an "insert"
    // * Just an "insert"
    // * Just a "delete"
    // We handle the three cases separately.
    if (deletion && insertion) {
        const oldWsPrefix = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(deletion.value);
        const oldWsSuffix = (0, $522b35a8e51f20dc$export$36887699017cd794)(deletion.value);
        const newWsPrefix = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(insertion.value);
        const newWsSuffix = (0, $522b35a8e51f20dc$export$36887699017cd794)(insertion.value);
        if (startKeep) {
            const commonWsPrefix = (0, $522b35a8e51f20dc$export$79b570479388804a)(oldWsPrefix, newWsPrefix);
            startKeep.value = (0, $522b35a8e51f20dc$export$5ec0d2836752f6f9)(startKeep.value, newWsPrefix, commonWsPrefix);
            deletion.value = (0, $522b35a8e51f20dc$export$f2888183a34644d4)(deletion.value, commonWsPrefix);
            insertion.value = (0, $522b35a8e51f20dc$export$f2888183a34644d4)(insertion.value, commonWsPrefix);
        }
        if (endKeep) {
            const commonWsSuffix = (0, $522b35a8e51f20dc$export$72b7bdd32a5d419c)(oldWsSuffix, newWsSuffix);
            endKeep.value = (0, $522b35a8e51f20dc$export$22ef8700548ec20)(endKeep.value, newWsSuffix, commonWsSuffix);
            deletion.value = (0, $522b35a8e51f20dc$export$aac196711902dc7)(deletion.value, commonWsSuffix);
            insertion.value = (0, $522b35a8e51f20dc$export$aac196711902dc7)(insertion.value, commonWsSuffix);
        }
    } else if (insertion) {
        // The whitespaces all reflect what was in the new text rather than
        // the old, so we essentially have no information about whitespace
        // insertion or deletion. We just want to dedupe the whitespace.
        // We do that by having each change object keep its trailing
        // whitespace and deleting duplicate leading whitespace where
        // present.
        if (startKeep) {
            const ws = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(insertion.value);
            insertion.value = insertion.value.substring(ws.length);
        }
        if (endKeep) {
            const ws = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(endKeep.value);
            endKeep.value = endKeep.value.substring(ws.length);
        }
    // otherwise we've got a deletion and no insertion
    } else if (startKeep && endKeep) {
        const newWsFull = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(endKeep.value), delWsStart = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(deletion.value), delWsEnd = (0, $522b35a8e51f20dc$export$36887699017cd794)(deletion.value);
        // Any whitespace that comes straight after startKeep in both the old and
        // new texts, assign to startKeep and remove from the deletion.
        const newWsStart = (0, $522b35a8e51f20dc$export$79b570479388804a)(newWsFull, delWsStart);
        deletion.value = (0, $522b35a8e51f20dc$export$f2888183a34644d4)(deletion.value, newWsStart);
        // Any whitespace that comes straight before endKeep in both the old and
        // new texts, and hasn't already been assigned to startKeep, assign to
        // endKeep and remove from the deletion.
        const newWsEnd = (0, $522b35a8e51f20dc$export$72b7bdd32a5d419c)((0, $522b35a8e51f20dc$export$f2888183a34644d4)(newWsFull, newWsStart), delWsEnd);
        deletion.value = (0, $522b35a8e51f20dc$export$aac196711902dc7)(deletion.value, newWsEnd);
        endKeep.value = (0, $522b35a8e51f20dc$export$22ef8700548ec20)(endKeep.value, newWsFull, newWsEnd);
        // If there's any whitespace from the new text that HASN'T already been
        // assigned, assign it to the start:
        startKeep.value = (0, $522b35a8e51f20dc$export$5ec0d2836752f6f9)(startKeep.value, newWsFull, newWsFull.slice(0, newWsFull.length - newWsEnd.length));
    } else if (endKeep) {
        // We are at the start of the text. Preserve all the whitespace on
        // endKeep, and just remove whitespace from the end of deletion to the
        // extent that it overlaps with the start of endKeep.
        const endKeepWsPrefix = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(endKeep.value);
        const deletionWsSuffix = (0, $522b35a8e51f20dc$export$36887699017cd794)(deletion.value);
        const overlap = (0, $522b35a8e51f20dc$export$87cbcebd9d601a4f)(deletionWsSuffix, endKeepWsPrefix);
        deletion.value = (0, $522b35a8e51f20dc$export$aac196711902dc7)(deletion.value, overlap);
    } else if (startKeep) {
        // We are at the END of the text. Preserve all the whitespace on
        // startKeep, and just remove whitespace from the start of deletion to
        // the extent that it overlaps with the end of startKeep.
        const startKeepWsSuffix = (0, $522b35a8e51f20dc$export$36887699017cd794)(startKeep.value);
        const deletionWsPrefix = (0, $522b35a8e51f20dc$export$a23146986e7c5c23)(deletion.value);
        const overlap = (0, $522b35a8e51f20dc$export$87cbcebd9d601a4f)(startKeepWsSuffix, deletionWsPrefix);
        deletion.value = (0, $522b35a8e51f20dc$export$f2888183a34644d4)(deletion.value, overlap);
    }
}
class $92d521d03e53a52f$var$WordsWithSpaceDiff extends (0, $d57b1677955bba91$export$2e2bcd8739ae039) {
    tokenize(value) {
        // Slightly different to the tokenizeIncludingWhitespace regex used above in
        // that this one treats each individual newline as a distinct token, rather
        // than merging them into other surrounding whitespace. This was requested
        // in https://github.com/kpdecker/jsdiff/issues/180 &
        //    https://github.com/kpdecker/jsdiff/issues/211
        const regex = new RegExp(`(\\r?\\n)|[${$92d521d03e53a52f$var$extendedWordChars}]+|[^\\S\\n\\r]+|[^${$92d521d03e53a52f$var$extendedWordChars}]`, 'ug');
        return value.match(regex) || [];
    }
}
const $92d521d03e53a52f$export$f75b3353adc8cfd = new $92d521d03e53a52f$var$WordsWithSpaceDiff();
function $92d521d03e53a52f$export$3941790a84174c86(oldStr, newStr, options) {
    return $92d521d03e53a52f$export$f75b3353adc8cfd.diff(oldStr, newStr, options);
}


//#region src/utils/renderDiffWithHighlighter.ts
const $688ba6849a1df22e$var$DEFAULT_PLAIN_TEXT_OPTIONS = {
    forcePlainText: false
};
function $688ba6849a1df22e$export$bb1e2b1b9fe7b5e(diff, highlighter, options, { forcePlainText: forcePlainText, startingLine: startingLine, totalLines: totalLines, expandedHunks: expandedHunks, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac) } = $688ba6849a1df22e$var$DEFAULT_PLAIN_TEXT_OPTIONS) {
    if (forcePlainText) {
        startingLine ??= 0;
        totalLines ??= Infinity;
    } else {
        startingLine = 0;
        totalLines = Infinity;
    }
    const isWindowedHighlight = startingLine > 0 || totalLines < Infinity;
    const baseThemeType = typeof options.theme === "string" ? highlighter.getTheme(options.theme).type : void 0;
    const themeStyles = (0, $2dcbebec51687b3b$export$4dfa4d391e354885)({
        theme: options.theme,
        highlighter: highlighter
    });
    const lineDiffType = forcePlainText && !isWindowedHighlight && (diff.unifiedLineCount > 1e3 || diff.splitLineCount > 1e3) ? "none" : options.lineDiffType;
    const code = {
        deletionLines: [],
        additionLines: []
    };
    const { maxLineDiffLength: maxLineDiffLength } = options;
    const shouldGroupAll = !forcePlainText && !diff.isPartial;
    const expandedHunksForIteration = forcePlainText ? expandedHunks : void 0;
    const buckets = /* @__PURE__ */ new Map();
    function getBucketForHunk(hunkIndex) {
        const index = shouldGroupAll ? 0 : hunkIndex;
        const bucket = buckets.get(index) ?? $688ba6849a1df22e$var$createBucket();
        buckets.set(index, bucket);
        return bucket;
    }
    function appendContent(lineContent, lineIndex, segments, contentWrapper) {
        if (isWindowedHighlight) {
            let segment = segments.at(-1);
            if (segment == null || segment.targetIndex + segment.count !== lineIndex) {
                segment = {
                    targetIndex: lineIndex,
                    originalOffset: contentWrapper.length,
                    count: 0
                };
                segments.push(segment);
            }
            segment.count++;
        }
        contentWrapper.push(lineContent);
    }
    (0, $14677931af57706f$export$62615825adc21c24)({
        diff: diff,
        diffStyle: "both",
        startingLine: startingLine,
        totalLines: totalLines,
        expandedHunks: isWindowedHighlight ? expandedHunksForIteration : true,
        collapsedContextThreshold: collapsedContextThreshold,
        callback: ({ hunkIndex: hunkIndex, additionLine: additionLine, deletionLine: deletionLine, type: type })=>{
            const bucket = getBucketForHunk(hunkIndex);
            const splitLineIndex = additionLine != null ? additionLine.splitLineIndex : deletionLine.splitLineIndex;
            if (type === "change" && additionLine != null && deletionLine != null) $688ba6849a1df22e$var$computeLineDiffDecorations({
                additionLine: diff.additionLines[additionLine.lineIndex],
                deletionLine: diff.deletionLines[deletionLine.lineIndex],
                deletionLineIndex: bucket.deletionContent.length,
                additionLineIndex: bucket.additionContent.length,
                deletionDecorations: bucket.deletionDecorations,
                additionDecorations: bucket.additionDecorations,
                lineDiffType: lineDiffType,
                maxLineDiffLength: maxLineDiffLength
            });
            if (deletionLine != null) {
                appendContent(diff.deletionLines[deletionLine.lineIndex], deletionLine.lineIndex, bucket.deletionSegments, bucket.deletionContent);
                bucket.deletionInfo.push({
                    type: type === "change" ? "change-deletion" : type,
                    lineNumber: deletionLine.lineNumber,
                    altLineNumber: type === "change" ? void 0 : additionLine.lineNumber ?? void 0,
                    lineIndex: `${deletionLine.unifiedLineIndex},${splitLineIndex}`
                });
            }
            if (additionLine != null) {
                appendContent(diff.additionLines[additionLine.lineIndex], additionLine.lineIndex, bucket.additionSegments, bucket.additionContent);
                bucket.additionInfo.push({
                    type: type === "change" ? "change-addition" : type,
                    lineNumber: additionLine.lineNumber,
                    altLineNumber: type === "change" ? void 0 : deletionLine.lineNumber ?? void 0,
                    lineIndex: `${additionLine.unifiedLineIndex},${splitLineIndex}`
                });
            }
        }
    });
    for (const bucket of buckets.values()){
        if (bucket.deletionContent.length === 0 && bucket.additionContent.length === 0) continue;
        const deletionFile = {
            name: diff.prevName ?? diff.name,
            contents: bucket.deletionContent.value
        };
        const additionFile = {
            name: diff.name,
            contents: bucket.additionContent.value
        };
        const { deletionLines: deletionLines, additionLines: additionLines } = $688ba6849a1df22e$var$renderTwoFiles({
            deletionFile: deletionFile,
            deletionInfo: bucket.deletionInfo,
            deletionDecorations: bucket.deletionDecorations,
            additionFile: additionFile,
            additionInfo: bucket.additionInfo,
            additionDecorations: bucket.additionDecorations,
            highlighter: highlighter,
            options: options,
            languageOverride: forcePlainText ? "text" : diff.lang
        });
        if (shouldGroupAll) {
            code.deletionLines = deletionLines;
            code.additionLines = additionLines;
            continue;
        }
        if (bucket.deletionSegments.length > 0) for (const seg of bucket.deletionSegments)for(let i = 0; i < seg.count; i++)code.deletionLines[seg.targetIndex + i] = deletionLines[seg.originalOffset + i];
        else code.deletionLines.push(...deletionLines);
        if (bucket.additionSegments.length > 0) for (const seg of bucket.additionSegments)for(let i = 0; i < seg.count; i++)code.additionLines[seg.targetIndex + i] = additionLines[seg.originalOffset + i];
        else code.additionLines.push(...additionLines);
    }
    return {
        code: code,
        themeStyles: themeStyles,
        baseThemeType: baseThemeType
    };
}
function $688ba6849a1df22e$var$computeLineDiffDecorations({ deletionLine: deletionLine, additionLine: additionLine, deletionLineIndex: deletionLineIndex, additionLineIndex: additionLineIndex, deletionDecorations: deletionDecorations, additionDecorations: additionDecorations, lineDiffType: lineDiffType, maxLineDiffLength: maxLineDiffLength }) {
    if (deletionLine == null || additionLine == null || lineDiffType === "none") return;
    deletionLine = (0, $edf66b00d8168e8a$export$b6130a543868c75e)(deletionLine);
    additionLine = (0, $edf66b00d8168e8a$export$b6130a543868c75e)(additionLine);
    if (deletionLine.length > maxLineDiffLength || additionLine.length > maxLineDiffLength) return;
    const lineDiff = lineDiffType === "char" ? (0, $d5f86155ad1115b9$export$325021f2061a40f5)(deletionLine, additionLine) : (0, $92d521d03e53a52f$export$3941790a84174c86)(deletionLine, additionLine);
    const deletionSpans = [];
    const additionSpans = [];
    const enableJoin = lineDiffType === "word-alt";
    const lastItem = lineDiff.at(-1);
    for (const item of lineDiff){
        const isLastItem = item === lastItem;
        if (!item.added && !item.removed) {
            (0, $f7a2cee45883e48d$export$a2e48160801caed)({
                item: item,
                arr: deletionSpans,
                enableJoin: enableJoin,
                isNeutral: true,
                isLastItem: isLastItem
            });
            (0, $f7a2cee45883e48d$export$a2e48160801caed)({
                item: item,
                arr: additionSpans,
                enableJoin: enableJoin,
                isNeutral: true,
                isLastItem: isLastItem
            });
        } else if (item.removed) (0, $f7a2cee45883e48d$export$a2e48160801caed)({
            item: item,
            arr: deletionSpans,
            enableJoin: enableJoin,
            isLastItem: isLastItem
        });
        else (0, $f7a2cee45883e48d$export$a2e48160801caed)({
            item: item,
            arr: additionSpans,
            enableJoin: enableJoin,
            isLastItem: isLastItem
        });
    }
    let spanIndex = 0;
    for (const span of deletionSpans){
        if (span[0] === 1) deletionDecorations.push((0, $f7a2cee45883e48d$export$87d096fbee48ce80)({
            line: deletionLineIndex,
            spanStart: spanIndex,
            spanLength: span[1].length
        }));
        spanIndex += span[1].length;
    }
    spanIndex = 0;
    for (const span of additionSpans){
        if (span[0] === 1) additionDecorations.push((0, $f7a2cee45883e48d$export$87d096fbee48ce80)({
            line: additionLineIndex,
            spanStart: spanIndex,
            spanLength: span[1].length
        }));
        spanIndex += span[1].length;
    }
}
function $688ba6849a1df22e$var$createBucket() {
    return {
        deletionContent: {
            push (value) {
                this.value += value;
                this.length++;
            },
            value: "",
            length: 0
        },
        additionContent: {
            push (value) {
                this.value += value;
                this.length++;
            },
            value: "",
            length: 0
        },
        deletionInfo: [],
        additionInfo: [],
        deletionDecorations: [],
        additionDecorations: [],
        deletionSegments: [],
        additionSegments: []
    };
}
function $688ba6849a1df22e$var$renderTwoFiles({ deletionFile: deletionFile, additionFile: additionFile, deletionInfo: deletionInfo, additionInfo: additionInfo, highlighter: highlighter, deletionDecorations: deletionDecorations, additionDecorations: additionDecorations, languageOverride: languageOverride, options: { theme: themeOrThemes = (0, $6986aac91971cc6d$export$bcfc57767d137a59), ...options } }) {
    const deletionLang = languageOverride ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(deletionFile.name);
    const additionLang = languageOverride ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(additionFile.name);
    const { state: state, transformers: transformers } = (0, $8eabaf3795872bdc$export$b288a91f7d0d05d6)(options.useTokenTransformer);
    const hastConfig = (()=>{
        return typeof themeOrThemes === "string" ? {
            ...options,
            lang: "text",
            theme: themeOrThemes,
            transformers: transformers,
            decorations: void 0,
            defaultColor: false,
            cssVariablePrefix: (0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("token")
        } : {
            ...options,
            lang: "text",
            themes: themeOrThemes,
            transformers: transformers,
            decorations: void 0,
            defaultColor: false,
            cssVariablePrefix: (0, $ab1b0607c7492dc4$export$df7d907f3fbd85f9)("token")
        };
    })();
    return {
        deletionLines: (()=>{
            if (deletionFile.contents === "") return [];
            hastConfig.lang = deletionLang;
            state.lineInfo = deletionInfo;
            hastConfig.decorations = deletionDecorations;
            return (0, $fb43f60ae112d7f4$export$c18bf1cf224af47d)(highlighter.codeToHast((0, $edf66b00d8168e8a$export$b6130a543868c75e)(deletionFile.contents), hastConfig));
        })(),
        additionLines: (()=>{
            if (additionFile.contents === "") return [];
            hastConfig.lang = additionLang;
            hastConfig.decorations = additionDecorations;
            state.lineInfo = additionInfo;
            return (0, $fb43f60ae112d7f4$export$c18bf1cf224af47d)(highlighter.codeToHast((0, $edf66b00d8168e8a$export$b6130a543868c75e)(additionFile.contents), hastConfig));
        })()
    };
}



//#region src/renderers/DiffHunksRenderer.ts
let $20c00fd23bdb2e87$var$instanceId = -1;
var $20c00fd23bdb2e87$export$ed1701ccb6824959 = class {
    __id = `diff-hunks-renderer:${++$20c00fd23bdb2e87$var$instanceId}`;
    highlighter;
    diff;
    expandedHunks = /* @__PURE__ */ new Map();
    deletionAnnotations = {};
    additionAnnotations = {};
    computedLang = "text";
    renderCache;
    constructor(options = {
        theme: (0, $6986aac91971cc6d$export$bcfc57767d137a59)
    }, onRenderUpdate, workerManager){
        this.options = options;
        this.onRenderUpdate = onRenderUpdate;
        this.workerManager = workerManager;
        if (workerManager?.isWorkingPool() !== true) this.highlighter = (0, $e1de8f8a9ed7d4cd$export$5ce36088543a0a6f)(options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59)) ? (0, $5038ef2223d0d43d$export$b046b6d0abcdff6a)() : void 0;
    }
    cleanUp() {
        this.recycle();
        this.expandedHunks.clear();
        this.workerManager = void 0;
        this.onRenderUpdate = void 0;
    }
    recycle() {
        this.highlighter = void 0;
        this.diff = void 0;
        this.renderCache = void 0;
        this.additionAnnotations = {};
        this.deletionAnnotations = {};
        this.workerManager?.cleanUpTasks(this);
    }
    setOptions(options) {
        this.options = options;
    }
    mergeOptions(options) {
        this.options = {
            ...this.options,
            ...options
        };
    }
    expandHunk(index, direction, expansionLineCount = this.getOptionsWithDefaults().expansionLineCount) {
        const region = {
            ...this.expandedHunks.get(index) ?? {
                fromStart: 0,
                fromEnd: 0
            }
        };
        if (direction === "up" || direction === "both") region.fromStart += expansionLineCount;
        if (direction === "down" || direction === "both") region.fromEnd += expansionLineCount;
        if (this.renderCache?.highlighted !== true) this.renderCache = void 0;
        this.expandedHunks.set(index, region);
    }
    getExpandedHunk(hunkIndex) {
        return this.expandedHunks.get(hunkIndex) ?? (0, $6986aac91971cc6d$export$6c97fd980b17f9d2);
    }
    getExpandedHunksMap() {
        return this.expandedHunks;
    }
    setLineAnnotations(lineAnnotations) {
        this.additionAnnotations = {};
        this.deletionAnnotations = {};
        for (const annotation of lineAnnotations){
            const map = (()=>{
                switch(annotation.side){
                    case "deletions":
                        return this.deletionAnnotations;
                    case "additions":
                        return this.additionAnnotations;
                }
            })();
            const arr = map[annotation.lineNumber] ?? [];
            map[annotation.lineNumber] = arr;
            arr.push(annotation);
        }
    }
    getUnifiedLineDecoration({ lineType: lineType }) {
        return {
            gutterLineType: lineType
        };
    }
    getSplitLineDecoration({ side: side, type: type }) {
        if (type !== "change") return {
            gutterLineType: type
        };
        return {
            gutterLineType: side === "deletions" ? "change-deletion" : "change-addition"
        };
    }
    createAnnotationElement(span) {
        return (0, $03fd4bd96344ff46$export$a11205b4d57749fb)(span);
    }
    getOptionsWithDefaults() {
        const { diffIndicators: diffIndicators = "bars", diffStyle: diffStyle = "split", disableBackground: disableBackground = false, disableFileHeader: disableFileHeader = false, disableLineNumbers: disableLineNumbers = false, disableVirtualizationBuffers: disableVirtualizationBuffers = false, collapsed: collapsed = false, expandUnchanged: expandUnchanged = false, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac), expansionLineCount: expansionLineCount = 100, hunkSeparators: hunkSeparators = "line-info", lineDiffType: lineDiffType = "word-alt", maxLineDiffLength: maxLineDiffLength = 1e3, overflow: overflow = "scroll", stickyHeader: stickyHeader = false, theme: theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59), headerRenderMode: headerRenderMode = "default", tokenizeMaxLineLength: tokenizeMaxLineLength = 1e3, tokenizeMaxLength: tokenizeMaxLength = (0, $6986aac91971cc6d$export$b31ab775814f11e2), useTokenTransformer: useTokenTransformer = false, useCSSClasses: useCSSClasses = false } = this.options;
        return {
            diffIndicators: diffIndicators,
            diffStyle: diffStyle,
            disableBackground: disableBackground,
            disableFileHeader: disableFileHeader,
            disableLineNumbers: disableLineNumbers,
            disableVirtualizationBuffers: disableVirtualizationBuffers,
            collapsed: collapsed,
            expandUnchanged: expandUnchanged,
            collapsedContextThreshold: collapsedContextThreshold,
            expansionLineCount: expansionLineCount,
            hunkSeparators: hunkSeparators,
            lineDiffType: lineDiffType,
            maxLineDiffLength: maxLineDiffLength,
            overflow: overflow,
            stickyHeader: stickyHeader,
            theme: this.workerManager?.getDiffRenderOptions().theme ?? theme,
            headerRenderMode: headerRenderMode,
            tokenizeMaxLineLength: tokenizeMaxLineLength,
            tokenizeMaxLength: tokenizeMaxLength,
            useTokenTransformer: useTokenTransformer,
            useCSSClasses: useCSSClasses
        };
    }
    async initializeHighlighter() {
        this.highlighter = await (0, $5038ef2223d0d43d$export$3ae4f582c943284e)((0, $3dc03ceed6671d25$export$d8fa3650d67306ca)(this.computedLang, this.options));
        return this.highlighter;
    }
    hydrate(diff) {
        if (diff == null) return;
        this.diff = diff;
        const { options: options } = this.getRenderOptions(diff);
        const massiveDiff = $20c00fd23bdb2e87$var$isDiffMassive(diff, this.getTokenizeMaxLength());
        let cache = this.workerManager?.getDiffResultCache(diff);
        if (cache != null && !(0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(options, cache.options)) cache = void 0;
        this.renderCache ??= {
            diff: diff,
            highlighted: !massiveDiff && !(0, $ac8a37f5a3c58257$export$e92605dcb43e76fc)(diff),
            options: options,
            result: massiveDiff ? void 0 : cache?.result,
            renderRange: void 0
        };
        if (this.workerManager?.isWorkingPool() === true) {
            if (this.renderCache.result == null && !massiveDiff) this.workerManager.highlightDiffAST(this, this.diff);
        } else if (this.highlighter == null) {
            this.computedLang = diff.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(diff.name);
            this.initializeHighlighter();
        }
    }
    getRenderOptions(diff) {
        const options = (()=>{
            if (this.workerManager?.isWorkingPool() === true) return this.workerManager.getDiffRenderOptions();
            const { theme: theme, tokenizeMaxLineLength: tokenizeMaxLineLength, lineDiffType: lineDiffType, maxLineDiffLength: maxLineDiffLength } = this.getOptionsWithDefaults();
            return {
                theme: theme,
                useTokenTransformer: (0, $0b5b6647dbdfacae$export$b3fc1fc961cc0c)(this.options),
                tokenizeMaxLineLength: tokenizeMaxLineLength,
                lineDiffType: lineDiffType,
                maxLineDiffLength: maxLineDiffLength
            };
        })();
        this.getOptionsWithDefaults();
        const { renderCache: renderCache } = this;
        if (renderCache?.result == null) return {
            options: options,
            forceHighlight: true
        };
        if (!(0, $dba1055e9d278b35$export$3ad525473176feb1)(diff, renderCache.diff) || !(0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(options, renderCache.options)) return {
            options: options,
            forceHighlight: true
        };
        return {
            options: options,
            forceHighlight: false
        };
    }
    renderDiff(diff = this.renderCache?.diff, renderRange = (0, $6986aac91971cc6d$export$de9ceafea6c24cf3)) {
        if (diff == null) return;
        const { expandUnchanged: expandUnchanged = false, collapsedContextThreshold: collapsedContextThreshold } = this.getOptionsWithDefaults();
        let { options: options, forceHighlight: forceHighlight } = this.getRenderOptions(diff);
        const cache = this.getMatchingWorkerResultCache(diff, options);
        if (cache != null && !this.hasHighlightedRenderCache(diff, options)) {
            this.renderCache = {
                diff: diff,
                highlighted: true,
                renderRange: void 0,
                ...cache
            };
            forceHighlight = false;
        }
        this.renderCache ??= {
            diff: diff,
            highlighted: false,
            options: options,
            result: void 0,
            renderRange: void 0
        };
        const hasContent = diff.additionLines.length > 0 || diff.deletionLines.length > 0;
        const forcePlainText = !hasContent || (0, $ac8a37f5a3c58257$export$e92605dcb43e76fc)(diff) || $20c00fd23bdb2e87$var$isDiffMassive(diff, this.getTokenizeMaxLength());
        const newContent = !(0, $dba1055e9d278b35$export$3ad525473176feb1)(diff, this.renderCache.diff);
        const newRenderRange = !(0, $27129b485d2e8f5d$export$7df1d5d844442f33)(this.renderCache.renderRange, renderRange);
        if (this.workerManager?.isWorkingPool() === true) {
            if (forcePlainText || this.renderCache.result == null || !this.renderCache.highlighted && (newContent || newRenderRange)) {
                this.renderCache.diff = diff;
                this.renderCache.options = options;
                this.renderCache.highlighted = false;
                if (this.renderCache.result == null || newContent || newRenderRange || forceHighlight) this.renderCache.result = this.workerManager.getPlainDiffAST(diff, renderRange.startingLine, renderRange.totalLines, (0, $21c8eb6d7f07b5b0$export$e14e0cdc699e8e20)(renderRange) ? true : expandUnchanged ? true : this.expandedHunks, collapsedContextThreshold);
                this.renderCache.renderRange = renderRange;
            }
            if (!forcePlainText && hasContent && (!this.renderCache.highlighted || forceHighlight)) this.workerManager.highlightDiffAST(this, diff);
        } else {
            this.computedLang = diff.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(diff.name);
            const hasThemes = this.highlighter != null && (0, $e1de8f8a9ed7d4cd$export$5ce36088543a0a6f)(options.theme);
            const hasLangs = this.highlighter != null && (0, $78bde705d027ffd2$export$fa78c2fcbeceac38)(this.computedLang);
            const canHighlight = !forcePlainText && hasLangs;
            if (this.highlighter != null && hasThemes && (forceHighlight || forcePlainText || !this.renderCache.highlighted && canHighlight || this.renderCache.result == null)) {
                const { result: result, options: options$1 } = this.renderDiffWithHighlighter(diff, this.highlighter, forcePlainText || !hasLangs);
                this.renderCache = {
                    diff: diff,
                    options: options$1,
                    highlighted: canHighlight,
                    result: result,
                    renderRange: void 0
                };
            }
            if (!hasThemes || !forcePlainText && !hasLangs) this.asyncHighlight(diff).then(({ result: result, options: options$1 })=>{
                if (this.renderCache != null) this.renderCache.highlighted = false;
                this.onHighlightSuccess(diff, result, options$1, !forcePlainText);
            });
        }
        return this.renderCache.result != null ? this.processDiffResult(this.renderCache.diff, renderRange, this.renderCache.result) : void 0;
    }
    async asyncRender(diff, renderRange = (0, $6986aac91971cc6d$export$de9ceafea6c24cf3)) {
        const { result: result } = await this.asyncHighlight(diff);
        return this.processDiffResult(diff, renderRange, result);
    }
    createPreElement(split, totalLines, customProperties) {
        const { diffIndicators: diffIndicators, disableBackground: disableBackground, disableLineNumbers: disableLineNumbers, overflow: overflow } = this.getOptionsWithDefaults();
        return (0, $d98c49a6cb7f2b6e$export$bbf52dba466bc3d2)({
            type: "diff",
            diffIndicators: diffIndicators,
            disableBackground: disableBackground,
            disableLineNumbers: disableLineNumbers,
            overflow: overflow,
            split: split,
            totalLines: totalLines,
            customProperties: customProperties
        });
    }
    async asyncHighlight(diff) {
        const forcePlainText = $20c00fd23bdb2e87$var$isDiffMassive(diff, this.getTokenizeMaxLength());
        this.computedLang = forcePlainText ? "text" : diff.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(diff.name);
        const hasThemes = this.highlighter != null && (0, $e1de8f8a9ed7d4cd$export$5ce36088543a0a6f)(this.options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59));
        const hasLangs = forcePlainText || this.highlighter != null && (0, $78bde705d027ffd2$export$fa78c2fcbeceac38)(this.computedLang);
        if (this.highlighter == null || !hasThemes || !hasLangs) this.highlighter = await this.initializeHighlighter();
        return this.renderDiffWithHighlighter(diff, this.highlighter, forcePlainText);
    }
    renderDiffWithHighlighter(diff, highlighter, forcePlainText = false) {
        const { options: options } = this.getRenderOptions(diff);
        const { collapsedContextThreshold: collapsedContextThreshold } = this.getOptionsWithDefaults();
        return {
            result: (0, $688ba6849a1df22e$export$bb1e2b1b9fe7b5e)(diff, highlighter, options, {
                forcePlainText: forcePlainText,
                expandedHunks: forcePlainText ? true : void 0,
                collapsedContextThreshold: collapsedContextThreshold
            }),
            options: options
        };
    }
    onHighlightSuccess(diff, result, options, highlighted = true) {
        if (this.renderCache == null) return;
        const triggerRenderUpdate = !this.renderCache.highlighted || !(0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(this.renderCache.options, options) || !(0, $dba1055e9d278b35$export$3ad525473176feb1)(this.renderCache.diff, diff);
        this.renderCache = {
            diff: diff,
            options: options,
            highlighted: highlighted,
            result: result,
            renderRange: void 0
        };
        if (triggerRenderUpdate) this.onRenderUpdate?.();
    }
    getMatchingWorkerResultCache(diff, options) {
        const cache = this.workerManager?.getDiffResultCache(diff);
        if (cache == null || !(0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(options, cache.options)) return;
        return cache;
    }
    hasHighlightedRenderCache(diff, options) {
        const { renderCache: renderCache } = this;
        return renderCache?.result != null && renderCache.highlighted && (0, $dba1055e9d278b35$export$3ad525473176feb1)(diff, renderCache.diff) && (0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(options, renderCache.options);
    }
    onHighlightError(error) {
        console.error(error);
    }
    getTokenizeMaxLength() {
        return this.options.tokenizeMaxLength ?? (0, $6986aac91971cc6d$export$b31ab775814f11e2);
    }
    processDiffResult(fileDiff, renderRange, { code: code, themeStyles: themeStyles, baseThemeType: baseThemeType }) {
        const { diffStyle: diffStyle, disableFileHeader: disableFileHeader, expandUnchanged: expandUnchanged, expansionLineCount: expansionLineCount, collapsedContextThreshold: collapsedContextThreshold, hunkSeparators: hunkSeparators } = this.getOptionsWithDefaults();
        this.diff = fileDiff;
        const unified = diffStyle === "unified";
        let additionsContentAST = [];
        let deletionsContentAST = [];
        let unifiedContentAST = [];
        const hunkData = [];
        const { additionLines: additionLines, deletionLines: deletionLines } = code;
        const context = {
            rowCount: 0,
            hunkSeparators: hunkSeparators,
            additionsContentAST: additionsContentAST,
            deletionsContentAST: deletionsContentAST,
            unifiedContentAST: unifiedContentAST,
            unifiedGutterAST: (0, $f6f1fb01992c2ec8$export$275418e72db785cd)(),
            deletionsGutterAST: (0, $f6f1fb01992c2ec8$export$275418e72db785cd)(),
            additionsGutterAST: (0, $f6f1fb01992c2ec8$export$275418e72db785cd)(),
            expansionLineCount: expansionLineCount,
            hunkData: hunkData,
            incrementRowCount (count = 1) {
                context.rowCount += count;
            },
            pushToGutter (type, element) {
                switch(type){
                    case "unified":
                        context.unifiedGutterAST.children.push(element);
                        break;
                    case "deletions":
                        context.deletionsGutterAST.children.push(element);
                        break;
                    case "additions":
                        context.additionsGutterAST.children.push(element);
                        break;
                }
            }
        };
        const trailingRangeSize = $20c00fd23bdb2e87$var$calculateTrailingRangeSize(fileDiff);
        const pendingSplitContext = {
            size: 0,
            side: void 0,
            increment () {
                this.size += 1;
            },
            flush () {
                if (diffStyle === "unified") return;
                if (this.size <= 0 || this.side == null) {
                    this.side = void 0;
                    this.size = 0;
                    return;
                }
                if (this.side === "additions") {
                    context.pushToGutter("additions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(void 0, "buffer", this.size));
                    additionsContentAST?.push((0, $2bedb99ff5e4f346$export$1d4ec6e35ce12893)(this.size));
                } else {
                    context.pushToGutter("deletions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(void 0, "buffer", this.size));
                    deletionsContentAST?.push((0, $2bedb99ff5e4f346$export$1d4ec6e35ce12893)(this.size));
                }
                this.size = 0;
                this.side = void 0;
            }
        };
        const pushGutterLineNumber = (type, lineType, lineNumber, lineIndex, gutterProperties)=>{
            context.pushToGutter(type, (0, $f6f1fb01992c2ec8$export$6fcf2c49524b5dc1)(lineType, lineNumber, lineIndex, gutterProperties));
        };
        function pushSeparators(props) {
            pendingSplitContext.flush();
            if (diffStyle === "unified") $20c00fd23bdb2e87$var$pushSeparator("unified", props, context);
            else {
                $20c00fd23bdb2e87$var$pushSeparator("deletions", props, context);
                $20c00fd23bdb2e87$var$pushSeparator("additions", props, context);
            }
        }
        (0, $14677931af57706f$export$62615825adc21c24)({
            diff: fileDiff,
            diffStyle: diffStyle,
            startingLine: renderRange.startingLine,
            totalLines: renderRange.totalLines,
            expandedHunks: expandUnchanged ? true : this.expandedHunks,
            collapsedContextThreshold: collapsedContextThreshold,
            callback: ({ hunkIndex: hunkIndex, hunk: hunk, collapsedBefore: collapsedBefore, collapsedAfter: collapsedAfter, additionLine: additionLine, deletionLine: deletionLine, type: type })=>{
                const splitLineIndex = deletionLine != null ? deletionLine.splitLineIndex : additionLine.splitLineIndex;
                const unifiedLineIndex = additionLine != null ? additionLine.unifiedLineIndex : deletionLine.unifiedLineIndex;
                if (diffStyle === "split" && type !== "change") pendingSplitContext.flush();
                if (collapsedBefore > 0) pushSeparators({
                    hunkIndex: hunkIndex,
                    collapsedLines: collapsedBefore,
                    rangeSize: Math.max(hunk?.collapsedBefore ?? 0, 0),
                    hunkSpecs: hunk?.hunkSpecs,
                    isFirstHunk: hunkIndex === 0,
                    isLastHunk: false,
                    isExpandable: !fileDiff.isPartial
                });
                const lineIndex = diffStyle === "unified" ? unifiedLineIndex : splitLineIndex;
                const renderedLineContext = {
                    type: type,
                    hunkIndex: hunkIndex,
                    lineIndex: lineIndex,
                    unifiedLineIndex: unifiedLineIndex,
                    splitLineIndex: splitLineIndex,
                    deletionLine: deletionLine,
                    additionLine: additionLine
                };
                if (diffStyle === "unified") {
                    const injectedRows = this.getUnifiedInjectedRowsForLine?.(renderedLineContext);
                    if (injectedRows?.before != null) $20c00fd23bdb2e87$var$pushUnifiedInjectedRows(injectedRows.before, context);
                    let deletionLineContent = deletionLine != null ? deletionLines[deletionLine.lineIndex] : void 0;
                    let additionLineContent = additionLine != null ? additionLines[additionLine.lineIndex] : void 0;
                    if (deletionLineContent == null && additionLineContent == null) {
                        const errorMessage = "DiffHunksRenderer.processDiffResult: deletionLine and additionLine are null, something is wrong";
                        console.error(errorMessage, {
                            file: fileDiff.name
                        });
                        throw new Error(errorMessage);
                    }
                    const lineType = type === "change" ? additionLine != null ? "change-addition" : "change-deletion" : type;
                    const lineDecoration = this.getUnifiedLineDecoration({
                        type: type,
                        lineType: lineType,
                        additionLineIndex: additionLine?.lineIndex,
                        deletionLineIndex: deletionLine?.lineIndex
                    });
                    pushGutterLineNumber("unified", lineDecoration.gutterLineType, additionLine != null ? additionLine.lineNumber : deletionLine.lineNumber, `${unifiedLineIndex},${splitLineIndex}`, lineDecoration.gutterProperties);
                    if (additionLineContent != null) additionLineContent = $20c00fd23bdb2e87$var$withContentProperties(additionLineContent, lineDecoration.contentProperties);
                    else if (deletionLineContent != null) deletionLineContent = $20c00fd23bdb2e87$var$withContentProperties(deletionLineContent, lineDecoration.contentProperties);
                    $20c00fd23bdb2e87$var$pushLineWithAnnotation({
                        diffStyle: "unified",
                        type: type,
                        deletionLine: deletionLineContent,
                        additionLine: additionLineContent,
                        unifiedSpan: this.getAnnotations("unified", deletionLine?.lineNumber, additionLine?.lineNumber, hunkIndex, lineIndex),
                        createAnnotationElement: (span)=>this.createAnnotationElement(span),
                        context: context
                    });
                    if (injectedRows?.after != null) $20c00fd23bdb2e87$var$pushUnifiedInjectedRows(injectedRows.after, context);
                } else {
                    const injectedRows = this.getSplitInjectedRowsForLine?.(renderedLineContext);
                    if (injectedRows?.before != null) $20c00fd23bdb2e87$var$pushSplitInjectedRows(injectedRows.before, context, pendingSplitContext);
                    let deletionLineContent = deletionLine != null ? deletionLines[deletionLine.lineIndex] : void 0;
                    let additionLineContent = additionLine != null ? additionLines[additionLine.lineIndex] : void 0;
                    const deletionLineDecoration = this.getSplitLineDecoration({
                        side: "deletions",
                        type: type,
                        lineIndex: deletionLine?.lineIndex
                    });
                    const additionLineDecoration = this.getSplitLineDecoration({
                        side: "additions",
                        type: type,
                        lineIndex: additionLine?.lineIndex
                    });
                    if (deletionLineContent == null && additionLineContent == null) {
                        const errorMessage = "DiffHunksRenderer.processDiffResult: deletionLine and additionLine are null, something is wrong";
                        console.error(errorMessage, {
                            file: fileDiff.name
                        });
                        throw new Error(errorMessage);
                    }
                    const missingSide = (()=>{
                        if (type === "change") {
                            if (additionLineContent == null) return "additions";
                            else if (deletionLineContent == null) return "deletions";
                        }
                    })();
                    if (missingSide != null) {
                        if (pendingSplitContext.side != null && pendingSplitContext.side !== missingSide) throw new Error("DiffHunksRenderer.processDiffResult: iterateOverDiff, invalid pending splits");
                        pendingSplitContext.side = missingSide;
                        pendingSplitContext.increment();
                    }
                    const annotationSpans = this.getAnnotations("split", deletionLine?.lineNumber, additionLine?.lineNumber, hunkIndex, lineIndex);
                    if (annotationSpans != null && pendingSplitContext.size > 0) pendingSplitContext.flush();
                    if (deletionLine != null) {
                        const deletionLineDecorated = $20c00fd23bdb2e87$var$withContentProperties(deletionLineContent, deletionLineDecoration.contentProperties);
                        pushGutterLineNumber("deletions", deletionLineDecoration.gutterLineType, deletionLine.lineNumber, `${deletionLine.unifiedLineIndex},${splitLineIndex}`, deletionLineDecoration.gutterProperties);
                        if (deletionLineDecorated != null) deletionLineContent = deletionLineDecorated;
                    }
                    if (additionLine != null) {
                        const additionLineDecorated = $20c00fd23bdb2e87$var$withContentProperties(additionLineContent, additionLineDecoration.contentProperties);
                        pushGutterLineNumber("additions", additionLineDecoration.gutterLineType, additionLine.lineNumber, `${additionLine.unifiedLineIndex},${splitLineIndex}`, additionLineDecoration.gutterProperties);
                        if (additionLineDecorated != null) additionLineContent = additionLineDecorated;
                    }
                    $20c00fd23bdb2e87$var$pushLineWithAnnotation({
                        diffStyle: "split",
                        type: type,
                        additionLine: additionLineContent,
                        deletionLine: deletionLineContent,
                        ...annotationSpans,
                        createAnnotationElement: (span)=>this.createAnnotationElement(span),
                        context: context
                    });
                    if (injectedRows?.after != null) $20c00fd23bdb2e87$var$pushSplitInjectedRows(injectedRows.after, context, pendingSplitContext);
                }
                const noEOFCRDeletion = deletionLine?.noEOFCR ?? false;
                const noEOFCRAddition = additionLine?.noEOFCR ?? false;
                if (noEOFCRAddition || noEOFCRDeletion) {
                    if (noEOFCRDeletion) {
                        const noEOFType = type === "context" || type === "context-expanded" ? type : "change-deletion";
                        if (diffStyle === "unified") {
                            context.unifiedContentAST.push((0, $ad7c9e088ba31ab3$export$6f465003dc977e6d)(noEOFType));
                            context.pushToGutter("unified", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(noEOFType, "metadata", 1));
                        } else {
                            context.deletionsContentAST.push((0, $ad7c9e088ba31ab3$export$6f465003dc977e6d)(noEOFType));
                            context.pushToGutter("deletions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(noEOFType, "metadata", 1));
                            if (!noEOFCRAddition) {
                                context.pushToGutter("additions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(void 0, "buffer", 1));
                                context.additionsContentAST.push((0, $2bedb99ff5e4f346$export$1d4ec6e35ce12893)(1));
                            }
                        }
                    }
                    if (noEOFCRAddition) {
                        const noEOFType = type === "context" || type === "context-expanded" ? type : "change-addition";
                        if (diffStyle === "unified") {
                            context.unifiedContentAST.push((0, $ad7c9e088ba31ab3$export$6f465003dc977e6d)(noEOFType));
                            context.pushToGutter("unified", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(noEOFType, "metadata", 1));
                        } else {
                            context.additionsContentAST.push((0, $ad7c9e088ba31ab3$export$6f465003dc977e6d)(noEOFType));
                            context.pushToGutter("additions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(noEOFType, "metadata", 1));
                            if (!noEOFCRDeletion) {
                                context.pushToGutter("deletions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(void 0, "buffer", 1));
                                context.deletionsContentAST.push((0, $2bedb99ff5e4f346$export$1d4ec6e35ce12893)(1));
                            }
                        }
                    }
                    context.incrementRowCount(1);
                }
                if (collapsedAfter > 0 && hunkSeparators !== "simple") pushSeparators({
                    hunkIndex: type === "context-expanded" ? hunkIndex : hunkIndex + 1,
                    collapsedLines: collapsedAfter,
                    rangeSize: trailingRangeSize,
                    hunkSpecs: void 0,
                    isFirstHunk: false,
                    isLastHunk: true,
                    isExpandable: !fileDiff.isPartial
                });
                context.incrementRowCount(1);
            }
        });
        if (diffStyle === "split") pendingSplitContext.flush();
        const totalLines = Math.max((0, $e6fb4b0b54142a9f$export$d3f1a6c0d274d994)(fileDiff.hunks), fileDiff.additionLines.length ?? 0, fileDiff.deletionLines.length ?? 0);
        const hasBuffer = renderRange.bufferBefore > 0 || renderRange.bufferAfter > 0;
        const shouldIncludeAdditions = !unified && fileDiff.type !== "deleted";
        const shouldIncludeDeletions = !unified && fileDiff.type !== "new";
        const hasContent = context.rowCount > 0 || hasBuffer;
        additionsContentAST = shouldIncludeAdditions && hasContent ? additionsContentAST : void 0;
        deletionsContentAST = shouldIncludeDeletions && hasContent ? deletionsContentAST : void 0;
        unifiedContentAST = unified && hasContent ? unifiedContentAST : void 0;
        const preNode = this.createPreElement(deletionsContentAST != null && additionsContentAST != null, totalLines);
        return {
            unifiedGutterAST: unified && hasContent ? context.unifiedGutterAST.children : void 0,
            unifiedContentAST: unifiedContentAST,
            deletionsGutterAST: shouldIncludeDeletions && hasContent ? context.deletionsGutterAST.children : void 0,
            deletionsContentAST: deletionsContentAST,
            additionsGutterAST: shouldIncludeAdditions && hasContent ? context.additionsGutterAST.children : void 0,
            additionsContentAST: additionsContentAST,
            hunkData: hunkData,
            preNode: preNode,
            themeStyles: themeStyles,
            baseThemeType: baseThemeType,
            headerElement: !disableFileHeader ? this.renderHeader(this.diff) : void 0,
            totalLines: totalLines,
            rowCount: context.rowCount,
            bufferBefore: renderRange.bufferBefore,
            bufferAfter: renderRange.bufferAfter,
            css: ""
        };
    }
    renderCodeAST(type, result) {
        const gutterAST = type === "unified" ? result.unifiedGutterAST : type === "deletions" ? result.deletionsGutterAST : result.additionsGutterAST;
        const contentAST = type === "unified" ? result.unifiedContentAST : type === "deletions" ? result.deletionsContentAST : result.additionsContentAST;
        if (gutterAST == null || contentAST == null) return;
        const gutter = (0, $f6f1fb01992c2ec8$export$275418e72db785cd)(gutterAST);
        gutter.properties.style = `grid-row: span ${result.rowCount}`;
        return [
            gutter,
            (0, $a72acb3cb61e0911$export$ae45562cd268c97b)(contentAST, result.rowCount)
        ];
    }
    renderFullAST(result, children = []) {
        const containerSize = this.getOptionsWithDefaults().hunkSeparators === "line-info";
        const unifiedAST = this.renderCodeAST("unified", result);
        if (unifiedAST != null) {
            children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
                tagName: "code",
                children: unifiedAST,
                properties: {
                    "data-code": "",
                    "data-container-size": containerSize ? "" : void 0,
                    "data-unified": ""
                }
            }));
            return {
                ...result.preNode,
                children: children
            };
        }
        const deletionsAST = this.renderCodeAST("deletions", result);
        if (deletionsAST != null) children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "code",
            children: deletionsAST,
            properties: {
                "data-code": "",
                "data-container-size": containerSize ? "" : void 0,
                "data-deletions": ""
            }
        }));
        const additionsAST = this.renderCodeAST("additions", result);
        if (additionsAST != null) children.push((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "code",
            children: additionsAST,
            properties: {
                "data-code": "",
                "data-container-size": containerSize ? "" : void 0,
                "data-additions": ""
            }
        }));
        return {
            ...result.preNode,
            children: children
        };
    }
    renderFullHTML(result, tempChildren = []) {
        return (0, $59ad8c13d9107e7c$export$a10125c086a4df16)(this.renderFullAST(result, tempChildren));
    }
    renderPartialHTML(children, columnType) {
        if (columnType == null) return (0, $59ad8c13d9107e7c$export$a10125c086a4df16)(children);
        return (0, $59ad8c13d9107e7c$export$a10125c086a4df16)((0, $f6f1fb01992c2ec8$export$2099ac7106a04fb9)({
            tagName: "code",
            children: children,
            properties: {
                "data-code": "",
                "data-container-size": this.getOptionsWithDefaults().hunkSeparators === "line-info" ? "" : void 0,
                [`data-${columnType}`]: ""
            }
        }));
    }
    getAnnotations(type, deletionLineNumber, additionLineNumber, hunkIndex, lineIndex) {
        const deletionSpan = {
            type: "annotation",
            hunkIndex: hunkIndex,
            lineIndex: lineIndex,
            annotations: []
        };
        if (deletionLineNumber != null) for (const anno of this.deletionAnnotations[deletionLineNumber] ?? [])deletionSpan.annotations.push((0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(anno));
        const additionSpan = {
            type: "annotation",
            hunkIndex: hunkIndex,
            lineIndex: lineIndex,
            annotations: []
        };
        if (additionLineNumber != null) for (const anno of this.additionAnnotations[additionLineNumber] ?? [])(type === "unified" ? deletionSpan : additionSpan).annotations.push((0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(anno));
        if (type === "unified") {
            if (deletionSpan.annotations.length > 0) return deletionSpan;
            return;
        }
        if (additionSpan.annotations.length === 0 && deletionSpan.annotations.length === 0) return;
        return {
            deletionSpan: deletionSpan,
            additionSpan: additionSpan
        };
    }
    renderHeader(diff) {
        const { headerRenderMode: headerRenderMode, stickyHeader: stickyHeader } = this.getOptionsWithDefaults();
        return (0, $70ef609d54bc0682$export$de00955f585ed124)({
            fileOrDiff: diff,
            mode: headerRenderMode,
            stickyHeader: stickyHeader
        });
    }
};
function $20c00fd23bdb2e87$var$getModifiedLinesString(lines) {
    return `${lines} unmodified line${lines > 1 ? "s" : ""}`;
}
function $20c00fd23bdb2e87$var$pushUnifiedInjectedRows(rows, context) {
    for (const row of rows){
        context.unifiedContentAST.push(row.content);
        context.pushToGutter("unified", row.gutter);
        context.incrementRowCount(1);
    }
}
function $20c00fd23bdb2e87$var$pushSplitInjectedRows(rows, context, pendingSplitContext) {
    for (const { deletion: deletion, addition: addition } of rows){
        if (deletion == null && addition == null) continue;
        const missingSide = deletion != null && addition != null ? void 0 : deletion == null ? "deletions" : "additions";
        if (missingSide == null || pendingSplitContext.side !== missingSide) pendingSplitContext.flush();
        if (deletion != null) {
            context.deletionsContentAST.push(deletion.content);
            context.pushToGutter("deletions", deletion.gutter);
        }
        if (addition != null) {
            context.additionsContentAST.push(addition.content);
            context.pushToGutter("additions", addition.gutter);
        }
        if (missingSide != null) {
            pendingSplitContext.side = missingSide;
            pendingSplitContext.increment();
        }
        context.incrementRowCount(1);
    }
}
function $20c00fd23bdb2e87$var$pushLineWithAnnotation({ diffStyle: diffStyle, type: type, deletionLine: deletionLine, additionLine: additionLine, unifiedSpan: unifiedSpan, deletionSpan: deletionSpan, additionSpan: additionSpan, createAnnotationElement: createAnnotationElement$1, context: context }) {
    let hasAnnotationRow = false;
    if (diffStyle === "unified") {
        if (additionLine != null) context.unifiedContentAST.push(additionLine);
        else if (deletionLine != null) context.unifiedContentAST.push(deletionLine);
        if (unifiedSpan != null) {
            const lineType = type === "change" ? deletionLine != null ? "change-deletion" : "change-addition" : type;
            context.unifiedContentAST.push(createAnnotationElement$1(unifiedSpan));
            context.pushToGutter("unified", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(lineType, "annotation", 1));
            hasAnnotationRow = true;
        }
    } else if (diffStyle === "split") {
        if (deletionLine != null) context.deletionsContentAST.push(deletionLine);
        if (additionLine != null) context.additionsContentAST.push(additionLine);
        if (deletionSpan != null) {
            const lineType = type === "change" ? deletionLine != null ? "change-deletion" : "context" : type;
            context.deletionsContentAST.push(createAnnotationElement$1(deletionSpan));
            context.pushToGutter("deletions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(lineType, "annotation", 1));
            hasAnnotationRow = true;
        }
        if (additionSpan != null) {
            const lineType = type === "change" ? additionLine != null ? "change-addition" : "context" : type;
            context.additionsContentAST.push(createAnnotationElement$1(additionSpan));
            context.pushToGutter("additions", (0, $f6f1fb01992c2ec8$export$8622585bcb778ce3)(lineType, "annotation", 1));
            hasAnnotationRow = true;
        }
    }
    if (hasAnnotationRow) context.incrementRowCount(1);
}
function $20c00fd23bdb2e87$var$pushSeparator(type, { hunkIndex: hunkIndex, collapsedLines: collapsedLines, rangeSize: rangeSize, hunkSpecs: hunkSpecs, isFirstHunk: isFirstHunk, isLastHunk: isLastHunk, isExpandable: isExpandable }, context) {
    if (collapsedLines <= 0) return;
    const linesAST = type === "unified" ? context.unifiedContentAST : type === "deletions" ? context.deletionsContentAST : context.additionsContentAST;
    if (context.hunkSeparators === "metadata") {
        if (hunkSpecs != null) {
            context.pushToGutter(type, (0, $467c81971f656628$export$2f446885d1462a2f)({
                type: "metadata",
                content: hunkSpecs,
                isFirstHunk: isFirstHunk,
                isLastHunk: isLastHunk
            }));
            linesAST.push((0, $467c81971f656628$export$2f446885d1462a2f)({
                type: "metadata",
                content: hunkSpecs,
                isFirstHunk: isFirstHunk,
                isLastHunk: isLastHunk
            }));
            if (type !== "additions") context.incrementRowCount(1);
        }
        return;
    }
    if (context.hunkSeparators === "simple") {
        if (hunkIndex > 0) {
            context.pushToGutter(type, (0, $467c81971f656628$export$2f446885d1462a2f)({
                type: "simple",
                isFirstHunk: isFirstHunk,
                isLastHunk: false
            }));
            linesAST.push((0, $467c81971f656628$export$2f446885d1462a2f)({
                type: "simple",
                isFirstHunk: isFirstHunk,
                isLastHunk: false
            }));
            if (type !== "additions") context.incrementRowCount(1);
        }
        return;
    }
    const slotName = (0, $f1d4f75c6830f6c7$export$79318a5690a6a67c)(type, hunkIndex);
    const chunked = rangeSize > context.expansionLineCount;
    const expandIndex = isExpandable ? hunkIndex : void 0;
    context.pushToGutter(type, (0, $467c81971f656628$export$2f446885d1462a2f)({
        type: context.hunkSeparators,
        content: $20c00fd23bdb2e87$var$getModifiedLinesString(collapsedLines),
        expandIndex: expandIndex,
        chunked: chunked,
        slotName: slotName,
        isFirstHunk: isFirstHunk,
        isLastHunk: isLastHunk
    }));
    linesAST.push((0, $467c81971f656628$export$2f446885d1462a2f)({
        type: context.hunkSeparators,
        content: $20c00fd23bdb2e87$var$getModifiedLinesString(collapsedLines),
        expandIndex: expandIndex,
        chunked: chunked,
        slotName: slotName,
        isFirstHunk: isFirstHunk,
        isLastHunk: isLastHunk
    }));
    if (type !== "additions") context.incrementRowCount(1);
    context.hunkData.push({
        slotName: slotName,
        hunkIndex: hunkIndex,
        lines: collapsedLines,
        type: type,
        expandable: isExpandable ? {
            up: !isFirstHunk,
            down: !isLastHunk,
            chunked: chunked
        } : void 0
    });
}
function $20c00fd23bdb2e87$var$withContentProperties(lineNode, contentProperties) {
    if (lineNode == null || lineNode.type !== "element" || contentProperties == null) return lineNode;
    return {
        ...lineNode,
        properties: {
            ...lineNode.properties,
            ...contentProperties
        }
    };
}
function $20c00fd23bdb2e87$var$isDiffMassive(diff, tokenizeMaxLength) {
    return Math.max(diff.additionLines.length, diff.deletionLines.length) > tokenizeMaxLength;
}
function $20c00fd23bdb2e87$var$calculateTrailingRangeSize(fileDiff) {
    const lastHunk = fileDiff.hunks.at(-1);
    if (lastHunk == null || fileDiff.isPartial || fileDiff.additionLines.length === 0 || fileDiff.deletionLines.length === 0) return 0;
    const additionRemaining = fileDiff.additionLines.length - (lastHunk.additionLineIndex + lastHunk.additionCount);
    const deletionRemaining = fileDiff.deletionLines.length - (lastHunk.deletionLineIndex + lastHunk.deletionCount);
    if (additionRemaining !== deletionRemaining) throw new Error(`DiffHunksRenderer.processDiffResult: trailing context mismatch (additions=${additionRemaining}, deletions=${deletionRemaining}) for ${fileDiff.name}`);
    return Math.min(additionRemaining, deletionRemaining);
}


//#region src/utils/areDiffLineAnnotationsEqual.ts
function $a3b0304f444dee7b$export$ca01e18417775cba(annotationA, annotationB) {
    return annotationA.lineNumber === annotationB.lineNumber && annotationA.side === annotationB.side && annotationA.metadata === annotationB.metadata;
}


//#region src/utils/areHunkDataEqual.ts
function $79e412ce58011e8b$export$aa926e9b1f80d0db(hunkA, hunkB) {
    return hunkA.slotName === hunkB.slotName && hunkA.hunkIndex === hunkB.hunkIndex && hunkA.lines === hunkB.lines && hunkA.type === hunkB.type && hunkA.expandable?.chunked === hunkB.expandable?.chunked && hunkA.expandable?.up === hunkB.expandable?.up && hunkA.expandable?.down === hunkB.expandable?.down;
}



//#region src/components/FileDiff.ts
let $b379a40a520278df$var$instanceId = -1;
var $b379a40a520278df$export$92d2c7803a4156dd = class {
    static LoadedCustomComponent = (0, $7b74b50028a59173$export$98ca8dd7f9e1f79e);
    __id = `file-diff:${++$b379a40a520278df$var$instanceId}`;
    fileContainer;
    spriteSVG;
    pre;
    codeUnified;
    codeDeletions;
    codeAdditions;
    bufferBefore;
    bufferAfter;
    themeCSSStyle;
    appliedThemeCSS;
    hasAdoptedThemeCSS = false;
    unsafeCSSStyle;
    appliedUnsafeCSS;
    gutterUtilityContent;
    headerElement;
    headerPrefix;
    headerMetadata;
    headerCustom;
    separatorCache = /* @__PURE__ */ new Map();
    errorWrapper;
    placeHolder;
    hunksRenderer;
    resizeManager;
    scrollSyncManager;
    interactionManager;
    annotationCache = /* @__PURE__ */ new Map();
    lineAnnotations = [];
    managersDirty = false;
    deletionFile;
    additionFile;
    fileDiff;
    renderRange;
    appliedPreAttributes;
    lastRenderedHeaderHTML;
    cachedHeaderHTML;
    lastRowCount;
    enabled = true;
    constructor(options = {
        theme: (0, $6986aac91971cc6d$export$bcfc57767d137a59)
    }, workerManager, isContainerManaged = false){
        this.options = options;
        this.workerManager = workerManager;
        this.isContainerManaged = isContainerManaged;
        this.hunksRenderer = this.createHunksRenderer(options);
        this.resizeManager = new (0, $44ea84d1b8c4f335$export$c2996b1539fb6bb1)();
        this.scrollSyncManager = new (0, $4e32724a2af3c2d6$export$2d605f5da0332df8)();
        this.interactionManager = new (0, $12fff3ed1f91ca75$export$aaa80641d584351c)("diff", (0, $12fff3ed1f91ca75$export$81858fc3df89d648)(options, typeof options.hunkSeparators === "function" || (options.hunkSeparators ?? "line-info") === "line-info" || options.hunkSeparators === "line-info-basic" ? this.handleExpandHunk : void 0, this.getLineIndex));
        this.workerManager?.subscribeToThemeChanges(this);
        this.enabled = true;
    }
    handleHighlightRender = ()=>{
        this.rerender();
    };
    getHunksRendererOptions(options) {
        return {
            ...options,
            headerRenderMode: options.renderCustomHeader != null ? "custom" : "default",
            hunkSeparators: typeof options.hunkSeparators === "function" ? "custom" : options.hunkSeparators
        };
    }
    createHunksRenderer(options) {
        return new (0, $20c00fd23bdb2e87$export$ed1701ccb6824959)(this.getHunksRendererOptions(options), this.handleHighlightRender, this.workerManager);
    }
    getLineIndex = (lineNumber, side = "additions")=>{
        if (this.fileDiff == null) return;
        const lastHunk = this.fileDiff.hunks.at(-1);
        let targetUnifiedIndex;
        let targetSplitIndex;
        hunkIterator: for (const hunk of this.fileDiff.hunks){
            let currentLineNumber = side === "deletions" ? hunk.deletionStart : hunk.additionStart;
            const hunkCount = side === "deletions" ? hunk.deletionCount : hunk.additionCount;
            let splitIndex = hunk.splitLineStart;
            let unifiedIndex = hunk.unifiedLineStart;
            if (lineNumber < currentLineNumber) {
                const difference = currentLineNumber - lineNumber;
                targetUnifiedIndex = Math.max(unifiedIndex - difference, 0);
                targetSplitIndex = Math.max(splitIndex - difference, 0);
                break hunkIterator;
            }
            if (lineNumber >= currentLineNumber + hunkCount) {
                if (hunk === lastHunk) {
                    const difference = lineNumber - (currentLineNumber + hunkCount);
                    targetUnifiedIndex = unifiedIndex + hunk.unifiedLineCount + difference;
                    targetSplitIndex = splitIndex + hunk.splitLineCount + difference;
                    break hunkIterator;
                }
                continue;
            }
            for (const content of hunk.hunkContent)if (content.type === "context") {
                if (lineNumber < currentLineNumber + content.lines) {
                    const difference = lineNumber - currentLineNumber;
                    targetSplitIndex = splitIndex + difference;
                    targetUnifiedIndex = unifiedIndex + difference;
                    break hunkIterator;
                } else {
                    currentLineNumber += content.lines;
                    splitIndex += content.lines;
                    unifiedIndex += content.lines;
                }
            } else {
                const sideCount = side === "deletions" ? content.deletions : content.additions;
                if (lineNumber < currentLineNumber + sideCount) {
                    const indexDifference = lineNumber - currentLineNumber;
                    targetUnifiedIndex = unifiedIndex + (side === "additions" ? content.deletions : 0) + indexDifference;
                    targetSplitIndex = splitIndex + indexDifference;
                    break hunkIterator;
                } else {
                    currentLineNumber += sideCount;
                    splitIndex += Math.max(content.deletions, content.additions);
                    unifiedIndex += content.deletions + content.additions;
                }
            }
            break hunkIterator;
        }
        if (targetUnifiedIndex == null || targetSplitIndex == null) return;
        return [
            targetUnifiedIndex,
            targetSplitIndex
        ];
    };
    setOptions(options) {
        if (options == null) return;
        this.options = options;
        this.cachedHeaderHTML = void 0;
        this.hunksRenderer.setOptions(this.getHunksRendererOptions(options));
        this.interactionManager.setOptions((0, $12fff3ed1f91ca75$export$81858fc3df89d648)(options, typeof options.hunkSeparators === "function" || (options.hunkSeparators ?? "line-info") === "line-info" || options.hunkSeparators === "line-info-basic" ? this.handleExpandHunk : void 0, this.getLineIndex));
    }
    mergeOptions(options) {
        this.options = {
            ...this.options,
            ...options
        };
    }
    setThemeType(themeType) {
        if ((this.options.themeType ?? "system") === themeType) return;
        this.mergeOptions({
            themeType: themeType
        });
        this.applyCachedThemeState(themeType);
    }
    applyCachedThemeState(themeType) {
        if (typeof this.options.theme === "string" || this.fileContainer == null || this.appliedThemeCSS == null) return false;
        const effectiveThemeType = this.appliedThemeCSS.baseThemeType ?? themeType;
        if (this.appliedThemeCSS.themeType === effectiveThemeType) return false;
        this.applyThemeState(this.fileContainer, this.appliedThemeCSS.themeStyles, themeType, this.appliedThemeCSS.baseThemeType);
        return true;
    }
    hasThemeChanged() {
        return this.appliedThemeCSS != null && !(0, $0246eee5e18b0420$export$e40448283aec01f1)(this.appliedThemeCSS.theme, this.options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59));
    }
    getHoveredLine = ()=>{
        return this.interactionManager.getHoveredLine();
    };
    setLineAnnotations(lineAnnotations) {
        this.lineAnnotations = lineAnnotations;
    }
    canPartiallyRender(forceRender, annotationsChanged, didContentChange) {
        if (forceRender || annotationsChanged || didContentChange || typeof this.options.hunkSeparators === "function") return false;
        return true;
    }
    setSelectedLines(range, options) {
        this.interactionManager.setSelection(range, options);
    }
    flushManagers() {
        if (!this.managersDirty || this.pre == null) {
            this.managersDirty = false;
            return;
        }
        const { diffStyle: diffStyle = "split", overflow: overflow = "scroll" } = this.options;
        this.interactionManager.setup(this.pre);
        this.resizeManager.setup(this.pre, overflow === "wrap");
        if (overflow === "scroll" && diffStyle === "split") this.scrollSyncManager.setup(this.pre, this.codeDeletions, this.codeAdditions);
        else this.scrollSyncManager.cleanUp();
        this.managersDirty = false;
    }
    cleanUp(recycle = false) {
        this.resizeManager.cleanUp();
        this.interactionManager.cleanUp();
        this.scrollSyncManager.cleanUp();
        this.managersDirty = false;
        this.workerManager?.unsubscribeToThemeChanges(this);
        this.renderRange = void 0;
        if (!this.isContainerManaged) this.fileContainer?.remove();
        this.fileContainer = void 0;
        this.lineAnnotations = [];
        this.clearAuxiliaryNodes();
        this.annotationCache.clear();
        this.pre = void 0;
        this.codeUnified = void 0;
        this.codeDeletions = void 0;
        this.codeAdditions = void 0;
        this.bufferBefore = void 0;
        this.bufferAfter = void 0;
        this.appliedPreAttributes = void 0;
        this.headerElement = void 0;
        this.headerPrefix = void 0;
        this.headerMetadata = void 0;
        this.headerCustom = void 0;
        this.placeHolder = void 0;
        this.lastRenderedHeaderHTML = void 0;
        if (!recycle) this.cachedHeaderHTML = void 0;
        this.errorWrapper = void 0;
        this.spriteSVG = void 0;
        this.lastRowCount = void 0;
        this.themeCSSStyle = void 0;
        this.appliedThemeCSS = void 0;
        this.hasAdoptedThemeCSS = false;
        this.unsafeCSSStyle = void 0;
        this.appliedUnsafeCSS = void 0;
        if (recycle) this.hunksRenderer.recycle();
        else {
            this.hunksRenderer.cleanUp();
            this.workerManager = void 0;
            this.fileDiff = void 0;
            this.deletionFile = void 0;
            this.additionFile = void 0;
        }
        this.enabled = false;
    }
    virtualizedSetup() {
        this.enabled = true;
        this.workerManager?.subscribeToThemeChanges(this);
    }
    hydrate(props) {
        const { fileContainer: fileContainer, prerenderedHTML: prerenderedHTML, preventEmit: preventEmit = false, lineAnnotations: lineAnnotations, oldFile: oldFile, newFile: newFile, fileDiff: fileDiff } = props;
        this.hydrateElements(fileContainer, prerenderedHTML);
        if ($b379a40a520278df$var$shouldRenderCode(this.pre, $b379a40a520278df$var$hasDiffContent({
            fileDiff: fileDiff,
            oldFile: oldFile,
            newFile: newFile
        }), this.options.collapsed) || $b379a40a520278df$var$shouldRenderHeader(this.headerElement, $b379a40a520278df$var$hasDiffHeaderContent({
            fileDiff: fileDiff,
            oldFile: oldFile,
            newFile: newFile
        }), this.options.disableFileHeader)) this.render({
            ...props,
            preventEmit: true
        });
        else this.hydrationSetup({
            fileDiff: fileDiff,
            oldFile: oldFile,
            newFile: newFile,
            lineAnnotations: lineAnnotations
        });
        if (!preventEmit) this.emitPostRender();
    }
    hydrateElements(fileContainer, prerenderedHTML) {
        (0, $7951d831173cd21c$export$2793dc7c568f39d4)(fileContainer, prerenderedHTML);
        for (const element of fileContainer.shadowRoot?.children ?? []){
            if (element instanceof SVGElement) {
                this.spriteSVG = element;
                continue;
            }
            if (!(element instanceof HTMLElement)) continue;
            if (element instanceof HTMLPreElement) {
                this.pre = element;
                for (const code of element.children){
                    if (!(code instanceof HTMLElement) || code.tagName.toLowerCase() !== "code") continue;
                    if ("deletions" in code.dataset) this.codeDeletions = code;
                    if ("additions" in code.dataset) this.codeAdditions = code;
                    if ("unified" in code.dataset) this.codeUnified = code;
                }
                continue;
            }
            if ("diffsHeader" in element.dataset) {
                this.headerElement = element;
                continue;
            }
            if (element instanceof HTMLStyleElement && element.hasAttribute((0, $6986aac91971cc6d$export$4ce037b01ed1780d))) {
                this.themeCSSStyle = element;
                continue;
            }
            if (element instanceof HTMLStyleElement && element.hasAttribute((0, $6986aac91971cc6d$export$26189492e726cd65))) {
                this.unsafeCSSStyle = element;
                this.appliedUnsafeCSS = element.textContent;
                continue;
            }
        }
        if (this.pre != null) {
            this.syncCodeNodesFromPre(this.pre);
            this.pre.removeAttribute("data-dehydrated");
        }
        this.fileContainer = fileContainer;
        this.hydrateMeasuredScrollbar();
    }
    hydrationSetup({ fileDiff: fileDiff, oldFile: oldFile, newFile: newFile, lineAnnotations: lineAnnotations }) {
        this.lineAnnotations = lineAnnotations ?? this.lineAnnotations;
        this.additionFile = newFile;
        this.deletionFile = oldFile;
        this.fileDiff = fileDiff ?? (oldFile != null && newFile != null ? (0, $80c7965a049ab6e5$export$98aafcdfd1bcb1be)(oldFile, newFile, this.options.parseDiffOptions) : void 0);
        if (this.pre == null) return;
        this.hunksRenderer.hydrate(this.fileDiff);
        this.renderAnnotations();
        this.renderGutterUtility();
        this.injectUnsafeCSS();
        this.managersDirty = true;
        this.flushManagers();
    }
    rerender() {
        if (!this.enabled || this.fileDiff == null && this.additionFile == null && this.deletionFile == null) return;
        this.render({
            forceRender: true,
            renderRange: this.renderRange
        });
    }
    handleExpandHunk = (hunkIndex, direction, expansionLineCountOverride)=>{
        this.expandHunk(hunkIndex, direction, expansionLineCountOverride);
    };
    expandHunk = (hunkIndex, direction, expansionLineCountOverride)=>{
        this.hunksRenderer.expandHunk(hunkIndex, direction, expansionLineCountOverride);
        this.rerender();
    };
    render({ oldFile: oldFile, newFile: newFile, fileDiff: fileDiff, deferManagers: deferManagers = false, forceRender: forceRender = false, preventEmit: preventEmit = false, lineAnnotations: lineAnnotations, fileContainer: fileContainer, containerWrapper: containerWrapper, renderRange: renderRange }) {
        if (!this.enabled) throw new Error("FileDiff.render: attempting to call render after cleaned up");
        const { collapsed: collapsed = false, themeType: themeType = "system" } = this.options;
        const nextRenderRange = collapsed ? void 0 : renderRange;
        const themeChanged = this.hasThemeChanged();
        const filesDidChange = oldFile != null && newFile != null && (!(0, $2f249b89688d7794$export$66ae137c56162891)(oldFile, this.deletionFile) || !(0, $2f249b89688d7794$export$66ae137c56162891)(newFile, this.additionFile));
        let diffDidChange = fileDiff != null && fileDiff !== this.fileDiff;
        const annotationsChanged = lineAnnotations != null && (lineAnnotations.length > 0 || this.lineAnnotations.length > 0) ? lineAnnotations !== this.lineAnnotations : false;
        if (!collapsed && (0, $27129b485d2e8f5d$export$7df1d5d844442f33)(nextRenderRange, this.renderRange) && !forceRender && !annotationsChanged && !themeChanged && (fileDiff != null && fileDiff === this.fileDiff || fileDiff == null && !filesDidChange)) return this.applyCachedThemeState(themeType);
        const { renderRange: previousRenderRange } = this;
        this.renderRange = nextRenderRange;
        this.deletionFile = oldFile;
        this.additionFile = newFile;
        if (fileDiff != null) this.fileDiff = fileDiff;
        else if (oldFile != null && newFile != null && filesDidChange) {
            diffDidChange = true;
            this.fileDiff = (0, $80c7965a049ab6e5$export$98aafcdfd1bcb1be)(oldFile, newFile, this.options.parseDiffOptions);
        }
        if (diffDidChange) this.cachedHeaderHTML = void 0;
        if (lineAnnotations != null) this.setLineAnnotations(lineAnnotations);
        if (this.fileDiff == null) return false;
        this.hunksRenderer.setOptions(this.getHunksRendererOptions(this.options));
        this.hunksRenderer.setLineAnnotations(this.lineAnnotations);
        const { disableErrorHandling: disableErrorHandling = false, disableFileHeader: disableFileHeader = false } = this.options;
        if (disableFileHeader) {
            if (this.headerElement != null) {
                this.headerElement.remove();
                this.headerElement = void 0;
                this.lastRenderedHeaderHTML = void 0;
            }
            this.clearHeaderSlots();
        }
        fileContainer = this.getOrCreateFileContainer(fileContainer, containerWrapper);
        this.applyCachedThemeState(themeType);
        if (collapsed) {
            this.removeRenderedCode();
            this.clearAuxiliaryNodes();
            try {
                const hunksResult = this.hunksRenderer.renderDiff(this.fileDiff, (0, $6986aac91971cc6d$export$af82796f7deef107));
                if (hunksResult != null) this.applyThemeState(fileContainer, hunksResult.themeStyles, themeType, hunksResult.baseThemeType);
                if (hunksResult?.headerElement != null) this.applyHeaderToDOM(hunksResult.headerElement, fileContainer);
                this.renderSeparators([]);
                this.injectUnsafeCSS();
            } catch (error) {
                if (disableErrorHandling) throw error;
                console.error(error);
                if (error instanceof Error) this.applyErrorToDOM(error, fileContainer);
            }
            if (!preventEmit) this.emitPostRender();
            return true;
        }
        try {
            const pre = this.getOrCreatePreNode(fileContainer);
            if (!(this.canPartiallyRender(forceRender, annotationsChanged, filesDidChange || diffDidChange || themeChanged) && this.applyPartialRender({
                previousRenderRange: previousRenderRange,
                renderRange: nextRenderRange
            }))) {
                const hunksResult = this.hunksRenderer.renderDiff(this.fileDiff, nextRenderRange);
                if (hunksResult == null) {
                    if (this.workerManager?.isInitialized() === false) this.workerManager.initialize().then(()=>this.rerender());
                    return false;
                }
                this.applyThemeState(fileContainer, hunksResult.themeStyles, themeType, hunksResult.baseThemeType);
                if (hunksResult.headerElement != null) this.applyHeaderToDOM(hunksResult.headerElement, fileContainer);
                if (hunksResult.additionsContentAST != null || hunksResult.deletionsContentAST != null || hunksResult.unifiedContentAST != null) this.applyHunksToDOM(pre, hunksResult);
                else if (this.pre != null) {
                    this.pre.remove();
                    this.pre = void 0;
                }
                this.renderSeparators(hunksResult.hunkData);
            }
            this.applyBuffers(pre, nextRenderRange);
            this.injectUnsafeCSS();
            this.renderAnnotations();
            this.renderGutterUtility();
            this.managersDirty = true;
            if (!deferManagers) this.flushManagers();
        } catch (error) {
            if (disableErrorHandling) throw error;
            console.error(error);
            if (error instanceof Error) this.applyErrorToDOM(error, fileContainer);
        }
        if (!preventEmit) this.emitPostRender();
        return true;
    }
    emitPostRender() {
        if (this.fileContainer != null) this.options.onPostRender?.(this.fileContainer, this);
    }
    removeRenderedCode() {
        this.resizeManager.cleanUp();
        this.scrollSyncManager.cleanUp();
        this.interactionManager.cleanUp();
        this.bufferBefore?.remove();
        this.bufferBefore = void 0;
        this.bufferAfter?.remove();
        this.bufferAfter = void 0;
        this.codeUnified?.remove();
        this.codeUnified = void 0;
        this.codeDeletions?.remove();
        this.codeDeletions = void 0;
        this.codeAdditions?.remove();
        this.codeAdditions = void 0;
        this.pre?.remove();
        this.pre = void 0;
        this.appliedPreAttributes = void 0;
        this.lastRowCount = void 0;
    }
    clearAuxiliaryNodes() {
        for (const { element: element } of this.separatorCache.values())element.remove();
        this.separatorCache.clear();
        for (const { element: element } of this.annotationCache.values())element.remove();
        this.annotationCache.clear();
        this.gutterUtilityContent?.remove();
        this.gutterUtilityContent = void 0;
    }
    renderPlaceholder(height) {
        if (this.fileContainer == null) return false;
        this.cleanChildNodes();
        if (this.placeHolder == null) {
            const shadowRoot = this.fileContainer.shadowRoot ?? this.fileContainer.attachShadow({
                mode: "open"
            });
            this.placeHolder = document.createElement("div");
            this.placeHolder.dataset.placeholder = "";
            shadowRoot.appendChild(this.placeHolder);
        }
        this.placeHolder.style.setProperty("height", `${height}px`);
        return true;
    }
    primeHighlightCache() {
        const { fileDiff: fileDiff, workerManager: workerManager } = this;
        if (fileDiff == null || workerManager == null || (0, $ac8a37f5a3c58257$export$e92605dcb43e76fc)(fileDiff)) return;
        const tokenizeMaxLength = this.options.tokenizeMaxLength ?? (0, $6986aac91971cc6d$export$b31ab775814f11e2);
        if (Math.max(fileDiff.additionLines.length, fileDiff.deletionLines.length) > tokenizeMaxLength) return;
        workerManager.primeDiffHighlightCache(fileDiff);
    }
    cleanChildNodes() {
        this.resizeManager.cleanUp();
        this.scrollSyncManager.cleanUp();
        this.interactionManager.cleanUp();
        this.clearAuxiliaryNodes();
        this.bufferAfter?.remove();
        this.bufferBefore?.remove();
        this.codeAdditions?.remove();
        this.codeDeletions?.remove();
        this.codeUnified?.remove();
        this.errorWrapper?.remove();
        this.headerElement?.remove();
        this.headerPrefix?.remove();
        this.headerMetadata?.remove();
        this.headerCustom?.remove();
        this.pre?.remove();
        this.spriteSVG?.remove();
        this.themeCSSStyle?.remove();
        this.unsafeCSSStyle?.remove();
        this.bufferAfter = void 0;
        this.bufferBefore = void 0;
        this.codeAdditions = void 0;
        this.codeDeletions = void 0;
        this.codeUnified = void 0;
        this.errorWrapper = void 0;
        this.headerElement = void 0;
        this.headerPrefix = void 0;
        this.headerMetadata = void 0;
        this.headerCustom = void 0;
        this.pre = void 0;
        this.spriteSVG = void 0;
        this.themeCSSStyle = void 0;
        this.appliedThemeCSS = void 0;
        this.hasAdoptedThemeCSS = false;
        this.unsafeCSSStyle = void 0;
        this.appliedUnsafeCSS = void 0;
        this.lastRenderedHeaderHTML = void 0;
        this.lastRowCount = void 0;
    }
    renderSeparators(hunkData) {
        const { hunkSeparators: hunkSeparators } = this.options;
        if (this.isContainerManaged || this.fileContainer == null || typeof hunkSeparators !== "function") {
            for (const { element: element } of this.separatorCache.values())element.remove();
            this.separatorCache.clear();
            return;
        }
        const staleSeparators = new Map(this.separatorCache);
        for (const hunk of hunkData){
            const id = hunk.slotName;
            let cache = this.separatorCache.get(id);
            if (cache == null || !(0, $79e412ce58011e8b$export$aa926e9b1f80d0db)(hunk, cache.hunkData)) {
                cache?.element.remove();
                const element = document.createElement("div");
                element.style.display = "contents";
                element.slot = hunk.slotName;
                const child = hunkSeparators(hunk, this);
                if (child != null) element.appendChild(child);
                this.fileContainer.appendChild(element);
                cache = {
                    element: element,
                    hunkData: hunk
                };
                this.separatorCache.set(id, cache);
            }
            staleSeparators.delete(id);
        }
        for (const [id, { element: element }] of staleSeparators.entries()){
            this.separatorCache.delete(id);
            element.remove();
        }
    }
    renderAnnotations() {
        if (this.isContainerManaged || this.fileContainer == null) {
            for (const { element: element } of this.annotationCache.values())element.remove();
            this.annotationCache.clear();
            return;
        }
        const staleAnnotations = new Map(this.annotationCache);
        const { renderAnnotation: renderAnnotation } = this.options;
        if (renderAnnotation != null && this.lineAnnotations.length > 0) for (const [index, annotation] of this.lineAnnotations.entries()){
            const id = `${index}-${(0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation)}`;
            let cache = this.annotationCache.get(id);
            if (cache == null || !(0, $a3b0304f444dee7b$export$ca01e18417775cba)(annotation, cache.annotation)) {
                cache?.element.remove();
                const content = renderAnnotation(annotation);
                if (content == null) continue;
                cache = {
                    element: (0, $c2c6bb2973b29e85$export$4b9f37d754cdceeb)((0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation)),
                    annotation: annotation
                };
                cache.element.appendChild(content);
                this.fileContainer.appendChild(cache.element);
                this.annotationCache.set(id, cache);
            }
            staleAnnotations.delete(id);
        }
        for (const [id, { element: element }] of staleAnnotations.entries()){
            this.annotationCache.delete(id);
            element.remove();
        }
    }
    renderGutterUtility() {
        const { renderGutterUtility: renderGutterUtility } = this.options;
        if (this.fileContainer == null || renderGutterUtility == null) {
            this.gutterUtilityContent?.remove();
            this.gutterUtilityContent = void 0;
            return;
        }
        const element = renderGutterUtility(this.interactionManager.getHoveredLine);
        if (element != null && this.gutterUtilityContent != null) return;
        else if (element == null) {
            this.gutterUtilityContent?.remove();
            this.gutterUtilityContent = void 0;
            return;
        }
        const gutterUtilityContent = (0, $b4d03e340999f061$export$9c2f722fd7aacea4)();
        gutterUtilityContent.appendChild(element);
        this.fileContainer.appendChild(gutterUtilityContent);
        this.gutterUtilityContent = gutterUtilityContent;
    }
    getOrCreateFileContainer(fileContainer, parentNode) {
        const previousContainer = this.fileContainer;
        this.fileContainer = fileContainer ?? this.fileContainer ?? document.createElement((0, $6986aac91971cc6d$export$b583bc7fc1f35cf2));
        const containerChanged = previousContainer !== this.fileContainer;
        if (previousContainer != null && containerChanged) {
            this.lastRenderedHeaderHTML = void 0;
            this.headerElement = void 0;
        }
        if (parentNode != null && this.fileContainer.parentNode !== parentNode) parentNode.appendChild(this.fileContainer);
        if (containerChanged) this.adoptReusableShellElements(this.fileContainer);
        this.ensureSpriteSVG(this.fileContainer);
        return this.fileContainer;
    }
    adoptReusableShellElements(fileContainer) {
        const { shadowRoot: shadowRoot } = fileContainer;
        if (shadowRoot == null) return;
        for (const element of shadowRoot.children)if (element instanceof SVGElement) this.spriteSVG ??= element;
        else if ((0, $0d4053e5b759c704$export$1405a8e7808a3d28)(element) && element.hasAttribute((0, $6986aac91971cc6d$export$4ce037b01ed1780d))) {
            this.themeCSSStyle ??= element;
            this.hasAdoptedThemeCSS = true;
        } else if ((0, $0d4053e5b759c704$export$1405a8e7808a3d28)(element) && element.hasAttribute((0, $6986aac91971cc6d$export$26189492e726cd65))) {
            this.unsafeCSSStyle ??= element;
            this.appliedUnsafeCSS ??= this.options.unsafeCSS ?? void 0;
        }
    }
    ensureSpriteSVG(fileContainer) {
        const shadowRoot = fileContainer.shadowRoot ?? fileContainer.attachShadow({
            mode: "open"
        });
        if (this.spriteSVG == null) {
            const fragment = document.createElement("div");
            fragment.innerHTML = (0, $166d24462d2ee37b$export$ddccfde1db76f444);
            const firstChild = fragment.firstChild;
            if (firstChild instanceof SVGElement) this.spriteSVG = firstChild;
        }
        if (this.spriteSVG != null && this.spriteSVG.parentNode !== shadowRoot) shadowRoot.appendChild(this.spriteSVG);
    }
    getOrCreatePreNode(container) {
        const shadowRoot = container.shadowRoot ?? container.attachShadow({
            mode: "open"
        });
        if (this.pre == null) {
            this.pre = document.createElement("pre");
            this.appliedPreAttributes = void 0;
            this.codeUnified = void 0;
            this.codeDeletions = void 0;
            this.codeAdditions = void 0;
            shadowRoot.appendChild(this.pre);
        } else if (this.pre.parentNode !== shadowRoot) {
            shadowRoot.appendChild(this.pre);
            this.appliedPreAttributes = void 0;
        }
        this.placeHolder?.remove();
        this.placeHolder = void 0;
        return this.pre;
    }
    syncCodeNodesFromPre(pre) {
        this.codeUnified = void 0;
        this.codeDeletions = void 0;
        this.codeAdditions = void 0;
        for (const child of Array.from(pre.children)){
            if (!(child instanceof HTMLElement)) continue;
            if (child.hasAttribute("data-unified")) this.codeUnified = child;
            else if (child.hasAttribute("data-deletions")) this.codeDeletions = child;
            else if (child.hasAttribute("data-additions")) this.codeAdditions = child;
        }
    }
    applyHeaderToDOM(headerAST, container) {
        this.cleanupErrorWrapper();
        this.placeHolder?.remove();
        this.placeHolder = void 0;
        const { fileDiff: fileDiff } = this;
        const headerHTML = this.cachedHeaderHTML ?? (0, $59ad8c13d9107e7c$export$a10125c086a4df16)(headerAST);
        this.cachedHeaderHTML = headerHTML;
        if (headerHTML !== this.lastRenderedHeaderHTML) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = headerHTML;
            const newHeader = tempDiv.firstElementChild;
            if (!(newHeader instanceof HTMLElement)) return;
            if (this.headerElement != null) container.shadowRoot?.replaceChild(newHeader, this.headerElement);
            else container.shadowRoot?.prepend(newHeader);
            this.headerElement = newHeader;
            this.lastRenderedHeaderHTML = headerHTML;
        }
        if (this.isContainerManaged || fileDiff == null) return;
        const { renderCustomHeader: renderCustomHeader, renderHeaderPrefix: renderHeaderPrefix, renderHeaderMetadata: renderHeaderMetadata } = this.options;
        if (renderCustomHeader != null) {
            const content$1 = renderCustomHeader(fileDiff) ?? void 0;
            this.headerCustom = this.upsertHeaderSlotElement(container, this.headerCustom, (0, $6986aac91971cc6d$export$87f913619cd5fa67), content$1);
            this.headerPrefix?.remove();
            this.headerMetadata?.remove();
            this.headerPrefix = void 0;
            this.headerMetadata = void 0;
            return;
        }
        const prefix = renderHeaderPrefix?.(fileDiff) ?? void 0;
        const content = renderHeaderMetadata?.(fileDiff) ?? void 0;
        this.headerPrefix = this.upsertHeaderSlotElement(container, this.headerPrefix, (0, $6986aac91971cc6d$export$69d2d3bd52efd12a), prefix);
        this.headerMetadata = this.upsertHeaderSlotElement(container, this.headerMetadata, (0, $6986aac91971cc6d$export$f5d94b4150f59afc), content);
        this.headerCustom?.remove();
        this.headerCustom = void 0;
    }
    clearHeaderSlots() {
        this.headerPrefix?.remove();
        this.headerMetadata?.remove();
        this.headerCustom?.remove();
        this.headerPrefix = void 0;
        this.headerMetadata = void 0;
        this.headerCustom = void 0;
    }
    upsertHeaderSlotElement(container, current, slot, content) {
        if (content == null) {
            current?.remove();
            return;
        }
        const element = current ?? this.createHeaderSlotElement(slot);
        if (current == null) container.appendChild(element);
        this.replaceHeaderSlotContent(element, content);
        return element;
    }
    replaceHeaderSlotContent(element, content) {
        element.replaceChildren();
        if (content instanceof Element) element.appendChild(content);
        else element.innerText = `${content}`;
    }
    createHeaderSlotElement(slot) {
        const element = document.createElement("div");
        element.slot = slot;
        return element;
    }
    injectUnsafeCSS() {
        const { unsafeCSS: unsafeCSS } = this.options;
        const shadowRoot = this.fileContainer?.shadowRoot;
        if (shadowRoot == null) return;
        if (unsafeCSS == null || unsafeCSS === "") {
            if (this.unsafeCSSStyle != null) {
                this.unsafeCSSStyle.remove();
                this.unsafeCSSStyle = void 0;
            }
            this.appliedUnsafeCSS = void 0;
            return;
        }
        if (this.unsafeCSSStyle?.parentNode === shadowRoot && this.appliedUnsafeCSS === unsafeCSS) return;
        this.unsafeCSSStyle ??= (0, $2b516b4212841f75$export$c520e3d3d812f648)();
        if (this.unsafeCSSStyle.parentNode !== shadowRoot) shadowRoot.appendChild(this.unsafeCSSStyle);
        this.unsafeCSSStyle.textContent = (0, $001f0bd23af5fd92$export$bf3957559e751562)(unsafeCSS);
        this.appliedUnsafeCSS = unsafeCSS;
    }
    applyThemeState(container, themeStyles, themeType, baseThemeType) {
        const shadowRoot = container.shadowRoot ?? container.attachShadow({
            mode: "open"
        });
        const effectiveThemeType = baseThemeType ?? themeType;
        const currentTheme = this.options.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59);
        const theme = typeof currentTheme === "string" ? currentTheme : {
            ...currentTheme
        };
        const scrollbarGutter = (0, $6c5a73e7fcb28098$export$c8735f53e6551891)(shadowRoot);
        if (this.themeCSSStyle?.parentNode === shadowRoot && this.appliedThemeCSS?.themeStyles === themeStyles && this.appliedThemeCSS.themeType === effectiveThemeType && this.appliedThemeCSS.scrollbarGutter === scrollbarGutter) {
            this.appliedThemeCSS.theme = theme;
            return;
        }
        if (this.hasAdoptedThemeCSS && this.themeCSSStyle?.parentNode === shadowRoot) {
            this.hasAdoptedThemeCSS = false;
            this.appliedThemeCSS = {
                theme: theme,
                themeStyles: themeStyles,
                themeType: effectiveThemeType,
                baseThemeType: baseThemeType,
                scrollbarGutter: scrollbarGutter
            };
            return;
        }
        this.themeCSSStyle = (0, $56283d44ece37dbc$export$a0a7f1f190c55d90)({
            shadowRoot: shadowRoot,
            currentNode: this.themeCSSStyle,
            themeCSS: (0, $001f0bd23af5fd92$export$c514b17fd29d7d29)(themeStyles, effectiveThemeType, scrollbarGutter)
        });
        this.appliedThemeCSS = this.themeCSSStyle != null ? {
            theme: theme,
            themeStyles: themeStyles,
            themeType: effectiveThemeType,
            baseThemeType: baseThemeType,
            scrollbarGutter: scrollbarGutter
        } : void 0;
    }
    hydrateMeasuredScrollbar() {
        const shadowRoot = this.fileContainer?.shadowRoot;
        if (shadowRoot == null || this.themeCSSStyle == null) return;
        this.themeCSSStyle.textContent = (0, $001f0bd23af5fd92$export$bfd64041029ebdb4)(this.themeCSSStyle.textContent ?? "", (0, $6c5a73e7fcb28098$export$c8735f53e6551891)(shadowRoot));
    }
    applyHunksToDOM(pre, result) {
        const { overflow: overflow = "scroll" } = this.options;
        const containerSize = (this.options.hunkSeparators ?? "line-info") === "line-info";
        const rowSpan = overflow === "wrap" ? result.rowCount : void 0;
        this.cleanupErrorWrapper();
        this.applyPreNodeAttributes(pre, result);
        let shouldReplace = false;
        const codeElements = [];
        const unifiedAST = this.hunksRenderer.renderCodeAST("unified", result);
        const deletionsAST = this.hunksRenderer.renderCodeAST("deletions", result);
        const additionsAST = this.hunksRenderer.renderCodeAST("additions", result);
        if (unifiedAST != null) {
            shouldReplace = this.codeUnified == null || this.codeAdditions != null || this.codeDeletions != null;
            this.codeDeletions?.remove();
            this.codeDeletions = void 0;
            this.codeAdditions?.remove();
            this.codeAdditions = void 0;
            this.codeUnified = (0, $1f97c906c36c90b4$export$e74beb130200ec1d)({
                code: this.codeUnified,
                columnType: "unified",
                rowSpan: rowSpan,
                containerSize: containerSize
            });
            this.codeUnified.innerHTML = this.hunksRenderer.renderPartialHTML(unifiedAST);
            codeElements.push(this.codeUnified);
        } else if (deletionsAST != null || additionsAST != null) {
            if (deletionsAST != null) {
                shouldReplace = this.codeDeletions == null || this.codeUnified != null;
                this.codeUnified?.remove();
                this.codeUnified = void 0;
                this.codeDeletions = (0, $1f97c906c36c90b4$export$e74beb130200ec1d)({
                    code: this.codeDeletions,
                    columnType: "deletions",
                    rowSpan: rowSpan,
                    containerSize: containerSize
                });
                this.codeDeletions.innerHTML = this.hunksRenderer.renderPartialHTML(deletionsAST);
                codeElements.push(this.codeDeletions);
            } else {
                this.codeDeletions?.remove();
                this.codeDeletions = void 0;
            }
            if (additionsAST != null) {
                shouldReplace = shouldReplace || this.codeAdditions == null || this.codeUnified != null;
                this.codeUnified?.remove();
                this.codeUnified = void 0;
                this.codeAdditions = (0, $1f97c906c36c90b4$export$e74beb130200ec1d)({
                    code: this.codeAdditions,
                    columnType: "additions",
                    rowSpan: rowSpan,
                    containerSize: containerSize
                });
                this.codeAdditions.innerHTML = this.hunksRenderer.renderPartialHTML(additionsAST);
                codeElements.push(this.codeAdditions);
            } else {
                this.codeAdditions?.remove();
                this.codeAdditions = void 0;
            }
        } else {
            this.codeUnified?.remove();
            this.codeUnified = void 0;
            this.codeDeletions?.remove();
            this.codeDeletions = void 0;
            this.codeAdditions?.remove();
            this.codeAdditions = void 0;
        }
        if (codeElements.length === 0) pre.textContent = "";
        else if (shouldReplace) pre.replaceChildren(...codeElements);
        this.lastRowCount = result.rowCount;
    }
    applyPartialRender({ previousRenderRange: previousRenderRange, renderRange: renderRange }) {
        const { pre: pre, codeUnified: codeUnified, codeAdditions: codeAdditions, codeDeletions: codeDeletions, options: { diffStyle: diffStyle = "split" } } = this;
        if (pre == null || previousRenderRange == null || renderRange == null || !Number.isFinite(previousRenderRange.totalLines) || !Number.isFinite(renderRange.totalLines) || this.lastRowCount == null) return false;
        const codeElements = this.getCodeColumns(diffStyle, codeUnified, codeDeletions, codeAdditions);
        if (codeElements == null) return false;
        const previousStart = previousRenderRange.startingLine;
        const nextStart = renderRange.startingLine;
        const previousEnd = previousStart + previousRenderRange.totalLines;
        const nextEnd = nextStart + renderRange.totalLines;
        const overlapStart = Math.max(previousStart, nextStart);
        const overlapEnd = Math.min(previousEnd, nextEnd);
        if (overlapEnd <= overlapStart) return false;
        const trimStart = Math.max(0, overlapStart - previousStart);
        const trimEnd = Math.max(0, previousEnd - overlapEnd);
        const trimResult = this.trimColumns({
            columns: codeElements,
            trimStart: trimStart,
            trimEnd: trimEnd,
            previousStart: previousStart,
            overlapStart: overlapStart,
            overlapEnd: overlapEnd,
            diffStyle: diffStyle
        });
        if (trimResult < 0) throw new Error("applyPartialRender: failed to trim to overlap");
        if (this.lastRowCount < trimResult) throw new Error("applyPartialRender: trimmed beyond DOM row count");
        let rowCount = this.lastRowCount - trimResult;
        const renderChunk = (startingLine, totalLines)=>{
            if (totalLines <= 0 || this.fileDiff == null) return;
            return this.hunksRenderer.renderDiff(this.fileDiff, {
                startingLine: startingLine,
                totalLines: totalLines,
                bufferBefore: 0,
                bufferAfter: 0
            });
        };
        const prependResult = renderChunk(nextStart, Math.max(overlapStart - nextStart, 0));
        if (prependResult == null && nextStart < overlapStart) return false;
        const appendResult = renderChunk(overlapEnd, Math.max(nextEnd - overlapEnd, 0));
        if (appendResult == null && nextEnd > overlapEnd) return false;
        const applyChunk = (result, insertPosition)=>{
            if (result == null) return;
            if (diffStyle === "unified" && !Array.isArray(codeElements)) this.insertPartialHTML(diffStyle, codeElements, result, insertPosition);
            else if (diffStyle === "split" && Array.isArray(codeElements)) this.insertPartialHTML(diffStyle, codeElements, result, insertPosition);
            else throw new Error("FileDiff.applyPartialRender.applyChunk: invalid chunk application");
            rowCount += result.rowCount;
        };
        this.cleanupErrorWrapper();
        applyChunk(prependResult, "afterbegin");
        applyChunk(appendResult, "beforeend");
        if (this.lastRowCount !== rowCount) {
            this.applyRowSpan(diffStyle, codeElements, rowCount);
            this.lastRowCount = rowCount;
        }
        return true;
    }
    insertPartialHTML(diffStyle, columns, result, insertPosition) {
        if (diffStyle === "unified" && !Array.isArray(columns)) {
            const unifiedAST = this.hunksRenderer.renderCodeAST("unified", result);
            this.renderPartialColumn(columns, unifiedAST, insertPosition);
        } else if (diffStyle === "split" && Array.isArray(columns)) {
            const deletionsAST = this.hunksRenderer.renderCodeAST("deletions", result);
            const additionsAST = this.hunksRenderer.renderCodeAST("additions", result);
            this.renderPartialColumn(columns[0], deletionsAST, insertPosition);
            this.renderPartialColumn(columns[1], additionsAST, insertPosition);
        } else throw new Error("FileDiff.insertPartialHTML: Invalid argument composition");
    }
    renderPartialColumn(column, ast, insertPosition) {
        if (column == null || ast == null) return;
        const gutterChildren = $b379a40a520278df$var$getElementChildren(ast[0]);
        const contentChildren = $b379a40a520278df$var$getElementChildren(ast[1]);
        if (gutterChildren == null || contentChildren == null) throw new Error("FileDiff.insertPartialHTML: Unexpected AST structure");
        const firstHASTElement = contentChildren.at(0);
        if (insertPosition === "beforeend" && firstHASTElement?.type === "element" && typeof firstHASTElement.properties["data-buffer-size"] === "number") this.mergeBuffersIfNecessary(firstHASTElement.properties["data-buffer-size"], column.content.children[column.content.children.length - 1], column.gutter.children[column.gutter.children.length - 1], gutterChildren, contentChildren, true);
        const lastHASTElement = contentChildren.at(-1);
        if (insertPosition === "afterbegin" && lastHASTElement?.type === "element" && typeof lastHASTElement.properties["data-buffer-size"] === "number") this.mergeBuffersIfNecessary(lastHASTElement.properties["data-buffer-size"], column.content.children[0], column.gutter.children[0], gutterChildren, contentChildren, false);
        column.gutter.insertAdjacentHTML(insertPosition, this.hunksRenderer.renderPartialHTML(gutterChildren));
        column.content.insertAdjacentHTML(insertPosition, this.hunksRenderer.renderPartialHTML(contentChildren));
    }
    mergeBuffersIfNecessary(adjustmentSize, contentElement, gutterElement, gutterChildren, contentChildren, fromStart) {
        if (!(contentElement instanceof HTMLElement) || !(gutterElement instanceof HTMLElement)) return;
        const currentSize = this.getBufferSize(contentElement.dataset);
        if (currentSize == null) return;
        if (fromStart) {
            gutterChildren.shift();
            contentChildren.shift();
        } else {
            gutterChildren.pop();
            contentChildren.pop();
        }
        this.updateBufferSize(contentElement, currentSize + adjustmentSize);
        this.updateBufferSize(gutterElement, currentSize + adjustmentSize);
    }
    applyRowSpan(diffStyle, columns, rowCount) {
        const applySpan = (column)=>{
            if (column == null) return;
            column.gutter.style.setProperty("grid-row", `span ${rowCount}`);
            column.content.style.setProperty("grid-row", `span ${rowCount}`);
        };
        if (diffStyle === "unified" && !Array.isArray(columns)) applySpan(columns);
        else if (diffStyle === "split" && Array.isArray(columns)) {
            applySpan(columns[0]);
            applySpan(columns[1]);
        } else throw new Error("dun fuuuuked up");
    }
    trimColumnRows(columns, preTrimCount, postTrimStart) {
        let visibleLineIndex = 0;
        let rowCount = 0;
        let rowIndex = 0;
        let pendingMetadataTrim = false;
        const hasPostTrim = postTrimStart >= 0;
        if (columns == null) return 0;
        const contentChildren = Array.from(columns.content.children);
        const gutterChildren = Array.from(columns.gutter.children);
        if (contentChildren.length !== gutterChildren.length) throw new Error("FileDiff.trimColumnRows: columns do not match");
        while(rowIndex < contentChildren.length){
            if (preTrimCount <= 0 && !hasPostTrim && !pendingMetadataTrim) break;
            const gutterElement = gutterChildren[rowIndex];
            const contentElement = contentChildren[rowIndex];
            rowIndex++;
            if (!(gutterElement instanceof HTMLElement) || !(contentElement instanceof HTMLElement)) {
                console.error({
                    gutterElement: gutterElement,
                    contentElement: contentElement
                });
                throw new Error("FileDiff.trimColumnRows: invalid row elements");
            }
            if (pendingMetadataTrim) {
                pendingMetadataTrim = false;
                if (gutterElement.dataset.gutterBuffer === "annotation" && "lineAnnotation" in contentElement.dataset || gutterElement.dataset.gutterBuffer === "metadata" && "noNewline" in contentElement.dataset) {
                    gutterElement.remove();
                    contentElement.remove();
                    rowCount++;
                    continue;
                }
            }
            if ("lineIndex" in gutterElement.dataset && "lineIndex" in contentElement.dataset) {
                if (preTrimCount > 0 || hasPostTrim && visibleLineIndex >= postTrimStart) {
                    gutterElement.remove();
                    contentElement.remove();
                    if (preTrimCount > 0) {
                        preTrimCount--;
                        if (preTrimCount === 0) pendingMetadataTrim = true;
                    }
                    rowCount++;
                }
                visibleLineIndex++;
                continue;
            }
            if ("separator" in gutterElement.dataset && "separator" in contentElement.dataset) {
                if (preTrimCount > 0 || hasPostTrim && visibleLineIndex >= postTrimStart) {
                    gutterElement.remove();
                    contentElement.remove();
                    rowCount++;
                }
                continue;
            }
            if (gutterElement.dataset.gutterBuffer === "annotation" && "lineAnnotation" in contentElement.dataset) {
                if (preTrimCount > 0 || hasPostTrim && visibleLineIndex >= postTrimStart) {
                    gutterElement.remove();
                    contentElement.remove();
                    rowCount++;
                }
                continue;
            }
            if (gutterElement.dataset.gutterBuffer === "metadata" && "noNewline" in contentElement.dataset) {
                if (preTrimCount > 0 || hasPostTrim && visibleLineIndex >= postTrimStart) {
                    gutterElement.remove();
                    contentElement.remove();
                    rowCount++;
                }
                continue;
            }
            if (gutterElement.dataset.gutterBuffer === "buffer" && "contentBuffer" in contentElement.dataset) {
                const totalRows = this.getBufferSize(contentElement.dataset);
                if (totalRows == null) throw new Error("FileDiff.trimColumnRows: invalid element");
                if (preTrimCount > 0) {
                    const rowsToRemove = Math.min(preTrimCount, totalRows);
                    const newSize = totalRows - rowsToRemove;
                    if (newSize > 0) {
                        this.updateBufferSize(gutterElement, newSize);
                        this.updateBufferSize(contentElement, newSize);
                        rowCount += rowsToRemove;
                    } else {
                        gutterElement.remove();
                        contentElement.remove();
                        rowCount += totalRows;
                    }
                    preTrimCount -= rowsToRemove;
                    if (preTrimCount === 0 && newSize === 0) pendingMetadataTrim = true;
                } else if (hasPostTrim) {
                    const bufferStart = visibleLineIndex;
                    const bufferEnd = visibleLineIndex + totalRows - 1;
                    if (postTrimStart <= bufferStart) {
                        gutterElement.remove();
                        contentElement.remove();
                        rowCount += totalRows;
                    } else if (postTrimStart <= bufferEnd) {
                        const rowsToRemove = bufferEnd - postTrimStart + 1;
                        const newSize = totalRows - rowsToRemove;
                        this.updateBufferSize(gutterElement, newSize);
                        this.updateBufferSize(contentElement, newSize);
                        rowCount += rowsToRemove;
                    }
                }
                visibleLineIndex += totalRows;
                continue;
            }
            console.error({
                gutterElement: gutterElement,
                contentElement: contentElement
            });
            throw new Error("FileDiff.trimColumnRows: unknown row elements");
        }
        return rowCount;
    }
    trimColumns({ columns: columns, diffStyle: diffStyle, overlapEnd: overlapEnd, overlapStart: overlapStart, previousStart: previousStart, trimEnd: trimEnd, trimStart: trimStart }) {
        const preTrimCount = Math.max(0, overlapStart - previousStart);
        const postTrimStart = overlapEnd - previousStart;
        if (postTrimStart < 0) throw new Error("FileDiff.trimColumns: overlap ends before previous");
        const shouldTrimStart = trimStart > 0;
        const shouldTrimEnd = trimEnd > 0;
        if (!shouldTrimStart && !shouldTrimEnd) return 0;
        const effectivePreTrimCount = shouldTrimStart ? preTrimCount : 0;
        const effectivePostTrimStart = shouldTrimEnd ? postTrimStart : -1;
        if (diffStyle === "unified" && !Array.isArray(columns)) return this.trimColumnRows(columns, effectivePreTrimCount, effectivePostTrimStart);
        else if (diffStyle === "split" && Array.isArray(columns)) {
            const deletionsTrim = this.trimColumnRows(columns[0], effectivePreTrimCount, effectivePostTrimStart);
            const additionsTrim = this.trimColumnRows(columns[1], effectivePreTrimCount, effectivePostTrimStart);
            if (columns[0] != null && columns[1] != null && deletionsTrim !== additionsTrim) throw new Error("FileDiff.trimColumns: split columns out of sync");
            return columns[0] != null ? deletionsTrim : additionsTrim;
        } else {
            console.error({
                diffStyle: diffStyle,
                columns: columns
            });
            throw new Error("FileDiff.trimColumns: Invalid columns for diffType");
        }
    }
    getBufferSize(properties) {
        const parsed = Number.parseInt(properties?.bufferSize ?? "", 10);
        return Number.isNaN(parsed) ? void 0 : parsed;
    }
    updateBufferSize(element, size) {
        element.dataset.bufferSize = `${size}`;
        element.style.setProperty("grid-row", `span ${size}`);
        element.style.setProperty("min-height", `calc(${size} * 1lh)`);
    }
    getCodeColumns(diffStyle, codeUnified, codeDeletions, codeAdditions) {
        function getColumns(code) {
            if (code == null) return;
            const gutter = code.children[0];
            const content = code.children[1];
            if (!(gutter instanceof HTMLElement) || !(content instanceof HTMLElement) || gutter.dataset.gutter == null || content.dataset.content == null) return;
            return {
                gutter: gutter,
                content: content
            };
        }
        if (diffStyle === "unified") return getColumns(codeUnified);
        else {
            const deletions = getColumns(codeDeletions);
            const additions = getColumns(codeAdditions);
            return deletions != null || additions != null ? [
                deletions,
                additions
            ] : void 0;
        }
    }
    applyBuffers(pre, renderRange) {
        if (renderRange == null || this.shouldDisableVirtualizationBuffers()) {
            if (this.bufferBefore != null) {
                this.bufferBefore.remove();
                this.bufferBefore = void 0;
            }
            if (this.bufferAfter != null) {
                this.bufferAfter.remove();
                this.bufferAfter = void 0;
            }
            return;
        }
        if (renderRange.bufferBefore > 0) {
            if (this.bufferBefore == null) {
                this.bufferBefore = document.createElement("div");
                this.bufferBefore.dataset.virtualizerBuffer = "before";
                pre.before(this.bufferBefore);
            }
            this.bufferBefore.style.setProperty("height", `${renderRange.bufferBefore}px`);
            this.bufferBefore.style.setProperty("contain", "strict");
        } else if (this.bufferBefore != null) {
            this.bufferBefore.remove();
            this.bufferBefore = void 0;
        }
        if (renderRange.bufferAfter > 0) {
            if (this.bufferAfter == null) {
                this.bufferAfter = document.createElement("div");
                this.bufferAfter.dataset.virtualizerBuffer = "after";
                pre.after(this.bufferAfter);
            }
            this.bufferAfter.style.setProperty("height", `${renderRange.bufferAfter}px`);
            this.bufferAfter.style.setProperty("contain", "strict");
        } else if (this.bufferAfter != null) {
            this.bufferAfter.remove();
            this.bufferAfter = void 0;
        }
    }
    shouldDisableVirtualizationBuffers() {
        return this.options.disableVirtualizationBuffers ?? false;
    }
    applyPreNodeAttributes(pre, { additionsContentAST: additionsContentAST, deletionsContentAST: deletionsContentAST, totalLines: totalLines }, customProperties) {
        const { diffIndicators: diffIndicators = "bars", disableBackground: disableBackground = false, disableLineNumbers: disableLineNumbers = false, overflow: overflow = "scroll", diffStyle: diffStyle = "split" } = this.options;
        const preProperties = {
            type: "diff",
            diffIndicators: diffIndicators,
            disableBackground: disableBackground,
            disableLineNumbers: disableLineNumbers,
            overflow: overflow,
            split: diffStyle === "unified" ? false : additionsContentAST != null && deletionsContentAST != null,
            totalLines: totalLines,
            customProperties: customProperties
        };
        if ((0, $0f5986330d731e6d$export$732d2d41c8f0dbb)(preProperties, this.appliedPreAttributes)) return;
        (0, $c1b1c6b8488e516b$export$fcea31ce4b8860ec)(pre, preProperties);
        this.appliedPreAttributes = preProperties;
    }
    applyErrorToDOM(error, container) {
        this.cleanupErrorWrapper();
        this.pre?.remove();
        this.pre = void 0;
        this.appliedPreAttributes = void 0;
        const shadowRoot = container.shadowRoot ?? container.attachShadow({
            mode: "open"
        });
        this.errorWrapper ??= document.createElement("div");
        this.errorWrapper.dataset.errorWrapper = "";
        this.errorWrapper.textContent = "";
        shadowRoot.appendChild(this.errorWrapper);
        const errorMessage = document.createElement("div");
        errorMessage.dataset.errorMessage = "";
        errorMessage.innerText = error.message;
        this.errorWrapper.appendChild(errorMessage);
        const errorStack = document.createElement("pre");
        errorStack.dataset.errorStack = "";
        errorStack.innerText = error.stack ?? "No Error Stack";
        this.errorWrapper.appendChild(errorStack);
    }
    cleanupErrorWrapper() {
        this.errorWrapper?.remove();
        this.errorWrapper = void 0;
    }
};
function $b379a40a520278df$var$hasDiffContent({ fileDiff: fileDiff, oldFile: oldFile, newFile: newFile }) {
    return fileDiff != null && fileDiff.hunks.length > 0 || oldFile != null || newFile != null;
}
function $b379a40a520278df$var$hasDiffHeaderContent({ fileDiff: fileDiff, oldFile: oldFile, newFile: newFile }) {
    return fileDiff != null || oldFile != null || newFile != null;
}
function $b379a40a520278df$var$shouldRenderCode(pre, hasContent, collapsed = false) {
    return !collapsed && pre == null && hasContent;
}
function $b379a40a520278df$var$shouldRenderHeader(headerElement, hasContent, disableFileHeader = false) {
    return headerElement == null && hasContent && !disableFileHeader;
}
function $b379a40a520278df$var$getElementChildren(node) {
    if (node == null || node.type !== "element") return;
    return node.children ?? [];
}


//#region src/components/VirtualizedFileDiff.ts
const $6e11c2280e7ca279$var$LAYOUT_CHECKPOINT_INTERVAL = 5e3;
let $6e11c2280e7ca279$var$instanceId = -1;
var $6e11c2280e7ca279$export$e1a9054d4036b12f = class extends (0, $b379a40a520278df$export$92d2c7803a4156dd) {
    __id = `little-virtualized-file-diff:${++$6e11c2280e7ca279$var$instanceId}`;
    top;
    height = 0;
    metrics;
    cache = {
        heights: /* @__PURE__ */ new Map(),
        checkpoints: [],
        totalLines: 0
    };
    isVisible = false;
    isSetup = false;
    virtualizer;
    layoutDirty = true;
    forceRenderOverride;
    constructor(options, virtualizer, metrics, workerManager, isContainerManaged = false){
        super(options, workerManager, isContainerManaged);
        this.virtualizer = virtualizer;
        this.metrics = (0, $f700fc78f9a614b9$export$1acb458e99845a9f)(metrics);
    }
    setMetrics(metrics, force = false) {
        const nextMetrics = (0, $f700fc78f9a614b9$export$1acb458e99845a9f)(metrics);
        if (!force && (0, $3ec53e4f7bbd4269$export$1db8244ab969c6c6)(this.metrics, nextMetrics)) return;
        this.metrics = nextMetrics;
        this.resetLayoutCache();
    }
    getLineHeight(lineIndex, hasMetadataLine = false) {
        const cached = this.cache.heights.get(lineIndex);
        if (cached != null) return cached;
        const multiplier = hasMetadataLine ? 2 : 1;
        return this.metrics.lineHeight * multiplier;
    }
    setOptions(options) {
        if (options == null) return;
        const { options: previousOptions } = this;
        const optionsChanged = !(0, $5e49faa8df06196c$export$1ace03bbcd701468)(previousOptions, options);
        const layoutChanged = optionsChanged && $6e11c2280e7ca279$var$hasDiffLayoutOptionChanged(previousOptions, options);
        super.setOptions(options);
        if (layoutChanged) this.resetLayoutCache(true);
        if (optionsChanged) this.forceRenderOverride = true;
        if (optionsChanged && this.isSimpleMode()) this.virtualizer.instanceChanged(this, layoutChanged);
    }
    resetLayoutCache(recompute = false) {
        this.layoutDirty = true;
        this.cache.heights.clear();
        this.cache.checkpoints = [];
        this.cache.totalLines = 0;
        this.renderRange = void 0;
        if (recompute && this.isSimpleMode()) this.computeApproximateSize();
    }
    reconcileHeights() {
        let hasHeightChange = false;
        const { overflow: overflow = "scroll" } = this.options;
        if (this.fileContainer == null || this.fileDiff == null) {
            if (this.height !== 0) hasHeightChange = true;
            this.height = 0;
            return hasHeightChange;
        }
        this.top = this.getVirtualizedTop();
        if (overflow === "scroll" && this.lineAnnotations.length === 0 && !this.isResizeDebuggingEnabled()) return hasHeightChange;
        const diffStyle = this.getDiffStyle();
        const codeGroups = diffStyle === "split" ? [
            this.codeDeletions,
            this.codeAdditions
        ] : [
            this.codeUnified
        ];
        for (const codeGroup of codeGroups){
            if (codeGroup == null) continue;
            const content = codeGroup.children[1];
            if (!(content instanceof HTMLElement)) continue;
            for (const line of content.children){
                if (!(line instanceof HTMLElement)) continue;
                const lineIndexAttr = line.dataset.lineIndex;
                if (lineIndexAttr == null) continue;
                const lineIndex = $6e11c2280e7ca279$var$parseLineIndex(lineIndexAttr, diffStyle);
                let measuredHeight = line.getBoundingClientRect().height;
                let hasMetadata = false;
                if (line.nextElementSibling instanceof HTMLElement && ("lineAnnotation" in line.nextElementSibling.dataset || "noNewline" in line.nextElementSibling.dataset)) {
                    if ("noNewline" in line.nextElementSibling.dataset) hasMetadata = true;
                    measuredHeight += line.nextElementSibling.getBoundingClientRect().height;
                }
                const expectedHeight = this.getLineHeight(lineIndex, hasMetadata);
                if (measuredHeight === expectedHeight) continue;
                hasHeightChange = true;
                if (measuredHeight === this.metrics.lineHeight * (hasMetadata ? 2 : 1)) this.cache.heights.delete(lineIndex);
                else this.cache.heights.set(lineIndex, measuredHeight);
            }
        }
        if (hasHeightChange || this.isResizeDebuggingEnabled()) this.computeApproximateSize(true);
        return hasHeightChange;
    }
    onRender = (dirty)=>{
        if (this.fileContainer == null) return false;
        if (dirty) this.top = this.getVirtualizedTop();
        return this.render();
    };
    prepareVirtualizedItem(fileDiff) {
        if (this.fileDiff !== fileDiff) this.resetLayoutCache();
        this.fileDiff = fileDiff;
        this.top = this.getVirtualizedTop();
        this.computeApproximateSize();
        return this.height;
    }
    getLinePosition(lineNumber, side = "additions") {
        if (this.fileDiff == null) return;
        const targetLineIndexes = this.getLineIndex(lineNumber, side);
        if (targetLineIndexes == null) return;
        const { disableFileHeader: disableFileHeader = false, expandUnchanged: expandUnchanged = false, collapsed: collapsed = false, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac) } = this.options;
        const diffStyle = this.getDiffStyle();
        const hunkSeparators = this.getHunkSeparatorType();
        const hunkSeparatorHeight = this.getHunkSeparatorHeight(hunkSeparators);
        const separatorGap = this.getSeparatorGap(hunkSeparators);
        const targetLineIndex = diffStyle === "split" ? targetLineIndexes[1] : targetLineIndexes[0];
        const checkpoint = this.getLayoutCheckpointBeforeLineIndex(targetLineIndex);
        let top = checkpoint?.top ?? (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        if (collapsed) return {
            top: top,
            height: 0
        };
        let position;
        (0, $14677931af57706f$export$62615825adc21c24)({
            diff: this.fileDiff,
            diffStyle: diffStyle,
            startingLine: checkpoint?.renderedLineIndex ?? 0,
            expandedHunks: expandUnchanged ? true : this.hunksRenderer.getExpandedHunksMap(),
            collapsedContextThreshold: collapsedContextThreshold,
            callback: ({ hunkIndex: hunkIndex, hunk: hunk, collapsedBefore: collapsedBefore, collapsedAfter: collapsedAfter, deletionLine: deletionLine, additionLine: additionLine })=>{
                const lineIndex = diffStyle === "split" ? additionLine?.splitLineIndex ?? deletionLine?.splitLineIndex : additionLine?.unifiedLineIndex ?? deletionLine?.unifiedLineIndex;
                if (lineIndex == null) throw new Error("VirtualizedFileDiff.getLinePosition: missing line index data");
                if (collapsedBefore > 0 && this.hasLeadingHunkSeparator(hunkIndex, hunk?.hunkSpecs, hunkSeparators)) {
                    if (hunkIndex > 0) top += separatorGap;
                    if (targetLineIndex >= lineIndex - collapsedBefore && targetLineIndex < lineIndex) {
                        position = {
                            top: top,
                            height: hunkSeparatorHeight
                        };
                        return true;
                    }
                    top += hunkSeparatorHeight + separatorGap;
                }
                const lineHeight = this.getLineHeight(lineIndex, (additionLine?.noEOFCR ?? false) || (deletionLine?.noEOFCR ?? false));
                if (lineIndex === targetLineIndex) {
                    position = {
                        top: top,
                        height: lineHeight
                    };
                    return true;
                }
                top += lineHeight;
                if (collapsedAfter > 0 && this.hasTrailingHunkSeparator(hunkSeparators)) {
                    if (targetLineIndex > lineIndex && targetLineIndex <= lineIndex + collapsedAfter) {
                        position = {
                            top: top + separatorGap,
                            height: hunkSeparatorHeight
                        };
                        return true;
                    }
                    top += separatorGap + hunkSeparatorHeight;
                }
                return false;
            }
        });
        return position;
    }
    getNumericScrollAnchor(localViewportTop) {
        if (this.fileDiff == null) return;
        const { disableFileHeader: disableFileHeader = false, expandUnchanged: expandUnchanged = false, collapsed: collapsed = false, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac) } = this.options;
        if (collapsed) return;
        const diffStyle = this.getDiffStyle();
        const hunkSeparators = this.getHunkSeparatorType();
        const hunkSeparatorHeight = this.getHunkSeparatorHeight(hunkSeparators);
        const separatorGap = this.getSeparatorGap(hunkSeparators);
        const checkpoint = this.getLayoutCheckpointBeforeTop(localViewportTop);
        let top = checkpoint?.top ?? (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        let anchor;
        (0, $14677931af57706f$export$62615825adc21c24)({
            diff: this.fileDiff,
            diffStyle: diffStyle,
            startingLine: checkpoint?.renderedLineIndex ?? 0,
            expandedHunks: expandUnchanged ? true : this.hunksRenderer.getExpandedHunksMap(),
            collapsedContextThreshold: collapsedContextThreshold,
            callback: ({ hunkIndex: hunkIndex, hunk: hunk, collapsedBefore: collapsedBefore, collapsedAfter: collapsedAfter, deletionLine: deletionLine, additionLine: additionLine })=>{
                const lineIndex = diffStyle === "split" ? additionLine?.splitLineIndex ?? deletionLine?.splitLineIndex : additionLine?.unifiedLineIndex ?? deletionLine?.unifiedLineIndex;
                if (lineIndex == null) throw new Error("VirtualizedFileDiff.getNumericScrollAnchor: missing line index data");
                if (collapsedBefore > 0 && this.hasLeadingHunkSeparator(hunkIndex, hunk?.hunkSpecs, hunkSeparators)) {
                    if (hunkIndex > 0) top += separatorGap;
                    top += hunkSeparatorHeight + separatorGap;
                }
                if (top >= localViewportTop) {
                    if (deletionLine != null) anchor = {
                        lineNumber: deletionLine.lineNumber,
                        side: "deletions",
                        top: top
                    };
                    else if (additionLine != null) anchor = {
                        lineNumber: additionLine.lineNumber,
                        side: "additions",
                        top: top
                    };
                    if (anchor != null) return true;
                }
                const lineHeight = this.getLineHeight(lineIndex, (additionLine?.noEOFCR ?? false) || (deletionLine?.noEOFCR ?? false));
                top += lineHeight;
                if (collapsedAfter > 0 && this.hasTrailingHunkSeparator(hunkSeparators)) top += separatorGap + hunkSeparatorHeight;
                return false;
            }
        });
        return anchor;
    }
    getVirtualizedHeight() {
        return this.height;
    }
    getAdvancedStickySpecs(windowSpecs) {
        if (this.top == null || this.fileDiff == null) return;
        if (this.options.collapsed === true) return {
            topOffset: this.top,
            height: this.height
        };
        const renderRange = windowSpecs != null ? this.computeRenderRangeFromWindow(this.fileDiff, this.top, windowSpecs) : this.renderRange;
        if (renderRange == null) return;
        const { bufferBefore: bufferBefore, bufferAfter: bufferAfter, totalLines: totalLines } = renderRange;
        return {
            topOffset: this.top + bufferBefore + (totalLines === 0 ? bufferAfter : 0),
            height: this.height - (bufferBefore + bufferAfter)
        };
    }
    cleanUp(recycle = false) {
        if (this.fileContainer != null && this.isSimpleMode()) this.getSimpleVirtualizer()?.disconnect(this.fileContainer);
        if (!recycle) this.resetLayoutCache();
        this.isSetup = false;
        super.cleanUp(recycle);
    }
    expandHunk = (hunkIndex, direction, expansionLineCountOverride)=>{
        this.hunksRenderer.expandHunk(hunkIndex, direction, expansionLineCountOverride);
        this.layoutDirty = true;
        this.computeApproximateSize();
        this.renderRange = void 0;
        this.virtualizer.instanceChanged(this, true);
    };
    setVisibility(visible) {
        if (this.isAdvancedMode() || this.fileContainer == null) return;
        this.renderRange = void 0;
        if (visible && !this.isVisible) {
            this.top = this.getVirtualizedTop();
            this.isVisible = true;
        } else if (!visible && this.isVisible) {
            this.isVisible = false;
            this.rerender();
        }
    }
    rerender() {
        if (!this.enabled || this.fileDiff == null && this.additionFile == null && this.deletionFile == null) return;
        this.forceRenderOverride = true;
        this.virtualizer.instanceChanged(this, false);
    }
    computeApproximateSize(force = false) {
        const shouldValidateSize = this.isResizeDebuggingEnabled();
        if (!force && !this.layoutDirty && !shouldValidateSize) return;
        const isFirstCompute = this.height === 0;
        this.height = 0;
        this.cache.checkpoints = [];
        this.cache.totalLines = 0;
        if (this.fileDiff == null) {
            this.layoutDirty = false;
            return;
        }
        const { disableFileHeader: disableFileHeader = false, expandUnchanged: expandUnchanged = false, collapsed: collapsed = false, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac) } = this.options;
        const diffStyle = this.getDiffStyle();
        const hunkSeparators = this.getHunkSeparatorType();
        const hunkSeparatorHeight = this.getHunkSeparatorHeight(hunkSeparators);
        const separatorGap = this.getSeparatorGap(hunkSeparators);
        const headerRegion = (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        const paddingBottom = (0, $f700fc78f9a614b9$export$7dbace702b635f2)(this.metrics);
        this.height += headerRegion;
        if (collapsed) {
            this.layoutDirty = false;
            return;
        }
        let renderedLineIndex = 0;
        (0, $14677931af57706f$export$62615825adc21c24)({
            diff: this.fileDiff,
            diffStyle: diffStyle,
            expandedHunks: expandUnchanged ? true : this.hunksRenderer.getExpandedHunksMap(),
            collapsedContextThreshold: collapsedContextThreshold,
            callback: ({ hunkIndex: hunkIndex, hunk: hunk, collapsedBefore: collapsedBefore, collapsedAfter: collapsedAfter, deletionLine: deletionLine, additionLine: additionLine })=>{
                const splitLineIndex = additionLine != null ? additionLine.splitLineIndex : deletionLine.splitLineIndex;
                const unifiedLineIndex = additionLine != null ? additionLine.unifiedLineIndex : deletionLine.unifiedLineIndex;
                const hasMetadata = (additionLine?.noEOFCR ?? false) || (deletionLine?.noEOFCR ?? false);
                const lineIndex = diffStyle === "split" ? splitLineIndex : unifiedLineIndex;
                this.addLayoutCheckpoint(renderedLineIndex, lineIndex, this.height);
                if (collapsedBefore > 0 && this.hasLeadingHunkSeparator(hunkIndex, hunk?.hunkSpecs, hunkSeparators)) {
                    if (hunkIndex > 0) this.height += separatorGap;
                    this.height += hunkSeparatorHeight + separatorGap;
                }
                this.height += this.getLineHeight(lineIndex, hasMetadata);
                if (collapsedAfter > 0 && this.hasTrailingHunkSeparator(hunkSeparators)) this.height += separatorGap + hunkSeparatorHeight;
                renderedLineIndex++;
            }
        });
        this.cache.totalLines = renderedLineIndex;
        if (this.fileDiff.hunks.length > 0) this.height += paddingBottom;
        if (this.fileContainer != null && shouldValidateSize && !isFirstCompute) {
            const rect = this.fileContainer.getBoundingClientRect();
            if (rect.height !== this.height) console.log("VirtualizedFileDiff.computeApproximateSize: computed height doesnt match", {
                name: this.fileDiff.name,
                elementHeight: rect.height,
                computedHeight: this.height
            });
            else console.log("VirtualizedFileDiff.computeApproximateSize: computed height IS CORRECT");
        }
        this.layoutDirty = false;
    }
    render({ fileContainer: fileContainer, oldFile: oldFile, newFile: newFile, fileDiff: fileDiff, forceRender: forceRender = false, ...props } = {}) {
        const { forceRenderOverride: forceRenderOverride, isSetup: isSetup } = this;
        this.forceRenderOverride = void 0;
        this.fileDiff ??= fileDiff ?? (oldFile != null && newFile != null ? (0, $80c7965a049ab6e5$export$98aafcdfd1bcb1be)(oldFile, newFile, this.options.parseDiffOptions) : void 0);
        fileContainer = this.getOrCreateFileContainer(fileContainer);
        if (this.fileDiff == null) {
            console.error("VirtualizedFileDiff.render: attempting to virtually render when we dont have the correct data");
            return false;
        }
        if (!isSetup) {
            this.computeApproximateSize();
            const virtualizer = this.getSimpleVirtualizer();
            this.top ??= this.getVirtualizedTop();
            if (this.isAdvancedMode()) this.isVisible = true;
            else {
                if (virtualizer == null) throw new Error("VirtualizedFileDiff.render: simple virtualizer is not available");
                virtualizer.connect(fileContainer, this);
                this.isVisible = virtualizer.isInstanceVisible(this.top ?? 0, this.height);
            }
            this.isSetup = true;
        } else this.top ??= this.getVirtualizedTop();
        if (!this.isVisible && this.isSimpleMode()) return this.renderPlaceholder(this.height);
        const windowSpecs = this.virtualizer.getWindowSpecs();
        const fileTop = this.top ?? 0;
        const renderRange = this.computeRenderRangeFromWindow(this.fileDiff, fileTop, windowSpecs);
        return super.render({
            fileDiff: this.fileDiff,
            fileContainer: fileContainer,
            renderRange: renderRange,
            oldFile: oldFile,
            newFile: newFile,
            forceRender: forceRenderOverride ?? forceRender,
            ...props
        });
    }
    syncVirtualizedTop() {
        this.top = this.getVirtualizedTop();
    }
    shouldDisableVirtualizationBuffers() {
        return this.isAdvancedMode() || super.shouldDisableVirtualizationBuffers();
    }
    isSimpleMode() {
        return this.virtualizer.type === "simple";
    }
    isAdvancedMode() {
        return this.virtualizer.type === "advanced";
    }
    getVirtualizedTop() {
        if (this.virtualizer.type === "advanced") return this.virtualizer.getLocalTopForInstance(this);
        return this.fileContainer != null ? this.virtualizer.getOffsetInScrollContainer(this.fileContainer) : 0;
    }
    getSimpleVirtualizer() {
        return this.virtualizer.type === "simple" ? this.virtualizer : void 0;
    }
    isResizeDebuggingEnabled() {
        return this.getSimpleVirtualizer()?.config.resizeDebugging ?? false;
    }
    getDiffStyle() {
        return this.options.diffStyle ?? "split";
    }
    getHunkSeparatorType() {
        return $6e11c2280e7ca279$var$getOptionHunkSeparatorType(this.options.hunkSeparators);
    }
    getHunkSeparatorHeight(type = this.getHunkSeparatorType()) {
        return this.metrics.hunkSeparatorHeight ?? (0, $f700fc78f9a614b9$export$84b205b9d7905293)(type);
    }
    getSeparatorGap(type = this.getHunkSeparatorType()) {
        return type === "simple" || type === "metadata" || type === "line-info-basic" ? 0 : this.metrics.spacing;
    }
    hasLeadingHunkSeparator(hunkIndex, hunkSpecs, type = this.getHunkSeparatorType()) {
        switch(type){
            case "simple":
                return hunkIndex > 0;
            case "metadata":
                return hunkSpecs != null;
            case "line-info":
            case "line-info-basic":
            case "custom":
                return true;
        }
    }
    hasTrailingHunkSeparator(type = this.getHunkSeparatorType()) {
        return type !== "simple" && type !== "metadata";
    }
    addLayoutCheckpoint(renderedLineIndex, lineIndex, top) {
        if (renderedLineIndex % $6e11c2280e7ca279$var$LAYOUT_CHECKPOINT_INTERVAL !== 0) return;
        this.cache.checkpoints.push({
            renderedLineIndex: renderedLineIndex,
            lineIndex: lineIndex,
            top: top
        });
    }
    getLayoutCheckpointBeforeLineIndex(lineIndex) {
        if (lineIndex <= 0 || this.cache.checkpoints.length === 0) return;
        let low = 0;
        let high = this.cache.checkpoints.length - 1;
        let result;
        while(low <= high){
            const mid = low + high >> 1;
            const checkpoint = this.cache.checkpoints[mid];
            if (checkpoint == null) throw new Error("VirtualizedFileDiff: invalid checkpoint index");
            if (checkpoint.lineIndex <= lineIndex) {
                result = checkpoint;
                low = mid + 1;
            } else high = mid - 1;
        }
        return result;
    }
    getLayoutCheckpointBeforeTop(top, hunkLineCount) {
        let low = 0;
        let high = this.cache.checkpoints.length - 1;
        let resultIndex = -1;
        while(low <= high){
            const mid = low + high >> 1;
            const checkpoint = this.cache.checkpoints[mid];
            if (checkpoint == null) throw new Error("VirtualizedFileDiff: invalid checkpoint index");
            if (checkpoint.top <= top) {
                resultIndex = mid;
                low = mid + 1;
            } else high = mid - 1;
        }
        if (hunkLineCount == null) return resultIndex >= 0 ? this.cache.checkpoints[resultIndex] : void 0;
        for(let index = resultIndex; index >= 0; index--){
            const checkpoint = this.cache.checkpoints[index];
            if (checkpoint == null) throw new Error("VirtualizedFileDiff: invalid checkpoint index");
            if (checkpoint.renderedLineIndex % hunkLineCount === 0) return checkpoint;
        }
    }
    getExpandedRegion(isPartial, hunkIndex, rangeSize) {
        if (rangeSize <= 0 || isPartial) return {
            fromStart: 0,
            fromEnd: 0,
            collapsedLines: Math.max(rangeSize, 0),
            renderAll: false
        };
        const { expandUnchanged: expandUnchanged = false, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac) } = this.options;
        if (expandUnchanged || rangeSize <= collapsedContextThreshold) return {
            fromStart: rangeSize,
            fromEnd: 0,
            collapsedLines: 0,
            renderAll: true
        };
        const region = this.hunksRenderer.getExpandedHunk(hunkIndex);
        const fromStart = Math.min(Math.max(region.fromStart, 0), rangeSize);
        const fromEnd = Math.min(Math.max(region.fromEnd, 0), rangeSize);
        const expandedCount = fromStart + fromEnd;
        const renderAll = expandedCount >= rangeSize;
        return {
            fromStart: fromStart,
            fromEnd: fromEnd,
            collapsedLines: Math.max(rangeSize - expandedCount, 0),
            renderAll: renderAll
        };
    }
    getExpandedLineCount(fileDiff, diffStyle) {
        let count = 0;
        if (fileDiff.isPartial) {
            for (const hunk of fileDiff.hunks)count += diffStyle === "split" ? hunk.splitLineCount : hunk.unifiedLineCount;
            return count;
        }
        for (const [hunkIndex, hunk] of fileDiff.hunks.entries()){
            const hunkCount = diffStyle === "split" ? hunk.splitLineCount : hunk.unifiedLineCount;
            count += hunkCount;
            const collapsedBefore = Math.max(hunk.collapsedBefore, 0);
            const { fromStart: fromStart, fromEnd: fromEnd, renderAll: renderAll } = this.getExpandedRegion(fileDiff.isPartial, hunkIndex, collapsedBefore);
            if (collapsedBefore > 0) count += renderAll ? collapsedBefore : fromStart + fromEnd;
        }
        const lastHunk = fileDiff.hunks.at(-1);
        if (lastHunk != null && $6e11c2280e7ca279$var$hasFinalHunk(fileDiff)) {
            const additionRemaining = fileDiff.additionLines.length - (lastHunk.additionLineIndex + lastHunk.additionCount);
            const deletionRemaining = fileDiff.deletionLines.length - (lastHunk.deletionLineIndex + lastHunk.deletionCount);
            if (lastHunk != null && additionRemaining !== deletionRemaining) throw new Error(`VirtualizedFileDiff: trailing context mismatch (additions=${additionRemaining}, deletions=${deletionRemaining}) for ${fileDiff.name}`);
            const trailingRangeSize = Math.min(additionRemaining, deletionRemaining);
            if (lastHunk != null && trailingRangeSize > 0) {
                const { fromStart: fromStart, renderAll: renderAll } = this.getExpandedRegion(fileDiff.isPartial, fileDiff.hunks.length, trailingRangeSize);
                count += renderAll ? trailingRangeSize : fromStart;
            }
        }
        return count;
    }
    computeRenderRangeFromWindow(fileDiff, fileTop, { top: top, bottom: bottom }) {
        const { disableFileHeader: disableFileHeader = false, expandUnchanged: expandUnchanged = false, collapsedContextThreshold: collapsedContextThreshold = (0, $6986aac91971cc6d$export$54c265eef46f12ac) } = this.options;
        const { hunkLineCount: hunkLineCount, lineHeight: lineHeight } = this.metrics;
        const diffStyle = this.getDiffStyle();
        const hunkSeparators = this.getHunkSeparatorType();
        const hunkSeparatorHeight = this.getHunkSeparatorHeight(hunkSeparators);
        const fileHeight = this.height;
        const lineCount = this.cache.totalLines > 0 ? this.cache.totalLines : this.getExpandedLineCount(fileDiff, diffStyle);
        const headerRegion = (0, $f700fc78f9a614b9$export$79fff7cc5b11b8b)(this.metrics, disableFileHeader);
        const paddingBottom = fileDiff.hunks.length > 0 ? (0, $f700fc78f9a614b9$export$7dbace702b635f2)(this.metrics) : 0;
        if (fileTop < top - fileHeight || fileTop > bottom) return {
            startingLine: 0,
            totalLines: 0,
            bufferBefore: 0,
            bufferAfter: fileHeight - headerRegion - paddingBottom
        };
        if (lineCount <= hunkLineCount || fileDiff.hunks.length === 0) return {
            startingLine: 0,
            totalLines: hunkLineCount,
            bufferBefore: 0,
            bufferAfter: 0
        };
        const estimatedTargetLines = Math.ceil(Math.max(bottom - top, 0) / lineHeight);
        const totalLines = Math.ceil(estimatedTargetLines / hunkLineCount) * hunkLineCount + hunkLineCount;
        const totalHunks = totalLines / hunkLineCount;
        const overflowHunks = totalHunks;
        const hunkOffsets = [];
        const viewportCenter = (top + bottom) / 2;
        const separatorGap = this.getSeparatorGap(hunkSeparators);
        const checkpoint = this.getLayoutCheckpointBeforeTop(Math.max(0, top - fileTop - totalLines * lineHeight * 2), hunkLineCount);
        let absoluteLineTop = fileTop + (checkpoint?.top ?? headerRegion);
        let currentLine = checkpoint?.renderedLineIndex ?? 0;
        let firstVisibleHunk;
        let centerHunk;
        let overflowCounter;
        (0, $14677931af57706f$export$62615825adc21c24)({
            diff: fileDiff,
            diffStyle: diffStyle,
            startingLine: checkpoint?.renderedLineIndex ?? 0,
            expandedHunks: expandUnchanged ? true : this.hunksRenderer.getExpandedHunksMap(),
            collapsedContextThreshold: collapsedContextThreshold,
            callback: ({ hunkIndex: hunkIndex, hunk: hunk, collapsedBefore: collapsedBefore, collapsedAfter: collapsedAfter, deletionLine: deletionLine, additionLine: additionLine })=>{
                const splitLineIndex = additionLine != null ? additionLine.splitLineIndex : deletionLine.splitLineIndex;
                const unifiedLineIndex = additionLine != null ? additionLine.unifiedLineIndex : deletionLine.unifiedLineIndex;
                const hasMetadata = (additionLine?.noEOFCR ?? false) || (deletionLine?.noEOFCR ?? false);
                const gapAdjustment = collapsedBefore > 0 && this.hasLeadingHunkSeparator(hunkIndex, hunk?.hunkSpecs, hunkSeparators) ? hunkSeparatorHeight + separatorGap + (hunkIndex > 0 ? separatorGap : 0) : 0;
                absoluteLineTop += gapAdjustment;
                const isAtHunkBoundary = currentLine % hunkLineCount === 0;
                const currentHunk = Math.floor(currentLine / hunkLineCount);
                if (isAtHunkBoundary) {
                    hunkOffsets[currentHunk] = absoluteLineTop - (fileTop + headerRegion + gapAdjustment);
                    if (overflowCounter != null) {
                        if (overflowCounter <= 0) return true;
                        overflowCounter--;
                    }
                }
                const lineHeight$1 = this.getLineHeight(diffStyle === "split" ? splitLineIndex : unifiedLineIndex, hasMetadata);
                if (absoluteLineTop > top - lineHeight$1 && absoluteLineTop < bottom) firstVisibleHunk ??= currentHunk;
                if (centerHunk == null && absoluteLineTop + lineHeight$1 > viewportCenter) centerHunk = currentHunk;
                if (overflowCounter == null && absoluteLineTop >= bottom && isAtHunkBoundary) overflowCounter = overflowHunks;
                currentLine++;
                absoluteLineTop += lineHeight$1;
                if (collapsedAfter > 0 && this.hasTrailingHunkSeparator(hunkSeparators)) absoluteLineTop += hunkSeparatorHeight + separatorGap;
                return false;
            }
        });
        if (firstVisibleHunk == null) return {
            startingLine: 0,
            totalLines: 0,
            bufferBefore: 0,
            bufferAfter: fileHeight - headerRegion - paddingBottom
        };
        centerHunk ??= firstVisibleHunk;
        const idealStartHunk = Math.round(centerHunk - totalHunks / 2);
        const maxStartHunk = Math.max(0, Math.ceil(lineCount / hunkLineCount) - totalHunks);
        const startHunk = Math.max(0, Math.min(idealStartHunk, maxStartHunk));
        const startingLine = startHunk * hunkLineCount;
        const clampedTotalLines = idealStartHunk < 0 ? totalLines + idealStartHunk * hunkLineCount : totalLines;
        const bufferBefore = hunkOffsets[startHunk] ?? 0;
        const finalHunkIndex = startHunk + clampedTotalLines / hunkLineCount;
        return {
            startingLine: startingLine,
            totalLines: clampedTotalLines,
            bufferBefore: bufferBefore,
            bufferAfter: finalHunkIndex < hunkOffsets.length ? fileHeight - headerRegion - hunkOffsets[finalHunkIndex] - paddingBottom : fileHeight - (absoluteLineTop - fileTop) - paddingBottom
        };
    }
};
function $6e11c2280e7ca279$var$hasDiffLayoutOptionChanged(previousOptions, nextOptions) {
    return (previousOptions.diffStyle ?? "split") !== (nextOptions.diffStyle ?? "split") || (previousOptions.overflow ?? "scroll") !== (nextOptions.overflow ?? "scroll") || (previousOptions.collapsed ?? false) !== (nextOptions.collapsed ?? false) || (previousOptions.disableLineNumbers ?? false) !== (nextOptions.disableLineNumbers ?? false) || (previousOptions.disableFileHeader ?? false) !== (nextOptions.disableFileHeader ?? false) || (previousOptions.diffIndicators ?? "bars") !== (nextOptions.diffIndicators ?? "bars") || (previousOptions.hunkSeparators ?? "line-info") !== (nextOptions.hunkSeparators ?? "line-info") || (previousOptions.expandUnchanged ?? false) !== (nextOptions.expandUnchanged ?? false) || (previousOptions.collapsedContextThreshold ?? (0, $6986aac91971cc6d$export$54c265eef46f12ac)) !== (nextOptions.collapsedContextThreshold ?? (0, $6986aac91971cc6d$export$54c265eef46f12ac)) || previousOptions.unsafeCSS !== nextOptions.unsafeCSS;
}
function $6e11c2280e7ca279$var$getOptionHunkSeparatorType(hunkSeparators) {
    return typeof hunkSeparators === "function" ? "custom" : hunkSeparators ?? "line-info";
}
function $6e11c2280e7ca279$var$hasFinalHunk(fileDiff) {
    const lastHunk = fileDiff.hunks.at(-1);
    if (lastHunk == null || fileDiff.isPartial || fileDiff.additionLines.length === 0 || fileDiff.deletionLines.length === 0) return false;
    return lastHunk.additionLineIndex + lastHunk.additionCount < fileDiff.additionLines.length || lastHunk.deletionLineIndex + lastHunk.deletionCount < fileDiff.deletionLines.length;
}
function $6e11c2280e7ca279$var$parseLineIndex(lineIndexAttr, diffStyle) {
    const [unifiedIndex, splitIndex] = lineIndexAttr.split(",").map(Number);
    return diffStyle === "split" ? splitIndex : unifiedIndex;
}


//#region src/components/CodeView.ts
const $a415f622906ecd36$var$CODE_VIEW_DIFF_OPTION_KEYS = [
    "theme",
    "disableLineNumbers",
    "overflow",
    "themeType",
    "disableFileHeader",
    "disableVirtualizationBuffers",
    "preferredHighlighter",
    "useCSSClasses",
    "useTokenTransformer",
    "tokenizeMaxLineLength",
    "tokenizeMaxLength",
    "unsafeCSS",
    "diffStyle",
    "diffIndicators",
    "disableBackground",
    "expandUnchanged",
    "collapsedContextThreshold",
    "lineDiffType",
    "maxLineDiffLength",
    "expansionLineCount",
    "lineHoverHighlight",
    "enableTokenInteractionsOnWhitespace",
    "enableGutterUtility",
    "__debugPointerEvents",
    "enableLineSelection",
    "controlledSelection",
    "disableErrorHandling"
];
const $a415f622906ecd36$var$CODE_VIEW_FILE_OPTION_KEYS = [
    "theme",
    "disableLineNumbers",
    "overflow",
    "themeType",
    "disableFileHeader",
    "disableVirtualizationBuffers",
    "preferredHighlighter",
    "useCSSClasses",
    "useTokenTransformer",
    "tokenizeMaxLineLength",
    "tokenizeMaxLength",
    "unsafeCSS",
    "lineHoverHighlight",
    "enableTokenInteractionsOnWhitespace",
    "enableGutterUtility",
    "__debugPointerEvents",
    "enableLineSelection",
    "controlledSelection",
    "disableErrorHandling"
];
const $a415f622906ecd36$var$CODE_VIEW_SHARED_CALLBACK_KEYS = [
    "renderCustomHeader",
    "renderHeaderPrefix",
    "renderHeaderMetadata",
    "renderAnnotation",
    "renderGutterUtility",
    "onPostRender",
    "onGutterUtilityClick",
    "onLineClick",
    "onLineNumberClick",
    "onLineEnter",
    "onLineLeave",
    "onTokenClick",
    "onTokenEnter",
    "onTokenLeave"
];
const $a415f622906ecd36$var$CODE_VIEW_SELECTION_CALLBACK_KEYS = [
    "onLineSelected",
    "onLineSelectionStart",
    "onLineSelectionChange",
    "onLineSelectionEnd"
];
const $a415f622906ecd36$var$DEFAULT_SCROLL_INTERACTION_RESTORE_DELAY_MS = 120;
const $a415f622906ecd36$var$SCROLLING_CODE_OVERFLOW_FIX_VARIABLE = "--diffs-overflow-override";
const $a415f622906ecd36$var$SCROLL_REBASE_CONTAINER_HEIGHT = 12e6;
const $a415f622906ecd36$var$SCROLL_REBASE_TRIGGER_TOP = 1e6;
const $a415f622906ecd36$var$SCROLL_REBASE_TARGET_TOP = 2e6;
const $a415f622906ecd36$var$SCROLL_REBASE_TARGET_BOTTOM = $a415f622906ecd36$var$SCROLL_REBASE_CONTAINER_HEIGHT - $a415f622906ecd36$var$SCROLL_REBASE_TARGET_TOP;
const $a415f622906ecd36$var$SCROLL_REBASE_THRESHOLD = $a415f622906ecd36$var$SCROLL_REBASE_CONTAINER_HEIGHT - $a415f622906ecd36$var$SCROLL_REBASE_TRIGGER_TOP;
const $a415f622906ecd36$var$CODE_VIEW_ELEMENT_POOL_LIMIT = 32;
const $a415f622906ecd36$var$MOBILE_SAFARI = (()=>{
    const { navigator: navigator } = globalThis;
    const userAgent = navigator.userAgent;
    const isIOS = /iP(?:hone|ad|od)/.test(userAgent);
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return (isIOS || isIPadOS) && /AppleWebKit/.test(userAgent) && /Safari/.test(userAgent) && !/(CriOS|FxiOS|EdgiOS|OPiOS)/.test(userAgent);
})();
var $a415f622906ecd36$export$6a048cde9ca9b775 = class CodeView {
    static __STOP = false;
    static __lastScrollPosition = 0;
    type = "advanced";
    config = {
        overscrollSize: 200,
        intersectionObserverMargin: 0,
        resizeDebugging: false
    };
    items = [];
    idToItem = /* @__PURE__ */ new Map();
    selectedLines = null;
    instanceToItem = /* @__PURE__ */ new Map();
    layoutDirtyIndex;
    slotCoordinator;
    slotSnapshot;
    scrollListeners = /* @__PURE__ */ new Set();
    scrollHeight = 0;
    containerHeight = -1;
    scrollTop = 0;
    scrollPageOffset = 0;
    scrollDirty = true;
    scrollInteractionFixTimer;
    pointerEventsDisabled = false;
    codeOverflowFix = false;
    height = 0;
    heightDirty = true;
    windowSpecs = {
        top: 0,
        bottom: 0
    };
    renderState = {
        scrollTop: -1,
        firstIndex: -1,
        lastIndex: -1,
        stickyHeight: 0,
        stickyTop: -1,
        stickyBottom: -1
    };
    itemMetricsCache = (0, $6986aac91971cc6d$export$c5e987fe582d77c0);
    pendingScrollTarget;
    pendingLayoutAnchor;
    scrollAnimation;
    root;
    resizeObserver;
    container = document.createElement("div");
    stickyContainer = document.createElement("div");
    stickyOffset = document.createElement("div");
    elementPool = [];
    pendingElementPool = [];
    options;
    workerManager;
    isContainerManaged;
    constructor(options = {
        theme: (0, $6986aac91971cc6d$export$bcfc57767d137a59)
    }, workerManager, isContainerManaged = false){
        this.options = options;
        this.computeMetricsCache(options.itemMetrics);
        this.workerManager = workerManager;
        this.isContainerManaged = isContainerManaged;
        this.stickyOffset.style.contain = "layout size";
        this.stickyContainer.style.position = "sticky";
        this.stickyContainer.style.width = "100%";
        this.stickyContainer.style.contain = "layout style inline-size";
        this.stickyContainer.style.isolation = "isolate";
        this.stickyContainer.style.display = "flex";
        this.stickyContainer.style.flexDirection = "column";
    }
    getLayout() {
        return this.options.layout ?? (0, $6986aac91971cc6d$export$8e5cf365ea11c6b);
    }
    computeMetricsCache(itemMetrics) {
        this.itemMetricsCache = {
            hunkLineCount: itemMetrics?.hunkLineCount ?? (0, $6986aac91971cc6d$export$c5e987fe582d77c0).hunkLineCount,
            lineHeight: itemMetrics?.lineHeight ?? (0, $6986aac91971cc6d$export$c5e987fe582d77c0).lineHeight,
            diffHeaderHeight: itemMetrics?.diffHeaderHeight ?? (0, $6986aac91971cc6d$export$c5e987fe582d77c0).diffHeaderHeight,
            hunkSeparatorHeight: itemMetrics?.hunkSeparatorHeight,
            spacing: itemMetrics?.spacing ?? (0, $6986aac91971cc6d$export$c5e987fe582d77c0).spacing,
            paddingTop: itemMetrics?.paddingTop,
            paddingBottom: itemMetrics?.paddingBottom
        };
        return this.itemMetricsCache;
    }
    getSmoothScrollSettings() {
        return this.options.smoothScrollSettings ?? (0, $6986aac91971cc6d$export$9de45920e0505112);
    }
    shouldDisablePointerEvents() {
        return this.options.pointerEventsOnScroll !== true;
    }
    shouldValidateItemHeights() {
        return (0, $6986aac91971cc6d$export$5d8096ed6304226f) && this.options.__devOnlyValidateItemHeights === true;
    }
    validateRenderedItemHeight(item) {
        if (!this.shouldValidateItemHeights() || item.element == null) return;
        const stickySpecs = item.instance.getAdvancedStickySpecs();
        if (stickySpecs == null) return;
        const expectedHeight = stickySpecs.height;
        const actualHeight = item.element.getBoundingClientRect().height;
        if (expectedHeight === actualHeight) return;
        console.error("CodeView: reconciled item height does not match DOM height", {
            id: item.item.id,
            type: item.type,
            index: item.index,
            version: item.version,
            expectedHeight: expectedHeight,
            actualHeight: actualHeight,
            delta: actualHeight - expectedHeight,
            stickyTopOffset: stickySpecs.topOffset,
            virtualizedHeight: item.instance.getVirtualizedHeight(),
            top: item.top,
            scrollTop: this.getScrollTop(),
            windowSpecs: {
                ...this.windowSpecs
            },
            element: item.element,
            instance: item.instance
        });
    }
    clearScrollInteractionTimer() {
        if (this.scrollInteractionFixTimer != null) {
            clearTimeout(this.scrollInteractionFixTimer);
            this.scrollInteractionFixTimer = void 0;
        }
    }
    suspendScrollInteractions() {
        this.clearScrollInteractionTimer();
        if (this.shouldDisablePointerEvents() && !this.pointerEventsDisabled) {
            this.stickyContainer.style.pointerEvents = "none";
            this.pointerEventsDisabled = true;
        }
        if ($a415f622906ecd36$var$MOBILE_SAFARI && !this.codeOverflowFix) {
            this.stickyContainer.style.setProperty($a415f622906ecd36$var$SCROLLING_CODE_OVERFLOW_FIX_VARIABLE, "hidden");
            this.codeOverflowFix = true;
        }
        this.scrollInteractionFixTimer = setTimeout(this.restoreScrollInteractions, $a415f622906ecd36$var$DEFAULT_SCROLL_INTERACTION_RESTORE_DELAY_MS);
    }
    restoreScrollInteractions = ()=>{
        this.clearScrollInteractionTimer();
        if (this.pointerEventsDisabled) {
            this.stickyContainer.style.removeProperty("pointer-events");
            this.pointerEventsDisabled = false;
        }
        if (this.codeOverflowFix) {
            this.stickyContainer.style.setProperty($a415f622906ecd36$var$SCROLLING_CODE_OVERFLOW_FIX_VARIABLE, "auto");
            this.codeOverflowFix = false;
        }
    };
    syncLayout() {
        const { gap: gap, paddingBottom: paddingBottom, paddingTop: paddingTop } = this.getLayout();
        this.stickyContainer.style.gap = `${gap}px`;
        this.container?.style.setProperty("margin-top", `${paddingTop}px`);
        this.container?.style.setProperty("margin-bottom", `${paddingBottom}px`);
    }
    setup(root) {
        if (this.root != null) throw new Error("CodeView.setup: already setup");
        this.root = root;
        this.root.style.overflowAnchor = "none";
        this.container ??= document.createElement("div");
        this.container.style.contain = "layout style";
        this.syncLayout();
        this.container.appendChild(this.stickyOffset);
        this.container.appendChild(this.stickyContainer);
        this.root.appendChild(this.container);
        this.scrollDirty = true;
        this.heightDirty = true;
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.stickyContainer);
        this.root.addEventListener("scroll", this.handleScroll, {
            passive: true
        });
        this.root.addEventListener("wheel", this.clearPendingScroll, {
            passive: true
        });
        this.root.addEventListener("touchstart", this.clearPendingScroll, {
            passive: true
        });
        this.root.addEventListener("pointerdown", this.clearPendingScroll, {
            passive: true
        });
        this.root.addEventListener("keydown", this.clearPendingScroll, {
            passive: true
        });
        this.resizeObserver.observe(this.root);
        this.render(true);
        window.__INSTANCE = this;
        window.__TOGGLE = ()=>{
            if (CodeView.__STOP) {
                CodeView.__STOP = false;
                this.scrollTo({
                    type: "position",
                    position: CodeView.__lastScrollPosition,
                    behavior: "instant"
                });
            } else {
                CodeView.__lastScrollPosition = this.getScrollTop();
                CodeView.__STOP = true;
            }
        };
    }
    reset() {
        this.restoreScrollInteractions();
        this.cleanAllRenderedItems();
        this.selectedLines = null;
        this.items.length = 0;
        this.idToItem.clear();
        this.instanceToItem.clear();
        this.layoutDirtyIndex = void 0;
        this.stickyContainer.textContent = "";
        this.stickyOffset.style.height = "";
        this.container?.style.removeProperty("height");
        this.containerHeight = -1;
        this.windowSpecs = {
            top: 0,
            bottom: 0
        };
        this.pendingLayoutAnchor = void 0;
        this.height = 0;
        this.scrollTop = 0;
        this.scrollPageOffset = 0;
        this.scrollHeight = 0;
        this.scrollDirty = true;
        this.heightDirty = true;
        this.resetRenderState();
        if (!this.isContainerManaged) this.flushSlotCoordinator();
    }
    cleanUp() {
        this.reset();
        this.clearElementPool();
        this.restoreScrollInteractions();
        this.resizeObserver?.disconnect();
        this.resizeObserver = void 0;
        this.root?.removeEventListener("scroll", this.handleScroll);
        this.root?.removeEventListener("wheel", this.clearPendingScroll);
        this.root?.removeEventListener("touchstart", this.clearPendingScroll);
        this.root?.removeEventListener("pointerdown", this.clearPendingScroll);
        this.root?.removeEventListener("keydown", this.clearPendingScroll);
        this.root?.style.removeProperty("overflow-anchor");
        this.container?.remove();
        this.stickyOffset.remove();
        this.stickyContainer.remove();
        this.stickyContainer.textContent = "";
        this.root = void 0;
        this.container = void 0;
    }
    cleanAllRenderedItems() {
        if (this.renderState.firstIndex === -1) return;
        for(let index = this.renderState.firstIndex; index <= this.renderState.lastIndex; index++){
            const item = this.items[index];
            if (item == null) throw new Error(`CodeView.cleanAllRenderedItems: Item does not exist at index: ${index}`);
            this.releaseRenderedItem(item);
        }
    }
    primeScrollTarget(target) {
        if (target.type === "position") return;
        const item = this.idToItem.get(target.id);
        if (item == null) return;
        item.instance.primeHighlightCache();
    }
    acquireElement() {
        this.promotePendingPooledElements();
        return this.elementPool.pop() ?? document.createElement((0, $6986aac91971cc6d$export$b583bc7fc1f35cf2));
    }
    releaseRenderedItem(item) {
        const { element: element } = item;
        item.instance.cleanUp(true);
        item.element = void 0;
        if (element == null) return;
        element.remove();
        this.cleanElementForPool(element);
        this.queueElementForPool(element);
    }
    cleanElementForPool(element) {
        const { shadowRoot: shadowRoot } = element;
        if (shadowRoot != null) {
            for (const child of Array.from(shadowRoot.children))if (!$a415f622906ecd36$var$isPooledShadowChild(child)) child.remove();
        }
        if (!this.isContainerManaged) element.replaceChildren();
    }
    queueElementForPool(element) {
        if (this.getElementPoolSize() >= $a415f622906ecd36$var$CODE_VIEW_ELEMENT_POOL_LIMIT) return;
        if (this.isElementClean(element)) this.elementPool.push(element);
        else this.pendingElementPool.push(element);
    }
    promotePendingPooledElements() {
        if (this.pendingElementPool.length === 0) return;
        const { pendingElementPool: pendingElements } = this;
        this.pendingElementPool = [];
        for (const element of pendingElements)if (this.isElementClean(element) && this.elementPool.length < $a415f622906ecd36$var$CODE_VIEW_ELEMENT_POOL_LIMIT) this.elementPool.push(element);
        else if (this.getElementPoolSize() < $a415f622906ecd36$var$CODE_VIEW_ELEMENT_POOL_LIMIT) this.pendingElementPool.push(element);
    }
    isElementClean(element) {
        return element.childNodes.length === 0;
    }
    getElementPoolSize() {
        return this.elementPool.length + this.pendingElementPool.length;
    }
    clearElementPool() {
        this.elementPool.length = 0;
        this.pendingElementPool.length = 0;
    }
    resolveEffectiveScrollBehavior(target, destination) {
        if ((0, $930cfefdc5651f76$export$ff7706047246b98b)()) return "instant";
        if (target.behavior !== "smooth-auto") return target.behavior ?? "instant";
        return Math.abs(destination - this.getScrollTop()) <= this.getHeight() * 10 ? "smooth" : "instant";
    }
    scrollTo(target) {
        if (this.root == null) return;
        const pendingTarget = this.normalizeScrollTarget(target);
        if (pendingTarget == null) return;
        const destination = this.resolveScrollTargetTop(pendingTarget);
        if (destination == null) return;
        this.primeScrollTarget(pendingTarget);
        if (this.resolveEffectiveScrollBehavior(pendingTarget, destination) === "smooth") this.scrollAnimation ??= {
            position: this.getScrollTop(),
            velocity: 0,
            lastTimestamp: performance.now()
        };
        else this.scrollAnimation = void 0;
        this.suspendScrollInteractions();
        this.pendingLayoutAnchor = void 0;
        this.pendingScrollTarget = pendingTarget;
        this.render();
    }
    setSelectedLines(selection, options) {
        this.applySelectedLines(selection, options);
    }
    getSelectedLines() {
        return this.selectedLines;
    }
    clearSelectedLines(options) {
        this.applySelectedLines(null, options);
    }
    getItem(itemId) {
        return this.idToItem.get(itemId)?.item;
    }
    updateItem(input) {
        const item = this.idToItem.get(input.id);
        if (item == null) {
            console.error(`CodeView.updateItem: unknown item id "${input.id}"`);
            return false;
        }
        if (!this.syncItemRecord(item, input)) return false;
        this.markItemLayoutDirty(item);
        this.scrollDirty = true;
        this.render();
        this.syncSelection();
        return true;
    }
    updateItemId(oldId, newId) {
        if (oldId === newId) return true;
        const item = this.idToItem.get(oldId);
        if (item == null) {
            console.error(`CodeView.updateItemId: unknown item id "${oldId}"`);
            return false;
        }
        if (this.idToItem.has(newId)) {
            console.error(`CodeView.updateItemId: duplicate item id "${newId}"`);
            return false;
        }
        this.idToItem.delete(oldId);
        item.item.id = newId;
        this.idToItem.set(newId, item);
        if (item.type === "diff") item.instance.setOptions(this.createOptions(item.item));
        else item.instance.setOptions(this.createOptions(item.item));
        if (this.selectedLines?.id === oldId) {
            this.selectedLines = {
                ...this.selectedLines,
                id: newId
            };
            this.options.onSelectedLinesChange?.(this.selectedLines);
        }
        this.renamePendingScrollTarget(oldId, newId);
        this.renamePendingLayoutAnchor(oldId, newId);
        this.render();
        return true;
    }
    addItem(input) {
        this.addItems([
            input
        ]);
        this.syncSelection();
    }
    addItems(inputs) {
        this.appendItemsInternal(inputs);
        this.syncSelection();
    }
    setItems(items) {
        if (items.length === 0) this.reset();
        else if (this.items.length === 0) this.appendItemsInternal(items);
        else if (!this.tryAppendItems(items)) this.reconcileItems(items);
        this.syncSelection();
    }
    /**
	* Append new records to the viewer while preserving existing layout state.
	* This is the shared path for imperative adds and the append-only reconcile
	* fast path, so it measures new items immediately and only triggers render
	* once at the end.
	*/ appendItemsInternal(inputs, render = true) {
        if (inputs.length === 0) return;
        const layout = this.getLayout();
        let nextTop = this.items.length === 0 ? 0 : this.scrollHeight + layout.gap;
        const appendedTop = nextTop;
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input == null) throw new Error("CodeView.appendItemsInternal: missing input item");
            if (this.idToItem.has(input.id)) throw new Error(`CodeView.addItem: duplicate id "${input.id}"`);
            const item = this.createItem(input, this.items.length, nextTop);
            this.items.push(item);
            this.idToItem.set(item.item.id, item);
            this.instanceToItem.set(item.instance, item);
            item.height = $a415f622906ecd36$var$prepareItemInstance(item);
            nextTop += item.height + layout.gap;
        }
        this.scrollHeight = nextTop - layout.gap;
        this.scrollDirty = true;
        if (render) {
            if (this.canSkipRenderForAppend(appendedTop)) this.syncContainerHeight();
            else this.render();
        }
    }
    canSkipRenderForAppend(appendedTop) {
        return this.container != null && this.renderState.firstIndex !== -1 && this.pendingScrollTarget == null && this.scrollAnimation == null && this.layoutDirtyIndex == null && appendedTop > this.windowSpecs.bottom;
    }
    setOptions(options) {
        if (options == null) return;
        this.capturePendingLayoutAnchor();
        const previousLayout = this.getLayout();
        const { itemMetricsCache: previousItemMetrics } = this;
        if ($a415f622906ecd36$var$shouldClearPool(this.options, options)) this.clearElementPool();
        this.options = options;
        const nextItemMetrics = this.computeMetricsCache(options.itemMetrics);
        const itemMetricsChanged = !(0, $3ec53e4f7bbd4269$export$1db8244ab969c6c6)(previousItemMetrics, nextItemMetrics);
        if (!(0, $3ec53e4f7bbd4269$export$1db8244ab969c6c6)(previousLayout, this.getLayout())) this.syncLayout();
        for(let index = 0; index < this.items.length; index++){
            const item = this.items[index];
            if (item == null) throw new Error("CodeView.setOptions: invalid item index");
            if (itemMetricsChanged) item.instance.setMetrics(nextItemMetrics, true);
            if (item.type === "diff") item.instance.setOptions(this.createOptions(item.item));
            else item.instance.setOptions(this.createOptions(item.item));
        }
        this.markLayoutDirtyFromIndex(0);
        this.scrollDirty = true;
        if (!this.isContainerManaged && this.items.length > 0) this.render();
    }
    capturePendingLayoutAnchor() {
        if (this.root == null || this.items.length === 0 || this.pendingScrollTarget != null) return;
        this.pendingLayoutAnchor = this.getScrollAnchor(this.getScrollTop());
    }
    render(immediate = false) {
        if (CodeView.__STOP) return;
        if (immediate) {
            (0, $c4a6ed6d38b63558$export$932f2205472a6595)(this.computeRenderRangeAndEmit);
            this.computeRenderRangeAndEmit();
        } else (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    }
    instanceChanged(instance, layoutDirty) {
        const item = this.instanceToItem.get(instance);
        if (item == null) throw new Error("CodeView.instanceChanged: An instance has changed that is not registered");
        if (layoutDirty) this.markItemLayoutDirty(item);
        this.render();
    }
    getWindowSpecs() {
        return this.windowSpecs;
    }
    getContainerElement() {
        return this.root;
    }
    getRenderedItems() {
        const { firstIndex: firstIndex, lastIndex: lastIndex } = this.renderState;
        if (firstIndex === -1 || lastIndex === -1 || lastIndex < firstIndex) return [];
        const renderedItems = [];
        for(let index = firstIndex; index <= lastIndex; index++){
            const item = this.items[index];
            if (item?.element == null) continue;
            if (item.type === "diff") renderedItems.push({
                id: item.item.id,
                type: "diff",
                item: item.item,
                version: item.version,
                element: item.element,
                instance: item.instance
            });
            else renderedItems.push({
                id: item.item.id,
                type: "file",
                item: item.item,
                version: item.version,
                element: item.element,
                instance: item.instance
            });
        }
        return renderedItems;
    }
    setSlotCoordinator(coordinator) {
        if (coordinator === this.slotCoordinator) return false;
        this.slotCoordinator = coordinator;
        this.slotSnapshot = void 0;
        return true;
    }
    getSlotSnapshot(coordinator) {
        return $a415f622906ecd36$var$getSlotSnapshot(this.getRenderedItems(), coordinator);
    }
    subscribeToScroll(listener) {
        this.scrollListeners.add(listener);
        return ()=>{
            this.scrollListeners.delete(listener);
        };
    }
    getLocalTopForInstance(instance) {
        const item = this.instanceToItem.get(instance);
        if (item == null) throw new Error("CodeView.getLocalTopForInstance: unknown virtualized instance");
        return item.top;
    }
    getTopForItem(id) {
        const item = this.idToItem.get(id);
        if (item == null) return;
        return item.top + this.getLayout().paddingTop;
    }
    createItem(input, index, top) {
        const { itemMetricsCache: itemMetrics } = this;
        if (input.type === "diff") return {
            type: "diff",
            item: input,
            version: input.version,
            index: index,
            instance: new (0, $6e11c2280e7ca279$export$e1a9054d4036b12f)(this.createOptions(input), this, itemMetrics, this.workerManager, this.isContainerManaged),
            top: top,
            height: 0,
            element: void 0
        };
        return {
            type: "file",
            item: input,
            version: input.version,
            index: index,
            instance: new (0, $04b40a9847bcadbe$export$6ddfbce10e697151)(this.createOptions(input), this, itemMetrics, this.workerManager, this.isContainerManaged),
            top: top,
            height: 0,
            element: void 0
        };
    }
    getItemById(itemId) {
        const item = this.idToItem.get(itemId);
        if (item == null) console.error(`CodeView.getItemById: unknown item id "${itemId}"`);
        return item;
    }
    getItemByMode(itemId, mode) {
        const item = this.getItemById(itemId);
        if (item == null) return;
        if (item.type !== mode) {
            console.error(`CodeView.getItemByMode: item id "${itemId}" is not a ${mode}`);
            return;
        }
        return item;
    }
    applySelectedLines(selection, options) {
        const { selectedLines: prevSelection } = this;
        if (selection == null && prevSelection == null || selection != null && prevSelection?.id === selection.id && (0, $b650ccf3ff2748b4$export$cfda57044a46e9e2)(prevSelection.range, selection.range)) return;
        if (prevSelection != null && prevSelection.id !== selection?.id) this.idToItem.get(prevSelection.id)?.instance.setSelectedLines(null, {
            notify: false
        });
        this.selectedLines = selection;
        this.idToItem.get(selection?.id ?? "")?.instance.setSelectedLines(selection?.range ?? null, options);
    }
    syncSelection() {
        if (this.selectedLines == null) return;
        const item = this.idToItem.get(this.selectedLines.id);
        if (item == null) {
            this.selectedLines = null;
            return;
        }
        item.instance.setSelectedLines(this.selectedLines.range, {
            notify: false
        });
    }
    renamePendingScrollTarget(oldId, newId) {
        const { pendingScrollTarget: pendingScrollTarget } = this;
        if (pendingScrollTarget == null || pendingScrollTarget.type === "position" || pendingScrollTarget.id !== oldId) return;
        this.pendingScrollTarget = {
            ...pendingScrollTarget,
            id: newId
        };
    }
    renamePendingLayoutAnchor(oldId, newId) {
        if (this.pendingLayoutAnchor?.id === oldId) this.pendingLayoutAnchor.id = newId;
    }
    wrapCallbackWithContext(mode, itemId, callback) {
        return (...args)=>{
            const item = this.getItemByMode(itemId, mode);
            if (item == null) return;
            return callback(...args, item);
        };
    }
    getWrappedOptionCallback(mode, key, itemId) {
        const callback = this.options[key];
        if (callback == null) return;
        return this.wrapCallbackWithContext(mode, itemId, callback);
    }
    getWrappedSelectionOptionCallback(mode, key, itemId) {
        if (this.options.enableLineSelection !== true) return;
        const callback = this.options[key];
        return (range)=>{
            const item = this.getItemByMode(itemId, mode);
            if (item == null) return;
            const selection = range == null ? null : {
                id: itemId,
                range: range
            };
            if (this.options.controlledSelection !== true) {
                if (range != null || this.selectedLines?.id === itemId) this.applySelectedLines(selection, {
                    notify: false
                });
            }
            this.options.onSelectedLinesChange?.(selection);
            return callback?.(range, item);
        };
    }
    createOptions(item) {
        const { id: itemId, type: mode } = item;
        const options = mode === "file" ? {
            stickyHeader: this.options.stickyHeaders
        } : {
            stickyHeader: this.options.stickyHeaders,
            hunkSeparators: this.options.hunkSeparators
        };
        const target = options;
        const passThroughKeys = mode === "file" ? $a415f622906ecd36$var$CODE_VIEW_FILE_OPTION_KEYS : $a415f622906ecd36$var$CODE_VIEW_DIFF_OPTION_KEYS;
        for (const key of passThroughKeys){
            const value = this.options[key];
            if (value !== void 0) target[key] = value;
        }
        target.collapsed = item.collapsed === true;
        for (const key of $a415f622906ecd36$var$CODE_VIEW_SHARED_CALLBACK_KEYS){
            const callback = this.getWrappedOptionCallback(mode, key, itemId);
            if (callback !== void 0) target[key] = callback;
        }
        for (const key of $a415f622906ecd36$var$CODE_VIEW_SELECTION_CALLBACK_KEYS){
            const callback = this.getWrappedSelectionOptionCallback(mode, key, itemId);
            if (callback !== void 0) target[key] = callback;
        }
        return options;
    }
    /**
	* Track the earliest index whose measured layout may now be stale. Later
	* render passes relayout from this point forward so we do not have to rebuild
	* positions for the whole list after every change.
	*/ markLayoutDirtyFromIndex(index) {
        this.layoutDirtyIndex = Math.min(this.layoutDirtyIndex ?? index, index);
    }
    /**
	* Mark the earliest affected item as layout-dirty after an imperative change.
	* Each record carries its current array index so this stays O(1) even when
	* the viewer holds a very large number of items.
	*/ markItemLayoutDirty(item) {
        if (this.items[item.index] !== item) throw new Error(`CodeView.markItemLayoutDirty: unknown item id "${item.item.id}"`);
        this.markLayoutDirtyFromIndex(item.index);
    }
    /**
	* Detect the common controlled-update case where the new list simply extends
	* the existing ordered prefix. When that happens we can reuse every current
	* record in place, sync any versioned payload changes, and append only the new
	* tail instead of rebuilding the whole list.
	*/ tryAppendItems(items) {
        if (items.length <= this.items.length) return false;
        for(let index = 0; index < this.items.length; index++){
            const existingItem = this.items[index];
            if (existingItem == null) throw new Error("CodeView.tryAppendItems: missing existing item");
            const nextItem = items[index];
            if (nextItem == null || existingItem.item.id !== nextItem.id || existingItem.type !== nextItem.type) return false;
        }
        for(let index = 0; index < this.items.length; index++){
            const existingItem = this.items[index];
            if (existingItem == null) throw new Error("CodeView.tryAppendItems: missing existing item");
            const nextItem = items[index];
            if (nextItem == null) throw new Error("CodeView.tryAppendItems: append candidate missing prefix item");
            if (this.syncItemRecord(existingItem, nextItem)) this.markLayoutDirtyFromIndex(index);
        }
        this.appendItemsInternal(items.slice(this.items.length), false);
        this.scrollDirty = true;
        this.render();
        return true;
    }
    /**
	* Reconcile a new controlled item list against the existing records by id.
	* This reuses records and instances when type matches, cleans up removed
	* records, rebuilds the lookup maps, and marks layout dirty whenever order,
	* membership, or versioned item data changes.
	*/ reconcileItems(items) {
        const { items: previousItems, idToItem: previousById } = this;
        const removedItems = new Set(previousItems);
        const nextItems = [];
        const nextIdToItem = /* @__PURE__ */ new Map();
        const nextInstanceToItem = /* @__PURE__ */ new Map();
        let firstDirtyIndex;
        for(let index = 0; index < items.length; index++){
            const input = items[index];
            if (input == null) throw new Error("CodeView.reconcileItems: missing input item");
            if (nextIdToItem.has(input.id)) throw new Error(`CodeView.setItems: duplicate id "${input.id}"`);
            const previousItem = previousById.get(input.id);
            const item = previousItem != null && previousItem.type === input.type ? previousItem : this.createItem(input, index, 0);
            item.index = index;
            if (previousItem != null && previousItem.type === input.type) {
                removedItems.delete(previousItem);
                if (this.syncItemRecord(item, input)) firstDirtyIndex = Math.min(firstDirtyIndex ?? index, index);
            } else firstDirtyIndex = Math.min(firstDirtyIndex ?? index, index);
            if (previousItems[index] !== item) firstDirtyIndex = Math.min(firstDirtyIndex ?? index, index);
            nextItems.push(item);
            nextIdToItem.set(input.id, item);
            nextInstanceToItem.set(item.instance, item);
        }
        for(let index = 0; index < previousItems.length; index++){
            const removedItem = previousItems[index];
            if (removedItem == null || !removedItems.has(removedItem)) continue;
            this.releaseRenderedItem(removedItem);
            const dirtyIndex = Math.max(nextItems.length - 1, 0);
            firstDirtyIndex = Math.min(firstDirtyIndex ?? dirtyIndex, dirtyIndex);
        }
        if (firstDirtyIndex == null) return;
        this.items = nextItems;
        this.idToItem = nextIdToItem;
        this.instanceToItem = nextInstanceToItem;
        if (this.renderState.firstIndex >= nextItems.length) this.resetRenderState();
        else if (this.renderState.lastIndex >= nextItems.length) this.renderState.lastIndex = nextItems.length - 1;
        this.markLayoutDirtyFromIndex(firstDirtyIndex);
        this.scrollDirty = true;
        this.render();
    }
    /**
	* Update a reused record from the latest controlled item only when its item
	* version changes. Matching versions mean CodeView keeps the current record
	* snapshot, which lets imperative updates remain in place until the caller
	* intentionally publishes a newer version.
	*/ syncItemRecord(item, nextItem) {
        if (item.type !== nextItem.type) throw new Error(`CodeView.syncItemRecord: type mismatch for id "${nextItem.id}"`);
        if (item.version === nextItem.version) return false;
        item.item = nextItem;
        item.version = nextItem.version;
        if (item.type === "diff") item.instance.setOptions(this.createOptions(item.item));
        else item.instance.setOptions(this.createOptions(item.item));
        return true;
    }
    getMaxScrollTopForHeight(scrollHeight) {
        const { paddingBottom: paddingBottom, paddingTop: paddingTop } = this.getLayout();
        return Math.max(paddingTop + scrollHeight + paddingBottom - this.getHeight(), 0);
    }
    getMaxScrollTop() {
        return this.getMaxScrollTopForHeight(this.getScrollHeight());
    }
    shouldRebaseScroll() {
        return this.getMaxScrollTop() > $a415f622906ecd36$var$SCROLL_REBASE_THRESHOLD;
    }
    getPagedScrollHeight() {
        return this.shouldRebaseScroll() ? Math.min(this.getScrollHeight(), $a415f622906ecd36$var$SCROLL_REBASE_CONTAINER_HEIGHT) : this.getScrollHeight();
    }
    getMaxPagedScrollTop() {
        return this.getMaxScrollTopForHeight(this.getPagedScrollHeight());
    }
    clampPagedScrollTop(value) {
        const maxScroll = this.getMaxPagedScrollTop();
        return Math.max(0, Math.min(value, maxScroll));
    }
    /**
	* Clamps a logical scroll position to the min/max allowable scroll range
	* based on the full computed content height.
	*/ clampScrollTop(value) {
        const maxScroll = this.getMaxScrollTop();
        return Math.max(0, Math.min(value, maxScroll));
    }
    getMaxScrollPageOffset() {
        return Math.max(this.getMaxScrollTop() - this.getMaxPagedScrollTop(), 0);
    }
    clampScrollPageOffset(value) {
        const maxOffset = this.getMaxScrollPageOffset();
        return Math.max(0, Math.min(value, maxOffset));
    }
    resolveScrollPageWindow(scrollTop, preferredPagedScrollTop) {
        let pagedScrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.clampPagedScrollTop(preferredPagedScrollTop));
        let scrollPageOffset = this.clampScrollPageOffset(scrollTop - pagedScrollTop);
        pagedScrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.clampPagedScrollTop(scrollTop - scrollPageOffset));
        scrollPageOffset = this.clampScrollPageOffset(scrollTop - pagedScrollTop);
        return {
            pagedScrollTop: pagedScrollTop,
            scrollPageOffset: scrollPageOffset
        };
    }
    /**
	* Resolve how a logical scrollTop maps onto the reusable paged scroll window
	* without mutating the current page offset.
	*/ resolvePagedScrollPosition(logicalScrollTop) {
        if (!this.shouldRebaseScroll()) return {
            pagedScrollTop: this.clampPagedScrollTop(logicalScrollTop),
            scrollPageOffset: 0
        };
        const currentPageOffset = this.clampScrollPageOffset(this.scrollPageOffset);
        const pagedScrollTop = logicalScrollTop - currentPageOffset;
        const pagedMaxScrollTop = this.getMaxPagedScrollTop();
        const maxRebaseOffset = this.getMaxScrollPageOffset();
        const shouldMoveDown = pagedScrollTop > $a415f622906ecd36$var$SCROLL_REBASE_THRESHOLD && currentPageOffset < maxRebaseOffset;
        const shouldMoveUp = pagedScrollTop < $a415f622906ecd36$var$SCROLL_REBASE_TRIGGER_TOP && currentPageOffset > 0;
        if (pagedScrollTop < 0 || pagedScrollTop > pagedMaxScrollTop || shouldMoveDown || shouldMoveUp) return this.resolveScrollPageWindow(logicalScrollTop, shouldMoveUp ? Math.min($a415f622906ecd36$var$SCROLL_REBASE_TARGET_BOTTOM, pagedMaxScrollTop) : $a415f622906ecd36$var$SCROLL_REBASE_TARGET_TOP);
        return {
            pagedScrollTop: (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.clampPagedScrollTop(pagedScrollTop)),
            scrollPageOffset: currentPageOffset
        };
    }
    needsScrollPageUpdate(logicalScrollTop) {
        const roundedScrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.clampScrollTop(logicalScrollTop));
        const { scrollPageOffset: scrollPageOffset } = this.resolvePagedScrollPosition(roundedScrollTop);
        return scrollPageOffset !== this.scrollPageOffset;
    }
    getPagedLayoutTop(logicalTop) {
        if (!this.shouldRebaseScroll()) return logicalTop;
        return Math.max(logicalTop - this.scrollPageOffset, 0);
    }
    getStickyHeaderOffset() {
        return this.options.stickyHeaders === true && this.options.disableFileHeader !== true ? this.itemMetricsCache.diffHeaderHeight : 0;
    }
    getScrollTargetRect(target) {
        const item = this.idToItem.get(target.id);
        if (item == null) {
            console.warn(`CodeView.scrollTo: unknown item id "${target.id}"`);
            return;
        }
        if (target.type === "item") return {
            top: item.top,
            height: item.height
        };
        if (target.type === "range") {
            const rangePosition = this.getRangeScrollPosition(item, target);
            if (rangePosition == null) {
                console.warn(`CodeView.scrollTo: unable to resolve range ${$a415f622906ecd36$var$formatSelectedLineRange(target.range)} for item "${target.id}"`);
                return;
            }
            return {
                top: item.top + rangePosition.top,
                height: rangePosition.height
            };
        }
        const linePosition = this.getLineScrollPosition(item, target);
        if (linePosition == null) {
            console.warn(`CodeView.scrollTo: unable to resolve line ${target.lineNumber} for item "${target.id}"`);
            return;
        }
        return {
            top: item.top + linePosition.top,
            height: linePosition.height
        };
    }
    normalizeScrollTarget(target) {
        if (target.type === "position" || target.align !== "nearest") return target;
        const rect = this.getScrollTargetRect(target);
        if (rect == null) return;
        const offset = target.offset ?? 0;
        const targetTop = this.getLayout().paddingTop + rect.top;
        const targetBottom = targetTop + rect.height;
        const currentTop = this.getScrollTop();
        const visibleTop = currentTop + (target.type === "line" || target.type === "range" ? this.getStickyHeaderOffset() : 0);
        const visibleBottom = currentTop + this.getHeight();
        if (targetTop - offset <= visibleTop && targetBottom + offset >= visibleBottom) return;
        if (targetTop - offset < visibleTop) return {
            ...target,
            align: "start"
        };
        if (targetBottom + offset > visibleBottom) return {
            ...target,
            align: "end"
        };
    }
    /**
	* Resolve a target's scroll position
	
	* Returns `undefined` when we can't resolve a target for whatever reason
	*/ resolveScrollTargetTop(target) {
        if (target.type === "position") {
            const clampedPosition = this.clampScrollTop(target.position);
            return clampedPosition !== target.position ? clampedPosition : this.clampScrollTop(target.position - this.getStickyHeaderOffset());
        }
        const item = this.idToItem.get(target.id);
        if (item == null) {
            console.warn(`CodeView.scrollTo: unknown item id "${target.id}"`);
            return;
        }
        if (target.type === "item") return this.clampScrollTop(this.resolveAlignedScrollPosition(item.top, item.height, target.align, target.offset));
        if (target.type === "range") {
            const rangePosition = this.getRangeScrollPosition(item, target);
            if (rangePosition == null) {
                console.warn(`CodeView.scrollTo: unable to resolve range ${$a415f622906ecd36$var$formatSelectedLineRange(target.range)} for item "${target.id}"`);
                return;
            }
            return this.clampScrollTop(this.resolveAlignedScrollPosition(item.top + rangePosition.top, rangePosition.height, target.align, target.offset, this.getStickyHeaderOffset()));
        }
        const linePosition = this.getLineScrollPosition(item, target);
        if (linePosition == null) {
            console.warn(`CodeView.scrollTo: unable to resolve line ${target.lineNumber} for item "${target.id}"`);
            return;
        }
        return this.clampScrollTop(this.resolveAlignedScrollPosition(item.top + linePosition.top, linePosition.height, target.align, target.offset, this.getStickyHeaderOffset()));
    }
    /**
	* Given an existing scroll target (scroll top and height), figure out the
	* correct scroll position to target based on the desired alignment, offset
	* and stickyOffset if necessary
	*/ resolveAlignedScrollPosition(targetTop, targetHeight, align, offset = 0, stickyOffset = 0) {
        targetTop += this.getLayout().paddingTop;
        const viewportHeight = this.getHeight();
        if (align === "center" && targetHeight + offset < viewportHeight) return targetTop - (viewportHeight - targetHeight) / 2 + offset;
        if (align === "end") return targetTop - (viewportHeight - targetHeight) + offset;
        return targetTop - stickyOffset - offset;
    }
    getLineScrollPosition(item, target) {
        if (item.type === "diff") return item.instance.getLinePosition(target.lineNumber, target.side);
        return item.instance.getLinePosition(target.lineNumber);
    }
    getRangeScrollPosition(item, target) {
        const { range: range } = target;
        const startPosition = this.getLineScrollPosition(item, {
            type: "line",
            id: target.id,
            lineNumber: range.start,
            side: range.side
        });
        const endPosition = this.getLineScrollPosition(item, {
            type: "line",
            id: target.id,
            lineNumber: range.end,
            side: range.endSide ?? range.side
        });
        if (startPosition == null || endPosition == null) return;
        const startTop = startPosition.top;
        const startBottom = startTop + startPosition.height;
        const endTop = endPosition.top;
        const endBottom = endTop + endPosition.height;
        const top = Math.min(startTop, endTop);
        return {
            top: top,
            height: Math.max(startBottom, endBottom) - top
        };
    }
    /**
	* Determine target scroll position for current frame.
	*
	* If there's no pendingScrollTarget then we just return the current scroll
	* position
	*
	* If there's a pendingScrollTarget then we depend on whether there's a
	* smooth scroll animation or not. If not just return the destination, or
	* compute next position given the smooth scroll spring physics
	*/ computeTargetScrollTopForFrame(scrollTop, frameTimestamp) {
        if (this.pendingScrollTarget == null) return scrollTop;
        const destination = this.resolveScrollTargetTop(this.pendingScrollTarget);
        if (destination == null) return scrollTop;
        const { scrollAnimation: scrollAnimation } = this;
        if (scrollAnimation == null) return destination;
        return this.computeSpringStep(scrollAnimation, destination, frameTimestamp).position;
    }
    /**
	* Closed-form critical-damped ODE step.
	*
	* Stable at any dt (Euler would blow up once ω·dt ≳ 1), so this survives
	* big RAF gaps (tab-wake, offscreen frames) and resize-driven ticks that
	* fire outside the normal RAF cadence.
	*/ computeSpringStep(animation, destination, frameTimestamp) {
        const dt = Math.max(0, frameTimestamp - animation.lastTimestamp);
        const { omega: omega } = this.getSmoothScrollSettings();
        const decay = Math.exp(-omega * dt);
        const displacement = animation.position - destination;
        const springCoeff = animation.velocity + omega * displacement;
        return {
            position: destination + (displacement + springCoeff * dt) * decay,
            velocity: (springCoeff * (1 - omega * dt) - omega * displacement) * decay
        };
    }
    /**
	* For any given pendingScrollTarget, updates any in flight smooth scroll
	* animations and returns the target scrollTop to move towards
	*
	* Resolves the animation based on frame time and adopts any necessary scroll
	* anchoring corrections if necessary
	*/ advanceScrollAnimation(frameTimestamp, anchorDelta) {
        if (this.pendingScrollTarget == null) return;
        const destination = this.resolveScrollTargetTop(this.pendingScrollTarget);
        if (destination == null) {
            this.pendingScrollTarget = void 0;
            this.scrollAnimation = void 0;
            return;
        }
        const animation = this.scrollAnimation;
        if (animation == null) return destination;
        animation.position += anchorDelta;
        const { position: position, velocity: velocity } = this.computeSpringStep(animation, destination, frameTimestamp);
        animation.lastTimestamp = frameTimestamp;
        animation.position = position;
        animation.velocity = velocity;
        const { positionEpsilon: positionEpsilon, velocityEpsilon: velocityEpsilon } = this.getSmoothScrollSettings();
        if (Math.abs(destination - position) <= positionEpsilon && Math.abs(velocity) <= velocityEpsilon) {
            animation.position = destination;
            animation.velocity = 0;
            this.scrollAnimation = void 0;
            return destination;
        }
        return animation.position;
    }
    computeRenderRangeAndEmit = (timestamp = performance.now())=>{
        if (CodeView.__STOP || this.container == null) return;
        const viewportHeight = this.getHeight();
        const initialScrollTop = this.getScrollTop();
        let scrollTopAfterLayout = initialScrollTop;
        let computeScrollCorrection = this.pendingLayoutAnchor != null;
        let scrollAnchor = this.getScrollAnchor(scrollTopAfterLayout);
        if (this.layoutDirtyIndex != null) {
            this.recomputeLayout(this.layoutDirtyIndex);
            this.layoutDirtyIndex = void 0;
            computeScrollCorrection = true;
        }
        if (computeScrollCorrection && scrollAnchor != null) {
            const anchoredScrollTopAfterLayout = this.resolveAnchoredScrollTop(scrollAnchor);
            if (anchoredScrollTopAfterLayout != null) {
                const layoutAnchorDelta = anchoredScrollTopAfterLayout - scrollTopAfterLayout;
                scrollTopAfterLayout = anchoredScrollTopAfterLayout;
                if (this.scrollAnimation != null) this.scrollAnimation.position += layoutAnchorDelta;
            }
        }
        if (computeScrollCorrection) {
            scrollTopAfterLayout = this.clampScrollTop(scrollTopAfterLayout);
            this.syncContainerHeight();
        }
        const targetScrollTop = this.computeTargetScrollTopForFrame(scrollTopAfterLayout, timestamp);
        const fitPerfectly = !computeScrollCorrection && (this.renderState.scrollTop === -1 || Math.abs(targetScrollTop - this.renderState.scrollTop) > viewportHeight + this.config.overscrollSize * 2);
        if (fitPerfectly) scrollAnchor = void 0;
        this.windowSpecs = (0, $71eae0748844a945$export$182aa6646dae80cc)({
            scrollTop: targetScrollTop,
            height: viewportHeight,
            scrollHeight: this.getScrollHeight(),
            fitPerfectly: fitPerfectly,
            fitPerfectlyOverscroll: this.getFitPerfectlyOverscroll(),
            overscrollSize: this.config.overscrollSize
        });
        let syncedScrollTop = initialScrollTop;
        if (this.pendingScrollTarget != null && targetScrollTop !== syncedScrollTop || this.needsScrollPageUpdate(targetScrollTop)) {
            this.applyScrollFix(targetScrollTop, syncedScrollTop, this.windowSpecs);
            syncedScrollTop = targetScrollTop;
        }
        const { top: top, bottom: bottom } = this.windowSpecs;
        const { firstIndex: firstIndex, lastIndex: lastIndex } = this.renderState;
        if (firstIndex >= 0) for(let index = firstIndex; index <= lastIndex; index++){
            const item = this.items[index];
            if (item == null) throw new Error(`CodeView.computeRenderRangeAndEmit: No item at index: ${index}`);
            if (!(item.top > top - item.height && item.top <= bottom)) this.releaseRenderedItem(item);
        }
        let prevElement;
        const updatedItems = /* @__PURE__ */ new Set();
        const startingIndex = this.findFirstVisibleIndex(top);
        const lastRenderedIndex = this.findLastVisibleIndex(bottom);
        for(let itemIndex = startingIndex; itemIndex <= lastRenderedIndex; itemIndex++){
            const item = this.items[itemIndex];
            if (item == null) throw new Error(`CodeView.computeRenderRangeAndEmit: missing item`);
            const { instance: instance } = item;
            if (item.element == null) {
                item.element = this.acquireElement();
                $a415f622906ecd36$var$syncRenderedItemOrder(this.stickyContainer, item.element, prevElement);
                instance.virtualizedSetup();
                if ($a415f622906ecd36$var$renderItem(item, item.element)) updatedItems.add(item);
                prevElement = item.element;
            } else {
                $a415f622906ecd36$var$syncRenderedItemOrder(this.stickyContainer, item.element, prevElement);
                if ($a415f622906ecd36$var$renderItem(item)) updatedItems.add(item);
                prevElement = item.element;
            }
        }
        this.renderState.firstIndex = startingIndex <= lastRenderedIndex ? startingIndex : -1;
        this.renderState.lastIndex = lastRenderedIndex;
        this.flushSlotCoordinator();
        this.reconcileRenderedItems(updatedItems);
        this.syncContainerHeight();
        this.updateStickyPositioning();
        const anchoredScrollTopAfterRender = scrollAnchor != null ? this.resolveAnchoredScrollTop(scrollAnchor) : void 0;
        if (scrollAnchor === this.pendingLayoutAnchor) this.pendingLayoutAnchor = void 0;
        const postRenderAnchorDelta = anchoredScrollTopAfterRender != null ? anchoredScrollTopAfterRender - scrollTopAfterLayout : 0;
        let postRenderScrollTop = targetScrollTop;
        let shouldCheckPendingTargetSettled = false;
        if (this.pendingScrollTarget != null) {
            const pendingTargetScrollTop = this.advanceScrollAnimation(timestamp, postRenderAnchorDelta);
            if (pendingTargetScrollTop != null) {
                postRenderScrollTop = pendingTargetScrollTop;
                shouldCheckPendingTargetSettled = true;
            } else postRenderScrollTop = scrollTopAfterLayout;
        } else postRenderScrollTop = anchoredScrollTopAfterRender ?? targetScrollTop;
        if (postRenderScrollTop !== syncedScrollTop) {
            this.applyScrollFix(postRenderScrollTop, syncedScrollTop, this.windowSpecs);
            syncedScrollTop = postRenderScrollTop;
        }
        if (shouldCheckPendingTargetSettled && this.pendingScrollTarget != null && this.isPendingTargetSettled(this.pendingScrollTarget)) {
            this.pendingScrollTarget = void 0;
            this.scrollAnimation = void 0;
        }
        this.renderState.scrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(syncedScrollTop);
        this.flushManagers(updatedItems);
        if (fitPerfectly || this.scrollAnimation != null) this.render();
    };
    flushManagers(updatedItems) {
        for (const item of updatedItems)item.instance.flushManagers();
    }
    syncContainerHeight() {
        const pagedScrollHeight = this.getPagedScrollHeight();
        if (this.container == null || this.containerHeight === pagedScrollHeight) return;
        this.container.style.height = `${pagedScrollHeight}px`;
        this.containerHeight = pagedScrollHeight;
    }
    getStickyBounds(windowSpecs) {
        const { firstIndex: firstIndex, lastIndex: lastIndex } = windowSpecs != null ? {
            firstIndex: this.findFirstVisibleIndex(windowSpecs.top),
            lastIndex: this.findLastVisibleIndex(windowSpecs.bottom)
        } : this.renderState;
        if (firstIndex === -1 || lastIndex === -1 || firstIndex > lastIndex) return;
        const firstStickySpecs = this.items[firstIndex]?.instance.getAdvancedStickySpecs(windowSpecs);
        const lastStickySpecs = this.items[lastIndex]?.instance.getAdvancedStickySpecs(windowSpecs);
        if (firstStickySpecs == null || lastStickySpecs == null) return;
        return {
            stickyTop: this.getPagedLayoutTop(Math.max(firstStickySpecs.topOffset, 0)),
            stickyBottom: this.getPagedLayoutTop(lastStickySpecs.topOffset + lastStickySpecs.height)
        };
    }
    applyStickyPositioning({ stickyTop: stickyTop, stickyBottom: stickyBottom }) {
        const height = this.getHeight();
        const { itemMetricsCache: itemMetrics } = this;
        const stickyContainerHeight = stickyBottom - stickyTop;
        this.renderState.stickyHeight = stickyContainerHeight;
        this.renderState.stickyTop = stickyTop;
        this.renderState.stickyBottom = stickyBottom;
        this.stickyOffset.style.height = `${stickyTop}px`;
        const randomOffset = (Math.random() * itemMetrics.lineHeight >> 0) * -1;
        const stickyJitter = -Math.max(stickyContainerHeight + randomOffset, 0) + height;
        this.stickyContainer.style.top = `${stickyJitter}px`;
        this.stickyContainer.style.bottom = `${stickyJitter + itemMetrics.diffHeaderHeight}px`;
    }
    syncPagedScrollScaffolding(windowSpecs) {
        this.syncContainerHeight();
        const stickyBounds = this.getStickyBounds(windowSpecs);
        if (stickyBounds == null) return;
        this.applyStickyPositioning(stickyBounds);
    }
    reconcileRenderedItems(updatedItems) {
        const { firstIndex: firstIndex, lastIndex: lastIndex } = this.renderState;
        if (firstIndex === -1) return;
        let currentTop = -1;
        let heightChanged = false;
        for(let index = firstIndex; index < this.items.length; index++){
            if (!heightChanged && index > lastIndex) break;
            const item = this.items[index];
            if (item == null) throw new Error("CodeView.reconcileRenderedItems: Invalid item");
            if (currentTop === -1) currentTop = item.top;
            else if (item.top !== currentTop) {
                item.top = currentTop;
                item.instance.syncVirtualizedTop();
                heightChanged = true;
            }
            if (updatedItems == null ? index <= lastIndex : updatedItems.has(item)) {
                if (item.instance.reconcileHeights()) {
                    heightChanged = true;
                    item.height = item.instance.getVirtualizedHeight();
                }
                this.validateRenderedItemHeight(item);
            }
            currentTop += item.instance.getVirtualizedHeight();
            if (index < this.items.length - 1) currentTop += this.getLayout().gap;
        }
        if (heightChanged && currentTop != null) {
            this.scrollDirty = true;
            this.scrollHeight = currentTop;
        }
    }
    updateStickyPositioning() {
        const stickyBounds = this.getStickyBounds();
        if (stickyBounds == null) return;
        const { stickyTop: stickyTop, stickyBottom: stickyBottom } = stickyBounds;
        if (stickyBottom - stickyTop === this.renderState.stickyHeight && stickyTop === this.renderState.stickyTop && stickyBottom === this.renderState.stickyBottom) return;
        this.applyStickyPositioning(stickyBounds);
    }
    handleScroll = ()=>{
        if (CodeView.__STOP) return;
        this.suspendScrollInteractions();
        this.scrollDirty = true;
        this.notifyScroll();
        this.render();
    };
    clearPendingScroll = ()=>{
        this.pendingScrollTarget = void 0;
        this.pendingLayoutAnchor = void 0;
        this.scrollAnimation = void 0;
    };
    handleResize = (entries)=>{
        for (const entry of entries)if (entry.target === this.stickyContainer) {
            if (entry.borderBoxSize[0].blockSize !== this.renderState.stickyHeight) {
                const currentScrollTop = this.getScrollTop();
                const anchor = this.getScrollAnchor(currentScrollTop);
                this.reconcileRenderedItems();
                this.updateStickyPositioning();
                const anchoredScrollTop = anchor != null ? this.resolveAnchoredScrollTop(anchor) : void 0;
                if (anchoredScrollTop != null) {
                    const resizeAnchorDelta = anchoredScrollTop - currentScrollTop;
                    this.applyScrollFix(anchoredScrollTop, currentScrollTop, this.windowSpecs);
                    if (this.scrollAnimation != null) this.scrollAnimation.position += resizeAnchorDelta;
                }
                if (this.pendingScrollTarget != null && this.isPendingTargetSettled(this.pendingScrollTarget)) {
                    this.pendingScrollTarget = void 0;
                    this.scrollAnimation = void 0;
                }
            }
        } else {
            this.scrollDirty = true;
            this.heightDirty = true;
            this.render();
        }
    };
    /**
	* Figure out scrollTop accounting for sticky header if enabled and
	* necessary
	*/ getScrollAnchorViewportTop(absoluteItemTop, scrollTop) {
        return absoluteItemTop < scrollTop ? scrollTop + this.getStickyHeaderOffset() : scrollTop;
    }
    /**
	* Attempt to find a scroll anchor based on build in metrics of the existing
	* rendered files/diff.
	*
	* A scroll anchor represents the first fully visible element (in other
	* words, the first file or first line who's top is fully in the viewport).
	*/ getScrollAnchor(scrollTop) {
        if (this.pendingLayoutAnchor != null) return this.pendingLayoutAnchor;
        const { firstIndex: firstIndex, lastIndex: lastIndex, stickyTop: stickyTop, stickyBottom: stickyBottom } = this.renderState;
        if (firstIndex === -1 || lastIndex === -1) return;
        const viewportHeight = this.getHeight();
        if (stickyTop === -1 || stickyBottom === -1) return;
        for(let index = firstIndex; index <= lastIndex; index++){
            const item = this.items[index];
            if (item == null) continue;
            const absoluteItemTop = this.getLayout().paddingTop + item.top;
            if (absoluteItemTop + item.height <= scrollTop) continue;
            if (absoluteItemTop >= scrollTop + viewportHeight) break;
            if (absoluteItemTop >= scrollTop) return {
                type: "item",
                id: item.item.id,
                viewportOffset: absoluteItemTop - scrollTop
            };
            const localViewportTop = this.getScrollAnchorViewportTop(absoluteItemTop, scrollTop) - absoluteItemTop;
            const lineAnchor = item.instance.getNumericScrollAnchor(localViewportTop);
            if (lineAnchor != null) {
                const absoluteLineTop = absoluteItemTop + lineAnchor.top;
                return {
                    type: "line",
                    id: item.item.id,
                    lineNumber: lineAnchor.lineNumber,
                    side: lineAnchor.side,
                    viewportOffset: absoluteLineTop - scrollTop
                };
            }
        }
    }
    /**
	* Given a scroll anchor, attempt to resolve a newly updated (and clamped)
	* scroll position to keep the anchored element in place.
	*
	* If we can't resolve a position for whatever reason, we'll return
	* undefined.
	*/ resolveAnchoredScrollTop(anchor) {
        const item = this.idToItem.get(anchor.id);
        if (item == null) return;
        const { paddingTop: paddingTop } = this.getLayout();
        if (anchor.type === "item") {
            const absoluteItemTop = paddingTop + item.top;
            return this.clampScrollTop(absoluteItemTop - anchor.viewportOffset);
        }
        const linePosition = item.type === "diff" ? item.instance.getLinePosition(anchor.lineNumber, anchor.side) : item.instance.getLinePosition(anchor.lineNumber);
        if (linePosition == null) return;
        const absoluteLineTop = paddingTop + item.top + linePosition.top;
        return this.clampScrollTop(absoluteLineTop - anchor.viewportOffset);
    }
    /**
	* Apply a device-pixel-rounded scroll position if it differs from the last
	* logical scrollTop synchronized into the paged scroll scaffold.
	*/ applyScrollFix(targetScrollTop, syncedScrollTop, windowSpecs) {
        if (this.root == null) return;
        const roundedTargetScrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.clampScrollTop(targetScrollTop));
        const roundedSyncedScrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(syncedScrollTop);
        const { scrollPageOffset: previousPageOffset } = this;
        const syncedPagedScrollTop = (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.clampPagedScrollTop(roundedSyncedScrollTop - previousPageOffset));
        const { pagedScrollTop: pagedScrollTop, scrollPageOffset: scrollPageOffset } = this.resolvePagedScrollPosition(roundedTargetScrollTop);
        const targetPagedScrollTop = pagedScrollTop;
        const rebaseChanged = previousPageOffset !== scrollPageOffset;
        if (roundedTargetScrollTop === this.renderState.scrollTop && roundedTargetScrollTop === roundedSyncedScrollTop && targetPagedScrollTop === syncedPagedScrollTop && !rebaseChanged) return;
        this.suspendScrollInteractions();
        if (targetPagedScrollTop !== syncedPagedScrollTop || rebaseChanged) {
            this.scrollPageOffset = scrollPageOffset;
            this.syncPagedScrollScaffolding(windowSpecs);
        }
        if (targetPagedScrollTop !== syncedPagedScrollTop) this.root.scrollTo({
            top: targetPagedScrollTop,
            behavior: "instant"
        });
        this.renderState.scrollTop = roundedTargetScrollTop;
        this.scrollTop = roundedTargetScrollTop;
        this.scrollDirty = false;
    }
    /**
	* Decide whether a pending programmatic scroll has reached its
	* destination and should be cleared.
	*/ isPendingTargetSettled(target) {
        const top = this.resolveScrollTargetTop(target);
        if (top == null) return true;
        return (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(this.getScrollTop()) === (0, $57a3bb19b0510d4e$export$8c36de38ff643fe0)(top);
    }
    getScrollTop() {
        if (!this.scrollDirty) return this.scrollTop;
        this.scrollDirty = false;
        const rootScrollTop = this.root?.scrollTop ?? 0;
        this.scrollTop = this.clampScrollTop(rootScrollTop + this.scrollPageOffset);
        return this.scrollTop;
    }
    getHeight() {
        if (!this.heightDirty) return this.height;
        this.heightDirty = false;
        this.height = this.root?.getBoundingClientRect().height ?? 0;
        return this.height;
    }
    getScrollHeight() {
        return this.scrollHeight;
    }
    flushSlotCoordinator() {
        if (this.slotCoordinator == null) return;
        const { onSnapshotChange: onSnapshotChange } = this.slotCoordinator;
        const slotSnapshot = $a415f622906ecd36$var$getSlotSnapshot(this.getRenderedItems(), this.slotCoordinator);
        if ($a415f622906ecd36$var$areSlotSnapshotsEqual(this.slotSnapshot, slotSnapshot)) return;
        this.slotSnapshot = slotSnapshot;
        onSnapshotChange(slotSnapshot);
    }
    notifyScroll() {
        if (this.scrollListeners.size === 0) return;
        const scrollTop = this.getScrollTop();
        for (const listener of this.scrollListeners)listener(scrollTop, this);
    }
    /**
	* Find the first item whose bottom edge crosses into the viewport window.
	* This lets scroll-time rendering jump directly near the visible range instead
	* of linearly scanning from the start of very large item lists.
	*/ findFirstVisibleIndex(top) {
        let low = 0;
        let high = this.items.length - 1;
        let result = this.items.length;
        while(low <= high){
            const mid = low + high >> 1;
            const item = this.items[mid];
            if (item == null) throw new Error("CodeView.findFirstVisibleIndex: invalid item index");
            if (item.top + item.height > top) {
                result = mid;
                high = mid - 1;
            } else low = mid + 1;
        }
        return result;
    }
    /**
	* Find the last item whose top edge is still within the viewport window.
	* Paired with findFirstVisibleIndex, this bounds the render loop to only the
	* slice of items that can actually intersect the current scroll range.
	*/ findLastVisibleIndex(bottom) {
        let low = 0;
        let high = this.items.length - 1;
        let result = -1;
        while(low <= high){
            const mid = low + high >> 1;
            const item = this.items[mid];
            if (item == null) throw new Error("CodeView.findLastVisibleIndex: invalid item index");
            if (item.top <= bottom) {
                result = mid;
                low = mid + 1;
            } else high = mid - 1;
        }
        return result;
    }
    /**
	* Recompute measured tops and heights starting from the earliest dirty item.
	* Earlier items keep their existing layout, while everything from startIndex
	* onward is remeasured so downstream positions and total scroll height stay
	* consistent after inserts, removals, or versioned item updates.
	*/ recomputeLayout(startIndex = 0) {
        if (this.items.length === 0) {
            this.scrollHeight = 0;
            return;
        }
        const layout = this.getLayout();
        let runningTop = 0;
        if (startIndex > 0) {
            const previousItem = this.items[startIndex - 1];
            if (previousItem == null) throw new Error("CodeView.recomputeLayout: invalid dirty index");
            runningTop = previousItem.top + previousItem.height + layout.gap;
        }
        for(let index = startIndex; index < this.items.length; index++){
            const item = this.items[index];
            if (item == null) throw new Error("CodeView.recomputeLayout: invalid item index");
            item.top = runningTop;
            if (item.type === "diff") item.height = item.instance.prepareVirtualizedItem(item.item.fileDiff);
            else item.height = item.instance.prepareVirtualizedItem(item.item.file);
            runningTop += item.height;
            if (index < this.items.length - 1) runningTop += layout.gap;
        }
        if (runningTop !== this.scrollHeight) this.scrollDirty = true;
        this.scrollHeight = runningTop;
    }
    resetRenderState() {
        this.renderState.scrollTop = -1;
        this.renderState.firstIndex = -1;
        this.renderState.lastIndex = -1;
        this.renderState.stickyHeight = 0;
        this.renderState.stickyTop = -1;
        this.renderState.stickyBottom = -1;
    }
    getFitPerfectlyOverscroll() {
        return this.getLayout().gap + this.itemMetricsCache.diffHeaderHeight;
    }
};
function $a415f622906ecd36$var$prepareItemInstance(item) {
    item.instance.cleanUp(true);
    if (item.type === "diff") return item.instance.prepareVirtualizedItem(item.item.fileDiff);
    else return item.instance.prepareVirtualizedItem(item.item.file);
}
function $a415f622906ecd36$var$shouldClearPool(previousOptions, nextOptions) {
    return !(0, $0246eee5e18b0420$export$e40448283aec01f1)(previousOptions.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59), nextOptions.theme ?? (0, $6986aac91971cc6d$export$bcfc57767d137a59)) || (previousOptions.themeType ?? "system") !== (nextOptions.themeType ?? "system") || previousOptions.unsafeCSS !== nextOptions.unsafeCSS;
}
function $a415f622906ecd36$var$isPooledShadowChild(child) {
    if (child instanceof SVGElement) return true;
    return (0, $0d4053e5b759c704$export$1405a8e7808a3d28)(child) && (child.hasAttribute((0, $6986aac91971cc6d$export$4145a617a0026c98)) || child.hasAttribute((0, $6986aac91971cc6d$export$4ce037b01ed1780d)) || child.hasAttribute((0, $6986aac91971cc6d$export$26189492e726cd65)));
}
function $a415f622906ecd36$var$formatSelectedLineRange(range) {
    const start = $a415f622906ecd36$var$formatSelectedLinePoint(range.start, range.side);
    const end = $a415f622906ecd36$var$formatSelectedLinePoint(range.end, range.endSide ?? range.side);
    return start === end ? start : `${start}-${end}`;
}
function $a415f622906ecd36$var$formatSelectedLinePoint(lineNumber, side) {
    if (side == null) return `${lineNumber}`;
    return `${side === "deletions" ? "D" : "A"}${lineNumber}`;
}
function $a415f622906ecd36$var$renderItem(item, fileContainer) {
    if (item.type === "diff") return item.instance.render({
        deferManagers: true,
        fileContainer: fileContainer,
        fileDiff: item.item.fileDiff,
        lineAnnotations: item.item.annotations
    });
    else return item.instance.render({
        deferManagers: true,
        fileContainer: fileContainer,
        file: item.item.file,
        lineAnnotations: item.item.annotations
    });
}
/**
* Keep the rendered DOM order aligned with the current record order even when
* we reuse existing elements. Reused items may already be mounted elsewhere in
* the sticky container, so this moves them into the correct sibling position
* before rendering updates.
*/ function $a415f622906ecd36$var$syncRenderedItemOrder(container, element, prevElement) {
    if (prevElement == null) {
        if (container.firstChild !== element) container.prepend(element);
        return;
    }
    if (prevElement.nextSibling !== element) prevElement.after(element);
}
function $a415f622906ecd36$var$hasAnnotations(item) {
    return (item.annotations?.length ?? 0) > 0;
}
function $a415f622906ecd36$var$getSlotSnapshot(renderedItems, { hasHeaderRenderers: hasHeaderRenderers, hasAnnotationRenderer: hasAnnotationRenderer, hasGutterRenderer: hasGutterRenderer }) {
    if (renderedItems.length === 0) return;
    if (hasHeaderRenderers || hasGutterRenderer) return renderedItems;
    if (!hasAnnotationRenderer) return;
    const slotSnapshot = [];
    for (const renderedItem of renderedItems)if ($a415f622906ecd36$var$hasAnnotations(renderedItem.item)) slotSnapshot.push(renderedItem);
    return slotSnapshot.length > 0 ? slotSnapshot : void 0;
}
function $a415f622906ecd36$var$areSlotSnapshotsEqual(previous, next) {
    if (previous == null || next == null) return previous === next;
    if (previous.length !== next.length) return false;
    for(let index = 0; index < previous.length; index++){
        const previousItem = previous[index];
        const nextItem = next[index];
        if (previousItem == null || nextItem == null || previousItem.id !== nextItem.id || previousItem.type !== nextItem.type || previousItem.element !== nextItem.element || previousItem.version !== nextItem.version) return false;
    }
    return true;
}


//#region src/utils/areManagedSnapshotsEqual.ts
function $4019b097f14ecd67$export$ca3e7b5963358354(previous, next) {
    if (previous == null || next == null) return previous === next;
    if (previous.length !== next.length) return false;
    for(let index = 0; index < previous.length; index++){
        const previousItem = previous[index];
        const nextItem = next[index];
        if (previousItem == null || nextItem == null || previousItem.id !== nextItem.id || previousItem.type !== nextItem.type || previousItem.element !== nextItem.element || previousItem.version !== nextItem.version) return false;
    }
    return true;
}




//#region src/utils/getMergeConflictActionSlotName.ts
function $6df7d7d2e2865b86$export$2b59b4cecb579564({ hunkIndex: hunkIndex, lineIndex: lineIndex, conflictIndex: conflictIndex }) {
    return `merge-conflict-action-${hunkIndex}-${lineIndex}-${conflictIndex}`;
}


//#region src/utils/parseMergeConflictDiffFromFile.ts
function $e6197aea3722697f$export$a1a4a4a6a830658e(action, fileDiff) {
    const hunk = fileDiff.hunks[action.hunkIndex];
    if (hunk == null) return;
    return {
        hunkIndex: action.hunkIndex,
        lineIndex: $e6197aea3722697f$var$getUnifiedLineStartForContent(hunk, action.startContentIndex)
    };
}
function $e6197aea3722697f$export$6b1f2b5fc3ddd452(file, maxContextLines = 6) {
    maxContextLines = Math.max(maxContextLines, 1);
    const s = {
        deletionLines: [],
        additionLines: [],
        conflictStack: [],
        conflictBuilders: [],
        actions: [],
        hunks: [],
        nextConflictIndex: 0,
        splitLineCount: 0,
        unifiedLineCount: 0,
        lastHunkEnd: 0,
        activeHunk: void 0,
        maxContextLines: maxContextLines,
        maxContextLines2: maxContextLines * 2
    };
    const contents = file.contents;
    const contentLength = contents.length;
    if (contentLength > 0) {
        let lineStart = 0;
        let lineIndex = 0;
        let newlinePos = contents.indexOf("\n", lineStart);
        while(newlinePos !== -1){
            $e6197aea3722697f$var$processLine(s, contents.slice(lineStart, newlinePos + 1), lineIndex);
            lineStart = newlinePos + 1;
            lineIndex++;
            newlinePos = contents.indexOf("\n", lineStart);
        }
        if (lineStart < contentLength) $e6197aea3722697f$var$processLine(s, contents.slice(lineStart), lineIndex);
    }
    if (s.conflictStack.length > 0) throw new Error("parseMergeConflictDiffFromFile: unfinished merge conflict marker stack");
    if (s.activeHunk != null && s.activeHunk.hunkContent.length > 0) {
        $e6197aea3722697f$var$flushBufferedContext(s, s.activeHunk, "trailing");
        $e6197aea3722697f$var$finalizeActiveHunk(s);
    }
    for(let conflictIndex = 0; conflictIndex < s.conflictBuilders.length; conflictIndex++){
        const builder = s.conflictBuilders[conflictIndex];
        if (builder == null || !builder.completed) throw new Error(`parseMergeConflictDiffFromFile: failed to build merge conflict action ${conflictIndex}`);
    }
    if (s.hunks.length > 0 && s.additionLines.length > 0 && s.deletionLines.length > 0) {
        const lastHunk = s.hunks[s.hunks.length - 1];
        const collapsedAfter = Math.max(s.additionLines.length - (lastHunk.additionStart + lastHunk.additionCount - 1), 0);
        s.splitLineCount += collapsedAfter;
        s.unifiedLineCount += collapsedAfter;
    }
    const currentContents = s.deletionLines.join("");
    const incomingContents = s.additionLines.join("");
    const currentFile = $e6197aea3722697f$var$createResolvedConflictFile(file, "current", currentContents);
    const incomingFile = $e6197aea3722697f$var$createResolvedConflictFile(file, "incoming", incomingContents);
    let type = "change";
    if (incomingContents === "") type = "deleted";
    else if (currentContents === "") type = "new";
    const fileDiff = {
        name: file.name,
        prevName: void 0,
        type: type,
        hunks: s.hunks,
        splitLineCount: s.splitLineCount,
        unifiedLineCount: s.unifiedLineCount,
        isPartial: false,
        deletionLines: s.deletionLines,
        additionLines: s.additionLines,
        cacheKey: file.cacheKey != null ? `${file.cacheKey}:merge-conflict-diff` : void 0
    };
    return {
        fileDiff: fileDiff,
        currentFile: currentFile,
        incomingFile: incomingFile,
        actions: s.actions,
        markerRows: $e6197aea3722697f$export$af9cb54b9c988fc6(fileDiff, s.actions)
    };
}
function $e6197aea3722697f$var$processLine(s, line, index) {
    const frame = s.conflictStack[s.conflictStack.length - 1];
    if (frame == null) {
        if (line.length >= 7 && line.charCodeAt(0) === 60 && $e6197aea3722697f$var$getMergeConflictMarkerType(line) === "start") {
            $e6197aea3722697f$var$handleStartMarker(s, line, index);
            return;
        }
        $e6197aea3722697f$var$emitContextLine(s, line);
        return;
    }
    const markerType = $e6197aea3722697f$var$getMergeConflictMarkerType(line);
    if (markerType === "start") {
        $e6197aea3722697f$var$handleStartMarker(s, line, index);
        return;
    }
    if (markerType === "base") {
        frame.stage = "base";
        frame.baseMarkerLineIndex = index;
        frame.markerLines.base = line;
        return;
    }
    if (markerType === "separator") {
        frame.stage = "incoming";
        frame.separatorLineIndex = index;
        frame.markerLines.separator = line;
        return;
    }
    if (markerType === "end") {
        const completedFrame = s.conflictStack.pop();
        if (completedFrame == null) throw new Error("parseMergeConflictDiffFromFile: encountered end marker before start marker");
        $e6197aea3722697f$var$finalizeConflict(s, completedFrame, index, line);
        return;
    }
    if (frame.stage === "current") $e6197aea3722697f$var$emitChangeLine(s, "deletion", line, frame.conflictIndex, "current");
    else if (frame.stage === "base") $e6197aea3722697f$var$emitContextLine(s, line, frame.conflictIndex);
    else $e6197aea3722697f$var$emitChangeLine(s, "addition", line, frame.conflictIndex, "incoming");
}
function $e6197aea3722697f$var$ensureActiveHunk(s) {
    s.activeHunk ??= $e6197aea3722697f$var$createHunkBuilder(s.additionLines.length + 1, s.deletionLines.length + 1);
    return s.activeHunk;
}
function $e6197aea3722697f$var$assignConflictContent(s, conflictIndex, role, contentIndex) {
    const builder = s.conflictBuilders[conflictIndex];
    if (builder == null) throw new Error(`parseMergeConflictDiffFromFile: failed to locate conflict action ${conflictIndex}`);
    const action = builder.action;
    const hunkIndex = s.hunks.length;
    if (action.hunkIndex < 0) action.hunkIndex = hunkIndex;
    else if (action.hunkIndex !== hunkIndex) throw new Error(`parseMergeConflictDiffFromFile: conflict ${conflictIndex} spans multiple hunks and cannot be anchored`);
    if (action.startContentIndex < 0) action.startContentIndex = contentIndex;
    action.endContentIndex = contentIndex;
    action.endMarkerContentIndex = contentIndex;
    if (role === "current") {
        action.currentContentIndex ??= contentIndex;
        return;
    }
    if (role === "base") {
        action.baseContentIndex ??= contentIndex;
        return;
    }
    action.incomingContentIndex = contentIndex;
}
function $e6197aea3722697f$var$appendChangeLine(hunk, lineType, additionLineIndex, deletionLineIndex) {
    const hunkContent = hunk.hunkContent;
    const lastContent = hunkContent[hunkContent.length - 1];
    if (lastContent?.type === "change") {
        if (lineType === "addition") lastContent.additions++;
        else lastContent.deletions++;
        return hunkContent.length - 1;
    }
    hunkContent.push({
        type: "change",
        additions: lineType === "addition" ? 1 : 0,
        deletions: lineType === "deletion" ? 1 : 0,
        additionLineIndex: additionLineIndex,
        deletionLineIndex: deletionLineIndex
    });
    return hunkContent.length - 1;
}
function $e6197aea3722697f$var$flushBufferedContext(s, hunk, mode) {
    let count = hunk.contextBufferCount;
    let addStart = hunk.contextBufferAdditionStart;
    let delStart = hunk.contextBufferDeletionStart;
    if (mode === "leading" && count > s.maxContextLines) {
        const difference = count - s.maxContextLines;
        addStart += difference;
        delStart += difference;
        count = s.maxContextLines;
        hunk.additionStart += difference;
        hunk.deletionStart += difference;
        hunk.additionLineIndex += difference;
        hunk.deletionLineIndex += difference;
    }
    if (mode === "trailing" && count > s.maxContextLines) count = s.maxContextLines;
    if (count === 0) {
        hunk.contextBufferCount = 0;
        hunk.contextBufferBaseConflicts = void 0;
        return;
    }
    const hunkContent = hunk.hunkContent;
    const lastContent = hunkContent[hunkContent.length - 1];
    let contentIndex;
    if (lastContent?.type === "context") {
        lastContent.lines += count;
        contentIndex = hunkContent.length - 1;
    } else {
        hunkContent.push({
            type: "context",
            lines: count,
            additionLineIndex: addStart,
            deletionLineIndex: delStart
        });
        contentIndex = hunkContent.length - 1;
    }
    hunk.additionCount += count;
    hunk.deletionCount += count;
    const baseConflicts = hunk.contextBufferBaseConflicts;
    if (baseConflicts != null) {
        const bufferStartOffset = addStart - hunk.contextBufferAdditionStart;
        for (const [offset, conflictIndex] of baseConflicts)if (offset >= bufferStartOffset && offset < bufferStartOffset + count) $e6197aea3722697f$var$assignConflictContent(s, conflictIndex, "base", contentIndex);
    }
    hunk.contextBufferCount = 0;
    hunk.contextBufferBaseConflicts = void 0;
}
function $e6197aea3722697f$var$finalizeActiveHunk(s) {
    if (s.activeHunk == null) return;
    const hunk = s.activeHunk;
    s.activeHunk = void 0;
    if (hunk.hunkContent.length === 0) return;
    let hunkSplitLineCount = 0;
    let hunkUnifiedLineCount = 0;
    for (const content of hunk.hunkContent)if (content.type === "context") {
        hunkSplitLineCount += content.lines;
        hunkUnifiedLineCount += content.lines;
    } else {
        hunkSplitLineCount += Math.max(content.additions, content.deletions);
        hunkUnifiedLineCount += content.additions + content.deletions;
    }
    const collapsedBefore = Math.max(hunk.additionStart - 1 - s.lastHunkEnd, 0);
    const finalizedHunk = {
        collapsedBefore: collapsedBefore,
        additionStart: hunk.additionStart,
        additionCount: hunk.additionCount,
        additionLines: hunk.additionLines,
        additionLineIndex: hunk.additionLineIndex,
        deletionStart: hunk.deletionStart,
        deletionCount: hunk.deletionCount,
        deletionLines: hunk.deletionLines,
        deletionLineIndex: hunk.deletionLineIndex,
        hunkContent: hunk.hunkContent,
        hunkContext: void 0,
        hunkSpecs: `@@ -${$e6197aea3722697f$var$formatHunkRange(hunk.deletionStart, hunk.deletionCount)} +${$e6197aea3722697f$var$formatHunkRange(hunk.additionStart, hunk.additionCount)} @@\n`,
        splitLineStart: s.splitLineCount + collapsedBefore,
        splitLineCount: hunkSplitLineCount,
        unifiedLineStart: s.unifiedLineCount + collapsedBefore,
        unifiedLineCount: hunkUnifiedLineCount,
        noEOFCRAdditions: false,
        noEOFCRDeletions: false
    };
    s.hunks.push(finalizedHunk);
    s.splitLineCount += collapsedBefore + hunkSplitLineCount;
    s.unifiedLineCount += collapsedBefore + hunkUnifiedLineCount;
    s.lastHunkEnd = hunk.additionStart + hunk.additionCount - 1;
}
function $e6197aea3722697f$var$splitHunkWithBufferedContext(s) {
    if (s.activeHunk == null) return;
    const hunk = s.activeHunk;
    const count = hunk.contextBufferCount;
    const omittedContextLineCount = count - s.maxContextLines2;
    const nextAddStart = hunk.contextBufferAdditionStart + count - s.maxContextLines;
    const nextDelStart = hunk.contextBufferDeletionStart + count - s.maxContextLines;
    let nextBaseConflicts;
    if (hunk.contextBufferBaseConflicts != null) {
        const tailOffset = count - s.maxContextLines;
        for (const [offset, ci] of hunk.contextBufferBaseConflicts)if (offset >= tailOffset) {
            nextBaseConflicts ??= /* @__PURE__ */ new Map();
            nextBaseConflicts.set(offset - tailOffset, ci);
        }
    }
    $e6197aea3722697f$var$flushBufferedContext(s, hunk, "trailing");
    const emittedAdditionCount = hunk.additionCount;
    const emittedDeletionCount = hunk.deletionCount;
    $e6197aea3722697f$var$finalizeActiveHunk(s);
    s.activeHunk = $e6197aea3722697f$var$createHunkBuilder(hunk.additionStart + emittedAdditionCount + omittedContextLineCount, hunk.deletionStart + emittedDeletionCount + omittedContextLineCount);
    s.activeHunk.contextBufferAdditionStart = nextAddStart;
    s.activeHunk.contextBufferDeletionStart = nextDelStart;
    s.activeHunk.contextBufferCount = s.maxContextLines;
    s.activeHunk.contextBufferBaseConflicts = nextBaseConflicts;
}
function $e6197aea3722697f$var$emitContextLine(s, line, baseConflictIndex = -1) {
    const hunk = $e6197aea3722697f$var$ensureActiveHunk(s);
    if (hunk.contextBufferCount === 0) {
        hunk.contextBufferAdditionStart = s.additionLines.length;
        hunk.contextBufferDeletionStart = s.deletionLines.length;
    }
    s.additionLines.push(line);
    s.deletionLines.push(line);
    if (baseConflictIndex >= 0) {
        hunk.contextBufferBaseConflicts ??= /* @__PURE__ */ new Map();
        hunk.contextBufferBaseConflicts.set(hunk.contextBufferCount, baseConflictIndex);
    }
    hunk.contextBufferCount++;
}
function $e6197aea3722697f$var$emitChangeLine(s, lineType, line, conflictIndex, role) {
    let hunk = $e6197aea3722697f$var$ensureActiveHunk(s);
    if (hunk.hunkContent.length > 0 && hunk.contextBufferCount > s.maxContextLines2) {
        $e6197aea3722697f$var$splitHunkWithBufferedContext(s);
        hunk = s.activeHunk;
    }
    $e6197aea3722697f$var$flushBufferedContext(s, hunk, hunk.hunkContent.length === 0 ? "leading" : "before-change");
    const additionLineIndex = s.additionLines.length;
    const deletionLineIndex = s.deletionLines.length;
    if (lineType === "addition") s.additionLines.push(line);
    else s.deletionLines.push(line);
    const contentIndex = $e6197aea3722697f$var$appendChangeLine(hunk, lineType, additionLineIndex, deletionLineIndex);
    if (lineType === "addition") {
        hunk.additionCount++;
        hunk.additionLines++;
    } else {
        hunk.deletionCount++;
        hunk.deletionLines++;
    }
    $e6197aea3722697f$var$assignConflictContent(s, conflictIndex, role, contentIndex);
}
function $e6197aea3722697f$var$finalizeConflict(s, frame, endLineIndex, endMarkerLine) {
    if (frame.separatorLineIndex == null || frame.markerLines.separator == null) throw new Error(`parseMergeConflictDiffFromFile: conflict ${frame.conflictIndex} is missing a separator marker`);
    const builder = s.conflictBuilders[frame.conflictIndex];
    if (builder == null) throw new Error(`parseMergeConflictDiffFromFile: failed to finalize conflict ${frame.conflictIndex}`);
    const action = builder.action;
    action.markerLines.separator = frame.markerLines.separator;
    action.markerLines.end = endMarkerLine;
    if (frame.markerLines.base != null) action.markerLines.base = frame.markerLines.base;
    action.conflict = {
        conflictIndex: frame.conflictIndex,
        startLineIndex: frame.startLineIndex,
        startLineNumber: frame.startLineIndex + 1,
        separatorLineIndex: frame.separatorLineIndex,
        separatorLineNumber: frame.separatorLineIndex + 1,
        endLineIndex: endLineIndex,
        endLineNumber: endLineIndex + 1,
        baseMarkerLineIndex: frame.baseMarkerLineIndex,
        baseMarkerLineNumber: frame.baseMarkerLineIndex != null ? frame.baseMarkerLineIndex + 1 : void 0
    };
    const fallbackContentIndex = action.currentContentIndex ?? action.incomingContentIndex;
    action.currentContentIndex ??= fallbackContentIndex;
    action.incomingContentIndex ??= fallbackContentIndex;
    if (action.startContentIndex < 0 && fallbackContentIndex != null) action.startContentIndex = fallbackContentIndex;
    if (action.endContentIndex < 0 && fallbackContentIndex != null) action.endContentIndex = fallbackContentIndex;
    if (action.endMarkerContentIndex < 0 && fallbackContentIndex != null) action.endMarkerContentIndex = fallbackContentIndex;
    if (action.hunkIndex < 0 || action.startContentIndex < 0 || action.endContentIndex < 0 || action.endMarkerContentIndex < 0) throw new Error(`parseMergeConflictDiffFromFile: failed to anchor merge conflict ${frame.conflictIndex}`);
    s.actions[action.conflictIndex] = action;
    builder.completed = true;
}
function $e6197aea3722697f$var$handleStartMarker(s, line, lineIndex) {
    const conflictIndex = s.nextConflictIndex;
    s.nextConflictIndex++;
    s.conflictStack.push({
        conflictIndex: conflictIndex,
        stage: "current",
        startLineIndex: lineIndex,
        markerLines: {
            start: line
        }
    });
    s.conflictBuilders[conflictIndex] = {
        completed: false,
        action: {
            conflict: {
                conflictIndex: conflictIndex,
                startLineIndex: lineIndex,
                startLineNumber: lineIndex + 1,
                separatorLineIndex: lineIndex,
                separatorLineNumber: lineIndex + 1,
                endLineIndex: lineIndex,
                endLineNumber: lineIndex + 1,
                baseMarkerLineIndex: void 0,
                baseMarkerLineNumber: void 0
            },
            conflictIndex: conflictIndex,
            hunkIndex: -1,
            startContentIndex: -1,
            endContentIndex: -1,
            endMarkerContentIndex: -1,
            markerLines: {
                start: line,
                separator: "",
                end: ""
            }
        }
    };
}
function $e6197aea3722697f$var$createHunkBuilder(additionStart, deletionStart) {
    return {
        additionStart: additionStart,
        deletionStart: deletionStart,
        additionCount: 0,
        deletionCount: 0,
        additionLines: 0,
        deletionLines: 0,
        additionLineIndex: Math.max(additionStart - 1, 0),
        deletionLineIndex: Math.max(deletionStart - 1, 0),
        hunkContent: [],
        contextBufferAdditionStart: Math.max(additionStart - 1, 0),
        contextBufferDeletionStart: Math.max(deletionStart - 1, 0),
        contextBufferCount: 0,
        contextBufferBaseConflicts: void 0
    };
}
function $e6197aea3722697f$var$formatHunkRange(start, count) {
    return count === 1 ? `${start}` : `${start},${count}`;
}
function $e6197aea3722697f$var$getMergeConflictMarkerType(line) {
    if (line.length < 7) return;
    const markerCode = line.charCodeAt(0);
    if (markerCode !== 60 && markerCode !== 62 && markerCode !== 61 && markerCode !== 124) return;
    const lineEnd = $e6197aea3722697f$var$getLineContentEndIndex(line);
    if (lineEnd < 7) return;
    let markerLength = 1;
    while(markerLength < lineEnd && line.charCodeAt(markerLength) === markerCode)markerLength++;
    if (markerLength < 7) return;
    if (markerCode === 61) return markerLength === lineEnd ? "separator" : void 0;
    if (markerLength !== lineEnd && !$e6197aea3722697f$var$isWhitespaceCode(line.charCodeAt(markerLength))) return;
    if (markerCode === 60) return "start";
    if (markerCode === 62) return "end";
    return "base";
}
function $e6197aea3722697f$var$getLineContentEndIndex(line) {
    let end = line.length;
    if (end > 0 && line.charCodeAt(end - 1) === 10) end--;
    if (end > 0 && line.charCodeAt(end - 1) === 13) end--;
    return end;
}
function $e6197aea3722697f$var$isWhitespaceCode(code) {
    return code === 9 || code === 10 || code === 11 || code === 12 || code === 13 || code === 32;
}
function $e6197aea3722697f$var$createResolvedConflictFile(file, side, contents) {
    return {
        ...file,
        contents: contents,
        cacheKey: file.cacheKey != null ? `${file.cacheKey}:merge-conflict-${side}` : void 0
    };
}
function $e6197aea3722697f$export$af9cb54b9c988fc6(fileDiff, actions) {
    const markerRows = [];
    const hunkLineStartCache = new Array(fileDiff.hunks.length);
    const getLineStart = (hunkIndex, contentIndex)=>{
        const hunk = fileDiff.hunks[hunkIndex];
        if (hunk == null) return 0;
        let starts = hunkLineStartCache[hunkIndex];
        if (starts == null) {
            starts = new Array(hunk.hunkContent.length + 1);
            let lineIndex = hunk.unifiedLineStart;
            starts[0] = lineIndex;
            for(let index = 0; index < hunk.hunkContent.length; index++){
                const content = hunk.hunkContent[index];
                lineIndex += content.type === "context" ? content.lines : content.deletions + content.additions;
                starts[index + 1] = lineIndex;
            }
            hunkLineStartCache[hunkIndex] = starts;
        }
        return starts[Math.max(contentIndex, 0)] ?? hunk.unifiedLineStart;
    };
    const getLineEnd = (hunkIndex, contentIndex)=>{
        const lineStart = getLineStart(hunkIndex, contentIndex);
        const lineEndExclusive = hunkLineStartCache[hunkIndex]?.[Math.max(contentIndex + 1, 0)] ?? getLineStart(hunkIndex, contentIndex + 1);
        return Math.max(lineStart, lineEndExclusive - 1);
    };
    for (const action of actions){
        if (action == null) continue;
        const hunk = fileDiff.hunks[action.hunkIndex];
        if (hunk == null) continue;
        const actionLineIndex = getLineStart(action.hunkIndex, action.startContentIndex);
        markerRows.push($e6197aea3722697f$var$createMergeConflictMarkerRow(action, "marker-start", action.startContentIndex, action.markerLines.start, actionLineIndex));
        if (action.baseContentIndex != null) {
            const currentContentIndex$1 = action.currentContentIndex;
            const incomingContentIndex = action.incomingContentIndex;
            if (currentContentIndex$1 == null || incomingContentIndex == null) continue;
            const baseMarkerLine = action.markerLines.base;
            if (baseMarkerLine == null) continue;
            const currentChange = hunk.hunkContent[currentContentIndex$1];
            const baseContext = hunk.hunkContent[action.baseContentIndex];
            const incomingChange = hunk.hunkContent[incomingContentIndex];
            if (currentChange?.type !== "change" || baseContext?.type !== "context" || incomingChange?.type !== "change") continue;
            const currentStart = getLineStart(action.hunkIndex, currentContentIndex$1);
            const incomingStart = getLineStart(action.hunkIndex, incomingContentIndex);
            markerRows.push($e6197aea3722697f$var$createMergeConflictMarkerRow(action, "marker-base", action.baseContentIndex, baseMarkerLine, currentStart + currentChange.deletions));
            markerRows.push($e6197aea3722697f$var$createMergeConflictMarkerRow(action, "marker-separator", action.baseContentIndex, action.markerLines.separator, incomingStart), $e6197aea3722697f$var$createMergeConflictMarkerRow(action, "marker-end", action.endMarkerContentIndex, action.markerLines.end, getLineEnd(action.hunkIndex, action.endMarkerContentIndex)));
            continue;
        }
        const currentContentIndex = action.currentContentIndex;
        if (currentContentIndex == null) continue;
        const content = hunk.hunkContent[currentContentIndex];
        if (content?.type !== "change") continue;
        const contentStart = getLineStart(action.hunkIndex, currentContentIndex);
        const separatorLineIndex = content.deletions > 0 ? contentStart + content.deletions : actionLineIndex;
        markerRows.push($e6197aea3722697f$var$createMergeConflictMarkerRow(action, "marker-separator", currentContentIndex, action.markerLines.separator, separatorLineIndex), $e6197aea3722697f$var$createMergeConflictMarkerRow(action, "marker-end", action.endMarkerContentIndex, action.markerLines.end, getLineEnd(action.hunkIndex, action.endMarkerContentIndex)));
    }
    return markerRows;
}
function $e6197aea3722697f$var$createMergeConflictMarkerRow(action, type, contentIndex, lineText, lineIndex) {
    return {
        type: type,
        hunkIndex: action.hunkIndex,
        contentIndex: contentIndex,
        conflictIndex: action.conflictIndex,
        lineText: lineText,
        lineIndex: lineIndex
    };
}
function $e6197aea3722697f$var$getUnifiedLineStartForContent(hunk, contentIndex) {
    let lineIndex = hunk.unifiedLineStart;
    for(let index = 0; index < contentIndex; index++){
        const content = hunk.hunkContent[index];
        lineIndex += content.type === "context" ? content.lines : content.deletions + content.additions;
    }
    return lineIndex;
}


//#region src/react/constants.ts
const $60116dac34141baf$export$64538652ceca3c8a = {
    position: "absolute",
    top: 0,
    bottom: 0,
    textAlign: "center",
    whiteSpace: "normal",
    touchAction: "none"
};
const $60116dac34141baf$export$9db05a6bdfd6b0fc = {
    display: "contents"
};
function $60116dac34141baf$export$45b326e4df8b4632() {
    return null;
}



//#region src/react/utils/renderDiffChildren.tsx
function $d72acda64073d2b6$export$2c383ee185e3e25e({ fileDiff: fileDiff, actions: actions, renderCustomHeader: renderCustomHeader, renderHeaderPrefix: renderHeaderPrefix, renderHeaderMetadata: renderHeaderMetadata, renderAnnotation: renderAnnotation, renderGutterUtility: renderGutterUtility, renderMergeConflictUtility: renderMergeConflictUtility, lineAnnotations: lineAnnotations, getHoveredLine: getHoveredLine, getInstance: getInstance }) {
    const customHeader = renderCustomHeader?.(fileDiff);
    const prefix = renderHeaderPrefix?.(fileDiff);
    const metadata = renderHeaderMetadata?.(fileDiff);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            customHeader != null ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: (0, $6986aac91971cc6d$export$87f913619cd5fa67),
                children: customHeader
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    prefix != null && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: (0, $6986aac91971cc6d$export$69d2d3bd52efd12a),
                        children: prefix
                    }),
                    metadata != null && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: (0, $6986aac91971cc6d$export$f5d94b4150f59afc),
                        children: metadata
                    })
                ]
            }),
            renderAnnotation != null && lineAnnotations?.map((annotation, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    slot: (0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation),
                    children: renderAnnotation(annotation)
                }, index)),
            actions != null && renderMergeConflictUtility != null && getInstance != null && actions.map((action)=>{
                if (action == null) return;
                const slot = $d72acda64073d2b6$var$getSlotName(action, fileDiff);
                return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    slot: slot,
                    style: (0, $60116dac34141baf$export$9db05a6bdfd6b0fc),
                    children: renderMergeConflictUtility(action, getInstance)
                }, slot);
            }),
            renderGutterUtility != null && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "gutter-utility-slot",
                style: (0, $60116dac34141baf$export$64538652ceca3c8a),
                children: renderGutterUtility(getHoveredLine)
            })
        ]
    });
}
function $d72acda64073d2b6$var$getSlotName(action, fileDiff) {
    const anchor = (0, $e6197aea3722697f$export$a1a4a4a6a830658e)(action, fileDiff);
    return anchor != null ? (0, $6df7d7d2e2865b86$export$2b59b4cecb579564)({
        hunkIndex: anchor.hunkIndex,
        lineIndex: anchor.lineIndex,
        conflictIndex: action.conflictIndex
    }) : void 0;
}






//#region src/react/utils/renderFileChildren.tsx
function $e5fd8d5ef1bc741e$export$26dd293a21f7d4d9({ file: file, renderCustomHeader: renderCustomHeader, renderHeaderPrefix: renderHeaderPrefix, renderHeaderMetadata: renderHeaderMetadata, renderAnnotation: renderAnnotation, lineAnnotations: lineAnnotations, renderGutterUtility: renderGutterUtility, getHoveredLine: getHoveredLine }) {
    const customHeader = renderCustomHeader?.(file);
    const prefix = renderHeaderPrefix?.(file);
    const metadata = renderHeaderMetadata?.(file);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            customHeader != null ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: (0, $6986aac91971cc6d$export$87f913619cd5fa67),
                children: customHeader
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    prefix != null && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: (0, $6986aac91971cc6d$export$69d2d3bd52efd12a),
                        children: prefix
                    }),
                    metadata != null && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: (0, $6986aac91971cc6d$export$f5d94b4150f59afc),
                        children: metadata
                    })
                ]
            }),
            renderAnnotation != null && lineAnnotations?.map((annotation, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    slot: (0, $ac9bb0f0aa61e1e0$export$3619c1a4d9651049)(annotation),
                    children: renderAnnotation(annotation)
                }, index)),
            renderGutterUtility != null && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "gutter-utility-slot",
                style: (0, $60116dac34141baf$export$64538652ceca3c8a),
                children: renderGutterUtility(getHoveredLine)
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
//#region src/react/utils/useStableCallback.ts
function $8441625c98d053f4$export$1a8b1350915fe2e0(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useInsertionEffect)(()=>void (callbackRef.current = callback));
    return (0, $acw62.useCallback)((...args)=>{
        return callbackRef.current(...args);
    }, []);
}


















//#region src/highlighter/languages/getResolvedLanguages.ts
function $b9896363026d98a2$export$2936a97d9a641b1b(languages) {
    const resolvedLanguages = [];
    for (const language of languages){
        const resolvedLanguage = (0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).get(language);
        if (resolvedLanguage == null) throw new Error(`getResolvedLanguages: ${language} is not resolved. Please resolve languages before calling getResolvedLanguages`);
        resolvedLanguages.push(resolvedLanguage);
    }
    return resolvedLanguages;
}



//#region src/highlighter/languages/hasResolvedLanguages.ts
function $8edae962e194c315$export$a2c631f93f61c29(languages) {
    for (const language of Array.isArray(languages) ? languages : [
        languages
    ])if (!(0, $afd67e7e9e3398b6$export$440dc6ff9aa62a31).has(language)) return false;
    return true;
}




//#region src/highlighter/languages/resolveLanguages.ts
async function $77b7dc915eb04ebf$export$61257669d85d8858(languages) {
    const resolvedLanguages = [];
    const languagesToResolve = [];
    for (const language of languages){
        if (language === "text" || language === "ansi") continue;
        const maybeResolvedLanguage = (0, $043fc06f42768105$export$4d019cfecfbb353a)(language) ?? (0, $d9d27917a97241a9$export$fd43f4122341a86b)(language);
        if ("then" in maybeResolvedLanguage) languagesToResolve.push(maybeResolvedLanguage);
        else resolvedLanguages.push(maybeResolvedLanguage);
    }
    if (languagesToResolve.length > 0) await Promise.all(languagesToResolve).then((_resolvedLanguages)=>{
        for (const resolvedLanguage of _resolvedLanguages){
            if (resolvedLanguage == null) throw new Error("resolvedLanguages: unable to resolve language");
            resolvedLanguages.push(resolvedLanguage);
        }
    });
    return resolvedLanguages;
}



//#region src/highlighter/themes/getResolvedThemes.ts
function $c97cc94942f48e8d$export$919d19fd06c3b39c(themeNames) {
    const resolvedThemes = [];
    for (const themeName of themeNames){
        const theme = (0, $e663a760095f022f$export$517305f1f1af691).get(themeName);
        if (theme == null) throw new Error(`getAllResolvedThemes: ${themeName} is unresolved, you must resolve all necessary themes before calling this function`);
        resolvedThemes.push(theme);
    }
    return resolvedThemes;
}




//#region src/highlighter/themes/resolveThemes.ts
async function $ac9dfd2c6a86320d$export$94455fe17f38f5a8(themes) {
    const resolvedThemes = [];
    const themesToResolve = [];
    for (const themeName of themes){
        const themeData = (0, $13ad887817b0c006$export$406f844df6312956)(themeName) ?? (0, $f14bbb1aa2411005$export$da5ffdb7039764e9)(themeName);
        if ("then" in themeData) themesToResolve.push(themeData);
        else resolvedThemes.push(themeData);
    }
    if (themesToResolve.length > 0) await Promise.all(themesToResolve).then((resolved)=>{
        for (const theme of resolved)if (theme != null) resolvedThemes.push(theme);
    });
    return resolvedThemes;
}


var $561b2d4dfe1535c8$exports = {};
!function(g, c) {
    c($561b2d4dfe1535c8$exports);
}($561b2d4dfe1535c8$exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});


//#region src/worker/WorkerPoolManager.ts
const $26a8b6f63b30fd2a$var$IGNORE_RESPONSE = Symbol("IGNORE_RESPONSE");
var $26a8b6f63b30fd2a$var$WorkerPoolTerminatedError = class extends Error {
    constructor(){
        super("WorkerPoolManager: operation canceled because the pool terminated");
    }
};
var $26a8b6f63b30fd2a$export$21289b88a997fd2 = class {
    highlighter;
    preferredHighlighter;
    renderOptions;
    renderOptionsVersion = 0;
    initialized = false;
    workers = [];
    queuedTasks = [];
    queuedTaskByInstance = /* @__PURE__ */ new Map();
    taskByHighlightKey = /* @__PURE__ */ new Map();
    activeTaskById = /* @__PURE__ */ new Map();
    activeRequestByInstance = /* @__PURE__ */ new Map();
    nextRequestId = 0;
    themeSubscribers = /* @__PURE__ */ new Set();
    workersFailed = false;
    statSubscribers = /* @__PURE__ */ new Set();
    fileCache;
    diffCache;
    _queuedBroadcast;
    lifecycleGeneration = 0;
    constructor(options, { langs: langs, theme: theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59), useTokenTransformer: useTokenTransformer = false, lineDiffType: lineDiffType = "word-alt", maxLineDiffLength: maxLineDiffLength = 1e3, tokenizeMaxLineLength: tokenizeMaxLineLength = 1e3, preferredHighlighter: preferredHighlighter = "shiki-js" }){
        this.options = options;
        this.preferredHighlighter = preferredHighlighter;
        this.renderOptions = {
            theme: theme,
            useTokenTransformer: useTokenTransformer,
            lineDiffType: lineDiffType,
            maxLineDiffLength: maxLineDiffLength,
            tokenizeMaxLineLength: tokenizeMaxLineLength
        };
        this.fileCache = new (0, (/*@__PURE__*/$parcel$interopDefault($561b2d4dfe1535c8$exports))).LRUMap(options.totalASTLRUCacheSize ?? 100);
        this.diffCache = new (0, (/*@__PURE__*/$parcel$interopDefault($561b2d4dfe1535c8$exports))).LRUMap(options.totalASTLRUCacheSize ?? 100);
        this.queueInitialization(langs);
    }
    isWorkingPool() {
        return !this.workersFailed;
    }
    getFileResultCache(file) {
        return file.cacheKey != null ? this.fileCache.get(file.cacheKey) : void 0;
    }
    getDiffResultCache(diff) {
        return diff.cacheKey != null ? this.diffCache.get(diff.cacheKey) : void 0;
    }
    inspectCaches() {
        const { fileCache: fileCache, diffCache: diffCache } = this;
        return {
            fileCache: fileCache,
            diffCache: diffCache
        };
    }
    evictFileFromCache(cacheKey) {
        try {
            return this.fileCache.delete(cacheKey) !== void 0;
        } finally{
            this.queueBroadcastStateChanges();
        }
    }
    evictDiffFromCache(cacheKey) {
        try {
            return this.diffCache.delete(cacheKey) !== void 0;
        } finally{
            this.queueBroadcastStateChanges();
        }
    }
    async setRenderOptions({ theme: theme = (0, $6986aac91971cc6d$export$bcfc57767d137a59), useTokenTransformer: useTokenTransformer = false, lineDiffType: lineDiffType = "word-alt", maxLineDiffLength: maxLineDiffLength = 1e3, tokenizeMaxLineLength: tokenizeMaxLineLength = 1e3 }) {
        const { lifecycleGeneration: lifecycleGeneration } = this;
        try {
            const newRenderOptions = {
                theme: theme,
                useTokenTransformer: useTokenTransformer,
                lineDiffType: lineDiffType,
                maxLineDiffLength: maxLineDiffLength,
                tokenizeMaxLineLength: tokenizeMaxLineLength
            };
            if (!this.isInitialized()) await this.initialize();
            if (!this.isCurrentLifecycle(lifecycleGeneration) || (0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(newRenderOptions, this.renderOptions)) return;
            const themeNames = (0, $1aa1190ca9b15e96$export$a11593be0c51d6a7)(theme);
            let resolvedThemes = [];
            if (!(0, $0246eee5e18b0420$export$e40448283aec01f1)(newRenderOptions.theme, this.renderOptions.theme)) {
                if ((0, $bf2dbe218dfe08c0$export$94034355ed3693a6)(themeNames)) resolvedThemes = (0, $c97cc94942f48e8d$export$919d19fd06c3b39c)(themeNames);
                else resolvedThemes = await (0, $ac9dfd2c6a86320d$export$94455fe17f38f5a8)(themeNames);
            }
            if (!this.isCurrentLifecycle(lifecycleGeneration)) return;
            if (this.highlighter != null) {
                (0, $b5e7a3dd7253d51b$export$3bf43cacd1a90d16)(resolvedThemes, this.highlighter);
                await this.setRenderOptionsOnWorkers(newRenderOptions, resolvedThemes);
            } else {
                const [highlighter] = await Promise.all([
                    (0, $5038ef2223d0d43d$export$3ae4f582c943284e)({
                        themes: themeNames,
                        langs: [
                            "text"
                        ],
                        preferredHighlighter: this.preferredHighlighter
                    }),
                    this.setRenderOptionsOnWorkers(newRenderOptions, resolvedThemes)
                ]);
                if (!this.isCurrentLifecycle(lifecycleGeneration)) return;
                this.highlighter = highlighter;
            }
            if (!this.isCurrentLifecycle(lifecycleGeneration)) return;
            this.renderOptions = newRenderOptions;
            this.renderOptionsVersion++;
            this.diffCache.clear();
            this.fileCache.clear();
            for (const instance of this.themeSubscribers)instance.rerender();
        } catch (error) {
            if (error instanceof $26a8b6f63b30fd2a$var$WorkerPoolTerminatedError || !this.isCurrentLifecycle(lifecycleGeneration)) return;
            throw error;
        }
    }
    getFileRenderOptions() {
        const { tokenizeMaxLineLength: tokenizeMaxLineLength, theme: theme, useTokenTransformer: useTokenTransformer } = this.renderOptions;
        return {
            theme: theme,
            useTokenTransformer: useTokenTransformer,
            tokenizeMaxLineLength: tokenizeMaxLineLength
        };
    }
    getDiffRenderOptions() {
        return {
            ...this.renderOptions
        };
    }
    async setRenderOptionsOnWorkers(renderOptions, resolvedThemes) {
        if (this.workersFailed) return;
        if (!this.isInitialized()) await this.initialize();
        const taskPromises = [];
        for (const managedWorker of this.workers){
            if (!managedWorker.initialized) {
                console.log({
                    managedWorker: managedWorker
                });
                throw new Error("setRenderOptionsOnWorkers: Somehow we have an uninitialized worker");
            }
            taskPromises.push(new Promise((resolve, reject)=>{
                const id = this.generateRequestId();
                const task = {
                    type: "set-render-options",
                    id: id,
                    request: {
                        type: "set-render-options",
                        id: id,
                        renderOptions: renderOptions,
                        resolvedThemes: resolvedThemes
                    },
                    resolve: resolve,
                    reject: reject,
                    requestStart: Date.now()
                };
                this.activeTaskById.set(id, task);
                managedWorker.worker.postMessage(task.request);
            }));
        }
        await Promise.all(taskPromises);
    }
    subscribeToThemeChanges(instance) {
        this.themeSubscribers.add(instance);
        this.queueBroadcastStateChanges();
        return ()=>{
            this.unsubscribeToThemeChanges(instance);
            this.queueBroadcastStateChanges();
        };
    }
    unsubscribeToThemeChanges(instance) {
        this.themeSubscribers.delete(instance);
        this.queueBroadcastStateChanges();
    }
    subscribeToStatChanges(callback) {
        this.statSubscribers.add(callback);
        callback(this.getStats());
        return ()=>{
            this.statSubscribers.delete(callback);
        };
    }
    queueBroadcastStateChanges() {
        if (this._queuedBroadcast != null) return;
        this._queuedBroadcast = requestAnimationFrame(this._broadcastStateChanges);
    }
    _broadcastStateChanges = ()=>{
        if (this._queuedBroadcast != null) {
            cancelAnimationFrame(this._queuedBroadcast);
            this._queuedBroadcast = void 0;
        }
        const stats = this.getStats();
        for (const callback of this.statSubscribers)callback(stats);
    };
    cleanUpTasks(instance) {
        this.detachInstanceFromQueuedTasks(instance);
        const requestId = this.activeRequestByInstance.get(instance);
        if (requestId != null) {
            const task = this.activeTaskById.get(requestId);
            if ($26a8b6f63b30fd2a$var$isRenderTask(task)) {
                this.detachInstanceFromRenderTask(task, instance);
                if (!task.primeCache && task.instances.size === 0) this.removeActiveTask(task);
            } else this.activeTaskById.delete(requestId);
        }
        this.activeRequestByInstance.delete(instance);
        this.queueBroadcastStateChanges();
    }
    isInitialized() {
        return this.initialized === true;
    }
    async initialize(languages = []) {
        if (this.initialized === true) return;
        else if (this.initialized === false) {
            const { lifecycleGeneration: lifecycleGeneration } = this;
            this.initialized = new Promise((resolve, reject)=>{
                (async ()=>{
                    try {
                        const themes = (0, $1aa1190ca9b15e96$export$a11593be0c51d6a7)(this.renderOptions.theme);
                        let resolvedThemes = [];
                        if ((0, $bf2dbe218dfe08c0$export$94034355ed3693a6)(themes)) resolvedThemes = (0, $c97cc94942f48e8d$export$919d19fd06c3b39c)(themes);
                        else resolvedThemes = await (0, $ac9dfd2c6a86320d$export$94455fe17f38f5a8)(themes);
                        if (!this.isCurrentLifecycle(lifecycleGeneration)) {
                            resolve();
                            return;
                        }
                        let resolvedLanguages = [];
                        if ((0, $8edae962e194c315$export$a2c631f93f61c29)(languages)) resolvedLanguages = (0, $b9896363026d98a2$export$2936a97d9a641b1b)(languages);
                        else resolvedLanguages = await (0, $77b7dc915eb04ebf$export$61257669d85d8858)(languages);
                        if (!this.isCurrentLifecycle(lifecycleGeneration)) {
                            resolve();
                            return;
                        }
                        const [highlighter] = await Promise.all([
                            (0, $5038ef2223d0d43d$export$3ae4f582c943284e)({
                                themes: themes,
                                langs: [
                                    "text",
                                    ...languages
                                ],
                                preferredHighlighter: this.preferredHighlighter
                            }),
                            this.initializeWorkers(resolvedThemes, resolvedLanguages)
                        ]);
                        if (!this.isCurrentLifecycle(lifecycleGeneration)) {
                            this.terminateWorkers();
                            resolve();
                            return;
                        }
                        this.highlighter = highlighter;
                        this.initialized = true;
                        this.diffCache.clear();
                        this.fileCache.clear();
                        this.drainQueue();
                        this.queueBroadcastStateChanges();
                        resolve();
                    } catch (e) {
                        if (e instanceof $26a8b6f63b30fd2a$var$WorkerPoolTerminatedError || !this.isCurrentLifecycle(lifecycleGeneration)) {
                            resolve();
                            return;
                        }
                        this.initialized = false;
                        this.workersFailed = true;
                        this.queueBroadcastStateChanges();
                        reject(e);
                    }
                })();
            });
            this.queueBroadcastStateChanges();
        } else return this.initialized;
    }
    async initializeWorkers(resolvedThemes, resolvedLanguages) {
        this.workersFailed = false;
        const initPromises = [];
        const customExtensionVersion = (0, $350fbdca8afa0197$export$57722d6cacc4c14b)();
        const customExtensionMap = customExtensionVersion > 0 ? (0, $350fbdca8afa0197$export$d97a82fa7de98085)() : void 0;
        if (this.workers.length > 0) this.terminateWorkers();
        for(let i = 0; i < (this.options.poolSize ?? 8); i++){
            const worker = this.options.workerFactory();
            const managedWorker = {
                worker: worker,
                request_id: void 0,
                initialized: false,
                langs: new Set([
                    "text",
                    ...resolvedLanguages.map(({ name: name })=>name)
                ]),
                customExtensionsVersion: 0
            };
            worker.addEventListener("message", (event)=>{
                this.handleWorkerMessage(managedWorker, event.data);
            });
            worker.addEventListener("error", (error)=>console.error("Worker error:", error, managedWorker));
            this.workers.push(managedWorker);
            initPromises.push(new Promise((resolve, reject)=>{
                const id = this.generateRequestId();
                const task = {
                    type: "initialize",
                    id: id,
                    request: {
                        type: "initialize",
                        id: id,
                        renderOptions: this.renderOptions,
                        preferredHighlighter: this.preferredHighlighter,
                        resolvedThemes: resolvedThemes,
                        resolvedLanguages: resolvedLanguages,
                        customExtensionsVersion: customExtensionMap != null ? customExtensionVersion : void 0,
                        customExtensionMap: customExtensionMap
                    },
                    resolve () {
                        managedWorker.initialized = true;
                        resolve();
                    },
                    reject: reject,
                    requestStart: Date.now()
                };
                this.activeTaskById.set(id, task);
                this.executeTask(managedWorker, task);
            }));
        }
        await Promise.all(initPromises);
    }
    drainQueue = ()=>{
        this._queuedDrain = void 0;
        if (this.initialized !== true || this.queuedTasks.length === 0) return;
        for(let i = 0; i < this.queuedTasks.length;){
            const task = this.queuedTasks[i];
            if (this.hasActiveRequest(task)) {
                i++;
                continue;
            }
            const langs = $26a8b6f63b30fd2a$var$getLangsFromTask(task);
            const availableWorker = this.getAvailableWorker(langs);
            if (availableWorker == null) break;
            this.queuedTasks.splice(i, 1);
            this.assignWorkerToTask(task, availableWorker);
            this.resolveLanguagesAndExecuteTask(availableWorker, task, langs);
        }
        this.queueBroadcastStateChanges();
    };
    highlightFileAST(instance, file) {
        const cachedResult = this.getFileResultCache(file);
        if ((0, $15de751b18238005$export$4d513fdf32c04fe0)(file) || cachedResult != null && (0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(cachedResult.options, this.getFileRenderOptions())) return;
        if (!this.hasMatchingFileInstanceTask(instance, file)) this.submitTask(instance, {
            type: "file",
            file: file
        });
    }
    primeFileHighlightCache(file) {
        if (file.cacheKey == null) {
            console.warn(`WorkerPoolManager.primeFileHighlightCache: priming highlight cache requires file.cacheKey; skipping "${file.name}".`);
            return;
        }
        const cachedResult = this.getFileResultCache(file);
        const highlightKey = this.getFileHighlightKey(file);
        if (highlightKey == null || (0, $15de751b18238005$export$4d513fdf32c04fe0)(file) || cachedResult != null && (0, $9739dc975c8bf830$export$9edcb29d52fcb8e5)(cachedResult.options, this.getFileRenderOptions())) return;
        const existingTask = this.getTaskByHighlightKey(highlightKey);
        if (existingTask != null) existingTask.primeCache = true;
        else this.submitCacheTask({
            type: "file",
            file: file
        }, highlightKey);
    }
    getPlainFileAST(file, startingLine, totalLines, lines) {
        if (this.highlighter == null) {
            this.queueInitialization();
            return;
        }
        return (0, $64eb39638c0b85af$export$b0a36636bcffa870)(file, this.highlighter, this.renderOptions, {
            forcePlainText: true,
            startingLine: startingLine,
            totalLines: totalLines,
            lines: lines
        });
    }
    highlightDiffAST(instance, diff) {
        const cachedResult = this.getDiffResultCache(diff);
        if ((0, $ac8a37f5a3c58257$export$e92605dcb43e76fc)(diff) || cachedResult != null && (0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(cachedResult.options, this.getDiffRenderOptions())) return;
        if (!this.hasMatchingDiffInstanceTask(instance, diff)) this.submitTask(instance, {
            type: "diff",
            diff: diff
        });
    }
    primeDiffHighlightCache(diff) {
        if (diff.cacheKey == null) {
            console.warn(`WorkerPoolManager.primeDiffHighlightCache: priming highlight cache requires diff.cacheKey; skipping "${diff.prevName ?? diff.name}" -> "${diff.name}".`);
            return;
        }
        const cachedResult = this.getDiffResultCache(diff);
        const highlightKey = this.getDiffHighlightKey(diff);
        if (highlightKey == null || (0, $ac8a37f5a3c58257$export$e92605dcb43e76fc)(diff) || cachedResult != null && (0, $f47ec40e1ade4b8f$export$2234c8b26b4dfe19)(cachedResult.options, this.getDiffRenderOptions())) return;
        const existingTask = this.getTaskByHighlightKey(highlightKey);
        if (existingTask != null) existingTask.primeCache = true;
        else this.submitCacheTask({
            type: "diff",
            diff: diff
        }, highlightKey);
    }
    getPlainDiffAST(diff, startingLine, totalLines, expandedHunks, collapsedContextThreshold) {
        return this.highlighter != null ? (0, $688ba6849a1df22e$export$bb1e2b1b9fe7b5e)(diff, this.highlighter, this.renderOptions, {
            forcePlainText: true,
            startingLine: startingLine,
            totalLines: totalLines,
            expandedHunks: expandedHunks,
            collapsedContextThreshold: collapsedContextThreshold
        }) : void 0;
    }
    terminate() {
        this.lifecycleGeneration++;
        this.cancelActiveWorkerTasks();
        this.terminateWorkers();
        this.fileCache.clear();
        this.diffCache.clear();
        this.activeRequestByInstance.clear();
        this.queuedTasks.length = 0;
        this.queuedTaskByInstance.clear();
        this.taskByHighlightKey.clear();
        this.activeTaskById.clear();
        this.highlighter = void 0;
        this.initialized = false;
        this.workersFailed = false;
        this.queueBroadcastStateChanges();
    }
    isCurrentLifecycle(lifecycleGeneration) {
        return this.lifecycleGeneration === lifecycleGeneration;
    }
    queueInitialization(languages) {
        this.initialize(languages).catch((error)=>{
            console.error(error);
        });
    }
    cancelActiveWorkerTasks() {
        const error = new $26a8b6f63b30fd2a$var$WorkerPoolTerminatedError();
        for (const task of this.activeTaskById.values())if ("reject" in task) task.reject(error);
    }
    terminateWorkers() {
        for (const managedWorker of this.workers)managedWorker.worker.terminate();
        this.workers.length = 0;
    }
    getStats() {
        return {
            managerState: (()=>{
                if (this.initialized === false) return "waiting";
                if (this.initialized !== true) return "initializing";
                return "initialized";
            })(),
            totalWorkers: this.workers.length,
            workersFailed: this.workersFailed,
            busyWorkers: this.workers.filter((w)=>w.request_id != null).length,
            queuedTasks: this.queuedTasks.length,
            activeTasks: this.activeTaskById.size,
            themeSubscribers: this.themeSubscribers.size,
            fileCacheSize: this.fileCache.size,
            diffCacheSize: this.diffCache.size
        };
    }
    submitTask(instance, request) {
        if (this.initialized === false) this.queueInitialization();
        const highlightKey = this.getHighlightKeyForRequest(request);
        const existingTask = highlightKey != null ? this.getTaskByHighlightKey(highlightKey) : void 0;
        if (existingTask != null) {
            this.detachInstanceFromQueuedTasks(instance, existingTask);
            this.addInstanceToTask(existingTask, instance);
            this.queueBroadcastStateChanges();
            return;
        }
        this.detachInstanceFromQueuedTasks(instance);
        const id = this.generateRequestId();
        const requestStart = Date.now();
        const task = (()=>{
            switch(request.type){
                case "file":
                    return {
                        type: "file",
                        id: id,
                        request: {
                            ...request,
                            id: id
                        },
                        instances: new Set([
                            instance
                        ]),
                        primeCache: false,
                        highlightKey: highlightKey,
                        requestStart: requestStart
                    };
                case "diff":
                    return {
                        type: "diff",
                        id: id,
                        request: {
                            ...request,
                            id: id
                        },
                        instances: new Set([
                            instance
                        ]),
                        primeCache: false,
                        highlightKey: highlightKey,
                        requestStart: requestStart
                    };
            }
        })();
        this.enqueueRenderTask(task, instance);
    }
    submitCacheTask(request, highlightKey) {
        if (this.initialized === false) this.queueInitialization();
        const id = this.generateRequestId();
        const requestStart = Date.now();
        const task = (()=>{
            switch(request.type){
                case "file":
                    return {
                        type: "file",
                        id: id,
                        request: {
                            ...request,
                            id: id
                        },
                        instances: /* @__PURE__ */ new Set(),
                        primeCache: true,
                        highlightKey: highlightKey,
                        requestStart: requestStart
                    };
                case "diff":
                    return {
                        type: "diff",
                        id: id,
                        request: {
                            ...request,
                            id: id
                        },
                        instances: /* @__PURE__ */ new Set(),
                        primeCache: true,
                        highlightKey: highlightKey,
                        requestStart: requestStart
                    };
            }
        })();
        this.enqueueRenderTask(task);
    }
    enqueueRenderTask(task, instance) {
        this.queuedTasks.push(task);
        if (instance != null) this.queuedTaskByInstance.set(instance, task);
        if (task.highlightKey != null) this.taskByHighlightKey.set(task.highlightKey, task);
        this.queueDrain();
    }
    async resolveLanguagesAndExecuteTask(availableWorker, task, langs) {
        try {
            const workerMissingLangs = langs.filter((lang)=>!availableWorker.langs.has(lang));
            if (workerMissingLangs.length > 0) {
                if ((0, $8edae962e194c315$export$a2c631f93f61c29)(workerMissingLangs)) task.request.resolvedLanguages = (0, $b9896363026d98a2$export$2936a97d9a641b1b)(workerMissingLangs);
                else task.request.resolvedLanguages = await (0, $77b7dc915eb04ebf$export$61257669d85d8858)(workerMissingLangs);
            }
            if (!this.activeTaskById.has(task.id)) {
                if (availableWorker.request_id === task.id) {
                    this.cleanWorkerAndTask(availableWorker, task);
                    this.queueBroadcastStateChanges();
                    if (this.queuedTasks.length > 0) this.queueDrain();
                }
                return;
            }
            this.executeTask(availableWorker, task);
        } catch  {
            this.cleanWorkerAndTask(availableWorker, task);
            this.queueBroadcastStateChanges();
            if (this.queuedTasks.length > 0) this.queueDrain();
        }
    }
    handleWorkerMessage(managedWorker, response) {
        const task = this.activeTaskById.get(response.id);
        try {
            if (task == null) throw $26a8b6f63b30fd2a$var$IGNORE_RESPONSE;
            else if (response.type === "error") {
                const error = new Error(response.error);
                if (response.stack) error.stack = response.stack;
                if ("reject" in task) task.reject(error);
                else if ($26a8b6f63b30fd2a$var$isRenderTask(task)) this.notifyHighlightError(task, error);
                else throw new Error("handleWorkerMessage: unknown task type");
                throw error;
            } else switch(response.requestType){
                case "initialize":
                    if (task.type !== "initialize") throw new Error("handleWorkerMessage: task/response dont match");
                    this.syncCustomExtensionVersion(managedWorker, task.request);
                    task.resolve();
                    break;
                case "set-render-options":
                    if (task.type !== "set-render-options") throw new Error("handleWorkerMessage: task/response dont match");
                    task.resolve();
                    break;
                case "file":
                    {
                        if (task.type !== "file") throw new Error("handleWorkerMessage: task/response dont match");
                        const { result: result, options: options } = response;
                        const { request: request } = task;
                        this.syncCustomExtensionVersion(managedWorker, request);
                        if (request.file.cacheKey != null) this.fileCache.set(request.file.cacheKey, {
                            result: result,
                            options: options
                        });
                        this.notifyFileInstances(task, result, options);
                        break;
                    }
                case "diff":
                    {
                        if (task.type !== "diff") throw new Error("handleWorkerMessage: task/response dont match");
                        const { result: result, options: options } = response;
                        const { request: request } = task;
                        this.syncCustomExtensionVersion(managedWorker, request);
                        if (request.diff.cacheKey != null) this.diffCache.set(request.diff.cacheKey, {
                            result: result,
                            options: options
                        });
                        this.notifyDiffInstances(task, result, options);
                        break;
                    }
            }
        } catch (error) {
            if (error !== $26a8b6f63b30fd2a$var$IGNORE_RESPONSE) console.error(error, task, response);
        }
        this.cleanWorkerAndTask(managedWorker, task);
        this.queueBroadcastStateChanges();
        if (this.queuedTasks.length > 0) this.queueDrain();
    }
    _queuedDrain;
    queueDrain() {
        if (this._queuedDrain != null) return;
        this._queuedDrain = Promise.resolve().then(this.drainQueue);
        this.queueBroadcastStateChanges();
    }
    assignWorkerToTask(task, managedWorker) {
        managedWorker.request_id = task.id;
        if ($26a8b6f63b30fd2a$var$isRenderTask(task)) {
            this.clearQueuedInstanceRequests(task);
            this.trackInstanceRequests(task);
        }
        this.activeTaskById.set(task.id, task);
    }
    cleanWorkerAndTask(managedWorker, task) {
        managedWorker.request_id = void 0;
        if (task != null) {
            if ($26a8b6f63b30fd2a$var$isRenderTask(task)) {
                this.clearInstanceRequests(task);
                this.clearHighlightKey(task);
            }
            this.activeTaskById.delete(task.id);
        }
    }
    executeTask(managedWorker, task) {
        if ($26a8b6f63b30fd2a$var$shouldSyncCustomExtensions(task.request)) this.maybeAttachCustomExtensions(managedWorker, task.request);
        if (!this.activeTaskById.has(task.id)) this.assignWorkerToTask(task, managedWorker);
        for (const lang of $26a8b6f63b30fd2a$var$getLangsFromTask(task))managedWorker.langs.add(lang);
        try {
            managedWorker.worker.postMessage(task.request);
        } catch (error) {
            console.error("Failed to post message to worker:", error);
            if ($26a8b6f63b30fd2a$var$isRenderTask(task)) this.notifyHighlightError(task, error);
            else if ("reject" in task) task.reject(error);
            this.cleanWorkerAndTask(managedWorker, task);
            if (this.queuedTasks.length > 0) this.queueDrain();
        }
        this.queueBroadcastStateChanges();
    }
    maybeAttachCustomExtensions(managedWorker, request) {
        if (request.customExtensionsVersion != null) return;
        const version = (0, $350fbdca8afa0197$export$57722d6cacc4c14b)();
        if (managedWorker.customExtensionsVersion >= version) return;
        request.customExtensionsVersion = version;
        request.customExtensionMap = (0, $350fbdca8afa0197$export$d97a82fa7de98085)();
    }
    syncCustomExtensionVersion(managedWorker, request) {
        if (request.customExtensionsVersion == null) return;
        managedWorker.customExtensionsVersion = request.customExtensionsVersion;
    }
    getAvailableWorker(langs) {
        let worker;
        for (const managedWorker of this.workers){
            if (managedWorker.request_id != null || !managedWorker.initialized) continue;
            worker = managedWorker;
            if (langs.length === 0) break;
            let hasEveryLang = true;
            for (const lang of langs)if (!managedWorker.langs.has(lang)) {
                hasEveryLang = false;
                break;
            }
            if (hasEveryLang) break;
        }
        return worker;
    }
    getFileHighlightKey(file) {
        if (file.cacheKey == null) return;
        return `file:${file.cacheKey}:${this.renderOptionsVersion}`;
    }
    getDiffHighlightKey(diff) {
        if (diff.cacheKey == null) return;
        return `diff:${diff.cacheKey}:${this.renderOptionsVersion}`;
    }
    getHighlightKeyForRequest(request) {
        switch(request.type){
            case "file":
                return this.getFileHighlightKey(request.file);
            case "diff":
                return this.getDiffHighlightKey(request.diff);
        }
    }
    hasActiveRequest(task) {
        for (const instance of $26a8b6f63b30fd2a$var$getInstances(task))if (this.activeRequestByInstance.has(instance)) return true;
        return false;
    }
    addInstanceToTask(task, instance) {
        if (task.type === "file") task.instances.add(instance);
        else task.instances.add(instance);
        if (this.activeTaskById.has(task.id)) this.activeRequestByInstance.set(instance, task.id);
        else this.queuedTaskByInstance.set(instance, task);
    }
    detachInstanceFromQueuedTasks(instance, exceptTask) {
        const task = this.queuedTaskByInstance.get(instance);
        if (task == null || task === exceptTask) return;
        this.queuedTaskByInstance.delete(instance);
        this.detachInstanceFromRenderTask(task, instance);
        if (!task.primeCache && task.instances.size === 0) this.removeQueuedTask(task);
    }
    detachInstanceFromRenderTask(task, instance) {
        if (task.type === "file") task.instances.delete(instance);
        else task.instances.delete(instance);
    }
    removeQueuedTask(task) {
        const index = this.queuedTasks.indexOf(task);
        if (index !== -1) this.queuedTasks.splice(index, 1);
        this.clearQueuedInstanceRequests(task);
        this.clearHighlightKey(task);
    }
    removeActiveTask(task) {
        this.clearInstanceRequests(task);
        this.clearHighlightKey(task);
        this.activeTaskById.delete(task.id);
    }
    clearQueuedInstanceRequests(task) {
        for (const instance of $26a8b6f63b30fd2a$var$getInstances(task))if (this.queuedTaskByInstance.get(instance) === task) this.queuedTaskByInstance.delete(instance);
    }
    clearHighlightKey(task) {
        if (task.highlightKey != null && this.taskByHighlightKey.get(task.highlightKey) === task) this.taskByHighlightKey.delete(task.highlightKey);
    }
    trackInstanceRequests(task) {
        for (const instance of $26a8b6f63b30fd2a$var$getInstances(task))this.activeRequestByInstance.set(instance, task.id);
    }
    clearInstanceRequests(task) {
        for (const instance of $26a8b6f63b30fd2a$var$getInstances(task))if (this.activeRequestByInstance.get(instance) === task.id) this.activeRequestByInstance.delete(instance);
    }
    notifyFileInstances(task, result, options) {
        for (const instance of task.instances)if (this.activeRequestByInstance.get(instance) === task.id) instance.onHighlightSuccess(task.request.file, result, options);
    }
    notifyDiffInstances(task, result, options) {
        for (const instance of task.instances)if (this.activeRequestByInstance.get(instance) === task.id) instance.onHighlightSuccess(task.request.diff, result, options);
    }
    notifyHighlightError(task, error) {
        for (const instance of $26a8b6f63b30fd2a$var$getInstances(task))if (this.activeRequestByInstance.get(instance) === task.id) instance.onHighlightError(error);
    }
    hasMatchingFileInstanceTask(instance, file) {
        for (const task of this.iterateRenderTasks())if (task.type === "file" && task.instances.has(instance) && (0, $2f249b89688d7794$export$66ae137c56162891)(file, task.request.file)) return true;
        return false;
    }
    hasMatchingDiffInstanceTask(instance, diff) {
        for (const task of this.iterateRenderTasks())if (task.type === "diff" && task.instances.has(instance) && (0, $dba1055e9d278b35$export$3ad525473176feb1)(task.request.diff, diff)) return true;
        return false;
    }
    getTaskByHighlightKey(highlightKey) {
        return this.taskByHighlightKey.get(highlightKey);
    }
    *iterateRenderTasks() {
        for (const task of this.queuedTasks)yield task;
        for (const task of this.activeTaskById.values())if ($26a8b6f63b30fd2a$var$isRenderTask(task)) yield task;
    }
    generateRequestId() {
        return `req_${++this.nextRequestId}`;
    }
};
function $26a8b6f63b30fd2a$var$shouldSyncCustomExtensions(request) {
    return request.type === "initialize" || request.type === "file" || request.type === "diff";
}
function $26a8b6f63b30fd2a$var$getLangsFromTask(task) {
    const langs = /* @__PURE__ */ new Set();
    if (task.type === "initialize" || task.type === "set-render-options") return [];
    switch(task.type){
        case "file":
            langs.add(task.request.file.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(task.request.file.name));
            break;
        case "diff":
            langs.add(task.request.diff.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(task.request.diff.name));
            langs.add(task.request.diff.lang ?? (0, $350fbdca8afa0197$export$c90416708c3e3b9)(task.request.diff.prevName ?? "-"));
            break;
    }
    langs.delete("text");
    return Array.from(langs);
}
function $26a8b6f63b30fd2a$var$isRenderTask(task) {
    return task?.type === "file" || task?.type === "diff";
}
function $26a8b6f63b30fd2a$var$getInstances(task) {
    return task.instances;
}


//#region src/worker/getOrCreateWorkerPoolSingleton.ts
let $1a8276770bdcc59f$var$workerPoolSingleton;
function $1a8276770bdcc59f$export$80c319b3842b27e({ poolOptions: poolOptions, highlighterOptions: highlighterOptions }) {
    $1a8276770bdcc59f$var$workerPoolSingleton ??= new (0, $26a8b6f63b30fd2a$export$21289b88a997fd2)(poolOptions, highlighterOptions);
    return $1a8276770bdcc59f$var$workerPoolSingleton;
}
function $1a8276770bdcc59f$export$9f98e868ba2cb1f2() {
    if ($1a8276770bdcc59f$var$workerPoolSingleton == null) return;
    $1a8276770bdcc59f$var$workerPoolSingleton.terminate();
    $1a8276770bdcc59f$var$workerPoolSingleton = void 0;
}



var $acw62 = parcelRequire("acw62");

'use client';
//#region src/react/WorkerPoolContext.tsx
const $6420ed5fedaeb898$export$536e5a16a8f8264d = (0, $acw62.createContext)(void 0);
let $6420ed5fedaeb898$var$instanceCount = 0;
function $6420ed5fedaeb898$export$476a4d322aa67dc5({ children: children, poolOptions: poolOptions, highlighterOptions: highlighterOptions }) {
    const [poolManager] = (0, $acw62.useState)(()=>{
        if (typeof window === "undefined") return;
        return (0, $1a8276770bdcc59f$export$80c319b3842b27e)({
            poolOptions: poolOptions,
            highlighterOptions: highlighterOptions
        });
    });
    (0, $acw62.useInsertionEffect)(()=>{
        if (poolManager != null) {
            $6420ed5fedaeb898$var$instanceCount++;
            return ()=>{
                $6420ed5fedaeb898$var$instanceCount--;
            };
        }
    }, [
        poolManager
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if ($6420ed5fedaeb898$var$instanceCount === 0) (0, $1a8276770bdcc59f$export$9f98e868ba2cb1f2)();
        };
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($6420ed5fedaeb898$export$536e5a16a8f8264d.Provider, {
        value: poolManager,
        children: children
    });
}
function $6420ed5fedaeb898$export$2aa4a627f562044a() {
    return (0, $acw62.useContext)($6420ed5fedaeb898$export$536e5a16a8f8264d);
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

'use client';
//#region src/react/CodeView.tsx
const $8262e07508ab2a93$var$useIsometricEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
function $8262e07508ab2a93$var$createDefaultCache(controlled) {
    return {
        instance: void 0,
        items: void 0,
        controlled: controlled,
        managedOptions: void 0,
        disableFlushSync: false,
        slotCoordinator: void 0
    };
}
function $8262e07508ab2a93$var$CodeViewInner(props, ref) {
    const { className: className, containerRef: containerRef, disableWorkerPool: disableWorkerPool = false, initialItems: initialItems, items: controlledItems, onScroll: onScroll, onSelectedLinesChange: onSelectedLinesChange, options: options, renderAnnotation: renderAnnotation, renderCustomHeader: renderCustomHeader, renderGutterUtility: renderGutterUtility, renderHeaderMetadata: renderHeaderMetadata, renderHeaderPrefix: renderHeaderPrefix, selectedLines: selectedLines, style: style } = props;
    const controlled = controlledItems !== void 0;
    const poolManager = (0, $acw62.useContext)((0, $6420ed5fedaeb898$export$536e5a16a8f8264d));
    const cachedDataRef = (0, $acw62.useRef)($8262e07508ab2a93$var$createDefaultCache(controlled));
    const hasCustomHeader = renderCustomHeader != null;
    const hasAnnotationRenderer = renderAnnotation != null;
    const hasGutterRenderer = renderGutterUtility != null;
    const hasHeaderRenderers = hasCustomHeader || renderHeaderPrefix != null || renderHeaderMetadata != null;
    const hasRenderers = hasHeaderRenderers || hasAnnotationRenderer || hasGutterRenderer;
    const emitSelectedLinesChange = (0, $8441625c98d053f4$export$1a8b1350915fe2e0)((selection)=>{
        onSelectedLinesChange?.(selection);
    });
    const controlledSelection = selectedLines !== void 0;
    const managedOptions = (0, $acw62.useMemo)(()=>$8262e07508ab2a93$var$createManagedCodeViewOptions({
            options: options,
            hasCustomHeader: hasCustomHeader,
            hasGutterRenderer: hasGutterRenderer,
            onSelectedLinesChange: onSelectedLinesChange != null ? emitSelectedLinesChange : void 0,
            controlledSelection: controlledSelection
        }), [
        options,
        hasCustomHeader,
        hasGutterRenderer,
        onSelectedLinesChange,
        emitSelectedLinesChange,
        controlledSelection
    ]);
    const [slotContentStore] = (0, $acw62.useState)(()=>$8262e07508ab2a93$var$createSlotContentStore());
    const [, forceUpdate] = (0, $acw62.useState)({});
    const nodeRef = (0, $8441625c98d053f4$export$1a8b1350915fe2e0)((node)=>{
        if (cachedDataRef.current.instance != null && (node == null || node !== cachedDataRef.current.instance.getContainerElement())) {
            cachedDataRef.current.instance.cleanUp();
            slotContentStore.publish(void 0);
            cachedDataRef.current = $8262e07508ab2a93$var$createDefaultCache(controlled);
        }
        if (node != null && node !== cachedDataRef.current.instance?.getContainerElement()) {
            cachedDataRef.current.instance = new (0, $a415f622906ecd36$export$6a048cde9ca9b775)(managedOptions, !disableWorkerPool ? poolManager : void 0, true);
            cachedDataRef.current.instance.setup(node);
        }
        if (typeof containerRef === "function") containerRef(node);
        else if (containerRef != null) containerRef.current = node;
    });
    const onSnapshotChange = (0, $8441625c98d053f4$export$1a8b1350915fe2e0)((snapshot)=>{
        if (cachedDataRef.current.disableFlushSync) slotContentStore.publish(snapshot);
        else (0, $1u0KT.flushSync)(()=>{
            slotContentStore.publish(snapshot);
        });
    });
    const slotCoordinator = (0, $acw62.useMemo)(()=>{
        if (!hasHeaderRenderers && !hasAnnotationRenderer && !hasGutterRenderer) return;
        else return {
            hasHeaderRenderers: hasHeaderRenderers,
            hasAnnotationRenderer: hasAnnotationRenderer,
            hasGutterRenderer: hasGutterRenderer,
            onSnapshotChange: onSnapshotChange
        };
    }, [
        onSnapshotChange,
        hasAnnotationRenderer,
        hasGutterRenderer,
        hasHeaderRenderers
    ]);
    $8262e07508ab2a93$var$useIsometricEffect(()=>{
        return onScroll != null ? cachedDataRef.current.instance?.subscribeToScroll(onScroll) : void 0;
    });
    $8262e07508ab2a93$var$useIsometricEffect(()=>{
        const { instance: instance, controlled: prevControlled, items: prevItems, managedOptions: prevManagedOptions, slotCoordinator: prevSlotCoordinator } = cachedDataRef.current;
        if (instance == null) return;
        try {
            cachedDataRef.current.disableFlushSync = true;
            let shouldRender = false;
            if (!(0, $5e49faa8df06196c$export$1ace03bbcd701468)(managedOptions, prevManagedOptions)) {
                cachedDataRef.current.managedOptions = managedOptions;
                instance.setOptions(managedOptions);
                shouldRender = true;
            }
            if (prevControlled !== controlled) {
                console.error("CodeView: cannot switch between controlled and uncontrolled modes. Remount with a new key instead.");
                return;
            }
            if (controlled) {
                if (controlledItems !== prevItems) {
                    if ($8262e07508ab2a93$var$areItemListsEqual(prevItems, controlledItems)) cachedDataRef.current.items = controlledItems;
                    else if ($8262e07508ab2a93$var$isAppendOnlyItemUpdate(prevItems, controlledItems)) {
                        cachedDataRef.current.items = controlledItems;
                        instance.addItems(controlledItems.slice(prevItems.length));
                    } else {
                        cachedDataRef.current.items = controlledItems;
                        instance.setItems(controlledItems);
                        shouldRender = true;
                    }
                }
            } else if (prevItems == null) {
                const seedItems = initialItems ?? [];
                cachedDataRef.current.items = seedItems;
                if (seedItems.length > 0) {
                    instance.setItems(seedItems);
                    shouldRender = true;
                }
            }
            if (selectedLines !== void 0) instance.setSelectedLines(selectedLines, {
                notify: false
            });
            const slotPublish = instance.setSlotCoordinator(slotCoordinator);
            let forceInlinePublish = false;
            if (slotCoordinator !== prevSlotCoordinator) {
                if (slotCoordinator == null || prevSlotCoordinator == null) forceInlinePublish = true;
                cachedDataRef.current.slotCoordinator = slotCoordinator;
            }
            if (shouldRender || slotPublish) instance.render(true);
            if (slotPublish && slotCoordinator == null) slotContentStore.publish(void 0);
            if (forceInlinePublish) forceUpdate({});
        } finally{
            cachedDataRef.current.disableFlushSync = false;
        }
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            addItems (items) {
                const { controlled: controlled$1, instance: instance } = cachedDataRef.current;
                $8262e07508ab2a93$var$assertUncontrolledCodeViewAction(controlled$1, "addItems");
                if (instance == null) console.error("CodeView.addItems: no valid instance to append items with", items);
                else instance.addItems(items);
            },
            getItem (id) {
                const { instance: instance } = cachedDataRef.current;
                if (instance == null) {
                    console.error("CodeView.getItem: no valid instance exists", id);
                    return;
                } else return instance.getItem(id);
            },
            updateItem (item) {
                const { controlled: controlled$1, instance: instance } = cachedDataRef.current;
                $8262e07508ab2a93$var$assertUncontrolledCodeViewAction(controlled$1, "updateItem");
                if (instance == null) {
                    console.error("CodeView.updateItem: no valid instance to update item with", item);
                    return false;
                }
                return instance.updateItem(item);
            },
            updateItemId (oldId, newId) {
                const { controlled: controlled$1, instance: instance } = cachedDataRef.current;
                $8262e07508ab2a93$var$assertUncontrolledCodeViewAction(controlled$1, "updateItemId");
                if (instance == null) {
                    console.error("CodeView.updateItemId: no valid instance to update item id with", oldId, newId);
                    return false;
                }
                return instance.updateItemId(oldId, newId);
            },
            scrollTo (target) {
                const { instance: instance } = cachedDataRef.current;
                if (instance == null) console.error("CodeView.scrollTo: no valid instance to scroll with", target);
                else instance.scrollTo(target);
            },
            setSelectedLines (selection) {
                const { instance: instance } = cachedDataRef.current;
                if (instance == null) console.error("CodeView.setSelectedLines: no valid instance to update selection with", selection);
                else {
                    instance.setSelectedLines(selection, {
                        notify: false
                    });
                    emitSelectedLinesChange(selection);
                }
            },
            getSelectedLines () {
                const { instance: instance } = cachedDataRef.current;
                if (instance == null) {
                    console.error("CodeView.getSelectedLines: no valid instance exists");
                    return null;
                } else return instance.getSelectedLines();
            },
            clearSelectedLines () {
                const { instance: instance } = cachedDataRef.current;
                if (instance == null) console.error("CodeView.clearSelectedLines: no valid instance to update selection with");
                else {
                    instance.clearSelectedLines({
                        notify: false
                    });
                    emitSelectedLinesChange(null);
                }
            },
            getInstance () {
                return cachedDataRef.current.instance;
            }
        }), [
        emitSelectedLinesChange
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: nodeRef,
                className: className,
                style: style
            }),
            hasRenderers && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8262e07508ab2a93$var$SlotPortals, {
                managedContentStore: slotContentStore,
                renderCustomHeader: renderCustomHeader,
                renderHeaderPrefix: renderHeaderPrefix,
                renderHeaderMetadata: renderHeaderMetadata,
                renderAnnotation: renderAnnotation,
                renderGutterUtility: renderGutterUtility
            })
        ]
    });
}
const $8262e07508ab2a93$export$6a048cde9ca9b775 = (0, $acw62.forwardRef)($8262e07508ab2a93$var$CodeViewInner);
function $8262e07508ab2a93$var$isAppendOnlyItemUpdate(previousItems, nextItems) {
    if (previousItems == null || nextItems.length <= previousItems.length) return false;
    if (previousItems.length === 0) return true;
    for(let index = 0; index < previousItems.length; index++)if (nextItems[index] !== previousItems[index]) return false;
    return true;
}
function $8262e07508ab2a93$var$areItemListsEqual(previousItems, nextItems) {
    if (previousItems == null || previousItems.length !== nextItems.length) return false;
    for(let index = 0; index < previousItems.length; index++)if (previousItems[index] !== nextItems[index]) return false;
    return true;
}
function $8262e07508ab2a93$var$assertUncontrolledCodeViewAction(controlled, action) {
    if (!controlled) return;
    throw new Error(`CodeView.${action} cannot be used when CodeView is controlled. Use initialItems for imperative item updates.`);
}
function $8262e07508ab2a93$var$createSlotContentStore() {
    let snapshot;
    const listeners = /* @__PURE__ */ new Set();
    return {
        getSnapshot () {
            return snapshot;
        },
        publish (nextSnapshot) {
            if ((0, $4019b097f14ecd67$export$ca3e7b5963358354)(snapshot, nextSnapshot)) return;
            snapshot = nextSnapshot;
            for (const listener of listeners)listener();
        },
        subscribe (listener) {
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
function $8262e07508ab2a93$var$createManagedCodeViewOptions({ options: options, hasCustomHeader: hasCustomHeader, hasGutterRenderer: hasGutterRenderer, onSelectedLinesChange: onSelectedLinesChange, controlledSelection: controlledSelection }) {
    if (!hasCustomHeader && !hasGutterRenderer && onSelectedLinesChange == null && !controlledSelection) return options;
    options = {
        ...options,
        controlledSelection: controlledSelection,
        onSelectedLinesChange: onSelectedLinesChange
    };
    if (hasCustomHeader) options.renderCustomHeader = $8262e07508ab2a93$var$noopRender;
    if (hasGutterRenderer) options.renderGutterUtility = $8262e07508ab2a93$var$noopRender;
    return options;
}
const $8262e07508ab2a93$var$SlotPortals = (0, $acw62.memo)(function SlotPortals$1({ managedContentStore: managedContentStore, renderCustomHeader: renderCustomHeader, renderHeaderPrefix: renderHeaderPrefix, renderHeaderMetadata: renderHeaderMetadata, renderAnnotation: renderAnnotation, renderGutterUtility: renderGutterUtility }) {
    const subscribe = (0, $8441625c98d053f4$export$1a8b1350915fe2e0)((listener)=>managedContentStore.subscribe(listener));
    const getSnapshot = (0, $8441625c98d053f4$export$1a8b1350915fe2e0)(()=>managedContentStore.getSnapshot());
    return (0, $acw62.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot)?.map((renderedItem)=>{
        return (0, $1u0KT.createPortal)($8262e07508ab2a93$var$renderCodeViewItemChildren({
            renderedItem: renderedItem,
            renderCustomHeader: renderCustomHeader,
            renderHeaderPrefix: renderHeaderPrefix,
            renderHeaderMetadata: renderHeaderMetadata,
            renderAnnotation: renderAnnotation,
            renderGutterUtility: renderGutterUtility
        }), renderedItem.element, renderedItem.id);
    });
});
function $8262e07508ab2a93$var$renderCodeViewItemChildren({ renderedItem: renderedItem, renderCustomHeader: renderCustomHeader, renderHeaderPrefix: renderHeaderPrefix, renderHeaderMetadata: renderHeaderMetadata, renderAnnotation: renderAnnotation, renderGutterUtility: renderGutterUtility }) {
    if (renderedItem.type === "diff") {
        const { item: item, instance: instance } = renderedItem;
        return (0, $d72acda64073d2b6$export$2c383ee185e3e25e)({
            fileDiff: item.fileDiff,
            renderCustomHeader: renderCustomHeader != null ? ()=>renderCustomHeader(item) : void 0,
            renderHeaderPrefix: renderHeaderPrefix != null ? ()=>renderHeaderPrefix(item) : void 0,
            renderHeaderMetadata: renderHeaderMetadata != null ? ()=>renderHeaderMetadata(item) : void 0,
            renderAnnotation: renderAnnotation != null ? (annotation)=>renderAnnotation(annotation, item) : void 0,
            lineAnnotations: item.annotations,
            renderGutterUtility: renderGutterUtility != null ? (getHoveredLine)=>renderGutterUtility(getHoveredLine, item) : void 0,
            getHoveredLine: instance.getHoveredLine
        });
    } else {
        const { item: item, instance: instance } = renderedItem;
        return (0, $e5fd8d5ef1bc741e$export$26dd293a21f7d4d9)({
            file: item.file,
            renderCustomHeader: renderCustomHeader != null ? ()=>renderCustomHeader(item) : void 0,
            renderHeaderPrefix: renderHeaderPrefix != null ? ()=>renderHeaderPrefix(item) : void 0,
            renderHeaderMetadata: renderHeaderMetadata != null ? ()=>renderHeaderMetadata(item) : void 0,
            renderAnnotation: renderAnnotation != null ? (annotation)=>renderAnnotation(annotation, item) : void 0,
            lineAnnotations: item.annotations,
            renderGutterUtility: renderGutterUtility != null ? (getHoveredLine)=>renderGutterUtility(getHoveredLine, item) : void 0,
            getHoveredLine: instance.getHoveredLine
        });
    }
}
function $8262e07508ab2a93$var$noopRender() {}




var $acw62 = parcelRequire("acw62");
const $ea48220a143b30f5$var$threadsVersion = new WeakMap();
let $ea48220a143b30f5$var$version = 1;
function $ea48220a143b30f5$export$b03e7cabf0eb0daa({ patch: patch, threads: threads = [], pendingComment: pendingComment, renderAnnotation: renderAnnotation, onGutterUtilityClick: onGutterUtilityClick }) {
    let files = (0, $acw62.useMemo)(()=>(0, $9fe687489fc907dc$export$31a4476216ccf196)(patch), [
        patch
    ]);
    let items = (0, $acw62.useMemo)(()=>{
        let threadVersion = $ea48220a143b30f5$var$threadsVersion.get(threads);
        if (!threadVersion) {
            threadVersion = $ea48220a143b30f5$var$version++;
            $ea48220a143b30f5$var$threadsVersion.set(threads, threadVersion);
        }
        let threadsByPath = new Map();
        for (let thread of threads){
            if (!thread.path || thread.line == null) continue;
            let list = threadsByPath.get(thread.path);
            if (!list) threadsByPath.set(thread.path, list = []);
            list.push(thread);
        }
        return files.flatMap((parsed, pi)=>parsed.files.map((file, fi)=>{
                let fileThreads = threadsByPath.get(file.name) ?? [];
                let annotations = fileThreads.map((thread)=>({
                        side: thread.diffSide === 'LEFT' ? 'deletions' : 'additions',
                        lineNumber: thread.line,
                        metadata: thread
                    }));
                let version = threadVersion;
                if (pendingComment && pendingComment.path === file.name) {
                    annotations = [
                        ...annotations,
                        {
                            side: pendingComment.side,
                            lineNumber: pendingComment.line,
                            metadata: null
                        }
                    ];
                    version++;
                }
                return {
                    id: `${pi}:${fi}:${file.name}`,
                    type: 'diff',
                    fileDiff: file,
                    annotations: annotations,
                    version: version
                };
            }));
    }, [
        files,
        threads,
        pendingComment
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8262e07508ab2a93$export$6a048cde9ca9b775), {
        items: items,
        options: {
            theme: {
                dark: 'pierre-dark',
                light: 'pierre-light'
            },
            themeType: 'system',
            stickyHeaders: true,
            diffStyle: 'unified',
            ...onGutterUtilityClick && {
                enableGutterUtility: true,
                onGutterUtilityClick: (range, context)=>{
                    if (context?.type === 'diff') onGutterUtilityClick(context.item.fileDiff.name, range.end, range.endSide ?? range.side ?? 'additions');
                }
            }
        },
        className: "h-full overflow-auto px-4 [&>div]:m-0! diff-code-view",
        renderAnnotation: renderAnnotation
    });
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $b99d9fc19f4fd326$export$722debc0e56fea39(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, $acw62.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$formatterCache = new Map();
class $ed3e02e855b6b71b$export$ad991b66133851cf {
    constructor(locale, options = {}){
        this.formatter = $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($ed3e02e855b6b71b$var$$12a3c853105e5a70$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {}
};
function $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref ?? defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($ed3e02e855b6b71b$var$$12a3c853105e5a70$var$formatterCache.has(cacheKey)) return $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior = null;
function $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$hasBuggyHour12Behavior() {
    if ($ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior == null) $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior;
}
let $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle = null;
function $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$hasBuggyResolvedHourCycle() {
    if ($ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle == null) $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle;
}
function $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = $ed3e02e855b6b71b$var$$12a3c853105e5a70$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c5bcadf5f58d658e$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $b99d9fc19f4fd326$export$722debc0e56fea39)(options ?? {}, $c5bcadf5f58d658e$var$$60f33508b4cd9d3b$var$isEqual);
    let { locale: locale } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    return (0, $acw62.useMemo)(()=>new (0, $ed3e02e855b6b71b$export$ad991b66133851cf)(locale, options), [
        locale,
        options
    ]);
}
function $c5bcadf5f58d658e$var$$60f33508b4cd9d3b$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}








var $acw62 = parcelRequire("acw62");
var $67ec25f47aa78033$var$j;
function $67ec25f47aa78033$export$3fc0912547321ab3(z) {
    if (!$67ec25f47aa78033$var$j) {
        if (typeof document < "u") $67ec25f47aa78033$var$j = document.createElement("textarea");
        else return;
    }
    var q = "&" + z + ";";
    $67ec25f47aa78033$var$j.innerHTML = q;
    var v = $67ec25f47aa78033$var$j.value;
    return v !== q ? v : void 0;
}
var $67ec25f47aa78033$export$d3e1a78cff21f600 = {};


var $87a23dccae47b18a$var$b = 32, $87a23dccae47b18a$var$R = 9, $87a23dccae47b18a$var$B9 = 13, $87a23dccae47b18a$var$x = 10, $87a23dccae47b18a$var$$0 = 96, $87a23dccae47b18a$var$A0 = 126, $87a23dccae47b18a$var$O0 = 91, $87a23dccae47b18a$var$e0 = 94, $87a23dccae47b18a$var$c = 62, $87a23dccae47b18a$var$J9 = 35, $87a23dccae47b18a$var$G$ = 37, $87a23dccae47b18a$var$p = 45, $87a23dccae47b18a$var$C0 = 61, $87a23dccae47b18a$var$N0 = 92, $87a23dccae47b18a$var$B0 = 42, $87a23dccae47b18a$var$z0 = 95, $87a23dccae47b18a$var$Z0 = 60, $87a23dccae47b18a$var$K$ = 64, $87a23dccae47b18a$var$p0 = 93, $87a23dccae47b18a$var$x0 = 33, $87a23dccae47b18a$var$g$ = 38, $87a23dccae47b18a$var$E0 = 58, $87a23dccae47b18a$var$x$ = 70, $87a23dccae47b18a$var$j9 = 102, $87a23dccae47b18a$var$h9 = 104, $87a23dccae47b18a$var$W9 = 119, $87a23dccae47b18a$var$u9 = 116, $87a23dccae47b18a$var$O$ = 112, $87a23dccae47b18a$var$E$ = 115, $87a23dccae47b18a$var$K6 = 160, $87a23dccae47b18a$var$q6 = 12, $87a23dccae47b18a$var$J6 = 44, $87a23dccae47b18a$var$T$ = 59, $87a23dccae47b18a$var$i9 = 63, $87a23dccae47b18a$var$d0 = 46, $87a23dccae47b18a$var$j0 = 47, $87a23dccae47b18a$var$S9 = 39, $87a23dccae47b18a$var$M9 = 34, $87a23dccae47b18a$var$A9 = 43, $87a23dccae47b18a$var$w0 = 124, $87a23dccae47b18a$var$g9 = 123, $87a23dccae47b18a$var$D$ = 125, $87a23dccae47b18a$var$$9 = 40, $87a23dccae47b18a$var$Z9 = 41, $87a23dccae47b18a$var$a9 = 30, $87a23dccae47b18a$var$B$ = 31, $87a23dccae47b18a$var$o = 48, $87a23dccae47b18a$var$i = 57, $87a23dccae47b18a$var$d = 65, $87a23dccae47b18a$var$l = 90, $87a23dccae47b18a$var$U0 = 97, $87a23dccae47b18a$var$H0 = 122, $87a23dccae47b18a$var$n9 = 128, $87a23dccae47b18a$var$i0 = 32, $87a23dccae47b18a$var$kZ = {
    blockQuote: 0,
    breakLine: 1,
    breakThematic: 2,
    codeBlock: 3,
    codeInline: 4,
    footnote: 5,
    footnoteReference: 6,
    frontmatter: 7,
    gfmTask: 8,
    heading: 9,
    htmlBlock: 10,
    htmlComment: 11,
    htmlSelfClosing: 12,
    image: 13,
    link: 14,
    orderedList: 15,
    paragraph: 16,
    ref: 17,
    refCollection: 18,
    table: 19,
    text: 20,
    textFormatted: 21,
    unorderedList: 22
}, $87a23dccae47b18a$export$e0aa44767d8750d5 = $87a23dccae47b18a$var$kZ;
function $87a23dccae47b18a$var$O6($) {
    if (!$87a23dccae47b18a$var$U6($, "---")) return null;
    let Q = 3;
    for(; Q < $.length && ($[Q] === " " || $[Q] === "	");)Q++;
    if (Q < $.length && $[Q] === "\r" && Q++, Q >= $.length || $[Q] !== `
`) return null;
    Q++;
    let Z = !1;
    for(; Q < $.length;){
        let V = Q;
        for(; Q < $.length && $[Q] !== `
` && $[Q] !== "\r";)Q++;
        if (Q >= $.length) break;
        let Y = Q;
        if ($[Q] === "\r" && Q++, Q < $.length && $[Q] === `
` && Q++, $87a23dccae47b18a$var$U6($, "---", V)) return {
            endPos: Q,
            hasValidYaml: Z
        };
        if (!Z) {
            let G = $87a23dccae47b18a$var$CZ($, V, Y);
            if (G < Y) {
                let K = $.charCodeAt(G);
                if (K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$H0 || K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$l || K >= $87a23dccae47b18a$var$o && K <= $87a23dccae47b18a$var$i || K === $87a23dccae47b18a$var$z0) {
                    for(G++; G < Y && (K = $.charCodeAt(G), K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$H0 || K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$l || K >= $87a23dccae47b18a$var$o && K <= $87a23dccae47b18a$var$i || K === $87a23dccae47b18a$var$z0 || K === $87a23dccae47b18a$var$p || K === $87a23dccae47b18a$var$d0);)G++;
                    G < Y && $.charCodeAt(G) === $87a23dccae47b18a$var$E0 && (G++, G >= Y ? Z = !0 : (K = $.charCodeAt(G), (K === $87a23dccae47b18a$var$b || K === $87a23dccae47b18a$var$R) && (Z = !0)));
                }
            }
        }
    }
    return null;
}
var $87a23dccae47b18a$var$SZ = /&([a-zA-Z0-9]+|#[0-9]{1,7}|#x[0-9a-fA-F]{1,6});/gi, $87a23dccae47b18a$var$gZ = {
    class: "className",
    for: "htmlFor",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    autocomplete: "autoComplete",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    classid: "classId",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    crossorigin: "crossOrigin",
    enctype: "encType",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    inputmode: "inputMode",
    keyparams: "keyParams",
    keytype: "keyType",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    novalidate: "noValidate",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap",
    viewbox: "viewBox"
};
function $87a23dccae47b18a$var$c0($) {
    var Q = {};
    for(var Z in $){
        var V = Z.toLowerCase(), Y = $87a23dccae47b18a$var$gZ[V];
        if (Y) Q[Y] = $[Z];
        else {
            var G = Z.indexOf(":");
            G !== -1 ? Q[Z.slice(0, G) + Z[G + 1].toUpperCase() + Z.slice(G + 2)] = $[Z] : Q[Z] = $[Z];
        }
    }
    return Q;
}
var $87a23dccae47b18a$var$D6 = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s|^<(div|p|h[1-6]|ul|ol|li|blockquote|pre|table|thead|tbody|tr|td|th|dl|dt|dd|hr|address|article|aside|details|dialog|figure|figcaption|footer|form|header|main|menu|nav|section|summary|textarea|fieldset|legend|center|dir|hgroup|marquee|search|output|template)\b)/i;
function $87a23dccae47b18a$var$s9($) {
    return $.indexOf("&") === -1 ? $ : $.replace($87a23dccae47b18a$var$SZ, (Q, Z)=>{
        var V = (0, $67ec25f47aa78033$export$3fc0912547321ab3)(Z);
        if (V) return V;
        if (Z[0] === "#") {
            var Y = Z[1] === "x" || Z[1] === "X" ? parseInt(Z.slice(2), 16) : parseInt(Z.slice(1), 10);
            return Y === 0 || Y >= 55296 && Y <= 57343 || Y > 1114111 ? "\uFFFD" : Y <= 65535 ? String.fromCharCode(Y) : String.fromCharCode(55296 + (Y - 65536 >> 10), 56320 + (Y - 65536 & 1023));
        }
        return Q;
    });
}
var $87a23dccae47b18a$var$F6 = /(javascript|vbscript|data(?!:image)):/i;
function $87a23dccae47b18a$export$3e2338ea76b578c9($) {
    if ($87a23dccae47b18a$var$F6.test($)) return null;
    if ($.indexOf("%") === -1) return $;
    try {
        let Q = decodeURIComponent($).replace(/[^A-Za-z0-9/:]/g, "");
        if ($87a23dccae47b18a$var$F6.test(Q)) return null;
    } catch  {
        return null;
    }
    return $;
}
var $87a23dccae47b18a$var$f0 = {}, $87a23dccae47b18a$var$m0, $87a23dccae47b18a$var$L0;
for($87a23dccae47b18a$var$m0 = [
    192,
    193,
    194,
    195,
    196,
    197,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    198
], $87a23dccae47b18a$var$L0 = 0; $87a23dccae47b18a$var$L0 < $87a23dccae47b18a$var$m0.length; $87a23dccae47b18a$var$L0++)$87a23dccae47b18a$var$f0[$87a23dccae47b18a$var$m0[$87a23dccae47b18a$var$L0]] = "a";
for($87a23dccae47b18a$var$f0[231] = $87a23dccae47b18a$var$f0[199] = "c", $87a23dccae47b18a$var$f0[240] = $87a23dccae47b18a$var$f0[208] = "d", $87a23dccae47b18a$var$m0 = [
    200,
    201,
    202,
    203,
    233,
    232,
    234,
    235
], $87a23dccae47b18a$var$L0 = 0; $87a23dccae47b18a$var$L0 < $87a23dccae47b18a$var$m0.length; $87a23dccae47b18a$var$L0++)$87a23dccae47b18a$var$f0[$87a23dccae47b18a$var$m0[$87a23dccae47b18a$var$L0]] = "e";
for($87a23dccae47b18a$var$m0 = [
    207,
    239,
    206,
    238,
    205,
    237,
    204,
    236
], $87a23dccae47b18a$var$L0 = 0; $87a23dccae47b18a$var$L0 < $87a23dccae47b18a$var$m0.length; $87a23dccae47b18a$var$L0++)$87a23dccae47b18a$var$f0[$87a23dccae47b18a$var$m0[$87a23dccae47b18a$var$L0]] = "i";
for($87a23dccae47b18a$var$f0[209] = $87a23dccae47b18a$var$f0[241] = "n", $87a23dccae47b18a$var$m0 = [
    248,
    216,
    339,
    338,
    213,
    245,
    212,
    244,
    211,
    243,
    210,
    242
], $87a23dccae47b18a$var$L0 = 0; $87a23dccae47b18a$var$L0 < $87a23dccae47b18a$var$m0.length; $87a23dccae47b18a$var$L0++)$87a23dccae47b18a$var$f0[$87a23dccae47b18a$var$m0[$87a23dccae47b18a$var$L0]] = "o";
for($87a23dccae47b18a$var$m0 = [
    220,
    252,
    219,
    251,
    218,
    250,
    217,
    249
], $87a23dccae47b18a$var$L0 = 0; $87a23dccae47b18a$var$L0 < $87a23dccae47b18a$var$m0.length; $87a23dccae47b18a$var$L0++)$87a23dccae47b18a$var$f0[$87a23dccae47b18a$var$m0[$87a23dccae47b18a$var$L0]] = "u";
$87a23dccae47b18a$var$f0[376] = $87a23dccae47b18a$var$f0[255] = $87a23dccae47b18a$var$f0[221] = $87a23dccae47b18a$var$f0[253] = "y";
function $87a23dccae47b18a$export$c383cdd2a518017a($) {
    for(var Q = "", Z = -1, V = $.length, Y = 0; Y < V; Y++){
        var G = $.charCodeAt(Y);
        if (G >= $87a23dccae47b18a$var$U0 && G <= $87a23dccae47b18a$var$H0 || G >= $87a23dccae47b18a$var$o && G <= $87a23dccae47b18a$var$i) {
            Z < 0 && (Z = Y);
            continue;
        }
        if (G >= $87a23dccae47b18a$var$d && G <= $87a23dccae47b18a$var$l) {
            Z >= 0 && (Q += $.slice(Z, Y), Z = -1), Q += String.fromCharCode(G + $87a23dccae47b18a$var$i0);
            continue;
        }
        if (G === $87a23dccae47b18a$var$b || G === $87a23dccae47b18a$var$p) {
            Z >= 0 && (Q += $.slice(Z, Y), Z = -1), Q += "-";
            continue;
        }
        Z >= 0 && (Q += $.slice(Z, Y), Z = -1);
        var K = $87a23dccae47b18a$var$f0[G];
        K && (Q += K);
    }
    return Z >= 0 && (Q += $.slice(Z)), Q;
}
function $87a23dccae47b18a$var$U6($, Q, Z) {
    return $.startsWith(Q, Z);
}
var $87a23dccae47b18a$var$X6 = new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
    "circle",
    "ellipse",
    "line",
    "path",
    "polygon",
    "polyline",
    "rect",
    "use",
    "stop",
    "animate",
    "set"
]);
function $87a23dccae47b18a$var$c9($) {
    let Q = $.toLowerCase();
    if ($87a23dccae47b18a$var$X6.has(Q)) return !0;
    let Z = Q.indexOf(":");
    return Z !== -1 ? (Q = Q.slice(Z + 1), $87a23dccae47b18a$var$X6.has(Q)) : !1;
}
var $87a23dccae47b18a$var$v9 = 1, $87a23dccae47b18a$var$W6 = 2, $87a23dccae47b18a$var$d9 = 4, $87a23dccae47b18a$var$z6 = 8, $87a23dccae47b18a$var$xZ = 16, $87a23dccae47b18a$var$Q9 = 32, $87a23dccae47b18a$var$_9 = 64, $87a23dccae47b18a$var$H6 = 1, $87a23dccae47b18a$var$EZ = 2, $87a23dccae47b18a$var$TZ = 3, $87a23dccae47b18a$var$fZ = 4, $87a23dccae47b18a$var$B6 = function() {
    var $ = new Uint8Array(128), Q;
    for($[$87a23dccae47b18a$var$R] = $87a23dccae47b18a$var$v9, $[$87a23dccae47b18a$var$x] = $87a23dccae47b18a$var$v9 | $87a23dccae47b18a$var$W6, $[$87a23dccae47b18a$var$q6] = $87a23dccae47b18a$var$v9, $[$87a23dccae47b18a$var$B9] = $87a23dccae47b18a$var$v9 | $87a23dccae47b18a$var$W6, $[$87a23dccae47b18a$var$b] = $87a23dccae47b18a$var$v9, Q = $87a23dccae47b18a$var$x0; Q <= $87a23dccae47b18a$var$j0; Q++)$[Q] = $87a23dccae47b18a$var$d9;
    for(Q = $87a23dccae47b18a$var$E0; Q <= $87a23dccae47b18a$var$K$; Q++)$[Q] = $87a23dccae47b18a$var$d9;
    for(Q = $87a23dccae47b18a$var$O0; Q <= $87a23dccae47b18a$var$$0; Q++)$[Q] = $87a23dccae47b18a$var$d9;
    for(Q = $87a23dccae47b18a$var$g9; Q <= $87a23dccae47b18a$var$A0; Q++)$[Q] = $87a23dccae47b18a$var$d9;
    for(Q = $87a23dccae47b18a$var$o; Q <= $87a23dccae47b18a$var$i; Q++)$[Q] = $87a23dccae47b18a$var$xZ;
    for(Q = $87a23dccae47b18a$var$d; Q <= $87a23dccae47b18a$var$l; Q++)$[Q] = $87a23dccae47b18a$var$z6;
    for(Q = $87a23dccae47b18a$var$U0; Q <= $87a23dccae47b18a$var$H0; Q++)$[Q] = $87a23dccae47b18a$var$z6;
    return $;
}(), $87a23dccae47b18a$var$A5 = function() {
    let $ = new Uint8Array(128);
    return $[$87a23dccae47b18a$var$N0] = $87a23dccae47b18a$var$EZ, $[$87a23dccae47b18a$var$O0] = $87a23dccae47b18a$var$fZ, $[$87a23dccae47b18a$var$B0] = $[$87a23dccae47b18a$var$z0] = $[$87a23dccae47b18a$var$A0] = $[$87a23dccae47b18a$var$C0] = $87a23dccae47b18a$var$TZ, $[$87a23dccae47b18a$var$$0] = $[$87a23dccae47b18a$var$Z0] = $[$87a23dccae47b18a$var$K$] = $[$87a23dccae47b18a$var$p0] = $[$87a23dccae47b18a$var$x] = $[$87a23dccae47b18a$var$b] = $[$87a23dccae47b18a$var$x0] = $87a23dccae47b18a$var$H6, $[$87a23dccae47b18a$var$j9] = $[$87a23dccae47b18a$var$h9] = $[$87a23dccae47b18a$var$W9] = $87a23dccae47b18a$var$H6, $;
}(), $87a23dccae47b18a$var$j6 = /[\p{P}\p{S}]/u, $87a23dccae47b18a$var$M6 = /\p{Zs}/u, $87a23dccae47b18a$var$p9 = [];
function $87a23dccae47b18a$var$C$($) {
    var Q = $.indexOf("\r"), Z = $.indexOf("\0");
    if (Q === -1 && Z === -1) return $;
    var V = $.length;
    $87a23dccae47b18a$var$p9.length = 0;
    var Y = 0, G = 0;
    for(Q === -1 ? G = Z : Z === -1 ? G = Q : G = Q < Z ? Q : Z; G < V; G++){
        var K = $.charCodeAt(G);
        K === $87a23dccae47b18a$var$B9 ? (Y < G && $87a23dccae47b18a$var$p9.push($.slice(Y, G)), G + 1 < V && $.charCodeAt(G + 1) === $87a23dccae47b18a$var$x && G++, $87a23dccae47b18a$var$p9.push(`
`), Y = G + 1) : K === 0 && (Y < G && $87a23dccae47b18a$var$p9.push($.slice(Y, G)), $87a23dccae47b18a$var$p9.push("\uFFFD"), Y = G + 1);
    }
    return Y < V && $87a23dccae47b18a$var$p9.push($.slice(Y)), $87a23dccae47b18a$var$p9.join("");
}
function $87a23dccae47b18a$var$CZ($, Q, Z) {
    let V = Z ?? $.length;
    for(; Q < V && ($[Q] === " " || $[Q] === "	");)Q++;
    return Q;
}
function $87a23dccae47b18a$var$m$($) {
    if (!$) return !1;
    for(var Q in $)return !0;
    return !1;
}
function $87a23dccae47b18a$var$A6($) {
    return {
        attrs: {},
        children: [
            {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                text: $
            }
        ],
        c: !0,
        type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
        tag: "header"
    };
}
function $87a23dccae47b18a$var$v6($) {
    var Q = [];
    if (!$) return Q;
    for(var Z in $)Z.charCodeAt(0) === 94 && Q.push({
        identifier: Z,
        footnote: $[Z].target
    });
    return Q;
}
function $87a23dccae47b18a$var$t9($, Q, Z) {
    for(var V = $, Y = Q.split("."), G = 0; G < Y.length && (V = V?.[Y[G]], V !== void 0);)G++;
    return V || Z;
}
function $87a23dccae47b18a$var$_6($) {
    for(var Q = !1, Z = 0; Z < $.length; Z++){
        var V = $.charCodeAt(Z);
        if (V <= $87a23dccae47b18a$var$b || V === $87a23dccae47b18a$var$M9 || V === $87a23dccae47b18a$var$G$ || V === $87a23dccae47b18a$var$Z0 || V === $87a23dccae47b18a$var$c || V === $87a23dccae47b18a$var$O0 || V === $87a23dccae47b18a$var$N0 || V === $87a23dccae47b18a$var$p0 || V === $87a23dccae47b18a$var$e0 || V === $87a23dccae47b18a$var$$0 || V >= 123) {
            Q = !0;
            break;
        }
    }
    if (!Q) return $;
    for(var Y = "", Z = 0; Z < $.length; Z++){
        var V = $.charCodeAt(Z);
        if (V === $87a23dccae47b18a$var$G$ && Z + 2 < $.length) {
            var G = $.charCodeAt(Z + 1), K = $.charCodeAt(Z + 2);
            if ((G >= $87a23dccae47b18a$var$o && G <= $87a23dccae47b18a$var$i || G >= $87a23dccae47b18a$var$d && G <= $87a23dccae47b18a$var$x$ || G >= $87a23dccae47b18a$var$U0 && G <= $87a23dccae47b18a$var$j9) && (K >= $87a23dccae47b18a$var$o && K <= $87a23dccae47b18a$var$i || K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$x$ || K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$j9)) {
                Y += $[Z] + $[Z + 1] + $[Z + 2], Z += 2;
                continue;
            }
        }
        Y += encodeURI($[Z]);
    }
    return Y;
}
function $87a23dccae47b18a$var$I6(...$) {
    return $.filter(Boolean).join(" ");
}
function $87a23dccae47b18a$var$v5($, Q) {
    if (!Q) return $;
    let Z = $87a23dccae47b18a$var$t9(Q, $, void 0);
    return typeof Z == "string" ? Z : typeof Z == "object" && Z.component ? Z.component : $;
}
function $87a23dccae47b18a$var$_5($, Q) {
    if (!Q) return {};
    let Z = $87a23dccae47b18a$var$t9(Q, $, void 0);
    return typeof Z == "object" && Z.props ? Z.props : {};
}
var $87a23dccae47b18a$var$mZ = new Set([
    "title",
    "textarea",
    "style",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "script",
    "plaintext"
]), $87a23dccae47b18a$var$j$ = /<(\/?)(title|textarea|style|xmp|iframe|noembed|noframes|script|plaintext)(\s|>|\/)/gi;
function $87a23dccae47b18a$var$h$($) {
    return $87a23dccae47b18a$var$mZ.has($.toLowerCase());
}
function $87a23dccae47b18a$var$N6($) {
    return $87a23dccae47b18a$var$j$.lastIndex = 0, $87a23dccae47b18a$var$j$.test($);
}
function $87a23dccae47b18a$var$u$($) {
    return $87a23dccae47b18a$var$j$.lastIndex = 0, $.replace($87a23dccae47b18a$var$j$, function(Q, Z, V, Y) {
        return "&lt;" + Z + V + Y;
    });
}
var $87a23dccae47b18a$var$C6 = /^<([a-zA-Z][a-zA-Z0-9-]*)\s[^>]*>/, $87a23dccae47b18a$var$m6 = /^<[A-Z]/, $87a23dccae47b18a$var$p$ = [
    "script",
    "pre",
    "style",
    "textarea"
], $87a23dccae47b18a$var$F$ = new Set($87a23dccae47b18a$var$p$), $87a23dccae47b18a$var$hZ = /<(?:pre|script|style|textarea)\b/i, $87a23dccae47b18a$var$P6 = /<(?:pre|script|style|textarea)\b/iy, $87a23dccae47b18a$var$w6 = /^(\s{0,3}#[#\s]|\s{0,3}[-*+]\s|\s{0,3}\d+\.\s|\s{0,3}>\s|\s{0,3}```)/m, $87a23dccae47b18a$var$y6 = /^<([a-z][^ >/\n\r]*) ?([^>]*?)>/im, $87a23dccae47b18a$var$h6 = new Uint8Array(128);
(function() {
    for(var $ = [
        $87a23dccae47b18a$var$$0,
        $87a23dccae47b18a$var$B0,
        $87a23dccae47b18a$var$z0,
        $87a23dccae47b18a$var$A0,
        $87a23dccae47b18a$var$C0,
        $87a23dccae47b18a$var$O0,
        $87a23dccae47b18a$var$x0,
        $87a23dccae47b18a$var$Z0,
        $87a23dccae47b18a$var$N0,
        $87a23dccae47b18a$var$B$,
        $87a23dccae47b18a$var$h9,
        $87a23dccae47b18a$var$W9,
        $87a23dccae47b18a$var$j9
    ], Q = 0; Q < $.length; Q++)$87a23dccae47b18a$var$h6[$[Q]] = 1;
})();
var $87a23dccae47b18a$var$R6 = /([a-zA-Z_][a-zA-Z0-9_-]*)=(?:"([^"]*)"|'([^']*)')/g;
function $87a23dccae47b18a$var$u6($) {
    return $87a23dccae47b18a$var$F$.has($);
}
function $87a23dccae47b18a$var$p6($) {
    return $87a23dccae47b18a$var$hZ.test($);
}
function $87a23dccae47b18a$var$d6($, Q, Z) {
    for(var V = Q, Y = Z; V < Y && ($.charCodeAt(V) === $87a23dccae47b18a$var$b || $.charCodeAt(V) === $87a23dccae47b18a$var$R);)V++;
    if (V >= Y) return !1;
    $.charCodeAt(V) === $87a23dccae47b18a$var$w0 && V++;
    for(var G = 0; V < Y;){
        for(; V < Y && ($.charCodeAt(V) === $87a23dccae47b18a$var$b || $.charCodeAt(V) === $87a23dccae47b18a$var$R);)V++;
        if (V >= Y) break;
        if ($.charCodeAt(V) === $87a23dccae47b18a$var$w0 && G > 0) {
            for(var K = V + 1; K < Y && ($.charCodeAt(K) === $87a23dccae47b18a$var$b || $.charCodeAt(K) === $87a23dccae47b18a$var$R);)K++;
            if (K >= Y) return !0;
        }
        if ($.charCodeAt(V) === $87a23dccae47b18a$var$E0 && V++, V >= Y || $.charCodeAt(V) !== $87a23dccae47b18a$var$p) return !1;
        for(; V < Y && $.charCodeAt(V) === $87a23dccae47b18a$var$p;)V++;
        for(V < Y && $.charCodeAt(V) === $87a23dccae47b18a$var$E0 && V++, G++; V < Y && ($.charCodeAt(V) === $87a23dccae47b18a$var$b || $.charCodeAt(V) === $87a23dccae47b18a$var$R);)V++;
        if (V < Y) {
            if ($.charCodeAt(V) === $87a23dccae47b18a$var$w0) V++;
            else return !1;
        }
    }
    return G > 0;
}
function $87a23dccae47b18a$var$N9($, Q) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$Z0) return null;
    let Z = Q + 1, V = $.length, Y = !1;
    $.charCodeAt(Z) === $87a23dccae47b18a$var$j0 && (Z++, Y = !0);
    let G = Z, K = $.charCodeAt(Z);
    if (!(K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$H0 || K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$l)) return null;
    for(; Z < V && ($.charCodeAt(Z) >= $87a23dccae47b18a$var$U0 && $.charCodeAt(Z) <= $87a23dccae47b18a$var$H0 || $.charCodeAt(Z) >= $87a23dccae47b18a$var$d && $.charCodeAt(Z) <= $87a23dccae47b18a$var$l || $.charCodeAt(Z) >= $87a23dccae47b18a$var$o && $.charCodeAt(Z) <= $87a23dccae47b18a$var$i || $.charCodeAt(Z) === $87a23dccae47b18a$var$p);)Z++;
    let q = $.slice(G, Z);
    if (!q) return null;
    let J = Z;
    for(; Z < V && ($.charCodeAt(Z) === $87a23dccae47b18a$var$b || $.charCodeAt(Z) === $87a23dccae47b18a$var$R || $.charCodeAt(Z) === $87a23dccae47b18a$var$x);)Z++;
    let F = $.slice(J, Z);
    if (Z === J && Z < V) {
        var W = $.charCodeAt(Z);
        if (W !== $87a23dccae47b18a$var$c && W !== $87a23dccae47b18a$var$j0) return null;
    }
    let X = Z, H = {}, z = !1;
    for(; Z < V;){
        let E = $.charCodeAt(Z);
        if (E === $87a23dccae47b18a$var$c) {
            let L = $.slice(X, Z);
            return {
                tag: q,
                attrs: H,
                selfClosing: !1,
                end: Z + 1,
                rawAttrs: L,
                whitespaceBeforeAttrs: F,
                isClosing: Y,
                hasSpaceBeforeSlash: z
            };
        }
        if (E === $87a23dccae47b18a$var$b || E === $87a23dccae47b18a$var$R || E === $87a23dccae47b18a$var$x) {
            Z++;
            continue;
        }
        if (E === $87a23dccae47b18a$var$j0 && Z + 1 < V && $.charCodeAt(Z + 1) === $87a23dccae47b18a$var$c) {
            let L = $.slice(X, Z);
            return z = Z > X && $.charCodeAt(Z - 1) === $87a23dccae47b18a$var$b, {
                tag: q,
                attrs: H,
                selfClosing: !0,
                end: Z + 2,
                rawAttrs: L,
                whitespaceBeforeAttrs: F,
                isClosing: Y,
                hasSpaceBeforeSlash: z
            };
        }
        var D = Z, j = $.charCodeAt(Z);
        if (!(j >= $87a23dccae47b18a$var$U0 && j <= $87a23dccae47b18a$var$H0 || j >= $87a23dccae47b18a$var$d && j <= $87a23dccae47b18a$var$l || j === $87a23dccae47b18a$var$z0 || j === $87a23dccae47b18a$var$E0)) return null;
        for(Z++; Z < V;){
            var U = $.charCodeAt(Z);
            if (U >= $87a23dccae47b18a$var$U0 && U <= $87a23dccae47b18a$var$H0 || U >= $87a23dccae47b18a$var$d && U <= $87a23dccae47b18a$var$l || U >= $87a23dccae47b18a$var$o && U <= $87a23dccae47b18a$var$i || U === $87a23dccae47b18a$var$z0 || U === $87a23dccae47b18a$var$d0 || U === $87a23dccae47b18a$var$E0 || U === $87a23dccae47b18a$var$p) Z++;
            else break;
        }
        for(var B = $.slice(D, Z); Z < V && ($.charCodeAt(Z) === $87a23dccae47b18a$var$b || $.charCodeAt(Z) === $87a23dccae47b18a$var$R);)Z++;
        if ($.charCodeAt(Z) !== $87a23dccae47b18a$var$C0) {
            H[B] = "";
            continue;
        }
        for(Z++; Z < V && ($.charCodeAt(Z) === $87a23dccae47b18a$var$b || $.charCodeAt(Z) === $87a23dccae47b18a$var$R);)Z++;
        var M = $.charCodeAt(Z);
        if (M === $87a23dccae47b18a$var$M9 || M === $87a23dccae47b18a$var$S9) {
            Z++;
            for(var A = Z; Z < V && $.charCodeAt(Z) !== M;)Z++;
            if (Z >= V) return null;
            if (H[B] = $.slice(A, Z), Z++, Z < V) {
                var k = $.charCodeAt(Z);
                if (k !== $87a23dccae47b18a$var$b && k !== $87a23dccae47b18a$var$R && k !== $87a23dccae47b18a$var$x && k !== $87a23dccae47b18a$var$c && k !== $87a23dccae47b18a$var$j0) return null;
            }
        } else if (M === $87a23dccae47b18a$var$g9) {
            var _ = 1, A = Z;
            for(Z++; Z < V && _ > 0;){
                var U = $.charCodeAt(Z);
                U === $87a23dccae47b18a$var$g9 ? _++ : U === $87a23dccae47b18a$var$D$ && _--, Z++;
            }
            H[B] = $.slice(A, Z);
        } else {
            for(var A = Z; Z < V;){
                var O = $.charCodeAt(Z);
                if (O === $87a23dccae47b18a$var$b || O === $87a23dccae47b18a$var$R || O === $87a23dccae47b18a$var$c || O === $87a23dccae47b18a$var$x || O === $87a23dccae47b18a$var$M9 || O === $87a23dccae47b18a$var$S9 || O === $87a23dccae47b18a$var$C0 || O === $87a23dccae47b18a$var$Z0 || O === $87a23dccae47b18a$var$$0) break;
                Z++;
            }
            if (Z === A) return null;
            H[B] = $.slice(A, Z);
        }
    }
    return null;
}
function $87a23dccae47b18a$var$c6($, Q, Z) {
    if (!Z.optimizeForStreaming && $.indexOf("[") === -1) return !1;
    for(var V = 0, Y = $.length, G = !1, K = !1; V < Y;){
        for(var q = $.indexOf(`
`, V), J = q < 0 ? Y : q, F = V, W = 0; F < J && W < 4;)if ($.charCodeAt(F) === $87a23dccae47b18a$var$b) W++, F++;
        else if ($.charCodeAt(F) === $87a23dccae47b18a$var$R) W += 4, F++;
        else break;
        if (F >= J) {
            G = !1, V = q < 0 ? Y : q + 1;
            continue;
        }
        if (W < 4) {
            var X = $.charCodeAt(F);
            if (X === $87a23dccae47b18a$var$$0 || X === $87a23dccae47b18a$var$A0) {
                for(var H = X, z = 0, D = F; D < J && $.charCodeAt(D) === H;)z++, D++;
                if (z >= 3) {
                    var j = !0;
                    if (H === $87a23dccae47b18a$var$$0) {
                        for(var U = D; U < J; U++)if ($.charCodeAt(U) === $87a23dccae47b18a$var$$0) {
                            j = !1;
                            break;
                        }
                    }
                    if (j) {
                        G = !1;
                        for(var B = q < 0 ? Y : q + 1; B < Y;){
                            for(var M = B, A = 0; M < Y && A < 4;){
                                var k = $.charCodeAt(M);
                                if (k === $87a23dccae47b18a$var$b) A++, M++;
                                else if (k === $87a23dccae47b18a$var$R) A += 4, M++;
                                else break;
                            }
                            if (A < 4 && M < Y && $.charCodeAt(M) === H) {
                                for(var _ = 0; M < Y && $.charCodeAt(M) === H;)_++, M++;
                                if (_ >= z) {
                                    for(; M < Y && ($.charCodeAt(M) === $87a23dccae47b18a$var$b || $.charCodeAt(M) === $87a23dccae47b18a$var$R);)M++;
                                    if (M >= Y || $.charCodeAt(M) === $87a23dccae47b18a$var$x) {
                                        V = M >= Y ? Y : M + 1;
                                        break;
                                    }
                                }
                            }
                            for(; B < Y && $.charCodeAt(B) !== $87a23dccae47b18a$var$x;)B++;
                            B < Y && B++;
                        }
                        B >= Y && (V = Y, K = !0);
                        continue;
                    }
                }
            }
        }
        for(var O = F; O < J && $.charCodeAt(O) === $87a23dccae47b18a$var$c;){
            O++, O < J && $.charCodeAt(O) === $87a23dccae47b18a$var$b && O++;
            for(var E = 0; O < J && E < 4;)if ($.charCodeAt(O) === $87a23dccae47b18a$var$b) E++, O++;
            else if ($.charCodeAt(O) === $87a23dccae47b18a$var$R) E += 4, O++;
            else break;
            if (E >= 4) break;
            G = !1;
        }
        if (!G && W < 4 && O < J && $.charCodeAt(O) === $87a23dccae47b18a$var$O0 && !(O + 1 < Y && $.charCodeAt(O + 1) === $87a23dccae47b18a$var$e0)) {
            var L = $87a23dccae47b18a$var$l6($, O, Q);
            if (L) {
                V = L, G = !1;
                continue;
            }
        }
        var y = $.charCodeAt(F);
        if (y === $87a23dccae47b18a$var$J9 && W < 4) G = !1;
        else if (W < 4 && (y === $87a23dccae47b18a$var$p || y === $87a23dccae47b18a$var$B0 || y === $87a23dccae47b18a$var$z0)) {
            for(var I = F, f = 0; I < J;){
                var w = $.charCodeAt(I);
                if (w === y) f++;
                else if (w !== $87a23dccae47b18a$var$b && w !== $87a23dccae47b18a$var$R) break;
                I++;
            }
            G = !(f >= 3 && I >= J);
        } else G = !0;
        V = q < 0 ? Y : q + 1;
    }
    return K;
}
function $87a23dccae47b18a$var$l6($, Q, Z) {
    let V = $.length;
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$O0) return null;
    let Y = Q + 1 < V && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$e0, G = Q + 1;
    for(; G < V;){
        var K = $.charCodeAt(G);
        if (K === $87a23dccae47b18a$var$p0) {
            G++;
            break;
        }
        if (K === $87a23dccae47b18a$var$O0) return null;
        K === $87a23dccae47b18a$var$N0 && G + 1 < V && G++, G++;
    }
    if (G > V || $.charCodeAt(G - 1) !== $87a23dccae47b18a$var$p0) return null;
    let q = $.slice(Q + 1, G - 1);
    if (q.length > 999) return null;
    let J = $87a23dccae47b18a$var$M$(q);
    if (!J || G >= V || $.charCodeAt(G) !== $87a23dccae47b18a$var$E0) return null;
    G++;
    let F = !1;
    for(; G < V;){
        let T = $.charCodeAt(G);
        if (T === $87a23dccae47b18a$var$b || T === $87a23dccae47b18a$var$R) G++;
        else if (T === $87a23dccae47b18a$var$x && !F) F = !0, G++;
        else break;
    }
    if (Y) {
        let T = $.indexOf(`
`, G), m = T < 0 ? V : T, C = $.slice(G, m).trim();
        return Z[J] = {
            target: C,
            title: void 0
        }, T < 0 ? V : T + 1;
    }
    var W;
    if (G < V && $.charCodeAt(G) === $87a23dccae47b18a$var$Z0) {
        G++;
        for(var X = G; G < V && $.charCodeAt(G) !== $87a23dccae47b18a$var$c && $.charCodeAt(G) !== $87a23dccae47b18a$var$x;)$.charCodeAt(G) === $87a23dccae47b18a$var$N0 && G + 1 < V && G++, G++;
        if (G >= V || $.charCodeAt(G) !== $87a23dccae47b18a$var$c) return null;
        W = $.slice(X, G), G++;
        for(var H = $.indexOf(`
`, G), z = H < 0 ? V : H, D = G; D < z && ($.charCodeAt(D) === $87a23dccae47b18a$var$b || $.charCodeAt(D) === $87a23dccae47b18a$var$R);)D++;
        if (D < z) {
            if (D === G) return null;
            var j = $.charCodeAt(D);
            if (j !== $87a23dccae47b18a$var$M9 && j !== $87a23dccae47b18a$var$S9 && j !== $87a23dccae47b18a$var$$9) return null;
        }
    } else {
        for(var X = G, U = 0; G < V;){
            var K = $.charCodeAt(G);
            if (K === $87a23dccae47b18a$var$$9) U++;
            else if (K === $87a23dccae47b18a$var$Z9) {
                if (U === 0) break;
                U--;
            } else {
                if (K === $87a23dccae47b18a$var$b || K === $87a23dccae47b18a$var$R || K === $87a23dccae47b18a$var$x) break;
                K === $87a23dccae47b18a$var$N0 && G + 1 < V && G++;
            }
            G++;
        }
        if (W = $.slice(X, G), !W) return null;
    }
    for(; G < V && ($.charCodeAt(G) === $87a23dccae47b18a$var$b || $.charCodeAt(G) === $87a23dccae47b18a$var$R);)G++;
    var B = $.indexOf(`
`, G), M = B < 0 ? V : B, A, k = !1, _ = G, O = G;
    if (G === M && G < V) for(O = G + 1; O < V && ($.charCodeAt(O) === $87a23dccae47b18a$var$b || $.charCodeAt(O) === $87a23dccae47b18a$var$R);)O++;
    if (O < V) {
        var E = $.charCodeAt(O);
        if (E === $87a23dccae47b18a$var$M9 || E === $87a23dccae47b18a$var$S9 || E === $87a23dccae47b18a$var$$9) {
            for(var L = E === $87a23dccae47b18a$var$$9 ? 41 : E, y = O + 1, I = y; y < V;){
                var f = $.charCodeAt(y);
                if (f === L) {
                    for(var w = y + 1; w < V && ($.charCodeAt(w) === $87a23dccae47b18a$var$b || $.charCodeAt(w) === $87a23dccae47b18a$var$R);)w++;
                    (w >= V || $.charCodeAt(w) === $87a23dccae47b18a$var$x) && (A = $.slice(I, y), k = !0, _ = w < V ? w + 1 : V);
                    break;
                }
                if (f === $87a23dccae47b18a$var$N0 && y + 1 < V) {
                    y += 2;
                    continue;
                }
                if (f === $87a23dccae47b18a$var$x && y + 1 < V && $.charCodeAt(y + 1) === $87a23dccae47b18a$var$x) break;
                y++;
            }
            if (!k && O === G) return null;
        }
    }
    if (k) return Z[J] || (Z[J] = {
        target: $87a23dccae47b18a$var$$$(W),
        title: A !== void 0 ? $87a23dccae47b18a$var$s9($87a23dccae47b18a$var$$$(A)) : A
    }), _;
    for(; G < M && ($.charCodeAt(G) === $87a23dccae47b18a$var$b || $.charCodeAt(G) === $87a23dccae47b18a$var$R);)G++;
    return G < M ? null : (Z[J] || (Z[J] = {
        target: $87a23dccae47b18a$var$$$(W),
        title: A
    }), B < 0 ? V : B + 1);
}
var $87a23dccae47b18a$var$u0 = new Uint8Array($87a23dccae47b18a$var$B6);
for($87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$B$] = $87a23dccae47b18a$var$v9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$J9] |= $87a23dccae47b18a$var$Q9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$c] |= $87a23dccae47b18a$var$Q9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$p] |= $87a23dccae47b18a$var$Q9 | $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$A9] |= $87a23dccae47b18a$var$Q9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$B0] |= $87a23dccae47b18a$var$Q9 | $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$z0] |= $87a23dccae47b18a$var$Q9 | $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$$0] |= $87a23dccae47b18a$var$Q9 | $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$A0] |= $87a23dccae47b18a$var$Q9 | $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$Z0] |= $87a23dccae47b18a$var$Q9 | $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$O0] |= $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$x0] |= $87a23dccae47b18a$var$_9, $87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$w0] |= $87a23dccae47b18a$var$Q9, $87a23dccae47b18a$var$q$ = $87a23dccae47b18a$var$o; $87a23dccae47b18a$var$q$ <= $87a23dccae47b18a$var$i; $87a23dccae47b18a$var$q$++)$87a23dccae47b18a$var$u0[$87a23dccae47b18a$var$q$] |= $87a23dccae47b18a$var$Q9;
var $87a23dccae47b18a$var$q$;
function $87a23dccae47b18a$var$k6($) {
    if ($.indexOf("[") < 0 && $.indexOf("]") < 0) return !1;
    for(var Q = 0; Q < $.length; Q++){
        if ($.charCodeAt(Q) === $87a23dccae47b18a$var$N0) {
            Q++;
            continue;
        }
        if ($.charCodeAt(Q) === $87a23dccae47b18a$var$O0 || $.charCodeAt(Q) === $87a23dccae47b18a$var$p0) return !0;
    }
    return !1;
}
function $87a23dccae47b18a$var$M$($) {
    var Q = $.replace(/\s+/g, " ").trim();
    return Q.indexOf("\u1E9E") !== -1 ? Q.replace(/\u1E9E/g, "ss").toLowerCase() : Q.toLowerCase();
}
function $87a23dccae47b18a$var$l$($) {
    return $ < $87a23dccae47b18a$var$n9 ? $87a23dccae47b18a$var$u0[$] : $ === $87a23dccae47b18a$var$K6 ? $87a23dccae47b18a$var$v9 : 0;
}
function $87a23dccae47b18a$var$$$($) {
    return $.indexOf("\\") === -1 ? $ : $.replace(/\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, "$1");
}
var $87a23dccae47b18a$var$r6 = null, $87a23dccae47b18a$var$o6 = -1, $87a23dccae47b18a$var$i6 = -1;
function $87a23dccae47b18a$var$G0($, Q) {
    if (Q === $87a23dccae47b18a$var$o6 && $ === $87a23dccae47b18a$var$r6) return $87a23dccae47b18a$var$i6;
    var Z = $.indexOf(`
`, Q);
    return Z < 0 ? $.length : Z;
}
function $87a23dccae47b18a$var$t($, Q) {
    let Z = $87a23dccae47b18a$var$G0($, Q);
    return Z < $.length ? Z + 1 : Z;
}
function $87a23dccae47b18a$var$J$($, Q, Z) {
    for(; Q < Z;){
        let V = $.charCodeAt(Q);
        if (V !== $87a23dccae47b18a$var$b && V !== $87a23dccae47b18a$var$R) break;
        Q++;
    }
    return Q;
}
function $87a23dccae47b18a$var$L6($, Q) {
    let Z = $87a23dccae47b18a$var$t($, Q);
    for(; Z < $.length;){
        let V = $87a23dccae47b18a$var$G0($, Z);
        if ($87a23dccae47b18a$var$l0($, Z, V)) return Z;
        Z = $87a23dccae47b18a$var$t($, Z);
    }
    return $.length;
}
function $87a23dccae47b18a$var$P9($, Q, Z, V) {
    let Y = 0;
    for(; Q + Y < Z && $.charCodeAt(Q + Y) === V;)Y++;
    return Y;
}
var $87a23dccae47b18a$var$Y0 = 0, $87a23dccae47b18a$var$Q0 = 0;
function $87a23dccae47b18a$var$v0($, Q, Z) {
    for($87a23dccae47b18a$var$Y0 = 0, $87a23dccae47b18a$var$Q0 = 0; Q + $87a23dccae47b18a$var$Q0 < Z;){
        let V = $.charCodeAt(Q + $87a23dccae47b18a$var$Q0);
        if (V === $87a23dccae47b18a$var$R) $87a23dccae47b18a$var$Y0 += 4 - $87a23dccae47b18a$var$Y0 % 4;
        else if (V === $87a23dccae47b18a$var$b) $87a23dccae47b18a$var$Y0++;
        else break;
        $87a23dccae47b18a$var$Q0++;
    }
}
function $87a23dccae47b18a$var$l0($, Q, Z) {
    return $87a23dccae47b18a$var$J$($, Q, Z) >= Z;
}
function $87a23dccae47b18a$var$a6($, Q, Z, V) {
    let Y = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, Y), $87a23dccae47b18a$var$Y0 > 3) return null;
    let G = Q + $87a23dccae47b18a$var$Q0;
    if ($.charCodeAt(G) !== $87a23dccae47b18a$var$J9) return null;
    let K = $87a23dccae47b18a$var$P9($, G, Y, 35);
    if (K < 1 || K > 6 || (G += K, G < Y && $.charCodeAt(G) !== $87a23dccae47b18a$var$b && $.charCodeAt(G) !== $87a23dccae47b18a$var$R)) return null;
    G = $87a23dccae47b18a$var$J$($, G, Y);
    for(var q = Y; q > G && $.charCodeAt(q - 1) === $87a23dccae47b18a$var$b;)q--;
    for(var J = q; q > G && $.charCodeAt(q - 1) === $87a23dccae47b18a$var$J9;)q--;
    if (q < J) {
        if (q === G || $.charCodeAt(q - 1) === $87a23dccae47b18a$var$b) for(; q > G && $.charCodeAt(q - 1) === $87a23dccae47b18a$var$b;)q--;
        else q = J;
    }
    let F = $.slice(G, q), W = $87a23dccae47b18a$var$h0(F, 0, F.length, Z, V), H = (V?.slugify || $87a23dccae47b18a$export$c383cdd2a518017a)(F);
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.heading,
            level: K,
            children: W,
            id: H
        },
        end: $87a23dccae47b18a$var$t($, Y)
    };
}
function $87a23dccae47b18a$var$uZ($, Q, Z) {
    var V = $.charCodeAt(Q);
    if (V !== $87a23dccae47b18a$var$C0 && V !== $87a23dccae47b18a$var$p) return !1;
    for(var Y = Q; Y < Z && $.charCodeAt(Y) === V;)Y++;
    for(; Y < Z && ($.charCodeAt(Y) === $87a23dccae47b18a$var$b || $.charCodeAt(Y) === $87a23dccae47b18a$var$R);)Y++;
    return Y >= Z;
}
function $87a23dccae47b18a$var$f9($, Q) {
    let Z = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, Z), $87a23dccae47b18a$var$Y0 > 3) return null;
    let V = Q + $87a23dccae47b18a$var$Q0, Y = $.charCodeAt(V);
    if (Y !== $87a23dccae47b18a$var$p && Y !== $87a23dccae47b18a$var$B0 && Y !== $87a23dccae47b18a$var$z0) return null;
    let G = 0;
    for(; V < Z;){
        let K = $.charCodeAt(V);
        if (K === Y) G++;
        else if (K !== $87a23dccae47b18a$var$b && K !== $87a23dccae47b18a$var$R) return null;
        V++;
    }
    return G < 3 ? null : {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.breakThematic
        },
        end: $87a23dccae47b18a$var$t($, Z)
    };
}
function $87a23dccae47b18a$var$pZ($, Q, Z) {
    let V = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, V), $87a23dccae47b18a$var$Y0 > 3) return null;
    let Y = $87a23dccae47b18a$var$Y0, G = $87a23dccae47b18a$var$Q0, K = Q + $87a23dccae47b18a$var$Q0, q = $.charCodeAt(K);
    if (q !== $87a23dccae47b18a$var$$0 && q !== $87a23dccae47b18a$var$A0) return null;
    let J = $87a23dccae47b18a$var$P9($, K, V, q);
    if (J < 3) return null;
    K += J;
    let F = $87a23dccae47b18a$var$J$($, K, V), W = V;
    if (q === $87a23dccae47b18a$var$$0) {
        for(let y = F; y < V; y++)if ($.charCodeAt(y) === $87a23dccae47b18a$var$$0) return null;
    }
    for(; W > F && ($.charCodeAt(W - 1) === $87a23dccae47b18a$var$b || $.charCodeAt(W - 1) === $87a23dccae47b18a$var$R);)W--;
    let X = $.slice(F, W), H = "", z = "", D = X.indexOf(" ");
    D === -1 ? H = X : (H = X.slice(0, D), z = X.slice(D + 1).trim()), H = $87a23dccae47b18a$var$$$(H);
    var j = void 0;
    if (z) {
        $87a23dccae47b18a$var$R6.lastIndex = 0;
        for(var U; (U = $87a23dccae47b18a$var$R6.exec(z)) !== null;)j || (j = {}), j[U[1]] = U[2] !== void 0 ? U[2] : U[3];
    }
    let B = $87a23dccae47b18a$var$t($, V), M = B, A = $.length;
    for(; M < $.length;){
        let y = $87a23dccae47b18a$var$G0($, M);
        if ($87a23dccae47b18a$var$v0($, M, y), $87a23dccae47b18a$var$Y0 < 4) {
            let I = M + $87a23dccae47b18a$var$Q0;
            var k = $87a23dccae47b18a$var$P9($, I, y, q);
            if (k >= J) {
                let f = I + k;
                if ($87a23dccae47b18a$var$l0($, f, y)) {
                    A = $87a23dccae47b18a$var$t($, y);
                    break;
                }
            }
        }
        M = $87a23dccae47b18a$var$t($, y);
    }
    var _;
    if (Y === 0) _ = M > B && $.charCodeAt(M - 1) === $87a23dccae47b18a$var$x ? $.slice(B, M - 1) : $.slice(B, M);
    else {
        _ = "";
        for(var O = B; O < M;){
            var E = $87a23dccae47b18a$var$G0($, O);
            $87a23dccae47b18a$var$v0($, O, E);
            var L = Math.min($87a23dccae47b18a$var$Q0, Y);
            _ += $.slice(O + L, E) + `
`, O = $87a23dccae47b18a$var$t($, E);
        }
        _.length > 0 && _.charCodeAt(_.length - 1) === $87a23dccae47b18a$var$x && (_ = _.slice(0, -1));
    }
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.codeBlock,
            lang: H || void 0,
            text: _,
            infoString: z || void 0,
            attrs: j
        },
        end: A
    };
}
function $87a23dccae47b18a$var$dZ($, Q) {
    let Z = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, Z), $87a23dccae47b18a$var$Y0 < 4) return null;
    let V = "", Y = Q;
    for(; Y < $.length;){
        let z = $87a23dccae47b18a$var$G0($, Y);
        if ($87a23dccae47b18a$var$v0($, Y, z), $87a23dccae47b18a$var$l0($, Y, z)) {
            for(var G = 0, K = $87a23dccae47b18a$var$t($, z); K < $.length;){
                var q = $87a23dccae47b18a$var$G0($, K);
                if ($87a23dccae47b18a$var$l0($, K, q)) {
                    G++, K = $87a23dccae47b18a$var$t($, q);
                    continue;
                }
                if ($87a23dccae47b18a$var$v0($, K, q), $87a23dccae47b18a$var$Y0 >= 4) {
                    for(var J = 0; J <= G; J++)V += `
`;
                    Y = K;
                    break;
                }
                break;
            }
            if (Y !== K) break;
            continue;
        }
        if ($87a23dccae47b18a$var$Y0 < 4) break;
        let D = 0, j = 0;
        var F = 0;
        for(let U = Y; U < z && j < 4; U++){
            if ($.charCodeAt(U) === $87a23dccae47b18a$var$R) {
                var W = 4 - j % 4;
                j + W > 4 && (F = j + W - 4), j += W;
            } else j++;
            D++;
        }
        var X = "";
        if (F > 0) for(var H = 0; H < F; H++)X += " ";
        X += $.slice(Y + D, z), V += X + `
`, Y = $87a23dccae47b18a$var$t($, z);
    }
    for(; V.length > 0 && V.charCodeAt(V.length - 1) === $87a23dccae47b18a$var$x;)V = V.slice(0, -1);
    for(; V.length > 0 && V.charCodeAt(V.length - 1) === $87a23dccae47b18a$var$x;)V = V.slice(0, -1);
    return V ? {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.codeBlock,
            lang: void 0,
            text: V,
            infoString: void 0,
            attrs: void 0
        },
        end: Y
    } : null;
}
function $87a23dccae47b18a$var$cZ($, Q, Z, V) {
    let Y = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, Y), $87a23dccae47b18a$var$Y0 > 3) return null;
    let G = Q + $87a23dccae47b18a$var$Q0;
    if ($.charCodeAt(G) !== $87a23dccae47b18a$var$c) return null;
    let K = "", q = Q, J, F = !1, W = !1, X = !1;
    for(; q < $.length;){
        let g = $87a23dccae47b18a$var$G0($, q);
        $87a23dccae47b18a$var$v0($, q, g);
        let X0 = q + $87a23dccae47b18a$var$Q0;
        if ($.charCodeAt(X0) === $87a23dccae47b18a$var$c) {
            let J0 = X0 + 1;
            var H = $87a23dccae47b18a$var$Y0 + 1, z = !1;
            if (J0 < g) {
                var D = $.charCodeAt(J0);
                D === $87a23dccae47b18a$var$b ? (J0++, H++, z = !0) : D === $87a23dccae47b18a$var$R && (z = !0);
            }
            for(var j = "", U = !1, B = J0; B < g; B++)if ($.charCodeAt(B) === $87a23dccae47b18a$var$R) {
                U = !0;
                break;
            }
            if (U) {
                var M = H;
                if (z && J0 < g && $.charCodeAt(J0) === $87a23dccae47b18a$var$R) {
                    for(var A = 4 - M % 4, k = 0; k < A - 1; k++)j += " ";
                    M += A, J0++;
                }
                for(var _ = J0; _ < g; _++)if ($.charCodeAt(_) === $87a23dccae47b18a$var$R) {
                    for(var O = 4 - M % 4, E = 0; E < O; E++)j += " ";
                    M += O;
                } else j += $[_], M++;
            } else j = $.slice(J0, g);
            if (!K && !J) {
                let P = j.match(/^\[!([A-Za-z]+)\]\s*$/);
                if (P) {
                    J = P[1].toUpperCase(), q = $87a23dccae47b18a$var$t($, g);
                    continue;
                }
            }
            K += j + `
`;
            var L = j.trimStart();
            L.startsWith("```") || L.startsWith("~~~") ? X = !X : j.startsWith("    ") || j.startsWith("	") ? X = !0 : L.length > 0 && !X && (X = !1), W = L.length > 0, q = $87a23dccae47b18a$var$t($, g);
        } else if (K && !$87a23dccae47b18a$var$l0($, q, g) && W) {
            if ($87a23dccae47b18a$var$Y0 < 4) {
                var y = q + $87a23dccae47b18a$var$Q0, I = y < g ? $.charCodeAt(y) : 0;
                if (I === $87a23dccae47b18a$var$J9 || I === $87a23dccae47b18a$var$c || I === $87a23dccae47b18a$var$$0 || I === $87a23dccae47b18a$var$A0 || I === $87a23dccae47b18a$var$Z0 || (I === $87a23dccae47b18a$var$p || I === $87a23dccae47b18a$var$B0 || I === $87a23dccae47b18a$var$z0) && $87a23dccae47b18a$var$f9($, q) || (I === $87a23dccae47b18a$var$p || I === $87a23dccae47b18a$var$B0 || I === $87a23dccae47b18a$var$A9) && y + 1 < g && ($.charCodeAt(y + 1) === $87a23dccae47b18a$var$b || $.charCodeAt(y + 1) === $87a23dccae47b18a$var$R)) break;
                if (I >= $87a23dccae47b18a$var$o && I <= $87a23dccae47b18a$var$i) {
                    for(var f = y; f < g && $.charCodeAt(f) >= $87a23dccae47b18a$var$o && $.charCodeAt(f) <= $87a23dccae47b18a$var$i;)f++;
                    if (f < g && ($.charCodeAt(f) === $87a23dccae47b18a$var$d0 || $.charCodeAt(f) === $87a23dccae47b18a$var$Z9)) break;
                }
            }
            if (X) break;
            K += $.slice(q, g) + `
`, F = !0, q = $87a23dccae47b18a$var$t($, g);
        } else break;
    }
    if (!K && !J) return null;
    var { inBlockQuote: w, g: T } = Z;
    Z.inBlockQuote = !0, F && (Z.g = !0);
    let m = $87a23dccae47b18a$var$b9(K || "", Z, V);
    return Z.inBlockQuote = w, Z.g = T, {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.blockQuote,
            children: m,
            alert: J || void 0
        },
        end: q
    };
}
function $87a23dccae47b18a$var$n6($, Q, Z) {
    for(var V = 0, Y = Q; Y < Z; Y++)$.charCodeAt(Y) === $87a23dccae47b18a$var$R ? V += 4 - V % 4 : V++;
    return V;
}
function $87a23dccae47b18a$var$E9($, Q, Z) {
    if ($87a23dccae47b18a$var$v0($, Q, Z), $87a23dccae47b18a$var$Y0 > 3) return null;
    var V = Q + $87a23dccae47b18a$var$Q0;
    if (V >= Z) return null;
    var Y = $.charCodeAt(V), G = $87a23dccae47b18a$var$Y0, K = V;
    if (Y === $87a23dccae47b18a$var$p || Y === $87a23dccae47b18a$var$B0 || Y === $87a23dccae47b18a$var$A9) {
        if (K = V + 1, K < Z && $.charCodeAt(K) !== $87a23dccae47b18a$var$b && $.charCodeAt(K) !== $87a23dccae47b18a$var$R && $.charCodeAt(K) !== $87a23dccae47b18a$var$x) return null;
    } else if (Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i) {
        for(var q = V; q < Z && q - V < 9;){
            var J = $.charCodeAt(q);
            if (J < $87a23dccae47b18a$var$o || J > $87a23dccae47b18a$var$i) break;
            q++;
        }
        if (q > V && q < Z) {
            var F = $.charCodeAt(q);
            if (F === $87a23dccae47b18a$var$d0 || F === $87a23dccae47b18a$var$Z9) {
                if (K = q + 1, K < Z && $.charCodeAt(K) !== $87a23dccae47b18a$var$b && $.charCodeAt(K) !== $87a23dccae47b18a$var$R && $.charCodeAt(K) !== $87a23dccae47b18a$var$x) return null;
            } else return null;
        } else return null;
    } else return null;
    var W = K, X = $87a23dccae47b18a$var$n6($, Q, K), H = 0, z = W, D = X;
    if (W >= Z) return {
        ordered: Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i,
        marker: Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i ? $[q] : $[V],
        start: Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i ? parseInt($.slice(V, q), 10) : void 0,
        contentStart: W,
        contentCol: X + 1,
        markerCol: G,
        isEmpty: !0
    };
    for(; z < Z && ($.charCodeAt(z) === $87a23dccae47b18a$var$b || $.charCodeAt(z) === $87a23dccae47b18a$var$R);){
        if ($.charCodeAt(z) === $87a23dccae47b18a$var$R) {
            var j = 4 - D % 4;
            D += j;
        } else D++;
        z++, H++;
    }
    var U = z >= Z, B = D - X;
    return U || B > 4 ? (D = X + 1, z = W + 1, H = 1) : H === 0 && (D = X + 1, z = W, H = 1), {
        ordered: Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i,
        marker: Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i ? $[q] : $[V],
        start: Y >= $87a23dccae47b18a$var$o && Y <= $87a23dccae47b18a$var$i ? parseInt($.slice(V, q), 10) : void 0,
        contentStart: z,
        contentCol: D,
        markerCol: G,
        isEmpty: U
    };
}
var $87a23dccae47b18a$var$A$ = 0;
function $87a23dccae47b18a$var$lZ($, Q, Z, V) {
    var Y = 0, G = Q;
    for($87a23dccae47b18a$var$A$ = 0; G < Z && Y < V;){
        var K = $.charCodeAt(G);
        if (K === $87a23dccae47b18a$var$R) {
            var q = 4 - Y % 4;
            if (Y + q > V) {
                $87a23dccae47b18a$var$A$ = Y + q - V, G++, Y = V;
                break;
            }
            Y += q;
        } else if (K === $87a23dccae47b18a$var$b) Y++;
        else break;
        G++;
    }
    return G;
}
function $87a23dccae47b18a$var$S6($, Q, Z, V) {
    var Y = $87a23dccae47b18a$var$G0($, Q), G = $87a23dccae47b18a$var$E9($, Q, Y);
    if (!G) return null;
    var K = [], q = Q, J = G.contentCol, F = "", W = G.isEmpty, X = !1, H = !1;
    if (!G.isEmpty) {
        for(var z = !1, D = G.contentStart; D < Y; D++)if ($.charCodeAt(D) === $87a23dccae47b18a$var$R) {
            z = !0;
            break;
        }
        if (z) {
            var j = "", U = $87a23dccae47b18a$var$n6($, Q, G.contentStart), B = U - G.contentCol;
            if (B > 0) for(var M = 0; M < B; M++)j += " ";
            for(var A = G.contentStart; A < Y; A++)if ($.charCodeAt(A) === $87a23dccae47b18a$var$R) {
                for(var k = 4 - U % 4, _ = 0; _ < k; _++)j += " ";
                U += k;
            } else j += $[A], U++;
            F = j + `
`;
        } else F = $.slice(G.contentStart, Y) + `
`;
    }
    for(q = $87a23dccae47b18a$var$t($, Y); q < $.length;){
        var O = $87a23dccae47b18a$var$G0($, q);
        $87a23dccae47b18a$var$v0($, q, O);
        var E = $.charCodeAt(q + $87a23dccae47b18a$var$Q0);
        if ($87a23dccae47b18a$var$Y0 < J && (E === $87a23dccae47b18a$var$p || E === $87a23dccae47b18a$var$B0 || E === $87a23dccae47b18a$var$z0) && $87a23dccae47b18a$var$Y0 <= 3 && $87a23dccae47b18a$var$f9($, q)) break;
        var L = $87a23dccae47b18a$var$E9($, q, O);
        if (L && L.ordered === G.ordered && L.marker === G.marker && L.markerCol < J) {
            K.push({
                contentCol: J,
                raw: F,
                hasBlankAfter: X,
                isEmpty: W
            }), X && (H = !0), J = L.contentCol, W = L.isEmpty, X = !1, F = L.isEmpty ? "" : $.slice(L.contentStart, O) + `
`, q = $87a23dccae47b18a$var$t($, O);
            continue;
        }
        if ($87a23dccae47b18a$var$l0($, q, O)) {
            F += `
`, q = $87a23dccae47b18a$var$t($, O);
            for(var y = !1, I = 0; I < F.length; I++){
                var f = F.charCodeAt(I);
                if (f !== $87a23dccae47b18a$var$x && f !== $87a23dccae47b18a$var$B9 && f !== $87a23dccae47b18a$var$b && f !== $87a23dccae47b18a$var$R) {
                    y = !0;
                    break;
                }
            }
            if (W && !y) {
                if (q < $.length) {
                    var w = $87a23dccae47b18a$var$G0($, q), T = $87a23dccae47b18a$var$E9($, q, w);
                    if (!T || T.ordered !== G.ordered || T.marker !== G.marker) break;
                    X = !0;
                } else break;
            }
            if (q < $.length) {
                var m = $87a23dccae47b18a$var$G0($, q);
                $87a23dccae47b18a$var$v0($, q, m);
                var C = $.charCodeAt(q + $87a23dccae47b18a$var$Q0);
                if ((C === $87a23dccae47b18a$var$p || C === $87a23dccae47b18a$var$B0 || C === $87a23dccae47b18a$var$z0) && $87a23dccae47b18a$var$Y0 <= 3 && $87a23dccae47b18a$var$f9($, q)) break;
                var g = $87a23dccae47b18a$var$E9($, q, m);
                if (g && g.ordered === G.ordered && g.marker === G.marker && g.markerCol < J) {
                    X = !0;
                    continue;
                }
                if (!$87a23dccae47b18a$var$l0($, q, m) && $87a23dccae47b18a$var$Y0 < J) break;
            }
            continue;
        }
        if ($87a23dccae47b18a$var$Y0 >= J) {
            var X0 = $87a23dccae47b18a$var$lZ($, q, O, J);
            if ($87a23dccae47b18a$var$A$ > 0) {
                for(var J0 = "", P = J, a = 0; a < $87a23dccae47b18a$var$A$; a++)J0 += " ", P++;
                for(var r = X0; r < O; r++)if ($.charCodeAt(r) === $87a23dccae47b18a$var$R) {
                    for(var y0 = 4 - P % 4, R0 = 0; R0 < y0; R0++)J0 += " ";
                    P += y0;
                } else J0 += $[r], P++;
                F += J0 + `
`;
            } else F += $.slice(X0, O) + `
`;
            q = $87a23dccae47b18a$var$t($, O);
            continue;
        }
        for(var F0 = !1, u = 0; u < F.length; u++){
            var n = F.charCodeAt(u);
            if (n !== $87a23dccae47b18a$var$x && n !== $87a23dccae47b18a$var$B9 && n !== $87a23dccae47b18a$var$b && n !== $87a23dccae47b18a$var$R) {
                F0 = !0;
                break;
            }
        }
        if (!X && F0 && !W) {
            var D0 = q + $87a23dccae47b18a$var$Q0, s = $.charCodeAt(D0), M0 = s === $87a23dccae47b18a$var$J9 || s === $87a23dccae47b18a$var$c || s === $87a23dccae47b18a$var$Z0 || s === $87a23dccae47b18a$var$$0 || s === $87a23dccae47b18a$var$A0 || (s === $87a23dccae47b18a$var$p || s === $87a23dccae47b18a$var$B0 || s === $87a23dccae47b18a$var$z0 || s === $87a23dccae47b18a$var$A9) && ($87a23dccae47b18a$var$f9($, q) !== null || $87a23dccae47b18a$var$E9($, q, O) !== null) || s >= $87a23dccae47b18a$var$o && s <= $87a23dccae47b18a$var$i && $87a23dccae47b18a$var$E9($, q, O) !== null;
            if (!M0) {
                F += "" + $.slice(D0, O) + `
`, q = $87a23dccae47b18a$var$t($, O);
                continue;
            }
        }
        break;
    }
    if (K.push({
        contentCol: J,
        raw: F,
        hasBlankAfter: X,
        isEmpty: W
    }), K.length === 0) return null;
    var _0 = H;
    if (!_0) for(var K0 = 0; K0 < K.length; K0++){
        if (K[K0].hasBlankAfter && K0 < K.length - 1) {
            _0 = !0;
            break;
        }
        if (!K[K0].isEmpty) {
            for(var b0 = K[K0].raw, V0 = b0.length, W0 = 0, h = !1, N = !1, e = !1, I0 = !1, a0 = 0, n0 = 0, P0 = -1; W0 < V0;){
                var S = b0.indexOf(`
`, W0);
                if (S < 0 && (S = V0), I0) {
                    $87a23dccae47b18a$var$v0(b0, W0, S);
                    for(var S0 = b0.slice(W0 + $87a23dccae47b18a$var$Q0, S), q0 = 0; q0 < S0.length && S0.charCodeAt(q0) === a0;)q0++;
                    q0 >= n0 && S0.slice(q0).trim() === "" && (I0 = !1), W0 = S < V0 ? S + 1 : V0;
                    continue;
                }
                if ($87a23dccae47b18a$var$l0(b0, W0, S)) {
                    P0 >= 0 ? e = !0 : h && (N = !0), W0 = S < V0 ? S + 1 : V0;
                    continue;
                }
                if ($87a23dccae47b18a$var$v0(b0, W0, S), P0 >= 0) {
                    if ($87a23dccae47b18a$var$Y0 >= P0) {
                        W0 = S < V0 ? S + 1 : V0;
                        continue;
                    }
                    var s0 = $87a23dccae47b18a$var$E9(b0, W0, S);
                    if (s0 && s0.markerCol < P0 && s0.contentCol <= P0) {
                        W0 = S < V0 ? S + 1 : V0;
                        continue;
                    }
                    if (s0) {
                        W0 = S < V0 ? S + 1 : V0;
                        continue;
                    }
                    P0 = -1, e && (N = !0, e = !1);
                }
                var z9 = b0.slice(W0 + $87a23dccae47b18a$var$Q0, S), w9 = z9.charCodeAt(0);
                if ((w9 === $87a23dccae47b18a$var$$0 || w9 === $87a23dccae47b18a$var$A0) && $87a23dccae47b18a$var$Y0 <= 3) {
                    for(var H9 = 0; H9 < z9.length && z9.charCodeAt(H9) === w9;)H9++;
                    if (H9 >= 3) {
                        if (N && h) {
                            _0 = !0;
                            break;
                        }
                        I0 = !0, a0 = w9, n0 = H9, h = !0, W0 = S < V0 ? S + 1 : V0;
                        continue;
                    }
                }
                var F9 = $87a23dccae47b18a$var$Y0 <= 3 ? $87a23dccae47b18a$var$E9(b0, W0, S) : null;
                if (F9 && h) {
                    if (N) {
                        _0 = !0;
                        break;
                    }
                    P0 = F9.contentCol, e = !1, W0 = S < V0 ? S + 1 : V0, h = !0;
                    continue;
                }
                if (N) {
                    _0 = !0;
                    break;
                }
                h = !0, W0 = S < V0 ? S + 1 : V0;
            }
            if (_0) break;
        }
    }
    for(var O9 = [], C9 = 0; C9 < K.length; C9++){
        for(var Z$ = K[C9], D9 = Z$.raw, V9 = D9.length; V9 > 0 && D9.charCodeAt(V9 - 1) === $87a23dccae47b18a$var$x;)V9--;
        var Y9 = V9 < D9.length ? D9.slice(0, V9) : D9, G9 = null;
        if (Y9.length >= 3 && Y9.charCodeAt(0) === $87a23dccae47b18a$var$O0) {
            var U9 = Y9[1];
            (U9 === " " || U9 === "x" || U9 === "X") && Y9.charCodeAt(2) === $87a23dccae47b18a$var$p0 && (G9 = {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.gfmTask,
                completed: U9 === "x" || U9 === "X"
            }, Y9 = Y9.slice(3));
        }
        var k0;
        if (Z$.isEmpty && Y9.trim() === "") k0 = [];
        else if (_0) {
            var y9 = Z.inList;
            Z.inList = !0, k0 = $87a23dccae47b18a$var$b9(Y9, Z, V), Z.inList = y9;
        } else {
            var X9 = Z.inList;
            if (Z.inList = !0, k0 = $87a23dccae47b18a$var$b9(Y9, Z, V), Z.inList = X9, k0.length === 1 && k0[0].type === $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph) k0 = k0[0].children;
            else {
                for(var K9 = [], R9 = 0; R9 < k0.length; R9++)if (k0[R9].type === $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph) for(var r9 = k0[R9].children, q9 = 0; q9 < r9.length; q9++)K9.push(r9[q9]);
                else K9.push(k0[R9]);
                k0 = K9;
            }
        }
        G9 ? O9.push([
            G9,
            {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                text: " "
            },
            ...k0
        ]) : O9.push(k0);
    }
    return {
        node: {
            type: G.ordered ? $87a23dccae47b18a$export$e0aa44767d8750d5.orderedList : $87a23dccae47b18a$export$e0aa44767d8750d5.unorderedList,
            start: G.ordered ? G.start : void 0,
            items: O9
        },
        end: q
    };
}
var $87a23dccae47b18a$var$v$ = new Set([
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
]);
function $87a23dccae47b18a$var$I9($, Q, Z) {
    let V = {};
    for (let [K, q] of Object.entries($)){
        let J = K, F = K.toLowerCase();
        if (F === "style" && typeof q == "string") {
            let W = {}, X = [], H = 0, z = 0;
            for(let j = 0; j < q.length; j++){
                let U = q.charCodeAt(j);
                U === $87a23dccae47b18a$var$$9 ? H++ : U === $87a23dccae47b18a$var$Z9 ? H-- : U === $87a23dccae47b18a$var$T$ && H === 0 && (X.push(q.slice(z, j)), z = j + 1);
            }
            z < q.length && X.push(q.slice(z));
            let D = !1;
            X.forEach((j)=>{
                let U = j.indexOf(":");
                if (U === -1) return;
                let B = j.slice(0, U).trim(), M = j.slice(U + 1).trim();
                if (B && M) {
                    if (/url\s*\(\s*(javascript|vbscript|data:(?!image\/))/i.test(M)) {
                        D = !0;
                        return;
                    }
                    let A = B.indexOf("-") !== -1 ? B.replace(/-([a-z])/g, (k, _)=>_.toUpperCase()) : B;
                    W[A] = M;
                }
            }), !D && Object.keys(W).length > 0 && (V[J] = W);
        } else if ((F === "href" || F === "src") && Z?.sanitizer) {
            let W = Z.sanitizer(q, Q, F);
            W !== null && (V[J] = W);
        } else if (q === "") V[J] = !0;
        else if (q.length >= 2 && q.charCodeAt(0) === $87a23dccae47b18a$var$g9 && q.charCodeAt(q.length - 1) === $87a23dccae47b18a$var$D$) {
            var Y = q.slice(1, -1);
            if (Y.length > 0) {
                var G = Y.charCodeAt(0);
                if (G === $87a23dccae47b18a$var$O0 || G === $87a23dccae47b18a$var$g9) try {
                    V[J] = JSON.parse(Y);
                    continue;
                } catch  {}
            }
            if (Y === "true") {
                V[J] = !0;
                continue;
            }
            if (Y === "false") {
                V[J] = !1;
                continue;
            }
            if (Z?.evalUnserializableExpressions) try {
                V[J] = (0, eval)("(" + Y + ")");
                continue;
            } catch  {}
            V[J] = Y;
        } else V[J] = q;
    }
    return V;
}
function $87a23dccae47b18a$var$T9($, Q, Z) {
    let V = Q.length;
    if (V === 0) return Z;
    var Y = Q.charCodeAt(0), G = Y >= $87a23dccae47b18a$var$d && Y <= $87a23dccae47b18a$var$l || Y >= $87a23dccae47b18a$var$U0 && Y <= $87a23dccae47b18a$var$H0;
    if (!G) {
        for(var K = String.fromCharCode(Y), q = $.length - V, J = Z; J <= q;){
            var F = $.indexOf(K, J);
            if (F === -1 || F > q) return -1;
            for(var W = !0, X = 1; X < V; X++){
                var H = $.charCodeAt(F + X), z = Q.charCodeAt(X);
                if (H >= $87a23dccae47b18a$var$d && H <= $87a23dccae47b18a$var$l && (H += $87a23dccae47b18a$var$i0), z >= $87a23dccae47b18a$var$d && z <= $87a23dccae47b18a$var$l && (z += $87a23dccae47b18a$var$i0), H !== z) {
                    W = !1;
                    break;
                }
            }
            if (W) return F;
            J = F + 1;
        }
        return -1;
    }
    Y >= $87a23dccae47b18a$var$d && Y <= $87a23dccae47b18a$var$l && (Y += $87a23dccae47b18a$var$i0);
    for(let j = Z; j <= $.length - V; j++){
        var D = $.charCodeAt(j);
        if (D >= $87a23dccae47b18a$var$d && D <= $87a23dccae47b18a$var$l && (D += $87a23dccae47b18a$var$i0), D !== Y) continue;
        let U = !0;
        for(let B = 1; B < V; B++){
            let M = $.charCodeAt(j + B), A = Q.charCodeAt(B);
            if (M >= $87a23dccae47b18a$var$d && M <= $87a23dccae47b18a$var$l && (M += $87a23dccae47b18a$var$i0), A >= $87a23dccae47b18a$var$d && A <= $87a23dccae47b18a$var$l && (A += $87a23dccae47b18a$var$i0), M !== A) {
                U = !1;
                break;
            }
        }
        if (U) return j;
    }
    return -1;
}
function $87a23dccae47b18a$var$rZ($, Q, Z) {
    let V = Q.length;
    var Y = Q.charCodeAt(0);
    Y >= $87a23dccae47b18a$var$d && Y <= $87a23dccae47b18a$var$l && (Y += $87a23dccae47b18a$var$i0);
    for(let K = Math.min(Z, $.length - V); K >= 0; K--){
        var G = $.charCodeAt(K);
        if (G >= $87a23dccae47b18a$var$d && G <= $87a23dccae47b18a$var$l && (G += $87a23dccae47b18a$var$i0), G !== Y) continue;
        let q = !0;
        for(let J = 1; J < V; J++){
            let F = $.charCodeAt(K + J), W = Q.charCodeAt(J);
            if (F >= $87a23dccae47b18a$var$d && F <= $87a23dccae47b18a$var$l && (F += $87a23dccae47b18a$var$i0), W >= $87a23dccae47b18a$var$d && W <= $87a23dccae47b18a$var$l && (W += $87a23dccae47b18a$var$i0), F !== W) {
                q = !1;
                break;
            }
        }
        if (q) return K;
    }
    return -1;
}
var $87a23dccae47b18a$var$_$ = -1;
function $87a23dccae47b18a$var$d$($, Q, Z) {
    let V = Z.toLowerCase(), Y = "<" + V, G = "</" + V, K = 1, q = Q, J = $.length;
    for($87a23dccae47b18a$var$_$ = -1; q < J && K > 0;){
        let X = $87a23dccae47b18a$var$T9($, Y, q), H = $87a23dccae47b18a$var$T9($, G, q);
        if (H === -1) return -1;
        if (X !== -1 && X < H) {
            let z = $87a23dccae47b18a$var$N9($, X);
            z ? (z.tag.toLowerCase() === V && !z.isClosing && !z.selfClosing && !$87a23dccae47b18a$var$c9(z.tag) && K++, q = z.end) : q = X + 1;
        } else {
            var F = H + G.length, W = F < J ? $.charCodeAt(F) : 62;
            if ((W === $87a23dccae47b18a$var$c || W === $87a23dccae47b18a$var$b || W === $87a23dccae47b18a$var$R || W === $87a23dccae47b18a$var$x) && (K--, K === 0)) {
                $87a23dccae47b18a$var$_$ = H;
                let z = H + G.length;
                for(; z < J && $.charCodeAt(z) !== $87a23dccae47b18a$var$c;)z++;
                return z + 1;
            }
            q = H + 1;
        }
    }
    return -1;
}
function $87a23dccae47b18a$var$s6($, Q, Z, V) {
    if (V.ignoreHTMLBlocks || V.disableParsingRawHTML) return null;
    var Y = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, Y), $87a23dccae47b18a$var$Y0 > 3 && !Z.inHTML) return null;
    var G = Q + $87a23dccae47b18a$var$Q0;
    if ($.charCodeAt(G) !== $87a23dccae47b18a$var$Z0) return null;
    var K = $.indexOf(">", G + 1);
    if (K !== -1 && K < Y) {
        var q = $.slice(G + 1, K);
        if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(q) || /^[^\s@]+@[^\s@]+$/.test(q)) return null;
    }
    var J = $87a23dccae47b18a$var$oZ($, G);
    if (J >= 1 && J <= 5) {
        var F = $.length;
        if (J === 1) {
            for(var W = $.length, X = 0; X < $87a23dccae47b18a$var$p$.length; X++){
                var H = $87a23dccae47b18a$var$T9($, "</" + $87a23dccae47b18a$var$p$[X] + ">", G);
                H >= 0 && H < W && (W = H);
            }
            if (W < $.length) {
                var z = $.indexOf(">", W);
                F = z >= 0 ? $87a23dccae47b18a$var$t($, z + 1) : $.length;
            }
        } else {
            var D = J === 2 ? "-->" : J === 3 ? "?>" : J === 4 ? ">" : "]]>", j = $.indexOf(D, G);
            j >= 0 && (F = $87a23dccae47b18a$var$t($, j + D.length));
        }
        var U = $.slice(G, F);
        if (J >= 2) return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlComment,
                text: U,
                h: !1,
                raw: !0
            },
            end: F
        };
        var B = "div", M = U.match(/^<\/?([a-zA-Z][a-zA-Z0-9-]*)/);
        M && (B = M[1]);
        var A = $87a23dccae47b18a$var$N9($, G), k = {}, _;
        A && !A.isClosing && (k = $87a23dccae47b18a$var$I9(A.attrs, B, V), _ = A.whitespaceBeforeAttrs + A.rawAttrs);
        var O = [], E = B.toLowerCase(), L = "</" + E, y = $87a23dccae47b18a$var$T9(U, L, 0), I = U, f = "";
        if (A && A.isClosing) for(I = U.slice(A.end - G); I.length > 0 && I.charCodeAt(I.length - 1) === $87a23dccae47b18a$var$x;)I = I.slice(0, -1);
        else if (A && !A.isClosing) {
            var w = A.end - G;
            if (y !== -1) for(I = U.slice(w), I.charCodeAt(0) === $87a23dccae47b18a$var$x && (I = I.slice(1)); I.length > 0 && I.charCodeAt(I.length - 1) === $87a23dccae47b18a$var$x;)I = I.slice(0, -1);
            else for(I = U; I.length > 0 && I.charCodeAt(I.length - 1) === $87a23dccae47b18a$var$x;)I = I.slice(0, -1);
            if (y !== -1) {
                var T = U.slice(w, y);
                f = T.trim();
            }
        }
        var m = A ? A.isClosing : !1;
        return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                tag: B,
                attrs: k,
                f: _,
                children: O,
                a: I,
                text: f,
                c: !0,
                b: m
            },
            end: F
        };
    }
    if (J === 6 || J === 7) {
        var C = $87a23dccae47b18a$var$L6($, Q), g = C < $.length ? C : $.length, X0 = $.slice(G, g), J0 = C < $.length ? $87a23dccae47b18a$var$t($, C) : $.length, P = $87a23dccae47b18a$var$N9($, G);
        if (P) {
            var a = P.tag, r = a.toLowerCase(), y0 = P.isClosing;
            if (y0) {
                var R0 = $.slice(P.end, g);
                return {
                    node: {
                        type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                        tag: a,
                        attrs: {},
                        children: [],
                        a: R0,
                        text: R0,
                        c: !0,
                        b: !0
                    },
                    end: J0
                };
            }
            if (P.selfClosing || $87a23dccae47b18a$var$c9(a)) return {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                    tag: a,
                    attrs: $87a23dccae47b18a$var$I9(P.attrs, a, V),
                    f: P.whitespaceBeforeAttrs + P.rawAttrs,
                    children: [],
                    a: "",
                    text: "",
                    c: !1,
                    b: !1
                },
                end: P.end < $.length && $.charCodeAt(P.end) === $87a23dccae47b18a$var$x ? P.end + 1 : P.end
            };
            var F0 = Z.d || 0, u = $.slice(G, g), n = -1, D0 = -1;
            if (F0 < 10) {
                for(var s = "</" + r, M0 = P.end - G, _0 = 1, K0 = M0; K0 < u.length && _0 > 0;){
                    var b0 = $87a23dccae47b18a$var$T9(u, "<" + r, K0), V0 = $87a23dccae47b18a$var$T9(u, s, K0);
                    if (V0 === -1) break;
                    if (b0 !== -1 && b0 < V0) {
                        var W0 = b0 + r.length + 1;
                        if (W0 < u.length) {
                            var h = u.charCodeAt(W0);
                            (h === $87a23dccae47b18a$var$b || h === $87a23dccae47b18a$var$R || h === $87a23dccae47b18a$var$x || h === $87a23dccae47b18a$var$c || h === $87a23dccae47b18a$var$j0) && _0++;
                        }
                        K0 = b0 + 1;
                    } else {
                        var N = V0 + s.length;
                        if (N < u.length) {
                            var e = u.charCodeAt(N);
                            if ((e === $87a23dccae47b18a$var$c || e === $87a23dccae47b18a$var$b || e === $87a23dccae47b18a$var$R || e === $87a23dccae47b18a$var$x) && (_0--, _0 === 0)) {
                                n = V0;
                                for(var I0 = N; I0 < u.length && u.charCodeAt(I0) !== $87a23dccae47b18a$var$c;)I0++;
                                D0 = I0 + 1;
                                break;
                            }
                        } else if (_0--, _0 === 0) {
                            n = V0, D0 = u.length;
                            break;
                        }
                        K0 = V0 + 1;
                    }
                }
                var a0 = !1;
                if (n === -1 && J === 6 && !P.isClosing) {
                    var n0 = $87a23dccae47b18a$var$d$($, P.end, r);
                    if (n0 !== -1) {
                        for(var P0 = $87a23dccae47b18a$var$_$, S = P.end, S0 = !1, q0 = !1, s0 = !1, z9 = 0, w9 = !1, H9 = !1, F9 = S; F9 < P0;){
                            var O9 = $.charCodeAt(F9);
                            if (O9 === $87a23dccae47b18a$var$x) H9 && (S0 = !0), w9 || z9++, H9 = !0, F9++;
                            else if (O9 === $87a23dccae47b18a$var$b || O9 === $87a23dccae47b18a$var$R) F9++;
                            else {
                                if (!w9 && (w9 = !0, z9 >= 2 && O9 === $87a23dccae47b18a$var$Z0)) {
                                    s0 = !0;
                                    break;
                                }
                                if (H9 = !1, O9 === $87a23dccae47b18a$var$Z0) {
                                    var C9 = $.charCodeAt(F9 + 1) | 32;
                                    if ((C9 === $87a23dccae47b18a$var$O$ || C9 === $87a23dccae47b18a$var$E$ || C9 === $87a23dccae47b18a$var$u9) && ($87a23dccae47b18a$var$P6.lastIndex = F9, $87a23dccae47b18a$var$P6.test($))) {
                                        q0 = !0;
                                        break;
                                    }
                                }
                                F9++;
                            }
                        }
                        if (S0 && !s0 && !q0) {
                            var Z$ = $87a23dccae47b18a$var$G0($, n0);
                            g = Z$, J0 = $87a23dccae47b18a$var$t($, Z$), u = $.slice(G, g), X0 = $.slice(G, g), n = P0 - G, D0 = n0 - G, a0 = !0;
                        }
                    }
                }
            }
            var D9 = P.rawAttrs.indexOf(`
`) !== -1 || P.whitespaceBeforeAttrs.indexOf(`
`) !== -1, V9 = !1;
            if (n !== -1) {
                var Y9 = u.slice(D0).trim();
                V9 = Y9.length === 0;
            }
            var G9 = !1, U9 = g, k0 = J0;
            if (n !== -1) {
                var y9 = G + D0, X9 = $87a23dccae47b18a$var$G0($, y9 - 1);
                if (y9 < X9) {
                    for(var K9 = y9; K9 < X9 && ($.charCodeAt(K9) === $87a23dccae47b18a$var$b || $.charCodeAt(K9) === $87a23dccae47b18a$var$R);)K9++;
                    if (K9 < X9 && $.charCodeAt(K9) === $87a23dccae47b18a$var$Z0) {
                        var R9 = $87a23dccae47b18a$var$N9($, K9);
                        R9 && !R9.isClosing && (G9 = !0, U9 = y9, k0 = y9, V9 = !0);
                    }
                }
                if (!G9) {
                    var r9 = $87a23dccae47b18a$var$t($, X9);
                    if (r9 < g) {
                        for(var q9 = r9; q9 < g && ($.charCodeAt(q9) === $87a23dccae47b18a$var$b || $.charCodeAt(q9) === $87a23dccae47b18a$var$R);)q9++;
                        if (q9 < g && $.charCodeAt(q9) === $87a23dccae47b18a$var$Z0) {
                            var YZ = $87a23dccae47b18a$var$N9($, q9);
                            YZ && (G9 = !0, U9 = X9, k0 = r9, V9 = !0);
                        }
                    }
                }
                if (!G9 && Z.inHTML) {
                    G9 = !0, U9 = X9, k0 = $87a23dccae47b18a$var$t($, X9);
                    var GZ = $.slice(y9, X9).trim();
                    V9 = GZ.length === 0;
                }
            }
            var o9 = [], t0 = "";
            if (n !== -1) {
                t0 = u.slice(P.end - G, n);
                var k9 = t0.trim();
                if (k9) {
                    var { inline: KZ, inHTML: qZ, d: JZ } = Z;
                    Z.inHTML = !0, Z.d = F0 + 1;
                    var FZ = r === "p";
                    if (FZ) Z.inline = !0, o9 = $87a23dccae47b18a$var$h0(k9, 0, k9.length, Z, V);
                    else {
                        var n$ = t0.indexOf(`

`) !== -1, s$ = $87a23dccae47b18a$var$w6.test(k9), P$ = $87a23dccae47b18a$var$y6.test(k9), UZ = n$ || s$ || Z.inHTML && P$, XZ = t0.length >= 2 && t0.charCodeAt(0) === $87a23dccae47b18a$var$x && t0.charCodeAt(t0.length - 1) === $87a23dccae47b18a$var$x && !n$;
                        XZ && !s$ && !P$ ? o9 = [
                            {
                                type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                                text: k9
                            }
                        ] : UZ || P$ ? (Z.inline = !1, o9 = $87a23dccae47b18a$var$b9(t0, Z, V)) : (Z.inline = !0, o9 = $87a23dccae47b18a$var$h0(k9, 0, k9.length, Z, V));
                    }
                    Z.inline = KZ, Z.inHTML = qZ, Z.d = JZ;
                }
            }
            var t$ = !1;
            if (J === 6 && n !== -1 && !Z.inHTML && !D9) {
                var w$ = t0, WZ = /<[a-zA-Z][^>]*>/.test(w$), zZ = /\n\n/.test(w$) || /^(\s{0,3}#[#\s]|\s{0,3}[-*+]\s|\s{0,3}\d+\.\s|\s{0,3}>\s|\s{0,3}```)/m.test(w$);
                WZ && !zZ && (t$ = !0);
            }
            var HZ = !a0 && (Z.inHTML || J === 7 || D9 || !V9 || t$);
            if (HZ) {
                var o0, e$ = !1;
                if (n !== -1 && G9) {
                    var $6 = !1;
                    if (Z.inHTML && D0 < u.length) {
                        for(var X$ = D0; X$ < u.length && u.charCodeAt(X$) !== $87a23dccae47b18a$var$x;)X$++;
                        var y$ = u.slice(D0, X$).trim();
                        $6 = y$.length > 1 && y$.charCodeAt(0) === $87a23dccae47b18a$var$Z0 && y$.charCodeAt(1) !== $87a23dccae47b18a$var$j0;
                    }
                    o0 = $6 ? u.slice(P.end - G) : t0, e$ = !0;
                } else (J === 7 || Z.inHTML) && n !== -1 ? (o0 = u.slice(P.end - G), o0.charCodeAt(0) === $87a23dccae47b18a$var$x && (o0 = o0.slice(1))) : G9 ? o0 = $.slice(G, U9) : D9 ? o0 = X0 : (o0 = u.slice(P.end - G), o0.charCodeAt(0) === $87a23dccae47b18a$var$x && (o0 = o0.slice(1)));
                var Z6 = {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                    tag: a,
                    attrs: $87a23dccae47b18a$var$I9(P.attrs, a, V),
                    f: P.whitespaceBeforeAttrs + P.rawAttrs,
                    children: o9,
                    a: o0,
                    text: o0,
                    c: !0,
                    b: !1
                };
                return e$ && (Z6.k = !0), {
                    node: Z6,
                    end: k0
                };
            }
            return {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                    tag: a,
                    attrs: $87a23dccae47b18a$var$I9(P.attrs, a, V),
                    f: P.whitespaceBeforeAttrs + P.rawAttrs,
                    children: o9,
                    a: a0 ? "" : t0,
                    text: t0,
                    c: !1,
                    b: !1
                },
                end: k0
            };
        }
        var W$ = X0.match(/^<(\/?)([a-zA-Z][a-zA-Z0-9-]*)/), OZ = W$ ? W$[2] : "div", Q6 = W$ ? W$[1] === "/" : !1, R$ = X0;
        if (Q6) {
            var V6 = X0.indexOf(">");
            V6 !== -1 && (R$ = X0.slice(V6 + 1));
        }
        return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                tag: OZ,
                attrs: {},
                children: [],
                a: R$,
                text: R$,
                c: !0,
                b: Q6
            },
            end: J0
        };
    }
    var T0 = $87a23dccae47b18a$var$N9($, G);
    if (!T0) return null;
    var L9 = T0.tag, k$ = L9.toLowerCase(), Y6 = L9.charCodeAt(0), z$ = Y6 >= $87a23dccae47b18a$var$d && Y6 <= $87a23dccae47b18a$var$l;
    if (!z$ && !$87a23dccae47b18a$var$v$.has(k$) && !$87a23dccae47b18a$var$F$.has(k$) && !k$.includes("-")) return null;
    if (T0.isClosing) return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
            tag: L9,
            attrs: {},
            a: $.slice(G, T0.end),
            b: !0
        },
        end: T0.end
    };
    var H5 = !0, m9 = $87a23dccae47b18a$var$d$($, T0.end, L9), Q$ = [];
    if (m9 !== -1) {
        var DZ = $87a23dccae47b18a$var$_$, H$ = $.slice(T0.end, DZ), V$ = H$.trim();
        if (V$) {
            var BZ = H$.indexOf(`

`) !== -1, jZ = $87a23dccae47b18a$var$w6.test(V$), MZ = $87a23dccae47b18a$var$y6.test(V$), AZ = Z.inline, vZ = Z.inHTML, _Z = Z.d;
            Z.inHTML = !0, Z.d = (Z.d || 0) + 1, BZ || jZ || MZ ? (Z.inline = !1, Q$ = $87a23dccae47b18a$var$b9(H$, Z, V)) : (Z.inline = !0, Q$ = $87a23dccae47b18a$var$h0(V$, 0, V$.length, Z, V)), Z.inline = AZ, Z.inHTML = vZ, Z.d = _Z;
        }
        var IZ = $87a23dccae47b18a$var$G0($, m9), NZ = $.slice(m9, IZ).trim(), L$ = NZ ? m9 : $87a23dccae47b18a$var$t($, m9), G6 = z$ ? $.slice(G, m9) : $.slice(G, L$), O5 = z$ ? m9 : L$;
        return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
                tag: L9,
                attrs: $87a23dccae47b18a$var$I9(T0.attrs, L9, V),
                f: T0.whitespaceBeforeAttrs + T0.rawAttrs,
                children: Q$,
                a: G6,
                text: z$ ? H$ : G6,
                c: !0,
                b: !1
            },
            end: L$
        };
    }
    var Y$ = $87a23dccae47b18a$var$L6($, T0.end), bZ = Y$ < $.length ? $87a23dccae47b18a$var$t($, Y$) : Y$, S$ = $.slice(T0.end, Y$);
    if (S$.trim()) {
        var { inline: PZ, inHTML: wZ, d: yZ } = Z;
        Z.inline = !1, Z.inHTML = !0, Z.d = (Z.d || 0) + 1, Q$ = $87a23dccae47b18a$var$b9(S$, Z, V), Z.inline = PZ, Z.inHTML = wZ, Z.d = yZ;
    }
    var RZ = $.slice(T0.end, Y$);
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
            tag: L9,
            attrs: $87a23dccae47b18a$var$I9(T0.attrs, L9, V),
            f: T0.whitespaceBeforeAttrs + T0.rawAttrs,
            children: Q$,
            a: RZ,
            text: S$,
            c: !0,
            b: !1
        },
        end: bZ
    };
}
function $87a23dccae47b18a$var$oZ($, Q) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$Z0) return 0;
    var Z = Q + 1, V = $.length;
    if ($.charCodeAt(Z) === $87a23dccae47b18a$var$x0 && $.charCodeAt(Z + 1) === $87a23dccae47b18a$var$p && $.charCodeAt(Z + 2) === $87a23dccae47b18a$var$p) return 2;
    if ($.charCodeAt(Z) === $87a23dccae47b18a$var$i9) return 3;
    if ($.charCodeAt(Z) === $87a23dccae47b18a$var$x0) {
        var Y = $.charCodeAt(Z + 1);
        if (Y >= $87a23dccae47b18a$var$d && Y <= $87a23dccae47b18a$var$l) return 4;
        if ($.slice(Z + 1, Z + 8) === "[CDATA[") return 5;
    }
    for(var G = $.charCodeAt(Z) === $87a23dccae47b18a$var$j0, K = G ? Z + 1 : Z, q = K; q < V;){
        var J = $.charCodeAt(q);
        if (J >= $87a23dccae47b18a$var$d && J <= $87a23dccae47b18a$var$l || J >= $87a23dccae47b18a$var$U0 && J <= $87a23dccae47b18a$var$H0 || J >= $87a23dccae47b18a$var$o && J <= $87a23dccae47b18a$var$i || J === $87a23dccae47b18a$var$p) q++;
        else break;
    }
    if (q === K) return 0;
    var F = $.slice(K, q);
    if ($87a23dccae47b18a$var$F$.has(F.toLowerCase())) {
        if (G) return 0;
        var W = $.charCodeAt(q);
        return W === $87a23dccae47b18a$var$b || W === $87a23dccae47b18a$var$R || W === $87a23dccae47b18a$var$c || W === $87a23dccae47b18a$var$x || q >= V ? 1 : 0;
    }
    if ($87a23dccae47b18a$var$v$.has(F.toLowerCase())) {
        if (G) {
            for(var X = q; X < V && ($.charCodeAt(X) === $87a23dccae47b18a$var$b || $.charCodeAt(X) === $87a23dccae47b18a$var$R);)X++;
            return X < V && $.charCodeAt(X) === $87a23dccae47b18a$var$c ? 6 : 0;
        }
        var H = q < V ? $.charCodeAt(q) : -1;
        return H === $87a23dccae47b18a$var$b || H === $87a23dccae47b18a$var$R || H === $87a23dccae47b18a$var$c || H === $87a23dccae47b18a$var$x || H === $87a23dccae47b18a$var$j0 || H === -1 ? 6 : 0;
    }
    if (G) {
        for(var U = q; U < V && ($.charCodeAt(U) === $87a23dccae47b18a$var$b || $.charCodeAt(U) === $87a23dccae47b18a$var$R);)U++;
        if (U < V && $.charCodeAt(U) === $87a23dccae47b18a$var$c) {
            var B = $87a23dccae47b18a$var$G0($, Q), M = $.slice(U + 1, B).trim();
            if (M === "") return 7;
        }
    } else {
        var z = $87a23dccae47b18a$var$G0($, Q), D = $87a23dccae47b18a$var$N9($, Q);
        if (D && D.end <= z) {
            var j = $.slice(D.end, z).trim();
            if (j === "") return 7;
        }
    }
    return 0;
}
function $87a23dccae47b18a$var$g6($, Q, Z) {
    for(var V = 0, Y = $.length; V < Y && ($.charCodeAt(V) === $87a23dccae47b18a$var$b || $.charCodeAt(V) === $87a23dccae47b18a$var$R);)V++;
    for(; Y > V && ($.charCodeAt(Y - 1) === $87a23dccae47b18a$var$b || $.charCodeAt(Y - 1) === $87a23dccae47b18a$var$R);)Y--;
    V < Y && $.charCodeAt(V) === $87a23dccae47b18a$var$w0 && V++, Y > V && $.charCodeAt(Y - 1) === $87a23dccae47b18a$var$w0 && (Y - 2 < V || $.charCodeAt(Y - 2) !== $87a23dccae47b18a$var$N0) && Y--;
    for(var G = [], K = V, q = !1, J = [], F = V; F < Y;){
        var W = $.charCodeAt(F);
        if (W === $87a23dccae47b18a$var$N0 && F + 1 < Y) {
            $.charCodeAt(F + 1) === $87a23dccae47b18a$var$w0 ? (q || (q = !0, J = []), J.push($.slice(K, F)), J.push("|"), F += 2, K = F) : F += 2;
            continue;
        }
        if (W === $87a23dccae47b18a$var$$0) {
            for(var X = 0; F < Y && $.charCodeAt(F) === $87a23dccae47b18a$var$$0;)X++, F++;
            for(var H = !1; F < Y && !H;){
                for(var z = 0; F < Y && $.charCodeAt(F) === $87a23dccae47b18a$var$$0;)z++, F++;
                z === X ? H = !0 : z === 0 && F++;
            }
            continue;
        }
        if (W === $87a23dccae47b18a$var$w0) {
            var D = q ? (J.push($.slice(K, F)), J.join("")) : $.slice(K, F);
            G.push(D.trim()), F++, K = F, q = !1, J = [];
            continue;
        }
        F++;
    }
    var j = q ? (J.push($.slice(K, Y)), J.join("")) : $.slice(K, Y);
    return G.push(j.trim()), G.map(function(U) {
        var B = U.indexOf("\\|") !== -1 ? U.replace(/\\\|/g, "|") : U;
        return $87a23dccae47b18a$var$h0(B, 0, B.length, Q, Z);
    });
}
function $87a23dccae47b18a$var$x6($, Q, Z, V) {
    let Y = $87a23dccae47b18a$var$G0($, Q);
    var G = $.indexOf("|", Q);
    if (G < 0 || G >= Y) return null;
    let K = $87a23dccae47b18a$var$t($, Y);
    if (K >= $.length) return null;
    let q = $87a23dccae47b18a$var$G0($, K);
    if (!$87a23dccae47b18a$var$d6($, K, q)) return null;
    let J = $.slice(Q, Y), F = $.slice(K, q);
    for(var W = [], X = 0, H = F.length; X < H && (F.charCodeAt(X) === $87a23dccae47b18a$var$b || F.charCodeAt(X) === $87a23dccae47b18a$var$R);)X++;
    for(X < H && F.charCodeAt(X) === $87a23dccae47b18a$var$w0 && X++; X < H;){
        for(; X < H && (F.charCodeAt(X) === $87a23dccae47b18a$var$b || F.charCodeAt(X) === $87a23dccae47b18a$var$R);)X++;
        if (X >= H || F.charCodeAt(X) === $87a23dccae47b18a$var$w0) break;
        var z = F.charCodeAt(X) === $87a23dccae47b18a$var$E0;
        for(z && X++; X < H && F.charCodeAt(X) === $87a23dccae47b18a$var$p;)X++;
        var D = X < H && F.charCodeAt(X) === $87a23dccae47b18a$var$E0;
        for(D && X++, W.push(z && D ? "center" : D ? "right" : z ? "left" : null); X < H && (F.charCodeAt(X) === $87a23dccae47b18a$var$b || F.charCodeAt(X) === $87a23dccae47b18a$var$R);)X++;
        X < H && F.charCodeAt(X) === $87a23dccae47b18a$var$w0 && X++;
    }
    let j = $87a23dccae47b18a$var$g6(J, Z, V);
    if (W.length !== j.length) return null;
    let U = [], B = $87a23dccae47b18a$var$t($, q);
    for(; B < $.length;){
        let E = $87a23dccae47b18a$var$G0($, B), L = $.slice(B, E);
        if ($87a23dccae47b18a$var$l0($, B, E)) break;
        if ($87a23dccae47b18a$var$v0($, B, E), $87a23dccae47b18a$var$Y0 < 4) {
            var M = $.charCodeAt(B + $87a23dccae47b18a$var$Q0);
            if (M === $87a23dccae47b18a$var$c || M === $87a23dccae47b18a$var$J9 || (M === $87a23dccae47b18a$var$p || M === $87a23dccae47b18a$var$B0 || M === $87a23dccae47b18a$var$z0) && $87a23dccae47b18a$var$f9($, B)) break;
            if (M === $87a23dccae47b18a$var$$0 || M === $87a23dccae47b18a$var$A0) {
                for(var A = B + $87a23dccae47b18a$var$Q0, k = 0; A < E && $.charCodeAt(A) === M;)k++, A++;
                if (k >= 3) break;
            }
        }
        U.push($87a23dccae47b18a$var$g6(L, Z, V)), B = $87a23dccae47b18a$var$t($, E);
    }
    if (V.optimizeForStreaming && U.length === 0) return null;
    for(var _ = j.length, O = 0; O < U.length; O++)if (U[O].length < _) for(; U[O].length < _;)U[O].push([]);
    else U[O].length > _ && (U[O].length = _);
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.table,
            header: j,
            cells: U,
            align: W
        },
        end: B
    };
}
function $87a23dccae47b18a$var$iZ($, Q, Z) {
    var V = $87a23dccae47b18a$var$G0($, Q);
    if ($87a23dccae47b18a$var$v0($, Q, V), $87a23dccae47b18a$var$Y0 > 3) return null;
    var Y = Q + $87a23dccae47b18a$var$Q0;
    if ($.charCodeAt(Y) !== $87a23dccae47b18a$var$O0) return null;
    if (Y + 1 < $.length && $.charCodeAt(Y + 1) === $87a23dccae47b18a$var$e0) {
        var G = $87a23dccae47b18a$var$aZ($, Y, Z);
        return G || null;
    }
    Z.refs || (Z.refs = {});
    var K = $87a23dccae47b18a$var$l6($, Y, Z.refs);
    return K === null ? null : {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.refCollection
        },
        end: K
    };
}
function $87a23dccae47b18a$var$aZ($, Q, Z) {
    var V = $.length;
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$O0 || Q + 1 >= V || $.charCodeAt(Q + 1) !== $87a23dccae47b18a$var$e0) return null;
    for(var Y = Q + 2, G = Y; Y < V && $.charCodeAt(Y) !== $87a23dccae47b18a$var$p0;){
        if ($.charCodeAt(Y) === $87a23dccae47b18a$var$x) return null;
        Y++;
    }
    if (Y >= V) return null;
    var K = ("^" + $.slice(G, Y)).toLowerCase();
    if (Y++, Y >= V || $.charCodeAt(Y) !== $87a23dccae47b18a$var$E0) return null;
    for(Y++; Y < V && ($.charCodeAt(Y) === $87a23dccae47b18a$var$b || $.charCodeAt(Y) === $87a23dccae47b18a$var$R);)Y++;
    if (Y < V && $.charCodeAt(Y) === $87a23dccae47b18a$var$x) for(Y++; Y < V && ($.charCodeAt(Y) === $87a23dccae47b18a$var$b || $.charCodeAt(Y) === $87a23dccae47b18a$var$R);)Y++;
    var q = $.indexOf(`
`, Y);
    q < 0 && (q = V);
    for(var J = $.slice(Y, q).trim(), F = q < V ? q + 1 : V; F < V;){
        var W = $87a23dccae47b18a$var$G0($, F);
        if ($87a23dccae47b18a$var$v0($, F, W), $87a23dccae47b18a$var$Y0 >= 2 && !$87a23dccae47b18a$var$l0($, F, W)) J += `
` + $.slice(F, W), F = $87a23dccae47b18a$var$t($, W);
        else if ($87a23dccae47b18a$var$l0($, F, W)) {
            var X = $87a23dccae47b18a$var$t($, W);
            if (X < V) {
                var H = $87a23dccae47b18a$var$G0($, X);
                if ($87a23dccae47b18a$var$v0($, X, H), $87a23dccae47b18a$var$Y0 >= 2) {
                    J += `
`, F = $87a23dccae47b18a$var$t($, W);
                    continue;
                }
            }
            break;
        } else break;
    }
    return Z.refs[K] || (Z.refs[K] = {
        target: J,
        title: void 0
    }), {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.footnote
        },
        end: F
    };
}
function $87a23dccae47b18a$var$nZ($, Q, Z, V) {
    let Y = Q, G = 0, K = 0, q = -1;
    for(; Y < $.length;){
        let f = q >= 0 ? q : $87a23dccae47b18a$var$G0($, Y);
        if (q = -1, $87a23dccae47b18a$var$l0($, Y, f)) break;
        if ($87a23dccae47b18a$var$v0($, Y, f), $87a23dccae47b18a$var$Y0 < 4 && K > 0 && !Z.g) {
            let T = $.charCodeAt(Y + $87a23dccae47b18a$var$Q0);
            if (T === $87a23dccae47b18a$var$C0 || T === $87a23dccae47b18a$var$p) {
                let m = Y + $87a23dccae47b18a$var$Q0;
                for(; m < f && $.charCodeAt(m) === T;)m++;
                for(; m < f && ($.charCodeAt(m) === $87a23dccae47b18a$var$b || $.charCodeAt(m) === $87a23dccae47b18a$var$R);)m++;
                if (m >= f) {
                    G = T === $87a23dccae47b18a$var$C0 ? 1 : 2, Y = $87a23dccae47b18a$var$t($, f);
                    break;
                }
            }
        }
        K = f;
        let w = $87a23dccae47b18a$var$t($, f);
        if (w < $.length) {
            if ($.charCodeAt(w) === $87a23dccae47b18a$var$a9) {
                var J = $87a23dccae47b18a$var$G0($, w);
                Y = $87a23dccae47b18a$var$t($, J), K = J;
                continue;
            }
            let T = $87a23dccae47b18a$var$G0($, w);
            if (q = T, $87a23dccae47b18a$var$v0($, w, T), $87a23dccae47b18a$var$Y0 < 4) {
                let m = $.charCodeAt(w + $87a23dccae47b18a$var$Q0);
                if (m === $87a23dccae47b18a$var$c) {
                    Y = w;
                    break;
                }
                if (m === $87a23dccae47b18a$var$J9 && $87a23dccae47b18a$var$a6($, w, Z, V)) {
                    Y = w;
                    break;
                }
                if (m === $87a23dccae47b18a$var$$0 || m === $87a23dccae47b18a$var$A0) {
                    for(var F = w + $87a23dccae47b18a$var$Q0, W = 0; F < T && $.charCodeAt(F) === m;)W++, F++;
                    if (W >= 3) {
                        Y = w;
                        break;
                    }
                }
                if (m === $87a23dccae47b18a$var$Z0) {
                    var X = w + $87a23dccae47b18a$var$Q0 + 1, H = X < T ? $.charCodeAt(X) : 0, z = H === $87a23dccae47b18a$var$x0 || H === $87a23dccae47b18a$var$i9;
                    if (!z && H === $87a23dccae47b18a$var$j0) {
                        for(var D = X + 1, j = D; j < T && ($.charCodeAt(j) >= $87a23dccae47b18a$var$d && $.charCodeAt(j) <= $87a23dccae47b18a$var$l || $.charCodeAt(j) >= $87a23dccae47b18a$var$U0 && $.charCodeAt(j) <= $87a23dccae47b18a$var$H0 || $.charCodeAt(j) >= $87a23dccae47b18a$var$o && $.charCodeAt(j) <= $87a23dccae47b18a$var$i || $.charCodeAt(j) === $87a23dccae47b18a$var$p);)j++;
                        j > D && (z = $87a23dccae47b18a$var$v$.has($.slice(D, j).toLowerCase()));
                    } else if (!z) {
                        for(var U = X; U < T && ($.charCodeAt(U) >= $87a23dccae47b18a$var$d && $.charCodeAt(U) <= $87a23dccae47b18a$var$l || $.charCodeAt(U) >= $87a23dccae47b18a$var$U0 && $.charCodeAt(U) <= $87a23dccae47b18a$var$H0 || $.charCodeAt(U) >= $87a23dccae47b18a$var$o && $.charCodeAt(U) <= $87a23dccae47b18a$var$i || $.charCodeAt(U) === $87a23dccae47b18a$var$p);)U++;
                        if (U > X) {
                            var B = $.slice(X, U).toLowerCase();
                            z = $87a23dccae47b18a$var$v$.has(B) || $87a23dccae47b18a$var$F$.has(B);
                        }
                    }
                    if (z && $87a23dccae47b18a$var$s6($, w, Z, V)) {
                        Y = w;
                        break;
                    }
                }
                if (m === $87a23dccae47b18a$var$p || m === $87a23dccae47b18a$var$B0 || m === $87a23dccae47b18a$var$A9) {
                    let C = w + $87a23dccae47b18a$var$Q0 + 1;
                    if (C < T && ($.charCodeAt(C) === $87a23dccae47b18a$var$b || $.charCodeAt(C) === $87a23dccae47b18a$var$R)) {
                        var M = $87a23dccae47b18a$var$J$($, C, T);
                        if (M < T && !$87a23dccae47b18a$var$f9($, w)) {
                            Y = w;
                            break;
                        }
                    }
                }
                if (m >= $87a23dccae47b18a$var$o && m <= $87a23dccae47b18a$var$i) {
                    let C = w + $87a23dccae47b18a$var$Q0;
                    for(; C < T && $.charCodeAt(C) >= $87a23dccae47b18a$var$o && $.charCodeAt(C) <= $87a23dccae47b18a$var$i;)C++;
                    if (C < T && ($.charCodeAt(C) === $87a23dccae47b18a$var$d0 || $.charCodeAt(C) === $87a23dccae47b18a$var$Z9) && C - (w + $87a23dccae47b18a$var$Q0) === 1 && $.charCodeAt(w + $87a23dccae47b18a$var$Q0) === 49) {
                        var A = C + 1;
                        if (A < T && ($.charCodeAt(A) === $87a23dccae47b18a$var$b || $.charCodeAt(A) === $87a23dccae47b18a$var$R)) {
                            var k = $87a23dccae47b18a$var$J$($, A, T);
                            if (k < T) {
                                Y = w;
                                break;
                            }
                        }
                    }
                }
                if (m === $87a23dccae47b18a$var$w0) {
                    let C = $87a23dccae47b18a$var$t($, T);
                    if (C < $.length) {
                        let g = $87a23dccae47b18a$var$G0($, C);
                        if ($87a23dccae47b18a$var$d6($, C, g)) {
                            Y = w;
                            break;
                        }
                    }
                }
                if ((m === $87a23dccae47b18a$var$p || m === $87a23dccae47b18a$var$B0 || m === $87a23dccae47b18a$var$z0) && $87a23dccae47b18a$var$f9($, w)) {
                    if (m !== $87a23dccae47b18a$var$p) {
                        Y = w;
                        break;
                    }
                    let C = 0, g = w + $87a23dccae47b18a$var$Q0;
                    for(; g < T && $.charCodeAt(g) === $87a23dccae47b18a$var$p;)C++, g++;
                    for(; g < T && ($.charCodeAt(g) === $87a23dccae47b18a$var$b || $.charCodeAt(g) === $87a23dccae47b18a$var$R);)g++;
                    if (g < T) {
                        Y = w;
                        break;
                    }
                }
            }
        }
        Y = $87a23dccae47b18a$var$t($, f);
    }
    for(var _ = G ? K : Y; _ > Q && ($.charCodeAt(_ - 1) === $87a23dccae47b18a$var$x || $.charCodeAt(_ - 1) === $87a23dccae47b18a$var$B9 || $.charCodeAt(_ - 1) === $87a23dccae47b18a$var$b || $.charCodeAt(_ - 1) === $87a23dccae47b18a$var$R);)_--;
    for(var O = Q; O < _ && ($.charCodeAt(O) === $87a23dccae47b18a$var$b || $.charCodeAt(O) === $87a23dccae47b18a$var$R);)O++;
    if (O >= _) return null;
    for(var E = !1, L = O; L < _; L++)if ($.charCodeAt(L) === $87a23dccae47b18a$var$a9) {
        E = !0;
        break;
    }
    var y = E ? $.slice(O, _).replace(/\u001E/g, "") : $.slice(O, _);
    if (!y) return null;
    let I = $87a23dccae47b18a$var$sZ(y, 0, y.length, Z, V);
    if (G) {
        let w = (V?.slugify || $87a23dccae47b18a$export$c383cdd2a518017a)(y);
        return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.heading,
                level: G,
                children: I,
                id: w
            },
            end: Y
        };
    }
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph,
            children: I
        },
        end: Y
    };
}
function $87a23dccae47b18a$var$sZ($, Q, Z, V, Y) {
    var G = $.indexOf(`
`, Q);
    if (G < 0 || G >= Z) return $87a23dccae47b18a$var$h0($, Q, Z, V, Y);
    for(var K = "", q = Q, J = Q; J < Z;){
        var F = $.charCodeAt(J);
        if (F === $87a23dccae47b18a$var$$0) {
            var W = $87a23dccae47b18a$var$N$($, J, Z);
            if (W > J) {
                for(var X = !1, H = J; H < W; H++)if ($.charCodeAt(H) === $87a23dccae47b18a$var$x) {
                    X = !0;
                    break;
                }
                X && (K += $.slice(q, J), K += $.slice(J, W).replace(/\n/g, " "), q = W), J = W;
                continue;
            }
        }
        if (F === $87a23dccae47b18a$var$Z0) {
            var z = $87a23dccae47b18a$var$t6($, J, Z);
            if (z > J) {
                J = z;
                continue;
            }
        }
        if (F === $87a23dccae47b18a$var$x) {
            var D = !1, j = 0;
            if (J > Q && $.charCodeAt(J - 1) === $87a23dccae47b18a$var$N0) D = !0, j = 1;
            else {
                for(var U = 0, B = J - 1; B >= Q && $.charCodeAt(B) === $87a23dccae47b18a$var$b;)U++, B--;
                U >= 2 && (D = !0, j = U);
            }
            if (D) K += $.slice(q, J - j), K += "";
            else {
                for(var M = J; M > q && $.charCodeAt(M - 1) === $87a23dccae47b18a$var$b;)M--;
                K += $.slice(q, M) + `
`;
            }
            for(J++; J < Z && $.charCodeAt(J) === $87a23dccae47b18a$var$b;)J++;
            q = J;
            continue;
        }
        J++;
    }
    return q < Z && (K += $.slice(q, Z)), $87a23dccae47b18a$var$h0(K, 0, K.length, V, Y);
}
function $87a23dccae47b18a$var$tZ($, Q, Z) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$$0) return null;
    let V = $87a23dccae47b18a$var$P9($, Q, Z, 96), Y = Q + V;
    for(; Y < Z;){
        let G = $.indexOf("`", Y);
        if (G < 0 || G >= Z) return null;
        let K = $87a23dccae47b18a$var$P9($, G, Z, 96);
        if (K === V) {
            let q = $.slice(Q + V, G);
            return q = q.replace(/\n/g, " "), q.length > 0 && q[0] === " " && q[q.length - 1] === " " && q.trim().length > 0 && (q = q.slice(1, -1)), {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.codeInline,
                    text: q
                },
                end: G + K
            };
        }
        Y = G + K;
    }
    return null;
}
function $87a23dccae47b18a$var$N$($, Q, Z) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$$0) return Q;
    let V = $87a23dccae47b18a$var$P9($, Q, Z, 96), Y = Q + V;
    for(; Y < Z;){
        let G = $.indexOf("`", Y);
        if (G < 0 || G >= Z) return Q;
        let K = $87a23dccae47b18a$var$P9($, G, Z, 96);
        if (K === V) return G + K;
        Y = G + K;
    }
    return Q;
}
function $87a23dccae47b18a$var$t6($, Q, Z) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$Z0) return Q;
    if (Q + 1 < Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$j0) {
        let F = Q + 2;
        for(; F < Z && $.charCodeAt(F) !== $87a23dccae47b18a$var$c;)F++;
        return F < Z ? F + 1 : Q;
    }
    if (Q + 3 < Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$x0 && $.charCodeAt(Q + 2) === $87a23dccae47b18a$var$p && $.charCodeAt(Q + 3) === $87a23dccae47b18a$var$p) {
        let F = $.indexOf("-->", Q + 4);
        return F >= 0 ? F + 3 : Q;
    }
    let V = Q + 1, Y = V;
    for(; V < Z;){
        let F = $.charCodeAt(V);
        if (F >= $87a23dccae47b18a$var$d && F <= $87a23dccae47b18a$var$l || F >= $87a23dccae47b18a$var$U0 && F <= $87a23dccae47b18a$var$H0 || F >= $87a23dccae47b18a$var$o && F <= $87a23dccae47b18a$var$i || F === $87a23dccae47b18a$var$p) V++;
        else break;
    }
    if (V === Y) return Q;
    let G = $.slice(Y, V).toLowerCase(), K = !1;
    for(; V < Z;){
        let F = $.charCodeAt(V);
        if (F === $87a23dccae47b18a$var$c) {
            V++;
            break;
        }
        if (F === $87a23dccae47b18a$var$j0 && V + 1 < Z && $.charCodeAt(V + 1) === $87a23dccae47b18a$var$c) {
            V += 2, K = !0;
            break;
        }
        if (F === $87a23dccae47b18a$var$M9 || F === $87a23dccae47b18a$var$S9) {
            var q = F;
            for(V++; V < Z && $.charCodeAt(V) !== q;)V++;
            V < Z && V++;
            continue;
        }
        if (F === $87a23dccae47b18a$var$x) return Q;
        V++;
    }
    if (K || $87a23dccae47b18a$var$c9(G)) return V;
    let J = 1;
    for(; V < Z && J > 0;)if ($.charCodeAt(V) === $87a23dccae47b18a$var$Z0) {
        if (V + 1 < Z && $.charCodeAt(V + 1) === $87a23dccae47b18a$var$j0) {
            let F = V + 2, W = F;
            for(; W < Z && ($.charCodeAt(W) >= $87a23dccae47b18a$var$d && $.charCodeAt(W) <= $87a23dccae47b18a$var$l || $.charCodeAt(W) >= $87a23dccae47b18a$var$U0 && $.charCodeAt(W) <= $87a23dccae47b18a$var$H0);)W++;
            if ($.slice(F, W).toLowerCase() === G) {
                for(; W < Z && $.charCodeAt(W) !== $87a23dccae47b18a$var$c;)W++;
                if (W < Z && W++, J--, J === 0) return W;
            }
            V = W;
        } else {
            let F = V + 1, W = F;
            for(; W < Z && ($.charCodeAt(W) >= $87a23dccae47b18a$var$d && $.charCodeAt(W) <= $87a23dccae47b18a$var$l || $.charCodeAt(W) >= $87a23dccae47b18a$var$U0 && $.charCodeAt(W) <= $87a23dccae47b18a$var$H0);)W++;
            $.slice(F, W).toLowerCase() === G && J++, V++;
        }
    } else V++;
    return V;
}
function $87a23dccae47b18a$var$eZ($, Q, Z, V, Y) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$A0 || Q + 1 >= Z || $.charCodeAt(Q + 1) !== $87a23dccae47b18a$var$A0) return null;
    let G = Q + 2;
    for(; G + 1 < Z;){
        let K = $.charCodeAt(G);
        if (K === $87a23dccae47b18a$var$$0) {
            let q = $87a23dccae47b18a$var$N$($, G, Z);
            if (q > G) {
                G = q;
                continue;
            }
        }
        if (K === $87a23dccae47b18a$var$A0 && $.charCodeAt(G + 1) === $87a23dccae47b18a$var$A0) {
            let q = $.slice(Q + 2, G), J = $87a23dccae47b18a$var$h0(q, 0, q.length, V, Y);
            return {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.textFormatted,
                    tag: "del",
                    children: J
                },
                end: G + 2
            };
        }
        K === $87a23dccae47b18a$var$N0 && G + 1 < Z && G++, G++;
    }
    return null;
}
function $87a23dccae47b18a$var$$5($, Q, Z, V, Y) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$C0 || Q + 1 >= Z || $.charCodeAt(Q + 1) !== $87a23dccae47b18a$var$C0) return null;
    let G = Q + 2;
    for(; G + 1 < Z;){
        let K = $.charCodeAt(G);
        if (K === $87a23dccae47b18a$var$$0) {
            let q = $87a23dccae47b18a$var$N$($, G, Z);
            if (q > G) {
                G = q;
                continue;
            }
        }
        if (K === $87a23dccae47b18a$var$C0 && $.charCodeAt(G + 1) === $87a23dccae47b18a$var$C0 && G > Q + 2) {
            let q = $.slice(Q + 2, G), J = $87a23dccae47b18a$var$h0(q, 0, q.length, V, Y);
            return {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.textFormatted,
                    tag: "mark",
                    children: J
                },
                end: G + 2
            };
        }
        K === $87a23dccae47b18a$var$N0 && G + 1 < Z && G++, G++;
    }
    return null;
}
function $87a23dccae47b18a$var$E6($, Q, Z) {
    return $ < $87a23dccae47b18a$var$n9 ? !!($87a23dccae47b18a$var$l$($) & $87a23dccae47b18a$var$d9) : $87a23dccae47b18a$var$j6.test(Q[Z]);
}
function $87a23dccae47b18a$var$T6($, Q, Z) {
    return $ < $87a23dccae47b18a$var$n9 ? !!($87a23dccae47b18a$var$l$($) & $87a23dccae47b18a$var$v9) : $87a23dccae47b18a$var$M6.test(Q[Z]);
}
function $87a23dccae47b18a$var$Z5($, Q, Z) {
    var V = $.charCodeAt(Q);
    if (V !== $87a23dccae47b18a$var$B0 && V !== $87a23dccae47b18a$var$z0) return null;
    var Y = $87a23dccae47b18a$var$P9($, Q, Z, V);
    if (Y === 0) return null;
    var G = Q > 0 ? $.charCodeAt(Q - 1) : 32, K = Q + Y < Z ? $.charCodeAt(Q + Y) : 32, q = $87a23dccae47b18a$var$T6(G, $, Q - 1), J = $87a23dccae47b18a$var$T6(K, $, Q + Y), F = Q > 0 ? $87a23dccae47b18a$var$E6(G, $, Q - 1) : !1, W = Q + Y < Z ? $87a23dccae47b18a$var$E6(K, $, Q + Y) : !1, X = !J && (!W || q || F), H = !q && (!F || J || W), z, D;
    return V === $87a23dccae47b18a$var$B0 ? (z = X, D = H) : (z = X && (!H || F), D = H && (!X || W)), {
        len: Y,
        canOpen: z,
        canClose: D
    };
}
function $87a23dccae47b18a$var$Q5($, Q, Z, V) {
    if (Q.length !== 0) {
        for(var Y = [], G = 0; G < 12; G++)Y[G] = -1;
        for(var K = 0; K < Q.length;){
            var q = Q[K];
            if (!q.active || !q.canClose) {
                K++;
                continue;
            }
            for(var J = q.ch === $87a23dccae47b18a$var$B0 ? 0 : 1, F = J * 6 + q.len % 3 * 2 + (q.canOpen ? 1 : 0), W = Y[F] !== void 0 ? Y[F] : -1, X = -1, H = K - 1; H > W; H--){
                var z = Q[H];
                if (!(!z.active || z.ch !== q.ch || !z.canOpen) && !((q.canOpen || z.canClose) && (z.len + q.len) % 3 === 0 && z.len % 3 !== 0)) {
                    X = H;
                    break;
                }
            }
            if (X < 0) {
                Y[F] = K - 1, !q.canOpen && (q.active = !1), K++;
                continue;
            }
            var D = Q[X], j = D.len >= 2 && q.len >= 2, U = j ? 2 : 1;
            D.len -= U, q.len -= U;
            var B = $[D.idx], M = $[q.idx];
            B.text = B.text.slice(0, B.text.length - U), M.text = M.text.slice(U);
            var A = D.idx + 1, k = q.idx, _ = $.slice(A, k), O = {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.textFormatted,
                tag: j ? "strong" : "em",
                children: _
            };
            $.splice(A, k - A, O);
            for(var E = k - A - 1, L = 0; L < Q.length; L++)Q[L].idx > D.idx && (Q[L].idx -= E);
            for(var y = X + 1; y < K; y++)Q[y].active = !1;
            if (D.len === 0 && (D.active = !1, B.text === "")) {
                $.splice(D.idx, 1);
                for(var I = 0; I < Q.length; I++)Q[I].idx > D.idx ? Q[I].idx-- : Q[I].idx === D.idx && (Q[I].idx = -1);
            }
            if (q.len === 0) {
                q.active = !1;
                var f = q.idx;
                if (M.text === "") {
                    $.splice(f, 1);
                    for(var w = 0; w < Q.length; w++)Q[w].idx > f ? Q[w].idx-- : Q[w].idx === f && (Q[w].idx = -1);
                }
            } else continue;
            K++;
        }
        for(var T = 0, m = 0; m < $.length; m++){
            var C = $[m];
            if (C.type === $87a23dccae47b18a$export$e0aa44767d8750d5.text) {
                var g = C;
                if (g.text === "") continue;
                if (T > 0 && $[T - 1].type === $87a23dccae47b18a$export$e0aa44767d8750d5.text) {
                    $[T - 1].text += g.text;
                    continue;
                }
            }
            $[T++] = C;
        }
        $.length = T;
    }
}
function $87a23dccae47b18a$var$f6($, Q, Z, V, Y) {
    let G = $.charCodeAt(Q) === $87a23dccae47b18a$var$x0, K = G ? Q + 1 : Q;
    if ($.charCodeAt(K) !== $87a23dccae47b18a$var$O0) return null;
    var q = $.indexOf("]", K + 1);
    if (q < 0 || q >= Z) return null;
    for(var J = K + 1, F = -1, W = 1; J < Z && W > 0;){
        var X = $.charCodeAt(J);
        if (X === $87a23dccae47b18a$var$N0 && J + 1 < Z) {
            J += 2;
            continue;
        }
        if (X === $87a23dccae47b18a$var$$0) {
            var H = $87a23dccae47b18a$var$N$($, J, Z);
            if (H > J) {
                J = H;
                continue;
            }
        }
        if (X === $87a23dccae47b18a$var$Z0) {
            var z = $87a23dccae47b18a$var$e6($, J, Z);
            if (z) {
                J = z.end;
                continue;
            }
            var D = $87a23dccae47b18a$var$t6($, J, Z);
            if (D > J) {
                J = D;
                continue;
            }
        }
        X === $87a23dccae47b18a$var$O0 ? W++ : X === $87a23dccae47b18a$var$p0 && W--, J++;
    }
    if (W !== 0) return null;
    var j = J - 1, U = $.slice(K + 1, j), B = J < Z ? $.charCodeAt(J) : 0, M = !1;
    if (B === $87a23dccae47b18a$var$$9) {
        var A = !0;
        for(J++; J < Z && ($.charCodeAt(J) === $87a23dccae47b18a$var$b || $.charCodeAt(J) === $87a23dccae47b18a$var$x);)J++;
        var k = "", _ = J;
        if (J < Z && $.charCodeAt(J) === $87a23dccae47b18a$var$Z0) {
            for(J++, _ = J; _ < Z && $.charCodeAt(_) !== $87a23dccae47b18a$var$c;){
                if ($.charCodeAt(_) === $87a23dccae47b18a$var$N0 && _ + 1 < Z) {
                    _ += 2;
                    continue;
                }
                if ($.charCodeAt(_) === $87a23dccae47b18a$var$x) {
                    A = !1;
                    break;
                }
                _++;
            }
            A && (_ >= Z || $.charCodeAt(_) !== $87a23dccae47b18a$var$c) && (A = !1), A && (k = $.slice(J, _), _++);
        } else if (A) {
            if (V.e !== void 0 && J >= V.e) A = !1;
            else {
                for(var O = 0, E = !1; _ < Z;){
                    var L = $.charCodeAt(_);
                    if (L === $87a23dccae47b18a$var$N0 && _ + 1 < Z) {
                        _ += 2;
                        continue;
                    }
                    if (L === $87a23dccae47b18a$var$$9) O++;
                    else if (L === $87a23dccae47b18a$var$Z9) {
                        if (E = !0, O === 0) break;
                        O--;
                    } else if (L === $87a23dccae47b18a$var$b || L === $87a23dccae47b18a$var$x) break;
                    _++;
                }
                _ >= Z && !E && (V.e === void 0 || J < V.e) && (V.e = J), k = $.slice(J, _);
            }
        }
        if (A) {
            for(J = _; J < Z && ($.charCodeAt(J) === $87a23dccae47b18a$var$b || $.charCodeAt(J) === $87a23dccae47b18a$var$x);)J++;
            var y;
            if (J < Z) {
                var I = $.charCodeAt(J);
                if (I === $87a23dccae47b18a$var$M9 || I === $87a23dccae47b18a$var$S9 || I === $87a23dccae47b18a$var$$9) {
                    var f = I === $87a23dccae47b18a$var$$9 ? 41 : I;
                    J++;
                    for(var w = J; J < Z && $.charCodeAt(J) !== f;)$.charCodeAt(J) === $87a23dccae47b18a$var$N0 && J + 1 < Z && J++, J++;
                    J >= Z ? A = !1 : (y = $.slice(w, J), J++);
                }
            }
            if (A) {
                for(; J < Z && ($.charCodeAt(J) === $87a23dccae47b18a$var$b || $.charCodeAt(J) === $87a23dccae47b18a$var$x);)J++;
                (J >= Z || $.charCodeAt(J) !== $87a23dccae47b18a$var$Z9) && (A = !1);
            }
        }
        if (A) {
            J++, k = $87a23dccae47b18a$var$$$(k), y !== void 0 && (y = $87a23dccae47b18a$var$s9($87a23dccae47b18a$var$$$(y)));
            var T = Y?.sanitizer || $87a23dccae47b18a$export$3e2338ea76b578c9, m = T(k, G ? "img" : "a", G ? "src" : "href"), C = m === null ? null : k;
            if (G) {
                var g = $87a23dccae47b18a$var$h0(U, 0, U.length, V, Y), X0 = $87a23dccae47b18a$var$I$(g);
                return {
                    node: {
                        type: $87a23dccae47b18a$export$e0aa44767d8750d5.image,
                        target: C,
                        alt: X0,
                        title: y
                    },
                    end: J
                };
            } else {
                var J0 = V.inAnchor;
                V.inAnchor = !0;
                var P = J0 ? [
                    {
                        type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                        text: U
                    }
                ] : $87a23dccae47b18a$var$h0(U, 0, U.length, V, Y);
                return V.inAnchor = J0, !V.inAnchor && $87a23dccae47b18a$var$c$(P) ? null : {
                    node: {
                        type: $87a23dccae47b18a$export$e0aa44767d8750d5.link,
                        target: C,
                        title: y,
                        children: P
                    },
                    end: J
                };
            }
        } else J = j + 1, M = !0;
    }
    var a = "", r = J;
    if (!M && B === $87a23dccae47b18a$var$O0) {
        var y0 = J + 1;
        r = y0;
        for(var R0 = !1; r < Z && $.charCodeAt(r) !== $87a23dccae47b18a$var$p0;){
            if ($.charCodeAt(r) === $87a23dccae47b18a$var$N0 && r + 1 < Z) {
                r += 2;
                continue;
            }
            if ($.charCodeAt(r) === $87a23dccae47b18a$var$O0) {
                R0 = !0;
                break;
            }
            r++;
        }
        if (R0 || r >= Z) return null;
        var F0 = $.slice(y0, r);
        if (F0.trim()) a = $87a23dccae47b18a$var$M$(F0);
        else {
            if ($87a23dccae47b18a$var$k6(U)) return null;
            a = $87a23dccae47b18a$var$M$(U);
        }
        r = r + 1;
    } else {
        if ($87a23dccae47b18a$var$k6(U)) return null;
        a = $87a23dccae47b18a$var$M$(U);
    }
    var u = V.refs[a];
    if (!u) return null;
    if (G) return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.image,
            target: u.target,
            alt: $87a23dccae47b18a$var$I$($87a23dccae47b18a$var$h0(U, 0, U.length, V, Y)),
            title: u.title
        },
        end: r
    };
    var n = V.inAnchor;
    V.inAnchor = !0;
    var P = n ? [
        {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
            text: U
        }
    ] : $87a23dccae47b18a$var$h0(U, 0, U.length, V, Y);
    return V.inAnchor = n, !V.inAnchor && $87a23dccae47b18a$var$c$(P) ? null : {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.link,
            target: u.target,
            title: u.title,
            children: P
        },
        end: r
    };
}
function $87a23dccae47b18a$var$e6($, Q, Z) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$Z0) return null;
    for(var V = Q + 1; V < Z;){
        var Y = $.charCodeAt(V);
        if (Y === $87a23dccae47b18a$var$c) break;
        if (Y === $87a23dccae47b18a$var$b || Y === $87a23dccae47b18a$var$x || Y === $87a23dccae47b18a$var$B9 || Y === $87a23dccae47b18a$var$Z0) return null;
        V++;
    }
    if (V >= Z || $.charCodeAt(V) !== $87a23dccae47b18a$var$c) return null;
    var G = $.slice(Q + 1, V), K = G.match(/^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^\x00-\x20]*)$/);
    return K ? {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.link,
            target: G,
            title: void 0,
            children: [
                {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                    text: G
                }
            ]
        },
        end: V + 1
    } : G.indexOf("@") !== -1 && /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(G) ? {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.link,
            target: "mailto:" + G,
            title: void 0,
            children: [
                {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                    text: G
                }
            ]
        },
        end: V + 1
    } : null;
}
function $87a23dccae47b18a$var$V5($, Q, Z, V) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$O0 || Q + 1 >= Z || $.charCodeAt(Q + 1) !== $87a23dccae47b18a$var$e0) return null;
    let Y = Q + 2;
    for(; Y < Z && $.charCodeAt(Y) !== $87a23dccae47b18a$var$p0 && $.charCodeAt(Y) !== $87a23dccae47b18a$var$x;)Y++;
    if (Y >= Z || $.charCodeAt(Y) !== $87a23dccae47b18a$var$p0) return null;
    let G = $.slice(Q + 2, Y);
    return G ? {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.footnoteReference,
            target: "#" + $87a23dccae47b18a$export$c383cdd2a518017a(G),
            text: G
        },
        end: Y + 1
    } : null;
}
function $87a23dccae47b18a$var$Y5($, Q, Z, V) {
    if (V.disableBareUrls) return null;
    var Y = "", G = !1, K = $.charCodeAt(Q);
    if (K === $87a23dccae47b18a$var$h9 || K === 72 ? Q + 8 <= Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$u9 && $.charCodeAt(Q + 2) === $87a23dccae47b18a$var$u9 && $.charCodeAt(Q + 3) === $87a23dccae47b18a$var$O$ && ($.charCodeAt(Q + 4) === $87a23dccae47b18a$var$E$ && $.charCodeAt(Q + 5) === $87a23dccae47b18a$var$E0 && $.charCodeAt(Q + 6) === $87a23dccae47b18a$var$j0 && $.charCodeAt(Q + 7) === $87a23dccae47b18a$var$j0 ? Y = "https://" : $.charCodeAt(Q + 4) === $87a23dccae47b18a$var$E0 && $.charCodeAt(Q + 5) === $87a23dccae47b18a$var$j0 && $.charCodeAt(Q + 6) === $87a23dccae47b18a$var$j0 && (Y = "http://")) : K === $87a23dccae47b18a$var$j9 || K === 70 ? Q + 6 <= Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$u9 && $.charCodeAt(Q + 2) === $87a23dccae47b18a$var$O$ && $.charCodeAt(Q + 3) === $87a23dccae47b18a$var$E0 && $.charCodeAt(Q + 4) === $87a23dccae47b18a$var$j0 && $.charCodeAt(Q + 5) === $87a23dccae47b18a$var$j0 && (Y = "ftp://") : (K === $87a23dccae47b18a$var$W9 || K === 87) && Q + 4 <= Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$W9 && $.charCodeAt(Q + 2) === $87a23dccae47b18a$var$W9 && $.charCodeAt(Q + 3) === $87a23dccae47b18a$var$d0 && (Y = "www.", G = !0), !Y) return null;
    let q = Q + Y.length;
    for(; q < Z;){
        let O = $.charCodeAt(q);
        if (O === $87a23dccae47b18a$var$b || O === $87a23dccae47b18a$var$x || O === $87a23dccae47b18a$var$R || O === $87a23dccae47b18a$var$B9 || O === $87a23dccae47b18a$var$Z0 || O === $87a23dccae47b18a$var$c) break;
        q++;
    }
    for(var J = 0, F = 0, W = Q; W < q; W++){
        var X = $.charCodeAt(W);
        X === $87a23dccae47b18a$var$$9 ? J++ : X === $87a23dccae47b18a$var$Z9 && F++;
    }
    let H = q;
    for(; H > Q + Y.length;){
        let O = $.charCodeAt(H - 1);
        if (O === $87a23dccae47b18a$var$d0 || O === $87a23dccae47b18a$var$J6 || O === $87a23dccae47b18a$var$E0 || O === $87a23dccae47b18a$var$x0 || O === $87a23dccae47b18a$var$i9 || O === $87a23dccae47b18a$var$Z9 || O === $87a23dccae47b18a$var$B0 || O === $87a23dccae47b18a$var$z0 || O === $87a23dccae47b18a$var$A0) {
            if (O === $87a23dccae47b18a$var$Z9) {
                if (J >= F) break;
                F--;
            }
            H--;
        } else if (O === $87a23dccae47b18a$var$T$) {
            for(var z = H - 2; z > Q && ($.charCodeAt(z) >= $87a23dccae47b18a$var$d && $.charCodeAt(z) <= $87a23dccae47b18a$var$l || $.charCodeAt(z) >= $87a23dccae47b18a$var$U0 && $.charCodeAt(z) <= $87a23dccae47b18a$var$H0 || $.charCodeAt(z) >= $87a23dccae47b18a$var$o && $.charCodeAt(z) <= $87a23dccae47b18a$var$i);)z--;
            z >= Q && $.charCodeAt(z) === $87a23dccae47b18a$var$g$ ? H = z : H--;
        } else break;
    }
    if (H <= Q + Y.length) return null;
    var D = Q + (G ? 4 : Y.length), j = $.indexOf("/", D);
    if ((j < 0 || j > H) && (j = H), G && $.indexOf(".", D) === -1) return null;
    for(var U = -1, B = -1, M = j - 1; M >= D; M--)if ($.charCodeAt(M) === $87a23dccae47b18a$var$d0) {
        if (U < 0) U = M;
        else {
            B = M;
            break;
        }
    }
    for(var A = B >= 0 ? B + 1 : D, M = A; M < j; M++)if ($.charCodeAt(M) === $87a23dccae47b18a$var$z0) return null;
    var k = $.slice(Q, H), _ = G ? "http://" + k : k;
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.link,
            target: _,
            title: void 0,
            children: [
                {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                    text: k
                }
            ]
        },
        end: H
    };
}
function $87a23dccae47b18a$var$G5($, Q, Z, V) {
    if (V.disableBareUrls) return null;
    for(var Y = Q, G = Y; Y < Z;){
        var K = $.charCodeAt(Y);
        if (K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$l || K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$H0 || K >= $87a23dccae47b18a$var$o && K <= $87a23dccae47b18a$var$i || K === $87a23dccae47b18a$var$d0 || K === $87a23dccae47b18a$var$x0 || K === $87a23dccae47b18a$var$J9 || K === 36 || K === $87a23dccae47b18a$var$G$ || K === $87a23dccae47b18a$var$g$ || K === $87a23dccae47b18a$var$S9 || K === $87a23dccae47b18a$var$B0 || K === $87a23dccae47b18a$var$A9 || K === $87a23dccae47b18a$var$j0 || K === $87a23dccae47b18a$var$C0 || K === $87a23dccae47b18a$var$i9 || K === $87a23dccae47b18a$var$e0 || K === $87a23dccae47b18a$var$z0 || K === $87a23dccae47b18a$var$$0 || K === $87a23dccae47b18a$var$g9 || K === $87a23dccae47b18a$var$w0 || K === $87a23dccae47b18a$var$D$ || K === $87a23dccae47b18a$var$A0 || K === $87a23dccae47b18a$var$p) Y++;
        else break;
    }
    if (Y === G || Y >= Z || $.charCodeAt(Y) !== $87a23dccae47b18a$var$K$) return null;
    Y++;
    for(var q = Y, J = -1, F = Y; Y < Z;){
        var K = $.charCodeAt(Y);
        if (K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$l || K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$H0 || K >= $87a23dccae47b18a$var$o && K <= $87a23dccae47b18a$var$i) Y++;
        else if ((K === $87a23dccae47b18a$var$p || K === $87a23dccae47b18a$var$z0) && Y > q) Y++;
        else if (K === $87a23dccae47b18a$var$d0) {
            if (Y === q) break;
            var W = $.charCodeAt(Y - 1);
            if (W === $87a23dccae47b18a$var$p || W === $87a23dccae47b18a$var$z0 || Y - F > 63) break;
            if (Y + 1 < Z) {
                var X = $.charCodeAt(Y + 1);
                if (X >= $87a23dccae47b18a$var$d && X <= $87a23dccae47b18a$var$l || X >= $87a23dccae47b18a$var$U0 && X <= $87a23dccae47b18a$var$H0 || X >= $87a23dccae47b18a$var$o && X <= $87a23dccae47b18a$var$i) J = Y, F = Y + 1, Y++;
                else break;
            } else break;
        } else break;
    }
    if (Y - F > 63 || J < 0) return null;
    var H = $.charCodeAt(Y - 1);
    if (!(H >= $87a23dccae47b18a$var$d && H <= $87a23dccae47b18a$var$l || H >= $87a23dccae47b18a$var$U0 && H <= $87a23dccae47b18a$var$H0 || H >= $87a23dccae47b18a$var$o && H <= $87a23dccae47b18a$var$i) || Y <= J + 1) return null;
    for(var z = -1, D = J - 1; D >= q; D--)if ($.charCodeAt(D) === $87a23dccae47b18a$var$d0) {
        z = D;
        break;
    }
    for(var j = z >= 0 ? z + 1 : q, D = j; D < Y; D++)if ($.charCodeAt(D) === $87a23dccae47b18a$var$z0) return null;
    var U = $.slice(Q, Y);
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.link,
            target: "mailto:" + U,
            title: void 0,
            children: [
                {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
                    text: U
                }
            ]
        },
        end: Y
    };
}
function $87a23dccae47b18a$var$c$($) {
    for(var Q = 0; Q < $.length; Q++)if ($[Q].type === $87a23dccae47b18a$export$e0aa44767d8750d5.link || "children" in $[Q] && Array.isArray($[Q].children) && $87a23dccae47b18a$var$c$($[Q].children)) return !0;
    return !1;
}
function $87a23dccae47b18a$var$I$($) {
    for(var Q = "", Z = 0; Z < $.length; Z++){
        var V = $[Z];
        V.type === $87a23dccae47b18a$export$e0aa44767d8750d5.text ? Q += V.text : V.type === $87a23dccae47b18a$export$e0aa44767d8750d5.breakLine ? Q += " " : V.type === $87a23dccae47b18a$export$e0aa44767d8750d5.codeInline ? Q += V.text : "children" in V && Array.isArray(V.children) ? Q += $87a23dccae47b18a$var$I$(V.children) : V.type === $87a23dccae47b18a$export$e0aa44767d8750d5.image ? Q += V.alt || "" : V.type === $87a23dccae47b18a$export$e0aa44767d8750d5.link && (Q += $87a23dccae47b18a$var$I$(V.children));
    }
    return Q;
}
function $87a23dccae47b18a$var$l9($) {
    let Q = $.includes("&") ? $87a23dccae47b18a$var$s9($) : $;
    return {
        type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
        text: Q
    };
}
function $87a23dccae47b18a$var$K5($, Q, Z, V, Y) {
    if ($.charCodeAt(Q) !== $87a23dccae47b18a$var$Z0) return null;
    var G = Q + 1;
    if (G >= Z) return null;
    var K = $.charCodeAt(G);
    if (K === $87a23dccae47b18a$var$x0 && G + 1 < Z && $.charCodeAt(G + 1) === $87a23dccae47b18a$var$p && G + 2 < Z && $.charCodeAt(G + 2) === $87a23dccae47b18a$var$p) {
        var q = G + 3;
        if (q < Z && $.charCodeAt(q) === $87a23dccae47b18a$var$c) return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlComment,
                text: "",
                h: !0
            },
            end: q + 1
        };
        if (q + 1 < Z && $.charCodeAt(q) === $87a23dccae47b18a$var$p && $.charCodeAt(q + 1) === $87a23dccae47b18a$var$c) return {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlComment,
                text: "-",
                h: !0
            },
            end: q + 2
        };
        var J = $.indexOf("-->", q);
        return J !== -1 && J <= Z - 3 ? {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlComment,
                text: $.slice(Q + 4, J),
                h: !1
            },
            end: J + 3
        } : null;
    }
    if (K === $87a23dccae47b18a$var$i9) {
        var F = $.indexOf("?>", G + 1);
        return F !== -1 && F < Z ? {
            node: {
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
                tag: "?",
                attrs: {},
                a: $.slice(Q, F + 2),
                b: !1
            },
            end: F + 2
        } : null;
    }
    if (K === $87a23dccae47b18a$var$x0 && G + 1 < Z) {
        var W = $.charCodeAt(G + 1);
        if (W === $87a23dccae47b18a$var$O0 && $.slice(G + 1, G + 8) === "[CDATA[") {
            var X = $.indexOf("]]>", G + 8);
            return X !== -1 && X < Z ? {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
                    tag: "![CDATA[",
                    attrs: {},
                    a: $.slice(Q, X + 3),
                    b: !1
                },
                end: X + 3
            } : null;
        }
        if (W >= $87a23dccae47b18a$var$d && W <= $87a23dccae47b18a$var$l) {
            var H = $.indexOf(">", G + 2);
            return H !== -1 && H < Z ? {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
                    tag: "!" + $.slice(G + 1, H),
                    attrs: {},
                    a: $.slice(Q, H + 1),
                    b: !1
                },
                end: H + 1
            } : null;
        }
    }
    if (K === $87a23dccae47b18a$var$j0) {
        var z = G + 1;
        if (z >= Z) return null;
        var D = $.charCodeAt(z);
        if (!(D >= $87a23dccae47b18a$var$d && D <= $87a23dccae47b18a$var$l || D >= $87a23dccae47b18a$var$U0 && D <= $87a23dccae47b18a$var$H0)) return null;
        for(z++; z < Z;){
            var j = $.charCodeAt(z);
            if (j >= $87a23dccae47b18a$var$d && j <= $87a23dccae47b18a$var$l || j >= $87a23dccae47b18a$var$U0 && j <= $87a23dccae47b18a$var$H0 || j >= $87a23dccae47b18a$var$o && j <= $87a23dccae47b18a$var$i || j === $87a23dccae47b18a$var$p) z++;
            else break;
        }
        for(; z < Z && ($.charCodeAt(z) === $87a23dccae47b18a$var$b || $.charCodeAt(z) === $87a23dccae47b18a$var$R || $.charCodeAt(z) === $87a23dccae47b18a$var$x);)z++;
        if (z < Z && $.charCodeAt(z) === $87a23dccae47b18a$var$c) {
            var U = $.slice(G + 1, z).trim();
            return {
                node: {
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
                    tag: U,
                    attrs: {},
                    a: $.slice(Q, z + 1),
                    b: !0
                },
                end: z + 1
            };
        }
        return null;
    }
    if (!(K >= $87a23dccae47b18a$var$d && K <= $87a23dccae47b18a$var$l || K >= $87a23dccae47b18a$var$U0 && K <= $87a23dccae47b18a$var$H0)) return null;
    var B = $87a23dccae47b18a$var$N9($, Q);
    if (!B) return null;
    var M = B.tag, A = M.toLowerCase(), k = B.selfClosing;
    if (k || $87a23dccae47b18a$var$c9(M)) return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
            tag: M,
            attrs: $87a23dccae47b18a$var$I9(B.attrs, M, Y),
            a: $.slice(Q, B.end),
            b: !1
        },
        end: B.end
    };
    var _ = $87a23dccae47b18a$var$F$.has(A), O = $87a23dccae47b18a$var$d$($.slice(0, Z), B.end, M);
    if (O === -1) return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing,
            tag: M,
            attrs: $87a23dccae47b18a$var$I9(B.attrs, M, Y),
            a: $.slice(Q, B.end),
            b: !1
        },
        end: B.end
    };
    var E = $87a23dccae47b18a$var$rZ($, "</" + A, O), L = $.slice(B.end, E), y = [];
    if (_) L.trim() && (y = [
        {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
            text: L
        }
    ]);
    else {
        var I = L.trim();
        if (I) {
            var { inAnchor: f, inline: w } = V;
            A === "a" && (V.inAnchor = !0);
            var T = I.indexOf(`

`) !== -1 || /^#{1,6}\s/.test(I);
            T ? (V.inline = !1, y = $87a23dccae47b18a$var$b9(I, V, Y)) : y = $87a23dccae47b18a$var$h0(I, 0, I.length, V, Y), V.inAnchor = f, V.inline = w;
        }
    }
    return {
        node: {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock,
            tag: M,
            attrs: $87a23dccae47b18a$var$I9(B.attrs, M, Y),
            f: B.rawAttrs,
            children: y,
            a: void 0,
            text: L,
            c: !1,
            b: !1
        },
        end: O
    };
}
var $87a23dccae47b18a$var$q5 = 200, $87a23dccae47b18a$var$e9 = 0;
function $87a23dccae47b18a$var$h0($, Q, Z, V, Y) {
    if ($87a23dccae47b18a$var$e9++, $87a23dccae47b18a$var$e9 > $87a23dccae47b18a$var$q5) return $87a23dccae47b18a$var$e9--, [
        {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
            text: $.slice(Q, Z)
        }
    ];
    var G = V.e;
    V.e = void 0;
    let K = V;
    if (Y.optimizeForStreaming) {
        let n0 = function(S, S0) {
            for(var q0 = 1, s0 = S0 + 1; s0 < S.length; s0++){
                var z9 = S.charCodeAt(s0);
                if (z9 === $87a23dccae47b18a$var$O0) q0++;
                else if (z9 === $87a23dccae47b18a$var$p0 && (q0--, q0 === 0)) return s0;
            }
            return -1;
        }, N = $.slice(Q, Z), e = N;
        for(var q = 0, J = 0, F = 0, W = 0, X = 0, H = -1, z = -1, D = -1, j = -1, U = -1, B = 0; B < N.length; B++){
            var M = N.charCodeAt(B);
            M === $87a23dccae47b18a$var$B0 ? B + 1 < N.length && N.charCodeAt(B + 1) === $87a23dccae47b18a$var$B0 ? (q++, H = B, B++) : (J++, z = B) : M === $87a23dccae47b18a$var$z0 ? B + 1 < N.length && N.charCodeAt(B + 1) === $87a23dccae47b18a$var$z0 ? (F++, D = B, B++) : (W++, j = B) : M === $87a23dccae47b18a$var$A0 && B + 1 < N.length && N.charCodeAt(B + 1) === $87a23dccae47b18a$var$A0 && (X++, U = B, B++);
        }
        var A = [];
        X % 2 === 1 && U >= 0 && A.push([
            U,
            2
        ]), F % 2 === 1 && D >= 0 && A.push([
            D,
            2
        ]), W % 2 === 1 && j >= 0 && A.push([
            j,
            1
        ]), q % 2 === 1 && H >= 0 && A.push([
            H,
            2
        ]), J % 2 === 1 && z >= 0 && A.push([
            z,
            1
        ]), A.sort(function(S, S0) {
            return S0[0] - S[0];
        });
        for(var k = 0; k < A.length; k++){
            var _ = A[k][0], O = A[k][1];
            N = N.slice(0, _) + N.slice(_ + O);
        }
        let I0 = 0, a0 = -1;
        for(let S = 0; S < N.length; S++)N.charCodeAt(S) === $87a23dccae47b18a$var$$0 && (I0++, a0 = S);
        if (I0 % 2 === 1 && a0 !== -1) {
            let S = !1, S0 = -1, q0 = 0;
            for(; q0 < N.length;)N.charCodeAt(q0) === $87a23dccae47b18a$var$$0 && (S ? (S = !1, S0 = -1) : (S0 = q0, S = !0)), q0++;
            S && S0 !== -1 && (N = N.slice(0, S0));
        }
        for(var E = !0; E;){
            E = !1;
            for(var L = -1, y = -1, I = -1, f = !1, w = 0; w < N.length; w++){
                var T = N.charCodeAt(w);
                if (T === $87a23dccae47b18a$var$O0 && (w === 0 || N.charCodeAt(w - 1) !== $87a23dccae47b18a$var$N0)) {
                    var m = w > 0 && N.charCodeAt(w - 1) === $87a23dccae47b18a$var$x0, C = m ? w - 1 : w, g = n0(N, w);
                    if (g === -1) L = C, f = m, y = w + 1, I = N.length;
                    else {
                        var X0 = g + 1;
                        if (X0 >= N.length) L = C, f = m, y = w + 1, I = g;
                        else if (N.charCodeAt(X0) === $87a23dccae47b18a$var$$9) {
                            var J0 = N.indexOf(")", X0 + 1);
                            J0 === -1 ? (L = C, f = m, y = w + 1, I = g, w = N.length) : w = J0;
                        } else if (N.charCodeAt(X0) === $87a23dccae47b18a$var$O0) {
                            var P = N.indexOf("]", X0 + 1);
                            P === -1 ? (L = C, f = m, y = w + 1, I = g, w = N.length) : w = P;
                        } else w = g;
                    }
                }
            }
            if (L >= 0) {
                var a = f ? "" : N.slice(y, I);
                N = N.slice(0, L) + a, E = !0;
            }
        }
        let P0 = N.match(/<([A-Z][A-Za-z0-9]*)(?:\s[^>]*)?>([^<]*)$/);
        if (P0 && P0.index !== void 0) {
            var r = P0[0].length - P0[2].length, y0 = r >= 2 && P0[0].charCodeAt(r - 2) === $87a23dccae47b18a$var$j0;
            if (!y0) {
                for(var R0 = !1, F0 = 0, u = 0; u < P0.index; u++)N.charCodeAt(u) === $87a23dccae47b18a$var$$0 && F0++;
                if (R0 = F0 % 2 === 1, !R0) {
                    let S = P0[1];
                    $87a23dccae47b18a$var$T9(N, "</" + S, 0) === -1 && (N = N.replace(/<[A-Z][A-Za-z0-9]*(?:\s[^>]*)?>([^<]*)$/, "$1"));
                }
            }
        }
        N !== e && ($ = $.slice(0, Q) + N, Z = Q + N.length);
    }
    let n = [];
    var D0 = [];
    let s = Q;
    var M0 = Y.disableAutoLink || Y.disableBareUrls || K.inAnchor ? -1 : $.indexOf("@", Q);
    for(M0 >= Z && (M0 = -1); Q < Z;){
        let N = $.charCodeAt(Q), e = null;
        if (N === $87a23dccae47b18a$var$$0) {
            if (e = $87a23dccae47b18a$var$tZ($, Q, Z), !e) {
                var _0 = $87a23dccae47b18a$var$P9($, Q, Z, $87a23dccae47b18a$var$$0);
                Q += _0 - 1;
            }
        } else if (N === $87a23dccae47b18a$var$B0 || N === $87a23dccae47b18a$var$z0) {
            var K0 = $87a23dccae47b18a$var$Z5($, Q, Z);
            if (K0) {
                if (K0.canOpen || K0.canClose) {
                    Q > s && n.push($87a23dccae47b18a$var$l9($.slice(s, Q)));
                    var b0 = $.slice(Q, Q + K0.len), V0 = $87a23dccae47b18a$var$l9(b0);
                    D0.push({
                        idx: n.length,
                        ch: N,
                        len: K0.len,
                        canOpen: K0.canOpen,
                        canClose: K0.canClose,
                        active: !0
                    }), n.push(V0), Q += K0.len, s = Q;
                    continue;
                }
                Q += K0.len - 1;
            }
        } else if (N === $87a23dccae47b18a$var$A0) e = $87a23dccae47b18a$var$eZ($, Q, Z, K, Y);
        else if (N === $87a23dccae47b18a$var$C0) e = $87a23dccae47b18a$var$$5($, Q, Z, K, Y);
        else if (N === $87a23dccae47b18a$var$O0) Q + 1 < Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$e0 && (e = $87a23dccae47b18a$var$V5($, Q, Z, K)), e || (e = $87a23dccae47b18a$var$f6($, Q, Z, K, Y));
        else if (N === $87a23dccae47b18a$var$x0 && Q + 1 < Z && $.charCodeAt(Q + 1) === $87a23dccae47b18a$var$O0) e = $87a23dccae47b18a$var$f6($, Q, Z, K, Y);
        else if (N === $87a23dccae47b18a$var$Z0) e = $87a23dccae47b18a$var$e6($, Q, Z), !e && !Y.disableParsingRawHTML && !Y.ignoreHTMLBlocks && (e = $87a23dccae47b18a$var$K5($, Q, Z, K, Y));
        else if ((N === $87a23dccae47b18a$var$h9 || N === $87a23dccae47b18a$var$W9 || N === $87a23dccae47b18a$var$j9) && !K.inAnchor && !Y.disableAutoLink && (Q === 0 || $.charCodeAt(Q - 1) !== $87a23dccae47b18a$var$Z0)) {
            var W0 = Q + 1 < Z ? $.charCodeAt(Q + 1) : 0;
            (N === $87a23dccae47b18a$var$h9 && W0 === $87a23dccae47b18a$var$u9 || N === $87a23dccae47b18a$var$j9 && W0 === $87a23dccae47b18a$var$u9 || N === $87a23dccae47b18a$var$W9 && W0 === $87a23dccae47b18a$var$W9) && (e = $87a23dccae47b18a$var$Y5($, Q, Z, Y));
        }
        if (!e && M0 >= 0 && M0 - Q <= 64 && !K.inAnchor && !Y.disableAutoLink && !Y.disableBareUrls && (N >= $87a23dccae47b18a$var$d && N <= $87a23dccae47b18a$var$l || N >= $87a23dccae47b18a$var$U0 && N <= $87a23dccae47b18a$var$H0 || N >= $87a23dccae47b18a$var$o && N <= $87a23dccae47b18a$var$i) && (e = $87a23dccae47b18a$var$G5($, Q, Z, Y), !e && Q >= M0 && (M0 = $.indexOf("@", Q + 1), M0 >= Z && (M0 = -1))), N === $87a23dccae47b18a$var$B$) {
            Q > s && n.push($87a23dccae47b18a$var$l9($.slice(s, Q))), n.push({
                type: $87a23dccae47b18a$export$e0aa44767d8750d5.breakLine
            }), Q++, s = Q;
            continue;
        }
        if (e) Q > s && n.push($87a23dccae47b18a$var$l9($.slice(s, Q))), n.push(e.node), Q = e.end, s = Q;
        else {
            if (N === $87a23dccae47b18a$var$N0 && Q + 1 < Z) {
                let I0 = $.charCodeAt(Q + 1);
                if ($87a23dccae47b18a$var$l$(I0) & $87a23dccae47b18a$var$d9) {
                    Q > s && n.push($87a23dccae47b18a$var$l9($.slice(s, Q))), n.push($87a23dccae47b18a$var$l9($[Q + 1])), Q += 2, s = Q;
                    continue;
                }
            }
            if (Q++, M0 < 0 || M0 - Q > 64) for(; Q < Z && !(M0 >= 0 && M0 - Q <= 64);){
                var h = $.charCodeAt(Q);
                if (h < $87a23dccae47b18a$var$n9 && !$87a23dccae47b18a$var$h6[h]) Q++;
                else break;
            }
        }
    }
    if (Z > s) {
        let N = $.slice(s, Z);
        N && n.push($87a23dccae47b18a$var$l9(N));
    }
    return D0.length > 0 && $87a23dccae47b18a$var$Q5(n, D0, V, Y), V.e = G, $87a23dccae47b18a$var$e9--, n;
}
var $87a23dccae47b18a$var$J5 = 500;
function $87a23dccae47b18a$var$b9($, Q, Z) {
    var V = Q.i || 0;
    if (V > $87a23dccae47b18a$var$J5) return [
        {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.text,
            text: $
        }
    ];
    Q.i = V + 1;
    let Y = Q;
    if (Z.optimizeForStreaming && !Q.j) {
        var G = $.length;
        G > 0 && $.charCodeAt(G - 1) === $87a23dccae47b18a$var$x && G--;
        for(var K = G; K > 0 && $.charCodeAt(K - 1) !== $87a23dccae47b18a$var$x;)K--;
        if (K > 0 && $.charCodeAt(K) === $87a23dccae47b18a$var$w0) {
            for(var q = !0, J = K; J < G; J++){
                var F = $.charCodeAt(J);
                if (F !== $87a23dccae47b18a$var$b && F !== $87a23dccae47b18a$var$R && F !== $87a23dccae47b18a$var$p && F !== $87a23dccae47b18a$var$E0 && F !== $87a23dccae47b18a$var$w0) {
                    q = !1;
                    break;
                }
            }
            if (q) {
                for(var W = K - 1; W > 0 && $.charCodeAt(W - 1) !== $87a23dccae47b18a$var$x;)W--;
                $.charCodeAt(W) === $87a23dccae47b18a$var$w0 && ($ = $.slice(0, W).trimEnd());
            }
        }
        var X = $.trim(), H = X.lastIndexOf(`
`), z = H === -1 ? X : X.slice(H + 1);
        if (z.length > 0 && z.charCodeAt(0) === $87a23dccae47b18a$var$w0) {
            for(var D = !1, j = !1, U = 1; U < z.length; U++){
                var B = z.charCodeAt(U);
                B === $87a23dccae47b18a$var$w0 && (D = !0), B === $87a23dccae47b18a$var$p && (j = !0);
            }
            D && j && ($ = H === -1 ? "" : $.slice(0, $.lastIndexOf(z)).trimEnd());
        }
        for(var M = -1, A = -1, k = -1, _ = $.length - 1; _ >= 0; _--)if ($.charCodeAt(_) === $87a23dccae47b18a$var$Z0) {
            var O = _ + 1 < $.length ? $.charCodeAt(_ + 1) : 0;
            if (O >= $87a23dccae47b18a$var$d && O <= $87a23dccae47b18a$var$l || O >= $87a23dccae47b18a$var$U0 && O <= $87a23dccae47b18a$var$H0) {
                for(var E = _ + 2; E < $.length;){
                    var L = $.charCodeAt(E);
                    if (L >= $87a23dccae47b18a$var$d && L <= $87a23dccae47b18a$var$l || L >= $87a23dccae47b18a$var$U0 && L <= $87a23dccae47b18a$var$H0 || L >= $87a23dccae47b18a$var$o && L <= $87a23dccae47b18a$var$i) E++;
                    else break;
                }
                for(var y = E; y < $.length && $.charCodeAt(y) !== $87a23dccae47b18a$var$c;)y++;
                if (y < $.length && $.charCodeAt(y - 1) !== $87a23dccae47b18a$var$j0) {
                    for(var I = !1, f = y + 1; f < $.length; f++)if ($.charCodeAt(f) === $87a23dccae47b18a$var$Z0) {
                        I = !0;
                        break;
                    }
                    I || (M = _, A = E, k = y + 1);
                }
            }
            break;
        }
        if (M >= 0) {
            for(var w = 0, T = 0; T < M; T++)$.charCodeAt(T) === $87a23dccae47b18a$var$$0 && w++;
            if (w % 2 === 0) {
                var m = $.slice(M + 1, A);
                $87a23dccae47b18a$var$T9($, "</" + m, 0) === -1 && ($ = $.slice(0, M) + $.slice(k));
            }
        }
        for(var C = $.length; C > 0 && $.charCodeAt(C - 1) === $87a23dccae47b18a$var$x;)C--;
        if (C > 0) {
            for(var g = C; g > 0 && $.charCodeAt(g - 1) !== $87a23dccae47b18a$var$x;)g--;
            for(var X0 = g, J0 = 0; X0 < C && $.charCodeAt(X0) === $87a23dccae47b18a$var$b && J0 < 3;)X0++, J0++;
            if (g > 0 && X0 < C && $87a23dccae47b18a$var$uZ($, X0, C)) {
                for(var P = g - 1, a = P; a > 0 && $.charCodeAt(a - 1) !== $87a23dccae47b18a$var$x;)a--;
                $87a23dccae47b18a$var$l0($, a, P) || ($ = $.slice(0, g).trimEnd());
            }
        }
        var r = $.length;
        if (r > 0) {
            for(var y0 = $.lastIndexOf(`
`), R0 = y0 === -1 ? 0 : y0 + 1, F0 = r, u = R0, n = 0; u < F0 && $.charCodeAt(u) === $87a23dccae47b18a$var$b && n < 3;)u++, n++;
            if (u < F0) {
                var D0 = $.charCodeAt(u), s = !1;
                if (D0 === $87a23dccae47b18a$var$B0 || D0 === $87a23dccae47b18a$var$p || D0 === $87a23dccae47b18a$var$A9) {
                    var M0 = u + 1;
                    if (M0 >= F0 || $.charCodeAt(M0) === $87a23dccae47b18a$var$b || $.charCodeAt(M0) === $87a23dccae47b18a$var$R) {
                        for(var _0 = M0; _0 < F0 && ($.charCodeAt(_0) === $87a23dccae47b18a$var$b || $.charCodeAt(_0) === $87a23dccae47b18a$var$R);)_0++;
                        _0 >= F0 && (s = !0);
                    }
                } else if (D0 >= $87a23dccae47b18a$var$o && D0 <= $87a23dccae47b18a$var$i) {
                    for(var K0 = u; K0 < F0 && $.charCodeAt(K0) >= $87a23dccae47b18a$var$o && $.charCodeAt(K0) <= $87a23dccae47b18a$var$i;)K0++;
                    if (K0 < F0 && ($.charCodeAt(K0) === $87a23dccae47b18a$var$d0 || $.charCodeAt(K0) === $87a23dccae47b18a$var$Z9)) {
                        var b0 = K0 + 1;
                        if (b0 >= F0 || $.charCodeAt(b0) === $87a23dccae47b18a$var$b || $.charCodeAt(b0) === $87a23dccae47b18a$var$R) {
                            for(var V0 = b0; V0 < F0 && ($.charCodeAt(V0) === $87a23dccae47b18a$var$b || $.charCodeAt(V0) === $87a23dccae47b18a$var$R);)V0++;
                            V0 >= F0 && (s = !0);
                        }
                    }
                }
                s && ($ = $.slice(0, R0).trimEnd());
            }
        }
    }
    if (Q.inline) return $87a23dccae47b18a$var$h0($, 0, $.length, Q, Z);
    let W0 = [], h = 0, N = $.length;
    if (h === 0 && !Z.disableFrontmatter && $.startsWith("---")) {
        let S = $87a23dccae47b18a$var$O6($);
        if (S && S.hasValidYaml) {
            if (Z.preserveFrontmatter !== !1) {
                let S0 = $.slice(0, S.endPos).trimEnd();
                W0.push({
                    type: $87a23dccae47b18a$export$e0aa44767d8750d5.frontmatter,
                    text: S0
                });
            }
            h = S.endPos;
        }
    }
    for(; h < N;){
        for(var e = $.indexOf(`
`, h), I0 = e < 0 ? N : e; h < N && $87a23dccae47b18a$var$l0($, h, I0);)h = I0 < N ? I0 + 1 : I0, h < N && (e = $.indexOf(`
`, h), I0 = e < 0 ? N : e);
        if (h >= N) break;
        $.charCodeAt(h), $87a23dccae47b18a$var$v0($, h, I0);
        let S = null;
        if ($87a23dccae47b18a$var$r6 = $, $87a23dccae47b18a$var$o6 = h, $87a23dccae47b18a$var$i6 = I0, $.charCodeAt(h) !== $87a23dccae47b18a$var$a9 && $87a23dccae47b18a$var$Y0 >= 4 && !Q.inHTML) S = $87a23dccae47b18a$var$dZ($, h);
        else if ($.charCodeAt(h) !== $87a23dccae47b18a$var$a9) {
            let S0 = h + $87a23dccae47b18a$var$Q0, q0 = $.charCodeAt(S0);
            q0 === $87a23dccae47b18a$var$J9 ? S = $87a23dccae47b18a$var$a6($, h, Q, Z) : q0 === $87a23dccae47b18a$var$c ? S = $87a23dccae47b18a$var$cZ($, h, Q, Z) : q0 === $87a23dccae47b18a$var$$0 || q0 === $87a23dccae47b18a$var$A0 ? S = $87a23dccae47b18a$var$pZ($, h, Q) : q0 === $87a23dccae47b18a$var$p || q0 === $87a23dccae47b18a$var$B0 || q0 === $87a23dccae47b18a$var$z0 ? (S = $87a23dccae47b18a$var$f9($, h), !S && (S = $87a23dccae47b18a$var$S6($, h, Q, Z))) : q0 === $87a23dccae47b18a$var$A9 || q0 >= $87a23dccae47b18a$var$o && q0 <= $87a23dccae47b18a$var$i ? S = $87a23dccae47b18a$var$S6($, h, Q, Z) : q0 === $87a23dccae47b18a$var$Z0 ? S = $87a23dccae47b18a$var$s6($, h, Q, Z) : q0 === $87a23dccae47b18a$var$w0 ? S = $87a23dccae47b18a$var$x6($, h, Q, Z) : q0 === $87a23dccae47b18a$var$O0 && (S = $87a23dccae47b18a$var$iZ($, h, Q));
        }
        if (!S) {
            for(var a0 = !1, n0 = h; n0 < I0; n0++)if ($.charCodeAt(n0) === $87a23dccae47b18a$var$w0) {
                a0 = !0;
                break;
            }
            a0 && (S = $87a23dccae47b18a$var$x6($, h, Q, Z));
        }
        if (S || (S = $87a23dccae47b18a$var$nZ($, h, Q, Z)), S) S.node.type !== $87a23dccae47b18a$export$e0aa44767d8750d5.refCollection && W0.push(S.node), h = S.end;
        else {
            var P0 = $.indexOf(`
`, h);
            h = P0 < 0 ? N : P0 + 1;
        }
    }
    return Q.i = V, W0;
}
function $87a23dccae47b18a$export$8f49e4af10703ce3($, Q) {
    $87a23dccae47b18a$var$e9 = 0, $.charCodeAt(0) === 65279 && ($ = $.slice(1)), $ = $87a23dccae47b18a$var$C$($);
    let Z = {
        inline: !1,
        inAnchor: !1,
        inHTML: !1,
        inList: !1,
        inBlockQuote: !1,
        refs: {}
    }, V = {
        ...Q,
        slugify: Q?.slugify ? (G)=>Q.slugify(G, $87a23dccae47b18a$export$c383cdd2a518017a) : $87a23dccae47b18a$export$c383cdd2a518017a,
        sanitizer: Q?.sanitizer || $87a23dccae47b18a$export$3e2338ea76b578c9,
        tagfilter: Q?.tagfilter !== !1
    };
    Z.j = $87a23dccae47b18a$var$c6($, Z.refs, V);
    let Y = $87a23dccae47b18a$var$b9($, Z, V);
    return $87a23dccae47b18a$var$m$(Z.refs) ? [
        {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.refCollection,
            refs: Z.refs
        },
        ...Y
    ] : Y;
}
function $87a23dccae47b18a$var$ZZ($, Q, Z, V) {
    var Y = $87a23dccae47b18a$var$N9($, Q);
    return Y ? {
        tagName: Y.tag,
        tagLower: Y.tag.toLowerCase(),
        attrs: Y.rawAttrs,
        whitespaceBeforeAttrs: Y.whitespaceBeforeAttrs,
        isSelfClosing: Y.selfClosing,
        hasSpaceBeforeSlash: Y.hasSpaceBeforeSlash,
        isClosing: Y.isClosing,
        hasNewline: Y.whitespaceBeforeAttrs.includes(`
`) || Y.rawAttrs.includes(`
`),
        endPos: Y.end
    } : null;
}
function $87a23dccae47b18a$var$b$($, Q, Z) {
    $87a23dccae47b18a$var$e9 = 0, $ = $87a23dccae47b18a$var$C$($), !Q.refs && (Q.refs = {}), Q.j = $87a23dccae47b18a$var$c6($, Q.refs, Z);
    let V = $87a23dccae47b18a$var$b9($, Q, Z);
    return $87a23dccae47b18a$var$m$(Q.refs) ? [
        {
            type: $87a23dccae47b18a$export$e0aa44767d8750d5.refCollection,
            refs: Q.refs
        },
        ...V
    ] : V;
}
var $87a23dccae47b18a$var$U5 = /^\n+/, $87a23dccae47b18a$var$r$;
try {
    $87a23dccae47b18a$var$r$ = $acw62.createElement("div").$$typeof;
} catch  {
    $87a23dccae47b18a$var$r$ = Symbol.for("react.transitional.element");
}
function $87a23dccae47b18a$var$o$($, Q, Z) {
    return {
        $$typeof: $87a23dccae47b18a$var$r$,
        type: $,
        key: Z != null ? "" + Z : null,
        ref: null,
        props: Q,
        _owner: null,
        _store: {},
        _debugStack: null,
        _debugTask: null
    };
}
var $87a23dccae47b18a$var$i$ = typeof $acw62.createContext < "u" ? $acw62.createContext(void 0) : void 0;
function $87a23dccae47b18a$var$QZ($, Q, Z, V, Y, G, K, q, J) {
    switch($.type){
        case $87a23dccae47b18a$export$e0aa44767d8750d5.blockQuote:
            {
                let U = {
                    key: Z.key
                };
                return $.alert && (U.className = "markdown-alert-" + G($.alert.toLowerCase(), $87a23dccae47b18a$export$c383cdd2a518017a), $.children.unshift($87a23dccae47b18a$var$A6($.alert))), V("blockquote", U, Q($.children, Z));
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.breakLine:
            return V("br", {
                key: Z.key
            });
        case $87a23dccae47b18a$export$e0aa44767d8750d5.breakThematic:
            return V("hr", {
                key: Z.key
            });
        case $87a23dccae47b18a$export$e0aa44767d8750d5.frontmatter:
            return q.preserveFrontmatter ? V("pre", {
                key: Z.key
            }, $.text) : null;
        case $87a23dccae47b18a$export$e0aa44767d8750d5.codeBlock:
            let j = $.lang ? $87a23dccae47b18a$var$s9($.lang) : "";
            return V("pre", {
                key: Z.key
            }, V("code", {
                ...$87a23dccae47b18a$var$c0($.attrs || {}),
                className: j ? `language-${j} lang-${j}` : ""
            }, $.text));
        case $87a23dccae47b18a$export$e0aa44767d8750d5.codeInline:
            return V("code", {
                key: Z.key
            }, $.text);
        case $87a23dccae47b18a$export$e0aa44767d8750d5.footnoteReference:
            return V("a", {
                key: Z.key,
                href: Y($.target, "a", "href") || void 0
            }, V("sup", {
                key: Z.key
            }, $.text));
        case $87a23dccae47b18a$export$e0aa44767d8750d5.gfmTask:
            return V("input", {
                checked: $.completed,
                key: Z.key,
                readOnly: !0,
                type: "checkbox"
            });
        case $87a23dccae47b18a$export$e0aa44767d8750d5.heading:
            return V(`h${$.level}`, {
                id: $.id,
                key: Z.key
            }, Q($.children, Z));
        case $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock:
            {
                let U = $;
                if (q.tagfilter && $87a23dccae47b18a$var$h$(U.tag)) {
                    var F = "";
                    if (U.attrs) for(var W in U.attrs){
                        var X = U.attrs[W];
                        X === !0 ? F += " " + W : X != null && X !== !1 && (F += " " + W + '="' + String(X) + '"');
                    }
                    return V("span", {
                        key: Z.key
                    }, "<" + U.tag + F + ">");
                }
                if (U.a && U.c) {
                    let I = function(P) {
                        if ((P.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing || P.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock) && P.b) return [];
                        if (P.type === $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph) {
                            let a = P.children;
                            return a ? a.flatMap(I) : [];
                        }
                        return P.type === $87a23dccae47b18a$export$e0aa44767d8750d5.text ? P.text?.trim() ? [
                            P
                        ] : [] : P.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock && P.children ? [
                            {
                                ...P,
                                children: P.children?.flatMap(I)
                            }
                        ] : [
                            P
                        ];
                    }, w = function(P) {
                        for(var a = 0; a < P.length; a++)P[a].type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock && (P[a].c = !1), "children" in P[a] && P[a].children && w(P[a].children);
                    }, J0 = function(P, a) {
                        for(var r = 0; r < P.length; r++){
                            var y0 = P[r];
                            if (y0.type === $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph && y0.children) for(var R0 = y0.children, F0 = 0; F0 < R0.length; F0++){
                                var u = R0[F0];
                                if (u.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing && u.b && u.tag.toLowerCase() === a) {
                                    var n = P.slice(0, r);
                                    F0 > 0 && n.push({
                                        type: $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph,
                                        children: R0.slice(0, F0)
                                    });
                                    var D0 = [];
                                    if (F0 + 1 < R0.length) {
                                        var s = R0.slice(F0 + 1);
                                        s = s.filter(function(M0) {
                                            return !(M0.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing && M0.b);
                                        }), s.length > 0 && (D0 = s);
                                    }
                                    return D0 = D0.concat(P.slice(r + 1)), {
                                        found: !0,
                                        beforeClose: n,
                                        afterClose: D0
                                    };
                                }
                            }
                            if ((y0.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing || y0.type === $87a23dccae47b18a$export$e0aa44767d8750d5.htmlBlock) && y0.b && y0.tag.toLowerCase() === a) return {
                                found: !0,
                                beforeClose: P.slice(0, r),
                                afterClose: P.slice(r + 1)
                            };
                        }
                        return {
                            found: !1,
                            beforeClose: P,
                            afterClose: []
                        };
                    }, B = U.tag.toLowerCase(), M = $87a23dccae47b18a$var$u6(B), A = U.children && U.children.length > 0, k = /<[a-z][^>]{0,100}>/i.test(U.a);
                    if (M) {
                        let P = U.a.replace(new RegExp("\\s*</" + B + ">\\s*$", "i"), "");
                        return q.tagfilter && (P = $87a23dccae47b18a$var$u$(P)), k ? J($.tag, {
                            key: Z.key,
                            ...$87a23dccae47b18a$var$c0($.attrs || {}),
                            dangerouslySetInnerHTML: {
                                __html: P
                            }
                        }) : J($.tag, {
                            key: Z.key,
                            ...$87a23dccae47b18a$var$c0($.attrs || {})
                        }, P);
                    }
                    let _ = new RegExp(`^<${U.tag}(\\s|>)`, "i").test(U.a);
                    if (A && !_ && q.tagfilter && $87a23dccae47b18a$var$N6(U.a)) return J($.tag, {
                        key: Z.key,
                        ...$87a23dccae47b18a$var$c0($.attrs || {})
                    }, Q(U.children, Z));
                    if ($87a23dccae47b18a$var$p6(U.a)) {
                        let P = q.tagfilter ? $87a23dccae47b18a$var$u$(U.a) : U.a;
                        return J($.tag, {
                            key: Z.key,
                            ...$87a23dccae47b18a$var$c0($.attrs || {}),
                            dangerouslySetInnerHTML: {
                                __html: P
                            }
                        });
                    }
                    let E = {
                        slugify: (P)=>G(P, $87a23dccae47b18a$export$c383cdd2a518017a),
                        sanitizer: Y,
                        tagfilter: !0
                    }, L = U.a.replace(/>\s+</g, "><").replace(/\n+/g, " ").trim();
                    if (new RegExp(`^<${U.tag}(\\s[^>]*)?>(\\s*</${U.tag}>)?$`, "i").test(L)) return U.children && U.children.length > 0 ? J($.tag, {
                        key: Z.key,
                        ...$87a23dccae47b18a$var$c0($.attrs || {})
                    }, Q(U.children, Z)) : J($.tag, {
                        key: Z.key,
                        ...$87a23dccae47b18a$var$c0($.attrs || {})
                    });
                    let f = $87a23dccae47b18a$var$b$(L, {
                        inline: !1,
                        refs: K,
                        inHTML: !1
                    }, E);
                    w(f);
                    let T = U.tag.toLowerCase(), m = "</" + T + ">", C = new RegExp(`^<${U.tag}(\\s|>)`, "i").test(L), g = L.toLowerCase().trimEnd().endsWith(m), X0 = C && g;
                    if (X0 && A) return J($.tag, {
                        key: Z.key,
                        ...$87a23dccae47b18a$var$c0($.attrs || {})
                    }, Q(U.children, Z));
                    if (X0) return Q(f.flatMap(I), Z);
                    var H = J0(f, T);
                    if (H.found && H.afterClose.length > 0) {
                        var z = H.beforeClose.flatMap(I), D = H.afterClose.flatMap(I);
                        return $87a23dccae47b18a$var$o$($acw62.Fragment, {
                            children: [
                                J($.tag, {
                                    key: Z.key,
                                    ...$87a23dccae47b18a$var$c0($.attrs || {})
                                }, Q(z, Z)),
                                Q(D, Z)
                            ]
                        }, null);
                    }
                    return J($.tag, {
                        key: Z.key,
                        ...$87a23dccae47b18a$var$c0($.attrs || {})
                    }, Q(f.flatMap(I), Z));
                }
                return $87a23dccae47b18a$var$c9($.tag) ? J($.tag, {
                    key: Z.key,
                    ...$87a23dccae47b18a$var$c0($.attrs || {})
                }) : J($.tag, {
                    key: Z.key,
                    ...$87a23dccae47b18a$var$c0($.attrs || {})
                }, $.children ? Q($.children, Z) : "");
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.htmlSelfClosing:
            {
                let U = $;
                if (q.tagfilter && $87a23dccae47b18a$var$h$(U.tag)) {
                    var F = "";
                    if (U.attrs) for(var W in U.attrs){
                        var X = U.attrs[W];
                        X === !0 ? F += " " + W : X != null && X !== !1 && (F += " " + W + '="' + String(X) + '"');
                    }
                    return V("span", {
                        key: Z.key
                    }, "<" + U.tag + F + " />");
                }
                return J($.tag, {
                    key: Z.key,
                    ...$87a23dccae47b18a$var$c0($.attrs || {})
                });
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.image:
            {
                let U = $.target != null ? Y($.target, "img", "src") : null;
                return V("img", {
                    key: Z.key,
                    alt: $.alt && $.alt.length > 0 ? $.alt : void 0,
                    title: $.title || void 0,
                    src: U || void 0
                });
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.link:
            {
                let U = {
                    key: Z.key
                };
                return $.target != null && (U.href = $87a23dccae47b18a$var$_6($.target)), $.title && (U.title = $.title), V("a", U, Q($.children, Z));
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.table:
            {
                let U = $;
                return V("table", {
                    key: Z.key
                }, V("thead", {
                    key: "thead"
                }, V("tr", null, U.header.map(function(M, A) {
                    return V("th", {
                        key: A,
                        style: U.align[A] == null ? {} : {
                            textAlign: U.align[A]
                        }
                    }, Q(M, Z));
                }))), U.cells.length > 0 && V("tbody", {
                    key: "tbody"
                }, U.cells.map(function(M, A) {
                    return V("tr", {
                        key: A
                    }, M.map(function(_, O) {
                        return V("td", {
                            key: O,
                            style: U.align[O] == null ? {} : {
                                textAlign: U.align[O]
                            }
                        }, Q(_, Z));
                    }));
                })));
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.text:
            return $.text;
        case $87a23dccae47b18a$export$e0aa44767d8750d5.textFormatted:
            return V($.tag, {
                key: Z.key
            }, Q($.children, Z));
        case $87a23dccae47b18a$export$e0aa44767d8750d5.orderedList:
        case $87a23dccae47b18a$export$e0aa44767d8750d5.unorderedList:
            {
                let U = $.type === $87a23dccae47b18a$export$e0aa44767d8750d5.orderedList ? "ol" : "ul";
                return V(U, {
                    key: Z.key,
                    start: $.type === $87a23dccae47b18a$export$e0aa44767d8750d5.orderedList ? $.start : void 0
                }, $.items.map(function(M, A) {
                    return V("li", {
                        key: A
                    }, Q(M, Z));
                }));
            }
        case $87a23dccae47b18a$export$e0aa44767d8750d5.paragraph:
            return V("p", {
                key: Z.key
            }, Q($.children, Z));
        case $87a23dccae47b18a$export$e0aa44767d8750d5.ref:
            return null;
        default:
            return null;
    }
}
var $87a23dccae47b18a$var$X5 = ($, Q, Z, V, Y, G, K)=>{
    var q = (F)=>F.map(function(W) {
            return "text" in W ? W.text : "";
        }), J = (F, W = {})=>{
        var X = (W.renderDepth || 0) + 1;
        if (X > 2500) return q(F);
        W.renderDepth = X;
        for(var H = W.key, z = [], D = !1, j = 0; j < F.length; j++){
            W.key = j;
            var U;
            if ($) {
                var B = $87a23dccae47b18a$var$QZ.bind(null, F[j], J, W, Q, Z, V, Y, G, K);
                U = $(B, F[j], J, W);
            } else U = $87a23dccae47b18a$var$QZ(F[j], J, W, Q, Z, V, Y, G, K);
            var M = typeof U == "string";
            if (M && D) z[z.length - 1] += U;
            else if (U !== null) {
                if (Array.isArray(U)) for(var A = 0; A < U.length; A++)z.push(U[A]);
                else z.push(U);
            }
            D = M;
        }
        return W.key = H, W.renderDepth = X - 1, z;
    };
    return J;
}, $87a23dccae47b18a$var$W5 = ($, Q)=>{
    let Z = $87a23dccae47b18a$var$t9(Q, $, void 0);
    return Z ? typeof Z == "function" || typeof Z == "object" && "render" in Z ? Z : $87a23dccae47b18a$var$t9(Q, `${$}.component`, $) : $;
};
function $87a23dccae47b18a$var$z5($, Q) {
    let Z = {
        ...Q || {}
    };
    Z.overrides = Z.overrides || {};
    let V = Z.slugify || $87a23dccae47b18a$export$c383cdd2a518017a, Y = Z.sanitizer || $87a23dccae47b18a$export$3e2338ea76b578c9, G = Z.createElement, K = Z.overrides && Object.keys(Z.overrides).length > 0, q = (A)=>$87a23dccae47b18a$var$U$(A, {
            ...Z,
            wrapper: null
        });
    function J(A) {
        for(var k in A){
            var _ = A[k];
            if (typeof _ == "string" && _.length > 0 && _.charCodeAt(0) === $87a23dccae47b18a$var$Z0 && ($87a23dccae47b18a$var$C6.test(_) || $87a23dccae47b18a$var$m6.test(_) || $87a23dccae47b18a$var$ZZ(_, 0))) {
                var O = q(_.trim());
                A[k] = k === "innerHTML" && Array.isArray(O) ? O[0] : O;
            }
        }
    }
    function F(A, k, ..._) {
        var O = k || {}, E = A;
        if (K) {
            var L = $87a23dccae47b18a$var$t9(Z.overrides, A + ".props", {});
            E = $87a23dccae47b18a$var$W5(A, Z.overrides), O = {
                ...O,
                ...L,
                className: $87a23dccae47b18a$var$I6(O.className, L.className) || void 0
            };
        }
        if (!G) {
            var y = O.key;
            return y != null && delete O.key, _.length === 1 ? O.children = _[0] : _.length > 1 && (O.children = _), $87a23dccae47b18a$var$o$(E, O, y);
        }
        return G(E, O, ..._);
    }
    function W(A, k, ..._) {
        return k && J(k), F(A, k, ..._);
    }
    let X = {
        ...Z,
        slugify: Z.slugify ? (A)=>Z.slugify(A, $87a23dccae47b18a$export$c383cdd2a518017a) : $87a23dccae47b18a$export$c383cdd2a518017a,
        sanitizer: Y,
        tagfilter: Z.tagfilter !== !1
    }, H = $[0] && $[0].type === $87a23dccae47b18a$export$e0aa44767d8750d5.refCollection ? $[0].refs : {}, z = $87a23dccae47b18a$var$X5(Z.renderRule, F, Y, V, H, Z, W), D = z($, {
        inline: Z.forceInline,
        refs: H
    }), j = $87a23dccae47b18a$var$v6(H);
    if (j.length && D.push(F("footer", {
        key: "footer"
    }, j.map(function(k) {
        let _ = k.identifier.charCodeAt(0) === $87a23dccae47b18a$var$e0 ? k.identifier.slice(1) : k.identifier, O = $87a23dccae47b18a$var$b$(k.footnote, {
            inline: !0,
            refs: H
        }, X);
        return F("div", {
            id: V(_, $87a23dccae47b18a$export$c383cdd2a518017a),
            key: k.identifier
        }, _ + ": ", z(O, {
            inline: !0,
            refs: H
        }));
    }))), Z.wrapper === null) return D;
    let U = Z.wrapper || (Z.forceInline ? "span" : "div"), B;
    if (D.length > 1 || Z.forceWrapper) B = D;
    else return D.length === 1 ? D[0] : null;
    var M = Z.wrapperProps ? {
        ...Z.wrapperProps
    } : {};
    return M.children = B, $87a23dccae47b18a$var$o$(U, M, "outer");
}
function $87a23dccae47b18a$var$U$($ = "", Q = {}) {
    let Z = {
        ...Q || {}
    };
    Z.overrides = Z.overrides || {};
    let V = Z.slugify || $87a23dccae47b18a$export$c383cdd2a518017a, Y = Z.sanitizer || $87a23dccae47b18a$export$3e2338ea76b578c9;
    function G(J) {
        let F = Z.forceInline || !Z.forceBlock && !$87a23dccae47b18a$var$D6.test(J), W = {
            ...Z,
            slugify: Z.slugify ? (D)=>Z.slugify(D, $87a23dccae47b18a$export$c383cdd2a518017a) : $87a23dccae47b18a$export$c383cdd2a518017a,
            sanitizer: Y,
            tagfilter: Z.tagfilter !== !1
        }, X = J;
        if (!F) {
            let D = X.length;
            for(; D > 0 && (X[D - 1] === `
` || X[D - 1] === "\r");)D--;
            X = X.slice(0, D), X = `${X.replace($87a23dccae47b18a$var$U5, "")}

`;
        }
        if (Z.optimizeForStreaming) {
            var H = X.lastIndexOf("<");
            H !== -1 && X.indexOf(">", H) === -1 && (X = X.slice(0, H)), H = J.lastIndexOf("<"), H !== -1 && J.indexOf(">", H) === -1 && (J = J.slice(0, H));
        }
        let z = $87a23dccae47b18a$var$b$(F ? J : X, {
            inline: F,
            refs: K
        }, W);
        return $87a23dccae47b18a$var$z5(z, {
            ...W,
            forceInline: F
        });
    }
    let K = {};
    return G($);
}
var $87a23dccae47b18a$var$L5 = ({ options: $, children: Q })=>$87a23dccae47b18a$var$i$ ? $acw62.createElement($87a23dccae47b18a$var$i$.Provider, {
        value: $
    }, Q) : Q, $87a23dccae47b18a$var$a$ = ({ children: $, options: Q, ...Z })=>{
    if (!(typeof $acw62.useContext < "u")) {
        let J = {
            ...Q,
            overrides: {
                ...Q?.overrides
            },
            wrapperProps: {
                ...Q?.wrapperProps,
                ...Z
            }
        };
        return $87a23dccae47b18a$var$U$($ ?? "", J);
    }
    let Y = $acw62.useContext($87a23dccae47b18a$var$i$), G = $acw62.useMemo(()=>({
            ...Y,
            ...Q,
            overrides: {
                ...Y?.overrides,
                ...Q?.overrides
            },
            wrapperProps: {
                ...Y?.wrapperProps,
                ...Q?.wrapperProps,
                ...Z
            }
        }), [
        Y,
        Q,
        Z
    ]), K = $ ?? "";
    return $acw62.useMemo(()=>$87a23dccae47b18a$var$U$(K, G), [
        K,
        G
    ]);
}, $87a23dccae47b18a$var$VZ = $87a23dccae47b18a$var$a$, $87a23dccae47b18a$export$7460c8b7e4ce9582 = $87a23dccae47b18a$var$a$, $87a23dccae47b18a$export$69f434acfbdb0b32 = $87a23dccae47b18a$var$U$, $87a23dccae47b18a$export$2e2bcd8739ae039 = $87a23dccae47b18a$var$VZ;



var $acw62 = parcelRequire("acw62");








/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ba749b8f43b06f39$export$51e84d46ca0bc451(props, state, ref) {
    const { isSelected: isSelected } = state;
    const { isPressed: isPressed, buttonProps: buttonProps } = (0, $7ba2564f6a00a739$export$ea18c227d4417cc3)({
        ...props,
        onPress: (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        isSelected: isSelected,
        isDisabled: props.isDisabled || false,
        buttonProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(buttonProps, {
            'aria-pressed': isSelected
        })
    };
}








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1a6bde74ea376d1b$export$fa142eb1681c520(props, ref) {
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, orientation: orientation = 'horizontal' } = props;
    let [isInToolbar, setInToolbar] = (0, $acw62.useState)(false);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        setInToolbar(!!(ref.current && ref.current.parentElement?.closest('[role="toolbar"]')));
    });
    const { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    const shouldReverse = direction === 'rtl' && orientation === 'horizontal';
    let focusManager = (0, $5c60d71a4f66bda5$export$c5251b9e124bf29)(ref);
    const onKeyDown = (e)=>{
        // don't handle portalled events
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) return;
        if (orientation === 'horizontal' && e.key === 'ArrowRight' || orientation === 'vertical' && e.key === 'ArrowDown') {
            if (shouldReverse) focusManager.focusPrevious();
            else focusManager.focusNext();
        } else if (orientation === 'horizontal' && e.key === 'ArrowLeft' || orientation === 'vertical' && e.key === 'ArrowUp') {
            if (shouldReverse) focusManager.focusNext();
            else focusManager.focusPrevious();
        } else if (e.key === 'Tab') {
            // When the tab key is pressed, we want to move focus
            // out of the entire toolbar. To do this, move focus
            // to the first or last focusable child, and let the
            // browser handle the Tab key as usual from there.
            e.stopPropagation();
            lastFocused.current = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
            if (e.shiftKey) focusManager.focusFirst();
            else focusManager.focusLast();
            return;
        } else return;
        // Prevent arrow keys from being handled by nested action groups.
        e.stopPropagation();
        e.preventDefault();
    };
    // Record the last focused child when focus moves out of the toolbar.
    const lastFocused = (0, $acw62.useRef)(null);
    const onBlur = (e)=>{
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget) && !lastFocused.current) lastFocused.current = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
    };
    // Restore focus to the last focused child when focus returns into the toolbar.
    // If the element was removed, do nothing, either the first item in the first group,
    // or the last item in the last group will be focused, depending on direction.
    const onFocus = (e)=>{
        if (lastFocused.current && !(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget) && (0, $8fd85525b97849bf$export$4282f70798064fe0)(ref.current, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
            lastFocused.current?.focus();
            lastFocused.current = null;
        }
    };
    return {
        toolbarProps: {
            ...(0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
                labelable: true
            }),
            role: !isInToolbar ? 'toolbar' : 'group',
            'aria-orientation': orientation,
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabel == null ? ariaLabelledBy : undefined,
            onKeyDownCapture: !isInToolbar ? onKeyDown : undefined,
            onFocusCapture: !isInToolbar ? onFocus : undefined,
            onBlurCapture: !isInToolbar ? onBlur : undefined
        }
    };
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $36187d83ea3c88ee$export$dd5580ae642f110f(props, state, ref) {
    let { isDisabled: isDisabled } = props;
    let { toolbarProps: toolbarProps } = (0, $1a6bde74ea376d1b$export$fa142eb1681c520)(props, ref);
    return {
        groupProps: {
            ...toolbarProps,
            role: state.selectionMode === 'single' ? 'radiogroup' : toolbarProps.role,
            'aria-disabled': isDisabled
        }
    };
}
function $36187d83ea3c88ee$export$bc53712daae3d6e6(props, state, ref) {
    let toggleState = {
        isSelected: state.selectedKeys.has(props.id),
        defaultSelected: false,
        setSelected (isSelected) {
            state.setSelected(props.id, isSelected);
        },
        toggle () {
            state.toggleKey(props.id);
        }
    };
    let { isPressed: isPressed, isSelected: isSelected, isDisabled: isDisabled, buttonProps: buttonProps } = (0, $ba749b8f43b06f39$export$51e84d46ca0bc451)({
        ...props,
        id: undefined,
        isDisabled: props.isDisabled || state.isDisabled
    }, toggleState, ref);
    if (state.selectionMode === 'single') {
        buttonProps.role = 'radio';
        buttonProps['aria-checked'] = toggleState.isSelected;
        delete buttonProps['aria-pressed'];
    }
    return {
        isPressed: isPressed,
        isSelected: isSelected,
        isDisabled: isDisabled,
        buttonProps: buttonProps
    };
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b52e1da7b37de02e$export$8deac67f4addf270(props) {
    let { selectionMode: selectionMode = 'single', disallowEmptySelection: disallowEmptySelection, isDisabled: isDisabled = false } = props;
    let [selectedKeys, setSelectedKeys] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)((0, $acw62.useMemo)(()=>props.selectedKeys ? new Set(props.selectedKeys) : undefined, [
        props.selectedKeys
    ]), (0, $acw62.useMemo)(()=>props.defaultSelectedKeys ? new Set(props.defaultSelectedKeys) : new Set(), [
        props.defaultSelectedKeys
    ]), props.onSelectionChange);
    return {
        selectionMode: selectionMode,
        isDisabled: isDisabled,
        selectedKeys: selectedKeys,
        setSelectedKeys: setSelectedKeys,
        toggleKey (key) {
            let keys;
            if (selectionMode === 'multiple') {
                keys = new Set(selectedKeys);
                if (keys.has(key) && (!disallowEmptySelection || keys.size > 1)) keys.delete(key);
                else keys.add(key);
            } else keys = new Set(selectedKeys.has(key) && !disallowEmptySelection ? [] : [
                key
            ]);
            setSelectedKeys(keys);
        },
        setSelected (key, isSelected) {
            if (isSelected !== selectedKeys.has(key)) this.toggleKey(key);
        }
    };
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bd07d90d110e288e$export$298258635ae0dd97 = (0, $acw62.createContext)({});
const $bd07d90d110e288e$export$a8a71863db173133 = (0, $acw62.createContext)(null);
const $bd07d90d110e288e$export$40258cc1d95ff477 = (0, $acw62.forwardRef)(function ToggleButtonGroup(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $bd07d90d110e288e$export$298258635ae0dd97);
    let state = (0, $b52e1da7b37de02e$export$8deac67f4addf270)(props);
    let { groupProps: groupProps } = (0, $36187d83ea3c88ee$export$dd5580ae642f110f)(props, state, ref);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            orientation: props.orientation || 'horizontal',
            isDisabled: state.isDisabled,
            state: state
        },
        defaultClassName: 'react-aria-ToggleButtonGroup'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'horizontal',
        "data-disabled": props.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bd07d90d110e288e$export$a8a71863db173133.Provider, {
        value: state
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08cc935c33eff3e5$export$758399f318e6385a), null, renderProps.children)));
});






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e509f521b17159b$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(props.isSelected, props.defaultSelected || false, props.onChange);
    let [initialValue] = (0, $acw62.useState)(isSelected);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        defaultSelected: props.defaultSelected ?? initialValue,
        setSelected: updateSelected,
        toggle: toggleState
    };
}





/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1295d6fef9679e74$export$43506d75ebd2e218 = (0, $acw62.createContext)({});
const $1295d6fef9679e74$export$d2b052e7b4be1756 = (0, $acw62.forwardRef)(function ToggleButton(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $1295d6fef9679e74$export$43506d75ebd2e218);
    let groupState = (0, $acw62.useContext)((0, $bd07d90d110e288e$export$a8a71863db173133));
    let state = (0, $1e509f521b17159b$export$8042c6c013fd5226)(groupState && props.id != null ? {
        isSelected: groupState.selectedKeys.has(props.id),
        onChange (isSelected) {
            groupState.setSelected(props.id, isSelected);
        }
    } : props);
    let { buttonProps: buttonProps, isPressed: isPressed, isSelected: isSelected, isDisabled: isDisabled } = groupState && props.id != null ? (0, $36187d83ea3c88ee$export$bc53712daae3d6e6)({
        ...props,
        id: props.id
    }, groupState, ref) : (0, $ba749b8f43b06f39$export$51e84d46ca0bc451)({
        ...props,
        id: props.id != null ? String(props.id) : undefined
    }, state, ref);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $0cde480b945a073a$export$4e328f61c538687f)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        ...props,
        isDisabled: isDisabled
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        values: {
            isHovered: isHovered,
            isPressed: isPressed,
            isFocused: isFocused,
            isSelected: state.isSelected,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            state: state
        },
        defaultClassName: 'react-aria-ToggleButton'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).button, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, buttonProps, focusProps, hoverProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-disabled": isDisabled || undefined,
        "data-pressed": isPressed || undefined,
        "data-selected": isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f978dd1340ad1a86$export$c9549807523555e0).Provider, {
        value: {
            isSelected: isSelected
        }
    }, renderProps.children));
});





var $acw62 = parcelRequire("acw62");

let $d560ed2d957d30cf$var$avatarSizes = {
    s: 'w-5',
    l: 'w-10'
};
function $d560ed2d957d30cf$export$e2255cf6045e8d47({ src: src, size: size = 's', className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        className: `${$d560ed2d957d30cf$var$avatarSizes[size]} aspect-square rounded-full ${className}`
    });
}
function $d560ed2d957d30cf$export$d05367b09ac9e47f({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "bg-daw-blue-100 border border-daw-blue-200 text-daw-blue-800 text-xs font-mono py-[2px] px-2 rounded",
        children: children
    });
}
let $d560ed2d957d30cf$var$states = {
    MERGED: 'bg-daw-purple-100 border-daw-purple-200 text-daw-purple-700',
    CLOSED: 'bg-daw-red-100 border-daw-red-200 text-daw-red-700',
    OPEN: 'bg-daw-green-100 border-daw-green-200 text-daw-green-700',
    DRAFT: 'bg-daw-gray-200 border-daw-gray-300 text-daw-gray-800'
};
let $d560ed2d957d30cf$var$statusIcons = {
    MERGED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$578402671e214a82), {
        className: "text-daw-purple-700"
    }),
    CLOSED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5026ec832c277e74), {
        className: "text-daw-red-700"
    }),
    OPEN: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$9a124e3933109cb2), {
        className: "text-daw-green-700"
    }),
    DRAFT: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$51ed17e21f1e5e24), {
        className: "text-daw-gray-700"
    })
};
function $d560ed2d957d30cf$export$559eb15a98685419({ data: data, type: type }) {
    let state = data.state;
    if ('isDraft' in data && data.isDraft) state = 'DRAFT';
    if (type === 'icon') return $d560ed2d957d30cf$var$statusIcons[state];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `capitalize w-fit px-2 py-0.5 rounded border text-sm font-medium ${$d560ed2d957d30cf$var$states[state]}`,
        children: state.toLowerCase()
    });
}
let $d560ed2d957d30cf$var$checkStates = {
    EXPECTED: 'bg-daw-yellow-500',
    PENDING: 'bg-daw-yellow-500',
    ACTION_REQUIRED: 'bg-daw-yellow-500',
    ERROR: 'bg-daw-red-500',
    FAILURE: 'bg-daw-red-500',
    SUCCESS: 'bg-daw-green-500',
    CANCELLED: 'bg-daw-gray-500',
    NEUTRAL: 'bg-daw-gray-500',
    SKIPPED: 'bg-daw-gray-500',
    STALE: 'bg-daw-gray-500',
    STARTUP_FAILURE: 'bg-daw-red-500',
    TIMED_OUT: 'bg-daw-red-500',
    CHANGES_REQUESTED: 'bg-daw-red-500',
    REVIEW_REQUIRED: 'bg-daw-red-500',
    APPROVED: 'bg-daw-green-500',
    COMMENTED: 'bg-daw-gray-500',
    DISMISSED: 'bg-daw-gray-500'
};
let $d560ed2d957d30cf$var$checkIcons = {
    EXPECTED: null,
    PENDING: null,
    ERROR: null,
    FAILURE: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {
        className: "text-daw-red-500 group-selected:text-daw-white"
    }),
    ACTION_REQUIRED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$4a143c8822a09fb4), {
        className: "text-daw-yellow-600 group-selected:text-daw-white"
    }),
    CANCELLED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$dc6949a98411e916), {
        className: "text-daw-gray-500 group-selected:text-daw-white"
    }),
    STARTUP_FAILURE: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {
        className: "text-daw-red-500 group-selected:text-daw-white"
    }),
    TIMED_OUT: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {
        className: "text-daw-red-500 group-selected:text-daw-white"
    }),
    SUCCESS: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7dd004358974b05d), {
        className: "text-daw-green-500 group-selected:text-daw-white"
    }),
    NEUTRAL: null,
    STALE: null,
    SKIPPED: null,
    CHANGES_REQUESTED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {
        className: "text-daw-red-500 group-selected:text-daw-white"
    }),
    REVIEW_REQUIRED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {
        className: "text-daw-yellow-500 group-selected:text-daw-white"
    }),
    APPROVED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7dd004358974b05d), {
        className: "text-daw-green-500 group-selected:text-daw-white"
    }),
    COMMENTED: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a3543c9c8473fb3d), {
        className: "text-daw-gray-500 group-selected:text-daw-white"
    }),
    DISMISSED: null
};
function $d560ed2d957d30cf$export$96e9906d6d93a972({ state: state, filled: filled }) {
    let icon = $d560ed2d957d30cf$var$checkIcons[state];
    if (filled && icon) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `w-5 h-5 rounded-full text-white flex items-center justify-center ${$d560ed2d957d30cf$var$checkStates[state]}`,
        children: /*#__PURE__*/ (0, $acw62.cloneElement)(icon, {
            className: 'text-white'
        })
    });
    if (icon) return icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `w-2 h-2 rounded-full ${$d560ed2d957d30cf$var$checkStates[state]}`
    });
}
function $d560ed2d957d30cf$export$60332b2344f7fe41({ children: children, gridArea: gridArea, className: className, ...otherProps }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `bg-daw-white rounded-xl p-3 shadow-card min-w-0 ${className || ''}`,
        style: {
            gridArea: gridArea
        },
        ...otherProps,
        children: children
    });
}
function $d560ed2d957d30cf$export$f04a61298a47a40f({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `rounded-full px-1.5 aspect-square flex items-center ${className}`,
        children: children
    });
}
function $d560ed2d957d30cf$export$346ada88e5d95317({ color: color, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "px-2 py-0.5 text-black rounded-full text-xs font-semibold border",
        style: {
            background: `#${color}66`,
            borderColor: `#${color}66`,
            color: `color-mix(in srgb, #${color}, light-dark(black, white) 70%)`
        },
        children: children
    });
}
const $d560ed2d957d30cf$export$d9f8b01a59748b2c = {
    BLUE: 'bg-blue-400/20 text-blue-600 group-selected:text-blue-300 dark:text-blue-300 dark:group-selected:text-blue-600 border-blue-400/20',
    GRAY: 'bg-neutral-400/20 text-neutral-600 group-selected:text-neutral-300 dark:text-neutral-300 dark:group-selected:text-neutral-600 border-neutral-400/20',
    GREEN: 'bg-green-400/20 text-green-600 group-selected:text-green-300 dark:text-green-300 dark:group-selected:text-green-600 border-green-400/20',
    ORANGE: 'bg-orange-400/20 text-orange-600 group-selected:text-orange-300 dark:text-orange-300 dark:group-selected:text-orange-600 border-orange-400/20',
    PINK: 'bg-pink-400/20 text-pink-600 group-selected:text-pink-300 dark:text-pink-300 dark:group-selected:text-pink-600 border-pink-400/20',
    PURPLE: 'bg-purple-400/20 text-purple-600 group-selected:text-purple-300 dark:text-purple-300 dark:group-selected:text-purple-600 border-purple-400/20',
    RED: 'bg-red-400/20 text-red-600 group-selected:text-red-300 dark:text-red-300 dark:group-selected:text-red-600 border-red-400/20',
    YELLOW: 'bg-yellow-400/20 text-yellow-600 group-selected:text-yellow-300 dark:text-yellow-300 dark:group-selected:text-yellow-600 border-yellow-400/20'
};
function $d560ed2d957d30cf$export$cd9ef921569d6bdf({ issueType: issueType, className: className }) {
    let colors = $d560ed2d957d30cf$export$d9f8b01a59748b2c[issueType.color] ?? $d560ed2d957d30cf$export$d9f8b01a59748b2c.GRAY;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `px-2 font-semibold rounded-full border ${colors}${className ? ` ${className}` : ''}`,
        children: issueType.name
    });
}
function $d560ed2d957d30cf$export$1f44aaf2ec115b54({ actor: actor }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex items-center align-bottom",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d560ed2d957d30cf$export$e2255cf6045e8d47, {
                src: actor.avatarUrl,
                className: "inline mr-2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                href: actor.url,
                target: "_blank",
                className: "font-semibold hover:underline",
                children: actor.login
            })
        ]
    });
}
$d560ed2d957d30cf$export$1f44aaf2ec115b54.fragment = `
fragment ActorFragment on Actor {
  avatarUrl
  url
  login
}
`;






//#region src/react/utils/templateRender.tsx
function $57201c9a5acac26e$export$5c04c7d02692535b(children, __html) {
    if (typeof window === "undefined" && __html != null) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("template", {
                shadowrootmode: "open",
                dangerouslySetInnerHTML: {
                    __html: __html
                }
            }),
            children
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
}










//#region src/utils/areVirtualWindowSpecsEqual.ts
function $01fd4b619c317ff9$export$ae7cd73857576f20(windowSpecsA, windowSpecsB) {
    if (windowSpecsA == null || windowSpecsB == null) return windowSpecsA === windowSpecsB;
    return windowSpecsA.top === windowSpecsB.top && windowSpecsA.bottom === windowSpecsB.bottom;
}


//#region src/components/Virtualizer.ts
const $f0c79771fd6ba4ac$var$DEFAULT_OVERSCROLL_SIZE = 1e3;
const $f0c79771fd6ba4ac$var$INTERSECTION_OBSERVER_MARGIN = $f0c79771fd6ba4ac$var$DEFAULT_OVERSCROLL_SIZE * 4;
const $f0c79771fd6ba4ac$var$INTERSECTION_OBSERVER_THRESHOLD = [
    0,
    1e-6,
    .99999,
    1
];
const $f0c79771fd6ba4ac$var$DEFAULT_VIRTUALIZER_CONFIG = {
    overscrollSize: $f0c79771fd6ba4ac$var$DEFAULT_OVERSCROLL_SIZE,
    intersectionObserverMargin: $f0c79771fd6ba4ac$var$INTERSECTION_OBSERVER_MARGIN,
    resizeDebugging: false
};
let $f0c79771fd6ba4ac$var$lastSize = 0;
let $f0c79771fd6ba4ac$var$instance = -1;
var $f0c79771fd6ba4ac$export$89be5a243e59c4b2 = class Virtualizer {
    static __STOP = false;
    static __lastScrollPosition = 0;
    __id = `virtualizer-${++$f0c79771fd6ba4ac$var$instance}`;
    config;
    type = "simple";
    intersectionObserver;
    scrollTop = 0;
    height = 0;
    scrollHeight = 0;
    windowSpecs = {
        top: 0,
        bottom: 0
    };
    root;
    contentContainer;
    resizeObserver;
    observers = /* @__PURE__ */ new Map();
    visibleInstances = /* @__PURE__ */ new Map();
    visibleInstancesDirty = false;
    instancesChanged = /* @__PURE__ */ new Set();
    scrollDirty = true;
    heightDirty = true;
    scrollHeightDirty = true;
    renderedObservers = 0;
    connectQueue = /* @__PURE__ */ new Map();
    constructor(config){
        this.config = {
            ...$f0c79771fd6ba4ac$var$DEFAULT_VIRTUALIZER_CONFIG,
            ...config
        };
    }
    setup(root, contentContainer) {
        if (this.root != null) return;
        this.root = root;
        this.resizeObserver = new ResizeObserver(this.handleContainerResize);
        this.intersectionObserver = new IntersectionObserver(this.handleIntersectionChange, {
            root: this.root,
            threshold: $f0c79771fd6ba4ac$var$INTERSECTION_OBSERVER_THRESHOLD,
            rootMargin: `${this.config.intersectionObserverMargin}px 0px ${this.config.intersectionObserverMargin}px 0px`
        });
        if (root instanceof Document) this.setupWindow();
        else this.setupElement(contentContainer);
        window.__INSTANCE = this;
        window.__TOGGLE = ()=>{
            if (Virtualizer.__STOP) {
                Virtualizer.__STOP = false;
                (this.getScrollContainerElement() ?? window).scrollTo({
                    top: Virtualizer.__lastScrollPosition
                });
                (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
            } else {
                Virtualizer.__lastScrollPosition = this.getScrollTop();
                Virtualizer.__STOP = true;
            }
        };
        for (const [container, instance$1] of this.connectQueue.entries())this.connect(container, instance$1);
        this.connectQueue.clear();
        this.markDOMDirty();
        (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    }
    instanceChanged(instance$1, domDirty) {
        this.instancesChanged.add(instance$1);
        if (domDirty) this.markDOMDirty();
        (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    }
    getWindowSpecs() {
        if (this.windowSpecs.top === 0 && this.windowSpecs.bottom === 0) this.windowSpecs = (0, $71eae0748844a945$export$182aa6646dae80cc)({
            scrollTop: this.getScrollTop(),
            height: this.getHeight(),
            scrollHeight: this.getScrollHeight(),
            overscrollSize: this.config.overscrollSize
        });
        return this.windowSpecs;
    }
    isInstanceVisible(elementTop, elementHeight) {
        const scrollTop = this.getScrollTop();
        const height = this.getHeight();
        const margin = this.config.intersectionObserverMargin;
        const top = scrollTop - margin;
        const bottom = scrollTop + height + margin;
        return !(elementTop < top - elementHeight || elementTop > bottom);
    }
    handleContainerResize = (entries)=>{
        if (this.root == null) return;
        let shouldQueueUpdate = false;
        for (const entry of entries){
            const blockSize = entry.borderBoxSize[0].blockSize;
            if (this.root instanceof Document) {
                if (blockSize !== this.scrollHeight) {
                    this.scrollHeightDirty = true;
                    shouldQueueUpdate = true;
                    if (this.config.resizeDebugging) {
                        console.log("Virtualizer: content size change", this.__id, {
                            sizeChange: blockSize - $f0c79771fd6ba4ac$var$lastSize,
                            newSize: blockSize
                        });
                        $f0c79771fd6ba4ac$var$lastSize = blockSize;
                    }
                }
            } else if (entry.target === this.root) {
                if (blockSize !== this.height) {
                    this.heightDirty = true;
                    shouldQueueUpdate = true;
                }
            } else if (entry.target === this.contentContainer) {
                this.scrollHeightDirty = true;
                shouldQueueUpdate = true;
                if (this.config.resizeDebugging) {
                    console.log("Virtualizer: scroller size change", this.__id, {
                        sizeChange: blockSize - $f0c79771fd6ba4ac$var$lastSize,
                        newSize: blockSize
                    });
                    $f0c79771fd6ba4ac$var$lastSize = blockSize;
                }
            }
        }
        if (shouldQueueUpdate) (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    };
    setupWindow() {
        if (this.root == null || !(this.root instanceof Document)) throw new Error("Virtualizer.setupWindow: Invalid setup method");
        window.addEventListener("scroll", this.handleWindowScroll, {
            passive: true
        });
        window.addEventListener("resize", this.handleWindowResize, {
            passive: true
        });
        this.resizeObserver?.observe(this.root.documentElement);
    }
    setupElement(contentContainer) {
        if (this.root == null || this.root instanceof Document) throw new Error("Virtualizer.setupElement: Invalid setup method");
        this.root.addEventListener("scroll", this.handleElementScroll, {
            passive: true
        });
        this.resizeObserver?.observe(this.root);
        contentContainer ??= this.root.firstElementChild ?? void 0;
        if (contentContainer instanceof HTMLElement) {
            this.contentContainer = contentContainer;
            this.resizeObserver?.observe(contentContainer);
        }
    }
    cleanUp() {
        this.resizeObserver?.disconnect();
        this.resizeObserver = void 0;
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = void 0;
        this.root?.removeEventListener("scroll", this.handleElementScroll);
        window.removeEventListener("scroll", this.handleWindowScroll);
        window.removeEventListener("resize", this.handleWindowResize);
        this.root = void 0;
        this.contentContainer = void 0;
        this.observers.clear();
        this.visibleInstances.clear();
        this.instancesChanged.clear();
        this.connectQueue.clear();
        this.visibleInstancesDirty = false;
        this.windowSpecs = {
            top: 0,
            bottom: 0
        };
        this.scrollTop = 0;
        this.height = 0;
        this.scrollHeight = 0;
    }
    getOffsetInScrollContainer(element) {
        return this.getScrollTop() + $f0c79771fd6ba4ac$var$getRelativeBoundingTop(element, this.getScrollContainerElement());
    }
    connect(container, instance$1) {
        if (this.observers.has(container)) throw new Error("Virtualizer.connect: instance is already connected...");
        if (this.intersectionObserver == null) this.connectQueue.set(container, instance$1);
        else {
            this.intersectionObserver.observe(container);
            this.observers.set(container, instance$1);
            this.instancesChanged.add(instance$1);
            this.markDOMDirty();
            (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
        }
        return ()=>this.disconnect(container);
    }
    disconnect(container) {
        const instance$1 = this.observers.get(container);
        this.connectQueue.delete(container);
        if (instance$1 == null) return;
        this.intersectionObserver?.unobserve(container);
        this.observers.delete(container);
        if (this.visibleInstances.delete(container)) this.visibleInstancesDirty = true;
        this.markDOMDirty();
        (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    }
    handleWindowResize = ()=>{
        if (Virtualizer.__STOP || window.innerHeight === this.height) return;
        this.heightDirty = true;
        (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    };
    handleWindowScroll = ()=>{
        if (Virtualizer.__STOP || this.root == null || !(this.root instanceof Document)) return;
        this.scrollDirty = true;
        (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    };
    handleElementScroll = ()=>{
        if (Virtualizer.__STOP || this.root == null || this.root instanceof Document) return;
        this.scrollDirty = true;
        (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    };
    computeRenderRangeAndEmit = ()=>{
        if (Virtualizer.__STOP) return;
        const wrapperDirty = this.heightDirty || this.scrollHeightDirty;
        if (!this.scrollDirty && !this.scrollHeightDirty && !this.heightDirty && this.renderedObservers === this.observers.size && !this.visibleInstancesDirty && this.instancesChanged.size === 0) return;
        if (this.instancesChanged.size === 0) {
            const windowSpecs = (0, $71eae0748844a945$export$182aa6646dae80cc)({
                scrollTop: this.getScrollTop(),
                height: this.getHeight(),
                scrollHeight: this.getScrollHeight(),
                overscrollSize: this.config.overscrollSize
            });
            if ((0, $01fd4b619c317ff9$export$ae7cd73857576f20)(this.windowSpecs, windowSpecs) && this.renderedObservers === this.observers.size && !this.visibleInstancesDirty && this.instancesChanged.size === 0) return;
            this.windowSpecs = windowSpecs;
        }
        this.visibleInstancesDirty = false;
        this.renderedObservers = this.observers.size;
        const anchor = this.getScrollAnchor(this.height);
        const updatedInstances = /* @__PURE__ */ new Set();
        for (const instance$1 of wrapperDirty ? this.observers.values() : this.visibleInstances.values())if (instance$1.onRender(wrapperDirty)) updatedInstances.add(instance$1);
        for (const instance$1 of this.instancesChanged){
            if (updatedInstances.has(instance$1)) continue;
            if (instance$1.onRender(wrapperDirty)) updatedInstances.add(instance$1);
        }
        this.scrollFix(anchor);
        if (this.instancesChanged.size > 0) this.markDOMDirty();
        for (const instance$1 of updatedInstances)instance$1.reconcileHeights();
        if (this.instancesChanged.size > 0 || wrapperDirty) (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
        updatedInstances.clear();
        this.instancesChanged.clear();
    };
    scrollFix(anchor) {
        if (anchor == null) return;
        const scrollContainer = this.getScrollContainerElement();
        const { lineIndex: lineIndex, lineOffset: lineOffset, fileElement: fileElement, fileOffset: fileOffset, fileTypeOffset: fileTypeOffset } = anchor;
        if (lineIndex != null && lineOffset != null) {
            const element = fileElement.shadowRoot?.querySelector(`[data-line][data-line-index="${lineIndex}"]`);
            if (element instanceof HTMLElement) {
                const top$1 = $f0c79771fd6ba4ac$var$getRelativeBoundingTop(element, scrollContainer);
                if (top$1 !== lineOffset) {
                    const scrollOffset = top$1 - lineOffset;
                    this.applyScrollFix(scrollOffset);
                }
                return;
            }
        }
        const top = $f0c79771fd6ba4ac$var$getRelativeBoundingTop(fileElement, scrollContainer);
        if (fileTypeOffset === "top") {
            if (top !== fileOffset) this.applyScrollFix(top - fileOffset);
        } else {
            const bottom = top + fileElement.getBoundingClientRect().height;
            if (bottom !== fileOffset) this.applyScrollFix(bottom - fileOffset);
        }
    }
    applyScrollFix(scrollOffset) {
        if (this.root == null || this.root instanceof Document) window.scrollTo({
            top: window.scrollY + scrollOffset,
            behavior: "instant"
        });
        else this.root.scrollTo({
            top: this.root.scrollTop + scrollOffset,
            behavior: "instant"
        });
        this.markDOMDirty();
    }
    getScrollAnchor(viewportHeight) {
        const scrollContainer = this.getScrollContainerElement();
        let bestAnchor;
        for (const [fileElement] of this.visibleInstances.entries()){
            const fileTop = $f0c79771fd6ba4ac$var$getRelativeBoundingTop(fileElement, scrollContainer);
            const fileBottom = fileTop + fileElement.offsetHeight;
            let fileOffset;
            let fileTypeOffset;
            if (fileBottom <= 0) {
                fileOffset = fileBottom;
                fileTypeOffset = "bottom";
            } else {
                fileOffset = fileTop;
                fileTypeOffset = "top";
            }
            let bestLineIndex;
            let bestLineOffset;
            if (fileBottom > 0 && fileTop < viewportHeight) for (const line of fileElement.shadowRoot?.querySelectorAll("[data-line][data-line-index]") ?? []){
                if (!(line instanceof HTMLElement)) continue;
                const lineIndex = line.dataset.lineIndex;
                if (lineIndex == null) continue;
                const lineOffset = $f0c79771fd6ba4ac$var$getRelativeBoundingTop(line, scrollContainer);
                if (lineOffset < 0) continue;
                bestLineIndex = lineIndex;
                bestLineOffset = lineOffset;
                break;
            }
            if (bestAnchor?.lineOffset != null && bestLineOffset == null) continue;
            let shouldReplace = false;
            if (bestAnchor == null) shouldReplace = true;
            else if (bestLineOffset != null && (bestAnchor.lineOffset == null || bestLineOffset < bestAnchor.lineOffset)) shouldReplace = true;
            else if (bestLineOffset == null && bestAnchor.lineOffset == null) {
                if (fileOffset >= 0 && (bestAnchor.fileOffset < 0 || fileOffset < bestAnchor.fileOffset)) shouldReplace = true;
                else if (fileOffset < 0 && bestAnchor.fileOffset < 0 && fileOffset > bestAnchor.fileOffset) shouldReplace = true;
            }
            if (shouldReplace) bestAnchor = {
                fileElement: fileElement,
                fileTypeOffset: fileTypeOffset,
                fileOffset: fileOffset,
                lineIndex: bestLineIndex,
                lineOffset: bestLineOffset
            };
        }
        return bestAnchor;
    }
    handleIntersectionChange = (entries)=>{
        this.scrollDirty = true;
        for (const { target: target, isIntersecting: isIntersecting } of entries){
            if (!(target instanceof HTMLElement)) throw new Error("Virtualizer.handleIntersectionChange: target not an HTMLElement");
            const instance$1 = this.observers.get(target);
            if (instance$1 == null) continue;
            if (isIntersecting && !this.visibleInstances.has(target)) {
                instance$1.setVisibility(true);
                this.visibleInstances.set(target, instance$1);
                this.visibleInstancesDirty = true;
            } else if (!isIntersecting && this.visibleInstances.has(target)) {
                instance$1.setVisibility(false);
                this.visibleInstances.delete(target);
                this.visibleInstancesDirty = true;
            }
        }
        if (this.visibleInstancesDirty) (0, $c4a6ed6d38b63558$export$7b4bf160c2c55328)(this.computeRenderRangeAndEmit);
    };
    getScrollTop() {
        if (!this.scrollDirty) return this.scrollTop;
        this.scrollDirty = false;
        let scrollTop = (()=>{
            if (this.root == null) return 0;
            if (this.root instanceof Document) return window.scrollY;
            return this.root.scrollTop;
        })();
        scrollTop = Math.max(0, Math.min(scrollTop, this.getScrollHeight() - this.getHeight()));
        this.scrollTop = scrollTop;
        return scrollTop;
    }
    getScrollHeight() {
        if (!this.scrollHeightDirty) return this.scrollHeight;
        this.scrollHeightDirty = false;
        this.scrollHeight = (()=>{
            if (this.root == null) return 0;
            if (this.root instanceof Document) return this.root.documentElement.scrollHeight;
            return this.root.scrollHeight;
        })();
        return this.scrollHeight;
    }
    getHeight() {
        if (!this.heightDirty) return this.height;
        this.heightDirty = false;
        this.height = (()=>{
            if (this.root == null) return 0;
            if (this.root instanceof Document) return globalThis.innerHeight;
            return this.root.getBoundingClientRect().height;
        })();
        return this.height;
    }
    markDOMDirty() {
        this.scrollDirty = true;
        this.scrollHeightDirty = true;
        this.heightDirty = true;
    }
    getScrollContainerElement() {
        return this.root == null || this.root instanceof Document ? void 0 : this.root;
    }
};
function $f0c79771fd6ba4ac$var$getRelativeBoundingTop(element, scrollContainer) {
    const rect = element.getBoundingClientRect();
    const scrollContainerTop = scrollContainer?.getBoundingClientRect().top ?? 0;
    return rect.top - scrollContainerTop;
}



var $acw62 = parcelRequire("acw62");

'use client';
//#region src/react/Virtualizer.tsx
const $18fbaafe04d507e8$export$d288a7dd40372bc = (0, $acw62.createContext)(void 0);
function $18fbaafe04d507e8$export$89be5a243e59c4b2({ children: children, config: config, className: className, style: style, contentClassName: contentClassName, contentStyle: contentStyle }) {
    const [instance] = (0, $acw62.useState)(()=>{
        return typeof window !== "undefined" ? new (0, $f0c79771fd6ba4ac$export$89be5a243e59c4b2)(config) : void 0;
    });
    const ref = (0, $acw62.useCallback)((node)=>{
        if (node != null) instance?.setup(node);
        else instance?.cleanUp();
    }, [
        instance
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($18fbaafe04d507e8$export$d288a7dd40372bc.Provider, {
        value: instance,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: className,
            style: style,
            ref: ref,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: contentClassName,
                style: contentStyle,
                children: children
            })
        })
    });
}
function $18fbaafe04d507e8$export$dd6d526d88b5a137() {
    return (0, $acw62.useContext)($18fbaafe04d507e8$export$d288a7dd40372bc);
}



var $acw62 = parcelRequire("acw62");
//#region src/react/utils/useFileInstance.ts
const $0239f2e728ddbab8$var$useIsometricEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
function $0239f2e728ddbab8$export$db59da89b7660520({ file: file, options: options, lineAnnotations: lineAnnotations, selectedLines: selectedLines, prerenderedHTML: prerenderedHTML, metrics: metrics, hasGutterRenderUtility: hasGutterRenderUtility, hasCustomHeader: hasCustomHeader, disableWorkerPool: disableWorkerPool }) {
    const simpleVirtualizer = (0, $18fbaafe04d507e8$export$dd6d526d88b5a137)();
    const controlledSelection = selectedLines !== void 0;
    const poolManager = (0, $acw62.useContext)((0, $6420ed5fedaeb898$export$536e5a16a8f8264d));
    const instanceRef = (0, $acw62.useRef)(null);
    const ref = (0, $8441625c98d053f4$export$1a8b1350915fe2e0)((node)=>{
        if (node != null) {
            if (instanceRef.current != null) throw new Error("File: An instance should not already exist when a node is created");
            if (simpleVirtualizer != null) instanceRef.current = new (0, $04b40a9847bcadbe$export$6ddfbce10e697151)($0239f2e728ddbab8$var$mergeFileOptions({
                controlledSelection: controlledSelection,
                hasCustomHeader: hasCustomHeader,
                hasGutterRenderUtility: hasGutterRenderUtility,
                options: options
            }), simpleVirtualizer, metrics, !disableWorkerPool ? poolManager : void 0, true);
            else instanceRef.current = new (0, $25cd466ecc388b00$export$b6afa8811b7e644e)($0239f2e728ddbab8$var$mergeFileOptions({
                controlledSelection: controlledSelection,
                hasCustomHeader: hasCustomHeader,
                hasGutterRenderUtility: hasGutterRenderUtility,
                options: options
            }), !disableWorkerPool ? poolManager : void 0, true);
            instanceRef.current.hydrate({
                file: file,
                fileContainer: node,
                lineAnnotations: lineAnnotations,
                prerenderedHTML: prerenderedHTML
            });
        } else {
            if (instanceRef.current == null) throw new Error("File: A File instance should exist when unmounting");
            instanceRef.current.cleanUp();
            instanceRef.current = null;
        }
    });
    $0239f2e728ddbab8$var$useIsometricEffect(()=>{
        if (instanceRef.current == null) return;
        const newOptions = $0239f2e728ddbab8$var$mergeFileOptions({
            controlledSelection: controlledSelection,
            hasCustomHeader: hasCustomHeader,
            hasGutterRenderUtility: hasGutterRenderUtility,
            options: options
        });
        const forceRender = !(0, $5e49faa8df06196c$export$1ace03bbcd701468)(instanceRef.current.options, newOptions);
        instanceRef.current.setOptions(newOptions);
        instanceRef.current.render({
            file: file,
            lineAnnotations: lineAnnotations,
            forceRender: forceRender
        });
        if (selectedLines !== void 0) instanceRef.current.setSelectedLines(selectedLines);
    });
    return {
        ref: ref,
        getHoveredLine: (0, $acw62.useCallback)(()=>{
            return instanceRef.current?.getHoveredLine();
        }, [])
    };
}
function $0239f2e728ddbab8$var$mergeFileOptions({ options: options, controlledSelection: controlledSelection, hasCustomHeader: hasCustomHeader, hasGutterRenderUtility: hasGutterRenderUtility }) {
    if (!controlledSelection && !hasGutterRenderUtility && !hasCustomHeader) return options;
    return {
        ...options,
        controlledSelection: controlledSelection,
        renderCustomHeader: hasCustomHeader ? (0, $60116dac34141baf$export$45b326e4df8b4632) : options?.renderCustomHeader,
        renderGutterUtility: hasGutterRenderUtility ? (0, $60116dac34141baf$export$45b326e4df8b4632) : options?.renderGutterUtility
    };
}



'use client';
//#region src/react/File.tsx
function $75aaf218ff21c0fd$export$b6afa8811b7e644e({ file: file, lineAnnotations: lineAnnotations, selectedLines: selectedLines, options: options, metrics: metrics, className: className, style: style, renderAnnotation: renderAnnotation, renderCustomHeader: renderCustomHeader, renderHeaderPrefix: renderHeaderPrefix, renderHeaderMetadata: renderHeaderMetadata, prerenderedHTML: prerenderedHTML, renderGutterUtility: renderGutterUtility, disableWorkerPool: disableWorkerPool = false }) {
    const { ref: ref, getHoveredLine: getHoveredLine } = (0, $0239f2e728ddbab8$export$db59da89b7660520)({
        file: file,
        options: options,
        metrics: metrics,
        lineAnnotations: lineAnnotations,
        selectedLines: selectedLines,
        prerenderedHTML: prerenderedHTML,
        hasGutterRenderUtility: renderGutterUtility != null,
        hasCustomHeader: renderCustomHeader != null,
        disableWorkerPool: disableWorkerPool
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6986aac91971cc6d$export$b583bc7fc1f35cf2), {
        ref: ref,
        className: className,
        style: style,
        children: (0, $57201c9a5acac26e$export$5c04c7d02692535b)((0, $e5fd8d5ef1bc741e$export$26dd293a21f7d4d9)({
            file: file,
            renderAnnotation: renderAnnotation,
            renderCustomHeader: renderCustomHeader,
            renderHeaderPrefix: renderHeaderPrefix,
            renderHeaderMetadata: renderHeaderMetadata,
            renderGutterUtility: renderGutterUtility,
            lineAnnotations: lineAnnotations,
            getHoveredLine: getHoveredLine
        }), prerenderedHTML)
    });
}




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f86a0ac31b8d349c$export$37fb8590cf2c088c = (0, $acw62.createContext)({});
let $f86a0ac31b8d349c$var$$41fb335299a4a39e$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const $f86a0ac31b8d349c$export$f5b8910cec6cf069 = (0, $ffa0afb9817175b6$export$86427a43e3e48ebb)(function Input(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $f86a0ac31b8d349c$export$37fb8590cf2c088c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        ...props,
        isDisabled: props.disabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $0cde480b945a073a$export$4e328f61c538687f)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Input'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).input, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)($f86a0ac31b8d349c$var$$41fb335299a4a39e$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});










var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3db0f099b6775132$export$f9c6924e160136d1 = (0, $acw62.createContext)({});
const $3db0f099b6775132$export$eb2fcfdbd7ba97d4 = (0, $acw62.forwardRef)(function Group(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $3db0f099b6775132$export$f9c6924e160136d1);
    let { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    isDisabled ??= !!props['aria-disabled'] && props['aria-disabled'] !== 'false';
    isInvalid ??= !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        onHoverStart: onHoverStart,
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd,
        isDisabled: isDisabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $0cde480b945a073a$export$4e328f61c538687f)({
        within: true
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Group'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(otherProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        role: props.role ?? 'group',
        slot: props.slot ?? undefined,
        "data-focus-within": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-invalid": isInvalid || undefined,
        "data-readonly": isReadOnly || undefined
    }, renderProps.children);
});













var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6c26a6b63b63e32f$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = 'input', isDisabled: isDisabled = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, type: type = 'text', validationBehavior: validationBehavior = 'aria' } = props;
    let [value, setValue] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(props.value, props.defaultValue || '', props.onChange);
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)(props, ref);
    let validationState = (0, $0c6ddd323fa7af24$export$fc1a364ae1f3ff10)({
        ...props,
        value: value
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $ec7707e2bf6dfe59$export$294aa081a6c6f55d)({
        ...props,
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    let [initialValue] = (0, $acw62.useState)(value);
    (0, $a71202214a10b9ab$export$5add1d006293d136)(ref, props.defaultValue ?? initialValue, setValue);
    (0, $9aec99f022b72b42$export$b8473d3665f3a75a)(props, validationState, ref);
    return {
        labelProps: labelProps,
        inputProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, inputElementType === 'input' ? inputOnlyProps : undefined, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === 'native',
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            'aria-invalid': isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-activedescendant': props['aria-activedescendant'],
            'aria-autocomplete': props['aria-autocomplete'],
            'aria-haspopup': props['aria-haspopup'],
            'aria-controls': props['aria-controls'],
            value: value,
            onChange: (e)=>setValue((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e).value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            form: props.form,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            autoCorrect: props.autoCorrect,
            spellCheck: props.spellCheck,
            [parseInt((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: props.enterKeyHint,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}



var $fd499ce408c30dbf$export$2e2bcd8739ae039 = {};
$fd499ce408c30dbf$export$2e2bcd8739ae039 = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};


var $c398e49c63e76ff3$export$2e2bcd8739ae039 = {};
$c398e49c63e76ff3$export$2e2bcd8739ae039 = {
    "Clear search": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{442}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`
};


var $ce705276d050187d$export$2e2bcd8739ae039 = {};
$ce705276d050187d$export$2e2bcd8739ae039 = {
    "Clear search": `Vymazat hled\xe1n\xed`
};


var $cac7e520a78e7ee1$export$2e2bcd8739ae039 = {};
$cac7e520a78e7ee1$export$2e2bcd8739ae039 = {
    "Clear search": `Ryd s\xf8gning`
};


var $2fb3c48b6caa45a5$export$2e2bcd8739ae039 = {};
$2fb3c48b6caa45a5$export$2e2bcd8739ae039 = {
    "Clear search": `Suche zur\xfccksetzen`
};


var $651f64394732b8fc$export$2e2bcd8739ae039 = {};
$651f64394732b8fc$export$2e2bcd8739ae039 = {
    "Clear search": `\u{391}\u{3C0}\u{3B1}\u{3BB}\u{3BF}\u{3B9}\u{3C6}\u{3AE} \u{3B1}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}\u{3C2}`
};


var $8702b33b5bf3db56$export$2e2bcd8739ae039 = {};
$8702b33b5bf3db56$export$2e2bcd8739ae039 = {
    "Clear search": `Clear search`
};


var $656549f0c8a3c7d9$export$2e2bcd8739ae039 = {};
$656549f0c8a3c7d9$export$2e2bcd8739ae039 = {
    "Clear search": `Borrar b\xfasqueda`
};


var $e56f360daa9a7f85$export$2e2bcd8739ae039 = {};
$e56f360daa9a7f85$export$2e2bcd8739ae039 = {
    "Clear search": `T\xfchjenda otsing`
};


var $5c6ec4b708601ae2$export$2e2bcd8739ae039 = {};
$5c6ec4b708601ae2$export$2e2bcd8739ae039 = {
    "Clear search": `Tyhjenn\xe4 haku`
};


var $c2b368a9e97a3251$export$2e2bcd8739ae039 = {};
$c2b368a9e97a3251$export$2e2bcd8739ae039 = {
    "Clear search": `Effacer la recherche`
};


var $23cf9da4cdd3df44$export$2e2bcd8739ae039 = {};
$23cf9da4cdd3df44$export$2e2bcd8739ae039 = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};


var $41e365901cc819f4$export$2e2bcd8739ae039 = {};
$41e365901cc819f4$export$2e2bcd8739ae039 = {
    "Clear search": `Obri\u{161}i pretragu`
};


var $648b982c5a678f16$export$2e2bcd8739ae039 = {};
$648b982c5a678f16$export$2e2bcd8739ae039 = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};


var $24821121c8e8414d$export$2e2bcd8739ae039 = {};
$24821121c8e8414d$export$2e2bcd8739ae039 = {
    "Clear search": `Cancella ricerca`
};


var $67968c5ac3054dff$export$2e2bcd8739ae039 = {};
$67968c5ac3054dff$export$2e2bcd8739ae039 = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};


var $6e6dcfec7bb0aafb$export$2e2bcd8739ae039 = {};
$6e6dcfec7bb0aafb$export$2e2bcd8739ae039 = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};


var $f7e2738ce82ec99c$export$2e2bcd8739ae039 = {};
$f7e2738ce82ec99c$export$2e2bcd8739ae039 = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};


var $4f47eb4eaadcc03f$export$2e2bcd8739ae039 = {};
$4f47eb4eaadcc03f$export$2e2bcd8739ae039 = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};


var $0f1b018b10ec2bc5$export$2e2bcd8739ae039 = {};
$0f1b018b10ec2bc5$export$2e2bcd8739ae039 = {
    "Clear search": `T\xf8m s\xf8k`
};


var $c44709be01632d4c$export$2e2bcd8739ae039 = {};
$c44709be01632d4c$export$2e2bcd8739ae039 = {
    "Clear search": `Zoekactie wissen`
};


var $d65ac5ce75e8946b$export$2e2bcd8739ae039 = {};
$d65ac5ce75e8946b$export$2e2bcd8739ae039 = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};


var $56048ae49fc62c8e$export$2e2bcd8739ae039 = {};
$56048ae49fc62c8e$export$2e2bcd8739ae039 = {
    "Clear search": `Limpar pesquisa`
};


var $6ab6b5258bc619bf$export$2e2bcd8739ae039 = {};
$6ab6b5258bc619bf$export$2e2bcd8739ae039 = {
    "Clear search": `Limpar pesquisa`
};


var $868590d7b9262aa7$export$2e2bcd8739ae039 = {};
$868590d7b9262aa7$export$2e2bcd8739ae039 = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};


var $b79672ff4b0cc222$export$2e2bcd8739ae039 = {};
$b79672ff4b0cc222$export$2e2bcd8739ae039 = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};


var $66db5ff6d1ed6e4a$export$2e2bcd8739ae039 = {};
$66db5ff6d1ed6e4a$export$2e2bcd8739ae039 = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};


var $c2bd9b600281735b$export$2e2bcd8739ae039 = {};
$c2bd9b600281735b$export$2e2bcd8739ae039 = {
    "Clear search": `Po\u{10D}isti iskanje`
};


var $881c12560ce2348a$export$2e2bcd8739ae039 = {};
$881c12560ce2348a$export$2e2bcd8739ae039 = {
    "Clear search": `Obri\u{161}i pretragu`
};


var $1e09bb0f48fdb098$export$2e2bcd8739ae039 = {};
$1e09bb0f48fdb098$export$2e2bcd8739ae039 = {
    "Clear search": `Rensa s\xf6kning`
};


var $e84254328aa46ed7$export$2e2bcd8739ae039 = {};
$e84254328aa46ed7$export$2e2bcd8739ae039 = {
    "Clear search": `Aramay\u{131} temizle`
};


var $717194d4231b068d$export$2e2bcd8739ae039 = {};
$717194d4231b068d$export$2e2bcd8739ae039 = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};


var $95b6acf62402b888$export$2e2bcd8739ae039 = {};
$95b6acf62402b888$export$2e2bcd8739ae039 = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};


var $ad6628a9dff888fd$export$2e2bcd8739ae039 = {};
$ad6628a9dff888fd$export$2e2bcd8739ae039 = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};


var $aa599754565ca91d$export$2e2bcd8739ae039 = {};
$aa599754565ca91d$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $fd499ce408c30dbf$export$2e2bcd8739ae039),
    "bg-BG": (0, $c398e49c63e76ff3$export$2e2bcd8739ae039),
    "cs-CZ": (0, $ce705276d050187d$export$2e2bcd8739ae039),
    "da-DK": (0, $cac7e520a78e7ee1$export$2e2bcd8739ae039),
    "de-DE": (0, $2fb3c48b6caa45a5$export$2e2bcd8739ae039),
    "el-GR": (0, $651f64394732b8fc$export$2e2bcd8739ae039),
    "en-US": (0, $8702b33b5bf3db56$export$2e2bcd8739ae039),
    "es-ES": (0, $656549f0c8a3c7d9$export$2e2bcd8739ae039),
    "et-EE": (0, $e56f360daa9a7f85$export$2e2bcd8739ae039),
    "fi-FI": (0, $5c6ec4b708601ae2$export$2e2bcd8739ae039),
    "fr-FR": (0, $c2b368a9e97a3251$export$2e2bcd8739ae039),
    "he-IL": (0, $23cf9da4cdd3df44$export$2e2bcd8739ae039),
    "hr-HR": (0, $41e365901cc819f4$export$2e2bcd8739ae039),
    "hu-HU": (0, $648b982c5a678f16$export$2e2bcd8739ae039),
    "it-IT": (0, $24821121c8e8414d$export$2e2bcd8739ae039),
    "ja-JP": (0, $67968c5ac3054dff$export$2e2bcd8739ae039),
    "ko-KR": (0, $6e6dcfec7bb0aafb$export$2e2bcd8739ae039),
    "lt-LT": (0, $f7e2738ce82ec99c$export$2e2bcd8739ae039),
    "lv-LV": (0, $4f47eb4eaadcc03f$export$2e2bcd8739ae039),
    "nb-NO": (0, $0f1b018b10ec2bc5$export$2e2bcd8739ae039),
    "nl-NL": (0, $c44709be01632d4c$export$2e2bcd8739ae039),
    "pl-PL": (0, $d65ac5ce75e8946b$export$2e2bcd8739ae039),
    "pt-BR": (0, $56048ae49fc62c8e$export$2e2bcd8739ae039),
    "pt-PT": (0, $6ab6b5258bc619bf$export$2e2bcd8739ae039),
    "ro-RO": (0, $868590d7b9262aa7$export$2e2bcd8739ae039),
    "ru-RU": (0, $b79672ff4b0cc222$export$2e2bcd8739ae039),
    "sk-SK": (0, $66db5ff6d1ed6e4a$export$2e2bcd8739ae039),
    "sl-SI": (0, $c2bd9b600281735b$export$2e2bcd8739ae039),
    "sr-SP": (0, $881c12560ce2348a$export$2e2bcd8739ae039),
    "sv-SE": (0, $1e09bb0f48fdb098$export$2e2bcd8739ae039),
    "tr-TR": (0, $e84254328aa46ed7$export$2e2bcd8739ae039),
    "uk-UA": (0, $717194d4231b068d$export$2e2bcd8739ae039),
    "zh-CN": (0, $95b6acf62402b888$export$2e2bcd8739ae039),
    "zh-TW": (0, $ad6628a9dff888fd$export$2e2bcd8739ae039)
};



function $9b702292f35358b9$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9b702292f35358b9$export$9bb30bbe003b82e0(props, state, inputRef) {
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($9b702292f35358b9$var$$parcel$interopDefault((0, $aa599754565ca91d$export$2e2bcd8739ae039)), '@react-aria/searchfield');
    let { isDisabled: isDisabled, isReadOnly: isReadOnly, onSubmit: onSubmit, onClear: onClear, type: type = 'search' } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === 'Enter' && (isDisabled || isReadOnly)) e.preventDefault();
        if (isDisabled || isReadOnly) return;
        // for backward compatibility;
        // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
        if (key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(state.value);
        }
        if (key === 'Escape') {
            // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
            // the hook
            if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) e.continuePropagation();
            else {
                e.preventDefault();
                state.setValue('');
                if (onClear) onClear();
            }
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current?.focus();
    };
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $6c26a6b63b63e32f$export$712718f7aec83d5)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type: type
    }, inputRef);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart: onPressStart
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        ...validation
    };
}





var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $89e567c38a20e78e$export$3f8be18b0f41eaf2(props) {
    let [value, setValue] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)($89e567c38a20e78e$var$$56baeede9f35e022$var$toString(props.value), $89e567c38a20e78e$var$$56baeede9f35e022$var$toString(props.defaultValue) || '', props.onChange);
    return {
        value: value,
        setValue: setValue
    };
}
function $89e567c38a20e78e$var$$56baeede9f35e022$var$toString(val) {
    if (val == null) return;
    return val.toString();
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3de6a7daf03a057f$export$d1c4e4c63cb03a11 = (0, $acw62.createContext)(null);
const $3de6a7daf03a057f$export$b94867ecbd698f21 = (0, $ffa0afb9817175b6$export$86427a43e3e48ebb)(function SearchField(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $3de6a7daf03a057f$export$d1c4e4c63cb03a11);
    let { validationBehavior: formValidationBehavior } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)((0, $bdd138f35fdd977e$export$c24727297075ec6a)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, $acw62.useRef)(null);
    [props, inputRef] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, inputRef, (0, $80b3f40af2eadde4$export$698f465ec27e93df));
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let state = (0, $89e567c38a20e78e$export$3f8be18b0f41eaf2)({
        ...props,
        validationBehavior: validationBehavior
    });
    let { labelProps: labelProps, inputProps: inputProps, clearButtonProps: clearButtonProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $9b702292f35358b9$export$9bb30bbe003b82e0)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, inputRef);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false,
            state: state
        },
        defaultClassName: 'react-aria-SearchField'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $f86a0ac31b8d349c$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $972ba92a45901f5b$export$24d547caef80ccd1),
                clearButtonProps
            ],
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $3db0f099b6775132$export$f9c6924e160136d1),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $76bbfd363f450690$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, renderProps.children));
});



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7c3a1fdaf0c6ad5f$export$3274cf84b703fff(options) {
    let collator = (0, $040b7c2ffa13ce2b$export$a16aca283550c30d)({
        usage: 'search',
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $acw62.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}















var $acw62 = parcelRequire("acw62");


const $160aae2205f65d4a$export$2dc6166a7e65358c = (0, $acw62.createContext)({});
let $160aae2205f65d4a$var$$bd263d78e9bf3c56$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const $160aae2205f65d4a$export$f5c9f3c2c4054eec = (0, $acw62.forwardRef)(function TextArea(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $160aae2205f65d4a$export$2dc6166a7e65358c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)(props);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $0cde480b945a073a$export$4e328f61c538687f)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-TextArea'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).textarea, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)($160aae2205f65d4a$var$$bd263d78e9bf3c56$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});














var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $09752816b77dea6a$export$2129e27b3ef0d483 = (0, $acw62.createContext)(null);
const $09752816b77dea6a$export$2c73285ae9390cec = (0, $ffa0afb9817175b6$export$86427a43e3e48ebb)(function TextField(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $09752816b77dea6a$export$2129e27b3ef0d483);
    let { validationBehavior: formValidationBehavior } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)((0, $bdd138f35fdd977e$export$c24727297075ec6a)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, $acw62.useRef)(null);
    [props, inputRef] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, inputRef, (0, $80b3f40af2eadde4$export$698f465ec27e93df));
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let [inputElementType, setInputElementType] = (0, $acw62.useState)('input');
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $6c26a6b63b63e32f$export$712718f7aec83d5)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        inputElementType: inputElementType,
        label: label,
        validationBehavior: validationBehavior
    }, inputRef);
    // Intercept setting the input ref so we can determine what kind of element we have.
    // useTextField uses this to determine what props to include.
    let inputOrTextAreaRef = (0, $acw62.useCallback)((el)=>{
        inputRef.current = el;
        if (el) setInputElementType(el instanceof HTMLTextAreaElement ? 'textarea' : 'input');
    }, [
        inputRef
    ]);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-TextField'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $f86a0ac31b8d349c$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, $160aae2205f65d4a$export$2dc6166a7e65358c),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, $3db0f099b6775132$export$f9c6924e160136d1),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $76bbfd363f450690$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, renderProps.children));
});



var $acw62 = parcelRequire("acw62");
function $fb50f473036ab352$export$66aad0404632933({ issue: issue }) {
    let formRef = (0, $acw62.useRef)(null);
    let [isClosing, setClosing] = (0, $acw62.useState)(false);
    let key = [
        issue.__typename === 'Issue' ? (0, $376a85c6166d1b77$export$8f76aa81e935a507).query() : (0, $92995ef58fa84f45$export$d8ee8bed60538a6a).query(),
        {
            owner: issue.repository.owner.login,
            repo: issue.repository.name,
            number: issue.number
        }
    ];
    let onSubmit = async (comment)=>{
        await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).issues.createComment({
            owner: issue.repository.owner.login,
            repo: issue.repository.name,
            issue_number: issue.number,
            body: comment
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)(key);
    };
    async function handleClose() {
        setClosing(true);
        try {
            let comment = formRef.current ? new FormData(formRef.current).get('comment') : '';
            if (comment) await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).issues.createComment({
                owner: issue.repository.owner.login,
                repo: issue.repository.name,
                issue_number: issue.number,
                body: comment
            });
            await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).issues.update({
                owner: issue.repository.owner.login,
                repo: issue.repository.name,
                issue_number: issue.number,
                state: 'closed'
            });
            formRef.current?.reset();
            await (0, $e30a63e8d43c13f6$export$35e795649ee09318)(key);
        } finally{
            setClosing(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fb50f473036ab352$export$dade19d95388b828, {
        formRef: formRef,
        onSubmit: onSubmit,
        children: issue.viewerCanClose && issue.state === 'OPEN' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
            type: "button",
            isPending: isClosing,
            onPress: handleClose,
            className: "px-4 py-2 rounded-md bg-purple-500 pressed:bg-purple-600 border border-purple-400 pressed:border-purple-500 pending:opacity-50 transition text-white text-sm font-medium cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
            children: "Close"
        })
    });
}
function $fb50f473036ab352$export$dade19d95388b828({ children: children, className: className, autoFocus: autoFocus, onSubmit: onSubmit, onCancel: onCancel, formRef: formRef }) {
    let [isPending, setPending] = (0, $acw62.useState)(false);
    let handleSubmit = async (e)=>{
        e.preventDefault();
        let form = e.target;
        let comment = new FormData(form).get('comment');
        if (comment && typeof comment === 'string' && onSubmit) try {
            setPending(true);
            await onSubmit(comment);
        } finally{
            setPending(false);
        }
        form.reset();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        ref: formRef,
        className: `flex flex-col gap-2 items-end ${className}`,
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $09752816b77dea6a$export$2c73285ae9390cec), {
                name: "comment",
                className: "flex flex-col gap-1 w-full",
                autoFocus: autoFocus,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aaf42248096e4ba7$export$b04be29aa201d4f5), {
                        className: "text-xs",
                        children: "Comment"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $160aae2205f65d4a$export$f5c9f3c2c4054eec), {
                        className: "w-full bg-daw-gray-50 border border-daw-gray-400 rounded outline-none focus:ring-1 focus:border-blue-600 ring-blue-600 p-2",
                        rows: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    children,
                    onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        type: "button",
                        onPress: onCancel,
                        className: "px-4 py-2 rounded-md bg-daw-gray-300 pressed:bg-daw-gray-400 border border-daw-gray-400 pressed:border-daw-gray-500 text-daw-gray-800 text-sm font-medium cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        type: "submit",
                        isPending: isPending,
                        className: "px-4 py-2 rounded-md bg-green-600 pressed:bg-green-700 border border-green-700 pressed:border-green-800 dark:border-green-500 dark:pressed:border-green-600 pending:opacity-50 transition text-white text-sm font-medium cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
                        children: "Comment"
                    })
                ]
            })
        ]
    });
}



function $376a85c6166d1b77$export$8f76aa81e935a507({ owner: owner, repo: repo, number: number }) {
    let { data: res } = (0, $9efcf42537b67d79$export$dd0a697e1782aedd)($376a85c6166d1b77$export$8f76aa81e935a507.query(), {
        owner: owner,
        repo: repo,
        number: number
    });
    let data = res?.repository.issue;
    if (!data) return null;
    async function deleteComment(id) {
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation DeleteIssueComment($id: ID!) { deleteIssueComment(input: {id: $id}) { clientMutationId } }`, {
            id: id
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $376a85c6166d1b77$export$8f76aa81e935a507.query(),
            {
                owner: owner,
                repo: repo,
                number: number
            }
        ]);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$1f5b733bf3f0b704).Provider, {
        value: {
            owner: owner,
            repo: repo
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-1 justify-center min-h-0 overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-y-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 my-4 max-w-3xl mx-auto px-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$export$8b251419efc915eb, {
                                data: data
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$bc479ee64936fcb7), {
                                data: data
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f88f8247c03421$export$e6a97ba2cae5bb94), {
                                items: data.timelineItems.nodes,
                                onDeleteComment: deleteComment
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb50f473036ab352$export$66aad0404632933), {
                                issue: data
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$IssueSidebar, {
                    data: data
                })
            ]
        })
    });
}
$376a85c6166d1b77$export$8f76aa81e935a507.preload = (owner, repo, number)=>{
    (0, $9efcf42537b67d79$export$513ccb98c53b8039)($376a85c6166d1b77$export$8f76aa81e935a507.query(), {
        owner: owner,
        repo: repo,
        number: number
    });
};
$376a85c6166d1b77$export$8f76aa81e935a507.query = ()=>`
query IssueTimeline($owner: String!, $repo: String!, $number: Int!) {
  repository(owner:$owner, name:$repo) {
    issue(number:$number) {
      __typename
      id
      number
      url
      title
      body
      createdAt
      state
      author {
        ...ActorFragment
      }
      reactionGroups {
        ...ReactionFragment
      }
      repository {
        name
        owner {
          login
          avatarUrl
        }
        issueTypes(first: 20) {
          nodes {
            id
            name
            color
          }
        }
        labels(first: 100) {
          nodes {
            id
            name
            color
          }
        }
      }
      viewerCanClose
      labels(first: 20) {
        nodes {
          id
          name
          color
        }
      }
      assignees(first: 20) {
        nodes {
          login
          avatarUrl
          url
        }
      }
      milestone {
        title
        url
      }
      issueType {
        id
        name
        color
      }
      closedByPullRequestsReferences(first: 10, includeClosedPrs: true) {
        nodes {
          __typename
          number
          title
          url
          state
          isDraft
        }
      }
      timelineItems(first:100) {
        nodes {
          ...IssueTimelineFragment
        }
      }
    }
  }
}

${(0, $63f88f8247c03421$export$e6a97ba2cae5bb94).issueFragment()}
`;
function $376a85c6166d1b77$export$8b251419efc915eb({ data: data }) {
    let isPR = data.__typename === 'PullRequest';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 bg-daw-white rounded-xl p-4 shadow-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                                src: data.repository.owner.avatarUrl
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-daw-gray-700",
                                children: [
                                    data.repository.owner.login,
                                    "/",
                                    data.repository.name,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                                        target: "_blank",
                                        href: data.url,
                                        children: [
                                            "#",
                                            data.number
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$559eb15a98685419), {
                        data: data
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: `${isPR ? 'text-xl' : 'text-2xl'} font-semibold`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87a23dccae47b18a$export$2e2bcd8739ae039), {
                    children: data.title
                })
            }),
            'headRefName' in data && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                            children: data.headRefName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$9ca09caa9c849d9c), {
                            className: "text-daw-gray-700"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                            children: data.baseRefName
                        })
                    ]
                })
            })
        ]
    });
}
function $376a85c6166d1b77$var$SidebarSection({ title: title, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 px-3 py-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-xs font-semibold text-daw-gray-600 tracking-wide",
                children: title
            }),
            children
        ]
    });
}
function $376a85c6166d1b77$var$IssueSidebar({ data: data }) {
    let anyData = data;
    let assignees = data.assignees?.nodes ?? [];
    let milestone = data.milestone;
    let linkedPRs = anyData.closedByPullRequestsReferences?.nodes ?? [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
        className: "w-60 shrink-0 h-fit max-h-full overflow-y-auto my-4 mr-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col text-sm",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$SidebarSection, {
                    title: "Issue Type",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$IssueTypeSelect, {
                        data: data
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$SidebarSection, {
                    title: "Labels",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$LabelsSelect, {
                        data: data
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$SidebarSection, {
                    title: "Milestone",
                    children: milestone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                        href: milestone.url,
                        target: "_blank",
                        className: "hover:underline truncate",
                        children: milestone.title
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-daw-gray-500 text-xs",
                        children: "No milestone"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$SidebarSection, {
                    title: "Assignees",
                    children: assignees.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-daw-gray-500 text-xs",
                        children: "No assignees"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-1.5",
                        children: assignees.map((a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                                        src: a.avatarUrl
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                                        href: a.url,
                                        target: "_blank",
                                        className: "hover:underline truncate",
                                        children: a.login
                                    })
                                ]
                            }, a.login))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($376a85c6166d1b77$var$SidebarSection, {
                    title: "Linked PRs",
                    children: linkedPRs.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-daw-gray-500 text-xs",
                        children: "None yet"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: linkedPRs.map((pr)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "shrink-0 mt-0.5",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$559eb15a98685419), {
                                            data: pr,
                                            type: "icon"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                                        href: pr.url,
                                        className: "text-xs hover:underline outline-none focus-visible:underline font-medium line-clamp-2",
                                        children: pr.title
                                    })
                                ]
                            }, pr.number))
                    })
                })
            ]
        })
    });
}
const $376a85c6166d1b77$var$listBoxItemClass = 'flex items-center px-2 py-1 rounded-lg cursor-default outline-none focus:bg-daw-gray-100 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-blue-600 text-xs';
function $376a85c6166d1b77$var$IssueTypeSelect({ data: data }) {
    let anyData = data;
    let issueType = anyData.issueType;
    let availableTypes = anyData.repository?.issueTypes?.nodes ?? [];
    let [selectedKey, setSelectedKey] = (0, $acw62.useState)(issueType?.id ?? 'none');
    let currentId = issueType?.id ?? 'none';
    if (selectedKey !== currentId) setSelectedKey(currentId);
    let displayType = availableTypes.find((t)=>t.id === selectedKey) ?? null;
    async function handleChange(key) {
        let newId = String(key);
        setSelectedKey(newId);
        let issueTypeId = newId === 'none' ? null : newId;
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation UpdateIssueType($id: ID!, $issueTypeId: ID) {
        updateIssue(input: {id: $id, issueTypeId: $issueTypeId}) { issue { id } }
      }`, {
            id: data.id,
            issueTypeId: issueTypeId
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $376a85c6166d1b77$export$8f76aa81e935a507.query(),
            {
                owner: data.repository.owner.login,
                repo: data.repository.name,
                number: data.number
            }
        ]);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $234aa604da0871e2$export$ef9b1a59e592288f), {
        value: selectedKey,
        onChange: handleChange,
        "aria-label": "Issue type",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                className: "group flex items-center gap-1 cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded-full -mx-0.5 px-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $234aa604da0871e2$export$e288731fd71264f0), {
                        children: displayType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$cd9ef921569d6bdf), {
                            issueType: displayType,
                            className: "py-0.5 text-xs"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-daw-gray-500 text-xs",
                            children: "No issue type"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$4857d3f3f5f8319b), {
                        size: 12,
                        className: "opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 group-aria-expanded:opacity-100 text-daw-gray-500 shrink-0 transition-opacity"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c079ee9c5fe80a9e$export$5b6b19405a83ff9d), {
                crossOffset: -30,
                className: "bg-daw-white rounded-xl shadow-card outline-none p-1 min-w-44",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$41f133550aa26f48), {
                    className: "outline-none flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                            id: "none",
                            textValue: "No issue type",
                            className: $376a85c6166d1b77$var$listBoxItemClass,
                            children: ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-3 shrink-0 text-daw-gray-700",
                                            children: isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7dd004358974b05d), {
                                                size: 12
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-daw-gray-500 py-0.5",
                                            children: "No issue type"
                                        })
                                    ]
                                })
                        }),
                        availableTypes.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                                id: t.id,
                                textValue: t.name,
                                className: $376a85c6166d1b77$var$listBoxItemClass,
                                children: ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-3 shrink-0 text-daw-gray-700",
                                                children: isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7dd004358974b05d), {
                                                    size: 12
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$cd9ef921569d6bdf), {
                                                issueType: t,
                                                className: "py-0.5 text-xs"
                                            })
                                        ]
                                    })
                            }, t.id))
                    ]
                })
            })
        ]
    });
}
function $376a85c6166d1b77$var$LabelsSelect({ data: data }) {
    let availableLabels = data.repository?.labels?.nodes ?? [];
    let [labels, setLabels] = (0, $acw62.useState)(data.labels.nodes);
    let [isDirty, setIsDirty] = (0, $acw62.useState)(false);
    let displayLabels = labels.sort((a, b)=>a.name.localeCompare(b.name));
    let selected = data.labels.nodes.map((l)=>l.id).sort();
    let [lastLabels, setLastLabels] = (0, $acw62.useState)(selected);
    if (lastLabels.length !== selected.length || lastLabels.some((s, i)=>s !== selected[i])) {
        setLastLabels(selected);
        setLabels(data.labels.nodes);
    }
    async function handleOpenChange(open) {
        if (!open && isDirty) {
            setIsDirty(false);
            await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation UpdateIssueLabels($id: ID!, $labelIds: [ID!]!) {
          updateIssue(input: {id: $id, labelIds: $labelIds}) { issue { id } }
        }`, {
                id: data.id,
                labelIds: displayLabels.map((s)=>s.id)
            });
            await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
                $376a85c6166d1b77$export$8f76aa81e935a507.query(),
                {
                    owner: data.repository.owner.login,
                    repo: data.repository.name,
                    number: data.number
                }
            ]);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $234aa604da0871e2$export$ef9b1a59e592288f), {
        selectionMode: "multiple",
        value: displayLabels.map((s)=>s.id),
        onChange: (keys)=>{
            setLabels(keys.map((key)=>data.labels.nodes.find((l)=>l.id === key) || availableLabels.find((l)=>l.id === key)));
            setIsDirty(true);
        },
        onOpenChange: handleOpenChange,
        "aria-label": "Labels",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                className: "group flex items-center gap-1 w-fit cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded-full -mx-0.5 px-0.5 text-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $234aa604da0871e2$export$e288731fd71264f0), {
                        className: "flex flex-wrap gap-1 min-w-0",
                        children: displayLabels.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-daw-gray-500 text-xs",
                            children: "None yet"
                        }) : displayLabels.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$346ada88e5d95317), {
                                color: l.color,
                                children: l.name
                            }, l.id))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$4857d3f3f5f8319b), {
                        size: 12,
                        className: "opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 group-aria-expanded:opacity-100 text-daw-gray-500 shrink-0 transition-opacity mt-0.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c079ee9c5fe80a9e$export$5b6b19405a83ff9d), {
                crossOffset: -30,
                className: "bg-daw-white rounded-xl shadow-card outline-none min-w-44 flex flex-col",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $80b3f40af2eadde4$export$2f2b9559550c7bbc), {
                    filter: (0, $7c3a1fdaf0c6ad5f$export$3274cf84b703fff)({
                        sensitivity: 'base'
                    }).contains,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3de6a7daf03a057f$export$b94867ecbd698f21), {
                            autoFocus: true,
                            "aria-label": "Search",
                            className: "min-w-0 m-1",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-1 rounded-lg px-2 py-1 focus-within:ring-2 ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$82eafebb825fc23f), {
                                        size: 14,
                                        className: "text-daw-gray-500 shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f86a0ac31b8d349c$export$f5b8910cec6cf069), {
                                        className: "flex-1 text-sm outline-none bg-transparent min-w-0 placeholder:text-daw-gray-400",
                                        placeholder: "Search..."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$41f133550aa26f48), {
                            className: "outline-none flex-1 flex flex-col rounded-xl p-1 scroll-p-1 overflow-y-auto",
                            children: availableLabels.sort((a, b)=>a.name.localeCompare(b.name)).map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                                    id: l.id,
                                    textValue: l.name,
                                    className: $376a85c6166d1b77$var$listBoxItemClass,
                                    children: ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center gap-2 w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-3 shrink-0 text-daw-gray-700",
                                                    children: isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7dd004358974b05d), {
                                                        size: 12
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$346ada88e5d95317), {
                                                    color: l.color,
                                                    children: l.name
                                                })
                                            ]
                                        })
                                }, l.id))
                        })
                    ]
                })
            })
        ]
    });
}







var $acw62 = parcelRequire("acw62");




async function $5379651f9cfa2f72$var$fetchCommit([, owner, repo, sha]) {
    const res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).repos.getCommit({
        owner: owner,
        repo: repo,
        ref: sha
    });
    return res.data;
}
async function $5379651f9cfa2f72$var$fetchCommitDiff([, owner, repo, sha]) {
    const res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).request('GET /repos/{owner}/{repo}/commits/{ref}', {
        owner: owner,
        repo: repo,
        ref: sha,
        headers: {
            accept: 'application/vnd.github.diff'
        }
    });
    return res.data;
}
function $5379651f9cfa2f72$export$fb998822db15ddc({ owner: owner, repo: repo, sha: sha }) {
    let { data: commit } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'commit',
        owner,
        repo,
        sha
    ], $5379651f9cfa2f72$var$fetchCommit);
    let { data: patch } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'commit-diff',
        owner,
        repo,
        sha
    ], $5379651f9cfa2f72$var$fetchCommitDiff);
    if (!commit) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col h-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5379651f9cfa2f72$var$CommitHeader, {
                commit: commit,
                owner: owner,
                repo: repo
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 min-h-0",
                children: patch ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea48220a143b30f5$export$b03e7cabf0eb0daa), {
                    patch: patch
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-sm text-daw-gray-500 py-4 max-w-3xl mx-auto w-full",
                    children: "Loading diff\u2026"
                })
            })
        ]
    });
}
$5379651f9cfa2f72$export$fb998822db15ddc.preload = (owner, repo, sha)=>{
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'commit',
        owner,
        repo,
        sha
    ], $5379651f9cfa2f72$var$fetchCommit);
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'commit-diff',
        owner,
        repo,
        sha
    ], $5379651f9cfa2f72$var$fetchCommitDiff);
};
function $5379651f9cfa2f72$var$CommitHeader({ commit: commit, owner: owner, repo: repo }) {
    let df = (0, $c5bcadf5f58d658e$export$85fd5fdf27bacc79)({
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    });
    let [title, ...bodyLines] = commit.commit.message.split('\n');
    let body = bodyLines.join('\n').trim();
    let date = commit.commit.author?.date;
    let authorName = commit.author?.login ?? commit.commit.author?.name ?? 'Unknown';
    let avatarUrl = commit.author?.avatar_url ?? '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 my-2 mx-4 shrink-0 bg-daw-white rounded-xl p-4 shadow-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                        src: avatarUrl
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-daw-gray-700",
                        children: [
                            owner,
                            "/",
                            repo
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                        target: "_blank",
                        href: commit.html_url,
                        className: "font-mono text-xs text-daw-gray-500 hover:underline",
                        children: commit.sha.slice(0, 7)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-xl font-semibold",
                children: title
            }),
            body && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5379651f9cfa2f72$var$CommitBody, {
                body: body
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2 text-sm text-daw-gray-600",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                        src: avatarUrl,
                        size: "s"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: authorName
                    }),
                    date && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: df.format(new Date(date))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "\xb7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-daw-gray-500 font-medium",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-red-500",
                                children: [
                                    "-",
                                    commit.stats?.deletions
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "ml-1 text-green-600",
                                children: [
                                    "+",
                                    commit.stats?.additions
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $5379651f9cfa2f72$var$CommitBody({ body: body }) {
    let [expanded, setExpanded] = (0, $acw62.useState)(false);
    let lines = body.split('\n');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex ${expanded ? 'flex-col items-start' : 'items-baseline'} gap-0.5`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                className: `text-sm text-daw-gray-600 whitespace-pre-wrap font-sans`,
                children: expanded ? body : lines[0]
            }),
            lines.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                onPress: ()=>setExpanded((e)=>!e),
                className: "text-xs text-daw-gray-400 hover:text-daw-gray-600 cursor-default outline-none focus-visible:ring-1 ring-blue-600 rounded px-0.5 -mt-0.5",
                children: expanded ? 'Less' : "\xb7\xb7\xb7"
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


// GitHub's GraphQL API returns emoji as shortcodes rather than Unicode (for
// example DiscussionCategory.emoji returns ":bulb:"), so we render them for
// display. GitHub's emoji REST API (https://api.github.com/emojis) maps each
// shortcode to an image URL; standard emoji encode their Unicode codepoint(s)
// in the path, e.g. .../unicode/1f64f.png, which we turn back into the actual
// emoji character. Custom GitHub emoji (e.g. :shipit:) have no Unicode form, so
// we render the image URL that GitHub provides.
const $36781a27136fc942$var$UNICODE_RE = /\/unicode\/([0-9a-f-]+)\.png/i;
async function $36781a27136fc942$var$fetchEmojis() {
    const { data: data } = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).emojis.get();
    const map = {};
    for (const [name, url] of Object.entries(data)){
        const match = url.match($36781a27136fc942$var$UNICODE_RE);
        if (match) map[name] = {
            kind: "unicode",
            value: match[1].split("-").map((cp)=>String.fromCodePoint(parseInt(cp, 16))).join("")
        };
        else map[name] = {
            kind: "image",
            url: url
        };
    }
    return map;
}
const $36781a27136fc942$var$SHORTCODE_RE = /:([a-z0-9_+-]+):/gi;
function $36781a27136fc942$var$renderEmoji(name, emoji, key) {
    if (emoji.kind === "unicode") return emoji.value;
    return (0, $acw62.createElement)("img", {
        key: key,
        src: emoji.url,
        alt: `:${name}:`,
        title: `:${name}:`,
        loading: "lazy",
        decoding: "async",
        className: "inline-block h-[1em] w-[1em] align-[-0.125em]"
    });
}
function $36781a27136fc942$export$fed36daf6b3f26d1() {
    const { data: map } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)("github-emojis", $36781a27136fc942$var$fetchEmojis);
    return (0, $acw62.useCallback)((text)=>{
        if (!map) return text;
        const nodes = [];
        let lastIndex = 0;
        let hasEmoji = false;
        for (const match of text.matchAll($36781a27136fc942$var$SHORTCODE_RE)){
            const [shortcode, name] = match;
            const index = match.index ?? 0;
            const emoji = map[name.toLowerCase()];
            if (!emoji) continue;
            if (index > lastIndex) nodes.push(text.slice(lastIndex, index));
            nodes.push($36781a27136fc942$var$renderEmoji(name, emoji, `${name}-${index}`));
            lastIndex = index + shortcode.length;
            hasEmoji = true;
        }
        if (!hasEmoji) return text;
        if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
        return nodes;
    }, [
        map
    ]);
}







function $e37a2db30c2ebb15$export$6c4ed0cff880690c({ owner: owner, repo: repo, number: number }) {
    let { data: res } = (0, $9efcf42537b67d79$export$dd0a697e1782aedd)($e37a2db30c2ebb15$export$6c4ed0cff880690c.query(), {
        owner: owner,
        repo: repo,
        number: number
    });
    let data = res?.repository.discussion;
    if (!data) return null;
    async function addComment(body, replyToId) {
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`
      mutation AddDiscussionComment($input: AddDiscussionCommentInput!) {
        addDiscussionComment(input: $input) { comment { id } }
      }
    `, {
            input: {
                discussionId: data.id,
                body: body,
                ...replyToId ? {
                    replyToId: replyToId
                } : {}
            }
        });
        (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $e37a2db30c2ebb15$export$6c4ed0cff880690c.query(),
            {
                owner: owner,
                repo: repo,
                number: number
            }
        ]);
    }
    async function deleteComment(id) {
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation DeleteDiscussionComment($id: ID!) { deleteDiscussionComment(input: {id: $id}) { clientMutationId } }`, {
            id: id
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $e37a2db30c2ebb15$export$6c4ed0cff880690c.query(),
            {
                owner: owner,
                repo: repo,
                number: number
            }
        ]);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$1f5b733bf3f0b704).Provider, {
        value: {
            owner: owner,
            repo: repo
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4 my-4 w-full max-w-3xl mx-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e37a2db30c2ebb15$var$DiscussionHeader, {
                    data: data
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$bc479ee64936fcb7), {
                    data: data
                }),
                data.comments.nodes?.map((comment)=>comment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e37a2db30c2ebb15$var$DiscussionCommentItem, {
                        comment: comment,
                        onDelete: deleteComment,
                        onReply: addComment
                    }, comment.id)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb50f473036ab352$export$dade19d95388b828), {
                    onSubmit: addComment,
                    children: null
                })
            ]
        })
    });
}
$e37a2db30c2ebb15$export$6c4ed0cff880690c.query = ()=>`
query Discussion($owner: String!, $repo: String!, $number: Int!) {
  repository(owner: $owner, name: $repo) {
    discussion(number: $number) {
      __typename
      id
      number
      url
      title
      body
      createdAt
      closed
      category { name emoji }
      author { ...ActorFragment }
      reactionGroups { ...ReactionFragment }
      repository {
        name
        owner { login avatarUrl }
      }
      comments(first: 100) {
        nodes {
          __typename id body createdAt isAnswer viewerCanDelete
          author { ...ActorFragment }
          reactionGroups { ...ReactionFragment }
          replies(first: 20) {
            nodes {
              __typename id body createdAt viewerCanDelete
              author { ...ActorFragment }
              reactionGroups { ...ReactionFragment }
            }
          }
        }
      }
    }
  }
}

${(0, $d560ed2d957d30cf$export$1f44aaf2ec115b54).fragment}
${(0, $739e3e11d093b75a$export$44cd1c46d5ca2376).fragment}
`;
function $e37a2db30c2ebb15$var$DiscussionHeader({ data: data }) {
    let renderGitHubEmojis = (0, $36781a27136fc942$export$fed36daf6b3f26d1)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 mb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2 flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                                src: data.repository.owner.avatarUrl
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-daw-gray-700",
                                children: [
                                    data.repository.owner.login,
                                    "/",
                                    data.repository.name,
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                                        target: "_blank",
                                        href: data.url,
                                        children: [
                                            "#",
                                            data.number
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `capitalize w-fit px-2 py-0.5 rounded border text-sm font-medium ${data.closed ? 'bg-daw-red-100 border-daw-red-200 text-daw-red-700' : 'bg-daw-green-100 border-daw-green-200 text-daw-green-700'}`,
                        children: data.closed ? 'Closed' : 'Open'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "w-fit px-2 py-0.5 rounded border text-sm font-medium bg-daw-purple-100 border-daw-purple-200 text-daw-purple-700",
                        children: [
                            renderGitHubEmojis(data.category.emoji),
                            " ",
                            data.category.name
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-2xl font-semibold",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87a23dccae47b18a$export$2e2bcd8739ae039), {
                    children: data.title
                })
            })
        ]
    });
}
function $e37a2db30c2ebb15$var$DiscussionCommentItem({ comment: comment, onDelete: onDelete, onReply: onReply }) {
    const [showReply, setShowReply] = (0, $acw62.useState)(false);
    const hasReplies = (comment.replies.nodes?.length ?? 0) > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$bc479ee64936fcb7), {
                    data: comment,
                    onDelete: ()=>onDelete(comment.id)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ml-8 flex flex-col gap-2 border-l-2 border-daw-gray-200 pl-4",
                children: [
                    comment.replies.nodes?.map((reply)=>reply && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$bc479ee64936fcb7), {
                            data: reply,
                            onDelete: ()=>onDelete(reply.id)
                        }, reply.id)),
                    showReply && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb50f473036ab352$export$dade19d95388b828), {
                        autoFocus: true,
                        onSubmit: async (body)=>{
                            await onReply(body, comment.id);
                            setShowReply(false);
                        },
                        onCancel: ()=>setShowReply(false)
                    }),
                    !showReply && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        onPress: ()=>setShowReply(true),
                        className: "self-start flex items-center gap-1.5 text-xs text-daw-gray-700 hover:text-daw-gray-800 transition cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded py-0.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a3543c9c8473fb3d), {}),
                            "Reply"
                        ]
                    })
                ]
            })
        ]
    });
}


const $50c3c6889737e436$var$SlideOverContext = /*#__PURE__*/ (0, $acw62.createContext)({
    open: ()=>{},
    close: ()=>{}
});
function $50c3c6889737e436$export$83de82a58dfb4ba0() {
    return (0, $acw62.useContext)($50c3c6889737e436$var$SlideOverContext);
}
const $50c3c6889737e436$export$1f5b733bf3f0b704 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $50c3c6889737e436$export$b01e713f6ca1a150(url) {
    try {
        const parsed = new URL(url);
        if (parsed.hostname !== 'github.com') return null;
        const parts = parsed.pathname.split('/').filter(Boolean);
        if (parts.length < 4) return null;
        const [owner, repo, type, id] = parts;
        if (type === 'issues') {
            const number = parseInt(id, 10);
            if (!isNaN(number)) return {
                type: 'issue',
                owner: owner,
                repo: repo,
                number: number
            };
        } else if (type === 'pull') {
            const number = parseInt(id, 10);
            if (!isNaN(number)) return {
                type: 'pr',
                owner: owner,
                repo: repo,
                number: number
            };
        } else if (type === 'commit') return {
            type: 'commit',
            owner: owner,
            repo: repo,
            sha: id
        };
        else if (type === 'discussions') {
            const number = parseInt(id, 10);
            if (!isNaN(number)) return {
                type: 'discussion',
                owner: owner,
                repo: repo,
                number: number
            };
        }
        return null;
    } catch  {
        return null;
    }
}
const $50c3c6889737e436$var$CLOSED = {
    history: [],
    index: -1
};
function $50c3c6889737e436$var$updateHistory(state, scrollRef) {
    let newHistory = state.history.slice();
    if (state.history[state.index]) newHistory[state.index] = {
        content: state.history[state.index].content,
        scrollPosition: scrollRef.current?.scrollTop ?? 0
    };
    return newHistory;
}
function $50c3c6889737e436$export$6fa1c918a237be3f({ children: children }) {
    const [{ history: history, index: index }, setState] = (0, $acw62.useState)($50c3c6889737e436$var$CLOSED);
    const scrollRef = (0, $acw62.useRef)(null);
    const open = (0, $acw62.useCallback)((c)=>{
        setState((s)=>({
                history: [
                    ...$50c3c6889737e436$var$updateHistory(s, scrollRef).slice(0, s.index + 1),
                    {
                        content: c,
                        scrollPosition: 0
                    }
                ],
                index: s.index + 1
            }));
    }, []);
    const close = (0, $acw62.useCallback)(()=>{
        setState($50c3c6889737e436$var$CLOSED);
    }, []);
    const back = (0, $acw62.useCallback)(()=>setState((s)=>({
                history: $50c3c6889737e436$var$updateHistory(s, scrollRef),
                index: s.index - 1
            })), []);
    const forward = (0, $acw62.useCallback)(()=>setState((s)=>({
                history: $50c3c6889737e436$var$updateHistory(s, scrollRef),
                index: s.index + 1
            })), []);
    const content = history[index] ?? null;
    const canGoBack = index > 0;
    const canGoForward = index < history.length - 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($50c3c6889737e436$var$SlideOverContext.Provider, {
        value: {
            open: open,
            close: close
        },
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50c3c6889737e436$var$Panel, {
                content: content,
                index: index,
                scrollRef: scrollRef,
                onClose: close,
                onBack: back,
                onForward: forward,
                canGoBack: canGoBack,
                canGoForward: canGoForward
            })
        ]
    });
}
function $50c3c6889737e436$var$Panel({ content: content, index: index, scrollRef: scrollRef, onClose: onClose, onBack: onBack, onForward: onForward, canGoBack: canGoBack, canGoForward: canGoForward }) {
    const isOpen = content !== null;
    const navBtnClass = "p-1.5 rounded-md hover:bg-daw-gray-100 pressed:bg-daw-gray-200 cursor-default outline-none focus-visible:ring-2 ring-blue-600 disabled:opacity-40";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `fixed top-0 right-0 h-full w-3/5 bg-daw-gray-50 border-l border-daw-gray-200 shadow-2xl z-50 flex flex-col transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full pointer-events-none'}`,
        inert: !isOpen || undefined,
        role: "dialog",
        "aria-modal": "false",
        children: content && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c60d71a4f66bda5$export$20e40289641fbbb6), {
            autoFocus: true,
            restoreFocus: true,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between p-2 shrink-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center gap-0.5",
                            children: (canGoBack || canGoForward) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                        onPress: onBack,
                                        isDisabled: !canGoBack,
                                        "aria-label": "Back",
                                        className: navBtnClass,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$8afed21ef5c2afa5), {
                                            size: 16
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                        onPress: onForward,
                                        isDisabled: !canGoForward,
                                        "aria-label": "Forward",
                                        className: navBtnClass,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$9ca09caa9c849d9c), {
                                            size: 16
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                            onPress: onClose,
                            "aria-label": "Close",
                            className: navBtnClass,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {
                                size: 16
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50c3c6889737e436$var$ScrollPane, {
                    ref: scrollRef,
                    scrollPosition: content.scrollPosition,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50c3c6889737e436$var$PageContent, {
                        content: content.content
                    })
                }, index)
            ]
        })
    });
}
function $50c3c6889737e436$var$ScrollPane({ ref: ref, scrollPosition: scrollPosition, children: children }) {
    (0, $acw62.useLayoutEffect)(()=>{
        const el = ref.current;
        el.scrollTop = scrollPosition ?? 0;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: "flex-1 min-h-0 overflow-y-auto flex flex-col",
        children: children
    });
}
function $50c3c6889737e436$var$PageContent({ content: content }) {
    switch(content.type){
        case 'issue':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $376a85c6166d1b77$export$8f76aa81e935a507), {
                owner: content.owner,
                repo: content.repo,
                number: content.number
            });
        case 'pr':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92995ef58fa84f45$export$d8ee8bed60538a6a), {
                owner: content.owner,
                repo: content.repo,
                number: content.number
            });
        case 'commit':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5379651f9cfa2f72$export$fb998822db15ddc), {
                owner: content.owner,
                repo: content.repo,
                sha: content.sha
            });
        case 'discussion':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e37a2db30c2ebb15$export$6c4ed0cff880690c), {
                owner: content.owner,
                repo: content.repo,
                number: content.number
            });
    }
}
function $50c3c6889737e436$var$preloadContent(content) {
    switch(content.type){
        case 'issue':
            (0, $376a85c6166d1b77$export$8f76aa81e935a507).preload(content.owner, content.repo, content.number);
            break;
        case 'pr':
            (0, $92995ef58fa84f45$export$d8ee8bed60538a6a).preload(content.owner, content.repo, content.number);
            break;
        case 'commit':
            (0, $5379651f9cfa2f72$export$fb998822db15ddc).preload(content.owner, content.repo, content.sha);
            break;
    }
}
// Formats an issue/PR/discussion/commit URL as a short reference, e.g. "#123", "owner/repo#123", or "abc1234".
function $50c3c6889737e436$var$formatGitHubReference(href, content, currentRepo) {
    const url = new URL(href);
    if (url.pathname.split('/').filter(Boolean).length !== 4 || url.search) return null;
    const isCurrentRepo = currentRepo && content.owner.toLowerCase() === currentRepo.owner.toLowerCase() && content.repo.toLowerCase() === currentRepo.repo.toLowerCase();
    if (content.type === 'commit') {
        if (!/^[0-9a-f]{40}$/.test(content.sha)) return null;
        const sha = content.sha.slice(0, 7);
        return isCurrentRepo ? sha : `${content.owner}/${content.repo}@${sha}`;
    }
    let suffix = '';
    if (/^#(issuecomment|discussioncomment)-/.test(url.hash)) suffix = ' (comment)';
    else if (/^#pullrequestreview-/.test(url.hash)) suffix = ' (review)';
    const prefix = isCurrentRepo ? '' : `${content.owner}/${content.repo}`;
    return `${prefix}#${content.number}${suffix}`;
}
function $50c3c6889737e436$export$d308b62a6a8ceaca({ href: href, children: children, className: className, ...props }) {
    const { open: open } = $50c3c6889737e436$export$83de82a58dfb4ba0();
    const currentRepo = (0, $acw62.useContext)($50c3c6889737e436$export$1f5b733bf3f0b704);
    const content = href ? $50c3c6889737e436$export$b01e713f6ca1a150(href) : null;
    // Autolinked bare URLs (link text is the URL itself) render as short references.
    const text = Array.isArray(children) && children.length === 1 ? children[0] : children;
    if (href && content && typeof text === 'string' && text === href) children = $50c3c6889737e436$var$formatGitHubReference(href, content, currentRepo) ?? children;
    if (content) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
        onHoverStart: ()=>$50c3c6889737e436$var$preloadContent(content),
        onPress: ()=>open(content),
        className: `${className || ''} cursor-pointer`,
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
        target: "_blank",
        ...props,
        className: className,
        href: href,
        children: children
    });
}





var $acw62 = parcelRequire("acw62");



const $99083c852f5d697e$var$MAX_LINES = 200;
const $99083c852f5d697e$var$FRAGMENT_REGEX = /^L(\d+)(?:C\d+)?(?:-L(\d+)(?:C\d+)?)?$/;
function $99083c852f5d697e$export$3b660ce959b99beb(url) {
    try {
        let parsed = new URL(url);
        if (parsed.hostname !== 'github.com') return null;
        let match = $99083c852f5d697e$var$FRAGMENT_REGEX.exec(parsed.hash.slice(1));
        if (!match) return null;
        let [owner, repo, type, sha, ...pathParts] = parsed.pathname.split('/').filter(Boolean);
        if (type !== 'blob' || !sha || !/^[0-9a-f]{40}$/i.test(sha) || pathParts.length === 0) return null;
        let path = pathParts.map(decodeURIComponent).join('/');
        let start = parseInt(match[1], 10);
        let end = match[2] ? parseInt(match[2], 10) : start;
        if (start < 1) return null;
        if (end < start) [start, end] = [
            end,
            start
        ];
        return {
            owner: owner,
            repo: repo,
            sha: sha,
            path: path,
            start: start,
            end: end,
            url: url
        };
    } catch  {
        return null;
    }
}
// Returns a CodeReference if the given element is a bare autolinked permalink
// (like github.com, [text](url) links stay links).
function $99083c852f5d697e$var$getLinkReference(child) {
    if (!/*#__PURE__*/ (0, $acw62.isValidElement)(child)) return null;
    let { href: href, children: linkChildren } = child.props;
    if (typeof href !== 'string') return null;
    let text = Array.isArray(linkChildren) && linkChildren.length === 1 ? linkChildren[0] : linkChildren;
    if (text !== href) return null;
    return $99083c852f5d697e$export$3b660ce959b99beb(href);
}
function $99083c852f5d697e$export$1bbaa4741b975b90(children) {
    let array = Array.isArray(children) ? children : [
        children
    ];
    let found = false;
    let result = array.map((child, i)=>{
        let reference = $99083c852f5d697e$var$getLinkReference(child);
        if (reference) {
            found = true;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99083c852f5d697e$export$353f0589a86a4168, {
                reference: reference
            }, i);
        }
        return child;
    });
    return found ? result : null;
}
const $99083c852f5d697e$var$blobQuery = `
query CodeReferenceBlob($owner: String!, $name: String!, $expression: String!) {
  repository(owner: $owner, name: $name) {
    object(expression: $expression) {
      ... on Blob {
        text
        isBinary
      }
    }
  }
}
`;
function $99083c852f5d697e$export$353f0589a86a4168({ reference: reference }) {
    let { owner: owner, repo: repo, sha: sha, path: path, url: url, start: start } = reference;
    let { data: data, error: error } = (0, $9efcf42537b67d79$export$dd0a697e1782aedd)($99083c852f5d697e$var$blobQuery, {
        owner: owner,
        name: repo,
        expression: `${sha}:${path}`
    });
    let blob = data?.repository?.object;
    let lineCount = (0, $acw62.useMemo)(()=>{
        if (blob?.text == null) return null;
        let count = blob.text.split('\n').length;
        return blob.text.endsWith('\n') ? count - 1 : count;
    }, [
        blob
    ]);
    let failed = error != null || data != null && (blob?.text == null || blob.isBinary) || lineCount != null && start > lineCount;
    if (failed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "my-2",
        style: {
            wordBreak: 'break-word'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
            href: url,
            className: "underline",
            children: url
        })
    });
    let end = Math.min(reference.end, start + $99083c852f5d697e$var$MAX_LINES - 1, lineCount ?? Infinity);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "code-reference my-2 border border-daw-gray-200 rounded-xl overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "px-3 py-2 text-xs flex flex-col gap-0.5 border-b border-daw-gray-200 bg-daw-gray-50",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                        href: url,
                        target: "_blank",
                        className: "font-semibold text-daw-blue-800 hover:underline w-fit [word-break:break-all]",
                        children: [
                            repo,
                            "/",
                            path
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-daw-gray-600",
                        children: [
                            start === end ? `Line ${start}` : `Lines ${start} to ${end}`,
                            " in",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                                href: `https://github.com/${owner}/${repo}/commit/${sha}`,
                                className: "font-mono underline",
                                children: sha.slice(0, 7)
                            })
                        ]
                    })
                ]
            }),
            blob?.text != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "max-h-96 overflow-y-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99083c852f5d697e$var$Snippet, {
                    path: path,
                    contents: blob.text,
                    start: start,
                    end: end
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "animate-pulse bg-daw-gray-100",
                style: {
                    height: Math.min(end - start + 1, 19) * 20 + 16
                }
            })
        ]
    });
}
const $99083c852f5d697e$var$SNIPPET_OPTIONS = {
    theme: {
        dark: 'pierre-dark',
        light: 'pierre-light'
    },
    themeType: 'system',
    disableFileHeader: true
};
// Renders a window of the full file so the gutter shows the true line numbers.
// The React File wrapper doesn't expose renderRange, so this drives the
// imperative File class directly.
function $99083c852f5d697e$var$Snippet({ path: path, contents: contents, start: start, end: end }) {
    let ref = (0, $acw62.useRef)(null);
    let file = (0, $acw62.useMemo)(()=>({
            name: path,
            contents: contents
        }), [
        path,
        contents
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        let instance = new (0, $25cd466ecc388b00$export$b6afa8811b7e644e)($99083c852f5d697e$var$SNIPPET_OPTIONS);
        instance.render({
            file: file,
            containerWrapper: ref.current,
            renderRange: {
                startingLine: start - 1,
                totalLines: end - start + 1,
                bufferBefore: 0,
                bufferAfter: 0
            }
        });
        return ()=>instance.cleanUp();
    }, [
        file,
        start,
        end
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref
    });
}


function $739e3e11d093b75a$export$bc479ee64936fcb7({ data: data, onDelete: onDelete }) {
    let df = (0, $c5bcadf5f58d658e$export$85fd5fdf27bacc79)({
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    });
    let isAnswer = 'isAnswer' in data && data.isAnswer;
    let canDelete = onDelete && 'viewerCanDelete' in data && data.viewerCanDelete;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
        className: isAnswer ? 'outline outline-2 outline-daw-green-700' : '',
        children: [
            isAnswer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-1.5 text-xs text-daw-green-700 font-medium mb-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$f6dd727656c97851), {
                        size: 14,
                        className: "text-daw-green-600"
                    }),
                    "Marked as answer"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid gap-x-2",
                style: {
                    gridTemplateAreas: `
            "avatar    username"
            "avatar    date"
            ".         ."
            "body      body"
            ".         ."
            "reactions reactions"
          `,
                    gridTemplateRows: 'auto auto 8px auto 8px auto',
                    gridTemplateColumns: '40px 1fr'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                        size: "l",
                        className: "[grid-area:avatar]",
                        src: data.author.avatarUrl
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        style: {
                            gridArea: 'username'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium text-sm",
                                children: data.author.login
                            }),
                            canDelete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                onPress: ()=>window.confirm('Delete this comment?') && onDelete(),
                                className: "text-daw-gray-400 hover:text-daw-red-500 pressed:text-daw-red-600 cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$d23329de703dffc4), {
                                    size: 14
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xs text-daw-gray-600",
                        style: {
                            gridArea: 'date'
                        },
                        children: df.format(new Date(data.createdAt))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            gridArea: 'body'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($739e3e11d093b75a$export$286a50103f692ed6, {
                            children: data.body
                        })
                    }),
                    data.reactionGroups && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($739e3e11d093b75a$export$44cd1c46d5ca2376, {
                        id: data.id,
                        data: data.reactionGroups
                    })
                ]
            })
        ]
    });
}
$739e3e11d093b75a$export$bc479ee64936fcb7.fragment = `
fragment IssueCommentFragment on IssueComment {
  __typename
  id
  body
  createdAt
  author {
    ...ActorFragment
  }
  reactionGroups {
    ...ReactionFragment
  }
  viewerCanDelete
}
`;
const $739e3e11d093b75a$var$SUPPORTED_LANGUAGES = new Set([
    '1c',
    '1c-query',
    'abap',
    'actionscript-3',
    'ada',
    'adoc',
    'angular-html',
    'angular-ts',
    'apache',
    'apex',
    'apl',
    'applescript',
    'ara',
    'asciidoc',
    'asm',
    'astro',
    'awk',
    'ballerina',
    'bash',
    'bat',
    'batch',
    'be',
    'beancount',
    'berry',
    'bibtex',
    'bicep',
    'bird',
    'bird2',
    'blade',
    'bsl',
    'c',
    'c#',
    'c++',
    'c3',
    'cadence',
    'cairo',
    'cdc',
    'cjs',
    'clarity',
    'clj',
    'clojure',
    'closure-templates',
    'cmake',
    'cmd',
    'cobol',
    'codeowners',
    'codeql',
    'coffee',
    'coffeescript',
    'common-lisp',
    'console',
    'coq',
    'cpp',
    'cql',
    'crystal',
    'cs',
    'csharp',
    'css',
    'csv',
    'cts',
    'cue',
    'cypher',
    'd',
    'dart',
    'dax',
    'desktop',
    'diff',
    'docker',
    'dockerfile',
    'dotenv',
    'dream-maker',
    'edge',
    'elisp',
    'elixir',
    'elm',
    'emacs-lisp',
    'erb',
    'erl',
    'erlang',
    'f',
    'f#',
    'f03',
    'f08',
    'f18',
    'f77',
    'f90',
    'f95',
    'fennel',
    'fish',
    'fluent',
    'for',
    'fortran-fixed-form',
    'fortran-free-form',
    'fs',
    'fsharp',
    'fsl',
    'ftl',
    'gd',
    'gdresource',
    'gdscript',
    'gdshader',
    'genie',
    'gherkin',
    'git-commit',
    'git-rebase',
    'gjs',
    'gleam',
    'glimmer-js',
    'glimmer-ts',
    'glsl',
    'gn',
    'gnuplot',
    'go',
    'gql',
    'graphql',
    'groovy',
    'gts',
    'hack',
    'haml',
    'handlebars',
    'haskell',
    'haxe',
    'hbs',
    'hcl',
    'hjson',
    'hlsl',
    'hs',
    'html',
    'html-derivative',
    'http',
    'hurl',
    'hxml',
    'hy',
    'imba',
    'ini',
    'jade',
    'java',
    'javascript',
    'jinja',
    'jison',
    'jl',
    'js',
    'json',
    'json5',
    'jsonc',
    'jsonl',
    'jsonnet',
    'jssm',
    'jsx',
    'julia',
    'just',
    'kdl',
    'kotlin',
    'kql',
    'kt',
    'kts',
    'kusto',
    'latex',
    'lean',
    'lean4',
    'less',
    'liquid',
    'lisp',
    'lit',
    'llvm',
    'log',
    'logo',
    'lua',
    'luau',
    'make',
    'makefile',
    'markdown',
    'marko',
    'matlab',
    'mbt',
    'mbti',
    'md',
    'mdc',
    'mdx',
    'mediawiki',
    'mermaid',
    'mips',
    'mipsasm',
    'mjs',
    'mmd',
    'mojo',
    'moonbit',
    'move',
    'mts',
    'nar',
    'narrat',
    'nextflow',
    'nextflow-groovy',
    'nf',
    'nginx',
    'nim',
    'nix',
    'nu',
    'nushell',
    'objc',
    'objective-c',
    'objective-cpp',
    'ocaml',
    'odin',
    'openscad',
    'pascal',
    'perl',
    'perl6',
    'php',
    'pkl',
    'plsql',
    'po',
    'polar',
    'postcss',
    'pot',
    'potx',
    'powerquery',
    'powershell',
    'prisma',
    'prolog',
    'properties',
    'proto',
    'protobuf',
    'ps',
    'ps1',
    'pug',
    'puppet',
    'purescript',
    'py',
    'python',
    'ql',
    'qml',
    'qmldir',
    'qss',
    'r',
    'racket',
    'raku',
    'razor',
    'rb',
    'reg',
    'regex',
    'regexp',
    'rel',
    'riscv',
    'ron',
    'rosmsg',
    'rs',
    'rst',
    'ruby',
    'rust',
    'sas',
    'sass',
    'scad',
    'scala',
    'scheme',
    'scss',
    'sdbl',
    'sh',
    'shader',
    'shaderlab',
    'shell',
    'shellscript',
    'shellsession',
    'smalltalk',
    'solidity',
    'soy',
    'sparql',
    'spl',
    'splunk',
    'sql',
    'ssh-config',
    'stata',
    'styl',
    'stylus',
    'surql',
    'surrealql',
    'svelte',
    'swift',
    'system-verilog',
    'systemd',
    'talon',
    'talonscript',
    'tasl',
    'tcl',
    'templ',
    'terraform',
    'tex',
    'tf',
    'tfvars',
    'toml',
    'tres',
    'ts',
    'ts-tags',
    'tscn',
    'tsp',
    'tsv',
    'tsx',
    'turtle',
    'twig',
    'typ',
    'typescript',
    'typespec',
    'typst',
    'v',
    'vala',
    'vb',
    'verilog',
    'vhdl',
    'vim',
    'viml',
    'vimscript',
    'vue',
    'vue-html',
    'vue-vine',
    'vy',
    'vyper',
    'wasm',
    'wenyan',
    'wgsl',
    'wiki',
    'wikitext',
    'wit',
    'wl',
    'wolfram',
    'xml',
    'xsl',
    'yaml',
    'yml',
    'zenscript',
    'zig',
    'zsh',
    "\u6587\u8A00"
]);
function $739e3e11d093b75a$export$286a50103f692ed6({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87a23dccae47b18a$export$2e2bcd8739ae039), {
        className: "[word-break:break-word]",
        options: {
            disableParsingRawHTML: true,
            // Always wrap in block elements so single-paragraph comments go through
            // the p override below.
            forceBlock: true,
            overrides: {
                img: {
                    props: {
                        style: {
                            maxWidth: '100%'
                        }
                    }
                },
                pre: {
                    component: (props)=>{
                        let child = props.children;
                        let lang = child?.props?.className?.match(/lang-([^\s]+)/);
                        if (lang && typeof child.props.children === 'string' && $739e3e11d093b75a$var$SUPPORTED_LANGUAGES.has(lang[1])) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75aaf218ff21c0fd$export$b6afa8811b7e644e), {
                            file: {
                                name: '',
                                lang: lang[1],
                                contents: child.props.children
                            },
                            options: {
                                theme: {
                                    dark: 'pierre-dark',
                                    light: 'pierre-light'
                                },
                                themeType: 'system',
                                disableFileHeader: true,
                                disableLineNumbers: true
                            },
                            className: "my-2"
                        });
                        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                            ...props,
                            className: "border border-daw-gray-200 rounded p-2 bg-daw-gray-50 text-xs my-2 overflow-auto"
                        });
                    }
                },
                h1: {
                    props: {
                        className: 'text-2xl font-semibold my-3 pb-1 border-b-2 border-daw-gray-200'
                    }
                },
                h2: {
                    props: {
                        className: 'text-xl font-semibold my-3'
                    }
                },
                h3: {
                    props: {
                        className: 'text-lg font-semibold my-3'
                    }
                },
                a: {
                    component: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                            ...props,
                            className: "underline",
                            children: props.children
                        })
                },
                p: {
                    component: (props)=>{
                        // Bare permalinks render as code snippets, like github.com.
                        // A div is used instead of a p since the snippets are blocks.
                        let replaced = (0, $99083c852f5d697e$export$1bbaa4741b975b90)(props.children);
                        if (replaced) return replaced.length === 1 ? replaced[0] : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            ...props,
                            children: replaced
                        });
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            ...props
                        });
                    },
                    props: {
                        className: 'my-2',
                        style: {
                            wordBreak: 'break-word'
                        }
                    }
                },
                ul: {
                    props: {
                        className: 'list-disc pl-4'
                    }
                },
                ol: {
                    props: {
                        className: 'list-decimal pl-4'
                    }
                },
                li: {
                    component: (props)=>{
                        let replaced = (0, $99083c852f5d697e$export$1bbaa4741b975b90)(props.children);
                        return replaced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            ...props,
                            children: replaced
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            ...props
                        });
                    },
                    props: {
                        className: 'my-1'
                    }
                },
                blockquote: {
                    props: {
                        className: 'border-l border-l-2 border-daw-gray-300 pl-2'
                    }
                }
            }
        },
        children: children
    });
}
const $739e3e11d093b75a$export$fefa818b32f677cd = {
    THUMBS_UP: "\uD83D\uDC4D",
    THUMBS_DOWN: "\uD83D\uDC4E",
    CONFUSED: "\uD83D\uDE15",
    EYES: "\uD83D\uDC40",
    HEART: "\u2764\uFE0F",
    HOORAY: "\uD83C\uDF89",
    LAUGH: "\uD83D\uDE04",
    ROCKET: "\uD83D\uDE80"
};
const $739e3e11d093b75a$var$reactionClass = "rounded-full text-sm bg-daw-gray-100 border border-daw-gray-200 hover:border-daw-gray-300 pressed:border-daw-gray-300 selected:bg-daw-blue-100 selected:border-daw-blue-200 selected:hover:border-daw-blue-300 selected:pressed:border-daw-blue-300 cursor-default flex items-center justify-center outline-none focus-visible:outline-blue-600 outline-offset-2";
function $739e3e11d093b75a$export$44cd1c46d5ca2376({ id: id, data: initialData }) {
    let [data, setData] = (0, $acw62.useState)(initialData);
    let toggleReaction = async (emoji, isSelected)=>{
        if (isSelected) {
            let data = (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`
        mutation AddReaction($input: AddReactionInput!) {
          addReaction(input: $input) {
            reactionGroups {
              ...ReactionFragment
            }
          }
        }

        ${$739e3e11d093b75a$export$44cd1c46d5ca2376.fragment}
      `, {
                input: {
                    subjectId: id,
                    content: emoji
                }
            });
            setData((await data).addReaction.reactionGroups);
        } else {
            let data = await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`
      mutation RemoveReaction($input: RemoveReactionInput!) {
        removeReaction(input: $input) {
          reactionGroups {
            ...ReactionFragment
          }
        }
      }

      ${$739e3e11d093b75a$export$44cd1c46d5ca2376.fragment}
    `, {
                input: {
                    subjectId: id,
                    content: emoji
                }
            });
            setData(data.removeReaction.reactionGroups);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-2",
        style: {
            gridArea: 'reactions'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce4897092af7eb66$export$2e1e1122cf0cba88), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        className: `${$739e3e11d093b75a$var$reactionClass} px-1.5 aspect-square`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$663870aff582477c), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c079ee9c5fe80a9e$export$5b6b19405a83ff9d), {
                        placement: "top start",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce4897092af7eb66$export$3ddf2d174ce01153), {
                            className: "border border-daw-gray-300 bg-daw-white shadow-lg flex gap-2 p-2 rounded-md outline-none",
                            children: ({ close: close })=>Object.keys($739e3e11d093b75a$export$fefa818b32f677cd).map((emoji)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1295d6fef9679e74$export$d2b052e7b4be1756), {
                                        isSelected: data.find((r)=>r.content === emoji)?.viewerHasReacted,
                                        onChange: (s)=>{
                                            toggleReaction(emoji, s);
                                            close();
                                        },
                                        className: `${$739e3e11d093b75a$var$reactionClass} px-2 py-0.5`,
                                        children: $739e3e11d093b75a$export$fefa818b32f677cd[emoji]
                                    }, emoji))
                        })
                    })
                ]
            }),
            data.filter((r)=>r.reactors.totalCount > 0).map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1295d6fef9679e74$export$d2b052e7b4be1756), {
                    isSelected: r.viewerHasReacted,
                    onChange: (s)=>toggleReaction(r.content, s),
                    className: `${$739e3e11d093b75a$var$reactionClass} px-2 py-0.5`,
                    children: [
                        $739e3e11d093b75a$export$fefa818b32f677cd[r.content],
                        " ",
                        r.reactors.totalCount
                    ]
                }, r.content))
        ]
    });
}
$739e3e11d093b75a$export$44cd1c46d5ca2376.fragment = `
fragment ReactionFragment on ReactionGroup {
  content
  viewerHasReacted
  reactors {
    totalCount
  }
}
`;





function $63f88f8247c03421$export$e6a97ba2cae5bb94({ items: items, onDeleteComment: onDeleteComment }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: items.map((item, i)=>{
            switch(item?.__typename){
                case 'IssueComment':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$bc479ee64936fcb7), {
                        data: item,
                        onDelete: onDeleteComment ? ()=>onDeleteComment(item.id) : undefined
                    }, i);
                case 'AutomaticBaseChangeSucceededEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$BaseChanged, {
                        data: item
                    }, i);
                case 'PullRequestCommit':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Committed, {
                        data: item
                    }, i);
                case 'HeadRefForcePushedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$ForcePushed, {
                        data: item
                    }, i);
                case 'PullRequestReview':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Reviewed, {
                        data: item
                    }, i);
                case 'ReviewDismissedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$ReviewDismissed, {
                        data: item
                    }, i);
                case 'RenamedTitleEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Renamed, {
                        data: item
                    }, i);
                case 'LabeledEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Labeled, {
                        data: item
                    }, i);
                case 'UnlabeledEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Unlabeled, {
                        data: item
                    }, i);
                case 'ClosedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Closed, {
                        data: item
                    }, i);
                case 'ReopenedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Reopened, {
                        data: item
                    }, i);
                case 'MergedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Merged, {
                        data: item
                    }, i);
                case 'HeadRefDeletedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$BranchDeleted, {
                        data: item
                    }, i);
                case 'CrossReferencedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CrossReferenced, {
                        data: item
                    }, i);
                case 'ReferencedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$Referenced, {
                        data: item
                    }, i);
                case 'ReviewRequestedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$ReviewRequested, {
                        data: item
                    }, i);
                case 'ConvertToDraftEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$ConvertToDraft, {
                        data: item
                    }, i);
                case 'ReadyForReviewEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$ReadyForReview, {
                        data: item
                    }, i);
                case 'CommentDeletedEvent':
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommentDeleted, {
                        data: item
                    }, i);
                case 'MentionedEvent':
                case 'SubscribedEvent':
                    return null;
                default:
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Unknown event ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                className: "break-all text-xs",
                                children: JSON.stringify(item)
                            })
                        ]
                    }, i);
            }
        })
    });
}
$63f88f8247c03421$export$e6a97ba2cae5bb94.issueFragment = ()=>`
fragment IssueTimelineFragment on PullRequestTimelineItems {
  __typename
  ...IssueCommentFragment
  ...RenamedTitleFragment
  ...LabeledEventFragment
  ...UnlabeledEventFragment
  ...ClosedEventFragment
  ...ReopenedEventFragment
  ...CrossReferencedEventFragment
  ...ReferencedEventFragment
  ...CommentDeletedEventFragment
}

${(0, $739e3e11d093b75a$export$bc479ee64936fcb7).fragment}
${$63f88f8247c03421$var$Renamed.fragment}
${$63f88f8247c03421$var$Labeled.fragment}
${$63f88f8247c03421$var$Unlabeled.fragment}
${$63f88f8247c03421$var$Closed.fragment}
${$63f88f8247c03421$var$Reopened.fragment}
${(0, $d560ed2d957d30cf$export$1f44aaf2ec115b54).fragment}
${(0, $739e3e11d093b75a$export$44cd1c46d5ca2376).fragment}
${$63f88f8247c03421$var$CrossReferenced.fragment}
${$63f88f8247c03421$var$Referenced.fragment}
${$63f88f8247c03421$var$CommentDeleted.fragment}
`;
$63f88f8247c03421$export$e6a97ba2cae5bb94.pullRequestFragment = ()=>`
fragment PullRequestTimelineFragment on PullRequestTimelineItems {
  ...IssueTimelineFragment
  ...BaseChangeEventFragment
  ...CommittedEventFragment
  ...ForcePushedEventFragment
  ...ReviewedEventFragment
  ...ReviewDismissedFragment
  ...MergedEventFragment
  ...BranchDeletedEventFragment
  ...ReviewRequestedEventFragment
  ...ConvertToDraftEventFragment
  ...ReadyForReviewEventFragment
}

${$63f88f8247c03421$export$e6a97ba2cae5bb94.issueFragment()}
${$63f88f8247c03421$var$BaseChanged.fragment}
${$63f88f8247c03421$var$Committed.fragment}
${$63f88f8247c03421$var$ForcePushed.fragment}
${$63f88f8247c03421$var$Reviewed.fragment}
${$63f88f8247c03421$var$ReviewDismissed.fragment}
${$63f88f8247c03421$var$Merged.fragment}
${$63f88f8247c03421$var$BranchDeleted.fragment}
${$63f88f8247c03421$export$ae751d0ac236b725.fragment}
${$63f88f8247c03421$var$ReviewRequested.fragment}
${$63f88f8247c03421$var$ConvertToDraft.fragment}
${$63f88f8247c03421$var$ReadyForReview.fragment}
`;
function $63f88f8247c03421$var$Labeled({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$80beb1cb95701424), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " added the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$346ada88e5d95317), {
                        color: data.label.color,
                        children: data.label.name
                    }),
                    " label"
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Labeled.fragment = `
fragment LabeledEventFragment on LabeledEvent {
  id
  actor {
    ...ActorFragment
  }
  label {
    name
    color
  }
}
`;
function $63f88f8247c03421$var$Unlabeled({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$80beb1cb95701424), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " removed the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$346ada88e5d95317), {
                        color: data.label.color,
                        children: data.label.name
                    }),
                    " label"
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Unlabeled.fragment = `
fragment UnlabeledEventFragment on UnlabeledEvent {
  id
  actor {
    ...ActorFragment
  }
  label {
    name
    color
  }
}
`;
function $63f88f8247c03421$var$Closed({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            data.stateReason === "NOT_PLANNED" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7d3458263f963d3), {})
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-purple-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$6738f79126c9668), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " closed this as ",
                    data.stateReason?.toLowerCase()
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Closed.fragment = `
fragment ClosedEventFragment on ClosedEvent {
  id
  actor {
    ...ActorFragment
  }
  stateReason
}
`;
function $63f88f8247c03421$var$Reopened({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-green-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5daf76ad79f58bb6), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " reopened this"
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Reopened.fragment = `
fragment ReopenedEventFragment on ReopenedEvent {
  id
  actor {
    ...ActorFragment
  }
}
`;
function $63f88f8247c03421$var$Merged({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-purple-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$578402671e214a82), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " merged commit ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommitLink, {
                        commit: data.commit
                    }),
                    " into ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                        children: data.mergeRefName
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Merged.fragment = `
fragment MergedEventFragment on MergedEvent {
  id
  actor {
    ...ActorFragment
  }
  commit {
    url
    abbreviatedOid
  }
  mergeRefName
}
`;
function $63f88f8247c03421$var$CommitLink({ commit: commit }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
        href: commit.url,
        className: "text-xs hover:underline",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
            children: commit.abbreviatedOid
        })
    });
}
function $63f88f8247c03421$var$BranchDeleted({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$c812d10d519e0edb), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " deleted the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                        children: data.headRefName
                    }),
                    " branch"
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$BranchDeleted.fragment = `
fragment BranchDeletedEventFragment on HeadRefDeletedEvent {
  id
  actor {
    ...ActorFragment
  }
  headRefName
}
`;
function $63f88f8247c03421$var$Renamed({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$d2c72b688139a728), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " changed the title from ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("del", {
                        children: data.previousTitle
                    }),
                    " to ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ins", {
                        children: data.currentTitle
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Renamed.fragment = `
fragment RenamedTitleFragment on RenamedTitleEvent {
  id
  actor {
    ...ActorFragment
  }
  previousTitle
  currentTitle
}
`;
function $63f88f8247c03421$var$Reviewed({ data: data }) {
    let pr = (0, $acw62.useContext)((0, $92995ef58fa84f45$export$f4ab24e4adfba615));
    let threadsById = new Map();
    for (let thread of pr?.reviewThreads.nodes)threadsById.set(thread?.comments.nodes?.[0]?.id, thread);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid items-center gap-2",
        style: {
            gridTemplateAreas: `
          "icon description"
          ".    issue"
        `,
            gridTemplateColumns: 'min-content 1fr'
        },
        children: [
            data.state === 'CHANGES_REQUESTED' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-red-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5026ec832c277e74), {})
            }) : data.state === 'APPROVED' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-green-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$f6dd727656c97851), {})
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$4b2c798a70974642), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    gridArea: 'description'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.author
                    }),
                    "  ",
                    data.state === 'CHANGES_REQUESTED' ? 'requested changes' : data.state === 'APPROVED' ? 'approved' : 'reviewed'
                ]
            }),
            (data.body || !!data.comments?.nodes?.length) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    gridArea: 'issue'
                },
                className: "flex flex-col gap-2",
                children: [
                    data.body && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$286a50103f692ed6), {
                            children: data.body
                        })
                    }),
                    data.comments.nodes?.map((comment)=>{
                        let thread = threadsById.get(comment?.id);
                        if (thread) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$export$ae751d0ac236b725, {
                            data: thread
                        }, thread.id);
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Reviewed.fragment = `
fragment ReviewedEventFragment on PullRequestReview {
  id
  author {
    ...ActorFragment
  }
  body
  createdAt
  reactionGroups {
    ...ReactionFragment
  }
  state
  comments(first:100) {
    nodes {
      id
    }
  }
}
`;
function $63f88f8247c03421$export$ae751d0ac236b725({ data: data }) {
    let df = (0, $c5bcadf5f58d658e$export$85fd5fdf27bacc79)({
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    });
    let pr = (0, $acw62.useContext)((0, $92995ef58fa84f45$export$f4ab24e4adfba615));
    async function resolveThread() {
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`
      mutation ResolveReviewThread($threadId: ID!) {
        resolveReviewThread(input: {threadId: $threadId}) {
          thread { id isResolved }
        }
      }
    `, {
            threadId: data.id
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            (0, $92995ef58fa84f45$export$d8ee8bed60538a6a).query(),
            {
                owner: pr.repository.owner.login,
                repo: pr.repository.name,
                number: pr.number
            }
        ]);
    }
    async function deleteReviewComment(id) {
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`
      mutation DeletePullRequestReviewComment($id: ID!) {
        deletePullRequestReviewComment(input: {id: $id}) { clientMutationId }
      }
    `, {
            id: id
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            (0, $92995ef58fa84f45$export$d8ee8bed60538a6a).query(),
            {
                owner: pr.repository.owner.login,
                repo: pr.repository.name,
                number: pr.number
            }
        ]);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
            open: !data.isCollapsed,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                    className: "font-mono text-xs cursor-default",
                    children: data.path
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-4 pt-3 mt-3 border-t border-daw-gray-200 whitespace-normal text-sm",
                    children: data.comments.nodes?.map((comment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-2 pb-4 border-b border-daw-gray-200 last:border-b-0 last:pb-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                                                    actor: comment.author
                                                }),
                                                " \u2022 ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-xs text-daw-gray-600",
                                                    children: df.format(new Date(comment.createdAt))
                                                }),
                                                comment.state === 'PENDING' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "w-fit ml-2 px-2 py-0.5 rounded border text-xs font-medium bg-daw-yellow-100 border-daw-yellow-200 text-daw-yellow-700",
                                                    children: "pending"
                                                })
                                            ]
                                        }),
                                        comment.viewerCanDelete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                            onPress: ()=>deleteReviewComment(comment.id),
                                            className: "text-daw-gray-400 hover:text-daw-red-500 pressed:text-daw-red-600 cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$d23329de703dffc4), {
                                                size: 14
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$286a50103f692ed6), {
                                        children: comment.body
                                    })
                                }),
                                comment.reactionGroups && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$44cd1c46d5ca2376), {
                                    id: comment.id,
                                    data: comment.reactionGroups
                                })
                            ]
                        }, comment.id))
                })
            ]
        })
    });
}
$63f88f8247c03421$export$ae751d0ac236b725.fragment = `
fragment PullRequestThreadFragment on PullRequestReviewThread {
  id
  isCollapsed
  isOutdated
  isResolved
  resolvedBy {
    ...ActorFragment
  }
  line
  diffSide
  path
  viewerCanResolve
  comments(first:100) {
    nodes {
      id
      author {
        ...ActorFragment
      }
      body
      createdAt
      reactionGroups {
        ...ReactionFragment
      }
      isMinimized
      minimizedReason
      startLine
      line
      path
      state
      outdated
      viewerCanDelete
    }
  }
}
`;
function $63f88f8247c03421$var$ReviewDismissed({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid items-center gap-2",
        style: {
            gridTemplateAreas: `
          "icon description"
          ".    issue"
        `,
            gridTemplateColumns: 'min-content 1fr'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " dismissed ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                        href: data.review.author.url,
                        target: "_blank",
                        className: "font-semibold hover:underline",
                        children: data.review.author.login
                    }),
                    "'s stale review ",
                    data.pullRequestCommit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "via ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommitLink, {
                                commit: data.pullRequestCommit.commit
                            })
                        ]
                    })
                ]
            }),
            data.dismissalMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
                gridArea: "issue",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$286a50103f692ed6), {
                    children: data.dismissalMessage
                })
            })
        ]
    });
}
$63f88f8247c03421$var$ReviewDismissed.fragment = `
fragment ReviewDismissedFragment on ReviewDismissedEvent {
  id
  actor {
    ...ActorFragment
  }
  review {
    author {
      login
      url
    }
  }
  dismissalMessage
  pullRequestCommit {
    commit {
      url
      abbreviatedOid
    }
  }
}
`;
function $63f88f8247c03421$var$CrossReferenced({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid items-center gap-2",
        style: {
            gridTemplateAreas: `
          "icon description"
          ".    issue"
        `,
            gridTemplateColumns: 'min-content 1fr'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$63f0d8a59fc7d9b4), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " referenced this"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
                gridArea: "issue",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex gap-1 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-1 flex-1 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                                    href: data.source.url,
                                    className: "truncate font-semibold outline-none hover:underline focus-visible:underline",
                                    children: data.source.title
                                }),
                                data.isCrossRepository && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex gap-1 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                                            src: data.source.repository.owner.avatarUrl
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                                            href: data.source.url,
                                            className: "text-daw-gray-700 outline-none hover:underline focus-visible:underline",
                                            children: [
                                                data.source.repository.owner.login,
                                                "/",
                                                data.source.repository.name,
                                                " #",
                                                data.source.number
                                            ]
                                        })
                                    ]
                                }),
                                !data.isCrossRepository && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                                    href: data.source.url,
                                    className: "text-daw-gray-700 outline-none hover:underline focus-visible:underline",
                                    children: [
                                        "#",
                                        data.source.number
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$559eb15a98685419), {
                            data: data.source
                        })
                    ]
                })
            })
        ]
    });
}
$63f88f8247c03421$var$CrossReferenced.fragment = `
fragment CrossReferencedEventFragment on CrossReferencedEvent {
  id
  actor {
    ...ActorFragment
  }
  isCrossRepository
  source {
    __typename
    ...on Issue {
      title
      number
      url
      number
      repository {
        name
        url
        owner {
          login
          avatarUrl
        }
      }
      state
    }
    ...on PullRequest {
      title
      number
      url
      number
      repository {
        name
        url
        owner {
          login
          avatarUrl
        }
      }
      state
    }
  }
}
`;
function $63f88f8247c03421$var$Referenced({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid items-center gap-2",
        style: {
            gridTemplateAreas: `
          "icon description"
          ".    commit"
        `,
            gridTemplateColumns: 'min-content 1fr'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$63f0d8a59fc7d9b4), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " referenced this pull request"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    gridArea: 'commit'
                },
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "flex-1 line-clamp-2 text-sm",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                            href: data.commit.commitUrl,
                            className: "hover:underline",
                            children: data.commit.message
                        })
                    }),
                    data.commit.statusCheckRollup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                        state: data.commit.statusCheckRollup.state
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommitLink, {
                        commit: data.commit
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$Referenced.fragment = `
fragment ReferencedEventFragment on ReferencedEvent {
  id
  actor {
    ...ActorFragment
  }
  isCrossRepository
  commit {
    url
    abbreviatedOid
    message
    commitUrl
    author {
      user {
        login
      }
      avatarUrl
    }
    statusCheckRollup {
      state
    }
  }
}
`;
function $63f88f8247c03421$var$Committed({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-2 items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$60c2c35f336e72eb), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
                src: data.commit.author.avatarUrl
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex-1 line-clamp-2 text-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$d308b62a6a8ceaca), {
                    href: data.commit.commitUrl,
                    className: "hover:underline",
                    children: data.commit.message
                })
            }),
            data.commit.statusCheckRollup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                state: data.commit.statusCheckRollup.state
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommitLink, {
                commit: data.commit
            })
        ]
    });
}
$63f88f8247c03421$var$Committed.fragment = `
fragment CommittedEventFragment on PullRequestCommit {
  id
  commit {
    url
    abbreviatedOid
    message
    commitUrl
    author {
      user {
        login
      }
      avatarUrl
    }
    statusCheckRollup {
      state
    }
  }
}
`;
function $63f88f8247c03421$var$ForcePushed({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$855627263578491e), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " force-pushed the ",
                    data.ref && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                        children: data.ref.name
                    }),
                    " branch from ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommitLink, {
                        commit: data.beforeCommit
                    }),
                    " to ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f88f8247c03421$var$CommitLink, {
                        commit: data.afterCommit
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$ForcePushed.fragment = `
fragment ForcePushedEventFragment on HeadRefForcePushedEvent {
  id
  actor {
    ...ActorFragment
  }
  beforeCommit {
    url
    abbreviatedOid
  }
  afterCommit {
    url
    abbreviatedOid
  }
  ref {
    name
  }
}
`;
function $63f88f8247c03421$var$BaseChanged({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-green-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$c812d10d519e0edb), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "Base automatically changed from ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                        children: data.oldBase
                    }),
                    " to ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$d05367b09ac9e47f), {
                        children: data.newBase
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$BaseChanged.fragment = `
fragment BaseChangeEventFragment on AutomaticBaseChangeSucceededEvent {
  id
  newBase
  oldBase
}
`;
function $63f88f8247c03421$var$ReviewRequested({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-green-600 text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$4b2c798a70974642), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " requested a review",
                    'login' in data.requestedReviewer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " from ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                                href: data.requestedReviewer.url,
                                target: "_blank",
                                className: "hover:underline font-semibold",
                                children: data.requestedReviewer.login
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$ReviewRequested.fragment = `
fragment ReviewRequestedEventFragment on ReviewRequestedEvent {
  actor {
    ...ActorFragment
  }
  requestedReviewer {
    ...on Actor {
      login
      url
    }
  }
}
`;
function $63f88f8247c03421$var$ConvertToDraft({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$51ed17e21f1e5e24), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " marked this pull request as a draft"
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$ConvertToDraft.fragment = `
fragment ConvertToDraftEventFragment on ConvertToDraftEvent {
  actor {
    ...ActorFragment
  }
}
`;
function $63f88f8247c03421$var$ReadyForReview({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$4b2c798a70974642), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " marked this pull request as ready for review"
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$ReadyForReview.fragment = `
fragment ReadyForReviewEventFragment on ReadyForReviewEvent {
  actor {
    ...ActorFragment
  }
}
`;
function $63f88f8247c03421$var$CommentDeleted({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$f04a61298a47a40f), {
                className: "bg-daw-gray-300 text-daw-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5e658a8851ae9322), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                        actor: data.actor
                    }),
                    " deleted a comment from ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                        href: data.deletedCommentAuthor.url,
                        target: "_blank",
                        className: "hover:underline font-semibold",
                        children: data.deletedCommentAuthor.login
                    })
                ]
            })
        ]
    });
}
$63f88f8247c03421$var$CommentDeleted.fragment = `
fragment CommentDeletedEventFragment on CommentDeletedEvent {
  actor {
    ...ActorFragment
  }
  deletedCommentAuthor {
    login
    url
  }
}
`;










async function $92995ef58fa84f45$var$fetchPatch([, owner, repo, number]) {
    let res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).request('GET /repos/{owner}/{repo}/pulls/{pull_number}', {
        owner: owner,
        repo: repo,
        pull_number: number,
        headers: {
            accept: 'application/vnd.github.diff'
        }
    });
    return res.data;
}
function $92995ef58fa84f45$var$usePatch(owner, repo, number) {
    return (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'patch',
        owner,
        repo,
        number
    ], $92995ef58fa84f45$var$fetchPatch);
}
const $92995ef58fa84f45$export$f4ab24e4adfba615 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $92995ef58fa84f45$export$d8ee8bed60538a6a({ owner: owner, repo: repo, number: number }) {
    let { data: res } = (0, $9efcf42537b67d79$export$dd0a697e1782aedd)($92995ef58fa84f45$export$d8ee8bed60538a6a.query(), {
        owner: owner,
        repo: repo,
        number: number
    });
    let data = res?.repository.pullRequest;
    let { data: patch } = $92995ef58fa84f45$var$usePatch(owner, repo, number);
    let [pendingComment, setPendingComment] = (0, $acw62.useState)(null);
    if (!data) return null;
    async function getOrCreateReviewId() {
        let reviewId = data.reviews?.nodes?.find((r)=>r?.state === 'PENDING')?.id;
        if (reviewId) return reviewId;
        let result = await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation AddPullRequestReview($pullRequestId: ID!) {
        addPullRequestReview(input: { pullRequestId: $pullRequestId }) {
          pullRequestReview {
            id
          }
        }
      }`, {
            pullRequestId: data.id
        });
        return result.addPullRequestReview.pullRequestReview.id;
    }
    async function handleSubmitComment(body) {
        if (!pendingComment || !data) return;
        let reviewId = await getOrCreateReviewId();
        let side = pendingComment.side === 'additions' ? 'RIGHT' : 'LEFT';
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation AddPullRequestReviewThread($pullRequestReviewId: ID!, $path: String!, $line: Int!, $side: DiffSide!, $body: String!) {
        addPullRequestReviewThread(input: {
          pullRequestReviewId: $pullRequestReviewId,
          path: $path,
          line: $line,
          side: $side,
          body: $body
        }) {
          thread {
            id
          }
        }
      }`, {
            pullRequestReviewId: reviewId,
            path: pendingComment.path,
            line: pendingComment.line,
            side: side,
            body: body
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $92995ef58fa84f45$export$d8ee8bed60538a6a.query(),
            {
                owner: owner,
                repo: repo,
                number: number
            }
        ]);
        setPendingComment(null);
    }
    async function handleSubmitReview(event) {
        if (!data) return;
        let existingReviewId = data.reviews?.nodes?.find((r)=>r?.state === 'PENDING')?.id;
        if (existingReviewId) await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation SubmitPullRequestReview($pullRequestReviewId: ID!, $event: PullRequestReviewEvent!) {
          submitPullRequestReview(input: {
            pullRequestReviewId: $pullRequestReviewId,
            event: $event
          }) {
            pullRequestReview {
              id
              state
            }
          }
        }`, {
            pullRequestReviewId: existingReviewId,
            event: event
        });
        else await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation AddAndSubmitPullRequestReview($pullRequestId: ID!, $event: PullRequestReviewEvent!) {
          addPullRequestReview(input: {
            pullRequestId: $pullRequestId,
            event: $event
          }) {
            pullRequestReview {
              id
              state
            }
          }
        }`, {
            pullRequestId: data.id,
            event: event
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $92995ef58fa84f45$export$d8ee8bed60538a6a.query(),
            {
                owner: owner,
                repo: repo,
                number: number
            }
        ]);
    }
    async function deleteComment(id) {
        await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation DeleteIssueComment($id: ID!) { deleteIssueComment(input: {id: $id}) { clientMutationId } }`, {
            id: id
        });
        await (0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $92995ef58fa84f45$export$d8ee8bed60538a6a.query(),
            {
                owner: owner,
                repo: repo,
                number: number
            }
        ]);
    }
    let hasPendingReview = data.reviews?.nodes?.some((r)=>r?.state === 'PENDING') ?? false;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92995ef58fa84f45$export$f4ab24e4adfba615.Provider, {
        value: data,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50c3c6889737e436$export$1f5b733bf3f0b704).Provider, {
            value: {
                owner: owner,
                repo: repo
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-1 min-h-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 px-4 pb-4 pt-2 -mr-4 max-w-3xl mx-auto w-[500px] overflow-auto text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $376a85c6166d1b77$export$8b251419efc915eb), {
                                data: data
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739e3e11d093b75a$export$bc479ee64936fcb7), {
                                data: data
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92995ef58fa84f45$var$PullHeader, {
                                data: data
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f88f8247c03421$export$e6a97ba2cae5bb94), {
                                items: data.timelineItems.nodes,
                                onDeleteComment: deleteComment
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb50f473036ab352$export$66aad0404632933), {
                                issue: data
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col flex-1 gap-2 pt-2 min-h-0",
                        children: [
                            data.state === 'OPEN' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mx-4 bg-daw-white rounded-xl p-3 shadow-card shrink-0 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center mr-auto text-sm font-medium",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "ml-1 text-daw-gray-600",
                                                children: [
                                                    data.changedFiles,
                                                    " ",
                                                    data.changedFiles === 1 ? 'file' : 'files'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "ml-3 text-red-500",
                                                children: [
                                                    "-",
                                                    data.deletions
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "ml-1 text-green-600",
                                                children: [
                                                    "+",
                                                    data.additions
                                                ]
                                            }),
                                            data.totalCommentsCount != null && data.totalCommentsCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a3543c9c8473fb3d), {
                                                        className: "ml-3 text-daw-gray-600"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "ml-1 text-daw-gray-600",
                                                        children: data.totalCommentsCount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                        isDisabled: !hasPendingReview,
                                        onPress: ()=>handleSubmitReview('COMMENT'),
                                        className: "px-3 py-1.5 rounded-md bg-daw-gray-300 pressed:bg-daw-gray-400 border border-daw-gray-400 pressed:border-daw-gray-500 text-daw-gray-800 text-xs font-medium cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600 disabled:opacity-40",
                                        children: "Comment"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                        isDisabled: !hasPendingReview,
                                        onPress: ()=>handleSubmitReview('REQUEST_CHANGES'),
                                        className: "px-3 py-1.5 rounded-md bg-red-500 pressed:bg-red-600 border border-red-600 pressed:border-red-700 text-white text-xs font-medium cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600 disabled:opacity-40",
                                        children: "Request changes"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                                        onPress: ()=>handleSubmitReview('APPROVE'),
                                        className: "px-3 py-1.5 rounded-md bg-green-600 pressed:bg-green-700 border border-green-700 pressed:border-green-800 dark:border-green-500 dark:pressed:border-green-600 text-white text-xs font-medium cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
                                        children: "Approve"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex-1 min-h-0",
                                children: patch ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea48220a143b30f5$export$b03e7cabf0eb0daa), {
                                    patch: patch,
                                    threads: data.reviewThreads.nodes ?? [],
                                    pendingComment: pendingComment,
                                    onGutterUtilityClick: (path, line, side)=>setPendingComment({
                                            path: path,
                                            line: line,
                                            side: side
                                        }),
                                    renderAnnotation: (annotation)=>{
                                        let { metadata: metadata } = annotation;
                                        if (metadata === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "font-sans text-base mx-2",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb50f473036ab352$export$dade19d95388b828), {
                                                    autoFocus: true,
                                                    onSubmit: handleSubmitComment,
                                                    onCancel: ()=>setPendingComment(null)
                                                })
                                            })
                                        });
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "font-sans text-base mx-2",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f88f8247c03421$export$ae751d0ac236b725), {
                                                data: metadata
                                            })
                                        });
                                    }
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-sm text-daw-gray-500 py-4 max-w-3xl mx-auto w-full",
                                    children: "Loading diff\u2026"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$92995ef58fa84f45$export$d8ee8bed60538a6a.query = ()=>`
query issueTimeline($owner: String!, $repo: String!, $number: Int!) {
  repository(owner:$owner, name:$repo) {
    pullRequest(number:$number) {
      __typename
      id
      number
      url
      title
      body
      createdAt
      state
      isDraft
      author {
        avatarUrl
        url
        login
      }
      reactionGroups {
        content
        viewerHasReacted
        reactors {
          totalCount
        }
      }
      repository {
        name
        viewerDefaultMergeMethod
        owner {
          login
          avatarUrl
        }
      }
      headRefName
      baseRefName
      reviews(last:100) {
        nodes {
          id
          author {
            ...ActorFragment
          }
          state
        }
      }
      commits(last:1) {
        nodes {
          commit {
            statusCheckRollup {
              state
            }
            checkSuites(first:100) {
              nodes {
                id
                app {
                  name
                  logoUrl
                  logoBackgroundColor
                }
                status
                conclusion
                checkRuns(first:100) {
                  nodes {
                    id
                    name
                    detailsUrl
                    status
                    conclusion
                    isRequired(pullRequestNumber:$number)
                  }
                }
              }
            }
          }
        }
      }
      additions
      deletions
      changedFiles
      totalCommentsCount
      mergeable
      isInMergeQueue
      isMergeQueueEnabled
      autoMergeRequest { mergeMethod }
      viewerCanEnableAutoMerge
      viewerCanDisableAutoMerge
      reviewDecision
      viewerCanMergeAsAdmin
      viewerCanClose
      viewerCanUpdateBranch
      timelineItems(first:100) {
        nodes {
          ...PullRequestTimelineFragment
        }
      }
      reviewThreads(first:100) {
        nodes {
          ...PullRequestThreadFragment
        }
      }
    }
  }
}

${(0, $63f88f8247c03421$export$e6a97ba2cae5bb94).pullRequestFragment()}
`;
$92995ef58fa84f45$export$d8ee8bed60538a6a.preload = (owner, repo, number)=>{
    (0, $9efcf42537b67d79$export$513ccb98c53b8039)($92995ef58fa84f45$export$d8ee8bed60538a6a.query(), {
        owner: owner,
        repo: repo,
        number: number
    });
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'patch',
        owner,
        repo,
        number
    ], $92995ef58fa84f45$var$fetchPatch);
};
function $92995ef58fa84f45$var$PullHeader({ data: data }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$60332b2344f7fe41), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4 text-sm",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92995ef58fa84f45$var$Reviews, {
                    data: data
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "border-daw-gray-200"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92995ef58fa84f45$var$Checks, {
                    data: data
                }),
                data.state === 'OPEN' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "border-daw-gray-200"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92995ef58fa84f45$var$Merge, {
                            data: data
                        })
                    ]
                })
            ]
        })
    });
}
let $92995ef58fa84f45$export$53385330f58411d1 = {
    APPROVED: 'Approved',
    REVIEW_REQUIRED: 'Review required',
    CHANGES_REQUESTED: 'Changes requested'
};
function $92995ef58fa84f45$var$Reviews({ data: data }) {
    let reviews = data.reviews?.nodes?.filter((node)=>node?.author?.login !== data.author?.login);
    if (!reviews || !reviews.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "No reviews."
    });
    let reviewsByAuthor = new Map();
    for (let review of reviews)reviewsByAuthor.set(review?.author?.login, review);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                        state: data.reviewDecision,
                        filled: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "font-semibold",
                        children: $92995ef58fa84f45$export$53385330f58411d1[data.reviewDecision]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: [
                    ...reviewsByAuthor.values()
                ]?.map((review, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "flex gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-5 flex justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                                    state: review.state
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$1f44aaf2ec115b54), {
                                    actor: review.author
                                })
                            })
                        ]
                    }, i))
            })
        ]
    });
}
function $92995ef58fa84f45$var$Checks({ data: data }) {
    let status = data.commits.nodes?.[0]?.commit.statusCheckRollup?.state;
    let checks = data.commits.nodes?.[0]?.commit.checkSuites?.nodes;
    if (status == null && checks?.length) status = 'PENDING';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                        state: status,
                        filled: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "font-semibold",
                        children: "Checks"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: checks?.map((check)=>{
                    if (!check?.conclusion) return null;
                    let summary = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-5 flex justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                                    state: check.conclusion
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: check.app?.logoUrl,
                                className: "w-8 h-8 rounded",
                                style: {
                                    backgroundColor: '#' + check.app?.logoBackgroundColor
                                },
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: check.app?.name
                                    }),
                                    check.conclusion === 'ACTION_REQUIRED' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-daw-gray-500 text-xs",
                                        children: "Awaiting approval"
                                    })
                                ]
                            })
                        ]
                    });
                    if (check?.checkRuns?.nodes?.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: summary
                    }, check.id);
                    if (check?.checkRuns?.nodes?.length > 1) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "flex flex-col gap-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                    className: "flex items-center",
                                    children: summary
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "flex flex-col gap-2 ml-4 mt-2",
                                    children: check?.checkRuns?.nodes?.map((node)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex gap-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-5 flex justify-center",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                                                        state: node.conclusion
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                                                            target: "_blank",
                                                            href: node.detailsUrl,
                                                            children: node.name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-daw-gray-500 text-xs",
                                                            children: node.isRequired ? 'Required' : 'Not required'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, node.id))
                                })
                            ]
                        })
                    }, check.id);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
                        children: check?.checkRuns?.nodes?.map((node)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "flex gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-5 flex justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                                            state: node.conclusion
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: check.app?.logoUrl,
                                        className: "w-8 h-8 rounded",
                                        style: {
                                            backgroundColor: '#' + check.app?.logoBackgroundColor
                                        },
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddc0a4000e0be42$export$a6c7ac8248d6e38a), {
                                                target: "_blank",
                                                href: node.detailsUrl,
                                                children: node.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-daw-gray-500 text-xs",
                                                children: node.isRequired ? 'Required' : 'Not required'
                                            })
                                        ]
                                    })
                                ]
                            }, node.id))
                    }, check.id);
                })
            })
        ]
    });
}
function $92995ef58fa84f45$var$Merge({ data: data }) {
    let [isMerging, setMerging] = (0, $acw62.useState)(false);
    let [isUpdating, setUpdating] = (0, $acw62.useState)(false);
    let [isPending, setPending] = (0, $acw62.useState)(false);
    let refresh = ()=>(0, $e30a63e8d43c13f6$export$35e795649ee09318)([
            $92995ef58fa84f45$export$d8ee8bed60538a6a.query(),
            {
                owner: data.repository.owner.login,
                repo: data.repository.name,
                number: data.number
            }
        ]);
    async function handleMerge() {
        setMerging(true);
        try {
            await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).pulls.merge({
                owner: data.repository.owner.login,
                repo: data.repository.name,
                pull_number: data.number,
                merge_method: data.repository.viewerDefaultMergeMethod.toLowerCase()
            });
            await refresh();
        } finally{
            setMerging(false);
        }
    }
    async function handleUpdateBranch() {
        setUpdating(true);
        try {
            await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).pulls.updateBranch({
                owner: data.repository.owner.login,
                repo: data.repository.name,
                pull_number: data.number
            });
            await refresh();
        } finally{
            setUpdating(false);
        }
    }
    async function handleAddToQueue() {
        setPending(true);
        try {
            await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation AddToMergeQueue($pullRequestId: ID!) { enqueuePullRequest(input: {pullRequestId: $pullRequestId}) { mergeQueue { id } } }`, {
                pullRequestId: data.id
            });
            await refresh();
        } finally{
            setPending(false);
        }
    }
    async function handleRemoveFromQueue() {
        setPending(true);
        try {
            await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation RemoveFromMergeQueue($pullRequestId: ID!, $branch: String!) { dequeuePullRequest(input: {pullRequestId: $pullRequestId, branch: $branch}) { mergeQueue { id } } }`, {
                pullRequestId: data.id,
                branch: data.baseRefName
            });
            await refresh();
        } finally{
            setPending(false);
        }
    }
    async function handleEnableAutoMerge() {
        setPending(true);
        try {
            await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation EnableAutoMerge($pullRequestId: ID!, $mergeMethod: PullRequestMergeMethod!) { enablePullRequestAutoMerge(input: {pullRequestId: $pullRequestId, mergeMethod: $mergeMethod}) { pullRequest { id } } }`, {
                pullRequestId: data.id,
                mergeMethod: data.repository.viewerDefaultMergeMethod
            });
            await refresh();
        } finally{
            setPending(false);
        }
    }
    async function handleDisableAutoMerge() {
        setPending(true);
        try {
            await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)(`mutation DisableAutoMerge($pullRequestId: ID!) { disablePullRequestAutoMerge(input: {pullRequestId: $pullRequestId}) { pullRequest { id } } }`, {
                pullRequestId: data.id
            });
            await refresh();
        } finally{
            setPending(false);
        }
    }
    if (data.mergeable !== 'MERGEABLE') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-2 items-center justify-space-between",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-daw-gray-600 text-balance flex-1",
                children: "Conflicts must be resolved before merging."
            }),
            data.viewerCanUpdateBranch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                isPending: isUpdating,
                onPress: handleUpdateBranch,
                className: "shrink-0 px-4 py-2 rounded-md bg-neutral-600 pressed:bg-neutral-700 border border-neutral-500 pressed:border-neutral-600 pending:opacity-50 transition text-white cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
                children: "Update branch"
            })
        ]
    });
    if (data.reviewDecision !== 'APPROVED' && (data.viewerCanEnableAutoMerge || data.viewerCanDisableAutoMerge)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex gap-2 items-center justify-end",
        children: data.autoMergeRequest ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
            isPending: isPending,
            onPress: handleDisableAutoMerge,
            className: "shrink-0 px-4 py-2 rounded-md bg-neutral-600 pressed:bg-neutral-700 border border-neutral-500 pressed:border-neutral-600 pending:opacity-50 transition text-white cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
            children: "Disable auto-merge"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
            isPending: isPending,
            onPress: handleEnableAutoMerge,
            className: "shrink-0 px-4 py-2 rounded-md bg-neutral-600 pressed:bg-neutral-700 border border-neutral-500 pressed:border-neutral-600 pending:opacity-50 transition text-white cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
            children: "Enable auto-merge"
        })
    });
    if (data.reviewDecision === 'APPROVED' && data.isMergeQueueEnabled) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex gap-2 items-center justify-end",
        children: data.isInMergeQueue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
            isPending: isPending,
            onPress: handleRemoveFromQueue,
            className: "shrink-0 px-4 py-2 rounded-md bg-neutral-600 pressed:bg-neutral-700 border border-neutral-500 pressed:border-neutral-600 pending:opacity-50 transition text-white cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
            children: "Remove from merge queue"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
            isPending: isPending,
            onPress: handleAddToQueue,
            className: "shrink-0 px-4 py-2 rounded-md bg-green-600 pressed:bg-green-700 border border-green-700 pressed:border-green-800 dark:border-green-500 dark:pressed:border-green-600 pending:opacity-50 transition text-white cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600",
            children: "Add to merge queue"
        })
    });
    let mergeColor = data.reviewDecision === 'APPROVED' ? 'bg-green-600 pressed:bg-green-700 border-green-700 pressed:border-green-800 dark:border-green-500 dark:pressed:border-green-600' : 'bg-red-600 pressed:bg-red-700 border-red-500 pressed:border-red-600';
    let mergeLabel = data.reviewDecision === 'APPROVED' ? 'Merge' : 'Merge as administrator';
    if (data.reviewDecision === 'APPROVED' || data.viewerCanMergeAsAdmin) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-2 items-center justify-end flex-wrap",
        children: [
            data.viewerCanMergeAsAdmin && data.reviewDecision !== 'APPROVED' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-daw-gray-600 text-balance flex-1",
                children: "Use your administrator privileges to merge this pull request immediately without waiting for requirements to be met."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                isPending: isMerging,
                onPress: handleMerge,
                className: `shrink-0 px-4 py-2 rounded-md border pending:opacity-50 transition text-white cursor-default outline-none focus-visible:ring-2 ring-offset-2 ring-blue-600 ${mergeColor}`,
                children: mergeLabel
            })
        ]
    });
    return null;
}







var $acw62 = parcelRequire("acw62");




// Shared state between server components and client components
const $25f67ffa4087bf8c$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $25f67ffa4087bf8c$var$UNDEFINED = /*#__NOINLINE__*/ $25f67ffa4087bf8c$var$noop();
const $25f67ffa4087bf8c$var$OBJECT = Object;
const $25f67ffa4087bf8c$var$isUndefined = (v)=>v === $25f67ffa4087bf8c$var$UNDEFINED;
const $25f67ffa4087bf8c$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $25f67ffa4087bf8c$var$table = new WeakMap();
const $25f67ffa4087bf8c$var$getTypeName = (value)=>$25f67ffa4087bf8c$var$OBJECT.prototype.toString.call(value);
const $25f67ffa4087bf8c$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $25f67ffa4087bf8c$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $25f67ffa4087bf8c$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $25f67ffa4087bf8c$var$getTypeName(arg);
    const isDate = $25f67ffa4087bf8c$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $25f67ffa4087bf8c$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $25f67ffa4087bf8c$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($25f67ffa4087bf8c$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $25f67ffa4087bf8c$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$25f67ffa4087bf8c$var$counter + '~';
        $25f67ffa4087bf8c$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $25f67ffa4087bf8c$var$stableHash(arg[index]) + ',';
            $25f67ffa4087bf8c$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $25f67ffa4087bf8c$var$OBJECT.keys(arg).sort();
            while(!$25f67ffa4087bf8c$var$isUndefined(index = keys.pop()))if (!$25f67ffa4087bf8c$var$isUndefined(arg[index])) result += index + ':' + $25f67ffa4087bf8c$var$stableHash(arg[index]) + ',';
            $25f67ffa4087bf8c$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $25f67ffa4087bf8c$var$serialize = (key)=>{
    if ($25f67ffa4087bf8c$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $25f67ffa4087bf8c$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $25f67ffa4087bf8c$var$getFirstPageKey = (getKey)=>{
    return $25f67ffa4087bf8c$var$serialize(getKey ? getKey(0, null) : null)[0];
};
const $25f67ffa4087bf8c$export$dbab534a48e651ef = (getKey)=>{
    return (0, $31b819a8af02b76f$export$8667f065faedc62c) + $25f67ffa4087bf8c$var$getFirstPageKey(getKey);
};
// We have to several type castings here because `useSWRInfinite` is a special
// hook where `key` and return type are not like the normal `useSWR` types.
const $25f67ffa4087bf8c$var$EMPTY_PROMISE = Promise.resolve();
const $25f67ffa4087bf8c$export$f27219e7b43e81d = (useSWRNext)=>(getKey, fn, config)=>{
        const didMountRef = (0, $acw62.useRef)(false);
        const { cache: cache$1, initialSize: initialSize = 1, revalidateAll: revalidateAll = false, persistSize: persistSize = false, revalidateFirstPage: revalidateFirstPage = true, revalidateOnMount: revalidateOnMount = false, parallel: parallel = false } = config;
        const [, , , PRELOAD] = (0, $e30a63e8d43c13f6$export$8b22cf2602fb60ce).get((0, $e30a63e8d43c13f6$export$db3b6bfb95261072));
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        let infiniteKey;
        try {
            infiniteKey = $25f67ffa4087bf8c$var$getFirstPageKey(getKey);
            if (infiniteKey) infiniteKey = (0, $31b819a8af02b76f$export$8667f065faedc62c) + infiniteKey;
        } catch (err) {
        // Not ready yet.
        }
        const [get, set, subscribeCache] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache$1, infiniteKey);
        const getSnapshot = (0, $acw62.useCallback)(()=>{
            const size = (0, $e30a63e8d43c13f6$export$f1e1789686576879)(get()._l) ? initialSize : get()._l;
            return size;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            cache$1,
            infiniteKey,
            initialSize
        ]);
        (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)((0, $acw62.useCallback)((callback)=>{
            if (infiniteKey) return subscribeCache(infiniteKey, ()=>{
                callback();
            });
            return ()=>{};
        }, [
            cache$1,
            infiniteKey
        ]), getSnapshot, getSnapshot);
        const resolvePageSize = (0, $acw62.useCallback)(()=>{
            const cachedPageSize = get()._l;
            return (0, $e30a63e8d43c13f6$export$f1e1789686576879)(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        const lastPageSizeRef = (0, $acw62.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0, $e30a63e8d43c13f6$export$3b14a55fb2447963)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            // Otherwise, we reset the page size to cached pageSize
            set({
                _l: persistSize ? lastPageSizeRef.current : resolvePageSize()
            });
        // `initialSize` isn't allowed to change during the lifecycle
        }, [
            infiniteKey,
            cache$1
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        const shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        const swr = useSWRNext(infiniteKey, async (key)=>{
            // get the revalidate context
            const forceRevalidateAll = get()._i;
            const shouldRevalidatePage = get()._r;
            set({
                _r: (0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08)
            });
            // return an array of page data
            const data = [];
            const pageSize = resolvePageSize();
            const [getCache] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache$1, key);
            const cacheData = getCache().data;
            const revalidators = [];
            let previousPageData = null;
            for(let i = 0; i < pageSize; ++i){
                const [pageKey, pageArg] = (0, $e30a63e8d43c13f6$export$2408f22a0fab9ae5)(getKey(i, parallel ? null : previousPageData));
                if (!pageKey) break;
                const [getSWRCache, setSWRCache] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache$1, pageKey);
                // Get the cached page data.
                let pageData = getSWRCache().data;
                // should fetch (or revalidate) if:
                // - `revalidateAll` is enabled
                // - `mutate()` called
                // - the cache is missing
                // - it's the first page and it's not the initial render
                // - `revalidateOnMount` is enabled and it's on mount
                // - cache for that page has changed
                const shouldFetchPage = revalidateAll || forceRevalidateAll || (0, $e30a63e8d43c13f6$export$f1e1789686576879)(pageData) || revalidateFirstPage && !i && !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(cacheData) || shouldRevalidateOnMount || cacheData && !(0, $e30a63e8d43c13f6$export$f1e1789686576879)(cacheData[i]) && !config.compare(cacheData[i], pageData);
                if (fn && (typeof shouldRevalidatePage === 'function' ? shouldRevalidatePage(pageData, pageArg) : shouldFetchPage)) {
                    const revalidate = async ()=>{
                        const hasPreloadedRequest = pageKey in PRELOAD;
                        if (!hasPreloadedRequest) pageData = await fn(pageArg);
                        else {
                            const req = PRELOAD[pageKey];
                            // delete the preload cache key before resolving it
                            // in case there's an error
                            delete PRELOAD[pageKey];
                            // get the page data from the preload cache
                            pageData = await req;
                        }
                        setSWRCache({
                            data: pageData,
                            _k: pageArg
                        });
                        data[i] = pageData;
                    };
                    if (parallel) revalidators.push(revalidate);
                    else await revalidate();
                } else data[i] = pageData;
                if (!parallel) previousPageData = pageData;
            }
            // flush all revalidateions in parallel
            if (parallel) await Promise.all(revalidators.map((r)=>r()));
            // once we executed the data fetching based on the context, clear the context
            set({
                _i: (0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08)
            });
            // return the data
            return data;
        }, config);
        const mutate = (0, $acw62.useCallback)(function(data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            const options = typeof opts === 'boolean' ? {
                revalidate: opts
            } : opts || {};
            // Default to true.
            const shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $25f67ffa4087bf8c$var$EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0, $e30a63e8d43c13f6$export$f1e1789686576879)(data)) // We only revalidate the pages that are changed
                set({
                    _i: false,
                    _r: options.revalidate
                });
                else // Calling `mutate()`, we revalidate all pages
                set({
                    _i: true,
                    _r: options.revalidate
                });
            }
            return arguments.length ? swr.mutate(data, {
                ...options,
                revalidate: shouldRevalidate
            }) : swr.mutate();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1
        ]);
        // Extend the SWR API
        const setSize = (0, $acw62.useCallback)((arg)=>{
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $25f67ffa4087bf8c$var$EMPTY_PROMISE;
            const [, changeSize] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache$1, infiniteKey);
            let size;
            if ((0, $e30a63e8d43c13f6$export$407448d2b89b1813)(arg)) size = arg(resolvePageSize());
            else if (typeof arg == 'number') size = arg;
            if (typeof size != 'number') return $25f67ffa4087bf8c$var$EMPTY_PROMISE;
            changeSize({
                _l: size
            });
            lastPageSizeRef.current = size;
            // Calculate the page data after the size change.
            const data = [];
            const [getInfiniteCache] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache$1, infiniteKey);
            let previousPageData = null;
            for(let i = 0; i < size; ++i){
                const [pageKey] = (0, $e30a63e8d43c13f6$export$2408f22a0fab9ae5)(getKey(i, previousPageData));
                const [getCache] = (0, $e30a63e8d43c13f6$export$df995fae86a55f06)(cache$1, pageKey);
                // Get the cached page data.
                const pageData = pageKey ? getCache().data : (0, $e30a63e8d43c13f6$export$3a6d5c9ae78a2c08);
                // Call `mutate` with infinte cache data if we can't get it from the page cache.
                if ((0, $e30a63e8d43c13f6$export$f1e1789686576879)(pageData)) return mutate(getInfiniteCache().data);
                data.push(pageData);
                previousPageData = pageData;
            }
            return mutate(data);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1,
            mutate,
            resolvePageSize
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data () {
                return swr.data;
            },
            get error () {
                return swr.error;
            },
            get isValidating () {
                return swr.isValidating;
            },
            get isLoading () {
                return swr.isLoading;
            }
        };
    };
const $25f67ffa4087bf8c$export$2e2bcd8739ae039 = (0, $73ef0a5623b28096$export$525ea7fc6ba00096)((0, $9ef683e011c31ff0$export$2e2bcd8739ae039), $25f67ffa4087bf8c$export$f27219e7b43e81d);




var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b5e00d5661c77b99$export$c84671f46d6a1ca {
    /**
   * Returns whether the layout should invalidate in response to
   * visible rectangle changes. By default, it only invalidates
   * when the virtualizer's size changes. Return true always
   * to make the layout invalidate while scrolling (e.g. sticky headers).
   */ shouldInvalidate(newRect, oldRect) {
        // By default, invalidate when the size changes
        return newRect.width !== oldRect.width || newRect.height !== oldRect.height;
    }
    /**
   * Returns whether the layout should invalidate when the layout options change.
   * By default it invalidates when the object identity changes. Override this
   * method to optimize layout updates based on specific option changes.
   */ shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions !== oldOptions;
    }
    /**
   * This method allows the layout to perform any pre-computation
   * it needs to in order to prepare LayoutInfos for retrieval.
   * Called by the virtualizer before `getVisibleLayoutInfos`
   * or `getLayoutInfo` are called.
   */ update(invalidationContext) {}
    /** @private */ getItemRect(key) {
        return this.getLayoutInfo(key)?.rect ?? null;
    }
    /** @private */ getVisibleRect() {
        return this.virtualizer.visibleRect;
    }
    constructor(){
        /** The Virtualizer the layout is currently attached to. */ this.virtualizer = null;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b758d2f50c514b88$export$7e0eeb9da702a085 {
    /**
   * @param type The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node.
   * @param key A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node.
   * @param rect The rectangle describing the size and position of this element.
   */ constructor(type, key, rect){
        this.type = type;
        this.key = key;
        this.parentKey = null;
        this.content = null;
        this.rect = rect;
        this.estimatedSize = false;
        this.isSticky = false;
        this.opacity = 1;
        this.transform = null;
        this.zIndex = 0;
        this.allowOverflow = false;
    }
    /**
   * Returns a copy of the LayoutInfo.
   */ copy() {
        let res = new $b758d2f50c514b88$export$7e0eeb9da702a085(this.type, this.key, this.rect.copy());
        res.estimatedSize = this.estimatedSize;
        res.opacity = this.opacity;
        res.transform = this.transform;
        res.parentKey = this.parentKey;
        res.content = this.content;
        res.isSticky = this.isSticky;
        res.zIndex = this.zIndex;
        res.allowOverflow = this.allowOverflow;
        return res;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $82e7d4b8304ffa13$export$baf26146a414f24a {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    /**
   * Returns a copy of this point.
   */ copy() {
        return new $82e7d4b8304ffa13$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Checks if two points are equal.
   */ equals(point) {
        return this.x === point.x && this.y === point.y;
    }
    /**
   * Returns true if this point is the origin.
   */ isOrigin() {
        return this.x === 0 && this.y === 0;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5b63612269032ac9$export$c79fc6492f3af13d {
    constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
   * The maximum x-coordinate in the rectangle.
   */ get maxX() {
        return this.x + this.width;
    }
    /**
   * The maximum y-coordinate in the rectangle.
   */ get maxY() {
        return this.y + this.height;
    }
    /**
   * The area of the rectangle.
   */ get area() {
        return this.width * this.height;
    }
    /**
   * The top left corner of the rectangle.
   */ get topLeft() {
        return new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(this.x, this.y);
    }
    /**
   * The top right corner of the rectangle.
   */ get topRight() {
        return new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(this.maxX, this.y);
    }
    /**
   * The bottom left corner of the rectangle.
   */ get bottomLeft() {
        return new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(this.x, this.maxY);
    }
    /**
   * The bottom right corner of the rectangle.
   */ get bottomRight() {
        return new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(this.maxX, this.maxY);
    }
    /**
   * Returns whether this rectangle intersects another rectangle.
   * @param rect - The rectangle to check.
   */ intersects(rect) {
        let isTestEnv = false;
        return (isTestEnv || this.area > 0 && rect.area > 0) && this.x <= rect.x + rect.width && rect.x <= this.x + this.width && this.y <= rect.y + rect.height && rect.y <= this.y + this.height;
    }
    /**
   * Returns whether this rectangle fully contains another rectangle.
   * @param rect - The rectangle to check.
   */ containsRect(rect) {
        return this.x <= rect.x && this.y <= rect.y && this.maxX >= rect.maxX && this.maxY >= rect.maxY;
    }
    /**
   * Returns whether the rectangle contains the given point.
   * @param point - The point to check.
   */ containsPoint(point) {
        return this.x <= point.x && this.y <= point.y && this.maxX >= point.x && this.maxY >= point.y;
    }
    /**
   * Returns the first corner of this rectangle (from top to bottom, left to right)
   * that is contained in the given rectangle, or null of the rectangles do not intersect.
   * @param rect - The rectangle to check.
   */ getCornerInRect(rect) {
        for (let key of [
            'topLeft',
            'topRight',
            'bottomLeft',
            'bottomRight'
        ]){
            if (rect.containsPoint(this[key])) return key;
        }
        return null;
    }
    equals(rect) {
        return rect.x === this.x && rect.y === this.y && rect.width === this.width && rect.height === this.height;
    }
    pointEquals(point) {
        return this.x === point.x && this.y === point.y;
    }
    sizeEquals(size) {
        return this.width === size.width && this.height === size.height;
    }
    /**
   * Returns the union of this Rect and another.
   */ union(other) {
        let x = Math.min(this.x, other.x);
        let y = Math.min(this.y, other.y);
        let width = Math.max(this.maxX, other.maxX) - x;
        let height = Math.max(this.maxY, other.maxY) - y;
        return new $5b63612269032ac9$export$c79fc6492f3af13d(x, y, width, height);
    }
    /**
   * Returns the intersection of this Rect with another.
   * If the rectangles do not intersect, an all zero Rect is returned.
   */ intersection(other) {
        if (!this.intersects(other)) return new $5b63612269032ac9$export$c79fc6492f3af13d(0, 0, 0, 0);
        let x = Math.max(this.x, other.x);
        let y = Math.max(this.y, other.y);
        return new $5b63612269032ac9$export$c79fc6492f3af13d(x, y, Math.min(this.maxX, other.maxX) - x, Math.min(this.maxY, other.maxY) - y);
    }
    /**
   * Returns a copy of this rectangle.
   */ copy() {
        return new $5b63612269032ac9$export$c79fc6492f3af13d(this.x, this.y, this.width, this.height);
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $4fe6fc815a21c442$export$cb6da89c6af1a8ec {
    constructor(width = 0, height = 0){
        this.width = Math.max(width, 0);
        this.height = Math.max(height, 0);
    }
    /**
   * Returns a copy of this size.
   */ copy() {
        return new $4fe6fc815a21c442$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    /**
   * Returns whether this size is equal to another one.
   */ equals(other) {
        return this.width === other.width && this.height === other.height;
    }
    /**
   * The total area of the Size.
   */ get area() {
        return this.width * this.height;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT = 48;
class $bed9aed30272a45f$export$cacbb3924155d68e extends (0, $b5e00d5661c77b99$export$c84671f46d6a1ca) {
    /**
   * Creates a new ListLayout with options. See the list of properties below for a description
   * of the options that can be provided.
   */ constructor(options = {}){
        super();
        this.rowSize = options?.rowSize ?? options?.rowHeight ?? null;
        this.orientation = options.orientation ?? 'vertical';
        this.estimatedRowSize = options?.estimatedRowSize ?? options?.estimatedRowHeight ?? null;
        this.headingSize = options?.headingSize ?? options?.headingHeight ?? null;
        this.estimatedHeadingSize = options?.estimatedHeadingSize ?? options?.estimatedHeadingHeight ?? null;
        this.loaderSize = options?.loaderSize ?? options?.loaderHeight ?? null;
        this.dropIndicatorThickness = options.dropIndicatorThickness || 2;
        this.gap = options.gap || 0;
        this.padding = options.padding || 0;
        this.layoutNodes = new Map();
        this.rootNodes = [];
        this.lastCollection = null;
        this.invalidateEverything = false;
        this.validRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)();
        this.requestedRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)();
        this.contentSize = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)();
    }
    // Backward compatibility for subclassing.
    get collection() {
        return this.virtualizer.collection;
    }
    /** @deprecated Use `rowSize` instead. */ get rowHeight() {
        return this.rowSize;
    }
    /** @deprecated Use `estimatedRowSize` instead. */ get estimatedRowHeight() {
        return this.estimatedRowSize;
    }
    /** @deprecated Use `headingSize` instead. */ get headingHeight() {
        return this.headingSize;
    }
    /** @deprecated Use `estimatedHeadingSize` instead. */ get estimatedHeadingHeight() {
        return this.estimatedHeadingSize;
    }
    /** @deprecated Use `loaderSize` instead. */ get loaderHeight() {
        return this.loaderSize;
    }
    getLayoutInfo(key) {
        this.ensureLayoutInfo(key);
        return this.layoutNodes.get(key)?.layoutInfo || null;
    }
    getVisibleLayoutInfos(rect) {
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        // Adjust rect to keep number of visible rows consistent.
        // (only if height > 1 or width > 1 for getDropTargetFromPoint)
        if (rect[heightProperty] > 1) {
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT) + this.gap;
            // Clone only before mutating
            rect = rect.copy();
            let offset = Math.floor(rect[offsetProperty] / rowHeight) * rowHeight;
            let height = rect[heightProperty] + rect[offsetProperty] - offset;
            rect[offsetProperty] = offset;
            rect[heightProperty] = Math.ceil(height / rowHeight) * rowHeight;
        }
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        this.layoutIfNeeded(rect);
        let res = [];
        let addNodes = (nodes)=>{
            for (let node of nodes)if (this.isVisible(node, rect)) {
                res.push(node.layoutInfo);
                if (node.children) addNodes(node.children);
            }
        };
        addNodes(this.rootNodes);
        return res;
    }
    layoutIfNeeded(rect) {
        if (!this.lastCollection) return;
        if (!this.requestedRect.containsRect(rect)) {
            this.requestedRect = this.requestedRect.union(rect);
            this.rootNodes = this.buildCollection();
        }
        // Ensure all of the persisted keys are available.
        for (let key of this.virtualizer.persistedKeys){
            if (this.ensureLayoutInfo(key)) return;
        }
    }
    ensureLayoutInfo(key) {
        // If the layout info wasn't found, it might be outside the bounds of the area that we've
        // computed layout for so far. This can happen when accessing a random key, e.g pressing Home/End.
        // Compute the full layout and try again.
        if (!this.layoutNodes.has(key) && this.requestedRect.area < this.contentSize.area && this.lastCollection) {
            this.requestedRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(0, 0, Infinity, Infinity);
            this.rootNodes = this.buildCollection();
            this.requestedRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(0, 0, this.contentSize.width, this.contentSize.height);
            return true;
        }
        return false;
    }
    isVisible(node, rect) {
        return node.layoutInfo.rect.intersects(rect) || node.layoutInfo.isSticky || node.layoutInfo.type === 'header' || node.layoutInfo.type === 'loader' || this.virtualizer.isPersistedKey(node.layoutInfo.key);
    }
    shouldInvalidateEverything(invalidationContext) {
        // Invalidate cache if the size of the collection changed.
        // In this case, we need to recalculate the entire layout.
        // Also invalidate if fixed sizes/gaps change.
        let options = invalidationContext.layoutOptions;
        return invalidationContext.sizeChanged || this.rowSize !== (options?.rowSize ?? options?.rowHeight ?? this.rowSize) || this.orientation !== (options?.orientation ?? this.orientation) || this.headingSize !== (options?.headingSize ?? options?.headingHeight ?? this.headingSize) || this.loaderSize !== (options?.loaderSize ?? options?.loaderHeight ?? this.loaderSize) || this.gap !== (options?.gap ?? this.gap) || this.padding !== (options?.padding ?? this.padding);
    }
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return (newOptions?.rowSize ?? newOptions?.rowHeight) !== (oldOptions?.rowSize ?? oldOptions?.rowHeight) || newOptions.orientation !== oldOptions.orientation || (newOptions?.estimatedRowSize ?? newOptions?.estimatedRowHeight) !== (oldOptions?.estimatedRowSize ?? oldOptions?.estimatedRowHeight) || (newOptions?.headingSize ?? newOptions?.headingHeight) !== (oldOptions?.headingSize ?? oldOptions?.headingHeight) || (newOptions?.estimatedHeadingSize ?? newOptions?.estimatedHeadingHeight) !== (oldOptions?.estimatedHeadingSize ?? oldOptions?.estimatedHeadingHeight) || (newOptions?.loaderSize ?? newOptions?.loaderHeight) !== (oldOptions?.loaderSize ?? oldOptions?.loaderHeight) || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.gap !== oldOptions.gap || newOptions.padding !== oldOptions.padding;
    }
    update(invalidationContext) {
        let collection = this.virtualizer.collection;
        // Reset valid rect if we will have to invalidate everything.
        // Otherwise we can reuse cached layout infos outside the current visible rect.
        this.invalidateEverything = this.shouldInvalidateEverything(invalidationContext);
        if (this.invalidateEverything) {
            this.requestedRect = this.virtualizer.visibleRect.copy();
            this.layoutNodes.clear();
        }
        let options = invalidationContext.layoutOptions;
        this.rowSize = options?.rowSize ?? options?.rowHeight ?? this.rowSize;
        this.orientation = options?.orientation ?? this.orientation;
        this.estimatedRowSize = options?.estimatedRowSize ?? options?.estimatedRowHeight ?? this.estimatedRowSize;
        this.headingSize = options?.headingSize ?? options?.headingHeight ?? this.headingSize;
        this.estimatedHeadingSize = options?.estimatedHeadingSize ?? options?.estimatedHeadingHeight ?? this.estimatedHeadingSize;
        this.loaderSize = options?.loaderSize ?? options?.loaderHeight ?? this.loaderSize;
        this.dropIndicatorThickness = options?.dropIndicatorThickness ?? this.dropIndicatorThickness;
        this.gap = options?.gap ?? this.gap;
        this.padding = options?.padding ?? this.padding;
        this.rootNodes = this.buildCollection();
        // Remove deleted layout nodes
        if (this.lastCollection && collection !== this.lastCollection) {
            for (let key of this.lastCollection.getKeys())if (!collection.getItem(key)) {
                let layoutNode = this.layoutNodes.get(key);
                if (layoutNode) this.layoutNodes.delete(key);
            }
        }
        this.lastCollection = collection;
        this.invalidateEverything = false;
        this.validRect = this.requestedRect.copy();
    }
    buildCollection(offset = this.padding) {
        let collection = this.virtualizer.collection;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let maxOffsetProperty = this.orientation === 'horizontal' ? 'maxX' : 'maxY';
        // filter out content nodes since we don't want them to affect the height
        // Tree specific for now, if we add content nodes to other collection items, we might need to reconsider this
        let collectionNodes = $bed9aed30272a45f$var$$942f06a693c162e2$var$toArray(collection, (node)=>node.type !== 'content');
        let loaderNodes = collectionNodes.filter((node)=>node.type === 'loader');
        let nodes = [];
        let isEmptyOrLoading = collection?.size === 0;
        if (isEmptyOrLoading) offset = 0;
        for (let node of collectionNodes){
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (node.type === 'item' && offset + rowHeight < this.requestedRect[offsetProperty] && !this.isValid(node, offset)) {
                offset += rowHeight;
                continue;
            }
            let layoutNode = this.orientation === 'horizontal' ? this.buildChild(node, offset, this.padding, null) : this.buildChild(node, this.padding, offset, null);
            offset = layoutNode.layoutInfo.rect[maxOffsetProperty] + this.gap;
            nodes.push(layoutNode);
            if (node.type === 'loader') {
                let index = loaderNodes.indexOf(node);
                loaderNodes.splice(index, 1);
            }
            // Build each loader that exists in the collection that is outside the visible rect so that they are persisted
            // at the proper estimated location. If the node.type is "section" then we don't do this shortcut since we have to
            // build the sections to see how tall they are.
            if ((node.type === 'item' || node.type === 'loader') && offset > this.requestedRect[maxOffsetProperty]) {
                let lastProcessedIndex = collectionNodes.indexOf(node);
                for (let loaderNode of loaderNodes){
                    let loaderNodeIndex = collectionNodes.indexOf(loaderNode);
                    // Subtract by an additional 1 since we've already added the current item's height to y
                    offset += (loaderNodeIndex - lastProcessedIndex - 1) * rowHeight;
                    let loader = this.orientation === 'horizontal' ? this.buildChild(loaderNode, offset, this.padding, null) : this.buildChild(loaderNode, this.padding, offset, null);
                    nodes.push(loader);
                    offset = loader.layoutInfo.rect[maxOffsetProperty];
                    lastProcessedIndex = loaderNodeIndex;
                }
                // Account for the rest of the items after the last loader spinner, subtract by 1 since we've processed the current node's height already
                offset += (collectionNodes.length - lastProcessedIndex - 1) * rowHeight;
                break;
            }
        }
        offset = Math.max(offset - this.gap, 0);
        offset += isEmptyOrLoading ? 0 : this.padding;
        this.contentSize = this.orientation === 'horizontal' ? new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(offset, this.virtualizer.size.height) : new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(this.virtualizer.size.width, offset);
        return nodes;
    }
    isValid(node, offset) {
        let cached = this.layoutNodes.get(node.key);
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        return !this.invalidateEverything && !!cached && cached.node === node && offset === cached.layoutInfo.rect[offsetProperty] && cached.layoutInfo.rect.intersects(this.validRect) && cached.validRect.containsRect(cached.layoutInfo.rect.intersection(this.requestedRect));
    }
    buildChild(node, x, y, parentKey) {
        if (this.isValid(node, this.orientation === 'horizontal' ? x : y)) return this.layoutNodes.get(node.key);
        let layoutNode = this.buildNode(node, x, y);
        layoutNode.layoutInfo.parentKey = parentKey ?? null;
        layoutNode.layoutInfo.allowOverflow = true;
        this.layoutNodes.set(node.key, layoutNode);
        return layoutNode;
    }
    buildNode(node, x, y) {
        switch(node.type){
            case 'section':
                return this.buildSection(node, x, y);
            case 'item':
                return this.buildItem(node, x, y);
            case 'header':
                return this.buildSectionHeader(node, x, y);
            case 'loader':
                return this.buildLoader(node, x, y);
            case 'separator':
                return this.buildItem(node, x, y);
            default:
                throw new Error('Unsupported node type: ' + node.type);
        }
    }
    buildLoader(node, x, y) {
        let rect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, this.padding, 0);
        let layoutInfo = new (0, $b758d2f50c514b88$export$7e0eeb9da702a085)(node.type, node.key, rect);
        // Note that if the user provides isLoading to their sentinel during a case where they only want to render the emptyState, this will reserve
        // room for the loader alongside rendering the emptyState
        if (this.orientation === 'horizontal') {
            rect.height = this.virtualizer.contentSize.height - this.padding - y;
            rect.width = node.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT : 0;
        } else {
            rect.width = this.virtualizer.contentSize.width - this.padding - x;
            rect.height = node.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT : 0;
        }
        return {
            layoutInfo: layoutInfo,
            validRect: rect.intersection(this.requestedRect)
        };
    }
    buildSection(node, x, y) {
        let collection = this.virtualizer.collection;
        let width = this.virtualizer.size.width - this.padding - x;
        let height = this.virtualizer.size.height - this.padding - y;
        let rect = this.orientation === 'horizontal' ? new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, 0, height) : new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, width, 0);
        let layoutInfo = new (0, $b758d2f50c514b88$export$7e0eeb9da702a085)(node.type, node.key, rect);
        let offset = this.orientation === 'horizontal' ? x : y;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let maxOffsetProperty = this.orientation === 'horizontal' ? 'maxX' : 'maxY';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let skipped = 0;
        let children = [];
        for (let child of (0, $d6e64cab34740d82$export$1005530eda016c13)(node, collection)){
            // skip if it is a content node, Tree specific for now, if we add content nodes to other collection items, we might need to reconsider this
            if (child.type === 'content') continue;
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (offset + rowHeight < this.requestedRect[offsetProperty] && !this.isValid(node, offset)) {
                offset += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.orientation === 'horizontal' ? this.buildChild(child, offset, y, layoutInfo.key) : this.buildChild(child, x, offset, layoutInfo.key);
            offset = layoutNode.layoutInfo.rect[maxOffsetProperty] + this.gap;
            children.push(layoutNode);
            if (offset > this.requestedRect[maxOffsetProperty]) {
                // Estimate the remaining height for rows that we don't need to layout right now.
                offset += ([
                    ...(0, $d6e64cab34740d82$export$1005530eda016c13)(node, collection)
                ].length - (children.length + skipped)) * rowHeight;
                break;
            }
        }
        offset -= this.gap;
        rect[heightProperty] = offset - (this.orientation === 'horizontal' ? x : y);
        return {
            layoutInfo: layoutInfo,
            children: children,
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node: node
        };
    }
    buildSectionHeader(node, x, y) {
        let widthProperty = this.orientation === 'horizontal' ? 'height' : 'width';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let width = this.virtualizer.size[widthProperty] - this.padding - (this.orientation === 'horizontal' ? y : x);
        let rectHeight = this.headingSize;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            let previousLayoutInfo = previousLayoutNode?.layoutInfo;
            if (previousLayoutInfo) {
                let curNode = this.virtualizer.collection.getItem(node.key);
                let lastNode = this.lastCollection ? this.lastCollection.getItem(node.key) : null;
                rectHeight = previousLayoutNode.layoutInfo.rect[heightProperty];
                isEstimated = width !== previousLayoutInfo.rect[widthProperty] || curNode !== lastNode || previousLayoutInfo.estimatedSize;
            } else {
                rectHeight = node.rendered ? this.estimatedHeadingSize : 0;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT;
        let headerRect = this.orientation === 'horizontal' ? new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, rectHeight, width - y) : new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, width - x, rectHeight);
        let header = new (0, $b758d2f50c514b88$export$7e0eeb9da702a085)('header', node.key, headerRect);
        header.estimatedSize = isEstimated;
        return {
            layoutInfo: header,
            children: [],
            validRect: header.rect.intersection(this.requestedRect),
            node: node
        };
    }
    buildItem(node, x, y) {
        let widthProperty = this.orientation === 'horizontal' ? 'height' : 'width';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let width = this.virtualizer.size[widthProperty] - this.padding - (this.orientation === 'horizontal' ? y : x);
        let rectHeight = this.rowSize;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                rectHeight = previousLayoutNode.layoutInfo.rect[heightProperty];
                isEstimated = width !== previousLayoutNode.layoutInfo.rect[widthProperty] || node !== previousLayoutNode.node || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                rectHeight = this.estimatedRowSize;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = $bed9aed30272a45f$var$$942f06a693c162e2$var$DEFAULT_HEIGHT;
        let rect = this.orientation === 'horizontal' ? new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, rectHeight, width) : new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, y, width, rectHeight);
        let layoutInfo = new (0, $b758d2f50c514b88$export$7e0eeb9da702a085)(node.type, node.key, rect);
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo: layoutInfo,
            children: [],
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node: node
        };
    }
    updateItemSize(key, size) {
        let layoutNode = this.layoutNodes.get(key);
        // If no layoutInfo, item has been deleted/removed.
        if (!layoutNode) return false;
        let collection = this.virtualizer.collection;
        let layoutInfo = layoutNode.layoutInfo;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        layoutInfo.estimatedSize = false;
        if (layoutInfo.rect[heightProperty] !== size[heightProperty]) {
            // Copy layout info rather than mutating so that later caches are invalidated.
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect[heightProperty] = size[heightProperty];
            layoutNode.layoutInfo = newLayoutInfo;
            // Items after this layoutInfo will need to be repositioned to account for the new height.
            // Adjust the validRect so that only items above remain valid.
            this.validRect[heightProperty] = Math.min(this.validRect[heightProperty], layoutInfo.rect[offsetProperty] - this.validRect[offsetProperty]);
            // The requestedRect also needs to be adjusted to account for the height difference.
            this.requestedRect[heightProperty] += newLayoutInfo.rect[heightProperty] - layoutInfo.rect[heightProperty];
            // Invalidate layout for this layout node and all parents
            this.updateLayoutNode(key, layoutInfo, newLayoutInfo);
            let node = layoutInfo.parentKey != null ? collection.getItem(layoutInfo.parentKey) : null;
            while(node){
                this.updateLayoutNode(node.key, layoutInfo, newLayoutInfo);
                node = node.parentKey != null ? collection.getItem(node.parentKey) : null;
            }
            return true;
        }
        return false;
    }
    updateLayoutNode(key, oldLayoutInfo, newLayoutInfo) {
        let n = this.layoutNodes.get(key);
        if (n) {
            // Invalidate by intersecting the validRect of this node with the overall validRect.
            n.validRect = n.validRect.intersection(this.validRect);
            // Replace layout info in LayoutNode
            if (n.layoutInfo === oldLayoutInfo) n.layoutInfo = newLayoutInfo;
        }
    }
    getContentSize() {
        return this.contentSize;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let searchRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(x, Math.max(0, y - this.gap), 1, Math.max(1, this.gap * 2));
        let candidates = this.getVisibleLayoutInfos(searchRect);
        let key = null;
        let minDistance = Infinity;
        for (let candidate of candidates){
            // Ignore items outside the search rect, e.g. persisted keys.
            if (!candidate.rect.intersects(searchRect)) continue;
            let yDist = Math.abs(candidate.rect.y - y);
            let maxYDist = Math.abs(candidate.rect.maxY - y);
            let dist = Math.min(yDist, maxYDist);
            if (dist < minDistance) {
                minDistance = dist;
                key = candidate.key;
            }
        }
        if (key == null || this.virtualizer.collection.size === 0) return {
            type: 'root'
        };
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = layoutInfo.rect;
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: 'before'
        })) target.dropPosition = 'before';
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: 'after'
        })) target.dropPosition = 'after';
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (target.dropPosition === 'before') rect = this.orientation === 'horizontal' ? new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(Math.max(0, layoutInfo.rect.x - this.dropIndicatorThickness / 2), layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height) : new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(layoutInfo.rect.x, Math.max(0, layoutInfo.rect.y - this.dropIndicatorThickness / 2), layoutInfo.rect.width, this.dropIndicatorThickness);
        else if (target.dropPosition === 'after') {
            // Render after last visible descendant of the drop target.
            let targetNode = this.collection.getItem(target.key);
            if (targetNode) {
                let targetLevel = targetNode.level ?? 0;
                let currentKey = this.collection.getKeyAfter(target.key);
                while(currentKey != null){
                    let node = this.collection.getItem(currentKey);
                    if (!node || node.level <= targetLevel) break;
                    layoutInfo = this.getLayoutInfo(currentKey) || layoutInfo;
                    currentKey = this.collection.getKeyAfter(currentKey);
                }
            }
            rect = this.orientation === 'horizontal' ? new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(layoutInfo.rect.maxX - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height) : new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(layoutInfo.rect.x, layoutInfo.rect.maxY - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        } else rect = layoutInfo.rect;
        return new (0, $b758d2f50c514b88$export$7e0eeb9da702a085)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
}
function $bed9aed30272a45f$var$$942f06a693c162e2$var$toArray(collection, predicate) {
    const result = [];
    for (const node of collection)if (predicate(node)) result.push(node);
    return result;
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $658099044b333d15$var$$6bbafa22c92cc056$var$KEY = 0;
class $658099044b333d15$export$1a5223887c560441 {
    constructor(virtualizer, viewType){
        this.virtualizer = virtualizer;
        this.key = ++$658099044b333d15$var$$6bbafa22c92cc056$var$KEY;
        this.viewType = viewType;
        this.children = new Set();
        this.reusableViews = new Map();
        this.layoutInfo = null;
        this.content = null;
        this.rendered = null;
    }
    /**
   * Prepares the view for reuse. Called just before the view is removed from the DOM.
   */ prepareForReuse() {
        this.content = null;
        this.rendered = null;
        this.layoutInfo = null;
    }
    getReusableView(reuseType) {
        // Reusable view queue should be FIFO so that DOM order remains consistent during scrolling.
        // For example, cells within a row should remain in the same order even if the row changes contents.
        // The cells within a row are removed from their parent in order. If the row is reused, the cells
        // should be reused in the new row in the same order they were before.
        let reusable = this.reusableViews.get(reuseType);
        let view = reusable && reusable.length > 0 ? reusable.shift() : new $658099044b333d15$export$7a41b6f219e61634(this.virtualizer, this, reuseType);
        return view;
    }
    reuseChild(child) {
        child.prepareForReuse();
        let reusable = this.reusableViews.get(child.viewType);
        if (!reusable) {
            reusable = [];
            this.reusableViews.set(child.viewType, reusable);
        }
        reusable.push(child);
    }
}
class $658099044b333d15$export$e21886a4eef6b29a extends $658099044b333d15$export$1a5223887c560441 {
    constructor(virtualizer){
        super(virtualizer, 'root');
    }
}
class $658099044b333d15$export$7a41b6f219e61634 extends $658099044b333d15$export$1a5223887c560441 {
    constructor(virtualizer, parent, viewType){
        super(virtualizer, viewType);
        this.parent = parent;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /** Returns whether two sets are equal. */ function $1f426df3a15f9300$export$a8d0d0c8d1c5df64(a, b) {
    if (a === b) return true;
    if (a.size !== b.size) return false;
    for (let key of a){
        if (!b.has(key)) return false;
    }
    return true;
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $bf139ab9a9efecf2$export$4455ee6afb38dcbb {
    setVisibleRect(rect) {
        let time = performance.now() - this.startTime;
        if (time < 500) {
            if (rect.x !== this.visibleRect.x && time > 0) this.velocity.x = (rect.x - this.visibleRect.x) / time;
            if (rect.y !== this.visibleRect.y && time > 0) this.velocity.y = (rect.y - this.visibleRect.y) / time;
        }
        this.startTime = performance.now();
        this.visibleRect = rect;
    }
    getOverscannedRect() {
        let overscanned = this.visibleRect.copy();
        let overscanY = this.visibleRect.height / 3;
        overscanned.height += overscanY;
        if (this.velocity.y < 0) overscanned.y -= overscanY;
        let overscanX = this.visibleRect.width / 3;
        overscanned.width += overscanX;
        if (this.velocity.x < 0) overscanned.x -= overscanX;
        return overscanned;
    }
    constructor(){
        this.startTime = 0;
        this.velocity = new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(0, 0);
        this.visibleRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)();
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $79884fa34aa00102$export$89be5a243e59c4b2 {
    constructor(options){
        this.delegate = options.delegate;
        this.collection = options.collection;
        this.layout = options.layout;
        this.contentSize = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec);
        this.visibleRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d);
        this.size = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec);
        this.persistedKeys = new Set();
        this._visibleViews = new Map();
        this._renderedContent = new WeakMap();
        this._rootView = new (0, $658099044b333d15$export$e21886a4eef6b29a)(this);
        this._isScrolling = false;
        this._invalidationContext = {};
        this._overscanManager = new (0, $bf139ab9a9efecf2$export$4455ee6afb38dcbb)();
    }
    /** Returns whether the given key, or an ancestor, is persisted. */ isPersistedKey(key) {
        // Quick check if the key is directly in the set of persisted keys.
        if (this.persistedKeys.has(key)) return true;
        // If not, check if the key is an ancestor of any of the persisted keys.
        for (let k of this.persistedKeys)while(k != null){
            let layoutInfo = this.layout.getLayoutInfo(k);
            if (!layoutInfo || layoutInfo.parentKey == null) break;
            k = layoutInfo.parentKey;
            if (k === key) return true;
        }
        return false;
    }
    getParentView(layoutInfo) {
        return layoutInfo.parentKey != null ? this._visibleViews.get(layoutInfo.parentKey) : this._rootView;
    }
    getReusableView(layoutInfo) {
        let parentView = this.getParentView(layoutInfo);
        let view = parentView.getReusableView(layoutInfo.type);
        view.layoutInfo = layoutInfo;
        this._renderView(view);
        return view;
    }
    _renderView(reusableView) {
        if (reusableView.layoutInfo) {
            let { type: type, key: key, content: content } = reusableView.layoutInfo;
            reusableView.content = content || this.collection.getItem(key);
            reusableView.rendered = this._renderContent(type, reusableView.content);
        }
    }
    _renderContent(type, content) {
        let cached = content != null ? this._renderedContent.get(content) : null;
        if (cached != null) return cached;
        let rendered = this.delegate.renderView(type, content);
        if (content) this._renderedContent.set(content, rendered);
        return rendered;
    }
    /**
   * Returns the key for the item view currently at the given point.
   */ keyAtPoint(point) {
        let rect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(point.x, point.y, 1, 1);
        let layoutInfos = rect.area === 0 ? [] : this.layout.getVisibleLayoutInfos(rect);
        // Layout may return multiple layout infos in the case of
        // persisted keys, so find the first one that actually intersects.
        for (let layoutInfo of layoutInfos){
            if (layoutInfo.rect.intersects(rect)) return layoutInfo.key;
        }
        return null;
    }
    relayout(context = {}) {
        // Update the layout
        this.layout.update(context);
        this.contentSize = this.layout.getContentSize();
        // Constrain scroll position.
        // If the content changed, scroll to the top.
        let visibleRect = this.visibleRect;
        let contentOffsetX = context.contentChanged ? 0 : visibleRect.x;
        let contentOffsetY = context.contentChanged ? 0 : visibleRect.y;
        contentOffsetX = Math.max(0, Math.min(this.contentSize.width - visibleRect.width, contentOffsetX));
        contentOffsetY = Math.max(0, Math.min(this.contentSize.height - visibleRect.height, contentOffsetY));
        if (contentOffsetX !== visibleRect.x || contentOffsetY !== visibleRect.y) {
            // If the offset changed, trigger a new re-render.
            let rect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(contentOffsetX, contentOffsetY, visibleRect.width, visibleRect.height);
            this.delegate.setVisibleRect(rect);
        } else this.updateSubviews();
    }
    getVisibleLayoutInfos() {
        let isTestEnv = false;
        let isClientWidthMocked = isTestEnv && typeof HTMLElement !== 'undefined' && Object.getOwnPropertyNames(HTMLElement.prototype).includes('clientWidth');
        let isClientHeightMocked = isTestEnv && typeof HTMLElement !== 'undefined' && Object.getOwnPropertyNames(HTMLElement.prototype).includes('clientHeight');
        let rect;
        if (isTestEnv && !(isClientWidthMocked && isClientHeightMocked)) rect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(0, 0, this.contentSize.width, this.contentSize.height);
        else rect = this._overscanManager.getOverscannedRect();
        let layoutInfos = this.layout.getVisibleLayoutInfos(rect);
        let map = new Map;
        for (let layoutInfo of layoutInfos)map.set(layoutInfo.key, layoutInfo);
        return map;
    }
    updateSubviews() {
        let visibleLayoutInfos = this.getVisibleLayoutInfos();
        let removed = new Set();
        for (let [key, view] of this._visibleViews){
            let layoutInfo = visibleLayoutInfos.get(key);
            // If a view's parent changed, treat it as a delete and re-create in the new parent.
            if (!layoutInfo || view.parent !== this.getParentView(layoutInfo)) {
                this._visibleViews.delete(key);
                view.parent.reuseChild(view);
                removed.add(view); // Defer removing in case we reuse this view.
            }
        }
        for (let [key, layoutInfo] of visibleLayoutInfos){
            let view = this._visibleViews.get(key);
            if (!view) {
                view = this.getReusableView(layoutInfo);
                view.parent.children.add(view);
                this._visibleViews.set(key, view);
                removed.delete(view);
            } else {
                view.layoutInfo = layoutInfo;
                let item = this.collection.getItem(layoutInfo.key);
                if (view.content !== item) {
                    if (view.content != null) this._renderedContent.delete(view.content);
                    this._renderView(view);
                }
            }
        }
        // The remaining views in `removed` were not reused to render new items.
        // They should be removed from the DOM. We also clear the reusable view queue
        // here since there's no point holding onto views that have been removed.
        // Doing so hurts performance in the future when reusing elements due to FIFO order.
        for (let view of removed){
            view.parent.children.delete(view);
            view.parent.reusableViews.clear();
        }
        // Reordering DOM nodes is costly, so we defer this until scrolling stops.
        // DOM order does not affect visual order (due to absolute positioning),
        // but does matter for assistive technology users.
        if (!this._isScrolling) for (let key of visibleLayoutInfos.keys()){
            let view = this._visibleViews.get(key);
            view.parent.children.delete(view);
            view.parent.children.add(view);
        }
    }
    /** Performs layout and updates visible views as needed. */ render(opts) {
        let mutableThis = this;
        let needsLayout = false;
        let offsetChanged = false;
        let sizeChanged = false;
        let itemSizeChanged = false;
        let layoutOptionsChanged = false;
        let needsUpdate = false;
        if (opts.collection !== this.collection) {
            mutableThis.collection = opts.collection;
            needsLayout = true;
        }
        if (opts.layout !== this.layout || this.layout.virtualizer !== this) {
            if (this.layout) this.layout.virtualizer = null;
            opts.layout.virtualizer = this;
            mutableThis.layout = opts.layout;
            needsLayout = true;
        }
        if (opts.persistedKeys && !(0, $1f426df3a15f9300$export$a8d0d0c8d1c5df64)(opts.persistedKeys, this.persistedKeys)) {
            mutableThis.persistedKeys = opts.persistedKeys;
            needsUpdate = true;
        }
        if (!this.visibleRect.equals(opts.visibleRect) || !this.size.equals(opts.size)) {
            this._overscanManager.setVisibleRect(opts.visibleRect);
            // Create a rectangle using the scroll position and layout size of the scroll view. This is not the same
            // as the visibleRect, whose width and height may change during window scrolling.
            let oldRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(this.visibleRect.x, this.visibleRect.y, this.size.width, this.size.height);
            let newRect = new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(opts.visibleRect.x, opts.visibleRect.y, opts.size.width, opts.size.height);
            let shouldInvalidate = this.layout.shouldInvalidate(newRect, oldRect);
            if (shouldInvalidate) {
                offsetChanged = !opts.visibleRect.pointEquals(this.visibleRect);
                sizeChanged = !this.size.equals(opts.size);
                needsLayout = true;
            } else needsUpdate = true;
            mutableThis.visibleRect = opts.visibleRect;
            mutableThis.size = opts.size;
        }
        if (opts.invalidationContext !== this._invalidationContext) {
            if (opts.invalidationContext) {
                sizeChanged ||= opts.invalidationContext.sizeChanged || false;
                offsetChanged ||= opts.invalidationContext.offsetChanged || false;
                itemSizeChanged ||= opts.invalidationContext.itemSizeChanged || false;
                layoutOptionsChanged ||= opts.invalidationContext.layoutOptions != null && this._invalidationContext.layoutOptions != null && opts.invalidationContext.layoutOptions !== this._invalidationContext.layoutOptions && this.layout.shouldInvalidateLayoutOptions(opts.invalidationContext.layoutOptions, this._invalidationContext.layoutOptions);
                needsLayout ||= itemSizeChanged || sizeChanged || offsetChanged || layoutOptionsChanged;
            }
            this._invalidationContext = opts.invalidationContext;
        }
        if (opts.isScrolling !== this._isScrolling) {
            this._isScrolling = opts.isScrolling;
            if (!opts.isScrolling) needsUpdate = true;
        }
        if (needsLayout) this.relayout({
            offsetChanged: offsetChanged,
            sizeChanged: sizeChanged,
            itemSizeChanged: itemSizeChanged,
            layoutOptionsChanged: layoutOptionsChanged,
            layoutOptions: this._invalidationContext.layoutOptions
        });
        else if (needsUpdate) this.updateSubviews();
        return Array.from(this._rootView.children);
    }
    getVisibleView(key) {
        return this._visibleViews.get(key);
    }
    invalidate(context) {
        this.delegate.invalidate(context);
    }
    updateItemSize(key, size) {
        if (!this.layout.updateItemSize) return;
        let changed = this.layout.updateItemSize(key, size);
        if (changed) this.invalidate({
            itemSizeChanged: true
        });
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b9ba18ccf5ed5da3$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};
function $b9ba18ccf5ed5da3$export$1505db82fe357e65(opts) {
    let [visibleRect, setVisibleRect] = (0, $acw62.useState)(new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(0, 0, 0, 0));
    let [size, setSize] = (0, $acw62.useState)(new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)());
    let [isScrolling, setScrolling] = (0, $acw62.useState)(false);
    let [invalidationContext, setInvalidationContext] = (0, $acw62.useState)({});
    let visibleRectChanged = (0, $acw62.useRef)(false);
    let [virtualizer] = (0, $acw62.useState)(()=>new (0, $79884fa34aa00102$export$89be5a243e59c4b2)({
            collection: opts.collection,
            layout: opts.layout,
            delegate: {
                setVisibleRect (rect) {
                    setVisibleRect(rect);
                    visibleRectChanged.current = true;
                },
                // TODO: should changing these invalidate the entire cache?
                renderView: opts.renderView,
                invalidate: setInvalidationContext
            }
        }));
    // onVisibleRectChange must be called from an effect, not during render.
    $b9ba18ccf5ed5da3$export$e5c5a5f917a5871c(()=>{
        if (visibleRectChanged.current) {
            visibleRectChanged.current = false;
            opts.onVisibleRectChange(visibleRect);
        }
    });
    let mergedInvalidationContext = (0, $acw62.useMemo)(()=>{
        if (opts.layoutOptions != null) return {
            ...invalidationContext,
            layoutOptions: opts.layoutOptions
        };
        return invalidationContext;
    }, [
        invalidationContext,
        opts.layoutOptions
    ]);
    let visibleViews = virtualizer.render({
        layout: opts.layout,
        collection: opts.collection,
        persistedKeys: opts.persistedKeys,
        layoutOptions: opts.layoutOptions,
        visibleRect: visibleRect,
        size: opts.allowsWindowScrolling ? size : visibleRect,
        invalidationContext: mergedInvalidationContext,
        isScrolling: isScrolling
    });
    let contentSize = virtualizer.contentSize;
    let startScrolling = (0, $acw62.useCallback)(()=>{
        setScrolling(true);
    }, []);
    let endScrolling = (0, $acw62.useCallback)(()=>{
        setScrolling(false);
    }, []);
    let state = (0, $acw62.useMemo)(()=>({
            virtualizer: virtualizer,
            visibleViews: visibleViews,
            setVisibleRect: setVisibleRect,
            size: size,
            setSize: setSize,
            contentSize: contentSize,
            isScrolling: isScrolling,
            startScrolling: startScrolling,
            endScrolling: endScrolling
        }), [
        virtualizer,
        visibleViews,
        setVisibleRect,
        size,
        setSize,
        contentSize,
        isScrolling,
        startScrolling,
        endScrolling
    ]);
    return state;
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult = null;
function $7081bedffe4d6a17$export$faf7630257ad4304(recalculate = false) {
    if ($7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult === null || recalculate) {
        const outerDiv = document.createElement('div');
        const outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        const innerDiv = document.createElement('div');
        const innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult = 'negative';
            else $7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult;
    }
    return $7081bedffe4d6a17$var$$3db4938a3baa5776$var$cachedRTLResult;
}
function $7081bedffe4d6a17$export$1389d168952b34b5(node, direction) {
    let { scrollLeft: scrollLeft } = node;
    // scrollLeft in rtl locales differs across browsers, so normalize.
    // See comment by getRTLOffsetType below for details.
    if (direction === 'rtl') {
        let { scrollWidth: scrollWidth, clientWidth: clientWidth } = node;
        switch($7081bedffe4d6a17$export$faf7630257ad4304()){
            case 'negative':
                scrollLeft = -scrollLeft;
                break;
            case 'positive-descending':
                scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
        }
    }
    return scrollLeft;
}
function $7081bedffe4d6a17$export$ed5fd5ffe5ab0ac(node, direction, scrollLeft) {
    if (direction === 'rtl') switch($7081bedffe4d6a17$export$faf7630257ad4304()){
        case 'negative':
            scrollLeft = -scrollLeft;
            break;
        case 'positive-ascending':
            break;
        default:
            {
                const { clientWidth: clientWidth, scrollWidth: scrollWidth } = node;
                scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
    }
    node.scrollLeft = scrollLeft;
}








var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
function $b3f4c8e1645e6a25$var$$d83ca946696b1300$var$ScrollView(props, ref) {
    ref = (0, $0231fe790c02c958$export$4338b53315abf666)(ref);
    let { scrollViewProps: scrollViewProps, contentProps: contentProps } = $b3f4c8e1645e6a25$export$2ea0c4974da4731b(props, ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "presentation",
        ...scrollViewProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", contentProps, props.children));
}
const $b3f4c8e1645e6a25$export$5665e3d6be6adea = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($b3f4c8e1645e6a25$var$$d83ca946696b1300$var$ScrollView);
function $b3f4c8e1645e6a25$export$2ea0c4974da4731b(props, ref) {
    let { contentSize: contentSize, onVisibleRectChange: onVisibleRectChange, onSizeChange: onSizeChange, innerStyle: innerStyle, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollDirection: scrollDirection = 'both', onScroll: onScrollProp, allowsWindowScrolling: allowsWindowScrolling, ...otherProps } = props;
    let state = (0, $acw62.useRef)({
        // Internal scroll position of the scroll view.
        scrollPosition: new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(),
        // Size of the scroll view.
        size: new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(),
        // Offset of the scroll view relative to the window viewport.
        viewportOffset: new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(),
        // Size of the window viewport.
        viewportSize: new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(),
        scrollEndTime: 0,
        scrollTimeout: null,
        isScrolling: false,
        lastVisibleRect: new (0, $5b63612269032ac9$export$c79fc6492f3af13d)()
    }).current;
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let updateVisibleRect = (0, $acw62.useCallback)(()=>{
        // Intersect the window viewport with the scroll view itself to find the actual visible rectangle.
        // This allows virtualized components to have unbounded height but still virtualize when scrolled with the page.
        // While there may be other scrollable elements between the <body> and the scroll view, we do not take
        // their sizes into account for performance reasons. Their scroll positions are accounted for in viewportOffset
        // though (due to getBoundingClientRect). This may result in more rows than absolutely necessary being rendered,
        // but no more than the entire height of the viewport which is good enough for virtualization use cases.
        let visibleRect = allowsWindowScrolling ? new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(state.viewportOffset.x + state.scrollPosition.x, state.viewportOffset.y + state.scrollPosition.y, Math.max(0, Math.min(state.size.width - state.viewportOffset.x, state.viewportSize.width)), Math.max(0, Math.min(state.size.height - state.viewportOffset.y, state.viewportSize.height))) : new (0, $5b63612269032ac9$export$c79fc6492f3af13d)(state.scrollPosition.x, state.scrollPosition.y, state.size.width, state.size.height);
        // Don't emit updates if the visible area is zero and the last emitted area was also zero.
        if (visibleRect.area > 0 || state.lastVisibleRect.area > 0) {
            onVisibleRectChange(visibleRect);
            state.lastVisibleRect = visibleRect;
        }
    }, [
        state,
        allowsWindowScrolling,
        onVisibleRectChange
    ]);
    let [isScrolling, setScrolling] = (0, $acw62.useState)(false);
    let onScroll = (0, $acw62.useCallback)((e)=>{
        let target = (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e);
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(target, ref.current)) return;
        if (onScrollProp && target === ref.current) onScrollProp(e);
        if (target !== ref.current) {
            // An ancestor element or the window was scrolled. Update the position of the scroll view relative to the viewport.
            let boundingRect = ref.current.getBoundingClientRect();
            let x = boundingRect.x < 0 ? -boundingRect.x : 0;
            let y = boundingRect.y < 0 ? -boundingRect.y : 0;
            if (x === state.viewportOffset.x && y === state.viewportOffset.y) return;
            state.viewportOffset = new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(x, y);
        } else {
            // The scroll view itself was scrolled. Update the local scroll position.
            // Prevent rubber band scrolling from shaking when scrolling out of bounds
            let scrollTop = target.scrollTop;
            let scrollLeft = (0, $7081bedffe4d6a17$export$1389d168952b34b5)(target, direction);
            state.scrollPosition = new (0, $82e7d4b8304ffa13$export$baf26146a414f24a)(Math.max(0, Math.min(scrollLeft, contentSize.width - state.size.width)), Math.max(0, Math.min(scrollTop, contentSize.height - state.size.height)));
        }
        (0, $1u0KT.flushSync)(()=>{
            updateVisibleRect();
            if (!state.isScrolling) {
                state.isScrolling = true;
                setScrolling(true);
                // Pause typekit MutationObserver during scrolling.
                window.dispatchEvent(new Event('tk.disconnect-observer'));
                if (onScrollStart) onScrollStart();
            }
            // So we don't constantly call clearTimeout and setTimeout,
            // keep track of the current timeout time and only reschedule
            // the timer when it is getting close.
            let now = Date.now();
            if (state.scrollEndTime <= now + 50) {
                state.scrollEndTime = now + 300;
                if (state.scrollTimeout != null) clearTimeout(state.scrollTimeout);
                state.scrollTimeout = setTimeout(()=>{
                    state.isScrolling = false;
                    setScrolling(false);
                    state.scrollTimeout = null;
                    window.dispatchEvent(new Event('tk.connect-observer'));
                    if (onScrollEnd) onScrollEnd();
                }, 300);
            }
        });
    }, [
        onScrollProp,
        ref,
        direction,
        state,
        contentSize,
        updateVisibleRect,
        onScrollStart,
        onScrollEnd
    ]);
    (0, $acw62.useEffect)(()=>{
        document.addEventListener('scroll', onScroll, true);
        return ()=>document.removeEventListener('scroll', onScroll, true);
    }, [
        onScroll
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (state.scrollTimeout != null) clearTimeout(state.scrollTimeout);
            if (state.isScrolling) window.dispatchEvent(new Event('tk.connect-observer'));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let isUpdatingSize = (0, $acw62.useRef)(false);
    let updateSize = (0, $acw62.useCallback)((flush)=>{
        let dom = ref.current;
        if (!dom || isUpdatingSize.current) return;
        // Prevent reentrancy when resize observer fires, triggers re-layout that results in
        // content size update, causing below layout effect to fire. This avoids infinite loops.
        isUpdatingSize.current = true;
        let isTestEnv = false;
        let isClientWidthMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes('clientWidth');
        let isClientHeightMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes('clientHeight');
        let clientWidth = dom.clientWidth;
        let clientHeight = dom.clientHeight;
        let w = isTestEnv && !isClientWidthMocked ? Infinity : clientWidth;
        let h = isTestEnv && !isClientHeightMocked ? Infinity : clientHeight;
        // Update the window viewport size.
        let viewportWidth = window.innerWidth;
        let viewportHeight = window.innerHeight;
        let viewportSizeChanged = state.viewportSize.width !== viewportWidth || state.viewportSize.height !== viewportHeight;
        if (viewportSizeChanged) state.viewportSize = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(viewportWidth, viewportHeight);
        if (state.size.width !== w || state.size.height !== h || viewportSizeChanged) {
            state.size = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(w, h);
            flush(()=>{
                updateVisibleRect();
                onSizeChange?.(state.size);
            });
            // If the clientWidth or clientHeight changed, scrollbars appeared or disappeared as
            // a result of the layout update. In this case, re-layout again to account for the
            // adjusted space. In very specific cases this might result in the scrollbars disappearing
            // again, resulting in extra padding. We stop after a maximum of two layout passes to avoid
            // an infinite loop. This matches how browsers behavior with native CSS grid layout.
            if (!isTestEnv && clientWidth !== dom.clientWidth || clientHeight !== dom.clientHeight) {
                state.size = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(dom.clientWidth, dom.clientHeight);
                flush(()=>{
                    updateVisibleRect();
                    onSizeChange?.(state.size);
                });
            }
        }
        isUpdatingSize.current = false;
    }, [
        ref,
        state,
        updateVisibleRect,
        onSizeChange
    ]);
    let updateSizeEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(updateSize);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        // Initialize viewportRect before updating size for the first time.
        state.viewportSize = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(window.innerWidth, window.innerHeight);
        let onWindowResize = ()=>{
            updateSizeEvent((0, $1u0KT.flushSync));
        };
        window.addEventListener('resize', onWindowResize);
        return ()=>window.removeEventListener('resize', onWindowResize);
    }, [
        state
    ]);
    // Update visible rect when the content size changes, in case scrollbars need to appear or disappear.
    let lastContentSize = (0, $acw62.useRef)(null);
    let [update, setUpdate] = (0, $acw62.useState)({});
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (!isUpdatingSize.current && (lastContentSize.current == null || !contentSize.equals(lastContentSize.current))) {
            // React doesn't allow flushSync inside effects, so queue a microtask.
            // We also need to wait until all refs are set (e.g. when passing a ref down from a parent).
            // If we are in an `act` environment, update immediately without a microtask so you don't need
            // to mock timers in tests. In this case, the update is synchronous already.
            // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
            // https://github.com/reactwg/react-18/discussions/102
            // @ts-ignore
            if (typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined') {
                // This is so we update size in a separate render but within the same act. Needs to be setState instead of refs
                // due to strict mode.
                setUpdate({});
                lastContentSize.current = contentSize;
                return;
            } else queueMicrotask(()=>updateSizeEvent((0, $1u0KT.flushSync)));
        }
        lastContentSize.current = contentSize;
    });
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        updateSizeEvent((fn)=>fn());
    }, [
        update
    ]);
    let onResize = (0, $acw62.useCallback)(()=>{
        updateSize((0, $1u0KT.flushSync));
    }, [
        updateSize
    ]);
    (0, $93616957b81f8d1a$export$683480f191c0e3ea)({
        ref: ref,
        box: 'border-box',
        onResize: onResize
    });
    let style = {
        // Reset padding so that relative positioning works correctly. Padding will be done in JS layout.
        padding: 0,
        ...otherProps.style
    };
    if (scrollDirection === 'horizontal') {
        style.overflowX = 'auto';
        style.overflowY = 'hidden';
    } else if (scrollDirection === 'vertical' || contentSize.width === state.size.width) {
        // Set overflow-x: hidden if content size is equal to the width of the scroll view.
        // This prevents horizontal scrollbars from flickering during resizing due to resize observer
        // firing slower than the frame rate, which may cause an infinite re-render loop.
        style.overflowY = 'auto';
        style.overflowX = 'hidden';
    } else style.overflow = 'auto';
    innerStyle = {
        width: Number.isFinite(contentSize.width) ? contentSize.width : undefined,
        height: Number.isFinite(contentSize.height) ? contentSize.height : undefined,
        pointerEvents: isScrolling ? 'none' : 'auto',
        position: 'relative',
        ...innerStyle
    };
    return {
        isScrolling: isScrolling,
        scrollViewProps: {
            ...otherProps,
            style: style
        },
        contentProps: {
            role: 'presentation',
            style: innerStyle
        }
    };
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $269203ff4752c015$export$1da781778207e0a2(options) {
    let { layoutInfo: layoutInfo, virtualizer: virtualizer, ref: ref } = options;
    let key = layoutInfo?.key;
    let updateSize = (0, $acw62.useCallback)(()=>{
        if (key != null && ref.current) {
            let size = $269203ff4752c015$var$$cd3854145620ec6a$var$getSize(ref.current);
            virtualizer.updateItemSize(key, size);
        }
    }, [
        virtualizer,
        key,
        ref
    ]);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (layoutInfo?.estimatedSize) updateSize();
    });
    return {
        updateSize: updateSize
    };
}
function $269203ff4752c015$var$$cd3854145620ec6a$var$getSize(node) {
    // Reset height before measuring so we get the intrinsic size
    let height = node.style.height;
    node.style.height = '';
    let size = new (0, $4fe6fc815a21c442$export$cb6da89c6af1a8ec)(node.scrollWidth, node.scrollHeight);
    node.style.height = height;
    return size;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2e469e655de322fc$export$6796df8ba7398521(props) {
    let { style: style, className: className, layoutInfo: layoutInfo, virtualizer: virtualizer, parent: parent, children: children } = props;
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let ref = (0, $acw62.useRef)(null);
    (0, $269203ff4752c015$export$1da781778207e0a2)({
        layoutInfo: layoutInfo,
        virtualizer: virtualizer,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "presentation",
        ref: ref,
        className: className,
        style: {
            ...$2e469e655de322fc$export$1481e64fbe01b8b3(layoutInfo, direction, parent),
            ...style
        }
    }, children);
}
let $2e469e655de322fc$var$$6c92e9e346cd7b1c$var$cache = new WeakMap();
function $2e469e655de322fc$export$1481e64fbe01b8b3(layoutInfo, dir, parent) {
    let xProperty = dir === 'rtl' ? 'right' : 'left';
    let cached = $2e469e655de322fc$var$$6c92e9e346cd7b1c$var$cache.get(layoutInfo);
    if (cached && cached[xProperty] != null) {
        if (!parent) return cached;
        // Invalidate if the parent position changed.
        let top = layoutInfo.rect.y - parent.rect.y;
        let x = layoutInfo.rect.x - parent.rect.x;
        if (cached.top === top && cached[xProperty] === x) return cached;
    }
    let rectStyles = {
        // TODO: For layoutInfos that are sticky that have parents with overflow visible, their "top" will be relative to the to the nearest scrolling container
        // which WON'T be the parent since the parent has overflow visible. This means we shouldn't offset the height by the parent's position
        // Not 100% about this change here since it is quite ambigious what the scrolling container maybe and how its top is positioned with respect to the
        // calculated layoutInfo.y here
        top: layoutInfo.rect.y - (parent && !(parent.allowOverflow && layoutInfo.isSticky) ? parent.rect.y : 0),
        [xProperty]: layoutInfo.rect.x - (parent && !(parent.allowOverflow && layoutInfo.isSticky) ? parent.rect.x : 0),
        width: layoutInfo.rect.width,
        height: layoutInfo.rect.height
    };
    // Get rid of any non finite values since they aren't valid css values
    Object.entries(rectStyles).forEach(([key, value])=>{
        if (!Number.isFinite(value)) rectStyles[key] = undefined;
    });
    let style = {
        position: layoutInfo.isSticky ? 'sticky' : 'absolute',
        // Sticky elements are positioned in normal document flow. Display inline-block so that they don't push other sticky columns onto the following rows.
        display: layoutInfo.isSticky ? 'inline-block' : undefined,
        overflow: layoutInfo.allowOverflow ? 'visible' : 'hidden',
        opacity: layoutInfo.opacity,
        zIndex: layoutInfo.zIndex,
        transform: layoutInfo.transform ?? undefined,
        contain: 'size layout style',
        ...rectStyles
    };
    $2e469e655de322fc$var$$6c92e9e346cd7b1c$var$cache.set(layoutInfo, style);
    return style;
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $17b5423babfad0e4$var$$143fb904d86051ce$var$VirtualizerContext = (0, $acw62.createContext)(null);
const $17b5423babfad0e4$var$$143fb904d86051ce$var$LayoutContext = (0, $acw62.createContext)(null);
function $17b5423babfad0e4$export$89be5a243e59c4b2(props) {
    let { children: children, layout: layoutProp, layoutOptions: layoutOptions } = props;
    let layout = (0, $acw62.useMemo)(()=>typeof layoutProp === 'function' ? new layoutProp() : layoutProp, [
        layoutProp
    ]);
    let renderer = (0, $acw62.useMemo)(()=>({
            isVirtualized: true,
            layoutDelegate: layout,
            dropTargetDelegate: layout.getDropTargetFromPoint ? layout : undefined,
            CollectionRoot: $17b5423babfad0e4$var$$143fb904d86051ce$var$CollectionRoot,
            CollectionBranch: $17b5423babfad0e4$var$$143fb904d86051ce$var$CollectionBranch
        }), [
        layout
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c9742a26b2470517$export$4feb769f8ddf26c5).Provider, {
        value: renderer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($17b5423babfad0e4$var$$143fb904d86051ce$var$LayoutContext.Provider, {
        value: {
            layout: layout,
            layoutOptions: layoutOptions
        }
    }, children));
}
function $17b5423babfad0e4$var$$143fb904d86051ce$var$CollectionRoot({ collection: collection, persistedKeys: persistedKeys, scrollRef: scrollRef, renderDropIndicator: renderDropIndicator }) {
    let { layout: layout, layoutOptions: layoutOptions } = (0, $acw62.useContext)($17b5423babfad0e4$var$$143fb904d86051ce$var$LayoutContext);
    let layoutOptions2 = layout.useLayoutOptions?.();
    let state = (0, $b9ba18ccf5ed5da3$export$1505db82fe357e65)({
        allowsWindowScrolling: true,
        layout: layout,
        collection: collection,
        renderView: (type, item)=>{
            return item?.render?.(item);
        },
        onVisibleRectChange (rect) {
            let element = scrollRef?.current;
            if (element) {
                element.scrollLeft = rect.x;
                element.scrollTop = rect.y;
            }
        },
        persistedKeys: persistedKeys,
        layoutOptions: (0, $acw62.useMemo)(()=>{
            if (layoutOptions && layoutOptions2) return {
                ...layoutOptions,
                ...layoutOptions2
            };
            return layoutOptions || layoutOptions2;
        }, [
            layoutOptions,
            layoutOptions2
        ])
    });
    let { contentProps: contentProps } = (0, $b3f4c8e1645e6a25$export$2ea0c4974da4731b)({
        onVisibleRectChange: state.setVisibleRect,
        onSizeChange: state.setSize,
        contentSize: state.contentSize,
        onScrollStart: state.startScrolling,
        onScrollEnd: state.endScrolling,
        allowsWindowScrolling: true
    }, scrollRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", contentProps, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($17b5423babfad0e4$var$$143fb904d86051ce$var$VirtualizerContext.Provider, {
        value: state
    }, $17b5423babfad0e4$var$$143fb904d86051ce$var$renderChildren(null, state.visibleViews, renderDropIndicator)));
}
function $17b5423babfad0e4$var$$143fb904d86051ce$var$CollectionBranch({ parent: parent, renderDropIndicator: renderDropIndicator }) {
    let virtualizer = (0, $acw62.useContext)($17b5423babfad0e4$var$$143fb904d86051ce$var$VirtualizerContext);
    let parentView = virtualizer.virtualizer.getVisibleView(parent.key);
    return $17b5423babfad0e4$var$$143fb904d86051ce$var$renderChildren(parentView, Array.from(parentView.children), renderDropIndicator);
}
function $17b5423babfad0e4$var$$143fb904d86051ce$var$renderChildren(parent, children, renderDropIndicator) {
    return children.map((view)=>$17b5423babfad0e4$var$$143fb904d86051ce$var$renderWrapper(parent, view, renderDropIndicator));
}
function $17b5423babfad0e4$var$$143fb904d86051ce$var$renderWrapper(parent, reusableView, renderDropIndicator) {
    let rendered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2e469e655de322fc$export$6796df8ba7398521), {
        key: reusableView.key,
        layoutInfo: reusableView.layoutInfo,
        virtualizer: reusableView.virtualizer,
        parent: parent?.layoutInfo
    }, reusableView.rendered);
    let { collection: collection, layout: layout } = reusableView.virtualizer;
    let node = reusableView.content;
    if (node?.type === 'item' && renderDropIndicator && layout.getDropTargetLayoutInfo) rendered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        key: reusableView.key
    }, $17b5423babfad0e4$var$$143fb904d86051ce$var$renderDropIndicatorWrapper(parent, reusableView, {
        type: 'item',
        key: reusableView.content.key,
        dropPosition: 'before'
    }, renderDropIndicator), rendered, (0, $c9742a26b2470517$export$2dbbd341daed716d)(collection, node, (target)=>$17b5423babfad0e4$var$$143fb904d86051ce$var$renderDropIndicatorWrapper(parent, reusableView, target, renderDropIndicator)));
    return rendered;
}
function $17b5423babfad0e4$var$$143fb904d86051ce$var$renderDropIndicatorWrapper(parent, reusableView, target, renderDropIndicator) {
    let indicator = renderDropIndicator(target);
    if (indicator) {
        let layoutInfo = reusableView.virtualizer.layout.getDropTargetLayoutInfo(target);
        indicator = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2e469e655de322fc$export$6796df8ba7398521), {
            layoutInfo: layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent?.layoutInfo
        }, indicator);
    }
    return indicator;
}



var $acw62 = parcelRequire("acw62");
function $856d6c0e128934d1$export$86e744c8a86f554d({ text: text }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center h-full text-lg text-neutral-700 dark:text-neutral-300 font-semibold",
        children: text
    });
}
function $856d6c0e128934d1$export$54c2e3dc7acea9f5({ 'aria-label': ariaLabel, items: items, selectedKeys: selectedKeys, isLoading: isLoading, isLoadingMore: isLoadingMore, hasMore: hasMore = true, onLoadMore: onLoadMore, children: children, header: header }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-[280px] shrink-0 flex flex-col bg-daw-white rounded-xl shadow-card my-2",
        children: [
            header,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17b5423babfad0e4$export$89be5a243e59c4b2), {
                    layout: (0, $bed9aed30272a45f$export$cacbb3924155d68e),
                    layoutOptions: {
                        estimatedRowSize: 56,
                        padding: 8,
                        gap: 4
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$41f133550aa26f48), {
                        "aria-label": ariaLabel,
                        selectionMode: "single",
                        selectionBehavior: "replace",
                        // @ts-ignore
                        linkBehavior: "selection",
                        selectedKeys: selectedKeys,
                        disallowEmptySelection: true,
                        className: "h-full overflow-auto",
                        style: {
                            display: 'block',
                            padding: 0
                        },
                        renderEmptyState: ()=>isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex justify-center items-center h-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-5 h-5 border-2 border-daw-gray-300 border-t-blue-500 rounded-full animate-spin"
                                })
                            }),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18968b9ec17502c7$export$fb8073518f34e6ec), {
                                items: items,
                                children: children
                            }),
                            !isLoading && hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$8e6d031a08cf56a1), {
                                isLoading: isLoadingMore,
                                onLoadMore: onLoadMore,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex justify-center items-center h-12",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-5 h-5 border-2 border-daw-gray-300 border-t-blue-500 rounded-full animate-spin"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function $856d6c0e128934d1$export$a7b06bfba60a8a78({ id: id, href: href, textValue: textValue, onPreload: onPreload, icon: icon, label: label, description: description, trailingIcon: trailingIcon }) {
    const ref = (0, $acw62.useCallback)((el)=>{
        if (!onPreload || !el) return;
        let timer = null;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) timer = setTimeout(()=>{
                onPreload();
                observer.disconnect();
            }, 500);
            else if (timer != null) {
                clearTimeout(timer);
                timer = null;
            }
        }, {
            rootMargin: '200px'
        });
        observer.observe(el);
        return ()=>{
            observer.disconnect();
            if (timer != null) clearTimeout(timer);
        };
    }, [
        onPreload
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
        ref: ref,
        id: id,
        href: href,
        textValue: textValue,
        style: {
            gridTemplateColumns: [
                icon ? 'auto' : null,
                '1fr',
                trailingIcon ? 'auto' : null
            ].filter(Boolean).join(' ')
        },
        className: `group grid gap-y-0.5 gap-x-3 items-baseline rounded-md cursor-default px-3 py-2 hover:bg-daw-gray-200 selected:bg-daw-gray-900 hover:aria-selected:bg-daw-gray-900 selected:text-daw-white outline-none focus-visible:outline-2 outline-blue-600 outline-offset-2`,
        children: [
            icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "col-start-1",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b7271d3af613df1$export$5f1af8db9871e1d6), {
                slot: "label",
                style: {
                    gridColumnStart: icon ? 2 : 1
                },
                className: "col-start-2 col-span-2 text-sm font-medium line-clamp-2",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b7271d3af613df1$export$5f1af8db9871e1d6), {
                slot: "description",
                style: {
                    gridColumnStart: icon ? 2 : 1
                },
                className: "self-center text-xs text-daw-gray-600 group-aria-selected:text-daw-gray-300 truncate",
                children: description
            }),
            trailingIcon != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    gridColumnStart: icon ? 3 : 2
                },
                className: "row-start-2 self-center",
                children: trailingIcon
            })
        ]
    });
}


const $f0891611a3844acc$var$PER_PAGE = 50;
const $f0891611a3844acc$var$getNotificationsKey = (pageIndex, previousPageData)=>{
    if (previousPageData && previousPageData.length < $f0891611a3844acc$var$PER_PAGE) return null;
    return [
        'notifications',
        pageIndex + 1
    ];
};
async function $f0891611a3844acc$var$fetchNotificationsPage([, page]) {
    let res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).activity.listNotificationsForAuthenticatedUser({
        page: page,
        per_page: $f0891611a3844acc$var$PER_PAGE,
        all: true,
        headers: {
            'If-None-Match': ''
        }
    });
    return res.data;
}
function $f0891611a3844acc$var$preloadNotification(item) {
    switch(item?.subject.type){
        case 'PullRequest':
            (0, $92995ef58fa84f45$export$d8ee8bed60538a6a).preload(item.repository.owner.login, item.repository.name, Number(item.subject.url.split('/').pop()));
            break;
        case 'Issue':
            (0, $376a85c6166d1b77$export$8f76aa81e935a507).preload(item.repository.owner.login, item.repository.name, Number(item.subject.url.split('/').pop()));
            break;
        case 'Discussion':
            (0, $9efcf42537b67d79$export$513ccb98c53b8039)((0, $e37a2db30c2ebb15$export$6c4ed0cff880690c).query(), {
                owner: item.repository.owner.login,
                repo: item.repository.name,
                number: Number(item.subject.url.split('/').pop())
            });
            break;
        case 'Commit':
            (0, $5379651f9cfa2f72$export$fb998822db15ddc).preload(item.repository.owner.login, item.repository.name, item.subject.url.split('/').pop());
            break;
    }
}
function $f0891611a3844acc$export$440662f585edec66() {
    let { data: data, size: size, setSize: setSize, isLoading: isLoading, isValidating: isValidating, mutate: mutate, error: error } = (0, $25f67ffa4087bf8c$export$2e2bcd8739ae039)($f0891611a3844acc$var$getNotificationsKey, $f0891611a3844acc$var$fetchNotificationsPage);
    let { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    let notifications = data?.flat() ?? [];
    let isLoadingMore = !isLoading && isValidating && (data?.length ?? 0) < size;
    let hasMore = !data || data[data.length - 1]?.length >= $f0891611a3844acc$var$PER_PAGE;
    const markAsRead = (0, $acw62.useCallback)((id)=>{
        mutate((currentData)=>currentData?.map((page)=>page.map((n)=>n.id === id ? {
                        ...n,
                        unread: false
                    } : n)), {
            revalidate: false
        });
        (0, $9efcf42537b67d79$export$85c7dd0b0150981e).activity.markThreadAsRead({
            thread_id: Number(id)
        });
    }, [
        mutate
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$54c2e3dc7acea9f5), {
                "aria-label": "Notifications",
                items: notifications,
                selectedKeys: [
                    pathname
                ],
                isLoading: isLoading,
                isLoadingMore: isLoadingMore,
                hasMore: hasMore,
                onLoadMore: ()=>{
                    if (!isLoading && !isValidating && !error) setSize(size + 1);
                },
                children: (item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f0891611a3844acc$var$NotificationItem, {
                        item: item
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-auto flex flex-col",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d88e17cec3da5cb4$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$86e744c8a86f554d), {
                                text: "No notification selected."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            path: ":id",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f0891611a3844acc$var$NotificationDetail, {
                                notifications: notifications,
                                markAsRead: markAsRead
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$f0891611a3844acc$export$440662f585edec66.preload = ()=>{
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'notifications',
        1
    ], $f0891611a3844acc$var$fetchNotificationsPage);
};
function $f0891611a3844acc$var$NotificationItem({ item: item }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$a7b06bfba60a8a78), {
        id: `/notifications/${item.id}`,
        href: `/notifications/${item.id}`,
        textValue: item.subject.title,
        onPreload: ()=>$f0891611a3844acc$var$preloadNotification(item),
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "w-[10px] h-[10px]",
            children: item.unread && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-label": "Unread",
                role: "status",
                className: "rounded-full bg-blue-500 w-full h-full"
            })
        }),
        label: item.subject.title,
        description: `${item.repository.full_name} #${item.subject.url?.split('/').pop()}`
    });
}
function $f0891611a3844acc$var$NotificationDetail({ notifications: notifications, markAsRead: markAsRead }) {
    let { id: id } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    let item = id ? notifications.find((n)=>n.id === id) : undefined;
    (0, $acw62.useEffect)(()=>{
        if (item?.unread) markAsRead(item.id);
    }, [
        item
    ]);
    switch(item?.subject.type){
        case 'PullRequest':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92995ef58fa84f45$export$d8ee8bed60538a6a), {
                owner: item.repository.owner.login,
                repo: item.repository.name,
                number: Number(item.subject.url.split('/').pop())
            }, item.id);
        case 'Issue':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $376a85c6166d1b77$export$8f76aa81e935a507), {
                owner: item.repository.owner.login,
                repo: item.repository.name,
                number: Number(item.subject.url.split('/').pop())
            }, item.id);
        case 'Discussion':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e37a2db30c2ebb15$export$6c4ed0cff880690c), {
                owner: item.repository.owner.login,
                repo: item.repository.name,
                number: Number(item.subject.url.split('/').pop())
            }, item.id);
        case 'Commit':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5379651f9cfa2f72$export$fb998822db15ddc), {
                owner: item.repository.owner.login,
                repo: item.repository.name,
                sha: item.subject.url.split('/').pop()
            }, item.id);
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$86e744c8a86f554d), {
                text: item ? `Unknown type: ${item.subject.type}` : 'No notification selected.'
            });
    }
}








var $acw62 = parcelRequire("acw62");











/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2abf9658a276383b$export$37b65e5b5444d35c = new WeakMap();







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b53b6428664a7c85$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        onPress (e) {
            onPress?.(e);
            state.setSelectedValue(value);
            ref.current?.focus();
        }
    });
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)((0, $195af97314dd822a$export$9d1611c77c2fe928)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, $195af97314dd822a$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name: name, form: form, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $2abf9658a276383b$export$37b65e5b5444d35c).get(state);
    (0, $a71202214a10b9ab$export$5add1d006293d136)(ref, state.defaultSelectedValue, state.setSelectedValue);
    (0, $9aec99f022b72b42$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior
    }, state, ref);
    return {
        labelProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(labelProps, (0, $acw62.useMemo)(()=>({
                onClick: (e)=>e.preventDefault(),
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            ...interactions,
            type: 'radio',
            name: name,
            form: form,
            tabIndex: tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === 'native',
            checked: checked,
            value: value,
            onChange: onChange,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }),
        isDisabled: isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}











/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $236b6c20ae958b83$export$62b9571f283ff5c2(props, state) {
    let { name: name, form: form, isReadOnly: isReadOnly, isRequired: isRequired, isDisabled: isDisabled, orientation: orientation = 'vertical', validationBehavior: validationBehavior = 'aria' } = props;
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $ec7707e2bf6dfe59$export$294aa081a6c6f55d)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        onBlurWithin (e) {
            props.onBlur?.(e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case 'ArrowRight':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'prev';
                else nextDir = 'next';
                break;
            case 'ArrowLeft':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'next';
                else nextDir = 'prev';
                break;
            case 'ArrowDown':
                nextDir = 'next';
                break;
            case 'ArrowUp':
                nextDir = 'prev';
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = (0, $5c60d71a4f66bda5$export$2d6ec8fc375ceafa)(e.currentTarget, {
            from: (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e),
            accept: (node)=>node instanceof (0, $c8e82650210ecd78$export$f21a1ffae260145a)(node).HTMLInputElement && node.type === 'radio'
        });
        let nextElem;
        if (nextDir === 'next') {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = (0, $3af2a5641bd71461$export$f680877a34711e37)(name);
    (0, $2abf9658a276383b$export$37b65e5b5444d35c).set(state, {
        name: groupName,
        form: form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    return {
        radioGroupProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: 'radiogroup',
            onKeyDown: onKeyDown,
            'aria-invalid': state.isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            'aria-disabled': isDisabled || undefined,
            'aria-orientation': orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $a3335b0230d2d7de$var$$384704861d32dbed$var$instance = Math.round(Math.random() * 10000000000);
let $a3335b0230d2d7de$var$$384704861d32dbed$var$i = 0;
function $a3335b0230d2d7de$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, $acw62.useMemo)(()=>props.name || `radio-group-${$a3335b0230d2d7de$var$$384704861d32dbed$var$instance}-${++$a3335b0230d2d7de$var$$384704861d32dbed$var$i}`, [
        props.name
    ]);
    let [selectedValue, setSelected] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(props.value, props.defaultValue ?? null, props.onChange);
    let [initialValue] = (0, $acw62.useState)(selectedValue);
    let [lastFocusedValue, setLastFocusedValue] = (0, $acw62.useState)(null);
    let validation = (0, $0c6ddd323fa7af24$export$fc1a364ae1f3ff10)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    return {
        ...validation,
        name: name,
        selectedValue: selectedValue,
        defaultSelectedValue: props.value !== undefined ? initialValue : props.defaultValue ?? null,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? 'invalid' : null),
        isInvalid: isInvalid
    };
}



var $acw62 = parcelRequire("acw62");




/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8286518ff8c479ac$export$a79eda4ff50e30b6 = (0, $acw62.createContext)(null);
const $8286518ff8c479ac$export$b118023277d4a5c3 = (0, $acw62.createContext)(null);
const $8286518ff8c479ac$export$29d84393af70866c = (0, $acw62.createContext)(null);
const $8286518ff8c479ac$export$a98f0dcb43a68a25 = (0, $acw62.forwardRef)(function RadioGroup(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $8286518ff8c479ac$export$a79eda4ff50e30b6);
    let { validationBehavior: formValidationBehavior } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)((0, $bdd138f35fdd977e$export$c24727297075ec6a)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $a3335b0230d2d7de$export$bca9d026f8e704eb)({
        ...props,
        validationBehavior: validationBehavior
    });
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { radioGroupProps: radioGroupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $236b6c20ae958b83$export$62b9571f283ff5c2)({
        ...props,
        label: label,
        validationBehavior: validationBehavior
    }, state);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            orientation: props.orientation || 'vertical',
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: state.isRequired,
            isInvalid: state.isInvalid,
            state: state
        },
        defaultClassName: 'react-aria-RadioGroup'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, radioGroupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'vertical',
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $8286518ff8c479ac$export$29d84393af70866c,
                state
            ],
            [
                (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $76bbfd363f450690$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08cc935c33eff3e5$export$758399f318e6385a), null, renderProps.children)));
});
const $8286518ff8c479ac$export$d7b12c4107be0d61 = (0, $acw62.forwardRef)(function Radio(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(otherProps, ref, $8286518ff8c479ac$export$b118023277d4a5c3);
    let state = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($8286518ff8c479ac$export$29d84393af70866c);
    let inputRef = (0, $0231fe790c02c958$export$4338b53315abf666)((0, $acw62.useMemo)(()=>(0, $eed06c8362986bd2$export$c9058316764c140e)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isPressed: isPressed } = (0, $b53b6428664a7c85$export$37b0961d2f4751e2)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $0cde480b945a073a$export$4e328f61c538687f)();
    let interactionDisabled = isDisabled || state.isReadOnly;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        ...props,
        isDisabled: interactionDisabled
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-Radio',
        values: {
            isSelected: isSelected,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isRequired: state.isRequired
        }
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).label, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b36921254027e01$export$439d29a4e110a164), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(inputProps, focusProps),
        ref: inputRef
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f978dd1340ad1a86$export$c9549807523555e0).Provider, {
        value: {
            isSelected: isSelected
        }
    }, renderProps.children));
});











/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cac2e2c469171308$export$ec98120685d4f57d = new WeakMap();






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b9aeac92b61c23ac$export$49ff6f28c54f1cbe(props, state) {
    let { isDisabled: isDisabled, name: name, form: form, validationBehavior: validationBehavior = 'aria' } = props;
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $ec7707e2bf6dfe59$export$294aa081a6c6f55d)({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    (0, $cac2e2c469171308$export$ec98120685d4f57d).set(state, {
        name: name,
        form: form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    return {
        groupProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            role: 'group',
            'aria-disabled': isDisabled || undefined,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}







/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b1a1d7847d21bc45$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, form: form, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, validationState: validationState = 'valid', isInvalid: isInvalid, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e).checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp,
        onClick: onClick,
        onPress (e) {
            onPress?.(e);
            state.toggle();
            ref.current?.focus();
        },
        isDisabled: isDisabled || isReadOnly
    });
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)(props, ref);
    let interactions = (0, $195af97314dd822a$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    (0, $a71202214a10b9ab$export$5add1d006293d136)(ref, state.defaultSelected, state.setSelected);
    return {
        labelProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
            'aria-invalid': isInvalid || validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            form: form,
            type: 'checkbox',
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === 'invalid'
    };
}






var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $51d31a8dca0485a8$export$e375f10ce42261c5(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, $0c6ddd323fa7af24$export$fc1a364ae1f3ff10)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $b1a1d7847d21bc45$export$cbe85ee05b554577)({
        ...props,
        isInvalid: isInvalid
    }, state, inputRef);
    (0, $9aec99f022b72b42$export$b8473d3665f3a75a)(props, validationState, inputRef);
    let { isIndeterminate: isIndeterminate, isRequired: isRequired, validationBehavior: validationBehavior = 'aria' } = props;
    (0, $acw62.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    // Reset validation state on label press for checkbox with a hidden input.
    let { pressProps: pressProps } = (0, $1aae0f2f42307dd4$export$45712eceda6fad21)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            // @ts-expect-error
            let { [(0, $0c6ddd323fa7af24$export$a763b9476acd3eb)]: groupValidationState } = props;
            let { commitValidation: commitValidation } = groupValidationState ? groupValidationState : validationState;
            commitValidation();
        }
    });
    return {
        labelProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(labelProps, pressProps, (0, $acw62.useMemo)(()=>({
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: {
            ...inputProps,
            checked: isSelected,
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            required: isRequired && validationBehavior === 'native'
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}





var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a99094766b061965$export$353b32fc6898d37d(props, state, inputRef) {
    const toggleState = (0, $1e509f521b17159b$export$8042c6c013fd5226)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        defaultSelected: state.defaultValue.includes(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { name: name, form: form, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $cac2e2c469171308$export$ec98120685d4f57d).get(state);
    validationBehavior = props.validationBehavior ?? validationBehavior;
    // Local validation for this checkbox.
    let { realtimeValidation: realtimeValidation } = (0, $0c6ddd323fa7af24$export$fc1a364ae1f3ff10)({
        ...props,
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: 'aria'
    });
    // Update the checkbox group state when realtime validation changes.
    let nativeValidation = (0, $acw62.useRef)((0, $0c6ddd323fa7af24$export$dad6ae84456c676a));
    let updateValidation = ()=>{
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, $acw62.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    let displayValidation = validationBehavior === 'native' ? state.displayValidation : combinedRealtimeValidation;
    let res = (0, $51d31a8dca0485a8$export$e375f10ce42261c5)({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        form: props.form || form,
        isRequired: props.isRequired ?? state.isRequired,
        validationBehavior: validationBehavior,
        [(0, $0c6ddd323fa7af24$export$a763b9476acd3eb)]: {
            realtimeValidation: combinedRealtimeValidation,
            displayValidation: displayValidation,
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation,
            updateValidation (v) {
                nativeValidation.current = v;
                updateValidation();
            }
        }
    }, toggleState, inputRef);
    return {
        ...res,
        inputProps: {
            ...res.inputProps,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }
    };
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $29336e95afb6a038$export$daff6da51032a415(props = {}) {
    let [selectedValues, setValue] = (0, $6f904fcfe20ed0fd$export$40bfa8c7b0832715)(props.value, props.defaultValue || [], props.onChange);
    let [initialValues] = (0, $acw62.useState)(selectedValues);
    let isRequired = !!props.isRequired && selectedValues.length === 0;
    let invalidValues = (0, $acw62.useRef)(new Map());
    let validation = (0, $0c6ddd323fa7af24$export$fc1a364ae1f3ff10)({
        ...props,
        value: selectedValues
    });
    let isInvalid = validation.displayValidation.isInvalid;
    const state = {
        ...validation,
        value: selectedValues,
        defaultValue: props.defaultValue ?? initialValues,
        setValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected (value) {
            return selectedValues.includes(value);
        },
        addValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue((selectedValues)=>{
                if (!selectedValues.includes(value)) return selectedValues.concat(value);
                return selectedValues;
            });
        },
        removeValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
        },
        toggleValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
            else setValue(selectedValues.concat(value));
        },
        setInvalid (value, v) {
            let s = new Map(invalidValues.current);
            if (v.isInvalid) s.set(value, v);
            else s.delete(value);
            invalidValues.current = s;
            validation.updateValidation((0, $0c6ddd323fa7af24$export$75ee7c75d68f5b0e)(...s.values()));
        },
        validationState: props.validationState ?? (isInvalid ? 'invalid' : null),
        isInvalid: isInvalid,
        isRequired: isRequired
    };
    return state;
}






var $acw62 = parcelRequire("acw62");





/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c8237d34e7f22709$export$b085522c77523c51 = (0, $acw62.createContext)(null);
const $c8237d34e7f22709$export$baf37c4be89255b8 = (0, $acw62.createContext)(null);
const $c8237d34e7f22709$export$139c5b8563afc1fc = (0, $acw62.createContext)(null);
const $c8237d34e7f22709$export$4aa08d5625cb8ead = (0, $acw62.forwardRef)(function CheckboxGroup(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $c8237d34e7f22709$export$baf37c4be89255b8);
    let { validationBehavior: formValidationBehavior } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)((0, $bdd138f35fdd977e$export$c24727297075ec6a)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $29336e95afb6a038$export$daff6da51032a415)({
        ...props,
        validationBehavior: validationBehavior
    });
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps: groupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $b9aeac92b61c23ac$export$49ff6f28c54f1cbe)({
        ...props,
        label: label,
        validationBehavior: validationBehavior
    }, state);
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false,
            isInvalid: state.isInvalid,
            state: state
        },
        defaultClassName: 'react-aria-CheckboxGroup'
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": props.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                $c8237d34e7f22709$export$139c5b8563afc1fc,
                state
            ],
            [
                (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $76bbfd363f450690$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, renderProps.children));
});
const $c8237d34e7f22709$export$48513f6b9f8ce62d = (0, $acw62.forwardRef)(function Checkbox(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(otherProps, ref, $c8237d34e7f22709$export$b085522c77523c51);
    let { validationBehavior: formValidationBehavior } = (0, $78f7e4721048d8d5$export$fabf2dc03a41866e)((0, $bdd138f35fdd977e$export$c24727297075ec6a)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let groupState = (0, $acw62.useContext)($c8237d34e7f22709$export$139c5b8563afc1fc);
    let inputRef = (0, $0231fe790c02c958$export$4338b53315abf666)((0, $acw62.useMemo)(()=>(0, $eed06c8362986bd2$export$c9058316764c140e)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isPressed: isPressed, isInvalid: isInvalid } = groupState ? (0, $a99094766b061965$export$353b32fc6898d37d)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
        // it's passed explicitly here to avoid typescript error (requires ignore).
        // @ts-ignore
        value: props.value,
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, groupState, inputRef) : (0, $51d31a8dca0485a8$export$e375f10ce42261c5)({
        ...(0, $78f7e4721048d8d5$export$ef03459518577ad4)(props),
        children: typeof props.children === 'function' ? true : props.children,
        validationBehavior: validationBehavior
    }, (0, $1e509f521b17159b$export$8042c6c013fd5226)(props), inputRef);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $0cde480b945a073a$export$4e328f61c538687f)();
    let isInteractionDisabled = isDisabled || isReadOnly;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-Checkbox',
        values: {
            isSelected: isSelected,
            isIndeterminate: props.isIndeterminate || false,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isInvalid: isInvalid,
            isRequired: props.isRequired || false
        }
    });
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).label, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-indeterminate": props.isIndeterminate || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b36921254027e01$export$439d29a4e110a164), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
});












/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e2dc165b0d9e239f$export$5b9bb410392e3991 = new WeakMap();
function $e2dc165b0d9e239f$export$f45c25170b9a99c2(state, key) {
    let { id: id } = $e2dc165b0d9e239f$export$5b9bb410392e3991.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${$e2dc165b0d9e239f$export$e0c709538cb8ae18(key)}`;
}
function $e2dc165b0d9e239f$export$e0c709538cb8ae18(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}




var $d9205d0fc80e0f56$export$2e2bcd8739ae039 = {};
$d9205d0fc80e0f56$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{63A}\u{64A}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "longPressToSelect": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{64B}\u{627} \u{644}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{648}\u{636}\u{639} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}.`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectedAll": `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{627}\u{635}\u{631}`,
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`
};


var $b4f81976cf269e47$export$2e2bcd8739ae039 = {};
$b4f81976cf269e47$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{435} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{438} \u{437}\u{430}\u{434}\u{440}\u{44A}\u{436}\u{442}\u{435} \u{437}\u{430} \u{434}\u{430} \u{432}\u{43B}\u{435}\u{437}\u{435}\u{442}\u{435} \u{432} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43D} \u{440}\u{435}\u{436}\u{438}\u{43C}.`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`
};


var $2202d384b78f2aa3$export$2e2bcd8739ae039 = {};
$2202d384b78f2aa3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Polo\u{17E}ka ${args.item} nen\xed vybr\xe1na.`,
    "longPressToSelect": `Dlouh\xfdm stisknut\xedm p\u{159}ejdete do re\u{17E}imu v\xfdb\u{11B}ru.`,
    "select": `Vybrat`,
    "selectedAll": `Vybr\xe1ny v\u{161}echny polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nevybr\xe1ny \u{17E}\xe1dn\xe9 polo\u{17E}ky`,
            one: ()=>`Vybr\xe1na ${formatter.number(args.count)} polo\u{17E}ka`,
            other: ()=>`Vybr\xe1no ${formatter.number(args.count)} polo\u{17E}ek`
        })}.`,
    "selectedItem": (args)=>`Vybr\xe1na polo\u{17E}ka ${args.item}.`
};


var $5b68367a889e0c01$export$2e2bcd8739ae039 = {};
$5b68367a889e0c01$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ikke valgt.`,
    "longPressToSelect": `Lav et langt tryk for at aktivere valgtilstand.`,
    "select": `V\xe6lg`,
    "selectedAll": `Alle elementer valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer valgt`,
            one: ()=>`${formatter.number(args.count)} element valgt`,
            other: ()=>`${formatter.number(args.count)} elementer valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} valgt.`
};


var $5187648348b4986d$export$2e2bcd8739ae039 = {};
$5187648348b4986d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nicht ausgew\xe4hlt.`,
    "longPressToSelect": `Gedr\xfcckt halten, um Auswahlmodus zu \xf6ffnen.`,
    "select": `Ausw\xe4hlen`,
    "selectedAll": `Alle Elemente ausgew\xe4hlt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Keine Elemente ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} Element ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} Elemente ausgew\xe4hlt`
        })}.`,
    "selectedItem": (args)=>`${args.item} ausgew\xe4hlt.`
};


var $909f2588c598a36d$export$2e2bcd8739ae039 = {};
$909f2588c598a36d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`,
    "longPressToSelect": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3C0}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3BB}\u{3B5}\u{3B9}\u{3C4}\u{3BF}\u{3C5}\u{3C1}\u{3B3}\u{3AF}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}.`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1} \u{3C4}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
            one: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "selectedItem": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`
};


var $5aea3cec31347491$export$2e2bcd8739ae039 = {};
$5aea3cec31347491$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};


var $6f0ff23823a024f9$export$2e2bcd8739ae039 = {};
$6f0ff23823a024f9$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} no seleccionado.`,
    "longPressToSelect": `Mantenga pulsado para abrir el modo de selecci\xf3n.`,
    "select": `Seleccionar`,
    "selectedAll": `Todos los elementos seleccionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ning\xfan elemento seleccionado`,
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} seleccionado.`
};


var $1585bec906cdc099$export$2e2bcd8739ae039 = {};
$1585bec906cdc099$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} pole valitud.`,
    "longPressToSelect": `Valikure\u{17E}iimi sisenemiseks vajutage pikalt.`,
    "select": `Vali`,
    "selectedAll": `K\xf5ik \xfcksused valitud.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\xdcksusi pole valitud`,
            one: ()=>`${formatter.number(args.count)} \xfcksus valitud`,
            other: ()=>`${formatter.number(args.count)} \xfcksust valitud`
        })}.`,
    "selectedItem": (args)=>`${args.item} valitud.`
};


var $706239cfea801da0$export$2e2bcd8739ae039 = {};
$706239cfea801da0$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Kohdetta ${args.item} ei valittu.`,
    "longPressToSelect": `Siirry valintatilaan painamalla pitk\xe4\xe4n.`,
    "select": `Valitse`,
    "selectedAll": `Kaikki kohteet valittu.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei yht\xe4\xe4n kohdetta valittu`,
            one: ()=>`${formatter.number(args.count)} kohde valittu`,
            other: ()=>`${formatter.number(args.count)} kohdetta valittu`
        })}.`,
    "selectedItem": (args)=>`${args.item} valittu.`
};


var $59828e85257b99f1$export$2e2bcd8739ae039 = {};
$59828e85257b99f1$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non s\xe9lectionn\xe9.`,
    "longPressToSelect": `Appuyez de mani\xe8re prolong\xe9e pour passer en mode de s\xe9lection.`,
    "select": `S\xe9lectionner`,
    "selectedAll": `Tous les \xe9l\xe9ments s\xe9lectionn\xe9s.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "selectedItem": (args)=>`${args.item} s\xe9lectionn\xe9.`
};


var $41e87e2aea4eb5f7$export$2e2bcd8739ae039 = {};
$41e87e2aea4eb5f7$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`,
    "longPressToSelect": `\u{5D4}\u{5E7}\u{5E9}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DC}\u{5DB}\u{5E0}\u{5D9}\u{5E1}\u{5D4} \u{5DC}\u{5DE}\u{5E6}\u{5D1} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}.`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD}`,
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} ${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`
};


var $85481898f58476f9$export$2e2bcd8739ae039 = {};
$85481898f58476f9$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Stavka ${args.item} nije odabrana.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u na\u{10D}in odabira.`,
    "select": `Odaberite`,
    "selectedAll": `Odabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije odabrana nijedna stavka`,
            one: ()=>`Odabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Odabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`Stavka ${args.item} je odabrana.`
};


var $ce3210a66aa6e9e0$export$2e2bcd8739ae039 = {};
$ce3210a66aa6e9e0$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nincs kijel\xf6lve.`,
    "longPressToSelect": `Nyomja hosszan a kijel\xf6l\xe9shez.`,
    "select": `Kijel\xf6l\xe9s`,
    "selectedAll": `Az \xf6sszes elem kijel\xf6lve.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy elem sincs kijel\xf6lve`,
            one: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`
        })}.`,
    "selectedItem": (args)=>`${args.item} kijel\xf6lve.`
};


var $d62e6768c29503a3$export$2e2bcd8739ae039 = {};
$d62e6768c29503a3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non selezionato.`,
    "longPressToSelect": `Premi a lungo per passare alla modalit\xe0 di selezione.`,
    "select": `Seleziona`,
    "selectedAll": `Tutti gli elementi selezionati.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessun elemento selezionato`,
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "selectedItem": (args)=>`${args.item} selezionato.`
};


var $c614f4d9e955b8c9$export$2e2bcd8739ae039 = {};
$c614f4d9e955b8c9$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{9078}\u{629E}\u{30E2}\u{30FC}\u{30C9}\u{3092}\u{958B}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "select": `\u{9078}\u{629E}`,
    "selectedAll": `\u{3059}\u{3079}\u{3066}\u{306E}\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9805}\u{76EE}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            one: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`,
            other: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}\u{3002}`,
    "selectedItem": (args)=>`${args.item} \u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`
};


var $c34c3f5a37a09f76$export$2e2bcd8739ae039 = {};
$c34c3f5a37a09f76$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "longPressToSelect": `\u{C120}\u{D0DD} \u{BAA8}\u{B4DC}\u{B85C} \u{B4E4}\u{C5B4}\u{AC00}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectedAll": `\u{BAA8}\u{B4E0} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`
        })}.`,
    "selectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`
};


var $b39b2938c9cc69cb$export$2e2bcd8739ae039 = {};
$b39b2938c9cc69cb$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nepasirinkta.`,
    "longPressToSelect": `Nor\u{117}dami \u{12F}jungti pasirinkimo re\u{17E}im\u{105}, paspauskite ir palaikykite.`,
    "select": `Pasirinkti`,
    "selectedAll": `Pasirinkti visi elementai.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nepasirinktas n\u{117} vienas elementas`,
            one: ()=>`Pasirinktas ${formatter.number(args.count)} elementas`,
            other: ()=>`Pasirinkta element\u{173}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Pasirinkta: ${args.item}.`
};


var $85b0760383639bef$export$2e2bcd8739ae039 = {};
$85b0760383639bef$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Vienums ${args.item} nav atlas\u{12B}ts.`,
    "longPressToSelect": `Ilgi turiet nospiestu. lai iesl\u{113}gtu atlases re\u{17E}\u{12B}mu.`,
    "select": `Atlas\u{12B}t`,
    "selectedAll": `Atlas\u{12B}ti visi vienumi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts neviens vienums`,
            one: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`,
            other: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Atlas\u{12B}ts vienums ${args.item}.`
};


var $ca8b7ed7c49bab98$export$2e2bcd8739ae039 = {};
$ca8b7ed7c49bab98$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} er ikke valgt.`,
    "longPressToSelect": `Bruk et langt trykk for \xe5 g\xe5 inn i valgmodus.`,
    "select": `Velg`,
    "selectedAll": `Alle elementer er valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer er valgt`,
            one: ()=>`${formatter.number(args.count)} element er valgt`,
            other: ()=>`${formatter.number(args.count)} elementer er valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} er valgt.`
};


var $0992357a881439a1$export$2e2bcd8739ae039 = {};
$0992357a881439a1$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} niet geselecteerd.`,
    "longPressToSelect": `Druk lang om de selectiemodus te openen.`,
    "select": `Selecteren`,
    "selectedAll": `Alle items geselecteerd.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Geen items geselecteerd`,
            one: ()=>`${formatter.number(args.count)} item geselecteerd`,
            other: ()=>`${formatter.number(args.count)} items geselecteerd`
        })}.`,
    "selectedItem": (args)=>`${args.item} geselecteerd.`
};


var $60d610cb644ed5e1$export$2e2bcd8739ae039 = {};
$60d610cb644ed5e1$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nie zaznaczono ${args.item}.`,
    "longPressToSelect": `Naci\u{15B}nij i przytrzymaj, aby wej\u{15B}\u{107} do trybu wyboru.`,
    "select": `Zaznacz`,
    "selectedAll": `Wszystkie zaznaczone elementy.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nie zaznaczono \u{17C}adnych element\xf3w`,
            one: ()=>`${formatter.number(args.count)} zaznaczony element`,
            other: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`
        })}.`,
    "selectedItem": (args)=>`Zaznaczono ${args.item}.`
};


var $b201a158ef37e5fd$export$2e2bcd8739ae039 = {};
$b201a158ef37e5fd$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Mantenha pressionado para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};


var $006201cdcfc59e16$export$2e2bcd8739ae039 = {};
$006201cdcfc59e16$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Prima continuamente para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};


var $885ca937a75774e2$export$2e2bcd8739ae039 = {};
$885ca937a75774e2$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} neselectat.`,
    "longPressToSelect": `Ap\u{103}sa\u{21B}i lung pentru a intra \xeen modul de selectare.`,
    "select": `Selectare`,
    "selectedAll": `Toate elementele selectate.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciun element selectat`,
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "selectedItem": (args)=>`${args.item} selectat.`
};


var $89603dd4211fec7a$export$2e2bcd8739ae039 = {};
$89603dd4211fec7a$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}.`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{44B} \u{432}\u{441}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
            one: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};


var $b48bdd4a39f703f3$export$2e2bcd8739ae039 = {};
$b48bdd4a39f703f3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nevybrat\xe9 polo\u{17E}ky: ${args.item}.`,
    "longPressToSelect": `Dlh\u{161}\xedm stla\u{10D}en\xedm prejdite do re\u{17E}imu v\xfdberu.`,
    "select": `Vybra\u{165}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{17D}iadne vybrat\xe9 polo\u{17E}ky`,
            one: ()=>`${formatter.number(args.count)} vybrat\xe1 polo\u{17E}ka`,
            other: ()=>`Po\u{10D}et vybrat\xfdch polo\u{17E}iek:${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Vybrat\xe9 polo\u{17E}ky: ${args.item}.`
};


var $9aac3993bf9616bd$export$2e2bcd8739ae039 = {};
$9aac3993bf9616bd$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Element ${args.item} ni izbran.`,
    "longPressToSelect": `Za izbirni na\u{10D}in pritisnite in dlje \u{10D}asa dr\u{17E}ite.`,
    "select": `Izberite`,
    "selectedAll": `Vsi elementi so izbrani.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Noben element ni izbran`,
            one: ()=>`${formatter.number(args.count)} element je izbran`,
            other: ()=>`${formatter.number(args.count)} elementov je izbranih`
        })}.`,
    "selectedItem": (args)=>`Element ${args.item} je izbran.`
};


var $96457dbd5873e82a$export$2e2bcd8739ae039 = {};
$96457dbd5873e82a$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nije izabrano.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u re\u{17E}im biranja.`,
    "select": `Izaberite`,
    "selectedAll": `Izabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije izabrana nijedna stavka`,
            one: ()=>`Izabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Izabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`${args.item} je izabrano.`
};


var $9327612db7b9bd27$export$2e2bcd8739ae039 = {};
$9327612db7b9bd27$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ej markerat.`,
    "longPressToSelect": `Tryck l\xe4nge n\xe4r du vill \xf6ppna v\xe4ljarl\xe4ge.`,
    "select": `Markera`,
    "selectedAll": `Alla markerade objekt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga markerade objekt`,
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "selectedItem": (args)=>`${args.item} markerat.`
};


var $e5cbebeaaaa7c002$export$2e2bcd8739ae039 = {};
$e5cbebeaaaa7c002$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} se\xe7ilmedi.`,
    "longPressToSelect": `Se\xe7im moduna girmek i\xe7in uzun bas\u{131}n.`,
    "select": `Se\xe7`,
    "selectedAll": `T\xfcm \xf6geler se\xe7ildi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7bir \xf6ge se\xe7ilmedi`,
            one: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`,
            other: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`
        })}.`,
    "selectedItem": (args)=>`${args.item} se\xe7ildi.`
};


var $f2160a6815eb2e2c$export$2e2bcd8739ae039 = {};
$f2160a6815eb2e2c$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{412}\u{438}\u{43A}\u{43E}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43E}\u{432}\u{433}\u{435} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{43D}\u{43D}\u{44F}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{438}\u{431}\u{43E}\u{440}\u{443}.`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectedAll": `\u{423}\u{441}\u{456} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{416}\u{43E}\u{434}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            one: ()=>`${formatter.number(args.count)} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};


var $b331c64fab7e010b$export$2e2bcd8739ae039 = {};
$b331c64fab7e010b$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9009}\u{62E9} ${args.item}\u{3002}`,
    "longPressToSelect": `\u{957F}\u{6309}\u{4EE5}\u{8FDB}\u{5165}\u{9009}\u{62E9}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectedAll": `\u{5DF2}\u{9009}\u{62E9}\u{6240}\u{6709}\u{9879}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9009}\u{62E9}\u{9879}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.item}\u{3002}`
};


var $75faa0bf440e1391$export$2e2bcd8739ae039 = {};
$75faa0bf440e1391$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{6309}\u{4EE5}\u{9032}\u{5165}\u{9078}\u{64C7}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9078}\u{53D6}`,
    "selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`
};


var $750ad44e3586ade4$export$2e2bcd8739ae039 = {};
$750ad44e3586ade4$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $d9205d0fc80e0f56$export$2e2bcd8739ae039),
    "bg-BG": (0, $b4f81976cf269e47$export$2e2bcd8739ae039),
    "cs-CZ": (0, $2202d384b78f2aa3$export$2e2bcd8739ae039),
    "da-DK": (0, $5b68367a889e0c01$export$2e2bcd8739ae039),
    "de-DE": (0, $5187648348b4986d$export$2e2bcd8739ae039),
    "el-GR": (0, $909f2588c598a36d$export$2e2bcd8739ae039),
    "en-US": (0, $5aea3cec31347491$export$2e2bcd8739ae039),
    "es-ES": (0, $6f0ff23823a024f9$export$2e2bcd8739ae039),
    "et-EE": (0, $1585bec906cdc099$export$2e2bcd8739ae039),
    "fi-FI": (0, $706239cfea801da0$export$2e2bcd8739ae039),
    "fr-FR": (0, $59828e85257b99f1$export$2e2bcd8739ae039),
    "he-IL": (0, $41e87e2aea4eb5f7$export$2e2bcd8739ae039),
    "hr-HR": (0, $85481898f58476f9$export$2e2bcd8739ae039),
    "hu-HU": (0, $ce3210a66aa6e9e0$export$2e2bcd8739ae039),
    "it-IT": (0, $d62e6768c29503a3$export$2e2bcd8739ae039),
    "ja-JP": (0, $c614f4d9e955b8c9$export$2e2bcd8739ae039),
    "ko-KR": (0, $c34c3f5a37a09f76$export$2e2bcd8739ae039),
    "lt-LT": (0, $b39b2938c9cc69cb$export$2e2bcd8739ae039),
    "lv-LV": (0, $85b0760383639bef$export$2e2bcd8739ae039),
    "nb-NO": (0, $ca8b7ed7c49bab98$export$2e2bcd8739ae039),
    "nl-NL": (0, $0992357a881439a1$export$2e2bcd8739ae039),
    "pl-PL": (0, $60d610cb644ed5e1$export$2e2bcd8739ae039),
    "pt-BR": (0, $b201a158ef37e5fd$export$2e2bcd8739ae039),
    "pt-PT": (0, $006201cdcfc59e16$export$2e2bcd8739ae039),
    "ro-RO": (0, $885ca937a75774e2$export$2e2bcd8739ae039),
    "ru-RU": (0, $89603dd4211fec7a$export$2e2bcd8739ae039),
    "sk-SK": (0, $b48bdd4a39f703f3$export$2e2bcd8739ae039),
    "sl-SI": (0, $9aac3993bf9616bd$export$2e2bcd8739ae039),
    "sr-SP": (0, $96457dbd5873e82a$export$2e2bcd8739ae039),
    "sv-SE": (0, $9327612db7b9bd27$export$2e2bcd8739ae039),
    "tr-TR": (0, $e5cbebeaaaa7c002$export$2e2bcd8739ae039),
    "uk-UA": (0, $f2160a6815eb2e2c$export$2e2bcd8739ae039),
    "zh-CN": (0, $b331c64fab7e010b$export$2e2bcd8739ae039),
    "zh-TW": (0, $75faa0bf440e1391$export$2e2bcd8739ae039)
};





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $642bb210cce17b9b$export$496315a1608d9602(cb, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    const lastDeps = (0, $acw62.useRef)(null);
    let cbEvent = (0, $7bf6d137e5c3909a$export$7f54fc3180508a52)(cb);
    (0, $acw62.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let prevDeps = lastDeps.current;
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!prevDeps || dependencies.some((dep, i)=>!Object.is(dep, prevDeps[i]))) cbEvent();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}



var $acw62 = parcelRequire("acw62");
function $7a6358886d0bdcfd$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7a6358886d0bdcfd$export$137e594ef3218a10(props, state) {
    let { getRowText: getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($7a6358886d0bdcfd$var$$parcel$interopDefault((0, $750ad44e3586ade4$export$2e2bcd8739ae039)), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, $acw62.useRef)(selection);
    let announceSelectionChange = (0, $acw62.useCallback)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = $7a6358886d0bdcfd$var$$2b2556a8276954c1$var$diffSelection(selection, lastSelection.current);
        let removedKeys = $7a6358886d0bdcfd$var$$2b2556a8276954c1$var$diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, $1c9c0beddd9981ff$export$a9b970dcc4ae71a9)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection,
        state.selectionManager.selectedKeys,
        state.selectionManager.isFocused,
        state.selectionManager.selectionBehavior,
        state.selectionManager.selectionMode,
        state.collection,
        getRowText,
        stringFormatter
    ]);
    (0, $642bb210cce17b9b$export$496315a1608d9602)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function $7a6358886d0bdcfd$var$$2b2556a8276954c1$var$diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c6d761be7e139cf9$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options?.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $acw62.useState)(false);
    (0, $484aedf5a2e0ad16$export$e5c5a5f917a5871c)(()=>{
        if (ref?.current && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, $5c60d71a4f66bda5$export$2d6ec8fc375ceafa)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    'tabIndex',
                    'disabled'
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}







var $acw62 = parcelRequire("acw62");
function $966fabd8f859042f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $966fabd8f859042f$export$be42ebdab07ae4c2(props) {
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($966fabd8f859042f$var$$parcel$interopDefault((0, $750ad44e3586ade4$export$2e2bcd8739ae039)), '@react-aria/grid');
    let modality = (0, $627d69440c27e5e4$export$98e20ec92f614cfe)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, $acw62.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, $e653c573b0f229ee$export$f8aeda7b10753fa1)(interactionDescription);
    return descriptionProps;
}




/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $afeb73cbc58bc586$export$664f9155035607eb(props, state, ref) {
    let { isVirtualized: isVirtualized, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, onAction: onAction, disallowTypeAhead: disallowTypeAhead, linkBehavior: linkBehavior = 'action', keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow', escapeKeyBehavior: escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp: shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps: listProps } = (0, $06a03ced0cfc365c$export$b95089534ab7c1fd)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref: ref,
        keyboardDelegate: keyboardDelegate,
        layoutDelegate: layoutDelegate,
        isVirtualized: isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior: linkBehavior,
        disallowTypeAhead: disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior: escapeKeyBehavior
    });
    let id = (0, $3af2a5641bd71461$export$f680877a34711e37)(props.id);
    (0, $e2dc165b0d9e239f$export$5b9bb410392e3991).set(state, {
        id: id,
        onAction: onAction,
        linkBehavior: linkBehavior,
        keyboardNavigationBehavior: keyboardNavigationBehavior,
        shouldSelectOnPressUp: shouldSelectOnPressUp
    });
    let descriptionProps = (0, $966fabd8f859042f$export$be42ebdab07ae4c2)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, $c6d761be7e139cf9$export$eac1895992b9f3d6)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let gridProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(domProps, {
        role: 'grid',
        id: id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, $7a6358886d0bdcfd$export$137e594ef3218a10)({}, state);
    return {
        gridProps: gridProps
    };
}









var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $da74686214326258$export$653eddfc964b0f8a = new WeakMap();
function $da74686214326258$export$4f8b5cda58b7e8ff(props, state, ref) {
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let keyboardDelegate = props.keyboardDelegate || new (0, $a3fdb18a48ed07b4$export$a05409b8bb224a5a)({
        collection: state.collection,
        ref: ref,
        orientation: 'horizontal',
        direction: direction,
        disabledKeys: state.disabledKeys,
        disabledBehavior: state.selectionManager.disabledBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $ec7707e2bf6dfe59$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: 'span'
    });
    let { gridProps: gridProps } = (0, $afeb73cbc58bc586$export$664f9155035607eb)({
        ...props,
        ...fieldProps,
        keyboardDelegate: keyboardDelegate,
        shouldFocusWrap: true,
        linkBehavior: 'override',
        keyboardNavigationBehavior: 'tab'
    }, state, ref);
    let [isFocusWithin, setFocusWithin] = (0, $acw62.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $dcef548b0303e20e$export$420e68273165f4ec)({
        onFocusWithinChange: setFocusWithin
    });
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props);
    // If the last tag is removed, focus the container.
    let prevCount = (0, $acw62.useRef)(state.collection.size);
    (0, $acw62.useEffect)(()=>{
        if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
        prevCount.current = state.collection.size;
    }, [
        state.collection.size,
        isFocusWithin,
        ref
    ]);
    $da74686214326258$export$653eddfc964b0f8a.set(state, {
        onRemove: props.onRemove
    });
    return {
        gridProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(gridProps, domProps, {
            role: state.collection.size ? 'grid' : 'group',
            'aria-atomic': false,
            'aria-relevant': 'additions',
            'aria-live': isFocusWithin ? 'polite' : 'off',
            ...focusWithinProps,
            ...fieldProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}


var $ba55f0981670c3e3$export$2e2bcd8739ae039 = {};
$ba55f0981670c3e3$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{625}\u{632}\u{627}\u{644}\u{629}`,
    "removeDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} DELETE \u{644}\u{625}\u{632}\u{627}\u{644}\u{629} \u{639}\u{644}\u{627}\u{645}\u{629}.`
};


var $c7f729e9b77e5729$export$2e2bcd8739ae039 = {};
$c7f729e9b77e5729$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{41F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{432}\u{430}\u{43D}\u{435}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Delete, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{43D}\u{435}\u{442}\u{435} \u{43C}\u{430}\u{440}\u{43A}\u{435}\u{440}\u{430}.`
};


var $c289afa288da99d1$export$2e2bcd8739ae039 = {};
$c289afa288da99d1$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odebrat`,
    "removeDescription": `Stisknut\xedm kl\xe1vesy Delete odeberete zna\u{10D}ku.`
};


var $8aa73107b3981ef7$export$2e2bcd8739ae039 = {};
$8aa73107b3981ef7$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Tryk p\xe5 Slet for at fjerne tag.`
};


var $4581a3a747ff00a9$export$2e2bcd8739ae039 = {};
$4581a3a747ff00a9$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Entfernen`,
    "removeDescription": `Auf \u{201E}L\xf6schen\u{201C} dr\xfccken, um das Tag zu entfernen.`
};


var $d06129317594f920$export$2e2bcd8739ae039 = {};
$d06129317594f920$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{39A}\u{3B1}\u{3C4}\u{3AC}\u{3C1}\u{3B3}\u{3B7}\u{3C3}\u{3B7}`,
    "removeDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{394}\u{3B9}\u{3B1}\u{3B3}\u{3C1}\u{3B1}\u{3C6}\u{3AE} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BA}\u{3B1}\u{3C4}\u{3B1}\u{3C1}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3AD}\u{3C4}\u{3B1}.`
};


var $c94e047013a67b88$export$2e2bcd8739ae039 = {};
$c94e047013a67b88$export$2e2bcd8739ae039 = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};


var $078b83ef4bb73bde$export$2e2bcd8739ae039 = {};
$078b83ef4bb73bde$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Quitar`,
    "removeDescription": `Pulse Eliminar para quitar la etiqueta.`
};


var $59f6047b6b52a0e5$export$2e2bcd8739ae039 = {};
$59f6047b6b52a0e5$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Eemalda`,
    "removeDescription": `Sildi eemaldamiseks vajutage kustutusklahvi Delete.`
};


var $7f69ddeacde57fec$export$2e2bcd8739ae039 = {};
$7f69ddeacde57fec$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Poista`,
    "removeDescription": `Poista tunniste painamalla Poista-painiketta.`
};


var $02b55a035a843467$export$2e2bcd8739ae039 = {};
$02b55a035a843467$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Supprimer`,
    "removeDescription": `Appuyez sur Supprimer pour supprimer l\u{2019}\xe9tiquette.`
};


var $57630636c199a490$export$2e2bcd8739ae039 = {};
$57630636c199a490$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{5D4}\u{5E1}\u{5E8}`,
    "removeDescription": `\u{5DC}\u{5D7}\u{5E5} \u{5E2}\u{5DC} \u{5DE}\u{5D7}\u{5E7} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5EA}\u{5D2}.`
};


var $be9cde28d3bc9ffb$export$2e2bcd8739ae039 = {};
$be9cde28d3bc9ffb$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Delete za uklanjanje oznake.`
};


var $618c2b670ea1d354$export$2e2bcd8739ae039 = {};
$618c2b670ea1d354$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Elt\xe1vol\xedt\xe1s`,
    "removeDescription": `Nyomja meg a Delete billenty\u{171}t a c\xedmke elt\xe1vol\xedt\xe1s\xe1hoz.`
};


var $89d6985b19031b8b$export$2e2bcd8739ae039 = {};
$89d6985b19031b8b$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Rimuovi`,
    "removeDescription": `Premi Elimina per rimuovere il tag.`
};


var $0ddcfe6be30d09fc$export$2e2bcd8739ae039 = {};
$0ddcfe6be30d09fc$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{524A}\u{9664}`,
    "removeDescription": `\u{30BF}\u{30B0}\u{3092}\u{524A}\u{9664}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}Delete \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{307E}\u{3059}\u{3002}`
};


var $dc92be7d09d16411$export$2e2bcd8739ae039 = {};
$dc92be7d09d16411$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{C81C}\u{AC70}`,
    "removeDescription": `\u{D0DC}\u{ADF8}\u{B97C} \u{C81C}\u{AC70}\u{D558}\u{B824}\u{BA74} Delete \u{D0A4}\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`
};


var $b4f189cb88c75936$export$2e2bcd8739ae039 = {};
$b4f189cb88c75936$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Pa\u{161}alinti`,
    "removeDescription": `Nor\u{117}dami pa\u{161}alinti \u{17E}ym\u{105}, paspauskite \u{201E}Delete\u{201C} klavi\u{161}\u{105}.`
};


var $2b9fc4c44308d55e$export$2e2bcd8739ae039 = {};
$2b9fc4c44308d55e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `No\u{146}emt`,
    "removeDescription": `Nospiediet Delete [Dz\u{113}st], lai no\u{146}emtu tagu.`
};


var $88013340d19a93ff$export$2e2bcd8739ae039 = {};
$88013340d19a93ff$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Trykk p\xe5 Slett for \xe5 fjerne taggen.`
};


var $bcd7b6642e8773ea$export$2e2bcd8739ae039 = {};
$bcd7b6642e8773ea$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Verwijderen`,
    "removeDescription": `Druk op Verwijderen om de tag te verwijderen.`
};


var $8c15582088e4819e$export$2e2bcd8739ae039 = {};
$8c15582088e4819e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Usu\u{144}`,
    "removeDescription": `Naci\u{15B}nij Usu\u{144}, aby usun\u{105}\u{107} znacznik.`
};


var $53b63269e1699b2e$export$2e2bcd8739ae039 = {};
$53b63269e1699b2e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Remover`,
    "removeDescription": `Pressione Delete para remover a tag.`
};


var $a61dd65bdba87796$export$2e2bcd8739ae039 = {};
$a61dd65bdba87796$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Eliminar`,
    "removeDescription": `Prima Delete para eliminar a tag.`
};


var $3f24f946159867be$export$2e2bcd8739ae039 = {};
$3f24f946159867be$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\xcendep\u{103}rta\u{163}i`,
    "removeDescription": `Ap\u{103}sa\u{21B}i pe Delete (\u{218}tergere) pentru a elimina eticheta.`
};


var $27236392fb091a26$export$2e2bcd8739ae039 = {};
$27236392fb091a26$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    "removeDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} DELETE, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{433}.`
};


var $53f42bb5ecd13705$export$2e2bcd8739ae039 = {};
$53f42bb5ecd13705$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odstr\xe1ni\u{165}`,
    "removeDescription": `Ak chcete odstr\xe1ni\u{165} zna\u{10D}ku, stla\u{10D}te kl\xe1ves Delete.`
};


var $55bf5fda1750e68f$export$2e2bcd8739ae039 = {};
$55bf5fda1750e68f$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};


var $41765002f2570022$export$2e2bcd8739ae039 = {};
$41765002f2570022$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Obri\u{161}i da biste uklonili oznaku.`
};


var $51b58842004fbdb2$export$2e2bcd8739ae039 = {};
$51b58842004fbdb2$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ta bort`,
    "removeDescription": `Tryck p\xe5 Radera f\xf6r att ta bort taggen.`
};


var $cce4fb3f24e6a823$export$2e2bcd8739ae039 = {};
$cce4fb3f24e6a823$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Kald\u{131}r`,
    "removeDescription": `Etiketi kald\u{131}rmak i\xe7in Sil tu\u{15F}una bas\u{131}n.`
};


var $b3a43a6e240a25f8$export$2e2bcd8739ae039 = {};
$b3a43a6e240a25f8$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{412}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Delete, \u{449}\u{43E}\u{431} \u{432}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438} \u{442}\u{435}\u{433}.`
};


var $fab3f161ec6f3955$export$2e2bcd8739ae039 = {};
$fab3f161ec6f3955$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{5220}\u{9664}`,
    "removeDescription": `\u{6309}\u{4E0B}\u{201C}\u{5220}\u{9664}\u{201D}\u{4EE5}\u{5220}\u{9664}\u{6807}\u{8BB0}\u{3002}`
};


var $94033edb5812ab2a$export$2e2bcd8739ae039 = {};
$94033edb5812ab2a$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{79FB}\u{9664}`,
    "removeDescription": `\u{6309} Delete \u{9375}\u{4EE5}\u{79FB}\u{9664}\u{6A19}\u{8A18}\u{3002}`
};


var $8e679d6db5ebacb9$export$2e2bcd8739ae039 = {};
$8e679d6db5ebacb9$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $ba55f0981670c3e3$export$2e2bcd8739ae039),
    "bg-BG": (0, $c7f729e9b77e5729$export$2e2bcd8739ae039),
    "cs-CZ": (0, $c289afa288da99d1$export$2e2bcd8739ae039),
    "da-DK": (0, $8aa73107b3981ef7$export$2e2bcd8739ae039),
    "de-DE": (0, $4581a3a747ff00a9$export$2e2bcd8739ae039),
    "el-GR": (0, $d06129317594f920$export$2e2bcd8739ae039),
    "en-US": (0, $c94e047013a67b88$export$2e2bcd8739ae039),
    "es-ES": (0, $078b83ef4bb73bde$export$2e2bcd8739ae039),
    "et-EE": (0, $59f6047b6b52a0e5$export$2e2bcd8739ae039),
    "fi-FI": (0, $7f69ddeacde57fec$export$2e2bcd8739ae039),
    "fr-FR": (0, $02b55a035a843467$export$2e2bcd8739ae039),
    "he-IL": (0, $57630636c199a490$export$2e2bcd8739ae039),
    "hr-HR": (0, $be9cde28d3bc9ffb$export$2e2bcd8739ae039),
    "hu-HU": (0, $618c2b670ea1d354$export$2e2bcd8739ae039),
    "it-IT": (0, $89d6985b19031b8b$export$2e2bcd8739ae039),
    "ja-JP": (0, $0ddcfe6be30d09fc$export$2e2bcd8739ae039),
    "ko-KR": (0, $dc92be7d09d16411$export$2e2bcd8739ae039),
    "lt-LT": (0, $b4f189cb88c75936$export$2e2bcd8739ae039),
    "lv-LV": (0, $2b9fc4c44308d55e$export$2e2bcd8739ae039),
    "nb-NO": (0, $88013340d19a93ff$export$2e2bcd8739ae039),
    "nl-NL": (0, $bcd7b6642e8773ea$export$2e2bcd8739ae039),
    "pl-PL": (0, $8c15582088e4819e$export$2e2bcd8739ae039),
    "pt-BR": (0, $53b63269e1699b2e$export$2e2bcd8739ae039),
    "pt-PT": (0, $a61dd65bdba87796$export$2e2bcd8739ae039),
    "ro-RO": (0, $3f24f946159867be$export$2e2bcd8739ae039),
    "ru-RU": (0, $27236392fb091a26$export$2e2bcd8739ae039),
    "sk-SK": (0, $53f42bb5ecd13705$export$2e2bcd8739ae039),
    "sl-SI": (0, $55bf5fda1750e68f$export$2e2bcd8739ae039),
    "sr-SP": (0, $41765002f2570022$export$2e2bcd8739ae039),
    "sv-SE": (0, $51b58842004fbdb2$export$2e2bcd8739ae039),
    "tr-TR": (0, $cce4fb3f24e6a823$export$2e2bcd8739ae039),
    "uk-UA": (0, $b3a43a6e240a25f8$export$2e2bcd8739ae039),
    "zh-CN": (0, $fab3f161ec6f3955$export$2e2bcd8739ae039),
    "zh-TW": (0, $94033edb5812ab2a$export$2e2bcd8739ae039)
};



















var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $17d02ac246f3debd$var$$be7bed9611dd7497$var$EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function $17d02ac246f3debd$export$9610e69494fadfd2(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node: node, isVirtualized: isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction: direction } = (0, $e9bafae0aa65a2d3$export$43bb16f9c6d9e3f7)();
    let { onAction: onAction, linkBehavior: linkBehavior, keyboardNavigationBehavior: keyboardNavigationBehavior, shouldSelectOnPressUp: shouldSelectOnPressUp } = (0, $e2dc165b0d9e239f$export$5b9bb410392e3991).get(state);
    let descriptionId = (0, $3af2a5641bd71461$export$b4cc09c592e8fdb8)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, $acw62.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !(0, $8fd85525b97849bf$export$b4f377a2b6254582)(ref.current))) (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        let index = node.index;
        if (node.level >= 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = $17d02ac246f3debd$var$$be7bed9611dd7497$var$getDirectChildren(parent, state.collection);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
                if (index > 0 && siblings[0].type !== 'item') index -= 1; // subtract one for the parent item's content node
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps: itemProps, ...itemStates } = (0, $9ef49e4bf6a3a063$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, $d773e80e0af5ed8a$export$e08e3b67e392101e)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus: focus,
        linkBehavior: linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) || !ref.current || !activeElement) return;
        let walker = (0, $5c60d71a4f66bda5$export$2d6ec8fc375ceafa)(ref.current);
        walker.currentNode = activeElement;
        if ('expandedKeys' in state && activeElement === ref.current) {
            if (e.key === $17d02ac246f3debd$var$$be7bed9611dd7497$var$EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === $17d02ac246f3debd$var$$be7bed9611dd7497$var$EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key) {
                // If item is collapsible, collapse it; else move to parent
                if (hasChildRows && state.expandedKeys.has(node.key)) {
                    state.toggleKey(node.key);
                    e.stopPropagation();
                    return;
                } else if (!state.expandedKeys.has(node.key) && node.parentKey) {
                    // Item is a leaf or already collapsed, move focus to parent
                    state.selectionManager.setFocusedKey(node.parentKey);
                    e.stopPropagation();
                    return;
                }
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, $ea661b83393f500e$export$80f3e147d781571c)(focusable);
                        (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(focusable, {
                            containingElement: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
                            (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(ref.current, {
                                containingElement: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = $17d02ac246f3debd$var$$be7bed9611dd7497$var$last(walker);
                            if (lastElement) {
                                (0, $ea661b83393f500e$export$80f3e147d781571c)(lastElement);
                                (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(lastElement, {
                                    containingElement: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, $ea661b83393f500e$export$80f3e147d781571c)(focusable);
                        (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(focusable, {
                            containingElement: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, $ea661b83393f500e$export$80f3e147d781571c)(ref.current);
                            (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(ref.current, {
                                containingElement: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = $17d02ac246f3debd$var$$be7bed9611dd7497$var$last(walker);
                            if (lastElement) {
                                (0, $ea661b83393f500e$export$80f3e147d781571c)(lastElement);
                                (0, $fea4bf42b4a1cc33$export$c826860796309d1b)(lastElement, {
                                    containingElement: (0, $05b5d708b420cd83$export$cfa2225e87938781)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && (0, $8fd85525b97849bf$export$4282f70798064fe0)(ref.current, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e))) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if ((0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e) !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, $627d69440c27e5e4$export$b9b3dfddab17db27)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        let activeElement = (0, $8fd85525b97849bf$export$cd4e5573fbe2b576)();
        if (!(0, $8fd85525b97849bf$export$4282f70798064fe0)(e.currentTarget, (0, $8fd85525b97849bf$export$e58f029f0fbfdb29)(e)) || !ref.current || !activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, $5c60d71a4f66bda5$export$2d6ec8fc375ceafa)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, $dc5a334d7ad7481f$export$bdc77b0c0a3a85d6)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, $195af97314dd822a$export$9d1611c77c2fe928)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture: onKeyDownCapture,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node['aria-label'] || node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && (node['aria-label'] || node.textValue) ? `${(0, $e2dc165b0d9e239f$export$f45c25170b9a99c2)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, $e2dc165b0d9e239f$export$f45c25170b9a99c2)(state, node.key)
    });
    if (isVirtualized) {
        let { collection: collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(rowProps, treeGridRowProps)
        },
        gridCellProps: gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function $17d02ac246f3debd$var$$be7bed9611dd7497$var$last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
function $17d02ac246f3debd$var$$be7bed9611dd7497$var$getDirectChildren(parent, collection) {
    // We can't assume that we can use firstChildKey because if a person builds a tree using hooks, they would not have access to that property (using type Node vs CollectionNode)
    // Instead, get all children and start at the first node (rather than just using firstChildKey) and only look at its siblings
    let children = collection.getChildren?.(parent.key);
    let childArray = children ? Array.from(children) : [];
    let node = childArray.length > 0 ? childArray[0] : null;
    let siblings = [];
    while(node){
        siblings.push(node);
        node = node.nextKey != null ? collection.getItem(node.nextKey) : null;
    }
    return siblings;
}






function $7c2de8e98feb9d96$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7c2de8e98feb9d96$export$3f568fff7dff2f03(props, state, ref) {
    let { item: item } = props;
    let stringFormatter = (0, $fd75b5296f720c9c$export$f12b703ca79dfbb1)($7c2de8e98feb9d96$var$$parcel$interopDefault((0, $8e679d6db5ebacb9$export$2e2bcd8739ae039)), '@react-aria/tag');
    let buttonId = (0, $3af2a5641bd71461$export$f680877a34711e37)();
    let { onRemove: onRemove } = (0, $da74686214326258$export$653eddfc964b0f8a).get(state) || {};
    let { rowProps: rowProps, gridCellProps: gridCellProps, ...states } = (0, $17d02ac246f3debd$export$9610e69494fadfd2)({
        node: item
    }, state, ref);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { descriptionProps: _, ...stateWithoutDescription } = states;
    let isDisabled = state.disabledKeys.has(item.key) || item.props.isDisabled;
    let onKeyDown = (e)=>{
        if (e.key === 'Delete' || e.key === 'Backspace') {
            if (isDisabled) return;
            e.preventDefault();
            if (state.selectionManager.isSelected(item.key)) onRemove?.(new Set(state.selectionManager.selectedKeys));
            else onRemove?.(new Set([
                item.key
            ]));
        }
    };
    let modality = (0, $627d69440c27e5e4$export$98e20ec92f614cfe)();
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'pointer';
    let description = onRemove && (modality === 'keyboard' || modality === 'virtual') ? stringFormatter.format('removeDescription') : '';
    let descProps = (0, $e653c573b0f229ee$export$f8aeda7b10753fa1)(description);
    let isItemFocused = item.key === state.selectionManager.focusedKey;
    let isFocused = state.selectionManager.focusedKey != null;
    let tabIndex = -1;
    if (!isDisabled && (isItemFocused || !isFocused)) tabIndex = 0;
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(item.props);
    let linkProps = (0, $dc5a334d7ad7481f$export$bdc77b0c0a3a85d6)(item.props);
    let { focusableProps: focusableProps } = (0, $2d50ad364d7cf854$export$4c014de7c8940b4c)({
        ...item.props,
        isDisabled: isDisabled
    }, ref);
    return {
        removeButtonProps: {
            'aria-label': stringFormatter.format('removeButtonLabel'),
            'aria-labelledby': `${buttonId} ${rowProps.id}`,
            isDisabled: isDisabled,
            id: buttonId,
            onPress: ()=>onRemove ? onRemove(new Set([
                    item.key
                ])) : null
        },
        rowProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(focusableProps, rowProps, domProps, linkProps, {
            tabIndex: tabIndex,
            onKeyDown: onRemove ? onKeyDown : undefined,
            'aria-describedby': descProps['aria-describedby']
        }),
        gridCellProps: (0, $195af97314dd822a$export$9d1611c77c2fe928)(gridCellProps, {
            'aria-errormessage': props['aria-errormessage'],
            'aria-label': props['aria-label']
        }),
        ...stateWithoutDescription,
        allowsRemoving: !!onRemove
    };
}









var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1f6cf0c78a1bac99$export$5b07b5dd2cbd96e3 = (0, $acw62.createContext)(null);
const $1f6cf0c78a1bac99$export$e755ce3685dd0ca9 = (0, $acw62.createContext)(null);
const $1f6cf0c78a1bac99$export$67ea30858aaf75e3 = (0, $acw62.forwardRef)(function TagGroup(props, ref) {
    [props, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(props, ref, $1f6cf0c78a1bac99$export$5b07b5dd2cbd96e3);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbc77d4357361516$export$7c5906fe4f1f2af2).Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$bf788dd355e3a401), {
        content: props.children
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f6cf0c78a1bac99$var$$3df3ddf5bafbc7b1$var$TagGroupInner, {
            props: props,
            forwardedRef: ref,
            collection: collection
        })));
});
function $1f6cf0c78a1bac99$var$$3df3ddf5bafbc7b1$var$TagGroupInner({ props: props, forwardedRef: ref, collection: collection }) {
    let tagListRef = (0, $acw62.useRef)(null);
    // Extract the user provided id so it doesn't clash with the collection id provided by Autocomplete
    let { id: id, ...otherProps } = props;
    [otherProps, tagListRef] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)(otherProps, tagListRef, (0, $80b3f40af2eadde4$export$b0d3ecf7112093a7));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { filter: filter, shouldUseVirtualFocus: shouldUseVirtualFocus, ...DOMCollectionProps } = otherProps;
    let [labelRef, label] = (0, $78f7e4721048d8d5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let tagGroupState = (0, $78bb3024d26c2ff4$export$2f645645f7bca764)({
        ...DOMCollectionProps,
        children: undefined,
        collection: collection
    });
    let filteredState = (0, $78bb3024d26c2ff4$export$ba9d38c0f1bf2b36)(tagGroupState, filter);
    // Prevent DOM props from going to two places.
    let domProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(otherProps, {
        global: true
    });
    let domPropOverrides = Object.fromEntries(Object.entries(domProps).map(([k, val])=>[
            k,
            k === 'id' ? val : undefined
        ]));
    let { gridProps: gridProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $da74686214326258$export$4f8b5cda58b7e8ff)({
        ...DOMCollectionProps,
        ...domPropOverrides,
        label: label
    }, filteredState, tagListRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        render: props.render,
        ...domProps,
        id: id,
        ref: ref,
        slot: props.slot || undefined,
        className: props.className ?? 'react-aria-TagGroup',
        style: props.style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $aaf42248096e4ba7$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    elementType: 'span',
                    ref: labelRef
                }
            ],
            [
                $1f6cf0c78a1bac99$export$e755ce3685dd0ca9,
                {
                    ...gridProps,
                    ref: tagListRef
                }
            ],
            [
                (0, $cbc77d4357361516$export$7c5906fe4f1f2af2),
                filteredState
            ],
            [
                (0, $9b7271d3af613df1$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, props.children));
}
const $1f6cf0c78a1bac99$export$f9fef0f55402315b = (0, $acw62.forwardRef)(function TagList(props, ref) {
    let state = (0, $acw62.useContext)((0, $cbc77d4357361516$export$7c5906fe4f1f2af2));
    return state ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f6cf0c78a1bac99$var$$3df3ddf5bafbc7b1$var$TagListInner, {
        props: props,
        forwardedRef: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18968b9ec17502c7$export$fb8073518f34e6ec), props);
});
function $1f6cf0c78a1bac99$var$$3df3ddf5bafbc7b1$var$TagListInner({ props: props, forwardedRef: forwardedRef }) {
    let state = (0, $acw62.useContext)((0, $cbc77d4357361516$export$7c5906fe4f1f2af2));
    let { CollectionRoot: CollectionRoot } = (0, $acw62.useContext)((0, $c9742a26b2470517$export$4feb769f8ddf26c5));
    let [gridProps, ref] = (0, $78f7e4721048d8d5$export$29f1550f4b0d4415)({}, forwardedRef, $1f6cf0c78a1bac99$export$e755ce3685dd0ca9);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $0cde480b945a073a$export$4e328f61c538687f)();
    let renderValues = {
        isEmpty: state.collection.size === 0,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        state: state
    };
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-TagList',
        values: renderValues
    });
    let persistedKeys = (0, $c9742a26b2470517$export$90e00781bc59d8f9)(state.selectionManager.focusedKey);
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, gridProps, focusProps),
        ref: ref,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08cc935c33eff3e5$export$758399f318e6385a), null, state.collection.size === 0 && props.renderEmptyState ? props.renderEmptyState(renderValues) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: persistedKeys
    })));
}
const $1f6cf0c78a1bac99$export$3288d34c523a1192 = (0, $18968b9ec17502c7$export$18af5c7a9e9b3664)((0, $5cc6cedd00940323$export$fd11f34e1d07f134), (props, forwardedRef, item)=>{
    let state = (0, $acw62.useContext)((0, $cbc77d4357361516$export$7c5906fe4f1f2af2));
    let ref = (0, $0231fe790c02c958$export$4338b53315abf666)(forwardedRef);
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $0cde480b945a073a$export$4e328f61c538687f)({
        within: false
    });
    let { rowProps: rowProps, gridCellProps: gridCellProps, removeButtonProps: removeButtonProps, ...states } = (0, $7c2de8e98feb9d96$export$3f568fff7dff2f03)({
        item: item
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c3d85362ed1440ed$export$ae780daf29e6d456)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let renderProps = (0, $78f7e4721048d8d5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-Tag',
        values: {
            ...states,
            isFocusVisible: isFocusVisible,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior
        }
    });
    (0, $acw62.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let DOMProps = (0, $c5a0f9cfef525171$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$df3a06d6289f983e).div, {
        ref: ref,
        ...(0, $195af97314dd822a$export$9d1611c77c2fe928)(DOMProps, renderProps, rowProps, focusProps, hoverProps),
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-removing": states.allowsRemoving || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78f7e4721048d8d5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $972ba92a45901f5b$export$24d547caef80ccd1),
                {
                    slots: {
                        remove: removeButtonProps
                    }
                }
            ],
            [
                (0, $c9742a26b2470517$export$4feb769f8ddf26c5),
                (0, $c9742a26b2470517$export$a164736487e3f0ae)
            ],
            [
                (0, $f978dd1340ad1a86$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children)));
});


const $0f7bab1df0f00300$export$ead4a8547fe3d9f8 = [
    {
        value: '',
        label: 'Latest activity'
    },
    {
        value: 'date_created',
        label: 'Newest'
    },
    {
        value: 'top',
        label: 'Top'
    }
];
const $0f7bab1df0f00300$export$a10e4eda63f1399b = [
    {
        value: 'created-desc',
        label: 'Newest'
    },
    {
        value: 'created-asc',
        label: 'Oldest'
    },
    {
        value: 'comments-desc',
        label: 'Most commented'
    },
    {
        value: 'updated-desc',
        label: 'Recently updated'
    },
    {
        value: 'reactions-desc',
        label: "\uD83D\uDD25 Most reactions"
    },
    {
        value: 'reactions-+1-desc',
        label: "\uD83D\uDC4D Thumbs up"
    },
    {
        value: 'reactions-heart-desc',
        label: "\u2764\uFE0F Heart"
    },
    {
        value: 'reactions-tada-desc',
        label: "\uD83C\uDF89 Tada"
    },
    {
        value: 'reactions-rocket-desc',
        label: "\uD83D\uDE80 Rocket"
    },
    {
        value: 'reactions-eyes-desc',
        label: "\uD83D\uDC40 Eyes"
    }
];
async function $0f7bab1df0f00300$export$f18317131e3a9f2c([, owner, repo]) {
    let res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).issues.listLabelsForRepo({
        owner: owner,
        repo: repo,
        per_page: 100
    });
    return res.data;
}
function $0f7bab1df0f00300$export$4c5b17bfcbab1742({ label: label, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-[10px] font-semibold text-daw-gray-500 uppercase tracking-wide",
                children: label
            }),
            children
        ]
    });
}
function $0f7bab1df0f00300$export$371ab307eab489c0({ value: value, label: label, color: color }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8286518ff8c479ac$export$d7b12c4107be0d61), {
        value: value,
        className: "flex items-center gap-2 text-sm cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded py-0.5",
        children: ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `w-3.5 h-3.5 rounded-full border-2 shrink-0 flex items-center justify-center ${isSelected ? 'border-blue-500' : 'border-daw-gray-400'}`,
                        children: isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-1.5 h-1.5 rounded-full bg-blue-500"
                        })
                    }),
                    color != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-2.5 h-2.5 rounded-full shrink-0",
                        style: {
                            backgroundColor: `#${color}`
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    })
                ]
            })
    });
}
function $0f7bab1df0f00300$export$dd948f91abc3a1c4({ isSelected: isSelected, onChange: onChange, label: label }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c8237d34e7f22709$export$48513f6b9f8ce62d), {
        isSelected: isSelected,
        onChange: onChange,
        className: "flex items-center gap-2 text-sm cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded py-0.5",
        children: ({ isSelected: sel })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `w-3.5 h-3.5 rounded border-2 shrink-0 flex items-center justify-center ${sel ? 'border-blue-500 bg-blue-500' : 'border-daw-gray-400'}`,
                        children: sel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$7dd004358974b05d), {
                            size: 8,
                            className: "text-white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    })
                ]
            })
    });
}
function $0f7bab1df0f00300$export$9190d2e14c16f4ef({ labels: labels, selectedLabels: selectedLabels, onLabelsChange: onLabelsChange }) {
    if (!labels.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f6cf0c78a1bac99$export$67ea30858aaf75e3), {
        selectionMode: "multiple",
        selectedKeys: new Set(selectedLabels),
        onSelectionChange: (keys)=>{
            if (keys !== 'all') onLabelsChange([
                ...keys
            ]);
        },
        "aria-label": "Labels",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f6cf0c78a1bac99$export$f9fef0f55402315b), {
            items: labels.map((l)=>({
                    ...l,
                    id: l.name
                })),
            className: "flex flex-wrap gap-1",
            children: (label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f6cf0c78a1bac99$export$3288d34c523a1192), {
                    className: ({ isSelected: isSelected })=>`px-2.5 py-0.5 text-xs font-semibold border rounded-full cursor-default outline-none focus-visible:ring-2 ring-blue-600 ring-offset-1${isSelected ? ' bg-daw-gray-900 text-daw-white border-daw-gray-900' : ''}`,
                    style: ({ isSelected: isSelected })=>isSelected ? {} : {
                            background: `#${label.color}66`,
                            borderColor: `#${label.color}66`,
                            color: `color-mix(in srgb, #${label.color}, black 70%)`
                        },
                    children: label.name
                })
        })
    });
}
function $0f7bab1df0f00300$export$ac838dd1e90609b3({ activeCount: activeCount, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce4897092af7eb66$export$2e1e1122cf0cba88), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                className: "shrink-0 flex items-center gap-1 text-xs font-medium px-2 py-1.5 rounded-md border border-daw-gray-200 hover:bg-daw-gray-100 cursor-default outline-none focus-visible:ring-2 ring-blue-600",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$28f6150e232898de), {
                        size: 13
                    }),
                    "Filters",
                    activeCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "px-1 py-px text-[9px] leading-none bg-blue-500 text-white rounded-full",
                        children: activeCount
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c079ee9c5fe80a9e$export$5b6b19405a83ff9d), {
                placement: "bottom end",
                offset: 4,
                className: "bg-white dark:bg-neutral-900 border border-daw-gray-200 rounded-lg shadow-xl outline-none w-72 max-h-[80vh] overflow-y-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce4897092af7eb66$export$3ddf2d174ce01153), {
                    "aria-label": "Filters",
                    className: "outline-none p-3 flex flex-col gap-4",
                    children: children
                })
            })
        ]
    });
}
function $0f7bab1df0f00300$export$79d13b60110f33be({ 'aria-label': ariaLabel, value: value, onChange: onChange, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-1.5 p-2 border-b border-daw-gray-200 shrink-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3de6a7daf03a057f$export$b94867ecbd698f21), {
                value: value,
                onChange: onChange,
                "aria-label": ariaLabel,
                className: "flex-1 min-w-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-1 border border-daw-gray-200 rounded-md px-2 py-1.5 focus-within:ring-2 ring-blue-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$82eafebb825fc23f), {
                            size: 14,
                            className: "text-daw-gray-500 shrink-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f86a0ac31b8d349c$export$f5b8910cec6cf069), {
                            className: "flex-1 text-sm outline-none bg-transparent min-w-0 placeholder:text-daw-gray-400",
                            placeholder: "Search..."
                        }),
                        value !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                            className: "text-daw-gray-400 hover:text-daw-gray-600 cursor-default outline-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a5090bbd7fc88fde), {
                                size: 14
                            })
                        })
                    ]
                })
            }),
            children
        ]
    });
}




const $ff17ea33ae06fe23$var$SEARCH_QUERY = `
query SearchIssues($q: String!, $cursor: String) {
  search(query: $q, type: ISSUE, first: 50, after: $cursor) {
    pageInfo { hasNextPage endCursor }
    nodes {
      ... on Issue {
        id number title state
        author { login }
        issueType { color name }
        comments {
          totalCount
        }
        reactionGroups {
          content
          reactors {
            totalCount
          }
        }
      }
    }
  }
}
`;
async function $ff17ea33ae06fe23$var$fetchIssuesPage([, query, cursor]) {
    const data = await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)($ff17ea33ae06fe23$var$SEARCH_QUERY, {
        q: query,
        cursor: cursor || undefined
    });
    return data.search;
}
function $ff17ea33ae06fe23$var$buildIssuesQuery(owner, repo, search, author, status, labels, sort) {
    const parts = [
        `repo:${owner}/${repo}`,
        'is:issue'
    ];
    if (status !== 'all') parts.push(`is:${status}`);
    if (author) parts.push(`author:${author}`);
    for (const label of labels)parts.push(`label:"${label}"`);
    if (search) parts.push(search);
    if (sort) parts.push(`sort:${sort}`);
    return parts.join(' ');
}
const $ff17ea33ae06fe23$var$TYPE_LABEL_NAMES = [
    'bug',
    'enhancement',
    'feature',
    'feature request',
    'question',
    'documentation'
];
function $ff17ea33ae06fe23$export$19dc41a5431fe112() {
    let { owner: owner = '', repo: repo = '' } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    const [searchInput, setSearchInput] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [status, setStatus] = (0, $acw62.useState)('open');
    const [selectedLabels, setSelectedLabels] = (0, $acw62.useState)([]);
    const [issueType, setIssueType] = (0, $acw62.useState)('');
    const [authorInput, setAuthorInput] = (0, $acw62.useState)('');
    const [author, setAuthor] = (0, $acw62.useState)('');
    const [sort, setSort] = (0, $acw62.useState)('created-desc');
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setSearch(searchInput), 300);
        return ()=>clearTimeout(timer);
    }, [
        searchInput
    ]);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setAuthor(authorInput), 500);
        return ()=>clearTimeout(timer);
    }, [
        authorInput
    ]);
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const { data: availableLabels } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'labels',
        owner,
        repo
    ], (0, $0f7bab1df0f00300$export$f18317131e3a9f2c));
    const getKey = (0, $acw62.useCallback)((pageIndex, prev)=>{
        if (prev && !prev.pageInfo.hasNextPage) return null;
        const labels = [
            ...selectedLabels,
            ...issueType ? [
                issueType
            ] : []
        ];
        const query = $ff17ea33ae06fe23$var$buildIssuesQuery(owner, repo, search, author, status, labels, sort);
        return [
            'issues',
            query,
            prev?.pageInfo.endCursor ?? ''
        ];
    }, [
        owner,
        repo,
        status,
        selectedLabels,
        issueType,
        sort,
        search,
        author
    ]);
    const { data: data, size: size, setSize: setSize, isLoading: isLoading, isValidating: isValidating, error: error } = (0, $25f67ffa4087bf8c$export$2e2bcd8739ae039)(getKey, $ff17ea33ae06fe23$var$fetchIssuesPage);
    const issues = data?.flatMap((p)=>p.nodes) ?? [];
    const isLoadingMore = !isLoading && isValidating && (data?.length ?? 0) < size;
    const hasMore = !data || data[data.length - 1]?.pageInfo.hasNextPage !== false;
    const activeFilterCount = [
        status !== 'open',
        selectedLabels.length > 0,
        !!issueType,
        !!authorInput.trim(),
        sort !== 'created-desc'
    ].filter(Boolean).length;
    const typeLabels = availableLabels?.filter((l)=>$ff17ea33ae06fe23$var$TYPE_LABEL_NAMES.includes(l.name.toLowerCase())) ?? [];
    const otherLabels = availableLabels?.filter((l)=>!$ff17ea33ae06fe23$var$TYPE_LABEL_NAMES.includes(l.name.toLowerCase())) ?? [];
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$79d13b60110f33be), {
        value: searchInput,
        onChange: setSearchInput,
        "aria-label": "Search issues",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff17ea33ae06fe23$var$IssueFilterPopover, {
            status: status,
            onStatusChange: setStatus,
            selectedLabels: selectedLabels,
            onLabelsChange: setSelectedLabels,
            issueType: issueType,
            onIssueTypeChange: setIssueType,
            author: authorInput,
            onAuthorChange: setAuthorInput,
            sort: sort,
            onSortChange: setSort,
            typeLabels: typeLabels,
            otherLabels: otherLabels,
            activeCount: activeFilterCount,
            onClear: ()=>{
                setStatus('open');
                setSelectedLabels([]);
                setIssueType('');
                setAuthorInput('');
                setAuthor('');
                setSort('created-desc');
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$54c2e3dc7acea9f5), {
                "aria-label": `Issues \u{2014} ${owner}/${repo}`,
                items: issues,
                selectedKeys: [
                    pathname
                ],
                isLoading: isLoading,
                isLoadingMore: isLoadingMore,
                hasMore: hasMore,
                header: header,
                onLoadMore: ()=>{
                    if (!isLoading && !isValidating && !error) setSize(size + 1);
                },
                children: (issue)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff17ea33ae06fe23$var$IssueListItem, {
                        issue: issue,
                        owner: owner,
                        repo: repo
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-auto flex flex-col",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d88e17cec3da5cb4$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$86e744c8a86f554d), {
                                text: "No issue selected."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            path: ":number",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ff17ea33ae06fe23$var$IssueRouteElement, {})
                        })
                    ]
                })
            })
        ]
    });
}
$ff17ea33ae06fe23$export$19dc41a5431fe112.preload = async function(owner, repo) {
    const query = $ff17ea33ae06fe23$var$buildIssuesQuery(owner, repo, '', '', 'open', [], 'created-desc');
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'issues',
        query,
        ''
    ], $ff17ea33ae06fe23$var$fetchIssuesPage);
};
function $ff17ea33ae06fe23$var$IssueFilterPopover({ status: status, onStatusChange: onStatusChange, selectedLabels: selectedLabels, onLabelsChange: onLabelsChange, issueType: issueType, onIssueTypeChange: onIssueTypeChange, author: author, onAuthorChange: onAuthorChange, sort: sort, onSortChange: onSortChange, typeLabels: typeLabels, otherLabels: otherLabels, activeCount: activeCount, onClear: onClear }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f7bab1df0f00300$export$ac838dd1e90609b3), {
        activeCount: activeCount,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Status",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: status,
                    onChange: onStatusChange,
                    "aria-label": "Status",
                    className: "flex gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "open",
                            label: "Open"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "closed",
                            label: "Closed"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "all",
                            label: "All"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Sort",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: sort,
                    onChange: onSortChange,
                    "aria-label": "Sort",
                    className: "flex flex-col gap-1",
                    children: (0, $0f7bab1df0f00300$export$a10e4eda63f1399b).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: opt.value,
                            label: opt.label
                        }, opt.value))
                })
            }),
            typeLabels.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                        label: "Type",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                            value: issueType,
                            onChange: onIssueTypeChange,
                            "aria-label": "Issue type",
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                                    value: "",
                                    label: "Any"
                                }),
                                typeLabels.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                                        value: l.name,
                                        label: l.name,
                                        color: l.color
                                    }, l.name))
                            ]
                        })
                    })
                ]
            }),
            otherLabels.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                        label: "Labels",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$9190d2e14c16f4ef), {
                            labels: otherLabels,
                            selectedLabels: selectedLabels,
                            onLabelsChange: onLabelsChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Author",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09752816b77dea6a$export$2c73285ae9390cec), {
                    value: author,
                    onChange: onAuthorChange,
                    "aria-label": "Author username",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f86a0ac31b8d349c$export$f5b8910cec6cf069), {
                        className: "w-full text-sm border border-daw-gray-200 rounded-md px-2 py-1.5 outline-none bg-transparent placeholder:text-daw-gray-400 focus:ring-2 ring-blue-500",
                        placeholder: "Username..."
                    })
                })
            }),
            activeCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        onPress: onClear,
                        className: "text-xs text-red-600 hover:underline cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded self-start",
                        children: "Clear filters"
                    })
                ]
            })
        ]
    });
}
// --- List items ---
//
function $ff17ea33ae06fe23$var$IssueListItem({ issue: issue, owner: owner, repo: repo }) {
    let description;
    let reactions = issue.reactionGroups.filter((r)=>r.reactors.totalCount > 0).map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            children: [
                (0, $739e3e11d093b75a$export$fefa818b32f677cd)[r.content],
                " ",
                r.reactors.totalCount
            ]
        }, i));
    let type = issue.issueType;
    let issueType = type ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$cd9ef921569d6bdf), {
        issueType: type,
        className: "text-2xs"
    }) : null;
    let commentCount = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            issueType,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a3543c9c8473fb3d), {
                        className: "w-3 h-3 inline mr-1"
                    }),
                    issue.comments.totalCount
                ]
            })
        ]
    });
    if (reactions.length) description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex gap-2 items-center",
        children: [
            commentCount,
            " ",
            reactions
        ]
    });
    else description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "flex gap-2 items-center",
        children: commentCount
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$a7b06bfba60a8a78), {
        id: `/${owner}/${repo}/issues/${issue.number}`,
        href: `/${owner}/${repo}/issues/${issue.number}`,
        textValue: issue.title,
        onPreload: ()=>(0, $376a85c6166d1b77$export$8f76aa81e935a507).preload(owner, repo, issue.number),
        label: issue.title,
        description: description
    });
}
function $ff17ea33ae06fe23$var$IssueRouteElement() {
    let { owner: owner = '', repo: repo = '', number: number } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $376a85c6166d1b77$export$8f76aa81e935a507), {
        owner: owner,
        repo: repo,
        number: Number(number)
    }, number);
}








var $acw62 = parcelRequire("acw62");






const $d0ae082cda95b06d$var$SEARCH_QUERY = `
query SearchPullRequests($q: String!, $cursor: String) {
  search(query: $q, type: ISSUE, first: 50, after: $cursor) {
    pageInfo { hasNextPage endCursor }
    nodes {
      ... on PullRequest {
        id number title state isDraft
        author { login avatarUrl }
        viewerLatestReview { state }
        reviewDecision
        reviews(last:100) {
          nodes {
            state
          }
        }
      }
    }
  }
}
`;
async function $d0ae082cda95b06d$var$fetchPullsPage([, query, cursor]) {
    const data = await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)($d0ae082cda95b06d$var$SEARCH_QUERY, {
        q: query,
        cursor: cursor || undefined
    });
    return data.search;
}
function $d0ae082cda95b06d$var$buildPullsQuery(owner, repo, search, author, status, labels, sort, draft) {
    const parts = [
        `repo:${owner}/${repo}`,
        'is:pr'
    ];
    if (status !== 'all') parts.push(`is:${status}`);
    if (draft) parts.push('is:draft');
    if (author) parts.push(`author:${author}`);
    for (const label of labels)parts.push(`label:"${label}"`);
    if (search) parts.push(search);
    if (sort) parts.push(`sort:${sort}`);
    return parts.join(' ');
}
const $d0ae082cda95b06d$var$STATUS_OPTIONS = [
    {
        value: 'open',
        label: 'Open'
    },
    {
        value: 'closed',
        label: 'Closed'
    },
    {
        value: 'merged',
        label: 'Merged'
    },
    {
        value: 'all',
        label: 'All'
    }
];
function $d0ae082cda95b06d$export$9d8e4061969dc9a7() {
    let { owner: owner = '', repo: repo = '' } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    const [searchInput, setSearchInput] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [status, setStatus] = (0, $acw62.useState)('open');
    const [draft, setDraft] = (0, $acw62.useState)(false);
    const [selectedLabels, setSelectedLabels] = (0, $acw62.useState)([]);
    const [authorInput, setAuthorInput] = (0, $acw62.useState)('');
    const [author, setAuthor] = (0, $acw62.useState)('');
    const [sort, setSort] = (0, $acw62.useState)('created-desc');
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setSearch(searchInput), 300);
        return ()=>clearTimeout(timer);
    }, [
        searchInput
    ]);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setAuthor(authorInput), 500);
        return ()=>clearTimeout(timer);
    }, [
        authorInput
    ]);
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const { data: availableLabels } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'labels',
        owner,
        repo
    ], (0, $0f7bab1df0f00300$export$f18317131e3a9f2c));
    const getKey = (0, $acw62.useCallback)((pageIndex, prev)=>{
        if (prev && !prev.pageInfo.hasNextPage) return null;
        const query = $d0ae082cda95b06d$var$buildPullsQuery(owner, repo, search, author, status, selectedLabels, sort, draft);
        return [
            'pulls',
            query,
            prev?.pageInfo.endCursor ?? ''
        ];
    }, [
        owner,
        repo,
        status,
        draft,
        selectedLabels,
        sort,
        search,
        author
    ]);
    const { data: data, size: size, setSize: setSize, isLoading: isLoading, isValidating: isValidating, error: error } = (0, $25f67ffa4087bf8c$export$2e2bcd8739ae039)(getKey, $d0ae082cda95b06d$var$fetchPullsPage);
    const pulls = data?.flatMap((p)=>p.nodes) ?? [];
    const isLoadingMore = !isLoading && isValidating && (data?.length ?? 0) < size;
    const hasMore = !data || data[data.length - 1]?.pageInfo.hasNextPage !== false;
    const activeFilterCount = [
        status !== 'open',
        draft,
        selectedLabels.length > 0,
        !!authorInput.trim(),
        sort !== 'created-desc'
    ].filter(Boolean).length;
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$79d13b60110f33be), {
        value: searchInput,
        onChange: setSearchInput,
        "aria-label": "Search pull requests",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0ae082cda95b06d$var$PullFilterPopover, {
            status: status,
            onStatusChange: setStatus,
            draft: draft,
            onDraftChange: setDraft,
            selectedLabels: selectedLabels,
            onLabelsChange: setSelectedLabels,
            author: authorInput,
            onAuthorChange: setAuthorInput,
            sort: sort,
            onSortChange: setSort,
            availableLabels: availableLabels ?? [],
            activeCount: activeFilterCount,
            onClear: ()=>{
                setStatus('open');
                setDraft(false);
                setSelectedLabels([]);
                setAuthorInput('');
                setAuthor('');
                setSort('created-desc');
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$54c2e3dc7acea9f5), {
                "aria-label": `Pull Requests \u{2014} ${owner}/${repo}`,
                items: pulls,
                selectedKeys: [
                    pathname
                ],
                isLoading: isLoading,
                isLoadingMore: isLoadingMore,
                hasMore: hasMore,
                header: header,
                onLoadMore: ()=>{
                    if (!isLoading && !isValidating && !error) setSize(size + 1);
                },
                children: (pull)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0ae082cda95b06d$var$PullListItem, {
                        pull: pull,
                        owner: owner,
                        repo: repo
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-auto flex flex-col",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d88e17cec3da5cb4$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$86e744c8a86f554d), {
                                text: "No pull request selected."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            path: ":number",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0ae082cda95b06d$var$PullRouteElement, {})
                        })
                    ]
                })
            })
        ]
    });
}
function $d0ae082cda95b06d$var$PullFilterPopover({ status: status, onStatusChange: onStatusChange, draft: draft, onDraftChange: onDraftChange, selectedLabels: selectedLabels, onLabelsChange: onLabelsChange, author: author, onAuthorChange: onAuthorChange, sort: sort, onSortChange: onSortChange, availableLabels: availableLabels, activeCount: activeCount, onClear: onClear }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f7bab1df0f00300$export$ac838dd1e90609b3), {
        activeCount: activeCount,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Status",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: status,
                    onChange: onStatusChange,
                    "aria-label": "Status",
                    className: "flex flex-col gap-1",
                    children: $d0ae082cda95b06d$var$STATUS_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: opt.value,
                            label: opt.label
                        }, opt.value))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Draft",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$dd948f91abc3a1c4), {
                    isSelected: draft,
                    onChange: onDraftChange,
                    label: "Draft only"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Sort",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: sort,
                    onChange: onSortChange,
                    "aria-label": "Sort",
                    className: "flex flex-col gap-1",
                    children: (0, $0f7bab1df0f00300$export$a10e4eda63f1399b).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: opt.value,
                            label: opt.label
                        }, opt.value))
                })
            }),
            availableLabels.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                        label: "Labels",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$9190d2e14c16f4ef), {
                            labels: availableLabels,
                            selectedLabels: selectedLabels,
                            onLabelsChange: onLabelsChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Author",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09752816b77dea6a$export$2c73285ae9390cec), {
                    value: author,
                    onChange: onAuthorChange,
                    "aria-label": "Author username",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f86a0ac31b8d349c$export$f5b8910cec6cf069), {
                        className: "w-full text-sm border border-daw-gray-200 rounded-md px-2 py-1.5 outline-none bg-transparent placeholder:text-daw-gray-400 focus:ring-2 ring-blue-500",
                        placeholder: "Username..."
                    })
                })
            }),
            activeCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        onPress: onClear,
                        className: "text-xs text-red-600 hover:underline cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded self-start",
                        children: "Clear filters"
                    })
                ]
            })
        ]
    });
}
$d0ae082cda95b06d$export$9d8e4061969dc9a7.preload = async function(owner, repo) {
    const query = $d0ae082cda95b06d$var$buildPullsQuery(owner, repo, '', '', 'open', [], 'created-desc', false);
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'pulls',
        query,
        ''
    ], $d0ae082cda95b06d$var$fetchPullsPage);
};
// --- List items ---
function $d0ae082cda95b06d$var$PullListItem({ pull: pull, owner: owner, repo: repo }) {
    const isMerged = pull.state === 'MERGED';
    const isDraft = pull.isDraft;
    const reviewState = pull.viewerLatestReview?.state;
    let avatar = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$e2255cf6045e8d47), {
        src: pull.author.avatarUrl
    });
    let description;
    if (isDraft) description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex gap-1 items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$51ed17e21f1e5e24), {
                size: 14,
                className: "text-neutral-500 group-aria-selected:text-daw-white"
            }),
            "Draft"
        ]
    });
    else if (pull.state === 'OPEN') {
        if (reviewState === 'APPROVED' || reviewState === 'CHANGES_REQUESTED' || reviewState === 'COMMENTED') {
            let message = reviewState === 'CHANGES_REQUESTED' ? 'requested changes' : reviewState.toLowerCase();
            description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex gap-1 items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                        state: reviewState
                    }),
                    "You ",
                    message
                ]
            });
        } else {
            let message = (0, $92995ef58fa84f45$export$53385330f58411d1)[pull.reviewDecision];
            let numReviews = pull.reviews.nodes.length;
            if (pull.reviewDecision === 'REVIEW_REQUIRED' && numReviews > 0) {
                let approvals = pull.reviews.nodes.filter((r)=>r.state === 'APPROVED').length;
                let changesRequested = pull.reviews.nodes.filter((r)=>r.state === 'CHANGES_REQUESTED').length;
                if (approvals > 0 && changesRequested === 0) message = `${approvals} ${approvals === 1 ? 'approval' : 'approvals'}`;
                else if (changesRequested > 0 && approvals === 0) message = `${changesRequested} requested changes`;
                else message = `${numReviews} ${numReviews === 1 ? 'review' : 'reviews'}`;
            }
            description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex gap-1 items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d560ed2d957d30cf$export$96e9906d6d93a972), {
                        state: pull.reviewDecision
                    }),
                    message
                ]
            });
        }
    } else if (isMerged) description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex gap-1 items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$578402671e214a82), {
                size: 14,
                className: "text-purple-600 group-aria-selected:text-daw-white"
            }),
            "Merged"
        ]
    });
    else description = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex gap-1 items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$5026ec832c277e74), {
                size: 14,
                className: "text-red-600 group-aria-selected:text-daw-white"
            }),
            "Closed"
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$a7b06bfba60a8a78), {
        id: `/${owner}/${repo}/pulls/${pull.number}`,
        href: `/${owner}/${repo}/pulls/${pull.number}`,
        textValue: pull.title,
        onPreload: ()=>(0, $92995ef58fa84f45$export$d8ee8bed60538a6a).preload(owner, repo, pull.number),
        label: pull.title,
        description: description,
        trailingIcon: avatar
    });
}
function $d0ae082cda95b06d$var$PullRouteElement() {
    let { owner: owner = '', repo: repo = '', number: number } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92995ef58fa84f45$export$d8ee8bed60538a6a), {
        owner: owner,
        repo: repo,
        number: Number(number)
    }, number);
}









var $acw62 = parcelRequire("acw62");





const $d81b35677dc61ef5$var$SEARCH_QUERY = `
query SearchDiscussions($q: String!, $cursor: String) {
  search(query: $q, type: DISCUSSION, first: 25, after: $cursor) {
    pageInfo { hasNextPage endCursor }
    nodes {
      ... on Discussion {
        id number title createdAt closed
        author { login avatarUrl url }
        comments { totalCount }
        category { name emoji }
        answerChosenAt
      }
    }
  }
}
`;
const $d81b35677dc61ef5$var$CATEGORIES_QUERY = `
query DiscussionCategories($owner: String!, $repo: String!) {
  repository(owner: $owner, name: $repo) {
    discussionCategories(first: 25) {
      nodes { id name emoji }
    }
  }
}
`;
async function $d81b35677dc61ef5$var$fetchDiscussions([, query, cursor]) {
    const data = await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)($d81b35677dc61ef5$var$SEARCH_QUERY, {
        q: query,
        cursor: cursor || undefined
    });
    return data.search;
}
async function $d81b35677dc61ef5$var$fetchCategories([, owner, repo]) {
    const data = await (0, $9efcf42537b67d79$export$1eb4e7c0ed67b035)($d81b35677dc61ef5$var$CATEGORIES_QUERY, {
        owner: owner,
        repo: repo
    });
    return data.repository.discussionCategories.nodes;
}
function $d81b35677dc61ef5$var$buildDiscussionQuery(owner, repo, search, author, status, answered, category, sort) {
    const parts = [
        `repo:${owner}/${repo}`
    ];
    if (status !== 'all') parts.push(`is:${status}`);
    if (answered) parts.push(`is:${answered}`);
    if (author) parts.push(`author:${author}`);
    if (category) parts.push(`category:"${category}"`);
    if (search) parts.push(search);
    if (sort) parts.push(`sort:${sort}`);
    return parts.join(' ');
}
function $d81b35677dc61ef5$export$45862fa640b5c10c() {
    const { owner: owner = '', repo: repo = '' } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    const [searchInput, setSearchInput] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [status, setStatus] = (0, $acw62.useState)('open');
    const [answered, setAnswered] = (0, $acw62.useState)('');
    const [authorInput, setAuthorInput] = (0, $acw62.useState)('');
    const [author, setAuthor] = (0, $acw62.useState)('');
    const [category, setCategory] = (0, $acw62.useState)('');
    const [sort, setSort] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setSearch(searchInput), 300);
        return ()=>clearTimeout(timer);
    }, [
        searchInput
    ]);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setAuthor(authorInput), 500);
        return ()=>clearTimeout(timer);
    }, [
        authorInput
    ]);
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const { data: categories } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'discussion-categories',
        owner,
        repo
    ], $d81b35677dc61ef5$var$fetchCategories);
    const query = $d81b35677dc61ef5$var$buildDiscussionQuery(owner, repo, search, author, status, answered, category, sort);
    const getKey = (0, $acw62.useCallback)((pageIndex, prev)=>{
        if (prev && !prev.pageInfo.hasNextPage) return null;
        return [
            'discussions',
            query,
            prev?.pageInfo.endCursor ?? ''
        ];
    }, [
        query
    ]);
    const { data: data, size: size, setSize: setSize, isLoading: isLoading, isValidating: isValidating, error: error } = (0, $25f67ffa4087bf8c$export$2e2bcd8739ae039)(getKey, $d81b35677dc61ef5$var$fetchDiscussions);
    const discussions = data?.flatMap((p)=>p.nodes) ?? [];
    const isLoadingMore = !isLoading && isValidating && (data?.length ?? 0) < size;
    const hasMore = !data || data[data.length - 1]?.pageInfo.hasNextPage !== false;
    const activeFilterCount = [
        status !== 'open',
        !!answered,
        !!category,
        !!authorInput.trim(),
        sort !== ''
    ].filter(Boolean).length;
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$79d13b60110f33be), {
        value: searchInput,
        onChange: setSearchInput,
        "aria-label": "Search discussions",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d81b35677dc61ef5$var$DiscussionFilterPopover, {
            status: status,
            onStatusChange: setStatus,
            answered: answered,
            onAnsweredChange: setAnswered,
            author: authorInput,
            onAuthorChange: setAuthorInput,
            category: category,
            onCategoryChange: setCategory,
            sort: sort,
            onSortChange: setSort,
            categories: categories ?? [],
            activeCount: activeFilterCount,
            onClear: ()=>{
                setStatus('open');
                setAnswered('');
                setCategory('');
                setAuthorInput('');
                setAuthor('');
                setSort('');
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$54c2e3dc7acea9f5), {
                "aria-label": `Discussions \u{2014} ${owner}/${repo}`,
                items: discussions,
                selectedKeys: [
                    pathname
                ],
                isLoading: isLoading,
                isLoadingMore: isLoadingMore,
                hasMore: hasMore,
                header: header,
                onLoadMore: ()=>{
                    if (!isLoading && !isValidating && !error) setSize(size + 1);
                },
                children: (discussion)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d81b35677dc61ef5$var$DiscussionListItem, {
                        discussion: discussion,
                        owner: owner,
                        repo: repo
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-auto flex flex-col",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d88e17cec3da5cb4$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$86e744c8a86f554d), {
                                text: "No discussion selected."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            path: ":number",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d81b35677dc61ef5$var$DiscussionRouteElement, {})
                        })
                    ]
                })
            })
        ]
    });
}
$d81b35677dc61ef5$export$45862fa640b5c10c.preload = async function(owner, repo) {
    const query = $d81b35677dc61ef5$var$buildDiscussionQuery(owner, repo, '', '', 'open', '', '', '');
    (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'discussions',
        query,
        ''
    ], $d81b35677dc61ef5$var$fetchDiscussions);
};
function $d81b35677dc61ef5$var$DiscussionFilterPopover({ status: status, onStatusChange: onStatusChange, answered: answered, onAnsweredChange: onAnsweredChange, author: author, onAuthorChange: onAuthorChange, category: category, onCategoryChange: onCategoryChange, sort: sort, onSortChange: onSortChange, categories: categories, activeCount: activeCount, onClear: onClear }) {
    const renderGitHubEmojis = (0, $36781a27136fc942$export$fed36daf6b3f26d1)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f7bab1df0f00300$export$ac838dd1e90609b3), {
        activeCount: activeCount,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Status",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: status,
                    onChange: onStatusChange,
                    "aria-label": "Status",
                    className: "flex gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "open",
                            label: "Open"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "closed",
                            label: "Closed"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "all",
                            label: "All"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Answered",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: answered,
                    onChange: onAnsweredChange,
                    "aria-label": "Answered",
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "",
                            label: "Any"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "answered",
                            label: "Answered"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: "unanswered",
                            label: "Unanswered"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Sort",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                    value: sort,
                    onChange: onSortChange,
                    "aria-label": "Sort",
                    className: "flex flex-col gap-1",
                    children: (0, $0f7bab1df0f00300$export$ead4a8547fe3d9f8).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                            value: opt.value,
                            label: opt.label
                        }, opt.value))
                })
            }),
            categories.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                        label: "Category",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8286518ff8c479ac$export$a98f0dcb43a68a25), {
                            value: category,
                            onChange: onCategoryChange,
                            "aria-label": "Category",
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                                    value: "",
                                    label: "Any"
                                }),
                                categories.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$371ab307eab489c0), {
                                        value: c.name,
                                        label: renderGitHubEmojis(`${c.emoji} ${c.name}`)
                                    }, c.id))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "border-daw-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f7bab1df0f00300$export$4c5b17bfcbab1742), {
                label: "Author",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09752816b77dea6a$export$2c73285ae9390cec), {
                    value: author,
                    onChange: onAuthorChange,
                    "aria-label": "Author username",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f86a0ac31b8d349c$export$f5b8910cec6cf069), {
                        className: "w-full text-sm border border-daw-gray-200 rounded-md px-2 py-1.5 outline-none bg-transparent placeholder:text-daw-gray-400 focus:ring-2 ring-blue-500",
                        placeholder: "Username..."
                    })
                })
            }),
            activeCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-daw-gray-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                        onPress: onClear,
                        className: "text-xs text-red-600 hover:underline cursor-default outline-none focus-visible:ring-2 ring-blue-600 rounded self-start",
                        children: "Clear filters"
                    })
                ]
            })
        ]
    });
}
// --- List items ---
function $d81b35677dc61ef5$var$DiscussionListItem({ discussion: discussion, owner: owner, repo: repo }) {
    let icon;
    if (discussion.answerChosenAt) icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$f6dd727656c97851), {
        size: 14,
        className: "text-purple-600 group-aria-selected:text-daw-white"
    });
    else if (discussion.closed) icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a82b67e11f494532), {
        size: 14,
        className: "text-red-600 group-aria-selected:text-daw-white"
    });
    else icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a82b67e11f494532), {
        size: 14,
        className: "text-green-600 group-aria-selected:text-daw-white"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$a7b06bfba60a8a78), {
        id: `/${owner}/${repo}/discussions/${discussion.number}`,
        href: `/${owner}/${repo}/discussions/${discussion.number}`,
        textValue: discussion.title,
        onPreload: ()=>(0, $9efcf42537b67d79$export$513ccb98c53b8039)((0, $e37a2db30c2ebb15$export$6c4ed0cff880690c).query(), {
                owner: owner,
                repo: repo,
                number: discussion.number
            }),
        icon: icon,
        label: discussion.title,
        description: `#${discussion.number} by ${discussion.author?.login}`
    });
}
function $d81b35677dc61ef5$var$DiscussionRouteElement() {
    let { owner: owner = '', repo: repo = '', number: number } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e37a2db30c2ebb15$export$6c4ed0cff880690c), {
        owner: owner,
        repo: repo,
        number: Number(number)
    }, number);
}










var $acw62 = parcelRequire("acw62");



const $739c6dd3901516fc$var$PER_PAGE = 30;
async function $739c6dd3901516fc$var$fetchRepoInfo([, owner, repo]) {
    const res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).repos.get({
        owner: owner,
        repo: repo
    });
    return res.data;
}
async function $739c6dd3901516fc$var$fetchBranches([, owner, repo]) {
    const res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).repos.listBranches({
        owner: owner,
        repo: repo,
        per_page: 100
    });
    return res.data;
}
async function $739c6dd3901516fc$var$fetchCommitsPage([, owner, repo, branch, page]) {
    const res = await (0, $9efcf42537b67d79$export$85c7dd0b0150981e).repos.listCommits({
        owner: owner,
        repo: repo,
        sha: branch,
        per_page: $739c6dd3901516fc$var$PER_PAGE,
        page: page
    });
    return {
        items: res.data.map((c)=>({
                ...c,
                id: c.sha
            })),
        hasNext: res.data.length === $739c6dd3901516fc$var$PER_PAGE
    };
}
function $739c6dd3901516fc$export$113f7519b875b6c5() {
    const { owner: owner = '', repo: repo = '' } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    const [branch, setBranch] = (0, $acw62.useState)(null);
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const { data: repoInfo } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'repo-info',
        owner,
        repo
    ], $739c6dd3901516fc$var$fetchRepoInfo);
    const { data: branches } = (0, $9ef683e011c31ff0$export$2e2bcd8739ae039)([
        'branches',
        owner,
        repo
    ], $739c6dd3901516fc$var$fetchBranches);
    const effectiveBranch = branch ?? repoInfo?.default_branch ?? 'main';
    const getKey = (0, $acw62.useCallback)((pageIndex, prev)=>{
        if (prev && !prev.hasNext) return null;
        return [
            'commits',
            owner,
            repo,
            effectiveBranch,
            pageIndex + 1
        ];
    }, [
        owner,
        repo,
        effectiveBranch
    ]);
    const { data: data, size: size, setSize: setSize, isLoading: isLoading, isValidating: isValidating, error: error } = (0, $25f67ffa4087bf8c$export$2e2bcd8739ae039)(getKey, $739c6dd3901516fc$var$fetchCommitsPage);
    const commits = data?.flatMap((p)=>p.items) ?? [];
    const isLoadingMore = !isLoading && isValidating && (data?.length ?? 0) < size;
    const hasMore = !data || data[data.length - 1]?.hasNext !== false;
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "p-2 border-b border-daw-gray-200 shrink-0",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($739c6dd3901516fc$var$BranchSelector, {
            branches: branches ?? [],
            value: effectiveBranch,
            onChange: setBranch
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$54c2e3dc7acea9f5), {
                "aria-label": `Commits \u{2014} ${owner}/${repo}`,
                items: commits,
                selectedKeys: [
                    pathname
                ],
                isLoading: isLoading,
                isLoadingMore: isLoadingMore,
                hasMore: hasMore,
                header: header,
                onLoadMore: ()=>{
                    if (!isLoading && !isValidating && !error) setSize(size + 1);
                },
                children: (commit)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($739c6dd3901516fc$var$CommitListItem, {
                        commit: commit,
                        owner: owner,
                        repo: repo
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-auto flex flex-col",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d88e17cec3da5cb4$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$86e744c8a86f554d), {
                                text: "No commit selected."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                            path: ":sha",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($739c6dd3901516fc$var$CommitRouteElement, {})
                        })
                    ]
                })
            })
        ]
    });
}
$739c6dd3901516fc$export$113f7519b875b6c5.preload = async function(owner, repo) {
    const repoInfo = await (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'repo-info',
        owner,
        repo
    ], $739c6dd3901516fc$var$fetchRepoInfo);
    const branch = repoInfo?.default_branch ?? 'main';
    await (0, $73ef0a5623b28096$export$513ccb98c53b8039)([
        'commits',
        owner,
        repo,
        branch,
        1
    ], $739c6dd3901516fc$var$fetchCommitsPage);
};
function $739c6dd3901516fc$var$BranchSelector({ branches: branches, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $234aa604da0871e2$export$ef9b1a59e592288f), {
        selectedKey: value,
        onSelectionChange: (key)=>onChange(key),
        "aria-label": "Branch",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                className: "flex items-center gap-1.5 text-xs font-medium px-2 py-1.5 rounded-md border border-daw-gray-200 hover:bg-daw-gray-100 cursor-default outline-none focus-visible:ring-2 ring-blue-600 w-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$c812d10d519e0edb), {
                        size: 13,
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "flex-1 text-left truncate",
                        children: value
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c079ee9c5fe80a9e$export$5b6b19405a83ff9d), {
                placement: "bottom",
                offset: 4,
                className: "bg-white dark:bg-neutral-900 border border-daw-gray-200 rounded-lg shadow-xl outline-none w-[--trigger-width] max-h-72 overflow-y-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$41f133550aa26f48), {
                    className: "outline-none p-1 flex flex-col",
                    items: branches,
                    children: (b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                            id: b.name,
                            textValue: b.name,
                            className: "text-sm px-2 py-1.5 rounded cursor-default outline-none hover:bg-daw-gray-100 selected:bg-daw-gray-900 selected:text-daw-white focus-visible:outline-2 outline-blue-600",
                            children: b.name
                        })
                })
            })
        ]
    });
}
function $739c6dd3901516fc$var$CommitListItem({ commit: commit, owner: owner, repo: repo }) {
    let df = (0, $c5bcadf5f58d658e$export$85fd5fdf27bacc79)({
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    let title = commit.commit.message.split('\n')[0];
    let author = commit.author?.login ?? commit.commit.author?.name ?? 'Unknown';
    let date = commit.commit.author?.date ? df.format(new Date(commit.commit.author.date)) : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $856d6c0e128934d1$export$a7b06bfba60a8a78), {
        id: `/${owner}/${repo}/commits/${commit.sha}`,
        href: `/${owner}/${repo}/commits/${commit.sha}`,
        textValue: title,
        onPreload: ()=>(0, $5379651f9cfa2f72$export$fb998822db15ddc).preload(owner, repo, commit.sha),
        label: title,
        description: `${author} \xb7 ${date}`
    });
}
function $739c6dd3901516fc$var$CommitRouteElement() {
    let { owner: owner, repo: repo, sha: sha } = (0, $d88e17cec3da5cb4$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5379651f9cfa2f72$export$fb998822db15ddc), {
        owner: owner,
        repo: repo,
        sha: sha
    }, sha);
}




var $acw62 = parcelRequire("acw62");

const $cd93687958c8007e$var$TOP_REPOS_QUERY = `
query TopRepositories {
  viewer {
    topRepositories(first: 20, orderBy: {field: UPDATED_AT, direction: DESC}) {
      nodes {
        nameWithOwner
        owner { login avatarUrl }
      }
    }
  }
}
`;
function $cd93687958c8007e$export$86fbec116b87613f() {
    let navigate = (0, $d88e17cec3da5cb4$export$9770f232ac06a008)();
    if (!localStorage.token) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Login, {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc5a334d7ad7481f$export$323e4fc2fa4753fb), {
        navigate: navigate,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $50c3c6889737e436$export$6fa1c918a237be3f), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$RepoPreloader, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col h-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Toolbar, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 gap-1 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$SourceSelector, {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d88e17cec3da5cb4$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                                            path: "/notifications/*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0891611a3844acc$export$440662f585edec66), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                                            path: "/:owner/:repo/issues/*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff17ea33ae06fe23$export$19dc41a5431fe112), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                                            path: "/:owner/:repo/pulls/*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0ae082cda95b06d$export$9d8e4061969dc9a7), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                                            path: "/:owner/:repo/discussions/*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d81b35677dc61ef5$export$45862fa640b5c10c), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                                            path: "/:owner/:repo/commits/*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $739c6dd3901516fc$export$113f7519b875b6c5), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$e7b0ac011bb776c6), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$444b3ab0cb9aec40), {
                                                to: "/notifications",
                                                replace: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $cd93687958c8007e$var$Login() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
        children: "Login"
    });
}
function $cd93687958c8007e$var$RepoPreloader() {
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const { urlOwner: urlOwner, urlRepo: urlRepo } = $cd93687958c8007e$var$parsePathParts(pathname);
    (0, $acw62.useEffect)(()=>{
        const currentRepo = urlOwner && urlRepo ? `${urlOwner}/${urlRepo}` : localStorage.getItem('github_lite_repo') ?? '';
        const [owner, repo] = currentRepo.split('/');
        if (owner && repo) {
            (0, $ff17ea33ae06fe23$export$19dc41a5431fe112).preload(owner, repo);
            (0, $d0ae082cda95b06d$export$9d8e4061969dc9a7).preload(owner, repo);
            (0, $d81b35677dc61ef5$export$45862fa640b5c10c).preload(owner, repo);
            (0, $739c6dd3901516fc$export$113f7519b875b6c5).preload(owner, repo);
        }
        (0, $f0891611a3844acc$export$440662f585edec66).preload();
    }, [
        urlOwner,
        urlRepo
    ]);
    return null;
}
function $cd93687958c8007e$var$parsePathParts(pathname) {
    const isNotifications = pathname.startsWith('/notifications');
    const parts = pathname.split('/').filter(Boolean);
    const urlOwner = isNotifications ? null : parts[0] ?? null;
    const urlRepo = isNotifications ? null : parts[1] ?? null;
    const section = isNotifications ? 'notifications' : parts[2] ?? 'issues';
    return {
        isNotifications: isNotifications,
        urlOwner: urlOwner,
        urlRepo: urlRepo,
        section: section
    };
}
function $cd93687958c8007e$var$getStoredRepoUrl() {
    const stored = localStorage.getItem('github_lite_repo') ?? '';
    return stored ? `/${stored}` : '';
}
function $cd93687958c8007e$var$Toolbar() {
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const navigate = (0, $d88e17cec3da5cb4$export$9770f232ac06a008)();
    const { data: data } = (0, $9efcf42537b67d79$export$dd0a697e1782aedd)($cd93687958c8007e$var$TOP_REPOS_QUERY, {});
    const repos = data?.viewer.topRepositories.nodes ?? [];
    const { isNotifications: isNotifications, urlOwner: urlOwner, urlRepo: urlRepo, section: section } = $cd93687958c8007e$var$parsePathParts(pathname);
    const currentRepo = urlOwner && urlRepo ? `${urlOwner}/${urlRepo}` : localStorage.getItem('github_lite_repo') ?? '';
    (0, $acw62.useEffect)(()=>{
        if (urlOwner && urlRepo) localStorage.setItem('github_lite_repo', `${urlOwner}/${urlRepo}`);
    }, [
        urlOwner,
        urlRepo
    ]);
    function handleRepoChange(nameWithOwner) {
        localStorage.setItem('github_lite_repo', nameWithOwner);
        navigate(`/${nameWithOwner}/${isNotifications ? 'issues' : section}`);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "px-2 pt-2 flex items-center shrink-0",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $234aa604da0871e2$export$ef9b1a59e592288f), {
            selectedKey: currentRepo || null,
            onSelectionChange: (key)=>handleRepoChange(key),
            "aria-label": "Repository",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $972ba92a45901f5b$export$353f5b6fc5456de1), {
                    className: "flex items-center gap-1.5 text-sm font-medium px-2 py-1.5 rounded-md bg-daw-white border border-daw-gray-200 hover:bg-daw-gray-100 pressed:bg-daw-gray-100 cursor-default outline-none focus-visible:ring-2 ring-blue-600",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $234aa604da0871e2$export$e288731fd71264f0), {
                        className: "max-w-xs truncate flex items-center gap-2"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c079ee9c5fe80a9e$export$5b6b19405a83ff9d), {
                    placement: "bottom start",
                    offset: 4,
                    className: "bg-white dark:bg-neutral-900 border border-daw-gray-200 rounded-lg shadow-xl outline-none w-72 max-h-80 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbc77d4357361516$export$41f133550aa26f48), {
                        className: "outline-none p-1 flex flex-col",
                        items: repos,
                        children: (repo)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                                id: repo.nameWithOwner,
                                textValue: repo.nameWithOwner,
                                className: "flex items-center gap-2 text-sm px-2 py-1.5 rounded cursor-default outline-none hover:bg-daw-gray-100 selected:bg-daw-gray-900 selected:text-daw-white focus-visible:outline-2 outline-blue-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: repo.owner.avatarUrl,
                                        className: "w-4 h-4 rounded-sm shrink-0",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "truncate",
                                        children: repo.nameWithOwner
                                    })
                                ]
                            })
                    })
                })
            ]
        })
    });
}
function $cd93687958c8007e$var$SourceSelector() {
    const { pathname: pathname } = (0, $d88e17cec3da5cb4$export$45d76561a5302f2b)();
    const { isNotifications: isNotifications, urlOwner: urlOwner, urlRepo: urlRepo, section: section } = $cd93687958c8007e$var$parsePathParts(pathname);
    const repoBase = urlOwner && urlRepo ? `/${urlOwner}/${urlRepo}` : $cd93687958c8007e$var$getStoredRepoUrl();
    const itemClass = "flex flex-col items-center gap-1 py-2 rounded-md cursor-default outline-none hover:bg-daw-gray-200 selected:bg-daw-gray-900 selected:text-daw-white focus-visible:outline-2 outline-blue-600";
    const labelClass = "text-[10px] font-medium leading-none";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$41f133550aa26f48), {
        "aria-label": "Source",
        selectionMode: "single",
        selectionBehavior: "replace",
        // @ts-ignore
        linkBehavior: "selection",
        selectedKeys: [
            section
        ],
        disallowEmptySelection: true,
        className: "w-16 flex flex-col py-3 gap-0.5 items-stretch px-1.5 shrink-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                id: "notifications",
                href: "/notifications",
                textValue: "Inbox",
                className: itemClass,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$2235404cc2cfe93c), {
                        size: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: labelClass,
                        children: "Inbox"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                id: "issues",
                href: `${repoBase}/issues`,
                textValue: "Issues",
                className: itemClass,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$9e6406dfc15cbb05), {
                        size: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: labelClass,
                        children: "Issues"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                id: "pulls",
                href: `${repoBase}/pulls`,
                textValue: "Pull Requests",
                className: itemClass,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$9a124e3933109cb2), {
                        size: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: labelClass,
                        children: "PRs"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                id: "discussions",
                href: `${repoBase}/discussions`,
                textValue: "Discussions",
                className: itemClass,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$a82b67e11f494532), {
                        size: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: labelClass,
                        children: "Discuss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbc77d4357361516$export$a11e76429ed99b4), {
                id: "commits",
                href: `${repoBase}/commits`,
                textValue: "Commits",
                className: itemClass,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c65e6561322b2ec$export$60c2c35f336e72eb), {
                        size: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: labelClass,
                        children: "Commits"
                    })
                ]
            })
        ]
    });
}



if (!localStorage.token) (0, $9efcf42537b67d79$export$596d806903d1f59e)();
else {
    let root = (0, $7e96a608cb33bf79$exports.createRoot)(document.querySelector('#app'));
    root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d88e17cec3da5cb4$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
    }));
}


//# sourceMappingURL=repo.463a47d1.js.map
